export const ipadict = {
    "aah": "ɑː",
    "aardvark": "ɑːdvɑːk",
    "aardvarks": "ɑːdvɑːks",
    "aardwolf": "ɑːdwʊlf",
    "aba": "ɐbæ",
    "abaca": "æbækɐ",
    "aback": "ɐbæk",
    "abacus": "æbækəs",
    "abacuses": "æbɐkəsɪz",
    "abalone": "ɐbæləʊn",
    "abandon": "ɐbændən",
    "abandoned": "ɐbændənd",
    "abandoning": "ɐbændənɪŋ",
    "abandonment": "ɐbændənmənt",
    "abandons": "ɐbændənz",
    "abas": "ɐbæz",
    "abase": "ɐbeɪs",
    "abasement": "ɐbeɪsmənt",
    "abashed": "ɐbæʃt",
    "abate": "ɐbeɪt",
    "abated": "ɐbeɪtɪd",
    "abatement": "ɐbeɪtmənt",
    "abates": "ɐbeɪts",
    "abating": "ɐbeɪtɪŋ",
    "abattoir": "æbɐtwɑː",
    "abattoirs": "æbɐtwɑːz",
    "abba": "æbɐ",
    "abb": "æb",
    "abbess": "æbɛs",
    "abbesses": "æbɛsɪz",
    "abbey": "æbi",
    "abbeys": "æbiz",
    "abbot": "æbət",
    "abbots": "æbəts",
    "abbreviate": "ɐbriːvɪeɪt",
    "abbreviated": "ɐbriːvɪeɪtɪd",
    "abbreviates": "ɐbriːvɪeɪts",
    "abbreviating": "ɐbriːvɪeɪtɪŋ",
    "abbreviation": "ɐbriːvɪeɪʃən",
    "abbreviations": "ɐbriːvɪeɪʃənz",
    "abdicate": "æbdɪkeɪt",
    "abdicated": "æbdɪkeɪtɪd",
    "abdicates": "æbdɪkeɪts",
    "abdicating": "æbdɪkeɪtɪŋ",
    "abdication": "æbdɪkeɪʃən",
    "abdomen": "æbdəmən",
    "abdomens": "æbdəmənz",
    "abdominal": "æbdɒmɪnəl",
    "abduct": "ɐbdʌkt",
    "abducted": "ɐbdʌktɪd",
    "abducting": "ɐbdʌktɪŋ",
    "abduction": "ɐbdʌkʃən",
    "abductions": "ɐbdʌkʃənz",
    "abductor": "ɐbdʌktɐ",
    "abductors": "ɐbdʌktəz",
    "abducts": "ɐbdʌkts",
    "abeam": "ɐbiːm",
    "abed": "ɐbɛd",
    "aberrant": "ɐbɛrənt",
    "aberration": "æbəreɪʃən",
    "aberrations": "æbəreɪʃənz",
    "abet": "ɐbɛt",
    "abetted": "ɐbɛtɪd",
    "abetting": "ɐbɛtɪŋ",
    "abeyance": "ɐbeɪəns",
    "abhor": "ɐbhɔː",
    "abhorred": "ɐbhɔːd",
    "abhorrence": "ɐbhɒrəns",
    "abhorrent": "ɐbhɒrənt",
    "abhorring": "ɐbhɔːrɪŋ",
    "abhors": "ɐbhɔːz",
    "abide": "ɐbaɪd",
    "abided": "ɐbaɪdɪd",
    "abides": "ɐbaɪdz",
    "abiding": "ɐbaɪdɪŋ",
    "abies": "ɐbaɪz",
    "abigail": "æbɪɡeɪl",
    "abilities": "ɐbɪlətiz",
    "ability": "ɐbɪləti",
    "abjection": "æbdʒɛkʃən",
    "abjectly": "æbdʒɛktli",
    "abjure": "ɐbdʒjɔː",
    "ablation": "ɐbleɪtiən",
    "ablaze": "ɐbleɪz",
    "able": "eɪbəl",
    "abler": "eɪblɐ",
    "ablest": "eɪbləst",
    "ablution": "ɐbluːʃən",
    "ablutions": "ɐbluːʃənz",
    "ably": "eɪbli",
    "abnegate": "æbnɪɡeɪt",
    "abnegation": "æbnɪɡeɪʃən",
    "abnormal": "ɐbnɔːməl",
    "abnormalities": "ɐbnɔːmælɪtiz",
    "abnormality": "ɐbnɔːmælɪti",
    "abnormally": "ɐbnɔːməli",
    "aboard": "ɐbɔːd",
    "abode": "ɐbəʊd",
    "abodes": "ɐbəʊdz",
    "abolish": "ɐbɒlɪʃ",
    "abolished": "ɐbɒlɪʃt",
    "abolishes": "ɐbɒlɪʃɪz",
    "abolishing": "ɐbɒlɪʃɪŋ",
    "abolishment": "ɐbɒlɪʃmənt",
    "abolition": "æbəlɪʃən",
    "abolitionist": "æbəlɪʃənɪst",
    "abolitionists": "æbəlɪʃənɪsts",
    "abominable": "ɐbɒmɪnəbəl",
    "abominably": "ɐbɒmɪnəbli",
    "abominate": "ɐbɒmɪneɪt",
    "abominated": "ɐbɒmɪneɪtɪd",
    "abomination": "ɐbɒmɪneɪʃən",
    "abominations": "ɐbɒmɪneɪʃənz",
    "abominator": "ɐbɒmɪneɪtɐ",
    "aboriginal": "æbərɪdʒɪnəl",
    "aboriginals": "æbərɪdʒɪnəlz",
    "aborigine": "æbərɪdʒəni",
    "aborigines": "æbərɪdʒəniz",
    "abort": "ɐbɔːt",
    "aborted": "ɐbɔːtɪd",
    "aborting": "ɐbɔːtɪŋ",
    "abortion": "ɐbɔːʃən",
    "abortionist": "ɐbɔːʃənɪst",
    "abortionists": "ɐbɔːʃənɪsts",
    "abortions": "ɐbɔːʃənz",
    "abortive": "ɐbɔːtɪv",
    "aborts": "ɐbɔːts",
    "abound": "ɐbaʊnd",
    "abounded": "ɐbaʊndɪd",
    "abounding": "ɐbaʊndɪŋ",
    "abounds": "ɐbaʊndz",
    "about": "ɐbaʊt",
    "above": "əbʌv",
    "abracadabra": "æbrəkədæbrɐ",
    "abrade": "ɐbreɪd",
    "abraded": "ɐbreɪdɪd",
    "abrades": "ɐbreɪdz",
    "abrading": "ɐbreɪdɪŋ",
    "abrasion": "ɐbreɪʒən",
    "abrasions": "ɐbreɪʒənz",
    "abrasive": "ɐbreɪsɪv",
    "abrasiveness": "ɐbreɪsɪvnəs",
    "abrasives": "ɐbreɪsɪvz",
    "abraxas": "ɐbræksəs",
    "abreast": "ɐbrɛst",
    "abri": "ɐbri",
    "abridged": "ɐbrɪdʒd",
    "abridgement": "ɐbrɪdʒmənt",
    "abroad": "ɐbrɔːd",
    "abrogated": "æbrəɡeɪtɪd",
    "abrogating": "æbrəɡeɪtɪŋ",
    "abrogation": "æbrəɡeɪʃən",
    "abrupt": "ɐbrʌpt",
    "abruption": "ɐbrʌpʃən",
    "abruptly": "ɐbrʌptli",
    "abruptness": "ɐbrʌptnəs",
    "abs": "æbz",
    "abscess": "æbsɛs",
    "abscesses": "æbsɛsɪz",
    "abscond": "ɐbskɒnd",
    "absconded": "ɐbskɒndɪd",
    "absconding": "ɐbskɒndɪŋ",
    "absconds": "ɐbskɒndz",
    "abseil": "æbseɪl",
    "abseiled": "æbseɪld",
    "abseiler": "æbseɪlɐ",
    "abseiling": "æbseɪlɪŋ",
    "abseils": "æbseɪlz",
    "absence": "æbsəns",
    "absences": "æbsənsɪz",
    "absented": "æbsɛntɪd",
    "absentee": "æbsəntiː",
    "absenteeism": "æbsəntiːɪzəm",
    "absentees": "æbsəntiːz",
    "absenting": "æbsɛntɪŋ",
    "absentminded": "æbsəntmaɪndɪd",
    "absentmindedly": "æbsəntmaɪndɪdli",
    "absinthe": "æbsɪnθ",
    "absolute": "æbsəluːt",
    "absolutely": "æbsəluːtli",
    "absolutes": "æbsəluːts",
    "absolution": "æbsəluːʃən",
    "absolutism": "æbsəluːtɪzəm",
    "absolutist": "æbsəluːtɪst",
    "absolve": "ɐbsɒlv",
    "absolved": "ɐbsɒlvd",
    "absolves": "ɐbsɒlvz",
    "absolving": "ɐbsɒlvɪŋ",
    "absorbable": "ɐbsɔːbəbəl",
    "absorb": "ɐbsɔːb",
    "absorbed": "ɐbsɔːbd",
    "absorbency": "ɐbsɔːbənsi",
    "absorbent": "ɐbsɔːbənt",
    "absorber": "ɐbsɔːbɐ",
    "absorbers": "ɐbsɔːbəz",
    "absorbing": "ɐbsɔːbɪŋ",
    "absorbs": "ɐbsɔːbz",
    "absorption": "ɐbsɔːpʃən",
    "abstain": "ɐbsteɪn",
    "abstained": "ɐbsteɪnd",
    "abstainers": "ɐbsteɪnəz",
    "abstaining": "ɐbsteɪnɪŋ",
    "abstains": "ɐbsteɪnz",
    "abstemious": "ɐbstiːmiəs",
    "abstention": "ɐbstɛnʃən",
    "abstentions": "ɐbstɛnʃənz",
    "abstinence": "æbstɪnəns",
    "abstinent": "æbstɪnənt",
    "abstracted": "ɐbstræktɪd",
    "abstracting": "ɐbstræktɪŋ",
    "abstraction": "ɐbstrækʃən",
    "abstractions": "ɐbstrækʃənz",
    "abstractly": "ɐbstræktli",
    "abstruse": "ɐbstruːs",
    "absurd": "ɐbsɜːd",
    "absurdist": "ɐbsɜːdɪst",
    "absurdities": "ɐbsɜːdɪtiz",
    "absurdity": "ɐbsɜːdɪti",
    "absurdly": "ɐbsɜːdli",
    "abundance": "ɐbʌndəns",
    "abundances": "ɐbʌndənsɪz",
    "abundant": "ɐbʌndənt",
    "abundantly": "ɐbʌndəntli",
    "abused": "ɐbjuːsd",
    "abuser": "ɐbjuːsɐ",
    "abusers": "ɐbjuːsəz",
    "abusing": "ɐbjuːsɪŋ",
    "abusive": "ɐbjuːsɪv",
    "abusively": "ɐbjuːsɪvli",
    "abut": "ɐbʌt",
    "abutment": "ɐbʌtmənt",
    "abutments": "ɐbʌtmənts",
    "abuts": "ɐbʌts",
    "abutting": "ɐbʌtɪŋ",
    "abuzz": "ɐbʌz",
    "aby": "ɐbaɪ",
    "abysmal": "ɐbɪsməl",
    "abysmally": "ɐbɪsməli",
    "abyssal": "ɐbɪsəl",
    "abyss": "ɐbɪs",
    "abysses": "ɐbɪsɪz",
    "acacia": "ɐkeɪʃɐ",
    "acacias": "ɐkeɪʃəz",
    "academe": "ɐkædəmi",
    "academia": "ækədiːmiə",
    "academic": "ækədɛmɪk",
    "academical": "ækədɛmɪkəl",
    "academically": "ækədɛmɪkli",
    "academician": "ækədɪmɪʃən",
    "academicians": "ækədɪmɪʃənz",
    "academics": "ækədɛmɪks",
    "academies": "ɐkædəmɪz",
    "academy": "ɐkædəmi",
    "acanthus": "ɐkɑːnθəs",
    "acceded": "ɐksiːdɪd",
    "accede": "ɐksiːd",
    "acceding": "ɐksiːdɪŋ",
    "accelerando": "ɐksɛlərændəʊ",
    "accelerant": "ɐksɛlərənt",
    "accelerated": "ɐksɛləreɪtɪd",
    "accelerate": "ɐksɛləreɪt",
    "accelerates": "ɐksɛləreɪts",
    "accelerating": "ɐksɛləreɪtɪŋ",
    "acceleration": "ɐksɛləreɪʃən",
    "accelerations": "ɐksɛləreɪʃənz",
    "accelerator": "ɐksɛləreɪtɐ",
    "accelerators": "ɐksɛləreɪtəz",
    "accelerometer": "ɐksɛlərɒmɪtɐ",
    "accelerometers": "ɐksɛlərɒmɪtəz",
    "accented": "æksəntɪd",
    "accentuate": "æksɛntʃuːeɪt",
    "accentuated": "æksɛntʃuːeɪtɪd",
    "accentuates": "æksɛntʃuːeɪts",
    "accentuating": "æksɛntʃuːeɪtɪŋ",
    "acceptability": "ɐksɛptəbɪlɪti",
    "acceptable": "ɐksɛptəbəl",
    "acceptably": "ɐksɛptəbli",
    "acceptance": "ɐksɛptəns",
    "acceptances": "ɐksɛptənsɪz",
    "acceptation": "ɐksɪpteɪʃən",
    "accepted": "ɐksɛptɪd",
    "accepting": "ɐksɛptɪŋ",
    "accept": "ɐksɛpt",
    "accepts": "ɐksɛpts",
    "access": "æksɛs",
    "accessed": "æksɛst",
    "accesses": "æksɛsɪz",
    "accessibility": "ɐksɛsəbɪlɪti",
    "accessible": "ɐksɛsəbəl",
    "accessibly": "ɐksɛsəbli",
    "accessing": "æksɛsɪŋ",
    "accession": "ɐksɛʃən",
    "accessories": "ɐksɛsəriz",
    "accessorised": "ɐksɛsɔːraɪzd",
    "accessorise": "ɐksɛsɔːraɪz",
    "accessorising": "ɐksɛsɔːraɪzɪŋ",
    "accessory": "ɐksɛsəri",
    "accident": "æksɪdənt",
    "accidental": "æksɪdɛntəl",
    "accidentally": "æksɪdɛntəli",
    "accidently": "æksɪdəntli",
    "accidents": "æksɪdənts",
    "accidie": "æksɪdi",
    "acclaimed": "ɐkleɪmd",
    "acclaiming": "ɐkleɪmɪŋ",
    "acclaim": "ɐkleɪm",
    "acclaims": "ɐkleɪmz",
    "acclamation": "ɐklɐmeɪʃən",
    "acclimated": "ɐklaɪmətɪd",
    "acclimate": "ɐklaɪmət",
    "acclimatisation": "ɐklaɪmɐtaɪzeɪʃən",
    "acclimatised": "ɐklaɪmɐtaɪzd",
    "acclimatise": "ɐklaɪmɐtaɪz",
    "acclimatising": "ɐklaɪmɐtaɪzɪŋ",
    "accolade": "ækəleɪd",
    "accolades": "ækəleɪdz",
    "accommodated": "ɐkɒmədeɪtɪd",
    "accommodate": "ɐkɒmədeɪt",
    "accommodates": "ɐkɒmədeɪts",
    "accommodating": "ɐkɒmədeɪtɪŋ",
    "accommodation": "ɐkɒmədeɪʃən",
    "accommodations": "ɐkɒmədeɪʃənz",
    "accompanied": "ɐkʌmpənɪd",
    "accompanies": "ɐkʌmpənɪz",
    "accompaniment": "ɐkʌmpɐnɪmənt",
    "accompaniments": "ɐkʌmpɐnɪmənts",
    "accompanist": "ɐkʌmpɐnɪst",
    "accompanists": "ɐkʌmpɐnɪsts",
    "accompanying": "ɐkʌmpənɪɪŋ",
    "accompany": "ɐkʌmpəni",
    "accomplice": "ɐkɒmplɪs",
    "accomplices": "ɐkɒmplɪsɪz",
    "accomplished": "ɐkɒmplɪʃt",
    "accomplishes": "ɐkɒmplɪʃɪz",
    "accomplishing": "ɐkɒmplɪʃɪŋ",
    "accomplish": "ɐkɒmplɪʃ",
    "accomplishment": "ɐkɒmplɪʃmənt",
    "accomplishments": "ɐkɒmplɪʃmənts",
    "accordance": "ɐkɔːdəns",
    "accordant": "ɐkɔːdənt",
    "accorded": "ɐkɔːdɪd",
    "according": "ɐkɔːdɪŋ",
    "accordingly": "ɐkɔːdɪŋli",
    "accordionist": "ɐkɔːdɪənɪst",
    "accordionists": "ɐkɔːdɪənɪsts",
    "accordion": "ɐkɔːdiən",
    "accordions": "ɐkɔːdiənz",
    "accord": "ɐkɔːd",
    "accords": "ɐkɔːdz",
    "accosted": "ɐkɒstɪd",
    "accosting": "ɐkɒstɪŋ",
    "accost": "ɐkɒst",
    "accosts": "ɐkɒsts",
    "accountability": "ɐkaʊntəbɪlɪti",
    "accountable": "ɐkaʊntəbəl",
    "accountancy": "ɐkaʊntənsi",
    "accountant": "ɐkaʊntənt",
    "accountants": "ɐkaʊntənts",
    "accounted": "ɐkaʊntɪd",
    "accounting": "ɐkaʊntɪŋ",
    "account": "ɐkaʊnt",
    "accounts": "ɐkaʊnts",
    "accoutred": "ɐkuːtrəd",
    "accoutrement": "ɐkuːtrɪmənt",
    "accoutrements": "ɐkuːtrɪmənts",
    "accreditation": "ɐkrɛdɪteɪʃən",
    "accredited": "ɐkrɛdɪtɪd",
    "accredits": "ɐkrɛdɪts",
    "accreted": "ɐkriːtɪd",
    "accrete": "ɐkriːt",
    "accretion": "ɐkrɛʃən",
    "accretions": "ɐkrɛʃənz",
    "accrual": "ɐkruːəl",
    "accrued": "ɐkruːd",
    "accrue": "ɐkruː",
    "accrues": "ɐkruːz",
    "accruing": "ɐkruːɪŋ",
    "acculturated": "ɐkʌltʃəreɪtɪd",
    "accumulated": "ɐkjuːmjʊleɪtɪd",
    "accumulate": "ɐkjuːmjʊleɪt",
    "accumulates": "ɐkjuːmjʊleɪts",
    "accumulating": "ɐkjuːmjʊleɪtɪŋ",
    "accumulation": "ɐkjuːmjʊleɪʃən",
    "accumulations": "ɐkjuːmjʊleɪʃənz",
    "accumulative": "ɐkjuːmjʊlətɪv",
    "accumulator": "ɐkjuːmjʊleɪtɐ",
    "accumulators": "ɐkjuːmjʊleɪtəz",
    "accuracy": "ækjʊrəsi",
    "accurate": "ækjʊrət",
    "accurately": "ækjʊrətli",
    "accursed": "ɐkɜːsɪd",
    "accusation": "ækjuːzeɪʃən",
    "accusations": "ækjuːzeɪʃənz",
    "accusative": "ɐkjuːzətɪv",
    "accusatory": "ɐkjuːzətəri",
    "accused": "ɐkjuːzd",
    "accuse": "ɐkjuːz",
    "accuser": "ɐkjuːzɐ",
    "accusers": "ɐkjuːzəz",
    "accuses": "ɐkjuːzɪz",
    "accusing": "ɐkjuːzɪŋ",
    "accusingly": "ɐkjuːzɪŋli",
    "accustomed": "ɐkʌstəmd",
    "accustom": "ɐkʌstəm",
    "aced": "eɪst",
    "ace": "eɪs",
    "acerbic": "ɐsɜːbɪk",
    "aces": "eɪsɪz",
    "acetate": "æsɪteɪt",
    "acetates": "æsɪteɪts",
    "acetic": "ɐsiːtɪk",
    "acetone": "æsɪtəʊn",
    "acetyl": "æsɪtaɪl",
    "acetylene": "ɐsɛtəliːn",
    "ached": "eɪkt",
    "aches": "eɪkz",
    "achievable": "ɐtʃiːvəbəl",
    "achieved": "ɐtʃiːvd",
    "achievements": "ɐtʃiːvmənts",
    "achievement": "ɐtʃiːvmənt",
    "achievers": "ɐtʃiːvəz",
    "achiever": "ɐtʃiːvɐ",
    "achieves": "ɐtʃiːvz",
    "achieve": "ɐtʃiːv",
    "achieving": "ɐtʃiːvɪŋ",
    "aching": "eɪkɪŋ",
    "achingly": "ɐtʃɪŋli",
    "achoo": "ɐtʃuː",
    "achy": "eɪki",
    "acid": "æsɪd",
    "acidic": "ɐsɪdɪk",
    "acidification": "ɐsɪdɪfɪkeɪʃən",
    "acidified": "ɐsɪdɪfaɪd",
    "acidifying": "ɐsɪdɪfaɪɪŋ",
    "acidify": "ɐsɪdɪfaɪ",
    "acidity": "æsɪdɪti",
    "acidosis": "ɐsɪdəʊsɪs",
    "acidotic": "ɐsɪdɒtɪk",
    "acids": "æsɪdz",
    "acidulated": "ɐsɪdjʊleɪtɪd",
    "acing": "eɪsɪŋ",
    "acknowledged": "ɐknɒlɪdʒd",
    "acknowledge": "ɐknɒlɪdʒ",
    "acknowledgement": "ɐknɒlɪdʒmənt",
    "acknowledgements": "ɐknɒlɪdʒmənts",
    "acknowledges": "ɐknɒlɪdʒɪz",
    "acknowledging": "ɐknɒlɪdʒɪŋ",
    "acknowledgment": "ɐknɒlɪdʒmənt",
    "acknowledgments": "ɐknɒlɪdʒmənts",
    "acme": "ækmi",
    "acne": "ækni",
    "acolyte": "ækəlaɪt",
    "acolytes": "ækəlaɪts",
    "aconite": "ækənaɪt",
    "aconites": "ækənaɪts",
    "acorn": "eɪkɔːn",
    "acorns": "eɪkɔːnz",
    "acoustical": "ɐkuːstɪkəl",
    "acoustically": "ɐkuːstɪkli",
    "acoustician": "ɐkuːstɪʃən",
    "acousticians": "ɐkuːstɪʃənz",
    "acoustic": "ɐkuːstɪk",
    "acoustics": "ɐkuːstɪks",
    "acquaintance": "ɐkweɪntəns",
    "acquaintanceship": "ɐkweɪntənsʃɪp",
    "acquaintances": "ɐkweɪntənsɪz",
    "acquainted": "ɐkweɪntɪd",
    "acquainting": "ɐkweɪntɪŋ",
    "acquaint": "ɐkweɪnt",
    "acquiesce": "ækwɪɛs",
    "acquiesced": "ækwɪɛst",
    "acquiescence": "ækwɪɛsəns",
    "acquiescent": "ækwɪɛsənt",
    "acquiesces": "ækwɪɛsɪz",
    "acquiescing": "ækwɪɛsɪŋ",
    "acquired": "ɐkwaɪəd",
    "acquire": "ɐkwaɪə",
    "acquirer": "ɐkwaɪərɐ",
    "acquires": "ɐkwaɪəz",
    "acquiring": "ɐkwaɪərɪŋ",
    "acquisition": "ɐkwɪsɪʃən",
    "acquisitions": "ɐkwɪsɪʃənz",
    "acquisitive": "ɐkwɪzɪtɪv",
    "acquit": "ɐkwɪt",
    "acquits": "ɐkwɪts",
    "acquittal": "ɐkwɪtəl",
    "acquittals": "ɐkwɪtəlz",
    "acquitted": "ɐkwɪtɪd",
    "acquitting": "ɐkwɪtɪŋ",
    "acreage": "eɪkərɪdʒ",
    "acreages": "eɪkərɪdʒɪz",
    "acred": "eɪkəd",
    "acres": "eɪkəz",
    "acrid": "ækrɪd",
    "acrimonious": "ækrɪməʊnɪəs",
    "acrimoniously": "ækrɪməʊnɪəsli",
    "acrimony": "ækrɪməni",
    "acrobat": "ækrəbæt",
    "acrobatic": "ækrəbætɪk",
    "acrobatically": "ækrəbætɪkli",
    "acrobatics": "ækrəbætɪks",
    "acrobats": "ækrəbæts",
    "acromegaly": "ækrəʊmɡəli",
    "acromion": "ækrəʊmiən",
    "acronym": "ækrənɪm",
    "acronyms": "ækrənɪmz",
    "acrophobia": "ækrəfəʊbiə",
    "acropolis": "ækrɒpəliz",
    "across": "əkrɒs",
    "acrostics": "ækrɒstɪks",
    "acrylic": "ɐkrɪlɪk",
    "acrylics": "ɐkrɪlɪks",
    "act": "ækt",
    "acted": "æktɪd",
    "actin": "æktɪn",
    "acting": "æktɪŋ",
    "actinic": "æktɪnɪk",
    "actinide": "æktɪnaɪd",
    "actinium": "æktɪniəm",
    "actionable": "ækʃənəbəl",
    "action": "ækʃən",
    "actions": "ækʃənz",
    "activate": "æktɪveɪt",
    "activated": "æktɪveɪtɪd",
    "activates": "æktɪveɪts",
    "activating": "æktɪveɪtɪŋ",
    "activation": "æktɪveɪʃən",
    "activations": "æktɪveɪʃənz",
    "activator": "æktɪveɪtɐ",
    "active": "æktɪv",
    "actively": "æktɪvli",
    "actives": "æktɪvz",
    "activism": "æktɪvɪzəm",
    "activist": "æktɪvɪst",
    "activists": "æktɪvɪsts",
    "activities": "æktɪvɪtiz",
    "activity": "æktɪvɪti",
    "actor": "æktɐ",
    "actors": "æktəz",
    "actress": "æktrəs",
    "actresses": "æktrəsɪz",
    "acts": "ækts",
    "actual": "æktʃuːəl",
    "actualisation": "æktʃuːəlaɪzeɪʃən",
    "actualise": "æktʃuːəlaɪz",
    "actualised": "æktʃuːəlaɪzd",
    "actualities": "æktʃuːælɪtiz",
    "actuality": "æktʃuːælɪti",
    "actually": "æktʃuːəli",
    "actuarial": "æktʃuːeərɪəl",
    "actuarially": "æktʃuːeərɪəli",
    "actuaries": "æktʃuːəriz",
    "actuary": "æktʃuːəri",
    "actuated": "æktʃuːeɪtɪd",
    "actuator": "æktʃuːeɪtɐ",
    "actuators": "æktʃuːeɪtəz",
    "acuity": "ɐkjuːɪti",
    "acumen": "ækjuːmɛn",
    "acupressure": "ækəprɛʃɐ",
    "acupuncture": "ækjuːpʌŋktʃɐ",
    "acupuncturist": "ækjuːpʌŋktʃərɪst",
    "acute": "ɐkjuːt",
    "acutely": "ɐkjuːtli",
    "acuteness": "ɐkjuːtnəs",
    "acuter": "ɐkjuːtɐ",
    "acyclovir": "ɐkaɪkləviə",
    "ad": "æd",
    "adage": "ædɪdʒ",
    "adages": "ædɪdʒɪz",
    "adagio": "ædɑːdʒɪəʊ",
    "adamant": "ædəmənt",
    "adamantine": "ædɐmɑːntiːn",
    "adamantly": "ædəməntli",
    "adaptability": "ɐdæptəbɪlɪti",
    "adaptable": "ɐdæptəbəl",
    "adaptation": "ɐdɐpteɪʃən",
    "adaptations": "ɐdɐpteɪʃənz",
    "adapt": "ɐdæpt",
    "adapted": "ɐdæptɪd",
    "adapter": "ɐdæptɐ",
    "adapters": "ɐdæptəz",
    "adapting": "ɐdæptɪŋ",
    "adaption": "ɐdæpʃən",
    "adaptions": "ɐdæpʃənz",
    "adaptive": "ɐdæptɪv",
    "adaptively": "ɐdæptɪvli",
    "adaptor": "ɐdæptɐ",
    "adaptors": "ɐdæptəz",
    "adapts": "ɐdæpts",
    "add": "æd",
    "added": "ædɪd",
    "addendum": "ɐdɛndəm",
    "adder": "ædɐ",
    "adders": "ædəz",
    "addicted": "ɐdɪktɪd",
    "addicting": "ɐdɪktɪŋ",
    "addiction": "ɐdɪkʃən",
    "addictions": "ɐdɪkʃənz",
    "addictive": "ɐdɪktɪv",
    "adding": "ædɪŋ",
    "additional": "ɐdɪʃənəl",
    "additionally": "ɐdɪʃənəli",
    "addition": "ɐdɪʃən",
    "additions": "ɐdɪʃənz",
    "additive": "ædɪtɪv",
    "additives": "ædɪtɪvz",
    "addle": "ædəl",
    "addled": "ædəld",
    "addles": "ædəlz",
    "addling": "ædlɪŋ",
    "addressable": "ɐdrɛsəbəl",
    "addressed": "ɐdrɛst",
    "addressee": "ɐdrɛsiː",
    "addresses": "ɐdrɛsɪz",
    "addressing": "ɐdrɛsɪŋ",
    "adds": "ædz",
    "adduced": "ɐdjuːst",
    "adduce": "ɐdjuːs",
    "adductor": "ɐdʌktɐ",
    "adenine": "ædəniːn",
    "adenocarcinoma": "ædənɒkɑːsɪnəʊmɐ",
    "adenoidal": "ædənɔɪdəl",
    "adenoids": "ædənɔɪdz",
    "adenosine": "ædənɒsaɪn",
    "adeptly": "ɐdɛptli",
    "adeptness": "ɐdɛptnəs",
    "adequacy": "ædɪkwəsi",
    "adequate": "ædɪkwət",
    "adequately": "ædɪkwətli",
    "adhered": "ædhiəd",
    "adhere": "ɐdhiə",
    "adherence": "ɐdhiərəns",
    "adherent": "ɐdhiərənt",
    "adherents": "ɐdhiərənts",
    "adheres": "ɐdhiəz",
    "adhering": "ædhiərɪŋ",
    "adhesion": "ɐdhiːʒən",
    "adhesive": "ɐdhiːsɪv",
    "adhesives": "ɐdhiːsɪvz",
    "adiabatic": "eɪdɪɐbætɪk",
    "adieu": "ɐdjuː",
    "adieux": "ɐdjuːz",
    "adipose": "ædɪpəʊz",
    "adits": "ædɪts",
    "adjacent": "ɐdʒeɪsənt",
    "adjectival": "ædʒɪktaɪvəl",
    "adjective": "ædʒɪktɪv",
    "adjectives": "ædʒɪktɪvz",
    "adjoin": "ɐdʒɔɪn",
    "adjoined": "ɐdʒɔɪnd",
    "adjoining": "ɐdʒɔɪnɪŋ",
    "adjoins": "ɐdʒɔɪnz",
    "adjourn": "ɐdʒɜːn",
    "adjourned": "ɐdʒɜːnd",
    "adjourning": "ɐdʒɜːnɪŋ",
    "adjournment": "ɐdʒɜːnmənt",
    "adjourns": "ɐdʒɜːnz",
    "adjudged": "ɐdʒʌdʒd",
    "adjudicated": "ɐdʒuːdɪkeɪtɪd",
    "adjudicate": "ɐdʒuːdɪkeɪt",
    "adjudicates": "ɐdʒuːdɪkeɪts",
    "adjudicating": "ɐdʒuːdɪkeɪtɪŋ",
    "adjudication": "ɐdʒuːdɪkeɪʃən",
    "adjudications": "ɐdʒuːdɪkeɪʃənz",
    "adjudicator": "ɐdʒuːdɪkeɪtɐ",
    "adjudicators": "ɐdʒuːdɪkeɪtəz",
    "adjunct": "æddʒʌŋkt",
    "adjustable": "ɐdʒʌstəbəl",
    "adjust": "ɐdʒʌst",
    "adjusted": "ɐdʒʌstɪd",
    "adjuster": "ɐdʒʌstɐ",
    "adjusters": "ɐdʒʌstəz",
    "adjusting": "ɐdʒʌstɪŋ",
    "adjustment": "ɐdʒʌstmənt",
    "adjustments": "ɐdʒʌstmənts",
    "adjustor": "ɐdʒʌstɐ",
    "adjustors": "ɐdʒʌstəz",
    "adjusts": "ɐdʒʌsts",
    "adjutant": "ædʒuːtənt",
    "adjuvant": "ɐdʒuːvənt",
    "admen": "ɐdmɛn",
    "administer": "ɐdmɪnɪstɐ",
    "administered": "ɐdmɪnɪstəd",
    "administering": "ɐdmɪnɪstərɪŋ",
    "administers": "ɐdmɪnɪstəz",
    "administrate": "ɐdmɪnɪstreɪt",
    "administrating": "ɐdmɪnɪstreɪtɪŋ",
    "administration": "ɐdmɪnɪstreɪʃən",
    "administrations": "ɐdmɪnɪstreɪʃənz",
    "administrative": "ɐdmɪnɪstrətɪv",
    "administratively": "ɐdmɪnɪstrətɪvli",
    "administrator": "ɐdmɪnɪstreɪtɐ",
    "administrators": "ɐdmɪnɪstreɪtəz",
    "admirable": "ædmərəbəl",
    "admirably": "ædmərəbli",
    "admiral": "ædmɜːrəl",
    "admirals": "ædmɜːrəlz",
    "admiralty": "ædmərəlti",
    "admiration": "ædməreɪʃən",
    "admired": "ɐdmaɪəd",
    "admire": "ɐdmaɪə",
    "admirer": "ɐdmaɪərɐ",
    "admirers": "ɐdmaɪərəz",
    "admires": "ɐdmaɪəz",
    "admiring": "ɐdmaɪərɪŋ",
    "admiringly": "ɐdmaɪərɪŋli",
    "admissibility": "ɐdmɪsəbɪlɪti",
    "admissible": "ɐdmɪsəbəl",
    "admission": "ɐdmɪʃən",
    "admissions": "ɐdmɪʃənz",
    "admit": "ɐdmɪt",
    "admits": "ɐdmɪts",
    "admittance": "ɐdmɪtəns",
    "admitted": "ɐdmɪtɪd",
    "admittedly": "ɐdmɪtɪdli",
    "admitting": "ɐdmɪtɪŋ",
    "admixture": "ɐdmɪkstʃɐ",
    "admonish": "ɐdmɒnɪʃ",
    "admonished": "ɐdmɒnɪʃt",
    "admonishes": "ɐdmɒnɪʃɪz",
    "admonishing": "ɐdmɒnɪʃɪŋ",
    "admonishment": "ɐdmɒnɪʃmənt",
    "admonition": "ædmənɪʃən",
    "admonitions": "ædmənɪʃənz",
    "adobe": "ɐdəʊbi",
    "ado": "ɐduː",
    "adolescence": "ædəlɛsəns",
    "adolescent": "ædəlɛsənt",
    "adolescents": "ædəlɛsənts",
    "adonis": "ædəʊniz",
    "adonises": "ædənaɪzɪz",
    "adoptable": "ɐdɒptəbəl",
    "adopt": "ɐdɒpt",
    "adopted": "ɐdɒptɪd",
    "adoptee": "ɐdɒptiː",
    "adopter": "ɐdɒptɐ",
    "adopters": "ɐdɒptəz",
    "adopting": "ɐdɒptɪŋ",
    "adoption": "ɐdɒpʃən",
    "adoptions": "ɐdɒpʃənz",
    "adoptive": "ɐdɒptɪv",
    "adopts": "ɐdɒpts",
    "adorable": "ɐdɔːrəbəl",
    "adorableness": "ɐdɔːrəbəlnəs",
    "adorably": "ɐdɔːrəbli",
    "adoration": "ædəreɪʃən",
    "adored": "ɐdɔːd",
    "adore": "ɐdɔː",
    "adorers": "ɐdɔːrəz",
    "adores": "ɐdɔːz",
    "adoring": "ɐdɔːrɪŋ",
    "adoringly": "ɐdɔːrɪŋli",
    "adorn": "ɐdɔːn",
    "adorned": "ɐdɔːnd",
    "adorning": "ɐdɔːnɪŋ",
    "adornment": "ɐdɔːnmənt",
    "adornments": "ɐdɔːnmənts",
    "adorns": "ɐdɔːnz",
    "adown": "ɐdaʊn",
    "adrenal": "ɐdriːnəl",
    "adrenalin": "ɐdrɛnɐlɪn",
    "adrenaline": "ɐdrɛnəlɪn",
    "adrift": "ɐdrɪft",
    "adroit": "ɐdrɔɪt",
    "adroitly": "ɐdrɔɪtli",
    "ads": "ædz",
    "adsorption": "ɐdsɔːpʃən",
    "adulate": "ædjʊleɪt",
    "adulated": "ædjʊleɪtɪd",
    "adulation": "ædjʊleɪʃən",
    "adult": "ædʌlt",
    "adulterated": "ɐdʌltəreɪtɪd",
    "adulterating": "ɐdʌltəreɪtɪŋ",
    "adulteration": "ɐdʌltəreɪʃən",
    "adulterer": "ɐdʌltərɐ",
    "adulterers": "ɐdʌltərəz",
    "adulteress": "ɐdʌltərəs",
    "adulteresses": "ɐdʌltərəsɪz",
    "adulteries": "ɐdʌltəriz",
    "adulterous": "ɐdʌltərəs",
    "adultery": "ɐdʌltəri",
    "adulthood": "ɐdʌlthʊd",
    "adults": "ædʌlts",
    "advanced": "ɐdvænst",
    "advance": "ɐdvæns",
    "advancement": "ɐdvænsmənt",
    "advancements": "ɐdvænsmənts",
    "advances": "ɐdvænsɪz",
    "advancing": "ɐdvænsɪŋ",
    "advantaged": "ɐdvɑːntɪdʒd",
    "advantage": "ɐdvɑːntɪdʒ",
    "advantageous": "ɐdvɑːnteɪdʒəs",
    "advantageously": "ɐdvɑːnteɪdʒəsli",
    "advantages": "ɐdvɑːntɪdʒɪz",
    "advent": "ædvɛnt",
    "adventitious": "ædvɪntɪʃəs",
    "adventured": "ɐdvɛntʃəd",
    "adventure": "ɐdvɛntʃɐ",
    "adventurer": "ɐdvɛntʃərɐ",
    "adventurers": "ɐdvɛntʃərəz",
    "adventures": "ɐdvɛntʃəz",
    "adventuresome": "ɐdvɛntʃəsʌm",
    "adventuress": "ɐdvɛntʃərɛs",
    "adventuring": "ɐdvɛntʃərɪŋ",
    "adventurism": "ɐdvɛntʃərɪzəm",
    "adventurist": "ɐdvɛntʃərɪst",
    "adventurists": "ɐdvɛntʃərɪsts",
    "adventurous": "ɐdvɛntʃərəs",
    "adventurously": "ɐdvɛntʃərəsli",
    "adventurousness": "ɐdvɛntʃərəsnəs",
    "adverb": "ædvɜːb",
    "adverbs": "ædvɜːbz",
    "adversarial": "ædvəseərɪəl",
    "adversaries": "ædvəsəriz",
    "adversary": "ædvəsəri",
    "adverse": "ædvɜːs",
    "adversely": "ædvɜːsli",
    "adversities": "ædvəsɪtiz",
    "adversity": "ædvəsɪti",
    "adverted": "ɐdvɜːtɪd",
    "advertise": "ædvətaɪz",
    "advertised": "ædvətaɪzd",
    "advertisement": "ɐdvɜːtɪsmənt",
    "advertisements": "ædvətaɪzmənts",
    "advertiser": "ædvətaɪzɐ",
    "advertisers": "ædvətaɪzəz",
    "advertises": "ædvətaɪzɪz",
    "advertising": "ædvətaɪzɪŋ",
    "advice": "ɐdvaɪs",
    "advices": "ɐdvaɪsɪz",
    "advisability": "ɐdvaɪzəbɪlɪti",
    "advisable": "ɐdvaɪzəbəl",
    "advised": "ɐdvaɪzd",
    "advisedly": "ɐdvaɪzɪdli",
    "advise": "ɐdvaɪz",
    "adviser": "ɐdvaɪzɐ",
    "advisers": "ɐdvaɪzəz",
    "advises": "ɐdvaɪzɪz",
    "advising": "ɐdvaɪzɪŋ",
    "advisor": "ɐdvaɪzɐ",
    "advisories": "ɐdvaɪzəriz",
    "advisors": "ɐdvaɪzəz",
    "advisory": "ɐdvaɪzəri",
    "advocaat": "ædvəkɑːt",
    "advocacy": "ædvəkəsi",
    "advocated": "ædvəkeɪtɪd",
    "advocating": "ædvəkeɪtɪŋ",
    "advocation": "ædvəkeɪʃən",
    "advocator": "ædvəkeɪtɐ",
    "adz": "ædz",
    "adze": "ædz",
    "aedes": "iːdz",
    "aegis": "iːdʒɪs",
    "aeolian": "iːəʊliən",
    "aeolipile": "iːəlɪpaɪl",
    "aeon": "iːɒn",
    "aeons": "iːɒnz",
    "aerated": "eəreɪtɪd",
    "aerate": "eəreɪt",
    "aerates": "eəreɪts",
    "aerating": "eəreɪtɪŋ",
    "aeration": "eəreɪʃən",
    "aerialist": "eərɪəlɪst",
    "aerials": "eərɪəlz",
    "aerobatic": "eərəʊbætɪk",
    "aerobatics": "eərəʊbætɪks",
    "aerobically": "eərəʊbɪkli",
    "aerobic": "eərəʊbɪk",
    "aerobics": "eərəʊbɪks",
    "aerodrome": "eərəʊdrəʊm",
    "aerodromes": "eərəʊdrəʊmz",
    "aerodynamically": "eərəʊdaɪnæmɪkli",
    "aerodynamic": "eərəʊdaɪnæmɪk",
    "aerodynamicist": "eərəʊdaɪnæmɪsɪst",
    "aerodynamics": "eərəʊdaɪnæmɪks",
    "aero": "eərəʊ",
    "aerofoil": "eərəʊfɔɪl",
    "aerofoils": "eərəʊfɔɪlz",
    "aeronaut": "eərəʊnɔːt",
    "aeronautical": "eərəʊnɔːtɪkəl",
    "aeronautic": "eərəʊnɔːtɪk",
    "aeronautics": "eərəʊnɔːtɪks",
    "aeronauts": "eərəʊnɔːts",
    "aeroplane": "eərəpleɪn",
    "aeroplanes": "eərəpleɪnz",
    "aerosol": "eərəsɒl",
    "aerosols": "eərəsɒlz",
    "aerospace": "eərəʊspeɪs",
    "aesthete": "iːsθiːt",
    "aesthetes": "iːsθiːts",
    "aesthetically": "iːsθɛtɪkli",
    "aesthetic": "iːsθɛtɪk",
    "aesthetics": "iːsθɛtɪks",
    "aestival": "iːstɪvəl",
    "aetiology": "iːtɪɒlədʒi",
    "afar": "ɐfɑː",
    "afeard": "ɐfiəd",
    "affability": "æfəbɪlɪti",
    "affable": "æfəbəl",
    "affaire": "ɐfeə",
    "affaires": "ɐfeəz",
    "affair": "ɐfeə",
    "affairs": "ɐfeəz",
    "affectation": "ɐfɪkteɪʃən",
    "affectations": "ɐfɪkteɪʃənz",
    "affected": "ɐfɛktɪd",
    "affecting": "ɐfɛktɪŋ",
    "affectionate": "ɐfɛkʃənət",
    "affectionately": "ɐfɛkʃənətli",
    "affection": "ɐfɛkʃən",
    "affections": "ɐfɛkʃənz",
    "affective": "ɐfɛktɪv",
    "affectively": "ɐfɛktɪvli",
    "afferent": "æfrənt",
    "affianced": "ɐfaɪənst",
    "affidavit": "æfɪdeɪvɪt",
    "affidavits": "æfɪdeɪvɪts",
    "affiliated": "ɐfɪlɪeɪtɪd",
    "affiliates": "ɐfɪlɪeɪts",
    "affiliation": "ɐfɪlɪeɪʃən",
    "affiliations": "ɐfɪlɪeɪʃənz",
    "affinities": "ɐfɪnɪtiz",
    "affinity": "ɐfɪnɪti",
    "affirmation": "æfəmeɪʃən",
    "affirmations": "æfəmeɪʃənz",
    "affirmative": "ɐfɜːmətɪv",
    "affirmatively": "ɐfɜːmətɪvli",
    "affirmed": "ɐfɜːmd",
    "affirm": "ɐfɜːm",
    "affirming": "ɐfɜːmɪŋ",
    "affirms": "ɐfɜːmz",
    "affixed": "ɐfɪkst",
    "afflatus": "ɐflætəs",
    "afflicted": "ɐflɪktɪd",
    "afflict": "ɐflɪkt",
    "afflicting": "ɐflɪktɪŋ",
    "affliction": "ɐflɪkʃən",
    "afflictions": "ɐflɪkʃənz",
    "afflicts": "ɐflɪkts",
    "affluence": "æfluːəns",
    "affluent": "æfluːənt",
    "affordability": "ɐfɔːdəbɪlɪti",
    "affordable": "ɐfɔːdəbəl",
    "affordably": "ɐfɔːdəbli",
    "afforded": "ɐfɔːdɪd",
    "afford": "ɐfɔːd",
    "affording": "ɐfɔːdɪŋ",
    "affords": "ɐfɔːdz",
    "afforestation": "ɐfɒrɪsteɪʃən",
    "affray": "ɐfreɪ",
    "affrighted": "ɐfraɪtɪd",
    "affright": "ɐfraɪt",
    "affronted": "ɐfrʌntɪd",
    "affront": "ɐfrʌnt",
    "affronts": "ɐfrʌnts",
    "afghan": "æfɡæn",
    "afghani": "æfɡɑːni",
    "afghanis": "æfɡɑːnɪz",
    "afghans": "æfɡænz",
    "aficionado": "ɐfɪʃənɑːdəʊ",
    "aficionados": "ɐfɪʃənɑːdəʊz",
    "afield": "ɐfiːld",
    "afire": "ɐfaɪə",
    "aflame": "ɐfleɪm",
    "aflatoxin": "ɐflætəksɪn",
    "afloat": "ɐfləʊt",
    "aflutter": "ɐflʌtɐ",
    "afoot": "ɐfʊt",
    "afore": "ɐfɔː",
    "aforementioned": "ɐfɔːmɛnʃənd",
    "aforesaid": "ɐfɔːsɛd",
    "aforethought": "ɐfɔːθɔːt",
    "afoul": "ɐfaʊl",
    "afraid": "ɐfreɪd",
    "afresh": "ɐfrɛʃ",
    "afterbirth": "ɑːftəbɜːθ",
    "afterburners": "ɑːftəbɜːnəz",
    "aftercare": "ɑːftəkeə",
    "aftereffect": "ɑːftərɪfɛkt",
    "aftereffects": "ɑːftərɪfɛkts",
    "after": "ɑːftɐ",
    "afterglow": "ɑːftəɡləʊ",
    "afterimage": "ɑːftərɪmɪdʒ",
    "afterlife": "ɑːftəlaɪf",
    "afterlives": "ɑːftəlɪvz",
    "aftermarket": "ɑːftəmɑːkɪt",
    "aftermath": "ɑːftəmæθ",
    "aftermaths": "ɑːftəmæθs",
    "afternoons": "ɑːftənuːnz",
    "afterschool": "ɑːftəskuːl",
    "afters": "ɑːftəz",
    "aftershave": "ɑːftəʃeɪv",
    "aftershaves": "ɑːftəʃeɪvz",
    "aftershock": "ɑːftəʃɒk",
    "aftershocks": "ɑːftəʃɒks",
    "aftertaste": "ɑːftəteɪst",
    "afterthought": "ɑːftəθɔːt",
    "afterward": "ɑːftəwəd",
    "afterwards": "ɑːftəwədz",
    "aft": "ɑːft",
    "aga": "ɑːɡɐ",
    "again": "ɐɡɛn",
    "against": "ɐɡɛnst",
    "agama": "æɡɑːmɐ",
    "agamas": "æɡɑːməz",
    "agapanthus": "æɡɐpɑːnθəs",
    "agar": "eɪɡɑː",
    "agaric": "æɡærɪk",
    "agate": "æɡeɪt",
    "agates": "æɡeɪts",
    "agave": "æɡeɪv",
    "agee": "ædʒiː",
    "age": "eɪdʒ",
    "ageing": "eɪdʒɪŋ",
    "ageism": "eɪdʒɪzəm",
    "ageist": "eɪdʒɪst",
    "ageless": "eɪdʒləs",
    "agencies": "eɪdʒənsiz",
    "agency": "eɪdʒənsi",
    "agenda": "ɐdʒɛndɐ",
    "agendas": "ɐdʒɛndəz",
    "agent": "eɪdʒənt",
    "agents": "eɪdʒənts",
    "ageratum": "eɪdʒərɑːtəm",
    "ages": "eɪdʒɪz",
    "agger": "æɡɐ",
    "aggie": "æɡi",
    "agglomeration": "ɐɡlɒməreɪʃən",
    "agglomerations": "ɐɡlɒməreɪʃənz",
    "aggrandise": "ɐɡrændaɪz",
    "aggrandisement": "ɐɡrændaɪzmənt",
    "aggrandising": "ɐɡrændaɪzɪŋ",
    "aggravate": "æɡrɐveɪt",
    "aggravated": "æɡrɐveɪtɪd",
    "aggravates": "æɡrɐveɪts",
    "aggravating": "æɡrɐveɪtɪŋ",
    "aggravation": "æɡrɐveɪʃən",
    "aggravations": "æɡrɐveɪʃənz",
    "aggregated": "æɡrɪɡeɪtɪd",
    "aggregating": "æɡrɪɡeɪtɪŋ",
    "aggregation": "æɡrɪɡeɪʃən",
    "aggregations": "æɡrɪɡeɪʃənz",
    "aggress": "ɐɡrɛs",
    "aggression": "ɐɡrɛʃən",
    "aggressions": "ɐɡrɛʃənz",
    "aggressive": "ɐɡrɛsɪv",
    "aggressively": "ɐɡrɛsɪvli",
    "aggressiveness": "ɐɡrɛsɪvnəs",
    "aggressor": "ɐɡrɛsɐ",
    "aggressors": "ɐɡrɛsəz",
    "aggrieved": "ɐɡriːvd",
    "aggro": "æɡrəʊ",
    "aghast": "ɐɡɑːst",
    "agile": "ædʒaɪl",
    "agilely": "ædʒaɪlli",
    "agility": "ædʒɪlɪti",
    "aging": "eɪdʒɪŋ",
    "agios": "ɑːdʒɪəʊz",
    "agist": "eɪdʒɪst",
    "agitate": "ædʒɪteɪt",
    "agitated": "ædʒɪteɪtɪd",
    "agitatedly": "ædʒɪteɪtɪdli",
    "agitates": "ædʒɪteɪts",
    "agitating": "ædʒɪteɪtɪŋ",
    "agitation": "ædʒɪteɪʃən",
    "agitator": "ædʒɪteɪtɐ",
    "agitators": "ædʒɪteɪtəz",
    "agitprop": "ædʒɪtprɒp",
    "aglet": "ɐɡlɛt",
    "agley": "ɐɡlaɪ",
    "aglow": "ɐɡləʊ",
    "agnosia": "æɡnəʊziə",
    "agnostic": "æɡnɒstɪk",
    "agnosticism": "æɡnɒstɪsɪzəm",
    "agnostics": "æɡnɒstɪks",
    "ago": "ɐɡəʊ",
    "agog": "ɐɡɒɡ",
    "agon": "æɡɒn",
    "agonies": "æɡənɪz",
    "agonise": "æɡənaɪz",
    "agonised": "æɡənaɪzd",
    "agonises": "æɡənaɪzɪz",
    "agonising": "æɡənaɪzɪŋ",
    "agonisingly": "æɡənaɪzɪŋli",
    "agony": "æɡəni",
    "agoraphobia": "æɡɔːrɐfəʊbiə",
    "agoraphobic": "æɡɔːrɐfəʊbɪk",
    "agouti": "æɡaʊti",
    "agoutis": "æɡaʊtiz",
    "agrarian": "æɡreəriən",
    "agreeable": "ɐɡriːəbəl",
    "agreeableness": "ɐɡriːəbəlnəs",
    "agreeably": "ɐɡriːəbli",
    "agreed": "ɐɡriːd",
    "agree": "ɐɡriː",
    "agreeing": "ɐɡriːɪŋ",
    "agreement": "ɐɡriːmənt",
    "agreements": "ɐɡriːmənts",
    "agrees": "ɐɡriːz",
    "agribusiness": "æɡrɪbɪznəs",
    "agribusinesses": "æɡrɪbɪznəsɪz",
    "agricultural": "æɡrɪkʌltʃərəl",
    "agriculturalist": "æɡrɪkʌltʃərəlɪst",
    "agriculturalists": "æɡrɪkʌltʃərəlɪsts",
    "agriculturally": "æɡrɪkʌltʃərəli",
    "agriculture": "æɡrɪkʌltʃɐ",
    "agriculturists": "æɡrɪkʌltʃərɪsts",
    "agrimony": "æɡrɪməni",
    "agrochemical": "æɡrəkɛmɪkəl",
    "agrochemicals": "æɡrəkɛmɪkəlz",
    "agronomist": "ɐɡrɒnəmɪst",
    "agronomists": "ɐɡrɒnəmɪsts",
    "agronomy": "ɐɡrɒnəmi",
    "aground": "ɐɡraʊnd",
    "ague": "eɪɡjuː",
    "ah": "ɑː",
    "aha": "ɑːhɑː",
    "ahead": "ɐhɛd",
    "ahem": "əhəm",
    "ahimsa": "æhɪmsɐ",
    "ahoy": "ɐhɔɪ",
    "aid": "eɪd",
    "aided": "eɪdɪd",
    "aide": "eɪd",
    "aider": "eɪdɐ",
    "aiders": "eɪdəz",
    "aides": "eɪdz",
    "aiding": "eɪdɪŋ",
    "aids": "eɪdz",
    "ai": "eɪaɪ",
    "aikido": "eɪkiːdəʊ",
    "ailed": "eɪld",
    "ail": "eɪl",
    "aileron": "eɪlərən",
    "ailerons": "eɪlərənz",
    "ailing": "eɪlɪŋ",
    "ailment": "eɪlmənt",
    "ailments": "eɪlmənts",
    "ails": "eɪlz",
    "aimed": "eɪmd",
    "aim": "eɪm",
    "aiming": "eɪmɪŋ",
    "aimless": "eɪmləs",
    "aimlessly": "eɪmləsli",
    "aimlessness": "eɪmləsnəs",
    "aims": "eɪmz",
    "ain": "eɪn",
    "airbag": "eəbæɡ",
    "airbags": "eəbæɡz",
    "airbase": "eəbeɪs",
    "airbases": "eəbeɪsɪz",
    "airbed": "eəbd",
    "airbeds": "eəbdz",
    "airborne": "eəbɔːn",
    "airbrushed": "eəbrʌʃt",
    "airbrush": "eəbrʌʃ",
    "airbrushes": "eəbrʌʃɪz",
    "airbrushing": "eəbrʌʃɪŋ",
    "airburst": "eəbɜːst",
    "airbus": "eəbʌs",
    "airbuses": "eəbʌsɪz",
    "aircraft": "eəkrɑːft",
    "aircraftman": "eəkrɑːftmən",
    "aircrew": "eəkruː",
    "aircrews": "eəkruːz",
    "airdrop": "eədrɒp",
    "airdrops": "eədrɒps",
    "aired": "eəd",
    "air": "eə",
    "airfare": "eəfeə",
    "airfares": "eəfeəz",
    "airfield": "eəfiːld",
    "airfields": "eəfiːldz",
    "airflow": "eəfləʊ",
    "airframe": "eəfreɪm",
    "airframes": "eəfreɪmz",
    "airfreight": "eəfreɪt",
    "airgun": "eəɡʌn",
    "airguns": "eəɡʌnz",
    "airhead": "eəhɛd",
    "airheads": "eəhɛdz",
    "airier": "eərɪɐ",
    "airily": "eərɪli",
    "airiness": "eərɪnəs",
    "airing": "eərɪŋ",
    "airings": "eərɪŋz",
    "airless": "eələs",
    "airlifted": "eəlɪftɪd",
    "airlift": "eəlɪft",
    "airlifting": "eəlɪftɪŋ",
    "airlifts": "eəlɪfts",
    "airline": "eəlaɪn",
    "airliner": "eəlaɪnɐ",
    "airliners": "eəlaɪnəz",
    "airlines": "eəlaɪnz",
    "airlock": "eəlɒk",
    "airlocks": "eəlɒks",
    "airmail": "eəmeɪl",
    "airman": "eəmən",
    "airmen": "eəmɛn",
    "airplay": "eəpleɪ",
    "airport": "eəpɔːt",
    "airports": "eəpɔːts",
    "airpower": "eəpaʊə",
    "airscrew": "eəskruː",
    "airs": "eəz",
    "airship": "eəʃɪp",
    "airships": "eəʃɪps",
    "airshow": "eəʃəʊ",
    "airshows": "eəʃəʊz",
    "airsick": "eəsɪk",
    "airspace": "eəspeɪs",
    "airspeed": "eəspiːd",
    "airstream": "eəstriːm",
    "airstrike": "eəstraɪk",
    "airstrikes": "eəstraɪks",
    "airstrip": "eəstrɪp",
    "airstrips": "eəstrɪps",
    "airt": "eət",
    "airtight": "eətaɪt",
    "airtime": "eətaɪm",
    "airwave": "eəweɪv",
    "airwaves": "eəweɪvz",
    "airway": "eəweɪ",
    "airways": "eəweɪz",
    "airworthiness": "eəwəðɪnəs",
    "airworthy": "eəwɜːði",
    "airy": "eəri",
    "ais": "aɪz",
    "aisle": "aɪəl",
    "aisles": "aɪəlz",
    "aitch": "eɪtʃ",
    "ait": "eɪt",
    "ajar": "ɐdʒɑː",
    "aka": "ækɐ",
    "akee": "ækiː",
    "akimbo": "ɐkɪmbəʊ",
    "akin": "ɐkɪn",
    "alabaster": "æləbæstɐ",
    "alack": "ɐlæk",
    "alacrity": "ɐlækrɪti",
    "ala": "ɐlæ",
    "alameda": "ɐleɪmdɐ",
    "alarmed": "ɐlɑːmd",
    "alarming": "ɐlɑːmɪŋ",
    "alarmingly": "ɐlɑːmɪŋli",
    "alarmism": "ɐlɑːmɪzəm",
    "alarmist": "ɐlɑːmɪst",
    "alarm": "ɐlɑːm",
    "alarms": "ɐlɑːmz",
    "alarum": "ɐlɑːrəm",
    "alarums": "ɐlɑːrəmz",
    "alas": "ɐlæs",
    "alba": "ælbɐ",
    "albacore": "ælbɐkɔː",
    "alb": "ælb",
    "albatross": "ælbɐtrɒs",
    "albatrosses": "ælbɐtrɒsɪz",
    "albedo": "ælbiːdəʊ",
    "albeit": "ɔːlbiːɪt",
    "albino": "ælbiːnəʊ",
    "albinos": "ælbiːnəʊz",
    "albs": "ælbz",
    "album": "ælbəm",
    "albumen": "ælbjuːmɛn",
    "albums": "ælbəmz",
    "alchemical": "ælkɛmɪkəl",
    "alchemist": "ælkɪmɪst",
    "alchemists": "ælkɪmɪsts",
    "alchemy": "ælkəmi",
    "alcohol": "ælkəhɒl",
    "alcoholic": "ælkəhɒlɪk",
    "alcoholically": "ælkəhɒlɪkli",
    "alcoholics": "ælkəhɒlɪks",
    "alcoholism": "ælkəhəʊlɪzəm",
    "alcohols": "ælkəhɒlz",
    "alcove": "ælkəʊv",
    "alcoves": "ælkəʊvz",
    "aldehyde": "ældɪhaɪd",
    "alderman": "ɔːldəmən",
    "aldermen": "ɔːldəmɛn",
    "alder": "ɔːldɐ",
    "alders": "ɔːldəz",
    "aldrin": "ɔːldrɪn",
    "alee": "æliː",
    "ale": "eɪl",
    "alehouse": "eɪlhaʊs",
    "alehouses": "eɪlhaʊzɪz",
    "alembic": "ɐlɛmbɪk",
    "alembics": "ɐlɛmbɪks",
    "aleph": "ælɛf",
    "alerted": "ɐlɜːtɪd",
    "alerting": "ɐlɜːtɪŋ",
    "alert": "ɐlɜːt",
    "alertly": "ɐlɜːtli",
    "alertness": "ɐlɜːtnəs",
    "alerts": "ɐlɜːts",
    "ales": "eɪlz",
    "alevin": "ɐlɛvɪn",
    "alexandrine": "ælɪɡzɑːndriːn",
    "alexandrite": "ælɪɡzɑːndraɪt",
    "alexia": "ɐlɛksiə",
    "alfalfa": "ælfælfɐ",
    "alfresco": "ɐlfrɛskəʊ",
    "alga": "ælɡɐ",
    "algae": "ælɡiː",
    "algal": "ælɡəl",
    "algebra": "ældʒɪbrɐ",
    "algebraic": "ældʒɪbreɪɪk",
    "alginate": "ældʒɪneɪt",
    "algorithm": "ælɡərɪθəm",
    "algorithmic": "ælɡərɪθmɪk",
    "algorithms": "ælɡərɪθəmz",
    "alias": "eɪliəs",
    "aliases": "eɪliəsɪz",
    "alibi": "æləbaɪ",
    "alibis": "æləbaɪz",
    "alienated": "eɪliəneɪtɪd",
    "alienate": "eɪliəneɪt",
    "alienates": "eɪliəneɪts",
    "alienating": "eɪliəneɪtɪŋ",
    "alienation": "eɪliəneɪʃən",
    "alien": "eɪliən",
    "aliens": "eɪliənz",
    "alighted": "ɐlaɪtɪd",
    "alighting": "ɐlaɪtɪŋ",
    "alight": "ɐlaɪt",
    "alights": "ɐlaɪts",
    "aligned": "ɐlaɪnd",
    "aligning": "ɐlaɪnɪŋ",
    "align": "ɐlaɪn",
    "alignment": "ɐlaɪnmənt",
    "alignments": "ɐlaɪnmənts",
    "aligns": "ɐlaɪnz",
    "alike": "ɐlaɪk",
    "alimentary": "ɐlaɪmɛntəri",
    "alimony": "ælɪməni",
    "aline": "ɐlaɪn",
    "alit": "ɐlɪt",
    "alive": "ɐlaɪv",
    "aliveness": "ɐlaɪvnəs",
    "aliya": "ælɪjɐ",
    "aliyah": "ælɪjɐ",
    "alkali": "ælkəlaɪ",
    "alkaline": "ælkəlaɪn",
    "alkalinity": "ælkəlaɪnɪti",
    "alkalis": "ælkəlaɪz",
    "alkaloid": "ælkɐlɔɪd",
    "alkaloids": "ælkɐlɔɪdz",
    "alkane": "ælkeɪn",
    "alkanes": "ælkeɪnz",
    "alkanet": "ælkɐnɛt",
    "alkenes": "ælkiːnz",
    "alky": "ælki",
    "allayed": "ɐleɪd",
    "allaying": "ɐleɪɪŋ",
    "allay": "ɐleɪ",
    "allays": "ɐleɪz",
    "allegation": "ælɪɡeɪʃən",
    "allegations": "ælɪɡeɪʃənz",
    "alleged": "ɐlɛdʒd",
    "allegedly": "ɐlɛdʒɪdli",
    "allege": "ɐlɛdʒ",
    "alleges": "ɐlɛdʒɪz",
    "allegiance": "ɐliːdʒəns",
    "allegiances": "ɐliːdʒənsɪz",
    "alleging": "ɐlɛdʒɪŋ",
    "allegorical": "ælɪɡɒrɪkəl",
    "allegories": "ælɪɡəriz",
    "allegory": "ælɪɡəri",
    "allegro": "ɐlɛɡrəʊ",
    "allele": "ɐliːl",
    "alleles": "ɐliːlz",
    "alleluia": "ælɪluːjɐ",
    "allemande": "æləmænd",
    "allergen": "ælədʒən",
    "allergenic": "ælədʒɛnɪk",
    "allergens": "ælədʒənz",
    "allergic": "ɐlɜːdʒɪk",
    "allergies": "ælədʒɪz",
    "allergist": "ælədʒɪst",
    "allergy": "ælədʒi",
    "alleviated": "ɐliːvɪeɪtɪd",
    "alleviate": "ɐliːvɪeɪt",
    "alleviates": "ɐliːvɪeɪts",
    "alleviating": "ɐliːvɪeɪtɪŋ",
    "alleviation": "ɐliːvɪeɪʃən",
    "alley": "æli",
    "alleys": "ælɪz",
    "alleyway": "ælɪweɪ",
    "alleyways": "ælɪweɪz",
    "alliance": "ɐlaɪəns",
    "alliances": "ɐlaɪənsɪz",
    "alligator": "ælɪɡeɪtɐ",
    "alligators": "ælɪɡeɪtəz",
    "alliteration": "ɐlɪtəreɪʃən",
    "alliterative": "ɐlɪtərətɪv",
    "alliteratively": "ɐlɪtərətɪvli",
    "allium": "æliəm",
    "allocate": "æləkeɪt",
    "allocated": "æləkeɪtɪd",
    "allocates": "æləkeɪts",
    "allocating": "æləkeɪtɪŋ",
    "allocation": "æləkeɪʃən",
    "allocations": "æləkeɪʃənz",
    "all": "ɔːl",
    "allot": "ɐlɒt",
    "allotment": "ɐlɒtmənt",
    "allotments": "ɐlɒtmənts",
    "allotrope": "ælətrəʊp",
    "allotropes": "ælətrəʊps",
    "allots": "ɐlɒts",
    "allotted": "ɐlɒtɪd",
    "allowable": "ɐlaʊəbəl",
    "allowance": "ɐlaʊəns",
    "allowances": "ɐlaʊənsɪz",
    "allowed": "ɐlaʊd",
    "allowing": "ɐlaʊɪŋ",
    "allow": "ɐlaʊ",
    "allows": "ɐlaʊz",
    "alloyed": "ælɔɪd",
    "alloying": "ælɔɪɪŋ",
    "allspice": "ɔːlspaɪs",
    "alluded": "ɐluːdɪd",
    "allude": "ɐluːd",
    "alludes": "ɐluːdz",
    "alluding": "ɐluːdɪŋ",
    "allured": "ɐlɔːd",
    "allure": "ɐlɔː",
    "alluring": "ɐlɔːrɪŋ",
    "alluringly": "ɐlɔːrɪŋli",
    "allusion": "ɐluːʒən",
    "allusions": "ɐluːʒənz",
    "allusive": "ɐluːsɪv",
    "alluvial": "ɐluːvɪəl",
    "alluvia": "ɐluːviə",
    "alluvium": "ɐluːviəm",
    "allying": "ælaɪɪŋ",
    "almanac": "ɒlmɐnæk",
    "almanacs": "ɒlmɐnæks",
    "almandine": "ɒlmɑːndiːn",
    "almighty": "ɒlmaɪti",
    "almond": "ɒlmənd",
    "almonds": "ɒlməndz",
    "almoner": "ɒlmənɐ",
    "almonry": "ɒlmɒnri",
    "almost": "ɔːlməʊst",
    "almshouse": "ɑːmzhaʊs",
    "almshouses": "ɑːmzhaʊzɪz",
    "alms": "ɑːmz",
    "aloe": "æləʊ",
    "aloes": "æləʊz",
    "aloft": "ɐlɒft",
    "aloha": "ɐləʊhɐ",
    "alone": "ɐləʊn",
    "aloneness": "ɐləʊnnəs",
    "along": "ɐlɒŋ",
    "alongside": "ɐlɒŋsaɪd",
    "aloof": "ɐluːf",
    "aloofness": "ɐluːfnəs",
    "alopecia": "ɐləʊpiːʃɐ",
    "aloud": "ɐlaʊd",
    "alow": "ɐləʊ",
    "alpaca": "ælpækɐ",
    "alpacas": "ælpækəz",
    "alp": "ælp",
    "alpha": "ælfɐ",
    "alphabet": "ælfəbɛt",
    "alphabetic": "ælfəbɛtɪk",
    "alphabetical": "ælfəbɛtɪkəl",
    "alphabetically": "ælfəbɛtɪkli",
    "alphabetise": "ælfəbɛtaɪz",
    "alphabetised": "ælfəbɛtaɪzd",
    "alphabetising": "ælfəbɛtaɪzɪŋ",
    "alphabets": "ælfəbɛts",
    "alphanumeric": "ælfənjuːmɛrɪk",
    "alphas": "ælfəz",
    "alpine": "ælpaɪn",
    "alpines": "ælpaɪnz",
    "alps": "ælps",
    "already": "ɔːlrɛdi",
    "alright": "ɔːlraɪt",
    "also": "ɒlsəʊ",
    "altar": "ɒltɐ",
    "altarpiece": "ɒltəpiːs",
    "altarpieces": "ɒltɑːpiːsɪz",
    "altars": "ɒltəz",
    "alteration": "ɒltəreɪʃən",
    "alterations": "ɒltəreɪʃənz",
    "alterative": "ɒltərətɪv",
    "altercation": "ɒltəkeɪʃən",
    "altercations": "ɒltəkeɪʃənz",
    "altered": "ɒltəd",
    "altering": "ɒltərɪŋ",
    "alter": "ɒltɐ",
    "alternated": "ɔːltəneɪtɪd",
    "alternately": "ɔːltɜːnətli",
    "alternates": "ɒltəneɪts",
    "alternating": "ɔːltəneɪtɪŋ",
    "alternation": "ɒltəneɪʃən",
    "alternations": "ɒltəneɪʃənz",
    "alternatively": "ɔːltɜːnətɪvli",
    "alternative": "ɔːltɜːnətɪv",
    "alternatives": "ɔːltɜːnətɪvz",
    "alternator": "ɔltəneɪtɐ",
    "alternators": "ɔltəneɪtəz",
    "alters": "ɒltəz",
    "although": "ɒlðəʊ",
    "altimeter": "æltɪmiːtɐ",
    "altiplano": "æltɪplɑːnəʊ",
    "altitude": "æltɪtjuːd",
    "altitudes": "æltɪtjuːdz",
    "alto": "æltəʊ",
    "altocumulus": "æltəkjuːmjʊləs",
    "altogether": "ɔːltəɡɛðɐ",
    "altos": "æltəʊz",
    "altruism": "ɔːltruːɪzəm",
    "altruistically": "ɔːltruːɪstɪkli",
    "altruistic": "ɔːltruːɪstɪk",
    "altruists": "ɔːltruːɪsts",
    "alula": "ɐljʊlæ",
    "alumina": "ɐluːmɪnɐ",
    "aluminate": "ɐluːmɪneɪt",
    "aluminium": "æljʊmɪniəm",
    "alumna": "ɐlʌmnɐ",
    "alumni": "ɐlʌmni",
    "alumnus": "ɐlʌmnəs",
    "alveolar": "ælvɪəʊlɐ",
    "alveoli": "ælvɪɒli",
    "always": "ɔːlweɪz",
    "alyssum": "ælɪsəm",
    "amadou": "æmɐduː",
    "amah": "æmɐ",
    "amain": "æmeɪn",
    "amalgamated": "ɐmælɡɐmeɪtɪd",
    "amalgamate": "ɐmælɡɐmeɪt",
    "amalgamates": "ɐmælɡɐmeɪts",
    "amalgamating": "ɐmælɡɐmeɪtɪŋ",
    "amalgamation": "ɐmælɡɐmeɪʃən",
    "amalgamations": "ɐmælɡɐmeɪʃənz",
    "amalgam": "ɐmælɡæm",
    "amandine": "æmɑːndiːn",
    "amanita": "æmɐniːtɐ",
    "amanuensis": "æmɐnjuːənsɪs",
    "amaranth": "æmərænθ",
    "amaretto": "æmərɛtəʊ",
    "amaryllis": "æmərɪlɪs",
    "amassed": "ɐmæst",
    "amasses": "ɐmæsɪz",
    "amassing": "ɐmæsɪŋ",
    "amass": "ɐmæs",
    "amateur": "æmətɐ",
    "amateurish": "æmətərɪʃ",
    "amateurishly": "æmətərɪʃli",
    "amateurishness": "æmətərɪʃnəs",
    "amateurism": "æmətərɪzəm",
    "amateurs": "æmətəz",
    "amatol": "æmɐtɒl",
    "amatory": "æmətəri",
    "amazed": "ɐmeɪzd",
    "amazement": "ɐmeɪzmənt",
    "amaze": "ɐmeɪz",
    "amazes": "ɐmeɪzɪz",
    "amazingly": "ɐmeɪzɪŋli",
    "amazing": "ɐmeɪzɪŋ",
    "amazon": "æməzən",
    "amazonian": "æməzəʊniən",
    "amazons": "æməzənz",
    "ambassadorial": "æmbɐsɐdɔːrɪəl",
    "ambassador": "ɐmbæsədɐ",
    "ambassadorship": "ɐmbæsədəʃɪp",
    "ambassadorships": "ɐmbæsədəʃɪps",
    "ambassadors": "ɐmbæsədəz",
    "ambassadress": "æmbɐsædrɛs",
    "amber": "æmbɐ",
    "ambergris": "æmbəɡrɪs",
    "ambiance": "æmbiəns",
    "ambidextrous": "æmbɪdɛkstrəs",
    "ambience": "æmbiəns",
    "ambient": "æmbiənt",
    "ambiguities": "æmbɪɡjuːɪtɪz",
    "ambiguity": "æmbɪɡjuːɪti",
    "ambiguous": "æmbɪɡjuːəs",
    "ambiguously": "æmbɪɡjuːəsli",
    "ambit": "æmbɪt",
    "ambition": "æmbɪʃən",
    "ambitions": "æmbɪʃənz",
    "ambitious": "æmbɪʃəs",
    "ambitiously": "æmbɪʃəsli",
    "ambivalence": "æmbɪvələns",
    "ambivalent": "æmbɪvələnt",
    "amble": "æmbəl",
    "ambled": "æmbəld",
    "ambler": "æmblɐ",
    "ambles": "æmbəlz",
    "ambling": "æmblɪŋ",
    "ambo": "æmbəʊ",
    "ambos": "æmbəʊz",
    "ambrosia": "æmbrəʊziə",
    "ambrosial": "æmbrəʊsɪəl",
    "ambulance": "æmbjʊləns",
    "ambulanceman": "æmbjʊlɑːnsɛmən",
    "ambulances": "æmbjʊlənsɪz",
    "ambulatory": "æmbjʊleɪtəri",
    "ambush": "æmbʊʃ",
    "ambushed": "æmbʊʃt",
    "ambusher": "æmbʊʃɐ",
    "ambushes": "æmbʊʃɪz",
    "ambushing": "æmbʊʃɪŋ",
    "ameer": "æmiə",
    "ameliorated": "ɐmiːliəreɪtɪd",
    "ameliorate": "ɐmiːliəreɪt",
    "ameliorating": "ɐmiːliəreɪtɪŋ",
    "amelioration": "ɐmiːliəreɪʃən",
    "amenable": "ɐmiːnəbəl",
    "amendable": "ɐmɛndəbəl",
    "amended": "ɐmɛndɪd",
    "amending": "ɐmɛndɪŋ",
    "amend": "ɐmɛnd",
    "amendment": "ɐmɛndmənt",
    "amendments": "ɐmɛndmənts",
    "amends": "ɐmɛndz",
    "amenities": "ɐmɛnɪtiz",
    "amenity": "ɐmɛnɪti",
    "amen": "ɑːmɛn",
    "ament": "ɐmɛnt",
    "amerced": "æmɜːst",
    "americium": "ɐmɪrɪsiəm",
    "amethyst": "æmɪθɪst",
    "amethysts": "æmɪθɪsts",
    "amiability": "eɪmiəbɪlɪti",
    "amiable": "eɪmiəbəl",
    "amiably": "eɪmiəbli",
    "amicable": "æmɪkəbəl",
    "amicably": "æmɪkəbli",
    "amice": "æmɪs",
    "amide": "ɐmaɪd",
    "amid": "ɐmɪd",
    "amidships": "ɐmɪdʃɪps",
    "amidst": "ɐmɪdst",
    "amie": "æmi",
    "amigo": "ɐmiːɡəʊ",
    "amigos": "ɐmiːɡəʊz",
    "ami": "ɑːmi",
    "amine": "æmaɪn",
    "amino": "ɐmiːnəʊ",
    "amir": "æmiə",
    "amirs": "æmiəz",
    "amiss": "ɐmɪs",
    "amity": "æmɪti",
    "ammeter": "æmiːtɐ",
    "ammeters": "æmiːtəz",
    "ammo": "æməʊ",
    "ammonia": "æməʊniə",
    "ammonite": "æmənaɪt",
    "ammonites": "æmənaɪts",
    "ammonium": "æməʊniəm",
    "ammunition": "æmjuːnɪʃən",
    "amnesia": "æmniːziə",
    "amnesiac": "æmniːzɪæk",
    "amnesic": "æmniːzɪk",
    "amnestied": "æmnəstɪd",
    "amnesties": "æmnəstɪz",
    "amnesty": "æmnəsti",
    "amniotic": "æmnɪɒtɪk",
    "amoeba": "ɐmiːbɐ",
    "amoebas": "ɐmiːbəz",
    "amoebic": "ɐmiːbɪk",
    "amok": "ɐmɒk",
    "among": "ɐmʌŋ",
    "amongst": "ɐmʌŋst",
    "amontillado": "æməntɪlɑːdəʊ",
    "amoral": "eɪmɒrəl",
    "amorality": "æmərælɪti",
    "amoroso": "æmɔːrəʊsəʊ",
    "amorous": "æmərəs",
    "amorously": "æmərəsli",
    "amorphous": "ɐmɔːfəs",
    "amounted": "ɐmaʊntɪd",
    "amounting": "ɐmaʊntɪŋ",
    "amount": "ɐmaʊnt",
    "amounts": "ɐmaʊnts",
    "amour": "æmɐ",
    "amours": "æməz",
    "amoxicillin": "æməksɪsɪlɪn",
    "amp": "æmp",
    "ampere": "æmpeə",
    "amperes": "æmpeəz",
    "ampersand": "æmpəsænd",
    "amphetamine": "æmfɛtɐmiːn",
    "amphetamines": "æmfɛtɐmiːnz",
    "amphibian": "æmfɪbiən",
    "amphibians": "æmfɪbiənz",
    "amphibious": "æmfɪbɪəs",
    "amphiboles": "æmfɪbəʊlz",
    "amphipods": "æmfɪpɒdz",
    "amphitheater": "æmfɪθiətɐ",
    "amphitheatre": "æmfɪθiətɐ",
    "amphitheatres": "æmfɪθiətəz",
    "amphora": "æmfɔːrɐ",
    "amphorae": "æmfɔːriː",
    "ampicillin": "æmpɪsɪlɪn",
    "ample": "æmpəl",
    "amplification": "æmplɪfɪkeɪʃən",
    "amplified": "æmplɪfaɪd",
    "amplifier": "æmplɪfaɪə",
    "amplifiers": "æmplɪfaɪəz",
    "amplifies": "æmplɪfaɪz",
    "amplify": "æmplɪfaɪ",
    "amplifying": "æmplɪfaɪɪŋ",
    "amplitude": "æmplɪtjuːd",
    "amply": "æmpli",
    "ampoule": "æmpuːl",
    "ampoules": "æmpuːlz",
    "amps": "æmps",
    "ampule": "æmpjuːl",
    "ampules": "æmpjuːlz",
    "ampulla": "æmpʊlɐ",
    "ampullae": "æmpʊliː",
    "amputate": "æmpjuːteɪt",
    "amputated": "æmpjuːteɪtɪd",
    "amputating": "æmpjuːteɪtɪŋ",
    "amputation": "æmpjuːteɪʃən",
    "amputations": "æmpjuːteɪʃənz",
    "amputee": "æmpjuːtiː",
    "amputees": "æmpjuːtiːz",
    "amrita": "æmriːtɐ",
    "amuck": "ɐmʌk",
    "amulet": "æmjʊlət",
    "amulets": "æmjʊləts",
    "amu": "ɑːmuː",
    "amused": "ɐmjuːzd",
    "amusement": "ɐmjuːzmənt",
    "amusements": "ɐmjuːzmənts",
    "amuse": "ɐmjuːz",
    "amuses": "ɐmjuːzɪz",
    "amusingly": "ɐmjuːzɪŋli",
    "amusing": "ɐmjuːzɪŋ",
    "amygdala": "æmɪɡdɑːlɐ",
    "amyl": "æmɪl",
    "amylase": "æmɪleɪs",
    "anabolic": "ænɐbɒlɪk",
    "anachronism": "ænækrənɪzəm",
    "anachronisms": "ænækrənɪzəmz",
    "anachronistic": "ænɐkrənɪstɪk",
    "anaconda": "ænɐkɒndɐ",
    "anacondas": "ænɐkɒndəz",
    "anaemia": "ɐniːmiə",
    "anaemic": "ɐniːmɪk",
    "anaerobic": "æneərəʊbɪk",
    "anaesthesia": "ænəsθiːziə",
    "anaesthesiologist": "ɐniːsθəsɪɒlədʒɪst",
    "anaesthetic": "ænəsθɛtɪk",
    "anaesthetics": "ænəsθɛtɪks",
    "anaesthetised": "ɐniːsθətaɪzd",
    "anaesthetise": "ɐniːsθətaɪz",
    "anaesthetising": "ɐniːsθətaɪzɪŋ",
    "anaesthetist": "ɐniːsθətɪst",
    "anaesthetists": "ɐniːsθətɪsts",
    "anaesthetized": "ɐniːsθətaɪzd",
    "anagram": "ænɐɡræm",
    "anagrammatic": "ænɐɡrɐmætɪk",
    "anagrams": "ænɐɡræmz",
    "analects": "æneɪləkts",
    "anal": "eɪnəl",
    "analgesia": "ænɐldʒiːziə",
    "analgesic": "ænɐldʒiːzɪk",
    "analgesics": "ænɐldʒiːzɪks",
    "anally": "eɪnəli",
    "analog": "ænəlɒɡ",
    "analogies": "ɐnælədʒɪz",
    "analogous": "ɐnæləɡəs",
    "analogue": "ænəlɒɡ",
    "analogy": "ɐnælədʒi",
    "analyse": "ænɐlaɪz",
    "analysed": "ænɐlaɪzd",
    "analyser": "ænɐlaɪsɐ",
    "analysers": "ænɐlaɪsəz",
    "analysing": "ænɐlaɪzɪŋ",
    "analysis": "ɐnæləsɪs",
    "analyst": "ænɐlɪst",
    "analysts": "ænɐlɪsts",
    "analytic": "ænɐlɪtɪk",
    "analytical": "ænɐlɪtɪkəl",
    "analytically": "ænɐlɪtɪkli",
    "anaphylaxis": "ænɐfɪlæksɪs",
    "anarchic": "ænɑːkɪk",
    "anarchical": "ænɑːkɪkəl",
    "anarchism": "ænəkɪzəm",
    "anarchist": "ænɑːkɪst",
    "anarchistic": "ænɑːkɪstɪk",
    "anarchists": "ænɑːkɪsts",
    "anarchy": "ænɑːki",
    "anas": "ɑːnəz",
    "anastomosis": "ænɑːstəməʊsɪs",
    "anathema": "ɐnæθəmɐ",
    "anatomical": "ænɐtɒmɪkəl",
    "anatomically": "ænɐtɒmɪkli",
    "anatomies": "ɐnætəmɪz",
    "anatomise": "ænɐtəmaɪz",
    "anatomised": "ænɐtəmaɪzd",
    "anatomising": "ænɐtəmaɪzɪŋ",
    "anatomist": "ænɐtəmɪst",
    "anatomists": "ænɐtəmɪsts",
    "anatomy": "ɐnætəmi",
    "ancestor": "ænsɛstɐ",
    "ancestors": "ænsɛstəz",
    "ancestral": "ænsɛstrəl",
    "ancestry": "ænsɛstri",
    "anchor": "ænkɐ",
    "anchorage": "ænkərɪdʒ",
    "anchorages": "ænkərɪdʒɪz",
    "anchored": "ænkəd",
    "anchoring": "ænkərɪŋ",
    "anchorite": "ænkəraɪt",
    "anchorman": "ænkəmən",
    "anchormen": "ænkəmɛn",
    "anchors": "ænkəz",
    "anchorwoman": "ænkəwʊmən",
    "anchovies": "æntʃɒvɪz",
    "anchovy": "æntʃɒvi",
    "ancient": "eɪnʃənt",
    "anciently": "eɪnʃəntli",
    "ancients": "eɪnʃənts",
    "ancilla": "ænsɪlɐ",
    "ancillaries": "ænsɪləriz",
    "ancillary": "ænsɪləri",
    "ancona": "ænkəʊnɐ",
    "ancon": "ænkən",
    "and": "ænd",
    "andante": "ændɑːnteɪ",
    "andirons": "ændaɪənz",
    "androgen": "ændrədʒən",
    "androgynous": "ændrɒdʒɪnəs",
    "androgyny": "ændrədʒɪni",
    "android": "ændrɔɪd",
    "androids": "ændrɔɪdz",
    "anecdotal": "ænɪkdəʊtəl",
    "anecdotally": "ænɪkdəʊtəli",
    "anecdote": "ænɪkdəʊt",
    "anecdotes": "ænɪkdəʊts",
    "anechoic": "eɪntʃəʊɪk",
    "ane": "eɪn",
    "anemometer": "ænɪmɒmɪtɐ",
    "anemone": "ɐnɛməni",
    "anemones": "ɐnɛməniz",
    "anent": "eɪnənt",
    "aneroid": "eɪnrɔɪd",
    "aneurin": "ænjuːrɪn",
    "aneurism": "ænjuːrərɪzəm",
    "aneurysm": "ænjuːrɪzəm",
    "aneurysms": "ænjuːrɪzəmz",
    "anew": "ɐnjuː",
    "angel": "eɪndʒəl",
    "angelfish": "eɪndʒəlfɪʃ",
    "angelica": "ændʒɛlɪkɐ",
    "angelic": "ændʒɛlɪk",
    "angels": "eɪndʒəlz",
    "anger": "æŋɡɐ",
    "angered": "æŋɡəd",
    "angering": "æŋɡərɪŋ",
    "angina": "æŋɡaɪnɐ",
    "angiogram": "æŋɡɪɒɡræm",
    "angiography": "æŋɡɪɒɡrəfi",
    "angioplasty": "æŋɡɪɒplɐsti",
    "angle": "æŋɡəl",
    "angled": "æŋɡəld",
    "anglepoise": "æŋɡəlpɔɪs",
    "angler": "æŋɡlɐ",
    "anglers": "æŋɡləz",
    "angles": "æŋɡəlz",
    "anglicise": "æŋɡlɪsaɪz",
    "anglicised": "æŋɡlɪsaɪzd",
    "anglicising": "æŋɡlɪsaɪzɪŋ",
    "angling": "æŋɡəlɪŋ",
    "anglophile": "æŋɡləfaɪl",
    "anglophiles": "æŋɡləfaɪlz",
    "anglophone": "æŋɡləfəʊn",
    "angora": "æŋɡɔːrɐ",
    "angoras": "æŋɡɔːrəz",
    "angostura": "æŋɡəstʃərɐ",
    "angrier": "æŋɡrɪɐ",
    "angriest": "æŋɡrɪəst",
    "angrily": "æŋɡrɪli",
    "angry": "æŋɡri",
    "angst": "æŋst",
    "angstrom": "æŋstrɒm",
    "anguish": "æŋɡwɪʃ",
    "anguished": "æŋɡwɪʃt",
    "angular": "ænɡjʊlɐ",
    "angularity": "ænɡjʊlærɪti",
    "angulation": "ænɡjʊleɪʃən",
    "anhydrous": "ænhaɪdrəs",
    "ani": "æni",
    "anil": "ænɪl",
    "aniline": "ænɪliːn",
    "anima": "ænɪmɐ",
    "animal": "ænɪməl",
    "animals": "ænɪməlz",
    "animated": "ænɪmeɪtɪd",
    "animates": "ænɪmeɪts",
    "animating": "ænɪmeɪtɪŋ",
    "animation": "ænɪmeɪʃən",
    "animations": "ænɪmeɪʃənz",
    "animator": "ænɪmeɪtɐ",
    "animators": "ænɪmeɪtəz",
    "anime": "ænɪmeɪ",
    "animism": "ænɪmɪzəm",
    "animist": "ænɪmɪst",
    "animists": "ænɪmɪsts",
    "animosities": "ænɪmɒsɪtiz",
    "animosity": "ænɪmɒsɪti",
    "animus": "ænɪməs",
    "anion": "ænaɪən",
    "anis": "ænɪz",
    "anise": "ænɪs",
    "aniseed": "ænɪsiːd",
    "ankh": "æŋk",
    "ankle": "æŋkəl",
    "ankles": "æŋkəlz",
    "anklet": "æŋklət",
    "anklets": "æŋkləts",
    "ankylosing": "æŋkɪləʊzɪŋ",
    "an": "ɐn",
    "anna": "ænɐ",
    "annal": "ænəl",
    "annals": "ænəlz",
    "annas": "ænəz",
    "annatto": "ænətəʊ",
    "annealed": "ɐniːld",
    "annealing": "ɐniːlɪŋ",
    "annelids": "ænɪlɪdz",
    "annexation": "ænɪkseɪʃən",
    "annexed": "ænɛkst",
    "annexing": "ænɛksɪŋ",
    "annihilated": "ɐnaɪəleɪtɪd",
    "annihilate": "ɐnaɪəleɪt",
    "annihilates": "ɐnaɪəleɪts",
    "annihilating": "ɐnaɪəleɪtɪŋ",
    "annihilation": "ɐnaɪəleɪʃən",
    "annihilator": "ɐnaɪəleɪtɐ",
    "anniversaries": "ænɪvɜːsəriz",
    "anniversary": "ænɪvɜːsəri",
    "annotate": "ænəʊteɪt",
    "annotated": "ænəʊteɪtɪd",
    "annotating": "ænəʊteɪtɪŋ",
    "annotation": "ænəʊteɪʃən",
    "annotations": "ænəʊteɪʃənz",
    "announced": "ɐnaʊnst",
    "announcement": "ɐnaʊnsmənt",
    "announcements": "ɐnaʊnsmənts",
    "announce": "ɐnaʊns",
    "announcer": "ɐnaʊnsɐ",
    "announcers": "ɐnaʊnsəz",
    "announces": "ɐnaʊnsɪz",
    "announcing": "ɐnaʊnsɪŋ",
    "annoyance": "ɐnɔɪəns",
    "annoyances": "ɐnɔɪənsɪz",
    "annoyed": "ɐnɔɪd",
    "annoyingly": "ɐnɔɪɪŋli",
    "annoying": "ɐnɔɪɪŋ",
    "annoy": "ɐnɔɪ",
    "annoys": "ɐnɔɪz",
    "annual": "ænjuːəl",
    "annualised": "ænjuːəlaɪzd",
    "annually": "ænjuːəli",
    "annuals": "ænjuːəlz",
    "annuities": "ɐnjuːɪtɪz",
    "annuity": "ɐnjuːɪti",
    "annular": "ɐnjʊlɑː",
    "annulled": "ɐnʌld",
    "annulment": "ɐnʌlmənt",
    "annulments": "ɐnʌlmənts",
    "annul": "ɐnʌl",
    "annuls": "ɐnʌlz",
    "annulus": "ɐnuːluːz",
    "annunciate": "ɐnʌnsɪeɪt",
    "annunciation": "ɐnʌnsɪeɪʃən",
    "anoa": "ænəʊɐ",
    "anoas": "ænəʊəz",
    "anodal": "ænɒdəl",
    "anode": "ænəʊd",
    "anodes": "ænəʊdz",
    "anodised": "ænədaɪzd",
    "anodyne": "ænədaɪn",
    "anointed": "ɐnɔɪntɪd",
    "anointing": "ɐnɔɪntɪŋ",
    "anointment": "ɐnɔɪntmənt",
    "anoint": "ɐnɔɪnt",
    "anoints": "ɐnɔɪnts",
    "anomalies": "ɐnɒməliz",
    "anomalous": "ɐnɒmələs",
    "anomaly": "ɐnɒməli",
    "anon": "ɐnɒn",
    "anonymity": "ænənɪmɪti",
    "anonymously": "ɐnɒnəməsli",
    "anonymous": "ɐnɒnəməs",
    "anopheles": "ænɒfəliːz",
    "anorak": "ænɔːræk",
    "anoraks": "ænɔːræks",
    "anorexia": "ænɔːrɛksiə",
    "anorexic": "ænɔːrɛksɪk",
    "anorexics": "ænɔːrɛksɪks",
    "anosmia": "ænɒzmiə",
    "another": "ɐnʌðɐ",
    "ans": "ænz",
    "answerable": "ɑːnsərəbəl",
    "answered": "ɑːnsəd",
    "answerer": "ɑːnsərɐ",
    "answering": "ɑːnsərɪŋ",
    "answer": "ɑːnsɐ",
    "answerphone": "ɑːnsəfəʊn",
    "answers": "ɑːnsəz",
    "antacid": "æntɐsɪd",
    "antacids": "æntɐsɪdz",
    "ant": "ænt",
    "antagonise": "æntæɡənaɪz",
    "antagonised": "æntæɡənaɪzd",
    "antagonises": "æntæɡənaɪzɪz",
    "antagonising": "æntæɡənaɪzɪŋ",
    "antagonism": "æntæɡənɪzəm",
    "antagonisms": "æntæɡənɪzəmz",
    "antagonist": "æntæɡənɪst",
    "antagonistic": "æntæɡənɪstɪk",
    "antagonists": "æntæɡənɪsts",
    "antarctic": "æntɑːktɪk",
    "ante": "æntiː",
    "anteater": "æntiːtɐ",
    "anteaters": "æntiːtəz",
    "antebellum": "æntɪbɛləm",
    "antecedent": "æntɪsiːdənt",
    "antecedents": "æntɪsiːdənts",
    "antechamber": "æntɪtʃeɪmbɐ",
    "anted": "æntɪd",
    "antediluvian": "æntiːdɪluːviən",
    "antelope": "æntɪləʊp",
    "antelopes": "æntɪləʊps",
    "antenatal": "æntəneɪtəl",
    "antennae": "æntɛniː",
    "antennas": "æntɛnəz",
    "anterior": "æntiərɪɐ",
    "anteriorly": "æntiərɪəli",
    "anteroom": "æntəruːm",
    "anterooms": "æntəruːmz",
    "antes": "æntiːs",
    "anthem": "ænθəm",
    "anthemion": "ænθɛmiən",
    "anthems": "ænθəmz",
    "anther": "ænθɐ",
    "anthers": "ænθəz",
    "anthill": "ænthɪl",
    "anthills": "ænthɪlz",
    "anthologies": "ænθɒlədʒɪz",
    "anthologised": "ænθɒlədʒaɪzd",
    "anthologist": "ænθɒlədʒɪst",
    "anthology": "ænθɒlədʒi",
    "anthracite": "ænθrɐsaɪt",
    "anthrax": "ænθræks",
    "anthropocentric": "ænθrəpəʊsɛntrɪk",
    "anthropogenic": "ænθrəpəʊdʒɛnɪk",
    "anthropoid": "ænθrəpɔɪd",
    "anthropoids": "ænθrəpɔɪdz",
    "anthropological": "ænθrəpəlɒdʒɪkəl",
    "anthropologist": "ænθrəpɒlədʒɪst",
    "anthropologists": "ænθrəpɒlədʒɪsts",
    "anthropology": "ænθrəpɒlədʒi",
    "anthropometries": "ænθrəpɒmətrɪz",
    "anthropomorphic": "ænθrəpəmɔːfɪk",
    "anthropomorphise": "ænθrəpɒmɔːfaɪz",
    "anthropomorphising": "ænθrəpɒmɔːfaɪzɪŋ",
    "anthropomorphism": "ænθrəpɒmɔːfɪzəm",
    "anthurium": "ænθjʊriəm",
    "anthuriums": "ænθjʊriəmz",
    "anti": "ænti",
    "antiaircraft": "æntɪeəkrɑːft",
    "antibacterial": "æntɪbæktiərɪəl",
    "antibiotic": "æntɪbaɪɒtɪk",
    "antibiotics": "æntɪbaɪɒtɪks",
    "antibodies": "æntɪbɒdɪz",
    "antibody": "æntɪbɒdi",
    "antic": "æntɪk",
    "antichrist": "æntɪkraɪst",
    "anticipate": "æntɪsɪpeɪt",
    "anticipated": "æntɪsɪpeɪtɪd",
    "anticipates": "æntɪsɪpeɪts",
    "anticipating": "æntɪsɪpeɪtɪŋ",
    "anticipation": "æntɪsɪpeɪʃən",
    "anticipatory": "æntɪsɪpətəri",
    "anticlimax": "æntɪklaɪmæks",
    "anticlockwise": "æntɪklɒkwaɪz",
    "anticoagulant": "æntɪkəʊæɡjʊlənt",
    "anticoagulants": "æntɪkəʊæɡjʊlənts",
    "antics": "æntɪks",
    "antidepressant": "æntɪdɪprɛsənt",
    "antidepressants": "æntɪdɪprɛsənts",
    "antidisestablishmentarianism": "æntɪdɪsɪstæblɪʃmənteəriənɪzəm",
    "antidote": "æntɪdəʊt",
    "antidotes": "æntɪdəʊts",
    "antiestablishment": "æntɪɪstæblɪʃmənt",
    "antifreeze": "æntɪfriːz",
    "antifungal": "æntɪfʌŋɡəl",
    "antigen": "æntɪdʒɛn",
    "antigovernment": "æntɪɡʌvənmənt",
    "antigravity": "æntɪɡrævɪti",
    "antihero": "æntɪhiərəʊ",
    "antiheroes": "æntɪhiərəʊz",
    "antihistamine": "æntɪhɪstɐmiːn",
    "antihistamines": "æntɪhɪstɐmiːnz",
    "antimacassar": "æntɪmækɐsɑː",
    "antimacassars": "æntɪmækɐsɑːz",
    "antimatter": "æntɪmætɐ",
    "antimicrobial": "æntɪmaɪkrəʊbɪəl",
    "antimony": "æntɪməni",
    "anting": "æntɪŋ",
    "antinuclear": "æntɪnjuːkliə",
    "antioxidant": "æntɪɒksɪdənt",
    "antioxidants": "æntɪɒksɪdənts",
    "antipasti": "æntɪpɑːsti",
    "antipasto": "æntɪpɑːstəʊ",
    "antipathetic": "æntɪpɐθɛtɪk",
    "antipathy": "æntɪpəθi",
    "antiperspirant": "æntɪpəspɪrənt",
    "antiperspirants": "æntɪpəspɪrənts",
    "antiphonal": "æntɪfənəl",
    "antipode": "æntɪpəʊd",
    "antipodean": "æntɪpəʊdiən",
    "antipodeans": "æntɪpəʊdiənz",
    "antipodes": "æntɪpəʊdz",
    "antipope": "æntɪpəʊp",
    "antiproton": "æntɪprəʊtɒn",
    "antiprotons": "æntɪprəʊtɒnz",
    "antipsychotic": "æntɪsaɪkɒtɪk",
    "antipsychotics": "æntɪsaɪkɒtɪks",
    "antipyretic": "æntɪpaɪrɛtɪk",
    "antiquarian": "æntɪkweəriən",
    "antiquarians": "æntɪkweəriənz",
    "antiquary": "æntɪkwəri",
    "antiquated": "æntɪkweɪtɪd",
    "antique": "æntiːk",
    "antiqued": "æntiːkd",
    "antiques": "æntiːks",
    "antiquing": "æntiːkɪŋ",
    "antiquities": "æntɪkwɪtiz",
    "antiquity": "æntɪkwɪti",
    "antirrhinum": "æntɪrhɪnəm",
    "antirrhinums": "æntɪrhɪnəmz",
    "antis": "æntiz",
    "antisemitic": "æntɪsɛmɪtɪk",
    "antiseptic": "æntɪsɛptɪk",
    "antiseptics": "æntɪsɛptɪks",
    "antiserum": "æntɪsɛrəm",
    "antisocial": "æntɪsəʊʃəl",
    "antitank": "æntɪtæŋk",
    "antiterrorist": "æntɪtɛrərɪst",
    "antitheses": "æntɪθəsiːz",
    "antithesis": "æntɪθəsɪs",
    "antithetical": "æntɪθɛtɪkəl",
    "antitrust": "æntɪtrʌst",
    "antiviral": "æntɪvaɪərəl",
    "antivirals": "æntɪvaɪərəlz",
    "antivirus": "æntɪvaɪrəs",
    "antler": "æntlɐ",
    "antlered": "æntləd",
    "antlers": "æntləz",
    "antonym": "æntənɪm",
    "antrum": "æntrəm",
    "ants": "ænts",
    "antsy": "æntsi",
    "anus": "eɪnʌs",
    "anuses": "eɪnʌsɪz",
    "anvil": "ænvəl",
    "anvils": "ænvəlz",
    "anxieties": "æŋzaɪətiz",
    "anxiety": "æŋzaɪəti",
    "anxious": "æŋʃəs",
    "anxiously": "æŋʃəsli",
    "anxiousness": "æŋʃəsnəs",
    "anybody": "ɛnɪbɒdi",
    "any": "ɛni",
    "anyhow": "ɛnɪhaʊ",
    "anymore": "ɛnɪmɔː",
    "anyone": "ɛnɪwɒn",
    "anyplace": "ɛnɪpleɪs",
    "anything": "ɛnɪθɪŋ",
    "anytime": "ɛnɪtaɪm",
    "anyway": "ɛnɪweɪ",
    "anyways": "ɛnɪweɪz",
    "anywhere": "ɛnɪweə",
    "anywheres": "ɛnɪweəz",
    "aorta": "eɪɔːtɐ",
    "aortic": "eɪɔːtɪk",
    "apace": "ɐpeɪs",
    "apache": "ɐpætʃi",
    "apaches": "ɐpætʃiɪz",
    "apartheid": "ɐpɑːθeɪd",
    "apartment": "ɐpɑːtmənt",
    "apartments": "ɐpɑːtmənts",
    "apart": "ɐpɑːt",
    "apathetic": "æpɐθɛtɪk",
    "apathetically": "æpɐθɛtɪkli",
    "apathy": "æpəθi",
    "apatosaurus": "ɐpætəsɔːrəs",
    "aped": "eɪpt",
    "ape": "eɪp",
    "apelike": "eɪplaɪk",
    "aperitif": "ɐpɛrətiːf",
    "aperitifs": "ɐpɛrətiːfs",
    "aperture": "æpətʃɐ",
    "apertures": "æpətʃəz",
    "apes": "eɪps",
    "apex": "eɪpɛks",
    "apexes": "eɪpɛksɪz",
    "aphasia": "ɐfeɪziə",
    "aphid": "eɪfɪd",
    "aphids": "eɪfɪdz",
    "aphorism": "æfərɪzəm",
    "aphorisms": "æfɔːrɪzəmz",
    "aphrodisiac": "æfrədɪsɪæk",
    "aphrodisiacs": "æfrədɪsɪæks",
    "apian": "eɪpiən",
    "apiarist": "eɪpiərɪst",
    "apiary": "eɪpjəri",
    "apical": "æpɪkəl",
    "apiculture": "æpɪkʌltʃɐ",
    "apiece": "ɐpiːs",
    "aping": "eɪpɪŋ",
    "apish": "eɪpɪʃ",
    "aplenty": "ɐplɛnti",
    "aplomb": "ɐplɒm",
    "apnoea": "ɐpniə",
    "apocalypse": "ɐpɒkɐlɪps",
    "apocalyptically": "ɐpɒkɐlɪptɪkli",
    "apocalyptic": "ɐpɒkɐlɪptɪk",
    "apocryphal": "ɐpɒkrɪfəl",
    "apocrypha": "ɐpɒkrɪfɐ",
    "apogee": "æpəʊdʒiː",
    "apolitical": "æpəlɪtɪkəl",
    "apollo": "ɐpɒləʊ",
    "apologetically": "ɐpɒlədʒɛtɪkli",
    "apologetic": "ɐpɒlədʒɛtɪk",
    "apologies": "ɐpɒlədʒɪz",
    "apologised": "ɐpɒlədʒaɪzd",
    "apologise": "ɐpɒlədʒaɪz",
    "apologises": "ɐpɒlədʒaɪzɪz",
    "apologising": "ɐpɒlədʒaɪzɪŋ",
    "apologist": "ɐpɒlədʒɪst",
    "apologists": "ɐpɒlədʒɪsts",
    "apology": "ɐpɒlədʒi",
    "apoplectic": "æpəplɛktɪk",
    "apoplexy": "æpəplɛksi",
    "apostasy": "ɐpɒstəsi",
    "apostate": "ɐpɒsteɪt",
    "apostates": "ɐpɒsteɪts",
    "apostle": "ɐpɒsəl",
    "apostles": "ɐpɒsəlz",
    "apostolic": "ɐpəstɒlɪk",
    "apostrophe": "ɐpɒstrəfi",
    "apostrophes": "ɐpɒstrəfɪz",
    "apothecaries": "ɐpɒθɪkəriz",
    "apothecary": "ɐpɒθɪkəri",
    "apotheosis": "ɐpɒθiːəʊsɪs",
    "appalled": "ɐpɔːld",
    "appallingly": "ɐpɔːlɪŋli",
    "appalling": "ɐpɔːlɪŋ",
    "appaloosa": "ɐpæluːsɐ",
    "appal": "ɐpɔːl",
    "appals": "ɐpɔːlz",
    "apparatchik": "æpərætʃɪk",
    "apparatchiks": "æpərætʃɪks",
    "apparatus": "æpəreɪtəs",
    "apparel": "æpərəl",
    "apparently": "ɐpærəntli",
    "apparent": "ɐpærənt",
    "apparition": "æpərɪʃən",
    "apparitions": "æpərɪʃənz",
    "appassionato": "ɐpæʃənɑːtəʊ",
    "appealed": "ɐpiːld",
    "appealingly": "ɐpiːlɪŋli",
    "appealing": "ɐpiːlɪŋ",
    "appeal": "ɐpiːl",
    "appeals": "ɐpiːlz",
    "appearance": "ɐpiərəns",
    "appearances": "ɐpiərənsɪz",
    "appeared": "ɐpiəd",
    "appearing": "ɐpiərɪŋ",
    "appear": "ɐpiə",
    "appears": "ɐpiəz",
    "appeased": "ɐpiːzd",
    "appeasement": "ɐpiːzmənt",
    "appease": "ɐpiːz",
    "appeaser": "ɐpiːzɐ",
    "appeasers": "ɐpiːzəz",
    "appeases": "ɐpiːzɪz",
    "appeasing": "ɐpiːzɪŋ",
    "appellant": "ɐpɛlənt",
    "appellate": "ɐpɛlət",
    "appellation": "ɐpɪleɪʃən",
    "appellations": "ɐpɪleɪʃənz",
    "appel": "ɐpɛl",
    "appendage": "ɐpɛndɪdʒ",
    "appendages": "ɐpɛndɪdʒɪz",
    "appendectomy": "ɐpɪndɛktəmi",
    "appended": "ɐpɛndɪd",
    "appendicectomy": "ɐpɛndɪkɛktəmi",
    "appendices": "ɐpɛndɪsɪz",
    "appendicitis": "ɐpɛndɪsaɪtɪs",
    "appendix": "ɐpɛndɪks",
    "append": "ɐpɛnd",
    "appertaining": "ɐpɜːteɪnɪŋ",
    "appertain": "ɐpɜːteɪn",
    "appetiser": "æpɪtaɪzɐ",
    "appetisers": "æpɪtaɪzəz",
    "appetising": "æpɪtaɪzɪŋ",
    "appetite": "æpɪtaɪt",
    "appetites": "æpɪtaɪts",
    "applauded": "ɐplɔːdɪd",
    "applauders": "ɐplɔːdəz",
    "applauding": "ɐplɔːdɪŋ",
    "applaud": "ɐplɔːd",
    "applauds": "ɐplɔːdz",
    "applause": "ɐplɔːz",
    "apple": "æpəl",
    "applecart": "æpəlkɑːt",
    "applejack": "æpəldʒæk",
    "apples": "æpəlz",
    "applesauce": "æpəlsɔːs",
    "applet": "æplət",
    "applets": "æpləts",
    "appliance": "ɐplaɪəns",
    "appliances": "ɐplaɪənsɪz",
    "applicability": "ɐplɪkəbɪlɪti",
    "applicable": "ɐplɪkəbəl",
    "applicant": "æplɪkənt",
    "applicants": "æplɪkənts",
    "application": "æplɪkeɪʃən",
    "applications": "æplɪkeɪʃənz",
    "applicator": "æplɪkeɪtɐ",
    "applicators": "æplɪkeɪtəz",
    "applied": "ɐplaɪd",
    "applies": "ɐplaɪz",
    "applying": "ɐplaɪɪŋ",
    "appointed": "ɐpɔɪntɪd",
    "appointee": "ɐpɔɪntiː",
    "appointees": "ɐpɔɪntiːz",
    "appointing": "ɐpɔɪntɪŋ",
    "appointment": "ɐpɔɪntmənt",
    "appointments": "ɐpɔɪntmənts",
    "appoint": "ɐpɔɪnt",
    "appoints": "ɐpɔɪnts",
    "apportioned": "ɐpɔːʃənd",
    "apportioning": "ɐpɔːʃənɪŋ",
    "apportionment": "ɐpɔːʃənmənt",
    "apportion": "ɐpɔːʃən",
    "apposite": "ɐpɒsɪt",
    "apposition": "ɐpəzɪʃən",
    "appraisal": "ɐpreɪsəl",
    "appraisals": "ɐpreɪsəlz",
    "appraised": "ɐpreɪzd",
    "appraise": "ɐpreɪz",
    "appraises": "ɐpreɪzɪz",
    "appraising": "ɐpreɪzɪŋ",
    "appreciable": "ɐpriːʃɪəbəl",
    "appreciably": "ɐpriːʃɪəbli",
    "appreciated": "ɐpriːʃɪeɪtɪd",
    "appreciate": "ɐpriːʃɪeɪt",
    "appreciates": "ɐpriːʃɪeɪts",
    "appreciating": "ɐpriːʃɪeɪtɪŋ",
    "appreciation": "ɐpriːʃɪeɪʃən",
    "appreciations": "ɐpriːʃɪeɪʃənz",
    "appreciatively": "ɐpriːʃiətɪvli",
    "appreciative": "ɐpriːʃiətɪv",
    "appreciator": "ɐpriːʃɪeɪtɐ",
    "appreciators": "ɐpriːʃɪeɪtəz",
    "apprehend": "æprɪhɛnd",
    "apprehended": "æprɪhɛndɪd",
    "apprehending": "æprɪhɛndɪŋ",
    "apprehension": "æprɪhɛnʃən",
    "apprehensions": "æprɪhɛnʃənz",
    "apprehensive": "æprɪhɛnsɪv",
    "apprehensively": "æprɪhɛnsɪvli",
    "apprenticed": "ɐprɛntɪst",
    "apprentice": "ɐprɛntɪs",
    "apprenticeship": "ɐprɛntɪsʃɪp",
    "apprenticeships": "ɐprɛntɪsʃɪps",
    "apprentices": "ɐprɛntɪsɪz",
    "apprised": "ɐpraɪzd",
    "apprise": "ɐpraɪz",
    "approachability": "ɐprəʊtʃəbɪlɪti",
    "approachable": "ɐprəʊtʃəbəl",
    "approached": "ɐprəʊtʃt",
    "approaches": "ɐprəʊtʃɪz",
    "approaching": "ɐprəʊtʃɪŋ",
    "approach": "ɐprəʊtʃ",
    "approbation": "ɐprəbeɪʃən",
    "appropriated": "ɐprəʊprɪətɪd",
    "appropriately": "ɐprəʊprɪətli",
    "appropriateness": "ɐprəʊprɪətnəs",
    "appropriates": "ɐprəʊprɪəts",
    "appropriating": "ɐprəʊprɪətɪŋ",
    "appropriation": "ɐprəʊprɪeɪʃən",
    "appropriations": "ɐprəʊprɪeɪʃənz",
    "approval": "ɐpruːvəl",
    "approvals": "ɐpruːvəlz",
    "approved": "ɐpruːvd",
    "approve": "ɐpruːv",
    "approver": "ɐpruːvɐ",
    "approves": "ɐpruːvz",
    "approvingly": "ɐpruːvɪŋli",
    "approving": "ɐpruːvɪŋ",
    "approximated": "ɐprɒksɪmeɪtɪd",
    "approximately": "ɐprɒksɪmətli",
    "approximates": "ɐprɒksɪmeɪts",
    "approximating": "ɐprɒksɪmeɪtɪŋ",
    "approximation": "ɐprɒksɪmeɪʃən",
    "approximations": "ɐprɒksɪmeɪʃənz",
    "appurtenances": "ɐpɜːtənənsɪz",
    "apricot": "eɪprɪkɒt",
    "apricots": "eɪprɪkɒts",
    "apron": "eɪprən",
    "aprons": "eɪprənz",
    "apropos": "æprəpəʊ",
    "apse": "æps",
    "apt": "æpt",
    "apter": "æptɐ",
    "aptitude": "æptɪtjuːd",
    "aptitudes": "æptɪtjuːdz",
    "aptly": "æptli",
    "aqua": "ækwɐ",
    "aquaculture": "ækwɐkʌltʃɐ",
    "aquae": "ækwiː",
    "aqualung": "ækwəlʌŋ",
    "aqualungs": "ækwəlʌŋz",
    "aquamarine": "ækwɐməriːn",
    "aquamarines": "ækwɐməriːnz",
    "aquanauts": "ækwɐnɔːts",
    "aquaplane": "ækwɐpleɪn",
    "aquaplaned": "ækwɐpleɪnd",
    "aquaplaning": "ækwɐpleɪnɪŋ",
    "aquaria": "ɐkweəriə",
    "aquarist": "ækwɑːrɪst",
    "aquarium": "ɐkweəriəm",
    "aquariums": "ɐkweəriəmz",
    "aquatic": "əkwætɪk",
    "aquatics": "əkwætɪks",
    "aquatint": "əkwætɪnt",
    "aquatints": "əkwætɪnts",
    "aquavit": "ækwɐvɪt",
    "aqueduct": "ækwɪdʌkt",
    "aqueducts": "ækwɪdʌkts",
    "aqueous": "eɪkwɪəs",
    "aquifer": "ækwɪfɐ",
    "aquifers": "ækwɪfəz",
    "aquilegia": "ækwɪliːdʒɐ",
    "aquilegias": "ækwɪliːdʒəz",
    "aquiline": "ækwɪliːn",
    "aquiver": "ækwɪvɐ",
    "arabesque": "æreɪbɛsk",
    "arabesques": "æreɪbɛskz",
    "arable": "ærɐbəl",
    "arachnid": "ɐræknɪd",
    "arachnids": "ɐræknɪdz",
    "arachnoid": "ɐræknɔɪd",
    "arachnophobia": "ɐræknəfəʊbiə",
    "arak": "æræk",
    "aramid": "ærɐmɪd",
    "arapaima": "ærɐpeɪmɐ",
    "araucaria": "ærəkeəriə",
    "arb": "ɑːb",
    "arbiter": "ɑːbɪtɐ",
    "arbiters": "ɑːbɪtəz",
    "arbitrage": "ɑːbɪtrɪdʒ",
    "arbitrarily": "ɑːbɪtrɛrəli",
    "arbitrariness": "ɑːbɪtrərinəs",
    "arbitrary": "ɑːbɪtrəri",
    "arbitrate": "ɑːbɪtreɪt",
    "arbitrated": "ɑːbɪtreɪtɪd",
    "arbitrating": "ɑːbɪtreɪtɪŋ",
    "arbitration": "ɑːbɪtreɪʃən",
    "arbitrator": "ɑːbɪtreɪtɐ",
    "arbitrators": "ɑːbɪtreɪtəz",
    "arbor": "ɑːbɐ",
    "arboreal": "ɑːbɔːriəl",
    "arboreta": "ɑːbɔːrɛtɐ",
    "arboretum": "ɑːbɔːrɛtəm",
    "arboretums": "ɑːbɔːrɛtəmz",
    "arboricultural": "ɑːbɔːrɪkʌltʃərəl",
    "arbour": "ɑːbɐ",
    "arbours": "ɑːbəz",
    "arbs": "ɑːbz",
    "arbutus": "ɑːbjuːtəs",
    "arcaded": "ɑːkeɪdɪd",
    "arcade": "ɑːkeɪd",
    "arcades": "ɑːkeɪdz",
    "arcading": "ɑːkeɪdɪŋ",
    "arcana": "ɑːkɑːnɐ",
    "arcane": "ɑːkeɪn",
    "arced": "ɑːkt",
    "archaeological": "ɑːkiːəlɒdʒɪkəl",
    "archaeologically": "ɑːkiːəlɒdʒɪkli",
    "archaeologist": "ɑːkiːɒlədʒɪst",
    "archaeologists": "ɑːkiːɒlədʒɪsts",
    "archaeology": "ɑːkiːɒlədʒi",
    "archaeopteryx": "ɑːkiːɒptərɪks",
    "archaic": "ɑːkeɪɪk",
    "archangels": "ɑːtʃeɪndʒəlz",
    "archangel": "ɑːtʃeɪndʒəl",
    "archbishops": "ɑːtʃbɪʃəps",
    "archbishop": "ɑːtʃbɪʃəp",
    "archdeacons": "ɑːtʃdiːkənz",
    "archdeacon": "ɑːtʃdiːkən",
    "archdiocese": "ɑːtʃdɪəʊsiːz",
    "archduchess": "ɑːtʃdʌtʃɛs",
    "archdukes": "ɑːtʃdjuːks",
    "archduke": "ɑːtʃdjuːk",
    "arched": "ɑːtʃd",
    "archenemies": "ɑːtʃɛnəmɪz",
    "archenemy": "ɑːtʃɛnəmi",
    "archeological": "ɑːkɪəlɒdʒɪkəl",
    "archeologically": "ɑːkɪəlɒdʒɪkli",
    "archeologist": "ɑːkɪɒlədʒɪst",
    "archeologists": "ɑːkɪɒlədʒɪsts",
    "archeology": "ɑːkɪɒlədʒi",
    "archers": "ɑːtʃəz",
    "archer": "ɑːtʃɐ",
    "archery": "ɑːtʃəri",
    "arches": "ɑːtʃɪz",
    "archetypal": "ɑːkɪtaɪpəl",
    "archetype": "ɑːkɪtaɪp",
    "archetypes": "ɑːkɪtaɪps",
    "archetypical": "ɑːkɪtɪpɪkəl",
    "arching": "ɑːtʃɪŋ",
    "archipelago": "ɑːkɪpɪleɪɡəʊ",
    "archipelagos": "ɑːkɪpɪleɪɡəʊz",
    "architect": "ɑːkɪtɛkt",
    "architects": "ɑːkɪtɛkts",
    "architectural": "ɑːkɪtɛktʃərəl",
    "architecturally": "ɑːkɪtɛktʃərəli",
    "architecture": "ɑːkɪtɛktʃɐ",
    "architectures": "ɑːkɪtɛktʃəz",
    "architrave": "ɑːkɪtreɪv",
    "architraves": "ɑːkɪtreɪvz",
    "archival": "ɑːkaɪvəl",
    "archived": "ɑːkaɪvd",
    "archive": "ɑːkaɪv",
    "archives": "ɑːkaɪvz",
    "archiving": "ɑːkaɪvɪŋ",
    "archivist": "ɑːkaɪvɪst",
    "archivists": "ɑːkaɪvɪsts",
    "archly": "ɑːtʃli",
    "archness": "ɑːtʃnɛs",
    "archon": "ɑːtʃɒn",
    "archrival": "ɑːtʃraɪvəl",
    "arch": "ɑːtʃ",
    "archways": "ɑːtʃweɪz",
    "archway": "ɑːtʃweɪ",
    "arcing": "ɑːkɪŋ",
    "arc": "ɑːk",
    "arcs": "ɑːks",
    "arctic": "ɑːktɪk",
    "arctics": "ɑːktɪks",
    "arcuate": "ɑːkjuːeɪt",
    "ardent": "ɑːdənt",
    "ardently": "ɑːdəntli",
    "ardor": "ɑːdɔː",
    "ardour": "ɑːdɐ",
    "arduous": "ɑːdjuːəs",
    "arduously": "ɑːdjuːəsli",
    "area": "eəriə",
    "areal": "eəriəl",
    "areas": "eəriəz",
    "areca": "ærɛkɐ",
    "arena": "ɐriːnɐ",
    "arenas": "ɐriːnəz",
    "areola": "ærɪəʊlɐ",
    "arethusa": "ærɪθjuːsɐ",
    "argent": "ɑːdʒənt",
    "argentine": "ɑːdʒɪntaɪn",
    "argentines": "ɑːdʒɪntaɪnz",
    "arginine": "ɑːdʒɪnaɪn",
    "argol": "ɑːɡɒl",
    "argonaut": "ɑːɡənɔːt",
    "argonauts": "ɑːɡənɔːts",
    "argon": "ɑːɡɒn",
    "argosies": "ɑːɡəsɪz",
    "argosy": "ɑːɡəsi",
    "argot": "ɑːɡət",
    "arguable": "ɑːɡjuːəbəl",
    "arguably": "ɑːɡjuːəbli",
    "argued": "ɑːɡjuːd",
    "argue": "ɑːɡjuː",
    "arguers": "ɑːɡəz",
    "argues": "ɑːɡjuːz",
    "arguing": "ɑːɡjuːɪŋ",
    "argumentation": "ɑːɡjuːmənteɪʃən",
    "argumentative": "ɑːɡjuːmɛntətɪv",
    "argumentive": "ɑːɡjuːmɛntɪv",
    "argument": "ɑːɡjuːmənt",
    "arguments": "ɑːɡjuːmənts",
    "argyle": "ɑːɡaɪl",
    "argyles": "ɑːɡaɪlz",
    "argyll": "ɑːɡʲaɪl",
    "aria": "eəriɐ",
    "arias": "eəriəz",
    "arid": "ærɪd",
    "aridity": "ærɪdɪti",
    "aridly": "ærɪdli",
    "ariel": "æriːəl",
    "aright": "əraɪt",
    "arise": "ɐraɪz",
    "arisen": "ərɪzən",
    "arises": "ɐraɪzɪz",
    "arising": "ɐraɪzɪŋ",
    "arista": "ærɪstɐ",
    "aristocracy": "ærɪstɒkrəsi",
    "aristocrat": "ærɪstɒkræt",
    "aristocratic": "ærɪstəkrætɪk",
    "aristocrats": "ærɪstɒkræts",
    "arithmetical": "ærɪθmɛtɪkəl",
    "arithmetically": "ærɪθmɛtɪkli",
    "ark": "ɑːk",
    "arks": "ɑːks",
    "armada": "ɑːmɑːdɐ",
    "armadas": "ɑːmɑːdəz",
    "armadillo": "ɑːmɐdɪləʊ",
    "armadillos": "ɑːmɐdɪləʊz",
    "armament": "ɑːməmənt",
    "armaments": "ɑːməmənts",
    "armature": "ɑːmətʃɔː",
    "armatures": "ɑːmətʃɔːz",
    "armband": "ɑːmbænd",
    "armbands": "ɑːmbændz",
    "armchair": "ɑːmtʃeə",
    "armchairs": "ɑːmtʃeəz",
    "armed": "ɑːmd",
    "armful": "ɑːmfəl",
    "armfuls": "ɑːmfəlz",
    "armhole": "ɑːmhəʊl",
    "armholes": "ɑːmhəʊlz",
    "armies": "ɑːmɪz",
    "armillary": "ɑːmɪləri",
    "arming": "ɑːmɪŋ",
    "armistice": "ɑːmɪstɪs",
    "armless": "ɑːmləs",
    "armlets": "ɑːmləts",
    "arm": "ɑːm",
    "armoire": "ɑːmwɑː",
    "armorial": "ɑːmɔːrɪəl",
    "armory": "ɑːməri",
    "armoured": "ɑːməd",
    "armourer": "ɑːmɜːrɐ",
    "armourers": "ɑːmɜːrəz",
    "armouries": "ɑːmɜːrɪz",
    "armouring": "ɑːmɜːrɪŋ",
    "armour": "ɑːmɐ",
    "armours": "ɑːməz",
    "armoury": "ɑːmɜːri",
    "armpit": "ɑːmpɪt",
    "armpits": "ɑːmpɪts",
    "armrest": "ɑːmrɛst",
    "armrests": "ɑːmrɛsts",
    "arms": "ɑːmz",
    "army": "ɑːmi",
    "arnica": "ɑːnɪkɐ",
    "aroma": "ɐrəʊmɐ",
    "aromas": "ɐrəʊməz",
    "aromatherapist": "ɐrəʊmɐθɛrəpɪst",
    "aromatherapists": "ɐrəʊmɐθɛrəpɪsts",
    "aromatherapy": "ɐrəʊmɐθɛrəpi",
    "aromatic": "ɐrəʊmætɪk",
    "aromatics": "ɐrəʊmætɪks",
    "arose": "ɐrəʊz",
    "around": "ɐraʊnd",
    "arousal": "ɐraʊsəl",
    "arouse": "ɐraʊz",
    "aroused": "ɐraʊzd",
    "arouses": "ɐraʊzɪz",
    "arousing": "ɐraʊzɪŋ",
    "arpeggio": "ɑːpɛɡɪəʊ",
    "arpeggios": "ɑːpɛɡɪəʊz",
    "arraigned": "ɐreɪnd",
    "arraign": "ɐreɪn",
    "arraignment": "ɐreɪnmənt",
    "arranged": "ɐreɪndʒd",
    "arrange": "ɐreɪndʒ",
    "arrangement": "ɐreɪndʒmənt",
    "arrangements": "ɐreɪndʒmənts",
    "arranger": "ɐreɪndʒɐ",
    "arrangers": "ɐreɪndʒəz",
    "arranges": "ɐreɪndʒɪz",
    "arranging": "ɐreɪndʒɪŋ",
    "arrant": "ærənt",
    "arras": "ɐræz",
    "array": "ɐreɪ",
    "arrayed": "ɐreɪd",
    "arrays": "ɐreɪz",
    "arrears": "ɐriəz",
    "arrestable": "ɐrɛstəbəl",
    "arrested": "ɐrɛstɪd",
    "arrest": "ɐrɛst",
    "arresting": "ɐrɛstɪŋ",
    "arrests": "ɐrɛsts",
    "arrhythmia": "ɐrhɪθmiə",
    "arrhythmic": "ɐrhɪθmɪk",
    "arris": "ɐrɪs",
    "arrival": "ɐraɪvəl",
    "arrivals": "ɐraɪvəlz",
    "arrive": "ɐraɪv",
    "arrived": "ɐraɪvd",
    "arrivederci": "ɐraɪvɪdəsaɪ",
    "arrives": "ɐraɪvz",
    "arriving": "ɐraɪvɪŋ",
    "arriviste": "ɐrɪviːst",
    "arrogance": "ærəɡəns",
    "arrogant": "ærəɡənt",
    "arrogantly": "ærəɡəntli",
    "arrondissement": "ærəndɪsmənt",
    "arrow": "ærəʊ",
    "arrowed": "ærəʊd",
    "arrowhead": "ærəʊhɛd",
    "arrowheads": "ærəʊhɛdz",
    "arrowing": "ærəʊɪŋ",
    "arrowroot": "ærəʊruːt",
    "arrows": "ærəʊz",
    "arroyo": "ærɔɪəʊ",
    "arsed": "ɑːsd",
    "arsehole": "ɑːsɪhəʊl",
    "arseholes": "ɑːsɪhəʊlz",
    "arsenal": "ɑːsənəl",
    "arsenals": "ɑːsənəlz",
    "arsenical": "ɑːsnɪkəl",
    "arse": "ɑːs",
    "arsing": "ɑːsɪŋ",
    "arsonist": "ɑːsənɪst",
    "arsonists": "ɑːsənɪsts",
    "arson": "ɑːsən",
    "artefacts": "ɑːtɪfækts",
    "artefact": "ɑːtɪfækt",
    "artemisia": "ɑːtɪmɪziə",
    "arterial": "ɑːtiərɪəl",
    "arteries": "ɑːtəriz",
    "arterioles": "ɑːtiərɪəʊlz",
    "arteriosclerosis": "ɑːtiərɪɒsklərəʊsɪs",
    "arteriovenous": "ɑːtiərɪəʊvnəs",
    "artery": "ɑːtəri",
    "artesian": "ɑːtiːziən",
    "artfully": "ɑːtfəli",
    "artful": "ɑːtfəl",
    "arthritic": "ɑːθrɪtɪk",
    "arthritis": "ɑːθraɪtɪs",
    "arthropods": "ɑːθrəpɒdz",
    "arthropod": "ɑːθrəpɒd",
    "arthroscopic": "ɑːθrəskɒpɪk",
    "arthroscopy": "ɑːθrɒskəpi",
    "artichokes": "ɑːtɪtʃəʊks",
    "artichoke": "ɑːtɪtʃəʊk",
    "articled": "ɑːtɪkəld",
    "articles": "ɑːtɪkəlz",
    "article": "ɑːtɪkəl",
    "articulacy": "ɑːtɪkjʊləsi",
    "articular": "ɑːtɪkjʊlɐ",
    "articulated": "ɑːtɪkjʊleɪtɪd",
    "articulately": "ɑːtɪkjʊleɪtli",
    "articulates": "ɑːtɪkjʊleɪts",
    "articulating": "ɑːtɪkjʊleɪtɪŋ",
    "articulation": "ɑːtɪkjʊleɪʃən",
    "artificer": "ɑːtɪfɪsɐ",
    "artifice": "ɑːtɪfɪs",
    "artificiality": "ɑːtɪfɪʃɪælɪti",
    "artificially": "ɑːtɪfɪʃəli",
    "artificial": "ɑːtɪfɪʃəl",
    "artillerymen": "ɑːtɪlərɪmɛn",
    "artillery": "ɑːtɪləri",
    "artiness": "ɑːtɪnəs",
    "artisanal": "ɑːtɪsənəl",
    "artisanship": "ɑːtɪsənʃɪp",
    "artisans": "ɑːtɪsənz",
    "artisan": "ɑːtɪsən",
    "artistes": "ɑːtiːsts",
    "artiste": "ɑːtiːst",
    "artistically": "ɑːtɪstɪkli",
    "artistic": "ɑːtɪstɪk",
    "artistry": "ɑːtɪstri",
    "artists": "ɑːtɪsts",
    "artist": "ɑːtɪst",
    "artless": "ɑːtləs",
    "arts": "ɑːts",
    "artsy": "ɑːtsi",
    "art": "ɑːt",
    "artworks": "ɑːtwɜːks",
    "artwork": "ɑːtwɜːk",
    "arty": "ɑːti",
    "arugula": "æruːɡjʊlɐ",
    "arum": "ærəm",
    "arvo": "ɑːvəʊ",
    "asafoetida": "ɐsæfiːtɪdɐ",
    "asap": "eɪɛseɪpiː",
    "asbestos": "æsbɛstəs",
    "asbestosis": "ɐsbɪstəʊsɪs",
    "ascendance": "ɐsɛndəns",
    "ascendancy": "ɐsɛndənsi",
    "ascendant": "ɐsɛndənt",
    "ascended": "ɐsɛndɪd",
    "ascendency": "ɐsɛndənsi",
    "ascender": "ɐsɛndɐ",
    "ascending": "ɐsɛndɪŋ",
    "ascend": "ɐsɛnd",
    "ascends": "ɐsɛndz",
    "ascension": "ɐsɛnʃən",
    "ascent": "ɐsɛnt",
    "ascents": "ɐsɛnts",
    "ascertain": "æsəteɪn",
    "ascertained": "æsəteɪnd",
    "ascertaining": "æsəteɪnɪŋ",
    "asceticism": "ɐsɛtɪsɪzəm",
    "ascetic": "ɐsɛtɪk",
    "ascetics": "ɐsɛtɪks",
    "ascites": "ɐssaɪts",
    "ascorbic": "ɐskɔːbɪk",
    "ascot": "ɐskɒt",
    "ascribed": "ɐskraɪbd",
    "ascribe": "ɐskraɪb",
    "ascribing": "ɐskraɪbɪŋ",
    "ascription": "ɐskrɪpʃən",
    "asepsis": "æsɛpsɪs",
    "aseptic": "æsɛptɪk",
    "asexual": "eɪsɛkʃuːəl",
    "ash": "æʃ",
    "ashamed": "ɐʃeɪmd",
    "ashamedly": "ɐʃeɪmɪdli",
    "ashcan": "æʃkæn",
    "ashed": "æʃt",
    "ashen": "æʃən",
    "ashes": "æʃɪz",
    "ashlar": "æʃlɐ",
    "ashlars": "æʃləz",
    "ashore": "ɐʃɔː",
    "ashram": "æʃræm",
    "ashtray": "æʃtreɪ",
    "ashtrays": "æʃtreɪz",
    "ashy": "æʃi",
    "aside": "ɐsaɪd",
    "asides": "ɐsaɪdz",
    "asinine": "æsɪnaɪn",
    "askance": "ɐskɑːns",
    "asked": "ɑːskt",
    "askew": "ɐskjuː",
    "asking": "ɑːskɪŋ",
    "ask": "ɑːsk",
    "asks": "ɑːsks",
    "aslant": "ɐslɑːnt",
    "asleep": "ɐsliːp",
    "asocial": "eɪsəʊʃəl",
    "asp": "æsp",
    "asparagus": "ɐspærəɡəs",
    "aspartame": "ɐspɑːteɪm",
    "aspect": "æspɛkt",
    "aspects": "æspɛkts",
    "aspen": "æspən",
    "aspens": "æspənz",
    "aspergillus": "ɐspɜːɡɪləs",
    "aspersion": "ɐspɜːʃən",
    "aspersions": "ɐspɜːʃənz",
    "asper": "ɐspɜː",
    "asphalt": "æsfɒlt",
    "asphodel": "ɐsfəʊdəl",
    "asphyxia": "ɐsfɪksiə",
    "asphyxiated": "ɐsfɪksɪeɪtɪd",
    "asphyxiate": "ɐsfɪksɪeɪt",
    "asphyxiating": "ɐsfɪksɪeɪtɪŋ",
    "asphyxiation": "ɐsfɪksɪeɪʃən",
    "aspic": "æspɪk",
    "aspidistra": "æspɪdɪstrɐ",
    "aspidistras": "æspɪdɪstrəz",
    "aspirant": "æspərənt",
    "aspirants": "æspərənts",
    "aspirated": "æspəreɪtɪd",
    "aspirating": "æspəreɪtɪŋ",
    "aspiration": "æspəreɪʃən",
    "aspirational": "æspəreɪʃənəl",
    "aspirations": "æspəreɪʃənz",
    "aspired": "ɐspaɪəd",
    "aspire": "ɐspaɪə",
    "aspires": "ɐspaɪəz",
    "aspirin": "æsprɪn",
    "aspiring": "ɐspaɪərɪŋ",
    "aspirins": "æsprɪnz",
    "asps": "æsps",
    "assailant": "ɐseɪlənt",
    "assailants": "ɐseɪlənts",
    "assailed": "ɐseɪld",
    "assailing": "ɐseɪlɪŋ",
    "assail": "ɐseɪl",
    "assails": "ɐseɪlz",
    "assai": "ɐsaɪ",
    "assassinated": "ɐsæsɪneɪtɪd",
    "assassinate": "ɐsæsɪneɪt",
    "assassinating": "ɐsæsɪneɪtɪŋ",
    "assassination": "ɐsæsɪneɪʃən",
    "assassinations": "ɐsæsɪneɪʃənz",
    "assassin": "ɐsæsɪn",
    "assassins": "ɐsæsɪnz",
    "assaulted": "ɐsɒltɪd",
    "assaulting": "ɐsɒltɪŋ",
    "assault": "ɐsɒlt",
    "assaults": "ɐsɒlts",
    "assayed": "ɐseɪd",
    "assayer": "ɐseɪɐ",
    "assaying": "ɐseɪɪŋ",
    "assay": "ɐseɪ",
    "assegai": "ɐsɛɡaɪ",
    "assemblage": "ɐsɛmblɪdʒ",
    "assemblages": "ɐsɛmblɪdʒɪz",
    "assembled": "ɐsɛmbəld",
    "assembler": "ɐsɛmblɐ",
    "assemblers": "ɐsɛmbləz",
    "assemble": "ɐsɛmbəl",
    "assembles": "ɐsɛmbəlz",
    "assemblies": "ɐsɛmblɪz",
    "assembling": "ɐsɛmblɪŋ",
    "assembly": "ɐsɛmbli",
    "assented": "ɐsɛntɪd",
    "assent": "ɐsɛnt",
    "assents": "ɐsɛnts",
    "asserted": "ɐsɜːtɪd",
    "asserting": "ɐsɜːtɪŋ",
    "assertion": "ɐsɜːʃən",
    "assertions": "ɐsɜːʃənz",
    "assertively": "ɐsɜːtɪvli",
    "assertiveness": "ɐsɜːtɪvnəs",
    "assertive": "ɐsɜːtɪv",
    "asserts": "ɐsɜːts",
    "assert": "ɐsɜːt",
    "assessable": "ɐsɛsəbəl",
    "assessed": "ɐsɛst",
    "assesses": "ɐsɛsɪz",
    "assessing": "ɐsɛsɪŋ",
    "assessment": "ɐsɛsmənt",
    "assessments": "ɐsɛsmənts",
    "assessor": "ɐsɛsɐ",
    "assessors": "ɐsɛsəz",
    "assess": "ɐsɛs",
    "asset": "æsɛt",
    "assets": "æsɛts",
    "assiduously": "ɐsɪdjuːəsli",
    "assiduous": "ɐsɪdjuːəs",
    "assignable": "ɐsaɪnəbəl",
    "assignation": "ɐsɪɡneɪʃən",
    "assignations": "ɐsɪɡneɪʃənz",
    "assigned": "ɐsaɪnd",
    "assigning": "ɐsaɪnɪŋ",
    "assignment": "ɐsaɪnmənt",
    "assignments": "ɐsaɪnmənts",
    "assign": "ɐsaɪn",
    "assigns": "ɐsaɪnz",
    "assimilated": "ɐsɪmɪleɪtɪd",
    "assimilate": "ɐsɪmɪleɪt",
    "assimilates": "ɐsɪmɪleɪts",
    "assimilating": "ɐsɪmɪleɪtɪŋ",
    "assimilation": "ɐsɪmɪleɪʃən",
    "assistance": "ɐsɪstəns",
    "assistants": "ɐsɪstənts",
    "assistant": "ɐsɪstənt",
    "assisted": "ɐsɪstɪd",
    "assisting": "ɐsɪstɪŋ",
    "assists": "ɐsɪsts",
    "assist": "ɐsɪst",
    "assize": "ɐsaɪz",
    "assizes": "ɐsaɪzɪz",
    "associated": "ɐsəʊsɪeɪtɪd",
    "associating": "ɐsəʊsɪeɪtɪŋ",
    "association": "ɐsəʊsɪeɪʃən",
    "associations": "ɐsəʊsɪeɪʃənz",
    "associative": "ɐsəʊsiətɪv",
    "assonance": "æsənəns",
    "assorted": "ɐsɔːtɪd",
    "assortment": "ɐsɔːtmənt",
    "assuaged": "ɐsweɪdʒd",
    "assuage": "ɐsweɪdʒ",
    "assumed": "ɐsuːmd",
    "assumes": "ɐsuːmz",
    "assume": "ɐsuːm",
    "assuming": "ɐsuːmɪŋ",
    "assumption": "ɐsʌmpʃən",
    "assumptions": "ɐsʌmpʃənz",
    "assumptive": "ɐsʌmptɪv",
    "assurance": "əʃjɔːrəns",
    "assurances": "əʃjɔːrənsɪz",
    "assured": "əʃjɔːd",
    "assuredly": "əʃjɔːrɪdli",
    "assuredness": "əʃjɔːdnəs",
    "assure": "əʃjɔː",
    "assures": "əʃjɔːz",
    "assuring": "əʃjɔːrɪŋ",
    "astatine": "ɐstætiːn",
    "asterisked": "ɑːstərɪskt",
    "asterisks": "ɑːstərɪsks",
    "asterisk": "ɑːstərɪsk",
    "asterism": "ɑːstərɪzəm",
    "astern": "ɐstɜːn",
    "asteroids": "ɑːstərɔɪdz",
    "asteroid": "ɑːstərɔɪd",
    "asters": "ɑːstəz",
    "aster": "ɑːstɐ",
    "asthma": "æsmɐ",
    "asthmatic": "æsmætɪk",
    "asthmatics": "æsmætɪks",
    "astigmatism": "ɐstɪɡmətɪzəm",
    "astilbes": "ɐstɪlbz",
    "astilbe": "ɐstɪlb",
    "astonished": "ɐstɒnɪʃt",
    "astonishes": "ɐstɒnɪʃɪz",
    "astonishingly": "ɐstɒnɪʃɪŋli",
    "astonishing": "ɐstɒnɪʃɪŋ",
    "astonishment": "ɐstɒnɪʃmənt",
    "astonish": "ɐstɒnɪʃ",
    "astounded": "ɐstaʊndɪd",
    "astoundingly": "ɐstaʊndɪŋli",
    "astounding": "ɐstaʊndɪŋ",
    "astounds": "ɐstaʊndz",
    "astound": "ɐstaʊnd",
    "astragal": "ɐstræɡəl",
    "astragalus": "ɐstræɡæləs",
    "astrakhan": "ɐstrækhən",
    "astral": "æstrəl",
    "astray": "ɐstreɪ",
    "astride": "ɐstraɪd",
    "astringency": "ɐstrɪndʒənsi",
    "astringents": "ɐstrɪndʒənts",
    "astringent": "ɐstrɪndʒənt",
    "astrobiology": "æstrəʊbaɪɒlədʒi",
    "astrolabe": "æstrəleɪb",
    "astrolabes": "æstrəleɪbz",
    "astrologers": "ɐstrɒləʊdʒəz",
    "astrologer": "ɐstrɒləʊdʒɐ",
    "astrologically": "ɐstrəlɒdʒɪkli",
    "astrological": "ɐstrəlɒdʒɪkəl",
    "astrologist": "ɐstrɒlədʒɪst",
    "astrology": "ɐstrɒlədʒi",
    "astronaut": "æstrənɔːt",
    "astronautics": "æstrənɔːtɪks",
    "astronauts": "æstrənɔːts",
    "astronomers": "ɐstrɒnəməz",
    "astronomer": "ɐstrɒnəmɐ",
    "astronomically": "ɐstrənɒmɪkli",
    "astronomical": "ɐstrənɒmɪkəl",
    "astronomic": "ɐstrənɒmɪk",
    "astronomy": "ɐstrɒnəmi",
    "astrophotography": "æstrəfəʊtɒɡrəfi",
    "astrophysical": "æstrəfɪzɪkəl",
    "astrophysicist": "æstrəfɪzɪsɪst",
    "astrophysicists": "æstrəfɪzɪsɪsts",
    "astrophysics": "æstrəfɪzɪks",
    "astutely": "ɐstjuːtli",
    "astuteness": "ɐstjuːtnəs",
    "astute": "ɐstjuːt",
    "asunder": "ɐsʌndɐ",
    "asylum": "ɐsaɪləm",
    "asylums": "ɐsaɪləmz",
    "asymmetrical": "eɪsɪmɛtrɪkəl",
    "asymmetrically": "eɪsɪmɛtrɪkli",
    "asymmetric": "eɪsɪmɛtrɪk",
    "asymmetry": "eɪsɪmətri",
    "asymptomatic": "æsɪmptəmætɪk",
    "asymptote": "æsɪmptəʊt",
    "at": "æt",
    "atavistic": "ætɐvɪstɪk",
    "ataxia": "æteɪksiə",
    "ataxic": "ætæksɪk",
    "atelier": "eɪtliɐ",
    "atheism": "eɪθɪɪzəm",
    "atheist": "eɪθɪɪst",
    "atheistic": "eɪθɪɪstɪk",
    "atheists": "eɪθɪɪsts",
    "atheling": "æθəlɪŋ",
    "athenaeum": "æθəniːəm",
    "atheneum": "æθəniːəm",
    "atherosclerosis": "æθərɒsklərəʊsɪs",
    "athlete": "æθliːt",
    "athletes": "æθliːts",
    "athletic": "æθlɛtɪk",
    "athletically": "æθlɛtɪkli",
    "athleticism": "æθlɛtɪsɪzəm",
    "athletics": "æθlɛtɪks",
    "athwart": "æθwɔːt",
    "atishoo": "ætɪʃuː",
    "atlas": "ætləs",
    "atlases": "ætləsɪz",
    "atmosphere": "ætməsfiə",
    "atmospheres": "ætməsfiəz",
    "atmospheric": "ætməsfɛrɪk",
    "atmospherically": "ætməsfɛrɪkli",
    "atmospherics": "ætməsfɛrɪks",
    "atoll": "ætɒl",
    "atolls": "ætɒlz",
    "atom": "ætəm",
    "atomically": "ɐtɒmɪkli",
    "atomics": "ɐtɒmɪks",
    "atomic": "ɐtɒmɪk",
    "atomisation": "ɐtɒmaɪzeɪʃən",
    "atomised": "ɐtɒmaɪzd",
    "atomiser": "ɐtɒmaɪzɐ",
    "atomise": "ɐtɒmaɪz",
    "atomising": "ɐtɒmaɪzɪŋ",
    "atomistic": "ɐtəmɪstɪk",
    "atoms": "ætəmz",
    "atomy": "ætəmi",
    "atonal": "eɪtəʊnəl",
    "atonality": "eɪtəʊnælɪti",
    "atoned": "ɐtəʊnd",
    "atonement": "ɐtəʊnmənt",
    "atone": "ɐtəʊn",
    "atoning": "ɐtəʊnɪŋ",
    "atop": "ɐtɒp",
    "atria": "ætriɐ",
    "atrial": "ætrɪəl",
    "atrium": "ætriəm",
    "atrociously": "ɐtrəʊʃəsli",
    "atrocious": "ɐtrəʊʃəs",
    "atrocities": "ɐtrɒsɪtiz",
    "atrocity": "ɐtrɒsɪti",
    "atrophic": "ætrɒfɪk",
    "atrophied": "ætrəfɪd",
    "atrophy": "ætrəfi",
    "atropine": "ætrəpaɪn",
    "attaboy": "ɐtæbɔɪ",
    "attachable": "ɐtætʃəbəl",
    "attached": "ɐtætʃt",
    "attaching": "ɐtætʃɪŋ",
    "attachments": "ɐtætʃmənts",
    "attachment": "ɐtætʃmənt",
    "attach": "ɐtætʃ",
    "attacked": "ɐtækt",
    "attackers": "ɐtækəz",
    "attacker": "ɐtækɐ",
    "attacking": "ɐtækɪŋ",
    "attacks": "ɐtæks",
    "attack": "ɐtæk",
    "attainability": "ɐteɪnəbɪlɪti",
    "attainable": "ɐteɪnəbəl",
    "attainder": "ɐteɪndɐ",
    "attained": "ɐteɪnd",
    "attaining": "ɐteɪnɪŋ",
    "attainments": "ɐteɪnmənts",
    "attainment": "ɐteɪnmənt",
    "attains": "ɐteɪnz",
    "attain": "ɐteɪn",
    "attar": "ɐtɑː",
    "attempted": "ɐtɛmptɪd",
    "attempting": "ɐtɛmptɪŋ",
    "attempts": "ɐtɛmpts",
    "attempt": "ɐtɛmpt",
    "attendances": "ɐtɛndənsɪz",
    "attendance": "ɐtɛndəns",
    "attendants": "ɐtɛndənts",
    "attendant": "ɐtɛndənt",
    "attended": "ɐtɛndɪd",
    "attendees": "ɐtɛndiːz",
    "attendee": "ɐtɛndiː",
    "attenders": "ɐtɛndəz",
    "attender": "ɐtɛndɐ",
    "attending": "ɐtɛndɪŋ",
    "attends": "ɐtɛndz",
    "attend": "ɐtɛnd",
    "attentional": "ɐtɛnʃənəl",
    "attentions": "ɐtɛnʃənz",
    "attention": "ɐtɛnʃən",
    "attentively": "ɐtɛntɪvli",
    "attentiveness": "ɐtɛntɪvnəs",
    "attentive": "ɐtɛntɪv",
    "attenuated": "ɐtɛnjuːeɪtɪd",
    "attenuation": "ɐtɛnjuːeɪʃən",
    "attestation": "ɐtɪsteɪʃən",
    "attested": "ɐtɛstɪd",
    "attesting": "ɐtɛstɪŋ",
    "attests": "ɐtɛsts",
    "attest": "ɐtɛst",
    "attic": "ætɪk",
    "attics": "ætɪks",
    "attired": "ɐtaɪəd",
    "attire": "ɐtaɪə",
    "attitude": "ætɪtjuːd",
    "attitudes": "ætɪtjuːdz",
    "attitudinal": "ætɪtjuːdɪnəl",
    "attorneys": "ɐtɜːniz",
    "attorney": "ɐtɜːni",
    "attractants": "ɐtræktənts",
    "attractant": "ɐtræktənt",
    "attracted": "ɐtræktɪd",
    "attracting": "ɐtræktɪŋ",
    "attractions": "ɐtrækʃənz",
    "attraction": "ɐtrækʃən",
    "attractively": "ɐtræktɪvli",
    "attractiveness": "ɐtræktɪvnəs",
    "attractive": "ɐtræktɪv",
    "attractor": "ɐtræktɐ",
    "attracts": "ɐtrækts",
    "attract": "ɐtrækt",
    "attributable": "ɐtrɪbjuːtəbəl",
    "attributed": "ɐtrɪbjuːtɪd",
    "attributing": "ɐtrɪbjuːtɪŋ",
    "attributions": "ɐtrɪbjuːʃənz",
    "attribution": "ɐtrɪbjuːʃən",
    "attritional": "ɐtrɪʃənəl",
    "attrition": "ɐtrɪʃən",
    "attuned": "ɐtjuːnd",
    "attune": "ɐtjuːn",
    "atypical": "eɪtɪpɪkəl",
    "auberge": "ɔːbədʒ",
    "aubergine": "əʊbəʒiːn",
    "aubergines": "əʊbəʒiːnz",
    "auburn": "ɔːbɜːn",
    "auctioned": "ɔːkʃənd",
    "auctioneer": "ɔːkʃəniə",
    "auctioneers": "ɔːkʃəniəz",
    "auctioning": "ɔːkʃənɪŋ",
    "auction": "ɔːkʃən",
    "auctions": "ɔːkʃənz",
    "audaciously": "ɔːdeɪʃəsli",
    "audacious": "ɔːdeɪʃəs",
    "audacity": "ɔːdæsɪti",
    "audibility": "ɔːdɪbɪlɪti",
    "audible": "ɔːdəbəl",
    "audibly": "ɔːdəbli",
    "audience": "ɔːdiəns",
    "audiences": "ɔːdiənsɪz",
    "audiobook": "ɔːdɪəʊbʊk",
    "audiobooks": "ɔːdɪəʊbʊks",
    "audiologist": "ɔːdɪɒlədʒɪst",
    "audiology": "ɔːdɪɒlədʒi",
    "audio": "ɔːdɪəʊ",
    "audios": "ɔːdɪəʊz",
    "audiovisual": "ɔːdɪəʊvɪʒuːəl",
    "audited": "ɔːdɪtɪd",
    "auditing": "ɔːdɪtɪŋ",
    "auditioned": "ɔːdɪʃənd",
    "auditioning": "ɔːdɪʃənɪŋ",
    "audition": "ɔːdɪʃən",
    "auditions": "ɔːdɪʃənz",
    "audit": "ɔːdɪt",
    "auditoria": "ɔːdɪtɔːriə",
    "auditorium": "ɔːdɪtɔːriəm",
    "auditoriums": "ɔːdɪtɔːriəmz",
    "auditor": "ɔːdɪtɐ",
    "auditors": "ɔːdɪtəz",
    "auditory": "ɔːdɪtəri",
    "audits": "ɔːdɪts",
    "auger": "ɔːɡɐ",
    "augers": "ɔːɡəz",
    "aught": "ɔːt",
    "augmentation": "ɔːɡmɛnteɪʃən",
    "augmentations": "ɔːɡmɛnteɪʃənz",
    "augmented": "ɔːɡmɛntɪd",
    "augmenting": "ɔːɡmɛntɪŋ",
    "augments": "ɔːɡmɛnts",
    "augured": "ɔːɡəd",
    "auguries": "ɔːɡjʊrɪz",
    "auguring": "ɔːɡərɪŋ",
    "augur": "ɔːɡɐ",
    "augurs": "ɔːɡəz",
    "augury": "ɔːɡjʊri",
    "auklets": "ɔːkləts",
    "auk": "ɔːk",
    "auks": "ɔːks",
    "auntie": "ɑːnti",
    "aunties": "ɑːntɪz",
    "aunt": "ɑːnt",
    "aunts": "ɑːnts",
    "aunty": "ɑːnti",
    "aurally": "ɔːrəli",
    "aural": "ɔːrəl",
    "aura": "ɔːrɐ",
    "auras": "ɔːrəz",
    "aureate": "ɔːriːt",
    "aurelia": "ɔːrɪlaɪɐ",
    "aureola": "ɔːrɪəʊlɐ",
    "aureole": "ɔːrɪəʊl",
    "aureoles": "ɔːrɪəʊlz",
    "aureus": "ɔːrɪəs",
    "auricle": "ɔːrɪkəl",
    "auric": "ɔːrɪk",
    "auricular": "ɔːrɪkjʊlɐ",
    "auriculas": "ɔːrɪkjʊləz",
    "auriscope": "ɔːrɪskəʊp",
    "aurochs": "ɔːrɒkz",
    "aurorae": "ɐrɔːriː",
    "auroral": "ɐrɔːrəl",
    "aurora": "ɐrɔːrɐ",
    "auroras": "ɐrɔːrəz",
    "aurum": "ɔːrəm",
    "auspices": "ɔːspɪsɪz",
    "auspiciously": "ɔːspɪʃəsli",
    "auspiciousness": "ɔːspɪʃəsnəs",
    "auspicious": "ɔːspɪʃəs",
    "austere": "ɔːstiə",
    "austerities": "ɔːstɛrɪtiz",
    "austerity": "ɔːstɛrɪti",
    "austral": "ɒstrəl",
    "auteur": "ɔːtɜː",
    "authentically": "ɔːθɛntɪkli",
    "authenticated": "ɔːθɛntɪkeɪtɪd",
    "authenticate": "ɔːθɛntɪkeɪt",
    "authenticates": "ɔːθɛntɪkeɪts",
    "authenticating": "ɔːθɛntɪkeɪtɪŋ",
    "authentication": "ɔːθɛntɪkeɪʃən",
    "authenticator": "ɔːθɛntɪkeɪtɐ",
    "authenticity": "ɔːθɪntɪsɪti",
    "authentic": "ɔːθɛntɪk",
    "authored": "ɔːθəd",
    "authoress": "ɔːθɔːs",
    "authorial": "ɔːθɔːrɪəl",
    "authoring": "ɔːθərɪŋ",
    "authorisation": "ɔːθɔːraɪzeɪʃən",
    "authorisations": "ɔːθɔːraɪzeɪʃənz",
    "authorised": "ɔːθɔːraɪzd",
    "authorise": "ɔːθɔːraɪz",
    "authorises": "ɔːθɔːraɪzɪz",
    "authorising": "ɔːθɔːraɪzɪŋ",
    "authoritarianism": "ɔːθɔːrɪteəriənɪzəm",
    "authoritarian": "ɔːθɔːrɪteəriən",
    "authoritarians": "ɔːθɔːrɪteəriənz",
    "authoritatively": "ɔːθɒrɪtətɪvli",
    "authoritative": "ɔːθɒrɪtətɪv",
    "authorities": "ɐθɒrɪtiz",
    "authority": "ɐθɒrɪti",
    "author": "ɔːθɐ",
    "authorship": "ɔːθəʃɪp",
    "authors": "ɔːθəz",
    "autism": "ɔːtɪzəm",
    "autistic": "ɔːtɪstɪk",
    "autobahn": "ɔːtəʊbɑːn",
    "autobahns": "ɔːtəʊbɑːnz",
    "autobiographer": "ɔːtəʊbaɪɒɡrəfɐ",
    "autobiographically": "ɔːtəʊbaɪəɡræfɪkli",
    "autobiographical": "ɔːtəʊbaɪəɡræfɪkəl",
    "autobiographies": "ɔːtəʊbaɪɒɡrəfɪz",
    "autobiography": "ɔːtəʊbaɪɒɡrəfi",
    "autobus": "ɔːtəʊbʌs",
    "autoclave": "ɔːtəʊkleɪv",
    "autocracy": "ɔːtɒkrəsi",
    "autocratic": "ɔːtəʊkrætɪk",
    "autocrat": "ɔːtəʊkræt",
    "autocrats": "ɔːtəʊkræts",
    "autocue": "ɔːtəʊkjuː",
    "autographed": "ɔːtəɡræfd",
    "autographically": "ɔːtəʊɡræfɪkli",
    "autographic": "ɔːtəʊɡræfɪk",
    "autographing": "ɔːtəɡræfɪŋ",
    "autograph": "ɔːtəɡræf",
    "autographs": "ɔːtəɡræfz",
    "autoimmune": "ɔːtəʊɪmjuːn",
    "automaker": "ɔːtəmeɪkɐ",
    "automakers": "ɔːtəmeɪkəz",
    "automata": "ɔːtəmɑːtɐ",
    "automated": "ɔːtəmeɪtɪd",
    "automate": "ɔːtəmeɪt",
    "automatically": "ɔːtəmætɪkli",
    "automatic": "ɔːtəmætɪk",
    "automatics": "ɔːtəmætɪks",
    "automating": "ɔːtəmeɪtɪŋ",
    "automation": "ɔːtəmeɪʃən",
    "automaton": "ɔːtɒmətən",
    "automatons": "ɔːtɒmətənz",
    "automat": "ɔːtəmæt",
    "automobile": "ɔːtəməbiəl",
    "automobiles": "ɔːtəməbiəlz",
    "automotive": "ɔːtəʊməʊtɪv",
    "autonomic": "ɔːtənɒmɪk",
    "autonomously": "ɔːtɒnəməsli",
    "autonomous": "ɔːtɒnəməs",
    "autonomy": "ɔːtɒnəmi",
    "auto": "ɔːtəʊ",
    "autopilot": "ɔːtəʊpaɪlət",
    "autopsies": "ɔːtɒpsiz",
    "autopsy": "ɔːtɒpsi",
    "autoroute": "ɔːtəʊruːt",
    "autos": "ɔːtəʊz",
    "autostrada": "ɔːtəʊstrɑːdɐ",
    "autosuggestion": "ɔːtəʊsədʒɛstʃən",
    "autumnal": "ɔːtʌmnəl",
    "autumn": "ɔːtʌm",
    "autumns": "ɔːtʌmz",
    "auxiliaries": "ɔːksɪliərɪz",
    "auxiliary": "ɔːksɪliəri",
    "availability": "ɐveɪləbɪlɪti",
    "available": "ɐveɪləbəl",
    "availed": "ɐveɪld",
    "availing": "ɐveɪlɪŋ",
    "avail": "ɐveɪl",
    "avalanche": "ævəlɑːnʃ",
    "avalanches": "ævəlɑːnʃɪz",
    "avarice": "ævərɪs",
    "avaricious": "ævərɪʃəs",
    "avast": "ɐvɑːst",
    "avatar": "ævɐtɑː",
    "avatars": "ævɐtɑːz",
    "avaunt": "ævɔːnt",
    "avenged": "ɐvɛndʒd",
    "avengers": "ɐvɛndʒəz",
    "avenger": "ɐvɛndʒɐ",
    "avenges": "ɐvɛndʒɪz",
    "avenge": "ɐvɛndʒ",
    "avenging": "ɐvɛndʒɪŋ",
    "avens": "ævənz",
    "aventurine": "ævɛntʃəriːn",
    "avenue": "ævənjuː",
    "avenues": "ævənjuːz",
    "average": "ævrɪdʒ",
    "averaged": "ævrɪdʒd",
    "averagely": "ævrɪdʒli",
    "averages": "ævrɪdʒɪz",
    "averaging": "ævrɪdʒɪŋ",
    "averse": "ɐvɜːs",
    "aversion": "ɐvɜːʃən",
    "aversive": "ɐvɜːsɪv",
    "averted": "ɐvɜːtɪd",
    "averting": "ɐvɜːtɪŋ",
    "averts": "ɐvɜːts",
    "avert": "ɐvɜːt",
    "avian": "eɪvɪən",
    "aviaries": "eɪviəriz",
    "aviary": "eɪviəri",
    "aviate": "eɪvɪeɪt",
    "aviation": "eɪvɪeɪʃən",
    "aviator": "eɪvɪeɪtɐ",
    "aviators": "eɪvɪeɪtəz",
    "aviatrix": "eɪvɪeɪtrɪks",
    "avid": "ævɪd",
    "avidly": "ævɪdli",
    "avion": "eɪvɪən",
    "avionics": "eɪvɪɒnɪks",
    "avocado": "ævəkɑːdəʊ",
    "avocadoes": "ævəkɑːdəʊz",
    "avocados": "ævəkɑːdəʊz",
    "avocation": "ævəkeɪʃən",
    "avocet": "ævɒsɪt",
    "avocets": "ævɒsɪts",
    "avoidable": "ɐvɔɪdəbəl",
    "avoidance": "ɐvɔɪdəns",
    "avoided": "ɐvɔɪdɪd",
    "avoider": "ɐvɔɪdɐ",
    "avoiding": "ɐvɔɪdɪŋ",
    "avoids": "ɐvɔɪdz",
    "avoid": "ɐvɔɪd",
    "avoirdupois": "ɐvwɑːdjuːpwɑː",
    "avos": "ɑːvəʊz",
    "avouch": "ɐvaʊtʃ",
    "avo": "ɑːvəʊ",
    "avowedly": "ɐvaʊɪdli",
    "avowed": "ɐvaʊd",
    "avows": "ɐvaʊz",
    "avow": "ɐvaʊ",
    "avulsion": "ævʌlʃən",
    "avuncular": "ævʌnkjʊlɐ",
    "awaited": "ɐweɪtɪd",
    "awaiting": "ɐweɪtɪŋ",
    "awaits": "ɐweɪts",
    "await": "ɐweɪt",
    "awaked": "ɐweɪkt",
    "awakened": "ɐweɪkənd",
    "awakenings": "ɐweɪknɪŋz",
    "awakening": "ɐweɪknɪŋ",
    "awakens": "ɐweɪkənz",
    "awaken": "ɐweɪkən",
    "awakes": "ɐweɪks",
    "awake": "ɐweɪk",
    "awaking": "ɐweɪkɪŋ",
    "awarded": "ɐwɔːdɪd",
    "awarding": "ɐwɔːdɪŋ",
    "awards": "ɐwɔːdz",
    "award": "ɐwɔːd",
    "awareness": "ɐweənəs",
    "aware": "ɐweə",
    "awash": "ɐwɒʃ",
    "away": "ɐweɪ",
    "awed": "ɔːd",
    "aweigh": "ɔːrɪɡ",
    "awe": "ɔː",
    "awesomely": "ɔːsʌmli",
    "awesomeness": "ɔːsʌmnəs",
    "awesome": "ɔːsʌm",
    "awestruck": "ɔːstrʌk",
    "awfully": "ɔːfəli",
    "awfulness": "ɔːfəlnəs",
    "awful": "ɔːfəl",
    "awhile": "ɐwaɪl",
    "awing": "ɔːrɪŋ",
    "awkwardly": "ɔːkwədli",
    "awkwardness": "ɔːkwədnəs",
    "awkward": "ɔːkwəd",
    "awl": "ɔːl",
    "awning": "ɔːnɪŋ",
    "awnings": "ɔːnɪŋz",
    "awn": "ɔːn",
    "awoken": "ɐwəʊkən",
    "awoke": "ɐwəʊk",
    "awol": "eɪwɒl",
    "awry": "ɐraɪ",
    "axe": "æks",
    "axed": "ækst",
    "axeman": "æksɛmən",
    "axial": "æksɪəl",
    "axilla": "æksɪlɐ",
    "axillary": "æksɪləri",
    "axils": "æksɪlz",
    "axing": "æksɪŋ",
    "axiom": "æksɪəm",
    "axiomatic": "æksɪəmætɪk",
    "axioms": "æksɪəmz",
    "axis": "æksɪs",
    "axle": "æksəl",
    "axles": "æksəlz",
    "axolotl": "æksəlɒtəl",
    "axolotls": "æksəlɒtəlz",
    "axon": "æksɒn",
    "axons": "æksɒnz",
    "ayah": "aɪɐ",
    "ayatollah": "aɪɐtɒlɐ",
    "ayatollahs": "aɪɐtɒləz",
    "ayes": "aɪz",
    "azalea": "æzeɪliə",
    "azaleas": "æzeɪliəz",
    "azimuth": "æzɪmʌθ",
    "azimuthal": "æzɪmʌθəl",
    "azine": "æziːn",
    "azo": "ɑːzəʊ",
    "azure": "æʒɐ",
    "azurite": "æzjʊrɪt",
    "baa": "bɑː",
    "baaed": "bɑːd",
    "baaing": "bɑːrɪŋ",
    "baba": "bɑːbɐ",
    "babas": "bɑːbəz",
    "babbitt": "bæbɪt",
    "babble": "bæbəl",
    "babbled": "bæbəld",
    "babbler": "bæblɐ",
    "babbles": "bæbəlz",
    "babbling": "bæblɪŋ",
    "babe": "beɪb",
    "babel": "beɪbəl",
    "babes": "beɪbz",
    "babied": "beɪbɪd",
    "babies": "beɪbɪz",
    "baboon": "bæbuːn",
    "baboons": "bæbuːnz",
    "babushka": "bæbʊʃkɐ",
    "babushkas": "bæbʊʃkəz",
    "baby": "beɪbi",
    "babyhood": "beɪbɪhʊd",
    "babying": "beɪbɪɪŋ",
    "babyish": "beɪbɪɪʃ",
    "babysat": "beɪbɪsæt",
    "babysit": "beɪbɪsɪt",
    "babysits": "beɪbɪsɪts",
    "babysitter": "beɪbɪsɪtɐ",
    "babysitters": "beɪbɪsɪtəz",
    "babysitting": "beɪbɪsɪtɪŋ",
    "baccalaureate": "bækɐlɔːriːt",
    "baccarat": "bækɐræt",
    "bacchanal": "bækənəl",
    "bacchanalia": "bækɐneɪliə",
    "bacchanalian": "bækɐneɪliən",
    "baccy": "bæki",
    "bach": "bɑːx",
    "bachelor": "bætʃəlɐ",
    "bachelorette": "bɑːkɪlɔːrɛt",
    "bachelorhood": "bætʃələhʊd",
    "bachelors": "bætʃələz",
    "bacilli": "bæsɪli",
    "bacillus": "bæsɪləs",
    "backache": "bækeɪk",
    "backaches": "bækeɪks",
    "back": "bæk",
    "backbeat": "bækbiːt",
    "backbench": "bækbɛntʃ",
    "backbencher": "bækbɛntʃɐ",
    "backbenchers": "bækbɛntʃəz",
    "backbenches": "bækbɛntʃɪz",
    "backbend": "bækbənd",
    "backbiting": "bækbɪtɪŋ",
    "backboard": "bækbɔːd",
    "backboards": "bækbɔːdz",
    "backbone": "bækbəʊn",
    "backbones": "bækbəʊnz",
    "backbreaker": "bækbreɪkɐ",
    "backbreaking": "bækbreɪkɪŋ",
    "backchat": "bæktʃæt",
    "backcloth": "bækklɒθ",
    "backcloths": "bækklɒθs",
    "backcomb": "bækkəʊm",
    "backcombing": "bækkəʊmɪŋ",
    "backdate": "bækdeɪt",
    "backdated": "bækdeɪtɪd",
    "backdating": "bækdeɪtɪŋ",
    "backdoor": "bækdɔː",
    "backdrop": "bækdrɒp",
    "backdrops": "bækdrɒps",
    "backed": "bækt",
    "backer": "bækɐ",
    "backers": "bækəz",
    "backfield": "bækfiːld",
    "backfill": "bækfɪl",
    "backfire": "bækfaɪə",
    "backfired": "bækfaɪəd",
    "backfires": "bækfaɪəz",
    "backfiring": "bækfaɪərɪŋ",
    "backflow": "bækfləʊ",
    "backgammon": "bækɡæmən",
    "background": "bækɡraʊnd",
    "backgrounds": "bækɡraʊndz",
    "backhand": "bækhænd",
    "backhanded": "bækhændɪd",
    "backhander": "bækhændɐ",
    "backhanders": "bækhændəz",
    "backhands": "bækhændz",
    "backhoe": "bækhəʊ",
    "backhouse": "bækhaʊs",
    "backing": "bækɪŋ",
    "backings": "bækɪŋz",
    "backlash": "bæklæʃ",
    "backlashes": "bæklæʃɪz",
    "backless": "bækləs",
    "backlight": "bæklaɪt",
    "backlit": "bæklɪt",
    "backlog": "bæklɒɡ",
    "backlogged": "bæklɒɡd",
    "backlogs": "bæklɒɡz",
    "backpack": "bækpæk",
    "backpacked": "bækpækt",
    "backpacker": "bækpækɐ",
    "backpackers": "bækpækəz",
    "backpacking": "bækpækɪŋ",
    "backpacks": "bækpæks",
    "backpedalling": "bækpɪdəlɪŋ",
    "backplate": "bækpleɪt",
    "backrest": "bækrɛst",
    "backroom": "bækruːm",
    "backrooms": "bækruːmz",
    "backs": "bæks",
    "backscratcher": "bækskrætʃɐ",
    "backseat": "bæksiːt",
    "backseats": "bæksiːts",
    "backside": "bæksaɪd",
    "backsides": "bæksaɪdz",
    "backslapping": "bækslæpɪŋ",
    "backslide": "bækslaɪd",
    "backslider": "bækslaɪdɐ",
    "backsliders": "bækslaɪdəz",
    "backsliding": "bækslaɪdɪŋ",
    "backspace": "bækspeɪs",
    "backspin": "bækspɪn",
    "backstabber": "bækstæbɐ",
    "backstabbers": "bækstæbəz",
    "backstabbing": "bækstæbɪŋ",
    "backstage": "bæksteɪdʒ",
    "backstairs": "bæksteəz",
    "backstay": "bæksteɪ",
    "backstop": "bækstɒp",
    "backstreet": "bækstriːt",
    "backstreets": "bækstriːts",
    "backstretch": "bækstrɛtʃ",
    "backstroke": "bækstrəʊk",
    "backswing": "bækswɪŋ",
    "backtrack": "bæktræk",
    "backtracked": "bæktrækt",
    "backtracking": "bæktrækɪŋ",
    "backtracks": "bæktræks",
    "backup": "bækʌp",
    "backups": "bækʌps",
    "backward": "bækwəd",
    "backwardness": "bækwədnəs",
    "backwards": "bækwədz",
    "backwash": "bækwɒʃ",
    "backwater": "bækwɔːtɐ",
    "backwaters": "bækwɔːtəz",
    "backwoods": "bækwʊdz",
    "backwoodsman": "bækwʊdzmən",
    "backwoodsmen": "bækwʊdzmɛn",
    "backyard": "bækjɑːd",
    "backyards": "bækjɑːdz",
    "bacon": "beɪkən",
    "bacteria": "bæktiərɪɐ",
    "bacterial": "bæktiərɪəl",
    "bacterias": "bæktiərɪəz",
    "bacteriological": "bæktiərɪəlɒdʒɪkəl",
    "bacteriologically": "bæktiərɪəlɒdʒɪkli",
    "bacteriologist": "bæktiərɪɒlədʒɪst",
    "bacteriologists": "bæktiərɪɒlədʒɪsts",
    "bacteriology": "bæktiərɪɒlədʒi",
    "bacteriophage": "bæktiərɪɒfɪdʒ",
    "bacterium": "bæktiərɪəm",
    "bad": "bæd",
    "badder": "bædɐ",
    "baddest": "bædəst",
    "baddie": "bædi",
    "baddies": "bædɪz",
    "baddy": "bædi",
    "bade": "beɪd",
    "badge": "bædʒ",
    "badged": "bædʒd",
    "badger": "bædʒɐ",
    "badgered": "bædʒəd",
    "badgering": "bædʒərɪŋ",
    "badgers": "bædʒəz",
    "badges": "bædʒɪz",
    "badinage": "bædɪnɪdʒ",
    "badlands": "bædləndz",
    "badly": "bædli",
    "badman": "bædmən",
    "badminton": "bædmɪntən",
    "badmouth": "bædməθ",
    "badmouthing": "bædməθɪŋ",
    "badness": "bædnəs",
    "bael": "beɪl",
    "baffle": "bæfəl",
    "baffled": "bæfəld",
    "bafflement": "bæfəlmənt",
    "baffles": "bæfəlz",
    "baffling": "bæflɪŋ",
    "bagasse": "bæɡæs",
    "bagatelle": "bæɡeɪtəl",
    "bag": "bæɡ",
    "bagel": "beɪɡəl",
    "bagels": "beɪɡəlz",
    "bagful": "bæɡfəl",
    "bagfuls": "bæɡfəlz",
    "baggage": "bæɡɪdʒ",
    "bagged": "bæɡd",
    "bagger": "bæɡɐ",
    "baggers": "bæɡəz",
    "baggie": "bæɡi",
    "baggier": "bæɡɪɐ",
    "baggies": "bæɡɪz",
    "baggiest": "bæɡɪəst",
    "bagginess": "bæɡɪnəs",
    "bagging": "bæɡɪŋ",
    "baggy": "bæɡi",
    "bagman": "bæɡmən",
    "bagpipe": "bæɡpaɪp",
    "bagpiper": "bæɡpɪpɐ",
    "bagpipers": "bæɡpɪpəz",
    "bagpipes": "bæɡpaɪps",
    "bags": "bæɡz",
    "baguette": "beɪɡt",
    "baguettes": "beɪɡts",
    "bahadur": "bæhɐdjɔː",
    "bah": "bɑː",
    "baht": "bɑːt",
    "bail": "beɪl",
    "bailed": "beɪld",
    "bailee": "beɪliː",
    "bailer": "beɪlɐ",
    "bailey": "beɪli",
    "baileys": "beɪlɪz",
    "bailie": "beɪli",
    "bailiff": "beɪlɪf",
    "bailiffs": "beɪlɪfs",
    "bailing": "beɪlɪŋ",
    "bailiwick": "beɪlɪwɪk",
    "bailout": "beɪlaʊt",
    "bailouts": "beɪlaʊts",
    "bails": "beɪlz",
    "bairn": "beən",
    "bairns": "beənz",
    "bait": "beɪt",
    "baited": "beɪtɪd",
    "baiter": "beɪtɐ",
    "baiting": "beɪtɪŋ",
    "baits": "beɪts",
    "baize": "beɪz",
    "bake": "beɪk",
    "baked": "beɪkt",
    "bakehouse": "beɪkhaʊs",
    "baker": "beɪkɐ",
    "bakeries": "beɪkərɪz",
    "bakers": "beɪkəz",
    "bakery": "beɪkəri",
    "bakes": "beɪks",
    "baking": "beɪkɪŋ",
    "baklava": "bæklɑːvɐ",
    "baksheesh": "bækʃiːʃ",
    "balaclava": "bælɐklɑːvɐ",
    "balaclavas": "bælɐklɑːvəz",
    "balalaika": "bælɐleɪkɐ",
    "balalaikas": "bælɐleɪkəz",
    "balance": "bæləns",
    "balanced": "bælənst",
    "balancer": "bælənsɐ",
    "balances": "bælənsɪz",
    "balancing": "bælənsɪŋ",
    "balboa": "bælbəʊɐ",
    "balbriggan": "bælbrɪɡən",
    "balconies": "bælkənɪz",
    "balcony": "bælkəni",
    "baldachin": "bɔːldɐtʃɪn",
    "bald": "bɔːld",
    "balder": "bɔːldɐ",
    "balderdash": "bɔːldədæʃ",
    "baldest": "bɔːldəst",
    "baldies": "bɔːldɪz",
    "balding": "bɔːldɪŋ",
    "baldly": "bɔːldli",
    "baldness": "bɔːldnəs",
    "balds": "bɔːldz",
    "baldy": "bɔːldi",
    "bale": "beɪl",
    "baled": "beɪld",
    "baleen": "bæliːn",
    "baleful": "beɪlfəl",
    "baler": "beɪlɐ",
    "bales": "beɪlz",
    "baling": "beɪlɪŋ",
    "balk": "bɔːlk",
    "balked": "bɔːlkt",
    "balking": "bɔːlkɪŋ",
    "balks": "bɔːlks",
    "ballad": "bæləd",
    "ballade": "bæleɪd",
    "balladeer": "bælɐdiə",
    "balladeers": "bælɐdiəz",
    "balladry": "bælædri",
    "ballads": "bælədz",
    "ballast": "bæləst",
    "ballasted": "bæləstɪd",
    "ball": "bɔːl",
    "ballboy": "bɔːlbɔɪ",
    "ballcock": "bɔːlkɒk",
    "balled": "bɔːld",
    "ballerina": "bæləriːnɐ",
    "ballerinas": "bæləriːnəz",
    "ballet": "bæleɪ",
    "balletic": "bælɛtɪk",
    "ballets": "bæleɪs",
    "ballgame": "bɔːlɡeɪm",
    "ballgown": "bɔːlɡaʊn",
    "ballgowns": "bɔːlɡaʊnz",
    "balling": "bɔːlɪŋ",
    "ballista": "bɐlɪstɐ",
    "ballistically": "bɐlɪstɪkli",
    "ballistic": "bɐlɪstɪk",
    "ballistics": "bɐlɪstɪks",
    "ballon": "bælən",
    "balloon": "bəluːn",
    "ballooned": "bəluːnd",
    "ballooning": "bəluːnɪŋ",
    "balloonist": "bæluːnɪst",
    "balloonists": "bæluːnɪsts",
    "balloons": "bəluːnz",
    "ballot": "bælət",
    "balloted": "bælətɪd",
    "balloting": "bælətɪŋ",
    "ballots": "bæləts",
    "ballpark": "bɔːlpɑːk",
    "ballplayer": "bɔːlpleɪɐ",
    "ballplayers": "bɔːlpleɪəz",
    "ballpoint": "bɔːlpɔɪnt",
    "ballpoints": "bɔːlpɔɪnts",
    "ballroom": "bɔːlruːm",
    "ballrooms": "bɔːlruːmz",
    "balls": "bɔːlz",
    "ballsed": "bɔːlzd",
    "ballsing": "bɔːlsɪŋ",
    "ballsy": "bɔːlsi",
    "bally": "bɔːli",
    "ballyhoo": "bælɪhuː",
    "balm": "bɑːm",
    "balms": "bɑːmz",
    "balmy": "bɑːmi",
    "baloney": "bələʊni",
    "balsa": "bɔːlsɐ",
    "balsam": "bɔːlsəm",
    "balsamic": "bɔːlsæmɪk",
    "baluster": "bælʌstɐ",
    "balusters": "bælʌstəz",
    "balustrade": "bæləstreɪd",
    "balustrades": "bæləstreɪdz",
    "bambino": "bæmbiːnəʊ",
    "bambinos": "bæmbiːnəʊz",
    "bamboos": "bæmbuːz",
    "bamboozle": "bæmbuːzəl",
    "bamboozled": "bæmbuːzəld",
    "bamboozling": "bæmbuːzlɪŋ",
    "banal": "beɪnəl",
    "banalities": "bænælɪtiz",
    "banality": "bænælɪti",
    "banana": "bɐnɑːnɐ",
    "bananas": "bɐnɑːnəz",
    "ban": "bæn",
    "banc": "bɑːnk",
    "bandage": "bændɪdʒ",
    "bandaged": "bændɪdʒd",
    "bandages": "bændɪdʒɪz",
    "bandaging": "bændɪdʒɪŋ",
    "bandaid": "bændeɪd",
    "bandana": "bændɑːnɐ",
    "bandanas": "bændɑːnəz",
    "bandanna": "bændænɐ",
    "bandannas": "bændænəz",
    "band": "bænd",
    "bandbox": "bændbɒks",
    "bandeau": "bændəʊ",
    "banded": "bændɪd",
    "bandicoot": "bændɪkuːt",
    "bandied": "bændɪd",
    "banding": "bændɪŋ",
    "bandit": "bændɪt",
    "banditry": "bændɪtri",
    "bandits": "bændɪts",
    "bandleader": "bændliːdɐ",
    "bandleaders": "bændliːdəz",
    "bandmaster": "bændmɑːstɐ",
    "bandolier": "bændəliɐ",
    "bandoliers": "bændəʊliəz",
    "bandsaw": "bændsɔː",
    "bands": "bændz",
    "bandsman": "bændzmən",
    "bandsmen": "bændzmɛn",
    "bandstand": "bændstænd",
    "bandstands": "bændstændz",
    "bandwagon": "bændwæɡən",
    "bandwagons": "bændwæɡənz",
    "bandwidth": "bændwɪdθ",
    "bandy": "bændi",
    "bandying": "bændɪɪŋ",
    "bane": "beɪn",
    "banes": "beɪnz",
    "bang": "bæŋ",
    "banged": "bæŋɡd",
    "banger": "bæŋɡɐ",
    "banging": "bæŋɪŋ",
    "bangle": "bæŋɡəl",
    "bangles": "bæŋɡəlz",
    "bangs": "bæŋz",
    "bani": "bæni",
    "banish": "bænɪʃ",
    "banished": "bænɪʃt",
    "banishes": "bænɪʃɪz",
    "banishing": "bænɪʃɪŋ",
    "banishment": "bænɪʃmənt",
    "banister": "bænɪstɐ",
    "banisters": "bænɪstəz",
    "banjo": "bændʒəʊ",
    "banjos": "bændʒəʊz",
    "bankable": "bæŋkəbəl",
    "bank": "bæŋk",
    "bankcard": "bæŋkkɑːd",
    "bankcards": "bæŋkkɑːdz",
    "banked": "bæŋkt",
    "banker": "bæŋkɐ",
    "bankers": "bæŋkəz",
    "banket": "bæŋkɪt",
    "banking": "bæŋkɪŋ",
    "banknote": "bænknəʊt",
    "banknotes": "bænknəʊts",
    "bankroll": "bæŋkrəʊl",
    "bankrolled": "bæŋkrəʊld",
    "bankrolling": "bæŋkrəʊlɪŋ",
    "bankrolls": "bæŋkrəʊlz",
    "bankrupt": "bæŋkrʌpt",
    "bankruptcies": "bæŋkrʌptsɪz",
    "bankruptcy": "bæŋkrʌptsi",
    "bankrupted": "bæŋkrʌptɪd",
    "bankrupting": "bæŋkrʌptɪŋ",
    "bankrupts": "bæŋkrʌpts",
    "banks": "bæŋks",
    "banksia": "bæŋksiə",
    "banlieue": "bænluː",
    "banned": "bænd",
    "banner": "bænɐ",
    "banners": "bænəz",
    "banning": "bænɪŋ",
    "bannister": "bænɪstɐ",
    "bannisters": "bænɪstəz",
    "bannock": "bænək",
    "bannocks": "bænəks",
    "banns": "bænz",
    "banquet": "bæŋkwɪt",
    "banqueting": "bænkwɪtɪŋ",
    "banquets": "bæŋkwɪts",
    "banquette": "bænkɛt",
    "banquettes": "bænkɛts",
    "bans": "bænz",
    "banshee": "bænʃiː",
    "banshees": "bænʃiːz",
    "bantam": "bɑːntæm",
    "bantams": "bɑːntæmz",
    "bantamweight": "bɑːntɐmweɪt",
    "bant": "bɑːnt",
    "banter": "bɑːntɐ",
    "bantered": "bɑːntəd",
    "bantering": "bɑːntərɪŋ",
    "banting": "bɑːntɪŋ",
    "banyan": "bænɪən",
    "banzai": "bænzaɪ",
    "baobab": "beɪəbæb",
    "baobabs": "beɪəbæbz",
    "bap": "bæp",
    "baps": "bæps",
    "baptise": "bæptaɪz",
    "baptised": "bæptaɪzd",
    "baptising": "bæptaɪzɪŋ",
    "baptismal": "bæptɪsməl",
    "baptism": "bæptɪzəm",
    "baptisms": "bæptɪzəmz",
    "baptist": "bæptɪst",
    "baptistery": "bæptɪstəri",
    "baptistry": "bæptɪstri",
    "baptists": "bæptɪsts",
    "barathea": "bærɐθiə",
    "bar": "bɑː",
    "barbarian": "bɑːbeəriən",
    "barbarians": "bɑːbeəriənz",
    "barbarically": "bɑːbærɪkli",
    "barbaric": "bɑːbærɪk",
    "barbarism": "bɑːbɑːrɪzəm",
    "barbarity": "bɑːbærɪti",
    "barbarous": "bɑːbærəs",
    "barbarously": "bɑːbɐrəsli",
    "barb": "bɑːb",
    "barbecue": "bɑːbɪkjuː",
    "barbecued": "bɑːbɪkjuːd",
    "barbecues": "bɑːbɪkjuːz",
    "barbecuing": "bɑːbɪkjuːɪŋ",
    "barbed": "bɑːbd",
    "barbel": "bɑːbəl",
    "barbell": "bɑːbɛl",
    "barbells": "bɑːbɛlz",
    "barbels": "bɑːbəlz",
    "barbeque": "bɑːbəkjuː",
    "barbequed": "bɑːbəkjuːd",
    "barbeques": "bɑːbəkjuːs",
    "barbequing": "bɑːbəkjuːɪŋ",
    "barber": "bɑːbɐ",
    "barbered": "bɑːbəd",
    "barbering": "bɑːbərɪŋ",
    "barberry": "bɑːbəri",
    "barbers": "bɑːbəz",
    "barbershop": "bɑːbəʃɒp",
    "barbet": "bɑːbɪt",
    "barbican": "bɑːbɪkən",
    "barbie": "bɑːbi",
    "barbies": "bɑːbɪz",
    "barbiturate": "bɑːbɪtʃɔːrət",
    "barbiturates": "bɑːbɪtʃɔːrəts",
    "barbs": "bɑːbz",
    "barcarole": "bɑːkərəʊl",
    "barcarolle": "bɑːkərəl",
    "barchan": "bɑːtʃən",
    "bard": "bɑːd",
    "bardic": "bɑːdɪk",
    "bards": "bɑːdz",
    "bareback": "beəbæk",
    "bare": "beə",
    "bared": "beəd",
    "barefaced": "beəfeɪst",
    "barefoot": "beəfʊt",
    "barefooted": "beəfʊtɪd",
    "bareheaded": "beəhɛdɪd",
    "barely": "beəli",
    "bareness": "beənəs",
    "barer": "beərɐ",
    "bares": "beəz",
    "barest": "beərəst",
    "barf": "bɑːf",
    "barfed": "bɑːft",
    "barfing": "bɑːfɪŋ",
    "barfly": "bɑːflaɪ",
    "bargain": "bɑːɡɪn",
    "bargained": "bɑːɡɪnd",
    "bargainer": "bɑːɡɪnɐ",
    "bargainers": "bɑːɡɪnəz",
    "bargaining": "bɑːɡɪnɪŋ",
    "bargains": "bɑːɡɪnz",
    "barge": "bɑːdʒ",
    "barged": "bɑːdʒd",
    "bargello": "bɑːdʒɛləʊ",
    "bargeman": "bɑːdʒɛmən",
    "bargemen": "bɑːdʒɪmɛn",
    "bargepole": "bɑːdʒɪpəʊl",
    "barges": "bɑːdʒɪz",
    "barging": "bɑːdʒɪŋ",
    "baric": "bærɪk",
    "baring": "beərɪŋ",
    "baritone": "bærɪtəʊn",
    "baritones": "bærɪtəʊnz",
    "barium": "beəriəm",
    "bark": "bɑːk",
    "barked": "bɑːkt",
    "barkeep": "bɑːkiːp",
    "barker": "bɑːkɐ",
    "barkers": "bɑːkəz",
    "barking": "bɑːkɪŋ",
    "barks": "bɑːks",
    "barley": "bɑːli",
    "barleycorn": "bɑːlɪkɔːn",
    "barmaid": "bɑːmeɪd",
    "barmaids": "bɑːmeɪdz",
    "barman": "bɑːmən",
    "barm": "bɑːm",
    "barmen": "bɑːmɛn",
    "barmier": "bɑːmɪɐ",
    "barmiest": "bɑːmɪəst",
    "barmy": "bɑːmi",
    "barnacle": "bɑːnəkəl",
    "barnacled": "bɑːnəkəld",
    "barnacles": "bɑːnəkəlz",
    "barn": "bɑːn",
    "barney": "bɑːni",
    "barneys": "bɑːnɪz",
    "barns": "bɑːnz",
    "barnstormer": "bɑːnstɔːmɐ",
    "barnstormers": "bɑːnstɔːməz",
    "barnstorming": "bɑːnstɔːmɪŋ",
    "barnyard": "bɑːnjɑːd",
    "barograph": "bærəɡræf",
    "barographs": "bærəɡræfz",
    "barometer": "bərɒmɪtɐ",
    "barometers": "bərɒmɪtəz",
    "barometric": "bærəʊmɛtrɪk",
    "baron": "bærən",
    "baroness": "bærəʊnəs",
    "baronesses": "bærəʊnəsɪz",
    "baronet": "bærənɛt",
    "baronetcy": "bærəʊntsi",
    "baronets": "bærənɛts",
    "baronial": "bærəʊnɪəl",
    "barons": "bærənz",
    "barony": "bærəni",
    "baroque": "bərəʊk",
    "barouche": "bæraʊtʃ",
    "barque": "bɑːk",
    "barques": "bɑːks",
    "barrack": "bærək",
    "barracked": "bærəkt",
    "barracking": "bærəkɪŋ",
    "barracks": "bærəks",
    "barracuda": "bærɐkjuːdɐ",
    "barracudas": "bærɐkjuːdəz",
    "barrage": "bærɑːʒ",
    "barraged": "bærɑːʒd",
    "barrages": "bærɑːʒɪz",
    "barrator": "bæreɪtɐ",
    "barratry": "bærətri",
    "barre": "bɑː",
    "barred": "bɑːd",
    "barrel": "bærəl",
    "barrelhead": "bærəlhɛd",
    "barrelled": "bærəld",
    "barrelling": "bærəlɪŋ",
    "barrels": "bærəlz",
    "barren": "bærən",
    "barrenness": "bærənnəs",
    "barrens": "bærənz",
    "barres": "bɑːz",
    "barret": "bærɪt",
    "barrette": "bærɛt",
    "barrettes": "bærɛts",
    "barricade": "bærɪkeɪd",
    "barricaded": "bærɪkeɪdɪd",
    "barricades": "bærɪkeɪdz",
    "barricading": "bærɪkeɪdɪŋ",
    "barrier": "bærɪɐ",
    "barriers": "bæriəz",
    "barring": "bɑːrɪŋ",
    "barrio": "bærɪəʊ",
    "barrios": "bærɪəʊz",
    "barrister": "bærɪstɐ",
    "barristers": "bærɪstəz",
    "barroom": "bæruːm",
    "barrow": "bærəʊ",
    "barrows": "bærəʊz",
    "bars": "bɑːz",
    "bartender": "bɑːtɛndɐ",
    "bartenders": "bɑːtɛndəz",
    "barter": "bɑːtɐ",
    "bartered": "bɑːtəd",
    "barterer": "bɑːtərɐ",
    "barterers": "bɑːtərəz",
    "bartering": "bɑːtərɪŋ",
    "barters": "bɑːtəz",
    "barton": "bɑːtən",
    "barye": "bɑːraɪ",
    "baryons": "bɑːrɪənz",
    "baryton": "bærɪtən",
    "basal": "beɪsəl",
    "basalt": "bæsɒlt",
    "basaltic": "bæsɒltɪk",
    "basalts": "bæsɒlts",
    "bascinet": "bæsɪnɛt",
    "bascule": "bæskjuːl",
    "bascules": "bæskjuːlz",
    "baseball": "beɪsbɔːl",
    "baseballs": "beɪsbɔːlz",
    "base": "beɪs",
    "based": "beɪst",
    "baseless": "beɪsləs",
    "baseline": "beɪslaɪn",
    "baselines": "beɪslaɪnz",
    "basely": "beɪsli",
    "baseman": "beɪsmən",
    "basement": "beɪsmənt",
    "basements": "beɪsmənts",
    "baseness": "beɪsnəs",
    "basenji": "beɪsndʒi",
    "baser": "beɪzɐ",
    "basest": "beɪsəst",
    "bash": "bæʃ",
    "bashed": "bæʃt",
    "basher": "bæʃɐ",
    "bashes": "bæʃɪz",
    "bashful": "bæʃfəl",
    "bashfully": "bæʃfəli",
    "bashfulness": "bæʃfəlnəs",
    "bashing": "bæʃɪŋ",
    "basically": "beɪsɪkli",
    "basic": "beɪsɪk",
    "basics": "beɪsɪks",
    "basil": "bæzəl",
    "basilica": "bæzɪlɪkɐ",
    "basilicas": "bæzɪlɪkəz",
    "basilisk": "bæzɪlɪsk",
    "basilisks": "bæzɪlɪsks",
    "basin": "beɪsən",
    "basinet": "beɪsɪnɛt",
    "basing": "beɪsɪŋ",
    "basins": "beɪsənz",
    "basis": "beɪsɪs",
    "bask": "bɑːsk",
    "basked": "bɑːskt",
    "basketball": "bɑːskɪtbɔːl",
    "basketballs": "bɑːskɪtbɔːlz",
    "basket": "bɑːskɪt",
    "basketful": "bɑːskɪtfəl",
    "basketry": "bɑːskɪtri",
    "baskets": "bɑːskɪts",
    "basketwork": "bɑːskɪtwɜːk",
    "basking": "bɑːskɪŋ",
    "basks": "bɑːsks",
    "basque": "bæsk",
    "basques": "bæsks",
    "basses": "beɪsɪz",
    "basset": "bæsɛt",
    "bassets": "bæsɛts",
    "bassinet": "bæsɪnɛt",
    "bassist": "beɪsɪst",
    "bassists": "beɪsɪsts",
    "basso": "bæsəʊ",
    "bassoon": "bæsuːn",
    "bassoonist": "bæsuːnɪst",
    "bassoons": "bæsuːnz",
    "bastard": "bɑːstəd",
    "bastardisation": "bɑːstədaɪzeɪʃən",
    "bastardised": "bɑːstədaɪzd",
    "bastards": "bɑːstədz",
    "bastardy": "bɑːstədi",
    "bast": "bɑːst",
    "baste": "beɪst",
    "basted": "bɑːstɪd",
    "baster": "bɑːstɐ",
    "basters": "bɑːstəz",
    "bastes": "beɪsts",
    "bastille": "bɑːstɪl",
    "basting": "bɑːstɪŋ",
    "bastion": "bæstiən",
    "bastions": "bæstiənz",
    "bat": "bæt",
    "batch": "bætʃ",
    "batched": "bætʃt",
    "batches": "bætʃɪz",
    "batching": "bætʃɪŋ",
    "bateau": "beɪtaʊ",
    "bate": "beɪt",
    "bated": "beɪtɪd",
    "bates": "beɪts",
    "batfish": "bætfɪʃ",
    "bath": "bɑːθ",
    "bathe": "beɪð",
    "bather": "beɪðɐ",
    "bathers": "beɪðəz",
    "bathes": "beɪðz",
    "bathetic": "beɪðɛtɪk",
    "bathhouse": "bɑːθhaʊs",
    "bathhouses": "bɑːθhaʊzɪz",
    "bathing": "beɪðɪŋ",
    "bathmat": "bɑːθmæt",
    "bathos": "bɑːθəʊz",
    "bathrobe": "bɑːθrəʊb",
    "bathrobes": "bɑːθrəʊbz",
    "bathroom": "bɑːθruːm",
    "bathrooms": "bɑːθruːmz",
    "bathtub": "bɑːθtʌb",
    "bathtubs": "bɑːθtʌbz",
    "bathwater": "bɑːθwɔːtɐ",
    "bathyscaphe": "bɑːθɪskæf",
    "batik": "bætɪk",
    "bating": "beɪtɪŋ",
    "batiste": "bætiːst",
    "baton": "bætən",
    "batons": "bætənz",
    "bats": "bæts",
    "batsman": "bætsmən",
    "batsmen": "bætsmɛn",
    "battalion": "bɐtæliən",
    "battalions": "bɐtæliənz",
    "batt": "bæt",
    "batted": "bætɪd",
    "batten": "bætən",
    "battened": "bætənd",
    "battening": "bætənɪŋ",
    "battens": "bætənz",
    "batter": "bætɐ",
    "battered": "bætəd",
    "batteries": "bætəriz",
    "battering": "bætərɪŋ",
    "batterings": "bætərɪŋz",
    "batters": "bætəz",
    "battery": "bætəri",
    "batting": "bætɪŋ",
    "battleaxe": "bætəlæks",
    "battleaxes": "bætəlæksɪz",
    "battle": "bætəl",
    "battled": "bætəld",
    "battledore": "bætəldɔː",
    "battledress": "bætəldrɛs",
    "battlefield": "bætəlfiːld",
    "battlefields": "bætəlfiːldz",
    "battlefront": "bætəlfrʌnt",
    "battleground": "bætəlɡraʊnd",
    "battlegrounds": "bætəlɡraʊndz",
    "battlement": "bætəlmənt",
    "battlements": "bætəlmənts",
    "battler": "bætlɐ",
    "battlers": "bætləz",
    "battles": "bætəlz",
    "battleship": "bætəlʃɪp",
    "battleships": "bætəlʃɪps",
    "battling": "bætlɪŋ",
    "batty": "bæti",
    "batwing": "bætwɪŋ",
    "bauble": "bɔːbəl",
    "baubles": "bɔːbəlz",
    "baud": "bɔːd",
    "bauds": "bɔːdz",
    "baulk": "bɔːk",
    "baulked": "bɔːkt",
    "baulks": "bɔːks",
    "bauxite": "bɔːksaɪt",
    "bawbees": "bɔːbiːz",
    "bawcock": "bɔːkɒk",
    "bawd": "bɔːd",
    "bawdier": "bɔːdɪɐ",
    "bawdiness": "bɔːdɪnəs",
    "bawdry": "bɔːdri",
    "bawds": "bɔːdz",
    "bawdy": "bɔːdi",
    "bawl": "bɔːl",
    "bawled": "bɔːld",
    "bawling": "bɔːlɪŋ",
    "bawls": "bɔːlz",
    "bayard": "beɪɑːd",
    "bay": "beɪ",
    "bayed": "beɪd",
    "baying": "beɪɪŋ",
    "bayonet": "beɪənɛt",
    "bayoneted": "beɪəʊniːtɪd",
    "bayoneting": "beɪəʊniːtɪŋ",
    "bayonets": "beɪənɛts",
    "bayou": "baɪuː",
    "bays": "beɪz",
    "bazaar": "bɐzɑː",
    "bazaars": "bɐzɑːz",
    "bazar": "bæzɑː",
    "bazillion": "bæzɪliən",
    "bazooka": "bɐzuːkɐ",
    "bazookas": "bɐzuːkəz",
    "b": "biː",
    "beach": "biːtʃ",
    "beachcomber": "biːtʃkɒmɐ",
    "beachcombers": "biːtʃkɒməz",
    "beachcombing": "biːtʃkəʊmɪŋ",
    "beached": "biːtʃt",
    "beaches": "biːtʃɪz",
    "beachfront": "biːtʃfrʌnt",
    "beachhead": "biːtʃhɛd",
    "beachheads": "biːtʃhɛdz",
    "beaching": "biːtʃɪŋ",
    "beachwear": "biːtʃweə",
    "beacon": "biːkən",
    "beacons": "biːkənz",
    "bead": "biːd",
    "beaded": "biːdɪd",
    "beading": "biːdɪŋ",
    "beadle": "biːdəl",
    "beadles": "biːdəlz",
    "beads": "biːdz",
    "beady": "biːdi",
    "beagle": "biːɡəl",
    "beagles": "biːɡəlz",
    "beak": "biːk",
    "beaked": "biːkt",
    "beaker": "biːkɐ",
    "beakers": "biːkəz",
    "beaks": "biːks",
    "beam": "biːm",
    "beamed": "biːmd",
    "beaming": "biːmɪŋ",
    "beams": "biːmz",
    "beamy": "biːmi",
    "beanbag": "biːnbæɡ",
    "beanbags": "biːnbæɡz",
    "bean": "biːn",
    "beanery": "biːnəri",
    "beanie": "biːni",
    "beanies": "biːnɪz",
    "beano": "biːnəʊ",
    "beanos": "biːnəʊz",
    "beanpole": "biːnpəʊl",
    "beanpoles": "biːnpəʊlz",
    "beans": "biːnz",
    "beansprout": "biːnspraʊt",
    "beansprouts": "biːnspraʊts",
    "beanstalk": "biːnstɔːk",
    "beanstalks": "biːnstɔːks",
    "bearable": "beərəbəl",
    "bear": "beə",
    "beard": "biəd",
    "bearded": "biədɪd",
    "bearding": "biədɪŋ",
    "beardless": "biədləs",
    "beards": "biədz",
    "bearer": "beərɐ",
    "bearers": "beərəz",
    "bearing": "beərɪŋ",
    "bearings": "beərɪŋz",
    "bearish": "beərɪʃ",
    "bears": "beəz",
    "bearskin": "beəskɪn",
    "bearskins": "beəskɪnz",
    "bearwood": "beəwʊd",
    "beast": "biːst",
    "beastliness": "biːstlinəs",
    "beastly": "biːstli",
    "beasts": "biːsts",
    "beatable": "biːtəbəl",
    "beat": "biːt",
    "beaten": "biːtən",
    "beater": "biːtɐ",
    "beaters": "biːtəz",
    "beatification": "biːætɪfɪkeɪʃən",
    "beatific": "biːɐtɪfɪk",
    "beatified": "biːætɪfaɪd",
    "beatify": "biːætɪfaɪ",
    "beating": "biːtɪŋ",
    "beatings": "biːtɪŋz",
    "beatitude": "biːætɪtjuːd",
    "beatitudes": "biːætɪtjuːdz",
    "beatnik": "biːtnɪk",
    "beatniks": "biːtnɪks",
    "beats": "biːts",
    "beau": "bəʊ",
    "beaus": "bəʊz",
    "beaut": "bjuːt",
    "beauteous": "bjuːtiəs",
    "beautician": "bjuːtɪʃən",
    "beauticians": "bjuːtɪʃənz",
    "beauties": "bjuːtɪz",
    "beautification": "bjuːtɪfɪkeɪʃən",
    "beautified": "bjuːtɪfaɪd",
    "beautiful": "bjuːtɪfəl",
    "beautifully": "bjuːtɪfəli",
    "beautify": "bjuːtɪfaɪ",
    "beautifying": "bjuːtɪfaɪɪŋ",
    "beauts": "bjuːts",
    "beauty": "bjuːti",
    "beaux": "bəʊ",
    "beaver": "biːvɐ",
    "beavered": "biːvəd",
    "beavering": "biːvərɪŋ",
    "beavers": "biːvəz",
    "be": "biː",
    "bebop": "bɪbɒp",
    "becalm": "bɪkɑːm",
    "becalmed": "bɪkɑːmd",
    "became": "bɪkeɪm",
    "because": "bɪkʌz",
    "beccafico": "bɛkæfɪkəʊ",
    "bechamel": "bɛtʃeɪməl",
    "beck": "bɛk",
    "becket": "bɛkɪt",
    "beckon": "bɛkən",
    "beckoned": "bɛkənd",
    "beckoning": "bɛkənɪŋ",
    "beckons": "bɛkənz",
    "becks": "bɛks",
    "become": "bɪkʌm",
    "becomes": "bɪkʌmz",
    "becoming": "bɪkʌmɪŋ",
    "becquerel": "bɛkwərəl",
    "bedazzle": "bɪdæzəl",
    "bedazzled": "bɪdæzəld",
    "bedazzling": "bɪdæzlɪŋ",
    "bed": "bɛd",
    "bedbug": "bɛdbʌɡ",
    "bedbugs": "bɛdbʌɡz",
    "bedchamber": "bɛdtʃeɪmbɐ",
    "bedchambers": "bɛdtʃeɪmbəz",
    "bedclothes": "bɛdkləʊðz",
    "bedcover": "bɛdkʌvɐ",
    "bedcovers": "bɛdkʌvəz",
    "bedded": "bɛdɪd",
    "bedder": "bɛdɐ",
    "bedders": "bɛdəz",
    "bedding": "bɛdɪŋ",
    "bedeck": "bɪdɛk",
    "bedecked": "bɪdɛkt",
    "bedevil": "bɪdɛvəl",
    "bedevilled": "bɪdɛvəld",
    "bedevils": "bɪdɛvəlz",
    "bedew": "bɪdjuː",
    "bedewed": "bɪdjuːd",
    "bedfellow": "bɛdfɪləʊ",
    "bedfellows": "bɛdfɪləʊz",
    "bedhead": "bɛdhɛd",
    "bedlam": "bɛdlæm",
    "bedlinen": "bɛdlaɪnən",
    "bedmate": "bɛdmeɪt",
    "bedouin": "bɛduːɪn",
    "bedpan": "bɛdpæn",
    "bedpans": "bɛdpænz",
    "bedpost": "bɛdpəʊst",
    "bedposts": "bɛdpəʊsts",
    "bedraggled": "bɪdræɡəld",
    "bedridden": "bɛdrɪdən",
    "bedrock": "bɛdrɒk",
    "bedrocks": "bɛdrɒks",
    "bedroll": "bɛdrəʊl",
    "bedroom": "bɛdruːm",
    "bedrooms": "bɛdruːmz",
    "beds": "bɛdz",
    "bedsheets": "bɛdʃiːts",
    "bedside": "bɛdsaɪd",
    "bedsides": "bɛdsaɪdz",
    "bedsit": "bɛdsɪt",
    "bedsits": "bɛdsɪts",
    "bedsitter": "bɛdsɪtɐ",
    "bedsores": "bɛdsɔːz",
    "bedspread": "bɛdsprɛd",
    "bedspreads": "bɛdsprɛdz",
    "bedsprings": "bɛdsprɪŋz",
    "bedstead": "bɛdstɛd",
    "bedsteads": "bɛdstɛdz",
    "bedstraw": "bɛdstrɔː",
    "bedtime": "bɛdtaɪm",
    "bedtimes": "bɛdtaɪmz",
    "bedwetting": "bɛdwɪtɪŋ",
    "bee": "biː",
    "beech": "biːtʃ",
    "beeches": "biːtʃɪz",
    "beechnuts": "biːtʃnʌts",
    "beechwood": "biːtʃwʊd",
    "beef": "biːf",
    "beefburger": "biːfbɜːɡɐ",
    "beefburgers": "biːfbɜːɡəz",
    "beefcake": "biːfkeɪk",
    "beefcakes": "biːfkeɪks",
    "beefeater": "biːfiːtɐ",
    "beefeaters": "biːfiːtəz",
    "beefed": "biːft",
    "beefier": "biːfɪɐ",
    "beefiest": "biːfɪəst",
    "beefiness": "biːfɪnəs",
    "beefing": "biːfɪŋ",
    "beefs": "biːfs",
    "beefsteak": "biːfsteɪk",
    "beefy": "biːfi",
    "beehive": "biːhaɪv",
    "beehives": "biːhaɪvz",
    "beekeeper": "biːkiːpɐ",
    "beekeepers": "biːkiːpəz",
    "beekeeping": "biːkiːpɪŋ",
    "beeline": "biːlaɪn",
    "been": "biːn",
    "beep": "biːp",
    "beeped": "biːpt",
    "beeper": "biːpɐ",
    "beepers": "biːpəz",
    "beeping": "biːpɪŋ",
    "beeps": "biːps",
    "beer": "biə",
    "beermat": "biəmæt",
    "beers": "biəz",
    "beery": "biəri",
    "bees": "biːz",
    "beeswax": "biːswɒks",
    "beet": "biːt",
    "beetle": "biːtəl",
    "beetled": "biːtəld",
    "beetles": "biːtəlz",
    "beetling": "biːtlɪŋ",
    "beetroot": "biːtruːt",
    "beetroots": "biːtruːts",
    "beets": "biːts",
    "beeves": "biːvz",
    "beezer": "biːzɐ",
    "befall": "bɪfɔːl",
    "befallen": "bɪfɔːlən",
    "befalling": "bɪfɔːlɪŋ",
    "befalls": "bɪfɔːlz",
    "befell": "bɪfɛl",
    "befit": "bɪfɪt",
    "befits": "bɪfɪts",
    "befitted": "bɪfɪtɪd",
    "befitting": "bɪfɪtɪŋ",
    "before": "bɪfɔː",
    "beforehand": "bɪfɔːhænd",
    "befoul": "bɪfaʊl",
    "befriend": "bɪfrɛnd",
    "befriended": "bɪfrɛndɪd",
    "befriending": "bɪfrɛndɪŋ",
    "befriends": "bɪfrɛndz",
    "befuddle": "bɪfʌdəl",
    "befuddled": "bɪfʌdəld",
    "befuddlement": "bɪfʌdəlmənt",
    "befuddling": "bɪfʌdlɪŋ",
    "began": "bɪɡæn",
    "begat": "bɪɡæt",
    "beg": "bɛɡ",
    "beget": "bɪɡɛt",
    "begets": "bɪɡɛts",
    "begetter": "bɪɡɛtɐ",
    "begetting": "bɪɡɛtɪŋ",
    "beggar": "bɛɡɐ",
    "beggared": "bɛɡəd",
    "beggars": "bɛɡəz",
    "beggary": "bɛɡəri",
    "begged": "bɛɡd",
    "begging": "bɛɡɪŋ",
    "begin": "bɪɡɪn",
    "beginner": "bɪɡɪnɐ",
    "beginners": "bɪɡɪnəz",
    "beginning": "bɪɡɪnɪŋ",
    "beginnings": "bɪɡɪnɪŋz",
    "begins": "bɪɡɪnz",
    "begone": "bɪɡɒn",
    "begonia": "bɪɡəʊniə",
    "begonias": "bɪɡəʊniəz",
    "begorra": "bɪɡɒrɐ",
    "begot": "bɪɡɒt",
    "begotten": "bɪɡɒtən",
    "begrudge": "bɪɡrʌdʒ",
    "begrudged": "bɪɡrʌdʒd",
    "begrudges": "bɪɡrʌdʒɪz",
    "begrudging": "bɪɡrʌdʒɪŋ",
    "begrudgingly": "bɪɡrʌdʒɪŋli",
    "begs": "bɛɡz",
    "beguile": "bɪɡaɪl",
    "beguiled": "bɪɡaɪld",
    "beguiles": "bɪɡaɪlz",
    "beguiling": "bɪɡaɪlɪŋ",
    "beguilingly": "bɪɡaɪlɪŋli",
    "beguine": "bɪɡwaɪn",
    "begum": "bɪɡʌm",
    "begun": "bɪɡʌn",
    "behalf": "bɪhɑːf",
    "behalves": "bɪhɑːvz",
    "behave": "bɪheɪv",
    "behaved": "bɪheɪvd",
    "behaves": "bɪheɪvz",
    "behaving": "bɪheɪvɪŋ",
    "behavioral": "bɪheɪvjərəl",
    "behavior": "bɪheɪvjɐ",
    "behavioural": "bɪheɪvjərəl",
    "behaviourally": "bɪheɪvjərəli",
    "behaviour": "bɪheɪvjɐ",
    "behaviourism": "bɪheɪvjərərɪzəm",
    "behaviourist": "bɪheɪvjərɪst",
    "behaviourists": "bɪheɪvjərɪsts",
    "behaviours": "bɪheɪvjəz",
    "behead": "bɪhɛd",
    "beheaded": "bɪhɛdɪd",
    "beheading": "bɪhɛdɪŋ",
    "beheld": "bɪhɛld",
    "behemoth": "bɪhiːmɒθ",
    "behemoths": "bɪhiːmɒθs",
    "behest": "bɪhɛst",
    "behind": "bɪhaɪnd",
    "behinds": "bɪhaɪndz",
    "behold": "bɪhəʊld",
    "beholden": "bɪhəʊldən",
    "beholder": "bɪhəʊldɐ",
    "beholders": "bɪhəʊldəz",
    "beholding": "bɪhəʊldɪŋ",
    "beholds": "bɪhəʊldz",
    "behove": "bɪhəʊv",
    "behoves": "bɪhəʊvz",
    "beige": "beɪʒ",
    "being": "biːɪŋ",
    "beings": "biːɪŋz",
    "bejewel": "bɪdʒuːəl",
    "bejewelled": "bɪdʒuːəld",
    "belabour": "bɪleɪbɐ",
    "belaboured": "bɪleɪbəd",
    "belated": "bɪleɪtɪd",
    "belatedly": "bɪleɪtɪdli",
    "belay": "bɪleɪ",
    "belayed": "bɪleɪd",
    "belaying": "bɪleɪɪŋ",
    "belch": "bɛltʃ",
    "belched": "bɛltʃt",
    "belches": "bɛltʃɪz",
    "belching": "bɛltʃɪŋ",
    "beldam": "bɛldəm",
    "beleaguer": "bɪliːɡɐ",
    "beleaguered": "bɪliːɡəd",
    "belemnite": "bɪlɛmnaɪt",
    "belemnites": "bɪlɛmnaɪts",
    "belfries": "bɛlfrɪz",
    "belfry": "bɛlfri",
    "belie": "bɪlaɪ",
    "belied": "bɪlaɪd",
    "belief": "bɪliːf",
    "beliefs": "bɪliːfs",
    "belies": "bɪlaɪz",
    "believability": "bɪliːvəbɪlɪti",
    "believable": "bɪliːvəbəl",
    "believably": "bɪliːvəbli",
    "believe": "bɪliːv",
    "believed": "bɪliːvd",
    "believer": "bɪliːvɐ",
    "believers": "bɪliːvəz",
    "believes": "bɪliːvz",
    "believing": "bɪliːvɪŋ",
    "belike": "bɪlaɪk",
    "belittle": "bɪlɪtəl",
    "belittled": "bɪlɪtəld",
    "belittles": "bɪlɪtəlz",
    "belittling": "bɪlɪtlɪŋ",
    "belladonna": "bɛlɐdɒnɐ",
    "bellarmine": "bɛlɑːmaɪn",
    "bell": "bɛl",
    "bellbottom": "bɛlbɒtəm",
    "bellboy": "bɛlbɔɪ",
    "bellboys": "bɛlbɔɪz",
    "belle": "bɛl",
    "belled": "bɛld",
    "belles": "bɛlz",
    "bellflower": "bɛlflaʊɐ",
    "bellflowers": "bɛlflaʊəz",
    "bellhop": "bɛlhɒp",
    "bellicose": "bɛlɪkəʊs",
    "bellicosity": "bɛlɪkɒsɪti",
    "bellied": "bɛlɪd",
    "bellies": "bɛlɪz",
    "belligerence": "bɪlɪdʒrəns",
    "belligerent": "bɪlɪdʒrənt",
    "belligerents": "bɪlɪdʒrənts",
    "belling": "bɛlɪŋ",
    "bellman": "bɛlmən",
    "bellow": "bɛləʊ",
    "bellowed": "bɛləʊd",
    "bellowing": "bɛləʊɪŋ",
    "bellows": "bɛləʊz",
    "bells": "bɛlz",
    "bellwether": "bɛlwɛðɐ",
    "bellyache": "bɛlɪeɪk",
    "bellyaching": "bɛlɪeɪkɪŋ",
    "belly": "bɛli",
    "bellybutton": "bɛlɪbʌtən",
    "bellybuttons": "bɛlɪbʌtənz",
    "bellyful": "bɛlɪfəl",
    "bellying": "bɛlɪɪŋ",
    "belong": "bɪlɒŋ",
    "belonged": "bɪlɒŋd",
    "belonging": "bɪlɒŋɪŋ",
    "belongings": "bɪlɒŋɪŋz",
    "belongs": "bɪlɒŋz",
    "beloveds": "bɪlʌvdz",
    "below": "bɪləʊ",
    "belt": "bɛlt",
    "belted": "bɛltɪd",
    "belting": "bɛltɪŋ",
    "beltings": "bɛltɪŋz",
    "belts": "bɛlts",
    "beltway": "bɛltweɪ",
    "beluga": "bɪluːɡɐ",
    "belugas": "bɪluːɡəz",
    "belvedere": "bɛlvɪdiə",
    "belvederes": "bɛlvɪdiəz",
    "belying": "bɪlaɪɪŋ",
    "bemoan": "bɪməʊn",
    "bemoaned": "bɪməʊnd",
    "bemoaning": "bɪməʊnɪŋ",
    "bemoans": "bɪməʊnz",
    "bemuse": "bɪmjuːz",
    "bemused": "bɪmjuːzd",
    "bemusement": "bɪmjuːzmənt",
    "bemuses": "bɪmjuːzɪz",
    "bemusing": "bɪmjuːzɪŋ",
    "ben": "bɛn",
    "bench": "bɛntʃ",
    "benched": "bɛntʃt",
    "bencher": "bɛntʃɐ",
    "benches": "bɛntʃɪz",
    "benching": "bɛntʃɪŋ",
    "benchmark": "bɛntʃmɑːk",
    "benchmarking": "bɛntʃmɑːkɪŋ",
    "benchmarks": "bɛntʃmɑːks",
    "benchwarmer": "bɛntʃwɔːmɐ",
    "bendable": "bɛndəbəl",
    "bend": "bɛnd",
    "bended": "bɛndɪd",
    "bender": "bɛndɐ",
    "benders": "bɛndəz",
    "bendiest": "bɛndɪəst",
    "bending": "bɛndɪŋ",
    "bends": "bɛndz",
    "bendy": "bɛndi",
    "beneath": "bɪniːθ",
    "benedict": "bɛnɪdɪkt",
    "benedictine": "bɛnɪdɪktiːn",
    "benediction": "bɛnɪdɪkʃən",
    "benedicts": "bɛnɪdɪkts",
    "benefaction": "bɛnɪfækʃən",
    "benefactions": "bɛnɪfækʃənz",
    "benefactor": "bɛnɪfæktɐ",
    "benefactors": "bɛnɪfæktəz",
    "benefactress": "bɛnɪfæktrəs",
    "beneficence": "bɛnɪfɪsəns",
    "beneficent": "bɛnɪfɪsənt",
    "beneficial": "bɛnɪfɪʃəl",
    "beneficially": "bɛnɪfɪʃəli",
    "beneficiaries": "bɛnɪfɪʃərɪz",
    "beneficiary": "bɛnɪfɪʃəri",
    "benefit": "bɛnɪfɪt",
    "benefited": "bɛnɪfɪtɪd",
    "benefiting": "bɛnɪfɪtɪŋ",
    "benefits": "bɛnɪfɪts",
    "benefitted": "bɛnɪfɪtɪd",
    "benefitting": "bɛnɪfɪtɪŋ",
    "benevolence": "bənɛvələns",
    "benevolent": "bənɛvələnt",
    "benevolently": "bənɛvələntli",
    "benighted": "bɪnaɪtɪd",
    "benign": "bɪnaɪn",
    "benignly": "bɪnaɪnli",
    "benison": "bɪnɪsən",
    "benjamin": "bɛndʒəmɪn",
    "benjamins": "bɛndʒəmɪnz",
    "bennet": "bɛnɪt",
    "bennets": "bɛnɪts",
    "benny": "bɛni",
    "bens": "bɛnz",
    "bent": "bɛnt",
    "benthic": "bɛnθɪk",
    "benthos": "bɛnθəʊz",
    "bents": "bɛnts",
    "bentwood": "bɛntwʊd",
    "benumbed": "bɪnʌmd",
    "benzene": "bɛnziːn",
    "benzine": "bɛnziːn",
    "benzoate": "bɛnzəʊt",
    "benzocaine": "bɛnzəkeɪn",
    "benzoyl": "bɛnzɔɪl",
    "benzyl": "bɛnzɪl",
    "bequeath": "bɪkwiːθ",
    "bequeathed": "bɪkwiːðd",
    "bequeathing": "bɪkwiːðɪŋ",
    "bequeaths": "bɪkwiːθs",
    "bequest": "bɪkwɛst",
    "bequests": "bɪkwɛsts",
    "berate": "bɪreɪt",
    "berated": "bɪreɪtɪd",
    "berates": "bɪreɪts",
    "berating": "bɪreɪtɪŋ",
    "berceuse": "bɜːsɜːz",
    "bereave": "bɪriːv",
    "bereaved": "bɪriːvd",
    "bereavement": "bɪriːvmənt",
    "bereavements": "bɪriːvmənts",
    "bereft": "bɪrɛft",
    "beret": "bɪreɪ",
    "berets": "bɪreɪs",
    "bergamot": "bɜːɡɐmɒt",
    "berg": "bɜːɡ",
    "bergs": "bɜːɡz",
    "beriberi": "bɛrɪbɛri",
    "berk": "bɜːk",
    "berkelium": "bɜːkiːliəm",
    "berks": "bɜːks",
    "berlin": "bɜːlɪn",
    "berlins": "bɜːlɪnz",
    "berm": "bɜːm",
    "berms": "bɜːmz",
    "bermudas": "bɜːmjuːdəz",
    "berried": "bɛrɪd",
    "berries": "bɛrɪz",
    "berry": "bɛri",
    "berserk": "bəsɜːk",
    "berserker": "bəsɜːkɐ",
    "bertha": "bɜːθɐ",
    "berth": "bɜːθ",
    "berthed": "bɜːθd",
    "berthing": "bɜːθɪŋ",
    "berths": "bɜːθs",
    "beryl": "bɛrəl",
    "beryllium": "bɜːrɪliəm",
    "beseech": "bɪsiːtʃ",
    "beseeched": "bɪsiːtʃt",
    "beseeching": "bɪsiːtʃɪŋ",
    "beset": "bɪsɛt",
    "besets": "bɪsɛts",
    "besetting": "bɪsɛtɪŋ",
    "beshrew": "bɪʃruː",
    "beside": "bɪsaɪd",
    "besides": "bɪsaɪdz",
    "besiege": "bɪsiːdʒ",
    "besieged": "bɪsiːdʒd",
    "besiegers": "bɪsiːdʒəz",
    "besieging": "bɪsiːdʒɪŋ",
    "besmear": "bɪsmiə",
    "besmeared": "bɪsmiəd",
    "besmirch": "bɪsmɜːtʃ",
    "besmirched": "bɪsmɜːtʃt",
    "besmirching": "bɪsmɜːtʃɪŋ",
    "besom": "bɪsɒm",
    "besoms": "bɪsɒmz",
    "besotted": "bɪsɒtɪd",
    "bespeak": "bɪspiːk",
    "bespeaking": "bɪspiːkɪŋ",
    "bespeaks": "bɪspiːks",
    "bespectacled": "bɪspɛktəkəld",
    "bespoke": "bɪspəʊk",
    "best": "bɛst",
    "bestial": "bɛstjəl",
    "bestiality": "bɛstɪælɪti",
    "bestiaries": "bɛsʃjərɪz",
    "bestiary": "bɛsʃjəri",
    "besting": "bɛstɪŋ",
    "bestirred": "bɪstɜːd",
    "bestow": "bɪstəʊ",
    "bestowed": "bɪstəʊd",
    "bestowing": "bɪstəʊɪŋ",
    "bestows": "bɪstəʊz",
    "bestride": "bɪstraɪd",
    "bestrides": "bɪstraɪdz",
    "bestriding": "bɪstraɪdɪŋ",
    "bestrode": "bɪstrəʊd",
    "bests": "bɛsts",
    "bestseller": "bɛstsɛlɐ",
    "bestsellers": "bɛstsɛləz",
    "bestselling": "bɛstsɛlɪŋ",
    "beta": "biːtɐ",
    "betake": "bɪteɪk",
    "betas": "biːtəz",
    "bet": "bɛt",
    "betcha": "bɛtʃɐ",
    "betel": "bɪtɛl",
    "beth": "bɛθ",
    "bethel": "bɛθəl",
    "bethink": "bɛθɪŋk",
    "bethought": "bɛθɔːt",
    "betide": "bɪtaɪd",
    "betimes": "bɪtaɪmz",
    "betoken": "bɪtəʊkən",
    "betony": "bɪtɒni",
    "betrayal": "bɪtreɪəl",
    "betrayals": "bɪtreɪəlz",
    "betray": "bɪtreɪ",
    "betrayed": "bɪtreɪd",
    "betrayer": "bɪtreɪɐ",
    "betrayers": "bɪtreɪəz",
    "betraying": "bɪtreɪɪŋ",
    "betrays": "bɪtreɪz",
    "betrothal": "bɪtrəʊðəl",
    "betrothed": "bɪtrəʊðd",
    "bets": "bɛts",
    "betta": "bɛtɐ",
    "betted": "bɛtɪd",
    "better": "bɛtɐ",
    "bettered": "bɛtəd",
    "bettering": "bɛtərɪŋ",
    "betterment": "bɛtəmənt",
    "betters": "bɛtəz",
    "betting": "bɛtɪŋ",
    "bettors": "bɛtəz",
    "between": "bɪtwiːn",
    "betwixt": "bɪtwɪkst",
    "bevel": "bɛvəl",
    "beveled": "bɛvəld",
    "bevelled": "bɛvəld",
    "bevelling": "bɛvəlɪŋ",
    "beverage": "bɛvərɪdʒ",
    "beverages": "bɛvərɪdʒɪz",
    "bevvies": "bɛvɪz",
    "bevvy": "bɛvi",
    "bevy": "bɛvi",
    "bewail": "bɪweɪl",
    "bewailing": "bɪweɪlɪŋ",
    "beware": "bɪweə",
    "bewaring": "bɪweərɪŋ",
    "bewhiskered": "bɪwɪskəd",
    "bewilder": "bɪwɪldɐ",
    "bewildered": "bɪwɪldəd",
    "bewildering": "bɪwɪldərɪŋ",
    "bewilderingly": "bɪwɪldərɪŋli",
    "bewilderment": "bɪwɪldəmənt",
    "bewilders": "bɪwɪldəz",
    "bewitch": "bɪwɪtʃ",
    "bewitched": "bɪwɪtʃt",
    "bewitches": "bɪwɪtʃɪz",
    "bewitching": "bɪwɪtʃɪŋ",
    "bey": "beɪ",
    "beyond": "bɪjɒnd",
    "bezel": "bɛzəl",
    "bezique": "bɛziːk",
    "bezoar": "bɛzɔː",
    "bhaji": "bɑːdʒi",
    "biannual": "baɪænjuːəl",
    "bias": "baɪəs",
    "biased": "baɪəst",
    "biases": "baɪəsɪz",
    "biasing": "baɪəsɪŋ",
    "biathlon": "baɪəθlɒn",
    "bi": "baɪ",
    "bib": "bɪb",
    "bible": "baɪbəl",
    "bibles": "baɪbəlz",
    "biblical": "bɪblɪkəl",
    "bibliographical": "bɪblɪəɡræfɪkəl",
    "bibliography": "bɪblɪɒɡrəfi",
    "bibliophile": "bɪblɪɒfaɪl",
    "bibliophiles": "bɪblɪɒfaɪlz",
    "bibs": "bɪbz",
    "bibulous": "baɪbjʊləs",
    "bicameral": "baɪkæmrəl",
    "bicarb": "bɪkɑːb",
    "bicarbonate": "baɪkɑːbəneɪt",
    "bice": "baɪs",
    "bicentenary": "baɪsɪntiːnəri",
    "bicentennial": "baɪsɪntɛnɪəl",
    "bicep": "baɪsəp",
    "biceps": "baɪsəps",
    "bicker": "bɪkɐ",
    "bickered": "bɪkəd",
    "bickering": "bɪkərɪŋ",
    "bickers": "bɪkəz",
    "bicolour": "baɪkʌlɐ",
    "bicorn": "bɪkɔːn",
    "bicuspid": "baɪkʌspɪd",
    "bicuspids": "baɪkʌspɪdz",
    "bicycle": "baɪsɪkəl",
    "bicycled": "baɪsɪkəld",
    "bicycles": "baɪsɪkəlz",
    "bicycling": "baɪsɪklɪŋ",
    "bicyclist": "baɪsɪklɪst",
    "bicyclists": "baɪsɪklɪsts",
    "bid": "bɪd",
    "biddable": "bɪdəbəl",
    "bidden": "bɪdən",
    "bidder": "bɪdɐ",
    "bidders": "bɪdəz",
    "biddies": "bɪdɪz",
    "bidding": "bɪdɪŋ",
    "biddy": "bɪdi",
    "bide": "baɪd",
    "bided": "baɪdɪd",
    "bides": "baɪdz",
    "bidet": "biːdeɪ",
    "bidets": "biːdeɪs",
    "biding": "baɪdɪŋ",
    "bids": "bɪdz",
    "biennial": "baɪɛnɪəl",
    "biennials": "baɪɛnɪəlz",
    "bier": "biə",
    "biers": "biəz",
    "biff": "bɪf",
    "biffed": "bɪft",
    "biffing": "bɪfɪŋ",
    "biffs": "bɪfs",
    "bifocal": "baɪfəʊkəl",
    "bifocals": "baɪfəʊkəlz",
    "bifurcated": "baɪfɜːkeɪtɪd",
    "bifurcating": "baɪfɜːkeɪtɪŋ",
    "bifurcation": "baɪfəkeɪʃən",
    "bigamist": "bɪɡɐmɪst",
    "bigamists": "bɪɡɐmɪsts",
    "bigamous": "bɪɡɐməs",
    "bigamy": "bɪɡæmi",
    "big": "bɪɡ",
    "bigfoot": "bɪɡfʊt",
    "bigger": "bɪɡɐ",
    "biggest": "bɪɡəst",
    "biggie": "bɪɡi",
    "biggies": "bɪɡɪz",
    "biggin": "bɪɡɪn",
    "biggins": "bɪɡɪnz",
    "biggish": "bɪɡɪʃ",
    "bighead": "bɪɡhɛd",
    "bigheads": "bɪɡhɛdz",
    "bighorn": "bɪɡhɔːn",
    "bight": "baɪt",
    "bigmouth": "bɪɡməθ",
    "bigness": "bɪɡnəs",
    "bigot": "bɪɡət",
    "bigoted": "bɪɡətɪd",
    "bigotries": "bɪɡətrɪz",
    "bigotry": "bɪɡətri",
    "bigots": "bɪɡəts",
    "bigshot": "bɪɡʃɒt",
    "bigwig": "bɪɡwɪɡ",
    "bigwigs": "bɪɡwɪɡz",
    "bijou": "biːʒuː",
    "bijouterie": "baɪdʒaʊtəri",
    "bijoux": "bɪdʒuː",
    "bike": "baɪk",
    "biked": "baɪkt",
    "biker": "baɪkɐ",
    "bikers": "baɪkəz",
    "bikes": "baɪks",
    "bikeway": "baɪkweɪ",
    "biking": "baɪkɪŋ",
    "bikini": "bɪkiːni",
    "bikinis": "bɪkiːniz",
    "bilateral": "baɪlætərəl",
    "bilaterally": "baɪlætərəli",
    "bilberries": "bɪlbərɪz",
    "bilberry": "bɪlbəri",
    "bilbo": "bɪlbəʊ",
    "bile": "baɪl",
    "bilge": "bɪldʒ",
    "bilges": "bɪldʒɪz",
    "biliary": "baɪlaɪəri",
    "bilingual": "baɪlɪŋɡwəl",
    "bilingualism": "baɪlɪŋɡjuːəlɪzəm",
    "bilingually": "baɪlɪŋɡwəli",
    "bilious": "bɪlɪəs",
    "bilk": "bɪlk",
    "bilked": "bɪlkt",
    "bilkers": "bɪlkəz",
    "bilking": "bɪlkɪŋ",
    "billable": "bɪləbəl",
    "billabong": "bɪlɐbɒŋ",
    "bill": "bɪl",
    "billboard": "bɪlbɔːd",
    "billboards": "bɪlbɔːdz",
    "billed": "bɪld",
    "billet": "bɪlɪt",
    "billeted": "bɪliːtɪd",
    "billeting": "bɪliːtɪŋ",
    "billets": "bɪlɪts",
    "billfold": "bɪlfəʊld",
    "billhook": "bɪlhʊk",
    "billhooks": "bɪlhʊks",
    "billiard": "bɪlɪəd",
    "billiards": "bɪlɪədz",
    "billies": "bɪliz",
    "billing": "bɪlɪŋ",
    "billings": "bɪlɪŋz",
    "billingsgate": "bɪlɪŋsɡeɪt",
    "billionaire": "bɪliəneə",
    "billionaires": "bɪliəneəz",
    "billion": "bɪliən",
    "billions": "bɪliənz",
    "billionth": "bɪliənθ",
    "billionths": "bɪliənθs",
    "billow": "bɪləʊ",
    "billowed": "bɪləʊd",
    "billowing": "bɪləʊɪŋ",
    "billows": "bɪləʊz",
    "billowy": "bɪləʊi",
    "bills": "bɪlz",
    "billy": "bɪli",
    "billycan": "bɪlɪkən",
    "billycock": "bɪlɪkɒk",
    "biltong": "bɪltɒŋ",
    "bimbo": "bɪmbəʊ",
    "bimbos": "bɪmbəʊz",
    "bimetallic": "baɪmɪtælɪk",
    "binaries": "baɪnəriz",
    "binary": "baɪnəri",
    "bin": "bɪn",
    "bind": "baɪnd",
    "binder": "baɪndɐ",
    "binders": "baɪndəz",
    "bindery": "baɪndəri",
    "binding": "baɪndɪŋ",
    "bindings": "baɪndɪŋz",
    "bindle": "baɪndəl",
    "binds": "baɪndz",
    "bindweed": "baɪndwiːd",
    "bine": "baɪn",
    "bines": "baɪnz",
    "binge": "bɪndʒ",
    "binged": "bɪndʒd",
    "bingeing": "bɪndʒɪŋ",
    "binger": "bɪndʒɐ",
    "binges": "bɪndʒɪz",
    "binging": "bɪŋɪŋ",
    "bingle": "bɪŋɡəl",
    "bingo": "bɪŋɡəʊ",
    "binman": "bɪnmæn",
    "binmen": "bɪnmɛn",
    "binnacle": "bɪnəkəl",
    "binned": "bɪnd",
    "binning": "bɪnɪŋ",
    "binocular": "bɪnɒkjʊlɐ",
    "binoculars": "bɪnɒkjʊləz",
    "binomial": "baɪnəʊmɪəl",
    "bins": "bɪnz",
    "biochemical": "baɪəʊkɛmɪkəl",
    "biochemically": "baɪəʊkɛmɪkli",
    "biochemist": "baɪəʊkɛmɪst",
    "biochemistry": "baɪəʊkɛmɪstri",
    "biochemists": "baɪəʊkɛmɪsts",
    "biodegradable": "baɪəʊdɪɡreɪdəbəl",
    "biodegradation": "baɪəʊdɪɡrɐdeɪʃən",
    "biodegrade": "baɪəʊdɪɡreɪd",
    "biodegrades": "baɪəʊdɪɡreɪdz",
    "biodiversity": "baɪəʊdaɪvɜːsɪti",
    "bioengineering": "baɪəʊɛndʒɪniərɪŋ",
    "bioethics": "baɪəʊɛθɪks",
    "biofeedback": "baɪəʊfiːdbæk",
    "biogas": "baɪəʊɡæs",
    "biographer": "baɪɒɡrəfɐ",
    "biographers": "baɪɒɡrəfəz",
    "biographical": "baɪəɡræfɪkəl",
    "biographies": "baɪɒɡrəfɪz",
    "biography": "baɪɒɡrəfi",
    "biological": "baɪəlɒdʒɪkəl",
    "biologically": "baɪəlɒdʒɪkli",
    "biologic": "baɪəlɒdʒɪk",
    "biologist": "baɪɒlədʒɪst",
    "biologists": "baɪɒlədʒɪsts",
    "biology": "baɪɒlədʒi",
    "bioluminescence": "baɪəʊluːmɪnɛsəns",
    "biomass": "baɪəʊmæs",
    "biome": "baɪəʊm",
    "biomechanical": "baɪəʊmɪkænɪkəl",
    "biomechanics": "baɪəʊmɪkænɪks",
    "biomedical": "baɪəʊmɛdɪkəl",
    "biomedicine": "baɪəʊmɛdsən",
    "biometric": "baɪəʊmɛtrɪk",
    "biometrics": "baɪəʊmɛtrɪks",
    "bionic": "baɪɒnɪk",
    "bionics": "baɪɒnɪks",
    "biophysics": "baɪəʊfɪzɪks",
    "biopic": "baɪəʊpɪk",
    "biopics": "baɪəʊpɪks",
    "biopsies": "baɪɒpsɪz",
    "biopsy": "baɪɒpsi",
    "biorhythms": "baɪəʊrɪðəmz",
    "bios": "baɪəʊz",
    "bioscope": "baɪəskəʊp",
    "biosphere": "baɪəʊsfiə",
    "biospheres": "baɪəʊsfiəz",
    "biotech": "baɪəʊtɛk",
    "biotechnology": "baɪəʊtɛknɒlədʒi",
    "biotic": "baɪɒtɪk",
    "bipartisan": "baɪpɑːtɪsən",
    "bipartisanship": "baɪpɑːtɪsənʃɪp",
    "bipedal": "baɪpiːdəl",
    "bipedalism": "baɪpiːdəlɪzəm",
    "biped": "baɪpɛd",
    "bipeds": "baɪpɛdz",
    "biplane": "baɪpleɪn",
    "biplanes": "baɪpleɪnz",
    "bipod": "bɪpɒd",
    "bipolar": "baɪpəʊlɐ",
    "biracial": "baɪreɪʃəl",
    "birch": "bɜːtʃ",
    "birched": "bɜːtʃt",
    "birches": "bɜːtʃɪz",
    "birching": "bɜːtʃɪŋ",
    "birdbath": "bɜːdbɑːθ",
    "bird": "bɜːd",
    "birdbrain": "bɜːdbreɪn",
    "birdbrains": "bɜːdbreɪnz",
    "birdcage": "bɜːdkeɪdʒ",
    "birdcages": "bɜːdkeɪdʒz",
    "birder": "bɜːdɐ",
    "birders": "bɜːdəz",
    "birdhouse": "bɜːdhaʊs",
    "birdie": "bɜːdi",
    "birdied": "bɜːdɪd",
    "birdieing": "bɜːdiɪŋ",
    "birdies": "bɜːdɪz",
    "birding": "bɜːdɪŋ",
    "birdlike": "bɜːdlaɪk",
    "birdman": "bɜːdmən",
    "birds": "bɜːdz",
    "birdseed": "bɜːdsiːd",
    "birdsong": "bɜːdsɒŋ",
    "birdwatcher": "bɜːdwɒtʃɐ",
    "birdwatchers": "bɜːdwɒtʃəz",
    "birdwatching": "bɜːdwɒtʃɪŋ",
    "birdying": "bɜːdɪɪŋ",
    "biretta": "baɪrɛtɐ",
    "birl": "bɜːl",
    "birling": "bɜːlɪŋ",
    "birr": "bɜː",
    "birth": "bɜːθ",
    "birthday": "bɜːθdeɪ",
    "birthdays": "bɜːθdeɪz",
    "birthed": "bɜːθd",
    "birthing": "bɜːθɪŋ",
    "birthmark": "bɜːθmɑːk",
    "birthmarks": "bɜːθmɑːks",
    "birthplace": "bɜːθpleɪs",
    "birthplaces": "bɜːθpleɪsɪz",
    "birthrate": "bɜːθreɪt",
    "birthright": "bɜːθraɪt",
    "births": "bɜːθs",
    "birthstone": "bɜːθstəʊn",
    "biscuit": "bɪskɪt",
    "biscuits": "bɪskɪts",
    "bisect": "baɪsɛkt",
    "bisected": "baɪsɛktɪd",
    "bisecting": "baɪsɛktɪŋ",
    "bisection": "baɪsɛkʃən",
    "bisector": "baɪsɛktɐ",
    "bisects": "baɪsɛkts",
    "bisexual": "baɪsɛkʃuːəl",
    "bisexuality": "baɪsɛkʃuːælɪti",
    "bisexuals": "baɪsɛkʃuːəlz",
    "bishop": "bɪʃəp",
    "bishopric": "bɪʃəprɪk",
    "bishoprics": "bɪʃəprɪks",
    "bishops": "bɪʃəps",
    "bismuth": "bɪsmʌθ",
    "bison": "baɪsən",
    "bisons": "baɪsənz",
    "bisque": "biːsk",
    "bistort": "bɪstɔːt",
    "bistro": "biːstrəʊ",
    "bistros": "biːstrəʊz",
    "bit": "bɪt",
    "bitch": "bɪtʃ",
    "bitched": "bɪtʃt",
    "bitches": "bɪtʃɪz",
    "bitchier": "bɪtʃɪɐ",
    "bitchiest": "bɪtʃɪəst",
    "bitchiness": "bɪtʃɪnəs",
    "bitching": "bɪtʃɪŋ",
    "bitchy": "bɪtʃi",
    "bite": "baɪt",
    "biter": "baɪtɐ",
    "biters": "baɪtəz",
    "bites": "baɪts",
    "biting": "baɪtɪŋ",
    "bitingly": "baɪtɪŋli",
    "bits": "bɪts",
    "bitted": "bɪtɪd",
    "bitten": "bɪtən",
    "bitter": "bɪtɐ",
    "bitterest": "bɪtərəst",
    "bitterly": "bɪtəli",
    "bittern": "bɪtən",
    "bitterness": "bɪtənəs",
    "bitterns": "bɪtənz",
    "bitters": "bɪtəz",
    "bittersweet": "bɪtəswiːt",
    "bitting": "bɪtɪŋ",
    "bitts": "bɪts",
    "bitty": "bɪti",
    "bitumen": "bɪtʃuːmən",
    "bituminous": "baɪtjuːmɪnəs",
    "bivalve": "baɪvælv",
    "bivalves": "baɪvælvz",
    "bivouac": "bɪvwɑːk",
    "bivouacked": "bɪvwɑːkt",
    "bivouacking": "bɪvwɑːkɪŋ",
    "bivouacs": "bɪvwɑːks",
    "bizarre": "bɪzɑː",
    "bizarrely": "bɪzɑːli",
    "bizarreness": "bɪzɑːnəs",
    "biz": "bɪz",
    "blabbed": "blæbd",
    "blabber": "blæbɐ",
    "blabbering": "blæbərɪŋ",
    "blabbermouth": "blæbəməθ",
    "blabbermouths": "blæbəməθs",
    "blabbing": "blæbɪŋ",
    "blab": "blæb",
    "blabs": "blæbz",
    "blackamoor": "blækɐmɔː",
    "blackamoors": "blækɐmɔːz",
    "blackball": "blækbɔːl",
    "blackballed": "blækbəld",
    "blackballing": "blækbɔːlɪŋ",
    "blackberries": "blækbərɪz",
    "blackberry": "blækbəri",
    "blackberrying": "blækbərɪɪŋ",
    "blackbird": "blækbɜːd",
    "blackbirds": "blækbɜːdz",
    "black": "blæk",
    "blackboard": "blækbɔːd",
    "blackboards": "blækbɔːdz",
    "blackcap": "blækkæp",
    "blackcock": "blækkɒk",
    "blackcurrant": "blækkʌrənt",
    "blackcurrants": "blækkʌrənts",
    "blacked": "blækt",
    "blacken": "blækən",
    "blackened": "blækənd",
    "blackening": "blækənɪŋ",
    "blackens": "blækənz",
    "blacker": "blækɐ",
    "blackest": "blækəst",
    "blackface": "blækfeɪs",
    "blackfaces": "blækfeɪsɪz",
    "blackguard": "blækɡɑːd",
    "blackguards": "blækɡɑːdz",
    "blackhead": "blækhɛd",
    "blackheads": "blækhɛdz",
    "blackhearts": "blækhɑːts",
    "blacking": "blækɪŋ",
    "blackish": "blækɪʃ",
    "blackjack": "blækdʒæk",
    "blackjacks": "blækdʒæks",
    "blackleg": "blæklɛɡ",
    "blacklist": "blæklɪst",
    "blacklisted": "blæklɪstɪd",
    "blacklisting": "blæklɪstɪŋ",
    "blacklists": "blæklɪsts",
    "blackly": "blækli",
    "blackmail": "blækmeɪl",
    "blackmailed": "blækmeɪld",
    "blackmailer": "blækmeɪlɐ",
    "blackmailers": "blækmeɪləz",
    "blackmailing": "blækmeɪlɪŋ",
    "blackmails": "blækmeɪlz",
    "blackness": "blæknəs",
    "blackout": "blækaʊt",
    "blackouts": "blækaʊts",
    "blacks": "blæks",
    "blacksmith": "blæksmɪθ",
    "blacksmithing": "blæksmɪθɪŋ",
    "blacksmiths": "blæksmɪθs",
    "blacktail": "blækteɪl",
    "blackthorn": "blækθɔːn",
    "blacktop": "blæktɒp",
    "bladder": "blædɐ",
    "bladders": "blædəz",
    "bladderwort": "blædəwɔːt",
    "blade": "bleɪd",
    "bladed": "bleɪdɪd",
    "blades": "bleɪdz",
    "blading": "bleɪdɪŋ",
    "blag": "blæɡ",
    "blagged": "blæɡd",
    "blagging": "blæɡɪŋ",
    "blags": "blæɡz",
    "blah": "blɑː",
    "blahs": "blɑːz",
    "blain": "bleɪn",
    "blame": "bleɪm",
    "blamed": "bleɪmd",
    "blameless": "bleɪmləs",
    "blamelessly": "bleɪmləsli",
    "blames": "bleɪmz",
    "blaming": "bleɪmɪŋ",
    "blanch": "blɑːntʃ",
    "blanched": "blɑːntʃt",
    "blanches": "blɑːnʃɪz",
    "blanching": "blɑːntʃɪŋ",
    "blancmange": "bləmɒnʒ",
    "blancmanges": "bləmɒnʒɪz",
    "bland": "blænd",
    "blander": "blændɐ",
    "blandest": "blændəst",
    "blandishments": "blændɪʃmənts",
    "blandly": "blændli",
    "blandness": "blændnəs",
    "blank": "blæŋk",
    "blanked": "blæŋkt",
    "blanker": "blæŋkɐ",
    "blanket": "blæŋkɪt",
    "blanketed": "blæŋkɪtɪd",
    "blanketing": "blæŋkɪtɪŋ",
    "blankets": "blæŋkɪts",
    "blanking": "blæŋkɪŋ",
    "blankly": "blæŋkli",
    "blankness": "blæŋknəs",
    "blanks": "blæŋks",
    "blanquette": "blænkɛt",
    "blare": "bleə",
    "blared": "bleəd",
    "blares": "bleəz",
    "blaring": "bleərɪŋ",
    "blarney": "blɑːni",
    "blaspheme": "blɑːsfiːm",
    "blasphemed": "blɑːsfiːmd",
    "blasphemer": "blɑːsfiːmɐ",
    "blasphemers": "blɑːsfiːməz",
    "blasphemes": "blɑːsfiːmz",
    "blasphemies": "blɑːsfəmɪz",
    "blaspheming": "blɑːsfiːmɪŋ",
    "blasphemous": "blɑːsfəməs",
    "blasphemy": "blɑːsfəmi",
    "blast": "blɑːst",
    "blasted": "blɑːstɪd",
    "blaster": "blɑːstɐ",
    "blasters": "blɑːstəz",
    "blasting": "blɑːstɪŋ",
    "blastocyst": "blɑːstəsɪst",
    "blastoff": "blɑːstɒf",
    "blasts": "blɑːsts",
    "blatant": "bleɪtənt",
    "blatantly": "bleɪtəntli",
    "blather": "blɑːðɐ",
    "blathered": "blɑːðəd",
    "blathering": "blɑːðərɪŋ",
    "blats": "blæts",
    "blatting": "blætɪŋ",
    "blaze": "bleɪz",
    "blazed": "bleɪzd",
    "blazer": "bleɪzɐ",
    "blazers": "bleɪzəz",
    "blazes": "bleɪzɪz",
    "blazing": "bleɪzɪŋ",
    "blazon": "bleɪzɒn",
    "blazoned": "bleɪzɒnd",
    "bleach": "bliːtʃ",
    "bleached": "bliːtʃt",
    "bleacher": "bliːtʃɐ",
    "bleachers": "bliːtʃəz",
    "bleaches": "bliːtʃɪz",
    "bleaching": "bliːtʃɪŋ",
    "bleak": "bliːk",
    "bleaker": "bliːkɐ",
    "bleakest": "bliːkəst",
    "bleakly": "bliːkli",
    "bleakness": "bliːknəs",
    "bleary": "bliəri",
    "bleat": "bliːt",
    "bleated": "bliːtɪd",
    "bleating": "bliːtɪŋ",
    "bleats": "bliːts",
    "bleb": "blɛb",
    "bled": "blɛd",
    "bleed": "bliːd",
    "bleeder": "bliːdɐ",
    "bleeders": "bliːdəz",
    "bleeding": "bliːdɪŋ",
    "bleeds": "bliːdz",
    "bleep": "bliːp",
    "bleeped": "bliːpt",
    "bleeper": "bliːpɐ",
    "bleepers": "bliːpəz",
    "bleeping": "bliːpɪŋ",
    "bleeps": "bliːps",
    "blemish": "blɛmɪʃ",
    "blemished": "blɛmɪʃt",
    "blemishes": "blɛmɪʃɪz",
    "blench": "blɛntʃ",
    "blend": "blɛnd",
    "blended": "blɛndɪd",
    "blender": "blɛndɐ",
    "blenders": "blɛndəz",
    "blending": "blɛndɪŋ",
    "blends": "blɛndz",
    "blennies": "blɛnɪz",
    "blenny": "blɛni",
    "blent": "blɛnt",
    "bless": "blɛs",
    "blessedly": "blɛsɪdli",
    "blesses": "blɛsɪz",
    "blessing": "blɛsɪŋ",
    "blessings": "blɛsɪŋz",
    "blest": "blɛst",
    "blew": "bluː",
    "blight": "blaɪt",
    "blighted": "blaɪtɪd",
    "blighter": "blaɪtɐ",
    "blighters": "blaɪtəz",
    "blighting": "blaɪtɪŋ",
    "blights": "blaɪts",
    "blimey": "blaɪmi",
    "blimp": "blɪmp",
    "blimps": "blɪmps",
    "blind": "blaɪnd",
    "blinded": "blaɪndɪd",
    "blinder": "blaɪndɐ",
    "blinders": "blaɪndəz",
    "blindest": "blaɪndəst",
    "blindfold": "blaɪndfəʊld",
    "blindfolded": "blaɪndfəʊldɪd",
    "blindfolding": "blaɪndfəʊldɪŋ",
    "blindfolds": "blaɪndfəʊldz",
    "blinding": "blaɪndɪŋ",
    "blindingly": "blaɪndɪŋli",
    "blindly": "blaɪndli",
    "blindness": "blaɪndnəs",
    "blinds": "blaɪndz",
    "blindside": "blaɪndsaɪd",
    "blindsided": "blaɪndsaɪdɪd",
    "blindsides": "blaɪndsaɪdz",
    "blini": "blɪni",
    "blinis": "blɪniz",
    "blink": "blɪŋk",
    "blinked": "blɪŋkt",
    "blinker": "blɪŋkɐ",
    "blinkered": "blɪŋkəd",
    "blinkers": "blɪŋkəz",
    "blinking": "blɪŋkɪŋ",
    "blinks": "blɪŋks",
    "blintz": "blɪnts",
    "blintzes": "blɪntsɪz",
    "blip": "blɪp",
    "blips": "blɪps",
    "bliss": "blɪs",
    "blissful": "blɪsfəl",
    "blissfully": "blɪsfəli",
    "blister": "blɪstɐ",
    "blistered": "blɪstəd",
    "blistering": "blɪstərɪŋ",
    "blisteringly": "blɪstərɪŋli",
    "blisters": "blɪstəz",
    "blithe": "blaɪð",
    "blithely": "blaɪðli",
    "blither": "blɪðɐ",
    "blithering": "blɪðərɪŋ",
    "blitz": "blɪts",
    "blitzed": "blɪtsd",
    "blitzes": "blɪtsɪz",
    "blitzing": "blɪtsɪŋ",
    "blitzkrieg": "blɪtskrɪɡ",
    "blizzard": "blɪzəd",
    "blizzards": "blɪzədz",
    "bloat": "bləʊt",
    "bloated": "bləʊtɪd",
    "bloater": "bləʊtɐ",
    "bloaters": "bləʊtəz",
    "bloating": "bləʊtɪŋ",
    "bloats": "bləʊts",
    "blobbed": "blɒbd",
    "blobbing": "blɒbɪŋ",
    "blob": "blɒb",
    "blobs": "blɒbz",
    "bloc": "blɒk",
    "blockade": "blɒkeɪd",
    "blockaded": "blɒkeɪdɪd",
    "blockades": "blɒkeɪdz",
    "blockading": "blɒkeɪdɪŋ",
    "blockage": "blɒkɪdʒ",
    "blockages": "blɒkɪdʒɪz",
    "block": "blɒk",
    "blockbuster": "blɒkbʌstɐ",
    "blockbusters": "blɒkbʌstəz",
    "blockbusting": "blɒkbʌstɪŋ",
    "blocked": "blɒkt",
    "blocker": "blɒkɐ",
    "blockers": "blɒkəz",
    "blockhead": "blɒkhɛd",
    "blockheads": "blɒkhɛdz",
    "blockhouse": "blɒkhaʊs",
    "blockhouses": "blɒkhaʊzɪz",
    "blocking": "blɒkɪŋ",
    "blocks": "blɒks",
    "blocky": "blɒki",
    "blocs": "blɒks",
    "blog": "blɒɡ",
    "blogged": "blɒɡd",
    "blogger": "blɒɡɐ",
    "bloggers": "blɒɡəz",
    "blogging": "blɒɡɪŋ",
    "blogs": "blɒɡz",
    "bloke": "bləʊk",
    "blokes": "bləʊks",
    "blokish": "blɒkɪʃ",
    "blond": "blɒnd",
    "blonde": "blɒnd",
    "blonder": "blɒndɐ",
    "blondes": "blɒndz",
    "blondish": "blɒndɪʃ",
    "blonds": "blɒndz",
    "bloodbath": "blʌdbɑːθ",
    "bloodbaths": "blʌdbɑːθs",
    "blood": "blʌd",
    "bloodcurdling": "blʌdkədlɪŋ",
    "blooded": "blʌdɪd",
    "bloodhound": "blʌdhaʊnd",
    "bloodhounds": "blʌdhaʊndz",
    "bloodied": "blʌdɪd",
    "bloodier": "blʌdɪɐ",
    "bloodiest": "blʌdɪəst",
    "bloodily": "blʌdɪli",
    "blooding": "blʌdɪŋ",
    "bloodless": "blʌdləs",
    "bloodlessly": "blʌdləsli",
    "bloodletting": "blʌdlɪtɪŋ",
    "bloodline": "blʌdlaɪn",
    "bloodlines": "blʌdlaɪnz",
    "bloods": "blʌdz",
    "bloodshed": "blʌdʃɛd",
    "bloodshot": "blʌdʃɒt",
    "bloodsports": "blʌdspɔːts",
    "bloodstain": "blʌdsteɪn",
    "bloodstained": "blʌdsteɪnd",
    "bloodstains": "blʌdsteɪnz",
    "bloodstock": "blʌdstɒk",
    "bloodstone": "blʌdstəʊn",
    "bloodstream": "blʌdstriːm",
    "bloodsucker": "blʌdsʌkɐ",
    "bloodsuckers": "blʌdsʌkəz",
    "bloodsucking": "blʌdsʌkɪŋ",
    "bloodthirsty": "blʌdθɜːsti",
    "bloody": "blʌdi",
    "bloom": "bluːm",
    "bloomed": "bluːmd",
    "bloomer": "bluːmɐ",
    "bloomers": "bluːməz",
    "blooming": "bluːmɪŋ",
    "blooms": "bluːmz",
    "bloomy": "bluːmi",
    "bloop": "bluːp",
    "blooper": "bluːpɐ",
    "bloopers": "bluːpəz",
    "blooping": "bluːpɪŋ",
    "bloops": "bluːps",
    "blossom": "blɒsəm",
    "blossomed": "blɒsəmd",
    "blossoming": "blɒsəmɪŋ",
    "blossoms": "blɒsəmz",
    "blossomy": "blɒsəmi",
    "blot": "blɒt",
    "blotch": "blɒtʃ",
    "blotched": "blɒtʃt",
    "blotches": "blɒtʃɪz",
    "blotchy": "blɒtʃi",
    "blots": "blɒts",
    "blotted": "blɒtɪd",
    "blotter": "blɒtɐ",
    "blotters": "blɒtəz",
    "blotting": "blɒtɪŋ",
    "blotto": "blɒtəʊ",
    "blouse": "blaʊz",
    "blouses": "blaʊzɪz",
    "blouson": "blaʊsən",
    "blow": "bləʊ",
    "blower": "bləʊɐ",
    "blowers": "bləʊəz",
    "blowfish": "bləʊfɪʃ",
    "blowflies": "bləʊflaɪz",
    "blowfly": "bləʊflaɪ",
    "blowhard": "bləʊhəd",
    "blowhole": "bləʊhəʊl",
    "blowholes": "bləʊhəʊlz",
    "blowing": "bləʊɪŋ",
    "blowlamp": "bləʊlæmp",
    "blown": "bləʊn",
    "blowout": "bləʊaʊt",
    "blowpipe": "bləʊpaɪp",
    "blowpipes": "bləʊpaɪps",
    "blows": "bləʊz",
    "blowsy": "bləʊsi",
    "blowtorch": "bləʊtɔːtʃ",
    "blowtorches": "bləʊtɔːtʃɪz",
    "blowup": "bləʊʌp",
    "blowy": "bləʊi",
    "blubber": "blʌbɐ",
    "blubbered": "blʌbəd",
    "blubbering": "blʌbərɪŋ",
    "blubbers": "blʌbəz",
    "blubbery": "blʌbəri",
    "blubbing": "blʌbɪŋ",
    "blub": "blʌb",
    "blubs": "blʌbz",
    "blucher": "blʌtʃɐ",
    "bludge": "blʌdʒ",
    "bludgeon": "blʌdʒən",
    "bludgeoned": "blʌdʒəʊnd",
    "bludgeoning": "blʌdʒəʊnɪŋ",
    "bludgeons": "blʌdʒənz",
    "bluebell": "bluːbɛl",
    "bluebells": "bluːbɛlz",
    "blueberries": "bluːbɛrɪz",
    "blueberry": "bluːbɛri",
    "bluebird": "bluːbɜːd",
    "bluebirds": "bluːbɜːdz",
    "blue": "bluː",
    "bluebottle": "bluːbɒtəl",
    "bluebottles": "bluːbɒtəlz",
    "bluecoat": "bluːkəʊt",
    "blued": "bluːd",
    "bluefish": "bluːfɪʃ",
    "bluegrass": "bluːɡrɑːs",
    "blueing": "bluːɪŋ",
    "blueish": "bluːɪʃ",
    "blueness": "bluːnəs",
    "bluenose": "bluːnəʊz",
    "blueprint": "bluːprɪnt",
    "blueprints": "bluːprɪnts",
    "bluer": "bluːɐ",
    "blues": "bluːz",
    "bluesman": "bluːsmæn",
    "bluest": "bluːəst",
    "bluestocking": "bluːstɒkɪŋ",
    "bluestone": "bluːstəʊn",
    "bluestones": "bluːstəʊnz",
    "bluesy": "bluːsi",
    "bluetongue": "bluːtʌŋ",
    "bluey": "bluːwaɪ",
    "bluff": "blʌf",
    "bluffed": "blʌft",
    "bluffer": "blʌfɐ",
    "bluffers": "blʌfəz",
    "bluffing": "blʌfɪŋ",
    "bluffs": "blʌfs",
    "bluing": "bluːɪŋ",
    "bluish": "bluːɪʃ",
    "blunder": "blʌndɐ",
    "blunderbuss": "blʌndəbʌs",
    "blundered": "blʌndəd",
    "blunderer": "blʌndərɐ",
    "blunderers": "blʌndərəz",
    "blundering": "blʌndərɪŋ",
    "blunders": "blʌndəz",
    "blunt": "blʌnt",
    "blunted": "blʌntɪd",
    "blunter": "blʌntɐ",
    "bluntest": "blʌntəst",
    "blunting": "blʌntɪŋ",
    "bluntly": "blʌntli",
    "bluntness": "blʌntnəs",
    "blunts": "blʌnts",
    "blurb": "blɜːb",
    "blur": "blɜː",
    "blurred": "blɜːd",
    "blurring": "blɜːrɪŋ",
    "blurry": "blɜːri",
    "blurs": "blɜːz",
    "blurt": "blɜːt",
    "blurted": "blɜːtɪd",
    "blurting": "blɜːtɪŋ",
    "blurts": "blɜːts",
    "blush": "blʌʃ",
    "blushed": "blʌʃt",
    "blusher": "blʌʃɐ",
    "blushers": "blʌʃəz",
    "blushes": "blʌʃɪz",
    "blushful": "blʌʃfəl",
    "blushing": "blʌʃɪŋ",
    "bluster": "blʌstɐ",
    "blustered": "blʌstəd",
    "blustering": "blʌstərɪŋ",
    "blusters": "blʌstəz",
    "blustery": "blʌstəri",
    "boa": "bəʊɐ",
    "boar": "bɔː",
    "board": "bɔːd",
    "boarded": "bɔːdɪd",
    "boarder": "bɔːdɐ",
    "boarders": "bɔːdəz",
    "boardgames": "bɔːdɡeɪmz",
    "boarding": "bɔːdɪŋ",
    "boardroom": "bɔːdruːm",
    "boardrooms": "bɔːdruːmz",
    "boards": "bɔːdz",
    "boardwalk": "bɔːdwɔːk",
    "boardwalks": "bɔːdwɔːks",
    "boarish": "bɔːrɪʃ",
    "boars": "bɔːz",
    "boas": "bəʊəz",
    "boast": "bəʊst",
    "boasted": "bəʊstɪd",
    "boaster": "bəʊstɐ",
    "boasters": "bəʊstəz",
    "boastful": "bəʊstfəl",
    "boastfully": "bəʊstfəli",
    "boasting": "bəʊstɪŋ",
    "boasts": "bəʊsts",
    "boat": "bəʊt",
    "boated": "bəʊtɪd",
    "boater": "bəʊtɐ",
    "boaters": "bəʊtəz",
    "boathouse": "bəʊthaʊs",
    "boathouses": "bəʊthaʊsɪz",
    "boating": "bəʊtɪŋ",
    "boatload": "bəʊtləʊd",
    "boatloads": "bəʊtləʊdz",
    "boatman": "bəʊtmən",
    "boatmen": "bəʊtmɛn",
    "boats": "bəʊts",
    "boatswain": "bəʊtsweɪn",
    "boatyard": "bəʊtjɑːd",
    "boatyards": "bəʊtjɑːdz",
    "bob": "bɒb",
    "bobbed": "bɒbd",
    "bobbies": "bɒbɪz",
    "bobbin": "bɒbɪn",
    "bobbing": "bɒbɪŋ",
    "bobbins": "bɒbɪnz",
    "bobble": "bɒbəl",
    "bobbled": "bɒbəld",
    "bobbles": "bɒbəlz",
    "bobbling": "bɒblɪŋ",
    "bobby": "bɒbi",
    "bobcat": "bɒbkæt",
    "bobcats": "bɒbkæts",
    "bobolink": "bɒbəlɪŋk",
    "bobs": "bɒbz",
    "bobsled": "bɒbsəld",
    "bobsledding": "bɒbslɛdɪŋ",
    "bobsleigh": "bɒbsleɪ",
    "bobsleighs": "bɒbsleɪz",
    "bobtail": "bɒbteɪl",
    "bobtailed": "bɒbteɪld",
    "bobtails": "bɒbteɪlz",
    "bocage": "bɒkeɪdʒ",
    "bocce": "bɒks",
    "bock": "bɒk",
    "bodacious": "bədeɪʃəs",
    "bod": "bɒd",
    "bode": "bəʊd",
    "boded": "bəʊdɪd",
    "bodega": "bəʊdɡɐ",
    "bodegas": "bəʊdɡəz",
    "bodes": "bəʊdz",
    "bodge": "bɒdʒ",
    "bodged": "bɒdʒd",
    "bodges": "bɒdʒɪz",
    "bodging": "bɒdʒɪŋ",
    "bodhisattva": "bɒdhɪsætvɐ",
    "bodice": "bɒdɪs",
    "bodices": "bɒdɪsɪz",
    "bodied": "bɒdɪd",
    "bodies": "bɒdɪz",
    "bodiless": "bɒdɪləs",
    "bodily": "bɒdɪli",
    "boding": "bəʊdɪŋ",
    "bodkin": "bɒdkɪn",
    "bodkins": "bɒdkɪnz",
    "bods": "bɒdz",
    "body": "bɒdi",
    "bodyboard": "bɒdɪbɔːd",
    "bodybuilder": "bɒdɪbɪldɐ",
    "bodybuilders": "bɒdɪbɪldəz",
    "bodybuilding": "bɒdɪbɪldɪŋ",
    "bodyguard": "bɒdɪɡɑːd",
    "bodyguards": "bɒdɪɡɑːdz",
    "bodysuit": "bɒdɪsuːt",
    "bodysurf": "bɒdɪsɜːf",
    "bodywork": "bɒdɪwɜːk",
    "boffin": "bɒfɪn",
    "boffins": "bɒfɪnz",
    "bog": "bɒɡ",
    "bogbean": "bɒɡbiːn",
    "bogey": "bəʊɡi",
    "bogeyed": "bəʊɡɪd",
    "bogeying": "bəʊɡɪɪŋ",
    "bogeyman": "bəʊɡɪmən",
    "bogeymen": "bəʊɡaɪmɛn",
    "bogeys": "bəʊɡɪz",
    "boggart": "bɒɡɑːt",
    "bogged": "bɒɡd",
    "boggier": "bɒɡɪɐ",
    "boggiest": "bɒɡɪəst",
    "bogging": "bɒɡɪŋ",
    "boggle": "bɒɡəl",
    "boggled": "bɒɡəld",
    "boggles": "bɒɡəlz",
    "boggling": "bɒɡlɪŋ",
    "boggy": "bɒɡi",
    "bogie": "bəʊdʒi",
    "bogies": "bəʊɡɪz",
    "bogle": "bɒɡəl",
    "bogs": "bɒɡz",
    "bogus": "bəʊɡəs",
    "bogusly": "bəʊɡəsli",
    "bogusness": "bəʊɡəsnəs",
    "bogy": "bəʊɡi",
    "bohemian": "bəʊhiːmiən",
    "bohemians": "bəʊhiːmiənz",
    "bohrium": "bəʊriəm",
    "boil": "bɔɪl",
    "boiled": "bɔɪld",
    "boiler": "bɔɪlɐ",
    "boilermaker": "bɔɪləmeɪkɐ",
    "boilermakers": "bɔɪləmeɪkəz",
    "boilerplate": "bɔɪləpleɪt",
    "boilers": "bɔɪləz",
    "boiling": "bɔɪlɪŋ",
    "boils": "bɔɪlz",
    "boisterous": "bɔɪstərəs",
    "bola": "bəʊlɐ",
    "bolas": "bəʊləz",
    "bold": "bəʊld",
    "bolder": "bəʊldɐ",
    "boldest": "bəʊldəst",
    "boldly": "bəʊldli",
    "boldness": "bəʊldnəs",
    "bole": "bəʊl",
    "bolero": "bɒleərəʊ",
    "boleros": "bɒleərəʊz",
    "boles": "bəʊlz",
    "boletus": "bəʊltəs",
    "bolivar": "bɒlɪvɑː",
    "boliviano": "bɒlɪviənəʊ",
    "bollard": "bɒlɑːd",
    "bollards": "bɒlɑːdz",
    "boll": "bɒl",
    "bollocking": "bɒləkɪŋ",
    "bollocks": "bɒləks",
    "bolls": "bɒlz",
    "bolo": "bəʊləʊ",
    "bologna": "bələʊni",
    "bolshevik": "bɒlʃɪvɪk",
    "bolsheviks": "bɒlʃɪvɪks",
    "bolshevism": "bɒlʃɪvɪzəm",
    "bolshie": "bɒlʃi",
    "bolshy": "bɒlʃi",
    "bolster": "bəʊlstɐ",
    "bolstered": "bəʊlstəd",
    "bolstering": "bəʊlstərɪŋ",
    "bolsters": "bəʊlstəz",
    "bolt": "bəʊlt",
    "bolted": "bəʊltɪd",
    "bolter": "bəʊltɐ",
    "bolthole": "bəʊlthəʊl",
    "bolting": "bəʊltɪŋ",
    "bolts": "bəʊlts",
    "bolus": "bəʊləs",
    "bombard": "bəmbɑːd",
    "bombarded": "bəmbɑːdɪd",
    "bombardier": "bɒmbədiə",
    "bombardiers": "bɒmbədiəz",
    "bombarding": "bəmbɑːdɪŋ",
    "bombardment": "bəmbɑːdmənt",
    "bombardments": "bəmbɑːdmənts",
    "bombards": "bəmbɑːdz",
    "bombast": "bɒmbɑːst",
    "bombastic": "bəmbɑːstɪk",
    "bomb": "bɒm",
    "bombe": "bɒm",
    "bombed": "bɒmd",
    "bomber": "bɒmɐ",
    "bombers": "bɒməz",
    "bombing": "bɒmɪŋ",
    "bombings": "bɒmɪŋz",
    "bombproof": "bɒmpruːf",
    "bombs": "bɒmz",
    "bombshell": "bɒmʃɛl",
    "bombshells": "bɒmʃɛlz",
    "bombsite": "bɒmsaɪt",
    "bonanza": "bənænzɐ",
    "bonanzas": "bənænzəz",
    "bonbon": "bɒnbɒn",
    "bonbons": "bɒnbɒnz",
    "bonce": "bɒns",
    "bonces": "bɒnsɪz",
    "bondage": "bɒndɪdʒ",
    "bond": "bɒnd",
    "bonded": "bɒndɪd",
    "bondholders": "bɒndhəʊldəz",
    "bonding": "bɒndɪŋ",
    "bondman": "bɒndmən",
    "bonds": "bɒndz",
    "bondsman": "bɒndzmən",
    "bone": "bəʊn",
    "boned": "bəʊnd",
    "bonehead": "bəʊnhɛd",
    "boneheaded": "bəʊnhɛdɪd",
    "boneheads": "bəʊnhɛdz",
    "boneless": "bəʊnləs",
    "bonemeal": "bəʊnmiəl",
    "boner": "bəʊnɐ",
    "boners": "bəʊnəz",
    "bones": "bəʊnz",
    "boneshaker": "bəʊnʃeɪkɐ",
    "boneshakers": "bəʊnʃeɪkəz",
    "boneyard": "bəʊnjɑːd",
    "boney": "bəʊni",
    "bonfire": "bɒnfaɪə",
    "bonfires": "bɒnfaɪəz",
    "bong": "bɒŋ",
    "bonging": "bɒŋɪŋ",
    "bongo": "bɒŋɡəʊ",
    "bongos": "bɒŋɡəʊz",
    "bongs": "bɒŋz",
    "bonhomie": "bɒnəmiː",
    "bonier": "bəʊnɪɐ",
    "boniest": "bəʊnɪəst",
    "boning": "bəʊnɪŋ",
    "bonito": "bəniːtəʊ",
    "bonk": "bɒŋk",
    "bonked": "bɒŋkt",
    "bonkers": "bɒŋkəz",
    "bonking": "bɒŋkɪŋ",
    "bonks": "bɒŋks",
    "bonne": "bɒn",
    "bonnet": "bɒnɪt",
    "bonnets": "bɒnɪts",
    "bonnie": "bɒni",
    "bonnier": "bɒnɪɐ",
    "bonniest": "bɒnɪəst",
    "bonny": "bɒni",
    "bonobo": "bənəʊbəʊ",
    "bonobos": "bənəʊbəʊz",
    "bonsai": "bɒnsaɪ",
    "bonspiel": "bɒnspiːl",
    "bonus": "bəʊnəs",
    "bonuses": "bəʊnəsɪz",
    "bony": "bəʊni",
    "bonze": "bɒnz",
    "bonzer": "bɒnzɐ",
    "boob": "buːb",
    "boobed": "buːbd",
    "boobies": "buːbɪz",
    "booboo": "buːbuː",
    "boobs": "buːbz",
    "boo": "buː",
    "booby": "buːbi",
    "boodle": "buːdəl",
    "boodles": "buːdəlz",
    "booed": "buːd",
    "booger": "bʊɡɐ",
    "boogers": "bʊɡəz",
    "boogeyman": "buːɡɪmən",
    "boogie": "buːɡi",
    "boogied": "buːɡɪd",
    "boogieing": "buːɡiɪŋ",
    "boogieman": "buːdʒɪmən",
    "boogies": "buːɡɪz",
    "boohoo": "buːhuː",
    "booing": "buːɪŋ",
    "bookable": "bʊkəbəl",
    "bookbinder": "bʊkbaɪndɐ",
    "bookbinders": "bʊkbaɪndəz",
    "bookbinding": "bʊkbaɪndɪŋ",
    "book": "bʊk",
    "bookcase": "bʊkkeɪs",
    "bookcases": "bʊkkeɪsɪz",
    "booked": "bʊkt",
    "bookend": "bʊkɛnd",
    "bookends": "bʊkɛndz",
    "bookie": "bʊki",
    "bookies": "bʊkɪz",
    "booking": "bʊkɪŋ",
    "bookings": "bʊkɪŋz",
    "bookish": "bʊkɪʃ",
    "bookkeeper": "bʊkkiːpɐ",
    "bookkeepers": "bʊkkiːpəz",
    "bookkeeping": "bʊkkiːpɪŋ",
    "booklet": "bʊklət",
    "booklets": "bʊkləts",
    "bookmaker": "bʊkmeɪkɐ",
    "bookmakers": "bʊkmeɪkəz",
    "bookmaking": "bʊkmeɪkɪŋ",
    "bookman": "bʊkmən",
    "bookmark": "bʊkmɑːk",
    "bookmarked": "bʊkmɑːkt",
    "bookmarks": "bʊkmɑːks",
    "bookplates": "bʊkpleɪts",
    "books": "bʊks",
    "bookseller": "bʊksɛlɐ",
    "booksellers": "bʊksɛləz",
    "bookshelf": "bʊkʃɛlf",
    "bookshelves": "bʊkʃɛlvz",
    "bookshop": "bʊkʃɒp",
    "bookshops": "bʊkʃɒps",
    "bookstall": "bʊkstɔːl",
    "bookstalls": "bʊkstɔːlz",
    "bookstand": "bʊkstænd",
    "bookstore": "bʊkstɔː",
    "bookstores": "bʊkstɔːz",
    "bookwork": "bʊkwɜːk",
    "bookworm": "bʊkwɜːm",
    "bookworms": "bʊkwɜːmz",
    "boombox": "buːmbɒks",
    "boom": "buːm",
    "boomed": "buːmd",
    "boomerang": "buːməræŋ",
    "boomeranging": "buːməreɪndʒɪŋ",
    "boomerangs": "buːməræŋz",
    "boomer": "buːmɐ",
    "boomers": "buːməz",
    "booming": "buːmɪŋ",
    "booms": "buːmz",
    "boon": "buːn",
    "boondocks": "buːndɒks",
    "boons": "buːnz",
    "boor": "bɔː",
    "boorish": "bɔːrɪʃ",
    "boorishness": "bɔːrɪʃnəs",
    "boors": "bɔːz",
    "boos": "buːz",
    "boost": "buːst",
    "boosted": "buːstɪd",
    "booster": "buːstɐ",
    "boosterism": "buːstərɪzəm",
    "boosters": "buːstəz",
    "boosting": "buːstɪŋ",
    "boosts": "buːsts",
    "boot": "buːt",
    "booted": "buːtɪd",
    "bootee": "buːtiː",
    "bootees": "buːtiːz",
    "bootery": "buːtəri",
    "booth": "buːθ",
    "booths": "buːθs",
    "bootie": "buːti",
    "booties": "buːtɪz",
    "booting": "buːtɪŋ",
    "bootjack": "buːtdʒæk",
    "bootlace": "buːtleɪs",
    "bootlaces": "buːtleɪsɪz",
    "bootleg": "buːtlɛɡ",
    "bootlegged": "buːtlɪɡɪd",
    "bootlegger": "buːtlɛɡɐ",
    "bootleggers": "buːtlɛɡəz",
    "bootlegging": "buːtlɛɡɪŋ",
    "bootless": "buːtləs",
    "boots": "buːts",
    "bootstrap": "buːtstræp",
    "bootstraps": "buːtstræps",
    "booty": "buːti",
    "booze": "buːz",
    "boozed": "buːzd",
    "boozer": "buːzɐ",
    "boozers": "buːzəz",
    "boozes": "buːzɪz",
    "boozing": "buːzɪŋ",
    "boozy": "buːzi",
    "bop": "bɒp",
    "bopped": "bɒpt",
    "bopper": "bɒpɐ",
    "bopping": "bɒpɪŋ",
    "bops": "bɒps",
    "bora": "bɔːrɐ",
    "boracic": "bɔːræsɪk",
    "borax": "bɔːræks",
    "bordello": "bɔːdɛləʊ",
    "bordellos": "bɔːdɛləʊz",
    "border": "bɔːdɐ",
    "bordered": "bɔːdəd",
    "borderer": "bɔːdərɐ",
    "borderers": "bɔːdərəz",
    "bordering": "bɔːdərɪŋ",
    "borderland": "bɔːdələnd",
    "borderlands": "bɔːdələndz",
    "borderline": "bɔːdəlaɪn",
    "borderlines": "bɔːdəlaɪnz",
    "borders": "bɔːdəz",
    "boreal": "bɔːriəl",
    "bore": "bɔː",
    "bored": "bɔːd",
    "boredom": "bɔːdəm",
    "borehole": "bɔːhəʊl",
    "boreholes": "bɔːhəʊlz",
    "borer": "bɔːrɐ",
    "bores": "bɔːz",
    "boric": "bɔːrɪk",
    "boring": "bɔːrɪŋ",
    "boringly": "bɔːrɪŋli",
    "born": "bɔːn",
    "borne": "bɔːn",
    "boron": "bɔːrɒn",
    "borough": "bʌrɐ",
    "boroughs": "bʌrəz",
    "borrow": "bɒrəʊ",
    "borrowed": "bɒrəʊd",
    "borrower": "bɒrəʊɐ",
    "borrowers": "bɒrəʊəz",
    "borrowing": "bɒrəʊɪŋ",
    "borrowings": "bɒrəʊɪŋz",
    "borrows": "bɒrəʊz",
    "borsch": "bɔːʃ",
    "borscht": "bɔːʃt",
    "borstal": "bɔːstəl",
    "borstals": "bɔːstəlz",
    "bort": "bɔːt",
    "borzoi": "bɔːzɔɪ",
    "bosh": "bɒʃ",
    "bosky": "bɒski",
    "bosom": "bʊsəm",
    "bosomed": "bʊsəmd",
    "bosoms": "bʊsəmz",
    "bosomy": "bʊsəmi",
    "boson": "bɒsən",
    "bosons": "bɒsənz",
    "boss": "bɒs",
    "bossed": "bɒst",
    "bosses": "bɒsɪz",
    "bossiest": "bɒsɪəst",
    "bossiness": "bɒsɪnəs",
    "bossing": "bɒsɪŋ",
    "bossy": "bɒsi",
    "bosun": "bəʊsən",
    "botanical": "bətænɪkəl",
    "botanically": "bətænɪkli",
    "botanicals": "bətænɪkəlz",
    "botanic": "bətænɪk",
    "botanising": "bɒtɐnaɪzɪŋ",
    "botanist": "bɒtɐnɪst",
    "botanists": "bɒtɐnɪsts",
    "botany": "bɒtəni",
    "botch": "bɒtʃ",
    "botched": "bɒtʃt",
    "botcher": "bɒtʃɐ",
    "botches": "bɒtʃɪz",
    "botching": "bɒtʃɪŋ",
    "botfly": "bɒtflaɪ",
    "both": "bəʊθ",
    "botheration": "bɒðəreɪʃən",
    "bother": "bɒðɐ",
    "bothered": "bɒðəd",
    "bothering": "bɒðərɪŋ",
    "bothers": "bɒðəz",
    "bothersome": "bɒðəsʌm",
    "bothy": "bəʊθi",
    "bots": "bɒts",
    "bott": "bɒt",
    "bottle": "bɒtəl",
    "bottled": "bɒtəld",
    "bottleneck": "bɒtəlnɛk",
    "bottlenecks": "bɒtəlnɛks",
    "bottler": "bɒtlɐ",
    "bottlers": "bɒtləz",
    "bottles": "bɒtəlz",
    "bottling": "bɒtlɪŋ",
    "bottom": "bɒtəm",
    "bottomed": "bɒtəmd",
    "bottoming": "bɒtəmɪŋ",
    "bottomless": "bɒtəmləs",
    "bottoms": "bɒtəmz",
    "botulism": "bɒtjuːlɪzəm",
    "boudoir": "buːdwɑː",
    "boudoirs": "buːdwɑːz",
    "bouffant": "buːfənt",
    "bouffants": "buːfənts",
    "bouffe": "buːf",
    "bougainvillea": "baʊɡeɪnvɪliə",
    "bougainvilleas": "baʊɡeɪnvɪliəz",
    "bough": "baʊ",
    "boughs": "baʊz",
    "bought": "bɔːt",
    "bougie": "baʊdʒi",
    "bouillabaisse": "buːɪlæbeɪs",
    "bouillabaisses": "buːɪlæbeɪɪsɪz",
    "bouilli": "buːɪli",
    "bouillon": "buːɪlən",
    "bouillons": "buːɪlənz",
    "boulder": "bəʊldɐ",
    "boulders": "bəʊldəz",
    "boules": "buːlz",
    "boulevard": "buːlɪvɑːd",
    "boulevards": "buːlɪvɑːdz",
    "bounce": "baʊns",
    "bounced": "baʊnst",
    "bouncer": "baʊnsɐ",
    "bouncers": "baʊnsəz",
    "bounces": "baʊnsɪz",
    "bouncier": "baʊnsɪɐ",
    "bounciest": "baʊnsɪəst",
    "bounciness": "baʊnsɪnɛs",
    "bouncing": "baʊnsɪŋ",
    "bouncy": "baʊnsi",
    "boundaries": "baʊndəriz",
    "boundary": "baʊndəri",
    "bound": "baʊnd",
    "bounded": "baʊndɪd",
    "bounden": "baʊndən",
    "bounder": "baʊndɐ",
    "bounders": "baʊndəz",
    "bounding": "baʊndɪŋ",
    "boundless": "baʊndləs",
    "bounds": "baʊndz",
    "bounteous": "baʊntiəs",
    "bounties": "baʊntɪz",
    "bountiful": "baʊntɪfəl",
    "bounty": "baʊnti",
    "bouquet": "buːkeɪ",
    "bouquets": "buːkeɪs",
    "bour": "bɜː",
    "bourbon": "bɜːbən",
    "bourbons": "bɜːbənz",
    "bourg": "bɜːɡ",
    "bourgeoisie": "bɔːʒwɑːziː",
    "bourn": "bɔːn",
    "bourne": "bɔːn",
    "bournes": "bɔːnz",
    "bourse": "bɔːs",
    "bousing": "baʊsɪŋ",
    "bout": "baʊt",
    "boutique": "buːtiːk",
    "boutiques": "buːtiːks",
    "bouts": "baʊts",
    "bouzouki": "buːzaʊki",
    "bouzoukis": "buːzaʊkiz",
    "bovid": "bəʊvɪd",
    "bovine": "bəʊvaɪn",
    "bovines": "bəʊvaɪnz",
    "bovver": "bɒvɐ",
    "bowdlerised": "bəʊdəlraɪzd",
    "bowel": "baʊəl",
    "bowels": "baʊəlz",
    "bowerbird": "baʊəbɜːd",
    "bowerbirds": "baʊəbɜːdz",
    "bowery": "baʊəri",
    "bowfin": "bəʊfɪn",
    "bowhead": "bəʊhɛd",
    "bowheads": "bəʊhɛdz",
    "bowl": "bəʊl",
    "bowled": "bəʊld",
    "bowler": "bəʊlɐ",
    "bowlers": "bəʊləz",
    "bowlful": "bəʊlfəl",
    "bowlfuls": "bəʊlfəlz",
    "bowline": "bəʊlaɪn",
    "bowlines": "bəʊlaɪnz",
    "bowling": "bəʊlɪŋ",
    "bowls": "bəʊlz",
    "bowsprit": "baʊsprɪt",
    "bowstring": "bəʊstrɪŋ",
    "bowyer": "bəʊaɪɐ",
    "box": "bɒks",
    "boxcar": "bɒkskɑː",
    "boxcars": "bɒkskɑːz",
    "boxed": "bɒkst",
    "boxer": "bɒksɐ",
    "boxers": "bɒksəz",
    "boxes": "bɒksɪz",
    "boxfish": "bɒksfɪʃ",
    "boxful": "bɒksfəl",
    "boxing": "bɒksɪŋ",
    "boxroom": "bɒksruːm",
    "boxwood": "bɒkswʊd",
    "boxy": "bɒksi",
    "boy": "bɔɪ",
    "boycott": "bɔɪkɒt",
    "boycotted": "bɔɪkɒtɪd",
    "boycotting": "bɔɪkɒtɪŋ",
    "boycotts": "bɔɪkɒts",
    "boyfriend": "bɔɪfrɛnd",
    "boyfriends": "bɔɪfrɛndz",
    "boyhood": "bɔɪhʊd",
    "boyish": "bɔɪɪʃ",
    "boyishly": "bɔɪɪʃli",
    "boyishness": "bɔɪɪʃnəs",
    "boys": "bɔɪz",
    "boysenberry": "bɔɪsənbəri",
    "bozo": "bəʊzəʊ",
    "bozos": "bəʊzəʊz",
    "bra": "brɑː",
    "brace": "breɪs",
    "braced": "breɪst",
    "bracelet": "breɪslət",
    "bracelets": "breɪsləts",
    "bracer": "breɪsɐ",
    "braces": "breɪsɪz",
    "brachial": "breɪʃəl",
    "brachiation": "breɪʃəʃən",
    "brachiopods": "brækɪɒpɒdz",
    "brachiosaurus": "brækɪəsɔːrəs",
    "bracing": "breɪsɪŋ",
    "bracingly": "breɪsɪŋli",
    "bracken": "brækən",
    "bracket": "brækɪt",
    "bracketed": "brækɪtɪd",
    "bracketing": "brækɪtɪŋ",
    "brackets": "brækɪts",
    "brackish": "brækɪʃ",
    "bract": "brækt",
    "bracts": "brækts",
    "bradawl": "brædɔːl",
    "brad": "bræd",
    "bradycardia": "brædɪkɑːdiə",
    "brae": "briː",
    "braes": "briːz",
    "brag": "bræɡ",
    "braggadocio": "bræɡɐdəʊsɪəʊ",
    "braggart": "bræɡɑːt",
    "braggarts": "bræɡɑːts",
    "bragged": "bræɡd",
    "bragger": "bræɡɐ",
    "bragging": "bræɡɪŋ",
    "brags": "bræɡz",
    "braid": "breɪd",
    "braided": "breɪdɪd",
    "braiding": "breɪdɪŋ",
    "braids": "breɪdz",
    "braille": "breɪl",
    "brails": "breɪlz",
    "brain": "breɪn",
    "brainchild": "breɪntʃaɪld",
    "brained": "breɪnd",
    "brainier": "breɪnɪɐ",
    "brainiest": "breɪnɪəst",
    "braininess": "breɪnɪnəs",
    "brainless": "breɪnləs",
    "brainpower": "breɪnpaʊɐ",
    "brains": "breɪnz",
    "brainstorm": "breɪnstɔːm",
    "brainstormed": "breɪnstɔːmd",
    "brainstorming": "breɪnstɔːmɪŋ",
    "brainteaser": "breɪntiːzɐ",
    "brainteasers": "breɪntiːzəz",
    "brainwash": "breɪnwɒʃ",
    "brainwashed": "breɪnwɒʃt",
    "brainwashing": "breɪnwɒʃɪŋ",
    "brainwave": "breɪnweɪv",
    "brainwaves": "breɪnweɪvz",
    "brainwork": "breɪnwɜːk",
    "brainy": "breɪni",
    "braise": "breɪz",
    "braised": "breɪzd",
    "braises": "breɪzɪz",
    "braising": "breɪzɪŋ",
    "brake": "breɪk",
    "braked": "breɪkt",
    "brakeman": "breɪkmən",
    "brakes": "breɪks",
    "brakesman": "breɪksmən",
    "braking": "breɪkɪŋ",
    "braless": "brɑːləs",
    "bramble": "bræmbəl",
    "brambles": "bræmbəlz",
    "brambling": "bræmblɪŋ",
    "bramblings": "bræmblɪŋz",
    "brambly": "bræmbli",
    "bran": "bræn",
    "branch": "brɑːntʃ",
    "branched": "brɑːntʃt",
    "branches": "brɑːntʃɪz",
    "branching": "brɑːntʃɪŋ",
    "brand": "brænd",
    "branded": "brændɪd",
    "brander": "brændɐ",
    "brandied": "brændɪd",
    "brandies": "brændɪz",
    "branding": "brændɪŋ",
    "brandish": "brændɪʃ",
    "brandished": "brændɪʃt",
    "brandishes": "brændɪʃɪz",
    "brandishing": "brændɪʃɪŋ",
    "brands": "brændz",
    "brandy": "brændi",
    "brant": "brɑːnt",
    "bras": "brɑːz",
    "brash": "bræʃ",
    "brasher": "bræʃɐ",
    "brashest": "bræʃəst",
    "brashly": "bræʃli",
    "brashness": "bræʃnəs",
    "brashy": "bræʃi",
    "brassbound": "brɑːsbaʊnd",
    "brass": "brɑːs",
    "brasserie": "brɑːsəri",
    "brasseries": "brɑːsəriz",
    "brasses": "brɑːsɪz",
    "brassica": "brɑːsɪkɐ",
    "brassie": "brɑːsi",
    "brassier": "brɑːsɪɐ",
    "brassiere": "brɑːsieə",
    "brassieres": "brɑːsieəz",
    "brassiness": "brɑːsɪnəs",
    "brassware": "brɑːsweə",
    "bratty": "bræti",
    "bratwurst": "brætwɜːst",
    "bravado": "brævɑːdəʊ",
    "brave": "breɪv",
    "braved": "breɪvd",
    "bravely": "breɪvli",
    "braveness": "breɪvnəs",
    "braver": "breɪvɐ",
    "bravery": "breɪvəri",
    "braves": "breɪvz",
    "bravest": "breɪvəst",
    "braving": "breɪvɪŋ",
    "bravissimo": "brævɪsɪməʊ",
    "bravo": "brɑːvəʊ",
    "bravos": "brɑːvəʊz",
    "bravura": "brævjɔːrɐ",
    "braw": "brɔː",
    "brawl": "brɔːl",
    "brawled": "brɔːld",
    "brawler": "brɔːlɐ",
    "brawlers": "brɔːləz",
    "brawling": "brɔːlɪŋ",
    "brawls": "brɔːlz",
    "brawn": "brɔːn",
    "brawny": "brɔːni",
    "bray": "breɪ",
    "brayed": "breɪd",
    "braying": "breɪɪŋ",
    "brays": "breɪz",
    "braze": "breɪz",
    "brazed": "breɪzd",
    "brazen": "breɪzən",
    "brazenly": "breɪzənli",
    "brazenness": "breɪzənnəs",
    "brazier": "breɪzɪɐ",
    "braziers": "breɪziəz",
    "brazil": "brɐzɪl",
    "brazils": "brɐzɪlz",
    "brazing": "breɪzɪŋ",
    "breach": "briːtʃ",
    "breached": "briːtʃt",
    "breaches": "briːtʃɪz",
    "breaching": "briːtʃɪŋ",
    "breadbasket": "brɛdbɑːskɪt",
    "bread": "brɛd",
    "breadboard": "brɛdbɔːd",
    "breadcrumb": "brɛdkrʌm",
    "breadcrumbs": "brɛdkrʌmz",
    "breaded": "brɛdɪd",
    "breadfruit": "brɛdfruːt",
    "breading": "brɛdɪŋ",
    "breadline": "brɛdlaɪn",
    "breads": "brɛdz",
    "breadth": "brɛdθ",
    "breadwinner": "brɛdwɪnɐ",
    "breadwinners": "brɛdwɪnəz",
    "breakable": "breɪkəbəl",
    "breakables": "breɪkəbəlz",
    "breakage": "breɪkɪdʒ",
    "breakages": "breɪkɪdʒɪz",
    "breakaway": "breɪkəweɪ",
    "breakaways": "breɪkəweɪz",
    "break": "breɪk",
    "breakdown": "breɪkdaʊn",
    "breakdowns": "breɪkdaʊnz",
    "breaker": "breɪkɐ",
    "breakers": "breɪkəz",
    "breakeven": "breɪkɛvən",
    "breakfast": "brɛkfəst",
    "breakfasted": "brɛkfəstɪd",
    "breakfasting": "brɛkfəstɪŋ",
    "breakfasts": "brɛkfəsts",
    "breakfront": "breɪkfrʌnt",
    "breaking": "breɪkɪŋ",
    "breakneck": "breɪknɛk",
    "breakout": "breɪkaʊt",
    "breakouts": "breɪkaʊts",
    "breakpoints": "breɪkpɔɪnts",
    "breaks": "breɪks",
    "breakthrough": "breɪkθruː",
    "breakthroughs": "breɪkθruːz",
    "breakup": "breɪkʌp",
    "breakups": "breɪkʌps",
    "breakwater": "breɪkwɔːtɐ",
    "breakwaters": "breɪkwɔːtəz",
    "bream": "briːm",
    "breams": "briːmz",
    "breast": "brɛst",
    "breastbone": "brɛstbəʊn",
    "breasted": "brɛstɪd",
    "breastfed": "brɛstft",
    "breastfeed": "brɛstfiːd",
    "breastfeeding": "brɛstfiːdɪŋ",
    "breastfeeds": "brɛstfiːdz",
    "breasting": "brɛstɪŋ",
    "breastplate": "brɛstpleɪt",
    "breastplates": "brɛstpleɪts",
    "breasts": "brɛsts",
    "breaststroke": "brɛststrəʊk",
    "breathable": "briːðəbəl",
    "breathalyse": "brɛθɐlaɪz",
    "breathalysed": "brɛθɐlaɪzd",
    "breathalyser": "brɛθɐlaɪsɐ",
    "breathalysers": "brɛθɐlaɪsəz",
    "breathalysing": "brɛθɐlaɪzɪŋ",
    "breath": "brɛθ",
    "breathe": "briːð",
    "breathed": "briːðd",
    "breather": "briːðɐ",
    "breathers": "briːðəz",
    "breathes": "briːðz",
    "breathing": "briːðɪŋ",
    "breathless": "brɛθləs",
    "breathlessly": "brɛθləsli",
    "breathlessness": "brɛθləsnəs",
    "breaths": "brɛθs",
    "breathtaking": "brɛθteɪkɪŋ",
    "breathtakingly": "brɛθteɪkɪŋli",
    "breathy": "brɛθi",
    "breccia": "brɛksiɐ",
    "bred": "brɛd",
    "brede": "briːd",
    "bree": "briː",
    "breech": "briːtʃ",
    "breeches": "briːtʃɪz",
    "breeching": "briːtʃɪŋ",
    "breed": "briːd",
    "breeder": "briːdɐ",
    "breeders": "briːdəz",
    "breeding": "briːdɪŋ",
    "breeds": "briːdz",
    "breeks": "briːks",
    "breeze": "briːz",
    "breezed": "briːzd",
    "breezes": "briːzɪz",
    "breezeway": "briːzweɪ",
    "breezier": "briːzɪɐ",
    "breeziest": "briːzɪəst",
    "breezily": "briːzɪli",
    "breeziness": "briːzɪnəs",
    "breezing": "briːzɪŋ",
    "breezy": "briːzi",
    "brent": "brɛnt",
    "brents": "brɛnts",
    "brethren": "brɛðrən",
    "breve": "briːv",
    "brevet": "brɛvɪt",
    "breviary": "brɛvjəri",
    "brevity": "brɛvɪti",
    "brew": "bruː",
    "brewed": "bruːd",
    "brewer": "bruːɐ",
    "breweries": "bruːəriz",
    "brewers": "bruːəz",
    "brewery": "bruːəri",
    "brewhouse": "bruːhaʊs",
    "brewing": "bruːɪŋ",
    "brewis": "bruːiz",
    "brews": "bruːz",
    "briar": "braɪə",
    "briars": "braɪəz",
    "briarwood": "braɪəwʊd",
    "bribable": "braɪbəbəl",
    "bribe": "braɪb",
    "bribed": "braɪbd",
    "bribery": "braɪbəri",
    "bribes": "braɪbz",
    "bribing": "braɪbɪŋ",
    "brickbat": "brɪkbæt",
    "brickbats": "brɪkbæts",
    "brick": "brɪk",
    "bricked": "brɪkt",
    "brickie": "brɪki",
    "brickies": "brɪkiz",
    "bricking": "brɪkɪŋ",
    "bricklayer": "brɪkleɪɐ",
    "bricklayers": "brɪkleɪəz",
    "bricklaying": "brɪkleɪɪŋ",
    "brickle": "brɪkəl",
    "bricks": "brɪks",
    "brickwork": "brɪkwɜːk",
    "brickyard": "brɪkjɑːd",
    "bricky": "brɪki",
    "bricolage": "brɪkɒlɪdʒ",
    "bridal": "braɪdəl",
    "bridals": "braɪdəlz",
    "bride": "braɪd",
    "bridegroom": "braɪdɡruːm",
    "bridegrooms": "braɪdɡruːmz",
    "brides": "braɪdz",
    "bridesmaid": "braɪdsmeɪd",
    "bridesmaids": "braɪdsmeɪdz",
    "bridewell": "braɪdwɛl",
    "bridgeable": "brɪdʒəbəl",
    "bridge": "brɪdʒ",
    "bridged": "brɪdʒd",
    "bridgehead": "brɪdʒhɛd",
    "bridges": "brɪdʒɪz",
    "bridging": "brɪdʒɪŋ",
    "bridle": "braɪdəl",
    "bridled": "braɪdəld",
    "bridles": "braɪdəlz",
    "bridleway": "braɪdəlweɪ",
    "bridleways": "braɪdəlweɪz",
    "brie": "briː",
    "brief": "briːf",
    "briefcase": "briːfkeɪs",
    "briefcases": "briːfkeɪsɪz",
    "briefed": "briːft",
    "briefer": "briːfɐ",
    "briefest": "briːfəst",
    "briefing": "briːfɪŋ",
    "briefings": "briːfɪŋz",
    "briefless": "briːfləs",
    "briefly": "briːfli",
    "briefs": "briːfs",
    "brier": "braɪə",
    "briers": "braɪəz",
    "brigade": "brɪɡeɪd",
    "brigades": "brɪɡeɪdz",
    "brigadier": "brɪɡɐdiə",
    "brigadiers": "brɪɡɐdiəz",
    "brigand": "brɪɡænd",
    "brigands": "brɪɡændz",
    "brigantine": "brɪɡɑːntiːn",
    "brig": "brɪɡ",
    "bright": "braɪt",
    "brighten": "braɪtən",
    "brightened": "braɪtənd",
    "brightener": "braɪtənɐ",
    "brighteners": "braɪtənəz",
    "brightening": "braɪtənɪŋ",
    "brightens": "braɪtənz",
    "brighter": "braɪtɐ",
    "brightest": "braɪtəst",
    "brightly": "braɪtli",
    "brightness": "braɪtnəs",
    "brightnesses": "braɪtnəsɪz",
    "brights": "braɪts",
    "brightwork": "braɪtwɜːk",
    "brigs": "brɪɡz",
    "brill": "brɪl",
    "brilliance": "brɪliːəns",
    "brilliancy": "brɪlɪənsi",
    "brilliant": "brɪlɪənt",
    "brilliantine": "brɪlɪəntiːn",
    "brilliantly": "brɪlɪəntli",
    "brim": "brɪm",
    "brimful": "brɪmfəl",
    "brimless": "brɪmləs",
    "brimmed": "brɪmd",
    "brimmer": "brɪmɐ",
    "brimming": "brɪmɪŋ",
    "brims": "brɪmz",
    "brimstone": "brɪmstəʊn",
    "brindle": "brɪndəl",
    "brindled": "brɪndəld",
    "brine": "braɪn",
    "bring": "brɪŋ",
    "bringer": "brɪŋɐ",
    "bringers": "brɪŋəz",
    "bringing": "brɪŋɪŋ",
    "brings": "brɪŋz",
    "brink": "brɪŋk",
    "brinkmanship": "brɪŋkmənʃɪp",
    "brinks": "brɪŋks",
    "brinksmanship": "brɪŋksmənʃɪp",
    "briny": "braɪni",
    "brio": "briːəʊ",
    "brioche": "briːəʊʃ",
    "brioches": "briːəʊʃɪz",
    "briony": "brɪɒni",
    "briquette": "brɪkɛt",
    "briquettes": "brɪkɛts",
    "bris": "brɪs",
    "brisk": "brɪsk",
    "brisker": "brɪskɐ",
    "brisket": "brɪskɪt",
    "briskly": "brɪskli",
    "briskness": "brɪsknəs",
    "bristle": "brɪsəl",
    "bristled": "brɪsəld",
    "bristles": "brɪsəlz",
    "bristletail": "brɪsəlteɪl",
    "bristling": "brɪslɪŋ",
    "bristly": "brɪstli",
    "brit": "brɪt",
    "britches": "brɪtʃɪz",
    "brits": "brɪts",
    "brittle": "brɪtəl",
    "brittleness": "brɪtəlnəs",
    "broach": "brəʊtʃ",
    "broached": "brəʊtʃt",
    "broaches": "brəʊtʃɪz",
    "broaching": "brəʊtʃɪŋ",
    "broadband": "brɔːdbænd",
    "broad": "brɔːd",
    "broadcast": "brɔːdkɑːst",
    "broadcasted": "brɔːdkɑːstɪd",
    "broadcaster": "brɔːdkɑːstɐ",
    "broadcasters": "brɔːdkɑːstəz",
    "broadcasting": "brɔːdkɑːstɪŋ",
    "broadcasts": "brɔːdkɑːsts",
    "broadcloth": "brɔːdklɒθ",
    "broaden": "brɔːdən",
    "broadened": "brɔːdənd",
    "broadening": "brɔːdənɪŋ",
    "broadens": "brɔːdənz",
    "broader": "brɔːdɐ",
    "broadest": "brɔːdəst",
    "broadleaf": "brɔːdliːf",
    "broadleaved": "brɔːdliːvd",
    "broadly": "brɔːdli",
    "broadminded": "brɔːdmaɪndɪd",
    "broadness": "brɔːdnəs",
    "broads": "brɔːdz",
    "broadsheet": "brɔːdʃiːt",
    "broadsheets": "brɔːdʃiːts",
    "broadside": "brɔːdsaɪd",
    "broadsides": "brɔːdsaɪdz",
    "broadsword": "brɔːdsɔːd",
    "broadswords": "brɔːdsɔːdz",
    "brocade": "brɒkeɪd",
    "brocades": "brɒkeɪdz",
    "broccoli": "brɒkəli",
    "broch": "brɒk",
    "brochette": "brətʃɛt",
    "brochure": "brəʊʃɐ",
    "brochures": "brəʊʃəz",
    "brock": "brɒk",
    "brocket": "brɒkɪt",
    "brogan": "brəʊɡən",
    "brogue": "brəʊɡ",
    "brogues": "brəʊɡz",
    "broil": "brɔɪl",
    "broiled": "brɔɪld",
    "broiler": "brɔɪlɐ",
    "broilers": "brɔɪləz",
    "broiling": "brɔɪlɪŋ",
    "broke": "brəʊk",
    "broken": "brəʊkən",
    "brokenhearted": "brəʊkənhɑːtɪd",
    "brokenly": "brəʊkənli",
    "brokenness": "brəʊkənnəs",
    "brokerage": "brəʊkrɪdʒ",
    "brokerages": "brəʊkrɪdʒɪz",
    "broker": "brəʊkɐ",
    "brokered": "brəʊkəd",
    "brokering": "brəʊkərɪŋ",
    "brokers": "brəʊkəz",
    "broking": "brəʊkɪŋ",
    "brollies": "brɒlɪz",
    "brolly": "brɒli",
    "bromate": "brɒmeɪt",
    "bromeliad": "brəʊmiːlɪæd",
    "bromide": "brɒmaɪd",
    "bromidic": "brəmɪdɪk",
    "bromine": "brɒmaɪn",
    "bronc": "brɒŋk",
    "bronchial": "brɒnkɪəl",
    "bronchi": "brɒnkaɪ",
    "bronchioles": "brɒnkɪəʊlz",
    "bronchitis": "brənkaɪtɪs",
    "bronchopneumonia": "brɒnkənjuːməʊniə",
    "bronchoscope": "brɒnkəskəʊp",
    "bronchus": "brɒnkəs",
    "bronco": "brɒnkəʊ",
    "broncos": "brɒnkəʊz",
    "brontosaurs": "brɒntəsɔːz",
    "brontosaurus": "brɒntəsɔːrəs",
    "brontosauruses": "brɒntəsɔːrəsɪz",
    "bronze": "brɒnz",
    "bronzed": "brɒnzd",
    "bronzes": "brɒnzɪz",
    "bronzing": "brɒnzɪŋ",
    "bronzy": "brɒnzi",
    "brooch": "brəʊtʃ",
    "brooches": "bruːtʃɪz",
    "brood": "bruːd",
    "brooded": "bruːdɪd",
    "brooder": "bruːdɐ",
    "broodiness": "bruːdɪnəs",
    "brooding": "bruːdɪŋ",
    "broods": "bruːdz",
    "broody": "bruːdi",
    "brook": "brʊk",
    "brooked": "brʊkt",
    "brooking": "brʊkɪŋ",
    "brooks": "brʊks",
    "broom": "bruːm",
    "brooms": "bruːmz",
    "broomstick": "bruːmstɪk",
    "broomsticks": "bruːmstɪks",
    "brose": "brəʊz",
    "broth": "brɒθ",
    "brothel": "brɒθəl",
    "brothels": "brɒθəlz",
    "brother": "brʌðɐ",
    "brotherhood": "brʌðəhʊd",
    "brotherhoods": "brʌðəhʊdz",
    "brotherly": "brʌðəli",
    "brothers": "brʌðəz",
    "broths": "brɒθs",
    "brougham": "brʌfəm",
    "brought": "brɔːt",
    "brouhaha": "braʊhɑːhɐ",
    "brow": "braʊ",
    "browbeat": "braʊbiːt",
    "browbeaten": "braʊbiːtən",
    "browbeating": "braʊbiːtɪŋ",
    "brown": "braʊn",
    "browned": "braʊnd",
    "browner": "braʊnɐ",
    "brownfield": "braʊnfiːld",
    "brownie": "braʊni",
    "brownies": "braʊnɪz",
    "browning": "braʊnɪŋ",
    "brownish": "braʊnɪʃ",
    "brownness": "braʊnnəs",
    "browns": "braʊnz",
    "brownstone": "braʊnstəʊn",
    "brows": "braʊz",
    "browse": "braʊz",
    "browsed": "braʊzd",
    "browser": "braʊzɐ",
    "browsers": "braʊzəz",
    "browses": "braʊzɪz",
    "browsing": "braʊzɪŋ",
    "brr": "biːɑːrɑː",
    "brucellosis": "bruːsɪləʊsɪs",
    "bruin": "bruːɪn",
    "bruins": "bruːɪnz",
    "bruise": "bruːz",
    "bruised": "bruːzd",
    "bruiser": "bruːzɐ",
    "bruisers": "bruːzəz",
    "bruises": "bruːzɪz",
    "bruising": "bruːzɪŋ",
    "bruit": "bruːt",
    "bruited": "bruːtɪd",
    "brunch": "brʌntʃ",
    "brunches": "brʌntʃɪz",
    "brunet": "brʌnɪt",
    "brunette": "brʌnɛt",
    "brunettes": "brʌnɛts",
    "brunt": "brʌnt",
    "brush": "brʌʃ",
    "brushed": "brʌʃt",
    "brushes": "brʌʃɪz",
    "brushing": "brʌʃɪŋ",
    "brushstroke": "brʌʃstrəʊk",
    "brushstrokes": "brʌʃstrəʊks",
    "brushwood": "brʌʃwʊd",
    "brushwork": "brʌʃwɜːk",
    "brushy": "brʌʃi",
    "brusque": "brʌsk",
    "brutal": "bruːtəl",
    "brutalisation": "bruːtəlaɪzeɪʃən",
    "brutalise": "bruːtəlaɪz",
    "brutalised": "bruːtəlaɪzd",
    "brutalises": "bruːtəlaɪzɪz",
    "brutalising": "bruːtəlaɪzɪŋ",
    "brutalism": "bruːtəlɪzəm",
    "brutalist": "bruːtəlɪst",
    "brutalities": "bruːtælɪtiz",
    "brutality": "bruːtælɪti",
    "brutally": "bruːtəli",
    "brut": "brʌt",
    "brute": "bruːt",
    "brutes": "bruːts",
    "brutish": "bruːtɪʃ",
    "brutishly": "bruːtɪʃli",
    "bryony": "braɪəni",
    "bubba": "bʌbɐ",
    "bub": "bʌb",
    "bubble": "bʌbəl",
    "bubbled": "bʌbəld",
    "bubblegum": "bʌbəlɡəm",
    "bubbler": "bʌblɐ",
    "bubbles": "bʌbəlz",
    "bubblier": "bʌbliɐ",
    "bubbliest": "bʌbliəst",
    "bubbling": "bʌblɪŋ",
    "bubbly": "bʌbli",
    "bubo": "bjuːbəʊ",
    "bubonic": "bjuːbɒnɪk",
    "bubs": "bʌbz",
    "buccal": "bʌkəl",
    "buccaneer": "bʌkɐniə",
    "buccaneering": "bʌkɐniərɪŋ",
    "buccaneers": "bʌkɐniəz",
    "buckaroo": "bʌkɐruː",
    "buckaroos": "bʌkɐruːz",
    "buck": "bʌk",
    "buckboard": "bʌkbɔːd",
    "bucked": "bʌkt",
    "bucket": "bʌkɪt",
    "bucketful": "bʌkɪtfəl",
    "bucketfuls": "bʌkɛtfəlz",
    "bucketing": "bʌkɪtɪŋ",
    "buckets": "bʌkɪts",
    "buckeye": "bʌkaɪ",
    "bucking": "bʌkɪŋ",
    "buckle": "bʌkəl",
    "buckled": "bʌkəld",
    "buckler": "bʌklɐ",
    "bucklers": "bʌkləz",
    "buckles": "bʌkəlz",
    "buckling": "bʌklɪŋ",
    "buckminsterfullerene": "bʌkmɪnstəfʊləriːn",
    "bucko": "bʌkəʊ",
    "buckram": "bʌkræm",
    "bucks": "bʌks",
    "buckshee": "bʌkʃiː",
    "buckshot": "bʌkʃɒt",
    "buckskin": "bʌkskɪn",
    "buckskins": "bʌkskɪnz",
    "buckthorn": "bʌkθɔːn",
    "buckwheat": "bʌkwiːt",
    "bucolic": "bjuːkɒlɪk",
    "bud": "bʌd",
    "budded": "bʌdɪd",
    "buddies": "bʌdɪz",
    "budding": "bʌdɪŋ",
    "buddle": "bʌdəl",
    "buddleia": "bʌdleɪɐ",
    "buddleias": "bʌdleɪəz",
    "buddy": "bʌdi",
    "budge": "bʌdʒ",
    "budged": "bʌdʒd",
    "budgerigar": "bʌdʒərɪɡɑː",
    "budgerigars": "bʌdʒərɪɡɑːz",
    "budges": "bʌdʒɪz",
    "budgetary": "bʌdʒɪtəri",
    "budget": "bʌdʒɪt",
    "budgeted": "bʌdʒɪtɪd",
    "budgeting": "bʌdʒɪtɪŋ",
    "budgets": "bʌdʒɪts",
    "budgie": "bʌdʒi",
    "budgies": "bʌdʒɪz",
    "budging": "bʌdʒɪŋ",
    "buds": "bʌdz",
    "bueno": "bjuːənəʊ",
    "buffalo": "bʌfələʊ",
    "buffaloes": "bʌfələʊz",
    "buffalos": "bʌfələʊz",
    "buff": "bʌf",
    "buffed": "bʌft",
    "buffer": "bʌfɐ",
    "buffered": "bʌfəd",
    "buffering": "bʌfərɪŋ",
    "buffers": "bʌfəz",
    "buffeted": "bʌfɪtɪd",
    "buffeting": "bʌfɪtɪŋ",
    "buffing": "bʌfɪŋ",
    "buffoon": "bʌfuːn",
    "buffoonery": "bʌfuːnəri",
    "buffoonish": "bʌfuːnɪʃ",
    "buffoons": "bʌfuːnz",
    "buffs": "bʌfs",
    "bug": "bʌɡ",
    "bugbear": "bʌɡbeə",
    "bugbears": "bʌɡbeəz",
    "bugged": "bʌɡd",
    "bugger": "bʌɡɐ",
    "buggered": "bʌɡəd",
    "buggering": "bʌɡərɪŋ",
    "buggers": "bʌɡəz",
    "buggery": "bʌɡəri",
    "buggies": "bʌɡɪz",
    "bugging": "bʌɡɪŋ",
    "buggy": "bʌɡi",
    "bugle": "bjuːɡəl",
    "bugler": "bjuːɡlɐ",
    "buglers": "bjuːɡləz",
    "bugles": "bjuːɡəlz",
    "bugling": "bʌɡlɪŋ",
    "bugloss": "bʌɡlɒs",
    "bugs": "bʌɡz",
    "buhl": "buːl",
    "build": "bɪld",
    "builder": "bɪldɐ",
    "builders": "bɪldəz",
    "building": "bɪldɪŋ",
    "buildings": "bɪldɪŋz",
    "builds": "bɪldz",
    "buildup": "bɪldʌp",
    "built": "bɪlt",
    "bulb": "bʌlb",
    "bulbils": "bʌlbɪlz",
    "bulbous": "bʌlbəs",
    "bulbs": "bʌlbz",
    "bulbul": "bʌlbʌl",
    "bulge": "bʌldʒ",
    "bulged": "bʌldʒd",
    "bulges": "bʌldʒɪz",
    "bulging": "bʌldʒɪŋ",
    "bulgur": "bʌlɡɐ",
    "bulgy": "bʌldʒi",
    "bulimia": "bjʊlɪmiə",
    "bulimic": "bjʊlɪmɪk",
    "bulk": "bʌlk",
    "bulked": "bʌlkt",
    "bulkhead": "bʌlkhɛd",
    "bulkheads": "bʌlkhɛdz",
    "bulkier": "bʌlkiɐ",
    "bulkiest": "bʌlkiəst",
    "bulkiness": "bʌlkinəs",
    "bulking": "bʌlkɪŋ",
    "bulks": "bʌlks",
    "bulky": "bʌlki",
    "bulla": "bʊlɐ",
    "bullace": "bʊleɪs",
    "bullaces": "bʊleɪsɪz",
    "bull": "bʊl",
    "bulldog": "bʊldɒɡ",
    "bulldogs": "bʊldɒɡz",
    "bulldoze": "bʊldəʊz",
    "bulldozed": "bʊldəʊzd",
    "bulldozer": "bʊldəʊzɐ",
    "bulldozers": "bʊldəʊzəz",
    "bulldozes": "bʊldəʊzɪz",
    "bulldozing": "bʊldəʊzɪŋ",
    "bullet": "bʊlɪt",
    "bulletin": "bʊlɪtɪn",
    "bulletins": "bʊlɪtɪnz",
    "bulletproof": "bʊlɪtpruːf",
    "bullets": "bʊlɪts",
    "bullfight": "bʊlfaɪt",
    "bullfighter": "bʊlfaɪtɐ",
    "bullfighters": "bʊlfaɪtəz",
    "bullfighting": "bʊlfaɪtɪŋ",
    "bullfights": "bʊlfaɪts",
    "bullfinch": "bʊlfɪntʃ",
    "bullfinches": "bʊlfɪntʃɪz",
    "bullfrog": "bʊlfrɒɡ",
    "bullfrogs": "bʊlfrɒɡz",
    "bullhead": "bʊlhɛd",
    "bullheads": "bʊlhɛdz",
    "bullhorn": "bʊlhɔːn",
    "bullied": "bʊlɪd",
    "bullies": "bʊlɪz",
    "bulling": "bʊlɪŋ",
    "bullion": "bʊliən",
    "bullish": "bʊlɪʃ",
    "bullishness": "bʊlɪʃnəs",
    "bullnose": "bʊlnəʊz",
    "bullock": "bʊlək",
    "bullocks": "bʊləks",
    "bullring": "bʊlrɪŋ",
    "bulls": "bʊlz",
    "bullshit": "bʊlʃɪt",
    "bullshitted": "bʊlʃɪtɪd",
    "bullshitter": "bʊlʃɪtɐ",
    "bullshitters": "bʊlʃɪtəz",
    "bullshitting": "bʊlʃɪtɪŋ",
    "bullwhip": "bʊlwɪp",
    "bully": "bʊli",
    "bullyboy": "bʊlɪbɔɪ",
    "bullyboys": "bʊlɪbɔɪz",
    "bullying": "bʊlɪɪŋ",
    "bulrush": "bʊlrʌʃ",
    "bulrushes": "bʊlrʌʃɪz",
    "bulwark": "bʊlwɔːk",
    "bulwarks": "bʊlwɔːks",
    "bumbag": "bʌmbæɡ",
    "bumblebee": "bʌmbəlbiː",
    "bumblebees": "bʌmbəlbiːz",
    "bumble": "bʌmbəl",
    "bumbled": "bʌmbəld",
    "bumbler": "bʌmblɐ",
    "bumblers": "bʌmbləz",
    "bumbles": "bʌmbəlz",
    "bumbling": "bʌmblɪŋ",
    "bum": "bʌm",
    "bumf": "bʌmf",
    "bummed": "bʌmd",
    "bummer": "bʌmɐ",
    "bummers": "bʌməz",
    "bumming": "bʌmɪŋ",
    "bump": "bʌmp",
    "bumped": "bʌmpt",
    "bumper": "bʌmpɐ",
    "bumpers": "bʌmpəz",
    "bumph": "bʌmf",
    "bumpier": "bʌmpɪɐ",
    "bumpiest": "bʌmpɪəst",
    "bumpiness": "bʌmpɪnəs",
    "bumping": "bʌmpɪŋ",
    "bumpkin": "bʌmpkɪn",
    "bumpkins": "bʌmpkɪnz",
    "bumps": "bʌmps",
    "bumptious": "bʌmpʃəs",
    "bumptiousness": "bʌmpʃəsnəs",
    "bumpy": "bʌmpi",
    "bums": "bʌmz",
    "bun": "bʌn",
    "bunch": "bʌntʃ",
    "bunched": "bʌntʃt",
    "bunches": "bʌntʃɪz",
    "bunching": "bʌntʃɪŋ",
    "bunchy": "bʌntʃi",
    "bundle": "bʌndəl",
    "bundled": "bʌndəld",
    "bundles": "bʌndəlz",
    "bundling": "bʌndlɪŋ",
    "bungalow": "bʌŋɡɐləʊ",
    "bungalows": "bʌŋɡɐləʊz",
    "bung": "bʌŋ",
    "bunged": "bʌndʒd",
    "bungee": "bʌndʒiː",
    "bungees": "bʌndʒiːz",
    "bunghole": "bʌŋhəʊl",
    "bunging": "bʌndʒɪŋ",
    "bungle": "bʌŋɡəl",
    "bungled": "bʌŋɡəld",
    "bungler": "bʌŋɡlɐ",
    "bungles": "bʌŋɡəlz",
    "bungling": "bʌŋɡəlɪŋ",
    "bungs": "bʌŋz",
    "bunion": "bʌnɪən",
    "bunions": "bʌnɪənz",
    "bunk": "bʌŋk",
    "bunked": "bʌŋkt",
    "bunker": "bʌŋkɐ",
    "bunkers": "bʌŋkəz",
    "bunkhouse": "bʌŋkhaʊs",
    "bunking": "bʌŋkɪŋ",
    "bunks": "bʌŋks",
    "bunkum": "bʌŋkəm",
    "bunnies": "bʌnɪz",
    "bunny": "bʌni",
    "buns": "bʌnz",
    "bunt": "bʌnt",
    "bunter": "bʌntɐ",
    "bunting": "bʌntɪŋ",
    "buntings": "bʌntɪŋz",
    "buntline": "bʌntlaɪn",
    "bunyip": "bʌnjɪp",
    "buoyancy": "bɔɪənsi",
    "buoyant": "bɔɪənt",
    "buoyantly": "bɔɪəntli",
    "buoy": "bɔɪ",
    "buoyed": "bɔɪd",
    "buoys": "bɔɪz",
    "buran": "bjʊrən",
    "bur": "bɜː",
    "burble": "bɜːbəl",
    "burbled": "bɜːbəld",
    "burbles": "bɜːbəlz",
    "burbling": "bɜːblɪŋ",
    "burbs": "bɜːbz",
    "burden": "bɜːdən",
    "burdened": "bɜːdənd",
    "burdening": "bɜːdənɪŋ",
    "burdens": "bɜːdənz",
    "burdensome": "bɜːdənsʌm",
    "burdock": "bɜːdɒk",
    "bureau": "bjɔːrəʊ",
    "bureaucracies": "bjɔːrɒkrəsiz",
    "bureaucracy": "bjɔːrɒkrəsi",
    "bureaucrat": "bjɔːrəʊkræt",
    "bureaucratically": "bjɔːrəʊkrætɪkli",
    "bureaucratic": "bjɔːrəʊkrætɪk",
    "bureaucrats": "bjɔːrəʊkræts",
    "bureaus": "bjɔːrəʊz",
    "bureaux": "bjɔːrəʊ",
    "burette": "bjɔːrɛt",
    "burg": "bɜːɡ",
    "burgeon": "bɜːdʒən",
    "burgeoned": "bɜːdʒənd",
    "burgeoning": "bɜːdʒənɪŋ",
    "burger": "bɜːɡɐ",
    "burgers": "bɜːɡəz",
    "burgess": "bɜːdʒɛs",
    "burgesses": "bɜːdʒɛsɪz",
    "burgh": "bɜːɡ",
    "burghers": "bɜːɡəz",
    "burghs": "bɜːɡz",
    "burglar": "bɜːɡlɐ",
    "burglaries": "bɜːɡləriz",
    "burglarised": "bɜːɡləraɪzd",
    "burglars": "bɜːɡləz",
    "burglary": "bɜːɡləri",
    "burgle": "bɜːɡəl",
    "burgled": "bɜːɡəld",
    "burgles": "bɜːɡəlz",
    "burgling": "bɜːɡlɪŋ",
    "burgundies": "bɜːɡʌndɪz",
    "burgundy": "bɜːɡʌndi",
    "burial": "bɛrɪəl",
    "burials": "bɛrɪəlz",
    "buried": "bɛrɪd",
    "burier": "bɛrɪɐ",
    "buries": "bɛrɪz",
    "burin": "bɛrɪn",
    "burka": "bɜːkɐ",
    "burke": "bɜːk",
    "burkes": "bɜːks",
    "burlap": "bɜːlæp",
    "burl": "bɜːl",
    "burlesque": "bɜːlɛsk",
    "burley": "bɜːli",
    "burly": "bɜːli",
    "burnable": "bɜːnəbəl",
    "burn": "bɜːn",
    "burned": "bɜːnd",
    "burner": "bɜːnɐ",
    "burners": "bɜːnəz",
    "burnet": "bɜːnɪt",
    "burning": "bɜːnɪŋ",
    "burnings": "bɜːnɪŋz",
    "burnish": "bɜːnɪʃ",
    "burnished": "bɜːnɪʃt",
    "burnisher": "bɜːnɪʃɐ",
    "burnishing": "bɜːnɪʃɪŋ",
    "burnout": "bɜːnaʊt",
    "burnouts": "bɜːnaʊts",
    "burns": "bɜːnz",
    "burnt": "bɜːnt",
    "burp": "bɜːp",
    "burped": "bɜːpt",
    "burping": "bɜːpɪŋ",
    "burps": "bɜːps",
    "burr": "bɜː",
    "burrito": "bʌriːtəʊ",
    "burritos": "bʌriːtəʊz",
    "burro": "bʌrəʊ",
    "burros": "bʌrəʊz",
    "burrow": "bʌrəʊ",
    "burrowed": "bʌrəʊd",
    "burrowing": "bʌrəʊɪŋ",
    "burrows": "bʌrəʊz",
    "burrs": "bɜːz",
    "burry": "bʌri",
    "bursa": "bɜːsɐ",
    "bursar": "bɜːsɐ",
    "bursaries": "bɜːsəriz",
    "bursars": "bɜːsəz",
    "bursary": "bɜːsəri",
    "burs": "bɜːz",
    "burse": "bɜːs",
    "bursitis": "bɜːsaɪtɪs",
    "burst": "bɜːst",
    "bursting": "bɜːstɪŋ",
    "bursts": "bɜːsts",
    "burton": "bɜːtən",
    "bury": "bɛri",
    "burying": "bɛrɪɪŋ",
    "busboy": "bʌsbɔɪ",
    "busboys": "bʌsbɔɪz",
    "bus": "bʌs",
    "busby": "bʌsbi",
    "bused": "bʌsd",
    "buses": "bʌsɪz",
    "bush": "bʊʃ",
    "bushcraft": "bʊʃkrɑːft",
    "bushed": "bʊʃt",
    "bushel": "bʊʃəl",
    "bushels": "bʊʃəlz",
    "bushes": "bʊʃɪz",
    "bushfire": "bʊʃfaɪə",
    "bushido": "bʊʃiːdəʊ",
    "bushier": "bʊʃɪɐ",
    "bushing": "bʊʃɪŋ",
    "bushland": "bʊʃlənd",
    "bushman": "bʊʃmən",
    "bushmaster": "bʊʃmɑːstɐ",
    "bushmasters": "bʊʃmɑːstəz",
    "bushmen": "bʊʃmɛn",
    "bushranger": "bʊʃreɪndʒɐ",
    "bushwhacked": "bʊʃwækt",
    "bushwhacking": "bʊʃwækɪŋ",
    "bushy": "bʊʃi",
    "busied": "bɪzɪd",
    "busier": "bɪzɪɐ",
    "busies": "bɪzɪz",
    "busiest": "bɪzɪəst",
    "busily": "bɪzɪli",
    "business": "bɪznəs",
    "businesses": "bɪznəsɪz",
    "businesslike": "bɪznəslaɪk",
    "businessman": "bɪznəsmən",
    "businessmen": "bɪznəsmɛn",
    "businessperson": "bɪznəspəsən",
    "businesswoman": "bɪznəswʊmən",
    "businesswomen": "bɪznəswɪmɪn",
    "busing": "bʌsɪŋ",
    "busk": "bʌsk",
    "busked": "bʌskt",
    "busker": "bʌskɐ",
    "buskers": "bʌskəz",
    "busking": "bʌskɪŋ",
    "busload": "bʌsləʊd",
    "busloads": "bʌsləʊdz",
    "busman": "bʌsmən",
    "buss": "bʌs",
    "bussed": "bʌst",
    "busses": "bʌsɪz",
    "bussing": "bʌsɪŋ",
    "bustard": "bʌstəd",
    "bustards": "bʌstədz",
    "bust": "bʌst",
    "busted": "bʌstɪd",
    "buster": "bʌstɐ",
    "busters": "bʌstəz",
    "bustiers": "bʌstiəz",
    "busting": "bʌstɪŋ",
    "bustle": "bʌsəl",
    "bustled": "bʌsəld",
    "bustles": "bʌsəlz",
    "bustling": "bʌslɪŋ",
    "busts": "bʌsts",
    "busty": "bʌsti",
    "busybodies": "bɪzɪbɒdɪz",
    "busybody": "bɪzɪbɒdi",
    "busy": "bɪzi",
    "busying": "bɪzɪɪŋ",
    "busyness": "bɪzɪnəs",
    "butane": "bjuːteɪn",
    "but": "bʌt",
    "butch": "bʊtʃ",
    "butcher": "bʊtʃɐ",
    "butchered": "bʊtʃəd",
    "butcheries": "bʊtʃəriz",
    "butchering": "bʊtʃərɪŋ",
    "butchers": "bʊtʃəz",
    "butchery": "bʊtʃəri",
    "butler": "bʌtlɐ",
    "butlers": "bʌtləz",
    "buts": "bʌts",
    "butt": "bʌt",
    "butte": "bʌt",
    "butted": "bʌtɪd",
    "butterball": "bʌtəbɔːl",
    "butter": "bʌtɐ",
    "buttercup": "bʌtəkʌp",
    "buttercups": "bʌtəkʌps",
    "buttered": "bʌtəd",
    "butterfat": "bʌtəfæt",
    "butterfingers": "bʌtəfɪŋɡəz",
    "butterfish": "bʌtəfɪʃ",
    "butterflied": "bʌtəflaɪd",
    "butterflies": "bʌtəflaɪz",
    "butterfly": "bʌtəflaɪ",
    "butterflying": "bʌtəflaɪɪŋ",
    "butteries": "bʌtəriz",
    "buttering": "bʌtərɪŋ",
    "buttermilk": "bʌtəmɪlk",
    "butternut": "bʌtənʌt",
    "butternuts": "bʌtənʌts",
    "butters": "bʌtəz",
    "butterscotch": "bʌtəskɒtʃ",
    "butterwort": "bʌtəwɔːt",
    "buttery": "bʌtəri",
    "buttes": "bʌts",
    "butties": "bʌtɪz",
    "butting": "bʌtɪŋ",
    "buttock": "bʌtək",
    "buttocks": "bʌtəks",
    "button": "bʌtən",
    "buttoned": "bʌtənd",
    "buttonhole": "bʌtənhəʊl",
    "buttonholed": "bʌtənhəʊld",
    "buttonholes": "bʌtənhəʊlz",
    "buttoning": "bʌtənɪŋ",
    "buttons": "bʌtənz",
    "buttress": "bʌtrəs",
    "buttressed": "bʌtrəst",
    "buttresses": "bʌtrəsɪz",
    "buttressing": "bʌtrəsɪŋ",
    "butts": "bʌts",
    "butty": "bʌti",
    "butyl": "bjuːtaɪl",
    "buxom": "bʌksəm",
    "buy": "baɪ",
    "buyback": "baɪbæk",
    "buyer": "baɪɐ",
    "buyers": "baɪəz",
    "buying": "baɪɪŋ",
    "buyout": "baɪaʊt",
    "buyouts": "baɪaʊts",
    "buys": "baɪz",
    "buzzard": "bʌzəd",
    "buzzards": "bʌzədz",
    "buzz": "bʌz",
    "buzzed": "bʌzd",
    "buzzer": "bʌzɐ",
    "buzzers": "bʌzəz",
    "buzzes": "bʌzɪz",
    "buzzing": "bʌzɪŋ",
    "buzzword": "bʌzwɜːd",
    "buzzwords": "bʌzwɜːdz",
    "bwana": "biːwɑːnɐ",
    "by": "baɪ",
    "bye": "baɪ",
    "byes": "baɪz",
    "bygone": "baɪɡɒn",
    "bygones": "baɪɡɒnz",
    "bylaw": "baɪlɔː",
    "bylaws": "baɪlɔːz",
    "byline": "baɪlaɪn",
    "bypass": "baɪpɑːs",
    "bypassed": "baɪpɑːst",
    "bypasses": "baɪpɑːsɪz",
    "bypassing": "baɪpɑːsɪŋ",
    "byproduct": "baɪprədʌkt",
    "byproducts": "baɪprədʌkts",
    "byre": "baɪə",
    "byres": "baɪəz",
    "bystander": "baɪstændɐ",
    "bystanders": "baɪstændəz",
    "byte": "baɪt",
    "bytes": "baɪts",
    "byway": "baɪweɪ",
    "byways": "baɪweɪz",
    "byword": "baɪwɜːd",
    "bywords": "baɪwɜːdz",
    "byzantine": "bɪzɑːntiːn",
    "cabal": "kɐbæl",
    "caballero": "kæbɐleərəʊ",
    "caballeros": "kæbɐleərəʊz",
    "cabana": "kæbɑːnɐ",
    "cabanas": "kæbɑːnəz",
    "cabaret": "kæbəreɪ",
    "cabarets": "kæbəreɪs",
    "cabbage": "kæbɪdʒ",
    "cabbages": "kæbɪdʒɪz",
    "cabbagy": "kæbædʒi",
    "cabbed": "kæbd",
    "cabbie": "kæbi",
    "cabbies": "kæbɪz",
    "cabbing": "kæbɪŋ",
    "cabby": "kæbi",
    "caber": "keɪbɐ",
    "cabernet": "kæbəneɪ",
    "cabers": "keɪbəz",
    "cabinet": "kæbɪnət",
    "cabinetmaker": "kæbaɪntmeɪkɐ",
    "cabinetmakers": "kæbaɪntmeɪkəz",
    "cabinetry": "kæbɪnətri",
    "cabinets": "kæbɪnəts",
    "cabin": "kæbɪn",
    "cabins": "kæbɪnz",
    "cab": "kæb",
    "cabled": "keɪbəld",
    "cablegram": "keɪbəlɡræm",
    "cable": "keɪbəl",
    "cables": "keɪbəlz",
    "cableway": "keɪbəlweɪ",
    "cabling": "keɪblɪŋ",
    "cabochon": "kæbɒtʃən",
    "cabochons": "kæbɒtʃənz",
    "caboodle": "kæbuːdəl",
    "caboose": "kæbuːs",
    "cabriole": "kæbrɪəʊl",
    "cabriolet": "kæbriːəleɪ",
    "cabs": "kæbz",
    "cacao": "kækaʊ",
    "cacciatore": "kæksɪætɐ",
    "cachalot": "kætʃɐlɒt",
    "cached": "kæʃt",
    "cache": "kæʃ",
    "caches": "kæʃɪz",
    "cachet": "kæʃeɪ",
    "cachets": "kæʃeɪs",
    "caching": "kæʃɪŋ",
    "cacique": "kæsiːk",
    "cackled": "kækəld",
    "cackle": "kækəl",
    "cackles": "kækəlz",
    "cackling": "kæklɪŋ",
    "cacophonous": "kɐkɒfənəs",
    "cacophony": "kɐkɒfəni",
    "cacti": "kæktaɪ",
    "cactuses": "kæktəsɪz",
    "cactus": "kæktəs",
    "cadaver": "kɐdævɐ",
    "cadaverous": "kɐdævərəs",
    "cadavers": "kɐdævəz",
    "caddied": "kædɪd",
    "caddie": "kædi",
    "caddies": "kædɪz",
    "caddish": "kædɪʃ",
    "caddis": "kædɪz",
    "caddying": "kædɪɪŋ",
    "caddy": "kædi",
    "cade": "keɪd",
    "cadence": "keɪdəns",
    "cadences": "keɪdənsɪz",
    "cadenza": "kædənzɐ",
    "cadet": "kɐdɛt",
    "cadets": "kɐdɛts",
    "cadged": "kædʒd",
    "cadge": "kædʒ",
    "cadging": "kædʒɪŋ",
    "cadi": "kædi",
    "cad": "kæd",
    "cadmium": "kædmiəm",
    "cadre": "kɑːdɐ",
    "cadres": "kɑːdəz",
    "cads": "kædz",
    "caecum": "kiːkəm",
    "caesarean": "siːseəriən",
    "caesareans": "siːseəriənz",
    "caesarian": "siːseəriən",
    "caesar": "siːzɐ",
    "caesium": "siːsiəm",
    "cafeteria": "kæfɪtiərɪɐ",
    "cafeterias": "kæfɪtiərɪəz",
    "cafetiere": "kæfɪtieə",
    "caffeinated": "kæfɪneɪtɪd",
    "caffeine": "kæfiːn",
    "caff": "kæf",
    "caffs": "kæfs",
    "caged": "keɪdʒd",
    "cage": "keɪdʒ",
    "cages": "keɪdʒɪz",
    "cagey": "keɪdʒi",
    "cagily": "keɪdʒɪli",
    "caging": "keɪdʒɪŋ",
    "cagoule": "kæɡuːl",
    "cagoules": "kæɡuːlz",
    "cagy": "keɪdʒi",
    "cahoots": "kɐhuːts",
    "caiman": "keɪmən",
    "caimans": "keɪmənz",
    "cain": "keɪn",
    "caird": "keəd",
    "cairngorm": "keəŋɡɔːm",
    "cairngorms": "keəŋɡɔːmz",
    "cairn": "keən",
    "cairns": "keənz",
    "caisson": "keɪsən",
    "caissons": "keɪsənz",
    "cajoled": "kɐdʒəʊld",
    "cajole": "kɐdʒəʊl",
    "cajoling": "kɐdʒəʊlɪŋ",
    "caked": "keɪkt",
    "cake": "keɪk",
    "cakes": "keɪks",
    "cakewalk": "keɪkwɔːk",
    "cakey": "keɪki",
    "caking": "keɪkɪŋ",
    "calabash": "kælɐbæʃ",
    "calamari": "kælɐməri",
    "calamine": "kælɐmiːn",
    "calamities": "kɐlæmɪtiz",
    "calamitous": "kɐlæmɪtəs",
    "calamity": "kɐlæmɪti",
    "calamus": "kælæməs",
    "calcareous": "kælkeərəs",
    "calcification": "kælsɪfɪkeɪʃən",
    "calcified": "kælsɪfaɪd",
    "calcifying": "kælsɪfaɪɪŋ",
    "calcined": "kælsiːnd",
    "calcite": "kælsaɪt",
    "calcium": "kælsiəm",
    "calculated": "kælkjʊleɪtɪd",
    "calculatedly": "kælkjʊleɪtɪdli",
    "calculate": "kælkjʊleɪt",
    "calculates": "kælkjʊleɪts",
    "calculating": "kælkjʊleɪtɪŋ",
    "calculatingly": "kælkjʊleɪtɪŋli",
    "calculation": "kælkjʊleɪʃən",
    "calculations": "kælkjʊleɪʃənz",
    "calculator": "kælkjʊleɪtɐ",
    "calculators": "kælkjʊleɪtəz",
    "calculi": "kælkjʊlaɪ",
    "calculus": "kælkjʊləs",
    "caldarium": "kɒldeəriəm",
    "caldera": "kɒldeərɐ",
    "calderas": "kɒldeərəz",
    "caldron": "kɒldrən",
    "calendar": "kæləndɐ",
    "calendars": "kæləndəz",
    "calender": "kæləndɐ",
    "calendrical": "kæləndrɪkəl",
    "calendula": "kæləndjʊlɐ",
    "calendulas": "kæləndjʊləz",
    "calf": "kɑːf",
    "calfs": "kɑːfs",
    "calfskin": "kɑːfskɪn",
    "calibrated": "kælɪbreɪtɪd",
    "calibrate": "kælɪbreɪt",
    "calibrates": "kælɪbreɪts",
    "calibrating": "kælɪbreɪtɪŋ",
    "calibration": "kælɪbreɪʃən",
    "calibrations": "kælɪbreɪʃənz",
    "calibre": "kælɪbɐ",
    "calicoes": "kælɪkəʊz",
    "calico": "kælɪkəʊ",
    "californium": "kælɪfɔːniəm",
    "caliginous": "kælɪdʒɪnəs",
    "caliper": "kælɪpɐ",
    "calipers": "kælɪpəz",
    "caliphate": "kælɪfeɪt",
    "caliph": "kælɪf",
    "caliphs": "kælɪfz",
    "calla": "kælɐ",
    "callas": "kæləz",
    "callback": "kɔːlbæk",
    "callbacks": "kɔːlbæks",
    "callboy": "kɔːlbɔɪ",
    "called": "kɔːld",
    "caller": "kɔːlɐ",
    "callers": "kɔːləz",
    "calligrapher": "kælɪɡrəfɐ",
    "calligraphers": "kælɪɡrəfəz",
    "calligraphic": "kælɪɡræfɪk",
    "calligraphy": "kælɪɡrəfi",
    "calling": "kɔːlɪŋ",
    "callings": "kɔːlɪŋz",
    "calliope": "kɐlaɪəpi",
    "calliper": "kælɪpɐ",
    "callipers": "kælɪpəz",
    "callisthenics": "kælɪsθɛnɪks",
    "call": "kɔːl",
    "calloused": "kælaʊsd",
    "callous": "kæləs",
    "callously": "kæləsli",
    "callousness": "kæləsnəs",
    "callow": "kæləʊ",
    "calls": "kɔːlz",
    "callused": "kæluːsd",
    "calluses": "kæləsɪz",
    "callus": "kæləs",
    "calmed": "kɑːmd",
    "calmer": "kɑːmɐ",
    "calmest": "kɑːməst",
    "calming": "kɑːmɪŋ",
    "calm": "kɑːm",
    "calmly": "kɑːmli",
    "calmness": "kɑːmnəs",
    "calms": "kɑːmz",
    "calomel": "kæləʊməl",
    "caloric": "kælɒrɪk",
    "calorie": "kælɔːri",
    "calories": "kæləriz",
    "calorific": "kælɔːrɪfɪk",
    "calumny": "kælʌmni",
    "calvados": "kælvɑːdəʊz",
    "calvaria": "kælveəriə",
    "calvary": "kælvəri",
    "calved": "kɑːvd",
    "calve": "kɑːv",
    "calves": "kɑːvz",
    "calving": "kɑːvɪŋ",
    "calx": "kælks",
    "calypso": "kælɪpsəʊ",
    "calypsos": "kælɪpsəʊz",
    "calyx": "kælɪks",
    "calzone": "kælzəʊni",
    "camaraderie": "kæmərɑːdəri",
    "cambered": "kæmbəd",
    "camber": "kæmbɐ",
    "cambers": "kæmbəz",
    "cambium": "kæmbiəm",
    "cambric": "kæmbrɪk",
    "camcorder": "kæmkɔːdɐ",
    "camcorders": "kæmkɔːdəz",
    "came": "keɪm",
    "camel": "kæməl",
    "camellia": "kæmɛliə",
    "camellias": "kæmɛliəz",
    "camelopard": "kæmɪlɒpəd",
    "camels": "kæməlz",
    "cameo": "kæmɪəʊ",
    "cameos": "kæmɪəʊz",
    "camera": "kæmrɐ",
    "cameraman": "kæmrəmən",
    "cameramen": "kæmrəmɛn",
    "cameras": "kæmrəz",
    "camerawoman": "kæmrəwʊmən",
    "camerawork": "kæmrəwɜːk",
    "camion": "kæmiən",
    "camisole": "kæmɪsəʊl",
    "camisoles": "kæmɪsəʊlz",
    "cam": "kæm",
    "camomile": "kæməmaɪl",
    "camouflaged": "kæməflɑːʒd",
    "camouflage": "kæməflɑːʒ",
    "camouflages": "kæməflɑːʒɪz",
    "camouflaging": "kæməflɑːʒɪŋ",
    "campaigned": "kæmpeɪnd",
    "campaigner": "kæmpeɪnɐ",
    "campaigners": "kæmpeɪnəz",
    "campaigning": "kæmpeɪnɪŋ",
    "campaign": "kæmpeɪn",
    "campaigns": "kæmpeɪnz",
    "campanile": "kæmpɐnaɪl",
    "campanologist": "kæmpɐnɒlədʒɪst",
    "campanologists": "kæmpɐnɒlədʒɪsts",
    "campanology": "kæmpɐnɒlədʒi",
    "campanula": "kæmpænjʊlɐ",
    "campanulas": "kæmpænjʊləz",
    "camped": "kæmpt",
    "camper": "kæmpɐ",
    "campers": "kæmpəz",
    "campfire": "kæmpfaɪə",
    "campfires": "kæmpfaɪəz",
    "camphorated": "kæmfəreɪtɪd",
    "camphor": "kæmfɐ",
    "camping": "kæmpɪŋ",
    "campion": "kæmpiən",
    "campions": "kæmpiənz",
    "camp": "kæmp",
    "campo": "kæmpəʊ",
    "campsite": "kæmpsaɪt",
    "campsites": "kæmpsaɪts",
    "camps": "kæmps",
    "campuses": "kæmpəsɪz",
    "campus": "kæmpəs",
    "campy": "kæmpi",
    "camshaft": "kæmʃɑːft",
    "cams": "kæmz",
    "canalisation": "kænəlaɪzeɪʃən",
    "canal": "kənæl",
    "canals": "kənælz",
    "canard": "kænɑːd",
    "canaries": "kəneəriz",
    "canary": "kəneəri",
    "canasta": "kænɑːstɐ",
    "cancan": "kænkæn",
    "cancel": "kænsəl",
    "cancellation": "kænsɪleɪʃən",
    "cancellations": "kænsɪleɪʃənz",
    "cancelled": "kænsəld",
    "cancelling": "kænsəlɪŋ",
    "cancels": "kænsəlz",
    "cancer": "kænsɐ",
    "cancerous": "kænsərəs",
    "cancers": "kænsəz",
    "candelabra": "kændɪlæbrɐ",
    "candelabras": "kændɪlæbrəz",
    "candelabrum": "kændɪlæbrəm",
    "candela": "kændɛlɐ",
    "candelas": "kændɛləz",
    "candidacy": "kændɪdəsi",
    "candida": "kændɪdɐ",
    "candidate": "kændɪdeɪt",
    "candidates": "kændɪdeɪts",
    "candidature": "kændɪdətʃɐ",
    "candid": "kændɪd",
    "candidly": "kændɪdli",
    "candidness": "kændɪdnəs",
    "candied": "kændɪd",
    "candies": "kændɪz",
    "candle": "kændəl",
    "candlelight": "kændəllaɪt",
    "candlelit": "kændəllɪt",
    "candlenut": "kændəlnʌt",
    "candles": "kændəlz",
    "candlestick": "kændəlstɪk",
    "candlesticks": "kændəlstɪks",
    "candlewick": "kændəlwɪk",
    "candling": "kændlɪŋ",
    "candour": "kændɐ",
    "candyfloss": "kændɪflɒs",
    "candy": "kændi",
    "candytuft": "kændɪtʌft",
    "caned": "keɪnd",
    "cane": "keɪn",
    "caner": "keɪnɐ",
    "canes": "keɪnz",
    "canfield": "kænfiːld",
    "canine": "keɪnaɪn",
    "canines": "keɪnaɪnz",
    "caning": "keɪnɪŋ",
    "canings": "keɪnɪŋz",
    "canister": "kænɪstɐ",
    "canisters": "kænɪstəz",
    "can": "kæn",
    "canker": "kæŋkɐ",
    "cankers": "kæŋkəz",
    "cannabis": "kænɐbɪs",
    "canna": "kænɐ",
    "cannas": "kænəz",
    "canned": "kænd",
    "cannelloni": "kænɪləʊni",
    "canneries": "kænəriz",
    "cannery": "kænəri",
    "cannibalisation": "kænɪbəlaɪzeɪʃən",
    "cannibalised": "kænɪbəlaɪzd",
    "cannibalise": "kænɪbəlaɪz",
    "cannibalising": "kænɪbəlaɪzɪŋ",
    "cannibalism": "kænɪbəlɪzəm",
    "cannibalistic": "kænɪbəlɪstɪk",
    "cannibal": "kænɪbəl",
    "cannibals": "kænɪbəlz",
    "cannier": "kænɪɐ",
    "canniest": "kænɪəst",
    "cannily": "kænɪli",
    "canniness": "kænɪnəs",
    "canning": "kænɪŋ",
    "cannoli": "kænəli",
    "cannonball": "kænənbɔːl",
    "cannonballs": "kænənbɔːlz",
    "cannoned": "kænənd",
    "cannoneers": "kænəniəz",
    "cannoning": "kænənɪŋ",
    "cannon": "kænən",
    "cannons": "kænənz",
    "cannula": "kɐnjʊlæ",
    "cannulas": "kɐnjʊlæz",
    "canny": "kæni",
    "canoed": "kənuːd",
    "canoeing": "kənuːɪŋ",
    "canoeist": "kænəʊɪst",
    "canoeists": "kænəʊɪsts",
    "canoe": "kənuː",
    "canoes": "kənuːz",
    "canola": "kænəʊlɐ",
    "canonical": "kɐnɒnɪkəl",
    "canonisation": "kænənaɪzeɪʃən",
    "canonised": "kænənaɪzd",
    "canonise": "kænənaɪz",
    "canon": "kænən",
    "canons": "kænənz",
    "canoodle": "kænuːdəl",
    "canoodling": "kænuːdlɪŋ",
    "canopied": "kænəpɪd",
    "canopies": "kænəpɪz",
    "canopy": "kænəpi",
    "cans": "kænz",
    "canst": "kænst",
    "cantaloupe": "kɑːntɐluːp",
    "cantankerous": "kɑːntæŋkərəs",
    "cantata": "kɑːntɑːtɐ",
    "cantatas": "kɑːntɑːtəz",
    "canted": "kɑːntɪd",
    "canteen": "kɑːntiːn",
    "canteens": "kɑːntiːnz",
    "cantered": "kɑːntəd",
    "cantering": "kɑːntərɪŋ",
    "canter": "kɑːntɐ",
    "canters": "kɑːntəz",
    "canticle": "kɑːntɪkəl",
    "canticles": "kɑːntɪkəlz",
    "cantilevered": "kæntɪliːvəd",
    "cantilevering": "kæntɪliːvərɪŋ",
    "cantilever": "kæntɪliːvɐ",
    "cantilevers": "kæntɪliːvəz",
    "cantina": "kɑːntiːnɐ",
    "canting": "kɑːntɪŋ",
    "cant": "kɑːnt",
    "cantle": "kɑːntəl",
    "canto": "kɑːntəʊ",
    "canton": "kæntɒn",
    "cantons": "kæntɒnz",
    "cantor": "kɑːntɔː",
    "cantos": "kɑːntəʊz",
    "canty": "kɑːnti",
    "canula": "kænjʊlɐ",
    "canvased": "kænvəst",
    "canvases": "kænvəsɪz",
    "canvasing": "kænvəsɪŋ",
    "canvas": "kænvəs",
    "canvassed": "kænvəst",
    "canvasser": "kænvəsɐ",
    "canvassers": "kænvəsəz",
    "canvasses": "kænvəsɪz",
    "canvassing": "kænvəsɪŋ",
    "canvass": "kænvəs",
    "canyoning": "kænɪəʊnɪŋ",
    "canyon": "kænɪən",
    "canyons": "kænɪənz",
    "capabilities": "keɪpəbɪlɪtiz",
    "capability": "keɪpəbɪlɪti",
    "capable": "keɪpəbəl",
    "capably": "keɪpəbli",
    "capacious": "kəpeɪʃəs",
    "capacitance": "kəpæsɪtəns",
    "capacities": "kəpæsɪtiz",
    "capacitor": "kəpæsɪtɐ",
    "capacitors": "kəpæsɪtəz",
    "capacity": "kəpæsɪti",
    "caped": "keɪpt",
    "cape": "keɪp",
    "capelin": "keɪplɪn",
    "capercaillie": "kæpəkeɪli",
    "capering": "keɪpərɪŋ",
    "caper": "keɪpɐ",
    "capers": "keɪpəz",
    "capes": "keɪps",
    "capful": "kæpfəl",
    "capfuls": "kæpfəlz",
    "capillaries": "kæpɪləriz",
    "capillary": "kæpɪləri",
    "capita": "kæpɪtɐ",
    "capitalisation": "kæpɪtəlaɪzeɪʃən",
    "capitalised": "kæpɪtəlaɪzd",
    "capitalise": "kæpɪtəlaɪz",
    "capitalises": "kæpɪtəlaɪzɪz",
    "capitalising": "kæpɪtəlaɪzɪŋ",
    "capitalism": "kæpɪtəlɪzəm",
    "capitalistic": "kæpɪtəlɪstɪk",
    "capitalist": "kæpɪtəlɪst",
    "capitalists": "kæpɪtəlɪsts",
    "capital": "kæpɪtəl",
    "capitals": "kæpɪtəlz",
    "capitate": "kæpɪteɪt",
    "capitation": "kæpɪteɪʃən",
    "capitol": "kæpɪtəl",
    "capitulated": "kɐpɪtʃʊleɪtɪd",
    "capitulate": "kɐpɪtʃʊleɪt",
    "capitulating": "kɐpɪtʃʊleɪtɪŋ",
    "capitulation": "kɐpɪtʃʊleɪʃən",
    "cap": "kæp",
    "caplet": "kæplət",
    "caplin": "kæplɪn",
    "capon": "keɪpɒn",
    "capons": "keɪpɒnz",
    "capos": "kɑːpəʊz",
    "capote": "kæpəʊt",
    "capped": "kæpt",
    "capper": "kæpɐ",
    "capping": "kæpɪŋ",
    "cappuccino": "kæpuːtʃiːnəʊ",
    "cappuccinos": "kæpuːtʃiːnəʊz",
    "capriccio": "kæprɪksɪəʊ",
    "caprice": "kɐpriːs",
    "caprices": "kɐpriːsɪz",
    "capricious": "kæprɪʃəs",
    "capriciously": "kæprɪʃəsli",
    "capriciousness": "kæprɪʃəsnəs",
    "capsaicin": "kæpseɪsɪn",
    "capsicum": "kæpsɪkəm",
    "capsicums": "kæpsɪkəmz",
    "capsid": "kæpsɪd",
    "capsized": "kæpsaɪzd",
    "capsize": "kæpsaɪz",
    "capsizes": "kæpsaɪzɪz",
    "capsizing": "kæpsaɪzɪŋ",
    "caps": "kæps",
    "capstan": "kæpstən",
    "capstans": "kæpstənz",
    "capstone": "kæpstəʊn",
    "capsular": "kæpsjʊlɐ",
    "capsule": "kæpsjuːl",
    "capsules": "kæpsjuːlz",
    "captaincy": "kæptɪnsi",
    "captained": "kæptɪnd",
    "captaining": "kæptɪnɪŋ",
    "captain": "kæptɪn",
    "captainship": "kæptɪnʃɪp",
    "captains": "kæptɪnz",
    "captioned": "kæpʃənd",
    "captioning": "kæpʃənɪŋ",
    "caption": "kæpʃən",
    "captions": "kæpʃənz",
    "captivated": "kæptɪveɪtɪd",
    "captivate": "kæptɪveɪt",
    "captivates": "kæptɪveɪts",
    "captivating": "kæptɪveɪtɪŋ",
    "captive": "kæptɪv",
    "captives": "kæptɪvz",
    "captivity": "kæptɪvɪti",
    "captor": "kæptɐ",
    "captors": "kæptəz",
    "captured": "kæptʃəd",
    "capture": "kæptʃɐ",
    "captures": "kæptʃəz",
    "capturing": "kæptʃərɪŋ",
    "capuchin": "kæpətʃɪn",
    "capuchins": "kæpətʃɪnz",
    "caput": "kæpʊt",
    "capybara": "kæpɪbɑːrɐ",
    "capybaras": "kæpɪbɑːrəz",
    "carabiner": "kærɐbaɪnɐ",
    "carabiners": "kærɐbɪnəz",
    "caracal": "kærækəl",
    "caracals": "kærækəlz",
    "caracara": "kærɐkɑːrɐ",
    "caracaras": "kærɐkɑːrəz",
    "caracoles": "kærɐkəʊlz",
    "carafe": "kɐræf",
    "carafes": "kɐræfs",
    "carambola": "kærɐmbəʊlɐ",
    "caramelisation": "kærəmɛlaɪzeɪʃən",
    "caramelised": "kærəmɛlaɪzd",
    "caramelise": "kærəmɛlaɪz",
    "caramelises": "kærəmɛlaɪzɪz",
    "caramelising": "kærəmɛlaɪzɪŋ",
    "caramel": "kærəmɛl",
    "caramels": "kærəmɛlz",
    "carapace": "kærɐpeɪs",
    "carapaces": "kærɐpeɪsɪz",
    "carat": "kæræt",
    "carats": "kæræts",
    "caravan": "kærɐvæn",
    "caravanning": "kærɐvænɪŋ",
    "caravanserai": "kærɐvænsəraɪ",
    "caravans": "kærɐvænz",
    "caravel": "kærævəl",
    "caravelle": "kærɐvɛl",
    "caraway": "kærəweɪ",
    "carbide": "kɑːbaɪd",
    "carbine": "kɑːbaɪn",
    "carbines": "kɑːbaɪnz",
    "carbohydrate": "kɑːbəʊhaɪdreɪt",
    "carbohydrates": "kɑːbəʊhaɪdreɪts",
    "carbolic": "kɑːbɒlɪk",
    "carbonaceous": "kɑːbəneɪʃəs",
    "carbonated": "kɑːbəneɪtɪd",
    "carbonates": "kɑːbəneɪts",
    "carbonation": "kɑːbəneɪʃən",
    "carbonic": "kɑːbɒnɪk",
    "carboniferous": "kɑːbənɪfərəs",
    "carbonised": "kɑːbənaɪzd",
    "carbon": "kɑːbən",
    "carbons": "kɑːbənz",
    "carborundum": "kɑːbɔːrʌndəm",
    "carboys": "kɑːbɔɪz",
    "carbuncle": "kɑːbʌŋkəl",
    "carbuncles": "kɑːbʌŋkəlz",
    "carburetor": "kɑːbərɛtɐ",
    "carburetted": "kɑːbjɔːrɪtɪd",
    "carcasses": "kɑːkəsɪz",
    "carcass": "kɑːkəs",
    "carcinogenic": "kɑːsɪnəʊdʒɛnɪk",
    "carcinogen": "kɑːsɪnədʒən",
    "carcinogens": "kɑːsɪnədʒənz",
    "carcinoma": "kɑːsɪnəʊmɐ",
    "cardamom": "kɑːdæməm",
    "cardamoms": "kɑːdæməmz",
    "cardamon": "kɑːdəmən",
    "cardboard": "kɑːdbɔːd",
    "carded": "kɑːdɪd",
    "carder": "kɑːdɐ",
    "cardholder": "kɑːdhəʊldɐ",
    "cardholders": "kɑːdhəʊldəz",
    "cardiac": "kɑːdɪæk",
    "cardies": "kɑːdɪz",
    "cardigan": "kɑːdɪɡən",
    "cardigans": "kɑːdɪɡənz",
    "cardinal": "kɑːdɪnəl",
    "cardinals": "kɑːdɪnəlz",
    "carding": "kɑːdɪŋ",
    "cardiogram": "kɑːdɪəʊɡræm",
    "cardioid": "kɑːdɪəʊɪd",
    "cardiologist": "kɑːdɪəʊlədʒɪst",
    "cardiologists": "kɑːdɪəʊlədʒɪsts",
    "cardiology": "kɑːdɪəʊlədʒi",
    "cardiomegaly": "kɑːdɪəʊmɪɡəli",
    "cardiopulmonary": "kɑːdɪəʊpəlmɒnəri",
    "cardiovascular": "kɑːdɪəʊvæskjʊlɐ",
    "card": "kɑːd",
    "cardoon": "kɑːduːn",
    "cardoons": "kɑːduːnz",
    "cards": "kɑːdz",
    "cared": "keəd",
    "careened": "kəriːnd",
    "careening": "kəriːnɪŋ",
    "careered": "kəriəd",
    "careering": "kəriərɪŋ",
    "careerist": "kəriərɪst",
    "careerists": "kəriərɪsts",
    "career": "kəriə",
    "careers": "kəriəz",
    "carefree": "keəfriː",
    "careful": "keəfəl",
    "carefullest": "keəfʊləst",
    "carefully": "keəfəli",
    "carefulness": "keəfəlnəs",
    "caregiver": "keəɡɪvɐ",
    "caregivers": "keəɡɪvəz",
    "care": "keə",
    "careless": "keələs",
    "carelessly": "keələsli",
    "carelessness": "keələsnəs",
    "carer": "keərɐ",
    "carers": "keərəz",
    "cares": "keəz",
    "caressed": "kərɛst",
    "caresser": "kərɛsɐ",
    "caresses": "kərɛsɪz",
    "caressing": "kərɛsɪŋ",
    "caress": "kərɛs",
    "caretaker": "keəteɪkɐ",
    "caretakers": "keəteɪkəz",
    "caret": "kærət",
    "careworn": "keəwɔːn",
    "cargoes": "kɑːɡəʊz",
    "cargo": "kɑːɡəʊ",
    "cargos": "kɑːɡəʊz",
    "caribou": "kærɪbuː",
    "caricatural": "kærɪkətʃɔːrəl",
    "caricatured": "kærɪkətʃɔːd",
    "caricature": "kærɪkətʃɔː",
    "caricatures": "kærɪkətʃɔːz",
    "caricaturing": "kærɪkətʃɔːrɪŋ",
    "caricaturist": "kærɪkətʃɔːrɪst",
    "caricaturists": "kærɪkətʃɔːrɪsts",
    "caries": "keəriz",
    "carillon": "kærɪlən",
    "carillons": "kærɪlənz",
    "carina": "kæriːnɐ",
    "caring": "keərɪŋ",
    "carioca": "kærɪəʊkɐ",
    "carious": "keərɪəs",
    "caritas": "kærɪtəz",
    "carjacked": "kɑːdʒækt",
    "carjacker": "kɑːdʒækɐ",
    "carjackers": "kɑːdʒækəz",
    "carjacking": "kɑːdʒækɪŋ",
    "carjack": "kɑːdʒæk",
    "car": "kɑː",
    "carked": "kɑːkt",
    "cark": "kɑːk",
    "carline": "kɑːlaɪn",
    "carling": "kɑːlɪŋ",
    "carl": "kɑːl",
    "carload": "kɑːləʊd",
    "carloads": "kɑːləʊdz",
    "carman": "kɑːmən",
    "carmine": "kɑːmaɪn",
    "carnage": "kɑːnɪdʒ",
    "carnality": "kɑːnælɪti",
    "carnal": "kɑːnəl",
    "carnally": "kɑːnəli",
    "carnassial": "kɑːnæsɪəl",
    "carnation": "kɑːneɪʃən",
    "carnations": "kɑːneɪʃənz",
    "carnauba": "kɑːnɔːbɐ",
    "carnelian": "kɑːniːliən",
    "carnelians": "kɑːniːliənz",
    "carnet": "kɑːnɪt",
    "carney": "kɑːni",
    "carnie": "kɑːni",
    "carnies": "kɑːnɪz",
    "carnival": "kɑːnɪvəl",
    "carnivals": "kɑːnɪvəlz",
    "carnivore": "kɑːnɪvɔː",
    "carnivores": "kɑːnɪvɔːz",
    "carnivorous": "kɑːnɪvərəs",
    "carny": "kɑːni",
    "carob": "kærɒb",
    "carol": "kærəl",
    "carollers": "kærələz",
    "carolling": "kærəlɪŋ",
    "carols": "kærəlz",
    "carolus": "kærɒləs",
    "carom": "kærɒm",
    "carotene": "kærəʊtiːn",
    "carotenoids": "kærəʊtnɔɪdz",
    "carotid": "kərɒtɪd",
    "caroused": "kæraʊsd",
    "carouse": "kæraʊs",
    "carousel": "kærəsɛl",
    "carousels": "kærəsɛlz",
    "carousing": "kæraʊsɪŋ",
    "carpal": "kɑːpəl",
    "carpals": "kɑːpəlz",
    "carpark": "kɑːpɑːk",
    "carpel": "kɑːpəl",
    "carpenter": "kɑːpəntɐ",
    "carpenters": "kɑːpəntəz",
    "carpentry": "kɑːpəntri",
    "carpetbagger": "kɑːpɪtbæɡɐ",
    "carpetbaggers": "kɑːpɪtbæɡəz",
    "carpeted": "kɑːpɪtɪd",
    "carpeting": "kɑːpɪtɪŋ",
    "carpets": "kɑːpɪts",
    "carping": "kɑːpɪŋ",
    "carp": "kɑːp",
    "carpool": "kɑːpuːl",
    "carport": "kɑːpɔːt",
    "carps": "kɑːps",
    "carpus": "kɑːpəs",
    "carrack": "kæræk",
    "carrageenan": "kærɐdʒiːnən",
    "carrageen": "kærɐdʒiːn",
    "carrefour": "kærɛfɐ",
    "carrel": "kærəl",
    "carrell": "kærəl",
    "carriage": "kærɪdʒ",
    "carriages": "kærɪdʒɪz",
    "carriageway": "kærɪdʒweɪ",
    "carriageways": "kærɪdʒweɪz",
    "carried": "kærɪd",
    "carrier": "kærɪɐ",
    "carriers": "kæriəz",
    "carries": "kærɪz",
    "carrion": "kæriən",
    "carrot": "kærət",
    "carrots": "kærəts",
    "carroty": "kærɒti",
    "carrying": "kærɪɪŋ",
    "carry": "kæri",
    "carsick": "kɑːsɪk",
    "cars": "kɑːz",
    "carted": "kɑːtɪd",
    "carte": "kɑːt",
    "cartel": "kɑːtɛl",
    "cartels": "kɑːtɛlz",
    "carter": "kɑːtɐ",
    "carters": "kɑːtəz",
    "cartes": "kɑːts",
    "carthorse": "kɑːθɔːs",
    "carthorses": "kɑːθɔːsɪz",
    "cartilage": "kɑːtɪlɪdʒ",
    "cartilages": "kɑːtɪlɪdʒɪz",
    "cartilaginous": "kɑːtɪlædʒɪnəs",
    "carting": "kɑːtɪŋ",
    "cart": "kɑːt",
    "cartload": "kɑːtləʊd",
    "cartloads": "kɑːtləʊdz",
    "cartographer": "kɑːtɒɡrəfɐ",
    "cartographers": "kɑːtɒɡrəfəz",
    "cartographical": "kɑːtəɡræfɪkəl",
    "cartographic": "kɑːtəɡræfɪk",
    "cartography": "kɑːtɒɡrəfi",
    "carton": "kɑːtən",
    "cartons": "kɑːtənz",
    "cartooning": "kɑːtuːnɪŋ",
    "cartoonish": "kɑːtuːnɪʃ",
    "cartoonist": "kɑːtuːnɪst",
    "cartoonists": "kɑːtuːnɪsts",
    "cartoon": "kɑːtuːn",
    "cartoons": "kɑːtuːnz",
    "cartoony": "kɑːtuːni",
    "cartouche": "kɑːtʌtʃ",
    "cartouches": "kɑːtʌtʃɪz",
    "cartridge": "kɑːtrɪdʒ",
    "cartridges": "kɑːtrɪdʒɪz",
    "carts": "kɑːts",
    "cartwheeled": "kɑːtwiːld",
    "cartwheeling": "kɑːtwiːlɪŋ",
    "cartwheel": "kɑːtwiːl",
    "cartwheels": "kɑːtwiːlz",
    "caruncles": "kɑːrʌŋkəlz",
    "carved": "kɑːvd",
    "carve": "kɑːv",
    "carvel": "kɑːvəl",
    "carveries": "kɑːvəriz",
    "carver": "kɑːvɐ",
    "carvers": "kɑːvəz",
    "carvery": "kɑːvəri",
    "carves": "kɑːvz",
    "carving": "kɑːvɪŋ",
    "carvings": "kɑːvɪŋz",
    "carwash": "kɑːwɒʃ",
    "caryatid": "kɑːrɪætɪd",
    "caryatids": "kɑːrɪætɪdz",
    "casaba": "kæsɑːbɐ",
    "casa": "kɑːsɐ",
    "cascaded": "kɐskeɪdɪd",
    "cascade": "kɐskeɪd",
    "cascades": "kɐskeɪdz",
    "cascading": "kɐskeɪdɪŋ",
    "cascara": "kæskɑːrɐ",
    "casebook": "keɪsbʊk",
    "cased": "keɪst",
    "casein": "keɪsiːn",
    "case": "keɪs",
    "caseload": "keɪsləʊd",
    "caseloads": "keɪsləʊdz",
    "casement": "keɪsmənt",
    "casements": "keɪsmənts",
    "cases": "keɪsɪz",
    "caseworker": "keɪswɜːkɐ",
    "caseworkers": "keɪswɜːkəz",
    "casework": "keɪswɜːk",
    "cashbox": "kæʃbɒks",
    "cashed": "kæʃt",
    "cashes": "kæʃɪz",
    "cashew": "kæʃjuː",
    "cashews": "kæʃjuːz",
    "cashflow": "kæʃfləʊ",
    "cashiered": "kæʃiəd",
    "cashier": "kæʃiə",
    "cashiers": "kæʃiəz",
    "cashing": "kæʃɪŋ",
    "cash": "kæʃ",
    "cashless": "kæʃləs",
    "cashmere": "kæʃmiə",
    "casing": "keɪsɪŋ",
    "casings": "keɪsɪŋz",
    "casino": "kɐsiːnəʊ",
    "casinos": "kɐsiːnəʊz",
    "casket": "kɑːskɪt",
    "caskets": "kɑːskɪts",
    "cask": "kɑːsk",
    "casks": "kɑːsks",
    "casques": "kæsks",
    "cassava": "kæsɑːvɐ",
    "casserole": "kæsərəʊl",
    "casseroles": "kæsərəʊlz",
    "casseroling": "kæsərəʊlɪŋ",
    "cassette": "kɐsɛt",
    "cassettes": "kɐsɛts",
    "cassia": "kæʃɐ",
    "cassino": "kæsiːnəʊ",
    "cassis": "kæsɪs",
    "cassiterite": "kæsɪtəraɪt",
    "cassock": "kæsək",
    "cassocks": "kæsəks",
    "cassoulet": "kæsəʊlət",
    "cassowaries": "kæsəʊəriz",
    "cassowary": "kæsəʊəri",
    "castanet": "kɑːstɐnɛt",
    "castanets": "kɑːstɐnɛts",
    "castaway": "kɑːstəweɪ",
    "castaways": "kɑːstəweɪz",
    "caste": "kɑːst",
    "castellated": "kɑːstɪleɪtɪd",
    "caster": "kɑːstɐ",
    "casters": "kɑːstəz",
    "castes": "kɑːsts",
    "castigated": "kɑːstɪɡeɪtɪd",
    "castigate": "kɑːstɪɡeɪt",
    "castigates": "kɑːstɪɡeɪts",
    "castigating": "kɑːstɪɡeɪtɪŋ",
    "castigation": "kɑːstɪɡeɪʃən",
    "casting": "kɑːstɪŋ",
    "castings": "kɑːstɪŋz",
    "cast": "kɑːst",
    "castle": "kɑːsəl",
    "castles": "kɑːsəlz",
    "castling": "kɑːslɪŋ",
    "castor": "kɑːstɐ",
    "castors": "kɑːstəz",
    "castrated": "kɑːstreɪtɪd",
    "castrate": "kɑːstreɪt",
    "castrates": "kɑːstreɪts",
    "castrating": "kɑːstreɪtɪŋ",
    "castration": "kɑːstreɪʃən",
    "castrations": "kɑːstreɪʃənz",
    "castrato": "kɑːstrɑːtəʊ",
    "castrator": "kɑːstreɪtɐ",
    "castratos": "kɑːstrɑːtəʊz",
    "casts": "kɑːsts",
    "casual": "kæʒuːəl",
    "casually": "kæʒuːəli",
    "casualness": "kæʒuːəlnəs",
    "casuals": "kæʒuːəlz",
    "casualties": "kæʒuːəltɪz",
    "casualty": "kæʒuːəlti",
    "cataclysmically": "kætɐklɪsmɪkli",
    "cataclysmic": "kætɐklɪsmɪk",
    "cataclysm": "kætɐklɪzəm",
    "cataclysms": "kætɐklɪzəmz",
    "catacomb": "kætɐkəʊm",
    "catacombs": "kætɐkəʊmz",
    "catalase": "kætɐleɪs",
    "cataleptic": "kæteɪlɛptɪk",
    "catalogued": "kætɐlɒɡd",
    "catalogue": "kætɐlɒɡ",
    "cataloguer": "kætɐlɒɡɐ",
    "catalogues": "kætɐlɒɡz",
    "cataloguing": "kætɐlɒɡɪŋ",
    "catalpa": "kætælpɐ",
    "catalysed": "kætɐlaɪzd",
    "catalyse": "kætɐlaɪz",
    "catalyses": "kætɐlaɪzɪz",
    "catalysing": "kætɐlaɪzɪŋ",
    "catalysis": "kætæləsɪs",
    "catalyst": "kætɐlɪst",
    "catalysts": "kætɐlɪsts",
    "catalytic": "kætɐlɪtɪk",
    "catamaran": "kætɐməræn",
    "catamarans": "kætɐmərænz",
    "catamite": "kætɐmaɪt",
    "cataplexy": "kætɐplɛksi",
    "catapulted": "kætɐpʌltɪd",
    "catapulting": "kætɐpʌltɪŋ",
    "catapult": "kætɐpʌlt",
    "catapults": "kætɐpʌlts",
    "cataract": "kætɐrækt",
    "cataracts": "kætɐrækts",
    "catarrh": "kətɑː",
    "catastrophe": "kɐtæstrəfi",
    "catastrophes": "kɐtæstrəfɪz",
    "catastrophically": "kætɐstrɒfɪkli",
    "catastrophic": "kætɐstrɒfɪk",
    "catatonia": "kætɐtəʊniə",
    "catatonic": "kætɐtɒnɪk",
    "catcalls": "kætkɔːlz",
    "catcher": "kætʃɐ",
    "catchers": "kætʃəz",
    "catches": "kætʃɪz",
    "catchier": "kætʃɪɐ",
    "catchiest": "kætʃɪəst",
    "catching": "kætʃɪŋ",
    "catchings": "kætʃɪŋz",
    "catch": "kætʃ",
    "catchment": "kætʃmənt",
    "catchments": "kætʃmənts",
    "catchphrase": "kætʃfreɪz",
    "catchphrases": "kætʃfreɪzɪz",
    "catchpole": "kætʃpəʊl",
    "catchup": "kætʃʌp",
    "catchy": "kætʃi",
    "catechism": "kætɪkɪzəm",
    "categorical": "kætɪɡɒrɪkəl",
    "categorically": "kætɪɡɒrɪkli",
    "categoric": "kætɪɡɒrɪk",
    "categories": "kætɪɡərɪz",
    "categorisation": "kætɪɡəraɪzeɪʃən",
    "categorisations": "kætɪɡəraɪzeɪʃənz",
    "categorised": "kætɪɡəraɪzd",
    "categorise": "kætɪɡəraɪz",
    "categorises": "kætɪɡəraɪzɪz",
    "categorising": "kætɪɡəraɪzɪŋ",
    "category": "kætɪɡəri",
    "cate": "keɪt",
    "catena": "kætiːnɐ",
    "cateran": "kætərən",
    "catered": "keɪtəd",
    "caterer": "keɪtərɐ",
    "caterers": "keɪtərəz",
    "catering": "keɪtərɪŋ",
    "cater": "keɪtɐ",
    "caterpillar": "kætəpɪlɐ",
    "caterpillars": "kætəpɪləz",
    "caters": "keɪtəz",
    "caterwauling": "kætəwɔːlɪŋ",
    "catfish": "kætfɪʃ",
    "catgut": "kætɡʌt",
    "catharsis": "kæθɑːsɪs",
    "cathartic": "kæθɑːtɪk",
    "cathedral": "kɐθiːdrəl",
    "cathedrals": "kɐθiːdrəlz",
    "catheterised": "kæθɛtəraɪzd",
    "catheterise": "kæθɛtəraɪz",
    "catheterising": "kæθɛtəraɪzɪŋ",
    "catheter": "kæθɛtɐ",
    "catheters": "kæθɛtəz",
    "cathode": "kæθəʊd",
    "cathodes": "kæθəʊdz",
    "catholic": "kæθlɪk",
    "cationic": "kætaɪɒnɪk",
    "cation": "kætaɪən",
    "cations": "kætaɪənz",
    "cat": "kæt",
    "catkin": "kætkɪn",
    "catkins": "kætkɪnz",
    "catlike": "kætlaɪk",
    "catmint": "kætmɪnt",
    "catnap": "kætnæp",
    "catnip": "kætnɪp",
    "cats": "kæts",
    "catsuit": "kætsuːt",
    "catsuits": "kætsuːts",
    "cattail": "kæteɪl",
    "catteries": "kætəriz",
    "cattery": "kætəri",
    "cattle": "kætəl",
    "cattleman": "kætəlmən",
    "cattlemen": "kætəlmɛn",
    "catty": "kæti",
    "catwalk": "kætwɔːk",
    "catwalks": "kætwɔːks",
    "caucuses": "kɔːkəsɪz",
    "caucusing": "kɔːkjuːsɪŋ",
    "caucus": "kɔːkəs",
    "cauda": "kɔːdɐ",
    "caudal": "kɔːdəl",
    "caudle": "kɔːdəl",
    "caught": "kɔːt",
    "cauldron": "kɔːldrən",
    "cauldrons": "kɔːldrənz",
    "cauliflower": "kɒlɪflaʊɐ",
    "cauliflowers": "kɒlɪflaʊəz",
    "caulis": "kɒliz",
    "caulked": "kɔːkt",
    "caulker": "kɔːkɐ",
    "caulkers": "kɔːkəz",
    "caulking": "kɔːkɪŋ",
    "caulk": "kɔːk",
    "caul": "kɔːl",
    "causalities": "kɔːsælɪtiz",
    "causality": "kɔːsælɪti",
    "causal": "kɔːsəl",
    "causally": "kɔːsəli",
    "causation": "kɔːseɪʃən",
    "causative": "kɔːsətɪv",
    "caused": "kɔːzd",
    "cause": "kɔːz",
    "causer": "kɔːsɐ",
    "causers": "kɔːsəz",
    "causes": "kɔːzɪz",
    "causeway": "kɔːzweɪ",
    "causeways": "kɔːsweɪz",
    "causing": "kɔːzɪŋ",
    "caustically": "kɔːstɪkli",
    "caustic": "kɔːstɪk",
    "cauterised": "kɔːtəraɪzd",
    "cauterise": "kɔːtəraɪz",
    "cauterises": "kɔːtəraɪzɪz",
    "cauterising": "kɔːtəraɪzɪŋ",
    "cautery": "kɔːtəri",
    "cautionary": "kɔːʃənəri",
    "cautioned": "kɔːʃənd",
    "cautioning": "kɔːʃənɪŋ",
    "caution": "kɔːʃən",
    "cautions": "kɔːʃənz",
    "cautious": "kɔːʃəs",
    "cautiously": "kɔːʃəsli",
    "cautiousness": "kɔːʃəsnəs",
    "cavalcade": "kævɐlkeɪd",
    "cavalier": "kævɐliə",
    "cavaliers": "kævɐliəz",
    "cavalries": "kævəlrɪz",
    "cavalry": "kævəlri",
    "cavalryman": "kævɐlrɪmən",
    "cavalrymen": "kævɐlrɪmɛn",
    "cavatina": "kævɐtiːnɐ",
    "caveat": "kævɪæt",
    "caveats": "kævɪæts",
    "caved": "keɪvd",
    "caveman": "keɪvmən",
    "cavemen": "keɪvmɛn",
    "cavendish": "kævəndɪʃ",
    "caver": "keɪvɐ",
    "cavern": "kævən",
    "cavernous": "kævənəs",
    "caverns": "kævənz",
    "cavers": "keɪvəz",
    "caves": "keɪvz",
    "caviar": "kævɪɑː",
    "cavies": "keɪvɪz",
    "caving": "keɪvɪŋ",
    "cavitation": "kævɪteɪʃən",
    "cavities": "kævɪtiz",
    "cavity": "kævɪti",
    "cavorted": "kɐvɔːtɪd",
    "cavorting": "kɐvɔːtɪŋ",
    "cavort": "kɐvɔːt",
    "cavorts": "kɐvɔːts",
    "cavy": "keɪvi",
    "cawed": "kɔːd",
    "cawing": "kɔːrɪŋ",
    "caw": "kɔː",
    "caws": "kɔːz",
    "cayenne": "keɪən",
    "cay": "keɪ",
    "cayman": "keɪmən",
    "caymans": "keɪmənz",
    "cays": "keɪz",
    "ceased": "siːsd",
    "ceasefire": "siːsfaɪə",
    "ceasefires": "siːsfaɪəz",
    "ceaselessly": "siːsləsli",
    "ceaseless": "siːsləs",
    "cease": "siːs",
    "ceases": "siːsɪz",
    "ceasing": "siːsɪŋ",
    "cecal": "sɛkəl",
    "cedar": "siːdɐ",
    "cedars": "siːdəz",
    "cedarwood": "siːdəwʊd",
    "ceded": "siːdɪd",
    "cede": "siːd",
    "ceding": "siːdɪŋ",
    "cedi": "sɛdi",
    "cedis": "sɛdɪz",
    "ceilidh": "keɪli",
    "ceilidhs": "keɪliz",
    "ceiling": "siːlɪŋ",
    "ceilings": "siːlɪŋz",
    "ceil": "siːl",
    "celadon": "sɛlædən",
    "celandine": "sɛlɐndiːn",
    "celebrant": "sɛləbrənt",
    "celebrants": "sɛləbrənts",
    "celebrated": "sɛləbreɪtɪd",
    "celebrate": "sɛləbreɪt",
    "celebrates": "sɛləbreɪts",
    "celebrating": "sɛləbreɪtɪŋ",
    "celebration": "sɛləbreɪʃən",
    "celebrations": "sɛləbreɪʃənz",
    "celebratory": "sɛləbrətəri",
    "celebrities": "səlɛbrɪtiz",
    "celebrity": "səlɛbrɪti",
    "celeb": "sɛlɛb",
    "celebs": "sɛlɛbz",
    "celeriac": "sɛliərɪæk",
    "celerity": "sɛlɛrɪti",
    "celery": "sɛləri",
    "celesta": "səlɛstɐ",
    "celeste": "səlɛst",
    "celestial": "səlɛstjəl",
    "celibacy": "sɛlɪbəsi",
    "celibate": "sɛlɪbeɪt",
    "cellarage": "sɛlærɪdʒ",
    "cellarer": "sɛleərɐ",
    "cellaret": "sɛlærət",
    "cellarette": "sɛlərɛt",
    "cellar": "sɛlɐ",
    "cellars": "sɛləz",
    "cellblock": "sɛlblɒk",
    "celled": "sɛld",
    "cellist": "sɛlɪst",
    "cellists": "sɛlɪsts",
    "celli": "tʃɛli",
    "cellmate": "sɛlmeɪt",
    "cellmates": "sɛlmeɪts",
    "cellophane": "sɛləfeɪn",
    "cellos": "tʃɛləʊz",
    "cello": "tʃɛləʊ",
    "cellphones": "sɛlfəʊnz",
    "cell": "sɛl",
    "cells": "sɛlz",
    "cellular": "sɛljʊlɐ",
    "cellulite": "sɛljuːlaɪt",
    "cellulitis": "sɛljuːlaɪtɪs",
    "celluloid": "sɛljuːlɔɪd",
    "cellulose": "sɛljuːləʊz",
    "celt": "kɛlt",
    "celtuce": "kɛltjuːs",
    "cementation": "sɪmɪnteɪʃən",
    "cemented": "sɪmɛntɪd",
    "cementing": "sɪmɛntɪŋ",
    "cement": "sɪmɛnt",
    "cements": "sɪmɛnts",
    "cemeteries": "sɛmɪtəriz",
    "cemetery": "sɛmɪtəri",
    "cenotaph": "sɛnəʊtæf",
    "censer": "sɛnsɐ",
    "censers": "sɛnsəz",
    "censored": "sɛnsəd",
    "censoring": "sɛnsərɪŋ",
    "censorious": "sɛnsɔːrɪəs",
    "censor": "sɛnsɐ",
    "censorship": "sɛnsəʃɪp",
    "censors": "sɛnsəz",
    "censured": "sɛnʃəd",
    "censure": "sɛnʃɐ",
    "censures": "sɛnʃəz",
    "censuses": "sɛnsuːsɪz",
    "census": "sɛnsəs",
    "centaur": "sɛntɔː",
    "centaurs": "sɛntɔːz",
    "centavos": "sɛntɑːvəʊz",
    "centenarian": "sɛntəneəriən",
    "centenarians": "sɛntəneəriənz",
    "centenaries": "sɛntiːnəriz",
    "centenary": "sɛntiːnəri",
    "centennial": "sɛntɛnɪəl",
    "centered": "sɛntəd",
    "centering": "sɛntərɪŋ",
    "center": "sɛntɐ",
    "centers": "sɛntəz",
    "centigrade": "sɛntɪɡreɪd",
    "centilitre": "sɛntɪliːtɐ",
    "centilitres": "sɛntɪliːtəz",
    "centime": "sɛntɪm",
    "centimes": "sɛntɪmz",
    "centimetre": "sɛntɪmiːtɐ",
    "centimetres": "sɛntɪmiːtəz",
    "centipede": "sɛntɪpiːd",
    "centipedes": "sɛntɪpiːdz",
    "cento": "sɛntəʊ",
    "centralisation": "sɛntrəlaɪzeɪʃən",
    "centralised": "sɛntrəlaɪzd",
    "centralisers": "sɛntrəlaɪzəz",
    "centralise": "sɛntrəlaɪz",
    "centralises": "sɛntrəlaɪzɪz",
    "centralising": "sɛntrəlaɪzɪŋ",
    "centralism": "sɛntrəlɪzəm",
    "centralist": "sɛntrəlɪst",
    "centrality": "sɛntrælɪti",
    "centrally": "sɛntrəli",
    "central": "sɛntrəl",
    "centra": "sɛntrɐ",
    "centreboard": "sɛntrɪbɔːd",
    "centred": "sɛntəd",
    "centrefold": "sɛntrɪfəʊld",
    "centrefolds": "sɛntrɪfəʊldz",
    "centreing": "sɛntərɪŋ",
    "centrepiece": "sɛntəpiːs",
    "centrepieces": "sɒntrɪpiːsɪz",
    "centre": "sɛntɐ",
    "centres": "sɛntəz",
    "centric": "sɛntrɪk",
    "centrifugal": "sɛntrɪfjuːɡəl",
    "centrifuge": "sɛntrɪfjuːdʒ",
    "centrifuges": "sɛntrɪfjuːdʒɪz",
    "centring": "sɛntrɪŋ",
    "centripetal": "sɛntraɪptəl",
    "centrist": "sɛntrɪst",
    "centrists": "sɛntrɪsts",
    "centromere": "sɛntrəʊmɐ",
    "centrum": "sɛntrəm",
    "cent": "sɛnt",
    "cents": "sɛnts",
    "centuries": "sɛntʃərɪz",
    "centurion": "sɛntʃɔːriən",
    "centurions": "sɛntʃɔːriənz",
    "century": "sɛntʃəri",
    "cephalic": "sɛfælɪk",
    "cephalopod": "sɛfɐlɒpɒd",
    "cephalopods": "sɛfɐlɒpɒdz",
    "ceramicist": "sɪræmɪsɪst",
    "ceramicists": "sɪræmɪsɪsts",
    "ceramic": "sɪræmɪk",
    "ceramics": "sɪræmɪks",
    "cereal": "siərɪəl",
    "cereals": "siərɪəlz",
    "cerebellum": "sɛrɪbɛləm",
    "cerebrally": "səriːbrəli",
    "cerebral": "səriːbrəl",
    "cerebra": "səriːbrɐ",
    "cerebrospinal": "səriːbrəspaɪnəl",
    "cerebrovascular": "səriːbrəvæskjʊlɐ",
    "cerebrum": "səriːbrəm",
    "ceremonially": "sɛrɪməʊnɪəli",
    "ceremonial": "sɛrɪməʊnɪəl",
    "ceremonials": "sɛrɪməʊnɪəlz",
    "ceremonies": "sɛrɪmənɪz",
    "ceremoniously": "sɛrɪməʊnɪəsli",
    "ceremonious": "sɛrɪməʊnɪəs",
    "ceremony": "sɛrɪməni",
    "cereus": "sɛrɪəs",
    "ceric": "sɛrɪk",
    "cerise": "səriːz",
    "cerium": "siərɪəm",
    "certainly": "sɜːtənli",
    "certain": "sɜːtən",
    "certainties": "sɜːtəntɪz",
    "certainty": "sɜːtənti",
    "certifiable": "sɜːtɪfaɪəbəl",
    "certifiably": "sɜːtɪfaɪəbli",
    "certificated": "sətɪfɪkətɪd",
    "certifications": "sɜːtɪfɪkeɪʃənz",
    "certification": "sɜːtɪfɪkeɪʃən",
    "certified": "sɜːtɪfaɪd",
    "certifies": "sɜːtɪfaɪz",
    "certifying": "sɜːtɪfaɪɪŋ",
    "certify": "sɜːtɪfaɪ",
    "certitude": "sɜːtɪtjuːd",
    "certs": "sɜːts",
    "cerulean": "sɛruːliən",
    "cerumen": "sɛruːmɛn",
    "cerussite": "sɛrəsaɪt",
    "cervical": "sɜːvɪkəl",
    "cervixes": "sɜːvɪksɪz",
    "cervix": "sɜːvɪks",
    "cessation": "sɛseɪʃən",
    "cession": "sɛʃən",
    "cesspit": "sɛspɪt",
    "cesspits": "sɛspɪts",
    "cesspool": "sɛspuːl",
    "cess": "sɛs",
    "cetacean": "sɛteɪʃən",
    "cetaceans": "sɛteɪʃənz",
    "chacma": "tʃækmɐ",
    "chad": "tʃæd",
    "chafed": "tʃeɪft",
    "chafer": "tʃeɪfɐ",
    "chafes": "tʃeɪfs",
    "chafe": "tʃeɪf",
    "chaffed": "tʃæft",
    "chaffer": "tʃæfɐ",
    "chaffinches": "tʃæfɪntʃɪz",
    "chaffinch": "tʃæfɪntʃ",
    "chaffing": "tʃæfɪŋ",
    "chaff": "tʃæf",
    "chafing": "tʃeɪfɪŋ",
    "chagrin": "ʃæɡrɪn",
    "chagrined": "ʃæɡrɪnd",
    "chained": "tʃeɪnd",
    "chaining": "tʃeɪnɪŋ",
    "chainsaws": "tʃeɪnsɔːz",
    "chainsaw": "tʃeɪnsɔː",
    "chains": "tʃeɪnz",
    "chain": "tʃeɪn",
    "chaired": "tʃeəd",
    "chairing": "tʃeərɪŋ",
    "chairlifts": "tʃeəlɪfts",
    "chairlift": "tʃeəlɪft",
    "chairmanships": "tʃeəmənʃɪps",
    "chairmanship": "tʃeəmənʃɪp",
    "chairman": "tʃeəmən",
    "chairmen": "tʃeəmɛn",
    "chairperson": "tʃeəpəsən",
    "chairs": "tʃeəz",
    "chair": "tʃeə",
    "chairwoman": "tʃeəwʊmən",
    "chaise": "ʃeɪz",
    "chaises": "ʃeɪzɪz",
    "chalcedony": "tʃælsɛdəni",
    "chalet": "ʃæleɪ",
    "chalets": "ʃæleɪs",
    "chalices": "tʃælɪsɪz",
    "chalice": "tʃælɪs",
    "chalkboard": "tʃɔːkbɔːd",
    "chalked": "tʃɔːkt",
    "chalkiness": "tʃɔːkinəs",
    "chalking": "tʃɔːkɪŋ",
    "chalks": "tʃɔːks",
    "chalk": "tʃɔːk",
    "chalky": "tʃɔːki",
    "challah": "tʃælɐ",
    "challenged": "tʃælɪndʒd",
    "challengers": "tʃælɪndʒəz",
    "challenger": "tʃælɪndʒɐ",
    "challenges": "tʃælɪndʒɪz",
    "challenge": "tʃælɪndʒ",
    "challengingly": "tʃælɪndʒɪŋli",
    "challenging": "tʃælɪndʒɪŋ",
    "challis": "tʃæliz",
    "chalybeate": "tʃælaɪbeɪt",
    "chambered": "tʃeɪmbəd",
    "chamberlains": "tʃeɪmbəlɪnz",
    "chamberlain": "tʃeɪmbəlɪn",
    "chambermaids": "tʃeɪmbəmeɪdz",
    "chambermaid": "tʃeɪmbəmeɪd",
    "chamberpots": "tʃeɪmbəpɒts",
    "chamberpot": "tʃeɪmbəpɒt",
    "chambers": "tʃeɪmbəz",
    "chamber": "tʃeɪmbɐ",
    "chameleon": "kəmiːliən",
    "chameleons": "kəmiːliənz",
    "chamfered": "tʃæmfəd",
    "chamfers": "tʃæmfəz",
    "chamfer": "tʃæmfɐ",
    "chammy": "tʃæmi",
    "chamomile": "kæməmaɪl",
    "champagne": "ʃæmpeɪn",
    "champagnes": "ʃæmpeɪnz",
    "champers": "tʃæmpəz",
    "champignon": "tʃæmpinjɒn",
    "champing": "tʃæmpɪŋ",
    "championed": "tʃæmpiənd",
    "championing": "tʃæmpiənɪŋ",
    "championships": "tʃæmpiənʃɪps",
    "championship": "tʃæmpiənʃɪp",
    "champions": "tʃæmpiənz",
    "champion": "tʃæmpiən",
    "champs": "tʃæmps",
    "champ": "tʃæmp",
    "cham": "tʃæm",
    "chanced": "tʃɑːnst",
    "chancellery": "tʃɑːnsɪləri",
    "chancellorship": "tʃɑːnsɪləʃɪp",
    "chancellors": "tʃɑːnsɛləz",
    "chancellor": "tʃɑːnsɛlɐ",
    "chancels": "tʃɑːnsəlz",
    "chancel": "tʃɑːnsəl",
    "chancery": "tʃɑːnsəri",
    "chances": "tʃɑːnsɪz",
    "chance": "tʃɑːns",
    "chancier": "tʃɑːnsɪɐ",
    "chancing": "tʃɑːnsɪŋ",
    "chancre": "tʃɑːnkɐ",
    "chancy": "tʃɑːnsi",
    "chandelier": "ʃændəliə",
    "chandeliers": "ʃændəliəz",
    "chandelle": "ʃændɛl",
    "chandlers": "tʃændləz",
    "chandler": "tʃændlɐ",
    "chandlery": "tʃændəlri",
    "changeability": "tʃeɪndʒəbɪlɪti",
    "changeable": "tʃeɪndʒəbəl",
    "changed": "tʃeɪndʒd",
    "changeless": "tʃeɪndʒləs",
    "changelings": "tʃeɪndʒlɪŋz",
    "changeling": "tʃeɪndʒlɪŋ",
    "changeovers": "tʃeɪndʒəʊvəz",
    "changeover": "tʃeɪndʒəʊvɐ",
    "changers": "tʃeɪndʒəz",
    "changer": "tʃeɪndʒɐ",
    "changes": "tʃeɪndʒɪz",
    "change": "tʃeɪndʒ",
    "changing": "tʃeɪndʒɪŋ",
    "channelled": "tʃænəld",
    "channelling": "tʃænəlɪŋ",
    "channels": "tʃænəlz",
    "channel": "tʃænəl",
    "chansons": "tʃænsənz",
    "chanson": "tʃænsən",
    "chanted": "tʃɑːntɪd",
    "chanterelles": "tʃɑːntərɛlz",
    "chanterelle": "tʃɑːntərɛl",
    "chanters": "tʃɑːntəz",
    "chanter": "tʃɑːntɐ",
    "chanteuse": "tʃɑːntɜːz",
    "chanticleer": "tʃɑːntɪkliə",
    "chanting": "tʃɑːntɪŋ",
    "chantries": "tʃɑːntriz",
    "chantry": "tʃɑːntri",
    "chants": "tʃɑːnts",
    "chant": "tʃɑːnt",
    "chanty": "tʃɑːnti",
    "chaos": "keɪɒs",
    "chaotically": "keɪɒtɪkli",
    "chaotic": "keɪɒtɪk",
    "chaparral": "tʃæpærəl",
    "chapatis": "tʃæpɑːtiz",
    "chapati": "tʃæpɑːti",
    "chapattis": "tʃæpætiz",
    "chapatti": "tʃæpæti",
    "chapbooks": "tʃæpbʊks",
    "chapeau": "tʃeɪpaʊ",
    "chapeaux": "tʃeɪpɔːks",
    "chapels": "tʃæpəlz",
    "chapel": "tʃæpəl",
    "chaperon": "ʃæpərəʊn",
    "chaperone": "ʃæpərəʊn",
    "chaperoned": "ʃæpərəʊnd",
    "chaperones": "ʃæpərəʊnz",
    "chaperoning": "ʃæpərəʊnɪŋ",
    "chaplaincies": "tʃæplɪnsɪz",
    "chaplaincy": "tʃæplɪnsi",
    "chaplains": "tʃæplɪnz",
    "chaplain": "tʃæplɪn",
    "chaplet": "tʃæplət",
    "chapman": "tʃæpmən",
    "chapped": "tʃæpt",
    "chappies": "tʃæpɪz",
    "chappie": "tʃæpi",
    "chapping": "tʃæpɪŋ",
    "chappy": "tʃæpi",
    "chap": "tʃæp",
    "chapters": "tʃæptəz",
    "chapter": "tʃæptɐ",
    "chapt": "tʃæpt",
    "charabancs": "tʃærɐbɑːnks",
    "charabanc": "tʃærɐbɑːnk",
    "characterful": "kærɪktəfəl",
    "characterisation": "kærɪktəraɪzeɪʃən",
    "characterisations": "kærɪktəraɪzeɪʃənz",
    "characterised": "kærɪktəraɪzd",
    "characterise": "kærɪktəraɪz",
    "characterises": "kærɪktəraɪzɪz",
    "characterising": "kærɪktəraɪzɪŋ",
    "characteristically": "kærɪktərɪstɪkli",
    "characteristic": "kærɪktərɪstɪk",
    "characteristics": "kærɪktərɪstɪks",
    "character": "kærɪktɐ",
    "characterless": "kærɪktələs",
    "characters": "kærɪktəz",
    "charactery": "kærɪktəri",
    "charade": "ʃɐrɑːd",
    "charades": "ʃɐrɑːdz",
    "charcoals": "tʃɑːkəʊlz",
    "charcoal": "tʃɑːkəʊl",
    "charcuteries": "tʃɑːkjuːtəriz",
    "charcuterie": "tʃɑːkjuːtəri",
    "chardonnay": "ʃɑːdəneɪ",
    "chardonnays": "ʃɑːdəneɪz",
    "chard": "tʃɑːd",
    "chare": "tʃeə",
    "charge": "tʃɑːdʒ",
    "chargeable": "tʃɑːdʒəbəl",
    "charged": "tʃɑːdʒd",
    "chargers": "tʃɑːdʒəz",
    "charger": "tʃɑːdʒɐ",
    "charging": "tʃɑːdʒɪŋ",
    "charioteers": "tʃæriətiəz",
    "charioteer": "tʃæriətiə",
    "chariots": "tʃæriəts",
    "chariot": "tʃæriət",
    "charisma": "kərɪsmɐ",
    "charismatically": "kærɪsmætɪkli",
    "charismatic": "kærɪsmætɪk",
    "charitable": "tʃærɪtəbəl",
    "charitably": "tʃærɪtəbli",
    "charities": "tʃærɪtiz",
    "charity": "tʃærɪti",
    "charlady": "tʃɑːleɪdi",
    "charlatan": "ʃɑːlətən",
    "charlatans": "ʃɑːlətənz",
    "charlies": "tʃɑːliz",
    "charlie": "tʃɑːli",
    "charlotte": "ʃɑːlət",
    "charlottes": "ʃɑːləts",
    "charmed": "tʃɑːmd",
    "charmers": "tʃɑːməz",
    "charmer": "tʃɑːmɐ",
    "charmingly": "tʃɑːmɪŋli",
    "charming": "tʃɑːmɪŋ",
    "charmless": "tʃɑːmləs",
    "charms": "tʃɑːmz",
    "charm": "tʃɑːm",
    "charnel": "tʃɑːnəl",
    "charred": "tʃɑːd",
    "charring": "tʃɑːrɪŋ",
    "chars": "tʃɑːz",
    "char": "tʃɑː",
    "charted": "tʃɑːtɪd",
    "chartered": "tʃɑːtəd",
    "charterers": "tʃɑːtərəz",
    "chartering": "tʃɑːtərɪŋ",
    "charters": "tʃɑːtəz",
    "charter": "tʃɑːtɐ",
    "charting": "tʃɑːtɪŋ",
    "chartists": "tʃɑːtɪsts",
    "chartist": "tʃɑːtɪst",
    "chartreuse": "ʃɑːtrɜːz",
    "charts": "tʃɑːts",
    "chart": "tʃɑːt",
    "charwoman": "tʃɑːwʊmən",
    "chased": "tʃeɪst",
    "chasers": "tʃeɪsəz",
    "chaser": "tʃeɪsɐ",
    "chases": "tʃeɪsɪz",
    "chase": "tʃeɪs",
    "chasing": "tʃeɪsɪŋ",
    "chasm": "kæzəm",
    "chasms": "kæzəmz",
    "chassepot": "ʃæsɪpɒt",
    "chasseur": "ʃæsɜː",
    "chastened": "tʃeɪstənd",
    "chastening": "tʃeɪstənɪŋ",
    "chaste": "tʃeɪst",
    "chastised": "tʃɑːstaɪzd",
    "chastisement": "tʃɑːstaɪzmənt",
    "chastises": "tʃɑːstaɪzɪz",
    "chastise": "tʃɑːstaɪz",
    "chastising": "tʃɑːstaɪzɪŋ",
    "chastity": "tʃɑːstɪti",
    "chasubles": "tʃæsʌbəlz",
    "chasuble": "tʃæsʌbəl",
    "cha": "tʃɑː",
    "chateaus": "ʃætəʊz",
    "chatroom": "tʃætruːm",
    "chats": "tʃæts",
    "chat": "tʃæt",
    "chatted": "tʃætɪd",
    "chattels": "tʃætəlz",
    "chattel": "tʃætəl",
    "chatterboxes": "tʃætəbɒksɪz",
    "chatterbox": "tʃætəbɒks",
    "chattered": "tʃætəd",
    "chattering": "tʃætərɪŋ",
    "chatters": "tʃætəz",
    "chatter": "tʃætɐ",
    "chattiest": "tʃætɪəst",
    "chatting": "tʃætɪŋ",
    "chatty": "tʃæti",
    "chauffer": "ʃəʊfɐ",
    "chauffeured": "ʃəʊfɜːd",
    "chauffeur": "ʃəʊfɜː",
    "chauffeuring": "ʃəʊfɜːrɪŋ",
    "chauffeurs": "ʃəʊfɜːz",
    "chauvinism": "ʃəʊvɪnɪzəm",
    "chauvinist": "ʃəʊvɪnɪst",
    "chauvinistic": "ʃəʊvɪnɪstɪk",
    "chauvinists": "ʃəʊvɪnɪsts",
    "chaw": "tʃɔː",
    "chazan": "tʃeɪzən",
    "cheapened": "tʃiːpənd",
    "cheapening": "tʃiːpənɪŋ",
    "cheapens": "tʃiːpənz",
    "cheapen": "tʃiːpən",
    "cheaper": "tʃiːpɐ",
    "cheapest": "tʃiːpəst",
    "cheapish": "tʃiːpɪʃ",
    "cheaply": "tʃiːpli",
    "cheapness": "tʃiːpnəs",
    "cheapo": "tʃiːpəʊ",
    "cheapskates": "tʃiːpskeɪts",
    "cheapskate": "tʃiːpskeɪt",
    "cheap": "tʃiːp",
    "cheated": "tʃiːtɪd",
    "cheaters": "tʃiːtəz",
    "cheater": "tʃiːtɐ",
    "cheating": "tʃiːtɪŋ",
    "cheats": "tʃiːts",
    "cheat": "tʃiːt",
    "checked": "tʃɛkt",
    "checkers": "tʃɛkəz",
    "checker": "tʃɛkɐ",
    "checking": "tʃɛkɪŋ",
    "checklists": "tʃɛklɪsts",
    "checklist": "tʃɛklɪst",
    "checkmated": "tʃɛkmeɪtɪd",
    "checkmates": "tʃɛkmeɪts",
    "checkmate": "tʃɛkmeɪt",
    "checkmating": "tʃɛkmeɪtɪŋ",
    "checkouts": "tʃɛkaʊts",
    "checkout": "tʃɛkaʊt",
    "checkpoints": "tʃɛkpɔɪnts",
    "checkpoint": "tʃɛkpɔɪnt",
    "checks": "tʃɛks",
    "check": "tʃɛk",
    "checkups": "tʃɛkʌps",
    "checkup": "tʃɛkʌp",
    "checky": "tʃɛki",
    "cheddar": "tʃɛdɐ",
    "cheder": "tʃɛdɐ",
    "cheekbones": "tʃiːkbəʊnz",
    "cheekbone": "tʃiːkbəʊn",
    "cheeked": "tʃiːkt",
    "cheekier": "tʃiːkɪɐ",
    "cheekiest": "tʃiːkɪəst",
    "cheekily": "tʃiːkɪli",
    "cheekiness": "tʃiːkɪnəs",
    "cheeking": "tʃiːkɪŋ",
    "cheeks": "tʃiːks",
    "cheek": "tʃiːk",
    "cheeky": "tʃiːki",
    "cheeped": "tʃiːpt",
    "cheeping": "tʃiːpɪŋ",
    "cheeps": "tʃiːps",
    "cheep": "tʃiːp",
    "cheered": "tʃiəd",
    "cheerer": "tʃiərɐ",
    "cheerfully": "tʃiəfəli",
    "cheerfulness": "tʃiəfəlnəs",
    "cheerful": "tʃiəfəl",
    "cheerier": "tʃiərɪɐ",
    "cheeriest": "tʃiərɪəst",
    "cheerily": "tʃiərɪli",
    "cheeriness": "tʃiərɪnəs",
    "cheering": "tʃiərɪŋ",
    "cheerios": "tʃiərɪəʊz",
    "cheerio": "tʃiərɪəʊ",
    "cheerleaders": "tʃiəliːdəz",
    "cheerleader": "tʃiəliːdɐ",
    "cheerless": "tʃiələs",
    "cheers": "tʃiəz",
    "cheer": "tʃiə",
    "cheery": "tʃiəri",
    "cheeseboard": "tʃiːzbɔːd",
    "cheeseburgers": "tʃiːzbɜːɡəz",
    "cheeseburger": "tʃiːzbɜːɡɐ",
    "cheesecakes": "tʃiːzkeɪks",
    "cheesecake": "tʃiːzkeɪk",
    "cheesecloth": "tʃiːzklɒθ",
    "cheesed": "tʃiːzd",
    "cheeses": "tʃiːzɪz",
    "cheese": "tʃiːz",
    "cheesier": "tʃiːsɪɐ",
    "cheesiest": "tʃiːsɪəst",
    "cheesiness": "tʃiːsɪnəs",
    "cheesing": "tʃiːzɪŋ",
    "cheesy": "tʃiːsi",
    "cheetahs": "tʃiːtəz",
    "cheetah": "tʃiːtɐ",
    "chef": "ʃɛf",
    "chefs": "ʃɛfs",
    "chela": "tʃɛlɐ",
    "chelicerae": "tʃɛlɪsəriː",
    "chelonian": "tʃɛləʊniən",
    "chemical": "kɛmɪkəl",
    "chemically": "kɛmɪkli",
    "chemicals": "kɛmɪkəlz",
    "chemise": "ʃəmiːz",
    "chemist": "kɛmɪst",
    "chemistry": "kɛmɪstri",
    "chemists": "kɛmɪsts",
    "chemmy": "kɛmi",
    "chemo": "kiːməʊ",
    "chemotherapy": "kiːməʊθɛrəpi",
    "chenille": "tʃɛnɪl",
    "chequebooks": "tʃɛkbʊks",
    "chequebook": "tʃɛkbʊk",
    "chequerboard": "tʃɛkəbɔːd",
    "chequered": "tʃɛkəd",
    "chequers": "tʃɛkəz",
    "chequer": "tʃɛkɐ",
    "cheques": "tʃɛkz",
    "cheque": "tʃɛk",
    "chequing": "tʃɛkɪŋ",
    "cherishable": "tʃɛrɪʃəbəl",
    "cherished": "tʃɛrɪʃt",
    "cherishes": "tʃɛrɪʃɪz",
    "cherishing": "tʃɛrɪʃɪŋ",
    "cherish": "tʃɛrɪʃ",
    "cheroots": "tʃɛruːts",
    "cheroot": "tʃɛruːt",
    "cherries": "tʃɛrɪz",
    "cherry": "tʃɛri",
    "chert": "tʃɜːt",
    "cherubic": "tʃəruːbɪk",
    "cherubim": "tʃɛruːbɪm",
    "cherubs": "tʃɛrʌbz",
    "cherub": "tʃɛrʌb",
    "chervil": "tʃɜːvəl",
    "chessboards": "tʃɛsbɔːdz",
    "chessboard": "tʃɛsbɔːd",
    "chessman": "tʃɛsmən",
    "chessmen": "tʃɛsmɛn",
    "chess": "tʃɛs",
    "chested": "tʃɛstɪd",
    "chesterfields": "tʃɛstəfiːldz",
    "chesterfield": "tʃɛstəfiːld",
    "chestful": "tʃɛstfəl",
    "chestnuts": "tʃɛstnʌts",
    "chestnut": "tʃɛstnʌt",
    "chests": "tʃɛsts",
    "chest": "tʃɛst",
    "chesty": "tʃɛsti",
    "chevalier": "ʃɛvɐliɐ",
    "chevaliers": "ʃɛvɐliəz",
    "chevet": "ʃɛvɪt",
    "cheviot": "ʃɛvɪət",
    "chevron": "ʃɛvrɒn",
    "chevrons": "ʃɛvrɒnz",
    "chevy": "ʃɛvi",
    "chewable": "tʃjuːəbəl",
    "chewed": "tʃjuːd",
    "chewers": "tʃjuːəz",
    "chewer": "tʃjuːɐ",
    "chewier": "tʃjuːɪɐ",
    "chewiest": "tʃjuːɪəst",
    "chewiness": "tʃjuːɪnəs",
    "chewing": "tʃjuːɪŋ",
    "chews": "tʃjuːz",
    "chew": "tʃjuː",
    "chewy": "tʃjuːi",
    "chez": "ʃeɪ",
    "chiaroscuro": "tʃaɪərəskjʊrəʊ",
    "chicane": "ʃɪkeɪn",
    "chicanery": "ʃɪkeɪnəri",
    "chicanes": "ʃɪkeɪnz",
    "chicest": "tʃaɪsəst",
    "chichi": "tʃɪtʃaɪ",
    "chic": "ʃiːk",
    "chickadees": "tʃɪkɐdiːz",
    "chickadee": "tʃɪkɐdiː",
    "chickened": "tʃɪkɪnd",
    "chickenfeed": "tʃɪkɪnfiːd",
    "chickening": "tʃɪkɪnɪŋ",
    "chickenpox": "tʃɪkɪnpɒks",
    "chickenshits": "tʃɪkɪnʃɪts",
    "chickenshit": "tʃɪkɪnʃɪt",
    "chickens": "tʃɪkɪnz",
    "chicken": "tʃɪkɪn",
    "chickpeas": "tʃɪkpiəz",
    "chickpea": "tʃɪkpiə",
    "chicks": "tʃɪks",
    "chick": "tʃɪk",
    "chickweed": "tʃɪkwiːd",
    "chicle": "tʃɪkəl",
    "chicory": "tʃɪkəri",
    "chico": "tʃiːkəʊ",
    "chided": "tʃaɪdɪd",
    "chides": "tʃaɪdz",
    "chide": "tʃaɪd",
    "chiding": "tʃaɪdɪŋ",
    "chid": "tʃɪd",
    "chiefdom": "tʃiːfdəm",
    "chiefer": "tʃiːfɐ",
    "chiefest": "tʃiːfəst",
    "chiefly": "tʃiːfli",
    "chiefs": "tʃiːfs",
    "chieftainship": "tʃiːftənʃɪp",
    "chieftains": "tʃiːftənz",
    "chieftain": "tʃiːftən",
    "chief": "tʃiːf",
    "chiffchaff": "tʃɪftʃæf",
    "chiffonier": "tʃɪfənɪɐ",
    "chiffon": "tʃɪfən",
    "chiggers": "tʃɪɡəz",
    "chigger": "tʃɪɡɐ",
    "chignon": "tʃinjɒn",
    "chihuahuas": "tʃɪwɑːwəz",
    "chihuahua": "tʃɪwɑːwɐ",
    "chilblains": "tʃɪlbleɪnz",
    "chilblain": "tʃɪlbleɪn",
    "childbearing": "tʃaɪldbeərɪŋ",
    "childbed": "tʃaɪldbɛd",
    "childbirth": "tʃaɪldbɜːθ",
    "childcare": "tʃaɪldkeə",
    "childe": "tʃaɪldɐ",
    "childhoods": "tʃaɪldhʊdz",
    "childhood": "tʃaɪldhʊd",
    "childishly": "tʃaɪldɪʃli",
    "childishness": "tʃaɪldɪʃnəs",
    "childish": "tʃaɪldɪʃ",
    "childlessness": "tʃaɪldləsnəs",
    "childless": "tʃaɪldləs",
    "childlike": "tʃaɪldlaɪk",
    "childminders": "tʃaɪldmaɪndəz",
    "childminder": "tʃaɪldmaɪndɐ",
    "childminding": "tʃaɪldmaɪndɪŋ",
    "childproof": "tʃaɪldpruːf",
    "children": "tʃɪldrən",
    "child": "tʃaɪld",
    "chiles": "tʃɪliz",
    "chile": "tʃɪli",
    "chilis": "tʃɪliz",
    "chilled": "tʃɪld",
    "chillers": "tʃɪləz",
    "chiller": "tʃɪlɐ",
    "chillier": "tʃɪliɐ",
    "chillies": "tʃɪliz",
    "chilliest": "tʃɪliəst",
    "chillingly": "tʃɪlɪŋli",
    "chilling": "tʃɪlɪŋ",
    "chilli": "tʃɪli",
    "chills": "tʃɪlz",
    "chill": "tʃɪl",
    "chilly": "tʃɪli",
    "chimaera": "tʃɪmeərɐ",
    "chimed": "tʃaɪmd",
    "chimera": "kaɪmiərɐ",
    "chimeras": "kaɪmiərəz",
    "chimere": "tʃaɪmɐ",
    "chimes": "tʃaɪmz",
    "chime": "tʃaɪm",
    "chiming": "tʃaɪmɪŋ",
    "chimneypiece": "tʃɪmnɪpiːs",
    "chimneys": "tʃɪmnɪz",
    "chimney": "tʃɪmni",
    "chimpanzees": "tʃɪmpɐnziːz",
    "chimpanzee": "tʃɪmpɐnziː",
    "chimps": "tʃɪmps",
    "chimp": "tʃɪmp",
    "china": "tʃaɪnɐ",
    "chinaware": "tʃaɪnɐweə",
    "chinchillas": "tʃɪntʃɪləz",
    "chinchilla": "tʃɪntʃɪlɐ",
    "chines": "tʃaɪnz",
    "chine": "tʃaɪn",
    "chinking": "tʃɪŋkɪŋ",
    "chinks": "tʃɪŋks",
    "chink": "tʃɪŋk",
    "chinless": "tʃɪnləs",
    "chinned": "tʃɪnd",
    "chinoiserie": "tʃɪnɔɪsəri",
    "chinooks": "tʃɪnʊks",
    "chinook": "tʃɪnʊk",
    "chinos": "tʃiːnəʊz",
    "chino": "tʃiːnəʊ",
    "chins": "tʃɪnz",
    "chinstraps": "tʃɪnstræps",
    "chinstrap": "tʃɪnstræp",
    "chin": "tʃɪn",
    "chintz": "tʃɪnts",
    "chintzy": "tʃɪntsi",
    "chinwag": "tʃɪnwæɡ",
    "chipboard": "tʃɪpbɔːd",
    "chipmunks": "tʃɪpmʌŋks",
    "chipmunk": "tʃɪpmʌŋk",
    "chipolatas": "tʃɪpəlɑːtəz",
    "chipolata": "tʃɪpəlɑːtɐ",
    "chipped": "tʃɪpt",
    "chippers": "tʃɪpəz",
    "chipper": "tʃɪpɐ",
    "chippies": "tʃɪpɪz",
    "chippie": "tʃɪpi",
    "chippings": "tʃɪpɪŋz",
    "chipping": "tʃɪpɪŋ",
    "chippy": "tʃɪpi",
    "chips": "tʃɪps",
    "chip": "tʃɪp",
    "chirk": "tʃɜːk",
    "chiropodist": "kɪrɒpədɪst",
    "chiropodists": "kɪrɒpədɪsts",
    "chiropody": "kɪrɒpədi",
    "chiropractic": "kaɪrəpræktɪk",
    "chiropractor": "kaɪrəpræktɐ",
    "chiropractors": "kaɪrəpræktəz",
    "chirped": "tʃɜːpt",
    "chirpier": "tʃɜːpɪɐ",
    "chirpily": "tʃɜːpɪli",
    "chirpiness": "tʃɜːpɪnəs",
    "chirping": "tʃɜːpɪŋ",
    "chirps": "tʃɜːps",
    "chirp": "tʃɜːp",
    "chirpy": "tʃɜːpi",
    "chirring": "tʃɜːrɪŋ",
    "chirruped": "tʃɪruːpt",
    "chirruping": "tʃɪruːpɪŋ",
    "chirrups": "tʃɪrʌps",
    "chirrup": "tʃɪrʌp",
    "chiselled": "tʃɪzəld",
    "chisellers": "tʃaɪsələz",
    "chiseller": "tʃaɪsəlɐ",
    "chiselling": "tʃɪzəlɪŋ",
    "chisels": "tʃɪzəlz",
    "chisel": "tʃɪzəl",
    "chis": "tʃaɪz",
    "chi": "tʃaɪ",
    "chitchatting": "tʃɪtʃætɪŋ",
    "chitchat": "tʃɪtʃæt",
    "chitin": "tʃɪtɪn",
    "chitlins": "tʃɪtlɪnz",
    "chits": "tʃɪts",
    "chittering": "tʃɪtərɪŋ",
    "chitterlings": "tʃɪtɜːlɪŋz",
    "chitters": "tʃɪtəz",
    "chitter": "tʃɪtɐ",
    "chit": "tʃɪt",
    "chivalric": "tʃɪvælrɪk",
    "chivalrously": "ʃɪvəlrəsli",
    "chivalrous": "ʃɪvəlrəs",
    "chivalry": "tʃɪvəlri",
    "chives": "tʃaɪvz",
    "chive": "tʃaɪv",
    "chivvied": "tʃɪvɪd",
    "chivvies": "tʃɪvɪz",
    "chivvying": "tʃɪvɪɪŋ",
    "chivvy": "tʃɪvi",
    "chlamydia": "klæmɪdiə",
    "chlorate": "klɔːreɪt",
    "chlorates": "klɔːreɪts",
    "chloride": "klɔːraɪd",
    "chlorides": "klɔːraɪdz",
    "chlorinated": "klɔːrɪneɪtɪd",
    "chlorine": "klɔːriːn",
    "chlorofluorocarbons": "klɔːrəʊflɔːrəkɑːbənz",
    "chloroform": "klɔːrəʊfɔːm",
    "chlorophyll": "klɔːrəʊfɪl",
    "chloroplasts": "klɔːrəʊplɑːsts",
    "chloroquine": "klɔːrəʊkwaɪn",
    "chlorosis": "klɔːrəʊsiz",
    "chlorpromazine": "klɔːrəprɒmɐziːn",
    "chocaholics": "tʃɒkɐhɒlɪks",
    "chocaholic": "tʃɒkɐhɒlɪk",
    "chocked": "tʃɒkt",
    "chockfull": "tʃɒkfʊl",
    "chocking": "tʃɒkɪŋ",
    "chocks": "tʃɒks",
    "chock": "tʃɒk",
    "chocoholics": "tʃɒkəʊhɒlɪks",
    "chocoholic": "tʃɒkəʊhɒlɪk",
    "chocolates": "tʃɒkləts",
    "chocolate": "tʃɒklət",
    "chocolatey": "tʃɒkəleɪti",
    "chocolatier": "tʃɒkəlætɪɐ",
    "chocolaty": "tʃɒkəlæti",
    "chocs": "tʃɒks",
    "choc": "tʃɒk",
    "choicer": "tʃɔɪsɐ",
    "choices": "tʃɔɪsɪz",
    "choicest": "tʃɔɪsəst",
    "choice": "tʃɔɪs",
    "choirboy": "kwaɪəbɔɪ",
    "choirboys": "kwaɪəbɔɪz",
    "choir": "kwaɪə",
    "choirmaster": "kwaɪəmɑːstɐ",
    "choirmasters": "kwaɪəmɑːstəz",
    "choirs": "kwaɪəz",
    "choked": "tʃəʊkt",
    "chokers": "tʃəʊkəz",
    "choker": "tʃəʊkɐ",
    "chokes": "tʃəʊks",
    "choke": "tʃəʊk",
    "choking": "tʃəʊkɪŋ",
    "cholecystectomy": "kəʊlsɪstɛktəmi",
    "cholecystitis": "kəʊlsɪstaɪtɪs",
    "cholent": "kəʊlənt",
    "cholera": "kɒlərɐ",
    "choleric": "kəʊlɛrɪk",
    "choler": "kəʊlɐ",
    "cholesterol": "kəlɛstərɒl",
    "cholla": "kɒlɐ",
    "chomped": "tʃɒmpt",
    "chomping": "tʃɒmpɪŋ",
    "chomps": "tʃɒmps",
    "chomp": "tʃɒmp",
    "chon": "tʃɒn",
    "chook": "tʃʊk",
    "choosers": "tʃuːzəz",
    "chooser": "tʃuːzɐ",
    "chooses": "tʃuːzɪz",
    "choose": "tʃuːz",
    "choosey": "tʃuːzi",
    "choosier": "tʃuːsɪɐ",
    "choosing": "tʃuːzɪŋ",
    "choosy": "tʃuːsi",
    "chophouse": "tʃɒfaʊs",
    "chopped": "tʃɒpt",
    "choppered": "tʃɒpəd",
    "choppering": "tʃɒpərɪŋ",
    "choppers": "tʃɒpəz",
    "chopper": "tʃɒpɐ",
    "choppier": "tʃɒpɪɐ",
    "choppiness": "tʃɒpɪnəs",
    "chopping": "tʃɒpɪŋ",
    "choppy": "tʃɒpi",
    "chopsticks": "tʃɒpstɪks",
    "chopstick": "tʃɒpstɪk",
    "chops": "tʃɒps",
    "chop": "tʃɒp",
    "chorale": "kɔːreɪl",
    "chorales": "kɔːreɪlz",
    "chordal": "kɔːdəl",
    "chord": "kɔːd",
    "chords": "kɔːdz",
    "chorea": "kɔːriə",
    "choreographed": "kɔːrɪɒɡræfd",
    "choreographer": "kɔːrɪɒɡrəfɐ",
    "choreographers": "kɔːrɪɒɡrəfəz",
    "choreographically": "kɔːrɪəɡræfɪkli",
    "choreographic": "kɔːrɪəɡræfɪk",
    "choreographing": "kɔːrɪɒɡræfɪŋ",
    "choreograph": "kɔːrɪɒɡræf",
    "choreographs": "kɔːrɪɒɡræfz",
    "choreography": "kɔːrɪɒɡrəfi",
    "chores": "tʃɔːz",
    "chore": "tʃɔː",
    "chorion": "kɔːriən",
    "chorister": "kɔːrɪstɐ",
    "choristers": "kɔːrɪstəz",
    "chorizo": "tʃɔriːzəʊ",
    "chortled": "tʃɔːtəld",
    "chortles": "tʃɔːtəlz",
    "chortle": "tʃɔːtəl",
    "chortling": "tʃɔːtlɪŋ",
    "chorused": "kɔːruːsd",
    "choruses": "kɔːrəsɪz",
    "chorus": "kɔːrəs",
    "chosen": "tʃəʊzən",
    "chose": "tʃəʊz",
    "choughs": "tʃəʊz",
    "chough": "tʃəʊ",
    "chou": "tʃuː",
    "chowders": "tʃaʊdəz",
    "chowder": "tʃaʊdɐ",
    "chowed": "tʃaʊd",
    "chowing": "tʃaʊɪŋ",
    "chow": "tʃaʊ",
    "chrism": "krɪzəm",
    "christened": "krɪstənd",
    "christening": "krɪstənɪŋ",
    "christenings": "krɪstənɪŋz",
    "christen": "krɪstən",
    "christiania": "krɪsʃiəniə",
    "christian": "krɪstʃən",
    "christie": "krɪsti",
    "christy": "krɪsti",
    "chromatically": "krəʊmætɪkli",
    "chromatic": "krəʊmætɪk",
    "chromatids": "krəʊmɐtɪdz",
    "chromatin": "krəʊmɐtɪn",
    "chromatograph": "krəʊmɐtɒɡræf",
    "chromatography": "krəʊmɐtɒɡrəfi",
    "chromed": "krəʊmd",
    "chrome": "krəʊm",
    "chroming": "krəʊmɪŋ",
    "chromium": "krəʊmiəm",
    "chromo": "krəʊməʊ",
    "chromolithograph": "krəʊməlɪθəɡræf",
    "chromosomal": "krəʊməsɒməl",
    "chromosome": "krəʊməsəʊm",
    "chromosomes": "krəʊməsəʊmz",
    "chromosphere": "krəʊməsfiə",
    "chronically": "krɒnɪkli",
    "chronic": "krɒnɪk",
    "chronicled": "krɒnɪkəld",
    "chronicle": "krɒnɪkəl",
    "chronicler": "krɒnɪklɐ",
    "chroniclers": "krɒnɪkləz",
    "chronicles": "krɒnɪkəlz",
    "chronicling": "krɒnɪklɪŋ",
    "chronograph": "krɒnəɡræf",
    "chronological": "krɒnəlɒdʒɪkəl",
    "chronologically": "krɒnəlɒdʒɪkli",
    "chronology": "krənɒlədʒi",
    "chronometer": "krənɒmɪtɐ",
    "chronometers": "krənɒmɪtəz",
    "chronon": "krɒnɒn",
    "chrysalises": "krɪsəlɪsɪz",
    "chrysalis": "krɪsəlɪs",
    "chrysanthemum": "krɪsɑːnθəməm",
    "chrysanthemums": "krɪsɑːnθəməmz",
    "chryselephantine": "kraɪslɪfɑːntiːn",
    "chubbier": "tʃʌbɪɐ",
    "chubbiness": "tʃʌbɪnəs",
    "chubby": "tʃʌbi",
    "chubs": "tʃʌbz",
    "chub": "tʃʌb",
    "chucked": "tʃʌkt",
    "chucking": "tʃʌkɪŋ",
    "chuckled": "tʃʌkəld",
    "chuckles": "tʃʌkəlz",
    "chuckle": "tʃʌkəl",
    "chuckling": "tʃʌklɪŋ",
    "chucks": "tʃʌks",
    "chuck": "tʃʌk",
    "chuffed": "tʃʌft",
    "chuffing": "tʃʌfɪŋ",
    "chuffs": "tʃʌfs",
    "chuff": "tʃʌf",
    "chugged": "tʃʌɡd",
    "chugging": "tʃʌɡɪŋ",
    "chugs": "tʃʌɡz",
    "chug": "tʃʌɡ",
    "chukkas": "tʃʌkəz",
    "chukka": "tʃʌkɐ",
    "chukkers": "tʃʌkəz",
    "chummed": "tʃʌmd",
    "chumminess": "tʃʌmɪnəs",
    "chumming": "tʃʌmɪŋ",
    "chummy": "tʃʌmi",
    "chumps": "tʃʌmps",
    "chump": "tʃʌmp",
    "chums": "tʃʌmz",
    "chum": "tʃʌm",
    "chundered": "tʃʌndəd",
    "chundering": "tʃʌndərɪŋ",
    "chunder": "tʃʌndɐ",
    "chunkier": "tʃʌŋkiɐ",
    "chunkiest": "tʃʌŋkiəst",
    "chunkiness": "tʃʌŋkinəs",
    "chunks": "tʃʌŋks",
    "chunk": "tʃʌŋk",
    "chunky": "tʃʌŋki",
    "chuntering": "tʃʌntərɪŋ",
    "chunter": "tʃʌntɐ",
    "churches": "tʃɜːtʃɪz",
    "churchgoers": "tʃɜːtʃɡəʊəz",
    "churchgoer": "tʃɜːtʃɡəʊɐ",
    "churchgoing": "tʃɜːtʃɡəʊɪŋ",
    "churchman": "tʃɜːtʃmən",
    "churchmen": "tʃɜːtʃmɛn",
    "church": "tʃɜːtʃ",
    "churchwardens": "tʃɜːtʃwɔːdənz",
    "churchwarden": "tʃɜːtʃwɔːdən",
    "churchyards": "tʃɜːtʃjɑːdz",
    "churchyard": "tʃɜːtʃjɑːd",
    "churchy": "tʃɜːtʃi",
    "churlish": "tʃɜːlɪʃ",
    "churl": "tʃɜːl",
    "churned": "tʃɜːnd",
    "churning": "tʃɜːnɪŋ",
    "churns": "tʃɜːnz",
    "churn": "tʃɜːn",
    "chutes": "ʃuːts",
    "chute": "ʃuːt",
    "chutneys": "tʃʌtnɪz",
    "chutney": "tʃʌtni",
    "chutzpah": "tʃʌtspɐ",
    "chyme": "tʃaɪm",
    "ciao": "tʃaʊ",
    "cicada": "sɪkɑːdɐ",
    "cicadas": "sɪkɑːdəz",
    "cicely": "saɪsli",
    "cicero": "saɪsrəʊ",
    "cichlids": "sɪtʃlɪdz",
    "cichlid": "sɪtʃlɪd",
    "cider": "saɪdɐ",
    "ciders": "saɪdəz",
    "cigarette": "sɪɡərɛt",
    "cigarettes": "sɪɡərɛts",
    "cigarillo": "sɪɡɑːrɪləʊ",
    "cigarillos": "sɪɡɑːrɪləʊz",
    "cigar": "sɪɡɑː",
    "cigars": "sɪɡɑːz",
    "cig": "sɪɡ",
    "cilantro": "sɪlɑːntrəʊ",
    "ciliary": "sɪliəri",
    "cilia": "sɪliɐ",
    "cilium": "sɪliəm",
    "cimex": "saɪmɛks",
    "cinched": "sɪntʃt",
    "cinches": "sɪntʃɪz",
    "cinching": "sɪntʃɪŋ",
    "cinchona": "sɪntʃəʊnɐ",
    "cinch": "sɪntʃ",
    "cinder": "sɪndɐ",
    "cinders": "sɪndəz",
    "cindery": "sɪndəri",
    "cinema": "sɪnəmɐ",
    "cinemas": "sɪnəməz",
    "cinematically": "sɪnɪmætɪkli",
    "cinematic": "sɪnɪmætɪk",
    "cinematographer": "sɪnɪmɐtɒɡrəfɐ",
    "cinematographers": "sɪnɪmɐtɒɡrəfəz",
    "cinematograph": "sɪnɪmætəɡræf",
    "cinematography": "sɪnɪmɐtɒɡrəfi",
    "cineraria": "sɪnəreəriə",
    "cine": "sɪn",
    "cinnabar": "sɪnɐbɑː",
    "cinnamon": "sɪnəmən",
    "cinquecento": "sɪnkwɪsɛntəʊ",
    "cinque": "sɪnk",
    "ciphering": "saɪfərɪŋ",
    "cipher": "saɪfɐ",
    "ciphers": "saɪfəz",
    "circadian": "sɜːkeɪdiən",
    "circa": "sɜːkɐ",
    "circled": "sɜːkəld",
    "circle": "sɜːkəl",
    "circles": "sɜːkəlz",
    "circlet": "sɜːklət",
    "circling": "sɜːklɪŋ",
    "circuited": "sɜːkɪtɪd",
    "circuiting": "sɜːkɪtɪŋ",
    "circuitous": "sɜːkjuːɪtəs",
    "circuitry": "sɜːkɪtri",
    "circuit": "sɜːkɪt",
    "circuits": "sɜːkɪts",
    "circularity": "sɜːkjʊlærɪti",
    "circularly": "sɜːkjʊləli",
    "circular": "sɜːkjʊlɐ",
    "circulars": "sɜːkjʊləz",
    "circulated": "sɜːkjʊleɪtɪd",
    "circulate": "sɜːkjʊleɪt",
    "circulates": "sɜːkjʊleɪts",
    "circulating": "sɜːkjʊleɪtɪŋ",
    "circulation": "sɜːkjʊleɪʃən",
    "circulations": "sɜːkjʊleɪʃənz",
    "circulatory": "sɜːkjʊleɪtəri",
    "circumambulate": "sɜːkəmæmbjʊleɪt",
    "circumcised": "sɜːkəmsaɪzd",
    "circumcise": "sɜːkəmsaɪz",
    "circumcising": "sɜːkəmsaɪzɪŋ",
    "circumcision": "sɜːkəmsɪʒən",
    "circumcisions": "sɜːkəmsɪʒənz",
    "circumference": "sɜːkʌmfrəns",
    "circumferential": "sɜːkəmfərɛnʃəl",
    "circumflex": "sɜːkəmflɛks",
    "circumlocution": "sɜːkəmləkjuːʃən",
    "circumlocutions": "sɜːkəmləkjuːʃənz",
    "circumnavigated": "sɜːkəmnævɪɡeɪtɪd",
    "circumnavigate": "sɜːkəmnævɪɡeɪt",
    "circumnavigates": "sɜːkəmnævɪɡeɪts",
    "circumnavigating": "sɜːkəmnævɪɡeɪtɪŋ",
    "circumnavigation": "sɜːkəmnævɪɡeɪʃən",
    "circumnavigations": "sɜːkəmnævɪɡeɪʃənz",
    "circumpolar": "sɜːkəmpəʊlɐ",
    "circumscribed": "sɜːkəmskraɪbd",
    "circumscribe": "sɜːkəmskraɪb",
    "circumspection": "sɜːkəmspɛkʃən",
    "circumspect": "sɜːkəmspɛkt",
    "circumstance": "sɜːkəmstæns",
    "circumstances": "sɜːkəmstænsɪz",
    "circumstantially": "sɜːkəmstɑːnʃəli",
    "circumstantial": "sɜːkəmstɑːnʃəl",
    "circumvallate": "sɜːkəmvæleɪt",
    "circumvented": "sɜːkəmvɛntɪd",
    "circumventing": "sɜːkəmvɛntɪŋ",
    "circumvention": "sɜːkəmvɛnʃən",
    "circumvent": "sɜːkəmvɛnt",
    "circumvents": "sɜːkəmvɛnts",
    "circuses": "sɜːkəsɪz",
    "circus": "sɜːkəs",
    "circusy": "sɜːkʌsi",
    "cirque": "sɜːk",
    "cirrhosis": "sɜːrəʊsɪs",
    "cirrocumulus": "sɪrəkjuːmjʊləs",
    "cirrus": "sɪrəs",
    "cisco": "sɪskəʊ",
    "cisterns": "sɪstənz",
    "cistern": "sɪstən",
    "cist": "sɪst",
    "citadels": "sɪtədɛlz",
    "citadel": "sɪtədɛl",
    "citation": "saɪteɪʃən",
    "citations": "saɪteɪʃənz",
    "cited": "saɪtɪd",
    "cite": "saɪt",
    "cites": "saɪts",
    "cities": "sɪtiz",
    "citing": "saɪtɪŋ",
    "citizenry": "sɪtɪzənri",
    "citizenship": "sɪtɪzənʃɪp",
    "citizens": "sɪtɪzənz",
    "citizen": "sɪtɪzən",
    "citrate": "sɪtreɪt",
    "citric": "sɪtrɪk",
    "citrines": "sɪtriːnz",
    "citrine": "sɪtriːn",
    "citronella": "sɪtrəʊnɛlɐ",
    "citrons": "sɪtrɒnz",
    "citron": "sɪtrɒn",
    "citrus": "sɪtrəs",
    "cittern": "sɪtən",
    "cityscape": "sɪtɪskeɪp",
    "city": "sɪti",
    "citywide": "sɪtɪwaɪd",
    "civet": "saɪvət",
    "civets": "saɪvəts",
    "civics": "sɪvɪks",
    "civic": "sɪvɪk",
    "civilians": "sɪvɪliənz",
    "civilian": "sɪvɪliən",
    "civilisations": "sɪvɪlaɪzeɪʃənz",
    "civilisation": "sɪvɪlaɪzeɪʃən",
    "civilised": "sɪvəlaɪzd",
    "civilise": "sɪvəlaɪz",
    "civilising": "sɪvəlaɪzɪŋ",
    "civilities": "sɪvɪlɪtiz",
    "civility": "sɪvɪlɪti",
    "civilly": "sɪvəli",
    "civil": "sɪvəl",
    "civvies": "sɪvɪz",
    "clachan": "klætʃən",
    "clacked": "klækt",
    "clacker": "klækɐ",
    "clacking": "klækɪŋ",
    "clack": "klæk",
    "clacks": "klæks",
    "claddagh": "klædɑːɡ",
    "cladding": "klædɪŋ",
    "clad": "klæd",
    "claimable": "kleɪməbəl",
    "claimant": "kleɪmənt",
    "claimants": "kleɪmənts",
    "claimed": "kleɪmd",
    "claimer": "kleɪmɐ",
    "claimers": "kleɪməz",
    "claiming": "kleɪmɪŋ",
    "claim": "kleɪm",
    "claims": "kleɪmz",
    "clairvoyance": "kleəvɔɪəns",
    "clairvoyant": "kleəvɔɪənt",
    "clairvoyants": "kleəvɔɪənts",
    "clambake": "klæmbeɪk",
    "clambered": "klæmbəd",
    "clambering": "klæmbərɪŋ",
    "clamber": "klæmbɐ",
    "clambers": "klæmbəz",
    "clam": "klæm",
    "clammed": "klæmd",
    "clamming": "klæmɪŋ",
    "clammy": "klæmi",
    "clamorous": "klæmərəs",
    "clamoured": "klæməd",
    "clamouring": "klæmɜːrɪŋ",
    "clamour": "klæmɐ",
    "clamours": "klæməz",
    "clampdown": "klæmpdaʊn",
    "clampdowns": "klæmpdaʊnz",
    "clamped": "klæmpt",
    "clamper": "klæmpɐ",
    "clamping": "klæmpɪŋ",
    "clamp": "klæmp",
    "clamps": "klæmps",
    "clamshell": "klæmʃɛl",
    "clams": "klæmz",
    "clandestine": "klændɛstɪn",
    "clandestinely": "klændɛstɪnli",
    "clanged": "klæŋd",
    "clanger": "klæŋɡɐ",
    "clangers": "klæŋɡəz",
    "clanging": "klæŋɪŋ",
    "clang": "klæŋ",
    "clangour": "klæŋɡɐ",
    "clangs": "klæŋz",
    "clanked": "klæŋkt",
    "clanking": "klæŋkɪŋ",
    "clank": "klæŋk",
    "clan": "klæn",
    "clanks": "klæŋks",
    "clannish": "klænɪʃ",
    "clans": "klænz",
    "clansman": "klænzmən",
    "clansmen": "klænzmɛn",
    "clapboard": "klæpbɔːd",
    "clap": "klæp",
    "clapped": "klæpt",
    "clapperboard": "klæpəbɔːd",
    "clapperboards": "klæpəbɔːdz",
    "clapper": "klæpɐ",
    "clappers": "klæpəz",
    "clapping": "klæpɪŋ",
    "claps": "klæps",
    "claptrap": "klæptræp",
    "claque": "klæk",
    "claques": "klæks",
    "clarence": "klærəns",
    "claret": "klærət",
    "clarets": "klærəts",
    "clarification": "klærɪfɪkeɪʃən",
    "clarifications": "klærɪfɪkeɪʃənz",
    "clarified": "klærɪfaɪd",
    "clarifies": "klærɪfaɪz",
    "clarifying": "klærɪfaɪɪŋ",
    "clarify": "klærɪfaɪ",
    "clarinet": "klærənɛt",
    "clarinets": "klærənɛts",
    "clarinettist": "klæraɪntɪst",
    "clarinettists": "klæraɪntɪsts",
    "clarion": "klæriən",
    "clarity": "klærɪti",
    "claro": "klærəʊ",
    "claros": "klærəʊz",
    "clarsach": "klɑːsætʃ",
    "clary": "kleəri",
    "clashed": "klæʃt",
    "clashes": "klæʃɪz",
    "clashing": "klæʃɪŋ",
    "clash": "klæʃ",
    "clasped": "klɑːspt",
    "clasping": "klɑːspɪŋ",
    "clasp": "klɑːsp",
    "clasps": "klɑːsps",
    "classed": "klɑːst",
    "classes": "klɑːsɪz",
    "classical": "klæsɪkəl",
    "classically": "klæsɪkli",
    "classicism": "klæsɪsɪzəm",
    "classicist": "klæsɪsɪst",
    "classicists": "klæsɪsɪsts",
    "classic": "klæsɪk",
    "classics": "klæsɪks",
    "classier": "klɑːsɪɐ",
    "classiest": "klɑːsɪəst",
    "classification": "klæsɪfɪkeɪʃən",
    "classifications": "klæsɪfɪkeɪʃənz",
    "classified": "klæsɪfaɪd",
    "classifieds": "klæsɪfaɪdz",
    "classifier": "klæsɪfaɪə",
    "classifiers": "klæsɪfaɪəz",
    "classifies": "klæsɪfaɪz",
    "classifying": "klæsɪfaɪɪŋ",
    "classify": "klæsɪfaɪ",
    "classily": "klɑːsɪli",
    "classiness": "klɑːsɪnəs",
    "classing": "klɑːsɪŋ",
    "classism": "klɑːsɪzəm",
    "classist": "klæsɪst",
    "class": "klɑːs",
    "classless": "klɑːsləs",
    "classlessness": "klɑːsləsnəs",
    "classmate": "klɑːsmeɪt",
    "classmates": "klɑːsmeɪts",
    "classroom": "klɑːsruːm",
    "classrooms": "klɑːsruːmz",
    "classwork": "klɑːswɜːk",
    "classy": "klɑːsi",
    "clastic": "klɑːstɪk",
    "clattered": "klætəd",
    "clattering": "klætərɪŋ",
    "clatter": "klætɐ",
    "clatters": "klætəz",
    "clause": "klɔːz",
    "clauses": "klɔːzɪz",
    "claustrophobia": "klɒstrəfəʊbiə",
    "claustrophobic": "klɒstrəfəʊbɪk",
    "clave": "kleɪv",
    "claver": "kleɪvɐ",
    "clavicle": "klævɪkəl",
    "clavicles": "klævɪkəlz",
    "clavier": "kleɪvɪɐ",
    "clawed": "klɔːd",
    "clawing": "klɔːrɪŋ",
    "claw": "klɔː",
    "claws": "klɔːz",
    "clayey": "kleɪi",
    "clay": "kleɪ",
    "claymore": "kleɪmɔː",
    "claymores": "kleɪmɔːz",
    "clays": "kleɪz",
    "claytonia": "kleɪtəʊniə",
    "cleaned": "kliːnd",
    "cleaner": "kliːnɐ",
    "cleaners": "kliːnəz",
    "cleanest": "kliːnəst",
    "cleaning": "kliːnɪŋ",
    "cleanings": "kliːnɪŋz",
    "clean": "kliːn",
    "cleanliest": "kliːnliəst",
    "cleanliness": "klɛnlɪnəs",
    "cleanness": "kliːnnəs",
    "cleansed": "klɛnzd",
    "cleanse": "klɛnz",
    "cleanser": "klɛnzɐ",
    "cleansers": "klɛnzəz",
    "cleanses": "klɛnzɪz",
    "cleansing": "klɛnzɪŋ",
    "cleans": "kliːnz",
    "cleanup": "kliːnʌp",
    "clearance": "kliərəns",
    "clearances": "kliərənsɪz",
    "cleared": "kliəd",
    "clearer": "kliərɐ",
    "clearest": "kliərəst",
    "clearing": "kliərɪŋ",
    "clearings": "kliərɪŋz",
    "clear": "kliə",
    "clearly": "kliəli",
    "clearness": "kliənəs",
    "clears": "kliəz",
    "clearway": "kliəweɪ",
    "clearwing": "kliəwərɪŋ",
    "cleat": "kliːt",
    "cleats": "kliːts",
    "cleavage": "kliːvɪdʒ",
    "cleavages": "kliːvɪdʒɪz",
    "cleaved": "kliːvd",
    "cleave": "kliːv",
    "cleaver": "kliːvɐ",
    "cleavers": "kliːvəz",
    "cleaves": "kliːvz",
    "cleaving": "kliːvɪŋ",
    "cleek": "kliːk",
    "clef": "klɛf",
    "clefs": "klɛfs",
    "cleft": "klɛft",
    "clefts": "klɛfts",
    "clematis": "klɛmɑːtiz",
    "clemency": "klɛmənsi",
    "clementine": "klɛmɪntaɪn",
    "clementines": "klɛmɪntaɪnz",
    "clement": "klɛmənt",
    "clem": "klɛm",
    "clenched": "klɛntʃt",
    "clenches": "klɛntʃɪz",
    "clenching": "klɛntʃɪŋ",
    "clench": "klɛntʃ",
    "clerestory": "klɛrɪstəri",
    "clergy": "klɜːdʒi",
    "clergyman": "klɜːdʒɪmən",
    "clergymen": "klɜːdʒɪmɛn",
    "clerical": "klɛrɪkəl",
    "cleric": "klɛrɪk",
    "clerics": "klɛrɪks",
    "clerihew": "klɛrɪhjuː",
    "clerked": "klɑːkt",
    "clerking": "klɑːkɪŋ",
    "clerk": "klɑːk",
    "clerkship": "klɑːkʃɪp",
    "clerks": "klɑːks",
    "cleverer": "klɛvərɐ",
    "cleverest": "klɛvərəst",
    "clever": "klɛvɐ",
    "cleverly": "klɛvəli",
    "cleverness": "klɛvənəs",
    "clew": "kluː",
    "clews": "kluːz",
    "clickable": "klɪkəbəl",
    "clicked": "klɪkt",
    "clicker": "klɪkɐ",
    "clickers": "klɪkəz",
    "clicking": "klɪkɪŋ",
    "click": "klɪk",
    "clicks": "klɪks",
    "client": "klaɪənt",
    "clients": "klaɪənts",
    "cliffhanger": "klɪfhæŋɐ",
    "cliffhangers": "klɪfhæŋəz",
    "cliffhanging": "klɪfhæŋɪŋ",
    "cliff": "klɪf",
    "cliffs": "klɪfs",
    "clifftop": "klɪftɒp",
    "clifftops": "klɪftɒps",
    "cliffy": "klɪfi",
    "climactically": "klaɪmæktɪkli",
    "climactic": "klaɪmæktɪk",
    "climate": "klaɪmət",
    "climates": "klaɪməts",
    "climatically": "klaɪmætɪkli",
    "climatic": "klaɪmætɪk",
    "climatologist": "klaɪmɐtɒlədʒɪst",
    "climatologists": "klaɪmɐtɒlədʒɪsts",
    "climaxed": "klaɪmækst",
    "climaxes": "klaɪmæksɪz",
    "climaxing": "klaɪmæksɪŋ",
    "climax": "klaɪmæks",
    "climbable": "klaɪməbəl",
    "climbdown": "klaɪmdaʊn",
    "climbed": "klaɪmd",
    "climber": "klaɪmɐ",
    "climbers": "klaɪməz",
    "climbing": "klaɪmɪŋ",
    "climb": "klaɪm",
    "climbs": "klaɪmz",
    "clime": "klaɪm",
    "climes": "klaɪmz",
    "clinched": "klɪntʃt",
    "clincher": "klɪntʃɐ",
    "clinchers": "klɪntʃəz",
    "clinches": "klɪntʃɪz",
    "clinching": "klɪntʃɪŋ",
    "clinch": "klɪntʃ",
    "cline": "klaɪn",
    "clinger": "klɪŋɡɐ",
    "clingers": "klɪŋɡəz",
    "clingfilm": "klɪŋfɪlm",
    "clinging": "klɪŋɪŋ",
    "cling": "klɪŋ",
    "clings": "klɪŋz",
    "clingy": "klɪŋi",
    "clinical": "klɪnɪkəl",
    "clinically": "klɪnɪkli",
    "clinician": "klɪnɪʃən",
    "clinicians": "klɪnɪʃənz",
    "clinic": "klɪnɪk",
    "clinics": "klɪnɪks",
    "clinked": "klɪŋkt",
    "clinker": "klɪŋkɐ",
    "clinking": "klɪŋkɪŋ",
    "clink": "klɪŋk",
    "clinks": "klɪŋks",
    "clinometer": "klɪnɒmɪtɐ",
    "clipboard": "klɪpbɔːd",
    "clipboards": "klɪpbɔːdz",
    "clip": "klɪp",
    "clipped": "klɪpt",
    "clipper": "klɪpɐ",
    "clippers": "klɪpəz",
    "clipping": "klɪpɪŋ",
    "clippings": "klɪpɪŋz",
    "clips": "klɪps",
    "clique": "kliːk",
    "cliques": "kliːks",
    "cliquey": "klɪkwi",
    "cliquier": "klɪkwɪɐ",
    "clitoral": "klɪtərəl",
    "clitoris": "klɪtərɪs",
    "cloaca": "kləʊkɐ",
    "cloaked": "kləʊkt",
    "cloaking": "kləʊkɪŋ",
    "cloak": "kləʊk",
    "cloakroom": "kləʊkruːm",
    "cloakrooms": "kləʊkruːmz",
    "cloaks": "kləʊks",
    "clobbered": "klɒbəd",
    "clobbering": "klɒbərɪŋ",
    "clobber": "klɒbɐ",
    "cloche": "klɒʃ",
    "cloches": "klɒʃɪz",
    "clocked": "klɒkt",
    "clocker": "klɒkɐ",
    "clocking": "klɒkɪŋ",
    "clock": "klɒk",
    "clockmaker": "klɒkmeɪkɐ",
    "clockmakers": "klɒkmeɪkəz",
    "clocks": "klɒks",
    "clockwise": "klɒkwaɪz",
    "clockwork": "klɒkwɜːk",
    "clockworks": "klɒkwɜːks",
    "clodhoppers": "klɒdhɒpəz",
    "clodhopping": "klɒdhɒpɪŋ",
    "clod": "klɒd",
    "clods": "klɒdz",
    "clogged": "klɒɡd",
    "clogging": "klɒɡɪŋ",
    "cloggy": "klɒɡi",
    "clog": "klɒɡ",
    "clogs": "klɒɡz",
    "cloistered": "klɔɪstəd",
    "cloister": "klɔɪstɐ",
    "cloisters": "klɔɪstəz",
    "clomping": "klɒmpɪŋ",
    "clomp": "klɒmp",
    "cloned": "kləʊnd",
    "clone": "kləʊn",
    "clones": "kləʊnz",
    "cloning": "kləʊnɪŋ",
    "clonked": "klɒŋkt",
    "clonking": "klɒŋkɪŋ",
    "clonk": "klɒŋk",
    "clop": "klɒp",
    "clopped": "klɒpt",
    "clopping": "klɒpɪŋ",
    "clops": "klɒps",
    "closed": "kləʊzd",
    "closely": "kləʊsli",
    "closeness": "kləʊznəs",
    "closers": "kləʊsəz",
    "closest": "kləʊsəst",
    "closeted": "klɒzɪtɪd",
    "closet": "klɒzɪt",
    "closets": "klɒzɪts",
    "closeup": "kləʊsʌp",
    "closeups": "kləʊsʌps",
    "closing": "kləʊzɪŋ",
    "closings": "kləʊzɪŋz",
    "clos": "kləʊz",
    "clostridium": "kləstrɪdiəm",
    "closure": "kləʊʒɐ",
    "closures": "kləʊʒəz",
    "clothed": "kləʊðd",
    "clothe": "kləʊð",
    "clotheshorse": "kləʊðʃɔːs",
    "clothes": "kləʊðz",
    "clothesline": "kləʊðslaɪn",
    "clothier": "klɒθɪɐ",
    "clothiers": "kləʊðiəz",
    "clothing": "kləʊðɪŋ",
    "cloth": "klɒθ",
    "cloths": "klɒθs",
    "clot": "klɒt",
    "clots": "klɒts",
    "clotted": "klɒtɪd",
    "clotting": "klɒtɪŋ",
    "cloture": "klɒtʃɐ",
    "cloudberries": "klaʊdbərɪz",
    "cloudburst": "klaʊdbɜːst",
    "clouded": "klaʊdɪd",
    "cloudier": "klaʊdɪɐ",
    "cloudiest": "klaʊdɪəst",
    "cloudiness": "klaʊdɪnəs",
    "clouding": "klaʊdɪŋ",
    "cloud": "klaʊd",
    "cloudless": "klaʊdləs",
    "clouds": "klaʊdz",
    "cloudy": "klaʊdi",
    "clough": "klʌf",
    "clouted": "klaʊtɪd",
    "clouting": "klaʊtɪŋ",
    "clout": "klaʊt",
    "clouts": "klaʊts",
    "clove": "kləʊv",
    "cloven": "kləʊvən",
    "clover": "kləʊvɐ",
    "cloverleaf": "kləʊvəliːf",
    "clovers": "kləʊvəz",
    "cloves": "kləʊvz",
    "clowned": "klaʊnd",
    "clowning": "klaʊnɪŋ",
    "clownish": "klaʊnɪʃ",
    "clown": "klaʊn",
    "clowns": "klaʊnz",
    "cloying": "klɔɪɪŋ",
    "cloy": "klɔɪ",
    "clubbable": "klʌbəbəl",
    "clubbed": "klʌbd",
    "clubber": "klʌbɐ",
    "clubbers": "klʌbəz",
    "clubbing": "klʌbɪŋ",
    "clubby": "klʌbi",
    "clubfoot": "klʌbfʊt",
    "clubhouse": "klʌbhaʊs",
    "clubhouses": "klʌbhaʊzɪz",
    "club": "klʌb",
    "clubland": "klʌblənd",
    "clubman": "klʌbmən",
    "clubs": "klʌbz",
    "clucked": "klʌkt",
    "clucking": "klʌkɪŋ",
    "cluck": "klʌk",
    "clucks": "klʌks",
    "clued": "kluːd",
    "clueing": "kluːɪŋ",
    "clue": "kluː",
    "clueless": "kluːləs",
    "clues": "kluːz",
    "clumped": "klʌmpt",
    "clumping": "klʌmpɪŋ",
    "clump": "klʌmp",
    "clumps": "klʌmps",
    "clumpy": "klʌmpi",
    "clumsier": "klʌmzɪɐ",
    "clumsiest": "klʌmzɪəst",
    "clumsily": "klʌmzɪli",
    "clumsiness": "klʌmzɪnəs",
    "clumsy": "klʌmzi",
    "clung": "klʌŋ",
    "clunked": "klʌŋkt",
    "clunker": "klʌŋkɐ",
    "clunkers": "klʌŋkəz",
    "clunking": "klʌŋkɪŋ",
    "clunk": "klʌŋk",
    "clunks": "klʌŋks",
    "clunky": "klʌŋki",
    "clustered": "klʌstəd",
    "clustering": "klʌstərɪŋ",
    "cluster": "klʌstɐ",
    "clusters": "klʌstəz",
    "clutched": "klʌtʃt",
    "clutches": "klʌtʃɪz",
    "clutching": "klʌtʃɪŋ",
    "clutch": "klʌtʃ",
    "cluttered": "klʌtəd",
    "cluttering": "klʌtərɪŋ",
    "clutter": "klʌtɐ",
    "clutters": "klʌtəz",
    "coached": "kəʊtʃt",
    "coaches": "kəʊtʃɪz",
    "coaching": "kəʊtʃɪŋ",
    "coach": "kəʊtʃ",
    "coachload": "kəʊtʃləʊd",
    "coachloads": "kəʊtʃləʊdz",
    "coachman": "kəʊtʃmən",
    "coachmen": "kəʊtʃmɛn",
    "coachwhip": "kəʊtʃwɪp",
    "coachwork": "kəʊtʃwɜːk",
    "coagulant": "kəʊæɡjʊlənt",
    "coagulants": "kəʊæɡjʊlənts",
    "coagulated": "kəʊæɡjʊleɪtɪd",
    "coagulates": "kəʊæɡjʊleɪts",
    "coagulating": "kəʊæɡjʊleɪtɪŋ",
    "coagulation": "kəʊæɡjʊleɪʃən",
    "coalesced": "kəʊəlɛst",
    "coalesce": "kəʊəlɛs",
    "coalescence": "kəʊəlɛsəns",
    "coalesces": "kəʊəlɛsɪz",
    "coalescing": "kəʊəlɛsɪŋ",
    "coalface": "kəʊlfeɪs",
    "coalfield": "kəʊlfiːld",
    "coalfields": "kəʊlfiːldz",
    "coalfish": "kəʊlfɪʃ",
    "coalition": "kəʊəlɪʃən",
    "coalitions": "kəʊəlɪʃənz",
    "coal": "kəʊl",
    "coalmine": "kəʊlmaɪn",
    "coalmines": "kəʊlmaɪnz",
    "coals": "kəʊlz",
    "coarse": "kɔːs",
    "coarsely": "kɔːsli",
    "coarsened": "kɔːsənd",
    "coarseness": "kɔːsnəs",
    "coarsening": "kɔːsənɪŋ",
    "coarsen": "kɔːsən",
    "coarsens": "kɔːsənz",
    "coarser": "kɔːsɐ",
    "coarsest": "kɔːsəst",
    "coastal": "kəʊstəl",
    "coasted": "kəʊstɪd",
    "coaster": "kəʊstɐ",
    "coasters": "kəʊstəz",
    "coastguard": "kəʊstɡɑːd",
    "coastguards": "kəʊstɡɑːdz",
    "coasting": "kəʊstɪŋ",
    "coast": "kəʊst",
    "coastland": "kəʊslənd",
    "coastline": "kəʊslaɪn",
    "coastlines": "kəʊslaɪnz",
    "coasts": "kəʊsts",
    "coastward": "kəʊstwəd",
    "coated": "kəʊtɪd",
    "coati": "kəʊti",
    "coating": "kəʊtɪŋ",
    "coatings": "kəʊtɪŋz",
    "coatis": "kəʊtiz",
    "coat": "kəʊt",
    "coats": "kəʊts",
    "coattails": "kəʊtteɪlz",
    "coaxed": "kəʊkst",
    "coaxes": "kəʊksɪz",
    "coaxing": "kəʊksɪŋ",
    "cobalt": "kəʊbɒlt",
    "cobber": "kɒbɐ",
    "cobbers": "kɒbəz",
    "cobbled": "kɒbəld",
    "cobble": "kɒbəl",
    "cobbler": "kɒblɐ",
    "cobblers": "kɒbləz",
    "cobbles": "kɒbəlz",
    "cobblestone": "kɒbəlstəʊn",
    "cobblestones": "kɒbəlstəʊnz",
    "cobbling": "kɒblɪŋ",
    "cob": "kɒb",
    "coble": "kɒbəl",
    "cobnut": "kɒbnʌt",
    "cobnuts": "kɒbnʌts",
    "cobra": "kəʊbrɐ",
    "cobras": "kəʊbrəz",
    "cobs": "kɒbz",
    "coburg": "kɒbɜːɡ",
    "cobwebbed": "kɒbwɛbd",
    "cobwebby": "kɒbwɪbi",
    "cobweb": "kɒbwɛb",
    "cobwebs": "kɒbwɛbz",
    "cocaine": "kəʊkeɪn",
    "coca": "kəʊkɐ",
    "coccus": "kɒkəs",
    "coccyx": "kɒkɪks",
    "cochineal": "kɒtʃɪniəl",
    "cochlea": "kɒkliːɐ",
    "cochlear": "kɒtʃliə",
    "cockamamie": "kɒkɐmæmi",
    "cockatiel": "kɒkɐtiːl",
    "cockatiels": "kɒkɐtiːlz",
    "cockatoo": "kɒkɐtuː",
    "cockatoos": "kɒkɐtuːz",
    "cockatrice": "kɒkætrɪs",
    "cocked": "kɒkt",
    "cockerel": "kɒkərəl",
    "cockerels": "kɒkərəlz",
    "cocker": "kɒkɐ",
    "cockers": "kɒkəz",
    "cockeyed": "kɒkɪd",
    "cockfighting": "kɒkfaɪtɪŋ",
    "cockfight": "kɒkfaɪt",
    "cockier": "kɒkiɐ",
    "cockily": "kɒkili",
    "cockiness": "kɒkinəs",
    "cocking": "kɒkɪŋ",
    "cock": "kɒk",
    "cockle": "kɒkəl",
    "cockleshell": "kɒklɪʃɛl",
    "cockleshells": "kɒklɪʃɛlz",
    "cockles": "kɒkəlz",
    "cockney": "kɒkni",
    "cockneys": "kɒknɪz",
    "cockpit": "kɒkpɪt",
    "cockpits": "kɒkpɪts",
    "cockroaches": "kɒkrəʊtʃɪz",
    "cockroach": "kɒkrəʊtʃ",
    "cockscomb": "kɒkskəʊm",
    "cockscombs": "kɒkskəʊmz",
    "cocks": "kɒks",
    "cockspur": "kɒkspɔː",
    "cocksucker": "kɒksʌkɐ",
    "cocksuckers": "kɒksʌkəz",
    "cocksure": "kɒkʃɔː",
    "cockswain": "kɒksweɪn",
    "cocktail": "kɒkteɪl",
    "cocktails": "kɒkteɪlz",
    "cockup": "kɒkʌp",
    "cockups": "kɒkʌps",
    "cocky": "kɒki",
    "cocoa": "kəʊkəʊ",
    "cocoanut": "kɒkəʊnʌt",
    "cocoanuts": "kɒkəʊnʌts",
    "cocoas": "kəʊkəʊz",
    "coco": "kəʊkəʊ",
    "coconut": "kəʊkənʌt",
    "coconuts": "kəʊkənʌts",
    "cocooned": "kəkuːnd",
    "cocooning": "kəkuːnɪŋ",
    "cocoon": "kəkuːn",
    "cocoons": "kəkuːnz",
    "cocos": "kəʊkəʊz",
    "cocotte": "kɒkɒt",
    "coda": "kəʊdɐ",
    "codas": "kəʊdəz",
    "codding": "kɒdɪŋ",
    "coddled": "kɒdəld",
    "coddle": "kɒdəl",
    "coddler": "kɒdlɐ",
    "coddles": "kɒdəlz",
    "coddling": "kɒdlɪŋ",
    "codebreaker": "kəʊdbreɪkɐ",
    "coded": "kəʊdɪd",
    "codeine": "kəʊdaɪn",
    "code": "kəʊd",
    "codenamed": "kəʊdneɪmd",
    "codename": "kəʊdneɪm",
    "coder": "kəʊdɐ",
    "coders": "kəʊdəz",
    "codes": "kəʊdz",
    "codeword": "kəʊdwɜːd",
    "codewords": "kəʊdwɜːdz",
    "codex": "kəʊdɛks",
    "codfish": "kɒdfɪʃ",
    "codger": "kɒdʒɐ",
    "codgers": "kɒdʒəz",
    "codices": "kɒdɪsɪz",
    "codicil": "kɒdɪsɪl",
    "codicils": "kɒdɪsɪlz",
    "codification": "kɒdɪfɪkeɪʃən",
    "codified": "kəʊdɪfaɪd",
    "codifying": "kəʊdɪfaɪɪŋ",
    "codify": "kəʊdɪfaɪ",
    "coding": "kəʊdɪŋ",
    "cod": "kɒd",
    "codling": "kɒdlɪŋ",
    "codon": "kɒdɒn",
    "codpiece": "kɒdpiːs",
    "codpieces": "kɒdpiːsɪz",
    "cods": "kɒdz",
    "codswallop": "kɒdswɒləp",
    "coed": "kəʊɛd",
    "coefficient": "kəʊɪfɪʃənt",
    "coefficients": "kəʊɪfɪʃənts",
    "coeliac": "siːlɪæk",
    "coerced": "kəʊɜːst",
    "coerce": "kəʊɜːs",
    "coercing": "kəʊɜːsɪŋ",
    "coercion": "kəʊɜːʃən",
    "coercive": "kəʊɜːsɪv",
    "coexisted": "kəʊɛɡzɪstɪd",
    "coexistence": "kəʊɛɡzɪstəns",
    "coexisting": "kəʊɛɡzɪstɪŋ",
    "coexist": "kəʊɛɡzɪst",
    "coffee": "kɒfi",
    "coffeemaker": "kɒfɪmeɪkɐ",
    "coffeepot": "kɒfɪpɒt",
    "coffees": "kɒfɪz",
    "cofferdam": "kɒfədæm",
    "coffer": "kɒfɐ",
    "coffers": "kɒfəz",
    "coffin": "kɒfɪn",
    "coffins": "kɒfɪnz",
    "coff": "kɒf",
    "cogent": "kəʊdʒənt",
    "cogently": "kəʊdʒəntli",
    "cogitate": "kɒdʒɪteɪt",
    "cogitates": "kɒdʒɪteɪts",
    "cogitating": "kɒdʒɪteɪtɪŋ",
    "cogitation": "kɒdʒɪteɪʃən",
    "cogitations": "kɒdʒɪteɪʃənz",
    "cog": "kɒɡ",
    "cognac": "kɒnjæk",
    "cognacs": "kɒnjæks",
    "cognisance": "kɒɡnɪsəns",
    "cognisant": "kɒɡnɪsənt",
    "cognition": "kɒɡnɪʃən",
    "cognitive": "kɒɡnɪtɪv",
    "cognitively": "kɒɡnɪtɪvli",
    "cognoscenti": "kɒɡnəsɛnti",
    "cogs": "kɒɡz",
    "cogwheel": "kɒɡwiːl",
    "cohabitation": "kəʊhæbɪteɪʃən",
    "cohabited": "kəʊhæbɪtɪd",
    "cohabiting": "kəʊhæbɪtɪŋ",
    "cohabit": "kəʊhæbɪt",
    "cohere": "kəʊhiə",
    "coherence": "kəʊhiərəns",
    "coherent": "kəʊhiərənt",
    "coherently": "kəʊhiərəntli",
    "coheres": "kəʊhiəz",
    "cohesion": "kəʊhiːʒən",
    "cohesive": "kəʊhiːsɪv",
    "cohesively": "kəʊhiːsɪvli",
    "cohesiveness": "kəʊhiːsɪvnəs",
    "cohort": "kəʊhɔːt",
    "cohorts": "kəʊhɔːts",
    "coiffed": "kɔɪft",
    "coiffeur": "kɔɪfɜː",
    "coiffured": "kɔɪfjɔːd",
    "coiffure": "kɔɪfjɔː",
    "coif": "kɔɪf",
    "coiled": "kɔɪld",
    "coiling": "kɔɪlɪŋ",
    "coil": "kɔɪl",
    "coils": "kɔɪlz",
    "coinage": "kɔɪnɪdʒ",
    "coincided": "kəʊɪnsaɪdɪd",
    "coincide": "kəʊɪnsaɪd",
    "coincidence": "kəʊɪnsɪdəns",
    "coincidences": "kəʊɪnsɪdənsɪz",
    "coincidental": "kəʊɪnsɪdɛntəl",
    "coincidentally": "kəʊɪnsɪdɛntəli",
    "coincident": "kəʊɪnsɪdənt",
    "coincides": "kəʊɪnsaɪdz",
    "coinciding": "kəʊɪnsaɪdɪŋ",
    "coined": "kɔɪnd",
    "coining": "kɔɪnɪŋ",
    "coin": "kɔɪn",
    "coins": "kɔɪnz",
    "coir": "kwɑː",
    "coital": "kɔɪtəl",
    "coition": "kɔɪʃən",
    "coitus": "kɔɪtəs",
    "coked": "kəʊkt",
    "coke": "kəʊk",
    "cokes": "kəʊks",
    "coking": "kəʊkɪŋ",
    "cola": "kəʊlɐ",
    "colander": "kɒləndɐ",
    "colanders": "kɒləndəz",
    "colas": "kəʊləz",
    "colcannon": "kɒlkænən",
    "colchicum": "kɒltʃɪkəm",
    "colder": "kəʊldɐ",
    "coldest": "kəʊldəst",
    "cold": "kəʊld",
    "coldly": "kəʊldli",
    "coldness": "kəʊldnəs",
    "colds": "kəʊldz",
    "colectomy": "kəlɛktəmi",
    "cole": "kəʊl",
    "coles": "kəʊlz",
    "coleslaw": "kəʊlslɔː",
    "coleus": "kəʊlɪəs",
    "coley": "kəʊli",
    "colic": "kɒlɪk",
    "colicky": "kɒlɪki",
    "coliseum": "kɒləsiːəm",
    "colitis": "kəlaɪtɪs",
    "collaborated": "kəlæbəreɪtɪd",
    "collaborate": "kəlæbəreɪt",
    "collaborates": "kəlæbəreɪts",
    "collaborating": "kəlæbəreɪtɪŋ",
    "collaborationist": "kəlæbəreɪʃənɪst",
    "collaboration": "kəlæbəreɪʃən",
    "collaborations": "kəlæbəreɪʃənz",
    "collaborative": "kəlæbrətɪv",
    "collaboratively": "kəlæbrətɪvli",
    "collaborator": "kəlæbɔːreɪtɐ",
    "collaborators": "kəlæbɔːreɪtəz",
    "collage": "kɒlɑːʒ",
    "collagen": "kɒleɪdʒən",
    "collages": "kɒlɑːʒɪz",
    "collapsed": "kəlæpsd",
    "collapse": "kəlæps",
    "collapses": "kəlæpsɪz",
    "collapsible": "kəlæpsəbəl",
    "collapsing": "kəlæpsɪŋ",
    "collarbone": "kɒləbəʊn",
    "collarbones": "kɒləbəʊnz",
    "collard": "kɒlɑːd",
    "collards": "kɒlɑːdz",
    "collared": "kɒləd",
    "collaring": "kɒlərɪŋ",
    "collar": "kɒlɐ",
    "collarless": "kɒlələs",
    "collars": "kɒləz",
    "collated": "kəleɪtɪd",
    "collate": "kəleɪt",
    "collateral": "kəlætərəl",
    "collates": "kəleɪts",
    "collating": "kəleɪtɪŋ",
    "collation": "kəleɪʃən",
    "collations": "kəleɪʃənz",
    "colleague": "kɒliːɡ",
    "colleagues": "kɒliːɡz",
    "collectable": "kəlɛktəbəl",
    "collectables": "kəlɛktəbəlz",
    "collected": "kəlɛktɪd",
    "collectible": "kəlɛktəbəl",
    "collectibles": "kəlɛktəbəlz",
    "collecting": "kəlɛktɪŋ",
    "collection": "kəlɛkʃən",
    "collections": "kəlɛkʃənz",
    "collective": "kəlɛktɪv",
    "collectively": "kəlɛktɪvli",
    "collectiveness": "kəlɛktɪvnəs",
    "collectives": "kəlɛktɪvz",
    "collectivisation": "kəlɛktɪvaɪzeɪʃən",
    "collectivised": "kəlɛktɪvaɪzd",
    "collectivism": "kəlɛktɪvɪzəm",
    "collectivist": "kəlɛktɪvɪst",
    "collectivity": "kəlɪktɪvɪti",
    "collector": "kəlɛktɐ",
    "collectors": "kəlɛktəz",
    "colleen": "kəliːn",
    "colleens": "kəliːnz",
    "college": "kɒlɪdʒ",
    "colleges": "kɒlɪdʒɪz",
    "collegial": "kəliːdʒəl",
    "collegiate": "kəliːdʒɪət",
    "collet": "kɒlɪt",
    "collets": "kɒlɪts",
    "collided": "kəlaɪdɪd",
    "collide": "kəlaɪd",
    "collider": "kəlaɪdɐ",
    "colliders": "kəlaɪdəz",
    "collides": "kəlaɪdz",
    "colliding": "kəlaɪdɪŋ",
    "collie": "kɒli",
    "collieries": "kɒlɪərɪz",
    "collier": "kɒliɐ",
    "colliers": "kɒliəz",
    "colliery": "kɒlɪəri",
    "collies": "kɒliz",
    "collins": "kɒlɪnz",
    "collision": "kəlɪʒən",
    "collisions": "kəlɪʒənz",
    "collodion": "kələʊdiən",
    "colloidal": "kɒlɔɪdəl",
    "colloid": "kɒlɔɪd",
    "colloids": "kɒlɔɪdz",
    "collop": "kɒləp",
    "colloquialism": "kələʊkwɪəlɪzəm",
    "colloquialisms": "kələʊkwɪəlɪzəmz",
    "colloquial": "kələʊkwɪəl",
    "colloquially": "kələʊkwɪəli",
    "colluded": "kəluːdɪd",
    "collude": "kəluːd",
    "colluder": "kəluːdɐ",
    "colludes": "kəluːdz",
    "colluding": "kəluːdɪŋ",
    "collusion": "kəluːʒən",
    "collusive": "kəluːsɪv",
    "colly": "kɒli",
    "collywobbles": "kɒlɪwɒbəlz",
    "colobus": "kɒlɒbəs",
    "cologne": "kələʊn",
    "colonel": "kɜːnəl",
    "colonels": "kɜːnəlz",
    "colones": "kəʊlənz",
    "colonialism": "kələʊnɪəlɪzəm",
    "colonialist": "kələʊnɪəlɪst",
    "colonialists": "kələʊnɪəlɪsts",
    "colonial": "kələʊnɪəl",
    "colonially": "kələʊnɪəli",
    "colonials": "kələʊnɪəlz",
    "colonic": "kəlɒnɪk",
    "colonies": "kɒlənɪz",
    "colonisation": "kɒlənaɪzeɪʃən",
    "colonised": "kɒlənaɪzd",
    "colonise": "kɒlənaɪz",
    "coloniser": "kɒlənaɪzɐ",
    "colonisers": "kɒlənaɪzəz",
    "colonises": "kɒlənaɪzɪz",
    "colonising": "kɒlənaɪzɪŋ",
    "colonist": "kɒlənɪst",
    "colonists": "kɒlənɪsts",
    "colonnaded": "kɒləneɪdɪd",
    "colonnade": "kɒləneɪd",
    "colonnades": "kɒləneɪdz",
    "colons": "kəʊlənz",
    "colony": "kɒləni",
    "colophon": "kɒlɒfən",
    "colorant": "kʌlərənt",
    "colorants": "kʌlərənts",
    "coloration": "kʌləreɪʃən",
    "coloratura": "kʌlərætʃərɐ",
    "colored": "kʌləd",
    "colors": "kʌləz",
    "colossal": "kəlɒsəl",
    "colossally": "kəlɒsəli",
    "colosseum": "kɒləsiəm",
    "colossi": "kəlɒsi",
    "colossus": "kəlɒsəs",
    "colostomy": "kəlɒstəmi",
    "colostrum": "kɒlɒstrəm",
    "colourants": "kʌlɜːrənts",
    "colouration": "kʌləreɪʃən",
    "colourblind": "kʌləblaɪnd",
    "coloured": "kʌləd",
    "coloureds": "kʌlədz",
    "colourful": "kʌləfəl",
    "colourfully": "kʌləfəli",
    "colourfulness": "kʌləfəlnəs",
    "colouring": "kʌlɜːrɪŋ",
    "colourings": "kʌlɜːrɪŋz",
    "colourised": "kʌləraɪzd",
    "colourist": "kʌlərɪst",
    "colourists": "kʌlərɪsts",
    "colour": "kʌlɐ",
    "colourless": "kʌlələs",
    "colours": "kʌləz",
    "colourway": "kʌləweɪ",
    "colourways": "kʌləweɪz",
    "cols": "kɒlz",
    "coltish": "kəʊltɪʃ",
    "coltishness": "kəʊltɪʃnəs",
    "colt": "kəʊlt",
    "colts": "kəʊlts",
    "columbine": "kɒləmbaɪn",
    "columbines": "kɒləmbaɪnz",
    "columnar": "kɒləmnɑː",
    "columned": "kɒlʌmd",
    "columnist": "kɒləmnɪst",
    "columnists": "kɒləmnɪsts",
    "column": "kɒlʌm",
    "columns": "kɒlʌmz",
    "colza": "kɒlzɐ",
    "coma": "kəʊmɐ",
    "comas": "kəʊməz",
    "comatose": "kəʊmɐtəʊz",
    "combatant": "kɒmbætənt",
    "combatants": "kɒmbætənts",
    "combated": "kɒmbætɪd",
    "combating": "kɒmbætɪŋ",
    "combative": "kɒmbətɪv",
    "combativeness": "kɒmbətɪvnəs",
    "combatting": "kɒmbætɪŋ",
    "combed": "kəʊmd",
    "combe": "kəmɛ",
    "combination": "kɒmbɪneɪʃən",
    "combinations": "kɒmbɪneɪʃənz",
    "combined": "kəmbaɪnd",
    "combing": "kəʊmɪŋ",
    "combings": "kəʊmɪŋz",
    "combining": "kəmbaɪnɪŋ",
    "comb": "kəʊm",
    "combo": "kɒmbəʊ",
    "combos": "kɒmbəʊz",
    "combs": "kəʊmz",
    "combusted": "kəmbʌstɪd",
    "combustible": "kəmbʌstəbəl",
    "combusting": "kəmbʌstɪŋ",
    "combustion": "kəmbʌstʃən",
    "combust": "kəmbʌst",
    "combusts": "kəmbʌsts",
    "comeback": "kʌmbæk",
    "comebacks": "kʌmbæks",
    "comedian": "kəmiːdiən",
    "comedians": "kəmiːdiənz",
    "comedic": "kəmiːdɪk",
    "comedienne": "kəmiːdɪɛn",
    "comediennes": "kəmiːdɪɛnz",
    "comedies": "kɒmədɪz",
    "comedown": "kəmɛdaʊn",
    "comedy": "kɒmədi",
    "come": "kʌm",
    "comeliness": "kʌmlɪnəs",
    "comely": "kʌmli",
    "comer": "kʌmɐ",
    "comers": "kʌməz",
    "comes": "kʌmz",
    "comestibles": "kəmɛstəbəlz",
    "cometary": "kəmɛtəri",
    "comet": "kɒmɪt",
    "comets": "kɒmɪts",
    "comeuppance": "kʌmʌpəns",
    "comfier": "kʌmfɪɐ",
    "comfiest": "kʌmfɪəst",
    "comfit": "kʌmfɪt",
    "comfortable": "kʌmftəbəl",
    "comfortableness": "kʌmftəbəlnəs",
    "comfortably": "kʌmftəbli",
    "comforted": "kʌmfətɪd",
    "comforter": "kʌmfətɐ",
    "comforters": "kʌmfətəz",
    "comforting": "kʌmfətɪŋ",
    "comfortingly": "kʌmfətɪŋli",
    "comfort": "kʌmfət",
    "comfortless": "kʌmfətləs",
    "comforts": "kʌmfəts",
    "comfrey": "kʌmfri",
    "comfy": "kʌmfi",
    "comical": "kɒmɪkəl",
    "comically": "kɒmɪkli",
    "comic": "kɒmɪk",
    "comics": "kɒmɪks",
    "coming": "kʌmɪŋ",
    "comings": "kʌmɪŋz",
    "comma": "kɒmɐ",
    "commandant": "kɒmɑːndænt",
    "commanded": "kəmɑːndɪd",
    "commandeered": "kɒmɑːndiəd",
    "commandeering": "kɒmɑːndiərɪŋ",
    "commandeer": "kɒmɑːndiə",
    "commandeers": "kɒmɑːndiəz",
    "commander": "kəmɑːndɐ",
    "commanders": "kəmɑːndəz",
    "commanding": "kəmɑːndɪŋ",
    "command": "kəmɑːnd",
    "commandment": "kəmɑːndmənt",
    "commandments": "kəmɑːndmənts",
    "commandoes": "kəmændəʊz",
    "commando": "kəmændəʊ",
    "commandos": "kəmændəʊz",
    "commands": "kəmɑːndz",
    "commas": "kɒməz",
    "commemorated": "kəmɛməreɪtɪd",
    "commemorate": "kəmɛməreɪt",
    "commemorates": "kəmɛməreɪts",
    "commemorating": "kəmɛməreɪtɪŋ",
    "commemoration": "kəmɛməreɪʃən",
    "commemorations": "kəmɛməreɪʃənz",
    "commemorative": "kəmɛmrətɪv",
    "commenced": "kəmɛnst",
    "commence": "kəmɛns",
    "commencement": "kəmɛnsmənt",
    "commences": "kəmɛnsɪz",
    "commencing": "kəmɛnsɪŋ",
    "commendable": "kəmɛndəbəl",
    "commendably": "kəmɛndəbli",
    "commendation": "kɒməndeɪʃən",
    "commendations": "kɒməndeɪʃənz",
    "commended": "kəmɛndɪd",
    "commending": "kəmɛndɪŋ",
    "commend": "kəmɛnd",
    "commends": "kəmɛndz",
    "commensurate": "kəmɛnsərət",
    "commensurately": "kəmɛnsərətli",
    "commentaries": "kɒməntrɪz",
    "commentary": "kɒməntri",
    "commentated": "kɒmənteɪtɪd",
    "commentate": "kɒmənteɪt",
    "commentates": "kɒmənteɪts",
    "commentating": "kɒmənteɪtɪŋ",
    "commentator": "kɒmənteɪtɐ",
    "commentators": "kɒmənteɪtəz",
    "commented": "kɒmɛntɪd",
    "commenting": "kɒmɛntɪŋ",
    "comment": "kɒmɛnt",
    "comments": "kɒmɛnts",
    "commerce": "kɒmɜːs",
    "commercialisation": "kəmɜːʃəlaɪzeɪʃən",
    "commercialised": "kəmɜːʃəlaɪzd",
    "commercialise": "kəmɜːʃəlaɪz",
    "commercialising": "kəmɜːʃəlaɪzɪŋ",
    "commercialism": "kəmɜːʃəlɪzəm",
    "commercial": "kəmɜːʃəl",
    "commercially": "kəmɜːʃəli",
    "commercials": "kəmɜːʃəlz",
    "commie": "kɒmi",
    "commies": "kəmɪz",
    "comminuted": "kəmɪnjuːtɪd",
    "comminute": "kəmɪnjuːt",
    "commiserated": "kəmɪsəreɪtɪd",
    "commiserate": "kəmɪsəreɪt",
    "commiserating": "kəmɪsəreɪtɪŋ",
    "commiseration": "kəmɪsəreɪʃən",
    "commiserations": "kəmɪsəreɪʃənz",
    "commissariat": "kɒmɪseərɪæt",
    "commissar": "kəmɪsɑː",
    "commissars": "kəmɪsɑːz",
    "commissary": "kəmɪsəri",
    "commissionaire": "kəmɪʃəneə",
    "commissionaires": "kəmɪʃəneəz",
    "commissioned": "kəmɪʃənd",
    "commissioner": "kəmɪʃənɐ",
    "commissioners": "kəmɪʃənəz",
    "commissioning": "kəmɪʃənɪŋ",
    "commission": "kəmɪʃən",
    "commissions": "kəmɪʃənz",
    "commit": "kəmɪt",
    "commitment": "kəmɪtmənt",
    "commitments": "kəmɪtmənts",
    "commits": "kəmɪts",
    "committal": "kəmɪtəl",
    "committed": "kəmɪtɪd",
    "committees": "kəmɪtiz",
    "committing": "kəmɪtɪŋ",
    "commode": "kəməʊd",
    "commodes": "kəməʊdz",
    "commodification": "kəmɒdɪfɪkeɪʃən",
    "commodify": "kəmɒdɪfaɪ",
    "commodious": "kəməʊdɪəs",
    "commodities": "kəmɒdɪtiz",
    "commodity": "kəmɒdɪti",
    "commodore": "kɒmədɔː",
    "commodores": "kɒmədɔːz",
    "commonalities": "kɒmənælɪtiz",
    "commonality": "kɒmənælɪti",
    "commonalty": "kɒmənəlti",
    "commoner": "kɒmənɐ",
    "commoners": "kɒmənəz",
    "commonest": "kɒmənəst",
    "common": "kɒmən",
    "commonly": "kɒmənli",
    "commonness": "kɒmənnəs",
    "commonplace": "kɒmənpleɪs",
    "commonsense": "kɒmənsɛns",
    "commons": "kɒmənz",
    "commonwealth": "kɒmənwɛlθ",
    "commonwealths": "kɒmənwɛlθs",
    "commotion": "kəməʊʃən",
    "commotions": "kəməʊʃənz",
    "communality": "kəmjuːnælɪti",
    "communal": "kəmjuːnəl",
    "communally": "kəmjuːnəli",
    "communed": "kɒmjuːnd",
    "communicable": "kəmjuːnɪkəbəl",
    "communicant": "kəmjuːnɪkənt",
    "communicants": "kəmjuːnɪkənts",
    "communicated": "kəmjuːnɪkeɪtɪd",
    "communicate": "kəmjuːnɪkeɪt",
    "communicates": "kəmjuːnɪkeɪts",
    "communicating": "kəmjuːnɪkeɪtɪŋ",
    "communication": "kəmjuːnɪkeɪʃən",
    "communications": "kəmjuːnɪkeɪʃənz",
    "communicative": "kəmjuːnɪkətɪv",
    "communicator": "kəmjuːnɪkeɪtɐ",
    "communicators": "kəmjuːnɪkeɪtəz",
    "communing": "kɒmjuːnɪŋ",
    "communion": "kəmjuːniən",
    "communions": "kəmjuːniənz",
    "communique": "kəmjuːnɪkeɪ",
    "communiques": "kəmjuːnɪkeɪs",
    "communism": "kɒmjuːnɪzəm",
    "communist": "kɒmjuːnɪst",
    "communists": "kɒmjuːnɪsts",
    "communitarianism": "kəmjuːnɪteəriənɪzəm",
    "communitarian": "kəmjuːnɪteəriən",
    "communities": "kəmjuːnɪtiz",
    "community": "kəmjuːnɪti",
    "commutable": "kəmjuːtəbəl",
    "commutation": "kɒmjuːteɪʃən",
    "commuted": "kəmjuːtɪd",
    "commute": "kəmjuːt",
    "commuter": "kəmjuːtɐ",
    "commuters": "kəmjuːtəz",
    "commutes": "kəmjuːts",
    "commuting": "kəmjuːtɪŋ",
    "compacted": "kəmpæktɪd",
    "compacter": "kəmpæktɐ",
    "compacting": "kəmpæktɪŋ",
    "compaction": "kəmpækʃən",
    "compactly": "kəmpæktli",
    "compactness": "kəmpæktnəs",
    "compactor": "kəmpæktɐ",
    "compactors": "kəmpæktəz",
    "compadre": "kəmpædɐ",
    "compagnie": "kəmpæɡni",
    "companies": "kʌmpənɪz",
    "companionable": "kəmpæniənəbəl",
    "companionably": "kəmpæniənəbli",
    "companionate": "kəmpæniəneɪt",
    "companion": "kəmpæniən",
    "companionship": "kəmpæniənʃɪp",
    "companions": "kəmpæniənz",
    "company": "kʌmpəni",
    "comparable": "kɒmpərəbəl",
    "comparably": "kɒmpərəbli",
    "comparative": "kəmpærətɪv",
    "comparatively": "kəmpærətɪvli",
    "comparatives": "kəmpærətɪvz",
    "comparator": "kəmpæreɪtɐ",
    "comparators": "kəmpæreɪtəz",
    "compared": "kəmpeəd",
    "compare": "kəmpeə",
    "compares": "kəmpeəz",
    "comparing": "kəmpeərɪŋ",
    "comparison": "kəmpærɪsən",
    "comparisons": "kəmpærɪsənz",
    "compartmentalisation": "kɒmpɑːtmɛntəlaɪzeɪʃən",
    "compartmentalised": "kɒmpɑːtmɛntəlaɪzd",
    "compartmentalise": "kɒmpɑːtmɛntəlaɪz",
    "compartmentalising": "kɒmpɑːtmɛntəlaɪzɪŋ",
    "compartment": "kəmpɑːtmənt",
    "compartments": "kəmpɑːtmənts",
    "compassed": "kʌmpəst",
    "compasses": "kʌmpəsɪz",
    "compassionate": "kəmpæʃənət",
    "compassionately": "kəmpæʃənətli",
    "compassion": "kəmpæʃən",
    "compass": "kʌmpəs",
    "compatibility": "kəmpætɪbɪlɪti",
    "compatible": "kəmpætəbəl",
    "compatriot": "kəmpætrɪət",
    "compatriots": "kəmpætrɪəts",
    "comped": "kɒmpt",
    "compel": "kəmpɛl",
    "compelled": "kəmpɛld",
    "compelling": "kəmpɛlɪŋ",
    "compellingly": "kəmpɛlɪŋli",
    "compels": "kəmpɛlz",
    "compendia": "kəmpɛndiə",
    "compendious": "kəmpɛndɪəs",
    "compendium": "kəmpɛndiəm",
    "compendiums": "kəmpɛndiəmz",
    "compensated": "kɒmpənseɪtɪd",
    "compensate": "kɒmpənseɪt",
    "compensates": "kɒmpənseɪts",
    "compensating": "kɒmpənseɪtɪŋ",
    "compensation": "kɒmpənseɪʃən",
    "compensations": "kɒmpənseɪʃənz",
    "compensator": "kɒmpənseɪtɐ",
    "compensatory": "kɒmpənsətəri",
    "competed": "kəmpiːtɪd",
    "compete": "kəmpiːt",
    "competence": "kɒmpɪtəns",
    "competences": "kɒmpɪtənsɪz",
    "competencies": "kɒmpɪtənsiz",
    "competency": "kɒmpɪtənsi",
    "competent": "kɒmpɪtənt",
    "competently": "kɒmpɪtəntli",
    "competes": "kəmpiːts",
    "competing": "kəmpiːtɪŋ",
    "competition": "kɒmpətɪʃən",
    "competitions": "kɒmpətɪʃənz",
    "competitive": "kəmpɛtɪtɪv",
    "competitively": "kəmpɛtɪtɪvli",
    "competitiveness": "kəmpɛtɪtɪvnəs",
    "competitor": "kəmpɛtɪtɐ",
    "competitors": "kəmpɛtɪtəz",
    "compilation": "kɒmpɪleɪʃən",
    "compilations": "kɒmpɪleɪʃənz",
    "compiled": "kəmpaɪld",
    "compile": "kəmpaɪl",
    "compiler": "kəmpaɪlɐ",
    "compilers": "kəmpaɪləz",
    "compiles": "kəmpaɪlz",
    "compiling": "kəmpaɪlɪŋ",
    "comping": "kɒmpɪŋ",
    "complacence": "kəmpleɪsəns",
    "complacency": "kəmpleɪsnsi",
    "complacent": "kəmpleɪsənt",
    "complacently": "kəmpleɪsəntli",
    "complainant": "kəmpleɪnənt",
    "complainants": "kəmpleɪnənts",
    "complained": "kəmpleɪnd",
    "complainer": "kəmpleɪnɐ",
    "complainers": "kəmpleɪnəz",
    "complaining": "kəmpleɪnɪŋ",
    "complain": "kəmpleɪn",
    "complains": "kəmpleɪnz",
    "complaint": "kəmpleɪnt",
    "complaints": "kəmpleɪnts",
    "compleat": "kəmpliːt",
    "complementarity": "kɒmplɪməntærɪti",
    "complementary": "kɒmplɪmɛntəri",
    "complemented": "kɒmplɪməntɪd",
    "complementing": "kɒmplɪməntɪŋ",
    "complement": "kɒmplɪmənt",
    "complements": "kɒmplɪmənts",
    "completed": "kəmpliːtɪd",
    "complete": "kəmpliːt",
    "completely": "kəmpliːtli",
    "completeness": "kəmpliːtnəs",
    "completer": "kəmplɛtɐ",
    "completes": "kəmpliːts",
    "completing": "kəmpliːtɪŋ",
    "completion": "kəmpliːʃən",
    "completions": "kəmpliːʃənz",
    "complexes": "kɒmplɛksɪz",
    "complexion": "kəmplɛkʃən",
    "complexions": "kəmplɛkʃənz",
    "complexities": "kəmplɛksɪtiz",
    "complexity": "kəmplɛksɪti",
    "compliance": "kəmplaɪəns",
    "compliant": "kəmplaɪənt",
    "compliantly": "kəmplaɪəntli",
    "complicated": "kɒmplɪkeɪtɪd",
    "complicatedly": "kɒmplɪkeɪtɪdli",
    "complicate": "kɒmplɪkeɪt",
    "complicates": "kɒmplɪkeɪts",
    "complicating": "kɒmplɪkeɪtɪŋ",
    "complication": "kɒmplɪkeɪʃən",
    "complications": "kɒmplɪkeɪʃənz",
    "complicit": "kəmplɪsɪt",
    "complicity": "kəmplɪsɪti",
    "complied": "kəmplaɪd",
    "complies": "kəmplaɪz",
    "complimentary": "kɒmplɪmɛntəri",
    "complimented": "kɒmplɪməntɪd",
    "complimenting": "kɒmplɪməntɪŋ",
    "compline": "kəmplaɪn",
    "complot": "kəmplɒt",
    "complying": "kəmplaɪɪŋ",
    "comply": "kəmplaɪ",
    "compo": "kəmpəʊ",
    "component": "kəmpəʊnənt",
    "components": "kəmpəʊnənts",
    "comport": "kəmpɔːt",
    "comportment": "kəmpɔːtmənt",
    "comports": "kəmpɔːts",
    "composed": "kəmpəʊzd",
    "compose": "kəmpəʊz",
    "composer": "kəmpəʊzɐ",
    "composers": "kəmpəʊzəz",
    "composes": "kəmpəʊzɪz",
    "composing": "kəmpəʊzɪŋ",
    "composite": "kɒmpəsɪt",
    "composites": "kɒmpəsɪts",
    "compositional": "kɒmpəzɪʃənəl",
    "composition": "kɒmpəzɪʃən",
    "compositions": "kɒmpəzɪʃənz",
    "compositor": "kɒmpəsɪtɐ",
    "compositors": "kɒmpəsɪtəz",
    "composted": "kɒmpɒstɪd",
    "composting": "kɒmpɒstɪŋ",
    "compost": "kɒmpɒst",
    "composts": "kɒmpɒsts",
    "composure": "kəmpəʊʒɐ",
    "compote": "kəmpəʊt",
    "compotes": "kəmpəʊts",
    "compounded": "kɒmpaʊndɪd",
    "compounding": "kɒmpaʊndɪŋ",
    "comprehended": "kɒmprɪhɛndɪd",
    "comprehending": "kɒmprɪhɛndɪŋ",
    "comprehend": "kɒmprɪhɛnd",
    "comprehends": "kɒmprɪhɛndz",
    "comprehensible": "kɒmprɪhɛnsəbəl",
    "comprehensibly": "kɒmprɪhɛnsəbli",
    "comprehension": "kɒmprɪhɛnʃən",
    "comprehensive": "kɒmprɪhɛnsɪv",
    "comprehensively": "kɒmprɪhɛnsɪvli",
    "comprehensiveness": "kɒmprɪhɛnsɪvnəs",
    "comprehensives": "kɒmprɪhɛnsɪvz",
    "compressed": "kəmprɛst",
    "compressing": "kəmprɛsɪŋ",
    "compression": "kəmprɛʃən",
    "compressions": "kəmprɛʃənz",
    "compressive": "kəmprɛsɪv",
    "compressor": "kəmprɛsɐ",
    "compressors": "kəmprɛsəz",
    "comprised": "kəmpraɪzd",
    "comprise": "kəmpraɪz",
    "comprises": "kəmpraɪzɪz",
    "comprising": "kəmpraɪzɪŋ",
    "compromised": "kɒmprəmaɪzd",
    "compromise": "kɒmprəmaɪz",
    "compromiser": "kɒmprəmaɪzɐ",
    "compromises": "kɒmprəmaɪzɪz",
    "compromising": "kɒmprəmaɪzɪŋ",
    "comps": "kɒmps",
    "comptroller": "kɒmtrəʊlɐ",
    "compulsion": "kəmpʌlʃən",
    "compulsions": "kəmpʌlʃənz",
    "compulsive": "kəmpʌlsɪv",
    "compulsively": "kəmpʌlsɪvli",
    "compulsorily": "kəmpʌlsərəli",
    "compulsory": "kəmpʌlsəri",
    "compunction": "kəmpʌŋkʃən",
    "compunctious": "kəmpʌŋkʃəs",
    "computable": "kəmpjuːtəbəl",
    "computational": "kɒmpjuːteɪʃənəl",
    "computation": "kɒmpjuːteɪʃən",
    "computations": "kɒmpjuːteɪʃənz",
    "computed": "kəmpjuːtɪd",
    "compute": "kəmpjuːt",
    "computerisation": "kəmpjuːtəraɪzeɪʃən",
    "computerised": "kəmpjuːtəraɪzd",
    "computerise": "kəmpjuːtəraɪz",
    "computerising": "kəmpjuːtəraɪzɪŋ",
    "computer": "kəmpjuːtɐ",
    "computers": "kəmpjuːtəz",
    "computes": "kəmpjuːts",
    "computing": "kəmpjuːtɪŋ",
    "comrade": "kɒmreɪd",
    "comradely": "kɒmreɪdli",
    "comradery": "kɒmreɪdəri",
    "comradeship": "kɒmreɪdʃɪp",
    "comrades": "kɒmreɪdz",
    "concatenated": "kənkætəneɪtɪd",
    "concatenates": "kənkætəneɪts",
    "concatenating": "kənkætəneɪtɪŋ",
    "concatenation": "kənkætəneɪʃən",
    "concave": "kɒnkeɪv",
    "concealed": "kənsiːld",
    "concealer": "kənsiːlɐ",
    "concealing": "kənsiːlɪŋ",
    "conceal": "kənsiːl",
    "concealment": "kənsiːlmənt",
    "conceals": "kənsiːlz",
    "conceded": "kənsiːdɪd",
    "concede": "kənsiːd",
    "concedes": "kənsiːdz",
    "conceding": "kənsiːdɪŋ",
    "conceited": "kənsiːtɪd",
    "conceit": "kənsiːt",
    "conceits": "kənsiːts",
    "conceivable": "kənsiːvəbəl",
    "conceivably": "kənsiːvəbli",
    "conceived": "kənsiːvd",
    "conceive": "kənsiːv",
    "conceives": "kənsiːvz",
    "conceiving": "kənsiːvɪŋ",
    "concentrated": "kɒnsəntreɪtɪd",
    "concentrate": "kɒnsəntreɪt",
    "concentrates": "kɒnsəntreɪts",
    "concentrating": "kɒnsəntreɪtɪŋ",
    "concentration": "kɒnsəntreɪʃən",
    "concentrations": "kɒnsəntreɪʃənz",
    "concentrically": "kənsɛntrɪkli",
    "concentric": "kənsɛntrɪk",
    "conception": "kənsɛpʃən",
    "conceptions": "kənsɛpʃənz",
    "concept": "kɒnsɛpt",
    "concepts": "kɒnsɛpts",
    "conceptualisation": "kənsɛptʃuːəlaɪzeɪʃən",
    "conceptualise": "kənsɛptʃuːəlaɪz",
    "conceptualising": "kənsɛptʃuːəlaɪzɪŋ",
    "conceptualism": "kənsɛptʃuːəlɪzəm",
    "conceptual": "kənsɛptʃuːəl",
    "conceptually": "kənsɛptʃuːəli",
    "concerned": "kənsɜːnd",
    "concerning": "kənsɜːnɪŋ",
    "concern": "kənsɜːn",
    "concerns": "kənsɜːnz",
    "concerted": "kənsɜːtɪd",
    "concerti": "kənsɜːti",
    "concertinaed": "kɒnsətiːnəd",
    "concertina": "kɒnsətiːnɐ",
    "concertinas": "kɒnsətiːnəz",
    "concerting": "kənsɜːtɪŋ",
    "concertino": "kɒnsətiːnəʊ",
    "concertmaster": "kənsɜːtmɑːstɐ",
    "concerto": "kəntʃeətəʊ",
    "concertos": "kəntʃeətəʊz",
    "concessionary": "kənsɛʃənəri",
    "concession": "kənsɛʃən",
    "concessions": "kənsɛʃənz",
    "concha": "kəntʃæ",
    "conches": "kɒntʃɪz",
    "conchie": "kəntʃaɪ",
    "conch": "kɒntʃ",
    "conchology": "kənkɒlədʒi",
    "concierge": "kɒnsɪeəʒ",
    "concierges": "kɒnsɪeəʒɪz",
    "conciliate": "kənsɪlɪeɪt",
    "conciliation": "kənsɪlɪeɪʃən",
    "conciliator": "kənsɪlɪeɪtɐ",
    "conciliatory": "kənsɪlɪətəri",
    "concise": "kənsaɪs",
    "concisely": "kənsaɪsli",
    "concision": "kənsɪʒən",
    "conclave": "kɒnkleɪv",
    "concluded": "kənkluːdɪd",
    "conclude": "kənkluːd",
    "concludes": "kənkluːdz",
    "concluding": "kənkluːdɪŋ",
    "conclusion": "kənkluːʒən",
    "conclusions": "kənkluːʒənz",
    "conclusive": "kənkluːsɪv",
    "conclusively": "kənkluːsɪvli",
    "concocted": "kənkɒktɪd",
    "concocter": "kənkɒktɐ",
    "concocting": "kənkɒktɪŋ",
    "concoction": "kənkɒkʃən",
    "concoctions": "kənkɒkʃənz",
    "concoct": "kənkɒkt",
    "concocts": "kənkɒkts",
    "concomitant": "kənkɒmɪtənt",
    "concordance": "kənkɔːdəns",
    "concordat": "kənkɔːdæt",
    "concord": "kənkɔːd",
    "concourse": "kɒnkɔːs",
    "concourses": "kɒnkɔːsɪz",
    "concreted": "kɒŋkriːtɪd",
    "concrete": "kɒŋkriːt",
    "concretely": "kɒŋkriːtli",
    "concreteness": "kɒŋkriːtnəs",
    "concreting": "kɒŋkriːtɪŋ",
    "concretion": "kɒŋkrɛʃən",
    "concretions": "kɒŋkrɛʃənz",
    "concubine": "kənkjuːbaɪn",
    "concubines": "kənkjuːbaɪnz",
    "concupiscence": "kɒnkjuːpɪsəns",
    "concupiscent": "kɒnkjuːpɪsənt",
    "concur": "kənkɜː",
    "concurred": "kənkɜːd",
    "concurrence": "kənkʌrəns",
    "concurrent": "kənkʌrənt",
    "concurrently": "kənkʌrəntli",
    "concurring": "kənkɜːrɪŋ",
    "concurs": "kənkɜːz",
    "concussed": "kənkʌst",
    "concussion": "kənkʌʃən",
    "concussions": "kənkʌʃənz",
    "concussive": "kənkʌsɪv",
    "concuss": "kənkʌs",
    "condemnation": "kɒndɪmneɪʃən",
    "condemnations": "kɒndɪmneɪʃənz",
    "condemnatory": "kəndɛmnətəri",
    "condemned": "kəndɛmd",
    "condemning": "kəndɛmɪŋ",
    "condemn": "kəndɛm",
    "condemns": "kəndɛmz",
    "condensate": "kəndɛnseɪt",
    "condensation": "kɒndɪnseɪʃən",
    "condensed": "kəndɛnsd",
    "condense": "kəndɛns",
    "condenser": "kəndɛnsɐ",
    "condensers": "kəndɛnsəz",
    "condenses": "kəndɛnsɪz",
    "condensing": "kəndɛnsɪŋ",
    "condescended": "kɒndɪsɛndɪd",
    "condescending": "kɒndɪsɛndɪŋ",
    "condescendingly": "kɒndɪsɛndɪŋli",
    "condescend": "kɒndɪsɛnd",
    "condescends": "kɒndɪsɛndz",
    "condescension": "kɒndɪsɛnʃən",
    "condign": "kəndaɪn",
    "condiment": "kɒndɪmənt",
    "condiments": "kɒndɪmənts",
    "conditionality": "kəndɪʃənælɪti",
    "conditional": "kəndɪʃənəl",
    "conditionally": "kəndɪʃənəli",
    "conditioned": "kəndɪʃənd",
    "conditioner": "kəndɪʃənɐ",
    "conditioners": "kəndɪʃənəz",
    "conditioning": "kəndɪʃənɪŋ",
    "condition": "kəndɪʃən",
    "conditions": "kəndɪʃənz",
    "condo": "kɒndəʊ",
    "condole": "kəndəʊl",
    "condolence": "kəndəʊləns",
    "condolences": "kəndəʊlənsɪz",
    "condominium": "kɒndəmɪniəm",
    "condominiums": "kɒndəmɪniəmz",
    "condom": "kɒndəm",
    "condoms": "kɒndəmz",
    "condoned": "kəndəʊnd",
    "condone": "kəndəʊn",
    "condones": "kəndəʊnz",
    "condoning": "kəndəʊnɪŋ",
    "condor": "kɒndɔː",
    "condors": "kɒndɔːz",
    "condos": "kɒndəʊz",
    "conduced": "kəndjuːst",
    "conduce": "kəndjuːs",
    "conducive": "kəndjuːsɪv",
    "conductance": "kəndʌktəns",
    "conducted": "kəndʌktɪd",
    "conducting": "kəndʌktɪŋ",
    "conduction": "kəndʌkʃən",
    "conductive": "kəndʌktɪv",
    "conductivity": "kɒndəktɪvɪti",
    "conductor": "kəndʌktɐ",
    "conductors": "kəndʌktəz",
    "conductress": "kəndʌktrəs",
    "conducts": "kɒndʌkts",
    "conduit": "kɒndjuːɪt",
    "conduits": "kɒndjuːɪts",
    "coned": "kəʊnd",
    "cone": "kəʊn",
    "cones": "kəʊnz",
    "coney": "kənaɪ",
    "confab": "kənfæb",
    "confabs": "kənfæbz",
    "confected": "kənfɛktɪd",
    "confectionary": "kənfɛkʃənəri",
    "confectioneries": "kənfɛkʃənəriz",
    "confectioner": "kənfɛkʃənɐ",
    "confectioners": "kənfɛkʃənəz",
    "confectionery": "kənfɛkʃənəri",
    "confection": "kənfɛkʃən",
    "confections": "kənfɛkʃənz",
    "confederacy": "kənfɛdərəsi",
    "confederation": "kənfɛdəreɪʃən",
    "confederations": "kənfɛdəreɪʃənz",
    "conference": "kɒnfrəns",
    "conferences": "kɒnfrənsɪz",
    "conferencing": "kɒnfrənsɪŋ",
    "confer": "kənfɜː",
    "conferment": "kənfɜːmənt",
    "conferred": "kənfɜːd",
    "conferring": "kənfɜːrɪŋ",
    "confers": "kənfɜːz",
    "confessed": "kənfɛst",
    "confesses": "kənfɛsɪz",
    "confessing": "kənfɛsɪŋ",
    "confessional": "kənfɛʃənəl",
    "confessionals": "kənfɛʃənəlz",
    "confession": "kənfɛʃən",
    "confessions": "kənfɛʃənz",
    "confess": "kənfɛs",
    "confessor": "kənfɛsɐ",
    "confetti": "kənfɛti",
    "confidante": "kɒnfɪdɑːnteɪ",
    "confidantes": "kɒnfɪdɑːnteɪs",
    "confidant": "kɒnfɪdænt",
    "confidants": "kɒnfɪdænts",
    "confided": "kənfaɪdɪd",
    "confide": "kənfaɪd",
    "confidence": "kɒnfɪdəns",
    "confidences": "kɒnfɪdənsɪz",
    "confidentiality": "kɒnfɪdɛnʃɪælɪti",
    "confidential": "kɒnfɪdɛnʃəl",
    "confidentially": "kɒnfɪdɛnʃəli",
    "confident": "kɒnfɪdənt",
    "confidently": "kɒnfɪdəntli",
    "confides": "kənfaɪdz",
    "confiding": "kənfaɪdɪŋ",
    "configuration": "kənfɪɡjʊreɪʃən",
    "configurations": "kənfɪɡjʊreɪʃənz",
    "configured": "kənfɪɡəd",
    "configure": "kənfɪɡɐ",
    "configuring": "kənfɪɡərɪŋ",
    "confined": "kənfaɪnd",
    "confinement": "kənfaɪnmənt",
    "confining": "kənfaɪnɪŋ",
    "confirmation": "kɒnfəmeɪʃən",
    "confirmations": "kɒnfəmeɪʃənz",
    "confirmatory": "kənfɜːmətəri",
    "confirmed": "kənfɜːmd",
    "confirming": "kənfɜːmɪŋ",
    "confirm": "kənfɜːm",
    "confirms": "kənfɜːmz",
    "confiscated": "kɒnfɪskeɪtɪd",
    "confiscate": "kɒnfɪskeɪt",
    "confiscates": "kɒnfɪskeɪts",
    "confiscating": "kɒnfɪskeɪtɪŋ",
    "confiscation": "kɒnfɪskeɪʃən",
    "confiscations": "kɒnfɪskeɪʃənz",
    "confiture": "kənfɪtʃɐ",
    "conflagration": "kɒnflɐɡreɪʃən",
    "conflagrations": "kɒnflɐɡreɪʃənz",
    "conflated": "kənfleɪtɪd",
    "conflate": "kənfleɪt",
    "conflates": "kənfleɪts",
    "conflating": "kənfleɪtɪŋ",
    "conflation": "kənfleɪʃən",
    "conflicted": "kənflɪktɪd",
    "conflicting": "kənflɪktɪŋ",
    "confluence": "kɒnfluːəns",
    "confluences": "kɒnfluːənsɪz",
    "conformable": "kənfɔːməbəl",
    "conformance": "kənfɔːməns",
    "conformation": "kɒnfɔːmeɪʃən",
    "conformed": "kənfɔːmd",
    "conforming": "kənfɔːmɪŋ",
    "conformism": "kənfɔːmɪzəm",
    "conformist": "kənfɔːmɪst",
    "conformists": "kənfɔːmɪsts",
    "conformity": "kənfɔːmɪti",
    "conform": "kənfɔːm",
    "conforms": "kənfɔːmz",
    "confounded": "kənfaʊndɪd",
    "confounding": "kənfaʊndɪŋ",
    "confounds": "kənfaʊndz",
    "confraternities": "kɒnfrɐtɜːnɪtiz",
    "confrontational": "kɒnfrənteɪʃənəl",
    "confrontation": "kɒnfrənteɪʃən",
    "confrontations": "kɒnfrənteɪʃənz",
    "confronted": "kənfrʌntɪd",
    "confronting": "kənfrʌntɪŋ",
    "confront": "kənfrʌnt",
    "confronts": "kənfrʌnts",
    "confused": "kənfjuːzd",
    "confusedly": "kənfjuːsɪdli",
    "confuse": "kənfjuːz",
    "confuses": "kənfjuːzɪz",
    "confusing": "kənfjuːzɪŋ",
    "confusingly": "kənfjuːzɪŋli",
    "confusion": "kənfjuːʒən",
    "confusions": "kənfjuːʒənz",
    "conga": "kənɡæ",
    "congas": "kənɡæz",
    "congealed": "kəndʒiːld",
    "congealing": "kəndʒiːlɪŋ",
    "congeal": "kəndʒiːl",
    "congeals": "kəndʒiːlz",
    "congeniality": "kəndʒiːnɪælɪti",
    "congenial": "kəndʒiːnɪəl",
    "congenital": "kəndʒɛnɪtəl",
    "congenitally": "kəndʒɛnɪtəli",
    "conger": "kɒŋɡɐ",
    "congers": "kɒŋɡəz",
    "congested": "kəndʒɛstɪd",
    "congestion": "kəndʒɛstʃən",
    "congestive": "kəndʒɛstɪv",
    "congest": "kəndʒɛst",
    "conglomerated": "kənɡlɒməreɪtɪd",
    "conglomeration": "kənɡlɒməreɪʃən",
    "conglomerations": "kənɡlɒməreɪʃənz",
    "congrats": "kənɡræts",
    "congratulated": "kənɡrætʃʊleɪtɪd",
    "congratulate": "kənɡrætʃʊleɪt",
    "congratulates": "kənɡrætʃʊleɪts",
    "congratulating": "kənɡrætʃʊleɪtɪŋ",
    "congratulation": "kənɡrætʃʊleɪʃən",
    "congratulations": "kənɡrætʃʊleɪʃənz",
    "congratulatory": "kənɡrætʃʊleɪtəri",
    "congregant": "kɒŋɡrɛɡənt",
    "congregants": "kɒŋɡrɛɡənts",
    "congregated": "kɒŋɡrɪɡeɪtɪd",
    "congregates": "kɒŋɡrɪɡeɪts",
    "congregating": "kɒŋɡrɪɡeɪtɪŋ",
    "congregationalist": "kɒŋɡrɪɡeɪʃənəlɪst",
    "congregationalists": "kɒŋɡrɪɡeɪʃənəlɪsts",
    "congregational": "kɒŋɡrɪɡeɪʃənəl",
    "congregation": "kɒŋɡrɪɡeɪʃən",
    "congregations": "kɒŋɡrɪɡeɪʃənz",
    "congresses": "kɒŋɡrɛsɪz",
    "congressional": "kənɡrɛʃənəl",
    "congressman": "kɒŋɡrɛsmən",
    "congressmen": "kɒŋɡrɪsmɛn",
    "congresswoman": "kɒŋɡrɪswʊmən",
    "congruence": "kɒnɡruːəns",
    "congruent": "kɒnɡruːənt",
    "conical": "kɒnɪkəl",
    "conic": "kənɪk",
    "conifer": "kənɪfɐ",
    "coniferous": "kənɪfərəs",
    "conifers": "kənɪfəz",
    "coning": "kəʊnɪŋ",
    "conjecture": "kəndʒɛktʃɐ",
    "conjectures": "kəndʒɛktʃəz",
    "conjoined": "kəndʒɔɪnd",
    "conjugal": "kɒndʒuːɡəl",
    "conjugated": "kɒndʒuːɡeɪtɪd",
    "conjugating": "kɒndʒuːɡeɪtɪŋ",
    "conjugation": "kɒndʒuːɡeɪʃən",
    "conjunction": "kəndʒʌŋkʃən",
    "conjunctions": "kəndʒʌŋkʃənz",
    "conjunctiva": "kəndʒʌŋktɪvɐ",
    "conjunctivitis": "kəndʒʌŋktɪvaɪtɪs",
    "conjuration": "kʌndʒjʊreɪʃən",
    "conjured": "kʌndʒəd",
    "conjure": "kʌndʒɐ",
    "conjurer": "kʌndʒjʊrɐ",
    "conjurers": "kʌndʒjʊrəz",
    "conjures": "kʌndʒəz",
    "conjuring": "kʌndʒərɪŋ",
    "conjuror": "kʌndʒjʊrɐ",
    "conjurors": "kʌndʒjʊrəz",
    "conked": "kɒnkt",
    "conker": "kɒnkɐ",
    "conkers": "kɒnkəz",
    "conking": "kɒnkɪŋ",
    "conk": "kɒnk",
    "con": "kɒn",
    "conks": "kɒnks",
    "conman": "kənmæn",
    "connected": "kənɛktɪd",
    "connectedness": "kənɛktɪdnəs",
    "connecter": "kənɛktɐ",
    "connecting": "kənɛktɪŋ",
    "connection": "kənɛkʃən",
    "connections": "kənɛkʃənz",
    "connective": "kənɛktɪv",
    "connectivity": "kɒnɪktɪvɪti",
    "connect": "kənɛkt",
    "connector": "kənɛktɐ",
    "connectors": "kənɛktəz",
    "connects": "kənɛkts",
    "conned": "kɒnd",
    "conning": "kɒnɪŋ",
    "connivance": "kənaɪvəns",
    "connived": "kənaɪvd",
    "connive": "kənaɪv",
    "conniver": "kənaɪvɐ",
    "conniving": "kənaɪvɪŋ",
    "conn": "kɒn",
    "connoisseur": "kɒnəsɜː",
    "connoisseurship": "kɒnəsɜːʃɪp",
    "connoisseurs": "kɒnəsɜːz",
    "connotation": "kɒnəʊteɪʃən",
    "connotations": "kɒnəʊteɪʃənz",
    "conquered": "kɒnkəd",
    "conquerer": "kɒnkərɐ",
    "conquering": "kɒnkərɪŋ",
    "conquer": "kɒnkɐ",
    "conqueror": "kɒnkwərɐ",
    "conquerors": "kɒnkwərəz",
    "conquers": "kɒnkəz",
    "conquest": "kɒnkwɛst",
    "conquests": "kɒnkwɛsts",
    "conquistadores": "kənkwɪstɐdɔːz",
    "conquistador": "kɒnkiːstədɔː",
    "conquistadors": "kɒnkiːstədɔːz",
    "conscience": "kɒnʃəns",
    "consciences": "kɒnʃənsɪz",
    "conscientious": "kɒnsɪɛnʃəs",
    "conscientiously": "kɒnsɪɛnʃəsli",
    "conscientiousness": "kɒnsɪɛnʃəsnəs",
    "conscious": "kɒnʃəs",
    "consciously": "kɒnʃəsli",
    "consciousnesses": "kɒnʃəsnəsɪz",
    "consciousness": "kɒnʃəsnəs",
    "conscripted": "kɒnskrɪptɪd",
    "conscripting": "kɒnskrɪptɪŋ",
    "conscription": "kɒnskrɪpʃən",
    "consecrated": "kɒnsɪkreɪtɪd",
    "consecrate": "kɒnsɪkreɪt",
    "consecrates": "kɒnsɪkreɪts",
    "consecrating": "kɒnsɪkreɪtɪŋ",
    "consecration": "kɒnsɪkreɪʃən",
    "consecutive": "kənsɛkjuːtɪv",
    "consecutively": "kənsɛkjuːtɪvli",
    "consensual": "kənsɛnsjuːəl",
    "consensually": "kənsɛnsjuːəli",
    "consensus": "kənsɛnsəs",
    "consented": "kənsɛntɪd",
    "consenting": "kənsɛntɪŋ",
    "consent": "kənsɛnt",
    "consents": "kənsɛnts",
    "consequence": "kɒnsɪkwəns",
    "consequences": "kɒnsɪkwənsɪz",
    "consequential": "kɒnsɪkwɛnʃəl",
    "consequentially": "kɒnsɪkwɛnʃəli",
    "consequent": "kɒnsɪkwənt",
    "consequently": "kɒnsɪkwəntli",
    "conservancies": "kənsɜːvənsɪz",
    "conservancy": "kənsɜːvənsi",
    "conservational": "kɒnsəveɪʃənəl",
    "conservationist": "kɒnsəveɪʃənɪst",
    "conservationists": "kɒnsəveɪʃənɪsts",
    "conservation": "kɒnsəveɪʃən",
    "conservations": "kɒnsəveɪʃənz",
    "conservatism": "kənsɜːvətɪzəm",
    "conservative": "kənsɜːvətɪv",
    "conservatively": "kənsɜːvətɪvli",
    "conservatives": "kənsɜːvətɪvz",
    "conservatoire": "kənsɜːvɐtwɑː",
    "conservatories": "kənsɜːvətəriz",
    "conservator": "kənsɜːveɪtɐ",
    "conservators": "kənsɜːveɪtəz",
    "conservatory": "kənsɜːvətəri",
    "conserved": "kənsɜːvd",
    "conserves": "kənsɜːvz",
    "conserving": "kənsɜːvɪŋ",
    "considerable": "kənsɪdərəbəl",
    "considerably": "kənsɪdərəbli",
    "considerate": "kənsɪdərət",
    "considerately": "kənsɪdərətli",
    "consideration": "kənsɪdəreɪʃən",
    "considerations": "kənsɪdəreɪʃənz",
    "considered": "kənsɪdəd",
    "considering": "kənsɪdərɪŋ",
    "consider": "kənsɪdɐ",
    "considers": "kənsɪdəz",
    "consigned": "kənsaɪnd",
    "consigning": "kənsaɪnɪŋ",
    "consign": "kənsaɪn",
    "consignment": "kənsaɪnmənt",
    "consignments": "kənsaɪnmənts",
    "consigns": "kənsaɪnz",
    "consisted": "kənsɪstɪd",
    "consistence": "kənsɪstəns",
    "consistencies": "kənsɪstənsiz",
    "consistency": "kənsɪstənsi",
    "consistent": "kənsɪstənt",
    "consistently": "kənsɪstəntli",
    "consisting": "kənsɪstɪŋ",
    "consistory": "kənsɪstəri",
    "consists": "kənsɪsts",
    "cons": "kɒnz",
    "consolation": "kɒnsəleɪʃən",
    "consolations": "kɒnsəleɪʃənz",
    "consoled": "kɒnsəʊld",
    "consolidated": "kənsɒlɪdeɪtɪd",
    "consolidates": "kənsɒlɪdeɪts",
    "consolidating": "kənsɒlɪdeɪtɪŋ",
    "consolidation": "kənsɒlɪdeɪʃən",
    "consolidations": "kənsɒlɪdeɪʃənz",
    "consoling": "kɒnsəʊlɪŋ",
    "consol": "kənsɒl",
    "consols": "kənsɒlz",
    "consonant": "kɒnsənənt",
    "consonants": "kɒnsənənts",
    "consorted": "kənsɔːtɪd",
    "consortia": "kənsɔːʃɐ",
    "consorting": "kənsɔːtɪŋ",
    "consortium": "kənsɔːtiəm",
    "consortiums": "kənsɔːtiəmz",
    "conspicuous": "kənspɪkjuːəs",
    "conspicuously": "kənspɪkjuːəsli",
    "conspiracies": "kənspɪrəsɪz",
    "conspiracy": "kənspɪrəsi",
    "conspiratorial": "kənspɪrətɔːrɪəl",
    "conspirator": "kənspɪrətɐ",
    "conspirators": "kənspɪrətəz",
    "conspired": "kənspaɪəd",
    "conspire": "kənspaɪə",
    "conspires": "kənspaɪəz",
    "conspiring": "kənspaɪərɪŋ",
    "constable": "kɒnstəbəl",
    "constables": "kɒnstəbəlz",
    "constabularies": "kənstæbjʊləriz",
    "constabulary": "kənstæbjʊləri",
    "constancy": "kɒnstənsi",
    "constant": "kɒnstənt",
    "constantly": "kɒnstəntli",
    "constants": "kɒnstənts",
    "constellation": "kɒnstɪleɪʃən",
    "constellations": "kɒnstɪleɪʃənz",
    "consternation": "kɒnstəneɪʃən",
    "constipated": "kɒnstɪpeɪtɪd",
    "constipation": "kɒnstɪpeɪʃən",
    "constituencies": "kənstɪtjuːənsɪz",
    "constituency": "kənstɪtjuːənsi",
    "constituent": "kənstɪtjuːənt",
    "constituents": "kənstɪtjuːənts",
    "constituted": "kɒnstɪtjuːtɪd",
    "constitute": "kɒnstɪtjuːt",
    "constitutes": "kɒnstɪtjuːts",
    "constituting": "kɒnstɪtjuːtɪŋ",
    "constitutionalism": "kɒnstɪtjuːʃənəlɪzəm",
    "constitutionality": "kɒnstɪtjuːʃənælɪti",
    "constitutional": "kɒnstɪtjuːʃənəl",
    "constitutionally": "kɒnstɪtjuːʃənəli",
    "constitution": "kɒnstɪtjuːʃən",
    "constitutions": "kɒnstɪtjuːʃənz",
    "constrained": "kənstreɪnd",
    "constraining": "kənstreɪnɪŋ",
    "constrain": "kənstreɪn",
    "constrains": "kənstreɪnz",
    "constraint": "kənstreɪnt",
    "constraints": "kənstreɪnts",
    "constricted": "kənstrɪktɪd",
    "constricting": "kənstrɪktɪŋ",
    "constriction": "kənstrɪkʃən",
    "constrictions": "kənstrɪkʃənz",
    "constrictive": "kənstrɪktɪv",
    "constrict": "kənstrɪkt",
    "constrictor": "kənstrɪktɐ",
    "constrictors": "kənstrɪktəz",
    "constricts": "kənstrɪkts",
    "constructed": "kənstrʌktɪd",
    "constructing": "kənstrʌktɪŋ",
    "constructional": "kənstrʌkʃənəl",
    "construction": "kənstrʌkʃən",
    "constructions": "kənstrʌkʃənz",
    "constructive": "kənstrʌktɪv",
    "constructively": "kənstrʌktɪvli",
    "constructivism": "kənstrʌktɪvɪzəm",
    "constructivist": "kənstrʌktɪvɪst",
    "constructivists": "kənstrʌktɪvɪsts",
    "constructor": "kənstrʌktɐ",
    "constructors": "kənstrʌktəz",
    "construed": "kənstruːd",
    "construe": "kənstruː",
    "consubstantial": "kɒnsəbstænʃəl",
    "consular": "kɒnsjʊlɐ",
    "consulate": "kɒnsjʊlət",
    "consulates": "kɒnsjʊləts",
    "consul": "kɒnsʌl",
    "consuls": "kɒnsʌlz",
    "consultancies": "kənsʌltənsɪz",
    "consultancy": "kənsʌltənsi",
    "consultant": "kənsʌltənt",
    "consultants": "kənsʌltənts",
    "consultation": "kɒnsəlteɪʃən",
    "consultations": "kɒnsəlteɪʃənz",
    "consultative": "kənsʌltətɪv",
    "consulted": "kənsʌltɪd",
    "consulting": "kənsʌltɪŋ",
    "consults": "kənsʌlts",
    "consumable": "kənsuːməbəl",
    "consumables": "kənsuːməbəlz",
    "consumed": "kənsuːmd",
    "consume": "kənsuːm",
    "consumerism": "kənsuːmərɪzəm",
    "consumerist": "kənsuːmərɪst",
    "consumer": "kənsuːmɐ",
    "consumers": "kənsuːməz",
    "consumes": "kənsuːmz",
    "consuming": "kənsuːmɪŋ",
    "consummated": "kənsʌmeɪtɪd",
    "consummately": "kɒnsəmeɪtli",
    "consummating": "kɒnsəmeɪtɪŋ",
    "consummation": "kɒnsəmeɪʃən",
    "consumption": "kənsʌmpʃən",
    "consumptions": "kənsʌmpʃənz",
    "consumptive": "kənsʌmptɪv",
    "contactable": "kɒntæktəbəl",
    "contacted": "kɒntæktɪd",
    "contacting": "kɒntæktɪŋ",
    "contacts": "kɒntækts",
    "contagion": "kənteɪdʒən",
    "contagious": "kənteɪdʒəs",
    "containable": "kənteɪnəbəl",
    "contained": "kənteɪnd",
    "containerisation": "kənteɪnəraɪzeɪʃən",
    "containerised": "kənteɪnəraɪzd",
    "container": "kənteɪnɐ",
    "containers": "kənteɪnəz",
    "containing": "kənteɪnɪŋ",
    "contain": "kənteɪn",
    "containment": "kənteɪnmənt",
    "contains": "kənteɪnz",
    "contaminant": "kəntæmɪnənt",
    "contaminants": "kəntæmɪnənts",
    "contaminated": "kəntæmɪneɪtɪd",
    "contaminate": "kəntæmɪneɪt",
    "contaminates": "kəntæmɪneɪts",
    "contaminating": "kəntæmɪneɪtɪŋ",
    "contamination": "kəntæmɪneɪʃən",
    "conte": "kəntɛ",
    "contemplated": "kɒntɪmpleɪtɪd",
    "contemplate": "kɒntɪmpleɪt",
    "contemplates": "kɒntɪmpleɪts",
    "contemplating": "kɒntɪmpleɪtɪŋ",
    "contemplation": "kɒntɪmpleɪʃən",
    "contemplations": "kɒntɪmpleɪʃənz",
    "contemplative": "kəntɛmplətɪv",
    "contemporaneous": "kəntɛmpɔːreɪniəs",
    "contemporaneously": "kəntɛmpɔːreɪniəsli",
    "contemporaries": "kəntɛmpərəriz",
    "contemporarily": "kəntɛmpərɛrəli",
    "contemporary": "kəntɛmpərəri",
    "contemptible": "kəntɛmptəbəl",
    "contempt": "kəntɛmpt",
    "contemptuous": "kəntɛmptʃuːəs",
    "contemptuously": "kəntɛmptʃuːəsli",
    "contended": "kəntɛndɪd",
    "contender": "kəntɛndɐ",
    "contenders": "kəntɛndəz",
    "contending": "kəntɛndɪŋ",
    "contend": "kəntɛnd",
    "contends": "kəntɛndz",
    "contented": "kəntɛntɪd",
    "contentedly": "kəntɛntɪdli",
    "contention": "kəntɛnʃən",
    "contentions": "kəntɛnʃənz",
    "contentious": "kəntɛnʃəs",
    "contentiousness": "kəntɛnʃəsnəs",
    "contentment": "kəntɛntmənt",
    "contestable": "kəntɛstəbəl",
    "contestant": "kəntɛstənt",
    "contestants": "kəntɛstənts",
    "contested": "kəntɛstɪd",
    "contesting": "kəntɛstɪŋ",
    "context": "kɒntɛkst",
    "contexts": "kɒntɛksts",
    "contextualised": "kəntɛkstʃuːəlaɪzd",
    "contextualise": "kəntɛkstʃuːəlaɪz",
    "contextualising": "kəntɛkstʃuːəlaɪzɪŋ",
    "contextual": "kəntɛkstʃuːəl",
    "contextually": "kəntɛkstʃuːəli",
    "contiguous": "kəntɪɡjuːəs",
    "continence": "kɒntɪnəns",
    "continental": "kɒntɪnɛntəl",
    "continentally": "kɒntɪnɛntəli",
    "continentals": "kɒntɪnɛntəlz",
    "continent": "kɒntɪnənt",
    "continents": "kɒntɪnənts",
    "contingencies": "kəntɪndʒənsiz",
    "contingency": "kəntɪndʒənsi",
    "contingent": "kəntɪndʒənt",
    "contingents": "kəntɪndʒənts",
    "continua": "kəntɪnjuːɐ",
    "continual": "kəntɪnjuːəl",
    "continually": "kəntɪnjuːəli",
    "continuance": "kəntɪnjuːəns",
    "continuation": "kəntɪnjuːeɪʃən",
    "continued": "kəntɪnjuːd",
    "continue": "kəntɪnjuː",
    "continuer": "kəntɪnjuːɐ",
    "continues": "kəntɪnjuːz",
    "continuing": "kəntɪnjuːɪŋ",
    "continuities": "kɒntɪnjuːɪtiz",
    "continuity": "kɒntɪnjuːɪti",
    "continuous": "kəntɪnjuːəs",
    "continuously": "kəntɪnjuːəsli",
    "continuum": "kəntɪnjuːəm",
    "contorted": "kəntɔːtɪd",
    "contorting": "kəntɔːtɪŋ",
    "contortionist": "kəntɔːʃənɪst",
    "contortionists": "kəntɔːʃənɪsts",
    "contortion": "kəntɔːʃən",
    "contortions": "kəntɔːʃənz",
    "contort": "kəntɔːt",
    "contorts": "kəntɔːts",
    "contoured": "kɒntəd",
    "contour": "kɒntɔː",
    "contours": "kɒntɔːz",
    "contraband": "kɒntrəbænd",
    "contrabassoon": "kɒntrəbæsuːn",
    "contraception": "kɒntrəsɛpʃən",
    "contraceptive": "kɒntrəsɛptɪv",
    "contraceptives": "kɒntrəsɛptɪvz",
    "contracted": "kəntræktɪd",
    "contractile": "kəntræktaɪl",
    "contracting": "kəntræktɪŋ",
    "contraction": "kəntrækʃən",
    "contractions": "kəntrækʃənz",
    "contractor": "kəntræktɐ",
    "contractors": "kəntræktəz",
    "contractual": "kəntræktʃuːəl",
    "contractually": "kəntræktʃuːəli",
    "contracture": "kəntræktʃɐ",
    "contractures": "kəntræktʃəz",
    "contradicted": "kɒntrədɪktɪd",
    "contradicting": "kɒntrədɪktɪŋ",
    "contradiction": "kɒntrədɪkʃən",
    "contradictions": "kɒntrədɪkʃənz",
    "contradict": "kɒntrədɪkt",
    "contradictory": "kɒntrədɪktəri",
    "contradicts": "kɒntrədɪkts",
    "contraflow": "kɒntrəfləʊ",
    "contrail": "kɒntreɪl",
    "contrails": "kɒntreɪlz",
    "contraindicated": "kəntreɪndɪkeɪtɪd",
    "contra": "kɒntrɐ",
    "contralto": "kəntræltəʊ",
    "contraltos": "kəntræltəʊz",
    "contraption": "kəntræpʃən",
    "contraptions": "kəntræpʃənz",
    "contrapuntal": "kɒntrəpʌntəl",
    "contrarian": "kɒntrəraɪən",
    "contras": "kɒntrəz",
    "contrasted": "kəntrɑːstɪd",
    "contrasting": "kəntrɑːstɪŋ",
    "contravened": "kɒntrəvɛnd",
    "contravene": "kɒntrəviːn",
    "contravenes": "kɒntrəviːnz",
    "contravening": "kɒntrəvɛnɪŋ",
    "contravention": "kɒntrəvɛnʃən",
    "contraventions": "kɒntrəvɛnʃənz",
    "contretemps": "kɒntrɪtɛmps",
    "contributed": "kɒntrɪbjuːtɪd",
    "contribute": "kɒntrɪbjuːt",
    "contributes": "kɒntrɪbjuːts",
    "contributing": "kɒntrɪbjuːtɪŋ",
    "contribution": "kɒntrɪbjuːʃən",
    "contributions": "kɒntrɪbjuːʃənz",
    "contributive": "kəntrɪbjuːtɪv",
    "contributor": "kəntrɪbjuːtɐ",
    "contributors": "kəntrɪbjuːtəz",
    "contributory": "kəntrɪbjuːtəri",
    "contrite": "kəntraɪt",
    "contrition": "kəntrɪʃən",
    "contrivance": "kəntraɪvəns",
    "contrived": "kəntraɪvd",
    "contrive": "kəntraɪv",
    "contriver": "kəntraɪvɐ",
    "contrives": "kəntraɪvz",
    "contriving": "kəntraɪvɪŋ",
    "control": "kəntrəʊl",
    "controllable": "kəntrəʊləbəl",
    "controlled": "kəntrəʊld",
    "controller": "kəntrəʊlɐ",
    "controllers": "kəntrəʊləz",
    "controlling": "kəntrəʊlɪŋ",
    "controls": "kəntrəʊlz",
    "controversial": "kɒntrəvɜːʃəl",
    "controversially": "kɒntrəvɜːʃəli",
    "controversies": "kɒntrəvɜːsɪz",
    "controversy": "kɒntrəvɜːsi",
    "contumely": "kəntjuːmli",
    "contusion": "kəntjuːʒən",
    "contusions": "kəntjuːʒənz",
    "conundrum": "kənʌndrəm",
    "conundrums": "kənʌndrəmz",
    "conurbation": "kɒnəbeɪʃən",
    "conurbations": "kɒnəbeɪʃənz",
    "convalesced": "kɒnvəlɛst",
    "convalesce": "kɒnvəlɛs",
    "convalescence": "kɒnvəlɛsəns",
    "convalescent": "kɒnvəlɛsənt",
    "convalescing": "kɒnvəlɛsɪŋ",
    "convectional": "kənvɛkʃənəl",
    "convection": "kənvɛkʃən",
    "convective": "kənvɛktɪv",
    "convector": "kənvɛktɐ",
    "convened": "kənviːnd",
    "convene": "kənviːn",
    "convener": "kənvɛnɐ",
    "convenes": "kənviːnz",
    "convenience": "kənviːnɪəns",
    "conveniences": "kənviːnɪənsɪz",
    "convenient": "kənviːnɪənt",
    "conveniently": "kənviːnɪəntli",
    "convening": "kənviːnɪŋ",
    "convenor": "kənvɛnɐ",
    "convenors": "kənvɛnəz",
    "conventicle": "kənvɛntɪkəl",
    "conventionalised": "kənvɛnʃənəlaɪzd",
    "conventionality": "kənvɛnʃənælɪti",
    "conventional": "kənvɛnʃənəl",
    "conventionally": "kənvɛnʃənəli",
    "convention": "kənvɛnʃən",
    "conventions": "kənvɛnʃənz",
    "convent": "kɒnvənt",
    "convents": "kɒnvənts",
    "converged": "kənvɜːdʒd",
    "converge": "kənvɜːdʒ",
    "convergence": "kənvɜːdʒəns",
    "convergent": "kənvɜːdʒənt",
    "converges": "kənvɜːdʒɪz",
    "converging": "kənvɜːdʒɪŋ",
    "conversant": "kənvɜːsənt",
    "conversationalist": "kɒnvəseɪʃənəlɪst",
    "conversational": "kɒnvəseɪʃənəl",
    "conversationally": "kɒnvəseɪʃənəli",
    "conversation": "kɒnvəseɪʃən",
    "conversations": "kɒnvəseɪʃənz",
    "conversazione": "kənvɜːsɐzaɪəni",
    "conversed": "kənvɜːsd",
    "conversely": "kənvɜːsli",
    "conversing": "kənvɜːsɪŋ",
    "conversion": "kənvɜːʃən",
    "conversions": "kənvɜːʃənz",
    "converted": "kənvɜːtɪd",
    "converter": "kənvɜːtɐ",
    "converters": "kənvɜːtəz",
    "convertible": "kənvɜːtəbəl",
    "convertibles": "kənvɜːtəbəlz",
    "converting": "kənvɜːtɪŋ",
    "convertor": "kənvɜːtɐ",
    "convertors": "kənvɜːtəz",
    "convex": "kɒnvɛks",
    "conveyance": "kənveɪəns",
    "conveyancer": "kənveɪənsɐ",
    "conveyances": "kənveɪənsɪz",
    "conveyancing": "kənveɪənsɪŋ",
    "conveyed": "kənveɪd",
    "conveyer": "kənveɪɐ",
    "conveyers": "kənveɪəz",
    "conveying": "kənveɪɪŋ",
    "convey": "kənveɪ",
    "conveyor": "kənveɪɐ",
    "conveyors": "kənveɪəz",
    "conveys": "kənveɪz",
    "convicted": "kənvɪktɪd",
    "convicting": "kənvɪktɪŋ",
    "conviction": "kənvɪkʃən",
    "convictions": "kənvɪkʃənz",
    "convinced": "kənvɪnst",
    "convince": "kənvɪns",
    "convinces": "kənvɪnsɪz",
    "convincing": "kənvɪnsɪŋ",
    "convincingly": "kənvɪnsɪŋli",
    "conviviality": "kənvɪvɪælɪti",
    "convivial": "kənvɪvɪəl",
    "convocation": "kɒnvəkeɪʃən",
    "convoluted": "kɒnvəluːtɪd",
    "convolution": "kɒnvəluːʃən",
    "convolutions": "kɒnvəluːʃənz",
    "convolvulus": "kənvɒlvjʊləs",
    "convoy": "kɒnvɔɪ",
    "convoys": "kɒnvɔɪz",
    "convulsed": "kənvʌlzd",
    "convulse": "kənvʌls",
    "convulsing": "kənvʌlsɪŋ",
    "convulsion": "kənvʌlʃən",
    "convulsions": "kənvʌlʃənz",
    "convulsive": "kənvʌlsɪv",
    "cooed": "kuːd",
    "cooee": "kuːiː",
    "cooing": "kuːɪŋ",
    "cookbook": "kʊkbʊk",
    "cookbooks": "kʊkbʊks",
    "cooked": "kʊkt",
    "cookeries": "kʊkəriz",
    "cooker": "kʊkɐ",
    "cookers": "kʊkəz",
    "cookery": "kʊkəri",
    "cookhouse": "kʊkhaʊs",
    "cookie": "kʊki",
    "cookies": "kʊkɪz",
    "cooking": "kʊkɪŋ",
    "cook": "kʊk",
    "cookout": "kʊkaʊt",
    "cookouts": "kʊkaʊts",
    "cooks": "kʊks",
    "coo": "kuː",
    "cookware": "kʊkweə",
    "cooky": "kʊki",
    "coolant": "kuːlənt",
    "coolants": "kuːlənts",
    "cooled": "kuːld",
    "cooler": "kuːlɐ",
    "coolers": "kuːləz",
    "coolest": "kuːləst",
    "coolie": "kuːli",
    "coolies": "kuːliz",
    "cooling": "kuːlɪŋ",
    "coolish": "kuːlɪʃ",
    "cool": "kuːl",
    "coolly": "kuːli",
    "coolness": "kuːlnəs",
    "cools": "kuːlz",
    "coomb": "kuːm",
    "coom": "kuːm",
    "coon": "kuːn",
    "coons": "kuːnz",
    "cooped": "kuːpt",
    "cooperage": "kəʊɒpərɪdʒ",
    "cooperated": "kəʊɒpəreɪtɪd",
    "cooperate": "kəʊɒpəreɪt",
    "cooperates": "kəʊɒpəreɪts",
    "cooperating": "kəʊɒpəreɪtɪŋ",
    "cooperation": "kəʊɒpəreɪʃən",
    "cooperative": "kəʊɒpərətɪv",
    "cooperatively": "kəʊɒpərətɪvli",
    "cooperatives": "kəʊɒpərətɪvz",
    "coopered": "kuːpəd",
    "coopering": "kuːpərɪŋ",
    "cooper": "kuːpɐ",
    "coopers": "kuːpəz",
    "coops": "kuːps",
    "coordinated": "kəʊɔːdɪneɪtɪd",
    "coordinating": "kəʊɔːdɪneɪtɪŋ",
    "coordination": "kəʊɔːdɪneɪʃən",
    "coordinator": "kəʊɔːdɪneɪtɐ",
    "coordinators": "kəʊɔːdɪneɪtəz",
    "coos": "kuːz",
    "cootie": "kuːti",
    "cooties": "kuːtɪz",
    "coot": "kuːt",
    "coots": "kuːts",
    "copacetic": "kɒpɐsɛtɪk",
    "coped": "kəʊpd",
    "cope": "kəʊp",
    "coper": "kəʊpɐ",
    "copes": "kəʊps",
    "copied": "kɒpɪd",
    "copier": "kɒpiə",
    "copiers": "kɒpiəz",
    "copies": "kɒpɪz",
    "coping": "kəʊpɪŋ",
    "copious": "kəʊpɪəs",
    "copiously": "kəʊpɪəsli",
    "cop": "kɒp",
    "copped": "kɒpt",
    "copperhead": "kɒpəhɛd",
    "copper": "kɒpɐ",
    "copperplate": "kɒpəpleɪt",
    "coppers": "kɒpəz",
    "coppersmith": "kɒpəsmɪθ",
    "coppery": "kɒpəri",
    "coppiced": "kɒpɪst",
    "coppice": "kɒpɪs",
    "coppices": "kɒpɪsɪz",
    "coppicing": "kɒpɪsɪŋ",
    "copping": "kɒpɪŋ",
    "copra": "kɒprɐ",
    "coprolite": "kɒprəlaɪt",
    "copse": "kɒps",
    "copses": "kɒpsɪz",
    "cops": "kɒps",
    "copter": "kɒptɐ",
    "copters": "kɒptəz",
    "copulated": "kɒpjʊleɪtɪd",
    "copulate": "kɒpjʊleɪt",
    "copulates": "kɒpjʊleɪts",
    "copulating": "kɒpjʊleɪtɪŋ",
    "copulation": "kɒpjʊleɪʃən",
    "copulations": "kɒpjʊleɪʃənz",
    "copybook": "kɒpɪbʊk",
    "copycat": "kɒpɪkæt",
    "copycats": "kɒpɪkæts",
    "copying": "kɒpɪɪŋ",
    "copyist": "kɒpɪɪst",
    "copyists": "kɒpɪɪsts",
    "copy": "kɒpi",
    "copyrighted": "kɒpɪraɪtɪd",
    "copyright": "kɒpɪraɪt",
    "copyrights": "kɒpɪraɪts",
    "copywriter": "kɒpɪraɪtɐ",
    "copywriters": "kɒpɪraɪtəz",
    "copywriting": "kɒpɪraɪtɪŋ",
    "coquet": "kɒkeɪ",
    "coquetry": "kɒkwɪtri",
    "coquette": "kəkɛt",
    "coquettish": "kəkɛtɪʃ",
    "coquettishly": "kəkɛtɪʃli",
    "coquille": "kɒkwɪl",
    "coquilles": "kɒkwɪlz",
    "coracle": "kɒrəkəl",
    "coracles": "kɒrəkəlz",
    "coral": "kɒrəl",
    "corals": "kɒrəlz",
    "corbeil": "kɔːbeɪl",
    "corbel": "kɔːbəl",
    "corbels": "kɔːbəlz",
    "cordage": "kɔːdɪdʒ",
    "corded": "kɔːdɪd",
    "corder": "kɔːdɐ",
    "cordiality": "kɔːdɪælɪti",
    "cordial": "kɔːdɪəl",
    "cordially": "kɔːdɪəli",
    "cordials": "kɔːdɪəlz",
    "cording": "kɔːdɪŋ",
    "cordite": "kɔːdaɪt",
    "cord": "kɔːd",
    "cordless": "kɔːdləs",
    "cordoned": "kɔːdənd",
    "cordoning": "kɔːdənɪŋ",
    "cordon": "kɔːdən",
    "cordons": "kɔːdənz",
    "cords": "kɔːdz",
    "corduroy": "kɔːdjɔːrɔɪ",
    "corduroys": "kɔːdjɔːrɔɪz",
    "cored": "kɔːd",
    "core": "kɔː",
    "coreopsis": "kɔːrɪɒpsɪs",
    "corer": "kɔːrɐ",
    "cores": "kɔːz",
    "corgi": "kɔːɡi",
    "corgis": "kɔːɡɪz",
    "coria": "kɒriɐ",
    "coriander": "kɒrɪændɐ",
    "coring": "kɔːrɪŋ",
    "corkage": "kɔːkɪdʒ",
    "corkboard": "kɔːkbɔːd",
    "corked": "kɔːkt",
    "corker": "kɔːkɐ",
    "corkers": "kɔːkəz",
    "corking": "kɔːkɪŋ",
    "cork": "kɔːk",
    "corkscrewed": "kɔːkskruːd",
    "corkscrewing": "kɔːkskruːɪŋ",
    "corkscrew": "kɔːkskruː",
    "corkscrews": "kɔːkskruːz",
    "corks": "kɔːks",
    "corky": "kɔːki",
    "corm": "kɔːm",
    "cormorant": "kɔːmərənt",
    "cormorants": "kɔːmərənts",
    "corms": "kɔːmz",
    "cornball": "kɔːnbɔːl",
    "cornbread": "kɔːnbrɛd",
    "corncob": "kɔːnkɒb",
    "corncrake": "kɔːŋkreɪk",
    "corncrakes": "kɔːŋkreɪks",
    "cornea": "kɔːniə",
    "corneal": "kɔːniəl",
    "corneas": "kɔːniəz",
    "corned": "kɔːnd",
    "cornelian": "kɔːniːliən",
    "cornel": "kɔːnəl",
    "cornerback": "kɔːnəbæk",
    "cornered": "kɔːnəd",
    "cornering": "kɔːnərɪŋ",
    "corner": "kɔːnɐ",
    "corners": "kɔːnəz",
    "cornerstone": "kɔːnəstəʊn",
    "cornerstones": "kɔːnəstəʊnz",
    "cornet": "kɔːnɪt",
    "cornets": "kɔːnɪts",
    "cornett": "kɔːnɪt",
    "cornfield": "kɔːnfiːld",
    "cornfields": "kɔːnfiːldz",
    "cornflake": "kɔːnfleɪk",
    "cornflakes": "kɔːnfleɪks",
    "cornflour": "kɔːnflaʊə",
    "cornflower": "kɔːnflaʊɐ",
    "cornflowers": "kɔːnflaʊəz",
    "cornice": "kɔːnɪs",
    "cornices": "kɔːnɪsɪz",
    "corniche": "kɔːniːʃ",
    "cornicing": "kɔːnɪsɪŋ",
    "corniest": "kɔːnɪəst",
    "corniness": "kɔːnɪnəs",
    "corning": "kɔːnɪŋ",
    "corn": "kɔːn",
    "cornmeal": "kɔːnmiəl",
    "cornpone": "kɔːnpəʊn",
    "cornrows": "kɔːnrəʊz",
    "corns": "kɔːnz",
    "cornstarch": "kɔːnstɑːk",
    "cornucopia": "kɔːnjuːkəʊpiə",
    "cornus": "kɔːnəs",
    "corny": "kɔːni",
    "corolla": "kərəʊlɐ",
    "corollary": "kərɒləri",
    "corollas": "kərəʊləz",
    "corona": "kərəʊnɐ",
    "coronal": "kɒrɒnəl",
    "coronary": "kɒrənəri",
    "coronas": "kərəʊnəz",
    "coronation": "kɒrəneɪʃən",
    "coronations": "kɒrəneɪʃənz",
    "coroner": "kɒrənɐ",
    "coroners": "kɒrənəz",
    "coronet": "kɒrənɛt",
    "coronets": "kɒrənɛts",
    "corporal": "kɔːprəl",
    "corporals": "kɔːprəlz",
    "corporate": "kɔːpərət",
    "corporately": "kɔːpərətli",
    "corporation": "kɔːpəreɪʃən",
    "corporations": "kɔːpəreɪʃənz",
    "corporeal": "kɔːpɔːriəl",
    "corpse": "kɔːps",
    "corpses": "kɔːpsɪz",
    "corpulence": "kɔːpjʊləns",
    "corpulent": "kɔːpjʊlənt",
    "corpuscle": "kɔːpʌskəl",
    "corpuscles": "kɔːpʌskəlz",
    "corpuscular": "kɔːpʌskjʊlɐ",
    "corpus": "kɔːpəs",
    "corral": "kəræl",
    "corralled": "kəræld",
    "corralling": "kərælɪŋ",
    "corrals": "kərælz",
    "correctable": "kərɛktəbəl",
    "corrected": "kərɛktɪd",
    "correcting": "kərɛktɪŋ",
    "correctional": "kərɛkʃənəl",
    "correction": "kərɛkʃən",
    "corrections": "kərɛkʃənz",
    "corrective": "kərɛktɪv",
    "correct": "kərɛkt",
    "correctly": "kərɛktli",
    "correctness": "kərɛktnəs",
    "corrector": "kərɛktɐ",
    "corrects": "kərɛkts",
    "correlated": "kɒrɪleɪtɪd",
    "correlate": "kɒrɪleɪt",
    "correlates": "kɒrɪleɪts",
    "correlating": "kɒrɪleɪtɪŋ",
    "correlation": "kɒrɪleɪʃən",
    "correlations": "kɒrɪleɪʃənz",
    "corresponded": "kɒrɪspɒndɪd",
    "correspondence": "kɒrɪspɒndəns",
    "correspondences": "kɒrɪspɒndənsɪz",
    "correspondent": "kɒrɪspɒndənt",
    "correspondents": "kɒrɪspɒndənts",
    "corresponding": "kɒrɪspɒndɪŋ",
    "correspondingly": "kɒrɪspɒndɪŋli",
    "correspond": "kɒrɪspɒnd",
    "corresponds": "kɒrɪspɒndz",
    "corrida": "kɒrɪdɐ",
    "corridor": "kɒrɪdɔː",
    "corridors": "kɒrɪdɔːz",
    "corrie": "kɒri",
    "corries": "kɒrɪz",
    "corroborated": "kərɒbəreɪtɪd",
    "corroborate": "kərɒbəreɪt",
    "corroborates": "kərɒbəreɪts",
    "corroborating": "kərɒbəreɪtɪŋ",
    "corroboration": "kərɒbəreɪʃən",
    "corroborative": "kərɒbrətɪv",
    "corroded": "kərəʊdɪd",
    "corrode": "kərəʊd",
    "corrodes": "kərəʊdz",
    "corroding": "kərəʊdɪŋ",
    "corrosion": "kərəʊʒən",
    "corrosive": "kərəʊsɪv",
    "corrugated": "kɒrəɡeɪtɪd",
    "corrugate": "kɒrəɡeɪt",
    "corrugation": "kɒruːɡeɪʃən",
    "corrugations": "kɒruːɡeɪʃənz",
    "corrupted": "kərʌptɪd",
    "corrupter": "kərʌptɐ",
    "corruptible": "kərʌptəbəl",
    "corrupting": "kərʌptɪŋ",
    "corruption": "kərʌpʃən",
    "corruptions": "kərʌpʃənz",
    "corrupt": "kərʌpt",
    "corruptly": "kərʌptli",
    "corrupts": "kərʌpts",
    "corsage": "kɔːsɑːʒ",
    "corsages": "kɔːsɑːʒɪz",
    "corsair": "kɔːseə",
    "corsairs": "kɔːseəz",
    "corse": "kɔːs",
    "corselet": "kɔːsɛlət",
    "corseted": "kɔːsɛtɪd",
    "corseting": "kɔːsɪtɪŋ",
    "corset": "kɔːsɛt",
    "corsetry": "kɔːsɪtri",
    "corsets": "kɔːsɛts",
    "cortex": "kɔːtɛks",
    "cortical": "kɔːtɪkəl",
    "corticosteroids": "kɔːtɪkɒstərɔɪdz",
    "cortisol": "kɔːtɪsɒl",
    "cortisone": "kɔːtɪsəʊn",
    "corundum": "kərʌndəm",
    "coruscating": "kɒrəskeɪtɪŋ",
    "corvette": "kɔːvɛt",
    "corvettes": "kɔːvɛts",
    "corydalis": "kɔːrɪdɑːliz",
    "coshed": "kɒʃt",
    "coshes": "kɒʃɪz",
    "cosh": "kɒʃ",
    "cosier": "kəʊzɪɐ",
    "cosies": "kəʊzɪz",
    "cosiest": "kəʊzɪəst",
    "cosily": "kəʊzɪli",
    "cosine": "kəʊsaɪn",
    "cosines": "kəʊsaɪnz",
    "cosiness": "kəʊzɪnəs",
    "cosmetically": "kɒzmɛtɪkli",
    "cosmetic": "kɒzmɛtɪk",
    "cosmetics": "kɒzmɛtɪks",
    "cosmetologist": "kɒzmɪtɒlədʒɪst",
    "cosmically": "kɒzmɪkli",
    "cosmic": "kɒzmɪk",
    "cosmogony": "kɒzməɡəni",
    "cosmological": "kɒzməlɒdʒɪkəl",
    "cosmologist": "kɒzmɒlədʒɪst",
    "cosmologists": "kɒzmɒlədʒɪsts",
    "cosmology": "kɒzmɒlədʒi",
    "cosmonaut": "kɒzmənɔːt",
    "cosmonauts": "kɒzmənɔːts",
    "cosmopolis": "kɒzmɒpəliz",
    "cosmopolitanism": "kɒzməpɒlɪtənɪzəm",
    "cosmopolitan": "kɒzməpɒlɪtən",
    "cosmopolitans": "kɒzməpɒlɪtənz",
    "cosmos": "kɒzmɒs",
    "cossack": "kɒsæk",
    "cossacks": "kɒsæks",
    "cosseted": "kɒsɛtɪd",
    "cosseting": "kɒsɪtɪŋ",
    "cosset": "kɒsɛt",
    "coss": "kɒs",
    "costa": "kɒstɐ",
    "costal": "kɒstəl",
    "costard": "kəʊstɑːd",
    "costed": "kɒstɪd",
    "costermonger": "kɒstəmɒŋɐ",
    "costermongers": "kɒstəmʌŋɡəz",
    "costing": "kɒstɪŋ",
    "costings": "kɒstɪŋz",
    "cost": "kɒst",
    "costless": "kɒstləs",
    "costlier": "kɒsliɐ",
    "costliest": "kɒsliəst",
    "costly": "kɒstli",
    "costs": "kɒsts",
    "costumed": "kɒstjuːmd",
    "costume": "kɒstjuːm",
    "costumer": "kɒstjuːmɐ",
    "costumes": "kɒstjuːmz",
    "costumiers": "kəstjuːmiəz",
    "costuming": "kɒstjuːmɪŋ",
    "cosy": "kəʊzi",
    "cote": "kəʊt",
    "coterie": "kəʊtəri",
    "coteries": "kəʊtəriz",
    "coterminous": "kəʊtəmɪnəs",
    "cotes": "kəʊts",
    "cotillion": "kəʊtɪliən",
    "cotillions": "kəʊtɪliənz",
    "cot": "kɒt",
    "cotoneaster": "kɒtəʊnæstɐ",
    "cots": "kɒts",
    "cottage": "kɒtɪdʒ",
    "cottager": "kɒtɪdʒɐ",
    "cottagers": "kɒtɪdʒəz",
    "cottages": "kɒtɪdʒɪz",
    "cottaging": "kɒtɪdʒɪŋ",
    "cotta": "kɒtɐ",
    "cottar": "kɒtɐ",
    "cotter": "kɒtɐ",
    "cotters": "kɒtəz",
    "cottoned": "kɒtənd",
    "cottoning": "kɒtənɪŋ",
    "cotton": "kɒtən",
    "cottonmouth": "kɒtənmaʊθ",
    "cottons": "kɒtənz",
    "cottontail": "kɒtənteɪl",
    "cottonwood": "kɒtənwʊd",
    "cottony": "kɒtəni",
    "cotyledons": "kɒtɪliːdənz",
    "couchant": "kaʊtʃənt",
    "couched": "kaʊtʃt",
    "couches": "kaʊtʃɪz",
    "couching": "kaʊtʃɪŋ",
    "couch": "kaʊtʃ",
    "cougar": "kuːɡɐ",
    "cougars": "kuːɡəz",
    "coughed": "kɒfd",
    "coughing": "kɒfɪŋ",
    "cough": "kɒf",
    "coughs": "kɒfz",
    "could": "kʊd",
    "couldst": "kʊdst",
    "coulis": "kuːliz",
    "coulomb": "kuːlɒm",
    "coulter": "kəʊltɐ",
    "coulters": "kəʊltəz",
    "council": "kaʊnsəl",
    "councillor": "kaʊnsɪlɐ",
    "councillors": "kaʊnsɪləz",
    "councils": "kaʊnsəlz",
    "counsel": "kaʊnsəl",
    "counselled": "kaʊnsəld",
    "counselling": "kaʊnsəlɪŋ",
    "counsellor": "kaʊnsɛlɐ",
    "counsellors": "kaʊnsɛləz",
    "counsels": "kaʊnsəlz",
    "countdown": "kaʊntdaʊn",
    "countdowns": "kaʊntdaʊnz",
    "counted": "kaʊntɪd",
    "countenanced": "kaʊntənənst",
    "countenance": "kaʊntənəns",
    "countenancing": "kaʊntənənsɪŋ",
    "counteracted": "kaʊntəræktɪd",
    "counteracting": "kaʊntəræktɪŋ",
    "counteract": "kaʊntərækt",
    "counteracts": "kaʊntərækts",
    "counterargument": "kaʊntərɑːɡjuːmənt",
    "counterattacked": "kaʊntərɐtækt",
    "counterattack": "kaʊntərɐtæk",
    "counterattacks": "kaʊntərɐtæks",
    "counterbalanced": "kaʊntəbælənst",
    "counterbalancing": "kaʊntəbælənsɪŋ",
    "counterblast": "kaʊntəblɑːst",
    "counterclaim": "kaʊntəkleɪm",
    "counterclaims": "kaʊntəkleɪmz",
    "counterclockwise": "kaʊntəklɒkwaɪz",
    "counterculture": "kaʊntəkʌltʃɐ",
    "countered": "kaʊntəd",
    "counterfactual": "kaʊntəfæktʃuːəl",
    "counterfeited": "kaʊntəfɪtɪd",
    "counterfeiter": "kaʊntəfɪtɐ",
    "counterfeiters": "kaʊntəfɪtəz",
    "counterfeiting": "kaʊntəfɪtɪŋ",
    "counterfeit": "kaʊntəfɪt",
    "counterfeits": "kaʊntəfɪts",
    "counterfoil": "kaʊntəfɔɪl",
    "countering": "kaʊntərɪŋ",
    "counterinsurgency": "kaʊntərɪnsɜːdʒənsi",
    "counterintelligence": "kaʊntərɪntɛlɪdʒəns",
    "counterintuitive": "kaʊntərɪntjuːɪtɪv",
    "counterintuitively": "kaʊntərɪntjuːɪtɪvli",
    "counter": "kaʊntɐ",
    "countermanded": "kaʊntəmændɪd",
    "countermand": "kaʊntəmænd",
    "countermeasure": "kaʊntəmɛʒɐ",
    "countermeasures": "kaʊntəmɛʒəz",
    "countermove": "kaʊntəmuːv",
    "counteroffensive": "kaʊntərəfɛnsɪv",
    "counterpane": "kaʊntəpeɪn",
    "counterpanes": "kaʊntəpeɪnz",
    "counterpart": "kaʊntəpɑːt",
    "counterparts": "kaʊntəpɑːts",
    "counterpointed": "kaʊntəpɔɪntɪd",
    "counterpointing": "kaʊntəpɔɪntɪŋ",
    "counterpoint": "kaʊntəpɔɪnt",
    "counterpoints": "kaʊntəpɔɪnts",
    "counterproductive": "kaʊntəprədʌktɪv",
    "countersigned": "kaʊntəsaɪnd",
    "countersign": "kaʊntəsaɪn",
    "counters": "kaʊntəz",
    "countertenor": "kaʊntətɛnɐ",
    "countertenors": "kaʊntətɛnəz",
    "countervailing": "kaʊntəveɪlɪŋ",
    "counterweight": "kaʊntəweɪt",
    "counterweights": "kaʊntəweɪts",
    "countesses": "kaʊntɛsɪz",
    "countess": "kaʊntɛs",
    "counties": "kaʊntɪz",
    "counting": "kaʊntɪŋ",
    "count": "kaʊnt",
    "countless": "kaʊntləs",
    "countries": "kʌntrɪz",
    "countrified": "kʌntrɪfaɪd",
    "country": "kʌntri",
    "countryman": "kʌntrɪmən",
    "countrymen": "kʌntrɪmɛn",
    "countryside": "kʌntrɪsaɪd",
    "countrysides": "kʌntrɪsaɪdz",
    "countrywide": "kʌntrɪwaɪd",
    "countrywoman": "kʌntrɪwʊmən",
    "countrywomen": "kʌntrɪwɪmɪn",
    "counts": "kaʊnts",
    "county": "kaʊnti",
    "coupe": "kuːp",
    "coupes": "kuːps",
    "coup": "kuːp",
    "coupled": "kʌpəld",
    "couple": "kʌpəl",
    "coupler": "kʌplɐ",
    "couples": "kʌpəlz",
    "couplet": "kʌplət",
    "couplets": "kʌpləts",
    "coupling": "kʌplɪŋ",
    "couplings": "kʌplɪŋz",
    "coupon": "kuːpɒn",
    "coupons": "kuːpɒnz",
    "coups": "kuːps",
    "courage": "kʌrɪdʒ",
    "courageous": "kʌreɪdʒəs",
    "courageously": "kʌreɪdʒəsli",
    "courageousness": "kʌreɪdʒəsnəs",
    "courante": "kɜːrɑːnteɪ",
    "courgette": "kɜːdʒɛt",
    "courgettes": "kɜːdʒɛts",
    "couriered": "kɜːriəd",
    "couriering": "kɜːriərɪŋ",
    "courier": "kɜːrɪɐ",
    "couriers": "kɜːriəz",
    "coursed": "kɔːsd",
    "course": "kɔːs",
    "courser": "kɔːsɐ",
    "coursers": "kɔːsəz",
    "courses": "kɔːsɪz",
    "coursework": "kɔːswɜːk",
    "coursing": "kɔːsɪŋ",
    "courted": "kɔːtɪd",
    "courteous": "kɜːtiəs",
    "courteously": "kɜːtiəsli",
    "courter": "kɜːtɐ",
    "courtesan": "kɔːtɪzən",
    "courtesans": "kɔːtɪzənz",
    "courtesies": "kɜːtəsɪz",
    "courtesy": "kɜːtəsi",
    "courthouse": "kɔːthaʊs",
    "courtier": "kɔːtɪɐ",
    "courtiers": "kɔːtiəz",
    "courting": "kɔːtɪŋ",
    "court": "kɔːt",
    "courtliness": "kɔːtlinəs",
    "courtly": "kɔːtli",
    "courtroom": "kɔːtruːm",
    "courtrooms": "kɔːtruːmz",
    "courtship": "kɔːtʃɪp",
    "courtships": "kɔːtʃɪps",
    "courts": "kɔːts",
    "courtyard": "kɔːtjɑːd",
    "courtyards": "kɔːtjɑːdz",
    "couscous": "kuːskuːs",
    "cousin": "kʌzən",
    "cousins": "kʌzənz",
    "couteau": "kaʊtəʊ",
    "couthie": "kuːθi",
    "couth": "kuːθ",
    "couture": "kuːtɔː",
    "couturier": "kaʊtʃərɪɐ",
    "couturiers": "kaʊtʃəriəz",
    "covalent": "kəʊveɪlənt",
    "covalently": "kəʊveɪləntli",
    "cove": "kəʊv",
    "covenanted": "kʌvənəntɪd",
    "covenanter": "kʌvənəntɐ",
    "covenanting": "kʌvənəntɪŋ",
    "covenant": "kʌvənənt",
    "covenants": "kʌvənənts",
    "coven": "kʌvən",
    "covens": "kʌvənz",
    "coverage": "kʌvərɪdʒ",
    "coverages": "kʌvərɪdʒɪz",
    "coverall": "kʌvərɔːl",
    "coveralls": "kʌvərɔːlz",
    "covered": "kʌvəd",
    "covering": "kʌvərɪŋ",
    "coverings": "kʌvərɪŋz",
    "cover": "kʌvɐ",
    "coverlet": "kʌvələt",
    "coverlets": "kʌvələts",
    "covers": "kʌvəz",
    "covert": "kəʊvɜːt",
    "covertly": "kəʊvɜːtli",
    "coverts": "kəʊvɜːts",
    "coverup": "kʌvərʌp",
    "coves": "kəʊvz",
    "coveted": "kʌvɪtɪd",
    "coveting": "kʌvɪtɪŋ",
    "covet": "kʌvɪt",
    "covetous": "kʌvətəs",
    "covetously": "kʌvətəsli",
    "covetousness": "kʌvətəsnəs",
    "covets": "kʌvɪts",
    "cowardice": "kaʊədɪs",
    "coward": "kaʊəd",
    "cowardly": "kaʊədli",
    "cowards": "kaʊədz",
    "cowbell": "kaʊbɛl",
    "cowbells": "kaʊbɛlz",
    "cowberry": "kaʊbəri",
    "cowbirds": "kaʊbɜːdz",
    "cowboy": "kaʊbɔɪ",
    "cowboys": "kaʊbɔɪz",
    "cowcatcher": "kaʊkætʃɐ",
    "cowed": "kaʊd",
    "cowered": "kaʊəd",
    "cowering": "kaʊərɪŋ",
    "cower": "kaʊɐ",
    "cowers": "kaʊəz",
    "cowgirl": "kaʊɡɜːl",
    "cowgirls": "kaʊɡɜːlz",
    "cowhand": "kaʊhænd",
    "cowhands": "kaʊhændz",
    "cowherd": "kaʊhɜːd",
    "cowhide": "kaʊhaɪd",
    "cow": "kaʊ",
    "cowled": "kaʊld",
    "cowlick": "kaʊlɪk",
    "cowling": "kaʊlɪŋ",
    "cowl": "kaʊl",
    "cowls": "kaʊlz",
    "cowman": "kaʊmən",
    "cowpat": "kaʊpæt",
    "cowpats": "kaʊpæts",
    "cowpoke": "kaʊpəʊk",
    "cowpokes": "kaʊpəʊks",
    "cowpox": "kaʊpɒks",
    "cowrie": "kaʊri",
    "cowries": "kaʊrɪz",
    "cowry": "kaʊri",
    "cowshed": "kaʊʃɛd",
    "cowsheds": "kaʊʃɛdz",
    "cows": "kaʊz",
    "cowslip": "kaʊslɪp",
    "cowslips": "kaʊslɪps",
    "coxcomb": "kɒkskəʊm",
    "coxed": "kɒkst",
    "coxes": "kɒksɪz",
    "coxing": "kɒksɪŋ",
    "cox": "kɒks",
    "coxswain": "kɒkssweɪn",
    "coy": "kɔɪ",
    "coyly": "kɔɪli",
    "coyness": "kɔɪnəs",
    "coyote": "kaɪəʊti",
    "coyotes": "kaɪəʊtiz",
    "coypu": "kɔɪpuː",
    "cozenage": "kəʊznɪdʒ",
    "cozen": "kəʊzən",
    "cozens": "kəʊzənz",
    "coz": "kɒz",
    "crabber": "kræbɐ",
    "crabbers": "kræbəz",
    "crabbiness": "kræbɪnəs",
    "crabbing": "kræbɪŋ",
    "crabby": "kræbi",
    "crab": "kræb",
    "crabs": "kræbz",
    "crackdown": "krækdaʊn",
    "crackdowns": "krækdaʊnz",
    "cracked": "krækt",
    "crackerjack": "krækədʒæk",
    "cracker": "krækɐ",
    "crackers": "krækəz",
    "crackhead": "krækhɛd",
    "crackheads": "krækhɛdz",
    "cracking": "krækɪŋ",
    "crack": "kræk",
    "crackled": "krækəld",
    "crackle": "krækəl",
    "crackles": "krækəlz",
    "crackleware": "krækluːeə",
    "crackling": "kræklɪŋ",
    "crackly": "krækli",
    "cracknel": "kræknəl",
    "crackpot": "krækpɒt",
    "crackpots": "krækpɒts",
    "cracks": "kræks",
    "cradled": "kreɪdəld",
    "cradle": "kreɪdəl",
    "cradles": "kreɪdəlz",
    "cradling": "kreɪdlɪŋ",
    "crafted": "krɑːftɪd",
    "craftier": "krɑːftɪɐ",
    "craftiest": "krɑːftɪəst",
    "craftily": "krɑːftɪli",
    "craftiness": "krɑːftɪnəs",
    "crafting": "krɑːftɪŋ",
    "craft": "krɑːft",
    "crafts": "krɑːfts",
    "craftsman": "krɑːftsmən",
    "craftsmanship": "krɑːftsmənʃɪp",
    "craftsmen": "krɑːftsmɛn",
    "craftspeople": "krɑːftspiːpəl",
    "craftsperson": "krɑːftspəsən",
    "craftswomen": "krɑːftswɪmɪn",
    "craftwork": "krɑːftwɜːk",
    "crafty": "krɑːfti",
    "craggy": "kræɡi",
    "crag": "kræɡ",
    "crags": "kræɡz",
    "crake": "kreɪk",
    "cram": "kræm",
    "crammed": "kræmd",
    "crammer": "kræmɐ",
    "crammers": "kræməz",
    "cramming": "kræmɪŋ",
    "cramped": "kræmpt",
    "cramping": "kræmpɪŋ",
    "cramp": "kræmp",
    "crampon": "kræmpɒn",
    "crampons": "kræmpɒnz",
    "cramps": "kræmps",
    "crams": "kræmz",
    "cranage": "krænɪdʒ",
    "cranberries": "krænbərɪz",
    "cranberry": "krænbəri",
    "craned": "kreɪnd",
    "crane": "kreɪn",
    "cranes": "kreɪnz",
    "crania": "kreɪniɐ",
    "cranial": "kreɪnɪəl",
    "craning": "kreɪnɪŋ",
    "craniotomy": "krænɪɒtəmi",
    "cranium": "kræniəm",
    "craniums": "kræniəmz",
    "crankcase": "kræŋkkeɪs",
    "cranked": "kræŋkt",
    "cranking": "kræŋkɪŋ",
    "crank": "kræŋk",
    "crankshaft": "kræŋkʃɑːft",
    "cranks": "kræŋks",
    "cranky": "kræŋki",
    "crannies": "krænɪz",
    "crannog": "krænɒɡ",
    "cranny": "kræni",
    "crap": "kræp",
    "crapped": "kræpt",
    "crapper": "kræpɐ",
    "crappers": "kræpəz",
    "crappiest": "kræpɪəst",
    "crapping": "kræpɪŋ",
    "crappy": "kræpi",
    "craps": "kræps",
    "crapy": "kreɪpi",
    "craquelure": "krækwɪlɔː",
    "crashed": "kræʃt",
    "crasher": "kræʃɐ",
    "crashers": "kræʃəz",
    "crashes": "kræʃɪz",
    "crashing": "kræʃɪŋ",
    "crash": "kræʃ",
    "crass": "krɑːs",
    "crassly": "krɑːsli",
    "crassness": "krɑːsnəs",
    "crated": "kreɪtɪd",
    "crate": "kreɪt",
    "cratered": "kreɪtəd",
    "cratering": "kreɪtərɪŋ",
    "crater": "kreɪtɐ",
    "craters": "kreɪtəz",
    "crates": "kreɪts",
    "crating": "kreɪtɪŋ",
    "cravat": "krævæt",
    "cravats": "krævæts",
    "craved": "kreɪvd",
    "crave": "kreɪv",
    "craven": "kreɪvən",
    "cravens": "kreɪvənz",
    "craves": "kreɪvz",
    "craving": "kreɪvɪŋ",
    "cravings": "kreɪvɪŋz",
    "crawfish": "krɔːfɪʃ",
    "craw": "krɔː",
    "crawled": "krɔːld",
    "crawler": "krɔːlɐ",
    "crawlers": "krɔːləz",
    "crawlies": "krɔːliz",
    "crawling": "krɔːlɪŋ",
    "crawl": "krɔːl",
    "crawls": "krɔːlz",
    "crawly": "krɔːli",
    "crayfish": "kreɪfɪʃ",
    "crayon": "kreɪɒn",
    "crayons": "kreɪɒnz",
    "crazed": "kreɪzd",
    "craze": "kreɪz",
    "crazes": "kreɪzɪz",
    "crazier": "kreɪzɪɐ",
    "crazies": "kreɪzɪz",
    "craziest": "kreɪzɪəst",
    "crazily": "kreɪzɪli",
    "craziness": "kreɪzɪnəs",
    "crazing": "kreɪzɪŋ",
    "crazy": "kreɪzi",
    "creaked": "kriːkt",
    "creaking": "kriːkɪŋ",
    "creak": "kriːk",
    "creaks": "kriːks",
    "creaky": "kriːki",
    "creamed": "kriːmd",
    "creamer": "kriːmɐ",
    "creamers": "kriːməz",
    "creamery": "kriːməri",
    "creamier": "kriːmɪɐ",
    "creamiest": "kriːmɪəst",
    "creaminess": "kriːmɪnəs",
    "creaming": "kriːmɪŋ",
    "cream": "kriːm",
    "creams": "kriːmz",
    "creamy": "kriːmi",
    "creased": "kriːsd",
    "crease": "kriːs",
    "creases": "kriːsɪz",
    "creasing": "kriːsɪŋ",
    "creatable": "kriːeɪtəbəl",
    "created": "kriːeɪtɪd",
    "create": "kriːeɪt",
    "creates": "kriːeɪts",
    "creatine": "kriːeɪtiːn",
    "creating": "kriːeɪtɪŋ",
    "creatinine": "kriːeɪtɪnaɪn",
    "creationism": "kriːeɪʃənɪzəm",
    "creationist": "kriːeɪʃənɪst",
    "creationists": "kriːeɪʃənɪsts",
    "creation": "kriːeɪʃən",
    "creations": "kriːeɪʃənz",
    "creative": "kriːeɪtɪv",
    "creatively": "kriːeɪtɪvli",
    "creativeness": "kriːeɪtɪvnəs",
    "creatives": "kriːeɪtɪvz",
    "creativity": "kriːeɪtɪvɪti",
    "creator": "kriːeɪtɐ",
    "creators": "kriːeɪtəz",
    "creature": "kriːtʃɐ",
    "creatures": "kriːtʃəz",
    "credence": "krɛdəns",
    "credential": "krɪdɛnʃəl",
    "credentials": "krɪdɛnʃəlz",
    "credenza": "krɪdɛnzɐ",
    "credibility": "krɛdɪbɪlɪti",
    "credible": "krɛdɪbəl",
    "credibly": "krɛdɪbli",
    "creditability": "krɛdɪtəbɪlɪti",
    "creditable": "krɛdɪtəbəl",
    "creditably": "krɛdɪtəbli",
    "credited": "krɛdɪtɪd",
    "crediting": "krɛdɪtɪŋ",
    "credit": "krɛdɪt",
    "creditor": "krɛdɪtɐ",
    "creditors": "krɛdɪtəz",
    "credits": "krɛdɪts",
    "creditworthiness": "krɛdɪtwɜːðɪnəs",
    "creditworthy": "krɛdɪtwɜːði",
    "cred": "krɛd",
    "credo": "kriːdəʊ",
    "credos": "kriːdəʊz",
    "credulity": "krɛdjʊlɪti",
    "credulous": "krɛdjʊləs",
    "creed": "kriːd",
    "creeds": "kriːdz",
    "cree": "kriː",
    "creek": "kriːk",
    "creeks": "kriːks",
    "creel": "kriːl",
    "creels": "kriːlz",
    "creeper": "kriːpɐ",
    "creepers": "kriːpəz",
    "creepier": "kriːpɪɐ",
    "creepiest": "kriːpɪəst",
    "creepily": "kriːpɪli",
    "creepiness": "kriːpɪnəs",
    "creeping": "kriːpɪŋ",
    "creep": "kriːp",
    "creeps": "kriːps",
    "creepy": "kriːpi",
    "crees": "kriːz",
    "cremated": "krɪmeɪtɪd",
    "cremate": "krɪmeɪt",
    "cremating": "krɪmeɪtɪŋ",
    "cremation": "krɪmeɪʃən",
    "cremations": "krɪmeɪʃənz",
    "crematoria": "krɪmɐtɔːriə",
    "crematorium": "krɪmɐtɔːriəm",
    "crematoriums": "krɪmɐtɔːriəmz",
    "creme": "kriːm",
    "cremes": "kriːmz",
    "crenellated": "krɛnɪleɪtɪd",
    "crenellations": "krɛnɪleɪʃənz",
    "crenshaw": "krɛnʃɔː",
    "crenulated": "krɛnjʊleɪtɪd",
    "creole": "krɪəʊl",
    "creosote": "krɪɒsəʊt",
    "crepe": "kreɪp",
    "crepes": "kreɪps",
    "crepey": "krɛpi",
    "crept": "krɛpt",
    "crepuscular": "krɛpʌskjʊlɐ",
    "crescendo": "krəʃɛndəʊ",
    "crescendos": "krəʃɛndəʊz",
    "crescent": "krɛsənt",
    "crescents": "krɛsənts",
    "cress": "krɛs",
    "crested": "krɛstɪd",
    "crestfallen": "krɛstfɔːlən",
    "cresting": "krɛstɪŋ",
    "crest": "krɛst",
    "crests": "krɛsts",
    "cretaceous": "krɛteɪʃəs",
    "cretin": "krɛtɪn",
    "cretinous": "krɛtɪnəs",
    "cretins": "krɛtɪnz",
    "crevasse": "krəvæs",
    "crevasses": "krɛvəsɪz",
    "crevice": "krɛvɪs",
    "crevices": "krɛvɪsɪz",
    "crewed": "kruːd",
    "crewel": "krɛwəl",
    "crewelwork": "krɛwəlwɜːk",
    "crewing": "kruːɪŋ",
    "crew": "kruː",
    "crewman": "kruːmən",
    "crewmate": "kruːmeɪt",
    "crewmen": "kruːmɛn",
    "crews": "kruːz",
    "cribbage": "krɪbɪdʒ",
    "cribbed": "krɪbd",
    "cribbing": "krɪbɪŋ",
    "crib": "krɪb",
    "cribs": "krɪbz",
    "cricked": "krɪkt",
    "cricketer": "krɪkɛtɐ",
    "cricketers": "krɪkɛtəz",
    "cricketing": "krɪkɪtɪŋ",
    "cricket": "krɪkɪt",
    "crickets": "krɪkɪts",
    "cricking": "krɪkɪŋ",
    "crick": "krɪk",
    "cricks": "krɪks",
    "cricoid": "krɪkɔɪd",
    "cried": "kraɪd",
    "crier": "kraɪə",
    "criers": "kraɪəz",
    "cries": "kraɪz",
    "crikey": "kraɪki",
    "crime": "kraɪm",
    "crimes": "kraɪmz",
    "criminalisation": "krɪmɪnəlaɪzeɪʃən",
    "criminalised": "krɪmɪnəlaɪzd",
    "criminalise": "krɪmɪnəlaɪz",
    "criminalises": "krɪmɪnəlaɪzɪz",
    "criminalising": "krɪmɪnəlaɪzɪŋ",
    "criminality": "krɪmɪnælɪti",
    "criminal": "krɪmɪnəl",
    "criminally": "krɪmɪnəli",
    "criminals": "krɪmɪnəlz",
    "criminologist": "krɪmɪnɒlədʒɪst",
    "criminologists": "krɪmɪnɒlədʒɪsts",
    "criminology": "krɪmɪnɒlədʒi",
    "crimped": "krɪmpt",
    "crimper": "krɪmpɐ",
    "crimpers": "krɪmpəz",
    "crimping": "krɪmpɪŋ",
    "crimp": "krɪmp",
    "crimple": "krɪmpəl",
    "crimps": "krɪmps",
    "crimson": "krɪmsən",
    "crimsons": "krɪmsənz",
    "cringed": "krɪndʒd",
    "cringe": "krɪndʒ",
    "cringes": "krɪndʒɪz",
    "cringing": "krɪndʒɪŋ",
    "cringle": "krɪŋɡəl",
    "crinkled": "krɪŋkəld",
    "crinkle": "krɪŋkəl",
    "crinkles": "krɪŋkəlz",
    "crinkling": "krɪŋklɪŋ",
    "crinkly": "krɪŋkli",
    "crinoline": "krɪnəliːn",
    "crinolines": "krɪnəliːnz",
    "criollo": "krɪɒləʊ",
    "cripes": "kraɪps",
    "crippled": "krɪpəld",
    "cripple": "krɪpəl",
    "crippler": "krɪplɐ",
    "cripples": "krɪpəlz",
    "crippling": "krɪplɪŋ",
    "cripplingly": "krɪpəlɪŋli",
    "crises": "kraɪsiːz",
    "crisis": "kraɪsɪs",
    "crispbread": "krɪspbrɛd",
    "crispbreads": "krɪspbrɛdz",
    "crisped": "krɪspt",
    "crisper": "krɪspɐ",
    "crispier": "krɪspɪɐ",
    "crispiest": "krɪspɪəst",
    "crispiness": "krɪspɪnəs",
    "crisping": "krɪspɪŋ",
    "crisp": "krɪsp",
    "crisply": "krɪspli",
    "crispness": "krɪspnəs",
    "crisps": "krɪsps",
    "crispy": "krɪspi",
    "crisscrossed": "krɪskrɒst",
    "crisscrossing": "krɪskrɒsɪŋ",
    "crisscross": "krɪskrɒs",
    "crista": "krɪstɐ",
    "criteria": "kraɪtiərɪɐ",
    "criterion": "kraɪtiərɪən",
    "criticality": "krɪtɪkælɪti",
    "critical": "krɪtɪkəl",
    "critically": "krɪtɪkli",
    "criticised": "krɪtɪsaɪzd",
    "criticise": "krɪtɪsaɪz",
    "criticises": "krɪtɪsaɪzɪz",
    "criticising": "krɪtɪsaɪzɪŋ",
    "criticism": "krɪtɪsɪzəm",
    "criticisms": "krɪtɪsɪzəmz",
    "critic": "krɪtɪk",
    "critics": "krɪtɪks",
    "critiqued": "krɪtiːkd",
    "critique": "krɪtiːk",
    "critiques": "krɪtiːks",
    "critiquing": "krɪtiːkɪŋ",
    "critter": "krɪtɐ",
    "critters": "krɪtəz",
    "croaked": "krəʊkt",
    "croaker": "krəʊkɐ",
    "croaking": "krəʊkɪŋ",
    "croak": "krəʊk",
    "croaks": "krəʊks",
    "croaky": "krəʊki",
    "crocheted": "krəʊʃeɪɪd",
    "crocheter": "krɒtʃɛtɐ",
    "crocheting": "krɒtʃɪtɪŋ",
    "crochet": "krəʊʃeɪ",
    "crochets": "krəʊʃeɪs",
    "crocked": "krɒkt",
    "crockery": "krɒkəri",
    "crocket": "krɒkɪt",
    "crockets": "krɒkɪts",
    "crock": "krɒk",
    "crocks": "krɒks",
    "crocodile": "krɒkədaɪl",
    "crocodiles": "krɒkədaɪlz",
    "crocodilian": "krɒkədɪliən",
    "crocodilians": "krɒkədɪliənz",
    "crocuses": "krəʊkəsɪz",
    "crocus": "krəʊkəs",
    "crofter": "krɒftɐ",
    "crofters": "krɒftəz",
    "crofting": "krɒftɪŋ",
    "croft": "krɒft",
    "crofts": "krɒfts",
    "croissant": "kwɑːsɑ̃",
    "croissants": "kwɑːsɑ̃s",
    "cromlech": "krɒmlɛtʃ",
    "cromlechs": "krɒmlɛtʃz",
    "crone": "krəʊn",
    "crones": "krəʊnz",
    "cronies": "krəʊnɪz",
    "cronk": "krɒŋk",
    "cronyism": "krəʊnɪɪzəm",
    "crony": "krəʊni",
    "crookedly": "krʊkɪdli",
    "crookedness": "krʊkɪdnəs",
    "crooking": "krʊkɪŋ",
    "crook": "krʊk",
    "crooks": "krʊks",
    "crooned": "kruːnd",
    "crooner": "kruːnɐ",
    "crooners": "kruːnəz",
    "crooning": "kruːnɪŋ",
    "croon": "kruːn",
    "croons": "kruːnz",
    "crop": "krɒp",
    "cropped": "krɒpt",
    "cropper": "krɒpɐ",
    "croppers": "krɒpəz",
    "cropping": "krɒpɪŋ",
    "crops": "krɒps",
    "croquet": "krɒkeɪ",
    "croquette": "krəkɛt",
    "croquettes": "krəkɛts",
    "crosier": "krəʊzɪɐ",
    "crosiers": "krəʊsiəz",
    "crossbar": "krɒsbɑː",
    "crossbars": "krɒsbɑːz",
    "crossbeams": "krɒsbiːmz",
    "crossbill": "krɒsbɪl",
    "crossbills": "krɒsbɪlz",
    "crossbones": "krɒsbəʊnz",
    "crossbow": "krɒsbəʊ",
    "crossbows": "krɒsbəʊz",
    "crossbred": "krɒsbrɛd",
    "crossbreeding": "krɒsbriːdɪŋ",
    "crossbreed": "krɒsbriːd",
    "crossbreeds": "krɒsbriːdz",
    "crosscheck": "krɒstʃɛk",
    "crossed": "krɒst",
    "crosse": "krɒs",
    "crosser": "krɒsɐ",
    "crosses": "krɒsɪz",
    "crossest": "krɒsəst",
    "crossfire": "krɒsfaɪə",
    "crosshair": "krɒsheə",
    "crosshatched": "krɒshætʃt",
    "crosshatches": "krɒshætʃɪz",
    "crosshatching": "krɒshætʃɪŋ",
    "crosshatch": "krɒshætʃ",
    "crosshead": "krɒshɛd",
    "crossing": "krɒsɪŋ",
    "crossings": "krɒsɪŋz",
    "cross": "krɒs",
    "crossly": "krɒsli",
    "crossness": "krɒsnəs",
    "crossover": "krɒsəʊvɐ",
    "crossovers": "krɒsəʊvəz",
    "crosspatch": "krɒspætʃ",
    "crosspieces": "krɒspiːsɪz",
    "crossroad": "krɒsrəʊd",
    "crossroads": "krɒsrəʊdz",
    "crosstalk": "krɒstɔːk",
    "crosstown": "krɒstaʊn",
    "crosswalk": "krɒswɔːk",
    "crossway": "krɒsweɪ",
    "crossways": "krɒsweɪz",
    "crosswind": "krɒswɪnd",
    "crosswinds": "krɒswɪndz",
    "crosswise": "krɒswaɪz",
    "crossword": "krɒswɜːd",
    "crosswords": "krɒswɜːdz",
    "crotchet": "krɒtʃɪt",
    "crotchets": "krɒtʃɪts",
    "crotchety": "krɒtʃɪti",
    "crotch": "krɒtʃ",
    "croton": "krəʊtən",
    "crouched": "kraʊtʃt",
    "crouches": "kraʊtʃɪz",
    "crouching": "kraʊtʃɪŋ",
    "crouch": "kraʊtʃ",
    "croupier": "kruːpɪɐ",
    "croupiers": "kruːpiəz",
    "croup": "kruːp",
    "croupy": "kruːpi",
    "crouse": "kraʊs",
    "crowbar": "krəʊbɑː",
    "crowbars": "krəʊbɑːz",
    "crowberries": "krəʊbərɪz",
    "crowberry": "krəʊbəri",
    "crowded": "kraʊdɪd",
    "crowding": "kraʊdɪŋ",
    "crowd": "kraʊd",
    "crowds": "kraʊdz",
    "crowed": "krəʊd",
    "crowfoot": "krəʊfʊt",
    "crowing": "krəʊɪŋ",
    "crow": "krəʊ",
    "crowned": "kraʊnd",
    "crowning": "kraʊnɪŋ",
    "crown": "kraʊn",
    "crowns": "kraʊnz",
    "crows": "krəʊz",
    "crozier": "krəʊzɪɐ",
    "croziers": "krəʊziəz",
    "cruces": "kruːsɪz",
    "crucial": "kruːʃəl",
    "crucially": "kruːʃəli",
    "cruciate": "kruːʃɪeɪt",
    "crucible": "kruːsəbəl",
    "crucibles": "kruːsəbəlz",
    "crucifer": "kruːsɪfɐ",
    "crucified": "kruːsɪfaɪd",
    "crucifies": "kruːsɪfaɪz",
    "crucifixes": "kruːsɪfɪksɪz",
    "crucifixion": "kruːsɪfɪkʃən",
    "crucifixions": "kruːsɪfɪkʃənz",
    "crucifix": "kruːsɪfɪks",
    "cruciform": "kruːsɪfɔːm",
    "crucifying": "kruːsɪfaɪɪŋ",
    "crucify": "kruːsɪfaɪ",
    "cruck": "krʌk",
    "cruddy": "krʌdi",
    "crude": "kruːd",
    "crudely": "kruːdli",
    "crudeness": "kruːdnəs",
    "cruder": "kruːdɐ",
    "crudest": "kruːdəst",
    "crudities": "kruːdɪtiz",
    "crudity": "kruːdɪti",
    "crud": "krʌd",
    "cruelest": "kruːələst",
    "cruel": "kruːəl",
    "crueller": "kruːəlɐ",
    "cruellest": "kruːələst",
    "cruelly": "kruːəli",
    "cruelties": "kruːəltɪz",
    "cruelty": "kruːəlti",
    "cruet": "kruːt",
    "cruets": "kruːts",
    "cruised": "kruːzd",
    "cruise": "kruːz",
    "cruiser": "kruːzɐ",
    "cruisers": "kruːzəz",
    "cruiserweight": "kruːzəweɪt",
    "cruises": "kruːzɪz",
    "cruising": "kruːzɪŋ",
    "cru": "kruː",
    "crullers": "krʌləz",
    "crumbed": "krʌmd",
    "crumbing": "krʌmɪŋ",
    "crumb": "krʌm",
    "crumbled": "krʌmbəld",
    "crumble": "krʌmbəl",
    "crumbles": "krʌmbəlz",
    "crumbliest": "krʌmblɪəst",
    "crumbliness": "krʌmblɪnəs",
    "crumbling": "krʌmblɪŋ",
    "crumbly": "krʌmbli",
    "crumbs": "krʌmz",
    "crumby": "krʌmbi",
    "crumhorn": "krʌmhɔːn",
    "crummiest": "krʌmɪəst",
    "crummy": "krʌmi",
    "crumpet": "krʌmpɪt",
    "crumpets": "krʌmpɪts",
    "crumping": "krʌmpɪŋ",
    "crump": "krʌmp",
    "crumpled": "krʌmpəld",
    "crumple": "krʌmpəl",
    "crumples": "krʌmpəlz",
    "crumpling": "krʌmplɪŋ",
    "crunched": "krʌntʃt",
    "cruncher": "krʌntʃɐ",
    "crunchers": "krʌntʃəz",
    "crunches": "krʌntʃɪz",
    "crunchier": "krʌntʃɪɐ",
    "crunchiest": "krʌntʃɪəst",
    "crunchiness": "krʌntʃɪnəs",
    "crunching": "krʌntʃɪŋ",
    "crunch": "krʌntʃ",
    "crunchy": "krʌntʃi",
    "crusaded": "kruːseɪdɪd",
    "crusade": "kruːseɪd",
    "crusader": "kruːseɪdɐ",
    "crusaders": "kruːseɪdəz",
    "crusades": "kruːseɪdz",
    "crusading": "kruːseɪdɪŋ",
    "cruse": "kruːs",
    "crushed": "krʌʃt",
    "crusher": "krʌʃɐ",
    "crushers": "krʌʃəz",
    "crushes": "krʌʃɪz",
    "crushing": "krʌʃɪŋ",
    "crushingly": "krʌʃɪŋli",
    "crush": "krʌʃ",
    "crus": "kruːz",
    "crustacean": "krʌsteɪʃən",
    "crustaceans": "krʌsteɪʃənz",
    "crustaceous": "krʌsteɪʃəs",
    "crusted": "krʌstɪd",
    "crustiness": "krʌstɪnəs",
    "crusting": "krʌstɪŋ",
    "crust": "krʌst",
    "crusts": "krʌsts",
    "crusty": "krʌsti",
    "crutches": "krʌtʃɪz",
    "crutch": "krʌtʃ",
    "crux": "krʌks",
    "crwth": "siːɑːdʌbəljuːtiːeɪtʃ",
    "crybaby": "kraɪbeɪbi",
    "cryer": "kraɪɐ",
    "crying": "kraɪɪŋ",
    "cry": "kraɪ",
    "cryogenically": "kraɪəʊdʒɛnɪkli",
    "cryogenic": "kraɪəʊdʒɛnɪk",
    "cryogenics": "kraɪəʊdʒɛnɪks",
    "cryolite": "kraɪəlaɪt",
    "cryonic": "kraɪɒnɪk",
    "cryonics": "kraɪɒnɪks",
    "cryostat": "kraɪəstæt",
    "cryotherapy": "kraɪəʊθɛrəpi",
    "cryptically": "krɪptɪkli",
    "cryptic": "krɪptɪk",
    "crypt": "krɪpt",
    "cryptogram": "krɪptəɡræm",
    "cryptographer": "krɪptɒɡrəfɐ",
    "cryptographers": "krɪptɒɡrəfəz",
    "cryptographic": "krɪptəɡræfɪk",
    "cryptography": "krɪptɒɡrəfi",
    "cryptology": "krɪptɒlədʒi",
    "cryptomeria": "krɪptəʊmiərɪɐ",
    "crypts": "krɪpts",
    "crystal": "krɪstəl",
    "crystalline": "krɪstɐlaɪn",
    "crystallisation": "krɪstɐlaɪzeɪʃən",
    "crystallised": "krɪstɐlaɪzd",
    "crystallise": "krɪstɐlaɪz",
    "crystallises": "krɪstɐlaɪzɪz",
    "crystallising": "krɪstɐlaɪzɪŋ",
    "crystallographer": "krɪstɐlɒɡrəfɐ",
    "crystallography": "krɪstɐlɒɡrəfi",
    "crystals": "krɪstəlz",
    "csc": "siːɛssiː",
    "c": "siː",
    "cs": "siːɛs",
    "cubbies": "kʌbɪz",
    "cubbyhole": "kʌbɪhəʊl",
    "cubbyholes": "kʌbɪhəʊlz",
    "cubby": "kʌbi",
    "cubebs": "kjuːbɛbz",
    "cubed": "kjuːbd",
    "cubes": "kjuːbz",
    "cubical": "kjuːbɪkəl",
    "cubic": "kjuːbɪk",
    "cubicle": "kjuːbɪkəl",
    "cubicles": "kjuːbɪkəlz",
    "cubing": "kjuːbɪŋ",
    "cubism": "kjuːbɪzəm",
    "cubistic": "kjuːbɪstɪk",
    "cubist": "kjuːbɪst",
    "cubists": "kjuːbɪsts",
    "cubit": "kjuːbɪt",
    "cubits": "kjuːbɪts",
    "cub": "kʌb",
    "cuboid": "kjuːbɔɪd",
    "cubs": "kʌbz",
    "cuckolded": "kʌkəʊldɪd",
    "cuckolding": "kʌkəʊldɪŋ",
    "cuckold": "kʌkəʊld",
    "cuckolds": "kʌkəʊldz",
    "cuckoo": "kʊkuː",
    "cuckoos": "kʊkuːz",
    "cucumber": "kjuːkʌmbɐ",
    "cucumbers": "kjuːkʌmbəz",
    "cuddled": "kʌdəld",
    "cuddle": "kʌdəl",
    "cuddles": "kʌdəlz",
    "cuddlesome": "kʌdəlsʌm",
    "cuddlier": "kʌdliɐ",
    "cuddliest": "kʌdliəst",
    "cuddling": "kʌdlɪŋ",
    "cuddly": "kʌdli",
    "cuddy": "kʌdi",
    "cudgel": "kʌdʒəl",
    "cudgels": "kʌdʒəlz",
    "cud": "kʌd",
    "cued": "kjuːd",
    "cueing": "kjuːɪŋ",
    "cue": "kjuː",
    "cues": "kjuːz",
    "cuesta": "kjuːstɐ",
    "cuffed": "kʌft",
    "cuffing": "kʌfɪŋ",
    "cuff": "kʌf",
    "cufflink": "kʌflɪŋk",
    "cufflinks": "kʌflɪŋks",
    "cuffs": "kʌfs",
    "cuing": "kjuːɪŋ",
    "cuirass": "kwɪræs",
    "cuisine": "kwɪziːn",
    "cuisines": "kwɪziːnz",
    "cuisses": "kwɪzzɪz",
    "culinary": "kjʊlɪnəri",
    "culled": "kʌld",
    "cullet": "kʌlɪt",
    "culling": "kʌlɪŋ",
    "cullis": "kʌliz",
    "cull": "kʌl",
    "culls": "kʌlz",
    "cully": "kʌli",
    "culminated": "kʌlmɪneɪtɪd",
    "culminate": "kʌlmɪneɪt",
    "culminates": "kʌlmɪneɪts",
    "culminating": "kʌlmɪneɪtɪŋ",
    "culmination": "kʌlmɪneɪʃən",
    "culm": "kʌlm",
    "culottes": "kjʊlɒts",
    "culpability": "kʌlpəbɪlɪti",
    "culpable": "kʌlpəbəl",
    "culpably": "kʌlpəbli",
    "culpa": "kʌlpɐ",
    "culprit": "kʌlprɪt",
    "culprits": "kʌlprɪts",
    "cultic": "kʌltɪk",
    "cultish": "kʌltɪʃ",
    "cultism": "kʌltɪzəm",
    "cultist": "kʌltɪst",
    "cultivar": "kʌltɪvɑː",
    "cultivars": "kʌltɪvɑːz",
    "cultivated": "kʌltɪveɪtɪd",
    "cultivate": "kʌltɪveɪt",
    "cultivates": "kʌltɪveɪts",
    "cultivating": "kʌltɪveɪtɪŋ",
    "cultivation": "kʌltɪveɪʃən",
    "cultivations": "kʌltɪveɪʃənz",
    "cultivator": "kʌltɪveɪtɐ",
    "cultivators": "kʌltɪveɪtəz",
    "cult": "kʌlt",
    "cults": "kʌlts",
    "cultural": "kʌltʃərəl",
    "culturally": "kʌltʃərəli",
    "cultured": "kʌltʃəd",
    "culture": "kʌltʃɐ",
    "cultures": "kʌltʃəz",
    "culturing": "kʌltʃərɪŋ",
    "culver": "kʌlvɐ",
    "culvert": "kʌlvɜːt",
    "culverts": "kʌlvɜːts",
    "cumbered": "kʌmbəd",
    "cumber": "kʌmbɐ",
    "cumbersome": "kʌmbəsʌm",
    "cumin": "kjuːmɪn",
    "cummerbund": "kʌməbʌnd",
    "cumming": "kʌmɪŋ",
    "cumquat": "kʌmkwæt",
    "cumulation": "kjuːmjʊleɪʃən",
    "cumulative": "kjuːmjʊlətɪv",
    "cumulatively": "kjuːmjʊlətɪvli",
    "cumulonimbus": "kjuːmjʊlɒnɪmbəs",
    "cumulous": "kjuːmjʊləs",
    "cumulus": "kjuːmjʊləs",
    "cuneiform": "kʌneɪfɔːm",
    "cunnilingus": "kʌnaɪlɪŋɡəs",
    "cunning": "kʌnɪŋ",
    "cunningly": "kʌnɪŋli",
    "cunt": "kʌnt",
    "cunts": "kʌnts",
    "cupbearer": "kʌpbeərɐ",
    "cupboard": "kʌbəd",
    "cupboards": "kʌbədz",
    "cupcake": "kʌpkeɪk",
    "cupcakes": "kʌpkeɪks",
    "cupful": "kʌpfəl",
    "cupfuls": "kʌpfəlz",
    "cupidity": "kjuːpɪdɪti",
    "cupid": "kjuːpɪd",
    "cupids": "kjuːpɪdz",
    "cup": "kʌp",
    "cupola": "kjuːpəʊlɐ",
    "cupolas": "kjuːpəʊləz",
    "cuppa": "kʌpɐ",
    "cuppas": "kʌpəz",
    "cupped": "kʌpt",
    "cupping": "kʌpɪŋ",
    "cupronickel": "kʌprənɪkəl",
    "cuprous": "kʌprəs",
    "cups": "kʌps",
    "curable": "kjɔːrəbəl",
    "curacy": "kjʊrəsi",
    "curare": "kjʊreə",
    "curassow": "kjʊrɐsəʊ",
    "curated": "kjɔːreɪtɪd",
    "curating": "kjɔːreɪtɪŋ",
    "curation": "kjʊreɪʃən",
    "curative": "kjʊrətɪv",
    "curatorial": "kjʊrɐtɔːrɪəl",
    "curator": "kjʊreɪtɐ",
    "curatorship": "kjʊreɪtəʃɪp",
    "curators": "kjʊreɪtəz",
    "curbed": "kɜːbd",
    "curbing": "kɜːbɪŋ",
    "curb": "kɜːb",
    "curbs": "kɜːbz",
    "curcuma": "kɜːkuːmɐ",
    "curd": "kɜːd",
    "curdled": "kɜːdəld",
    "curdle": "kɜːdəl",
    "curdles": "kɜːdəlz",
    "curdling": "kɜːdlɪŋ",
    "curds": "kɜːdz",
    "curdy": "kɜːdi",
    "cured": "kjɔːd",
    "cure": "kjɔː",
    "curer": "kjʊrɐ",
    "curers": "kjʊrəz",
    "cures": "kjɔːz",
    "curet": "kjʊrət",
    "curfew": "kɜːfjuː",
    "curfews": "kɜːfjuːz",
    "curia": "kjʊriɐ",
    "curie": "kjʊri",
    "curies": "kʌrɪz",
    "curing": "kjɔːrɪŋ",
    "curio": "kjʊrɪəʊ",
    "curiosities": "kjʊrɪɒsɪtiz",
    "curiosity": "kjʊrɪɒsɪti",
    "curios": "kjʊrɪəʊz",
    "curious": "kjʊrɪəs",
    "curiously": "kjʊrɪəsli",
    "curium": "kjʊriəm",
    "cur": "kɜː",
    "curled": "kɜːld",
    "curler": "kɜːlɐ",
    "curlers": "kɜːləz",
    "curlew": "kɜːluː",
    "curlews": "kɜːluːz",
    "curlicue": "kɜːlɪkjuː",
    "curlicues": "kɜːlɪkjuːz",
    "curlier": "kɜːliɐ",
    "curling": "kɜːlɪŋ",
    "curl": "kɜːl",
    "curls": "kɜːlz",
    "curly": "kɜːli",
    "curmudgeon": "kɜːmʌdʒən",
    "curmudgeonly": "kɜːmədʒənli",
    "curmudgeons": "kɜːmʌdʒənz",
    "currant": "kʌrənt",
    "currants": "kʌrənts",
    "currencies": "kʌrənsiz",
    "currency": "kʌrənsi",
    "current": "kʌrənt",
    "currently": "kʌrəntli",
    "currents": "kʌrənts",
    "curricula": "kʌrɪkjʊlɐ",
    "curricular": "kʌrɪkjʊlɐ",
    "curriculum": "kʌrɪkjʊləm",
    "curriculums": "kʌrɪkjʊləmz",
    "curried": "kʌrɪd",
    "currier": "kʌrɪɐ",
    "curries": "kʌrɪz",
    "currying": "kʌrɪɪŋ",
    "curry": "kʌri",
    "curse": "kɜːs",
    "curses": "kɜːsɪz",
    "cursing": "kɜːsɪŋ",
    "cursive": "kɜːsɪv",
    "curs": "kɜːz",
    "cursor": "kɜːsɐ",
    "cursory": "kɜːsəri",
    "curtailed": "kɜːteɪld",
    "curtailing": "kɜːteɪlɪŋ",
    "curtail": "kɜːteɪl",
    "curtailment": "kɜːteɪlmənt",
    "curtails": "kɜːteɪlz",
    "curtained": "kɜːtənd",
    "curtain": "kɜːtən",
    "curtains": "kɜːtənz",
    "curtilage": "kɜːtɪlɪdʒ",
    "curt": "kɜːt",
    "curtly": "kɜːtli",
    "curtseyed": "kɜːtsɪd",
    "curtseying": "kɜːtsɪɪŋ",
    "curtsey": "kɜːtsi",
    "curtseys": "kɜːtsɪz",
    "curtsied": "kɜːtsɪd",
    "curtsies": "kɜːtsɪz",
    "curtsying": "kɜːtsɪɪŋ",
    "curtsy": "kɜːtsi",
    "curvaceous": "kɜːveɪʃəs",
    "curvacious": "kɜːveɪʃəs",
    "curvature": "kɜːvətʃɐ",
    "curvatures": "kɜːvətʃəz",
    "curved": "kɜːvd",
    "curve": "kɜːv",
    "curves": "kɜːvz",
    "curvier": "kɜːvɪɐ",
    "curvilinear": "kɜːvɪlɪniə",
    "curving": "kɜːvɪŋ",
    "curvy": "kɜːvi",
    "cushiest": "kʊʃɪəst",
    "cushioned": "kʊʃənd",
    "cushioning": "kʊʃənɪŋ",
    "cushion": "kʊʃən",
    "cushions": "kʊʃənz",
    "cushiony": "kʊʃəni",
    "cushy": "kʊʃi",
    "cusped": "kʌspt",
    "cuspid": "kʌspɪd",
    "cusp": "kʌsp",
    "cusps": "kʌsps",
    "cussedness": "kʌstnəs",
    "cusses": "kʌsɪz",
    "cussing": "kʌsɪŋ",
    "cuss": "kʌs",
    "custard": "kʌstəd",
    "custards": "kʌstədz",
    "custodial": "kʌstəʊdɪəl",
    "custodian": "kʌstəʊdiən",
    "custodianship": "kʌstəʊdiənʃɪp",
    "custodians": "kʌstəʊdiənz",
    "custody": "kʌstədi",
    "customarily": "kʌstəmɛrəli",
    "customary": "kʌstəməri",
    "customer": "kʌstəmɐ",
    "customers": "kʌstəməz",
    "customisation": "kʌstəmaɪzeɪʃən",
    "customised": "kʌstəmaɪzd",
    "customise": "kʌstəmaɪz",
    "customises": "kʌstəmaɪzɪz",
    "customising": "kʌstəmaɪzɪŋ",
    "custom": "kʌstəm",
    "customs": "kʌstəmz",
    "cutaneous": "kjuːteɪniəs",
    "cutaway": "kʌtəweɪ",
    "cutaways": "kʌtəweɪz",
    "cutback": "kʌtbæk",
    "cutbacks": "kʌtbæks",
    "cutch": "kʌtʃ",
    "cute": "kjuːt",
    "cutely": "kjuːtli",
    "cuteness": "kjuːtnəs",
    "cuter": "kjuːtɐ",
    "cutest": "kjuːtəst",
    "cutesy": "kjuːtəsi",
    "cutey": "kjuːti",
    "cuticle": "kjuːtɪkəl",
    "cuticles": "kjuːtɪkəlz",
    "cutie": "kjuːti",
    "cuties": "kjuːtɪz",
    "cutis": "kjuːtiz",
    "cut": "kʌt",
    "cutlasses": "kʌtləsɪz",
    "cutlass": "kʌtləs",
    "cutler": "kʌtlɐ",
    "cutlers": "kʌtləz",
    "cutlery": "kʌtləri",
    "cutlet": "kʌtlət",
    "cutlets": "kʌtləts",
    "cutoff": "kʌtɒf",
    "cutout": "kʌtaʊt",
    "cutouts": "kʌtaʊts",
    "cuts": "kʌts",
    "cutter": "kʌtɐ",
    "cutters": "kʌtəz",
    "cutthroat": "kʌtθrəʊt",
    "cutthroats": "kʌtθrəʊts",
    "cutting": "kʌtɪŋ",
    "cuttings": "kʌtɪŋz",
    "cuttlefish": "kʌtəlfɪʃ",
    "cuttle": "kʌtəl",
    "cuttles": "kʌtəlz",
    "cutty": "kʌti",
    "cutworm": "kʌtwɜːm",
    "cuvette": "kjuːvɛt",
    "cwm": "kʊm",
    "cw": "siːdʌbəljuː",
    "cyanide": "saɪɐnaɪd",
    "cyanosis": "saɪɐnəʊsɪs",
    "cyan": "saɪæn",
    "cybernetic": "saɪbənɛtɪk",
    "cybernetics": "saɪbənɛtɪks",
    "cyberspace": "saɪbəspeɪs",
    "cyborg": "saɪbɔːɡ",
    "cyborgs": "saɪbɔːɡz",
    "cycad": "saɪkæd",
    "cycads": "saɪkædz",
    "cyclamen": "saɪkleɪmɛn",
    "cycled": "saɪkəld",
    "cycle": "saɪkəl",
    "cycles": "saɪkəlz",
    "cycleway": "saɪkəlweɪ",
    "cycleways": "saɪklweɪz",
    "cyclically": "saɪklɪkli",
    "cyclical": "saɪklɪkəl",
    "cyclic": "saɪklɪk",
    "cycling": "saɪklɪŋ",
    "cyclist": "saɪklɪst",
    "cyclists": "saɪklɪsts",
    "cycloid": "saɪklɔɪd",
    "cyclone": "saɪkləʊn",
    "cyclones": "saɪkləʊnz",
    "cyclonic": "saɪklɒnɪk",
    "cyclops": "saɪkləps",
    "cyclorama": "saɪkləræmɐ",
    "cyclotron": "saɪklətrɒn",
    "cygnet": "sɪɡnɪt",
    "cygnets": "sɪɡnɪts",
    "cylinder": "sɪlɪndɐ",
    "cylinders": "sɪlɪndəz",
    "cylindrical": "sɪlɪndrɪkəl",
    "cymbal": "sɪmbəl",
    "cymbals": "sɪmbəlz",
    "cynically": "sɪnɪkli",
    "cynical": "sɪnɪkəl",
    "cynicism": "sɪnɪsɪzəm",
    "cynic": "sɪnɪk",
    "cynics": "sɪnɪks",
    "cypher": "saɪfɐ",
    "cypresses": "saɪprəsɪz",
    "cypress": "saɪprəs",
    "cysteine": "sɪstaɪn",
    "cystic": "sɪstɪk",
    "cystitis": "sɪstaɪtɪs",
    "cysts": "sɪsts",
    "cyst": "sɪst",
    "cytology": "saɪtɒlədʒi",
    "cytoplasm": "saɪtəplæzəm",
    "cytosine": "saɪtəsaɪn",
    "cytotoxic": "saɪtətɒksɪk",
    "czardas": "tsɑːdəz",
    "czarist": "tsɑːrɪst",
    "czar": "tsɑː",
    "dabbed": "dæbd",
    "dabber": "dæbɐ",
    "dabbers": "dæbəz",
    "dabbing": "dæbɪŋ",
    "dabble": "dæbəl",
    "dabbled": "dæbəld",
    "dabbler": "dæblɐ",
    "dabblers": "dæbləz",
    "dabbles": "dæbəlz",
    "dabbling": "dæblɪŋ",
    "dabchick": "dæbtʃɪk",
    "dab": "dæb",
    "dabs": "dæbz",
    "dace": "deɪs",
    "dacha": "dætʃɐ",
    "dachas": "dætʃəz",
    "dachshund": "dætʃʃʌnd",
    "dachshunds": "dætʃʃʌndz",
    "dactyl": "dæktaɪl",
    "dada": "dɑːdɐ",
    "dadaism": "dædeɪɪzəm",
    "dadaist": "dædeɪɪst",
    "dadaists": "dædeɪɪsts",
    "dadas": "dɑːdəz",
    "dad": "dæd",
    "daddies": "dædɪz",
    "daddy": "dædi",
    "dado": "dɑːdəʊ",
    "dadoes": "dɑːdəʊz",
    "dads": "dædz",
    "daemon": "diːmən",
    "daemonic": "diːmɒnɪk",
    "daff": "dæf",
    "daffodil": "dæfədɪl",
    "daffodils": "dæfədɪlz",
    "daffy": "dæfi",
    "daft": "dɑːft",
    "dafter": "dɑːftɐ",
    "daftest": "dɑːftəst",
    "daftness": "dɑːftnəs",
    "dag": "dæɡ",
    "dagger": "dæɡɐ",
    "daggers": "dæɡəz",
    "dago": "deɪɡəʊ",
    "dags": "dæɡz",
    "daguerreotype": "deɪɡrɪɒtaɪp",
    "daguerreotypes": "deɪɡrɪɒtaɪps",
    "dah": "dɑː",
    "dahl": "dɑːl",
    "dahlia": "deɪliːɐ",
    "dahlias": "deɪliːəz",
    "dahs": "dɑːz",
    "daikon": "deɪkən",
    "dailies": "deɪliz",
    "daily": "deɪli",
    "daintier": "deɪntɪɐ",
    "dainties": "deɪntɪz",
    "daintiest": "deɪntɪəst",
    "daintily": "deɪntɪli",
    "daintiness": "deɪntɪnəs",
    "dainty": "deɪnti",
    "daiquiri": "deɪkwiəri",
    "daiquiris": "deɪkwɪrɪs",
    "dairies": "deərɪz",
    "dairy": "deəri",
    "dairying": "deərɪɪŋ",
    "dairymaid": "deərɪmeɪd",
    "dairyman": "deərɪmən",
    "dais": "deɪɪs",
    "daises": "deɪzɪz",
    "daisies": "deɪzɪz",
    "daisy": "deɪzi",
    "dak": "dæk",
    "daks": "dæks",
    "dale": "deɪl",
    "dales": "deɪlz",
    "dalesman": "deɪlzmən",
    "daleth": "deɪləθ",
    "dalliance": "dæliːəns",
    "dalliances": "dæliːənsɪz",
    "dallied": "dælid",
    "dally": "dæli",
    "dallying": "dæliɪŋ",
    "dalmatian": "dælmeɪʃən",
    "dalmatians": "dælmeɪʃənz",
    "daltonism": "dɒltənɪzəm",
    "damage": "dæmɪdʒ",
    "damaged": "dæmɪdʒd",
    "damages": "dæmɪdʒɪz",
    "damaging": "dæmɪdʒɪŋ",
    "damagingly": "dæmɪdʒɪŋli",
    "damascene": "dæmɐsiːn",
    "damascened": "dæmæsənd",
    "damascenes": "dæmɐsiːnz",
    "damask": "dæmɑːsk",
    "damasks": "dæmɑːsks",
    "dam": "dæm",
    "dame": "deɪm",
    "dames": "deɪmz",
    "dammed": "dæmd",
    "damming": "dæmɪŋ",
    "dammit": "dæmɪt",
    "damnable": "dæməbəl",
    "damnably": "dæməbli",
    "damnation": "dæmneɪʃən",
    "damn": "dæm",
    "damndest": "dæmndəst",
    "damned": "dæmd",
    "damnedest": "dæmnɛdəst",
    "damning": "dæmɪŋ",
    "damns": "dæmz",
    "damp": "dæmp",
    "damped": "dæmpt",
    "dampen": "dæmpən",
    "dampened": "dæmpənd",
    "dampener": "dæmpənɐ",
    "dampeners": "dæmpənəz",
    "dampening": "dæmpənɪŋ",
    "dampens": "dæmpənz",
    "damper": "dæmpɐ",
    "dampers": "dæmpəz",
    "damping": "dæmpɪŋ",
    "dampish": "dæmpɪʃ",
    "dampness": "dæmpnəs",
    "dampproof": "dæmpruːf",
    "damps": "dæmps",
    "dams": "dæmz",
    "damsel": "dæmsəl",
    "damselfish": "dæmsɛlfɪʃ",
    "damselflies": "dæmsɪlflaɪz",
    "damselfly": "dæmsɪlflaɪ",
    "damsels": "dæmsəlz",
    "damson": "dæmsən",
    "damsons": "dæmsənz",
    "danceable": "dɑːnsəbəl",
    "danced": "dɑːnst",
    "dance": "dɑːns",
    "dancer": "dɑːnsɐ",
    "dancers": "dɑːnsəz",
    "dances": "dɑːnsɪz",
    "dancing": "dɑːnsɪŋ",
    "dandelion": "dændɪlaɪən",
    "dandelions": "dændɪlaɪənz",
    "dander": "dændɐ",
    "dandier": "dændɪɐ",
    "dandies": "dændɪz",
    "dandiest": "dændɪəst",
    "dandified": "dændɪfaɪd",
    "dandled": "dændəld",
    "dandruff": "dændrʌf",
    "dandy": "dændi",
    "dandyism": "dændɪɪzəm",
    "dang": "dæŋ",
    "danged": "dæŋd",
    "danger": "deɪndʒɐ",
    "dangerous": "deɪndʒərəs",
    "dangerously": "deɪndʒərəsli",
    "dangerousness": "deɪndʒərəsnəs",
    "dangers": "deɪndʒəz",
    "danging": "dæŋɪŋ",
    "dangle": "dæŋɡəl",
    "dangled": "dæŋɡəld",
    "dangler": "dæŋɡlɐ",
    "danglers": "dæŋɡləz",
    "dangles": "dæŋɡəlz",
    "dangling": "dæŋɡəlɪŋ",
    "danish": "deɪnɪʃ",
    "danishes": "deɪnɪʃɪz",
    "dank": "dæŋk",
    "dap": "dæp",
    "daphne": "dæfni",
    "daphnes": "dæfniz",
    "dapper": "dæpɐ",
    "dapple": "dæpəl",
    "dappled": "dæpəld",
    "dapples": "dæpəlz",
    "dappling": "dæplɪŋ",
    "darbies": "dɑːbɪz",
    "dared": "deəd",
    "dare": "deə",
    "daredevil": "deədɛvəl",
    "daredevils": "deədɛvəlz",
    "daresay": "deəseɪ",
    "dares": "deəz",
    "daring": "deərɪŋ",
    "daringly": "deərɪŋli",
    "dariole": "dɑːrɪəʊl",
    "dark": "dɑːk",
    "darken": "dɑːkən",
    "darkened": "dɑːkənd",
    "darkening": "dɑːkənɪŋ",
    "darkens": "dɑːkənz",
    "darker": "dɑːkɐ",
    "darkest": "dɑːkəst",
    "darkie": "dɑːki",
    "darkies": "dɑːkiz",
    "darkish": "dɑːkɪʃ",
    "darkling": "dɑːklɪŋ",
    "darkly": "dɑːkli",
    "darkness": "dɑːknəs",
    "darkroom": "dɑːkruːm",
    "darkrooms": "dɑːkruːmz",
    "darksome": "dɑːksʌm",
    "darky": "dɑːki",
    "darling": "dɑːlɪŋ",
    "darlings": "dɑːlɪŋz",
    "darn": "dɑːn",
    "darned": "dɑːnd",
    "darnedest": "dɑːndəst",
    "darner": "dɑːnɐ",
    "darners": "dɑːnəz",
    "darning": "dɑːnɪŋ",
    "dartboard": "dɑːtbɔːd",
    "dartboards": "dɑːtbɔːdz",
    "dart": "dɑːt",
    "darted": "dɑːtɪd",
    "darter": "dɑːtɐ",
    "darters": "dɑːtəz",
    "darting": "dɑːtɪŋ",
    "darts": "dɑːts",
    "dashboard": "dæʃbɔːd",
    "dashboards": "dæʃbɔːdz",
    "dash": "dæʃ",
    "dashed": "dæʃt",
    "dasher": "dæʃɐ",
    "dashes": "dæʃɪz",
    "dashing": "dæʃɪŋ",
    "dashingly": "dæʃɪŋli",
    "dastard": "dɑːstəd",
    "dastardly": "dɑːstədli",
    "databank": "deɪtəbæŋk",
    "databanks": "deɪtəbæŋks",
    "database": "deɪtəbeɪs",
    "databases": "deɪtəbeɪsɪz",
    "datable": "deɪtəbəl",
    "data": "deɪtɐ",
    "dateable": "deɪtəbəl",
    "dated": "deɪtɪd",
    "date": "deɪt",
    "dateless": "deɪtləs",
    "dateline": "deɪtlaɪn",
    "dater": "deɪtɐ",
    "daters": "deɪtəz",
    "dates": "deɪts",
    "dating": "deɪtɪŋ",
    "dative": "dætɪv",
    "datum": "deɪtəm",
    "daub": "dɔːb",
    "daubed": "dɔːbd",
    "daube": "dɔːb",
    "dauber": "dɔːbɐ",
    "daubing": "dɔːbɪŋ",
    "daubs": "dɔːbz",
    "daughter": "dɔːtɐ",
    "daughters": "dɔːtəz",
    "daunt": "dɔːnt",
    "daunted": "dɔːntɪd",
    "daunting": "dɔːntɪŋ",
    "dauntingly": "dɔːntɪŋli",
    "dauntless": "dɔːntləs",
    "daunts": "dɔːnts",
    "dauphin": "dɔːfɪn",
    "dauphine": "dɔːfiːn",
    "davenport": "dævənpɔːt",
    "davenports": "dævənpɔːts",
    "davit": "dævɪt",
    "davits": "dævɪts",
    "dawdled": "dɔːdəld",
    "dawdle": "dɔːdəl",
    "dawdler": "dɔːdlɐ",
    "dawdling": "dɔːdlɪŋ",
    "daw": "dɔː",
    "dawn": "dɔːn",
    "dawned": "dɔːnd",
    "dawning": "dɔːnɪŋ",
    "dawns": "dɔːnz",
    "daws": "dɔːz",
    "daybed": "deɪbd",
    "daybook": "deɪbʊk",
    "daybreak": "deɪbreɪk",
    "daycare": "deɪkeə",
    "day": "deɪ",
    "daydream": "deɪdriːm",
    "daydreamed": "deɪdriːmd",
    "daydreamer": "deɪdriːmɐ",
    "daydreaming": "deɪdriːmɪŋ",
    "daydreams": "deɪdriːmz",
    "daylight": "deɪlaɪt",
    "daylights": "deɪlaɪts",
    "days": "deɪz",
    "daytime": "deɪtaɪm",
    "dazed": "deɪzd",
    "daze": "deɪz",
    "dazes": "deɪzɪz",
    "dazzle": "dæzəl",
    "dazzled": "dæzəld",
    "dazzler": "dæzlɐ",
    "dazzlers": "dæzləz",
    "dazzles": "dæzəlz",
    "dazzling": "dæzlɪŋ",
    "dazzlingly": "dæzəlɪŋli",
    "db": "diːbiː",
    "dc": "diːsiː",
    "d": "diː",
    "deacon": "diːkən",
    "deaconess": "diːkəʊnəs",
    "deacons": "diːkənz",
    "deactivated": "diːæktɪveɪtɪd",
    "deactivate": "diːæktɪveɪt",
    "deactivates": "diːæktɪveɪts",
    "deactivating": "diːæktɪveɪtɪŋ",
    "deactivation": "diːæktɪveɪʃən",
    "deadbeat": "dɛdbiːt",
    "deadbeats": "dɛdbiːts",
    "dead": "dɛd",
    "deaden": "dɛdən",
    "deadened": "dɛdənd",
    "deadening": "dɛdənɪŋ",
    "deadens": "dɛdənz",
    "deader": "dɛdɐ",
    "deadeye": "dɛdaɪ",
    "deadfall": "dɛdfɔːl",
    "deadhead": "dɛdhɛd",
    "deadheaded": "dɛdhɛdɪd",
    "deadheading": "dɛdhɛdɪŋ",
    "deadheads": "dɛdhɛdz",
    "deadlier": "dɛdliɐ",
    "deadliest": "dɛdliəst",
    "deadlight": "dɛdlaɪt",
    "deadline": "dɛdlaɪn",
    "deadlines": "dɛdlaɪnz",
    "deadliness": "dɛdlinəs",
    "deadlock": "dɛdlɒk",
    "deadlocked": "dɛdlɒkt",
    "deadlocks": "dɛdlɒks",
    "deadly": "dɛdli",
    "deadness": "dɛdnəs",
    "deadpan": "dɛdpæn",
    "deadweight": "dɛdweɪt",
    "deadwood": "dɛdwʊd",
    "deaf": "dɛf",
    "deafen": "dɛfən",
    "deafened": "dɛfənd",
    "deafening": "dɛfənɪŋ",
    "deafeningly": "dɛfənɪŋli",
    "deafer": "dɛfɐ",
    "deafness": "dɛfnəs",
    "deal": "diːl",
    "dealer": "diːlɐ",
    "dealers": "diːləz",
    "dealership": "diːləʃɪp",
    "dealerships": "diːləʃɪps",
    "dealing": "diːlɪŋ",
    "dealings": "diːlɪŋz",
    "deals": "diːlz",
    "dealt": "dɛlt",
    "dean": "diːn",
    "deanery": "diːnəri",
    "deans": "diːnz",
    "dear": "diə",
    "dearer": "diərɐ",
    "dearest": "diərəst",
    "dearie": "diəri",
    "dearies": "diərɪz",
    "dearly": "diəli",
    "dears": "diəz",
    "dearth": "dɜːθ",
    "deary": "diəri",
    "deathbed": "dɛθbɛd",
    "deathbeds": "dɛθbɛdz",
    "death": "dɛθ",
    "deathless": "dɛθləs",
    "deathly": "dɛθli",
    "deaths": "dɛθs",
    "deathtrap": "dɛθtræp",
    "deathwatch": "dɛθwɒtʃ",
    "deaves": "diːvz",
    "debacle": "deɪbɑːkəl",
    "debacles": "deɪbɑːkəlz",
    "debarred": "dɪbɑːd",
    "debars": "dɪbɑːz",
    "debase": "dɪbeɪs",
    "debased": "dɪbeɪst",
    "debasement": "dɪbeɪsmənt",
    "debases": "dɪbeɪsɪz",
    "debasing": "dɪbeɪsɪŋ",
    "debatable": "dɪbeɪtəbəl",
    "debate": "dɪbeɪt",
    "debated": "dɪbeɪtɪd",
    "debater": "dɪbeɪtɐ",
    "debaters": "dɪbeɪtəz",
    "debates": "dɪbeɪts",
    "debating": "dɪbeɪtɪŋ",
    "debauch": "dɪbɔːtʃ",
    "debauched": "dɪbɔːtʃt",
    "debauchee": "dɪbɔːtʃiː",
    "debauchery": "dɪbɔːtʃəri",
    "debauching": "dɪbɔːtʃɪŋ",
    "deb": "dɛb",
    "debenture": "dɛbɛntʃɐ",
    "debentures": "dɛbɛntʃəz",
    "debilitate": "dɪbɪlɪteɪt",
    "debilitated": "dɪbɪlɪteɪtɪd",
    "debilitating": "dɪbɪlɪteɪtɪŋ",
    "debilitation": "dɪbɪlɪteɪʃən",
    "debility": "dɪbɪlɪti",
    "debit": "dɛbɪt",
    "debited": "dɛbɪtɪd",
    "debiting": "dɛbɪtɪŋ",
    "debits": "dɛbɪts",
    "debonair": "dɛbəneə",
    "debonaire": "dɛbəneə",
    "debrief": "diːbriːf",
    "debriefed": "diːbriːft",
    "debriefing": "diːbriːfɪŋ",
    "debris": "dɛbriː",
    "debs": "dɛbz",
    "debt": "dɛt",
    "debtor": "dɛtɐ",
    "debtors": "dɛtəz",
    "debts": "dɛts",
    "debunk": "diːbʌnk",
    "debunked": "diːbʌnkt",
    "debunking": "diːbʌnkɪŋ",
    "debut": "deɪbjuː",
    "debuted": "deɪbjuːd",
    "debuting": "deɪbjuːɪŋ",
    "debuts": "deɪbjuːs",
    "decade": "dɛkeɪd",
    "decadence": "dɛkədəns",
    "decadent": "dɛkədənt",
    "decadently": "dɛkədəntli",
    "decades": "dɛkeɪdz",
    "decaf": "diːkæf",
    "decaff": "dɪkæf",
    "decaffeinated": "diːkæfɪneɪtɪd",
    "decagon": "dɪkæɡən",
    "decal": "dɪkæl",
    "decalogue": "dɪkælɒɡ",
    "decals": "dɪkælz",
    "decamp": "dɪkæmp",
    "decamped": "dɪkæmpt",
    "decamping": "dɪkæmpɪŋ",
    "decamps": "dɪkæmps",
    "decant": "dɪkɑːnt",
    "decanted": "dɪkɑːntɪd",
    "decanter": "dɪkɑːntɐ",
    "decanters": "dɪkɑːntəz",
    "decanting": "dɪkɑːntɪŋ",
    "decants": "dɪkɑːnts",
    "decapitated": "dɪkæpɪteɪtɪd",
    "decapitate": "dɪkæpɪteɪt",
    "decapitates": "dɪkæpɪteɪts",
    "decapitation": "dɪkæpɪteɪʃən",
    "decapitator": "dɪkæpɪteɪtɐ",
    "decapod": "dɪkæpɒd",
    "decarbonised": "dɪkɑːbənaɪzd",
    "decarbonise": "dɪkɑːbənaɪz",
    "decarbonising": "dɪkɑːbənaɪzɪŋ",
    "decathlete": "dɪkæθliːt",
    "decathlon": "dɪkæθlən",
    "decay": "dɪkeɪ",
    "decayed": "dɪkeɪd",
    "decaying": "dɪkeɪɪŋ",
    "decays": "dɪkeɪz",
    "deceased": "dɪsiːsd",
    "decease": "dɪsiːs",
    "decedent": "dɪsiːdənt",
    "deceit": "dɪsiːt",
    "deceitful": "dɪsiːtfəl",
    "deceitfulness": "dɪsiːtfəlnəs",
    "deceits": "dɪsiːts",
    "deceived": "dɪsiːvd",
    "deceive": "dɪsiːv",
    "deceiver": "dɪsiːvɐ",
    "deceivers": "dɪsiːvəz",
    "deceives": "dɪsiːvz",
    "deceiving": "dɪsiːvɪŋ",
    "deceivingly": "dɪsiːvɪŋli",
    "decelerated": "dɪsɛləreɪtɪd",
    "decelerate": "dɪsɛləreɪt",
    "decelerates": "dɪsɛləreɪts",
    "decelerating": "dɪsɛləreɪtɪŋ",
    "deceleration": "dɪsɛləreɪʃən",
    "decelerator": "dɪsɛləreɪtɐ",
    "decencies": "diːsənsiz",
    "decency": "diːsənsi",
    "decent": "diːsənt",
    "decently": "diːsəntli",
    "decentralisation": "dɪsɛntrəlaɪzeɪʃən",
    "decentralised": "dɪsɛntrəlaɪzd",
    "decentralise": "dɪsɛntrəlaɪz",
    "decentralising": "dɪsɛntrəlaɪzɪŋ",
    "deception": "dɪsɛpʃən",
    "deceptions": "dɪsɛpʃənz",
    "deceptive": "dɪsɛptɪv",
    "deceptively": "dɪsɛptɪvli",
    "decibel": "dɛsɪbəl",
    "decibels": "dɛsɪbəlz",
    "decided": "dɪsaɪdɪd",
    "decidedly": "dɪsaɪdɪdli",
    "decide": "dɪsaɪd",
    "decider": "dɪsaɪdɐ",
    "deciders": "dɪsaɪdəz",
    "decides": "dɪsaɪdz",
    "deciding": "dɪsaɪdɪŋ",
    "decidua": "dɪsɪdjuːɐ",
    "deciduous": "dɪsɪdjuːəs",
    "decile": "dɛsaɪl",
    "deciles": "dɛsaɪlz",
    "decimal": "dɛsɪməl",
    "decimalisation": "dɛsɪməlaɪzeɪʃən",
    "decimalised": "dɛsɪməlaɪzd",
    "decimals": "dɛsɪməlz",
    "decimated": "dɛsɪmeɪtɪd",
    "decimate": "dɛsɪmeɪt",
    "decimates": "dɛsɪmeɪts",
    "decimating": "dɛsɪmeɪtɪŋ",
    "decimation": "dɛsɪmeɪʃən",
    "decimetre": "dɛsɪmiːtɐ",
    "decipher": "dɪsaɪfɐ",
    "deciphered": "dɪsaɪfəd",
    "deciphering": "dɪsaɪfərɪŋ",
    "decipherment": "dɪsaɪfəmənt",
    "decision": "dɪsɪʒən",
    "decisions": "dɪsɪʒənz",
    "decisive": "dɪsaɪsɪv",
    "decisively": "dɪsaɪsɪvli",
    "decisiveness": "dɪsaɪsɪvnəs",
    "deckchair": "dɛktʃeə",
    "deckchairs": "dɛktʃeəz",
    "deck": "dɛk",
    "decked": "dɛkt",
    "deckhand": "dɛkhænd",
    "deckhands": "dɛkhændz",
    "decking": "dɛkɪŋ",
    "decks": "dɛks",
    "declaim": "dɪkleɪm",
    "declaimed": "dɪkleɪmd",
    "declaiming": "dɪkleɪmɪŋ",
    "declaims": "dɪkleɪmz",
    "declamation": "dɪklɐmeɪʃən",
    "declamations": "dɪklɐmeɪʃənz",
    "declamatory": "dɪklæmətəri",
    "declaration": "dɛkləreɪʃən",
    "declarations": "dɛkləreɪʃənz",
    "declarative": "dɪklærətɪv",
    "declaratory": "dɪklærətəri",
    "declared": "dɪkleəd",
    "declare": "dɪkleə",
    "declares": "dɪkleəz",
    "declaring": "dɪkleərɪŋ",
    "declass": "dɪklɑːs",
    "declassification": "dɪklæsɪfɪkeɪʃən",
    "declassified": "dɪklæsɪfaɪd",
    "declension": "dɪklɛnʃən",
    "declination": "dɪklɪneɪʃən",
    "declined": "dɪklaɪnd",
    "decline": "dɪklaɪn",
    "declines": "dɪklaɪnz",
    "declining": "dɪklaɪnɪŋ",
    "declivities": "dɪklɪvɪtiz",
    "decoded": "dɪkəʊdɪd",
    "decode": "dɪkəʊd",
    "deco": "dɛkəʊ",
    "decoder": "dɪkəʊdɐ",
    "decoders": "dɪkəʊdəz",
    "decodes": "dɪkəʊdz",
    "decoding": "dɪkəʊdɪŋ",
    "decolonisation": "dɪkɒlənaɪzeɪʃən",
    "decommission": "diːkəmɪʃən",
    "decommissioned": "diːkəmɪʃənd",
    "decommissioning": "diːkəmɪʃənɪŋ",
    "decomposed": "diːkəmpəʊzd",
    "decompose": "diːkəmpəʊz",
    "decomposes": "diːkəmpəʊzɪz",
    "decomposing": "diːkəmpəʊzɪŋ",
    "decomposition": "diːkɒmpəzɪʃən",
    "decompress": "diːkəmprɛs",
    "decompressed": "diːkəmprɛst",
    "decompressing": "diːkəmprɛsɪŋ",
    "decompression": "diːkəmprɛʃən",
    "decongestant": "diːkəndʒɛstənt",
    "decongestants": "diːkəndʒɛstənts",
    "deconsecrated": "diːkənsɛkreɪtɪd",
    "deconstruct": "diːkənstrʌkt",
    "deconstructed": "diːkənstrʌktɪd",
    "deconstructing": "diːkənstrʌktɪŋ",
    "deconstruction": "diːkənstrʌkʃən",
    "decontaminated": "diːkəntæmɪneɪtɪd",
    "decontaminate": "diːkəntæmɪneɪt",
    "decontaminating": "diːkəntæmɪneɪtɪŋ",
    "decontamination": "diːkəntæmɪneɪʃən",
    "decorated": "dɛkəreɪtɪd",
    "decorate": "dɛkəreɪt",
    "decorates": "dɛkəreɪts",
    "decorating": "dɛkəreɪtɪŋ",
    "decoration": "dɛkəreɪʃən",
    "decorations": "dɛkəreɪʃənz",
    "decorative": "dɛkrətɪv",
    "decoratively": "dɛkrətɪvli",
    "decorator": "dɛkɔːreɪtɐ",
    "decorators": "dɛkɔːreɪtəz",
    "decor": "deɪkɔː",
    "decorous": "dɛkərəs",
    "decorously": "dɛkərəsli",
    "decors": "deɪkɔːz",
    "decorum": "dɪkɔːrəm",
    "decoupage": "dɪkuːpɪdʒ",
    "decoupled": "dɪkʌpəld",
    "decouple": "dɪkʌpəl",
    "decoupling": "dɪkʌplɪŋ",
    "decoyed": "diːkɔɪd",
    "decreased": "diːkriːsd",
    "decreasing": "diːkriːsɪŋ",
    "decreasingly": "diːkriːsɪŋli",
    "decreed": "dɪkriːd",
    "decree": "dɪkriː",
    "decreeing": "dɪkriːɪŋ",
    "decrees": "dɪkriːz",
    "decrepit": "dɪkrɛpɪt",
    "decrepitude": "dɪkrɛpɪtjuːd",
    "decried": "dɪkraɪd",
    "decries": "dɪkraɪz",
    "decriminalisation": "dɪkrɪmɪnəlaɪzeɪʃən",
    "decriminalised": "dɪkrɪmɪnəlaɪzd",
    "decriminalise": "dɪkrɪmɪnəlaɪz",
    "decriminalising": "dɪkrɪmɪnəlaɪzɪŋ",
    "decry": "dɪkraɪ",
    "decrying": "dɪkraɪɪŋ",
    "decrypt": "dɪkrɪpt",
    "decrypted": "dɪkrɪptɪd",
    "decrypting": "dɪkrɪptɪŋ",
    "decryption": "dɪkrɪpʃən",
    "decrypts": "dɪkrɪpts",
    "de": "dɐ",
    "dedans": "dɛdənz",
    "dedicated": "dɛdɪkeɪtɪd",
    "dedicate": "dɛdɪkeɪt",
    "dedicates": "dɛdɪkeɪts",
    "dedicating": "dɛdɪkeɪtɪŋ",
    "dedication": "dɛdɪkeɪʃən",
    "dedications": "dɛdɪkeɪʃənz",
    "deduced": "dɪdjuːst",
    "deduce": "dɪdjuːs",
    "deduces": "dɪdjuːsɪz",
    "deducing": "dɪdjuːsɪŋ",
    "deduct": "dɪdʌkt",
    "deducted": "dɪdʌktɪd",
    "deductible": "dɪdʌktəbəl",
    "deducting": "dɪdʌktɪŋ",
    "deduction": "dɪdʌkʃən",
    "deductions": "dɪdʌkʃənz",
    "deductive": "dɪdʌktɪv",
    "deed": "diːd",
    "deeds": "diːdz",
    "deem": "diːm",
    "deemed": "diːmd",
    "deeming": "diːmɪŋ",
    "deems": "diːmz",
    "deemster": "diːmstɐ",
    "deep": "diːp",
    "deepen": "diːpən",
    "deepened": "diːpənd",
    "deepening": "diːpənɪŋ",
    "deepens": "diːpənz",
    "deeper": "diːpɐ",
    "deepest": "diːpəst",
    "deepfreeze": "diːpfriːz",
    "deeply": "diːpli",
    "deepness": "diːpnəs",
    "deeps": "diːps",
    "deer": "diə",
    "deerhound": "diəhaʊnd",
    "deerhounds": "diəhaʊndz",
    "deers": "diəz",
    "deerskin": "diəskɪn",
    "deerstalker": "diəstɔːkɐ",
    "deescalate": "diːskɐleɪt",
    "defaced": "dɪfeɪst",
    "deface": "dɪfeɪs",
    "defacement": "dɪfeɪsmənt",
    "defaces": "dɪfeɪsɪz",
    "defacing": "dɪfeɪsɪŋ",
    "defamation": "dɪfɐmeɪʃən",
    "defamatory": "dɪfæmətəri",
    "defamed": "dɪfeɪmd",
    "defame": "dɪfeɪm",
    "defaming": "dɪfeɪmɪŋ",
    "default": "dɪfɒlt",
    "defaulted": "dɪfɒltɪd",
    "defaulter": "dɪfɒltɐ",
    "defaulters": "dɪfɒltəz",
    "defaulting": "dɪfɒltɪŋ",
    "defaults": "dɪfɒlts",
    "defeat": "dɪfiːt",
    "defeated": "dɪfiːtɪd",
    "defeating": "dɪfiːtɪŋ",
    "defeatism": "dɪfiːtɪzəm",
    "defeatist": "dɪfiːtɪst",
    "defeatists": "dɪfiːtɪsts",
    "defeats": "dɪfiːts",
    "defecated": "dɪfɛkeɪtɪd",
    "defecate": "dɪfɛkeɪt",
    "defecates": "dɪfɛkeɪts",
    "defecating": "dɪfɛkeɪtɪŋ",
    "defecation": "dɪfɪkeɪʃən",
    "defected": "diːfɛktɪd",
    "defecting": "diːfɛktɪŋ",
    "defection": "dɪfɛkʃən",
    "defections": "dɪfɛkʃənz",
    "defective": "dɪfɛktɪv",
    "defectives": "dɪfɛktɪvz",
    "defector": "dɪfɛktɐ",
    "defectors": "dɪfɛktəz",
    "defenceless": "dɪfɛnsləs",
    "defences": "dɪfɛnsɪz",
    "defencing": "dɪfɛnsɪŋ",
    "defendable": "dɪfɛndəbəl",
    "defendant": "dɪfɛndənt",
    "defendants": "dɪfɛndənts",
    "defend": "dɪfɛnd",
    "defended": "dɪfɛndɪd",
    "defender": "dɪfɛndɐ",
    "defenders": "dɪfɛndəz",
    "defending": "dɪfɛndɪŋ",
    "defends": "dɪfɛndz",
    "defenestrated": "dɪfɛnɪstreɪtɪd",
    "defenestration": "dɪfɛnɪstreɪʃən",
    "defensible": "dɪfɛnsəbəl",
    "defensive": "dɪfɛnsɪv",
    "defensively": "dɪfɛnsɪvli",
    "defensiveness": "dɪfɛnsɪvnəs",
    "defer": "dɪfɜː",
    "deference": "dɛfrəns",
    "deferent": "dɛfrənt",
    "deferential": "dɛfərɛnʃəl",
    "deferentially": "dɛfərɛnʃəli",
    "deferment": "dɪfɜːmənt",
    "deferments": "dɪfɜːmənts",
    "deferral": "dɪfɜːrəl",
    "deferrals": "dɪfɜːrəlz",
    "deferred": "dɪfɜːd",
    "deferring": "dɪfɜːrɪŋ",
    "defers": "dɪfɜːz",
    "defiance": "dɪfaɪəns",
    "defiant": "dɪfaɪənt",
    "defiantly": "dɪfaɪəntli",
    "defibrillate": "dɪfɪbrɪleɪt",
    "defibrillation": "dɪfɪbrɪleɪʃən",
    "defibrillator": "dɪfɪbrɪleɪtɐ",
    "defibrillators": "dɪfɪbrɪleɪtəz",
    "deficiencies": "dɪfɪʃənsɪz",
    "deficiency": "dɪfɪʃənsi",
    "deficient": "dɪfɪʃənt",
    "deficit": "dɛfɪsɪt",
    "deficits": "dɛfɪsɪts",
    "defied": "dɪfaɪd",
    "defies": "dɪfaɪz",
    "defiled": "dɪfaɪld",
    "defilement": "dɪfaɪlmənt",
    "defiling": "dɪfaɪlɪŋ",
    "definable": "dɪfaɪnəbəl",
    "defined": "dɪfaɪnd",
    "define": "dɪfaɪn",
    "defines": "dɪfaɪnz",
    "defining": "dɪfaɪnɪŋ",
    "definite": "dɛfɪnət",
    "definitely": "dɛfɪnətli",
    "definition": "dɛfɪnɪʃən",
    "definitions": "dɛfɪnɪʃənz",
    "definitive": "dɪfɪnɪtɪv",
    "definitively": "dɪfɪnɪtɪvli",
    "deflated": "diːfleɪtɪd",
    "deflate": "diːfleɪt",
    "deflates": "diːfleɪts",
    "deflating": "diːfleɪtɪŋ",
    "deflationary": "diːfleɪʃənəri",
    "deflation": "diːfleɪʃən",
    "deflator": "diːfleɪtɐ",
    "deflect": "dɪflɛkt",
    "deflected": "dɪflɛktɪd",
    "deflecting": "dɪflɛktɪŋ",
    "deflection": "dɪflɛkʃən",
    "deflections": "dɪflɛkʃənz",
    "deflector": "dɪflɛktɐ",
    "deflectors": "dɪflɛktəz",
    "deflects": "dɪflɛkts",
    "deflower": "dɪflaʊɐ",
    "deflowered": "dɪflaʊəd",
    "defoliant": "dɪfəʊliənt",
    "defoliated": "dɪfəʊlɪeɪtɪd",
    "defoliation": "dɪfəʊlɪeɪʃən",
    "deforce": "dɪfɔːs",
    "deforestation": "dɪfɒrɪsteɪʃən",
    "deforest": "dɪfɒrɪst",
    "deforested": "dɪfɒrɪstɪd",
    "deforesting": "dɪfɒrɪstɪŋ",
    "deformation": "dɪfɔːmeɪʃən",
    "deformations": "dɪfɔːmeɪʃənz",
    "deform": "dɪfɔːm",
    "deformed": "dɪfɔːmd",
    "deforming": "dɪfɔːmɪŋ",
    "deformities": "dɪfɔːmɪtiz",
    "deformity": "dɪfɔːmɪti",
    "deforms": "dɪfɔːmz",
    "defraud": "dɪfrɔːd",
    "defrauded": "dɪfrɔːdɪd",
    "defrauding": "dɪfrɔːdɪŋ",
    "defrock": "dɪfrɒk",
    "defrocked": "dɪfrɒkt",
    "defrost": "dɪfrɒst",
    "defrosted": "dɪfrɒstɪd",
    "defrosting": "dɪfrɒstɪŋ",
    "defrosts": "dɪfrɒsts",
    "deft": "dɛft",
    "deftest": "dɪftɛst",
    "deftly": "dɛftli",
    "deftness": "dɪftnɛs",
    "defunct": "dɪfʌŋkt",
    "defused": "dɪfjuːzd",
    "defuse": "dɪfjuːz",
    "defuses": "dɪfjuːzɪz",
    "defusing": "dɪfjuːzɪŋ",
    "defy": "dɪfaɪ",
    "defying": "dɪfaɪɪŋ",
    "degas": "dɪɡæz",
    "degeneracy": "dɪdʒɛnərəsi",
    "degenerated": "dɪdʒɛnəreɪtɪd",
    "degenerating": "dɪdʒɛnəreɪtɪŋ",
    "degeneration": "dɪdʒɛnəreɪʃən",
    "degenerative": "dɪdʒɛnərətɪv",
    "degradable": "dɪɡreɪdəbəl",
    "degradation": "dɪɡrɐdeɪʃən",
    "degradations": "dɪɡrɐdeɪʃənz",
    "degraded": "dɪɡreɪdɪd",
    "degrade": "dɪɡreɪd",
    "degrades": "dɪɡreɪdz",
    "degrading": "dɪɡreɪdɪŋ",
    "degrease": "dɪɡriːs",
    "degree": "dɪɡriː",
    "degrees": "dɪɡriːz",
    "dehumanisation": "dɛhjuːmænaɪzeɪʃən",
    "dehumanised": "dɛhjuːmænaɪzd",
    "dehumanise": "dɛhjuːmænaɪz",
    "dehumanising": "dɛhjuːmænaɪzɪŋ",
    "dehumidifier": "dɛhjuːmɪdɪfaɪə",
    "dehumidifiers": "dɛhjuːmɪdɪfaɪəz",
    "dehydrated": "diːhaɪdreɪtɪd",
    "dehydrate": "diːhaɪdreɪt",
    "dehydrates": "diːhaɪdreɪts",
    "dehydrating": "diːhaɪdreɪtɪŋ",
    "dehydration": "diːhaɪdreɪʃən",
    "dehydrator": "diːhaɪdreɪtɐ",
    "deicer": "deɪsɐ",
    "deification": "deɪfɪkeɪʃən",
    "deified": "deɪfaɪd",
    "deify": "deɪfaɪ",
    "deifying": "deɪfaɪɪŋ",
    "deign": "deɪn",
    "deigned": "deɪnd",
    "deigns": "deɪnz",
    "deist": "deɪɪst",
    "deities": "deɪətiz",
    "deity": "deɪəti",
    "deject": "dɪdʒɛkt",
    "dejected": "dɪdʒɛktɪd",
    "dejectedly": "dɪdʒɛktɪdli",
    "dejection": "dɪdʒɛkʃən",
    "dekko": "dɛkəʊ",
    "delaine": "dɪleɪn",
    "delaminate": "dɪlæmɪneɪt",
    "delay": "dɪleɪ",
    "delayed": "dɪleɪd",
    "delaying": "dɪleɪɪŋ",
    "delays": "dɪleɪz",
    "delectable": "dɪlɛktəbəl",
    "delectably": "dɪlɛktəbli",
    "delectation": "dɪlɪkteɪʃən",
    "dele": "dɪlɛ",
    "delegated": "dɛlɪɡeɪtɪd",
    "delegating": "dɛlɪɡeɪtɪŋ",
    "delegation": "dɛlɪɡeɪʃən",
    "delegations": "dɛlɪɡeɪʃənz",
    "delegator": "dɛlɪɡeɪtɐ",
    "deleted": "dɪliːtɪd",
    "delete": "dɪliːt",
    "deleterious": "dɪlɪtiərɪəs",
    "deletes": "dɪliːts",
    "deleting": "dɪliːtɪŋ",
    "deletion": "dɪliːʃən",
    "deletions": "dɪliːʃənz",
    "delft": "dɛlft",
    "delftware": "dɛlftweə",
    "deliberated": "dɪlɪbərətɪd",
    "deliberately": "dɪlɪbərətli",
    "deliberates": "dɪlɪbərəts",
    "deliberating": "dɪlɪbərətɪŋ",
    "deliberation": "dɪlɪbəreɪʃən",
    "deliberations": "dɪlɪbəreɪʃənz",
    "deliberative": "dɪlɪbərətɪv",
    "delicacies": "dɛlɪkəsɪz",
    "delicacy": "dɛlɪkəsi",
    "delicate": "dɛlɪkət",
    "delicately": "dɛlɪkətli",
    "delicatessen": "dɛlɪkætɛsən",
    "delicatessens": "dɛlɪkætɛsənz",
    "delicious": "dɪlɪʃəs",
    "deliciously": "dɪlɪʃəsli",
    "deliciousness": "dɪlɪʃəsnəs",
    "deli": "dɛli",
    "delight": "dɪlaɪt",
    "delighted": "dɪlaɪtɪd",
    "delightedly": "dɪlaɪtɪdli",
    "delightful": "dɪlaɪtfəl",
    "delightfully": "dɪlaɪtfəli",
    "delighting": "dɪlaɪtɪŋ",
    "delights": "dɪlaɪts",
    "delineated": "dɪlɪniːtɪd",
    "delineate": "dɪlɪniːt",
    "delineates": "dɪlɪniːts",
    "delineating": "dɪlɪniːtɪŋ",
    "delineation": "dɪlɪniːʃən",
    "delineations": "dɪlɪniːʃənz",
    "delineator": "dɪlɪniːtɐ",
    "delinquencies": "dɪlɪnkwənsiz",
    "delinquency": "dɪlɪnkwənsi",
    "delinquent": "dɪlɪnkwənt",
    "delinquents": "dɪlɪnkwənts",
    "delirious": "dɪlɪrɪəs",
    "deliriously": "dɪlɪrɪəsli",
    "delirium": "dɪlɪriəm",
    "delis": "dɛlɪz",
    "deliverable": "dɪlɪvərəbəl",
    "deliverance": "dɪlɪvərəns",
    "deliver": "dɪlɪvɐ",
    "delivered": "dɪlɪvəd",
    "deliverer": "dɪlɪvərɐ",
    "deliverers": "dɪlɪvərəz",
    "deliveries": "dɪlɪvəriz",
    "delivering": "dɪlɪvərɪŋ",
    "delivers": "dɪlɪvəz",
    "delivery": "dɪlɪvəri",
    "dell": "dɛl",
    "dells": "dɛlz",
    "deloused": "dɪlaʊsd",
    "delouse": "dɪlaʊs",
    "delousing": "dɪlaʊsɪŋ",
    "delphinium": "dɛlfɪniəm",
    "delphiniums": "dɛlfɪniəmz",
    "delta": "dɛltɐ",
    "deltas": "dɛltəz",
    "deltoid": "dɛltɔɪd",
    "deltoids": "dɛltɔɪdz",
    "deluded": "dɪluːdɪd",
    "delude": "dɪluːd",
    "deludes": "dɪluːdz",
    "deluding": "dɪluːdɪŋ",
    "deluged": "dɛljuːdʒd",
    "deluge": "dɛljuːdʒ",
    "deluges": "dɛljuːdʒɪz",
    "delusional": "dɪluːʒənəl",
    "delusion": "dɪluːʒən",
    "delusions": "dɪluːʒənz",
    "delusive": "dɪluːsɪv",
    "deluxe": "dɪlʌks",
    "delved": "dɛlvd",
    "delve": "dɛlv",
    "delves": "dɛlvz",
    "delving": "dɛlvɪŋ",
    "demagogue": "dɛmɐɡɒɡ",
    "demagoguery": "dɛmɐɡɒɡri",
    "demagogues": "dɛmɐɡɒɡz",
    "demand": "dɪmɑːnd",
    "demanded": "dɪmɑːndɪd",
    "demanding": "dɪmɑːndɪŋ",
    "demands": "dɪmɑːndz",
    "demarcated": "dɪmɑːkeɪtɪd",
    "demarcate": "dɪmɑːkeɪt",
    "demarcation": "dɪmɑːkeɪʃən",
    "demarcations": "dɪmɑːkeɪʃənz",
    "dematerialised": "dɪmətiərɪəlaɪzd",
    "dematerialise": "dɪmətiərɪəlaɪz",
    "demean": "dɪmiːn",
    "demeaned": "dɪmiːnd",
    "demeaning": "dɪmiːnɪŋ",
    "demeanor": "dɪmiːnɐ",
    "demeanour": "dɪmiːnɐ",
    "demeans": "dɪmiːnz",
    "deme": "diːm",
    "dement": "dɪmɛnt",
    "demented": "dɪmɛntɪd",
    "dementedly": "dɪmɛntɪdli",
    "dementia": "dɪmɛnʃɐ",
    "demerit": "dɛmərɪt",
    "demerits": "dɛmərɪts",
    "demesne": "dɛmɛsni",
    "demigod": "dɛmɪɡɒd",
    "demijohn": "dɛmɪdʒɒn",
    "demilitarisation": "diːmɪlɪtəraɪzeɪʃən",
    "demilitarised": "diːmɪlɪtəraɪzd",
    "demilitarise": "diːmɪlɪtəraɪz",
    "demilitarising": "diːmɪlɪtəraɪzɪŋ",
    "demised": "dɪmaɪzd",
    "demise": "dɪmaɪz",
    "demises": "dɪmaɪzɪz",
    "demist": "dɛmɪst",
    "demitasse": "dɛmɪtæs",
    "demobbed": "dɛmɒbd",
    "demob": "dɛmɒb",
    "demobilisation": "dɪməʊbɪlaɪzeɪʃən",
    "demobilised": "dɪməʊbəlaɪzd",
    "demobilise": "dɪməʊbəlaɪz",
    "democracies": "dɪmɒkrəsɪz",
    "democracy": "dɪmɒkrəsi",
    "democrat": "dɛməkræt",
    "democratically": "dɛməkrætɪkli",
    "democratic": "dɛməkrætɪk",
    "democratisation": "dɪmɒkrɐtaɪzeɪʃən",
    "democratised": "dɪmɒkrɐtaɪzd",
    "democratise": "dɪmɒkrɐtaɪz",
    "democratising": "dɪmɒkrɐtaɪzɪŋ",
    "democrats": "dɛməkræts",
    "demo": "dɛməʊ",
    "demoed": "dɛməʊd",
    "demographers": "dɛmɒɡrəfəz",
    "demographically": "dɛməɡræfɪkli",
    "demographic": "dɛməɡræfɪk",
    "demographics": "dɛməɡræfɪks",
    "demography": "dɛmɒɡrəfi",
    "demoing": "dɛməʊɪŋ",
    "demoiselle": "dɛmɔɪsɛl",
    "demoiselles": "dɛmɔɪsɛlz",
    "demolish": "dɪmɒlɪʃ",
    "demolished": "dɪmɒlɪʃt",
    "demolishes": "dɪmɒlɪʃɪz",
    "demolishing": "dɪmɒlɪʃɪŋ",
    "demolition": "dɛməlɪʃən",
    "demolitions": "dɛməlɪʃənz",
    "demon": "diːmən",
    "demoniacal": "diːməʊnɪækəl",
    "demonically": "diːmɒnɪkli",
    "demonic": "diːmɒnɪk",
    "demonisation": "diːmənaɪzeɪʃən",
    "demonised": "diːmənaɪzd",
    "demonise": "diːmənaɪz",
    "demonises": "diːmənaɪzɪz",
    "demonising": "diːmənaɪzɪŋ",
    "demonology": "dɛmənɒlədʒi",
    "demons": "diːmənz",
    "demonstrable": "dɛmənstrəbəl",
    "demonstrably": "dɛmənstrəbli",
    "demonstrated": "dɛmənstreɪtɪd",
    "demonstrate": "dɛmənstreɪt",
    "demonstrates": "dɛmənstreɪts",
    "demonstrating": "dɛmənstreɪtɪŋ",
    "demonstration": "dɛmənstreɪʃən",
    "demonstrations": "dɛmənstreɪʃənz",
    "demonstrative": "dəmɒnstrətɪv",
    "demonstrator": "dɛmənstreɪtɐ",
    "demonstrators": "dɛmənstreɪtəz",
    "demoralisation": "dɪmɒrəlaɪzeɪʃən",
    "demoralised": "dɪmɒrəlaɪzd",
    "demoralise": "dɪmɒrəlaɪz",
    "demoralising": "dɪmɒrəlaɪzɪŋ",
    "demos": "dɛməʊz",
    "demoted": "dɪməʊtɪd",
    "demote": "dɪməʊt",
    "demotes": "dɪməʊts",
    "demotic": "dɪmɒtɪk",
    "demoting": "dɪməʊtɪŋ",
    "demotion": "dɪməʊʃən",
    "demotivated": "dɪməʊtɪveɪtɪd",
    "dempster": "dɛmpstɐ",
    "demur": "dɪmɜː",
    "demure": "dɪmjɔː",
    "demurely": "dɪmjɔːli",
    "demureness": "dɪmjɔːnəs",
    "demurred": "dɪmɜːd",
    "demy": "dɛmi",
    "demystified": "dɛmɪstɪfaɪd",
    "demystifies": "dɛmɪstɪfaɪz",
    "demystify": "dɛmɪstɪfaɪ",
    "demystifying": "dɛmɪstɪfaɪɪŋ",
    "denarius": "dɛneərɪəs",
    "denationalisation": "dɛneɪʃənəlaɪzeɪʃən",
    "denationalised": "dɛneɪʃənəlaɪzd",
    "denatured": "dɛnətʃəd",
    "denature": "dɛnətʃɐ",
    "den": "dɛn",
    "dendrites": "dɛndraɪts",
    "dendritic": "dɛndrɪtɪk",
    "dendrochronology": "dɛndrəkrənɒlədʒi",
    "dendrologist": "dɛndrɒlədʒɪst",
    "dendrology": "dɛndrɒlədʒi",
    "dene": "diːn",
    "dengue": "dɛnɡi",
    "deniability": "dɪnaɪəbɪlɪti",
    "deniable": "dɪnaɪəbəl",
    "denial": "dɪnaɪəl",
    "denials": "dɪnaɪəlz",
    "denied": "dɪnaɪd",
    "deniers": "dɪnaɪəz",
    "denies": "dɪnaɪz",
    "denigrated": "dɛnɪɡreɪtɪd",
    "denigrate": "dɛnɪɡreɪt",
    "denigrates": "dɛnɪɡreɪts",
    "denigrating": "dɛnɪɡreɪtɪŋ",
    "denigration": "dɛnɪɡreɪʃən",
    "denim": "dɛnɪm",
    "denims": "dɛnɪmz",
    "denizen": "dɛnɪzən",
    "denizens": "dɛnɪzənz",
    "denominated": "dɪnɒmɪneɪtɪd",
    "denominational": "dɪnɒmɪneɪʃənəl",
    "denomination": "dɪnɒmɪneɪʃən",
    "denominations": "dɪnɒmɪneɪʃənz",
    "denominator": "dɪnɒmɪneɪtɐ",
    "denominators": "dɪnɒmɪneɪtəz",
    "denoted": "dɪnəʊtɪd",
    "denote": "dɪnəʊt",
    "denotes": "dɪnəʊts",
    "denoting": "dɪnəʊtɪŋ",
    "denouement": "deɪnuːmɔ̃",
    "denounced": "dɪnaʊnst",
    "denounce": "dɪnaʊns",
    "denouncement": "dɪnaʊnsmənt",
    "denounces": "dɪnaʊnsɪz",
    "denouncing": "dɪnaʊnsɪŋ",
    "dens": "dɛnz",
    "dense": "dɛns",
    "densely": "dɛnsli",
    "denseness": "dɛnsnəs",
    "denser": "dɛnsɐ",
    "densest": "dɛnsəst",
    "densities": "dɛnsɪtiz",
    "density": "dɛnsɪti",
    "dental": "dɛntəl",
    "dentally": "dɛntəli",
    "dent": "dɛnt",
    "dented": "dɛntɪd",
    "denticles": "dɛntɪkəlz",
    "dentifrice": "dɛntɪfrɪs",
    "dentine": "dɛntiːn",
    "denting": "dɛntɪŋ",
    "dentist": "dɛntɪst",
    "dentistry": "dɛntɪstri",
    "dentists": "dɛntɪsts",
    "dentition": "dɛntɪʃən",
    "dents": "dɛnts",
    "denture": "dɛntʃɐ",
    "dentures": "dɛntʃəz",
    "denuded": "dɪnjuːdɪd",
    "denude": "dɪnjuːd",
    "denunciation": "dɪnʌnsɪeɪʃən",
    "deny": "dɪnaɪ",
    "denying": "dɪnaɪɪŋ",
    "deodar": "diːɒdɐ",
    "deodorant": "diːəʊdərənt",
    "deodorants": "diːəʊdərənts",
    "deodoriser": "diːəʊdəraɪzɐ",
    "deodorising": "diːəʊdəraɪzɪŋ",
    "depart": "dɪpɑːt",
    "departed": "dɪpɑːtɪd",
    "departing": "dɪpɑːtɪŋ",
    "departmental": "dɪpɑːtmɛntəl",
    "department": "dɪpɑːtmənt",
    "departments": "dɪpɑːtmənts",
    "departs": "dɪpɑːts",
    "departure": "dɪpɑːtʃɐ",
    "departures": "dɪpɑːtʃəz",
    "dependability": "dɪpɛndəbɪlɪti",
    "dependable": "dɪpɛndəbəl",
    "dependably": "dɪpɛndəbli",
    "dependance": "dɪpɛndəns",
    "dependancy": "dɪpɛndənsi",
    "dependant": "dɪpɛndənt",
    "dependants": "dɪpɛndənts",
    "depend": "dɪpɛnd",
    "depended": "dɪpɛndɪd",
    "dependence": "dɪpɛndəns",
    "dependencies": "dɪpɛndənsiz",
    "dependency": "dɪpɛndənsi",
    "dependent": "dɪpɛndənt",
    "dependents": "dɪpɛndənts",
    "depending": "dɪpɛndɪŋ",
    "depends": "dɪpɛndz",
    "depersonalises": "diːpɜːsənəlaɪzɪz",
    "depict": "dɪpɪkt",
    "depicted": "dɪpɪktɪd",
    "depicting": "dɪpɪktɪŋ",
    "depiction": "dɪpɪkʃən",
    "depictions": "dɪpɪkʃənz",
    "depicts": "dɪpɪkts",
    "depilatory": "dɪpɪlətəri",
    "deplane": "dɪpleɪn",
    "depleted": "dɪpliːtɪd",
    "deplete": "dɪpliːt",
    "depletes": "dɪpliːts",
    "depleting": "dɪpliːtɪŋ",
    "depletion": "dɪpliːʃən",
    "deplorable": "dɪplɔːrəbəl",
    "deplorably": "dɪplɔːrəbli",
    "deplored": "dɪplɔːd",
    "deplore": "dɪplɔː",
    "deplores": "dɪplɔːz",
    "deploring": "dɪplɔːrɪŋ",
    "deployable": "dɪplɔɪəbəl",
    "deploy": "dɪplɔɪ",
    "deployed": "dɪplɔɪd",
    "deploying": "dɪplɔɪɪŋ",
    "deployment": "dɪplɔɪmənt",
    "deployments": "dɪplɔɪmənts",
    "deploys": "dɪplɔɪz",
    "depolarisation": "diːpəʊləraɪzeɪʃən",
    "depoliticised": "diːpəlɪtɪsaɪzd",
    "depoliticise": "diːpəlɪtɪsaɪz",
    "depopulated": "diːpɒpjʊleɪtɪd",
    "depopulate": "diːpɒpjʊleɪt",
    "depopulating": "diːpɒpjʊleɪtɪŋ",
    "depopulation": "diːpɒpjʊleɪʃən",
    "deportation": "dɪpɔːteɪʃən",
    "deportations": "dɪpɔːteɪʃənz",
    "deport": "dɪpɔːt",
    "deported": "dɪpɔːtɪd",
    "deportees": "dɪpɔːtiːz",
    "deporting": "dɪpɔːtɪŋ",
    "deportment": "dɪpɔːtmənt",
    "deposed": "dɪpəʊzd",
    "depose": "dɪpəʊz",
    "deposing": "dɪpəʊzɪŋ",
    "deposit": "dɪpɒsɪt",
    "deposited": "dɪpɒsɪtɪd",
    "depositing": "dɪpɒsɪtɪŋ",
    "depositional": "dɛpəsɪʃənəl",
    "deposition": "dɛpəsɪʃən",
    "depositions": "dɛpəsɪʃənz",
    "depositor": "dɪpɒsɪtɐ",
    "depositories": "dɪpɒsɪtəriz",
    "depositors": "dɪpɒsɪtəz",
    "depository": "dɪpɒsɪtəri",
    "deposits": "dɪpɒsɪts",
    "depot": "dɛpəʊ",
    "depots": "dɛpəʊs",
    "depraved": "dɪpreɪvd",
    "deprave": "dɪpreɪv",
    "depraving": "dɪpreɪvɪŋ",
    "depravity": "dɪprævɪti",
    "deprecated": "dɛprɪkeɪtɪd",
    "deprecate": "dɛprɪkeɪt",
    "deprecates": "dɛprɪkeɪts",
    "deprecating": "dɛprɪkeɪtɪŋ",
    "deprecation": "dɛprɪkeɪʃən",
    "depreciated": "dɪpriːʃɪeɪtɪd",
    "depreciate": "dɪpriːʃɪeɪt",
    "depreciates": "dɪpriːʃɪeɪts",
    "depreciating": "dɪpriːʃɪeɪtɪŋ",
    "depreciation": "dɪpriːʃɪeɪʃən",
    "depredation": "dɪprɪdeɪʃən",
    "depredations": "dɪprɪdeɪʃənz",
    "depressant": "dɪprɛsənt",
    "depressants": "dɪprɛsənts",
    "depress": "dɪprɛs",
    "depressed": "dɪprɛst",
    "depresses": "dɪprɛsɪz",
    "depressing": "dɪprɛsɪŋ",
    "depressingly": "dɪprɛsɪŋli",
    "depression": "dɪprɛʃən",
    "depressions": "dɪprɛʃənz",
    "depressive": "dɪprɛsɪv",
    "depressives": "dɪprɛsɪvz",
    "depressor": "dɪprɛsɐ",
    "depressors": "dɪprɛsəz",
    "depressurised": "dɪprɛʃəraɪzd",
    "depressurise": "dɪprɛʃəraɪz",
    "depressurising": "dɪprɛʃəraɪzɪŋ",
    "deprivation": "dɪprɪveɪʃən",
    "deprivations": "dɪprɪveɪʃənz",
    "deprived": "dɪpraɪvd",
    "deprive": "dɪpraɪv",
    "deprives": "dɪpraɪvz",
    "depriving": "dɪpraɪvɪŋ",
    "depth": "dɛpθ",
    "depths": "dɛpθs",
    "deputation": "dɛpjuːteɪʃən",
    "deputed": "dɛpjuːtɪd",
    "depute": "dɛpjuːt",
    "deputes": "dɛpjuːts",
    "deputies": "dɛpjuːtɪz",
    "deputised": "dɛpjuːtaɪzd",
    "deputise": "dɛpjuːtaɪz",
    "deputises": "dɛpjuːtaɪzɪz",
    "deputising": "dɛpjuːtaɪzɪŋ",
    "deputy": "dɛpjuːti",
    "derail": "dɪreɪl",
    "derailed": "dɪreɪld",
    "derailing": "dɪreɪlɪŋ",
    "derailment": "dɪreɪlmənt",
    "derailments": "dɪreɪlmənts",
    "derails": "dɪreɪlz",
    "deranged": "dɪreɪndʒd",
    "derange": "dɪreɪndʒ",
    "derangement": "dɪreɪndʒmənt",
    "derbies": "dɑːbɪz",
    "derby": "dɑːbi",
    "deregulated": "diːrɛɡjuːleɪtɪd",
    "deregulate": "diːrɛɡjuːleɪt",
    "deregulating": "diːrɛɡjuːleɪtɪŋ",
    "deregulation": "diːrɛɡjuːleɪʃən",
    "deregulatory": "diːrɛɡjuːleɪtəri",
    "derelict": "dɛrɪlɪkt",
    "dereliction": "dɛrɪlɪkʃən",
    "derelicts": "dɛrɪlɪkts",
    "deride": "dɪraɪd",
    "derided": "dɪraɪdɪd",
    "derides": "dɪraɪdz",
    "deriding": "dɪraɪdɪŋ",
    "derision": "dɪrɪʒən",
    "derisive": "dɪraɪsɪv",
    "derisively": "dɪraɪsɪvli",
    "derisory": "dɪraɪzəri",
    "derivation": "dɛrɪveɪʃən",
    "derivations": "dɛrɪveɪʃənz",
    "derivative": "dɪrɪvətɪv",
    "derivatives": "dɪrɪvətɪvz",
    "derive": "dɪraɪv",
    "derived": "dɪraɪvd",
    "derives": "dɪraɪvz",
    "deriving": "dɪraɪvɪŋ",
    "dermabrasion": "dɜːmɐbreɪʒən",
    "derma": "dɜːmɐ",
    "dermal": "dɜːməl",
    "dermatitis": "dɜːmɐtaɪtɪs",
    "dermatological": "dɜːmɐtəlɒdʒɪkəl",
    "dermatologist": "dɜːmɐtɒlədʒɪst",
    "dermatologists": "dɜːmɐtɒlədʒɪsts",
    "dermatology": "dɜːmɐtɒlədʒi",
    "dermis": "dɜːmiz",
    "derogation": "dɛrəɡeɪʃən",
    "derogatory": "dɪrɒɡətəri",
    "derrick": "dɛrɪk",
    "derricks": "dɛrɪks",
    "derringer": "dɛrɪŋɐ",
    "derry": "dɛri",
    "derv": "dɜːv",
    "dervish": "dɜːvɪʃ",
    "dervishes": "dɜːvɪʃɪz",
    "desalination": "dɪsælɪneɪʃən",
    "desalted": "dɪsɒltɪd",
    "descaled": "dɪskeɪld",
    "descale": "dɪskeɪl",
    "descendant": "dɪsɛndənt",
    "descendants": "dɪsɛndənts",
    "descend": "dɪsɛnd",
    "descended": "dɪsɛndɪd",
    "descendent": "dɪsɛndənt",
    "descendents": "dɪsɛndənts",
    "descender": "dɪsɛndɐ",
    "descenders": "dɪsɛndəz",
    "descending": "dɪsɛndɪŋ",
    "descends": "dɪsɛndz",
    "descent": "dɪsɛnt",
    "descents": "dɪsɛnts",
    "describable": "dɪskraɪbəbəl",
    "described": "dɪskraɪbd",
    "describe": "dɪskraɪb",
    "describer": "dɪskraɪbɐ",
    "describes": "dɪskraɪbz",
    "describing": "dɪskraɪbɪŋ",
    "descried": "dɪskreɪd",
    "description": "dɪskrɪpʃən",
    "descriptions": "dɪskrɪpʃənz",
    "descriptive": "dɪskrɪptɪv",
    "descriptor": "dɪskrɪptɐ",
    "descriptors": "dɪskrɪptəz",
    "desecrated": "dɛsɪkreɪtɪd",
    "desecrate": "dɛsɪkreɪt",
    "desecrating": "dɛsɪkreɪtɪŋ",
    "desecration": "dɛsɪkreɪʃən",
    "desegregation": "diːsɛɡrɪɡeɪʃən",
    "deselect": "diːsɪlɛkt",
    "deselected": "diːsɪlɛktɪd",
    "deselection": "diːsɪlɛkʃən",
    "desensitisation": "diːsɛnsɪtaɪzeɪʃən",
    "desensitised": "diːsɛnsɪtaɪzd",
    "desensitise": "diːsɛnsɪtaɪz",
    "desensitises": "diːsɛnsɪtaɪzɪz",
    "desensitising": "diːsɛnsɪtaɪzɪŋ",
    "deserted": "dɪzɜːtɪd",
    "deserter": "dɪzɜːtɐ",
    "deserters": "dɪzɜːtəz",
    "desertification": "dɪzɜːtɪfɪkeɪʃən",
    "deserting": "dɪzɜːtɪŋ",
    "desertion": "dɪzɜːʃən",
    "desertions": "dɪzɜːʃənz",
    "deserved": "dɪzɜːvd",
    "deservedly": "dɪzɜːvɪdli",
    "deserve": "dɪzɜːv",
    "deserves": "dɪzɜːvz",
    "deserving": "dɪzɜːvɪŋ",
    "deservingly": "dɪzɜːvɪŋli",
    "desiccated": "dɛsɪkeɪtɪd",
    "desiccating": "dɛsɪkeɪtɪŋ",
    "desiccation": "dɛsɪkeɪʃən",
    "desiderata": "dɪzɪdərɑːtɐ",
    "designated": "dɛzɪɡneɪtɪd",
    "designate": "dɛzɪɡneɪt",
    "designates": "dɛzɪɡneɪts",
    "designating": "dɛzɪɡneɪtɪŋ",
    "designation": "dɛzɪɡneɪʃən",
    "designations": "dɛzɪɡneɪʃənz",
    "design": "dɪzaɪn",
    "designed": "dɪzaɪnd",
    "designer": "dɪzaɪnɐ",
    "designers": "dɪzaɪnəz",
    "designing": "dɪzaɪnɪŋ",
    "designs": "dɪzaɪnz",
    "desirability": "dɪzaɪərəbɪlɪti",
    "desirable": "dɪzaɪərəbəl",
    "desirably": "dɪzaɪərəbli",
    "desired": "dɪzaɪəd",
    "desire": "dɪzaɪə",
    "desires": "dɪzaɪəz",
    "desiring": "dɪzaɪərɪŋ",
    "desirous": "dɪzaɪərəs",
    "desist": "dɪsɪst",
    "desk": "dɛsk",
    "deskilled": "dɛskɪld",
    "desks": "dɛsks",
    "desktop": "dɛsktɒp",
    "desktops": "dɛsktɒps",
    "desolated": "dɛsələtɪd",
    "desolately": "dɛsələtli",
    "desolation": "dɛsəleɪʃən",
    "despair": "dɪspeə",
    "despaired": "dɪspeəd",
    "despairing": "dɪspeərɪŋ",
    "despairingly": "dɪspeərɪŋli",
    "despairs": "dɪspeəz",
    "despatch": "dɪspætʃ",
    "despatched": "dɪspætʃt",
    "despatches": "dɪspætʃɪz",
    "despatching": "dɪspætʃɪŋ",
    "desperado": "dɪspərɑːdəʊ",
    "desperadoes": "dɪspərɑːdəʊz",
    "desperados": "dɪspərɑːdəʊz",
    "desperate": "dɛspərət",
    "desperately": "dɛspərətli",
    "desperation": "dɛspəreɪʃən",
    "despicable": "dɪspɪkəbəl",
    "despicably": "dɪspɪkəbli",
    "despised": "dɪspaɪzd",
    "despise": "dɪspaɪz",
    "despises": "dɪspaɪzɪz",
    "despising": "dɪspaɪzɪŋ",
    "despite": "dɪspaɪt",
    "despoil": "dɪspɔɪl",
    "despoiled": "dɪspɔɪld",
    "despoiling": "dɪspɔɪlɪŋ",
    "despond": "dɪspɒnd",
    "despondency": "dɪspɒndənsi",
    "despondent": "dɪspɒndənt",
    "despot": "dɛspɒt",
    "despotic": "dɛspɒtɪk",
    "despotism": "dɛspətɪzəm",
    "despots": "dɛspɒts",
    "dessert": "dɪzɜːt",
    "desserts": "dɪzɜːts",
    "dessertspoon": "dɪzɜːtspuːn",
    "destabilisation": "diːsteɪbɪlaɪzeɪʃən",
    "destabilised": "diːsteɪbəlaɪzd",
    "destabilise": "diːsteɪbəlaɪz",
    "destabilises": "diːsteɪbəlaɪzɪz",
    "destabilising": "diːsteɪbəlaɪzɪŋ",
    "destination": "dɛstɪneɪʃən",
    "destinations": "dɛstɪneɪʃənz",
    "destined": "dɛstɪnd",
    "destine": "dɛstɪn",
    "destines": "dɛstɪnz",
    "destinies": "dɛstɪnɪz",
    "destiny": "dɛstɪni",
    "destitute": "dɛstɪtjuːt",
    "destitution": "dɛstɪtjuːʃən",
    "destroy": "dɪstrɔɪ",
    "destroyed": "dɪstrɔɪd",
    "destroyer": "dɪstrɔɪɐ",
    "destroyers": "dɪstrɔɪəz",
    "destroying": "dɪstrɔɪɪŋ",
    "destroys": "dɪstrɔɪz",
    "destruct": "dɪstrʌkt",
    "destructed": "dɪstrʌktɪd",
    "destructing": "dɪstrʌktɪŋ",
    "destruction": "dɪstrʌkʃən",
    "destructive": "dɪstrʌktɪv",
    "destructively": "dɪstrʌktɪvli",
    "destructiveness": "dɪstrʌktɪvnəs",
    "destructor": "dɪstrʌktɐ",
    "destructs": "dɪstrʌkts",
    "desuetude": "dɪsjuːətjuːd",
    "desultory": "diːsʌltəri",
    "detachable": "dɪtætʃəbəl",
    "detach": "dɪtætʃ",
    "detached": "dɪtætʃt",
    "detaches": "dɪtæʃɪz",
    "detaching": "dɪtætʃɪŋ",
    "detachment": "dɪtætʃmənt",
    "detachments": "dɪtætʃmənts",
    "detailed": "diːteɪld",
    "detailing": "diːteɪlɪŋ",
    "details": "diːteɪlz",
    "detain": "dɪteɪn",
    "detained": "dɪteɪnd",
    "detainee": "dɪteɪniː",
    "detainees": "dɪteɪniːz",
    "detaining": "dɪteɪnɪŋ",
    "detainment": "dɪteɪnmənt",
    "detains": "dɪteɪnz",
    "detectable": "dɪtɛktəbəl",
    "detect": "dɪtɛkt",
    "detected": "dɪtɛktɪd",
    "detecting": "dɪtɛktɪŋ",
    "detection": "dɪtɛkʃən",
    "detections": "dɪtɛkʃənz",
    "detective": "dɪtɛktɪv",
    "detectives": "dɪtɛktɪvz",
    "detector": "dɪtɛktɐ",
    "detectors": "dɪtɛktəz",
    "detects": "dɪtɛkts",
    "detent": "dɪtɛnt",
    "detention": "dɪtɛnʃən",
    "detentions": "dɪtɛnʃənz",
    "deter": "dɪtɜː",
    "detergent": "dɪtɜːdʒənt",
    "detergents": "dɪtɜːdʒənts",
    "deteriorated": "dɪtiəriəreɪtɪd",
    "deteriorate": "dɪtiəriəreɪt",
    "deteriorates": "dɪtiəriəreɪts",
    "deteriorating": "dɪtiəriəreɪtɪŋ",
    "deterioration": "dɪtiəriəreɪʃən",
    "determinant": "dɪtɜːmɪnənt",
    "determinants": "dɪtɜːmɪnənts",
    "determinate": "dɪtɜːmɪneɪt",
    "determinately": "dɪtɜːmɪneɪtli",
    "determination": "dɪtɜːmɪneɪʃən",
    "determinations": "dɪtɜːmɪneɪʃənz",
    "determinatives": "dɪtɜːmɪnətɪvz",
    "determined": "dɪtɜːmɪnd",
    "determinedly": "dɪtɜːmɪnɪdli",
    "determine": "dɪtɜːmɪn",
    "determines": "dɪtɜːmɪnz",
    "determining": "dɪtɜːmɪnɪŋ",
    "determinism": "dɪtɜːmɪnɪzəm",
    "determinist": "dɪtɜːmɪnɪst",
    "deterministic": "dɪtɜːmɪnɪstɪk",
    "deterred": "dɪtɜːd",
    "deterrence": "dɪtɜːrəns",
    "deterrent": "dɪtɜːrənt",
    "deterrents": "dɪtɜːrənts",
    "deterring": "dɪtɜːrɪŋ",
    "deters": "dɪtɜːz",
    "detestable": "dɪtɛstəbəl",
    "detestation": "dɪtɛsteɪʃən",
    "detest": "dɪtɛst",
    "detested": "dɪtɛstɪd",
    "detests": "dɪtɛsts",
    "dethroned": "diːθrəʊnd",
    "dethrone": "diːθrəʊn",
    "detonated": "dɛtəneɪtɪd",
    "detonate": "dɛtəneɪt",
    "detonates": "dɛtəneɪts",
    "detonating": "dɛtəneɪtɪŋ",
    "detonation": "dɛtəneɪʃən",
    "detonations": "dɛtəneɪʃənz",
    "detonator": "dɛtəneɪtɐ",
    "detonators": "dɛtəneɪtəz",
    "detour": "diːtɔː",
    "detoured": "diːtəd",
    "detours": "diːtɔːz",
    "detox": "diːtɒks",
    "detoxed": "diːtɒkst",
    "detoxes": "diːtɒksɪz",
    "detoxification": "diːtɒksɪfɪkeɪʃən",
    "detoxified": "diːtɒksɪfaɪd",
    "detoxifies": "diːtɒksɪfaɪz",
    "detoxify": "diːtɒksɪfaɪ",
    "detoxifying": "diːtɒksɪfaɪɪŋ",
    "detoxing": "diːtɒksɪŋ",
    "detract": "dɪtrækt",
    "detracted": "dɪtræktɪd",
    "detracting": "dɪtræktɪŋ",
    "detraction": "dɪtrækʃən",
    "detractor": "dɪtræktɐ",
    "detractors": "dɪtræktəz",
    "detracts": "dɪtrækts",
    "detrain": "diːtreɪn",
    "detrained": "diːtreɪnd",
    "detraining": "diːtreɪnɪŋ",
    "detrimental": "dɛtrɪmɛntəl",
    "detrimentally": "dɛtrɪmɛntəli",
    "detriment": "dɛtrɪmənt",
    "detritus": "dɪtraɪtəs",
    "deuced": "djuːst",
    "deuce": "djuːs",
    "deuces": "djuːsɪz",
    "deuterium": "djuːtiərɪəm",
    "deutschemark": "dɔɪtʃɪmɑːk",
    "deutzia": "djuːtsiɐ",
    "devaluation": "diːvæljuːeɪʃən",
    "devaluations": "diːvæljuːeɪʃənz",
    "devalued": "diːvæljuːd",
    "devalue": "diːvæljuː",
    "devalues": "diːvæljuːz",
    "devaluing": "diːvæljuːɪŋ",
    "devastated": "dɛvəsteɪtɪd",
    "devastate": "dɛvəsteɪt",
    "devastates": "dɛvəsteɪts",
    "devastating": "dɛvəsteɪtɪŋ",
    "devastatingly": "dɛvəsteɪtɪŋli",
    "devastation": "dɛvəsteɪʃən",
    "devastator": "dɛvəsteɪtɐ",
    "develop": "dɪvɛləp",
    "developed": "dɪvɛləpt",
    "developer": "dɪvɛləpɐ",
    "developers": "dɪvɛləpəz",
    "developing": "dɪvɛləpɪŋ",
    "developmental": "dɪvɛləpmɛntəl",
    "developmentally": "dɪvɛləpmɛntəli",
    "development": "dɪvɛləpmənt",
    "developments": "dɪvɛləpmənts",
    "develops": "dɪvɛləps",
    "deviance": "diːviəns",
    "deviancy": "diːvɪənsi",
    "deviant": "diːviənt",
    "deviants": "diːviənts",
    "deviated": "diːvɪeɪtɪd",
    "deviates": "diːvɪeɪts",
    "deviating": "diːvɪeɪtɪŋ",
    "deviation": "diːvɪeɪʃən",
    "deviationists": "diːvɪeɪʃənɪsts",
    "deviations": "diːvɪeɪʃənz",
    "device": "dɪvaɪs",
    "devices": "dɪvaɪsɪz",
    "devil": "dɛvəl",
    "devilfish": "dɛvɪlfɪʃ",
    "devilish": "dɛvɪlɪʃ",
    "devilishly": "dɛvɪlɪʃli",
    "devilishness": "dɛvɪlɪʃnəs",
    "devilled": "dɛvəld",
    "devilling": "dəvɪlɪŋ",
    "devilment": "dɛvəlmənt",
    "devilry": "dɛvɪlri",
    "devils": "dɛvəlz",
    "devious": "diːvɪəs",
    "deviously": "diːvɪəsli",
    "deviousness": "diːvɪəsnəs",
    "devised": "dɪvaɪzd",
    "devise": "dɪvaɪz",
    "devisers": "dɪvaɪzəz",
    "devises": "dɪvaɪzɪz",
    "devising": "dɪvaɪzɪŋ",
    "devoid": "dɪvɔɪd",
    "devoir": "dɪvwɑː",
    "devolutionary": "dɪvəluːʃənəri",
    "devolution": "dɪvəluːʃən",
    "devolutionist": "dɪvəluːʃənɪst",
    "devolved": "dɪvɒlvd",
    "devolve": "dɪvɒlv",
    "devolves": "dɪvɒlvz",
    "devolving": "dɪvɒlvɪŋ",
    "devoted": "dɪvəʊtɪd",
    "devotedly": "dɪvəʊtɪdli",
    "devote": "dɪvəʊt",
    "devotee": "dɛvəʊtiː",
    "devotees": "dɛvəʊtiːz",
    "devotes": "dɪvəʊts",
    "devoting": "dɪvəʊtɪŋ",
    "devotional": "dɪvəʊʃənəl",
    "devotion": "dɪvəʊʃən",
    "devotions": "dɪvəʊʃənz",
    "devour": "dɪvaʊə",
    "devoured": "dɪvaʊəd",
    "devourer": "dɪvaʊərɐ",
    "devouring": "dɪvaʊərɪŋ",
    "devours": "dɪvaʊəz",
    "devout": "dɪvaʊt",
    "devoutly": "dɪvaʊtli",
    "dewberry": "djuːbəri",
    "dew": "djuː",
    "dewdrop": "djuːdrɒp",
    "dewdrops": "djuːdrɒps",
    "dewlap": "djuːlæp",
    "dews": "djuːz",
    "dewy": "djuːi",
    "dexamethasone": "dɛksɐmɛθɐsəʊn",
    "dexter": "dɛkstɐ",
    "dexterity": "dɛkstɛrɪti",
    "dexterous": "dɛkstərəs",
    "dextro": "dɛkstrəʊ",
    "dextrose": "dɛkstrəʊz",
    "dextrous": "dɛkstrəs",
    "dey": "deɪ",
    "dg": "diːdʒiː",
    "dharma": "dɑːmɐ",
    "dhobi": "dəʊbaɪ",
    "dhole": "dəʊl",
    "dholes": "dəʊlz",
    "dhoti": "dəʊti",
    "dhow": "diːhaʊ",
    "dhows": "diːhaʊz",
    "diabetes": "daɪəbiːtiːz",
    "diabetic": "daɪəbɛtɪk",
    "diabetics": "daɪəbɛtɪks",
    "diabolical": "daɪəbɒlɪkəl",
    "diabolically": "daɪəbɒlɪkli",
    "diabolic": "daɪəbɒlɪk",
    "diabolo": "daɪæbələʊ",
    "diacritic": "daɪəkrɪtɪk",
    "diadem": "daɪədəm",
    "diagnose": "daɪəɡnəʊz",
    "diagnosed": "daɪəɡnəʊzd",
    "diagnosing": "daɪəɡnəʊzɪŋ",
    "diagnosis": "daɪəɡnəʊsɪs",
    "diagnostic": "daɪəɡnɒstɪk",
    "diagnostician": "daɪəɡnəstɪʃən",
    "diagnostics": "daɪəɡnɒstɪks",
    "diagonal": "daɪæɡənəl",
    "diagonally": "daɪæɡənəli",
    "diagonals": "daɪæɡənəlz",
    "diagram": "daɪəɡræm",
    "diagrammatic": "daɪəɡrɐmætɪk",
    "diagrams": "daɪəɡræmz",
    "dial": "daɪəl",
    "dialect": "daɪəlɛkt",
    "dialectical": "daɪəlɛktɪkəl",
    "dialectic": "daɪəlɛktɪk",
    "dialectics": "daɪəlɛktɪks",
    "dialects": "daɪəlɛkts",
    "dialled": "daɪəld",
    "dialler": "daɪəlɐ",
    "dialling": "daɪəlɪŋ",
    "dialog": "daɪəlɒɡ",
    "dialogue": "daɪəlɒɡ",
    "dialogues": "daɪəlɒɡz",
    "dials": "daɪəlz",
    "dialyse": "daɪəlaɪz",
    "dialysis": "daɪələsɪs",
    "diamagnetism": "daɪəmæɡnɪtɪzəm",
    "diameter": "daɪæmɪtɐ",
    "diameters": "daɪæmɪtəz",
    "diametrically": "daɪəmɛtrɪkli",
    "diametric": "daɪəmɛtrɪk",
    "diamondback": "daɪəməndbæk",
    "diamond": "daɪəmənd",
    "diamonds": "daɪəməndz",
    "dianetics": "daɪænɛtɪks",
    "dianthus": "daɪænθəs",
    "diaper": "daɪpɐ",
    "diapers": "daɪpəz",
    "diaphanous": "daɪæfənəs",
    "diaphoretic": "daɪəfɔːrɛtɪk",
    "diaphragmatic": "daɪəfrɐɡmætɪk",
    "diaphragm": "daɪəfræm",
    "diaphragms": "daɪəfræmz",
    "diaries": "daɪərɪz",
    "diarist": "daɪərɪst",
    "diarists": "daɪərɪsts",
    "diarrhoea": "daɪəriə",
    "diarrhoeal": "daɪəriəl",
    "diary": "daɪəri",
    "diaspora": "daɪæspərɐ",
    "diastole": "daɪəstəʊl",
    "diastolic": "daɪəstɒlɪk",
    "diathermy": "daɪəθəmi",
    "diatomaceous": "daɪətəmeɪʃəs",
    "diatomic": "daɪətɒmɪk",
    "diatoms": "daɪətəmz",
    "diatonic": "daɪətɒnɪk",
    "diatribe": "daɪətraɪb",
    "diatribes": "daɪətraɪbz",
    "diazepam": "daɪəzɛpæm",
    "dibble": "dɪbəl",
    "dib": "dɪb",
    "dibs": "dɪbz",
    "dice": "daɪs",
    "diced": "daɪst",
    "dicentra": "daɪsəntrɐ",
    "dices": "daɪsɪz",
    "dicey": "daɪsi",
    "dichotomy": "daɪkɒtəmi",
    "dichromate": "daɪkrəʊmeɪt",
    "dicing": "daɪsɪŋ",
    "dick": "dɪk",
    "dickens": "dɪkənz",
    "dicker": "dɪkɐ",
    "dickering": "dɪkərɪŋ",
    "dickey": "dɪki",
    "dickhead": "dɪkhɛd",
    "dickheads": "dɪkhɛdz",
    "dickie": "dɪki",
    "dicks": "dɪks",
    "dickybird": "dɪkɪbɜːd",
    "dicky": "dɪki",
    "dicot": "dɪkɒt",
    "dicta": "dɪktɐ",
    "dictated": "dɪkteɪtɪd",
    "dictating": "dɪkteɪtɪŋ",
    "dictation": "dɪkteɪʃən",
    "dictator": "dɪkteɪtɐ",
    "dictatorial": "dɪktɐtɔːrɪəl",
    "dictators": "dɪkteɪtəz",
    "dictatorship": "dɪkteɪtəʃɪp",
    "dictatorships": "dɪkteɪtəʃɪps",
    "dictionaries": "dɪkʃənəriz",
    "dictionary": "dɪkʃənəri",
    "diction": "dɪkʃən",
    "dictum": "dɪktəm",
    "dictums": "dɪktəmz",
    "didactic": "dɪdæktɪk",
    "didacticism": "dɪdæktɪsɪzəm",
    "did": "dɪd",
    "diddled": "dɪdəld",
    "diddle": "dɪdəl",
    "diddler": "dɪdlɐ",
    "diddling": "dɪdlɪŋ",
    "diddly": "dɪdli",
    "diddums": "dɪdəmz",
    "didgeridoo": "dɪdʒrɪduː",
    "didgeridoos": "dɪdʒrɪduːz",
    "dido": "diːdəʊ",
    "didst": "dɪdst",
    "dieback": "daɪbæk",
    "die": "daɪ",
    "died": "daɪd",
    "diehard": "daɪhɑːd",
    "diehards": "daɪhɑːdz",
    "dielectric": "daɪəlɛktrɪk",
    "dies": "daɪz",
    "diesel": "diːzəl",
    "diesels": "diːzəlz",
    "dietary": "daɪətəri",
    "diet": "daɪət",
    "dieted": "daɪətɪd",
    "dieters": "daɪətəz",
    "dietetic": "daɪətɛtɪk",
    "dietetics": "daɪətɛtɪks",
    "dietician": "daɪətɪʃən",
    "dieticians": "daɪətɪʃənz",
    "dieting": "daɪətɪŋ",
    "dietitian": "daɪətɪʃən",
    "dietitians": "daɪətɪʃənz",
    "diets": "daɪəts",
    "differ": "dɪfɐ",
    "differed": "dɪfəd",
    "difference": "dɪfrəns",
    "differences": "dɪfrənsɪz",
    "different": "dɪfrənt",
    "differentiable": "dɪfərɛnʃɪəbəl",
    "differential": "dɪfərɛnʃəl",
    "differentials": "dɪfərɛnʃəlz",
    "differentiated": "dɪfərɛnʃɪeɪtɪd",
    "differentiate": "dɪfərɛnʃɪeɪt",
    "differentiates": "dɪfərɛnʃɪeɪts",
    "differentiating": "dɪfərɛnʃɪeɪtɪŋ",
    "differentiation": "dɪfərɛnʃɪeɪʃən",
    "differentiator": "dɪfərɛnʃɪeɪtɐ",
    "differently": "dɪfrəntli",
    "differing": "dɪfərɪŋ",
    "differs": "dɪfəz",
    "difficile": "dɪfɪsaɪl",
    "difficult": "dɪfɪkəlt",
    "difficulties": "dɪfɪkʌltɪz",
    "difficultly": "dɪfɪkəltli",
    "difficulty": "dɪfɪkʌlti",
    "diffidence": "dɪfɪdəns",
    "diffident": "dɪfɪdənt",
    "diffract": "dɪfrækt",
    "diffracted": "dɪfræktɪd",
    "diffracting": "dɪfræktɪŋ",
    "diffraction": "dɪfrækʃən",
    "diffused": "dɪfjuːzd",
    "diffuser": "dɪfjuːsɐ",
    "diffuses": "dɪfjuːzɪz",
    "diffusing": "dɪfjuːzɪŋ",
    "diffusion": "dɪfjuːʒən",
    "dig": "dɪɡ",
    "digested": "daɪdʒɛstɪd",
    "digester": "daɪdʒɛstɐ",
    "digesters": "daɪdʒɛstəz",
    "digestible": "daɪdʒɛstəbəl",
    "digesting": "daɪdʒɛstɪŋ",
    "digestion": "daɪdʒɛstʃən",
    "digestive": "daɪdʒɛstɪv",
    "digestives": "daɪdʒɛstɪvz",
    "digged": "dɪɡd",
    "digger": "dɪɡɐ",
    "diggers": "dɪɡəz",
    "digging": "dɪɡɪŋ",
    "dight": "daɪt",
    "digital": "dɪdʒɪtəl",
    "digitalis": "dɪdʒɪtɑːlis",
    "digitally": "dɪdʒɪtəli",
    "digit": "dɪdʒɪt",
    "digitisation": "dɪdʒɪtaɪzeɪʃən",
    "digitised": "dɪdʒɪtaɪzd",
    "digitise": "dɪdʒɪtaɪz",
    "digitising": "dɪdʒɪtaɪzɪŋ",
    "digits": "dɪdʒɪts",
    "dignified": "dɪɡnɪfaɪd",
    "dignifies": "dɪɡnɪfaɪz",
    "dignify": "dɪɡnɪfaɪ",
    "dignifying": "dɪɡnɪfaɪɪŋ",
    "dignitaries": "dɪɡnɪtəriz",
    "dignitary": "dɪɡnɪtəri",
    "dignities": "dɪɡnɪtiz",
    "dignity": "dɪɡnɪti",
    "digress": "daɪɡrɛs",
    "digressed": "daɪɡrɛst",
    "digresses": "daɪɡrɛsɪz",
    "digressing": "daɪɡrɛsɪŋ",
    "digression": "daɪɡrɛʃən",
    "digressive": "daɪɡrɛsɪv",
    "digs": "dɪɡz",
    "dike": "daɪk",
    "dikes": "daɪks",
    "diktat": "dɪktæt",
    "diktats": "dɪktæts",
    "dilapidated": "dɪlɐpɪdeɪtɪd",
    "dilapidation": "dɪlɐpɪdeɪʃən",
    "dilatation": "daɪlɐteɪʃən",
    "dilate": "daɪleɪt",
    "dilated": "daɪleɪtɪd",
    "dilates": "daɪleɪts",
    "dilating": "daɪleɪtɪŋ",
    "dilation": "daɪleɪʃən",
    "dilator": "daɪleɪtɐ",
    "dilatory": "dɪlətəri",
    "dildo": "dɪldəʊ",
    "dildos": "dɪldəʊz",
    "dilemma": "daɪlɛmɐ",
    "dilemmas": "daɪlɛməz",
    "dilettante": "daɪltɑːnteɪ",
    "diligence": "dɪlɪdʒəns",
    "diligent": "dɪlɪdʒənt",
    "diligently": "dɪlɪdʒəntli",
    "dill": "dɪl",
    "dills": "dɪlz",
    "dillydallying": "dɪlɪdiɪŋ",
    "dilly": "dɪli",
    "dilute": "daɪluːt",
    "diluted": "daɪluːtɪd",
    "dilutes": "daɪluːts",
    "diluting": "daɪluːtɪŋ",
    "dilution": "daɪluːʃən",
    "dilutions": "daɪluːʃənz",
    "dim": "dɪm",
    "dime": "daɪm",
    "dimensional": "daɪmɛnʃənəl",
    "dimensionality": "daɪmɛnʃənælɪti",
    "dimensionally": "daɪmɛnʃənəli",
    "dimension": "daɪmɛnʃən",
    "dimensioning": "daɪmɛnʃənɪŋ",
    "dimensionless": "daɪmɛnʃənləs",
    "dimensions": "daɪmɛnʃənz",
    "dimer": "daɪmɐ",
    "dimes": "daɪmz",
    "diminish": "dɪmɪnɪʃ",
    "diminished": "dɪmɪnɪʃt",
    "diminishes": "dɪmɪnɪʃɪz",
    "diminishing": "dɪmɪnɪʃɪŋ",
    "diminishment": "dɪmɪnɪʃmənt",
    "diminuendo": "dɪmɪnjuːɛndəʊ",
    "diminution": "dɪmɪnjuːʃən",
    "diminutive": "dɪmɪnjuːtɪv",
    "dimly": "dɪmli",
    "dimmed": "dɪmd",
    "dimmer": "dɪmɐ",
    "dimmers": "dɪməz",
    "dimmest": "dɪməst",
    "dimming": "dɪmɪŋ",
    "dimness": "dɪmnəs",
    "dimorphism": "dɪmɔːfɪzəm",
    "dimpled": "dɪmpəld",
    "dimple": "dɪmpəl",
    "dimples": "dɪmpəlz",
    "dimpling": "dɪmplɪŋ",
    "dimply": "dɪmpli",
    "dims": "dɪmz",
    "dimwit": "dɪmwɪt",
    "dimwits": "dɪmwɪts",
    "dinar": "dɪnɑː",
    "dinars": "dɪnɑːz",
    "din": "dɪn",
    "dine": "daɪn",
    "dined": "daɪnd",
    "diner": "daɪnɐ",
    "diners": "daɪnəz",
    "dines": "daɪnz",
    "dinette": "daɪnɛt",
    "dingbat": "dɪŋbæt",
    "dingbats": "dɪŋbæts",
    "ding": "dɪŋ",
    "dingdong": "dɪŋdɒŋ",
    "dinged": "dɪndʒd",
    "dinge": "dɪndʒ",
    "dinghies": "dɪŋɡiz",
    "dinghy": "dɪŋɡi",
    "dingier": "dɪndʒɪɐ",
    "dinginess": "dɪndʒɪnəs",
    "dinging": "dɪŋɪŋ",
    "dingle": "dɪŋɡəl",
    "dingles": "dɪŋɡəlz",
    "dingo": "dɪŋɡəʊ",
    "dingoes": "dɪŋɡəʊz",
    "dings": "dɪŋz",
    "dining": "daɪnɪŋ",
    "dink": "dɪŋk",
    "dinkier": "dɪŋkiɐ",
    "dinkies": "dɪŋkiz",
    "dinkiest": "dɪŋkiəst",
    "dinky": "dɪŋki",
    "dinner": "dɪnɐ",
    "dinners": "dɪnəz",
    "dinnertime": "dɪnətaɪm",
    "dinnerware": "dɪnəweə",
    "dinning": "dɪnɪŋ",
    "dinosaur": "daɪnəsɔː",
    "dinosaurs": "daɪnəsɔːz",
    "dins": "dɪnz",
    "dint": "dɪnt",
    "dints": "dɪnts",
    "diocesan": "dɪəʊssən",
    "diocese": "dɪəʊsiːz",
    "dioceses": "dɪəʊsiːzɪz",
    "diode": "daɪəʊd",
    "diodes": "daɪəʊdz",
    "dionysian": "daɪənɪziən",
    "diopside": "dɪɒpsaɪd",
    "dioptre": "dɪɒptɐ",
    "diorama": "dɪəræmɐ",
    "dioramas": "dɪəræməz",
    "dioxide": "daɪɒksaɪd",
    "dioxides": "daɪɒksaɪdz",
    "dioxin": "daɪɒksɪn",
    "dioxins": "daɪɒksɪnz",
    "dip": "dɪp",
    "diphenyl": "dɪfiːnaɪl",
    "diphtheria": "dɪfθiərɪɐ",
    "diphthong": "dɪfθɒŋ",
    "diphthongs": "dɪfθɒŋz",
    "diphyodont": "dɪfɪɒdɒnt",
    "diplegia": "dɪpliːdʒɐ",
    "diplodocus": "dɪplədɒkəs",
    "diploid": "dɪplɔɪd",
    "diplomacy": "dɪpləʊməsi",
    "diploma": "dɪpləʊmɐ",
    "diplomas": "dɪpləʊməz",
    "diplomat": "dɪpləmæt",
    "diplomatically": "dɪpləmætɪkli",
    "diplomatic": "dɪpləmætɪk",
    "diplomats": "dɪpləmæts",
    "dipped": "dɪpt",
    "dipper": "dɪpɐ",
    "dippers": "dɪpəz",
    "dippier": "dɪpɪɐ",
    "dipping": "dɪpɪŋ",
    "dippy": "dɪpi",
    "dips": "dɪps",
    "dipsomaniac": "dɪpsəmeɪnɪæk",
    "dipsomania": "dɪpsəmeɪniə",
    "dipstick": "dɪpstɪk",
    "dipsticks": "dɪpstɪks",
    "diptych": "dɪptɪtʃ",
    "direct": "daɪrɛkt",
    "directed": "daɪrɛktɪd",
    "directing": "daɪrɛktɪŋ",
    "directional": "daɪrɛkʃənəl",
    "directionality": "daɪrɛkʃənælɪti",
    "direction": "daɪrɛkʃən",
    "directionless": "daɪrɛkʃənləs",
    "directions": "daɪrɛkʃənz",
    "directive": "daɪrɛktɪv",
    "directives": "daɪrɛktɪvz",
    "directly": "daɪrɛktli",
    "directness": "daɪrɛktnəs",
    "directorate": "daɪrɛktəreɪt",
    "director": "daɪrɛktɐ",
    "directorial": "daɪrɪktɔːrɪəl",
    "directories": "daɪrɛktəriz",
    "directors": "daɪrɛktəz",
    "directorship": "daɪrɛktəʃɪp",
    "directorships": "daɪrɛktəʃɪps",
    "directory": "daɪrɛktəri",
    "directs": "daɪrɛkts",
    "dire": "daɪə",
    "direly": "daɪəli",
    "direst": "daɪəst",
    "dirge": "dɜːdʒ",
    "dirges": "dɜːdʒɪz",
    "dirham": "dɜːrəm",
    "dirhams": "dɜːræmz",
    "dirigible": "dɪrɪdʒəbəl",
    "dirigibles": "dɪrɪdʒəbəlz",
    "dirk": "dɜːk",
    "dirks": "dɜːks",
    "dirndl": "dɜːndəl",
    "dirt": "dɜːt",
    "dirtied": "dɜːtɪd",
    "dirtier": "dɜːtɪɐ",
    "dirties": "dɜːtɪz",
    "dirtiest": "dɜːtɪəst",
    "dirtiness": "dɜːtɪnəs",
    "dirty": "dɜːti",
    "dirtying": "dɜːtɪɪŋ",
    "disabilities": "dɪsɐbɪlətiz",
    "disability": "dɪsɐbɪləti",
    "disabled": "dɪseɪbəld",
    "disable": "dɪseɪbəl",
    "disablement": "dɪseɪbəlmənt",
    "disables": "dɪseɪbəlz",
    "disabling": "dɪseɪblɪŋ",
    "disabused": "dɪsɐbjuːsd",
    "disabuse": "dɪsɐbjuːs",
    "disadvantaged": "dɪsɐdvɑːntɪdʒd",
    "disadvantage": "dɪsɐdvɑːntɪdʒ",
    "disadvantageous": "dɪsɐdvɑːnteɪdʒəs",
    "disadvantageously": "dɪsɐdvɑːnteɪdʒəsli",
    "disadvantages": "dɪsɐdvɑːntɪdʒɪz",
    "disadvantaging": "dɪsɐdvɑːntɪdʒɪŋ",
    "disaffected": "dɪsɐfɛktɪd",
    "disaffection": "dɪsɐfɛkʃən",
    "disagreeable": "dɪsɐɡriːəbəl",
    "disagreed": "dɪsɐɡriːd",
    "disagree": "dɪsɐɡriː",
    "disagreeing": "dɪsɐɡriːɪŋ",
    "disagreement": "dɪsɐɡriːmənt",
    "disagreements": "dɪsɐɡriːmənts",
    "disagrees": "dɪsɐɡriːz",
    "disallowance": "dɪsɐlaʊəns",
    "disallow": "dɪsɐlaʊ",
    "disallowed": "dɪsɐlaʊd",
    "disallowing": "dɪsɐlaʊɪŋ",
    "disallows": "dɪsɐlaʊz",
    "disappearance": "dɪsɐpiərəns",
    "disappearances": "dɪsɐpiərənsɪz",
    "disappear": "dɪsɐpiə",
    "disappeared": "dɪsɐpiəd",
    "disappearing": "dɪsɐpiərɪŋ",
    "disappears": "dɪsɐpiəz",
    "disappoint": "dɪsɐpɔɪnt",
    "disappointed": "dɪsɐpɔɪntɪd",
    "disappointing": "dɪsɐpɔɪntɪŋ",
    "disappointingly": "dɪsɐpɔɪntɪŋli",
    "disappointment": "dɪsɐpɔɪntmənt",
    "disappointments": "dɪsɐpɔɪntmənts",
    "disappoints": "dɪsɐpɔɪnts",
    "disapprobation": "dɪsɐprəbeɪʃən",
    "disapproval": "dɪsɐpruːvəl",
    "disapproved": "dɪsɐpruːvd",
    "disapprove": "dɪsɐpruːv",
    "disapproves": "dɪsɐpruːvz",
    "disapproving": "dɪsɐpruːvɪŋ",
    "disapprovingly": "dɪsɐpruːvɪŋli",
    "disarmament": "dɪsɑːməmənt",
    "disarm": "dɪsɑːm",
    "disarmed": "dɪsɑːmd",
    "disarming": "dɪsɑːmɪŋ",
    "disarmingly": "dɪsɑːmɪŋli",
    "disarms": "dɪsɑːmz",
    "disarranged": "dɪsɐreɪndʒd",
    "disarrange": "dɪsɐreɪndʒ",
    "disarray": "dɪsɐreɪ",
    "disassembled": "dɪsɐsɛmbəld",
    "disassemble": "dɪsɐsɛmbəl",
    "disassembling": "dɪsɐsɛmblɪŋ",
    "disassembly": "dɪsɐsɛmbli",
    "disassociated": "dɪsɐsəʊsɪeɪtɪd",
    "disassociate": "dɪsɐsəʊsɪeɪt",
    "disassociating": "dɪsɐsəʊsɪeɪtɪŋ",
    "disassociation": "dɪsɐsəʊsɪeɪʃən",
    "disaster": "dɪsɑːstɐ",
    "disasters": "dɪsɑːstəz",
    "disastrous": "dɪsæstrəs",
    "disastrously": "dɪsæstrəsli",
    "disavowal": "dɪsɐvaʊəl",
    "disavow": "dɪsɐvaʊ",
    "disavowed": "dɪsɐvaʊd",
    "disavowing": "dɪsɐvaʊɪŋ",
    "disband": "dɪsbænd",
    "disbanded": "dɪsbændɪd",
    "disbanding": "dɪsbændɪŋ",
    "disbandment": "dɪsbændmənt",
    "disbar": "dɪsbɑː",
    "disbarment": "dɪsbɑːmənt",
    "disbarred": "dɪsbɑːd",
    "disbelief": "dɪsbɪliːf",
    "disbelieved": "dɪsbɪliːvd",
    "disbelieve": "dɪsbɪliːv",
    "disbeliever": "dɪsbɪliːvɐ",
    "disbelievers": "dɪsbɪliːvəz",
    "disbelieving": "dɪsbɪliːvɪŋ",
    "disbelievingly": "dɪsbɪliːvɪŋli",
    "disbud": "dɪsbʌd",
    "disbursed": "dɪsbɜːsd",
    "disburse": "dɪsbɜːs",
    "disbursement": "dɪsbɜːsmənt",
    "disbursements": "dɪsbɜːsmənts",
    "disbursing": "dɪsbɜːsɪŋ",
    "discarded": "dɪskɑːdɪd",
    "discarding": "dɪskɑːdɪŋ",
    "disc": "dɪsk",
    "discern": "dɪsɜːn",
    "discerned": "dɪsɜːnd",
    "discernible": "dɪsɜːnəbəl",
    "discernibly": "dɪsɜːnəbli",
    "discerning": "dɪsɜːnɪŋ",
    "discernment": "dɪsɜːnmənt",
    "discharged": "dɪstʃɑːdʒd",
    "discharging": "dɪstʃɑːdʒɪŋ",
    "disciple": "dɪsaɪpəl",
    "disciples": "dɪsaɪpəlz",
    "discipleship": "dɪsaɪpəlʃɪp",
    "disciplinarian": "dɪsɪplɪneəriən",
    "disciplinarians": "dɪsɪplɪneəriənz",
    "disciplinary": "dɪsɪplɪnəri",
    "disciplined": "dɪsɪplɪnd",
    "discipline": "dɪsɪplɪn",
    "disciplines": "dɪsɪplɪnz",
    "disciplining": "dɪsɪplɪnɪŋ",
    "disclaimer": "dɪskleɪmɐ",
    "disclaimers": "dɪskleɪməz",
    "disclaiming": "dɪskleɪmɪŋ",
    "disclosed": "dɪskləʊzd",
    "disclose": "dɪskləʊz",
    "discloses": "dɪskləʊzɪz",
    "disclosing": "dɪskləʊzɪŋ",
    "disclosure": "dɪskləʊʒɐ",
    "disclosures": "dɪskləʊʒəz",
    "disco": "dɪskəʊ",
    "discoed": "dɪskəʊd",
    "discography": "dɪskɒɡrəfi",
    "discoid": "dɪskɔɪd",
    "discoing": "dɪskəʊɪŋ",
    "discoloration": "dɪskʌləreɪʃən",
    "discolouration": "dɪskʌləreɪʃən",
    "discolour": "dɪskʌlɐ",
    "discoloured": "dɪskʌləd",
    "discolouring": "dɪskʌlɜːrɪŋ",
    "discolours": "dɪskʌləz",
    "discombobulated": "dɪskəmbɒbjʊleɪtɪd",
    "discombobulate": "dɪskəmbɒbjʊleɪt",
    "discombobulating": "dɪskəmbɒbjʊleɪtɪŋ",
    "discombobulation": "dɪskɒmbəbjʊleɪʃən",
    "discomfited": "dɪskɒmfɪtɪd",
    "discomfiting": "dɪskɒmfɪtɪŋ",
    "discomfiture": "dɪskɒmfɪtʃɐ",
    "discomfortable": "dɪskʌmftəbəl",
    "discomfort": "dɪskʌmfət",
    "discomforted": "dɪskʌmfətɪd",
    "discomforting": "dɪskʌmfətɪŋ",
    "discomforts": "dɪskʌmfəts",
    "discompose": "dɪskɒmpəʊz",
    "disconcert": "dɪskənsɜːt",
    "disconcerted": "dɪskənsɜːtɪd",
    "disconcerting": "dɪskənsɜːtɪŋ",
    "disconcertingly": "dɪskənsɜːtɪŋli",
    "disconnect": "dɪskənɛkt",
    "disconnected": "dɪskənɛktɪd",
    "disconnectedness": "dɪskənɛktɪdnəs",
    "disconnecting": "dɪskənɛktɪŋ",
    "disconnection": "dɪskənɛkʃən",
    "disconnections": "dɪskənɛkʃənz",
    "disconnects": "dɪskənɛkts",
    "disconsolate": "dɪskɒnsələt",
    "discontent": "dɪskəntɛnt",
    "discontented": "dɪskəntɛntɪd",
    "discontentment": "dɪskəntɛntmənt",
    "discontents": "dɪskəntɛnts",
    "discontinuation": "dɪskəntɪnjuːeɪʃən",
    "discontinued": "dɪskəntɪnjuːd",
    "discontinue": "dɪskəntɪnjuː",
    "discontinuities": "dɪskəntɪnjuːɪtiz",
    "discontinuity": "dɪskəntɪnjuːɪti",
    "discordant": "dɪskɔːdənt",
    "discords": "dɪskɔːdz",
    "discos": "dɪskəʊz",
    "discotheque": "dɪskətɛk",
    "discotheques": "dɪskətɛkz",
    "discounted": "dɪskaʊntɪd",
    "discounter": "dɪskaʊntɐ",
    "discounters": "dɪskaʊntəz",
    "discounting": "dɪskaʊntɪŋ",
    "discouraged": "dɪskʌrɪdʒd",
    "discourage": "dɪskʌrɪdʒ",
    "discouragement": "dɪskʌrɪdʒmənt",
    "discourages": "dɪskʌrɪdʒɪz",
    "discouraging": "dɪskʌrɪdʒɪŋ",
    "discourteous": "dɪskɜːtiəs",
    "discourtesy": "dɪskɜːtəsi",
    "discover": "dɪskʌvɐ",
    "discovered": "dɪskʌvəd",
    "discoverer": "dɪskʌvərɐ",
    "discoverers": "dɪskʌvərəz",
    "discoveries": "dɪskʌvərɪz",
    "discovering": "dɪskʌvərɪŋ",
    "discovers": "dɪskʌvəz",
    "discovery": "dɪskʌvəri",
    "discreditable": "dɪskrɛdɪtəbəl",
    "discredit": "dɪskrɛdɪt",
    "discredited": "dɪskrɛdɪtɪd",
    "discrediting": "dɪskrɛdɪtɪŋ",
    "discredits": "dɪskrɛdɪts",
    "discreet": "dɪskriːt",
    "discreetly": "dɪskriːtli",
    "discrepancies": "dɪskrɛpənsɪz",
    "discrepancy": "dɪskrɛpənsi",
    "discrete": "dɪskriːt",
    "discretely": "dɪskriːtli",
    "discretionary": "dɪskrɛʃənəri",
    "discretion": "dɪskrɛʃən",
    "discriminant": "dɪskrɪmɪnənt",
    "discriminated": "dɪskrɪmɪneɪtɪd",
    "discriminate": "dɪskrɪmɪneɪt",
    "discriminates": "dɪskrɪmɪneɪts",
    "discriminating": "dɪskrɪmɪneɪtɪŋ",
    "discrimination": "dɪskrɪmɪneɪʃən",
    "discriminator": "dɪskrɪmɪneɪtɐ",
    "discriminatory": "dɪskrɪmɪnətəri",
    "discs": "dɪsks",
    "discursive": "dɪskɜːsɪv",
    "discus": "dɪskəs",
    "discuses": "dɪskʌzɪz",
    "discussable": "dɪskʌsəbəl",
    "discuss": "dɪskʌs",
    "discussed": "dɪskʌst",
    "discusses": "dɪskʌsɪz",
    "discussing": "dɪskʌsɪŋ",
    "discussion": "dɪskʌʃən",
    "discussions": "dɪskʌʃənz",
    "disdain": "dɪsdeɪn",
    "disdained": "dɪsdeɪnd",
    "disdainful": "dɪsdeɪnfəl",
    "disdainfully": "dɪsdeɪnfəli",
    "dis": "dɪs",
    "diseased": "dɪziːzd",
    "disease": "dɪziːz",
    "diseases": "dɪziːzɪz",
    "disembarkation": "dɪsɛmbɑːkeɪʃən",
    "disembark": "dɪsɛmbɑːk",
    "disembarked": "dɪsɛmbɑːkt",
    "disembarking": "dɪsɛmbɑːkɪŋ",
    "disembarks": "dɪsɛmbɑːks",
    "disembodied": "dɪsɛmbɒdɪd",
    "disembowel": "dɪsɛmbaʊəl",
    "disembowelled": "dɪsɛmbaʊəld",
    "disembowelling": "dɪsɛmbaʊəlɪŋ",
    "disembowelment": "dɪsɛmbaʊəlmənt",
    "disenchanted": "dɪsɛntʃɑːntɪd",
    "disenchantment": "dɪsɛntʃɑːntmənt",
    "disenfranchised": "dɪsɛnfrɑːntʃaɪzd",
    "disenfranchise": "dɪsɛnfrɑːntʃaɪz",
    "disenfranchisement": "dɪsɛnfrɑːntʃaɪzmənt",
    "disenfranchises": "dɪsɛnfrɑːntʃaɪzɪz",
    "disenfranchising": "dɪsɛnfrɑːntʃaɪzɪŋ",
    "disengaged": "dɪsɛnɡeɪdʒd",
    "disengage": "dɪsɛnɡeɪdʒ",
    "disengagement": "dɪsɛnɡeɪdʒmənt",
    "disengages": "dɪsɛnɡeɪdʒɪz",
    "disengaging": "dɪsɛnɡeɪdʒɪŋ",
    "disentangled": "dɪsɛntæŋɡəld",
    "disentangle": "dɪsɛntæŋɡəl",
    "disentangles": "dɪsɛntæŋɡəlz",
    "disentangling": "dɪsɛntæŋɡəlɪŋ",
    "disestablish": "dɪsɪstæblɪʃ",
    "disestablished": "dɪsɪstæblɪʃt",
    "disestablishment": "dɪsɪstæblɪʃmənt",
    "diseuse": "dɪsjuːs",
    "disfavour": "dɪsfeɪvɐ",
    "disfigured": "dɪsfɪɡəd",
    "disfigure": "dɪsfɪɡɐ",
    "disfigurement": "dɪsfɪɡəmənt",
    "disfigurements": "dɪsfɪɡəmənts",
    "disfiguring": "dɪsfɪɡərɪŋ",
    "disgorged": "dɪsɡɔːdʒd",
    "disgorge": "dɪsɡɔːdʒ",
    "disgorges": "dɪsɡɔːdʒɪz",
    "disgorging": "dɪsɡɔːdʒɪŋ",
    "disgraced": "dɪsɡreɪst",
    "disgrace": "dɪsɡreɪs",
    "disgraceful": "dɪsɡreɪsfəl",
    "disgracefully": "dɪsɡreɪsfəli",
    "disgraces": "dɪsɡreɪsɪz",
    "disgracing": "dɪsɡreɪsɪŋ",
    "disgruntled": "dɪsɡrʌntəld",
    "disgruntlement": "dɪsɡrʌntəlmənt",
    "disguised": "dɪsɡaɪzd",
    "disguise": "dɪsɡaɪz",
    "disguises": "dɪsɡaɪzɪz",
    "disguising": "dɪsɡaɪzɪŋ",
    "disgust": "dɪsɡʌst",
    "disgusted": "dɪsɡʌstɪd",
    "disgusting": "dɪsɡʌstɪŋ",
    "disgustingly": "dɪsɡʌstɪŋli",
    "disgusts": "dɪsɡʌsts",
    "disharmony": "dɪshɑːməni",
    "dishcloth": "dɪʃklɒθ",
    "dishcloths": "dɪʃklɒθs",
    "dish": "dɪʃ",
    "dishearten": "dɪshɑːtən",
    "disheartened": "dɪshɑːtənd",
    "disheartening": "dɪshɑːtənɪŋ",
    "disheartens": "dɪshɑːtənz",
    "dished": "dɪʃd",
    "dishes": "dɪʃɪz",
    "dishevelled": "dɪʃɛvəld",
    "dishing": "dɪʃɪŋ",
    "dishonest": "dɪsɒnɪst",
    "dishonestly": "dɪsɒnɪstli",
    "dishonesty": "dɪsɒnɪsti",
    "dishonourable": "dɪsɒnərəbəl",
    "dishonourably": "dɪsɒnərəbli",
    "dishonour": "dɪsɒnɐ",
    "dishonoured": "dɪsɒnəd",
    "dishonouring": "dɪsɒnɜːrɪŋ",
    "dishonours": "dɪsɒnəz",
    "dishwasher": "dɪʃwɒʃɐ",
    "dishwashers": "dɪʃwɒʃəz",
    "dishwater": "dɪʃwɔːtɐ",
    "dishy": "dɪʃi",
    "disillusion": "dɪsɪluːʒən",
    "disillusioned": "dɪsɪluːʒənd",
    "disillusioning": "dɪsɪluːʒənɪŋ",
    "disillusionment": "dɪsɪluːʒənmənt",
    "disincentive": "dɪsɪnsɛntɪv",
    "disincentives": "dɪsɪnsɛntɪvz",
    "disinclined": "dɪsɪnklaɪnd",
    "disinfectant": "dɪsɪnfɛktənt",
    "disinfectants": "dɪsɪnfɛktənts",
    "disinfect": "dɪsɪnfɛkt",
    "disinfected": "dɪsɪnfɛktɪd",
    "disinfecting": "dɪsɪnfɛktɪŋ",
    "disinfection": "dɪsɪnfɛkʃən",
    "disinflation": "dɪsɪnfleɪʃən",
    "disinformation": "dɪsɪnfəmeɪʃən",
    "disingenuous": "dɪsɪndʒɛnjuːəs",
    "disingenuously": "dɪsɪndʒɛnjuːəsli",
    "disinheritance": "dɪsɪnhɛrɪtəns",
    "disinherit": "dɪsɪnhɛrɪt",
    "disinherited": "dɪsɪnhɛrɪtɪd",
    "disintegrated": "dɪsɪntɪɡreɪtɪd",
    "disintegrate": "dɪsɪntɪɡreɪt",
    "disintegrates": "dɪsɪntɪɡreɪts",
    "disintegrating": "dɪsɪntɪɡreɪtɪŋ",
    "disintegration": "dɪsɪntɪɡreɪʃən",
    "disinterest": "dɪsɪntrəst",
    "disinterested": "dɪsɪntrəstɪd",
    "disinterred": "dɪsɪntɜːd",
    "disinvest": "dɪsɪnvɛst",
    "disinvestment": "dɪsɪnvɛstmənt",
    "disjoint": "dɪsdʒɔɪnt",
    "disjointed": "dɪsdʒɔɪntɪd",
    "disjointedness": "dɪsdʒɔɪntɪdnəs",
    "disjunction": "dɪsdʒʌŋkʃən",
    "disjuncture": "dɪsdʒʌŋktʃɐ",
    "disk": "dɪsk",
    "diskette": "dɪskɛt",
    "disks": "dɪsks",
    "disliked": "dɪslaɪkt",
    "dislike": "dɪslaɪk",
    "dislikes": "dɪslaɪks",
    "disliking": "dɪslaɪkɪŋ",
    "dislocated": "dɪsləʊkeɪtɪd",
    "dislocate": "dɪsləʊkeɪt",
    "dislocates": "dɪsləʊkeɪts",
    "dislocating": "dɪsləʊkeɪtɪŋ",
    "dislocation": "dɪsləʊkeɪʃən",
    "dislocations": "dɪsləʊkeɪʃənz",
    "dislodged": "dɪslɒdʒd",
    "dislodge": "dɪslɒdʒ",
    "dislodges": "dɪslɒdʒɪz",
    "dislodging": "dɪslɒdʒɪŋ",
    "disloyal": "dɪslɔɪəl",
    "disloyalty": "dɪslɔɪəlti",
    "dismal": "dɪzməl",
    "dismally": "dɪzməli",
    "dismantled": "dɪsmɑːntəld",
    "dismantle": "dɪsmɑːntəl",
    "dismantlement": "dɪsmɑːntəlmənt",
    "dismantles": "dɪsmɑːntəlz",
    "dismantling": "dɪsmɑːntlɪŋ",
    "dismay": "dɪsmeɪ",
    "dismayed": "dɪsmeɪd",
    "dismaying": "dɪsmeɪɪŋ",
    "dismays": "dɪsmeɪz",
    "dismember": "dɪsmɛmbɐ",
    "dismembered": "dɪsmɛmbəd",
    "dismembering": "dɪsmɛmbərɪŋ",
    "dismemberment": "dɪsmɛmbəmənt",
    "dismissal": "dɪsmɪsəl",
    "dismissals": "dɪsmɪsəlz",
    "dismiss": "dɪsmɪs",
    "dismissed": "dɪsmɪst",
    "dismisses": "dɪsmɪsɪz",
    "dismissible": "dɪsmɪsəbəl",
    "dismissing": "dɪsmɪsɪŋ",
    "dismissive": "dɪsmɪsɪv",
    "dismissively": "dɪsmɪsɪvli",
    "dismount": "dɪsmaʊnt",
    "dismounted": "dɪsmaʊntɪd",
    "dismounting": "dɪsmaʊntɪŋ",
    "dismounts": "dɪsmaʊnts",
    "disobedience": "dɪsəʊbiːdiəns",
    "disobedient": "dɪsəʊbiːdiənt",
    "disobey": "dɪsəʊbeɪ",
    "disobeyed": "dɪsəʊbeɪd",
    "disobeying": "dɪsəʊbeɪɪŋ",
    "disobeys": "dɪsəʊbeɪz",
    "disobliging": "dɪsəblaɪdʒɪŋ",
    "disorder": "dɪsɔːdɐ",
    "disordered": "dɪsɔːdəd",
    "disordering": "dɪsɔːdərɪŋ",
    "disorderly": "dɪsɔːdəli",
    "disorders": "dɪsɔːdəz",
    "disorganisation": "dɪsɔːɡɐnaɪzeɪʃən",
    "disorganised": "dɪsɔːɡɐnaɪzd",
    "disorientated": "dɪsɔːriənteɪtɪd",
    "disorientate": "dɪsɔːriənteɪt",
    "disorientating": "dɪsɔːriənteɪtɪŋ",
    "disorientation": "dɪsɔːriənteɪʃən",
    "disorient": "dɪsɔːriənt",
    "disoriented": "dɪsɔːriəntɪd",
    "disorienting": "dɪsɔːriəntɪŋ",
    "disown": "dɪsəʊn",
    "disowned": "dɪsəʊnd",
    "disowning": "dɪsəʊnɪŋ",
    "disowns": "dɪsəʊnz",
    "disparaged": "dɪspærɪdʒd",
    "disparage": "dɪspærɪdʒ",
    "disparaging": "dɪspærɪdʒɪŋ",
    "disparagingly": "dɪspærɪdʒɪŋli",
    "disparate": "dɪspərət",
    "disparities": "dɪspærɪtiz",
    "disparity": "dɪspærɪti",
    "dispassionate": "dɪspæʃənət",
    "dispassionately": "dɪspæʃənətli",
    "dispassion": "dɪspæʃən",
    "dispatch": "dɪspætʃ",
    "dispatched": "dɪspætʃt",
    "dispatcher": "dɪspætʃɐ",
    "dispatchers": "dɪspætʃəz",
    "dispatches": "dɪspætʃɪz",
    "dispatching": "dɪspætʃɪŋ",
    "dispel": "dɪspɛl",
    "dispelled": "dɪspɛld",
    "dispelling": "dɪspɛlɪŋ",
    "dispels": "dɪspɛlz",
    "dispensable": "dɪspɛnsəbəl",
    "dispensaries": "dɪspɛnsəriz",
    "dispensary": "dɪspɛnsəri",
    "dispensation": "dɪspɪnseɪʃən",
    "dispensations": "dɪspɪnseɪʃənz",
    "dispensed": "dɪspɛnsd",
    "dispense": "dɪspɛns",
    "dispenser": "dɪspɛnsɐ",
    "dispensers": "dɪspɛnsəz",
    "dispenses": "dɪspɛnsɪz",
    "dispensing": "dɪspɛnsɪŋ",
    "dispersal": "dɪspɜːsəl",
    "dispersant": "dɪspɜːsənt",
    "dispersed": "dɪspɜːsd",
    "disperse": "dɪspɜːs",
    "disperser": "dɪspɜːsɐ",
    "disperses": "dɪspɜːsɪz",
    "dispersing": "dɪspɜːsɪŋ",
    "dispersion": "dɪspɜːʃən",
    "dispirited": "dɪspɪrɪtɪd",
    "dispiriting": "dɪspɪrɪtɪŋ",
    "displaced": "dɪspleɪst",
    "displace": "dɪspleɪs",
    "displacement": "dɪspleɪsmənt",
    "displacements": "dɪspleɪsmənts",
    "displaces": "dɪspleɪsɪz",
    "displacing": "dɪspleɪsɪŋ",
    "displayable": "dɪspleɪəbəl",
    "display": "dɪspleɪ",
    "displayed": "dɪspleɪd",
    "displaying": "dɪspleɪɪŋ",
    "displays": "dɪspleɪz",
    "displeased": "dɪspliːzd",
    "displease": "dɪspliːz",
    "displeases": "dɪspliːzɪz",
    "displeasing": "dɪspliːzɪŋ",
    "displeasure": "dɪsplɛʒɐ",
    "disport": "dɪspɔːt",
    "disporting": "dɪspɔːtɪŋ",
    "disposable": "dɪspəʊzəbəl",
    "disposables": "dɪspɒsəbəlz",
    "disposal": "dɪspəʊzəl",
    "disposals": "dɪspəʊzəlz",
    "disposed": "dɪspəʊzd",
    "dispose": "dɪspəʊz",
    "disposes": "dɪspəʊzɪz",
    "disposing": "dɪspəʊzɪŋ",
    "disposition": "dɪspəzɪʃən",
    "dispositions": "dɪspəzɪʃənz",
    "dispossess": "dɪspəzɛs",
    "dispossessed": "dɪspəzɛst",
    "dispossessing": "dɪspəzɛsɪŋ",
    "dispossession": "dɪspəzɛʃən",
    "disproportional": "dɪsprəpɔːʃənəl",
    "disproportionally": "dɪsprəpɔːʃənəli",
    "disproportionate": "dɪsprəpɔːʃənət",
    "disproportionately": "dɪsprəpɔːʃənətli",
    "disproportion": "dɪsprəpɔːʃən",
    "disproved": "dɪspruːvd",
    "disprove": "dɪspruːv",
    "disproven": "dɪspruːvən",
    "disproves": "dɪspruːvz",
    "disproving": "dɪspruːvɪŋ",
    "disputable": "dɪspjuːtəbəl",
    "disputatious": "dɪspjuːteɪʃəs",
    "disputed": "dɪspjuːtɪd",
    "dispute": "dɪspjuːt",
    "disputes": "dɪspjuːts",
    "disputing": "dɪspjuːtɪŋ",
    "disqualification": "dɪskwɒlɪfɪkeɪʃən",
    "disqualifications": "dɪskwɒlɪfɪkeɪʃənz",
    "disqualified": "dɪskwɒlɪfaɪd",
    "disqualifies": "dɪskwɒlɪfaɪz",
    "disqualify": "dɪskwɒlɪfaɪ",
    "disqualifying": "dɪskwɒlɪfaɪɪŋ",
    "disquiet": "dɪskwaɪət",
    "disquieted": "dɪskwaɪətɪd",
    "disquieting": "dɪskwaɪətɪŋ",
    "disquisition": "dɪskwɪsɪʃən",
    "disregard": "dɪsrɪɡɑːd",
    "disregarded": "dɪsrɪɡɑːdɪd",
    "disregarding": "dɪsrɪɡɑːdɪŋ",
    "disregards": "dɪsrɪɡɑːdz",
    "disrepair": "dɪsrɪpeə",
    "disreputable": "dɪsrɛpjuːtəbəl",
    "disrepute": "dɪsrɪpjuːt",
    "disrespect": "dɪsrɪspɛkt",
    "disrespected": "dɪsrɪspɛktɪd",
    "disrespectful": "dɪsrɪspɛktfəl",
    "disrespectfully": "dɪsrɪspɛktfəli",
    "disrespecting": "dɪsrɪspɛktɪŋ",
    "disrespects": "dɪsrɪspɛkts",
    "disrobed": "dɪsrəʊbd",
    "disrobe": "dɪsrəʊb",
    "disrobing": "dɪsrəʊbɪŋ",
    "disrupt": "dɪsrʌpt",
    "disrupted": "dɪsrʌptɪd",
    "disrupter": "dɪsrʌptɐ",
    "disrupting": "dɪsrʌptɪŋ",
    "disruption": "dɪsrʌpʃən",
    "disruptions": "dɪsrʌpʃənz",
    "disruptive": "dɪsrʌptɪv",
    "disruptor": "dɪsrʌptɐ",
    "disrupts": "dɪsrʌpts",
    "dissatisfaction": "dɪsætɪsfækʃən",
    "dissatisfied": "dɪsætɪsfaɪd",
    "dissatisfying": "dɪsætɪsfaɪɪŋ",
    "diss": "dɪs",
    "dissect": "daɪsɛkt",
    "dissected": "daɪsɛktɪd",
    "dissecting": "daɪsɛktɪŋ",
    "dissection": "daɪsɛkʃən",
    "dissections": "daɪsɛkʃənz",
    "dissects": "daɪsɛkts",
    "dissed": "dɪst",
    "dissembled": "dɪsɛmbəld",
    "dissemble": "dɪsɛmbəl",
    "dissembling": "dɪsɛmblɪŋ",
    "disseminated": "dɪsɛmɪneɪtɪd",
    "disseminate": "dɪsɛmɪneɪt",
    "disseminates": "dɪsɛmɪneɪts",
    "disseminating": "dɪsɛmɪneɪtɪŋ",
    "dissemination": "dɪsɛmɪneɪʃən",
    "dissension": "dɪsɛnʃən",
    "dissensions": "dɪsɛnʃənz",
    "dissent": "dɪsɛnt",
    "dissented": "dɪsɛntɪd",
    "dissenter": "dɪsɛntɐ",
    "dissenters": "dɪsɛntəz",
    "dissenting": "dɪsɛntɪŋ",
    "dissents": "dɪsɛnts",
    "dissertation": "dɪsəteɪʃən",
    "dissertations": "dɪsəteɪʃənz",
    "disservice": "dɪsɜːvɪs",
    "disses": "dɪsɪz",
    "dissidence": "dɪsɪdəns",
    "dissident": "dɪsɪdənt",
    "dissidents": "dɪsɪdənts",
    "dissimilar": "dɪsɪmɪlɐ",
    "dissimilation": "dɪsɪmɪleɪʃən",
    "dissing": "dɪsɪŋ",
    "dissipated": "dɪsɪpeɪtɪd",
    "dissipate": "dɪsɪpeɪt",
    "dissipates": "dɪsɪpeɪts",
    "dissipating": "dɪsɪpeɪtɪŋ",
    "dissipation": "dɪsɪpeɪʃən",
    "dissociated": "dɪsəʊsɪeɪtɪd",
    "dissociate": "dɪsəʊsɪeɪt",
    "dissociating": "dɪsəʊsɪeɪtɪŋ",
    "dissociative": "dɪsəʊsiətɪv",
    "dissolute": "dɪsəluːt",
    "dissolution": "dɪsəluːʃən",
    "dissolvable": "dɪsɒlvəbəl",
    "dissolved": "dɪsɒlvd",
    "dissolve": "dɪsɒlv",
    "dissolves": "dɪsɒlvz",
    "dissolving": "dɪsɒlvɪŋ",
    "dissonance": "dɪsənəns",
    "dissonant": "dɪsənənt",
    "dissuaded": "dɪsweɪdɪd",
    "dissuade": "dɪsweɪd",
    "dissuading": "dɪsweɪdɪŋ",
    "distaff": "dɪstɑːf",
    "distal": "dɪstæl",
    "distally": "dɪstæli",
    "distanced": "dɪstənst",
    "distance": "dɪstəns",
    "distances": "dɪstənsɪz",
    "distancing": "dɪstənsɪŋ",
    "distant": "dɪstənt",
    "distantly": "dɪstəntli",
    "distaste": "dɪsteɪst",
    "distasteful": "dɪsteɪstfəl",
    "distemper": "dɪstɛmpɐ",
    "distempered": "dɪstɛmpəd",
    "distend": "dɪstɛnd",
    "distended": "dɪstɛndɪd",
    "distending": "dɪstɛndɪŋ",
    "distension": "dɪstɛnʃən",
    "distil": "dɪstɪl",
    "distillation": "dɪstɪleɪʃən",
    "distillations": "dɪstɪleɪʃənz",
    "distilled": "dɪstɪld",
    "distiller": "dɪstɪlɐ",
    "distilleries": "dɪstɪləriz",
    "distillers": "dɪstɪləz",
    "distillery": "dɪstɪləri",
    "distilling": "dɪstɪlɪŋ",
    "distils": "dɪstɪlz",
    "distinct": "dɪstɪŋkt",
    "distinction": "dɪstɪŋkʃən",
    "distinctions": "dɪstɪŋkʃənz",
    "distinctive": "dɪstɪŋktɪv",
    "distinctively": "dɪstɪŋktɪvli",
    "distinctiveness": "dɪstɪŋktɪvnəs",
    "distinctly": "dɪstɪŋktli",
    "distinguishable": "dɪstɪŋɡwɪʃəbəl",
    "distinguish": "dɪstɪŋɡwɪʃ",
    "distinguished": "dɪstɪŋɡwɪʃt",
    "distinguishes": "dɪstɪŋɡwɪʃɪz",
    "distinguishing": "dɪstɪŋɡwɪʃɪŋ",
    "distort": "dɪstɔːt",
    "distorted": "dɪstɔːtɪd",
    "distorting": "dɪstɔːtɪŋ",
    "distortion": "dɪstɔːʃən",
    "distortions": "dɪstɔːʃənz",
    "distorts": "dɪstɔːts",
    "distract": "dɪstrækt",
    "distracted": "dɪstræktɪd",
    "distractedly": "dɪstræktɪdli",
    "distracting": "dɪstræktɪŋ",
    "distraction": "dɪstrækʃən",
    "distractions": "dɪstrækʃənz",
    "distracts": "dɪstrækts",
    "distrait": "dɪstreɪt",
    "distraught": "dɪstrɔːt",
    "distress": "dɪstrɛs",
    "distressed": "dɪstrɛst",
    "distresses": "dɪstrɛsɪz",
    "distressful": "dɪstrɛsfəl",
    "distressing": "dɪstrɛsɪŋ",
    "distressingly": "dɪstrɛsɪŋli",
    "distributed": "dɪstrɪbjuːtɪd",
    "distribute": "dɪstrɪbjuːt",
    "distributes": "dɪstrɪbjuːts",
    "distributing": "dɪstrɪbjuːtɪŋ",
    "distributional": "dɪstrɪbjuːʃənəl",
    "distribution": "dɪstrɪbjuːʃən",
    "distributions": "dɪstrɪbjuːʃənz",
    "distributive": "dɪstrɪbjuːtɪv",
    "distributor": "dɪstrɪbjuːtɐ",
    "distributors": "dɪstrɪbjuːtəz",
    "district": "dɪstrɪkt",
    "districts": "dɪstrɪkts",
    "distrust": "dɪstrʌst",
    "distrusted": "dɪstrʌstɪd",
    "distrustful": "dɪstrʌstfəl",
    "distrusting": "dɪstrʌstɪŋ",
    "distrusts": "dɪstrʌsts",
    "disturbance": "dɪstɜːbəns",
    "disturbances": "dɪstɜːbənsɪz",
    "disturb": "dɪstɜːb",
    "disturbed": "dɪstɜːbd",
    "disturbing": "dɪstɜːbɪŋ",
    "disturbingly": "dɪstɜːbɪŋli",
    "disturbs": "dɪstɜːbz",
    "disunited": "dɪsjuːnaɪtɪd",
    "disunite": "dɪsjuːnaɪt",
    "disunity": "dɪsjuːnɪti",
    "disused": "dɪsjuːzd",
    "disuse": "dɪsjuːs",
    "ditch": "dɪtʃ",
    "ditched": "dɪtʃt",
    "ditches": "dɪtʃɪz",
    "ditching": "dɪtʃɪŋ",
    "ditchwater": "dɪtʃwɔːtɐ",
    "dit": "dɪt",
    "dither": "dɪðɐ",
    "dithered": "dɪðəd",
    "ditherer": "dɪðərɐ",
    "ditherers": "dɪðərəz",
    "dithering": "dɪðərɪŋ",
    "dithers": "dɪðəz",
    "dithery": "dɪθəri",
    "dits": "dɪts",
    "ditsy": "dɪtsi",
    "dittany": "dɪtəni",
    "ditties": "dɪtɪz",
    "ditto": "dɪtəʊ",
    "ditty": "dɪti",
    "ditzy": "dɪtsi",
    "diuretic": "dɪjuːrɛtɪk",
    "diuretics": "dɪjuːrɛtɪks",
    "diurnal": "dɪɜːnəl",
    "diva": "diːvɐ",
    "divan": "dɪvæn",
    "divans": "dɪvænz",
    "divas": "diːvəz",
    "dive": "daɪv",
    "dived": "daɪvd",
    "diver": "daɪvɐ",
    "diverge": "daɪvɜːdʒ",
    "diverged": "daɪvɜːdʒd",
    "divergence": "daɪvɜːdʒəns",
    "divergences": "daɪvɜːdʒənsɪz",
    "divergent": "daɪvɜːdʒənt",
    "diverges": "daɪvɜːdʒɪz",
    "diverging": "daɪvɜːdʒɪŋ",
    "diverse": "daɪvɜːs",
    "diversely": "daɪvɜːsli",
    "diversification": "daɪvɜːsɪfɪkeɪʃən",
    "diversified": "daɪvɜːsɪfaɪd",
    "diversifies": "daɪvɜːsɪfaɪz",
    "diversify": "daɪvɜːsɪfaɪ",
    "diversifying": "daɪvɜːsɪfaɪɪŋ",
    "diversionary": "daɪvɜːʃənəri",
    "diversion": "daɪvɜːʃən",
    "diversions": "daɪvɜːʃənz",
    "diversities": "daɪvɜːsɪtiz",
    "diversity": "daɪvɜːsɪti",
    "divert": "daɪvɜːt",
    "diverted": "daɪvɜːtɪd",
    "diverter": "daɪvɜːtɐ",
    "diverticula": "daɪvətɪkjʊlɐ",
    "diverticulitis": "daɪvɜːtɪkjʊlaɪtɪs",
    "diverticulum": "daɪvətɪkjʊləm",
    "diverting": "daɪvɜːtɪŋ",
    "divertissement": "daɪvɜːtɪsmənt",
    "diverts": "daɪvɜːts",
    "divest": "daɪvɛst",
    "divested": "daɪvɛstɪd",
    "divesting": "daɪvɛstɪŋ",
    "divestment": "daɪvɛstmənt",
    "divests": "daɪvɛsts",
    "divided": "dɪvaɪdɪd",
    "divide": "dɪvaɪd",
    "dividend": "dɪvɪdənd",
    "dividends": "dɪvɪdəndz",
    "divider": "dɪvaɪdɐ",
    "dividers": "dɪvaɪdəz",
    "divides": "dɪvaɪdz",
    "dividing": "dɪvaɪdɪŋ",
    "divination": "dɪvɪneɪʃən",
    "divined": "dɪvaɪnd",
    "divine": "dɪvaɪn",
    "divinely": "dɪvaɪnli",
    "diviner": "dɪvɪnɐ",
    "diviners": "dɪvɪnəz",
    "divines": "dɪvaɪnz",
    "diving": "daɪvɪŋ",
    "divining": "dɪvaɪnɪŋ",
    "divinities": "dɪvɪnɪtiz",
    "divinity": "dɪvɪnɪti",
    "divisible": "dɪvɪzəbəl",
    "divisional": "dɪvɪʒənəl",
    "division": "dɪvɪʒən",
    "divisions": "dɪvɪʒənz",
    "divisive": "dɪvaɪsɪv",
    "divisiveness": "dɪvaɪsɪvnəs",
    "divisor": "dɪvaɪzɐ",
    "divorced": "dɪvɔːst",
    "divorce": "dɪvɔːs",
    "divorces": "dɪvɔːsɪz",
    "divorcing": "dɪvɔːsɪŋ",
    "divot": "dɪvɒt",
    "divots": "dɪvɒts",
    "divulge": "daɪvʌldʒ",
    "divulged": "daɪvʌldʒd",
    "divulges": "daɪvʌldʒɪz",
    "divulging": "daɪvʌldʒɪŋ",
    "divvied": "dɪvɪd",
    "divvies": "dɪvɪz",
    "divvy": "dɪvi",
    "divvying": "dɪvɪɪŋ",
    "dixie": "dɪksi",
    "dixieland": "dɪksiːlənd",
    "dixies": "dɪksɪz",
    "dizzied": "dɪzɪd",
    "dizzier": "dɪzɪɐ",
    "dizziest": "dɪzɪəst",
    "dizzily": "dɪzɪli",
    "dizziness": "dɪzɪnəs",
    "dizzy": "dɪzi",
    "dizzying": "dɪzɪɪŋ",
    "dm": "diːɛm",
    "doable": "duːəbəl",
    "dobbed": "dɒbd",
    "dobbin": "dɒbɪn",
    "dobbing": "dɒbɪŋ",
    "dobbins": "dɒbɪnz",
    "dobby": "dɒbi",
    "dob": "dɒb",
    "doberman": "dəʊbəmən",
    "dobermans": "dəʊbəmənz",
    "dobra": "dɒbrɐ",
    "dobs": "dɒbz",
    "doc": "dɒk",
    "docile": "dəʊsaɪl",
    "docility": "dəʊsɪlɪti",
    "dock": "dɒk",
    "docked": "dɒkt",
    "docker": "dɒkɐ",
    "dockers": "dɒkəz",
    "docket": "dɒkɪt",
    "docketed": "dɒkɪtɪd",
    "dockets": "dɒkɪts",
    "docking": "dɒkɪŋ",
    "dockland": "dɒklənd",
    "docklands": "dɒkləndz",
    "docks": "dɒks",
    "dockside": "dɒksaɪd",
    "dockworkers": "dɒkwɜːkəz",
    "dockyard": "dɒkjɑːd",
    "dockyards": "dɒkjɑːdz",
    "docs": "dɒks",
    "doctoral": "dɒktərəl",
    "doctorate": "dɒktəreɪt",
    "doctorates": "dɒktəreɪts",
    "doctor": "dɒktɐ",
    "doctored": "dɒktəd",
    "doctoring": "dɒktərɪŋ",
    "doctors": "dɒktəz",
    "doctrinaire": "dɒktrɪneə",
    "doctrinal": "dɒktraɪnəl",
    "doctrine": "dɒktrɪn",
    "doctrines": "dɒktrɪnz",
    "docudrama": "dɒkədrɑːmɐ",
    "documentable": "dɒkjuːməntəbəl",
    "documentaries": "dɒkjuːmɛntəriz",
    "documentary": "dɒkjuːmɛntəri",
    "documentation": "dɒkjuːmənteɪʃən",
    "documented": "dɒkjuːməntɪd",
    "documenting": "dɒkjuːməntɪŋ",
    "dodder": "dɒdɐ",
    "doddered": "dɒdəd",
    "doddering": "dɒdərɪŋ",
    "doddery": "dɒdəri",
    "doddle": "dɒdəl",
    "dodecahedron": "dəʊdɛkɐhiːdrən",
    "dodged": "dɒdʒd",
    "dodge": "dɒdʒ",
    "dodgem": "dɒdʒəm",
    "dodgems": "dɒdʒəmz",
    "dodger": "dɒdʒɐ",
    "dodgers": "dɒdʒəz",
    "dodges": "dɒdʒɪz",
    "dodgier": "dɒdʒɪɐ",
    "dodgiest": "dɒdʒɪəst",
    "dodging": "dɒdʒɪŋ",
    "dodgy": "dɒdʒi",
    "dodo": "dəʊdəʊ",
    "dodos": "dəʊdəʊz",
    "doe": "dəʊ",
    "doer": "duːɐ",
    "doers": "duːəz",
    "doff": "dɒf",
    "doffed": "dɒft",
    "doffing": "dɒfɪŋ",
    "doffs": "dɒfs",
    "dogberry": "dɒɡbəri",
    "dogcart": "dɒɡkɑːt",
    "dogcatcher": "dɒɡkætʃɐ",
    "dog": "dɒɡ",
    "dogear": "dəʊdʒɑː",
    "doge": "dəʊdʒ",
    "doges": "dəʊdʒɪz",
    "dogface": "dɒɡfeɪs",
    "dogfight": "dɒɡfaɪt",
    "dogfights": "dɒɡfaɪts",
    "dogfish": "dɒɡfɪʃ",
    "doggedly": "dɒɡɪdli",
    "doggedness": "dɒɡɪdnəs",
    "dogger": "dɒɡɐ",
    "doggerel": "dɒɡərəl",
    "doggie": "dɒɡi",
    "doggies": "dɒɡɪz",
    "dogging": "dɒɡɪŋ",
    "doggo": "dɒɡəʊ",
    "doggoned": "dɒɡənd",
    "doggone": "dɒɡɒn",
    "doggy": "dɒɡi",
    "doghouse": "dɒɡhaʊs",
    "dogie": "dəʊdʒi",
    "dogies": "dəʊɡɪz",
    "dogleg": "dɒɡlɛɡ",
    "doglegs": "dɒɡlɛɡz",
    "doglike": "dɒɡlaɪk",
    "dogma": "dɒɡmɐ",
    "dogmas": "dɒɡməz",
    "dogmatically": "dɒɡmætɪkli",
    "dogmatic": "dɒɡmætɪk",
    "dogmatism": "dɒɡmətɪzəm",
    "dogsbody": "dɒɡsbɒdi",
    "dogs": "dɒɡz",
    "dogsled": "dɒɡsəld",
    "dogsleds": "dɒɡsldz",
    "dogtooth": "dɒɡtuːθ",
    "dogwood": "dɒɡwʊd",
    "dogwoods": "dɒɡwʊdz",
    "doh": "dəʊ",
    "doilies": "dɔɪliz",
    "doily": "dɔɪli",
    "doing": "duːɪŋ",
    "doings": "duːɪŋz",
    "doit": "dɔɪt",
    "dolce": "dɒltʃeɪ",
    "doldrums": "dəʊldrəmz",
    "doled": "dəʊld",
    "dole": "dəʊl",
    "doleful": "dəʊlfəl",
    "dolerite": "dəʊlraɪt",
    "doles": "dəʊlz",
    "doling": "dəʊlɪŋ",
    "dollar": "dɒlɐ",
    "dollars": "dɒləz",
    "doll": "dɒl",
    "dolled": "dɒld",
    "dollhouse": "dɒlhaʊs",
    "dollies": "dɒliz",
    "dolling": "dɒlɪŋ",
    "dollop": "dɒləp",
    "dolloped": "dɒləpd",
    "dolloping": "dɒləpɪŋ",
    "dollops": "dɒləps",
    "dolls": "dɒlz",
    "dolly": "dɒli",
    "dolman": "dɒlmən",
    "dolmens": "dɒlmɛnz",
    "dolomite": "dɒləmaɪt",
    "dolor": "dɒlɐ",
    "dolours": "dɒləz",
    "dolphin": "dɒlfɪn",
    "dolphins": "dɒlfɪnz",
    "dolt": "dəʊlt",
    "doltish": "dəʊltɪʃ",
    "dolts": "dəʊlts",
    "domain": "dəmeɪn",
    "domaine": "dəmeɪn",
    "domains": "dəmeɪnz",
    "domed": "dəʊmd",
    "dome": "dəʊm",
    "domesday": "dəʊmsdeɪ",
    "domes": "dəʊmz",
    "domestically": "dəmɛstɪkli",
    "domesticated": "dəmɛstɪkeɪtɪd",
    "domesticating": "dəmɛstɪkeɪtɪŋ",
    "domestication": "dəmɛstɪkeɪʃən",
    "domestic": "dəmɛstɪk",
    "domesticity": "dəmɪstɪsɪti",
    "domestics": "dəmɛstɪks",
    "domiciled": "dɒmɪsaɪld",
    "domicile": "dɒmɪsaɪl",
    "domiciles": "dɒmɪsaɪlz",
    "domiciliary": "dɒmɪsɪliəri",
    "dominance": "dɒmɪnəns",
    "dominant": "dɒmɪnənt",
    "dominantly": "dɒmɪnəntli",
    "dominants": "dɒmɪnənts",
    "dominated": "dɒmɪneɪtɪd",
    "dominate": "dɒmɪneɪt",
    "dominates": "dɒmɪneɪts",
    "dominating": "dɒmɪneɪtɪŋ",
    "domination": "dɒmɪneɪʃən",
    "dominations": "dɒmɪneɪʃənz",
    "dominator": "dɒmɪneɪtɐ",
    "dominatrix": "dɒmɪneɪtrɪks",
    "domineer": "dɒmɪniə",
    "domineering": "dɒmɪniərɪŋ",
    "doming": "dəʊmɪŋ",
    "dominion": "dəmɪniən",
    "dominions": "dəmɪniənz",
    "domino": "dɒmɪnəʊ",
    "dominoes": "dɒmɪnəʊz",
    "dominos": "dɒmɪnəʊz",
    "dona": "dəʊnɐ",
    "donated": "dəʊneɪtɪd",
    "donate": "dəʊneɪt",
    "donates": "dəʊneɪts",
    "donating": "dəʊneɪtɪŋ",
    "donation": "dəʊneɪʃən",
    "donations": "dəʊneɪʃənz",
    "donator": "dəʊneɪtɐ",
    "don": "dɒn",
    "done": "dʌn",
    "donee": "dəʊniː",
    "donga": "dɒŋɡɐ",
    "dong": "dɒŋ",
    "donged": "dɒŋd",
    "donging": "dɒŋɪŋ",
    "dongle": "dɒŋɡəl",
    "dongles": "dɒŋɡəlz",
    "dongs": "dɒŋz",
    "donkey": "dɒŋki",
    "donkeys": "dɒŋkɪz",
    "donna": "dɒnɐ",
    "donnas": "dɒnəz",
    "donned": "dɒnd",
    "donning": "dɒnɪŋ",
    "donnish": "dɒnɪʃ",
    "donnybrook": "dɒnɪbrʊk",
    "donor": "dəʊnɐ",
    "donors": "dəʊnəz",
    "dons": "dɒnz",
    "donut": "dəʊnʌt",
    "donuts": "dəʊnʌts",
    "doodad": "duːdæd",
    "doodah": "duːdɐ",
    "doodahs": "duːdəz",
    "doodlebug": "duːdəlbʌɡ",
    "doodlebugs": "duːdəlbʌɡz",
    "doodled": "duːdəld",
    "doodle": "duːdəl",
    "doodler": "duːdlɐ",
    "doodles": "duːdəlz",
    "doodling": "duːdlɪŋ",
    "doohickey": "duːhɪki",
    "doolally": "duːləli",
    "doom": "duːm",
    "doomed": "duːmd",
    "dooming": "duːmɪŋ",
    "doomsayers": "duːmseɪəz",
    "doomsday": "duːmsdeɪ",
    "dooms": "duːmz",
    "doorbell": "dɔːbɛl",
    "doorbells": "dɔːbɛlz",
    "door": "dɔː",
    "doorframe": "dɔːfreɪm",
    "doorframes": "dɔːfreɪmz",
    "doorkeeper": "dɔːkiːpɐ",
    "doorkeepers": "dɔːkiːpəz",
    "doorknob": "dɔːnɒb",
    "doorknobs": "dɔːnɒbz",
    "doorknocker": "dɔːknɒkɐ",
    "doorman": "dɔːmən",
    "doormat": "dɔːmæt",
    "doormats": "dɔːmæts",
    "doormen": "dɔːmɛn",
    "doornail": "dɔːneɪl",
    "doorpost": "dɔːpəʊst",
    "doors": "dɔːz",
    "doorstep": "dɔːstɛp",
    "doorstepped": "dɔːstɛpt",
    "doorstepping": "dɔːstɛpɪŋ",
    "doorsteps": "dɔːstɛps",
    "doorstop": "dɔːstɒp",
    "doorstops": "dɔːstɒps",
    "doorway": "dɔːweɪ",
    "doorways": "dɔːweɪz",
    "doozy": "duːzi",
    "dopa": "dəʊpɐ",
    "dopamine": "dɒpɐmiːn",
    "doped": "dəʊpt",
    "dope": "dəʊp",
    "doper": "dəʊpɐ",
    "dopers": "dəʊpəz",
    "dopes": "dəʊps",
    "dopey": "dəʊpi",
    "dopiest": "dəʊpɪəst",
    "doping": "dəʊpɪŋ",
    "dorado": "dɔːrɑːdəʊ",
    "dor": "dɔː",
    "dories": "dɔːrɪz",
    "dork": "dɔːk",
    "dorkiest": "dɔːkiəst",
    "dorks": "dɔːks",
    "dorky": "dɔːki",
    "dormancy": "dɔːmənsi",
    "dormant": "dɔːmənt",
    "dorm": "dɔːm",
    "dormer": "dɔːmɐ",
    "dormers": "dɔːməz",
    "dormice": "dɔːmɪs",
    "dormitories": "dɔːmɪtəriz",
    "dormitory": "dɔːmɪtəri",
    "dormouse": "dɔːmaʊs",
    "dorms": "dɔːmz",
    "dorsal": "dɔːsəl",
    "dorsum": "dɔːsəm",
    "dory": "dɔːri",
    "dosage": "dəʊsɪdʒ",
    "dosages": "dəʊsɪdʒɪz",
    "dos": "dɒs",
    "dosed": "dəʊst",
    "dose": "dəʊs",
    "doses": "dəʊsɪz",
    "dosh": "dɒʃ",
    "dosimeter": "dɒsaɪmiːtɐ",
    "dosing": "dəʊsɪŋ",
    "doss": "dɒs",
    "dosser": "dɒsɐ",
    "dossers": "dɒsəz",
    "dosshouse": "dɒshaʊs",
    "dossier": "dɒsɪeɪ",
    "dossiers": "dɒsɪeɪz",
    "dossing": "dɒsɪŋ",
    "dost": "dɒst",
    "dotage": "dəʊtɪdʒ",
    "dot": "dɒt",
    "doted": "dəʊtɪd",
    "dote": "dəʊt",
    "dotes": "dəʊts",
    "doth": "dʌθ",
    "doting": "dəʊtɪŋ",
    "dotingly": "dəʊtɪŋli",
    "dots": "dɒts",
    "dotted": "dɒtɪd",
    "dotterel": "dɒtərəl",
    "dottier": "dɒtɪɐ",
    "dotting": "dɒtɪŋ",
    "dotty": "dɒti",
    "double": "dʌbəl",
    "doubled": "dʌbəld",
    "doubleness": "dʌbəlnəs",
    "doubler": "dʌblɐ",
    "doubles": "dʌbəlz",
    "doublespeak": "dʌbəlspiːk",
    "doublet": "dʌblət",
    "doublethink": "dʌbəlθɪŋk",
    "doublets": "dʌbləts",
    "doubling": "dʌblɪŋ",
    "doublings": "dʌblɪŋz",
    "doubloon": "dʌbluːn",
    "doubloons": "dʌbluːnz",
    "doubly": "dʌbli",
    "doubt": "daʊt",
    "doubted": "daʊtɪd",
    "doubter": "daʊtɐ",
    "doubters": "daʊtəz",
    "doubtful": "daʊtfəl",
    "doubtfully": "daʊtfəli",
    "doubting": "daʊtɪŋ",
    "doubtless": "daʊtləs",
    "doubts": "daʊts",
    "douce": "daʊs",
    "douched": "duːʃt",
    "douche": "duːʃ",
    "douches": "duːʃɪz",
    "doughboy": "dəʊbɔɪ",
    "dough": "dəʊ",
    "doughnut": "dəʊnʌt",
    "doughnuts": "dəʊnʌts",
    "doughs": "dəʊz",
    "doughty": "daʊti",
    "doughy": "dəʊi",
    "douma": "daʊmɐ",
    "dour": "daʊə",
    "dourly": "daʊəli",
    "dourness": "daʊənəs",
    "douse": "daʊs",
    "doused": "daʊsd",
    "douses": "daʊsɪz",
    "dousing": "daʊsɪŋ",
    "dovecot": "dʌvkɒt",
    "dovecote": "dʌvkəʊt",
    "dovecotes": "dʌvkəʊts",
    "doves": "dʌvz",
    "dovetail": "dʌvteɪl",
    "dovetailed": "dʌvteɪld",
    "dovetailing": "dʌvteɪlɪŋ",
    "dovetails": "dʌvteɪlz",
    "dowager": "daʊɪdʒɐ",
    "dowagers": "daʊɪdʒəz",
    "dow": "daʊ",
    "dowdier": "daʊdɪɐ",
    "dowdy": "daʊdi",
    "dowel": "daʊəl",
    "dowelled": "daʊəld",
    "dowelling": "daʊəlɪŋ",
    "dowels": "daʊəlz",
    "dower": "daʊɐ",
    "dowie": "daʊi",
    "downbeat": "daʊnbiːt",
    "downcast": "daʊnkɑːst",
    "down": "daʊn",
    "downdraught": "daʊndrɑːft",
    "downed": "daʊnd",
    "downer": "daʊnɐ",
    "downers": "daʊnəz",
    "downfall": "daʊnfɔːl",
    "downfallen": "daʊnfɔːlən",
    "downfalls": "daʊnfɔːlz",
    "downgrade": "daʊŋɡreɪd",
    "downgraded": "daʊŋɡreɪdɪd",
    "downgrades": "daʊŋɡreɪdz",
    "downgrading": "daʊŋɡreɪdɪŋ",
    "downhearted": "daʊnhɑːtɪd",
    "downhills": "daʊnhɪlz",
    "downing": "daʊnɪŋ",
    "downland": "daʊnlənd",
    "downlands": "daʊnləndz",
    "downloadable": "daʊnləʊdəbəl",
    "download": "daʊnləʊd",
    "downloaded": "daʊnləʊdɪd",
    "downloading": "daʊnləʊdɪŋ",
    "downloads": "daʊnləʊdz",
    "downmarket": "daʊnmɑːkɪt",
    "downpipe": "daʊnpaɪp",
    "downpipes": "daʊnpaɪps",
    "downplay": "daʊnpleɪ",
    "downplayed": "daʊnpleɪd",
    "downplaying": "daʊnpleɪɪŋ",
    "downplays": "daʊnpleɪz",
    "downpour": "daʊnpɔː",
    "downpours": "daʊnpɔːz",
    "downrange": "daʊnreɪndʒ",
    "downright": "daʊnraɪt",
    "downriver": "daʊnrɪvɐ",
    "downscale": "daʊnskeɪl",
    "downs": "daʊnz",
    "downshift": "daʊnʃɪft",
    "downshifted": "daʊnʃɪftɪd",
    "downside": "daʊnsaɪd",
    "downsides": "daʊnsaɪdz",
    "downsize": "daʊnsaɪz",
    "downsized": "daʊnsaɪzd",
    "downsizes": "daʊnsaɪzɪz",
    "downsizing": "daʊnsaɪzɪŋ",
    "downspout": "daʊnspaʊt",
    "downstage": "daʊnsteɪdʒ",
    "downstream": "daʊnstriːm",
    "downstroke": "daʊnstrəʊk",
    "downswing": "daʊnswɪŋ",
    "downtime": "daʊntaɪm",
    "downtown": "daʊntaʊn",
    "downtrodden": "daʊntrɒdən",
    "downturn": "daʊntɜːn",
    "downturns": "daʊntɜːnz",
    "downward": "daʊnwəd",
    "downwardly": "daʊnwədli",
    "downwards": "daʊnwədz",
    "downwash": "daʊnwɒʃ",
    "downwind": "daʊnwɪnd",
    "downy": "daʊni",
    "dowries": "daʊrɪz",
    "dowry": "daʊri",
    "dowse": "daʊz",
    "dowsed": "daʊzd",
    "dowser": "daʊzɐ",
    "dowsers": "daʊzəz",
    "dowsing": "daʊzɪŋ",
    "doxy": "dɒksi",
    "doyen": "dɔɪən",
    "doyenne": "dɔɪən",
    "doyens": "dɔɪənz",
    "dozed": "dəʊzd",
    "doze": "dəʊz",
    "dozen": "dʌzən",
    "dozens": "dʌzənz",
    "dozer": "dəʊzɐ",
    "dozers": "dəʊzəz",
    "dozes": "dəʊzɪz",
    "dozier": "dəʊzɪɐ",
    "dozing": "dəʊzɪŋ",
    "dozy": "dəʊzi",
    "drabber": "dræbɐ",
    "drabble": "dræbəl",
    "drab": "dræb",
    "drably": "dreɪbli",
    "drabness": "dræbnəs",
    "drabs": "dræbz",
    "drachma": "drætʃmɐ",
    "drachmas": "drætʃməz",
    "draconian": "drækəʊniən",
    "draft": "drɑːft",
    "drafted": "drɑːftɪd",
    "drafter": "drɑːftɐ",
    "drafters": "drɑːftəz",
    "drafting": "drɑːftɪŋ",
    "drafts": "drɑːfts",
    "drag": "dræɡ",
    "dragged": "dræɡd",
    "dragger": "dræɡɐ",
    "dragging": "dræɡɪŋ",
    "draggy": "dræɡi",
    "dragnet": "dræɡnɛt",
    "dragon": "dræɡən",
    "dragonflies": "dræɡənflaɪz",
    "dragonfly": "dræɡənflaɪ",
    "dragons": "dræɡənz",
    "dragoon": "dræɡuːn",
    "dragooned": "dræɡuːnd",
    "dragooning": "dræɡuːnɪŋ",
    "dragoons": "dræɡuːnz",
    "drags": "dræɡz",
    "dragster": "dræɡstɐ",
    "dragsters": "dræɡstəz",
    "drainage": "dreɪnɪdʒ",
    "drain": "dreɪn",
    "drained": "dreɪnd",
    "drainer": "dreɪnɐ",
    "drainers": "dreɪnəz",
    "draining": "dreɪnɪŋ",
    "drainpipe": "dreɪnpaɪp",
    "drainpipes": "dreɪnpaɪps",
    "drains": "dreɪnz",
    "drake": "dreɪk",
    "drakes": "dreɪks",
    "drama": "drɑːmɐ",
    "dramas": "drɑːməz",
    "dramatically": "drəmætɪkli",
    "dramatic": "drəmætɪk",
    "dramatics": "drəmætɪks",
    "dramatisation": "dræmɐtaɪzeɪʃən",
    "dramatise": "dræmɐtaɪz",
    "dramatised": "dræmɐtaɪzd",
    "dramatises": "dræmɐtaɪzɪz",
    "dramatising": "dræmɐtaɪzɪŋ",
    "dramatist": "dræmɐtɪst",
    "dramatists": "dræmɐtɪsts",
    "dramaturge": "dræmətʃɔːdʒ",
    "dram": "dræm",
    "drams": "dræmz",
    "drank": "dræŋk",
    "draped": "dreɪpt",
    "drape": "dreɪp",
    "draper": "dreɪpɐ",
    "draperies": "dreɪpərɪz",
    "drapers": "dreɪpəz",
    "drapery": "dreɪpəri",
    "drapes": "dreɪps",
    "draping": "dreɪpɪŋ",
    "drastically": "drɑːstɪkli",
    "drastic": "drɑːstɪk",
    "drat": "dræt",
    "dratted": "drætɪd",
    "draught": "drɑːft",
    "draughts": "drɑːfts",
    "draughtsman": "drɑːftsmən",
    "draughtsmanship": "drɑːftsmənʃɪp",
    "draughtsmen": "drɑːftsmɛn",
    "draughty": "drɑːfti",
    "drawback": "drɔːbæk",
    "drawbacks": "drɔːbæks",
    "drawbridge": "drɔːbrɪdʒ",
    "drawbridges": "drɔːbrɪdʒɪz",
    "draw": "drɔː",
    "drawing": "drɔːrɪŋ",
    "drawings": "drɔːrɪŋz",
    "drawl": "drɔːl",
    "drawled": "drɔːld",
    "drawling": "drɔːlɪŋ",
    "drawls": "drɔːlz",
    "drawn": "drɔːn",
    "draws": "drɔːz",
    "drawstring": "drɔːstrɪŋ",
    "dray": "dreɪ",
    "drayman": "dreɪmən",
    "drays": "dreɪz",
    "dread": "drɛd",
    "dreaded": "drɛdɪd",
    "dreadful": "drɛdfəl",
    "dreadfully": "drɛdfəli",
    "dreadfulness": "drɛdfəlnəs",
    "dreading": "drɛdɪŋ",
    "dreadlocks": "drɛdlɒks",
    "dreadnaught": "drɛdnɔːt",
    "dreadnought": "drɛdnɔːt",
    "dreadnoughts": "drɛdnɔːts",
    "dreads": "drɛdz",
    "dreamboat": "driːmbəʊt",
    "dreamboats": "driːmbəʊts",
    "dream": "driːm",
    "dreamed": "driːmd",
    "dreamer": "driːmɐ",
    "dreamers": "driːməz",
    "dreamiest": "driːmɪəst",
    "dreamily": "driːmɪli",
    "dreaminess": "driːmɪnəs",
    "dreaming": "driːmɪŋ",
    "dreamland": "driːmlənd",
    "dreamless": "driːmləs",
    "dreamlike": "driːmlaɪk",
    "dreams": "driːmz",
    "dreamt": "drɛmpt",
    "dreamworld": "driːmwɜːld",
    "dreamy": "driːmi",
    "drear": "driə",
    "dreariest": "driərɪəst",
    "drearily": "driərɪli",
    "dreariness": "driərɪnəs",
    "dreary": "driəri",
    "dredged": "drɛdʒd",
    "dredge": "drɛdʒ",
    "dredger": "drɛdʒɐ",
    "dredgers": "drɛdʒəz",
    "dredges": "drɛdʒɪz",
    "dredging": "drɛdʒɪŋ",
    "dree": "driː",
    "dreg": "drɛɡ",
    "dregs": "drɛɡz",
    "drench": "drɛntʃ",
    "drenched": "drɛntʃt",
    "drenches": "drɛntʃɪz",
    "drenching": "drɛntʃɪŋ",
    "dressage": "drɛsɪdʒ",
    "dress": "drɛs",
    "dressed": "drɛst",
    "dresser": "drɛsɐ",
    "dressers": "drɛsəz",
    "dresses": "drɛsɪz",
    "dressing": "drɛsɪŋ",
    "dressings": "drɛsɪŋz",
    "dressmaker": "drɛsmeɪkɐ",
    "dressmakers": "drɛsmeɪkəz",
    "dressmaking": "drɛsmeɪkɪŋ",
    "dressy": "drɛsi",
    "drew": "druː",
    "dribble": "drɪbəl",
    "dribbled": "drɪbəld",
    "dribbler": "drɪblɐ",
    "dribbles": "drɪbəlz",
    "dribbling": "drɪblɪŋ",
    "dried": "draɪd",
    "drier": "draɪə",
    "driers": "draɪəz",
    "dries": "draɪz",
    "driest": "draɪəst",
    "drift": "drɪft",
    "drifted": "drɪftɪd",
    "drifter": "drɪftɐ",
    "drifters": "drɪftəz",
    "drifting": "drɪftɪŋ",
    "drifts": "drɪfts",
    "driftwood": "drɪftwʊd",
    "drill": "drɪl",
    "drilled": "drɪld",
    "driller": "drɪlɐ",
    "drillers": "drɪləz",
    "drilling": "drɪlɪŋ",
    "drillings": "drɪlɪŋz",
    "drills": "drɪlz",
    "drily": "draɪli",
    "drinkable": "drɪŋkəbəl",
    "drink": "drɪŋk",
    "drinker": "drɪŋkɐ",
    "drinkers": "drɪŋkəz",
    "drinking": "drɪŋkɪŋ",
    "drinkings": "drɪŋkɪŋz",
    "drinks": "drɪŋks",
    "drip": "drɪp",
    "dripped": "drɪpt",
    "dripper": "drɪpɐ",
    "dripping": "drɪpɪŋ",
    "drippings": "drɪpɪŋz",
    "drippy": "drɪpi",
    "drips": "drɪps",
    "drivability": "draɪvəbɪlɪti",
    "drivable": "draɪvəbəl",
    "drive": "draɪv",
    "drivel": "drɪvəl",
    "drivelling": "drɪvəlɪŋ",
    "driven": "drɪvən",
    "driver": "draɪvɐ",
    "drivers": "draɪvəz",
    "drives": "draɪvz",
    "driveshaft": "draɪvʃɑːft",
    "driveway": "draɪvweɪ",
    "driveways": "draɪvweɪz",
    "driving": "draɪvɪŋ",
    "drizzled": "drɪzəld",
    "drizzle": "drɪzəl",
    "drizzles": "drɪzəlz",
    "drizzling": "drɪzlɪŋ",
    "drizzly": "drɪzli",
    "drogue": "drəʊɡ",
    "drogues": "drəʊɡz",
    "droit": "drɔɪt",
    "droll": "drəʊl",
    "drollery": "drəʊləri",
    "dromedaries": "drəʊmdəriz",
    "dromedary": "drəʊmdəri",
    "droned": "drəʊnd",
    "drone": "drəʊn",
    "drones": "drəʊnz",
    "drongo": "drɒŋɡəʊ",
    "droning": "drəʊnɪŋ",
    "drool": "druːl",
    "drooled": "druːld",
    "drooling": "druːlɪŋ",
    "drools": "druːlz",
    "droop": "druːp",
    "drooped": "druːpt",
    "drooping": "druːpɪŋ",
    "droops": "druːps",
    "droopy": "druːpi",
    "drop": "drɒp",
    "droplet": "drɒplət",
    "droplets": "drɒpləts",
    "dropout": "drɒpaʊt",
    "dropouts": "drɒpaʊts",
    "dropped": "drɒpt",
    "dropper": "drɒpɐ",
    "droppers": "drɒpəz",
    "dropping": "drɒpɪŋ",
    "droppings": "drɒpɪŋz",
    "drops": "drɒps",
    "dropsy": "drɒpsi",
    "dropwort": "drɒpwɔːt",
    "drosophila": "drɒsəfɪlɐ",
    "dross": "drɒs",
    "drought": "draʊt",
    "droughts": "draʊts",
    "droughty": "draʊti",
    "drouth": "draʊθ",
    "drouthy": "draʊθi",
    "drove": "drəʊv",
    "drover": "drəʊvɐ",
    "drovers": "drəʊvəz",
    "droves": "drəʊvz",
    "droving": "drəʊvɪŋ",
    "drown": "draʊn",
    "drowned": "draʊnd",
    "drowning": "draʊnɪŋ",
    "drownings": "draʊnɪŋz",
    "drowns": "draʊnz",
    "drowse": "draʊz",
    "drowsily": "draʊsɪli",
    "drowsiness": "draʊsɪnəs",
    "drowsing": "draʊzɪŋ",
    "drowsy": "draʊsi",
    "drubbed": "drʌbd",
    "drubbing": "drʌbɪŋ",
    "drudged": "drʌdʒd",
    "drudge": "drʌdʒ",
    "drudgery": "drʌdʒri",
    "drug": "drʌɡ",
    "drugged": "drʌɡd",
    "druggie": "drʌɡi",
    "druggies": "drʌɡɪz",
    "drugging": "drʌɡɪŋ",
    "druggist": "drʌɡɪst",
    "druggists": "drʌɡɪsts",
    "druggy": "drʌɡi",
    "drugs": "drʌɡz",
    "drugstore": "drʌɡstɔː",
    "drugstores": "drʌɡstɔːz",
    "druid": "druːɪd",
    "druidical": "druːɪdɪkəl",
    "druidic": "druːɪdɪk",
    "druidism": "druːɪdɪzəm",
    "druids": "druːɪdz",
    "drumbeat": "drʌmbiːt",
    "drumbeats": "drʌmbiːts",
    "drum": "drʌm",
    "drumhead": "drʌmhɛd",
    "drumlin": "drʌmlɪn",
    "drumlins": "drʌmlɪnz",
    "drummed": "drʌmd",
    "drummer": "drʌmɐ",
    "drummers": "drʌməz",
    "drumming": "drʌmɪŋ",
    "drums": "drʌmz",
    "drumstick": "drʌmstɪk",
    "drumsticks": "drʌmstɪks",
    "drunkard": "drʌŋkəd",
    "drunkards": "drʌŋkədz",
    "drunk": "drʌŋk",
    "drunken": "drʌŋkən",
    "drunkenly": "drʌŋkənli",
    "drunkenness": "drʌŋkənnəs",
    "drunker": "drʌŋkɐ",
    "drunkest": "drʌŋkəst",
    "drunks": "drʌŋks",
    "drupe": "druːp",
    "dryad": "draɪæd",
    "dryads": "draɪædz",
    "dry": "draɪ",
    "dryer": "draɪɐ",
    "dryers": "draɪəz",
    "dryest": "draɪəst",
    "drying": "draɪɪŋ",
    "dryish": "drɪɪʃ",
    "dryness": "draɪnəs",
    "drys": "draɪz",
    "drystone": "drɪstəʊn",
    "drywall": "draɪwɔːl",
    "dual": "djuːəl",
    "dualism": "djuːəlɪzəm",
    "dualistic": "djuːəlɪstɪk",
    "dualists": "djuːəlɪsts",
    "dualities": "djuːælɪtiz",
    "duality": "djuːælɪti",
    "dually": "djuːəli",
    "dubbed": "dʌbd",
    "dubbin": "dʌbɪn",
    "dubbing": "dʌbɪŋ",
    "dub": "dʌb",
    "dubiety": "djuːbaɪəti",
    "dubious": "djuːbɪəs",
    "dubiously": "djuːbɪəsli",
    "dubs": "dʌbz",
    "ducal": "djuːkəl",
    "ducat": "dʒuːkæt",
    "ducats": "dʒuːkæts",
    "duce": "djuːs",
    "duchess": "dʌtʃɛs",
    "duchesses": "dʌtʃɛsɪz",
    "duchies": "dʌtʃɪz",
    "duchy": "dʌtʃi",
    "duckbill": "dʌkbɪl",
    "duckboard": "dʌkbɔːd",
    "duckboards": "dʌkbɔːdz",
    "duck": "dʌk",
    "ducked": "dʌkt",
    "duckies": "dʌkiz",
    "ducking": "dʌkɪŋ",
    "duckling": "dʌklɪŋ",
    "ducklings": "dʌklɪŋz",
    "duckpond": "dʌkpɒnd",
    "ducks": "dʌks",
    "duckweed": "dʌkwiːd",
    "ducky": "dʌki",
    "duct": "dʌkt",
    "ducted": "dʌktɪd",
    "ductile": "dʌktaɪl",
    "ducting": "dʌktɪŋ",
    "ducts": "dʌkts",
    "dud": "dʌd",
    "dude": "djuːd",
    "dudes": "djuːdz",
    "dudgeon": "dʌdʒɒn",
    "duds": "dʌdz",
    "due": "djuː",
    "duel": "djuːəl",
    "duelled": "djuːəld",
    "duelling": "djuːəlɪŋ",
    "duellist": "djuːəlɪst",
    "duellists": "djuːəlɪsts",
    "duels": "djuːəlz",
    "duende": "djuːɛnd",
    "dues": "djuːz",
    "duet": "djuːɛt",
    "duets": "djuːɛts",
    "duff": "dʌf",
    "duffed": "dʌft",
    "duffel": "dʌfəl",
    "duffer": "dʌfɐ",
    "duffers": "dʌfəz",
    "duffing": "dʌfɪŋ",
    "duffs": "dʌfs",
    "dug": "dʌɡ",
    "dugong": "djuːɡɒŋ",
    "dugongs": "djuːɡɒŋz",
    "dugout": "dʌɡaʊt",
    "dugouts": "dʌɡaʊts",
    "duh": "dʌ",
    "duke": "djuːk",
    "dukedom": "djuːkɛdəm",
    "dukedoms": "djuːkɛdəmz",
    "dukes": "djuːks",
    "dulcet": "dʌlsɪt",
    "dulcimer": "dʌlsɪmɐ",
    "dulcimers": "dʌlsɪməz",
    "dullard": "dʌlɑːd",
    "dullards": "dʌlɑːdz",
    "dull": "dʌl",
    "dulled": "dʌld",
    "duller": "dʌlɐ",
    "dullest": "dʌləst",
    "dulling": "dʌlɪŋ",
    "dullish": "dʌlɪʃ",
    "dullness": "dʌlnəs",
    "dulls": "dʌlz",
    "dulse": "dʌls",
    "duly": "djuːli",
    "duma": "duːmɐ",
    "dumbbell": "dʌmbɛl",
    "dumbbells": "dʌmbɛlz",
    "dumb": "dʌm",
    "dumber": "dʌmɐ",
    "dumbest": "dʌməst",
    "dumbfound": "dʌmfaʊnd",
    "dumbfounded": "dʌmfaʊndɪd",
    "dumbly": "dʌmli",
    "dumbness": "dʌmnəs",
    "dumbo": "dʌməʊ",
    "dumbos": "dʌməʊz",
    "dumbstruck": "dʌmstrʌk",
    "dumbwaiter": "dʌmweɪtɐ",
    "dummies": "dʌmɪz",
    "dummy": "dʌmi",
    "dump": "dʌmp",
    "dumped": "dʌmpt",
    "dumper": "dʌmpɐ",
    "dumpers": "dʌmpəz",
    "dumping": "dʌmpɪŋ",
    "dumpling": "dʌmplɪŋ",
    "dumplings": "dʌmplɪŋz",
    "dumps": "dʌmps",
    "dumpster": "dʌmpstɐ",
    "dumpsters": "dʌmpstəz",
    "dumpy": "dʌmpi",
    "dunce": "dʌns",
    "dunces": "dʌnsɪz",
    "dunderhead": "dʌndəhɛd",
    "dunderheads": "dʌndəhɛdz",
    "dun": "dʌn",
    "dune": "djuːn",
    "dunes": "djuːnz",
    "dungaree": "dʌŋɡɐriː",
    "dungarees": "dʌŋɡɐriːz",
    "dung": "dʌŋ",
    "dungeon": "dʌndʒən",
    "dungeons": "dʌndʒənz",
    "dunk": "dʌŋk",
    "dunked": "dʌŋkt",
    "dunking": "dʌŋkɪŋ",
    "dunks": "dʌŋks",
    "dunlin": "dʌnlɪn",
    "dunlins": "dʌnlɪnz",
    "dunned": "dʌnd",
    "dunnest": "dʌnəst",
    "dunning": "dʌnɪŋ",
    "dunnock": "dʌnək",
    "dunnocks": "dʌnəks",
    "dunno": "dʌnəʊ",
    "duns": "dʌnz",
    "dunt": "dʌnt",
    "duodenal": "djuːəʊdnəl",
    "duodenum": "djuːəʊdnəm",
    "duo": "djuːəʊ",
    "duologue": "djuːəlɒɡ",
    "duomo": "djuːəʊməʊ",
    "duopoly": "djuːɒpəli",
    "duos": "djuːəʊz",
    "duped": "djuːpt",
    "dupe": "djuːp",
    "duper": "duːpɐ",
    "dupes": "djuːps",
    "duping": "djuːpɪŋ",
    "duple": "djuːpəl",
    "duplex": "djuːplɛks",
    "duplicated": "djuːplɪkeɪtɪd",
    "duplicating": "djuːplɪkeɪtɪŋ",
    "duplication": "djuːplɪkeɪʃən",
    "duplications": "djuːplɪkeɪʃənz",
    "duplicitous": "djuːplɪsɪtəs",
    "duplicity": "djuːplɪsɪti",
    "durability": "djɔːrəbɪlɪti",
    "durable": "djɔːrəbəl",
    "durables": "djɔːrəbəlz",
    "durance": "djɔːrəns",
    "duration": "djɔːreɪʃən",
    "durations": "djɔːreɪʃənz",
    "durbar": "dɜːbɑː",
    "duress": "djɔːrɛs",
    "durian": "djɔːriən",
    "during": "djɔːrɪŋ",
    "duro": "djɔːrəʊ",
    "durst": "dɜːst",
    "durum": "djɔːrəm",
    "dusk": "dʌsk",
    "dusky": "dʌski",
    "dustbin": "dʌstbɪn",
    "dustbins": "dʌstbɪnz",
    "dustcart": "dʌstkɑːt",
    "dustcarts": "dʌstkɑːts",
    "dust": "dʌst",
    "dusted": "dʌstɪd",
    "duster": "dʌstɐ",
    "dusters": "dʌstəz",
    "dustier": "dʌstɪɐ",
    "dustiest": "dʌstɪəst",
    "dustiness": "dʌstɪnəs",
    "dusting": "dʌstɪŋ",
    "dustless": "dʌstləs",
    "dustman": "dʌstmən",
    "dustmen": "dʌstmɛn",
    "dustpan": "dʌstpæn",
    "dustproof": "dʌstpruːf",
    "dusts": "dʌsts",
    "dustsheets": "dʌstʃiːts",
    "dusty": "dʌsti",
    "dutch": "dʌtʃ",
    "duties": "djuːtɪz",
    "dutiful": "djuːtɪfəl",
    "dutifully": "djuːtɪfəli",
    "duty": "djuːti",
    "duvet": "duːveɪ",
    "duvets": "duːveɪs",
    "dux": "dʌks",
    "dwarf": "dwɔːf",
    "dwarfed": "dwɔːft",
    "dwarfing": "dwɔːfɪŋ",
    "dwarfish": "dwɔːfɪʃ",
    "dwarfism": "dwɔːfɪzəm",
    "dwarfs": "dwɔːfs",
    "dwarves": "dwɔːvz",
    "dweeb": "dwiːb",
    "dweebs": "dwiːbz",
    "dwell": "dwɛl",
    "dwelled": "dwɛld",
    "dweller": "dwɛlɐ",
    "dwellers": "dwɛləz",
    "dwelling": "dwɛlɪŋ",
    "dwellings": "dwɛlɪŋz",
    "dwells": "dwɛlz",
    "dwelt": "dwɛlt",
    "dwindled": "dwɪndəld",
    "dwindle": "dwɪndəl",
    "dwindles": "dwɪndəlz",
    "dwindling": "dwɪndlɪŋ",
    "dyad": "daɪæd",
    "dye": "daɪ",
    "dyed": "daɪd",
    "dyeing": "daɪɪŋ",
    "dyer": "daɪɐ",
    "dyers": "daɪəz",
    "dyes": "daɪz",
    "dying": "daɪɪŋ",
    "dyke": "daɪk",
    "dykes": "daɪks",
    "dynamical": "daɪnæmɪkəl",
    "dynamically": "daɪnæmɪkli",
    "dynamic": "daɪnæmɪk",
    "dynamics": "daɪnæmɪks",
    "dynamism": "daɪnɐmɪzəm",
    "dynamite": "daɪnɐmaɪt",
    "dynamited": "daɪnɐmaɪtɪd",
    "dynamo": "daɪnɐməʊ",
    "dynamometer": "daɪnɐmɒmɪtɐ",
    "dynamos": "daɪnɐməʊz",
    "dynast": "dɪnɑːst",
    "dynastic": "dɪnɑːstɪk",
    "dynasties": "dɪnɐstɪz",
    "dynasts": "dɪnɑːsts",
    "dynasty": "dɪnɐsti",
    "dyne": "daɪn",
    "dysentery": "dɪsəntəri",
    "dysfunctional": "dɪsfʌŋkʃənəl",
    "dysfunction": "dɪsfʌŋkʃən",
    "dysfunctions": "dɪsfʌŋkʃənz",
    "dyslexia": "dɪslɛksiə",
    "dyslexic": "dɪslɛksɪk",
    "dyslexics": "dɪslɛksɪks",
    "dyspepsia": "dɪspɛpsiə",
    "dyspeptic": "dɪspɛptɪk",
    "dysphasia": "dɪsfeɪziə",
    "dysphonia": "dɪsfəʊniə",
    "dysphoria": "dɪsfɔːriə",
    "dysplasia": "dɪspleɪziə",
    "dyspnoea": "dɪspniə",
    "dysprosium": "dɪsprəʊsiəm",
    "dystopia": "dɪstəʊpiə",
    "dystopian": "dɪstəʊpiən",
    "dystrophic": "dɪstrɒfɪk",
    "dystrophy": "dɪstrəfi",
    "each": "iːtʃ",
    "eager": "iːɡɐ",
    "eagerly": "iːɡəli",
    "eagerness": "iːɡənəs",
    "eagle": "iːɡəl",
    "eagles": "iːɡəlz",
    "eaglet": "iːɡlət",
    "earache": "iəreɪk",
    "eardrops": "iədrɒps",
    "eardrum": "iədrəm",
    "eardrums": "iədrəmz",
    "eared": "iəd",
    "earflaps": "iəflæps",
    "earful": "iəfəl",
    "ear": "iə",
    "earing": "iərɪŋ",
    "earldom": "ɜːldəm",
    "earldoms": "ɜːldəmz",
    "earlier": "ɜːlɪɐ",
    "earliest": "ɜːlɪəst",
    "earliness": "ɜːlɪnəs",
    "earl": "ɜːl",
    "earlobe": "iələʊb",
    "earlobes": "iələʊbz",
    "earls": "ɜːlz",
    "early": "ɜːli",
    "earmarked": "iəmɑːkt",
    "earmark": "iəmɑːk",
    "earmarking": "iəmɑːkɪŋ",
    "earmarks": "iəmɑːks",
    "earmuffs": "iəmʌfs",
    "earned": "ɜːnd",
    "earner": "ɜːnɐ",
    "earners": "ɜːnəz",
    "earnestly": "ɜːnəstli",
    "earnestness": "ɜːnəstnəs",
    "earnest": "ɜːnəst",
    "earning": "ɜːnɪŋ",
    "earnings": "ɜːnɪŋz",
    "earn": "ɜːn",
    "earns": "ɜːnz",
    "earphone": "iəfəʊn",
    "earphones": "iəfəʊnz",
    "earpiece": "iəpiːs",
    "earpieces": "iəpiːsɪz",
    "earplug": "iəplʌɡ",
    "earplugs": "iəplʌɡz",
    "earring": "iərɪŋ",
    "earrings": "iərɪŋz",
    "earshot": "iəʃɒt",
    "ears": "iəz",
    "earthbound": "ɜːθbaʊnd",
    "earthed": "ɜːθd",
    "earthen": "ɜːðən",
    "earthenware": "ɜːθənweə",
    "earthier": "ɜːθɪɐ",
    "earthiness": "ɜːθɪnəs",
    "earthing": "ɜːθɪŋ",
    "earthlight": "ɜːθlaɪt",
    "earthliness": "ɜːθlinəs",
    "earthlings": "ɜːθlɪŋz",
    "earthling": "ɜːθlɪŋ",
    "earthly": "ɜːθli",
    "earthman": "ɜːθmən",
    "earthquakes": "ɜːθkweɪks",
    "earthquake": "ɜːθkweɪk",
    "earthshine": "ɜːθʃaɪn",
    "earths": "ɜːθs",
    "earthwards": "ɜːθwədz",
    "earthworks": "ɜːθwɜːks",
    "earthwork": "ɜːθwɜːk",
    "earthworms": "ɜːθwɜːmz",
    "earthworm": "ɜːθwɜːm",
    "earthy": "ɜːθi",
    "earth": "ɜːθ",
    "earwax": "iəwæks",
    "earwig": "iəwɪɡ",
    "earwigs": "iəwɪɡz",
    "eased": "iːzd",
    "easeful": "iːzfəl",
    "ease": "iːz",
    "easel": "iːzəl",
    "easels": "iːzəlz",
    "easement": "iːzmənt",
    "eases": "iːzɪz",
    "easier": "iːzɪɐ",
    "easiest": "iːzɪəst",
    "easily": "iːzɪli",
    "easiness": "iːzɪnəs",
    "easing": "iːzɪŋ",
    "eastbound": "iːstbaʊnd",
    "easterly": "iːstəli",
    "easterner": "iːstənɐ",
    "easterners": "iːstənəz",
    "eastern": "iːstən",
    "easternmost": "iːstənməʊst",
    "east": "iːst",
    "eastward": "iːstwəd",
    "eastwards": "iːstwədz",
    "easygoing": "iːzɪɡəʊɪŋ",
    "easy": "iːzi",
    "eatable": "iːtəbəl",
    "eaten": "iːtən",
    "eateries": "iːtəriz",
    "eater": "iːtɐ",
    "eaters": "iːtəz",
    "eatery": "iːtəri",
    "eating": "iːtɪŋ",
    "eat": "iːt",
    "eats": "iːts",
    "eau": "əʊ",
    "eave": "iːv",
    "eavesdrop": "iːvzdrɒp",
    "eavesdropped": "iːvzdrɒpt",
    "eavesdropper": "iːvzdrɒpɐ",
    "eavesdroppers": "iːvzdrɒpəz",
    "eavesdropping": "iːvzdrɒpɪŋ",
    "eavesdrops": "iːvzdrɒps",
    "eaves": "iːvz",
    "ebb": "ɛb",
    "ebbed": "ɛbd",
    "ebbing": "ɛbɪŋ",
    "ebbs": "ɛbz",
    "ebonies": "ɛbənɪz",
    "ebonised": "ɛbənaɪzd",
    "ebony": "ɛbəni",
    "ebullience": "ɪbʊliəns",
    "ebullient": "ɪbʊliənt",
    "eccentrically": "ɛksɛntrɪkli",
    "eccentric": "ɛksɛntrɪk",
    "eccentricities": "ɛksɪntrɪsɪtiz",
    "eccentricity": "ɛksɪntrɪsɪti",
    "eccentrics": "ɛksɛntrɪks",
    "ecclesia": "ɪkliːziə",
    "ecclesiastical": "ɪkliːzɪæstɪkəl",
    "ecclesiastic": "ɪkliːzɪæstɪk",
    "ecclesiastics": "ɪkliːzɪæstɪks",
    "echelon": "ɛʃəlɒn",
    "echelons": "ɛʃəlɒnz",
    "echidna": "ɛtʃɪdnɐ",
    "echidnas": "ɛtʃɪdnəz",
    "echinacea": "ɛtʃaɪneɪsiə",
    "echinoderm": "ɛtʃɪnəʊdəm",
    "echinoderms": "ɛtʃɪnəʊdəmz",
    "echoed": "ɛkəʊd",
    "echo": "ɛkəʊ",
    "echoes": "ɛkəʊz",
    "echoing": "ɛkəʊɪŋ",
    "echolalia": "ɛkəleɪliə",
    "echolocate": "ɛkələʊkeɪt",
    "echolocation": "ɛkələʊkeɪʃən",
    "echopraxia": "ɛkəpreɪksiə",
    "echos": "ɛkəʊz",
    "echt": "ɛtʃt",
    "eclampsia": "ɪklæmpsiə",
    "eclecticism": "ɪklɛktɪsɪzəm",
    "eclectic": "ɪklɛktɪk",
    "eclipsed": "ɪklɪpsd",
    "eclipse": "ɪklɪps",
    "eclipses": "ɪklɪpsɪz",
    "eclipsing": "ɪklɪpsɪŋ",
    "ecliptic": "ɪklɪptɪk",
    "ecological": "ɛkəlɒdʒɪkəl",
    "ecologically": "ɛkəlɒdʒɪkli",
    "ecologist": "ɛkɒlədʒɪst",
    "ecologists": "ɛkɒlədʒɪsts",
    "ecology": "ɛkɒlədʒi",
    "economical": "iːkənɒmɪkəl",
    "economically": "iːkənɒmɪkli",
    "economic": "iːkənɒmɪk",
    "economics": "iːkənɒmɪks",
    "economies": "ɪkɒnəmɪz",
    "economised": "ɪkɒnəmaɪzd",
    "economise": "ɪkɒnəmaɪz",
    "economising": "ɪkɒnəmaɪzɪŋ",
    "economist": "ɪkɒnəmɪst",
    "economists": "ɪkɒnəmɪsts",
    "economy": "ɪkɒnəmi",
    "ecosystem": "iːkəʊsɪstəm",
    "ecosystems": "iːkəʊsɪstəmz",
    "ecotourism": "ɛkətɔːrɪzəm",
    "ecru": "ɛkruː",
    "ecstasies": "ɛkstəsiz",
    "ecstasy": "ɛkstəsi",
    "ecstatically": "ɛkstætɪkli",
    "ecstatic": "ɛkstætɪk",
    "ectoparasite": "ɛktəpærɐsaɪt",
    "ectopic": "ɛktɒpɪk",
    "ectoplasm": "ɛktəplæzəm",
    "ectoplasmic": "ɛktəplæzmɪk",
    "ectothermic": "ɛktəðɜːmɪk",
    "ecu": "ɛkuː",
    "ecumenical": "ɛkjuːmɛnɪkəl",
    "ecumenically": "ɛkjuːmɛnɪkli",
    "eczema": "ɛkzəmɐ",
    "eczematous": "ɛkzɪmætəs",
    "eddies": "ɛdɪz",
    "eddy": "ɛdi",
    "eddying": "ɛdɪɪŋ",
    "edelweiss": "ɛdɪlweɪs",
    "edged": "ɛdʒd",
    "edge": "ɛdʒ",
    "edger": "ɛdʒɐ",
    "edges": "ɛdʒɪz",
    "edgeways": "ɛdʒweɪz",
    "edgewise": "ɛdʒwaɪz",
    "edgier": "ɛdʒɪɐ",
    "edgiest": "ɛdʒɪəst",
    "edginess": "ɛdʒɪnəs",
    "edging": "ɛdʒɪŋ",
    "edgings": "ɛdʒɪŋz",
    "edgy": "ɛdʒi",
    "edh": "ɛd",
    "edible": "ɛdəbəl",
    "edibles": "ɛdəbəlz",
    "edict": "iːdɪkt",
    "edicts": "iːdɪkts",
    "edification": "ɛdɪfɪkeɪʃən",
    "edifice": "ɛdɪfɪs",
    "edifices": "ɛdɪfɪsɪz",
    "edified": "ɛdɪfaɪd",
    "edify": "ɛdɪfaɪ",
    "edifying": "ɛdɪfaɪɪŋ",
    "edited": "ɛdɪtɪd",
    "edit": "ɛdɪt",
    "editing": "ɛdɪtɪŋ",
    "edition": "ɪdɪʃən",
    "editions": "ɪdɪʃənz",
    "editor": "ɛdɪtɐ",
    "editorial": "ɛdɪtɔːrɪəl",
    "editorialised": "ɛdɪtɔːrɪəlaɪzd",
    "editorialise": "ɛdɪtɔːrɪəlaɪz",
    "editorialising": "ɛdɪtɔːrɪəlaɪzɪŋ",
    "editorially": "ɛdɪtɔːrɪəli",
    "editorials": "ɛdɪtɔːrɪəlz",
    "editors": "ɛdɪtəz",
    "editorship": "ɛdɪtəʃɪp",
    "edits": "ɛdɪts",
    "educated": "ɛdʒuːkeɪtɪd",
    "educate": "ɛdʒuːkeɪt",
    "educates": "ɛdʒuːkeɪts",
    "educating": "ɛdʒuːkeɪtɪŋ",
    "educational": "ɛdʒuːkeɪʃənəl",
    "educationalist": "ɛdʒuːkeɪʃənəlɪst",
    "educationalists": "ɛdʒuːkeɪʃənəlɪsts",
    "educationally": "ɛdʒuːkeɪʃənəli",
    "education": "ɛdʒuːkeɪʃən",
    "educationist": "ɛdʒuːkeɪʃənɪst",
    "educationists": "ɛdʒuːkeɪʃənɪsts",
    "educations": "ɛdʒuːkeɪʃənz",
    "educative": "ɛdʒuːkətɪv",
    "educator": "ɛdʒuːkeɪtɐ",
    "educators": "ɛdʒuːkeɪtəz",
    "eduction": "ɛdʌkʃən",
    "eek": "iːk",
    "eel": "iːl",
    "eels": "iːlz",
    "eelworm": "iːlwɜːm",
    "e'en": "ɛən",
    "e'er": "eə",
    "eerie": "iəri",
    "eeriest": "iərɪəst",
    "eerily": "iərɪli",
    "eeriness": "iərɪnəs",
    "eery": "iəri",
    "efface": "ɪfeɪs",
    "effacement": "ɪfeɪsmənt",
    "effaces": "ɪfeɪsɪz",
    "effacing": "ɪfeɪsɪŋ",
    "effected": "ɪfɛktɪd",
    "effect": "ɪfɛkt",
    "effecting": "ɪfɛktɪŋ",
    "effective": "ɪfɛktɪv",
    "effectively": "ɪfɛktɪvli",
    "effectiveness": "ɪfɛktɪvnəs",
    "effects": "ɪfɛkts",
    "effectual": "ɪfɛktʃuːəl",
    "effectually": "ɪfɛktʃuːəli",
    "effed": "ɛft",
    "effeminacy": "ɛfɪmɪnəsi",
    "effeminate": "ɛfɛmɪneɪt",
    "effervesce": "ɛfəvɛs",
    "effervescence": "ɛfəvɛsəns",
    "effervescent": "ɛfəvɛsənt",
    "effete": "ɛfiːt",
    "efficacious": "ɛfɪkeɪʃəs",
    "efficacy": "ɛfɪkəsi",
    "efficiencies": "ɪfɪʃənsɪz",
    "efficiency": "ɪfɪʃənsi",
    "efficient": "ɪfɪʃənt",
    "efficiently": "ɪfɪʃəntli",
    "eff": "iːɛfɛf",
    "effigies": "ɛfɪdʒɪz",
    "effigy": "ɛfɪdʒi",
    "effing": "ɛfɪŋ",
    "efflorescence": "ɛflərɛsəns",
    "effluence": "ɛfluːəns",
    "effluent": "ɛfluːənt",
    "effluvia": "ɛfluːviə",
    "effort": "ɛfət",
    "effortful": "ɛfətfəl",
    "effortless": "ɛfətləs",
    "effortlessly": "ɛfətləsli",
    "effortlessness": "ɛfətləsnəs",
    "efforts": "ɛfəts",
    "effrontery": "ɛfrəntəri",
    "effs": "ɛfs",
    "effulgent": "ɪfʌldʒənt",
    "effusion": "ɪfjuːʒən",
    "effusions": "ɪfjuːʒənz",
    "effusive": "ɪfjuːsɪv",
    "effusiveness": "ɪfjuːsɪvnəs",
    "eft": "ɛft",
    "egads": "ɛɡædz",
    "egalitarian": "ɪɡælɪteəriən",
    "egalitarianism": "ɪɡælɪteəriənɪzəm",
    "egestion": "ɛdʒɛstʃən",
    "eggbeater": "ɛɡbiːtɐ",
    "eggcup": "ɛɡkʌp",
    "eggcups": "ɛɡkʌps",
    "egg": "ɛɡ",
    "egged": "ɛɡd",
    "eggers": "ɛɡəz",
    "egghead": "ɛɡhɛd",
    "eggheads": "ɛɡhɛdz",
    "egging": "ɛɡɪŋ",
    "eggnog": "ɛɡnɒɡ",
    "eggplant": "ɛɡplænt",
    "eggplants": "ɛɡplænts",
    "eggs": "ɛɡz",
    "eggshell": "ɛɡʃɛl",
    "eggshells": "ɛɡʃɛlz",
    "eglantine": "ɛɡlɑːntiːn",
    "egocentric": "iːɡəʊsɛntrɪk",
    "ego": "iːɡəʊ",
    "egoism": "iːɡəʊɪzəm",
    "egoist": "iːɡəʊɪst",
    "egoless": "iːɡəʊləs",
    "egomaniacal": "iːɡəʊmɐnaɪəkəl",
    "egomaniac": "iːɡəʊmeɪnɪæk",
    "egos": "iːɡəʊz",
    "egotism": "ɛɡətɪzəm",
    "egotist": "ɛɡətɪst",
    "egotistical": "ɛɡətɪstɪkəl",
    "egotistic": "ɛɡətɪstɪk",
    "egregious": "ɪɡriːdʒəs",
    "egregiously": "ɪɡriːdʒəsli",
    "egret": "iːɡrət",
    "egrets": "iːɡrəts",
    "eh": "eɪ",
    "e": "iː",
    "eide": "aɪd",
    "eider": "aɪdɐ",
    "eiderdown": "aɪdədaʊn",
    "eiderdowns": "aɪdədaʊnz",
    "eiders": "aɪdəz",
    "eidetic": "aɪdɛtɪk",
    "eidos": "aɪdəʊz",
    "eighteen": "eɪtiːn",
    "eighteens": "eɪtiːnz",
    "eighteenth": "eɪtiːnθ",
    "eight": "eɪt",
    "eightfold": "eɪtfəʊld",
    "eighth": "eɪtθ",
    "eighths": "eɪtθs",
    "eighties": "eɪtɪz",
    "eightieth": "eɪtiəθ",
    "eightpence": "eɪtpəns",
    "eights": "eɪts",
    "eighty": "eɪti",
    "einkorn": "aɪŋkɔːn",
    "einsteinium": "aɪnstaɪniəm",
    "eisteddfod": "aɪstɪdfɒd",
    "eisteddfods": "aɪstɪdfɒdz",
    "either": "aɪðɐ",
    "ejaculated": "ɪdʒækjʊleɪtɪd",
    "ejaculating": "ɪdʒækjʊleɪtɪŋ",
    "ejaculation": "ɪdʒækjʊleɪʃən",
    "ejaculations": "ɪdʒækjʊleɪʃənz",
    "ejaculator": "ɪdʒækjʊleɪtɐ",
    "ejected": "ɪdʒɛktɪd",
    "ejecting": "ɪdʒɛktɪŋ",
    "ejection": "ɪdʒɛkʃən",
    "ejections": "ɪdʒɛkʃənz",
    "ejector": "ɪdʒɛktɐ",
    "ejects": "ɪdʒɛkts",
    "eked": "iːkt",
    "eke": "iːk",
    "ekes": "iːks",
    "eking": "iːkɪŋ",
    "elaborated": "ɪlæbəreɪtɪd",
    "elaborately": "ɪlæbəreɪtli",
    "elaborateness": "ɪlæbəreɪtnəs",
    "elaborates": "ɪlæbəreɪts",
    "elaborating": "ɪlæbəreɪtɪŋ",
    "elaboration": "ɪlæbəreɪʃən",
    "eland": "ɪlænd",
    "elands": "ɪlændz",
    "elapids": "ɪlæpɪdz",
    "elapsed": "ɪlæpsd",
    "elapse": "ɪlæps",
    "elapsing": "ɪlæpsɪŋ",
    "elasticated": "ɪlɑːstɪkeɪtɪd",
    "elasticised": "ɪlɑːstɪsaɪzd",
    "elasticity": "ɪlɑːstɪsɪti",
    "elastic": "ɪlɑːstɪk",
    "elated": "ɪleɪtɪd",
    "elate": "ɪleɪt",
    "elating": "ɪleɪtɪŋ",
    "elation": "ɪleɪʃən",
    "elbowed": "ɛlbəʊd",
    "elbow": "ɛlbəʊ",
    "elbowing": "ɛlbəʊɪŋ",
    "elbows": "ɛlbəʊz",
    "eld": "ɛld",
    "elderberries": "ɛldəbərɪz",
    "elderberry": "ɛldəbəri",
    "elder": "ɛldɐ",
    "elderflower": "ɛldəflaʊɐ",
    "elderly": "ɛldəli",
    "elders": "ɛldəz",
    "eldest": "ɛldəst",
    "eldritch": "ɛldrɪtʃ",
    "elecampane": "ɪlɛkɐmpeɪn",
    "electability": "ɪlɛktəbɪlɪti",
    "electable": "ɪlɛktəbəl",
    "elected": "ɪlɛktɪd",
    "electing": "ɪlɛktɪŋ",
    "electioneering": "ɪlɛkʃəniərɪŋ",
    "electioneer": "ɪlɛkʃəniə",
    "election": "ɪlɛkʃən",
    "elections": "ɪlɛkʃənz",
    "elective": "ɪlɛktɪv",
    "electives": "ɪlɛktɪvz",
    "elect": "ɪlɛkt",
    "electoral": "ɪlɛktərəl",
    "electorally": "ɪlɛktərəli",
    "electorate": "ɪlɛktəreɪt",
    "electorates": "ɪlɛktəreɪts",
    "elector": "ɪlɛktɐ",
    "electors": "ɪlɛktəz",
    "electret": "ɪlɛktrɪt",
    "electrical": "ɪlɛktrɪkəl",
    "electrically": "ɪlɛktrɪkli",
    "electrician": "ɪlɪktrɪʃən",
    "electricians": "ɪlɪktrɪʃənz",
    "electricity": "ɪlɛktrɪsɪti",
    "electric": "ɪlɛktrɪk",
    "electrics": "ɪlɛktrɪks",
    "electrification": "ɪlɛktrɪfɪkeɪʃən",
    "electrified": "ɪlɛktrɪfaɪd",
    "electrifies": "ɪlɛktrɪfaɪz",
    "electrifying": "ɪlɛktrɪfaɪɪŋ",
    "electrify": "ɪlɛktrɪfaɪ",
    "electrocardiogram": "ɪlɛktrəʊkɑːdɪəʊɡræm",
    "electrocardiograph": "ɪlɛktrəʊkɑːdɪəʊɡræf",
    "electrocardiography": "ɪlɛktrəʊkɑːdɪəʊɡrəfi",
    "electrochemical": "ɪlɛktrəʊkɛmɪkəl",
    "electrocuted": "ɪlɛktrəkjuːtɪd",
    "electrocute": "ɪlɛktrəkjuːt",
    "electrocutes": "ɪlɛktrəkjuːts",
    "electrocuting": "ɪlɛktrəkjuːtɪŋ",
    "electrocution": "ɪlɛktrəkjuːʃən",
    "electrocutions": "ɪlɛktrəkjuːʃənz",
    "electrode": "ɪlɛktrəʊd",
    "electrodes": "ɪlɛktrəʊdz",
    "electrodynamics": "ɪlɛktrəʊdaɪnæmɪks",
    "electroencephalogram": "ɪlɛktrəʊənsɛfɐlɒɡræm",
    "electroencephalograph": "ɪlɛktrəʊənsɛfɐlɒɡræf",
    "electroencephalography": "ɪlɛktrəʊənsɛfɐlɒɡrəfi",
    "electro": "ɪlɛktrəʊ",
    "electrolier": "ɛlɛktrəliɐ",
    "electroluminescent": "ɛlɛktrəluːmɪnɛsənt",
    "electrolysis": "ɛlɪktrɒləsɪs",
    "electrolyte": "ɛlɛktrəlaɪt",
    "electrolytes": "ɛlɛktrəlaɪts",
    "electrolytic": "ɛlɛktrəlɪtɪk",
    "electromagnetic": "ɪlɛktrəʊmɐɡnɛtɪk",
    "electromagnetism": "ɪlɛktrəʊmæɡnɪtɪzəm",
    "electromagnet": "ɪlɛktrəʊmæɡnɪt",
    "electromagnets": "ɪlɛktrəʊmæɡnɪts",
    "electromechanical": "ɪlɛktrəʊmɪkænɪkəl",
    "electromotive": "ɪlɛktrəʊməʊtɪv",
    "electronically": "ɛlɪktrɒnɪkli",
    "electronic": "ɛlɪktrɒnɪk",
    "electronics": "ɛlɪktrɒnɪks",
    "electron": "ɪlɛktrɒn",
    "electrons": "ɪlɛktrɒnz",
    "electroplated": "ɪlɛktrəʊpleɪtɪd",
    "electroplate": "ɪlɛktrəʊpleɪt",
    "electroplating": "ɪlɛktrəʊpleɪtɪŋ",
    "electroshock": "ɪlɛktrəʊʃɒk",
    "electrostatic": "ɪlɛktrəʊstætɪk",
    "electrotherapy": "ɪlɛktrəʊθɛrəpi",
    "electrotype": "ɪlɛktrəʊtaɪp",
    "electrum": "ɪlɛktrəm",
    "elects": "ɪlɛkts",
    "elegance": "ɛlɪɡəns",
    "elegant": "ɛlɪɡənt",
    "elegantly": "ɛlɪɡəntli",
    "elegiac": "ɛlɪdʒək",
    "elegiacs": "ɛlɪdʒəks",
    "elegies": "ɛlɪdʒɪz",
    "elegist": "ɛlɪdʒɪst",
    "elegy": "ɛlɪdʒi",
    "elemental": "ɛlɪmɛntəl",
    "elementary": "ɛlɪmɛntəri",
    "element": "ɛlɪmənt",
    "elements": "ɛlɪmənts",
    "elephant": "ɛlɪfənt",
    "elephantiasis": "ɛlɪfɑːnʃɪæsiz",
    "elephantine": "ɛlɪfɑːntiːn",
    "elephants": "ɛlɪfənts",
    "elevated": "ɛlɪveɪtɪd",
    "elevate": "ɛlɪveɪt",
    "elevates": "ɛlɪveɪts",
    "elevating": "ɛlɪveɪtɪŋ",
    "elevation": "ɛlɪveɪʃən",
    "elevations": "ɛlɪveɪʃənz",
    "elevator": "ɛlɪveɪtɐ",
    "elevators": "ɛlɪveɪtəz",
    "eleven": "ɪlɛvən",
    "elevenses": "ɪlɛvənsɪz",
    "elevens": "ɪlɛvənz",
    "eleventh": "ɪlɛvənθ",
    "elf": "ɛlf",
    "elfin": "ɛlfɪn",
    "elfish": "ɛlfɪʃ",
    "elfland": "ɛlflənd",
    "elicited": "ɪlɪsɪtɪd",
    "eliciting": "ɪlɪsɪtɪŋ",
    "elicit": "ɪlɪsɪt",
    "elicits": "ɪlɪsɪts",
    "elides": "ɪlaɪdz",
    "eliding": "ɪlaɪdɪŋ",
    "eligibility": "ɛlɪdʒəbɪlɪti",
    "eligible": "ɛlɪdʒəbəl",
    "eliminated": "ɪlɪmɪneɪtɪd",
    "eliminate": "ɪlɪmɪneɪt",
    "eliminates": "ɪlɪmɪneɪts",
    "eliminating": "ɪlɪmɪneɪtɪŋ",
    "elimination": "ɪlɪmɪneɪʃən",
    "eliminations": "ɪlɪmɪneɪʃənz",
    "eliminator": "ɪlɪmɪneɪtɐ",
    "eliminators": "ɪlɪmɪneɪtəz",
    "elision": "ɪlɪʒən",
    "elite": "ɪliːt",
    "elites": "ɪliːts",
    "elitism": "ɪliːtɪzəm",
    "elitist": "ɪliːtɪst",
    "elitists": "ɪliːtɪsts",
    "elixir": "ɪlɪksɐ",
    "elk": "ɛlk",
    "elks": "ɛlks",
    "ell": "ɛl",
    "ellipse": "ɪlɪps",
    "ellipsis": "ɪlɪpsɪs",
    "ellipsoid": "ɪlɪpsɔɪd",
    "elliptical": "ɪlɪptɪkəl",
    "elliptically": "ɪlɪptɪkli",
    "elliptic": "ɪlɪptɪk",
    "ells": "ɛlz",
    "elm": "ɛlm",
    "elms": "ɛlmz",
    "elocution": "ɪləkjuːʃən",
    "elongated": "ɪlɒŋɡeɪtɪd",
    "elongate": "ɪlɒŋɡeɪt",
    "elongates": "ɪlɒŋɡeɪts",
    "elongating": "ɪlɒŋɡeɪtɪŋ",
    "elongation": "ɪləŋɡeɪʃən",
    "eloped": "ɪləʊpt",
    "elope": "ɪləʊp",
    "elopement": "ɪləʊpmənt",
    "elopes": "ɪləʊps",
    "eloping": "ɪləʊpɪŋ",
    "eloquence": "ɛləkwəns",
    "eloquent": "ɛləkwənt",
    "eloquently": "ɛləkwəntli",
    "else": "ɛls",
    "els": "ɛlz",
    "elsewhere": "ɛlsweə",
    "elucidated": "ɪluːsɪdeɪtɪd",
    "elucidate": "ɪluːsɪdeɪt",
    "elucidates": "ɪluːsɪdeɪts",
    "elucidating": "ɪluːsɪdeɪtɪŋ",
    "elucidation": "ɪluːsɪdeɪʃən",
    "eluded": "ɪluːdɪd",
    "elude": "ɪluːd",
    "eludes": "ɪluːdz",
    "eluding": "ɪluːdɪŋ",
    "elusive": "ɪluːsɪv",
    "elusiveness": "ɪluːsɪvnəs",
    "elver": "ɛlvɐ",
    "elvers": "ɛlvəz",
    "elves": "ɛlvz",
    "elvish": "ɛlvɪʃ",
    "emaciated": "iːmeɪsɪeɪtɪd",
    "emaciation": "iːmeɪsɪeɪʃən",
    "emailed": "iːmeɪld",
    "emailing": "iːmeɪlɪŋ",
    "emails": "iːmeɪlz",
    "emanated": "ɛmɐneɪtɪd",
    "emanate": "ɛmɐneɪt",
    "emanates": "ɛmɐneɪts",
    "emanating": "ɛmɐneɪtɪŋ",
    "emanation": "ɛmɐneɪʃən",
    "emanations": "ɛmɐneɪʃənz",
    "emancipated": "ɪmɑːnsɪpeɪtɪd",
    "emancipate": "ɪmɑːnsɪpeɪt",
    "emancipation": "ɪmɑːnsɪpeɪʃən",
    "emancipator": "ɪmɑːnsɪpeɪtɐ",
    "emasculated": "ɪmæskjʊleɪtɪd",
    "emasculate": "ɪmæskjʊleɪt",
    "emasculating": "ɪmæskjʊleɪtɪŋ",
    "emasculation": "ɪmæskjʊleɪʃən",
    "embalmed": "ɛmbɑːmd",
    "embalm": "ɛmbɑːm",
    "embalmer": "ɛmbɑːmɐ",
    "embalmers": "ɛmbɑːməz",
    "embalming": "ɛmbɑːmɪŋ",
    "embalms": "ɛmbɑːmz",
    "embankment": "ɛmbæŋkmənt",
    "embankments": "ɛmbæŋkmənts",
    "embargoed": "ɛmbɑːɡəʊd",
    "embargo": "ɛmbɑːɡəʊ",
    "embargoes": "ɛmbɑːɡəʊz",
    "embarkation": "ɛmbɑːkeɪʃən",
    "embarked": "ɛmbɑːkt",
    "embark": "ɛmbɑːk",
    "embarking": "ɛmbɑːkɪŋ",
    "embarks": "ɛmbɑːks",
    "embarrassed": "ɛmbærəst",
    "embarrass": "ɛmbærəs",
    "embarrasses": "ɛmbærəsɪz",
    "embarrassing": "ɛmbærəsɪŋ",
    "embarrassingly": "ɛmbærəsɪŋli",
    "embarrassment": "ɛmbærəsmənt",
    "embarrassments": "ɛmbærəsmənts",
    "embassies": "ɛmbəsɪz",
    "embassy": "ɛmbəsi",
    "embattled": "ɛmbætəld",
    "embedded": "ɛmbɛdɪd",
    "embedding": "ɛmbɛdɪŋ",
    "embed": "ɛmbɛd",
    "embeds": "ɛmbɛdz",
    "embellished": "ɛmbɛlɪʃt",
    "embellish": "ɛmbɛlɪʃ",
    "embellishes": "ɛmbɛlɪʃɪz",
    "embellishing": "ɛmbɛlɪʃɪŋ",
    "embellishment": "ɛmbɛlɪʃmənt",
    "embellishments": "ɛmbɛlɪʃmənts",
    "ember": "ɛmbɐ",
    "embers": "ɛmbəz",
    "embezzled": "ɛmbɛzəld",
    "embezzle": "ɛmbɛzəl",
    "embezzlement": "ɛmbɛzəlmənt",
    "embezzler": "ɛmbɛzlɐ",
    "embezzling": "ɛmbɛzlɪŋ",
    "embittered": "ɛmbɪtəd",
    "embittering": "ɛmbɪtərɪŋ",
    "emblaze": "ɛmbleɪz",
    "emblazoned": "ɛmbleɪzənd",
    "emblazon": "ɛmbleɪzən",
    "emblematic": "ɛmbəlmætɪk",
    "emblem": "ɛmbləm",
    "emblems": "ɛmbləmz",
    "embodied": "ɛmbɒdɪd",
    "embodies": "ɛmbɒdɪz",
    "embodiment": "ɛmbɒdɪmənt",
    "embodiments": "ɛmbɒdɪmənts",
    "embody": "ɛmbɒdi",
    "embodying": "ɛmbɒdɪɪŋ",
    "emboldened": "ɛmbəʊldənd",
    "embolden": "ɛmbəʊldən",
    "emboldens": "ɛmbəʊldənz",
    "embolectomy": "ɛmbəlɛktəmi",
    "emboli": "ɛmbəʊli",
    "embolism": "ɛmbəʊlɪzəm",
    "embolus": "ɛmbɒləs",
    "embonpoint": "ɛmbɒnpɔɪnt",
    "embossed": "ɛmbɒst",
    "emboss": "ɛmbɒs",
    "embosses": "ɛmbɒsɪz",
    "embossing": "ɛmbɒsɪŋ",
    "embouchure": "ɛmbaʊʃjɔː",
    "embowered": "ɛmbaʊəd",
    "embraceable": "ɛmbreɪsəbəl",
    "embraced": "ɛmbreɪst",
    "embrace": "ɛmbreɪs",
    "embraces": "ɛmbreɪsɪz",
    "embracing": "ɛmbreɪsɪŋ",
    "embrocation": "ɛmbrəkeɪʃən",
    "embroidered": "ɛmbrɔɪdəd",
    "embroider": "ɛmbrɔɪdɐ",
    "embroiderer": "ɛmbrɔɪdərɐ",
    "embroiderers": "ɛmbrɔɪdərəz",
    "embroideries": "ɛmbrɔɪdəriz",
    "embroidering": "ɛmbrɔɪdərɪŋ",
    "embroiders": "ɛmbrɔɪdəz",
    "embroidery": "ɛmbrɔɪdəri",
    "embroiled": "ɛmbrɔɪld",
    "embroil": "ɛmbrɔɪl",
    "embroiling": "ɛmbrɔɪlɪŋ",
    "embroilment": "ɛmbrɔɪlmənt",
    "embroils": "ɛmbrɔɪlz",
    "embryo": "ɛmbrɪəʊ",
    "embryologist": "ɛmbrɪɒlədʒɪst",
    "embryologists": "ɛmbrɪɒlədʒɪsts",
    "embryology": "ɛmbrɪɒlədʒi",
    "embryonic": "ɛmbrɪɒnɪk",
    "embryos": "ɛmbrɪəʊz",
    "emcee": "ɛmsiː",
    "emcees": "ɛmsiːz",
    "em": "ɛm",
    "emerald": "ɛmərəld",
    "emeralds": "ɛmərəldz",
    "emerged": "ɪmɜːdʒd",
    "emerge": "ɪmɜːdʒ",
    "emergence": "ɪmɜːdʒəns",
    "emergencies": "ɪmɜːdʒənsiz",
    "emergency": "ɪmɜːdʒənsi",
    "emergent": "ɪmɜːdʒənt",
    "emerges": "ɪmɜːdʒɪz",
    "emerging": "ɪmɜːdʒɪŋ",
    "emeritus": "ɪmɛrɪtəs",
    "emersed": "ɪmɜːsd",
    "emersion": "ɪmɜːʃən",
    "emery": "ɛməri",
    "emetic": "ɪmɛtɪk",
    "emetics": "ɪmɛtɪks",
    "emigrant": "ɛmɪɡrənt",
    "emigrants": "ɛmɪɡrənts",
    "emigrated": "ɛmɪɡreɪtɪd",
    "emigrate": "ɛmɪɡreɪt",
    "emigrates": "ɛmɪɡreɪts",
    "emigrating": "ɛmɪɡreɪtɪŋ",
    "emigration": "ɛmɪɡreɪʃən",
    "emigrations": "ɛmɪɡreɪʃənz",
    "eminence": "ɛmɪnəns",
    "eminent": "ɛmɪnənt",
    "eminently": "ɛmɪnəntli",
    "emirate": "ɛmɪreɪt",
    "emirates": "ɛmɪreɪts",
    "emir": "ɛmiə",
    "emirs": "ɛmiəz",
    "emissaries": "ɛmɪsəriz",
    "emissary": "ɛmɪsəri",
    "emission": "ɪmɪʃən",
    "emissions": "ɪmɪʃənz",
    "emit": "ɪmɪt",
    "emits": "ɪmɪts",
    "emitted": "ɪmɪtɪd",
    "emitter": "ɪmɪtɐ",
    "emitters": "ɪmɪtəz",
    "emitting": "ɪmɪtɪŋ",
    "emmer": "ɛmɐ",
    "emmet": "ɛmɪt",
    "emollient": "ɪmɒliənt",
    "emoted": "ɪməʊtɪd",
    "emote": "ɪməʊt",
    "emoticon": "ɪmɒtɪkən",
    "emoticons": "ɪmɒtɪkənz",
    "emoting": "ɪməʊtɪŋ",
    "emotionalism": "ɪməʊʃənəlɪzəm",
    "emotionality": "ɪməʊʃənælɪti",
    "emotionally": "ɪməʊʃənəli",
    "emotional": "ɪməʊʃənəl",
    "emotionless": "ɪməʊʃənləs",
    "emotion": "ɪməʊʃən",
    "emotions": "ɪməʊʃənz",
    "emotive": "ɪməʊtɪv",
    "empanada": "ɛmpɐnɑːdɐ",
    "empathetically": "ɛmpɐθɛtɪkli",
    "empathetic": "ɛmpɐθɛtɪk",
    "empathic": "ɛmpæθɪk",
    "empathised": "ɛmpəθaɪzd",
    "empathise": "ɛmpəθaɪz",
    "empathises": "ɛmpəθaɪzɪz",
    "empathising": "ɛmpəθaɪzɪŋ",
    "empathy": "ɛmpəθi",
    "emperor": "ɛmpərɐ",
    "emperors": "ɛmpərəz",
    "emphasised": "ɛmfɐsaɪzd",
    "emphasise": "ɛmfɐsaɪz",
    "emphasis": "ɛmfəsɪs",
    "emphasises": "ɛmfɐsaɪzɪz",
    "emphasising": "ɛmfɐsaɪzɪŋ",
    "emphatically": "ɛmfætɪkli",
    "emphatic": "ɛmfætɪk",
    "emphysema": "ɛmfaɪsmɐ",
    "empire": "ɛmpaɪə",
    "empires": "ɛmpaɪəz",
    "empirical": "ɛmpɪrɪkəl",
    "empirically": "ɛmpɪrɪkli",
    "empiricism": "ɛmpɪrɪsɪzəm",
    "empiricist": "ɛmpɪrɪsɪst",
    "emplacement": "ɛmpleɪsmənt",
    "emplacements": "ɛmpleɪsmənts",
    "employability": "ɛmplɔɪəbɪlɪti",
    "employable": "ɛmplɔɪəbəl",
    "employed": "ɛmplɔɪd",
    "employee": "ɛmplɔɪiː",
    "employees": "ɛmplɔɪiːz",
    "employ": "ɛmplɔɪ",
    "employer": "ɛmplɔɪɐ",
    "employers": "ɛmplɔɪəz",
    "employing": "ɛmplɔɪɪŋ",
    "employment": "ɛmplɔɪmənt",
    "employments": "ɛmplɔɪmənts",
    "employs": "ɛmplɔɪz",
    "emporia": "ɛmpɔːriə",
    "emporium": "ɛmpɔːriəm",
    "emporiums": "ɛmpɔːriəmz",
    "empowered": "ɛmpaʊəd",
    "empower": "ɛmpaʊɐ",
    "empowering": "ɛmpaʊərɪŋ",
    "empowerment": "ɛmpaʊəmənt",
    "empowers": "ɛmpaʊəz",
    "empress": "ɛmprɛs",
    "empresses": "ɛmprɛsɪz",
    "emptied": "ɛmptɪd",
    "emptier": "ɛmptɪɐ",
    "empties": "ɛmptɪz",
    "emptiest": "ɛmptɪəst",
    "emptiness": "ɛmptɪnəs",
    "emptor": "ɛmptɔː",
    "empty": "ɛmpti",
    "emptying": "ɛmptɪɪŋ",
    "empurpled": "ɛmpɜːpəld",
    "empyema": "ɛmpɪɛmɐ",
    "ems": "ɛmz",
    "emu": "iːmjuː",
    "emulated": "ɛmjʊleɪtɪd",
    "emulate": "ɛmjʊleɪt",
    "emulates": "ɛmjʊleɪts",
    "emulating": "ɛmjʊleɪtɪŋ",
    "emulation": "ɛmjʊleɪʃən",
    "emulator": "ɛmjʊleɪtɐ",
    "emulous": "ɛmjʊləs",
    "emulsification": "ɪmʌlsɪfɪkeɪʃən",
    "emulsified": "ɪmʌlsɪfaɪd",
    "emulsifier": "ɪmʌlsɪfaɪə",
    "emulsifiers": "ɪmʌlsɪfaɪəz",
    "emulsifies": "ɪmʌlsɪfaɪz",
    "emulsifying": "ɪmʌlsɪfaɪɪŋ",
    "emulsify": "ɪmʌlsɪfaɪ",
    "emulsion": "ɪmʌlʃən",
    "emulsions": "ɪmʌlʃənz",
    "emus": "iːmjuːz",
    "enabled": "ɛneɪbəld",
    "enable": "ɛneɪbəl",
    "enabler": "ɛneɪblɐ",
    "enablers": "ɛneɪbləz",
    "enables": "ɛneɪbəlz",
    "enabling": "ɛneɪblɪŋ",
    "enacted": "ɛnæktɪd",
    "enact": "ɛnækt",
    "enacting": "ɛnæktɪŋ",
    "enactment": "ɛnæktmənt",
    "enactments": "ɛnæktmənts",
    "enactor": "ɛnæktɐ",
    "enacts": "ɛnækts",
    "enamelled": "ɪnæməld",
    "enamelling": "ɪnæməlɪŋ",
    "enamel": "ɪnæməl",
    "enamels": "ɪnæməlz",
    "enamoured": "ɪnæməd",
    "enate": "ɛneɪt",
    "encamped": "ɛnkæmpt",
    "encamp": "ɛnkæmp",
    "encampment": "ɛnkæmpmənt",
    "encampments": "ɛnkæmpmənts",
    "encapsulated": "ɛnkæpsjʊleɪtɪd",
    "encapsulate": "ɛnkæpsjʊleɪt",
    "encapsulates": "ɛnkæpsjʊleɪts",
    "encapsulating": "ɛnkæpsjʊleɪtɪŋ",
    "encapsulation": "ɛnkæpsuːleɪʃən",
    "encased": "ɛnkeɪst",
    "encase": "ɛnkeɪs",
    "encases": "ɛnkeɪsɪz",
    "encasing": "ɛnkeɪsɪŋ",
    "encaustic": "ɛnkɔːstɪk",
    "encephalitis": "ɛnsɛfɐlaɪtɪs",
    "encephalopathy": "ɛnsɛfɐlɒpəθi",
    "enchained": "ɛntʃeɪnd",
    "enchanted": "ɛntʃɑːntɪd",
    "enchant": "ɛntʃɑːnt",
    "enchanter": "ɛntʃɑːntɐ",
    "enchanters": "ɛntʃɑːntəz",
    "enchanting": "ɛntʃɑːntɪŋ",
    "enchantment": "ɛntʃɑːntmənt",
    "enchantments": "ɛntʃɑːntmənts",
    "enchantress": "ɛntʃɑːntrəs",
    "enchants": "ɛntʃɑːnts",
    "enchilada": "ɛntʃɪlɑːdɐ",
    "enchiladas": "ɛntʃɪlɑːdəz",
    "enciphered": "ɛnsaɪfəd",
    "encircled": "ɛnsɜːkəld",
    "encircle": "ɛnsɜːkəl",
    "encirclement": "ɛnsɜːkəlmənt",
    "encircles": "ɛnsɜːkəlz",
    "encircling": "ɛnsɜːklɪŋ",
    "enclave": "ɛnkleɪv",
    "enclaves": "ɛnkleɪvz",
    "enclosed": "ɛnkləʊzd",
    "enclose": "ɛnkləʊz",
    "encloses": "ɛnkləʊzɪz",
    "enclosing": "ɛnkləʊzɪŋ",
    "enclosure": "ɛnkləʊʒɐ",
    "enclosures": "ɛnkləʊʒəz",
    "encoded": "ɛnkəʊdɪd",
    "encode": "ɛnkəʊd",
    "encoder": "ɛnkəʊdɐ",
    "encodes": "ɛnkəʊdz",
    "encoding": "ɛnkəʊdɪŋ",
    "encomium": "ɛnkəʊmiəm",
    "encompassed": "ɛnkʌmpəst",
    "encompass": "ɛnkʌmpəs",
    "encompasses": "ɛnkʌmpəsɪz",
    "encompassing": "ɛnkʌmpəsɪŋ",
    "encored": "ɒnkəd",
    "encore": "ɒnkɔː",
    "encores": "ɒnkɔːz",
    "encountered": "ɛnkaʊntəd",
    "encounter": "ɛnkaʊntɐ",
    "encountering": "ɛnkaʊntərɪŋ",
    "encounters": "ɛnkaʊntəz",
    "encouraged": "ɛnkʌrɪdʒd",
    "encourage": "ɛnkʌrɪdʒ",
    "encouragement": "ɛnkʌrɪdʒmənt",
    "encourager": "ɛnkʌrɪdʒɐ",
    "encourages": "ɛnkʌrɪdʒɪz",
    "encouraging": "ɛnkʌrɪdʒɪŋ",
    "encouragingly": "ɛnkʌrɪdʒɪŋli",
    "encroached": "ɛnkrəʊtʃt",
    "encroach": "ɛnkrəʊtʃ",
    "encroaches": "ɛnkrəʊtʃɪz",
    "encroaching": "ɛnkrəʊtʃɪŋ",
    "encroachment": "ɛnkrəʊtʃmənt",
    "encroachments": "ɛnkrəʊtʃmənts",
    "encrustation": "ɛnkrəsteɪʃən",
    "encrustations": "ɛnkrəsteɪʃənz",
    "encrusted": "ɛnkrʌstɪd",
    "encrust": "ɛnkrʌst",
    "encrusting": "ɛnkrʌstɪŋ",
    "encrusts": "ɛnkrʌsts",
    "encrypted": "ɛnkrɪptɪd",
    "encrypt": "ɛnkrɪpt",
    "encrypting": "ɛnkrɪptɪŋ",
    "encryption": "ɛnkrɪpʃən",
    "encryptions": "ɛnkrɪpʃənz",
    "encrypts": "ɛnkrɪpts",
    "encumbered": "ɛnkʌmbəd",
    "encumber": "ɛnkʌmbɐ",
    "encumbrance": "ɛnkʌmbrəns",
    "encumbrances": "ɛnkʌmbrənsɪz",
    "encyclical": "ɛnsɪklɪkəl",
    "encyclopaedia": "ɛnsaɪkləpiːdiə",
    "encyclopaedias": "ɛnsaɪkləpiːdiəz",
    "encyclopedia": "ɛnsaɪkləʊpiːdiə",
    "encyclopedias": "ɛnsaɪkləʊpiːdiəz",
    "encyclopedic": "ɛnsaɪkləʊpiːdɪk",
    "endangered": "ɛndeɪndʒəd",
    "endanger": "ɛndeɪndʒɐ",
    "endangering": "ɛndeɪndʒərɪŋ",
    "endangerment": "ɛndeɪndʒəmənt",
    "endangers": "ɛndeɪndʒəz",
    "endeared": "ɛndiəd",
    "endear": "ɛndiə",
    "endearing": "ɛndiərɪŋ",
    "endearingly": "ɛndiərɪŋli",
    "endearment": "ɛndiəmənt",
    "endearments": "ɛndiəmənts",
    "endears": "ɛndiəz",
    "endeavoured": "ɛndɛvəd",
    "endeavour": "ɛndɛvɐ",
    "endeavouring": "ɛndɛvɜːrɪŋ",
    "endeavours": "ɛndɛvəz",
    "ended": "ɛndɪd",
    "endemic": "ɛndɛmɪk",
    "end": "ɛnd",
    "endgame": "ɛndɡeɪm",
    "endgames": "ɛndɡeɪmz",
    "ending": "ɛndɪŋ",
    "endings": "ɛndɪŋz",
    "endive": "ɛndɪv",
    "endives": "ɛndɪvz",
    "endless": "ɛndləs",
    "endlessly": "ɛndləsli",
    "endlessness": "ɛndləsnəs",
    "endocardial": "ɛndəʊkɑːdɪəl",
    "endocarditis": "ɛndəʊkɑːdaɪtɪs",
    "endocarp": "ɛndəʊkɑːp",
    "endocrine": "ɛndəʊkraɪn",
    "endocrinologist": "ɛndəʊkrɪnɒlədʒɪst",
    "endocrinology": "ɛndəʊkrɪnɒlədʒi",
    "endogamy": "ɛndəʊɡæmi",
    "endogenous": "ɛndəʊdʒənəs",
    "endometriosis": "ɛndəʊmɛtrɪəʊsɪs",
    "endometrium": "ɛndəʊmɛtriəm",
    "endorphin": "ɛndɔːfɪn",
    "endorphins": "ɛndɔːfɪnz",
    "endorsable": "ɛndɔːsəbəl",
    "endorsed": "ɛndɔːsd",
    "endorse": "ɛndɔːs",
    "endorsement": "ɛndɔːsmənt",
    "endorsements": "ɛndɔːsmənts",
    "endorser": "ɛndɔːsɐ",
    "endorses": "ɛndɔːsɪz",
    "endorsing": "ɛndɔːsɪŋ",
    "endoscope": "ɛndəʊskəʊp",
    "endoscopes": "ɛndəʊskəʊps",
    "endoscopic": "ɛndəʊskɒpɪk",
    "endoscopy": "ɛndəʊskəpi",
    "endoskeleton": "ɛndəʊskɛlɪtən",
    "endothermic": "ɛndəʊθɜːmɪk",
    "endowed": "ɛndaʊd",
    "endow": "ɛndaʊ",
    "endowing": "ɛndaʊɪŋ",
    "endowment": "ɛndaʊmənt",
    "endowments": "ɛndaʊmənts",
    "endows": "ɛndaʊz",
    "endpoint": "ɛndpɔɪnt",
    "ends": "ɛndz",
    "endue": "ɛndjuː",
    "endurable": "ɛndjɔːrəbəl",
    "endurance": "ɛndjɔːrəns",
    "endured": "ɛndjɔːd",
    "endure": "ɛndjɔː",
    "endures": "ɛndjɔːz",
    "enduring": "ɛndjɔːrɪŋ",
    "enema": "ɛnəmɐ",
    "enemas": "ɛnəməz",
    "enemies": "ɛnəmɪz",
    "enemy": "ɛnəmi",
    "en": "ɛn",
    "energetically": "ɛnədʒɛtɪkli",
    "energetic": "ɛnədʒɛtɪk",
    "energies": "ɛnədʒɪz",
    "energised": "ɛnədʒaɪzd",
    "energise": "ɛnədʒaɪz",
    "energiser": "ɛnədʒaɪzɐ",
    "energises": "ɛnədʒaɪzɪz",
    "energising": "ɛnədʒaɪzɪŋ",
    "energy": "ɛnədʒi",
    "enervated": "ɛnəveɪtɪd",
    "enervate": "ɛnəveɪt",
    "enervating": "ɛnəveɪtɪŋ",
    "enervation": "ɛnəveɪʃən",
    "enfeebled": "ɛnfiːbəld",
    "enfilade": "ɛnfɪleɪd",
    "enfleurage": "ɛnflɜːrɪdʒ",
    "enfolded": "ɛnfəʊldɪd",
    "enfold": "ɛnfəʊld",
    "enfolding": "ɛnfəʊldɪŋ",
    "enfolds": "ɛnfəʊldz",
    "enforceability": "ɛnfɔːsəbɪlɪti",
    "enforceable": "ɛnfɔːsəbəl",
    "enforced": "ɛnfɔːst",
    "enforce": "ɛnfɔːs",
    "enforcement": "ɛnfɔːsmənt",
    "enforcements": "ɛnfɔːsmənts",
    "enforcer": "ɛnfɔːsɐ",
    "enforcers": "ɛnfɔːsəz",
    "enforces": "ɛnfɔːsɪz",
    "enforcing": "ɛnfɔːsɪŋ",
    "enfranchised": "ɛnfrɑːntʃaɪzd",
    "enfranchise": "ɛnfrɑːntʃaɪz",
    "enfranchisement": "ɛnfrɑːntʃaɪzmənt",
    "engaged": "ɛnɡeɪdʒd",
    "engage": "ɛnɡeɪdʒ",
    "engagement": "ɛnɡeɪdʒmənt",
    "engagements": "ɛnɡeɪdʒmənts",
    "engages": "ɛnɡeɪdʒɪz",
    "engaging": "ɛnɡeɪdʒɪŋ",
    "engendered": "ɛndʒɛndəd",
    "engender": "ɛndʒɛndɐ",
    "engendering": "ɛndʒɛndərɪŋ",
    "engenders": "ɛndʒɛndəz",
    "engined": "ɛndʒɪnd",
    "engine": "ɛndʒɪn",
    "engineered": "ɛndʒɪniəd",
    "engineer": "ɛndʒɪniə",
    "engineering": "ɛndʒɪniərɪŋ",
    "engineers": "ɛndʒɪniəz",
    "engines": "ɛndʒɪnz",
    "english": "ɪŋɡlɪʃ",
    "engorged": "ɛnɡɔːdʒd",
    "engrained": "ɛnɡreɪnd",
    "engrain": "ɛnɡreɪn",
    "engraved": "ɛnɡreɪvd",
    "engrave": "ɛnɡreɪv",
    "engraver": "ɛnɡreɪvɐ",
    "engravers": "ɛnɡreɪvəz",
    "engraves": "ɛnɡreɪvz",
    "engraving": "ɛnɡreɪvɪŋ",
    "engravings": "ɛnɡreɪvɪŋz",
    "engrossed": "ɛnɡrəʊst",
    "engross": "ɛnɡrəʊs",
    "engrossing": "ɛnɡrəʊsɪŋ",
    "engulfed": "ɛnɡʌlft",
    "engulf": "ɛnɡʌlf",
    "engulfing": "ɛnɡʌlfɪŋ",
    "engulfs": "ɛnɡʌlfs",
    "enhanced": "ɛnhɑːnst",
    "enhance": "ɛnhɑːns",
    "enhancement": "ɛnhɑːnsmənt",
    "enhancements": "ɛnhɑːnsmənts",
    "enhancer": "ɛnhɑːnsɐ",
    "enhancers": "ɛnhɑːnsəz",
    "enhances": "ɛnhɑːnsɪz",
    "enhancing": "ɛnhɑːnsɪŋ",
    "enigma": "ɛnɪɡmɐ",
    "enigmas": "ɛnɪɡməz",
    "enigmatically": "ɛnɪɡmætɪkli",
    "enigmatic": "ɛnɪɡmætɪk",
    "enjoined": "ɛndʒɔɪnd",
    "enjoin": "ɛndʒɔɪn",
    "enjoining": "ɛndʒɔɪnɪŋ",
    "enjoyable": "ɛndʒɔɪəbəl",
    "enjoyably": "ɛndʒɔɪəbli",
    "enjoyed": "ɛndʒɔɪd",
    "enjoy": "ɛndʒɔɪ",
    "enjoying": "ɛndʒɔɪɪŋ",
    "enjoyment": "ɛndʒɔɪmənt",
    "enjoyments": "ɛndʒɔɪmənts",
    "enjoys": "ɛndʒɔɪz",
    "enlarged": "ɛnlɑːdʒd",
    "enlarge": "ɛnlɑːdʒ",
    "enlargement": "ɛnlɑːdʒmənt",
    "enlargements": "ɛnlɑːdʒmənts",
    "enlarger": "ɛnlɑːdʒɐ",
    "enlarges": "ɛnlɑːdʒɪz",
    "enlarging": "ɛnlɑːdʒɪŋ",
    "enlightened": "ɛnlaɪtənd",
    "enlighten": "ɛnlaɪtən",
    "enlightening": "ɛnlaɪtənɪŋ",
    "enlightenment": "ɛnlaɪtənmənt",
    "enlightens": "ɛnlaɪtənz",
    "enlisted": "ɛnlɪstɪd",
    "enlist": "ɛnlɪst",
    "enlisting": "ɛnlɪstɪŋ",
    "enlistment": "ɛnlɪstmənt",
    "enlists": "ɛnlɪsts",
    "enlivened": "ɛnlaɪvənd",
    "enliven": "ɛnlaɪvən",
    "enlivening": "ɛnlaɪvənɪŋ",
    "enlivens": "ɛnlaɪvənz",
    "enmeshed": "ɛnmɛʃt",
    "enmities": "ɛnmɪtiz",
    "enmity": "ɛnmɪti",
    "ennobled": "ɛnəʊbəld",
    "ennobling": "ɛnəʊblɪŋ",
    "ennui": "ɛnjuːi",
    "enormities": "ɪnɔːmɪtiz",
    "enormity": "ɪnɔːmɪti",
    "enormously": "ɪnɔːməsli",
    "enormous": "ɪnɔːməs",
    "enough": "ɪnʌf",
    "enquired": "ɛnkwaɪəd",
    "enquire": "ɛnkwaɪə",
    "enquirer": "ɛnkwaɪərɐ",
    "enquirers": "ɛnkwaɪərəz",
    "enquires": "ɛnkwaɪəz",
    "enquiries": "ɛnkwaɪərɪz",
    "enquiring": "ɛnkwaɪərɪŋ",
    "enquiry": "ɛnkwaɪəri",
    "enraged": "ɛnreɪdʒd",
    "enrage": "ɛnreɪdʒ",
    "enrages": "ɛnreɪdʒz",
    "enraging": "ɛnreɪdʒɪŋ",
    "enraptured": "ɛnræptʃəd",
    "enriched": "ɛnrɪtʃt",
    "enrich": "ɛnrɪtʃ",
    "enriches": "ɛnrɪtʃɪz",
    "enriching": "ɛnrɪtʃɪŋ",
    "enrichment": "ɛnrɪtʃmənt",
    "enrobed": "ɛnrəʊbd",
    "enrol": "ɛnrəʊl",
    "enrolled": "ɛnrəʊld",
    "enroll": "ɛnrəʊl",
    "enrolling": "ɛnrəʊlɪŋ",
    "enrollment": "ɛnrəʊlmənt",
    "enrolment": "ɛnrəʊlmənt",
    "enrolments": "ɛnrəʊlmənts",
    "enrols": "ɛnrəʊlz",
    "ensconced": "ɛnskɒnst",
    "ensemble": "ɒnsɒmbəl",
    "ensembles": "ɒnsɒmbəlz",
    "ens": "ɛnz",
    "enshrined": "ɛnʃraɪnd",
    "enshrine": "ɛnʃraɪn",
    "enshrines": "ɛnʃraɪnz",
    "enshrining": "ɛnʃraɪnɪŋ",
    "enshrouded": "ɛnʃraʊdɪd",
    "ensign": "ɛnsaɪn",
    "ensigns": "ɛnsaɪnz",
    "enslaved": "ɛnsleɪvd",
    "enslave": "ɛnsleɪv",
    "enslavement": "ɛnsleɪvmənt",
    "enslaver": "ɛnsleɪvɐ",
    "enslaves": "ɛnsleɪvz",
    "enslaving": "ɛnsleɪvɪŋ",
    "ensnared": "ɛnsneəd",
    "ensnare": "ɛnsneə",
    "ensnares": "ɛnsneəz",
    "ensnaring": "ɛnsneərɪŋ",
    "ensued": "ɛnsjuːd",
    "ensue": "ɛnsjuː",
    "ensues": "ɛnsjuːz",
    "ensuing": "ɛnsjuːɪŋ",
    "ensured": "ɛnʃɔːd",
    "ensure": "ɛnʃɔː",
    "ensures": "ɛnʃɔːz",
    "ensuring": "ɛnʃɔːrɪŋ",
    "entablature": "ɛntæblətʃɐ",
    "entailed": "ɛnteɪld",
    "entail": "ɛnteɪl",
    "entails": "ɛnteɪlz",
    "entangled": "ɛntæŋɡəld",
    "entangle": "ɛntæŋɡəl",
    "entanglement": "ɛntæŋɡəlmənt",
    "entanglements": "ɛntæŋɡəlmənts",
    "entangles": "ɛntæŋɡəlz",
    "entangling": "ɛntæŋɡəlɪŋ",
    "entasis": "ɛntæsiz",
    "entente": "ɒntɒnt",
    "entered": "ɛntəd",
    "enter": "ɛntɐ",
    "entering": "ɛntərɪŋ",
    "enteritis": "ɛntəraɪtɪs",
    "enterotomy": "ɛntərəʊtəmi",
    "enterprise": "ɛntəpraɪz",
    "enterprises": "ɛntəpraɪzɪz",
    "enterprising": "ɛntəpraɪzɪŋ",
    "enters": "ɛntəz",
    "entertained": "ɛntəteɪnd",
    "entertain": "ɛntəteɪn",
    "entertainer": "ɛntəteɪnɐ",
    "entertainers": "ɛntəteɪnəz",
    "entertaining": "ɛntəteɪnɪŋ",
    "entertainingly": "ɛntəteɪnɪŋli",
    "entertainment": "ɛntəteɪnmənt",
    "entertainments": "ɛntəteɪnmənts",
    "entertains": "ɛntəteɪnz",
    "enthral": "ɛnθrɔːl",
    "enthralled": "ɛnθrɔːld",
    "enthralling": "ɛnθrɔːlɪŋ",
    "enthrals": "ɛnθrɔːlz",
    "enthroned": "ɛnθrəʊnd",
    "enthronement": "ɛnθrəʊnmənt",
    "enthused": "ɛnθjuːsd",
    "enthuse": "ɛnθjuːs",
    "enthuses": "ɛnθjuːsɪz",
    "enthusiasm": "ɛnθjuːzɪæzəm",
    "enthusiasms": "ɛnθjuːzɪæzəmz",
    "enthusiast": "ɛnθjuːzɪæst",
    "enthusiastically": "ɛnθjuːzɪæstɪkli",
    "enthusiastic": "ɛnθjuːzɪæstɪk",
    "enthusiasts": "ɛnθjuːzɪæsts",
    "enthusing": "ɛnθjuːsɪŋ",
    "enticed": "ɛntaɪst",
    "entice": "ɛntaɪs",
    "enticement": "ɛntaɪsmənt",
    "enticements": "ɛntaɪsmənts",
    "entices": "ɛntaɪsɪz",
    "enticing": "ɛntaɪsɪŋ",
    "enticingly": "ɛntaɪsɪŋli",
    "entire": "ɛntaɪə",
    "entirely": "ɛntaɪəli",
    "entirety": "ɛntaɪrɪti",
    "entities": "ɛntɪtiz",
    "entitled": "ɛntaɪtəld",
    "entitle": "ɛntaɪtəl",
    "entitlement": "ɛntaɪtəlmənt",
    "entitlements": "ɛntaɪtəlmənts",
    "entitles": "ɛntaɪtəlz",
    "entitling": "ɛntaɪtlɪŋ",
    "entity": "ɛntɪti",
    "entombed": "ɛntuːmd",
    "entomb": "ɛntuːm",
    "entombing": "ɛntuːmɪŋ",
    "entombment": "ɛntuːmmənt",
    "entombs": "ɛntuːmz",
    "entomological": "ɛntɒməlɒdʒɪkəl",
    "entomologist": "ɛntəmɒlədʒɪst",
    "entomologists": "ɛntəmɒlədʒɪsts",
    "entomology": "ɛntəmɒlədʒi",
    "entourage": "ɒntʊrɑːʒ",
    "entourages": "ɒntʊrɑːʒɪz",
    "entrails": "ɛntreɪlz",
    "entranced": "ɛntrɑːnst",
    "entranceway": "ɛntrənsweɪ",
    "entrancing": "ɛntrɑːnsɪŋ",
    "entrant": "ɛntrənt",
    "entrants": "ɛntrənts",
    "entrap": "ɛntræp",
    "entrapment": "ɛntræpmənt",
    "entrapped": "ɛntræpt",
    "entreated": "ɛntriːtɪd",
    "entreat": "ɛntriːt",
    "entreaties": "ɛntriːtɪz",
    "entreats": "ɛntriːts",
    "entreaty": "ɛntriːti",
    "entrechat": "ɒntrɪtʃæt",
    "entrenched": "ɛntrɛntʃt",
    "entrench": "ɛntrɛntʃ",
    "entrenches": "ɛntrɛntʃɪz",
    "entrenching": "ɛntrɛntʃɪŋ",
    "entrenchment": "ɛntrɛntʃmənt",
    "entrenchments": "ɛntrɛntʃmənts",
    "entrepreneurialism": "ɒntrɪprɛnjuːrɪəlɪzəm",
    "entrepreneurially": "ɒntrɪprɪnjuːrɪəli",
    "entrepreneurial": "ɒntrɪprɪnjuːrɪəl",
    "entrepreneurism": "ɒntrɪprɛnjuːrərɪzəm",
    "entrepreneur": "ɒntrɪprɪnɜː",
    "entrepreneurship": "ɒntrɪprɪnɜːʃɪp",
    "entrepreneurs": "ɒntrɪprɪnɜːz",
    "entries": "ɛntrɪz",
    "entropy": "ɛntrəpi",
    "entrusted": "ɛntrʌstɪd",
    "entrust": "ɛntrʌst",
    "entrusting": "ɛntrʌstɪŋ",
    "entrusts": "ɛntrʌsts",
    "entry": "ɛntri",
    "entryway": "ɛntrɪweɪ",
    "entwined": "ɛntwaɪnd",
    "entwine": "ɛntwaɪn",
    "entwining": "ɛntwaɪnɪŋ",
    "enumerated": "ɪnjuːməreɪtɪd",
    "enumerate": "ɪnjuːməreɪt",
    "enumeration": "ɪnjuːməreɪʃən",
    "enunciated": "ɪnʌnsɪeɪtɪd",
    "enunciate": "ɪnʌnsɪeɪt",
    "enunciating": "ɪnʌnsɪeɪtɪŋ",
    "enunciation": "ɪnʌnsɪeɪʃən",
    "enure": "ɪnjɐ",
    "enuresis": "ɪnjʊriːsɪs",
    "enveloped": "ɛnvɛləpt",
    "enveloping": "ɛnvɛləpɪŋ",
    "envelops": "ɛnvɛləps",
    "enviable": "ɛnvɪəbəl",
    "enviably": "ɛnvɪəbli",
    "envied": "ɛnvɪd",
    "envies": "ɛnvɪz",
    "envious": "ɛnvɪəs",
    "enviously": "ɛnvɪəsli",
    "environ": "ɛnvaɪrən",
    "environmental": "ɛnvaɪrənmɛntəl",
    "environmentalism": "ɛnvaɪrənmɛntəlɪzəm",
    "environmentalist": "ɛnvaɪrənmɛntəlɪst",
    "environmentalists": "ɛnvaɪrənmɛntəlɪsts",
    "environmentally": "ɛnvaɪrənmɛntəli",
    "environment": "ɛnvaɪrənmənt",
    "environments": "ɛnvaɪrənmənts",
    "environs": "ɛnvaɪrənz",
    "envisaged": "ɛnvɪsɪdʒd",
    "envisage": "ɛnvɪsɪdʒ",
    "envisages": "ɛnvɪsɪdʒɪz",
    "envisaging": "ɛnvɪsɪdʒɪŋ",
    "envisioned": "ɛnvɪʒənd",
    "envision": "ɛnvɪʒən",
    "envisioning": "ɛnvɪʒənɪŋ",
    "envisions": "ɛnvɪʒənz",
    "envoi": "ɛnvɔɪ",
    "envoy": "ɛnvɔɪ",
    "envoys": "ɛnvɔɪz",
    "envy": "ɛnvi",
    "envying": "ɛnvɪɪŋ",
    "enwrapped": "ɛnræpt",
    "enzymatic": "ɛnzɪmætɪk",
    "enzyme": "ɛnzaɪm",
    "enzymes": "ɛnzaɪmz",
    "eon": "iːɒn",
    "eons": "iːɒnz",
    "eosinophils": "iːəsɪnəfɪlz",
    "epaulette": "ɛpəlɛt",
    "epaulettes": "ɛpəlɛts",
    "epergne": "ɛpəɡni",
    "epergnes": "ɛpəɡnɪz",
    "ephedrine": "ɛfɪdriːn",
    "ephemera": "ɪfɛmərɐ",
    "ephemeral": "ɪfɛmərəl",
    "epically": "ɛpɪkli",
    "epicene": "ɛpɪsiːn",
    "epicentre": "ɛpɪsəntɐ",
    "epicentres": "ɛpɪsəntəz",
    "epic": "ɛpɪk",
    "epics": "ɛpɪks",
    "epicurean": "ɛpɪkjʊriən",
    "epicureans": "ɛpɪkjʊriənz",
    "epicure": "ɛpɪkjɔː",
    "epicures": "ɛpɪkjɔːz",
    "epicycles": "ɛpɪsaɪkəlz",
    "epidemic": "ɛpɪdɛmɪk",
    "epidemics": "ɛpɪdɛmɪks",
    "epidemiological": "ɛpɪdɛmɪəlɒdʒɪkəl",
    "epidemiologist": "ɛpɪdɛmɪɒlədʒɪst",
    "epidemiologists": "ɛpɪdɛmɪɒlədʒɪsts",
    "epidemiology": "ɛpɪdɛmɪɒlədʒi",
    "epidermal": "ɛpɪdɜːməl",
    "epidermis": "ɛpɪdɜːmɪs",
    "epidural": "ɛpɪdjɔːrəl",
    "epidurals": "ɛpɪdjɔːrəlz",
    "epigastrium": "ɛpɪɡɑːstriəm",
    "epiglottis": "ɛpɪɡlɒtiz",
    "epigram": "ɛpɪɡræm",
    "epigrams": "ɛpɪɡræmz",
    "epigraph": "ɛpɪɡræf",
    "epigraphic": "ɛpɪɡræfɪk",
    "epilepsy": "ɛpɪlɛpsi",
    "epileptic": "ɛpɪlɛptɪk",
    "epileptics": "ɛpɪlɛptɪks",
    "epilogue": "ɛpɪlɒɡ",
    "epinephrine": "ɛpɪnɛfriːn",
    "epiphanies": "ɪpɪfənɪz",
    "epiphany": "ɪpɪfəni",
    "epiphysis": "ɛpɪfəsɪs",
    "epiphytes": "ɛpɪfaɪts",
    "episcopalian": "ɪpɪskəpeɪliən",
    "episcopal": "ɪpɪskɒpəl",
    "episcopate": "ɪpɪskəpeɪt",
    "episiotomy": "ɛpɪsɪɒtəmi",
    "episode": "ɛpɪsəʊd",
    "episodes": "ɛpɪsəʊdz",
    "episodically": "ɛpɪsɒdɪkli",
    "episodic": "ɛpɪsɒdɪk",
    "epistemology": "ɪpɪstɪmɒlədʒi",
    "epistle": "ɪpɪsəl",
    "epistles": "ɪpɪsəlz",
    "epistolary": "ɪpɪstəʊləri",
    "epitaph": "ɛpɪtæf",
    "epitaphs": "ɛpɪtæfz",
    "epithelium": "ɛpɪθiːliəm",
    "epithet": "ɛpɪθɪt",
    "epithets": "ɛpɪθɪts",
    "epitome": "ɪpɪtəmi",
    "epitomised": "ɛpɪtəmaɪzd",
    "epitomise": "ɛpɪtəmaɪz",
    "epitomises": "ɛpɪtəmaɪzɪz",
    "epitomising": "ɛpɪtəmaɪzɪŋ",
    "epoch": "ɛpɒk",
    "epochs": "ɛpɒkz",
    "eponymous": "ɛpɒnɪməs",
    "eponyms": "ɛpənɪmz",
    "epos": "iːpəʊz",
    "epoxy": "ɪpɒksi",
    "epsilon": "ɛpsɪlən",
    "equable": "ɛkəbəl",
    "equal": "iːkwəl",
    "equalisation": "iːkwəlaɪzeɪʃən",
    "equalised": "iːkwəlaɪzd",
    "equalise": "iːkwəlaɪz",
    "equaliser": "iːkwəlaɪzɐ",
    "equalisers": "iːkwəlaɪzəz",
    "equalises": "iːkwəlaɪzɪz",
    "equalising": "iːkwəlaɪzɪŋ",
    "equalities": "iːkwɒlɪtiz",
    "equality": "iːkwɒlɪti",
    "equalled": "iːkwəld",
    "equalling": "iːkwəlɪŋ",
    "equally": "iːkwəli",
    "equals": "iːkwəlz",
    "equanimity": "iːkwɐnɪmɪti",
    "equated": "ɪkweɪtɪd",
    "equate": "ɪkweɪt",
    "equates": "ɪkweɪts",
    "equating": "ɪkweɪtɪŋ",
    "equation": "ɪkweɪʒən",
    "equations": "ɪkweɪʒənz",
    "equatorial": "ɪkwɐtɔːrɪəl",
    "equator": "ɪkweɪtɐ",
    "equators": "ɪkweɪtəz",
    "equerries": "ɛkwərɪz",
    "equerry": "ɛkwəri",
    "equestrian": "ɛkwɛstriən",
    "equestrianism": "ɛkwɪstriənɪzəm",
    "equestrians": "ɛkwɛstriənz",
    "equidistant": "iːkwɪdɪstənt",
    "equilateral": "iːkwɪlætərəl",
    "equilibrium": "iːkwɪlɪbriəm",
    "equine": "ɛkwaɪn",
    "equines": "ɛkwaɪnz",
    "equinox": "ɛkwɪnɒks",
    "equinoxes": "ɛkwɪnɒksɪz",
    "equipage": "ɛkwɪpɪdʒ",
    "equip": "ɪkwɪp",
    "equipment": "ɪkwɪpmənt",
    "equipments": "ɪkwɪpmənts",
    "equipped": "ɪkwɪpt",
    "equipping": "ɪkwɪpɪŋ",
    "equips": "ɪkwɪps",
    "equisetum": "iːkwɪsɛtəm",
    "equitable": "ɛkwɪtəbəl",
    "equitably": "ɛkwɪtəbli",
    "equities": "ɛkwɪtiz",
    "equity": "ɛkwɪti",
    "equivalence": "ɪkwɪvələns",
    "equivalent": "ɪkwɪvələnt",
    "equivalents": "ɪkwɪvələnts",
    "equivocal": "ɪkwɪvəkəl",
    "equivocally": "ɪkwɪvəkəli",
    "equivocated": "ɪkwɪvəkeɪtɪd",
    "equivocate": "ɪkwɪvəkeɪt",
    "equivocates": "ɪkwɪvəkeɪts",
    "equivocating": "ɪkwɪvəkeɪtɪŋ",
    "equivocation": "ɪkwɪvəkeɪʃən",
    "equivocator": "ɪkwɪvəkeɪtɐ",
    "er": "ɜː",
    "eradicate": "ɪrædɪkeɪt",
    "eradicated": "ɪrædɪkeɪtɪd",
    "eradicates": "ɪrædɪkeɪts",
    "eradicating": "ɪrædɪkeɪtɪŋ",
    "eradication": "ɪrædɪkeɪʃən",
    "era": "iərɐ",
    "erasable": "ɪreɪzəbəl",
    "erased": "ɪreɪzd",
    "erase": "ɪreɪz",
    "eraser": "ɪreɪzɐ",
    "erasers": "ɪreɪzəz",
    "erases": "ɪreɪzɪz",
    "eras": "iərəz",
    "erasing": "ɪreɪzɪŋ",
    "erasure": "ɪreɪʒɐ",
    "erbium": "ɜːbiəm",
    "erected": "ɪrɛktɪd",
    "erect": "ɪrɛkt",
    "erectile": "ɪrɛktaɪl",
    "erecting": "ɪrɛktɪŋ",
    "erection": "ɪrɛkʃən",
    "erections": "ɪrɛkʃənz",
    "erector": "ɪrɛktɐ",
    "erectors": "ɪrɛktəz",
    "erects": "ɪrɛkts",
    "ere": "eə",
    "eremite": "ɪrɛmaɪt",
    "erg": "ɜːɡ",
    "ergo": "ɜːɡəʊ",
    "ergonomically": "ɜːɡənɒmɪkli",
    "ergonomic": "ɜːɡənɒmɪk",
    "ergonomics": "ɜːɡənɒmɪks",
    "ergot": "ɜːɡət",
    "ergotism": "ɜːɡətɪzəm",
    "ergs": "ɜːɡz",
    "ericaceous": "ɛrɪkeɪʃəs",
    "erigeron": "ɛrɪdʒərən",
    "eristic": "ɛrɪstɪk",
    "erk": "ɜːk",
    "ermine": "ɜːmɪn",
    "ermines": "ɜːmɪnz",
    "erne": "ɜːn",
    "eroded": "ɪrəʊdɪd",
    "erode": "ɪrəʊd",
    "erodes": "ɪrəʊdz",
    "eroding": "ɪrəʊdɪŋ",
    "erogenous": "ɪrɒdʒənəs",
    "erosional": "ɪrəʊʒənəl",
    "erosion": "ɪrəʊʒən",
    "erosive": "ɪrəʊsɪv",
    "erotically": "ɪrɒtɪkli",
    "erotica": "ɪrɒtɪkɐ",
    "eroticism": "ɪrɒtɪsɪzəm",
    "erotic": "ɪrɒtɪk",
    "erotomania": "ɪrəʊtəmeɪniə",
    "err": "ɜː",
    "errand": "ɛrənd",
    "errands": "ɛrəndz",
    "errant": "ɛrənt",
    "erratically": "ɛrætɪkli",
    "erratic": "ɛrætɪk",
    "erratum": "ɛrɑːtəm",
    "erred": "ɜːd",
    "erring": "ɜːrɪŋ",
    "erroneous": "ɛrəʊniəs",
    "erroneously": "ɛrəʊniəsli",
    "error": "ɛrɐ",
    "errors": "ɛrəz",
    "errs": "ɜːz",
    "ersatz": "ɜːsæts",
    "erst": "ɜːst",
    "erstwhile": "ɜːstwaɪl",
    "erudite": "ɛruːdaɪt",
    "erudition": "ɛruːdɪʃən",
    "erupted": "ɪrʌptɪd",
    "erupting": "ɪrʌptɪŋ",
    "eruption": "ɪrʌpʃən",
    "eruptions": "ɪrʌpʃənz",
    "eruptive": "ɪrʌptɪv",
    "erupt": "ɪrʌpt",
    "erupts": "ɪrʌpts",
    "erythema": "ɜːrɪθəmɐ",
    "erythrocytes": "ɜːrɪθrəsaɪts",
    "erythromycin": "ɜːrɪθrɒmɪsɪn",
    "escalade": "ɛskɐleɪd",
    "escalated": "ɛskɐleɪtɪd",
    "escalate": "ɛskɐleɪt",
    "escalates": "ɛskɐleɪts",
    "escalating": "ɛskɐleɪtɪŋ",
    "escalation": "ɛskɐleɪʃən",
    "escalations": "ɛskɐleɪʃənz",
    "escalator": "ɛskɐleɪtɐ",
    "escalators": "ɛskɐleɪtəz",
    "escallop": "ɛskɑːləp",
    "escalope": "ɛskɐləʊp",
    "escalopes": "ɛskɐləʊps",
    "escapade": "ɛskɐpeɪd",
    "escapades": "ɛskɐpeɪdz",
    "escaped": "ɛskeɪpt",
    "escapee": "ɛskæpiː",
    "escapees": "ɛskæpiːz",
    "escape": "ɛskeɪp",
    "escapement": "ɛskeɪpmənt",
    "escapements": "ɛskeɪpmənts",
    "escaper": "ɛskeɪpɐ",
    "escapes": "ɛskeɪps",
    "escaping": "ɛskeɪpɪŋ",
    "escapism": "ɛskeɪpɪzəm",
    "escapist": "ɛskeɪpɪst",
    "escapologist": "ɛskɐpɒlədʒɪst",
    "escapology": "ɛskɐpɒlədʒi",
    "escargot": "ɪskɑːɡəʊ",
    "escargots": "ɪskɑːɡəʊs",
    "escarole": "ɛskərəʊl",
    "escarpment": "ɪskɑːpmənt",
    "escarpments": "ɪskɑːpmənts",
    "eschatology": "ɛʃɐtɒlədʒi",
    "escheat": "ɛʃiːt",
    "eschewed": "ɪstʃuːd",
    "eschewing": "ɪstʃuːɪŋ",
    "eschews": "ɪstʃuːz",
    "eschew": "ɪstʃuː",
    "escorted": "ɛskɔːtɪd",
    "escorting": "ɛskɔːtɪŋ",
    "escritoire": "ɛskrɪtwɑː",
    "escrow": "ɛskrəʊ",
    "escudo": "ɛskjuːdəʊ",
    "escutcheon": "ɛskʌtʃən",
    "escutcheons": "ɛskʌtʃənz",
    "es": "iːz",
    "esoteric": "ɛsəʊtɛrɪk",
    "espadrille": "ɛspædrɪl",
    "espadrilles": "ɛspædrɪlz",
    "espagnole": "ɛspæɡnəʊl",
    "espaliered": "ɛspæliəd",
    "espalier": "ɛspæliɐ",
    "espaliers": "ɛspæliəz",
    "especially": "ɪspɛʃəli",
    "especial": "ɪspɛʃəl",
    "espied": "ɛspaɪd",
    "espionage": "ɛspɪənɑːʒ",
    "esplanade": "ɛsplɐneɪd",
    "espoused": "ɛspaʊsd",
    "espouse": "ɛspaʊs",
    "espouses": "ɛspaʊsɪz",
    "espousing": "ɛspaʊsɪŋ",
    "espresso": "ɛsprɛsəʊ",
    "espressos": "ɛsprɛsəʊz",
    "esprit": "ɛsprɪt",
    "espy": "ɛspaɪ",
    "esquire": "ɛskwaɪə",
    "essayed": "ɛseɪd",
    "essayist": "ɛseɪɪst",
    "esse": "ɛs",
    "essence": "ɛsəns",
    "essences": "ɛsənsɪz",
    "essentially": "ɪsɛnʃəli",
    "essential": "ɪsɛnʃəl",
    "essentials": "ɪsɛnʃəlz",
    "established": "ɪstæblɪʃt",
    "establishes": "ɪstæblɪʃɪz",
    "establishing": "ɪstæblɪʃɪŋ",
    "establishments": "ɪstæblɪʃmənts",
    "establishment": "ɪstæblɪʃmənt",
    "establish": "ɪstæblɪʃ",
    "estancia": "ɛstɑːnʃɐ",
    "estates": "ɪsteɪts",
    "estate": "ɪsteɪt",
    "esteemed": "ɛstiːmd",
    "esteem": "ɛstiːm",
    "esteems": "ɛstiːmz",
    "ester": "ɛstɐ",
    "esters": "ɛstəz",
    "esthetic": "ɛsθɛtɪk",
    "estimable": "ɛstɪməbəl",
    "estimated": "ɛstɪmeɪtɪd",
    "estimating": "ɛstɪmeɪtɪŋ",
    "estimation": "ɛstɪmeɪʃən",
    "estimations": "ɛstɪmeɪʃənz",
    "estimator": "ɛstɪmeɪtɐ",
    "estragon": "ɛstrəɡən",
    "estranged": "ɛstreɪndʒd",
    "estrange": "ɛstreɪndʒ",
    "estrangement": "ɛstreɪndʒmənt",
    "estranging": "ɛstreɪndʒɪŋ",
    "estuaries": "ɛstjuːəriz",
    "estuarine": "ɛstjuːɑːriːn",
    "estuary": "ɛstjuːəri",
    "etched": "ɛtʃt",
    "etcher": "ɛtʃɐ",
    "etches": "ɛtʃɪz",
    "etch": "ɛtʃ",
    "etching": "ɛtʃɪŋ",
    "etchings": "ɛtʃɪŋz",
    "eternally": "ɪtɜːnəli",
    "eternal": "ɪtɜːnəl",
    "eterne": "ɪtɜːn",
    "eternities": "ɪtɜːnɪtiz",
    "eternity": "ɪtɜːnɪti",
    "ethane": "iːθeɪn",
    "ethanol": "ɛθɐnɒl",
    "ethene": "iːθiːn",
    "ethereal": "iːθiərɪəl",
    "etherised": "iːθəraɪzd",
    "ether": "iːθɐ",
    "ethical": "ɛθɪkəl",
    "ethically": "ɛθɪkli",
    "ethic": "ɛθɪk",
    "ethicist": "ɛθɪsɪst",
    "ethics": "ɛθɪks",
    "ethnically": "ɛθnɪkli",
    "ethnic": "ɛθnɪk",
    "ethnicity": "ɛθnɪsɪti",
    "ethnics": "ɛθnɪks",
    "ethnocentrically": "ɛθnəʊsɛntrɪkli",
    "ethnographer": "ɛθnɒɡrəfɐ",
    "ethnographers": "ɛθnɒɡrəfəz",
    "ethnographic": "ɛθnəɡræfɪk",
    "ethnography": "ɛθnɒɡrəfi",
    "ethnology": "ɛθnɒlədʒi",
    "ethology": "iːθɒlədʒi",
    "ethos": "iːθəʊz",
    "ethylene": "ɛθɪliːn",
    "ethyl": "iːθaɪl",
    "etiolated": "ɛtɪɒleɪtɪd",
    "etiquette": "ɛtɪkɛt",
    "etna": "ɛtnɐ",
    "etymological": "ɛtɪməlɒdʒɪkəl",
    "etymologically": "ɛtɪməlɒdʒɪkli",
    "etymologies": "ɛtɪmɒlədʒɪz",
    "etymology": "ɛtɪmɒlədʒi",
    "eucalyptus": "juːkɐlɪptəs",
    "eucharistic": "juːkərɪstɪk",
    "euchre": "juːkɐ",
    "euclidean": "juːklaɪdiən",
    "euclidian": "juːklɪdiən",
    "eugenicist": "juːdʒənɪsɪst",
    "eugenicists": "juːdʒənɪsɪsts",
    "eugenic": "juːdʒɛnɪk",
    "eugenics": "juːdʒɛnɪks",
    "eukaryotes": "juːkɐrɪəʊts",
    "eukaryotic": "juːkɐrɪɒtɪk",
    "eulogies": "juːlədʒɪz",
    "eulogised": "juːlədʒaɪzd",
    "eulogise": "juːlədʒaɪz",
    "eulogising": "juːlədʒaɪzɪŋ",
    "eulogy": "juːlədʒi",
    "eunuch": "juːnʌtʃ",
    "eunuchs": "juːnʌtʃz",
    "euonymus": "juːənɪməs",
    "eupatorium": "juːpɐtɔːriəm",
    "euphemism": "juːfəmɪzəm",
    "euphemisms": "juːfəmɪzəmz",
    "euphemistically": "juːfɪmɪstɪkli",
    "euphemistic": "juːfɪmɪstɪk",
    "euphonious": "juːfəʊnɪəs",
    "euphonium": "juːfəʊniəm",
    "euphorbia": "juːfɔːbiə",
    "euphoria": "juːfɔːriə",
    "euphorically": "juːfɒrɪkli",
    "euphoric": "juːfɒrɪk",
    "eureka": "juːriːkɐ",
    "euro": "jɔːrəʊ",
    "europium": "jɔːrəʊpiəm",
    "euros": "jɔːrəʊz",
    "eurythmics": "juːrɪθmɪks",
    "euthanasia": "juːθɐneɪziə",
    "euthanize": "juːθɐnaɪz",
    "evacuated": "ɪvækjuːeɪtɪd",
    "evacuate": "ɪvækjuːeɪt",
    "evacuating": "ɪvækjuːeɪtɪŋ",
    "evacuations": "ɪvækjuːeɪʃənz",
    "evacuation": "ɪvækjuːeɪʃən",
    "evacuees": "ɪvækjuːiːz",
    "evacuee": "ɪvækjuːiː",
    "evaded": "ɪveɪdɪd",
    "evaders": "ɪveɪdəz",
    "evader": "ɪveɪdɐ",
    "evades": "ɪveɪdz",
    "evade": "ɪveɪd",
    "evading": "ɪveɪdɪŋ",
    "evaluated": "ɪvæljuːeɪtɪd",
    "evaluates": "ɪvæljuːeɪts",
    "evaluate": "ɪvæljuːeɪt",
    "evaluating": "ɪvæljuːeɪtɪŋ",
    "evaluations": "ɪvæljuːeɪʃənz",
    "evaluation": "ɪvæljuːeɪʃən",
    "evaluator": "ɪvæljuːeɪtɐ",
    "evanescence": "ɛvənɛsəns",
    "evanescent": "ɛvənɛsənt",
    "evangelicalism": "iːvɐndʒɛlɪkəlɪzəm",
    "evangelical": "iːvɐndʒɛlɪkəl",
    "evangelicals": "iːvɐndʒɛlɪkəlz",
    "evangelisation": "ɪvændʒɪlaɪzeɪʃən",
    "evangelise": "ɪvændʒɪlaɪz",
    "evangelising": "ɪvændʒɪlaɪzɪŋ",
    "evangelism": "ɪvændʒɪlɪzəm",
    "evangelistic": "ɪvændʒɪlɪstɪk",
    "evangelists": "ɪvændʒɪlɪsts",
    "evangelist": "ɪvændʒɪlɪst",
    "evaporated": "ɪvæpəreɪtɪd",
    "evaporates": "ɪvæpəreɪts",
    "evaporate": "ɪvæpəreɪt",
    "evaporating": "ɪvæpəreɪtɪŋ",
    "evaporation": "ɪvæpəreɪʃən",
    "evaporator": "ɪvæpɔːreɪtɐ",
    "evapotranspiration": "ɪvæpətrænspəreɪʃən",
    "evasions": "ɪveɪʒənz",
    "evasion": "ɪveɪʒən",
    "evasively": "ɪveɪsɪvli",
    "evasiveness": "ɪveɪsɪvnəs",
    "evasive": "ɪveɪsɪv",
    "eve": "iːv",
    "evened": "iːvənd",
    "evenings": "iːvnɪŋz",
    "even": "iːvən",
    "evenly": "iːvənli",
    "evenness": "iːvənnəs",
    "evens": "iːvənz",
    "evensong": "iːvənsɒŋ",
    "eventful": "ɪvɛntfəl",
    "eventide": "ɪvɛntaɪd",
    "eventing": "ɪvɛntɪŋ",
    "events": "ɪvɛnts",
    "eventualities": "ɪvɛntʃuːælɪtiz",
    "eventuality": "ɪvɛntʃuːælɪti",
    "eventually": "ɪvɛntʃuːəli",
    "eventual": "ɪvɛntʃuːəl",
    "event": "ɪvɛnt",
    "ever": "ɛvɐ",
    "everglade": "ɛvəɡleɪd",
    "everglades": "ɛvəɡleɪdz",
    "evergreen": "ɛvəɡriːn",
    "evergreens": "ɛvəɡriːnz",
    "everlasting": "ɛvəlɑːstɪŋ",
    "everlastingly": "ɛvəlɑːstɪŋli",
    "evermore": "ɛvəmɔː",
    "evert": "ɛvət",
    "everybody": "ɛvrɪbɒdi",
    "everyday": "ɛvrɪdeɪ",
    "every": "ɛvri",
    "everyman": "ɛvrɪmən",
    "everyone": "ɛvrɪwɒn",
    "everyplace": "ɛvrɪpleɪs",
    "everything": "ɛvrɪθɪŋ",
    "everywhere": "ɛvrɪweə",
    "eves": "iːvz",
    "evicted": "ɪvɪktɪd",
    "evicting": "ɪvɪktɪŋ",
    "evictions": "ɪvɪkʃənz",
    "eviction": "ɪvɪkʃən",
    "evicts": "ɪvɪkts",
    "evict": "ɪvɪkt",
    "evidenced": "ɛvɪdənst",
    "evidence": "ɛvɪdəns",
    "evidences": "ɛvɪdənsɪz",
    "evidencing": "ɛvɪdənsɪŋ",
    "evident": "ɛvɪdənt",
    "evidential": "ɛvɪdɛnʃəl",
    "evidentiary": "ɛvɪdɛnʃjəri",
    "evidently": "ɛvɪdəntli",
    "evildoers": "iːvəlduːəz",
    "evil": "iːvəl",
    "evillest": "iːvələst",
    "evilly": "iːvəli",
    "evilness": "iːvəlnəs",
    "evils": "iːvəlz",
    "evinces": "ɪvɪnsɪz",
    "evince": "ɪvɪns",
    "evincing": "ɪvɪnsɪŋ",
    "eviscerated": "ɪvɪsəreɪtɪd",
    "eviscerate": "ɪvɪsəreɪt",
    "eviscerating": "ɪvɪsəreɪtɪŋ",
    "evisceration": "ɪvɪsəreɪʃən",
    "evitable": "ɛvɪtəbəl",
    "evocations": "ɪvəkeɪʃənz",
    "evocation": "ɪvəkeɪʃən",
    "evocatively": "ɪvɒkətɪvli",
    "evocative": "ɪvɒkətɪv",
    "evoked": "ɪvəʊkt",
    "evokes": "ɪvəʊks",
    "evoke": "ɪvəʊk",
    "evoking": "ɪvəʊkɪŋ",
    "evolutionarily": "ɪvəluːʃənɛrəli",
    "evolutionary": "ɪvəluːʃənəri",
    "evolutionists": "ɪvəluːʃənɪsts",
    "evolutionist": "ɪvəluːʃənɪst",
    "evolutions": "ɪvəluːʃənz",
    "evolution": "ɪvəluːʃən",
    "evolved": "ɪvɒlvd",
    "evolvement": "ɪvɒlvmənt",
    "evolves": "ɪvɒlvz",
    "evolve": "ɪvɒlv",
    "evolving": "ɪvɒlvɪŋ",
    "ewer": "juːɐ",
    "ewers": "juːəz",
    "ewes": "juːz",
    "exabytes": "ɛɡzæbaɪts",
    "exacerbated": "ɛɡzæsəbeɪtɪd",
    "exacerbate": "ɛɡzæsəbeɪt",
    "exacerbates": "ɛɡzæsəbeɪts",
    "exacerbating": "ɛɡzæsəbeɪtɪŋ",
    "exacerbation": "ɛɡzæsəbeɪʃən",
    "exacted": "ɛɡzæktɪd",
    "exact": "ɛɡzækt",
    "exacting": "ɛɡzæktɪŋ",
    "exactitude": "ɛɡzæktɪtjuːd",
    "exactly": "ɛɡzæktli",
    "exactness": "ɛɡzæktnəs",
    "exacts": "ɛɡzækts",
    "exaggerated": "ɛɡzædʒəreɪtɪd",
    "exaggerate": "ɛɡzædʒəreɪt",
    "exaggerates": "ɛɡzædʒəreɪts",
    "exaggerating": "ɛɡzædʒəreɪtɪŋ",
    "exaggeration": "ɛɡzædʒəreɪʃən",
    "exaggerations": "ɛɡzædʒəreɪʃənz",
    "exaltation": "ɛɡzɐlteɪʃən",
    "exalted": "ɛɡzɒltɪd",
    "exalt": "ɛɡzɒlt",
    "exalting": "ɛɡzɒltɪŋ",
    "exalts": "ɛɡzɒlts",
    "exam": "ɛɡzæm",
    "examination": "ɛɡzæmɪneɪʃən",
    "examinations": "ɛɡzæmɪneɪʃənz",
    "examined": "ɛɡzæmɪnd",
    "examine": "ɛɡzæmɪn",
    "examiner": "ɛɡzæmɪnɐ",
    "examiners": "ɛɡzæmɪnəz",
    "examines": "ɛɡzæmɪnz",
    "examining": "ɛɡzæmɪnɪŋ",
    "example": "ɛɡzɑːmpəl",
    "examples": "ɛɡzɑːmpəlz",
    "exams": "ɛɡzæmz",
    "exasperated": "ɛɡzɑːspəreɪtɪd",
    "exasperate": "ɛɡzɑːspəreɪt",
    "exasperates": "ɛɡzɑːspəreɪts",
    "exasperating": "ɛɡzɑːspəreɪtɪŋ",
    "exasperation": "ɛɡzɑːspəreɪʃən",
    "excavated": "ɛkskəveɪtɪd",
    "excavate": "ɛkskəveɪt",
    "excavates": "ɛkskəveɪts",
    "excavating": "ɛkskəveɪtɪŋ",
    "excavation": "ɛkskəveɪʃən",
    "excavations": "ɛkskəveɪʃənz",
    "excavator": "ɛkskəveɪtɐ",
    "excavators": "ɛkskəveɪtəz",
    "exceeded": "ɛksiːdɪd",
    "exceed": "ɛksiːd",
    "exceeding": "ɛksiːdɪŋ",
    "exceedingly": "ɛksiːdɪŋli",
    "exceeds": "ɛksiːdz",
    "excel": "ɛksɛl",
    "excelled": "ɛksɛld",
    "excellence": "ɛksələns",
    "excellencies": "ɛksələnsiz",
    "excellency": "ɛksələnsi",
    "excellent": "ɛksələnt",
    "excellently": "ɛksələntli",
    "excelling": "ɛksɛlɪŋ",
    "excels": "ɛksɛlz",
    "excelsior": "ɛksɛlsjɐ",
    "excepted": "ɛksɛptɪd",
    "except": "ɛksɛpt",
    "excepting": "ɛksɛptɪŋ",
    "exceptional": "ɛksɛpʃənəl",
    "exceptionally": "ɛksɛpʃənəli",
    "exception": "ɛksɛpʃən",
    "exceptions": "ɛksɛpʃənz",
    "excepts": "ɛksɛpts",
    "excerpt": "ɛksɜːpt",
    "excerpts": "ɛksɜːpts",
    "excesses": "ɛksɛsɪz",
    "excessive": "ɛksɛsɪv",
    "excessively": "ɛksɛsɪvli",
    "exchangeable": "ɛkstʃeɪndʒəbəl",
    "exchanged": "ɛkstʃeɪndʒd",
    "exchange": "ɛkstʃeɪndʒ",
    "exchanger": "ɛkstʃeɪndʒɐ",
    "exchangers": "ɛkstʃeɪndʒəz",
    "exchanges": "ɛkstʃeɪndʒɪz",
    "exchanging": "ɛkstʃeɪndʒɪŋ",
    "exchequer": "ɛkstʃɛkɐ",
    "excised": "ɛksaɪzd",
    "exciseman": "ɛksaɪsmən",
    "excising": "ɛksaɪzɪŋ",
    "excision": "ɛksɪʒən",
    "excitability": "ɛksaɪtəbɪlɪti",
    "excitable": "ɛksaɪtəbəl",
    "excitably": "ɛksaɪtəbli",
    "excitation": "ɛksɪteɪʃən",
    "excitations": "ɛksɪteɪʃənz",
    "excited": "ɛksaɪtɪd",
    "excitedly": "ɛksaɪtɪdli",
    "excite": "ɛksaɪt",
    "excitement": "ɛksaɪtmənt",
    "excitements": "ɛksaɪtmənts",
    "exciter": "ɛksaɪtɐ",
    "excites": "ɛksaɪts",
    "exciting": "ɛksaɪtɪŋ",
    "excitingly": "ɛksaɪtɪŋli",
    "exclaimed": "ɛkskleɪmd",
    "exclaim": "ɛkskleɪm",
    "exclaiming": "ɛkskleɪmɪŋ",
    "exclaims": "ɛkskleɪmz",
    "exclamation": "ɛksklɐmeɪʃən",
    "exclamations": "ɛksklɐmeɪʃənz",
    "exclave": "ɛkskleɪv",
    "excluded": "ɛkskluːdɪd",
    "exclude": "ɛkskluːd",
    "excludes": "ɛkskluːdz",
    "excluding": "ɛkskluːdɪŋ",
    "exclusionary": "ɛkskluːʒənəri",
    "exclusion": "ɛkskluːʒən",
    "exclusions": "ɛkskluːʒənz",
    "exclusive": "ɛkskluːsɪv",
    "exclusively": "ɛkskluːsɪvli",
    "exclusiveness": "ɛkskluːsɪvnəs",
    "exclusives": "ɛkskluːsɪvz",
    "exclusivity": "ɛkskluːsɪvɪti",
    "excommunicated": "ɛkskəmjuːnɪkeɪtɪd",
    "excommunicate": "ɛkskəmjuːnɪkeɪt",
    "excommunicating": "ɛkskəmjuːnɪkeɪtɪŋ",
    "excommunication": "ɛkskəmjuːnɪkeɪʃən",
    "excommunications": "ɛkskəmjuːnɪkeɪʃənz",
    "excoriated": "ɛkskɔːrɪeɪtɪd",
    "excoriating": "ɛkskɔːrɪeɪtɪŋ",
    "excrement": "ɛkskrɪmənt",
    "excrescence": "ɛkskrɛsəns",
    "excreta": "ɛkskrɛtɐ",
    "excreted": "ɛkskriːtɪd",
    "excrete": "ɛkskriːt",
    "excretes": "ɛkskriːts",
    "excreting": "ɛkskriːtɪŋ",
    "excretion": "ɛkskrɛʃən",
    "excretions": "ɛkskrɛʃənz",
    "excretory": "ɛkskrɛtəri",
    "excruciated": "ɛkskruːʃɪeɪtɪd",
    "excruciating": "ɛkskruːʃɪeɪtɪŋ",
    "excruciatingly": "ɛkskruːʃɪeɪtɪŋli",
    "exculpatory": "ɛkskʌlpətəri",
    "excursion": "ɛkskɜːʃən",
    "excursionists": "ɛkskɜːʃənɪsts",
    "excursions": "ɛkskɜːʃənz",
    "excusable": "ɛkskjuːsəbəl",
    "excused": "ɛkskjuːsd",
    "excusing": "ɛkskjuːsɪŋ",
    "exec": "ɛɡzɛk",
    "execrable": "ɛɡzɛkrəbəl",
    "execration": "ɛɡzɪkreɪʃən",
    "execs": "ɛɡzɛks",
    "executable": "ɛksɪkjuːtəbəl",
    "executed": "ɛksɪkjuːtɪd",
    "execute": "ɛksɪkjuːt",
    "executes": "ɛksɪkjuːts",
    "executing": "ɛksɪkjuːtɪŋ",
    "execution": "ɛksɪkjuːʃən",
    "executioner": "ɛksɪkjuːʃənɐ",
    "executioners": "ɛksɪkjuːʃənəz",
    "executions": "ɛksɪkjuːʃənz",
    "executive": "ɛɡzɛkjuːtɪv",
    "executives": "ɛɡzɛkjuːtɪvz",
    "executor": "ɛɡzɛkjuːtɐ",
    "executors": "ɛɡzɛkjuːtəz",
    "exegesis": "ɛɡzɪdʒiːsɪs",
    "ex": "ɛks",
    "exemplar": "ɛɡzɛmplɐ",
    "exemplars": "ɛɡzɛmpləz",
    "exemplary": "ɛɡzɛmpləri",
    "exemplified": "ɛɡzɛmplɪfaɪd",
    "exemplifies": "ɛɡzɛmplɪfaɪz",
    "exemplify": "ɛɡzɛmplɪfaɪ",
    "exemplum": "ɛɡzɛmpləm",
    "exempted": "ɛɡzɛmptɪd",
    "exempt": "ɛɡzɛmpt",
    "exempting": "ɛɡzɛmptɪŋ",
    "exemption": "ɛɡzɛmpʃən",
    "exemptions": "ɛɡzɛmpʃənz",
    "exempts": "ɛɡzɛmpts",
    "exercised": "ɛksəsaɪzd",
    "exercise": "ɛksəsaɪz",
    "exerciser": "ɛksəsaɪzɐ",
    "exercisers": "ɛksəsaɪzəz",
    "exercises": "ɛksəsaɪzɪz",
    "exercising": "ɛksəsaɪzɪŋ",
    "exerted": "ɛɡzɜːtɪd",
    "exert": "ɛɡzɜːt",
    "exerting": "ɛɡzɜːtɪŋ",
    "exertion": "ɛɡzɜːʃən",
    "exertions": "ɛɡzɜːʃənz",
    "exerts": "ɛɡzɜːts",
    "exes": "ɛksɪz",
    "exeunt": "ɛɡzjuːnt",
    "exfoliant": "ɛksfəʊliənt",
    "exfoliated": "ɛksfəʊlɪeɪtɪd",
    "exfoliate": "ɛksfəʊlɪeɪt",
    "exfoliates": "ɛksfəʊlɪeɪts",
    "exfoliating": "ɛksfəʊlɪeɪtɪŋ",
    "exfoliation": "ɛksfəʊlɪeɪʃən",
    "exfoliator": "ɛksfəʊlɪeɪtɐ",
    "exhalation": "ɛkshɐleɪʃən",
    "exhalations": "ɛkshɐleɪʃənz",
    "exhaled": "ɛksheɪld",
    "exhale": "ɛksheɪl",
    "exhales": "ɛksheɪlz",
    "exhaling": "ɛksheɪlɪŋ",
    "exhausted": "ɛɡzɔːstɪd",
    "exhaust": "ɛɡzɔːst",
    "exhausting": "ɛɡzɔːstɪŋ",
    "exhaustion": "ɛɡzɔːstʃən",
    "exhaustive": "ɛɡzɔːstɪv",
    "exhaustively": "ɛɡzɔːstɪvli",
    "exhausts": "ɛɡzɔːsts",
    "exhibited": "ɛɡzɪbɪtɪd",
    "exhibit": "ɛɡzɪbɪt",
    "exhibiting": "ɛɡzɪbɪtɪŋ",
    "exhibition": "ɛksɪbɪʃən",
    "exhibitionism": "ɛksɪbɪʃənɪzəm",
    "exhibitionist": "ɛksɪbɪʃənɪst",
    "exhibitionistic": "ɛksɪbɪʃənɪstɪk",
    "exhibitionists": "ɛksɪbɪʃənɪsts",
    "exhibitions": "ɛksɪbɪʃənz",
    "exhibitor": "ɛɡzɪbɪtɐ",
    "exhibitors": "ɛɡzɪbɪtəz",
    "exhibits": "ɛɡzɪbɪts",
    "exhilarated": "ɛɡzɪlɐreɪtɪd",
    "exhilarates": "ɛɡzɪlɐreɪts",
    "exhilarating": "ɛɡzɪlɐreɪtɪŋ",
    "exhilaration": "ɛɡzɪlɐreɪʃən",
    "exhortation": "ɛɡzɔːteɪʃən",
    "exhortations": "ɛɡzɔːteɪʃənz",
    "exhorted": "ɛɡzɔːtɪd",
    "exhort": "ɛɡzɔːt",
    "exhorting": "ɛɡzɔːtɪŋ",
    "exhorts": "ɛɡzɔːts",
    "exhumation": "ɛɡzjuːmeɪʃən",
    "exhumations": "ɛɡzjuːmeɪʃənz",
    "exhumed": "ɛɡzjuːmd",
    "exhume": "ɛɡzjuːm",
    "exhuming": "ɛɡzjuːmɪŋ",
    "exigent": "ɛɡzaɪdʒənt",
    "exiguous": "ɛɡzɪɡjuːəs",
    "exiled": "ɛɡzaɪld",
    "exile": "ɛɡzaɪl",
    "exiles": "ɛɡzaɪlz",
    "exiling": "ɛɡzaɪlɪŋ",
    "existed": "ɛɡzɪstɪd",
    "existence": "ɛɡzɪstəns",
    "existences": "ɛɡzɪstənsɪz",
    "existent": "ɛɡzɪstənt",
    "existential": "ɛɡzɪstɛnʃəl",
    "existentialism": "ɛɡzɪstɛnʃɪəlɪzəm",
    "existentialist": "ɛɡzɪstɛnʃɪəlɪst",
    "exist": "ɛɡzɪst",
    "existing": "ɛɡzɪstɪŋ",
    "exists": "ɛɡzɪsts",
    "exited": "ɛɡzɪtɪd",
    "exit": "ɛɡzɪt",
    "exiting": "ɛɡzɪtɪŋ",
    "exits": "ɛɡzɪts",
    "exodus": "ɛksədəs",
    "exonerated": "ɛɡzɒnəreɪtɪd",
    "exonerate": "ɛɡzɒnəreɪt",
    "exonerates": "ɛɡzɒnəreɪts",
    "exonerating": "ɛɡzɒnəreɪtɪŋ",
    "exoneration": "ɛɡzəʊnreɪʃən",
    "exon": "ɛɡzɒn",
    "exorbitant": "ɛɡzɔːbɪtənt",
    "exorbitantly": "ɛɡzɔːbɪtəntli",
    "exorcised": "ɛksəsaɪzd",
    "exorcise": "ɛksəsaɪz",
    "exorcising": "ɛksəsaɪzɪŋ",
    "exorcism": "ɛksəsɪzəm",
    "exorcisms": "ɛksəsɪzəmz",
    "exorcist": "ɛksəsɪst",
    "exorcists": "ɛksəsɪsts",
    "exoskeleton": "ɛksəʊskɛlɪtən",
    "exoskeletons": "ɛksəʊskɛlɪtənz",
    "exosphere": "ɛksəʊsfiə",
    "exothermic": "ɛɡzəðɜːmɪk",
    "exotica": "ɛɡzɒtɪkɐ",
    "exotically": "ɛɡzɒtɪkli",
    "exotic": "ɛɡzɒtɪk",
    "exoticism": "ɛɡzɒtɪsɪzəm",
    "exotics": "ɛɡzɒtɪks",
    "expandable": "ɛkspændəbəl",
    "expanded": "ɛkspændɪd",
    "expand": "ɛkspænd",
    "expander": "ɛkspændɐ",
    "expanding": "ɛkspændɪŋ",
    "expands": "ɛkspændz",
    "expanse": "ɛkspæns",
    "expanses": "ɛkspænsɪz",
    "expansionary": "ɛkspænʃənəri",
    "expansion": "ɛkspænʃən",
    "expansionism": "ɛkspænʃənɪzəm",
    "expansionist": "ɛkspænʃənɪst",
    "expansionists": "ɛkspænʃənɪsts",
    "expansions": "ɛkspænʃənz",
    "expansive": "ɛkspænsɪv",
    "expansively": "ɛkspænsɪvli",
    "expansiveness": "ɛkspænsɪvnəs",
    "expat": "ɛkspæt",
    "expatriated": "ɛkspætrɪeɪtɪd",
    "expats": "ɛkspæts",
    "expectancies": "ɛkspɛktənsɪz",
    "expectancy": "ɛkspɛktənsi",
    "expectant": "ɛkspɛktənt",
    "expectantly": "ɛkspɛktəntli",
    "expectation": "ɛkspɪkteɪʃən",
    "expectations": "ɛkspɪkteɪʃənz",
    "expected": "ɛkspɛktɪd",
    "expect": "ɛkspɛkt",
    "expecting": "ɛkspɛktɪŋ",
    "expectorant": "ɛkspɛktərənt",
    "expectorating": "ɛkspɛktəreɪtɪŋ",
    "expects": "ɛkspɛkts",
    "expedience": "ɛkspiːdiəns",
    "expediency": "ɛkspiːdiənsi",
    "expedient": "ɛkspiːdiənt",
    "expedients": "ɛkspiːdiənts",
    "expedited": "ɛkspədaɪtɪd",
    "expedite": "ɛkspədaɪt",
    "expediter": "ɛkspədaɪtɐ",
    "expediting": "ɛkspədaɪtɪŋ",
    "expeditionary": "ɛkspədɪʃənəri",
    "expedition": "ɛkspədɪʃən",
    "expeditions": "ɛkspədɪʃənz",
    "expeditious": "ɛkspədɪʃəs",
    "expeditiously": "ɛkspədɪʃəsli",
    "expel": "ɛkspɛl",
    "expelled": "ɛkspɛld",
    "expelling": "ɛkspɛlɪŋ",
    "expels": "ɛkspɛlz",
    "expendable": "ɛkspɛndəbəl",
    "expendables": "ɛkspɛndəbəlz",
    "expended": "ɛkspɛndɪd",
    "expend": "ɛkspɛnd",
    "expending": "ɛkspɛndɪŋ",
    "expenditure": "ɛkspɛndɪtʃɐ",
    "expenditures": "ɛkspɛndɪtʃəz",
    "expends": "ɛkspɛndz",
    "expense": "ɛkspɛns",
    "expenses": "ɛkspɛnsɪz",
    "expensive": "ɛkspɛnsɪv",
    "expensively": "ɛkspɛnsɪvli",
    "experienced": "ɛkspiərɪənst",
    "experience": "ɛkspiərɪəns",
    "experiences": "ɛkspiərɪənsɪz",
    "experiencing": "ɛkspiərɪənsɪŋ",
    "experiential": "ɛkspiərɪɛnʃəl",
    "experimental": "ɛkspɛrɪmɛntəl",
    "experimentalism": "ɛkspɛrɪmɛntəlɪzəm",
    "experimentalist": "ɛkspɛrɪmɛntəlɪst",
    "experimentalists": "ɛkspɛrɪmɛntəlɪsts",
    "experimentally": "ɛkspɛrɪmɛntəli",
    "experimentation": "ɛkspɛrɪmənteɪʃən",
    "experimented": "ɛkspɛrɪməntɪd",
    "experiment": "ɛkspɛrɪmənt",
    "experimenter": "ɛkspɛrɪməntɐ",
    "experimenters": "ɛkspɛrɪmɛntəz",
    "experimenting": "ɛkspɛrɪməntɪŋ",
    "experiments": "ɛkspɛrɪmənts",
    "expert": "ɛkspɜːt",
    "expertise": "ɛkspətiːz",
    "expertly": "ɛkspɜːtli",
    "experts": "ɛkspɜːts",
    "expiate": "ɛkspɪeɪt",
    "expiation": "ɛkspɪeɪʃən",
    "expiration": "ɛkspəreɪʃən",
    "expired": "ɛkspaɪəd",
    "expire": "ɛkspaɪə",
    "expires": "ɛkspaɪəz",
    "expiring": "ɛkspaɪərɪŋ",
    "expiry": "ɛkspaɪəri",
    "explainable": "ɛkspleɪnəbəl",
    "explained": "ɛkspleɪnd",
    "explain": "ɛkspleɪn",
    "explainer": "ɛkspleɪnɐ",
    "explaining": "ɛkspleɪnɪŋ",
    "explains": "ɛkspleɪnz",
    "explanation": "ɛksplɐneɪʃən",
    "explanations": "ɛksplɐneɪʃənz",
    "explanatory": "ɛksplænətəri",
    "expletive": "ɛkspliːtɪv",
    "expletives": "ɛkspliːtɪvz",
    "explicable": "ɛksplɪkəbəl",
    "explicate": "ɛksplɪkeɪt",
    "explicit": "ɛksplɪsɪt",
    "explicitly": "ɛksplɪsɪtli",
    "exploded": "ɛkspləʊdɪd",
    "explode": "ɛkspləʊd",
    "exploder": "ɛkspləʊdɐ",
    "explodes": "ɛkspləʊdz",
    "exploding": "ɛkspləʊdɪŋ",
    "exploitable": "ɛksplɔɪtəbəl",
    "exploitation": "ɛksplɔɪteɪʃən",
    "exploitative": "ɛksplɔɪtətɪv",
    "exploited": "ɛksplɔɪtɪd",
    "exploiter": "ɛksplɔɪtɐ",
    "exploiters": "ɛksplɔɪtəz",
    "exploiting": "ɛksplɔɪtɪŋ",
    "exploitive": "ɛksplɔɪtɪv",
    "exploration": "ɛksplɔːreɪʃən",
    "explorations": "ɛksplɔːreɪʃənz",
    "exploratory": "ɛksplɔːrətəri",
    "explored": "ɛksplɔːd",
    "explore": "ɛksplɔː",
    "explorer": "ɛksplɔːrɐ",
    "explorers": "ɛksplɔːrəz",
    "explores": "ɛksplɔːz",
    "exploring": "ɛksplɔːrɪŋ",
    "explosion": "ɛkspləʊʒən",
    "explosions": "ɛkspləʊʒənz",
    "explosive": "ɛkspləʊsɪv",
    "explosively": "ɛkspləʊsɪvli",
    "explosiveness": "ɛkspləʊsɪvnəs",
    "explosives": "ɛkspləʊsɪvz",
    "expo": "ɛkspəʊ",
    "exponent": "ɛkspəʊnənt",
    "exponential": "ɛkspənɛnʃəl",
    "exponentially": "ɛkspənɛnʃəli",
    "exponents": "ɛkspəʊnənts",
    "exportable": "ɛkspɔːtəbəl",
    "exportation": "ɛkspɔːteɪʃən",
    "exported": "ɛkspɔːtɪd",
    "exporter": "ɛkspɔːtɐ",
    "exporters": "ɛkspɔːtəz",
    "exporting": "ɛkspɔːtɪŋ",
    "exposed": "ɛkspəʊzd",
    "expos": "ɛkspəʊz",
    "exposing": "ɛkspəʊzɪŋ",
    "exposition": "ɛkspəzɪʃən",
    "expositions": "ɛkspəzɪʃənz",
    "expostulate": "ɛkspɒstjʊleɪt",
    "exposure": "ɛkspəʊʒɐ",
    "exposures": "ɛkspəʊʒəz",
    "expounded": "ɛkspaʊndɪd",
    "expound": "ɛkspaʊnd",
    "expounding": "ɛkspaʊndɪŋ",
    "expressed": "ɛksprɛst",
    "express": "ɛksprɛs",
    "expresses": "ɛksprɛsɪz",
    "expressible": "ɛksprɛsəbəl",
    "expressing": "ɛksprɛsɪŋ",
    "expression": "ɛksprɛʃən",
    "expressionism": "ɛksprɛʃənɪzəm",
    "expressionist": "ɛksprɛʃənɪst",
    "expressionistic": "ɛksprɛʃənɪstɪk",
    "expressionists": "ɛksprɛʃənɪsts",
    "expressionless": "ɛksprɛʃənləs",
    "expressions": "ɛksprɛʃənz",
    "expressive": "ɛksprɛsɪv",
    "expressively": "ɛksprɛsɪvli",
    "expressiveness": "ɛksprɛsɪvnəs",
    "expressivity": "ɛksprɪsɪvɪti",
    "expressly": "ɛksprɛsli",
    "expressway": "ɛksprɛsweɪ",
    "expressways": "ɛksprɛsweɪz",
    "expropriated": "ɛksprɒprɪətɪd",
    "expropriate": "ɛksprɒprɪət",
    "expropriating": "ɛksprɒprɪətɪŋ",
    "expropriation": "ɛksprɒprɪeɪʃən",
    "expropriators": "ɛksprɒprɪeɪtəz",
    "expulsion": "ɛkspʌlʃən",
    "expulsions": "ɛkspʌlʃənz",
    "expunged": "ɛkspʌndʒd",
    "expunge": "ɛkspʌndʒ",
    "expunges": "ɛkspʌndʒɪz",
    "expurgated": "ɛkspɜːɡeɪtɪd",
    "exquisite": "ɛkskwɪsɪt",
    "exquisitely": "ɛkskwɪsɪtli",
    "exquisiteness": "ɛkskwɪsɪtnəs",
    "extant": "ɛkstɑːnt",
    "extemporaneous": "ɛkstɛmpɔːreɪniəs",
    "extempore": "ɛkstɛmpɔː",
    "extemporise": "ɛkstɛmpɔːraɪz",
    "extendable": "ɛkstɛndəbəl",
    "extended": "ɛkstɛndɪd",
    "extend": "ɛkstɛnd",
    "extender": "ɛkstɛndɐ",
    "extending": "ɛkstɛndɪŋ",
    "extends": "ɛkstɛndz",
    "extensible": "ɛkstɛnsəbəl",
    "extension": "ɛkstɛnʃən",
    "extensions": "ɛkstɛnʃənz",
    "extensive": "ɛkstɛnsɪv",
    "extensively": "ɛkstɛnsɪvli",
    "extensor": "ɛkstɛnsɐ",
    "extent": "ɛkstɛnt",
    "extents": "ɛkstɛnts",
    "extenuated": "ɛkstɛnjuːeɪtɪd",
    "extenuating": "ɛkstɛnjuːeɪtɪŋ",
    "exterior": "ɛkstiərɪɐ",
    "exteriors": "ɛkstiərɪəz",
    "exterminated": "ɛkstɜːmɪneɪtɪd",
    "exterminate": "ɛkstɜːmɪneɪt",
    "exterminating": "ɛkstɜːmɪneɪtɪŋ",
    "extermination": "ɛkstɜːmɪneɪʃən",
    "exterminator": "ɛkstɜːmɪneɪtɐ",
    "exterminators": "ɛkstɜːmɪneɪtəz",
    "external": "ɛkstɜːnəl",
    "externalised": "ɛkstɜːnəlaɪzd",
    "externalise": "ɛkstɜːnəlaɪz",
    "externalities": "ɛkstɜːnælɪtiz",
    "externally": "ɛkstɜːnəli",
    "externals": "ɛkstɜːnəlz",
    "extinct": "ɛkstɪŋkt",
    "extinction": "ɛkstɪŋkʃən",
    "extinctions": "ɛkstɪŋkʃənz",
    "extinguished": "ɛkstɪŋɡwɪʃt",
    "extinguish": "ɛkstɪŋɡwɪʃ",
    "extinguisher": "ɛkstɪŋɡwɪʃɐ",
    "extinguishers": "ɛkstɪŋɡwɪʃəz",
    "extinguishes": "ɛkstɪŋɡwɪʃɪz",
    "extinguishing": "ɛkstɪŋɡwɪʃɪŋ",
    "extirpated": "ɛkstɜːpeɪtɪd",
    "extirpate": "ɛkstɜːpeɪt",
    "extirpation": "ɛkstəpeɪʃən",
    "extol": "ɛkstəʊl",
    "extolled": "ɛkstəʊld",
    "extolling": "ɛkstəʊlɪŋ",
    "extols": "ɛkstəʊlz",
    "extorted": "ɛkstɔːtɪd",
    "extort": "ɛkstɔːt",
    "extorting": "ɛkstɔːtɪŋ",
    "extortionate": "ɛkstɔːʃənət",
    "extortionately": "ɛkstɔːʃənətli",
    "extortion": "ɛkstɔːʃən",
    "extortionist": "ɛkstɔːʃənɪst",
    "extorts": "ɛkstɔːts",
    "extracellular": "ɛkstrəsɛljʊlɐ",
    "extractable": "ɛkstræktəbəl",
    "extracted": "ɛkstræktɪd",
    "extracting": "ɛkstræktɪŋ",
    "extraction": "ɛkstrækʃən",
    "extractions": "ɛkstrækʃənz",
    "extractive": "ɛkstræktɪv",
    "extractor": "ɛkstræktɐ",
    "extractors": "ɛkstræktəz",
    "extracurricular": "ɛkstrəkərɪkjʊlɐ",
    "extradited": "ɛkstrədaɪtɪd",
    "extradite": "ɛkstrədaɪt",
    "extraditing": "ɛkstrədaɪtɪŋ",
    "extradition": "ɛkstrədɪʃən",
    "extraditions": "ɛkstrədɪʃənz",
    "extra": "ɛkstrɐ",
    "extramarital": "ɛkstrəmærɪtəl",
    "extraneous": "ɛkstreɪniəs",
    "extraordinaire": "ɛkstrɔːdɪneə",
    "extraordinarily": "ɛkstrɔːdɪnɛrəli",
    "extraordinary": "ɛkstrɔːdɪnəri",
    "extrapolated": "ɛkstræpəleɪtɪd",
    "extrapolate": "ɛkstræpəleɪt",
    "extrapolating": "ɛkstræpəleɪtɪŋ",
    "extrapolation": "ɛkstræpəleɪʃən",
    "extrapolations": "ɛkstræpəleɪʃənz",
    "extrapolator": "ɛkstræpəleɪtɐ",
    "extras": "ɛkstrəz",
    "extrasolar": "ɛkstrəsəʊlɐ",
    "extraterrestrial": "ɛkstrətərɛstrɪəl",
    "extraterrestrials": "ɛkstrətərɛstrɪəlz",
    "extravagance": "ɛkstrævəɡəns",
    "extravagances": "ɛkstrævəɡənsɪz",
    "extravagant": "ɛkstrævəɡənt",
    "extravagantly": "ɛkstrævəɡəntli",
    "extravaganza": "ɛkstrævəɡænzɐ",
    "extravaganzas": "ɛkstrævəɡænzəz",
    "extraversion": "ɛkstrəvɜːʃən",
    "extreme": "ɛkstriːm",
    "extremely": "ɛkstriːmli",
    "extremeness": "ɛkstriːmnəs",
    "extremes": "ɛkstriːmz",
    "extremest": "ɛkstrɛməst",
    "extremism": "ɛkstriːmɪzəm",
    "extremist": "ɛkstriːmɪst",
    "extremists": "ɛkstriːmɪsts",
    "extremities": "ɛkstrɛmɪtiz",
    "extremity": "ɛkstrɛmɪti",
    "extricable": "ɛkstrɪkəbəl",
    "extricated": "ɛkstrɪkeɪtɪd",
    "extricate": "ɛkstrɪkeɪt",
    "extricating": "ɛkstrɪkeɪtɪŋ",
    "extrication": "ɛkstrɪkeɪʃən",
    "extrinsic": "ɛkstrɪnzɪk",
    "extroversion": "ɛkstrəvɜːʃən",
    "extroverted": "ɛkstrəvɜːtɪd",
    "extrovert": "ɛkstrəvɜːt",
    "extroverts": "ɛkstrəvɜːts",
    "extruded": "ɛkstruːdɪd",
    "extrude": "ɛkstruːd",
    "extruder": "ɛkstruːdɐ",
    "extrusion": "ɛkstruːʒən",
    "extrusions": "ɛkstruːʒənz",
    "exuberance": "ɛɡzjuːbərəns",
    "exuberant": "ɛɡzjuːbərənt",
    "exuberantly": "ɛɡzjuːbərəntli",
    "exuded": "ɛɡzjuːdɪd",
    "exude": "ɛɡzjuːd",
    "exudes": "ɛɡzjuːdz",
    "exuding": "ɛɡzjuːdɪŋ",
    "exultant": "ɛɡzʌltənt",
    "exultantly": "ɛɡzʌltəntli",
    "exultation": "ɛɡzəlteɪʃən",
    "exulted": "ɛɡzʌltɪd",
    "exult": "ɛɡzʌlt",
    "eye": "aɪ",
    "eyeball": "aɪbɔːl",
    "eyeballed": "aɪbəld",
    "eyeballing": "aɪbɔːlɪŋ",
    "eyeballs": "aɪbɔːlz",
    "eyebright": "aɪbraɪt",
    "eyebrow": "aɪbraʊ",
    "eyebrows": "aɪbraʊz",
    "eyed": "aɪd",
    "eyeful": "aɪfəl",
    "eyefuls": "aɪfəlz",
    "eyeglass": "aɪɡlɑːs",
    "eyeglasses": "aɪɡlɑːsɪz",
    "eyeing": "aɪɪŋ",
    "eyelash": "aɪlæʃ",
    "eyelashes": "aɪlæʃɪz",
    "eyeless": "aɪləs",
    "eyelet": "aɪlət",
    "eyelets": "aɪləts",
    "eyelid": "aɪlɪd",
    "eyelids": "aɪlɪdz",
    "eyeliner": "aɪlaɪnɐ",
    "eyepiece": "aɪpiːs",
    "eyepieces": "aɪpiːsɪz",
    "eyes": "aɪz",
    "eyeshadow": "aɪʃɐdəʊ",
    "eyeshot": "aɪʃɒt",
    "eyesight": "aɪsaɪt",
    "eyesore": "aɪsɔː",
    "eyesores": "aɪsɔːz",
    "eyespot": "aɪspɒt",
    "eyespots": "aɪspɒts",
    "eyestalk": "aɪstɔːk",
    "eyestrain": "aɪstreɪn",
    "eyeteeth": "aɪtiːθ",
    "eyetooth": "aɪtuːθ",
    "eyewash": "aɪwɒʃ",
    "eyewitness": "aɪwɪtnəs",
    "eyewitnesses": "aɪwɪtnəsɪz",
    "eying": "aɪɪŋ",
    "eyre": "aɪɐ",
    "eyrie": "iəri",
    "fab": "fæb",
    "fabled": "feɪbəld",
    "fable": "feɪbəl",
    "fables": "feɪbəlz",
    "fabricant": "fæbrɪkənt",
    "fabricated": "fæbrɪkeɪtɪd",
    "fabricate": "fæbrɪkeɪt",
    "fabricating": "fæbrɪkeɪtɪŋ",
    "fabrication": "fæbrɪkeɪʃən",
    "fabrications": "fæbrɪkeɪʃənz",
    "fabricator": "fæbrɪkeɪtɐ",
    "fabricators": "fæbrɪkeɪtəz",
    "fabric": "fæbrɪk",
    "fabrics": "fæbrɪks",
    "fabulist": "fæbjʊlɪst",
    "fabulous": "fæbjʊləs",
    "fabulously": "fæbjʊləsli",
    "fabulousness": "fæbjʊləsnəs",
    "facade": "fəsɑːd",
    "facades": "fəsɑːdz",
    "facecloth": "feɪsklɒθ",
    "faced": "feɪsd",
    "facedown": "feɪsdaʊn",
    "face": "feɪs",
    "faceless": "feɪsləs",
    "facelift": "feɪslɪft",
    "facelifts": "feɪslɪfts",
    "faces": "feɪsɪz",
    "faceted": "fæsɛtɪd",
    "facet": "fæsɛt",
    "faceting": "fæsɛtɪŋ",
    "facetious": "fɐsiːʃəs",
    "facetiously": "fɐsiːʃəsli",
    "facetiousness": "fɐsiːʃəsnəs",
    "facets": "fæsɛts",
    "facetted": "fæsɛtɪd",
    "facia": "feɪʃɐ",
    "facial": "feɪʃəl",
    "facially": "feɪʃəli",
    "facials": "feɪʃəlz",
    "facile": "fæsaɪl",
    "facilitated": "fəsɪlɪteɪtɪd",
    "facilitate": "fəsɪlɪteɪt",
    "facilitates": "fəsɪlɪteɪts",
    "facilitating": "fəsɪlɪteɪtɪŋ",
    "facilitation": "fəsɪlɪteɪʃən",
    "facilitator": "fəsɪlɪteɪtɐ",
    "facilitators": "fəsɪlɪteɪtəz",
    "facilities": "fəsɪlɪtiz",
    "facility": "fəsɪlɪti",
    "facing": "feɪsɪŋ",
    "facings": "feɪsɪŋz",
    "facsimile": "fæksɪmɪli",
    "facsimiles": "fæksɪmɪlɪz",
    "fact": "fækt",
    "factional": "fækʃənəl",
    "factionalism": "fækʃənəlɪzəm",
    "faction": "fækʃən",
    "factions": "fækʃənz",
    "factious": "fækʃəs",
    "factitious": "fæktɪʃəs",
    "factoid": "fæktɔɪd",
    "factoids": "fæktɔɪdz",
    "factored": "fæktəd",
    "factor": "fæktɐ",
    "factorial": "fæktɔːrɪəl",
    "factories": "fæktəriz",
    "factoring": "fæktərɪŋ",
    "factorisation": "fæktɔːraɪzeɪʃən",
    "factorise": "fæktɔːraɪz",
    "factorising": "fæktɔːraɪzɪŋ",
    "factors": "fæktəz",
    "factory": "fæktəri",
    "factotum": "fæktɒtəm",
    "facts": "fækts",
    "factual": "fæktʃuːəl",
    "factually": "fæktʃuːəli",
    "facture": "fæktʃɐ",
    "faculties": "fækəltiz",
    "faculty": "fækəlti",
    "faddish": "fædɪʃ",
    "faddy": "fædi",
    "faded": "feɪdɪd",
    "fade": "feɪd",
    "fader": "feɪdɐ",
    "fades": "feɪdz",
    "fad": "fæd",
    "fadge": "fædʒ",
    "fading": "feɪdɪŋ",
    "fado": "fɑːdəʊ",
    "fads": "fædz",
    "faecal": "fiːkəl",
    "faeces": "fiːsiːz",
    "faerie": "feəri",
    "faeries": "feərɪz",
    "faery": "feəri",
    "fa": "fɑː",
    "faffed": "fæft",
    "faff": "fæf",
    "faffing": "fæfɪŋ",
    "fag": "fæɡ",
    "fagged": "fæɡd",
    "fagging": "fæɡɪŋ",
    "faggot": "fæɡət",
    "faggots": "fæɡəts",
    "fags": "fæɡz",
    "failed": "feɪld",
    "fail": "feɪl",
    "failing": "feɪlɪŋ",
    "failings": "feɪlɪŋz",
    "fails": "feɪlz",
    "failure": "feɪliə",
    "failures": "feɪliəz",
    "fain": "feɪn",
    "fainted": "feɪntɪd",
    "fainter": "feɪntɐ",
    "faintest": "feɪntəst",
    "faint": "feɪnt",
    "fainthearted": "feɪnthɑːtɪd",
    "fainting": "feɪntɪŋ",
    "faintly": "feɪntli",
    "faintness": "feɪntnəs",
    "faints": "feɪnts",
    "fairer": "feərɐ",
    "fairest": "feərəst",
    "fair": "feə",
    "fairground": "feəɡraʊnd",
    "fairgrounds": "feəɡraʊndz",
    "fairies": "feərɪz",
    "fairing": "feərɪŋ",
    "fairings": "feərɪŋz",
    "fairly": "feəli",
    "fairness": "feənəs",
    "fairs": "feəz",
    "fairway": "feəweɪ",
    "fairways": "feəweɪz",
    "fairy": "feəri",
    "fairyland": "feərɪlænd",
    "fairytale": "feərɪteɪl",
    "fairytales": "feərɪteɪlz",
    "faith": "feɪθ",
    "faithful": "feɪθfəl",
    "faithfully": "feɪθfəli",
    "faithfulness": "feɪθfəlnəs",
    "faithfuls": "feɪθfəlz",
    "faithless": "feɪθləs",
    "faithlessness": "feɪθləsnəs",
    "faiths": "feɪθs",
    "fajita": "fɐhiːtɐ",
    "fajitas": "fɐhiːtəz",
    "faked": "feɪkt",
    "fake": "feɪk",
    "faker": "feɪkɐ",
    "fakers": "feɪkəz",
    "fakery": "feɪkəri",
    "fakes": "feɪks",
    "faking": "feɪkɪŋ",
    "fakir": "fækiə",
    "fakirs": "fækiəz",
    "falafel": "fæleɪfəl",
    "falafels": "fæleɪfəlz",
    "falconer": "fælkənɐ",
    "falconers": "fælkənəz",
    "falcon": "fælkən",
    "falconry": "fælkɒnri",
    "falcons": "fælkənz",
    "fallacies": "fæləsɪz",
    "fallacious": "fæleɪʃəs",
    "fallacy": "fæləsi",
    "fallback": "fɔːlbæk",
    "fallen": "fɔːlən",
    "faller": "fɔːlɐ",
    "fallers": "fɔːləz",
    "fall": "fɔːl",
    "fallibility": "fælɪbɪlɪti",
    "fallible": "fæləbəl",
    "falling": "fɔːlɪŋ",
    "falloff": "fɔːlɒf",
    "fallout": "fɔːlaʊt",
    "fallowed": "fæləʊd",
    "fallow": "fæləʊ",
    "fallows": "fæləʊz",
    "falls": "fɔːlz",
    "false": "fɒls",
    "falsehood": "fɒlshʊd",
    "falsehoods": "fɒlshʊdz",
    "falsely": "fɒlsli",
    "falseness": "fɒlsnəs",
    "falsetto": "fɒlsɛtəʊ",
    "falsies": "fɒlsɪz",
    "falsifiability": "fɒlsɪfaɪəbɪlɪti",
    "falsification": "fɒlsɪfɪkeɪʃən",
    "falsifications": "fɒlsɪfɪkeɪʃənz",
    "falsified": "fɒlsɪfaɪd",
    "falsifies": "fɒlsɪfaɪz",
    "falsify": "fɒlsɪfaɪ",
    "falsifying": "fɒlsɪfaɪɪŋ",
    "falsity": "fɒlsɪti",
    "faltered": "fɒltəd",
    "falter": "fɒltɐ",
    "faltering": "fɒltərɪŋ",
    "falteringly": "fɒltərɪŋli",
    "falters": "fɒltəz",
    "famed": "feɪmd",
    "fame": "feɪm",
    "familial": "fæmɪlɪəl",
    "familiar": "fəmɪliə",
    "familiarisation": "fəmɪliəraɪzeɪʃən",
    "familiarised": "fəmɪliəraɪzd",
    "familiarise": "fəmɪliəraɪz",
    "familiarises": "fəmɪliəraɪzɪz",
    "familiarising": "fəmɪliəraɪzɪŋ",
    "familiarity": "fəmɪlɪærɪti",
    "familiarly": "fəmɪliəli",
    "familiars": "fəmɪliəz",
    "families": "fæmɪlɪz",
    "family": "fæmɪli",
    "famine": "fæmɪn",
    "famines": "fæmɪnz",
    "famished": "fæmɪʃt",
    "famous": "feɪməs",
    "famously": "feɪməsli",
    "fanatical": "fɐnætɪkəl",
    "fanatically": "fɐnætɪkli",
    "fanatic": "fɐnætɪk",
    "fanaticism": "fɐnætɪsɪzəm",
    "fanatics": "fɐnætɪks",
    "fanciable": "fænʃiəbəl",
    "fancied": "fænsɪd",
    "fancier": "fænsɪɐ",
    "fanciers": "fænsiəz",
    "fancies": "fænsɪz",
    "fanciest": "fænsɪəst",
    "fanciful": "fænsɪfəl",
    "fancifully": "fænsɪfəli",
    "fanciness": "fænsɪnɛs",
    "fancy": "fænsi",
    "fancying": "fænsɪɪŋ",
    "fandango": "fændæŋɡəʊ",
    "fandom": "fændəm",
    "fane": "feɪn",
    "fan": "fæn",
    "fanfare": "fænfeə",
    "fanfares": "fænfeəz",
    "fanged": "fæŋd",
    "fang": "fæŋ",
    "fangs": "fæŋz",
    "fanlight": "fænlaɪt",
    "fanned": "fænd",
    "fannies": "fænɪz",
    "fanning": "fænɪŋ",
    "fanny": "fæni",
    "fanon": "fænɒn",
    "fans": "fænz",
    "fantailed": "fɑːnteɪld",
    "fantail": "fɑːnteɪl",
    "fantails": "fɑːnteɪlz",
    "fantasia": "fɑːnteɪziə",
    "fantasies": "fɑːntəsiz",
    "fantasised": "fɑːntɐsaɪzd",
    "fantasise": "fɑːntɐsaɪz",
    "fantasises": "fɑːntɐsaɪzɪz",
    "fantasising": "fɑːntɐsaɪzɪŋ",
    "fantasist": "fɑːntɐsɪst",
    "fantasists": "fɑːntɐsɪsts",
    "fantast": "fɑːntæst",
    "fantastical": "fɑːntæstɪkəl",
    "fantastically": "fɑːntæstɪkli",
    "fantastic": "fɑːntæstɪk",
    "fantasy": "fɑːntəsi",
    "fanzine": "fænziːn",
    "fanzines": "fænziːnz",
    "farad": "færæd",
    "farandoles": "færɐndəʊlz",
    "faraway": "fɑːrəweɪ",
    "farce": "fɑːs",
    "farces": "fɑːsɪz",
    "farcical": "fɑːsɪkəl",
    "farcically": "fɑːsɪkli",
    "farci": "fɑːsaɪ",
    "fardel": "fɑːdəl",
    "fardels": "fɑːdəlz",
    "fard": "fɑːd",
    "fared": "feəd",
    "fare": "feə",
    "farer": "feərɐ",
    "fares": "feəz",
    "farewell": "feəwɛl",
    "farewells": "feəwɛlz",
    "far": "fɑː",
    "farfetched": "fɑːfɛtʃt",
    "farina": "fɑːriːnɐ",
    "faring": "feərɪŋ",
    "farl": "fɑːl",
    "farmed": "fɑːmd",
    "farmer": "fɑːmɐ",
    "farmers": "fɑːməz",
    "farm": "fɑːm",
    "farmhand": "fɑːmhænd",
    "farmhands": "fɑːmhændz",
    "farmhouse": "fɑːmhaʊs",
    "farmhouses": "fɑːmhaʊzɪz",
    "farming": "fɑːmɪŋ",
    "farmland": "fɑːmlənd",
    "farmlands": "fɑːmləndz",
    "farms": "fɑːmz",
    "farmstead": "fɑːmstɛd",
    "farmsteads": "fɑːmstɛdz",
    "farmyard": "fɑːmjɑːd",
    "farmyards": "fɑːmjɑːdz",
    "faro": "færəʊ",
    "farouche": "færaʊtʃ",
    "farrago": "færeɪɡəʊ",
    "farrier": "færɪɐ",
    "farriers": "færiəz",
    "farriery": "færɪəri",
    "farrowed": "færəʊd",
    "farrow": "færəʊ",
    "farrowing": "færəʊɪŋ",
    "farrows": "færəʊz",
    "farsighted": "fɑːsaɪtɪd",
    "farted": "fɑːtɪd",
    "fart": "fɑːt",
    "farther": "fɑːðɐ",
    "farthest": "fɑːðəst",
    "farthingales": "fɑːθɪŋɡeɪlz",
    "farthing": "fɑːθɪŋ",
    "farthings": "fɑːθɪŋz",
    "farting": "fɑːtɪŋ",
    "farts": "fɑːts",
    "fasces": "fæsɪz",
    "fascia": "feɪʃiɐ",
    "fascias": "feɪʃiəz",
    "fascinated": "fæsɪneɪtɪd",
    "fascinate": "fæsɪneɪt",
    "fascinates": "fæsɪneɪts",
    "fascinating": "fæsɪneɪtɪŋ",
    "fascinatingly": "fæsɪneɪtɪŋli",
    "fascination": "fæsɪneɪʃən",
    "fascinations": "fæsɪneɪʃənz",
    "fascinator": "fæsɪneɪtɐ",
    "fascism": "fæʃɪzəm",
    "fascist": "fæʃɪst",
    "fascistic": "fæʃɪstɪk",
    "fascists": "fæʃɪsts",
    "fash": "fæʃ",
    "fashionable": "fæʃənəbəl",
    "fashionably": "fæʃənəbli",
    "fashioned": "fæʃənd",
    "fashion": "fæʃən",
    "fashioning": "fæʃənɪŋ",
    "fashions": "fæʃənz",
    "fastback": "fɑːstbæk",
    "fastball": "fɑːstbɔːl",
    "fasted": "fɑːstɪd",
    "fastened": "fɑːsənd",
    "fastener": "fɑːstənɐ",
    "fasteners": "fɑːstənəz",
    "fasten": "fɑːsən",
    "fastening": "fɑːsənɪŋ",
    "fastenings": "fɑːsənɪŋz",
    "fastens": "fɑːsənz",
    "faster": "fɑːstɐ",
    "fastest": "fɑːstəst",
    "fast": "fɑːst",
    "fastidious": "fɑːstɪdɪəs",
    "fastidiously": "fɑːstɪdɪəsli",
    "fastidiousness": "fɑːstɪdɪəsnəs",
    "fasting": "fɑːstɪŋ",
    "fastnesses": "fɑːstnəsɪz",
    "fastness": "fɑːstnəs",
    "fasts": "fɑːsts",
    "fatal": "feɪtəl",
    "fatalism": "feɪtəlɪzəm",
    "fatalist": "feɪtəlɪst",
    "fatalistic": "feɪtəlɪstɪk",
    "fatalities": "feɪtælɪtiz",
    "fatality": "feɪtælɪti",
    "fatally": "feɪtəli",
    "fatback": "fætbæk",
    "fated": "feɪtɪd",
    "fate": "feɪt",
    "fateful": "feɪtfəl",
    "fatefully": "feɪtfəli",
    "fates": "feɪts",
    "fat": "fæt",
    "fathead": "fæthɛd",
    "fatheads": "fæthɛdz",
    "fathered": "fɑːðəd",
    "father": "fɑːðɐ",
    "fatherhood": "fɑːðəhʊd",
    "fathering": "fɑːðərɪŋ",
    "fatherland": "fɑːðələnd",
    "fatherless": "fɑːðələs",
    "fatherlessness": "fɑːðələsnəs",
    "fatherly": "fɑːðəli",
    "fathers": "fɑːðəz",
    "fathomed": "fæðəmd",
    "fathom": "fæðəm",
    "fathoming": "fæðəmɪŋ",
    "fathomless": "fæðəmləs",
    "fathoms": "fæðəmz",
    "fatigued": "fɐtiːɡd",
    "fatigue": "fɐtiːɡ",
    "fatigues": "fɐtiːɡz",
    "fatiguing": "fɐtiːɡɪŋ",
    "fatless": "fætləs",
    "fatly": "fætli",
    "fatness": "fætnəs",
    "fats": "fæts",
    "fatso": "fætsəʊ",
    "fatsos": "fætsəʊz",
    "fatted": "fætɪd",
    "fattened": "fætənd",
    "fatten": "fætən",
    "fattening": "fætənɪŋ",
    "fattens": "fætənz",
    "fatter": "fætɐ",
    "fattest": "fætəst",
    "fattier": "fætɪɐ",
    "fatties": "fætɪz",
    "fattiest": "fætɪəst",
    "fattiness": "fætɪnəs",
    "fattish": "fætɪʃ",
    "fatty": "fæti",
    "fatuous": "fætʃuːəs",
    "fatuousness": "fætʃuːəsnəs",
    "fatwa": "fætwɐ",
    "fatwas": "fætwəz",
    "faucet": "fɔːsɪt",
    "faucets": "fɔːsɪts",
    "faulted": "fɒltɪd",
    "fault": "fɒlt",
    "faulting": "fɒltɪŋ",
    "faultless": "fɒltləs",
    "faultlessly": "fɒltləsli",
    "faults": "fɒlts",
    "faulty": "fɒlti",
    "fauna": "fɔːnɐ",
    "faun": "fɔːn",
    "fauns": "fɔːnz",
    "fauve": "fəʊv",
    "fauvism": "fəʊvɪzəm",
    "fauvist": "fəʊvɪst",
    "faux": "fəʊ",
    "fave": "feɪv",
    "faves": "feɪvz",
    "favorable": "feɪvərəbəl",
    "favor": "feɪvɐ",
    "favorite": "feɪvərɪt",
    "favorites": "feɪvərɪts",
    "favoritism": "feɪvərɪtɪzəm",
    "favourable": "feɪvərəbəl",
    "favourably": "feɪvərəbli",
    "favoured": "feɪvəd",
    "favour": "feɪvɐ",
    "favouring": "feɪvɜːrɪŋ",
    "favourite": "feɪvrɪt",
    "favourites": "feɪvrɪts",
    "favouritism": "feɪvərɪtɪzəm",
    "favours": "feɪvəz",
    "fawned": "fɔːnd",
    "fawn": "fɔːn",
    "fawning": "fɔːnɪŋ",
    "fawns": "fɔːnz",
    "faxed": "fækst",
    "faxes": "fæksɪz",
    "fax": "fæks",
    "faxing": "fæksɪŋ",
    "fay": "feɪ",
    "fayre": "feɪɐ",
    "fazed": "feɪzd",
    "faze": "feɪz",
    "fazes": "feɪzɪz",
    "fazing": "feɪzɪŋ",
    "fealty": "fiːlti",
    "feared": "fiəd",
    "fear": "fiə",
    "fearful": "fiəfəl",
    "fearfully": "fiəfəli",
    "fearfulness": "fiəfəlnəs",
    "fearing": "fiərɪŋ",
    "fearless": "fiələs",
    "fearlessly": "fiələsli",
    "fearlessness": "fiələsnəs",
    "fears": "fiəz",
    "fearsome": "fiəsʌm",
    "fearsomely": "fiəsʌmli",
    "feasibility": "fiːzəbɪlɪti",
    "feasible": "fiːzəbəl",
    "feasibly": "fiːzəbli",
    "feasted": "fiːstɪd",
    "feast": "fiːst",
    "feasting": "fiːstɪŋ",
    "feasts": "fiːsts",
    "feat": "fiːt",
    "featherbed": "fɛðəbɛd",
    "featherbrain": "fɛðəbreɪn",
    "feathered": "fɛðəd",
    "feather": "fɛðɐ",
    "featherhead": "fɛðəhɛd",
    "feathering": "fɛðərɪŋ",
    "featherless": "fɛðələs",
    "featherlight": "fɛðəlaɪt",
    "feathers": "fɛðəz",
    "featherweight": "fɛðəweɪt",
    "featherweights": "fɛðəweɪts",
    "feathery": "fɛðəri",
    "feats": "fiːts",
    "featured": "fiːtʃəd",
    "feature": "fiːtʃɐ",
    "featureless": "fiːtʃələs",
    "features": "fiːtʃəz",
    "featuring": "fiːtʃərɪŋ",
    "febrile": "fɛbraɪl",
    "fecit": "fɛsɪt",
    "feck": "fɛk",
    "feckless": "fɛkləs",
    "fecklessness": "fɛkləsnəs",
    "fecund": "fɛkʌnd",
    "fecundity": "fɛkʌndɪti",
    "federal": "fɛdərəl",
    "federalising": "fɛdərəlaɪzɪŋ",
    "federalism": "fɛdərəlɪzəm",
    "federalist": "fɛdərəlɪst",
    "federalists": "fɛdərəlɪsts",
    "federally": "fɛdərəli",
    "federals": "fɛdərəlz",
    "federated": "fɛdəreɪtɪd",
    "federate": "fɛdərət",
    "federation": "fɛdəreɪʃən",
    "federations": "fɛdəreɪʃənz",
    "fed": "fɛd",
    "fedora": "fɪdɔːrɐ",
    "feds": "fɛdz",
    "feeble": "fiːbəl",
    "feebleness": "fiːbəlnəs",
    "feeblest": "fiːbləst",
    "feebly": "fiːbli",
    "feedback": "fiːdbæk",
    "feedbag": "fiːdbæɡ",
    "feeder": "fiːdɐ",
    "feeders": "fiːdəz",
    "feed": "fiːd",
    "feeding": "fiːdɪŋ",
    "feedings": "fiːdɪŋz",
    "feeds": "fiːdz",
    "feedstuffs": "fiːdstʌfs",
    "fee": "fiː",
    "feeler": "fiːlɐ",
    "feelers": "fiːləz",
    "feel": "fiːl",
    "feelgood": "fiːlɡʊd",
    "feeling": "fiːlɪŋ",
    "feelingly": "fiːlɪŋli",
    "feelings": "fiːlɪŋz",
    "feels": "fiːlz",
    "fees": "fiːz",
    "feet": "fiːt",
    "f": "ɛf",
    "feigned": "feɪnd",
    "feign": "feɪn",
    "feigning": "feɪnɪŋ",
    "feigns": "feɪnz",
    "feint": "feɪnt",
    "feinting": "feɪntɪŋ",
    "feistier": "faɪstiɐ",
    "feistiest": "faɪstiəst",
    "feistiness": "faɪstinəs",
    "feisty": "faɪsti",
    "feldspar": "fɛldspɑː",
    "felicitations": "fɛlɪsɪteɪʃənz",
    "felicitous": "fɛlɪsɪtəs",
    "felicitously": "fɛlɪsɪtəsli",
    "felicity": "fɛlɪsɪti",
    "feline": "fiːlaɪn",
    "felines": "fiːlaɪnz",
    "fella": "fɛlɐ",
    "fellah": "fɛlɐ",
    "fellas": "fɛləz",
    "fellatio": "fɛleɪʃɪəʊ",
    "felled": "fɛld",
    "feller": "fɛlɐ",
    "fellers": "fɛləz",
    "fell": "fɛl",
    "felling": "fɛlɪŋ",
    "fellow": "fɛləʊ",
    "fellows": "fɛləʊz",
    "fellowship": "fɛləʊʃɪp",
    "fellowships": "fɛləʊʃɪps",
    "fells": "fɛlz",
    "felon": "fɛlən",
    "felonies": "fɛlənɪz",
    "felonious": "fɛləʊnɪəs",
    "felons": "fɛlənz",
    "felony": "fɛləni",
    "felted": "fɛltɪd",
    "felt": "fɛlt",
    "felting": "fɛltɪŋ",
    "felts": "fɛlts",
    "felucca": "fɛlʌkɐ",
    "female": "fiːmeɪl",
    "femaleness": "fiːmeɪlnəs",
    "females": "fiːmeɪlz",
    "feminine": "fɛmənɪn",
    "femininity": "fɛmɪnɪnɪti",
    "feminisation": "fɛmɪnaɪzeɪʃən",
    "feminised": "fɛmɪnaɪzd",
    "feminise": "fɛmɪnaɪz",
    "feminising": "fɛmɪnaɪzɪŋ",
    "feminism": "fɛmɪnɪzəm",
    "feminist": "fɛmɪnɪst",
    "feminists": "fɛmɪnɪsts",
    "femme": "fɛm",
    "femora": "fɛmɔːrɐ",
    "femoral": "fɛmərəl",
    "femur": "fiːmɐ",
    "femurs": "fiːməz",
    "fenced": "fɛnst",
    "fence": "fɛns",
    "fencer": "fɛnsɐ",
    "fencers": "fɛnsəz",
    "fences": "fɛnsɪz",
    "fencing": "fɛnsɪŋ",
    "fended": "fɛndɪd",
    "fender": "fɛndɐ",
    "fenders": "fɛndəz",
    "fend": "fɛnd",
    "fending": "fɛndɪŋ",
    "fends": "fɛndz",
    "fenestra": "fɛnɛstrɐ",
    "fenestration": "fɛnɪstreɪʃən",
    "fenland": "fɛnlənd",
    "fennec": "fɛnɛk",
    "fennel": "fɛnəl",
    "fenny": "fɛni",
    "fens": "fɛnz",
    "fenugreek": "fɛnəɡriːk",
    "feral": "fɛrəl",
    "fer": "fɜː",
    "feria": "fiərɪɐ",
    "ferial": "fiərɪəl",
    "fermentation": "fɜːmɪnteɪʃən",
    "fermented": "fɜːmɛntɪd",
    "fermenting": "fɜːmɛntɪŋ",
    "fermi": "fɜːmi",
    "fermions": "fɜːmiənz",
    "fermium": "fɜːmiəm",
    "fernery": "fɜːnəri",
    "fern": "fɜːn",
    "ferns": "fɜːnz",
    "ferny": "fɜːni",
    "ferocious": "fərəʊʃəs",
    "ferociously": "fərəʊʃəsli",
    "ferocity": "fərɒsɪti",
    "ferreted": "fɛrɪtɪd",
    "ferret": "fɛrɪt",
    "ferreting": "fɛrɪtɪŋ",
    "ferrets": "fɛrɪts",
    "ferric": "fɛrɪk",
    "ferried": "fɛrɪd",
    "ferries": "fɛrɪz",
    "ferrite": "fɛraɪt",
    "ferritin": "fɛrɪtɪn",
    "ferromagnetic": "fɛrəmɐɡnɛtɪk",
    "ferrous": "fɛrəs",
    "ferrule": "fɛruːl",
    "ferrules": "fɛruːlz",
    "ferryboat": "fɛrɪbəʊt",
    "ferry": "fɛri",
    "ferrying": "fɛrɪɪŋ",
    "ferryman": "fɛrɪmən",
    "ferrymen": "fɛrɪmɛn",
    "fertile": "fɜːtaɪl",
    "fertilisation": "fɜːtɪlaɪzeɪʃən",
    "fertilised": "fɜːtəlaɪzd",
    "fertilise": "fɜːtəlaɪz",
    "fertiliser": "fɜːtəlaɪzɐ",
    "fertilisers": "fɜːtəlaɪzəz",
    "fertilises": "fɜːtəlaɪzɪz",
    "fertilising": "fɜːtəlaɪzɪŋ",
    "fertility": "fɜːtɪlɪti",
    "fervent": "fɜːvənt",
    "fervently": "fɜːvəntli",
    "fervour": "fɜːvɐ",
    "fescue": "fɛskjuː",
    "fessed": "fɛst",
    "fesses": "fɛsɪz",
    "fess": "fɛs",
    "fessing": "fɛsɪŋ",
    "festered": "fɛstəd",
    "fester": "fɛstɐ",
    "festering": "fɛstərɪŋ",
    "festers": "fɛstəz",
    "fest": "fɛst",
    "festival": "fɛstɪvəl",
    "festivals": "fɛstɪvəlz",
    "festive": "fɛstɪv",
    "festivities": "fɛstɪvɪtiz",
    "festivity": "fɛstɪvɪti",
    "festooned": "fɛstuːnd",
    "festoon": "fɛstuːn",
    "festoons": "fɛstuːnz",
    "fests": "fɛsts",
    "feta": "fiːtɐ",
    "fetched": "fɛtʃt",
    "fetcher": "fɛtʃɐ",
    "fetches": "fɛtʃɪz",
    "fetch": "fɛtʃ",
    "fetching": "fɛtʃɪŋ",
    "feted": "feɪtɪd",
    "fetid": "fɛtɪd",
    "feting": "feɪtɪŋ",
    "fetishes": "fɛtɪʃɪz",
    "fetish": "fɛtɪʃ",
    "fetishism": "fɛtɪʃɪzəm",
    "fetishist": "fɛtɪʃɪst",
    "fetishistic": "fɛtɪʃɪstɪk",
    "fetishists": "fɛtɪʃɪsts",
    "fetlock": "fɛtlɒk",
    "fetlocks": "fɛtlɒks",
    "fettered": "fɛtəd",
    "fetter": "fɛtɐ",
    "fetters": "fɛtəz",
    "fettle": "fɛtəl",
    "fettling": "fɛtlɪŋ",
    "fettuccine": "fɛtuːtʃiːn",
    "fetus": "fiːtəs",
    "feudal": "fjuːdəl",
    "feudalism": "fjuːdəlɪzəm",
    "feuded": "fjuːdɪd",
    "feud": "fjuːd",
    "feuding": "fjuːdɪŋ",
    "feuds": "fjuːdz",
    "feu": "fjuː",
    "fevered": "fiːvəd",
    "feverfew": "fiːvəfjuː",
    "fever": "fiːvɐ",
    "feverish": "fiːvərɪʃ",
    "feverishly": "fiːvərɪʃli",
    "fevers": "fiːvəz",
    "fewer": "fjuːɐ",
    "fewest": "fjuːəst",
    "few": "fjuː",
    "fey": "feɪ",
    "fezes": "fɛzɪz",
    "fez": "fɛz",
    "fezzes": "fɛzɪz",
    "fiascos": "fiːæskəʊz",
    "fiat": "fiːət",
    "fiats": "fiːəts",
    "fibbed": "fɪbd",
    "fibber": "fɪbɐ",
    "fibbers": "fɪbəz",
    "fibbing": "fɪbɪŋ",
    "fib": "fɪb",
    "fibreboard": "faɪbrɪbɔːd",
    "fibre": "faɪbɐ",
    "fibreglass": "faɪbrɪɡlɑːs",
    "fibres": "faɪbəz",
    "fibrillated": "fɪbrɪleɪtɪd",
    "fibrillating": "fɪbrɪleɪtɪŋ",
    "fibrillation": "fɪbrɪleɪʃən",
    "fibrils": "fɪbrəlz",
    "fibrin": "fɪbrɪn",
    "fibroid": "fɪbrɔɪd",
    "fibrosis": "fɪbrəʊsɪs",
    "fibrous": "fɪbrəs",
    "fibs": "fɪbz",
    "fibula": "fɪbjʊlɐ",
    "fibular": "fɪbjʊlɐ",
    "fiche": "fiːʃ",
    "fickle": "fɪkəl",
    "fickleness": "fɪkəlnəs",
    "fictional": "fɪkʃənəl",
    "fictionalisation": "fɪkʃənəlaɪzeɪʃən",
    "fictionalised": "fɪkʃənəlaɪzd",
    "fictionalise": "fɪkʃənəlaɪz",
    "fictionalises": "fɪkʃənəlaɪzɪz",
    "fictionalising": "fɪkʃənəlaɪzɪŋ",
    "fictionally": "fɪkʃənəli",
    "fiction": "fɪkʃən",
    "fictions": "fɪkʃənz",
    "fictitious": "fɪktɪʃəs",
    "ficus": "faɪkəs",
    "fiddled": "fɪdəld",
    "fiddle": "fɪdəl",
    "fiddler": "fɪdlɐ",
    "fiddlers": "fɪdləz",
    "fiddles": "fɪdəlz",
    "fiddlesticks": "fɪdəlstɪks",
    "fiddliest": "fɪdliəst",
    "fiddling": "fɪdlɪŋ",
    "fiddly": "fɪdli",
    "fidelity": "fɪdɛlɪti",
    "fid": "fɪd",
    "fidge": "fɪdʒ",
    "fidgeted": "fɪdʒɪtɪd",
    "fidget": "fɪdʒɪt",
    "fidgeting": "fɪdʒɪtɪŋ",
    "fidgets": "fɪdʒɪts",
    "fidgety": "fɪdʒɪti",
    "fiduciary": "fɪdjuːʃəri",
    "fie": "faɪ",
    "fiefdom": "fiːfdəm",
    "fiefdoms": "fiːfdəmz",
    "fief": "fiːf",
    "fielded": "fiːldɪd",
    "fielder": "fiːldɐ",
    "fielders": "fiːldəz",
    "fieldfare": "fiːldfeə",
    "fieldfares": "fiːldfeəz",
    "field": "fiːld",
    "fielding": "fiːldɪŋ",
    "fieldings": "fiːldɪŋz",
    "fields": "fiːldz",
    "fieldsman": "fiːldzmən",
    "fieldsmen": "fiːldzmɛn",
    "fieldwork": "fiːldwɜːk",
    "fiend": "fiːnd",
    "fiendish": "fiːndɪʃ",
    "fiendishly": "fiːndɪʃli",
    "fiends": "fiːndz",
    "fierce": "fiəs",
    "fiercely": "fiəsli",
    "fierceness": "fiəsnəs",
    "fiercer": "fiəsɐ",
    "fiercest": "fiəsəst",
    "fierier": "faɪərɪɐ",
    "fieriest": "faɪərɪəst",
    "fieriness": "faɪərɪnəs",
    "fiery": "faɪəri",
    "fiesta": "fiːɛstɐ",
    "fiestas": "fiːɛstəz",
    "fife": "faɪf",
    "fifer": "faɪfɐ",
    "fifers": "faɪfəz",
    "fifes": "faɪfs",
    "fifteen": "fɪftiːn",
    "fifteens": "fɪftiːnz",
    "fifteenth": "fɪftiːnθ",
    "fifth": "fɪfθ",
    "fifthly": "fɪfθli",
    "fifths": "fɪfθs",
    "fifties": "fɪftɪz",
    "fiftieth": "fɪftiəθ",
    "fifty": "fɪfti",
    "fig": "fɪɡ",
    "fightback": "faɪtbæk",
    "fighter": "faɪtɐ",
    "fighters": "faɪtəz",
    "fight": "faɪt",
    "fighting": "faɪtɪŋ",
    "fights": "faɪts",
    "figment": "fɪɡmənt",
    "figments": "fɪɡmənts",
    "figs": "fɪɡz",
    "figural": "fɪɡjʊrəl",
    "figuration": "fɪɡjʊreɪʃən",
    "figurative": "fɪɡjʊreɪtɪv",
    "figuratively": "fɪɡjʊreɪtɪvli",
    "figured": "fɪɡəd",
    "figure": "fɪɡɐ",
    "figurehead": "fɪɡəhɛd",
    "figureheads": "fɪɡjʊrɛhɛdz",
    "figurers": "fɪɡjʊrəz",
    "figures": "fɪɡəz",
    "figurine": "fɪɡjʊriːn",
    "figurines": "fɪɡjʊriːnz",
    "figuring": "fɪɡərɪŋ",
    "figwort": "fɪɡwɔːt",
    "fila": "fiːlɐ",
    "filament": "fɪləmənt",
    "filamentous": "fɪləmɛntəs",
    "filaments": "fɪləmənts",
    "filbert": "fɪlbət",
    "filberts": "fɪlbəts",
    "filched": "fɪltʃt",
    "filch": "fɪltʃ",
    "filching": "fɪltʃɪŋ",
    "filed": "faɪld",
    "filer": "faɪlɐ",
    "filers": "faɪləz",
    "files": "faɪlz",
    "filets": "fɪləts",
    "filial": "fɪlɪəl",
    "filibeg": "fɪlaɪbəɡ",
    "filibuster": "fɪlɪbʌstɐ",
    "filibustering": "fɪlɪbʌstərɪŋ",
    "filiform": "fɪlɪfɔːm",
    "filigree": "fɪlɪɡriː",
    "filing": "faɪlɪŋ",
    "filings": "faɪlɪŋz",
    "filled": "fɪld",
    "filler": "fɪlɐ",
    "fillers": "fɪləz",
    "filleted": "fɪliːtɪd",
    "filleter": "fɪlɛtɐ",
    "filleting": "fɪliːtɪŋ",
    "fillets": "fɪlɪts",
    "fill": "fɪl",
    "fillies": "fɪliz",
    "filling": "fɪlɪŋ",
    "fillings": "fɪlɪŋz",
    "fillip": "fɪlɪp",
    "fills": "fɪlz",
    "filly": "fɪli",
    "filmed": "fɪlmd",
    "film": "fɪlm",
    "filming": "fɪlmɪŋ",
    "filmmaker": "fɪlmeɪkɐ",
    "filmmakers": "fɪlmeɪkəz",
    "filmmaking": "fɪlmeɪkɪŋ",
    "filmography": "fɪlmɒɡrəfi",
    "films": "fɪlmz",
    "filmy": "fɪlmi",
    "filo": "faɪləʊ",
    "fils": "fɪlz",
    "filtered": "fɪltəd",
    "filter": "fɪltɐ",
    "filtering": "fɪltərɪŋ",
    "filters": "fɪltəz",
    "filth": "fɪlθ",
    "filthier": "fɪlθɪɐ",
    "filthiest": "fɪlθɪəst",
    "filthiness": "fɪlθɪnəs",
    "filthy": "fɪlθi",
    "filtration": "fɪltreɪʃən",
    "finable": "faɪnəbəl",
    "finagle": "fɪneɪɡəl",
    "finale": "fɪnɑːli",
    "finales": "fɪnɑːliz",
    "final": "faɪnəl",
    "finalisation": "faɪnəlaɪzeɪʃən",
    "finalised": "faɪnəlaɪzd",
    "finalise": "faɪnəlaɪz",
    "finalises": "faɪnəlaɪzɪz",
    "finalising": "faɪnəlaɪzɪŋ",
    "finalist": "faɪnəlɪst",
    "finalists": "faɪnəlɪsts",
    "finality": "faɪnælɪti",
    "finally": "faɪnəli",
    "finals": "faɪnəlz",
    "financed": "faɪnænst",
    "finance": "faɪnæns",
    "finances": "faɪnænsɪz",
    "financial": "faɪnænʃəl",
    "financially": "faɪnænʃəli",
    "financier": "faɪnænsɪɐ",
    "financiers": "faɪnænsiəz",
    "financing": "faɪnænsɪŋ",
    "finback": "fɪnbæk",
    "finches": "fɪntʃɪz",
    "finch": "fɪntʃ",
    "findable": "faɪndəbəl",
    "finder": "faɪndɐ",
    "finders": "faɪndəz",
    "find": "faɪnd",
    "finding": "faɪndɪŋ",
    "findings": "faɪndɪŋz",
    "finds": "faɪndz",
    "fined": "faɪnd",
    "finely": "faɪnli",
    "fineness": "faɪnnəs",
    "finer": "faɪnɐ",
    "finery": "faɪnəri",
    "fines": "faɪnz",
    "finessed": "fɪnɛst",
    "finesse": "fɪnɛs",
    "finesses": "fɪnɛsɪz",
    "finessing": "fɪnɛsɪŋ",
    "finest": "faɪnəst",
    "fin": "fɪn",
    "fingerboard": "fɪŋɡəbɔːd",
    "fingered": "fɪŋɡəd",
    "finger": "fɪŋɡɐ",
    "fingering": "fɪŋɡərɪŋ",
    "fingerings": "fɪŋɡərɪŋz",
    "fingerless": "fɪŋɡələs",
    "fingerling": "fɪŋɡɜːlɪŋ",
    "fingermarks": "fɪŋɡəmɑːks",
    "fingernail": "fɪŋɡəneɪl",
    "fingernails": "fɪŋɡəneɪlz",
    "fingerprinted": "fɪŋɡəprɪntɪd",
    "fingerprint": "fɪŋɡəprɪnt",
    "fingerprinting": "fɪŋɡəprɪntɪŋ",
    "fingerprints": "fɪŋɡəprɪnts",
    "fingers": "fɪŋɡəz",
    "fingertip": "fɪŋɡətɪp",
    "fingertips": "fɪŋɡətɪps",
    "finial": "fɪnɪəl",
    "finials": "fɪnɪəlz",
    "finical": "fɪnɪkəl",
    "finicky": "fɪnɪki",
    "fining": "faɪnɪŋ",
    "finings": "faɪnɪŋz",
    "finis": "fɪniz",
    "finished": "fɪnɪʃt",
    "finisher": "fɪnɪʃɐ",
    "finishers": "fɪnɪʃəz",
    "finishes": "fɪnɪʃɪz",
    "finishing": "fɪnɪʃɪŋ",
    "finite": "faɪnaɪt",
    "fink": "fɪŋk",
    "finks": "fɪŋks",
    "finned": "fɪnd",
    "finny": "fɪni",
    "fino": "fiːnəʊ",
    "fins": "fɪnz",
    "fiords": "fiːɔːdz",
    "fipple": "fɪpəl",
    "firearm": "faɪərɑːm",
    "firearms": "faɪərɑːmz",
    "fireback": "faɪəbæk",
    "fireball": "faɪəbɔːl",
    "fireballs": "faɪəbɔːlz",
    "firebird": "faɪəbɜːd",
    "firebirds": "faɪəbɜːdz",
    "fireboat": "faɪəbəʊt",
    "firebombed": "faɪəbɒmd",
    "firebomb": "faɪəbɒm",
    "firebombing": "faɪəbɒmɪŋ",
    "firebombs": "faɪəbɒmz",
    "firebox": "faɪəbɒks",
    "firebrand": "faɪəbrænd",
    "firebrands": "faɪəbrændz",
    "firebreak": "faɪəbreɪk",
    "firebreaks": "faɪəbreɪks",
    "firecracker": "faɪəkrækɐ",
    "firecrackers": "faɪəkrækəz",
    "firedamp": "faɪədæmp",
    "fired": "faɪəd",
    "firedog": "faɪədɒɡ",
    "fire": "faɪə",
    "firefighter": "faɪəfaɪtɐ",
    "firefighters": "faɪəfaɪtəz",
    "firefight": "faɪəfaɪt",
    "firefighting": "faɪəfaɪtɪŋ",
    "firefights": "faɪəfaɪts",
    "fireflies": "faɪəflaɪz",
    "firefly": "faɪəflaɪ",
    "fireguard": "faɪəɡɑːd",
    "firehouse": "faɪəhaʊs",
    "firelighter": "faɪəlaɪtɐ",
    "firelighters": "faɪəlaɪtəz",
    "firelight": "faɪəlaɪt",
    "firelock": "faɪəlɒk",
    "fireman": "faɪəmən",
    "firemen": "faɪəmɛn",
    "fireplace": "faɪəpleɪs",
    "fireplaces": "faɪəpleɪsɪz",
    "fireplug": "faɪəplʌɡ",
    "firepower": "faɪəpaʊɐ",
    "fireproofed": "faɪəpruːft",
    "fireproof": "faɪəpruːf",
    "fireproofing": "faɪəpruːfɪŋ",
    "firer": "faɪərɐ",
    "firers": "faɪərəz",
    "fires": "faɪəz",
    "fireside": "faɪəsaɪd",
    "firesides": "faɪəsaɪdz",
    "firestone": "faɪəstəʊn",
    "firestorm": "faɪəstɔːm",
    "firestorms": "faɪəstɔːmz",
    "firetrap": "faɪətræp",
    "firewall": "faɪəwɔːl",
    "firewalls": "faɪəwɔːlz",
    "firewater": "faɪəwɔːtɐ",
    "fireweed": "faɪəwiːd",
    "firewood": "faɪəwʊd",
    "firework": "faɪəwɜːk",
    "fireworks": "faɪəwɜːks",
    "fir": "fɜː",
    "firing": "faɪərɪŋ",
    "firings": "faɪərɪŋz",
    "firkin": "fɜːkɪn",
    "firmament": "fɜːməmənt",
    "firmed": "fɜːmd",
    "firmer": "fɜːmɐ",
    "firmest": "fɜːməst",
    "firm": "fɜːm",
    "firming": "fɜːmɪŋ",
    "firmly": "fɜːmli",
    "firmness": "fɜːmnəs",
    "firms": "fɜːmz",
    "firmware": "fɜːmweə",
    "firn": "fɜːn",
    "firs": "fɜːz",
    "firstborn": "fɜːstbɔːn",
    "first": "fɜːst",
    "firsthand": "fɜːsthænd",
    "firstly": "fɜːstli",
    "firsts": "fɜːsts",
    "firth": "fɜːθ",
    "firths": "fɜːθs",
    "fiscal": "fɪskəl",
    "fiscally": "fɪskəli",
    "fishbowl": "fɪʃbəʊl",
    "fishbowls": "fɪʃbəʊlz",
    "fishcake": "fɪʃkeɪk",
    "fishcakes": "fɪʃkeɪks",
    "fished": "fɪʃt",
    "fisher": "fɪʃɐ",
    "fisheries": "fɪʃəriz",
    "fisherman": "fɪʃəmən",
    "fishermen": "fɪʃəmɛn",
    "fishers": "fɪʃəz",
    "fishery": "fɪʃəri",
    "fishes": "fɪʃɪz",
    "fisheye": "fɪʃaɪ",
    "fish": "fɪʃ",
    "fishhook": "fɪʃhʊk",
    "fishier": "fɪʃɪɐ",
    "fishiness": "fɪʃɪnəs",
    "fishing": "fɪʃɪŋ",
    "fishmeal": "fɪʃmiəl",
    "fishmonger": "fɪʃmʌŋɡɐ",
    "fishmongers": "fɪʃmʌŋɡəz",
    "fishnet": "fɪʃnɛt",
    "fishnets": "fɪʃnɛts",
    "fishplates": "fɪʃpleɪts",
    "fishpond": "fɪʃpɒnd",
    "fishponds": "fɪʃpɒndz",
    "fishtail": "fɪʃteɪl",
    "fishtailing": "fɪʃteɪlɪŋ",
    "fishtails": "fɪʃteɪlz",
    "fishwife": "fɪʃwaɪf",
    "fishwives": "fɪʃwaɪvz",
    "fishy": "fɪʃi",
    "fissile": "fɪsaɪl",
    "fissionable": "fɪʃənəbəl",
    "fission": "fɪʃən",
    "fissions": "fɪʃənz",
    "fissured": "fɪʃəd",
    "fissure": "fɪʃɐ",
    "fissures": "fɪʃəz",
    "fist": "fɪst",
    "fistful": "fɪstfəl",
    "fistfuls": "fɪstfəlz",
    "fisticuffs": "fɪstɪkʌfs",
    "fists": "fɪsts",
    "fistula": "fɪstjʊlɐ",
    "fistulas": "fɪstjʊləz",
    "fitch": "fɪtʃ",
    "fit": "fɪt",
    "fitful": "fɪtfəl",
    "fitfully": "fɪtfəli",
    "fitly": "fɪtli",
    "fitment": "fɪtmənt",
    "fitments": "fɪtmənts",
    "fitness": "fɪtnəs",
    "fits": "fɪts",
    "fitted": "fɪtɪd",
    "fitter": "fɪtɐ",
    "fitters": "fɪtəz",
    "fittest": "fɪtəst",
    "fitting": "fɪtɪŋ",
    "fittingly": "fɪtɪŋli",
    "fittings": "fɪtɪŋz",
    "five": "faɪv",
    "fivefold": "faɪvfəʊld",
    "fiver": "faɪvɐ",
    "fivers": "faɪvəz",
    "fives": "faɪvz",
    "fixable": "fɪksəbəl",
    "fixated": "fɪkseɪtɪd",
    "fixate": "fɪkseɪt",
    "fixating": "fɪkseɪtɪŋ",
    "fixation": "fɪkseɪʃən",
    "fixations": "fɪkseɪʃənz",
    "fixative": "fɪksətɪv",
    "fixed": "fɪkst",
    "fixedly": "fɪksɪdli",
    "fixer": "fɪksɐ",
    "fixers": "fɪksəz",
    "fixes": "fɪksɪz",
    "fix": "fɪks",
    "fixing": "fɪksɪŋ",
    "fixings": "fɪksɪŋz",
    "fixity": "fɪksɪti",
    "fixture": "fɪkstʃɐ",
    "fixtures": "fɪkstʃəz",
    "fizzed": "fɪzd",
    "fizzes": "fɪzɪz",
    "fizz": "fɪz",
    "fizzier": "fɪzɪɐ",
    "fizziest": "fɪzɪəst",
    "fizzing": "fɪzɪŋ",
    "fizzled": "fɪzəld",
    "fizzle": "fɪzəl",
    "fizzles": "fɪzəlz",
    "fizzling": "fɪzlɪŋ",
    "fizzy": "fɪzi",
    "fjord": "fɪɔːd",
    "fjords": "fɪɔːdz",
    "flabbergasted": "flæbəɡɑːstɪd",
    "flabbergasting": "flæbəɡɑːstɪŋ",
    "flabbergasts": "flæbəɡɑːsts",
    "flabbier": "flæbɪɐ",
    "flabbiness": "flæbɪnəs",
    "flabby": "flæbi",
    "flab": "flæb",
    "flaccid": "flæsɪd",
    "flaccidity": "flæsɪdɪti",
    "flack": "flæk",
    "flacks": "flæks",
    "flagella": "flædʒɛlɐ",
    "flagellant": "flædʒɛlənt",
    "flagellants": "flædʒɛlənts",
    "flagellate": "flædʒɪleɪt",
    "flagellating": "flædʒɪleɪtɪŋ",
    "flagellation": "flædʒɪleɪʃən",
    "flagellum": "flɐdʒɛləm",
    "flageolet": "fleɪdʒɒlət",
    "flag": "flæɡ",
    "flagged": "flæɡd",
    "flagger": "flæɡɐ",
    "flagging": "flæɡɪŋ",
    "flagon": "flæɡɒn",
    "flagons": "flæɡɒnz",
    "flagpole": "flæɡpəʊl",
    "flagpoles": "flæɡpəʊlz",
    "flagrant": "fleɪɡrənt",
    "flagrantly": "fleɪɡrəntli",
    "flags": "flæɡz",
    "flagship": "flæɡʃɪp",
    "flagships": "flæɡʃɪps",
    "flagstaff": "flæɡstɑːf",
    "flagstone": "flæɡstəʊn",
    "flagstones": "flæɡstəʊnz",
    "flailed": "fleɪld",
    "flail": "fleɪl",
    "flailing": "fleɪlɪŋ",
    "flails": "fleɪlz",
    "flair": "fleə",
    "flairs": "fleəz",
    "flaked": "fleɪkt",
    "flake": "fleɪk",
    "flakes": "fleɪks",
    "flakey": "fleɪki",
    "flak": "flæk",
    "flakiest": "fleɪkɪəst",
    "flakiness": "fleɪkɪnəs",
    "flaking": "fleɪkɪŋ",
    "flaky": "fleɪki",
    "flambeau": "flæmbəʊ",
    "flambeing": "flæmbiːɪŋ",
    "flamboyance": "flæmbɔɪəns",
    "flamboyancy": "flæmbɔɪənsi",
    "flamboyant": "flæmbɔɪənt",
    "flamboyantly": "flæmbɔɪəntli",
    "flamed": "fleɪmd",
    "flame": "fleɪm",
    "flamenco": "flɐmɛŋkəʊ",
    "flameproof": "fleɪmpruːf",
    "flames": "fleɪmz",
    "flamethrower": "fleɪmθrəʊɐ",
    "flamethrowers": "fleɪmθrəʊəz",
    "flam": "flæm",
    "flaming": "fleɪmɪŋ",
    "flamingoes": "flɛmɪŋɡəʊz",
    "flamingo": "flɛmɪŋɡəʊ",
    "flamingos": "flɛmɪŋɡəʊz",
    "flammability": "flæməbɪlɪti",
    "flammable": "flæməbəl",
    "flan": "flæn",
    "flanged": "flændʒd",
    "flange": "flændʒ",
    "flanges": "flændʒɪz",
    "flanked": "flæŋkt",
    "flanker": "flæŋkɐ",
    "flankers": "flæŋkəz",
    "flank": "flæŋk",
    "flanking": "flæŋkɪŋ",
    "flanks": "flæŋks",
    "flannelette": "flænɪlɛt",
    "flannel": "flænəl",
    "flannelled": "flænəld",
    "flannelling": "flænəlɪŋ",
    "flannels": "flænəlz",
    "flans": "flænz",
    "flap": "flæp",
    "flapjack": "flæpdʒæk",
    "flapjacks": "flæpdʒæks",
    "flapped": "flæpt",
    "flapper": "flæpɐ",
    "flappers": "flæpəz",
    "flapping": "flæpɪŋ",
    "flaps": "flæps",
    "flared": "fleəd",
    "flare": "fleə",
    "flares": "fleəz",
    "flaring": "fleərɪŋ",
    "flashback": "flæʃbæk",
    "flashbacks": "flæʃbæks",
    "flashbulb": "flæʃbʌlb",
    "flashbulbs": "flæʃbʌlbz",
    "flashcards": "flæʃkɑːdz",
    "flashed": "flæʃt",
    "flasher": "flæʃɐ",
    "flashers": "flæʃəz",
    "flashes": "flæʃɪz",
    "flash": "flæʃ",
    "flashier": "flæʃɪɐ",
    "flashiest": "flæʃɪəst",
    "flashily": "flæʃɪli",
    "flashing": "flæʃɪŋ",
    "flashlight": "flæʃlaɪt",
    "flashlights": "flæʃlaɪts",
    "flashover": "flæʃəʊvɐ",
    "flashpoint": "flæʃpɔɪnt",
    "flashpoints": "flæʃpɔɪnts",
    "flashy": "flæʃi",
    "flask": "flɑːsk",
    "flasks": "flɑːsks",
    "flatbed": "flætbɛd",
    "flatfish": "flætfɪʃ",
    "flat": "flæt",
    "flatfoot": "flætfʊt",
    "flathead": "flɑːthɛd",
    "flatiron": "flætaɪən",
    "flatland": "flætlənd",
    "flatlet": "flætlət",
    "flatly": "flætli",
    "flatmate": "flætmeɪt",
    "flatmates": "flætmeɪts",
    "flatness": "flætnəs",
    "flats": "flæts",
    "flatted": "flætɪd",
    "flattened": "flætənd",
    "flattener": "flætənɐ",
    "flatten": "flætən",
    "flattening": "flætənɪŋ",
    "flattens": "flætənz",
    "flattered": "flætəd",
    "flatterer": "flætərɐ",
    "flatterers": "flætərəz",
    "flatter": "flætɐ",
    "flattering": "flætərɪŋ",
    "flatters": "flætəz",
    "flattery": "flætəri",
    "flattest": "flætəst",
    "flattish": "flætɪʃ",
    "flatulence": "flætjʊləns",
    "flatulent": "flætjʊlənt",
    "flatus": "flætəs",
    "flatware": "flætweə",
    "flatworm": "flætwɜːm",
    "flatworms": "flætwɜːmz",
    "flaunted": "flɔːntɪd",
    "flaunt": "flɔːnt",
    "flaunting": "flɔːntɪŋ",
    "flaunts": "flɔːnts",
    "flautist": "flɔːtɪst",
    "flautists": "flɔːtɪsts",
    "flavin": "flævɪn",
    "flavor": "fleɪvɐ",
    "flavoured": "fleɪvəd",
    "flavour": "fleɪvɐ",
    "flavourful": "fleɪvəfəl",
    "flavouring": "fleɪvɜːrɪŋ",
    "flavourings": "fleɪvɜːrɪŋz",
    "flavourless": "fleɪvələs",
    "flavours": "fleɪvəz",
    "flavoursome": "fleɪvəsʌm",
    "flawed": "flɔːd",
    "flaw": "flɔː",
    "flawless": "flɔːləs",
    "flawlessly": "flɔːləsli",
    "flawlessness": "flɔːləsnəs",
    "flaws": "flɔːz",
    "flaxen": "flæksən",
    "flax": "flæks",
    "flaxseed": "flækssiːd",
    "flayed": "fleɪd",
    "flay": "fleɪ",
    "flaying": "fleɪɪŋ",
    "flays": "fleɪz",
    "fleabag": "fliːbæɡ",
    "fleabags": "fliːbæɡz",
    "fleabane": "fliːbeɪn",
    "fleabite": "fliːbaɪt",
    "flea": "fliː",
    "fleam": "fliːm",
    "fleapit": "fliːpɪt",
    "fleas": "fliːz",
    "flecked": "flɛkt",
    "fleck": "flɛk",
    "flecking": "flɛkɪŋ",
    "flecks": "flɛks",
    "fled": "flɛd",
    "fledged": "flɛdʒd",
    "fledge": "flɛdʒ",
    "fledgeling": "flɛdʒlɪŋ",
    "fledgelings": "flɛdʒlɪŋz",
    "fledges": "flɛdʒɪz",
    "fledging": "flɛdʒɪŋ",
    "fledgling": "flɛdʒlɪŋ",
    "fledglings": "flɛdʒlɪŋz",
    "fleeced": "fliːst",
    "fleece": "fliːs",
    "fleeces": "fliːsɪz",
    "fleecing": "fliːsɪŋ",
    "fleecy": "fliːsi",
    "flee": "fliː",
    "fleeing": "fliːɪŋ",
    "flees": "fliːz",
    "fleeter": "fliːtɐ",
    "fleetest": "fliːtəst",
    "fleet": "fliːt",
    "fleeting": "fliːtɪŋ",
    "fleetingly": "fliːtɪŋli",
    "fleetly": "fliːtli",
    "fleetness": "fliːtnəs",
    "fleets": "fliːts",
    "fleshed": "flɛʃt",
    "flesher": "flɛʃɐ",
    "fleshes": "flɛʃɪz",
    "flesh": "flɛʃ",
    "fleshier": "flɛʃɪɐ",
    "fleshiness": "flɛʃɪnəs",
    "fleshing": "flɛʃɪŋ",
    "fleshly": "flɛʃli",
    "fleshpots": "flɛʃpɒts",
    "fleshy": "flɛʃi",
    "fletcher": "flɛtʃɐ",
    "fletch": "flɛtʃ",
    "flew": "fluː",
    "flexed": "flɛkst",
    "flexes": "flɛksɪz",
    "flex": "flɛks",
    "flexibilities": "flɛksɪbɪlɪtiz",
    "flexibility": "flɛksɪbɪlɪti",
    "flexible": "flɛksɪbəl",
    "flexibly": "flɛksəbli",
    "flexing": "flɛksɪŋ",
    "flexion": "flɛkʃən",
    "flexitime": "flɛksɪtaɪm",
    "flexor": "flɛksɐ",
    "flexure": "flɛkʃɔː",
    "flibbertigibbet": "flɪbətɪdʒəbbɪt",
    "flicked": "flɪkt",
    "flickered": "flɪkəd",
    "flicker": "flɪkɐ",
    "flickering": "flɪkərɪŋ",
    "flickers": "flɪkəz",
    "flickery": "flɪkəri",
    "flick": "flɪk",
    "flicking": "flɪkɪŋ",
    "flicks": "flɪks",
    "flied": "flaɪd",
    "flier": "flaɪə",
    "fliers": "flaɪəz",
    "flies": "flaɪz",
    "flighted": "flaɪtɪd",
    "flight": "flaɪt",
    "flightiest": "flaɪtɪəst",
    "flightless": "flaɪtləs",
    "flightpath": "flaɪtpɑːθ",
    "flights": "flaɪts",
    "flighty": "flaɪti",
    "flimflam": "flɪmflæm",
    "flimsier": "flɪmzɪɐ",
    "flimsily": "flɪmzɪli",
    "flimsy": "flɪmzi",
    "flinched": "flɪntʃt",
    "flincher": "flɪntʃɐ",
    "flinches": "flɪntʃɪz",
    "flinch": "flɪntʃ",
    "flinching": "flɪntʃɪŋ",
    "flinders": "flɪndəz",
    "flinger": "flɪŋɡɐ",
    "fling": "flɪŋ",
    "flinging": "flɪŋɪŋ",
    "flings": "flɪŋz",
    "flint": "flɪnt",
    "flintiness": "flɪntɪnəs",
    "flintlock": "flɪntlɒk",
    "flintlocks": "flɪntlɒks",
    "flints": "flɪnts",
    "flinty": "flɪnti",
    "flip": "flɪp",
    "flippancy": "flɪpənsi",
    "flippant": "flɪpənt",
    "flippantly": "flɪpəntli",
    "flipped": "flɪpt",
    "flipper": "flɪpɐ",
    "flippers": "flɪpəz",
    "flipping": "flɪpɪŋ",
    "flips": "flɪps",
    "flirtation": "flɜːteɪʃən",
    "flirtations": "flɜːteɪʃənz",
    "flirtatious": "flɜːteɪʃəs",
    "flirtatiousness": "flɜːteɪʃəsnəs",
    "flirted": "flɜːtɪd",
    "flirt": "flɜːt",
    "flirting": "flɜːtɪŋ",
    "flirts": "flɜːts",
    "flirty": "flɜːti",
    "flitches": "flɪtʃɪz",
    "flitch": "flɪtʃ",
    "flite": "flaɪt",
    "flit": "flɪt",
    "flits": "flɪts",
    "flitted": "flɪtɪd",
    "flitter": "flɪtɐ",
    "flittering": "flɪtərɪŋ",
    "flitters": "flɪtəz",
    "flitting": "flɪtɪŋ",
    "flivver": "flɪvɐ",
    "floatation": "fləʊteɪʃən",
    "floated": "fləʊtɪd",
    "floater": "fləʊtɐ",
    "floaters": "fləʊtəz",
    "float": "fləʊt",
    "floating": "fləʊtɪŋ",
    "floats": "fləʊts",
    "floaty": "fləʊti",
    "floccinaucinihilipilification": "flɒksɪnɔːsɪnaɪəlɪpɪlɪfɪkeɪʃən",
    "flocked": "flɒkt",
    "flock": "flɒk",
    "flocking": "flɒkɪŋ",
    "flocks": "flɒks",
    "floe": "fləʊ",
    "floes": "fləʊz",
    "flog": "flɒɡ",
    "flogged": "flɒɡd",
    "flogger": "flɒɡɐ",
    "floggers": "flɒɡəz",
    "flogging": "flɒɡɪŋ",
    "floggings": "flɒɡɪŋz",
    "flogs": "flɒɡz",
    "flong": "flɒŋ",
    "flooded": "flʌdɪd",
    "flood": "flʌd",
    "floodgate": "flʌdɡeɪt",
    "floodgates": "flʌdɡeɪts",
    "flooding": "flʌdɪŋ",
    "floodings": "flʌdɪŋz",
    "floodlight": "flʌdlaɪt",
    "floodlighting": "flʌdlaɪtɪŋ",
    "floodlights": "flʌdlaɪts",
    "floodlit": "flʌdlɪt",
    "floodplain": "flʌdpleɪn",
    "floodplains": "flʌdpleɪnz",
    "floods": "flʌdz",
    "floodwater": "flʌdwɔːtɐ",
    "floorboard": "flɔːbɔːd",
    "floorboards": "flɔːbɔːdz",
    "floored": "flɔːd",
    "floor": "flɔː",
    "flooring": "flɔːrɪŋ",
    "floors": "flɔːz",
    "floorshow": "flɔːʃəʊ",
    "floorwalker": "flɔːwɔːkɐ",
    "floozie": "fluːzi",
    "floozies": "fluːzɪz",
    "floozy": "fluːzi",
    "flop": "flɒp",
    "flopped": "flɒpt",
    "flopper": "flɒpɐ",
    "floppier": "flɒpɪɐ",
    "floppiness": "flɒpɪnəs",
    "flopping": "flɒpɪŋ",
    "floppy": "flɒpi",
    "flops": "flɒps",
    "flora": "flɔːrɐ",
    "floral": "flɔːrəl",
    "florally": "flɔːrəli",
    "florescent": "flərɛsənt",
    "floret": "flɒrət",
    "florets": "flɒrəts",
    "floribunda": "flɒrɪbʌndɐ",
    "florid": "flɒrɪd",
    "florilegium": "flɒraɪldʒəm",
    "florin": "flɒrɪn",
    "florins": "flɒrɪnz",
    "florist": "flɒrɪst",
    "florists": "flɒrɪsts",
    "flory": "flɔːri",
    "flossed": "flɒst",
    "floss": "flɒs",
    "flossing": "flɒsɪŋ",
    "flossy": "flɒsi",
    "flotation": "fləʊteɪʃən",
    "flotations": "fləʊteɪʃənz",
    "flotilla": "flətɪlɐ",
    "flotillas": "flətɪləz",
    "flotsam": "flɒtsəm",
    "flounced": "flaʊnst",
    "flounce": "flaʊns",
    "flounces": "flaʊnsɪz",
    "flouncing": "flaʊnsɪŋ",
    "flouncy": "flaʊnsi",
    "floundered": "flaʊndəd",
    "flounder": "flaʊndɐ",
    "floundering": "flaʊndərɪŋ",
    "flounders": "flaʊndəz",
    "floured": "flaʊəd",
    "flour": "flaʊə",
    "flouring": "flaʊərɪŋ",
    "flourished": "flʌrɪʃt",
    "flourishes": "flʌrɪʃɪz",
    "flourish": "flʌrɪʃ",
    "flourishing": "flʌrɪʃɪŋ",
    "flours": "flaʊəz",
    "floury": "flaʊəri",
    "flouted": "flaʊtɪd",
    "flout": "flaʊt",
    "flouting": "flaʊtɪŋ",
    "flowchart": "fləʊtʃɑːt",
    "flowed": "fləʊd",
    "flower": "flaʊə",
    "flowers": "flaʊəz",
    "flowerbed": "flaʊəbɛd",
    "flowerbeds": "flaʊəbɛdz",
    "flowered": "flaʊəd",
    "flowerer": "flaʊərɐ",
    "flowering": "flaʊərɪŋ",
    "flowerpot": "flaʊəpɒt",
    "flowerpots": "flaʊəpɒts",
    "flowery": "flaʊəri",
    "flow": "fləʊ",
    "flowing": "fləʊɪŋ",
    "flowingly": "fləʊɪŋli",
    "flown": "fləʊn",
    "flows": "fləʊz",
    "flubbed": "flʌbd",
    "flubbing": "flʌbɪŋ",
    "flub": "flʌb",
    "fluctuated": "flʌktʃuːeɪtɪd",
    "fluctuate": "flʌktʃuːeɪt",
    "fluctuates": "flʌktʃuːeɪts",
    "fluctuating": "flʌktʃuːeɪtɪŋ",
    "fluctuation": "flʌktʃuːeɪʃən",
    "fluctuations": "flʌktʃuːeɪʃənz",
    "flue": "fluː",
    "fluency": "fluːənsi",
    "fluent": "fluːənt",
    "fluently": "fluːəntli",
    "flues": "fluːz",
    "fluffed": "flʌft",
    "fluff": "flʌf",
    "fluffier": "flʌfɪɐ",
    "fluffiest": "flʌfɪəst",
    "fluffiness": "flʌfɪnəs",
    "fluffing": "flʌfɪŋ",
    "fluffs": "flʌfs",
    "fluffy": "flʌfi",
    "flu": "fluː",
    "flugelhorn": "fluːɡəlhɔːn",
    "fluid": "fluːɪd",
    "fluidity": "fluːɪdɪti",
    "fluidly": "fluːɪdli",
    "fluids": "fluːɪdz",
    "fluke": "fluːk",
    "flukes": "fluːks",
    "flukey": "fluːki",
    "flukiest": "flʌkɪəst",
    "fluky": "flʌki",
    "flume": "fluːm",
    "flumes": "fluːmz",
    "flummery": "flʌməri",
    "flummoxed": "flʌmɒkst",
    "flummox": "flʌmɒks",
    "flump": "flʌmp",
    "flumping": "flʌmpɪŋ",
    "flumps": "flʌmps",
    "flung": "flʌŋ",
    "flunked": "flʌŋkt",
    "flunkey": "flʌŋki",
    "flunk": "flʌŋk",
    "flunkies": "flʌŋkiz",
    "flunking": "flʌŋkɪŋ",
    "flunks": "flʌŋks",
    "flunky": "flʌŋki",
    "fluoresce": "flɔːrɛs",
    "fluorescein": "flɔːrɪsiːn",
    "fluorescence": "flɔːrɛsəns",
    "fluorescent": "flɔːrɛsənt",
    "fluorescing": "flɔːrɛsɪŋ",
    "fluoridated": "flɔːrɪdeɪtɪd",
    "fluoridation": "flɔːrɪdeɪʃən",
    "fluoride": "flɔːraɪd",
    "fluorides": "flɔːraɪdz",
    "fluorine": "flɔːriːn",
    "fluorite": "flɔːraɪt",
    "fluorocarbon": "flɔːrəkɑːbən",
    "fluorocarbons": "flɔːrəkɑːbənz",
    "fluorometer": "flɔːrɒmɪtɐ",
    "fluorspar": "flɔːspɑː",
    "flurried": "flʌrɪd",
    "flurries": "flʌrɪz",
    "flurry": "flʌri",
    "flushed": "flʌʃt",
    "flusher": "flʌʃɐ",
    "flushes": "flʌʃɪz",
    "flush": "flʌʃ",
    "flushing": "flʌʃɪŋ",
    "flustered": "flʌstəd",
    "fluster": "flʌstɐ",
    "fluted": "fluːtɪd",
    "flute": "fluːt",
    "flutes": "fluːts",
    "fluting": "fluːtɪŋ",
    "fluttered": "flʌtəd",
    "flutter": "flʌtɐ",
    "fluttering": "flʌtərɪŋ",
    "flutters": "flʌtəz",
    "fluttery": "flʌtəri",
    "fluty": "fljuːti",
    "fluvial": "fluːvɪəl",
    "fluxes": "flʌksɪz",
    "flux": "flʌks",
    "fluxions": "flʌkʃənz",
    "flyable": "flɪeɪbəl",
    "flyaway": "flaɪəweɪ",
    "flyby": "flaɪbaɪ",
    "flycatcher": "flaɪkætʃɐ",
    "flycatchers": "flaɪkætʃəz",
    "flyer": "flaɪɐ",
    "flyers": "flaɪəz",
    "fly": "flaɪ",
    "flying": "flaɪɪŋ",
    "flyleaf": "flaɪliːf",
    "flyover": "flaɪəʊvɐ",
    "flyovers": "flaɪəʊvəz",
    "flypaper": "flaɪpeɪpɐ",
    "flypast": "flaɪpɑːst",
    "flysheet": "flaɪʃiːt",
    "flyte": "flaɪt",
    "flytrap": "flaɪtræp",
    "flytraps": "flaɪtræps",
    "flyway": "flaɪweɪ",
    "flyways": "flaɪweɪz",
    "flyweight": "flaɪweɪt",
    "flyweights": "flaɪweɪts",
    "flywheel": "flaɪwiːl",
    "foaled": "fəʊld",
    "foal": "fəʊl",
    "foaling": "fəʊlɪŋ",
    "foals": "fəʊlz",
    "foamed": "fəʊmd",
    "foam": "fəʊm",
    "foamier": "fəʊmɪɐ",
    "foaming": "fəʊmɪŋ",
    "foams": "fəʊmz",
    "foamy": "fəʊmi",
    "fobbed": "fɒbd",
    "fobbing": "fɒbɪŋ",
    "fob": "fɒb",
    "fobs": "fɒbz",
    "focaccia": "fəʊkæksiə",
    "focal": "fəʊkəl",
    "foci": "fəʊsaɪ",
    "focused": "fəʊkəsd",
    "focuses": "fəʊkəsɪz",
    "focus": "fəʊkəs",
    "focusing": "fəʊkəsɪŋ",
    "focussed": "fəʊkəszt",
    "focussing": "fəʊkəszɪŋ",
    "fodder": "fɒdɐ",
    "foe": "fəʊ",
    "foes": "fəʊz",
    "foetal": "fiːtəl",
    "foetuses": "fiːtəsɪz",
    "foetus": "fiːtəs",
    "fogbound": "fɒɡbaʊnd",
    "fogey": "fəʊdʒi",
    "fogeys": "fəʊdʒɪz",
    "fog": "fɒɡ",
    "fogged": "fɒɡd",
    "foggiest": "fɒɡɪəst",
    "fogging": "fɒɡɪŋ",
    "foggy": "fɒɡi",
    "foghorn": "fɒɡhɔːn",
    "foghorns": "fɒɡhɔːnz",
    "fogies": "fəʊɡɪz",
    "fogs": "fɒɡz",
    "foibles": "fɔɪbəlz",
    "foiled": "fɔɪld",
    "foil": "fɔɪl",
    "foiling": "fɔɪlɪŋ",
    "foils": "fɔɪlz",
    "foisted": "fɔɪstɪd",
    "foist": "fɔɪst",
    "foisting": "fɔɪstɪŋ",
    "foists": "fɔɪsts",
    "foldable": "fəʊldəbəl",
    "foldaway": "fəʊldəweɪ",
    "folded": "fəʊldɪd",
    "folder": "fəʊldɐ",
    "folders": "fəʊldəz",
    "fold": "fəʊld",
    "folding": "fəʊldɪŋ",
    "folds": "fəʊldz",
    "folia": "fəʊliɐ",
    "foliage": "fəʊlɪɪdʒ",
    "foliar": "fəʊliə",
    "foliate": "fəʊlɪeɪt",
    "folie": "fəʊli",
    "folio": "fəʊlɪəʊ",
    "folios": "fəʊlɪəʊz",
    "folk": "fəʊk",
    "folklore": "fəʊklɔː",
    "folkloric": "fəʊklɒrɪk",
    "folklorist": "fəʊklɔːrɪst",
    "folklorists": "fəʊklɔːrɪsts",
    "folks": "fəʊks",
    "folksiness": "fəʊksɪnəs",
    "folksong": "fəʊksɒŋ",
    "folksy": "fəʊksi",
    "folktale": "fəʊkteɪl",
    "follicle": "fɒlɪkəl",
    "follicles": "fɒlɪkəlz",
    "follicular": "fəlɪkjʊlɐ",
    "follies": "fɒliz",
    "followed": "fɒləʊd",
    "follower": "fɒləʊɐ",
    "followers": "fɒləʊəz",
    "follow": "fɒləʊ",
    "following": "fɒləʊɪŋ",
    "followings": "fɒləʊɪŋz",
    "follows": "fɒləʊz",
    "followup": "fɒləʊʌp",
    "folly": "fɒli",
    "fomented": "fəʊməntɪd",
    "foment": "fəʊmənt",
    "fomenting": "fəʊməntɪŋ",
    "fondant": "fɒndənt",
    "fondants": "fɒndənts",
    "fonder": "fɒndɐ",
    "fondest": "fɒndəst",
    "fond": "fɒnd",
    "fondled": "fɒndəld",
    "fondle": "fɒndəl",
    "fondles": "fɒndəlz",
    "fondling": "fɒndlɪŋ",
    "fondly": "fɒndli",
    "fondness": "fɒndnəs",
    "fondue": "fɒndjuː",
    "fondu": "fɒnduː",
    "fontanelle": "fɒnteɪnəl",
    "font": "fɒnt",
    "fonts": "fɒnts",
    "food": "fuːd",
    "foodie": "fuːdi",
    "foodies": "fuːdɪz",
    "foods": "fuːdz",
    "foodstuff": "fuːdstʌf",
    "foodstuffs": "fuːdstʌfs",
    "fooled": "fuːld",
    "foolery": "fuːləri",
    "fool": "fuːl",
    "foolhardiness": "fuːlhɑːdɪnəs",
    "foolhardy": "fuːlhɑːdi",
    "fooling": "fuːlɪŋ",
    "foolish": "fuːlɪʃ",
    "foolishly": "fuːlɪʃli",
    "foolishness": "fuːlɪʃnəs",
    "foolproof": "fuːlpruːf",
    "foolscap": "fuːlskæp",
    "fools": "fuːlz",
    "footage": "fʊtɪdʒ",
    "footballer": "fʊtbɔːlɐ",
    "footballers": "fʊtbɔːləz",
    "football": "fʊtbɔːl",
    "footballing": "fʊtbɔːlɪŋ",
    "footballs": "fʊtbɔːlz",
    "footboard": "fʊtbɔːd",
    "footbridge": "fʊtbrɪdʒ",
    "footed": "fʊtɪd",
    "footer": "fʊtɐ",
    "footers": "fʊtəz",
    "footfall": "fʊtfɔːl",
    "footfalls": "fʊtfɔːlz",
    "foot": "fʊt",
    "footgear": "fʊtɡiə",
    "foothills": "fʊthɪlz",
    "foothold": "fʊthəʊld",
    "footholds": "fʊthəʊldz",
    "footie": "fʊti",
    "footing": "fʊtɪŋ",
    "footings": "fʊtɪŋz",
    "footle": "fʊtəl",
    "footless": "fʊtləs",
    "footlight": "fʊtlaɪt",
    "footlights": "fʊtlaɪts",
    "footlocker": "fʊtlɒkɐ",
    "footloose": "fʊtluːs",
    "footman": "fʊtmən",
    "footmark": "fʊtmɑːk",
    "footmarks": "fʊtmɑːks",
    "footmen": "fʊtmɛn",
    "footnote": "fʊtnəʊt",
    "footnotes": "fʊtnəʊts",
    "footpads": "fʊtpædz",
    "footpath": "fʊtpɑːθ",
    "footpaths": "fʊtpɑːθs",
    "footplate": "fʊtpleɪt",
    "footprint": "fʊtprɪnt",
    "footprints": "fʊtprɪnts",
    "footrest": "fʊtrɛst",
    "footrests": "fʊtrɛsts",
    "foots": "fʊts",
    "footsie": "fʊtsi",
    "footsies": "fʊtsɪz",
    "footsore": "fʊtsɔː",
    "footstep": "fʊtstɛp",
    "footsteps": "fʊtstɛps",
    "footstool": "fʊtstuːl",
    "footstools": "fʊtstuːlz",
    "footway": "fʊtweɪ",
    "footwear": "fʊtweə",
    "footwork": "fʊtwɜːk",
    "footy": "fʊti",
    "fop": "fɒp",
    "foppery": "fɒpəri",
    "foppish": "fɒpɪʃ",
    "fops": "fɒps",
    "fora": "fɔːrɐ",
    "foraged": "fɒrɪdʒd",
    "forage": "fɒrɪdʒ",
    "forager": "fɒrɪdʒɐ",
    "foragers": "fɒrɪdʒəz",
    "forages": "fɒrɪdʒɪz",
    "foraging": "fɒrɪdʒɪŋ",
    "foramen": "fɔːreɪmɛn",
    "foray": "fɔːreɪ",
    "forays": "fɔːreɪz",
    "forbade": "fəbeɪd",
    "forbad": "fəbæd",
    "forbearance": "fɔːbeərəns",
    "forbidden": "fəbɪdən",
    "forbidding": "fəbɪdɪŋ",
    "forbid": "fəbɪd",
    "forbids": "fəbɪdz",
    "forby": "fɔːbi",
    "forced": "fɔːst",
    "force": "fɔːs",
    "forceful": "fɔːsfəl",
    "forcefully": "fɔːsfəli",
    "forcemeat": "fɔːsɪmiːt",
    "forceps": "fɔːsɛps",
    "forcer": "fɔːsɐ",
    "forces": "fɔːsɪz",
    "forcible": "fɔːsəbəl",
    "forcibly": "fɔːsəbli",
    "forcing": "fɔːsɪŋ",
    "fordable": "fɔːdəbəl",
    "forded": "fɔːdɪd",
    "ford": "fɔːd",
    "fording": "fɔːdɪŋ",
    "fords": "fɔːdz",
    "forearmed": "fɔːrɑːmd",
    "forebear": "fɔːbeə",
    "forebears": "fɔːbeəz",
    "foreboding": "fɔːbəʊdɪŋ",
    "forebodings": "fɔːbəʊdɪŋz",
    "forecasted": "fɔːkɑːstɪd",
    "forecaster": "fɔːkɑːstɐ",
    "forecasters": "fɔːkɑːstəz",
    "forecast": "fɔːkɑːst",
    "forecasting": "fɔːkɑːstɪŋ",
    "forecastle": "fɔːkɑːsəl",
    "forecasts": "fɔːkɑːsts",
    "foreclosed": "fɔːkləʊzd",
    "foreclose": "fɔːkləʊz",
    "foreclosing": "fɔːkləʊzɪŋ",
    "foreclosure": "fɔːkləʊʒɐ",
    "foreclosures": "fɔːkləʊʒəz",
    "forecourt": "fɔːkɔːt",
    "forecourts": "fɔːkɔːts",
    "foredeck": "fɔːdɛk",
    "forefather": "fɔːfɑːðɐ",
    "forefathers": "fɔːfɑːðəz",
    "forefeet": "fɔːfiːt",
    "forefinger": "fɔːfɪŋɡɐ",
    "forefingers": "fɔːfɪŋɡəz",
    "fore": "fɔː",
    "forefoot": "fɔːfʊt",
    "forefront": "fɔːfrʌnt",
    "foregather": "fɔːɡæðɐ",
    "forego": "fɔːɡəʊ",
    "foregoing": "fɔːɡəʊɪŋ",
    "foregone": "fɔːɡɒn",
    "foregrounded": "fɔːɡraʊndɪd",
    "foreground": "fɔːɡraʊnd",
    "foregrounds": "fɔːɡraʊndz",
    "forehand": "fɔːhænd",
    "forehands": "fɔːhændz",
    "forehead": "fɔːhɛd",
    "foreheads": "fɔːhɛdz",
    "foreigner": "fɒrənɐ",
    "foreigners": "fɒrənəz",
    "foreign": "fɒrən",
    "foreignness": "fɒrənnəs",
    "foreknowledge": "fɔːnɒlɪdʒ",
    "foreland": "fɔːlənd",
    "foreleg": "fɔːlɛɡ",
    "forelegs": "fɔːlɛɡz",
    "forelimb": "fɔːlɪm",
    "forelimbs": "fɔːlɪmz",
    "forelock": "fɔːlɒk",
    "forelocks": "fɔːlɒks",
    "foreman": "fɔːmən",
    "foremast": "fɔːmɑːst",
    "foremen": "fɔːmɛn",
    "foremost": "fɔːməʊst",
    "forename": "fɔːneɪm",
    "forenames": "fɔːneɪmz",
    "forenoon": "fɔːnuːn",
    "forensically": "fərɛnsɪkli",
    "forensic": "fərɛnsɪk",
    "forensics": "fərɛnsɪks",
    "forepaws": "fɔːpɔːz",
    "forepeak": "fɔːpiːk",
    "foreplay": "fɔːpleɪ",
    "forequarter": "fɔːkwɔːtɐ",
    "forerunner": "fɔːrʌnɐ",
    "forerunners": "fɔːrʌnəz",
    "foresaid": "fɔːsɛd",
    "foresail": "fɔːseɪl",
    "foresaw": "fɔːsɔː",
    "foreseeable": "fɔːsiːəbəl",
    "foresee": "fɔːsiː",
    "foreseeing": "fɔːsiːɪŋ",
    "foreseen": "fɔːsiːn",
    "foresees": "fɔːsiːz",
    "fores": "fɔːz",
    "foreshadowed": "fɔːʃædəʊd",
    "foreshadow": "fɔːʃædəʊ",
    "foreshadowing": "fɔːʃædəʊɪŋ",
    "foreshadows": "fɔːʃædəʊz",
    "foreshore": "fɔːʃɔː",
    "foreshortened": "fɔːʃɔːtənd",
    "foreshortening": "fɔːʃɔːtənɪŋ",
    "foresighted": "fɔːsaɪtɪd",
    "foresight": "fɔːsaɪt",
    "foreskin": "fɔːskɪn",
    "foreskins": "fɔːskɪnz",
    "forestalled": "fɔːstɔːld",
    "forestall": "fɔːstɔːl",
    "forestalling": "fɔːstɔːlɪŋ",
    "forestation": "fɒrɪsteɪʃən",
    "forestay": "fɒrɪsteɪ",
    "forested": "fɒrɪstɪd",
    "forester": "fɒrɪstɐ",
    "foresters": "fɒrɪstəz",
    "forest": "fɒrɪst",
    "forestry": "fɒrɪstri",
    "forests": "fɒrɪsts",
    "foreswear": "fɔːsweə",
    "foreswore": "fɔːswɔː",
    "foretaste": "fɔːteɪst",
    "foretell": "fɔːtɛl",
    "foretelling": "fɔːtəlɪŋ",
    "foretells": "fɔːtɛlz",
    "forethought": "fɔːθɔːt",
    "foretold": "fɔːtəʊld",
    "forever": "fərɛvɐ",
    "forevermore": "fərɛvəmɔː",
    "forewarned": "fɔːwɔːnd",
    "forewarn": "fɔːwɔːn",
    "forewarning": "fɔːwɔːnɪŋ",
    "forewarns": "fɔːwɔːnz",
    "forewent": "fɔːwənt",
    "forewings": "fɔːwɪŋz",
    "foreword": "fɔːwɜːd",
    "forewords": "fɔːwɜːdz",
    "forfeited": "fɔːfɪtɪd",
    "forfeit": "fɔːfɪt",
    "forfeiting": "fɔːfɪtɪŋ",
    "forfeits": "fɔːfɪts",
    "forfeiture": "fɔːfeɪtʃɐ",
    "forfend": "fɔːfənd",
    "for": "fɔː",
    "forgave": "fəɡeɪv",
    "forged": "fɔːdʒd",
    "forge": "fɔːdʒ",
    "forger": "fɔːdʒɐ",
    "forgeries": "fɔːdʒəriz",
    "forgers": "fɔːdʒəz",
    "forgery": "fɔːdʒəri",
    "forges": "fɔːdʒɪz",
    "forget": "fəɡɛt",
    "forgetful": "fəɡɛtfəl",
    "forgetfulness": "fəɡɛtfəlnəs",
    "forgets": "fəɡɛts",
    "forgettable": "fəɡɛtəbəl",
    "forgetting": "fəɡɛtɪŋ",
    "forging": "fɔːdʒɪŋ",
    "forgings": "fɔːdʒɪŋz",
    "forgivable": "fəɡɪvəbəl",
    "forgive": "fəɡɪv",
    "forgiveness": "fəɡɪvnəs",
    "forgiven": "fəɡɪvən",
    "forgiver": "fəɡɪvɐ",
    "forgives": "fəɡɪvz",
    "forgiving": "fəɡɪvɪŋ",
    "forgoes": "fɔːɡəʊz",
    "forgo": "fɔːɡəʊ",
    "forgoing": "fɔːɡəʊɪŋ",
    "forgone": "fɔːɡɒn",
    "forgot": "fəɡɒt",
    "forgotten": "fəɡɒtən",
    "forint": "fɔːrɪnt",
    "forked": "fɔːkt",
    "fork": "fɔːk",
    "forkful": "fɔːkfəl",
    "forkfuls": "fɔːkfəlz",
    "forking": "fɔːkɪŋ",
    "forklift": "fɔːklɪft",
    "forklifts": "fɔːklɪfts",
    "forks": "fɔːks",
    "forlorn": "fɔːlɔːn",
    "forlornly": "fɔːlɔːnli",
    "forlornness": "fɔːlɔːnnəs",
    "formaldehyde": "fɔːmældɪhaɪd",
    "formal": "fɔːməl",
    "formalin": "fɔːmɐlɪn",
    "formalisation": "fɔːməlaɪzeɪʃən",
    "formalised": "fɔːməlaɪzd",
    "formalise": "fɔːməlaɪz",
    "formalises": "fɔːməlaɪzɪz",
    "formalising": "fɔːməlaɪzɪŋ",
    "formalist": "fɔːməlɪst",
    "formalities": "fɔːmælɪtiz",
    "formality": "fɔːmælɪti",
    "formally": "fɔːməli",
    "formals": "fɔːməlz",
    "formant": "fɔːmənt",
    "formate": "fɔːmeɪt",
    "format": "fɔːmæt",
    "formation": "fɔːmeɪʃən",
    "formations": "fɔːmeɪʃənz",
    "formative": "fɔːmətɪv",
    "formats": "fɔːmæts",
    "formatted": "fɔːmætɪd",
    "formatter": "fɔːmætɐ",
    "formatting": "fɔːmætɪŋ",
    "formed": "fɔːmd",
    "former": "fɔːmɐ",
    "formerly": "fɔːməli",
    "formers": "fɔːməz",
    "form": "fɔːm",
    "formic": "fɔːmɪk",
    "formidable": "fɔːmɪdəbəl",
    "formidably": "fɔːmɪdəbli",
    "forming": "fɔːmɪŋ",
    "formless": "fɔːmləs",
    "formlessness": "fɔːmləsnəs",
    "forms": "fɔːmz",
    "formulae": "fɔːmjʊliː",
    "formula": "fɔːmjʊlɐ",
    "formulaic": "fɔːmjʊleɪɪk",
    "formulary": "fɔːmjʊləri",
    "formulas": "fɔːmjʊləz",
    "formulated": "fɔːmjʊleɪtɪd",
    "formulate": "fɔːmjʊleɪt",
    "formulates": "fɔːmjʊleɪts",
    "formulating": "fɔːmjʊleɪtɪŋ",
    "formulation": "fɔːmjʊleɪʃən",
    "formulations": "fɔːmjʊleɪʃənz",
    "formwork": "fɔːmwɜːk",
    "fornicated": "fɔːnɪkeɪtɪd",
    "fornicate": "fɔːnɪkeɪt",
    "fornicating": "fɔːnɪkeɪtɪŋ",
    "fornication": "fɔːnɪkeɪʃən",
    "fornicator": "fɔːnɪkeɪtɐ",
    "fornicators": "fɔːnɪkeɪtəz",
    "forsake": "fɔːseɪk",
    "forsaken": "fɔːseɪkən",
    "forsakes": "fɔːseɪks",
    "forsaking": "fɔːseɪkɪŋ",
    "forsook": "fɔːsʊk",
    "forsooth": "fɔːsuːθ",
    "forswear": "fɔːsweə",
    "forsworn": "fɔːswɔːn",
    "forsythia": "fɔːsɪθiə",
    "fortes": "fɔːteɪs",
    "fort": "fɔːt",
    "forthcoming": "fɔːθkʌmɪŋ",
    "forth": "fɔːθ",
    "forthright": "fɔːθraɪt",
    "forthrightly": "fɔːθraɪtli",
    "forthrightness": "fɔːθraɪtnəs",
    "forthwith": "fɔːθwɪθ",
    "forties": "fɔːtɪz",
    "fortieth": "fɔːtiəθ",
    "fortification": "fɔːtɪfɪkeɪʃən",
    "fortifications": "fɔːtɪfɪkeɪʃənz",
    "fortified": "fɔːtɪfaɪd",
    "fortify": "fɔːtɪfaɪ",
    "fortifying": "fɔːtɪfaɪɪŋ",
    "fortis": "fɔːtiz",
    "fortissimo": "fɔːtɪsɪməʊ",
    "fortitude": "fɔːtɪtjuːd",
    "fortnight": "fɔːtnaɪt",
    "fortnightly": "fɔːtnaɪtli",
    "fortnights": "fɔːtnaɪts",
    "fortresses": "fɔːtrəsɪz",
    "fortress": "fɔːtrəs",
    "forts": "fɔːts",
    "fortuitous": "fɔːtjuːɪtəs",
    "fortuitously": "fɔːtjuːɪtəsli",
    "fortuity": "fɔːtjuːɪti",
    "fortunate": "fɔːtʃənət",
    "fortunately": "fɔːtʃənətli",
    "fortune": "fɔːtʃuːn",
    "fortunes": "fɔːtʃuːnz",
    "forty": "fɔːti",
    "forum": "fɔːrəm",
    "forums": "fɔːrəmz",
    "forwarded": "fɔːwədɪd",
    "forwarder": "fɔːwədɐ",
    "forward": "fɔːwəd",
    "forwarding": "fɔːwədɪŋ",
    "forwardly": "fɔːwədli",
    "forwardness": "fɔːwədnəs",
    "forwards": "fɔːwədz",
    "fossae": "fɒsiː",
    "fossa": "fɒsɐ",
    "fossas": "fɒsəz",
    "fossil": "fɒsəl",
    "fossilisation": "fɒsɪlaɪzeɪʃən",
    "fossilised": "fɒsəlaɪzd",
    "fossilise": "fɒsəlaɪz",
    "fossilising": "fɒsəlaɪzɪŋ",
    "fossils": "fɒsəlz",
    "fostered": "fɒstəd",
    "foster": "fɒstɐ",
    "fostering": "fɒstərɪŋ",
    "fosters": "fɒstəz",
    "fou": "fuː",
    "fought": "fɔːt",
    "fouled": "faʊld",
    "fouler": "faʊlɐ",
    "foulest": "faʊləst",
    "foul": "faʊl",
    "fouling": "faʊlɪŋ",
    "foully": "faʊli",
    "foulness": "faʊlnəs",
    "fouls": "faʊlz",
    "foundational": "faʊndeɪʃənəl",
    "foundation": "faʊndeɪʃən",
    "foundations": "faʊndeɪʃənz",
    "founded": "faʊndɪd",
    "foundered": "faʊndəd",
    "founder": "faʊndɐ",
    "foundering": "faʊndərɪŋ",
    "founders": "faʊndəz",
    "found": "faʊnd",
    "founding": "faʊndɪŋ",
    "foundling": "faʊndlɪŋ",
    "foundlings": "faʊndlɪŋz",
    "foundries": "faʊndrɪz",
    "foundry": "faʊndri",
    "founds": "faʊndz",
    "fountain": "faʊntɪn",
    "fountainhead": "faʊntɪnhɛd",
    "fountains": "faʊntɪnz",
    "fount": "faʊnt",
    "founts": "faʊnts",
    "fourchette": "fɔːtʃɛt",
    "four": "fɔː",
    "fourfold": "fɔːfəʊld",
    "fourpence": "fɔːpəns",
    "fourscore": "fɔːskɔː",
    "fours": "fɔːz",
    "foursome": "fɔːsʌm",
    "foursomes": "fɔːsʌmz",
    "foursquare": "fɔːskweə",
    "fourteen": "fɔːtiːn",
    "fourteenth": "fɔːtiːnθ",
    "fourth": "fɔːθ",
    "fourthly": "fɔːθli",
    "fourths": "fɔːθs",
    "fovea": "fəʊviə",
    "fowl": "faʊl",
    "fowling": "faʊlɪŋ",
    "fowls": "faʊlz",
    "foxed": "fɒkst",
    "foxes": "fɒksɪz",
    "fox": "fɒks",
    "foxglove": "fɒksɡlʌv",
    "foxgloves": "fɒksɡlʌvz",
    "foxhole": "fɒkshəʊl",
    "foxholes": "fɒkshəʊlz",
    "foxhound": "fɒkshaʊnd",
    "foxhounds": "fɒkshaʊndz",
    "foxhunting": "fɒkshʌntɪŋ",
    "foxier": "fɒksɪɐ",
    "foxing": "fɒksɪŋ",
    "foxtail": "fɒksteɪl",
    "foxtails": "fɒksteɪlz",
    "foxtrot": "fɒkstrɒt",
    "foxtrots": "fɒkstrɒts",
    "foxy": "fɒksi",
    "foyer": "fɔɪeɪ",
    "foyers": "fɔɪeɪz",
    "frabjous": "fræbdʒəs",
    "fracas": "frækəz",
    "fractal": "fræktəl",
    "fractals": "fræktəlz",
    "fractional": "frækʃənəl",
    "fractionally": "frækʃənəli",
    "fractionating": "frækʃənətɪŋ",
    "fraction": "frækʃən",
    "fractions": "frækʃənz",
    "fractious": "frækʃəs",
    "fractiousness": "frækʃəsnəs",
    "fractured": "fræktʃəd",
    "fracture": "fræktʃɐ",
    "fractures": "fræktʃəz",
    "fracturing": "fræktʃərɪŋ",
    "frae": "friː",
    "frag": "fræɡ",
    "fragile": "frædʒaɪl",
    "fragility": "frædʒɪlɪti",
    "fragmentary": "fræɡmɛntəri",
    "fragmentation": "fræɡmənteɪʃən",
    "fragmented": "fræɡmɛntɪd",
    "fragmenting": "fræɡmɛntɪŋ",
    "fragrance": "freɪɡrəns",
    "fragrances": "freɪɡrənsɪz",
    "fragrant": "freɪɡrənt",
    "frailer": "freɪlɐ",
    "frail": "freɪl",
    "frailties": "freɪltɪz",
    "frailty": "freɪlti",
    "fraise": "freɪz",
    "fraises": "freɪzɪz",
    "framboise": "fræmbɔɪs",
    "framboises": "fræmbɔɪsɪz",
    "framed": "freɪmd",
    "frame": "freɪm",
    "framer": "freɪmɐ",
    "framers": "freɪməz",
    "frames": "freɪmz",
    "framework": "freɪmwɜːk",
    "frameworks": "freɪmwɜːks",
    "framing": "freɪmɪŋ",
    "franc": "frɑːnk",
    "franchised": "frɑːntʃaɪzd",
    "franchisee": "frɑːntʃɪsiː",
    "franchisees": "frɑːntʃɪsiːz",
    "franchise": "frɑːntʃaɪz",
    "franchiser": "frɑːntʃaɪzɐ",
    "franchisers": "frɑːntʃaɪzəz",
    "franchises": "frɑːntʃaɪzɪz",
    "franchising": "frɑːntʃaɪzɪŋ",
    "franchisor": "frɑːntʃaɪzɐ",
    "francium": "frɑːnsiəm",
    "francophone": "frɑːnkəfəʊn",
    "francs": "frɑːnks",
    "frangipane": "fræŋɡɪpeɪn",
    "frangipani": "fræŋɡɪpɑːni",
    "franked": "fræŋkt",
    "franker": "fræŋkɐ",
    "frank": "fræŋk",
    "frankfurter": "fræŋkfɜːtɐ",
    "frankfurters": "fræŋkfɜːtəz",
    "frankfurt": "fræŋkfɜːt",
    "frankincense": "fræŋkɪnsəns",
    "franking": "fræŋkɪŋ",
    "franklin": "fræŋklɪn",
    "franklins": "fræŋklɪnz",
    "frankly": "fræŋkli",
    "frankness": "fræŋknəs",
    "franks": "fræŋks",
    "frantically": "frɑːntɪkli",
    "frantic": "frɑːntɪk",
    "frap": "fræp",
    "frappes": "fræps",
    "fraps": "fræps",
    "frater": "freɪtɐ",
    "fraternal": "frɐtɜːnəl",
    "fraternisation": "frɐtɜːnaɪzeɪʃən",
    "fraternised": "frɐtɜːnaɪzd",
    "fraternise": "frɐtɜːnaɪz",
    "fraternising": "frɐtɜːnaɪzɪŋ",
    "fraternities": "frɐtɜːnɪtiz",
    "fraternity": "frɐtɜːnɪti",
    "frat": "fræt",
    "fratricidal": "frætrɪsaɪdəl",
    "fratricide": "frætrɪsaɪd",
    "fraud": "frɔːd",
    "frauds": "frɔːdz",
    "fraudster": "frɔːdstɐ",
    "fraudsters": "frɔːdstəz",
    "fraudulent": "frɔːdjʊlənt",
    "fraudulently": "frɔːdjʊləntli",
    "fraught": "frɔːt",
    "frayed": "freɪd",
    "fray": "freɪ",
    "fraying": "freɪɪŋ",
    "frazzled": "fræzəld",
    "frazzle": "fræzəl",
    "frazzles": "fræzəlz",
    "frazzling": "fræzlɪŋ",
    "freaked": "friːkt",
    "freak": "friːk",
    "freakier": "friːkɪɐ",
    "freakiest": "friːkɪəst",
    "freakily": "friːkɪli",
    "freaking": "friːkɪŋ",
    "freakish": "friːkɪʃ",
    "freakishly": "friːkɪʃli",
    "freakout": "friːkaʊt",
    "freaks": "friːks",
    "freaky": "friːki",
    "freckled": "frɛkəld",
    "freckle": "frɛkəl",
    "freckles": "frɛkəlz",
    "freckling": "frɛklɪŋ",
    "freckly": "frɛkli",
    "freebase": "friːbeɪs",
    "freebie": "friːbi",
    "freebies": "friːbɪz",
    "freeboard": "friːbɔːd",
    "freebooter": "friːbuːtɐ",
    "freebooters": "friːbuːtəz",
    "freeborn": "friːbɔːn",
    "freed": "friːd",
    "freedman": "friːdmən",
    "freedom": "friːdəm",
    "freedoms": "friːdəmz",
    "free": "friː",
    "freeform": "friːfɔːm",
    "freehand": "friːhænd",
    "freeholder": "friːhəʊldɐ",
    "freeholders": "friːhəʊldəz",
    "freehold": "friːhəʊld",
    "freeholds": "friːhəʊldz",
    "freeing": "friːɪŋ",
    "freelanced": "friːlɑːnst",
    "freelance": "friːlɑːns",
    "freelancer": "friːlɑːnsɐ",
    "freelancers": "friːlɑːnsəz",
    "freelances": "friːlɑːnsɪz",
    "freelancing": "friːlɑːnsɪŋ",
    "freeloader": "friːləʊdɐ",
    "freeloaders": "friːləʊdəz",
    "freeload": "friːləʊd",
    "freeloading": "friːləʊdɪŋ",
    "freely": "friːli",
    "freeman": "friːmən",
    "freemasonry": "friːmeɪsɒnri",
    "freemen": "friːmɛn",
    "freeness": "friːnəs",
    "freephone": "friːfəʊn",
    "freer": "friːɐ",
    "frees": "friːz",
    "freesia": "friːziə",
    "freesias": "friːziəz",
    "freestanding": "friːstændɪŋ",
    "freest": "friːst",
    "freestone": "friːstəʊn",
    "freestyle": "friːstaɪl",
    "freestyles": "friːstaɪlz",
    "freeway": "friːweɪ",
    "freeways": "friːweɪz",
    "freewheel": "friːwiːl",
    "freewheeling": "friːwiːlɪŋ",
    "freewill": "friːwɪl",
    "freeze": "friːz",
    "freezer": "friːzɐ",
    "freezers": "friːzəz",
    "freezes": "friːzɪz",
    "freezing": "friːzɪŋ",
    "freighted": "freɪtɪd",
    "freighter": "freɪtɐ",
    "freighters": "freɪtəz",
    "freight": "freɪt",
    "freighting": "freɪtɪŋ",
    "freights": "freɪts",
    "french": "frɛntʃ",
    "frenetically": "frɛnɛtɪkli",
    "frenetic": "frɛnɛtɪk",
    "frenzied": "frɛnzɪd",
    "frenziedly": "frɛnzɪdli",
    "frenzies": "frɛnzɪz",
    "frenzy": "frɛnzi",
    "frequencies": "friːkwənsiz",
    "frequency": "friːkwənsi",
    "frequented": "friːkwəntɪd",
    "frequenting": "friːkwəntɪŋ",
    "frequently": "friːkwəntli",
    "frequents": "friːkwənts",
    "frescoes": "frɛskəʊz",
    "fresco": "frɛskəʊ",
    "frescos": "frɛskəʊz",
    "freshened": "frɛʃənd",
    "freshener": "frɛʃənɐ",
    "fresheners": "frɛʃənəz",
    "freshen": "frɛʃən",
    "freshening": "frɛʃənɪŋ",
    "freshens": "frɛʃənz",
    "fresher": "frɛʃɐ",
    "freshers": "frɛʃəz",
    "freshest": "frɛʃəst",
    "fresh": "frɛʃ",
    "freshly": "frɛʃli",
    "freshman": "frɛʃmən",
    "freshmen": "frɛʃmɛn",
    "freshness": "frɛʃnəs",
    "freshwater": "frɛʃwɔːtɐ",
    "fresnel": "frɛsnəl",
    "fret": "frɛt",
    "fretful": "frɛtfəl",
    "fretsaw": "frɛtsɔː",
    "frets": "frɛts",
    "fretted": "frɛtɪd",
    "fretting": "frɛtɪŋ",
    "fretwork": "frɛtwɜːk",
    "friable": "frɪəblɛ",
    "friar": "fraɪə",
    "friars": "fraɪəz",
    "friary": "fraɪəri",
    "fricassee": "frɪkɐseɪ",
    "frictional": "frɪkʃənəl",
    "friction": "frɪkʃən",
    "frictionless": "frɪkʃənləs",
    "frictions": "frɪkʃənz",
    "fridge": "frɪdʒ",
    "fridges": "frɪdʒɪz",
    "fried": "fraɪd",
    "friend": "frɛnd",
    "friendless": "frɛndləs",
    "friendlier": "frɛndliɐ",
    "friendlies": "frɛndliz",
    "friendliest": "frɛndliəst",
    "friendliness": "frɛndlinəs",
    "friendly": "frɛndli",
    "friends": "frɛndz",
    "friendship": "frɛndʃɪp",
    "friendships": "frɛndʃɪps",
    "frier": "fraɪə",
    "friers": "fraɪəz",
    "fries": "fraɪz",
    "frieze": "friːz",
    "friezes": "friːzɪz",
    "frigate": "frɪɡət",
    "frigates": "frɪɡəts",
    "frig": "frɪɡ",
    "frigging": "frɪɡɪŋ",
    "frighted": "fraɪtɪd",
    "frightened": "fraɪtənd",
    "frighteners": "fraɪtənəz",
    "frighten": "fraɪtən",
    "frightening": "fraɪtənɪŋ",
    "frighteningly": "fraɪtənɪŋli",
    "frightens": "fraɪtənz",
    "fright": "fraɪt",
    "frightful": "fraɪtfəl",
    "frightfully": "fraɪtfəli",
    "frighting": "fraɪtɪŋ",
    "frights": "fraɪts",
    "frigidarium": "frɪdʒɪdeəriəm",
    "frigid": "frɪdʒɪd",
    "frigidity": "frɪdʒɪdɪti",
    "frijoles": "frɪdʒəʊlz",
    "frilled": "frɪld",
    "frill": "frɪl",
    "frilliest": "frɪliəst",
    "frilling": "frɪlɪŋ",
    "frills": "frɪlz",
    "frilly": "frɪli",
    "fringed": "frɪndʒd",
    "fringe": "frɪndʒ",
    "fringes": "frɪndʒɪz",
    "fringing": "frɪndʒɪŋ",
    "fripperies": "frɪpəriz",
    "frippery": "frɪpəri",
    "frise": "fraɪz",
    "frisked": "frɪskt",
    "frisker": "frɪskɐ",
    "frisk": "frɪsk",
    "friskier": "frɪskiɐ",
    "frisking": "frɪskɪŋ",
    "frisky": "frɪski",
    "frisson": "friːsɔ̃",
    "frissons": "friːsɔ̃z",
    "frit": "frɪt",
    "frith": "frɪθ",
    "fritillaries": "frɪtɪləriz",
    "fritillary": "frɪtɪləri",
    "frittata": "frɪtɑːtɐ",
    "frittered": "frɪtəd",
    "fritter": "frɪtɐ",
    "frittering": "frɪtərɪŋ",
    "fritters": "frɪtəz",
    "fritz": "frɪts",
    "frivolities": "frɪvɒlɪtiz",
    "frivolity": "frɪvɒlɪti",
    "frivolous": "frɪvələs",
    "frivolously": "frɪvələsli",
    "frizzed": "frɪzd",
    "frizz": "frɪz",
    "frizzle": "frɪzəl",
    "frizzles": "frɪzəlz",
    "frizzling": "frɪzlɪŋ",
    "frizzly": "frɪzli",
    "frizzy": "frɪzi",
    "frock": "frɒk",
    "frocks": "frɒks",
    "froe": "frəʊ",
    "fro": "frəʊ",
    "frog": "frɒɡ",
    "frogfish": "frɒɡfɪʃ",
    "froggy": "frɒɡi",
    "froghopper": "frɒɡhɒpɐ",
    "froghoppers": "frɒɡhɒpəz",
    "frogman": "frɒɡmən",
    "frogmarched": "frɒɡmɑːkt",
    "frogmen": "frɒɡmɛn",
    "frogs": "frɒɡz",
    "frogspawn": "frɒɡspɔːn",
    "froideur": "frɔɪdɜː",
    "frolic": "frɒlɪk",
    "frolicked": "frɒlɪkt",
    "frolicking": "frɒlɪkɪŋ",
    "frolics": "frɒlɪks",
    "frolicsome": "frɒlɪksʌm",
    "from": "frɒm",
    "frond": "frɒnd",
    "fronds": "frɒndz",
    "frons": "frɒnz",
    "frontage": "frʌntɪdʒ",
    "frontages": "frʌntɪdʒɪz",
    "frontal": "frʌntəl",
    "frontally": "frʌntəli",
    "frontbencher": "frʌntbɛntʃɐ",
    "frontbenchers": "frʌntbɛntʃəz",
    "frontbench": "frʌntbɛntʃ",
    "fronted": "frʌntɪd",
    "front": "frʌnt",
    "frontier": "frʌntiə",
    "frontiers": "frʌntiəz",
    "frontiersman": "frʌntiəzmən",
    "frontiersmen": "frʌntiəzmɛn",
    "fronting": "frʌntɪŋ",
    "frontispiece": "frʌntɪzpiːs",
    "frontispieces": "frʌntɪspiːsɪz",
    "frontline": "frʌntlaɪn",
    "frontrunner": "frʌntrʌnɐ",
    "frontrunners": "frʌntrʌnəz",
    "fronts": "frʌnts",
    "frontwards": "frʌntwədz",
    "frostbite": "frɒstbaɪt",
    "frostbitten": "frɒstbɪtən",
    "frosted": "frɒstɪd",
    "frost": "frɒst",
    "frostier": "frɒstɪɐ",
    "frostiest": "frɒstɪəst",
    "frostiness": "frɒstɪnəs",
    "frosting": "frɒstɪŋ",
    "frosts": "frɒsts",
    "frosty": "frɒsti",
    "frothed": "frɒθd",
    "froth": "frɒθ",
    "frothiest": "frɒθɪəst",
    "frothiness": "frɒθɪnəs",
    "frothing": "frɒθɪŋ",
    "froths": "frɒθs",
    "frothy": "frɒθi",
    "froufrou": "fruːfruː",
    "frow": "fraʊ",
    "frowned": "fraʊnd",
    "frown": "fraʊn",
    "frowning": "fraʊnɪŋ",
    "frowns": "fraʊnz",
    "frowzy": "fraʊzi",
    "froze": "frəʊz",
    "frozen": "frəʊzən",
    "fructose": "frʌktəʊz",
    "frugal": "fruːɡəl",
    "frugality": "fruːɡælɪti",
    "frugally": "fruːɡəli",
    "frug": "frʌɡ",
    "fruitcake": "fruːtkeɪk",
    "fruitcakes": "fruːtkeɪks",
    "fruited": "fruːtɪd",
    "fruiterer": "fruːtərɐ",
    "fruiterers": "fruːtərəz",
    "fruiter": "fruːtɐ",
    "fruitful": "fruːtfəl",
    "fruitfully": "fruːtfəli",
    "fruitfulness": "fruːtfəlnəs",
    "fruit": "fruːt",
    "fruitier": "fruːtɪɐ",
    "fruitiest": "fruːtɪəst",
    "fruitiness": "fruːtɪnəs",
    "fruiting": "fruːtɪŋ",
    "fruition": "fruːɪʃən",
    "fruitless": "fruːtləs",
    "fruitlessly": "fruːtləsli",
    "fruits": "fruːts",
    "fruity": "fruːti",
    "frump": "frʌmp",
    "frumpy": "frʌmpi",
    "frustrated": "frʌstreɪtɪd",
    "frustrate": "frʌstreɪt",
    "frustrates": "frʌstreɪts",
    "frustrating": "frʌstreɪtɪŋ",
    "frustratingly": "frʌstreɪtɪŋli",
    "frustration": "frʌstreɪʃən",
    "frustrations": "frʌstreɪʃənz",
    "frustum": "frʌstəm",
    "fryer": "fraɪɐ",
    "fryers": "fraɪəz",
    "fry": "fraɪ",
    "frying": "fraɪɪŋ",
    "fuchsia": "fjuːʃɐ",
    "fuchsias": "fjuːʃəz",
    "fucked": "fʌkt",
    "fucker": "fʌkɐ",
    "fuckers": "fʌkəz",
    "fuck": "fʌk",
    "fuckhead": "fʌkhɛd",
    "fucking": "fʌkɪŋ",
    "fucks": "fʌks",
    "fuddled": "fʌdəld",
    "fuddle": "fʌdəl",
    "fudged": "fʌdʒd",
    "fudge": "fʌdʒ",
    "fudges": "fʌdʒɪz",
    "fudging": "fʌdʒɪŋ",
    "fuehrer": "fjuːhrɐ",
    "fuel": "fjuːəl",
    "fuelled": "fjuːəld",
    "fuelling": "fjuːəlɪŋ",
    "fuels": "fjuːəlz",
    "fug": "fʌɡ",
    "fuggy": "fʌɡi",
    "fugitive": "fjuːdʒɪtɪv",
    "fugitives": "fjuːdʒɪtɪvz",
    "fugs": "fʌɡz",
    "fugue": "fjuːɡ",
    "fugues": "fjuːɡz",
    "fuhrer": "fuːrɐ",
    "fuhrers": "fuːrəz",
    "fulcrum": "fʌlkrəm",
    "fulcrums": "fʌlkrəmz",
    "fulfil": "fʊlfɪl",
    "fulfilled": "fʊlfɪld",
    "fulfilling": "fʊlfɪlɪŋ",
    "fulfilment": "fʊlfɪlmənt",
    "fulfils": "fʊlfɪlz",
    "fullback": "fʊlbæk",
    "fullbacks": "fʊlbæks",
    "fulled": "fʊld",
    "fullerene": "fʊləriːn",
    "fuller": "fʊlɐ",
    "fullers": "fʊləz",
    "fullest": "fʊləst",
    "full": "fʊl",
    "fulling": "fʊlɪŋ",
    "fullish": "fʊlɪʃ",
    "fullness": "fʊlnəs",
    "fulls": "fʊlz",
    "fully": "fʊli",
    "fulmar": "fʊlmɐ",
    "fulmars": "fʊlməz",
    "fulminate": "fʊlmɪneɪt",
    "fulminating": "fʊlmɪneɪtɪŋ",
    "fulsome": "fʌlsʌm",
    "fulsomely": "fʊlsʌmli",
    "fumaroles": "fjuːmərəʊlz",
    "fumbled": "fʌmbəld",
    "fumble": "fʌmbəl",
    "fumbles": "fʌmbəlz",
    "fumbling": "fʌmblɪŋ",
    "fumed": "fjuːmd",
    "fume": "fjuːm",
    "fumes": "fjuːmz",
    "fumigated": "fjuːmɪɡeɪtɪd",
    "fumigate": "fjuːmɪɡeɪt",
    "fumigating": "fjuːmɪɡeɪtɪŋ",
    "fumigation": "fjuːmɪɡeɪʃən",
    "fumigator": "fjuːmɪɡeɪtɐ",
    "fumigators": "fjuːmɪɡeɪtəz",
    "fuming": "fjuːmɪŋ",
    "functional": "fʌŋkʃənəl",
    "functionalism": "fʌŋkʃənəlɪzəm",
    "functionalist": "fʌŋkʃənəlɪst",
    "functionality": "fʌŋkʃənælɪti",
    "functionally": "fʌŋkʃənəli",
    "functionaries": "fʌŋkʃənəriz",
    "functionary": "fʌŋkʃənəri",
    "functioned": "fʌŋkʃənd",
    "function": "fʌŋkʃən",
    "functioning": "fʌŋkʃənɪŋ",
    "functions": "fʌŋkʃənz",
    "fundamental": "fʌndəmɛntəl",
    "fundamentalism": "fʌndəmɛntəlɪzəm",
    "fundamentalist": "fʌndəmɛntəlɪst",
    "fundamentalists": "fʌndəmɛntəlɪsts",
    "fundamentally": "fʌndəmɛntəli",
    "fundamentals": "fʌndəmɛntəlz",
    "fundament": "fʌndəmənt",
    "funded": "fʌndɪd",
    "fund": "fʌnd",
    "funding": "fʌndɪŋ",
    "fundraiser": "fʌndreɪzɐ",
    "fundraisers": "fʌndreɪzəz",
    "fundraising": "fʌndreɪzɪŋ",
    "funds": "fʌndz",
    "fundus": "fʌndəs",
    "funeral": "fjuːnərəl",
    "funerals": "fjuːnərəlz",
    "funerary": "fjuːnərəri",
    "funereal": "fjuːniərɪəl",
    "funest": "fʌnəst",
    "funfair": "fʌnfeə",
    "funfairs": "fʌnfeəz",
    "fun": "fʌn",
    "fungal": "fʌŋɡəl",
    "fungible": "fʌndʒəbəl",
    "fungicide": "fʌŋɡɪsaɪd",
    "fungicides": "fʌŋɡɪsaɪdz",
    "fungi": "fʌŋɡi",
    "fungiform": "fʌŋɡɪfɔːm",
    "fungo": "fʌŋɡəʊ",
    "funguses": "fʌŋɡjuːsɪz",
    "fungus": "fʌŋɡəs",
    "funicular": "fjuːnɪkjʊlɐ",
    "funiculi": "fjuːnɪkjʊlaɪ",
    "funked": "fʌŋkt",
    "funk": "fʌŋk",
    "funkier": "fʌŋkiɐ",
    "funkiest": "fʌŋkiəst",
    "funkiness": "fʌŋkinəs",
    "funking": "fʌŋkɪŋ",
    "funky": "fʌŋki",
    "funnel": "fʌnəl",
    "funnelled": "fʌnəld",
    "funnelling": "fʌnəlɪŋ",
    "funnels": "fʌnəlz",
    "funner": "fʌnɐ",
    "funnest": "fʌnəst",
    "funnier": "fʌnɪɐ",
    "funnies": "fʌnɪz",
    "funniest": "fʌnɪəst",
    "funnily": "fʌnɪli",
    "funniness": "fʌnɪnəs",
    "funny": "fʌni",
    "funnyman": "fʌnɪmən",
    "furbelows": "fɜːbɪləʊz",
    "furbished": "fɜːbɪʃt",
    "furcula": "fɜːkjʊlɐ",
    "fur": "fɜː",
    "furies": "fjɔːrɪz",
    "furious": "fjɔːrɪəs",
    "furiously": "fjɔːrɪəsli",
    "furled": "fɜːld",
    "furl": "fɜːl",
    "furling": "fɜːlɪŋ",
    "furlong": "fɜːlɒŋ",
    "furlongs": "fɜːlɒŋz",
    "furlough": "fɜːləʊ",
    "furls": "fɜːlz",
    "furnace": "fɜːnɪs",
    "furnaces": "fɜːnɪsɪz",
    "furnished": "fɜːnɪʃt",
    "furnisher": "fɜːnɪʃɐ",
    "furnishes": "fɜːnɪʃɪz",
    "furnish": "fɜːnɪʃ",
    "furnishing": "fɜːnɪʃɪŋ",
    "furnishings": "fɜːnɪʃɪŋz",
    "furniture": "fɜːnɪtʃɐ",
    "furred": "fɜːd",
    "furriers": "fʌriəz",
    "furriest": "fɜːrɪəst",
    "furriness": "fɜːrɪnəs",
    "furring": "fɜːrɪŋ",
    "furrowed": "fʌrəʊd",
    "furrow": "fʌrəʊ",
    "furrowing": "fʌrəʊɪŋ",
    "furrows": "fʌrəʊz",
    "furry": "fɜːri",
    "furs": "fɜːz",
    "furtherance": "fɜːθərəns",
    "furthered": "fɜːðəd",
    "further": "fɜːðɐ",
    "furthering": "fɜːðərɪŋ",
    "furthermore": "fɜːðəmɔː",
    "furthermost": "fɜːðəməʊst",
    "furthers": "fɜːðəz",
    "furthest": "fɜːðəst",
    "furtive": "fɜːtɪv",
    "furtively": "fɜːtɪvli",
    "fury": "fjɔːri",
    "furze": "fɜːz",
    "fusebox": "fjuːsɪbɒks",
    "fused": "fjuːzd",
    "fusee": "fjuːsiː",
    "fuse": "fjuːz",
    "fuselage": "fjuːzəlɑːʒ",
    "fuselages": "fjuːzəlɑːʒɪz",
    "fuses": "fjuːzɪz",
    "fusilier": "fjuːslɪɐ",
    "fusiliers": "fjuːsɪliəz",
    "fusillade": "fjuːsɪleɪd",
    "fusing": "fjuːzɪŋ",
    "fusion": "fjuːʒən",
    "fusions": "fjuːʒənz",
    "fussed": "fʌst",
    "fusses": "fʌsɪz",
    "fuss": "fʌs",
    "fussier": "fʌsɪɐ",
    "fussiest": "fʌsɪəst",
    "fussiness": "fʌsɪnəs",
    "fussing": "fʌsɪŋ",
    "fusspot": "fʌspɒt",
    "fussy": "fʌsi",
    "fustanella": "fʌsteɪnɛlɐ",
    "fusty": "fʌsti",
    "futhark": "fʌθɑːk",
    "futile": "fjuːtaɪl",
    "futilely": "fjuːtaɪlli",
    "futility": "fjuːtɪlɪti",
    "futon": "fuːtɒn",
    "futons": "fuːtɒnz",
    "futtock": "fʌtək",
    "future": "fjuːtʃɐ",
    "futures": "fjuːtʃəz",
    "futurism": "fjuːtʃərɪzəm",
    "futurist": "fjuːtʃərɪst",
    "futuristic": "fjuːtʃərɪstɪk",
    "futurists": "fjuːtʃərɪsts",
    "futurologists": "fjuːtʃərɒlədʒɪsts",
    "fuzzed": "fʌzd",
    "fuzz": "fʌz",
    "fuzzier": "fʌzɪɐ",
    "fuzziest": "fʌzɪəst",
    "fuzzily": "fʌzɪli",
    "fuzziness": "fʌzɪnəs",
    "fuzzy": "fʌzi",
    "gab": "ɡæb",
    "gabardine": "ɡæbɑːdiːn",
    "gabbed": "ɡæbd",
    "gabber": "ɡæbɐ",
    "gabbing": "ɡæbɪŋ",
    "gabble": "ɡæbəl",
    "gabbled": "ɡæbəld",
    "gabbling": "ɡæblɪŋ",
    "gabbro": "ɡæbrəʊ",
    "gabby": "ɡæbi",
    "gaberdine": "ɡæbədiːn",
    "gabion": "ɡæbɪən",
    "gabled": "ɡeɪbəld",
    "gable": "ɡeɪbəl",
    "gables": "ɡeɪbəlz",
    "gabs": "ɡæbz",
    "gaby": "ɡeɪbi",
    "gadabout": "ɡædɐbaʊt",
    "gad": "ɡæd",
    "gadding": "ɡædɪŋ",
    "gadflies": "ɡædflaɪz",
    "gadfly": "ɡædflaɪ",
    "gadget": "ɡædʒɪt",
    "gadgetry": "ɡædʒɪtri",
    "gadgets": "ɡædʒɪts",
    "gadolinium": "ɡædəlɪniəm",
    "gadroon": "ɡædruːn",
    "gads": "ɡædz",
    "gadwall": "ɡædwɔːl",
    "gaff": "ɡæf",
    "gaffe": "ɡæf",
    "gaffer": "ɡæfɐ",
    "gaffers": "ɡæfəz",
    "gaffes": "ɡæfs",
    "gaffing": "ɡæfɪŋ",
    "gaffs": "ɡæfs",
    "gaga": "ɡɑːɡɐ",
    "gag": "ɡæɡ",
    "gage": "ɡeɪdʒ",
    "gages": "ɡeɪdʒɪz",
    "gagged": "ɡæɡd",
    "gagging": "ɡæɡɪŋ",
    "gaggle": "ɡæɡəl",
    "gaggles": "ɡæɡəlz",
    "gags": "ɡæɡz",
    "gaiety": "ɡeɪəti",
    "gaillardia": "ɡeɪlɑːdiə",
    "gaily": "ɡeɪli",
    "gained": "ɡeɪnd",
    "gain": "ɡeɪn",
    "gainer": "ɡeɪnɐ",
    "gainers": "ɡeɪnəz",
    "gainful": "ɡeɪnfəl",
    "gainfully": "ɡeɪnfəli",
    "gaining": "ɡeɪnɪŋ",
    "gainly": "ɡeɪnli",
    "gainsaid": "ɡeɪnsɛd",
    "gainsay": "ɡeɪnseɪ",
    "gains": "ɡeɪnz",
    "gaited": "ɡeɪtɪd",
    "gaiter": "ɡeɪtɐ",
    "gaiters": "ɡeɪtəz",
    "gait": "ɡeɪt",
    "gaits": "ɡeɪts",
    "galactic": "ɡɐlæktɪk",
    "galactose": "ɡælɐktəʊz",
    "gal": "ɡæl",
    "galah": "ɡælɐ",
    "gala": "ɡɑːlɐ",
    "galangal": "ɡælæŋɡəl",
    "galantine": "ɡælɑːntiːn",
    "galas": "ɡɑːləz",
    "galatea": "ɡæleɪtiə",
    "galaxies": "ɡælɐksiz",
    "galaxy": "ɡælɐksi",
    "galea": "ɡeɪliə",
    "gale": "ɡeɪl",
    "galena": "ɡɐliːnɐ",
    "gales": "ɡeɪlz",
    "galilee": "ɡælɪliː",
    "gallantly": "ɡæləntli",
    "gallantry": "ɡæləntri",
    "gallants": "ɡælənts",
    "gallbladder": "ɡælblædɐ",
    "galled": "ɡɔːld",
    "galleon": "ɡælɪən",
    "galleons": "ɡælɪənz",
    "galleria": "ɡæləriə",
    "galleried": "ɡælərid",
    "galleries": "ɡæləriz",
    "gallery": "ɡæləri",
    "galley": "ɡæli",
    "galleys": "ɡælɪz",
    "gallic": "ɡælɪk",
    "gallimaufry": "ɡælɪmɔːfri",
    "galling": "ɡɔːlɪŋ",
    "gallium": "ɡæliəm",
    "gallivant": "ɡælɪvænt",
    "gallivanting": "ɡælɪvæntɪŋ",
    "gall": "ɡɔːl",
    "gallon": "ɡælən",
    "gallons": "ɡælənz",
    "gallop": "ɡæləp",
    "galloped": "ɡæləpd",
    "galloper": "ɡæləʊpɐ",
    "galloping": "ɡæləpɪŋ",
    "gallops": "ɡæləps",
    "gallows": "ɡæləʊz",
    "galls": "ɡɔːlz",
    "gallstone": "ɡælstəʊn",
    "gallstones": "ɡælstəʊnz",
    "galluses": "ɡæləsɪz",
    "galoot": "ɡæluːt",
    "galop": "ɡæləp",
    "galore": "ɡɐlɔː",
    "galosh": "ɡælɒʃ",
    "galoshes": "ɡælɒʃɪz",
    "gals": "ɡælz",
    "galumphing": "ɡælʌmfɪŋ",
    "galvanic": "ɡælvænɪk",
    "galvanisation": "ɡælvɐnaɪzeɪʃən",
    "galvanise": "ɡælvɐnaɪz",
    "galvanised": "ɡælvɐnaɪzd",
    "galvanises": "ɡælvɐnaɪzɪz",
    "galvanising": "ɡælvɐnaɪzɪŋ",
    "galvanometer": "ɡælvɐnɒmɪtɐ",
    "gam": "ɡæm",
    "gamba": "ɡæmbɐ",
    "gambier": "ɡæmbɪɐ",
    "gambit": "ɡæmbɪt",
    "gambits": "ɡæmbɪts",
    "gamble": "ɡæmbəl",
    "gambled": "ɡæmbəld",
    "gambler": "ɡæmblɐ",
    "gamblers": "ɡæmbləz",
    "gambles": "ɡæmbəlz",
    "gambling": "ɡæmblɪŋ",
    "gamboge": "ɡæmbəʊdʒ",
    "gambol": "ɡæmbɒl",
    "gambolled": "ɡæmbɒld",
    "gambolling": "ɡæmbɒlɪŋ",
    "gambols": "ɡæmbɒlz",
    "gamed": "ɡeɪmd",
    "game": "ɡeɪm",
    "gamekeeper": "ɡeɪmkiːpɐ",
    "gamekeepers": "ɡeɪmkiːpəz",
    "gamelan": "ɡeɪmlæn",
    "gamely": "ɡeɪmli",
    "gamer": "ɡeɪmɐ",
    "gamers": "ɡeɪməz",
    "games": "ɡeɪmz",
    "gamesmanship": "ɡeɪmsmənʃɪp",
    "gamesome": "ɡeɪmsʌm",
    "gamester": "ɡeɪmstɐ",
    "gamete": "ɡæmiːt",
    "gametes": "ɡæmiːts",
    "gamey": "ɡeɪmi",
    "gamier": "ɡeɪmɪɐ",
    "gamin": "ɡæmɪn",
    "gamine": "ɡæmaɪn",
    "gaminess": "ɡeɪmɪnəs",
    "gaming": "ɡeɪmɪŋ",
    "gamma": "ɡæmɐ",
    "gammas": "ɡæməz",
    "gammon": "ɡæmən",
    "gammy": "ɡæmi",
    "gamp": "ɡæmp",
    "gamut": "ɡæmʌt",
    "gamy": "ɡeɪmi",
    "gan": "ɡæn",
    "gander": "ɡændɐ",
    "ganders": "ɡændəz",
    "gang": "ɡæŋ",
    "gangbusters": "ɡæŋbʌstəz",
    "ganged": "ɡæŋd",
    "ganger": "ɡæŋɡɐ",
    "gangers": "ɡæŋɡəz",
    "ganging": "ɡæŋɪŋ",
    "gangland": "ɡæŋɡlənd",
    "ganglia": "ɡæŋɡliɐ",
    "gangling": "ɡæŋɡəlɪŋ",
    "ganglion": "ɡæŋɡliən",
    "gangly": "ɡæŋli",
    "gangplank": "ɡæŋplæŋk",
    "gangplanks": "ɡæŋplæŋks",
    "gangrene": "ɡæŋɡriːn",
    "gangrenous": "ɡæŋɡrənəs",
    "gangs": "ɡæŋz",
    "gangsta": "ɡæŋstɐ",
    "gangstas": "ɡæŋstəz",
    "gangster": "ɡæŋstɐ",
    "gangsterdom": "ɡæŋstədəm",
    "gangsterism": "ɡæŋstərɪzəm",
    "gangsters": "ɡæŋstəz",
    "gangway": "ɡæŋweɪ",
    "gangways": "ɡæŋweɪz",
    "ganja": "ɡænjɐ",
    "gannet": "ɡænɪt",
    "gannets": "ɡænɪts",
    "gantries": "ɡɑːntriz",
    "gantry": "ɡɑːntri",
    "gap": "ɡæp",
    "gaped": "ɡeɪpt",
    "gape": "ɡeɪp",
    "gapes": "ɡeɪps",
    "gaping": "ɡeɪpɪŋ",
    "gappy": "ɡæpi",
    "gaps": "ɡæps",
    "gar": "ɡɑː",
    "garage": "ɡærɪdʒ",
    "garaged": "ɡærɪdʒd",
    "garages": "ɡærɪdʒɪz",
    "garaging": "ɡærɪdʒɪŋ",
    "garbage": "ɡɑːbɪdʒ",
    "garbanzos": "ɡɑːbænzəʊz",
    "garb": "ɡɑːb",
    "garbed": "ɡɑːbd",
    "garble": "ɡɑːbəl",
    "garbled": "ɡɑːbəld",
    "garbs": "ɡɑːbz",
    "gardant": "ɡɑːdənt",
    "garden": "ɡɑːdən",
    "gardened": "ɡɑːdənd",
    "gardener": "ɡɑːdənɐ",
    "gardeners": "ɡɑːdənəz",
    "gardenia": "ɡɑːdiːniə",
    "gardenias": "ɡɑːdiːniəz",
    "gardening": "ɡɑːdənɪŋ",
    "gardens": "ɡɑːdənz",
    "garfish": "ɡɑːfɪʃ",
    "gargantuan": "ɡɑːɡɑːntjuːən",
    "gargled": "ɡɑːɡəld",
    "gargle": "ɡɑːɡəl",
    "gargles": "ɡɑːɡəlz",
    "gargling": "ɡɑːɡlɪŋ",
    "gargoyle": "ɡɑːɡɔɪl",
    "gargoyles": "ɡɑːɡɔɪlz",
    "garibaldi": "ɡɑːrɪbɔːldi",
    "garibaldis": "ɡɑːrɪbɔːldɪz",
    "garish": "ɡeərɪʃ",
    "garishly": "ɡeərɪʃli",
    "garlanded": "ɡɑːləndɪd",
    "garlanding": "ɡɑːləndɪŋ",
    "garland": "ɡɑːlənd",
    "garlands": "ɡɑːləndz",
    "garlicky": "ɡɑːlɪki",
    "garlic": "ɡɑːlɪk",
    "garment": "ɡɑːmənt",
    "garments": "ɡɑːmənts",
    "garnered": "ɡɑːnəd",
    "garnering": "ɡɑːnərɪŋ",
    "garner": "ɡɑːnɐ",
    "garners": "ɡɑːnəz",
    "garnet": "ɡɑːnɪt",
    "garnets": "ɡɑːnɪts",
    "garnished": "ɡɑːnɪʃt",
    "garnishes": "ɡɑːnɪʃɪz",
    "garnishing": "ɡɑːnɪʃɪŋ",
    "garnish": "ɡɑːnɪʃ",
    "garniture": "ɡɑːnɪtʃɐ",
    "garotte": "ɡərɒt",
    "garret": "ɡærɪt",
    "garrets": "ɡærɪts",
    "garrison": "ɡærɪsən",
    "garrisoned": "ɡærɪsənd",
    "garrisoning": "ɡærɪsənɪŋ",
    "garrisons": "ɡærɪsənz",
    "garrotes": "ɡɐrɒts",
    "garrotte": "ɡærɒt",
    "garrotted": "ɡərrɒtɪd",
    "garrotting": "ɡərrɒtɪŋ",
    "garrulous": "ɡærjʊləs",
    "gars": "ɡɑːz",
    "garters": "ɡɑːtəz",
    "garter": "ɡɑːtɐ",
    "garth": "ɡɑːθ",
    "garvey": "ɡɑːveɪ",
    "gas": "ɡæs",
    "gasbag": "ɡæsbæɡ",
    "gaseous": "ɡeɪsiəs",
    "gases": "ɡæsɪz",
    "gash": "ɡæʃ",
    "gashed": "ɡæʃt",
    "gashes": "ɡæʃɪz",
    "gashing": "ɡæʃɪŋ",
    "gasket": "ɡɑːskɪt",
    "gaskets": "ɡɑːskɪts",
    "gaskin": "ɡɑːskɪn",
    "gaslight": "ɡæslaɪt",
    "gaslights": "ɡæslaɪts",
    "gasman": "ɡæzmən",
    "gasmen": "ɡæzmɛn",
    "gasohol": "ɡæsəʊhɒl",
    "gasolier": "ɡæsəliɐ",
    "gasoline": "ɡæsəliːn",
    "gasometer": "ɡæsɒmɪtɐ",
    "gasometers": "ɡæsɒmɪtəz",
    "gasped": "ɡɑːspt",
    "gasper": "ɡɑːspɐ",
    "gasping": "ɡɑːspɪŋ",
    "gasp": "ɡɑːsp",
    "gasps": "ɡɑːsps",
    "gassed": "ɡæst",
    "gasses": "ɡæsɪz",
    "gassiest": "ɡæsɪəst",
    "gassing": "ɡæsɪŋ",
    "gassings": "ɡæsɪŋz",
    "gassy": "ɡæsi",
    "gastrectomy": "ɡɑːstrɛktəmi",
    "gastric": "ɡɑːstrɪk",
    "gastritis": "ɡɑːstraɪtɪs",
    "gastroenteritis": "ɡæstrəʊntəraɪtɪs",
    "gastroenterologist": "ɡæstrəʊntərɒlədʒɪst",
    "gastroenterology": "ɡæstrəʊntərɒlədʒi",
    "gastrointestinal": "ɡæstrɔɪntɛstɪnəl",
    "gastronome": "ɡæstrənəʊm",
    "gastronomes": "ɡæstrənəʊmz",
    "gastronomic": "ɡæstrənɒmɪk",
    "gastronomical": "ɡæstrənɒmɪkəl",
    "gastronomically": "ɡæstrənɒmɪkli",
    "gastronomy": "ɡæstrɒnəmi",
    "gastropod": "ɡæstrəpɒd",
    "gastropods": "ɡæstrəpɒdz",
    "gastrostomy": "ɡæstrɒstəmi",
    "gasworks": "ɡæswɜːks",
    "gat": "ɡæt",
    "gateau": "ɡætəʊ",
    "gateaus": "ɡætəʊz",
    "gateaux": "ɡætəʊ",
    "gatecrashed": "ɡeɪtkræʃt",
    "gatecrasher": "ɡeɪtkræʃɐ",
    "gatecrashers": "ɡeɪtkræʃəz",
    "gatecrashes": "ɡeɪtkræʃɪz",
    "gatecrash": "ɡeɪtkræʃ",
    "gatecrashing": "ɡeɪtkræʃɪŋ",
    "gated": "ɡeɪtɪd",
    "gate": "ɡeɪt",
    "gatefold": "ɡeɪtfəʊld",
    "gatehouse": "ɡeɪthaʊs",
    "gatehouses": "ɡeɪthaʊzɪz",
    "gatekeeper": "ɡeɪtkiːpɐ",
    "gatekeepers": "ɡeɪtkiːpəz",
    "gatepost": "ɡeɪtpəʊst",
    "gateposts": "ɡeɪtpəʊsts",
    "gater": "ɡeɪtɐ",
    "gates": "ɡeɪts",
    "gateway": "ɡeɪtweɪ",
    "gateways": "ɡeɪtweɪz",
    "gather": "ɡæðɐ",
    "gathered": "ɡæðəd",
    "gatherer": "ɡæðərɐ",
    "gatherers": "ɡæðərəz",
    "gathering": "ɡæðərɪŋ",
    "gatherings": "ɡæðərɪŋz",
    "gathers": "ɡæðəz",
    "gating": "ɡeɪtɪŋ",
    "gator": "ɡeɪtɐ",
    "gators": "ɡeɪtəz",
    "gats": "ɡæts",
    "gauche": "ɡəʊʃ",
    "gaucho": "ɡɔːtʃəʊ",
    "gauchos": "ɡɔːtʃəʊz",
    "gaudier": "ɡɔːdɪɐ",
    "gaudiest": "ɡɔːdɪəst",
    "gaudily": "ɡɔːdɪli",
    "gaud": "ɡɔːd",
    "gaudy": "ɡɔːdi",
    "gauged": "ɡeɪdʒd",
    "gauge": "ɡeɪdʒ",
    "gauges": "ɡeɪdʒɪz",
    "gauging": "ɡeɪdʒɪŋ",
    "gauntlet": "ɡɔːntlət",
    "gauntlets": "ɡɔːntləts",
    "gaunt": "ɡɔːnt",
    "gaur": "ɡɔː",
    "gauss": "ɡaʊs",
    "gauze": "ɡɔːz",
    "gave": "ɡeɪv",
    "gavel": "ɡævəl",
    "gavels": "ɡævəlz",
    "gavotte": "ɡævɒt",
    "gawd": "ɡɔːd",
    "gawker": "ɡɔːkɐ",
    "gawkiness": "ɡɔːkinəs",
    "gawking": "ɡɔːkɪŋ",
    "gawk": "ɡɔːk",
    "gawky": "ɡɔːki",
    "gawped": "ɡɔːpt",
    "gawping": "ɡɔːpɪŋ",
    "gawp": "ɡɔːp",
    "gawps": "ɡɔːps",
    "gay": "ɡeɪ",
    "gayer": "ɡeɪɐ",
    "gayest": "ɡeɪəst",
    "gayness": "ɡeɪnəs",
    "gays": "ɡeɪz",
    "gazebos": "ɡɐziːbəʊz",
    "gazebo": "ɡɐziːbəʊ",
    "gazed": "ɡeɪzd",
    "gaze": "ɡeɪz",
    "gazelle": "ɡəzɛl",
    "gazelles": "ɡəzɛlz",
    "gazer": "ɡeɪzɐ",
    "gazers": "ɡeɪzəz",
    "gazes": "ɡeɪzɪz",
    "gazetteer": "ɡəzɪtiə",
    "gazette": "ɡəzɛt",
    "gazettes": "ɡəzɛts",
    "gazillion": "ɡæzɪliən",
    "gazillions": "ɡæzɪliənz",
    "gazing": "ɡeɪzɪŋ",
    "gazpacho": "ɡæzpætʃəʊ",
    "gazump": "ɡæzʌmp",
    "gazumped": "ɡæzʌmpt",
    "gazumping": "ɡæzʌmpɪŋ",
    "g": "dʒiː",
    "gean": "dʒiːn",
    "gearboxes": "ɡiəbɒksɪz",
    "gearbox": "ɡiəbɒks",
    "geared": "ɡiəd",
    "gear": "ɡiə",
    "gearing": "ɡiərɪŋ",
    "gearshift": "ɡiəʃɪft",
    "gears": "ɡiəz",
    "gearstick": "ɡiəstɪk",
    "gearwheel": "ɡiəwiːl",
    "gearwheels": "ɡiəwiːlz",
    "gecko": "ɡɛkəʊ",
    "geckos": "ɡɛkəʊz",
    "geddit": "ɡɛdɪt",
    "geed": "dʒiːd",
    "gee": "dʒiː",
    "geeing": "dʒiːɪŋ",
    "geekiest": "ɡiːkɪəst",
    "geek": "ɡiːk",
    "geeks": "ɡiːks",
    "geeky": "ɡiːki",
    "gees": "dʒiːz",
    "geese": "ɡiːs",
    "geest": "dʒiːst",
    "geez": "dʒiːz",
    "geezer": "ɡiːzɐ",
    "geezers": "ɡiːzəz",
    "geisha": "dʒeɪʃɐ",
    "geishas": "dʒeɪʃəz",
    "gelatin": "dʒɛlɐtɪn",
    "gelatine": "dʒɛlɐtiːn",
    "gelatinous": "dʒɛlætɪnəs",
    "gelded": "ɡɛldɪd",
    "geld": "ɡɛld",
    "gelding": "ɡɛldɪŋ",
    "geldings": "ɡɛldɪŋz",
    "gelignite": "dʒɛlɪɡnaɪt",
    "gelled": "dʒɛld",
    "gelling": "dʒɛlɪŋ",
    "gels": "dʒɛlz",
    "gelt": "dʒɛlt",
    "gem": "dʒɛm",
    "gemma": "dʒɛmɐ",
    "gemmologist": "dʒɛmɒlədʒɪst",
    "gemmology": "dʒɛmɒlədʒi",
    "gemmy": "dʒɛmi",
    "gemological": "dʒɛməlɒdʒɪkəl",
    "gemologist": "dʒɛmɒlədʒɪst",
    "gemsbok": "dʒɛmsbɒk",
    "gems": "dʒɛmz",
    "gemstone": "dʒɛmstəʊn",
    "gemstones": "dʒɛmstəʊnz",
    "gendarme": "dʒɛndɑːm",
    "gendarmerie": "dʒɛndɑːməri",
    "gendarmes": "dʒɛndɑːmz",
    "gender": "dʒɛndɐ",
    "gendered": "dʒɛndəd",
    "genderless": "dʒɛndələs",
    "genders": "dʒɛndəz",
    "genealogical": "dʒiːnɪælɒdʒɪkəl",
    "genealogies": "dʒiːnɪælədʒɪz",
    "genealogist": "dʒiːnɪælədʒɪst",
    "genealogists": "dʒiːnɪælədʒɪsts",
    "genealogy": "dʒiːnɪælədʒi",
    "gene": "dʒiːn",
    "genera": "dʒɛnərɐ",
    "general": "dʒɛnərəl",
    "generalisable": "dʒɛnərəlaɪzəbəl",
    "generalisation": "dʒɛnərəlaɪzeɪʃən",
    "generalisations": "dʒɛnərəlaɪzeɪʃənz",
    "generalised": "dʒɛnərəlaɪzd",
    "generalise": "dʒɛnərəlaɪz",
    "generalising": "dʒɛnərəlaɪzɪŋ",
    "generalissimo": "dʒɛnərɐlɪsɪməʊ",
    "generalist": "dʒɛnərəlɪst",
    "generalists": "dʒɛnərəlɪsts",
    "generalities": "dʒɛnərælɪtiz",
    "generality": "dʒɛnərælɪti",
    "generally": "dʒɛnərəli",
    "generals": "dʒɛnərəlz",
    "generalship": "dʒɛnərəlʃɪp",
    "generated": "dʒɛnəreɪtɪd",
    "generate": "dʒɛnəreɪt",
    "generates": "dʒɛnəreɪts",
    "generating": "dʒɛnəreɪtɪŋ",
    "generational": "dʒɛnəreɪʃənəl",
    "generation": "dʒɛnəreɪʃən",
    "generations": "dʒɛnəreɪʃənz",
    "generative": "dʒɛnərətɪv",
    "generator": "dʒɛnəreɪtɐ",
    "generators": "dʒɛnəreɪtəz",
    "generically": "dʒənɛrɪkli",
    "generic": "dʒənɛrɪk",
    "generosity": "dʒɛnərɒsɪti",
    "generous": "dʒɛnərəs",
    "generously": "dʒɛnərəsli",
    "genes": "dʒiːnz",
    "genesis": "dʒɛnɪsɪs",
    "genet": "dʒɛnɪt",
    "genetically": "dʒɛnɛtɪkli",
    "genetic": "dʒɛnɛtɪk",
    "geneticist": "dʒɛnɛtɪsɪst",
    "geneticists": "dʒɛnɛtɪsɪsts",
    "genetics": "dʒɛnɛtɪks",
    "geneva": "dʒəniːvɐ",
    "genial": "dʒiːnɪəl",
    "geniality": "dʒiːnɪælɪti",
    "genially": "dʒiːnɪəli",
    "genic": "dʒɛnɪk",
    "genie": "dʒiːni",
    "genies": "dʒɛnɪz",
    "genii": "dʒiːnɪaɪ",
    "genip": "dʒɛnɪp",
    "genital": "dʒɛnɪtəl",
    "genitalia": "dʒɛnɪteɪliə",
    "genitally": "dʒɛnɪtəli",
    "genitals": "dʒɛnɪtəlz",
    "genitive": "dʒɛnɪtɪv",
    "genius": "dʒiːnɪəs",
    "geniuses": "dʒiːnɪəsɪz",
    "genned": "dʒɛnd",
    "genning": "dʒɛnɪŋ",
    "genoa": "dʒɛnəʊɐ",
    "genocidal": "dʒɛnəsaɪdəl",
    "genocide": "dʒɛnəsaɪd",
    "genocides": "dʒɛnəsaɪdz",
    "genome": "dʒiːnəʊm",
    "genomes": "dʒiːnəʊmz",
    "genomic": "dʒɛnɒmɪk",
    "genomics": "dʒɛnɒmɪks",
    "genotype": "dʒɛnətaɪp",
    "genres": "ʒɒnrəz",
    "genre": "ʒɒnrɐ",
    "gens": "dʒɛnz",
    "gent": "dʒɛnt",
    "genteel": "dʒɛntiːl",
    "gentes": "dʒɛnts",
    "gentian": "dʒɛnʃən",
    "gentians": "dʒɛnʃənz",
    "gentile": "dʒɛntaɪl",
    "gentiles": "dʒɛntaɪlz",
    "gentility": "dʒɛntɪlɪti",
    "gentle": "dʒɛntəl",
    "gentlefolk": "dʒɛntəlfəʊk",
    "gentleman": "dʒɛntəlmən",
    "gentlemanly": "dʒɛntəlmənli",
    "gentlemen": "dʒɛntəlmən",
    "gentleness": "dʒɛntəlnəs",
    "gentler": "dʒɛntlɐ",
    "gentles": "dʒɛntəlz",
    "gentlest": "dʒɛntləst",
    "gentlewoman": "dʒɛntəlwʊmən",
    "gentlewomen": "dʒɛntəlwɪmɪn",
    "gently": "dʒɛntli",
    "gentrification": "dʒɛntrɪfɪkeɪʃən",
    "gentrified": "dʒɛntrɪfaɪd",
    "gentrify": "dʒɛntrɪfaɪ",
    "gentrifying": "dʒɛntrɪfaɪɪŋ",
    "gentry": "dʒɛntri",
    "gents": "dʒɛnts",
    "genu": "dʒɛnuː",
    "genuflect": "dʒɛnəflɛkt",
    "genuflection": "dʒɛnəflɛkʃən",
    "genuine": "dʒɛnjuːɪn",
    "genuinely": "dʒɛnjuːɪnli",
    "genuineness": "dʒɛnjuːɪnnəs",
    "genus": "dʒɛnəs",
    "geocentric": "dʒiːəʊsɛntrɪk",
    "geodesic": "dʒiːəʊdɛsɪk",
    "geodetic": "dʒiːəʊdɛtɪk",
    "geographer": "dʒɪɒɡrəfɐ",
    "geographers": "dʒɪɒɡrəfəz",
    "geographical": "dʒɪəɡræfɪkəl",
    "geographically": "dʒɪəɡræfɪkli",
    "geographic": "dʒɪəɡræfɪk",
    "geographies": "dʒɪɒɡrəfɪz",
    "geography": "dʒɪɒɡrəfi",
    "geological": "dʒɪəlɒdʒɪkəl",
    "geologically": "dʒɪəlɒdʒɪkli",
    "geologic": "dʒɪəlɒdʒɪk",
    "geologist": "dʒɪɒlədʒɪst",
    "geologists": "dʒɪɒlədʒɪsts",
    "geology": "dʒɪɒlədʒi",
    "geomagnetic": "dʒiːəʊmɐɡnɛtɪk",
    "geometer": "dʒiːəʊmiːtɐ",
    "geometrical": "dʒiːəʊmɛtrɪkəl",
    "geometrically": "dʒiːəʊmɛtrɪkli",
    "geometric": "dʒiːəʊmɛtrɪk",
    "geometries": "dʒiɒmətriz",
    "geometry": "dʒiɒmətri",
    "geomorphology": "dʒiːəʊmɔːfɒlədʒi",
    "geophysical": "dʒiːəʊfɪzɪkəl",
    "geophysicist": "dʒiːəʊfɪzɪsɪst",
    "geophysicists": "dʒiːəʊfɪzɪsɪsts",
    "geophysics": "dʒiːəʊfɪzɪks",
    "geopolitical": "dʒiːəʊpəlɪtɪkəl",
    "geopolitically": "dʒiːəʊpəlɪtɪkli",
    "geopolitics": "dʒiːəʊpəlɪtɪks",
    "geostationary": "dʒiːəʊsteɪʃənəri",
    "geothermal": "dʒiːəʊθɜːməl",
    "geranium": "dʒəreɪniəm",
    "geraniums": "dʒəreɪniəmz",
    "gerbil": "dʒɜːbɪl",
    "gerbils": "dʒɜːbɪlz",
    "geriatric": "dʒɛrɪætrɪk",
    "geriatrician": "dʒɛrɪɐtrɪʃən",
    "geriatrics": "dʒɛrɪætrɪks",
    "germander": "dʒɜːmɑːndɐ",
    "german": "dʒɜːmən",
    "germane": "dʒɜːmeɪn",
    "germanic": "dʒɜːmænɪk",
    "germanium": "dʒɜːmeɪniəm",
    "germ": "dʒɜːm",
    "germinal": "dʒɜːmɪnəl",
    "germinated": "dʒɜːmɪneɪtɪd",
    "germinate": "dʒɜːmɪneɪt",
    "germinates": "dʒɜːmɪneɪts",
    "germinating": "dʒɜːmɪneɪtɪŋ",
    "germination": "dʒɜːmɪneɪʃən",
    "germinator": "dʒɜːmɪneɪtɐ",
    "germs": "dʒɜːmz",
    "germy": "dʒɜːmi",
    "gerontology": "dʒɛrəntɒlədʒi",
    "gerrymander": "dʒɛrɪmɑːndɐ",
    "gerrymandered": "dʒɛrɪmɑːndəd",
    "gerrymandering": "dʒɛrɪmɑːndərɪŋ",
    "gerund": "dʒɛrʌnd",
    "gerunds": "dʒɛrʌndz",
    "gesso": "dʒɛsəʊ",
    "gestalt": "ɡəʃtɑːlt",
    "gestapo": "dʒɛstɑːpəʊ",
    "gestate": "dʒɪsteɪt",
    "gestating": "dʒɪsteɪtɪŋ",
    "gestational": "dʒɛsteɪʃənəl",
    "gestation": "dʒɛsteɪʃən",
    "gest": "dʒɛst",
    "gesticulate": "dʒɛstɪkjʊleɪt",
    "gesticulates": "dʒɛstɪkjʊleɪts",
    "gesticulating": "dʒɛstɪkjʊleɪtɪŋ",
    "gesticulation": "dʒɛstɪkjʊleɪʃən",
    "gesticulations": "dʒɛstɪkjʊleɪʃənz",
    "gestural": "dʒɛstʃərəl",
    "gestured": "dʒɛstʃəd",
    "gesture": "dʒɛstʃɐ",
    "gestures": "dʒɛstʃəz",
    "gesturing": "dʒɛstʃərɪŋ",
    "gesundheit": "dʒɛsəndhaɪt",
    "getaway": "ɡɛtəweɪ",
    "getaways": "ɡɛtəweɪz",
    "get": "ɡɛt",
    "gets": "ɡɛts",
    "gettable": "ɡɛtəbəl",
    "getter": "ɡɛtɐ",
    "getting": "ɡɛtɪŋ",
    "getup": "ɡɛtʌp",
    "geum": "dʒiːəm",
    "geyser": "ɡiːzɐ",
    "geysers": "ɡiːzəz",
    "ghastliest": "ɡɑːsliəst",
    "ghastliness": "ɡɑːstlinəs",
    "ghastly": "ɡɑːstli",
    "ghat": "ɡæt",
    "ghats": "ɡæts",
    "ghazi": "ɡeɪzi",
    "ghee": "ɡiː",
    "gherkin": "ɡɜːkɪn",
    "gherkins": "ɡɜːkɪnz",
    "ghettoes": "ɡɛtəʊz",
    "ghetto": "ɡɛtəʊ",
    "ghettoisation": "ɡɛtɔɪseɪʃən",
    "ghettoised": "ɡɛtɔɪsd",
    "ghettoise": "ɡɛtɔɪs",
    "ghettos": "ɡɛtəʊz",
    "ghosted": "ɡəʊstɪd",
    "ghost": "ɡəʊst",
    "ghosting": "ɡəʊstɪŋ",
    "ghostlike": "ɡəʊstlaɪk",
    "ghostly": "ɡəʊstli",
    "ghosts": "ɡəʊsts",
    "ghostwriter": "ɡəʊstraɪtɐ",
    "ghostwriting": "ɡəʊstraɪtɪŋ",
    "ghoulishly": "ɡuːlɪʃli",
    "ghoulish": "ɡuːlɪʃ",
    "ghouls": "ɡuːlz",
    "ghoul": "ɡuːl",
    "ghyll": "ɡɪl",
    "giant": "dʒaɪənt",
    "giantess": "dʒaɪəntɛs",
    "giants": "dʒaɪənts",
    "gibber": "dʒɪbɐ",
    "gibbering": "dʒɪbərɪŋ",
    "gibberish": "dʒɪbərɪʃ",
    "gibbers": "dʒɪbəz",
    "gibbet": "dʒɪbɪt",
    "gibbets": "dʒɪbɪts",
    "gibbon": "ɡɪbən",
    "gibbons": "ɡɪbənz",
    "gibbous": "ɡɪbəs",
    "gib": "dʒɪb",
    "gibes": "dʒaɪbz",
    "giblet": "dʒɪblət",
    "giblets": "dʒɪbləts",
    "gid": "ɡɪd",
    "giddier": "ɡɪdɪɐ",
    "giddiness": "ɡɪdɪnəs",
    "giddy": "ɡɪdi",
    "gie": "dʒaɪ",
    "gifted": "ɡɪftɪd",
    "gift": "ɡɪft",
    "gifting": "ɡɪftɪŋ",
    "gifts": "ɡɪfts",
    "gig": "ɡɪɡ",
    "gigabit": "ɡɪɡəbɪt",
    "gigabits": "ɡɪɡəbɪts",
    "gigabyte": "ɡɪɡəbaɪt",
    "gigabytes": "ɡɪɡəbaɪts",
    "gigahertz": "ɡɪɡəhɜːts",
    "gigantically": "dʒaɪɡæntɪkli",
    "gigantic": "dʒaɪɡæntɪk",
    "gigantism": "ɡɪɡəntɪzəm",
    "gigawatt": "ɡɪɡəwɒt",
    "gigawatts": "ɡɪɡəwɒts",
    "gigged": "ɡɪɡd",
    "gigging": "ɡɪɡɪŋ",
    "giggled": "ɡɪɡəld",
    "giggle": "ɡɪɡəl",
    "giggler": "ɡɪɡlɐ",
    "gigglers": "ɡɪɡləz",
    "giggles": "ɡɪɡəlz",
    "giggling": "ɡɪɡlɪŋ",
    "giggly": "ɡɪɡli",
    "gigolo": "dʒɪɡɒləʊ",
    "gigolos": "dʒɪɡɒləʊz",
    "gigot": "dʒɪɡət",
    "gigs": "ɡɪɡz",
    "gilbert": "ɡɪlbət",
    "gilberts": "ɡɪlbəts",
    "gilded": "ɡɪldɪd",
    "gilder": "ɡɪldɐ",
    "gilders": "ɡɪldəz",
    "gilding": "ɡɪldɪŋ",
    "gild": "ɡɪld",
    "gilds": "ɡɪldz",
    "gillies": "ɡɪliz",
    "gilt": "ɡɪlt",
    "gilts": "ɡɪlts",
    "gimbal": "ɡɪmbəl",
    "gimbals": "ɡɪmbəlz",
    "gimcracks": "ɡɪmkræks",
    "gimel": "ɡɪməl",
    "gimlet": "ɡɪmlət",
    "gimme": "ɡɪmi",
    "gimmes": "ɡɪmiz",
    "gimmick": "ɡɪmɪk",
    "gimmickry": "ɡɪmɪkri",
    "gimmicks": "ɡɪmɪks",
    "gimmicky": "ɡɪmɪki",
    "gimp": "ɡɪmp",
    "gimps": "ɡɪmps",
    "gimpy": "ɡɪmpi",
    "gin": "dʒɪn",
    "gingerbread": "dʒɪndʒəbrɛd",
    "ginger": "dʒɪndʒɐ",
    "gingered": "dʒɪndʒəd",
    "gingerly": "dʒɪndʒəli",
    "gingers": "dʒɪndʒəz",
    "gingery": "dʒɪndʒəri",
    "gingham": "dʒɪŋəm",
    "gingivitis": "dʒɪŋɡɪvaɪtɪs",
    "gingko": "dʒɪŋkəʊ",
    "gink": "dʒɪŋk",
    "ginkgo": "dʒɪŋkɡəʊ",
    "ginny": "dʒɪni",
    "ginormous": "dʒɪnɔːməs",
    "gins": "dʒɪnz",
    "ginseng": "dʒɪnsɛŋ",
    "gip": "dʒɪp",
    "gipsy": "dʒɪpsi",
    "giraffe": "dʒɪrɑːf",
    "giraffes": "dʒɪrɑːfs",
    "girandole": "dʒɜːrɐndəʊl",
    "gird": "ɡɜːd",
    "girded": "ɡɜːdɪd",
    "girder": "ɡɜːdɐ",
    "girders": "ɡɜːdəz",
    "girding": "ɡɜːdɪŋ",
    "girdled": "ɡɜːdəld",
    "girdle": "ɡɜːdəl",
    "girdles": "ɡɜːdəlz",
    "girdling": "ɡɜːdlɪŋ",
    "girds": "ɡɜːdz",
    "girlfriend": "ɡɜːlfrɛnd",
    "girlfriends": "ɡɜːlfrɛndz",
    "girlhood": "ɡɜːlhʊd",
    "girlie": "ɡɜːli",
    "girlies": "ɡɜːliz",
    "girlish": "ɡɜːlɪʃ",
    "girlishly": "ɡɜːlɪʃli",
    "girl": "ɡɜːl",
    "girls": "ɡɜːlz",
    "girly": "ɡɜːli",
    "giro": "dʒaɪrəʊ",
    "giros": "dʒaɪrəʊz",
    "girths": "ɡɜːθs",
    "girth": "ɡɜːθ",
    "girt": "ɡɜːt",
    "gismo": "dʒɪsməʊ",
    "gist": "dʒɪst",
    "gite": "ɡaɪt",
    "gits": "ɡɪts",
    "git": "ɡɪt",
    "gittern": "ɡɪtən",
    "giveaways": "ɡɪvɐweɪz",
    "giveaway": "ɡɪvɐweɪ",
    "givens": "ɡɪvənz",
    "given": "ɡɪvən",
    "givers": "ɡɪvəz",
    "giver": "ɡɪvɐ",
    "gives": "ɡɪvz",
    "give": "ɡɪv",
    "givings": "ɡɪvɪŋz",
    "giving": "ɡɪvɪŋ",
    "gizmos": "ɡɪzməʊz",
    "gizmo": "ɡɪzməʊ",
    "gizzards": "ɡɪzədz",
    "gizzard": "ɡɪzəd",
    "glabella": "ɡleɪbɛlɐ",
    "glacial": "ɡleɪʃəl",
    "glaciated": "ɡleɪsɪeɪtɪd",
    "glaciation": "ɡleɪsɪeɪʃən",
    "glacier": "ɡleɪʃɐ",
    "glaciers": "ɡleɪʃəz",
    "glaciologist": "ɡleɪsɪɒlədʒɪst",
    "glaciologists": "ɡleɪsɪɒlədʒɪsts",
    "glaciology": "ɡleɪsɪɒlədʒi",
    "gladdened": "ɡlædənd",
    "gladdening": "ɡlædənɪŋ",
    "gladden": "ɡlædən",
    "gladdens": "ɡlædənz",
    "gladder": "ɡlædɐ",
    "gladdest": "ɡlædəst",
    "glade": "ɡleɪd",
    "glades": "ɡleɪdz",
    "gladiatorial": "ɡlædɪɐtɔːrɪəl",
    "gladiator": "ɡlædɪeɪtɐ",
    "gladiators": "ɡlædɪeɪtəz",
    "gladiolas": "ɡlædɪəʊləz",
    "gladioli": "ɡlædɪəʊli",
    "gladiolus": "ɡlædɪəʊləs",
    "glad": "ɡlæd",
    "gladly": "ɡlædli",
    "gladness": "ɡlædnəs",
    "glads": "ɡlædz",
    "gladsome": "ɡlædsʌm",
    "gladstone": "ɡlædstəʊn",
    "gladstones": "ɡlædstəʊnz",
    "glaikit": "ɡleɪkɪt",
    "glam": "ɡlæm",
    "glamorisation": "ɡlæmɔːraɪzeɪʃən",
    "glamorised": "ɡlæmɔːraɪzd",
    "glamorise": "ɡlæmɔːraɪz",
    "glamorising": "ɡlæmɔːraɪzɪŋ",
    "glamorous": "ɡlæmərəs",
    "glamorously": "ɡlæmərəsli",
    "glamour": "ɡlæmɐ",
    "glamourous": "ɡlæmɜːrəs",
    "glanced": "ɡlɑːnst",
    "glance": "ɡlɑːns",
    "glances": "ɡlɑːnsɪz",
    "glancing": "ɡlɑːnsɪŋ",
    "gland": "ɡlænd",
    "glands": "ɡlændz",
    "glandular": "ɡlændjʊlɐ",
    "glans": "ɡlænz",
    "glared": "ɡleəd",
    "glare": "ɡleə",
    "glares": "ɡleəz",
    "glaring": "ɡleərɪŋ",
    "glaringly": "ɡleərɪŋli",
    "glasnost": "ɡlæsnɒst",
    "glassblower": "ɡlɑːsbləʊɐ",
    "glassblowers": "ɡlɑːsbləʊəz",
    "glassblowing": "ɡlɑːsbləʊɪŋ",
    "glassed": "ɡlɑːst",
    "glasses": "ɡlɑːsɪz",
    "glassful": "ɡlɑːsfəl",
    "glasshouse": "ɡlɑːshaʊs",
    "glasshouses": "ɡlɑːshaʊzɪz",
    "glassing": "ɡlɑːsɪŋ",
    "glassless": "ɡlɑːsləs",
    "glass": "ɡlɑːs",
    "glassman": "ɡlɑːsmən",
    "glassware": "ɡlɑːsweə",
    "glasswork": "ɡlɑːswɜːk",
    "glassworks": "ɡlɑːswɜːks",
    "glasswort": "ɡlɑːswɔːt",
    "glassy": "ɡlɑːsi",
    "glaucoma": "ɡlɔːkəʊmɐ",
    "glaucous": "ɡlɔːkəs",
    "glazed": "ɡleɪzd",
    "glaze": "ɡleɪz",
    "glazer": "ɡleɪzɐ",
    "glazers": "ɡleɪzəz",
    "glazes": "ɡleɪzɪz",
    "glazier": "ɡleɪzɪɐ",
    "glaziers": "ɡleɪziəz",
    "glazing": "ɡleɪzɪŋ",
    "gleamed": "ɡliːmd",
    "gleaming": "ɡliːmɪŋ",
    "gleam": "ɡliːm",
    "gleams": "ɡliːmz",
    "gleaned": "ɡliːnd",
    "gleaner": "ɡliːnɐ",
    "gleaning": "ɡliːnɪŋ",
    "gleanings": "ɡliːnɪŋz",
    "glean": "ɡliːn",
    "gleans": "ɡliːnz",
    "gleeful": "ɡliːfəl",
    "gleefully": "ɡliːfəli",
    "glee": "ɡliː",
    "glengarry": "ɡlɛŋɡæri",
    "glen": "ɡlɛn",
    "glens": "ɡlɛnz",
    "gley": "ɡleɪ",
    "glia": "ɡlaɪɐ",
    "glib": "ɡlɪb",
    "glibly": "ɡlɪbli",
    "glibness": "ɡlɪbnəs",
    "glided": "ɡlaɪdɪd",
    "glide": "ɡlaɪd",
    "glider": "ɡlaɪdɐ",
    "gliders": "ɡlaɪdəz",
    "glides": "ɡlaɪdz",
    "gliding": "ɡlaɪdɪŋ",
    "glimmered": "ɡlɪməd",
    "glimmering": "ɡlɪmərɪŋ",
    "glimmerings": "ɡlɪmərɪŋz",
    "glimmer": "ɡlɪmɐ",
    "glimmers": "ɡlɪməz",
    "glimpsed": "ɡlɪmpsd",
    "glimpse": "ɡlɪmps",
    "glimpses": "ɡlɪmpsɪz",
    "glimpsing": "ɡlɪmpsɪŋ",
    "glinted": "ɡlɪntɪd",
    "glinting": "ɡlɪntɪŋ",
    "glint": "ɡlɪnt",
    "glints": "ɡlɪnts",
    "glioma": "ɡlɪəʊmɐ",
    "glissandi": "ɡlɪsændi",
    "glissando": "ɡlɪsændəʊ",
    "glissandos": "ɡlɪsændəʊz",
    "glistened": "ɡlɪsənd",
    "glistening": "ɡlɪsənɪŋ",
    "glisten": "ɡlɪsən",
    "glistens": "ɡlɪsənz",
    "glisters": "ɡlɪstəz",
    "glitches": "ɡlɪtʃɪz",
    "glitch": "ɡlɪtʃ",
    "glitterati": "ɡlɪtərɑːti",
    "glittered": "ɡlɪtəd",
    "glittering": "ɡlɪtərɪŋ",
    "glitter": "ɡlɪtɐ",
    "glitters": "ɡlɪtəz",
    "glittery": "ɡlɪtəri",
    "glitziest": "ɡlɪtsɪəst",
    "glitz": "ɡlɪts",
    "glitzy": "ɡlɪtsi",
    "gloaming": "ɡləʊmɪŋ",
    "gloam": "ɡləʊm",
    "gloated": "ɡləʊtɪd",
    "gloating": "ɡləʊtɪŋ",
    "gloat": "ɡləʊt",
    "gloats": "ɡləʊts",
    "globalisation": "ɡləʊbəlaɪzeɪʃən",
    "globalised": "ɡləʊbəlaɪzd",
    "globalise": "ɡləʊbəlaɪz",
    "globalising": "ɡləʊbəlaɪzɪŋ",
    "globalism": "ɡləʊbəlɪzəm",
    "global": "ɡləʊbəl",
    "globally": "ɡləʊbəli",
    "globe": "ɡləʊb",
    "globes": "ɡləʊbz",
    "globetrotter": "ɡləʊbtrɒtɐ",
    "globetrotters": "ɡləʊbtrɒtəz",
    "globetrotting": "ɡləʊbtrɒtɪŋ",
    "glob": "ɡlɒb",
    "globs": "ɡlɒbz",
    "globular": "ɡlɒbjʊlɐ",
    "globule": "ɡlɒbjuːl",
    "globules": "ɡlɒbjuːlz",
    "glockenspiel": "ɡlɒkənspiːl",
    "glomerulus": "ɡlɒmərjʊləs",
    "glom": "ɡlɒm",
    "gloomier": "ɡluːmɪɐ",
    "gloomiest": "ɡluːmɪəst",
    "gloomily": "ɡluːmɪli",
    "gloominess": "ɡluːmɪnəs",
    "gloom": "ɡluːm",
    "gloomy": "ɡluːmi",
    "glop": "ɡlɒp",
    "gloried": "ɡlɔːrɪd",
    "glories": "ɡlɔːrɪz",
    "glorification": "ɡlɔːrɪfɪkeɪʃən",
    "glorified": "ɡlɔːrɪfaɪd",
    "glorifies": "ɡlɔːrɪfaɪz",
    "glorifying": "ɡlɔːrɪfaɪɪŋ",
    "glorify": "ɡlɔːrɪfaɪ",
    "glorious": "ɡlɔːrɪəs",
    "gloriously": "ɡlɔːrɪəsli",
    "gloriousness": "ɡlɔːrɪəsnəs",
    "glorying": "ɡlɔːrɪɪŋ",
    "glory": "ɡlɔːri",
    "glossary": "ɡlɒsəri",
    "glossed": "ɡlɒst",
    "glosser": "ɡlɒsɐ",
    "glosses": "ɡlɒsɪz",
    "glossier": "ɡlɒsɪɐ",
    "glossies": "ɡlɒsɪz",
    "glossiest": "ɡlɒsɪəst",
    "glossily": "ɡlɒsɪli",
    "glossiness": "ɡlɒsɪnəs",
    "glossing": "ɡlɒsɪŋ",
    "glossitis": "ɡləsaɪtɪs",
    "gloss": "ɡlɒs",
    "glossy": "ɡlɒsi",
    "glottal": "ɡlɒtəl",
    "glottis": "ɡlɒtiz",
    "gloved": "ɡlʌvd",
    "glove": "ɡlʌv",
    "glover": "ɡlʌvɐ",
    "gloves": "ɡlʌvz",
    "gloving": "ɡlʌvɪŋ",
    "glowed": "ɡləʊd",
    "glowered": "ɡlaʊəd",
    "glowering": "ɡlaʊərɪŋ",
    "glowing": "ɡləʊɪŋ",
    "glowingly": "ɡləʊɪŋli",
    "glow": "ɡləʊ",
    "glows": "ɡləʊz",
    "glowworm": "ɡləʊwɜːm",
    "glucagon": "ɡluːkəɡən",
    "glucose": "ɡluːkəʊs",
    "glued": "ɡluːd",
    "glueing": "ɡluːɪŋ",
    "glue": "ɡluː",
    "glues": "ɡluːz",
    "gluey": "ɡluːi",
    "gluing": "ɡluːɪŋ",
    "glum": "ɡlʌm",
    "glumly": "ɡlʌmli",
    "glummer": "ɡlʌmɐ",
    "glumness": "ɡlʌmnəs",
    "gluon": "ɡljuːɒn",
    "gluons": "ɡljuːɒnz",
    "glutamate": "ɡluːtɐmeɪt",
    "glutamates": "ɡluːtɐmeɪts",
    "glutamine": "ɡluːtɐmiːn",
    "gluteal": "ɡluːtiəl",
    "gluten": "ɡluːtən",
    "glutinous": "ɡluːtɪnəs",
    "glut": "ɡlʌt",
    "gluts": "ɡlʌts",
    "glutton": "ɡlʌtən",
    "gluttonous": "ɡlʌtənəs",
    "gluttons": "ɡlʌtənz",
    "gluttony": "ɡlʌtəni",
    "glycerine": "ɡlɪsəriːn",
    "glycerol": "ɡlɪsərɒl",
    "glycine": "ɡlaɪsiːn",
    "glycogen": "ɡlaɪkədʒən",
    "glycol": "ɡlaɪkɒl",
    "glycoside": "ɡlaɪkəsaɪd",
    "glyph": "ɡlɪf",
    "glyphs": "ɡlɪfz",
    "gnarled": "nɑːld",
    "gnarliest": "nɑːliəst",
    "gnarling": "nɑːlɪŋ",
    "gnarl": "nɑːl",
    "gnarls": "nɑːlz",
    "gnarly": "nɑːli",
    "gnashed": "næʃt",
    "gnashing": "næʃɪŋ",
    "gnash": "næʃ",
    "gnat": "næt",
    "gnats": "næts",
    "gnawed": "nɔːd",
    "gnawing": "nɔːrɪŋ",
    "gnaw": "nɔː",
    "gnaws": "nɔːz",
    "gneiss": "neɪs",
    "gnocchi": "nɒkaɪ",
    "gnomes": "nəʊmz",
    "gnomic": "nɒmɪk",
    "gnomon": "nɒmən",
    "gnostic": "nɒstɪk",
    "gnostics": "nɒstɪks",
    "gnu": "ɡənuː",
    "gnus": "ɡənuːz",
    "goad": "ɡəʊd",
    "goaded": "ɡəʊdɪd",
    "goading": "ɡəʊdɪŋ",
    "goads": "ɡəʊdz",
    "goa": "ɡəʊɐ",
    "goal": "ɡəʊl",
    "goalie": "ɡəʊli",
    "goalies": "ɡəʊliz",
    "goalkeeper": "ɡəʊlkiːpɐ",
    "goalkeepers": "ɡəʊlkiːpəz",
    "goalkeeping": "ɡəʊlkiːpɪŋ",
    "goalless": "ɡəʊlɛs",
    "goalmouth": "ɡəʊlmaʊθ",
    "goalpost": "ɡəʊlpəʊst",
    "goalposts": "ɡəʊlpəʊsts",
    "goalscorer": "ɡəʊlskɔːrɐ",
    "goalscorers": "ɡəʊlskɔːrəz",
    "goals": "ɡəʊlz",
    "goaltender": "ɡəʊltɛndɐ",
    "goatee": "ɡəʊtiː",
    "goatees": "ɡəʊtiːz",
    "goat": "ɡəʊt",
    "goatfish": "ɡəʊtfɪʃ",
    "goatherd": "ɡəʊðɜːd",
    "goats": "ɡəʊts",
    "goatskin": "ɡəʊtskɪn",
    "goatskins": "ɡəʊtskɪnz",
    "gob": "ɡɒb",
    "gobbed": "ɡɒbd",
    "gobbet": "ɡɒbɪt",
    "gobbets": "ɡɒbɪts",
    "gobbing": "ɡɒbɪŋ",
    "gobble": "ɡɒbəl",
    "gobbled": "ɡɒbəld",
    "gobbledegook": "ɡɒbəldɛɡʊk",
    "gobbledygook": "ɡɒbəldɪɡʊk",
    "gobbler": "ɡɒblɐ",
    "gobblers": "ɡɒbləz",
    "gobbles": "ɡɒbəlz",
    "gobbling": "ɡɒblɪŋ",
    "gobies": "ɡəʊbɪz",
    "goblet": "ɡɒblət",
    "goblets": "ɡɒbləts",
    "goblin": "ɡɒblɪn",
    "goblins": "ɡɒblɪnz",
    "gobo": "ɡəʊbəʊ",
    "gobs": "ɡɒbz",
    "gobsmacked": "ɡɒbsmækt",
    "gobstopper": "ɡɒbstɒpɐ",
    "gobstoppers": "ɡɒbstɒpəz",
    "goby": "ɡəʊbi",
    "godawful": "ɡɒdɔːfəl",
    "godchild": "ɡɒdtʃaɪld",
    "godchildren": "ɡɒdtʃɪldrən",
    "god": "ɡɒd",
    "goddam": "ɡɒdæm",
    "goddammit": "ɡɒdɐmɪt",
    "goddamn": "ɡɒdæm",
    "goddamned": "ɡɒdæmd",
    "goddaughter": "ɡɒdɔːtɐ",
    "goddaughters": "ɡɒdɔːtəz",
    "goddess": "ɡɒdɛs",
    "goddesses": "ɡɒdɛsɪz",
    "godfather": "ɡɒdfɑːðɐ",
    "godfathers": "ɡɒdfɑːðəz",
    "godforsaken": "ɡɒdfɔːseɪkən",
    "godhead": "ɡɒdhɛd",
    "godless": "ɡɒdləs",
    "godlessness": "ɡɒdləsnəs",
    "godlike": "ɡɒdlaɪk",
    "godliness": "ɡɒdlinəs",
    "godly": "ɡɒdli",
    "godmother": "ɡɒdmʌðɐ",
    "godmothers": "ɡɒdmʌðəz",
    "godowns": "ɡɒdaʊnz",
    "godparent": "ɡɒdpeərənt",
    "godparents": "ɡɒdpeərənts",
    "gods": "ɡɒdz",
    "godsend": "ɡɒdsɛnd",
    "godson": "ɡɒdsən",
    "godspeed": "ɡɒdspiːd",
    "godwit": "ɡɒdwɪt",
    "godwits": "ɡɒdwɪts",
    "go": "ɡəʊ",
    "goer": "ɡəʊɐ",
    "goers": "ɡəʊəz",
    "goes": "ɡəʊz",
    "gofer": "ɡəʊfɐ",
    "goggled": "ɡɒɡəld",
    "goggle": "ɡɒɡəl",
    "goggles": "ɡɒɡəlz",
    "goggling": "ɡɒɡlɪŋ",
    "goggly": "ɡɒɡli",
    "going": "ɡəʊɪŋ",
    "goings": "ɡəʊɪŋz",
    "goitre": "ɡɔɪtɐ",
    "goitres": "ɡɔɪtəz",
    "goldcrest": "ɡəʊldkrɛst",
    "goldcrests": "ɡəʊldkrɛsts",
    "gold": "ɡəʊld",
    "golden": "ɡəʊldən",
    "goldener": "ɡəʊldənɐ",
    "goldeneye": "ɡəʊldənaɪ",
    "goldfields": "ɡəʊldfiːldz",
    "goldfinch": "ɡəʊldfɪntʃ",
    "goldfinches": "ɡəʊldfɪntʃɪz",
    "goldfish": "ɡəʊldfɪʃ",
    "goldilocks": "ɡəʊldɪlɒks",
    "goldmine": "ɡəʊldmaɪn",
    "goldmines": "ɡəʊldmaɪnz",
    "golds": "ɡəʊldz",
    "goldsmith": "ɡəʊldsmɪθ",
    "goldsmiths": "ɡəʊldsmɪθs",
    "goldstone": "ɡəʊldstəʊn",
    "golem": "ɡəʊləm",
    "golfer": "ɡɒlfɐ",
    "golfers": "ɡɒlfəz",
    "golfing": "ɡɒlfɪŋ",
    "golf": "ɡɒlf",
    "golfs": "ɡɒlfs",
    "gollies": "ɡɒliz",
    "golliwog": "ɡəliːwɒɡ",
    "golliwogs": "ɡəliːwɒɡz",
    "golly": "ɡɒli",
    "gonadal": "ɡɒneɪdəl",
    "gonad": "ɡɒnæd",
    "gonads": "ɡɒnædz",
    "gondola": "ɡəndəʊlɐ",
    "gondolas": "ɡəndəʊləz",
    "gondolier": "ɡɒndəliɐ",
    "gondoliers": "ɡəndəʊliəz",
    "gone": "ɡɒn",
    "goner": "ɡɒnɐ",
    "goners": "ɡɒnəz",
    "gonged": "ɡɒŋd",
    "gong": "ɡɒŋ",
    "gongs": "ɡɒŋz",
    "gonna": "ɡənɐ",
    "gonorrhoea": "ɡɒnəriə",
    "gonzo": "ɡɒnzəʊ",
    "goobers": "ɡuːbəz",
    "goober": "ɡuːbɐ",
    "goodby": "ɡʊdbi",
    "goodbye": "ɡʊdbaɪ",
    "goodbyes": "ɡʊdbaɪz",
    "good": "ɡʊd",
    "goodie": "ɡʊdi",
    "goodies": "ɡʊdɪz",
    "goodish": "ɡʊdɪʃ",
    "goodliest": "ɡʊdliəst",
    "goodly": "ɡʊdli",
    "goodman": "ɡʊdmən",
    "goodness": "ɡʊdnəs",
    "goodnight": "ɡʊdnaɪt",
    "goods": "ɡʊdz",
    "goodwill": "ɡʊdwɪl",
    "goody": "ɡʊdi",
    "gooey": "ɡuːi",
    "goofballs": "ɡuːfbɔːlz",
    "goofball": "ɡuːfbɔːl",
    "goofed": "ɡuːft",
    "goofier": "ɡuːfɪɐ",
    "goofiness": "ɡuːfɪnəs",
    "goofing": "ɡuːfɪŋ",
    "goofs": "ɡuːfs",
    "goof": "ɡuːf",
    "goofy": "ɡuːfi",
    "googlies": "ɡuːɡliz",
    "googly": "ɡuːɡli",
    "googolplex": "ɡuːɡəlplɛks",
    "googol": "ɡuːɡɒl",
    "gooier": "ɡuːɪɐ",
    "gooiest": "ɡuːɪəst",
    "gook": "ɡʊk",
    "goons": "ɡuːnz",
    "goon": "ɡuːn",
    "goop": "ɡuːp",
    "goosanders": "ɡuːsændəz",
    "goosander": "ɡuːsændɐ",
    "gooseberries": "ɡuːsbərɪz",
    "gooseberry": "ɡuːsbəri",
    "goosebumps": "ɡuːsbʌmps",
    "goosed": "ɡuːsd",
    "goosegog": "ɡuːsɡɒɡ",
    "gooseneck": "ɡuːsnɛk",
    "goosestep": "ɡuːsstɛp",
    "gooses": "ɡuːsɪz",
    "goose": "ɡuːs",
    "goosing": "ɡuːsɪŋ",
    "goosy": "ɡuːsi",
    "goo": "ɡuː",
    "gopher": "ɡəʊfɐ",
    "gophers": "ɡəʊfəz",
    "gorblimey": "ɡɔːblaɪmi",
    "gored": "ɡɔːd",
    "gore": "ɡɔː",
    "gores": "ɡɔːz",
    "gorged": "ɡɔːdʒd",
    "gorge": "ɡɔːdʒ",
    "gorgeously": "ɡɔːdʒəsli",
    "gorgeousness": "ɡɔːdʒəsnəs",
    "gorgeous": "ɡɔːdʒəs",
    "gorges": "ɡɔːdʒɪz",
    "gorget": "ɡɔːɡɪt",
    "gorging": "ɡɔːdʒɪŋ",
    "gorgon": "ɡɔːɡən",
    "gorgons": "ɡɔːɡənz",
    "gorier": "ɡɔːrɪɐ",
    "goriest": "ɡɔːrɪəst",
    "gorilla": "ɡərɪlɐ",
    "gorillas": "ɡərɪləz",
    "goriness": "ɡɔːrɪnəs",
    "goring": "ɡɔːrɪŋ",
    "gormlessly": "ɡɔːmləsli",
    "gormlessness": "ɡɔːmləsnəs",
    "gormless": "ɡɔːmləs",
    "gorse": "ɡɔːs",
    "gory": "ɡɔːri",
    "gosh": "ɡɒʃ",
    "goshawk": "ɡɒʃɔːk",
    "goshawks": "ɡɒʃɔːks",
    "gosling": "ɡɒslɪŋ",
    "goslings": "ɡɒslɪŋz",
    "gospel": "ɡɒspəl",
    "gospels": "ɡɒspəlz",
    "gosport": "ɡɒspɔːt",
    "gossamer": "ɡɒsəmɐ",
    "gossiped": "ɡɒsɪpt",
    "gossipers": "ɡɒsɪpəz",
    "gossiping": "ɡɒsɪpɪŋ",
    "gossip": "ɡɒsɪp",
    "gossips": "ɡɒsɪps",
    "gossipy": "ɡɒsɪpi",
    "gotcha": "ɡɒtʃɐ",
    "gothic": "ɡɒθɪk",
    "goths": "ɡɒθs",
    "goth": "ɡɒθ",
    "got": "ɡɒt",
    "gotta": "ɡɒtɐ",
    "gotten": "ɡɒtən",
    "gouache": "ɡwɑːtʃ",
    "gouge": "ɡaʊdʒ",
    "gouged": "ɡaʊdʒd",
    "gougers": "ɡaʊdʒəz",
    "gouges": "ɡaʊdʒɪz",
    "gouging": "ɡaʊdʒɪŋ",
    "goulash": "ɡuːlæʃ",
    "gourami": "ɡɜːrɑːmi",
    "gourd": "ɡɔːd",
    "gourds": "ɡɔːdz",
    "gourmand": "ɡɔːmɑːnd",
    "gourmands": "ɡɔːmɑːndz",
    "gourmet": "ɡɔːmeɪ",
    "gourmets": "ɡɔːmeɪs",
    "gout": "ɡaʊt",
    "gouty": "ɡaʊti",
    "governable": "ɡʌvənəbəl",
    "governance": "ɡʌvənəns",
    "governed": "ɡʌvənd",
    "governesses": "ɡʌvənɛsɪz",
    "governess": "ɡʌvənɛs",
    "governing": "ɡʌvənɪŋ",
    "governmental": "ɡʌvənmɛntəl",
    "governments": "ɡʌvənmənts",
    "government": "ɡʌvənmənt",
    "governorship": "ɡʌvənəʃɪp",
    "governors": "ɡʌvənəz",
    "governor": "ɡʌvənɐ",
    "governs": "ɡʌvənz",
    "govern": "ɡʌvən",
    "gowan": "ɡaʊən",
    "gowk": "ɡaʊk",
    "gown": "ɡaʊn",
    "gowned": "ɡaʊnd",
    "gowns": "ɡaʊnz",
    "goy": "ɡɔɪ",
    "goys": "ɡɔɪz",
    "grab": "ɡræb",
    "grabbed": "ɡræbd",
    "grabber": "ɡræbɐ",
    "grabbers": "ɡræbəz",
    "grabbing": "ɡræbɪŋ",
    "grabby": "ɡræbi",
    "graben": "ɡreɪbən",
    "grabs": "ɡræbz",
    "graced": "ɡreɪst",
    "grace": "ɡreɪs",
    "graceful": "ɡreɪsfəl",
    "gracefully": "ɡreɪsfəli",
    "gracefulness": "ɡreɪsfəlnəs",
    "graceless": "ɡreɪsləs",
    "gracelessly": "ɡreɪsləsli",
    "graces": "ɡreɪsɪz",
    "gracile": "ɡræsaɪl",
    "gracing": "ɡreɪsɪŋ",
    "gracious": "ɡreɪʃəs",
    "graciously": "ɡreɪʃəsli",
    "graciousness": "ɡreɪʃəsnəs",
    "grackle": "ɡrækəl",
    "grad": "ɡræd",
    "gradation": "ɡrædeɪʃən",
    "gradations": "ɡrædeɪʃənz",
    "graded": "ɡreɪdɪd",
    "grade": "ɡreɪd",
    "gradely": "ɡreɪdli",
    "grader": "ɡreɪdɐ",
    "graders": "ɡreɪdəz",
    "grades": "ɡreɪdz",
    "gradient": "ɡreɪdiənt",
    "gradients": "ɡreɪdiənts",
    "gradin": "ɡrædɪn",
    "grading": "ɡreɪdɪŋ",
    "grads": "ɡrædz",
    "gradual": "ɡrædʒuːəl",
    "gradualism": "ɡrædʒuːəlɪzəm",
    "gradualist": "ɡrædʒuːəlɪst",
    "gradually": "ɡrædʒuːəli",
    "graduated": "ɡrædjuːeɪtɪd",
    "graduating": "ɡrædjuːeɪtɪŋ",
    "graduation": "ɡrædjuːeɪʃən",
    "graduations": "ɡrædjuːeɪʃənz",
    "graffiti": "ɡrɐfiːti",
    "graffito": "ɡræfiːtəʊ",
    "grafted": "ɡrɑːftɪd",
    "grafter": "ɡrɑːftɐ",
    "grafters": "ɡrɑːftəz",
    "graft": "ɡrɑːft",
    "grafting": "ɡrɑːftɪŋ",
    "grafts": "ɡrɑːfts",
    "graham": "ɡreɪəm",
    "grahams": "ɡreɪəmz",
    "grail": "ɡreɪl",
    "grails": "ɡreɪlz",
    "grained": "ɡreɪnd",
    "grain": "ɡreɪn",
    "grainier": "ɡreɪnɪɐ",
    "graininess": "ɡreɪnɪnəs",
    "grains": "ɡreɪnz",
    "grainy": "ɡreɪni",
    "gram": "ɡræm",
    "gramercy": "ɡræmɜːsi",
    "graminivorous": "ɡræmɪnɪvərəs",
    "grammar": "ɡræmɐ",
    "grammarian": "ɡræmeəriən",
    "grammars": "ɡræməz",
    "grammatically": "ɡræmætɪkli",
    "grammatical": "ɡrɐmætɪkəl",
    "gramophone": "ɡræməfəʊn",
    "gramophones": "ɡræməfəʊnz",
    "gramps": "ɡræmps",
    "grampus": "ɡræmpəs",
    "grams": "ɡræmz",
    "gran": "ɡræn",
    "granaries": "ɡrænəriz",
    "granary": "ɡrænəri",
    "grandad": "ɡrændæd",
    "grandads": "ɡrændædz",
    "grand": "ɡrænd",
    "grandchild": "ɡrændtʃaɪld",
    "grandchildren": "ɡrændtʃɪldrən",
    "granddad": "ɡrændæd",
    "granddaddies": "ɡrændɐdɪz",
    "granddaddy": "ɡrændɐdi",
    "granddads": "ɡrændædz",
    "granddaughter": "ɡrændɔːtɐ",
    "granddaughters": "ɡrændɔːtəz",
    "grandee": "ɡrændiː",
    "grandees": "ɡrændiːz",
    "grander": "ɡrændɐ",
    "grandest": "ɡrændəst",
    "grandeur": "ɡrændɜː",
    "grandfather": "ɡrændfɑːðɐ",
    "grandfathers": "ɡrændfɑːðəz",
    "grandiloquent": "ɡrændɪlɒkwənt",
    "grandiloquently": "ɡrændɪlɒkwəntli",
    "grandiose": "ɡrændɪəʊz",
    "grandiosity": "ɡrændɪɒsɪti",
    "grandly": "ɡrændli",
    "grandma": "ɡrændmɑː",
    "grandmamma": "ɡrændmæmɐ",
    "grandmas": "ɡrændmɑːz",
    "grandmaster": "ɡrændmɑːstɐ",
    "grandmasters": "ɡrændmɑːstəz",
    "grandmother": "ɡrændmʌðɐ",
    "grandmotherly": "ɡrændməðəli",
    "grandmothers": "ɡrændmʌðəz",
    "grandnephew": "ɡrændnɪfjuː",
    "grandness": "ɡrændnəs",
    "grandpa": "ɡrændpɑː",
    "grandpapa": "ɡrændpɑːpɐ",
    "grandparent": "ɡrændpeərənt",
    "grandparents": "ɡrændpeərənts",
    "grandpas": "ɡrændpɑːz",
    "grands": "ɡrændz",
    "grandsire": "ɡrændsaɪə",
    "grandson": "ɡrændsʌn",
    "grandsons": "ɡrændsʌnz",
    "grandstand": "ɡrændstænd",
    "grandstanding": "ɡrændstændɪŋ",
    "grandstands": "ɡrændstændz",
    "granduncle": "ɡrændʌŋkəl",
    "grange": "ɡreɪndʒ",
    "granger": "ɡreɪndʒɐ",
    "granges": "ɡreɪndʒɪz",
    "granite": "ɡrænɪt",
    "granites": "ɡrænɪts",
    "granitic": "ɡrænɪtɪk",
    "grannie": "ɡræni",
    "grannies": "ɡrænɪz",
    "granny": "ɡræni",
    "granola": "ɡrænəʊlɐ",
    "grans": "ɡrænz",
    "granted": "ɡrɑːntɪd",
    "granter": "ɡrɑːntɐ",
    "granting": "ɡrɑːntɪŋ",
    "grant": "ɡrɑːnt",
    "grants": "ɡrɑːnts",
    "granular": "ɡrænjʊlɐ",
    "granularity": "ɡrænjʊlærɪti",
    "granulated": "ɡrænjʊleɪtɪd",
    "granulation": "ɡrænjʊleɪʃən",
    "granule": "ɡrænjuːl",
    "granules": "ɡrænjuːlz",
    "granuloma": "ɡrænjʊləʊmɐ",
    "granulomas": "ɡrænjʊləʊməz",
    "grape": "ɡreɪp",
    "grapefruit": "ɡreɪpfruːt",
    "grapefruits": "ɡreɪpfruːts",
    "grapes": "ɡreɪps",
    "grapeshot": "ɡreɪpʃɒt",
    "grapevine": "ɡreɪpvaɪn",
    "grapevines": "ɡreɪpvaɪnz",
    "graph": "ɡræf",
    "graphed": "ɡræfd",
    "graphic": "ɡræfɪk",
    "graphical": "ɡræfɪkəl",
    "graphically": "ɡræfɪkli",
    "graphics": "ɡræfɪks",
    "graphing": "ɡræfɪŋ",
    "graphite": "ɡræfaɪt",
    "graphologist": "ɡræfɒlədʒɪst",
    "graphologists": "ɡræfɒlədʒɪsts",
    "graphology": "ɡræfɒlədʒi",
    "graphs": "ɡræfz",
    "grappa": "ɡræpɐ",
    "grapple": "ɡræpəl",
    "grappled": "ɡræpəld",
    "grappler": "ɡræplɐ",
    "grapplers": "ɡræpləz",
    "grapples": "ɡræpəlz",
    "grappling": "ɡræplɪŋ",
    "graspable": "ɡrɑːspəbəl",
    "grasped": "ɡrɑːspt",
    "grasper": "ɡrɑːspɐ",
    "grasping": "ɡrɑːspɪŋ",
    "grasp": "ɡrɑːsp",
    "grasps": "ɡrɑːsps",
    "grassed": "ɡrɑːst",
    "grasses": "ɡrɑːsɪz",
    "grasshopper": "ɡrɑːshɒpɐ",
    "grasshoppers": "ɡrɑːshɒpəz",
    "grassier": "ɡrɑːsɪɐ",
    "grassiest": "ɡrɑːsɪəst",
    "grassing": "ɡrɑːsɪŋ",
    "grassland": "ɡrɑːslənd",
    "grasslands": "ɡrɑːsləndz",
    "grassroots": "ɡrɑːsruːts",
    "grass": "ɡrɑːs",
    "grassy": "ɡrɑːsi",
    "grated": "ɡreɪtɪd",
    "grate": "ɡreɪt",
    "grateful": "ɡreɪtfəl",
    "gratefully": "ɡreɪtfəli",
    "grater": "ɡreɪtɐ",
    "graters": "ɡreɪtəz",
    "grates": "ɡreɪts",
    "gratification": "ɡrætɪfɪkeɪʃən",
    "gratifications": "ɡrætɪfɪkeɪʃənz",
    "gratified": "ɡrætɪfaɪd",
    "gratify": "ɡrætɪfaɪ",
    "gratifying": "ɡrætɪfaɪɪŋ",
    "gratifyingly": "ɡrætɪfaɪɪŋli",
    "gratin": "ɡrætɪn",
    "grating": "ɡreɪtɪŋ",
    "gratingly": "ɡreɪtɪŋli",
    "gratings": "ɡreɪtɪŋz",
    "gratis": "ɡrætis",
    "gratitude": "ɡrætɪtjuːd",
    "gratuities": "ɡrætjuːɪtɪz",
    "gratuitous": "ɡrætjuːɪtəs",
    "gratuitously": "ɡrætjuːɪtəsli",
    "gratuity": "ɡrætjuːɪti",
    "gravedigger": "ɡreɪvdɪɡɐ",
    "gravediggers": "ɡreɪvdɪɡəz",
    "gravel": "ɡrævəl",
    "gravelled": "ɡrævəld",
    "gravelling": "ɡrævəlɪŋ",
    "gravelly": "ɡrævəli",
    "gravels": "ɡrævəlz",
    "gravely": "ɡreɪvli",
    "graven": "ɡreɪvən",
    "graver": "ɡreɪvɐ",
    "graveside": "ɡreɪvsaɪd",
    "gravest": "ɡreɪvəst",
    "gravestone": "ɡreɪvstəʊn",
    "gravestones": "ɡreɪvstəʊnz",
    "graveyard": "ɡreɪvjɑːd",
    "graveyards": "ɡreɪvjɑːdz",
    "gravid": "ɡrævɪd",
    "gravies": "ɡreɪvɪz",
    "gravitas": "ɡrævɪtəz",
    "gravitate": "ɡrævɪteɪt",
    "gravitated": "ɡrævɪteɪtɪd",
    "gravitates": "ɡrævɪteɪts",
    "gravitating": "ɡrævɪteɪtɪŋ",
    "gravitation": "ɡrævɪteɪʃən",
    "gravitational": "ɡrævɪteɪʃənəl",
    "gravitationally": "ɡrævɪteɪʃənəli",
    "graviton": "ɡrævɪtən",
    "gravity": "ɡrævɪti",
    "gravy": "ɡreɪvi",
    "gray": "ɡreɪ",
    "grayling": "ɡreɪlɪŋ",
    "grays": "ɡreɪz",
    "grazed": "ɡreɪzd",
    "graze": "ɡreɪz",
    "grazer": "ɡreɪzɐ",
    "grazers": "ɡreɪzəz",
    "grazes": "ɡreɪzɪz",
    "grazier": "ɡreɪzɪɐ",
    "grazing": "ɡreɪzɪŋ",
    "grazings": "ɡreɪzɪŋz",
    "greaseball": "ɡriːsbɔːl",
    "greased": "ɡriːsd",
    "grease": "ɡriːs",
    "greasepaint": "ɡriːspeɪnt",
    "greaseproof": "ɡriːspruːf",
    "greaser": "ɡriːsɐ",
    "greasers": "ɡriːsəz",
    "greases": "ɡriːsɪz",
    "greasier": "ɡriːzɪɐ",
    "greasiness": "ɡriːzɪnəs",
    "greasing": "ɡriːsɪŋ",
    "greasy": "ɡriːzi",
    "greatcoat": "ɡreɪtkəʊt",
    "greatcoats": "ɡreɪtkəʊts",
    "greaten": "ɡreɪtən",
    "greater": "ɡreɪtɐ",
    "greatest": "ɡreɪtəst",
    "great": "ɡreɪt",
    "greatly": "ɡreɪtli",
    "greatness": "ɡreɪtnəs",
    "greats": "ɡreɪts",
    "greave": "ɡriːv",
    "greaves": "ɡriːvz",
    "grebe": "ɡriːb",
    "grebes": "ɡriːbz",
    "greed": "ɡriːd",
    "greedier": "ɡriːdɪɐ",
    "greediest": "ɡriːdɪəst",
    "greedily": "ɡriːdɪli",
    "greediness": "ɡriːdɪnəs",
    "greedy": "ɡriːdi",
    "gree": "ɡriː",
    "greenback": "ɡriːnbæk",
    "greenbacks": "ɡriːnbæks",
    "greenbelt": "ɡriːnbɛlt",
    "greened": "ɡriːnd",
    "greener": "ɡriːnɐ",
    "greenery": "ɡriːnəri",
    "greenest": "ɡriːnəst",
    "greenfield": "ɡriːnfiːld",
    "greenfinch": "ɡriːnfɪntʃ",
    "greenflies": "ɡriːnflaɪz",
    "greenfly": "ɡriːnflaɪ",
    "greengage": "ɡriːŋɡeɪdʒ",
    "greengages": "ɡriːŋɡeɪdʒɪz",
    "greengrocer": "ɡriːŋɡrəʊsɐ",
    "greengrocers": "ɡriːŋɡrəʊsəz",
    "greengrocery": "ɡriːŋɡrəʊsəri",
    "greenhorn": "ɡriːnhɔːn",
    "greenhorns": "ɡriːnhɔːnz",
    "greenhouse": "ɡriːnhaʊs",
    "greenhouses": "ɡriːnhaʊzɪz",
    "green": "ɡriːn",
    "greening": "ɡriːnɪŋ",
    "greenish": "ɡriːnɪʃ",
    "greenness": "ɡriːnnəs",
    "greenroom": "ɡriːnruːm",
    "greensand": "ɡriːnsænd",
    "greenshank": "ɡriːnʃæŋk",
    "greens": "ɡriːnz",
    "greenstone": "ɡriːnstəʊn",
    "greensward": "ɡriːnswəd",
    "greenwood": "ɡriːnwʊd",
    "greeny": "ɡriːni",
    "greeted": "ɡriːtɪd",
    "greeter": "ɡriːtɐ",
    "greeters": "ɡriːtəz",
    "greeting": "ɡriːtɪŋ",
    "greetings": "ɡriːtɪŋz",
    "greet": "ɡriːt",
    "greets": "ɡriːts",
    "gregarious": "ɡrɛɡeərɪəs",
    "gre": "ɡriː",
    "greige": "ɡreɪdʒ",
    "gremlin": "ɡrɛmlɪn",
    "gremlins": "ɡrɛmlɪnz",
    "grenade": "ɡrəneɪd",
    "grenades": "ɡrəneɪdz",
    "grenadier": "ɡrɛnɐdɪɐ",
    "grenadiers": "ɡrɛneɪdiəz",
    "grenadine": "ɡrɛnɐdiːn",
    "grew": "ɡruː",
    "greyback": "ɡreɪbæk",
    "greybeard": "ɡreɪbiəd",
    "grey": "ɡreɪ",
    "greyed": "ɡreɪd",
    "greyer": "ɡreɪɐ",
    "greyest": "ɡreɪəst",
    "greyhound": "ɡreɪhaʊnd",
    "greyhounds": "ɡreɪhaʊndz",
    "greying": "ɡreɪɪŋ",
    "greyish": "ɡreɪɪʃ",
    "greylag": "ɡreɪlæɡ",
    "greyness": "ɡreɪnəs",
    "greys": "ɡreɪz",
    "greywacke": "ɡreɪwæki",
    "gribble": "ɡrɪbəl",
    "grid": "ɡrɪd",
    "griddle": "ɡrɪdəl",
    "griddles": "ɡrɪdəlz",
    "gridiron": "ɡrɪdaɪən",
    "gridlock": "ɡrɪdlɒk",
    "gridlocked": "ɡrɪdlɒkt",
    "grids": "ɡrɪdz",
    "grief": "ɡriːf",
    "griefs": "ɡriːfs",
    "grievance": "ɡriːvəns",
    "grievances": "ɡriːvənsɪz",
    "grieved": "ɡriːvd",
    "grieve": "ɡriːv",
    "grieves": "ɡriːvz",
    "grieving": "ɡriːvɪŋ",
    "grievous": "ɡriːvəs",
    "grievously": "ɡriːvəsli",
    "griffin": "ɡrɪfɪn",
    "griffins": "ɡrɪfɪnz",
    "griffon": "ɡrɪfən",
    "grifter": "ɡrɪftɐ",
    "grig": "ɡrɪɡ",
    "grilled": "ɡrɪld",
    "grille": "ɡrɪl",
    "grilles": "ɡrɪlz",
    "grilling": "ɡrɪlɪŋ",
    "grillings": "ɡrɪlɪŋz",
    "grill": "ɡrɪl",
    "grills": "ɡrɪlz",
    "grilse": "ɡrɪls",
    "grimaced": "ɡrɪmɪst",
    "grimace": "ɡrɪmɪs",
    "grimaces": "ɡrɪmɪsɪz",
    "grimacing": "ɡrɪmɪsɪŋ",
    "grime": "ɡraɪm",
    "grimes": "ɡraɪmz",
    "grimiest": "ɡraɪmɪəst",
    "grimly": "ɡrɪmli",
    "grim": "ɡrɪm",
    "grimmer": "ɡrɪmɐ",
    "grimmest": "ɡrɪməst",
    "grimness": "ɡrɪmnəs",
    "grimy": "ɡraɪmi",
    "grind": "ɡraɪnd",
    "grinder": "ɡraɪndɐ",
    "grinders": "ɡraɪndəz",
    "grinding": "ɡraɪndɪŋ",
    "grindingly": "ɡraɪndɪŋli",
    "grinds": "ɡraɪndz",
    "grindstone": "ɡraɪndstəʊn",
    "gringo": "ɡrɪŋɡəʊ",
    "gringos": "ɡrɪŋɡəʊz",
    "grin": "ɡrɪn",
    "grinned": "ɡrɪnd",
    "grinner": "ɡrɪnɐ",
    "grinning": "ɡrɪnɪŋ",
    "grins": "ɡrɪnz",
    "gripe": "ɡraɪp",
    "griped": "ɡraɪpt",
    "gripes": "ɡraɪps",
    "griping": "ɡraɪpɪŋ",
    "grip": "ɡrɪp",
    "gripped": "ɡrɪpt",
    "grippe": "ɡrɪp",
    "gripper": "ɡrɪpɐ",
    "grippers": "ɡrɪpəz",
    "grippingly": "ɡrɪpɪŋli",
    "gripping": "ɡrɪpɪŋ",
    "grippy": "ɡrɪpi",
    "grips": "ɡrɪps",
    "grisaille": "ɡrɪseɪl",
    "grisette": "ɡraɪsɛt",
    "grisly": "ɡrɪsli",
    "gristle": "ɡrɪsəl",
    "gristly": "ɡrɪstli",
    "grist": "ɡrɪst",
    "grith": "ɡrɪθ",
    "grits": "ɡrɪts",
    "grit": "ɡrɪt",
    "gritted": "ɡrɪtɪd",
    "gritters": "ɡrɪtəz",
    "gritter": "ɡrɪtɐ",
    "grittier": "ɡrɪtɪɐ",
    "grittiest": "ɡrɪtɪəst",
    "grittiness": "ɡrɪtɪnəs",
    "gritting": "ɡrɪtɪŋ",
    "gritty": "ɡrɪti",
    "grizzled": "ɡrɪzəld",
    "grizzles": "ɡrɪzəlz",
    "grizzle": "ɡrɪzəl",
    "grizzlies": "ɡrɪzliz",
    "grizzling": "ɡrɪzlɪŋ",
    "grizzly": "ɡrɪzli",
    "groaned": "ɡrəʊnd",
    "groan": "ɡrəʊn",
    "groaner": "ɡrəʊnɐ",
    "groaners": "ɡrəʊnəz",
    "groaning": "ɡrəʊnɪŋ",
    "groans": "ɡrəʊnz",
    "groat": "ɡrəʊt",
    "groats": "ɡrəʊts",
    "grocer": "ɡrəʊsɐ",
    "groceries": "ɡrəʊsəriz",
    "grocers": "ɡrəʊsəz",
    "grocery": "ɡrəʊsəri",
    "grog": "ɡrɒɡ",
    "groggy": "ɡrɒɡi",
    "groin": "ɡrɔɪn",
    "groins": "ɡrɔɪnz",
    "grommet": "ɡrɒmɪt",
    "grommets": "ɡrɒmɪts",
    "groomed": "ɡruːmd",
    "groomers": "ɡruːməz",
    "groomer": "ɡruːmɐ",
    "grooming": "ɡruːmɪŋ",
    "groomsman": "ɡruːmzmən",
    "groomsmen": "ɡruːmzmɛn",
    "grooms": "ɡruːmz",
    "groom": "ɡruːm",
    "grooved": "ɡruːvd",
    "grooves": "ɡruːvz",
    "groove": "ɡruːv",
    "groovier": "ɡruːvɪɐ",
    "grooviest": "ɡruːvɪəst",
    "grooving": "ɡruːvɪŋ",
    "groovy": "ɡruːvi",
    "groped": "ɡrəʊpt",
    "grope": "ɡrəʊp",
    "groper": "ɡrəʊpɐ",
    "gropes": "ɡrəʊps",
    "groping": "ɡrəʊpɪŋ",
    "grossed": "ɡrəʊst",
    "grosser": "ɡrəʊsɐ",
    "gross": "ɡrəʊs",
    "grosses": "ɡrəʊsɪz",
    "grossest": "ɡrəʊsəst",
    "grossing": "ɡrəʊsɪŋ",
    "grossly": "ɡrəʊsli",
    "grossness": "ɡrəʊsnəs",
    "grosz": "ɡrɒsz",
    "grotesque": "ɡrəʊtɛsk",
    "grotesquely": "ɡrəʊtɛskli",
    "grotesqueness": "ɡrəʊtɛsknəs",
    "grotesques": "ɡrəʊtɛskz",
    "grots": "ɡrɒts",
    "grot": "ɡrɒt",
    "grottiest": "ɡrɒtɪəst",
    "grottoes": "ɡrɒtəʊz",
    "grottos": "ɡrɒtəʊz",
    "grotto": "ɡrɒtəʊ",
    "grotty": "ɡrɒti",
    "grouch": "ɡraʊtʃ",
    "grouchy": "ɡraʊtʃi",
    "ground": "ɡraʊnd",
    "groundbreaking": "ɡraʊndbreɪkɪŋ",
    "grounded": "ɡraʊndɪd",
    "grounder": "ɡraʊndɐ",
    "grounders": "ɡraʊndəz",
    "groundhog": "ɡraʊndhɒɡ",
    "groundhogs": "ɡraʊndhɒɡz",
    "grounding": "ɡraʊndɪŋ",
    "groundless": "ɡraʊndləs",
    "groundnut": "ɡraʊndnʌt",
    "grounds": "ɡraʊndz",
    "groundsel": "ɡraʊndsəl",
    "groundsheet": "ɡraʊndʃiːt",
    "groundskeeper": "ɡraʊndskiːpɐ",
    "groundsman": "ɡraʊndzmən",
    "groundsmen": "ɡraʊndzmɛn",
    "groundswell": "ɡraʊndswɛl",
    "groundwater": "ɡraʊndwɔːtɐ",
    "groundwork": "ɡraʊndwɜːk",
    "grouped": "ɡruːpt",
    "groupers": "ɡruːpəz",
    "grouper": "ɡruːpɐ",
    "groupies": "ɡruːpɪz",
    "groupie": "ɡruːpi",
    "groupings": "ɡruːpɪŋz",
    "grouping": "ɡruːpɪŋ",
    "groups": "ɡruːps",
    "group": "ɡruːp",
    "grouse": "ɡraʊs",
    "grousing": "ɡraʊsɪŋ",
    "grout": "ɡraʊt",
    "grouted": "ɡraʊtɪd",
    "grouting": "ɡraʊtɪŋ",
    "grove": "ɡrəʊv",
    "groveling": "ɡrɒvəlɪŋ",
    "grovelled": "ɡrɒvəld",
    "grovelling": "ɡrɒvəlɪŋ",
    "grovel": "ɡrɒvəl",
    "groves": "ɡrəʊvz",
    "grow": "ɡrəʊ",
    "grower": "ɡrəʊɐ",
    "growers": "ɡrəʊəz",
    "growing": "ɡrəʊɪŋ",
    "growl": "ɡraʊl",
    "growled": "ɡraʊld",
    "growler": "ɡraʊlɐ",
    "growlers": "ɡraʊləz",
    "growling": "ɡraʊlɪŋ",
    "growls": "ɡraʊlz",
    "growly": "ɡrəʊli",
    "grown": "ɡrəʊn",
    "grownup": "ɡrəʊnʌp",
    "grownups": "ɡrəʊnʌps",
    "grows": "ɡrəʊz",
    "growth": "ɡrəʊθ",
    "growths": "ɡrəʊθs",
    "groyne": "ɡrɔɪn",
    "groynes": "ɡrɔɪnz",
    "grub": "ɡrʌb",
    "grubbed": "ɡrʌbd",
    "grubber": "ɡrʌbɐ",
    "grubbier": "ɡrʌbɪɐ",
    "grubbiest": "ɡrʌbɪəst",
    "grubbiness": "ɡrʌbɪnəs",
    "grubbing": "ɡrʌbɪŋ",
    "grubby": "ɡrʌbi",
    "grubs": "ɡrʌbz",
    "grudge": "ɡrʌdʒ",
    "grudges": "ɡrʌdʒɪz",
    "grudging": "ɡrʌdʒɪŋ",
    "grudgingly": "ɡrʌdʒɪŋli",
    "grueling": "ɡruːəlɪŋ",
    "gruelling": "ɡruːəlɪŋ",
    "gruel": "ɡruːəl",
    "gruesomely": "ɡruːsʌmli",
    "gruesome": "ɡruːsʌm",
    "gruff": "ɡrʌf",
    "gruffly": "ɡrʌfli",
    "grumbled": "ɡrʌmbəld",
    "grumble": "ɡrʌmbəl",
    "grumbles": "ɡrʌmbəlz",
    "grumbling": "ɡrʌmblɪŋ",
    "grumblings": "ɡrʌmblɪŋz",
    "grumbly": "ɡrʌmbli",
    "grum": "ɡrʌm",
    "grumpier": "ɡrʌmpɪɐ",
    "grumpiest": "ɡrʌmpɪəst",
    "grumpily": "ɡrʌmpɪli",
    "grumpiness": "ɡrʌmpɪnəs",
    "grump": "ɡrʌmp",
    "grumps": "ɡrʌmps",
    "grumpy": "ɡrʌmpi",
    "grunge": "ɡrʌndʒ",
    "grungiest": "ɡrʌndʒɪəst",
    "grungy": "ɡrʌndʒi",
    "grunted": "ɡrʌntɪd",
    "grunter": "ɡrʌntɐ",
    "grunting": "ɡrʌntɪŋ",
    "grunt": "ɡrʌnt",
    "grunts": "ɡrʌnts",
    "gryphon": "ɡrɪfɒn",
    "gryphons": "ɡrɪfɒnz",
    "gs": "dʒiːɛs",
    "guacamole": "ɡwɑːkɐməʊliː",
    "guanacos": "ɡwɑːnɑːkəʊz",
    "guanaco": "ɡwɑːnɑːkəʊ",
    "guanine": "ɡwɑːnaɪn",
    "guano": "ɡwɑːnəʊ",
    "guan": "ɡwɑːn",
    "guarani": "ɡærɑːni",
    "guarantee": "ɡærɑːntiː",
    "guaranteed": "ɡærɑːntiːd",
    "guaranteeing": "ɡærɑːntiːɪŋ",
    "guarantees": "ɡærɑːntiːz",
    "guarantor": "ɡærɑːntɔː",
    "guarantors": "ɡærɑːntɔːz",
    "guaranty": "ɡærənti",
    "guard": "ɡɑːd",
    "guarded": "ɡɑːdɪd",
    "guarder": "ɡɑːdɐ",
    "guarders": "ɡɑːdəz",
    "guardhouse": "ɡɑːdhaʊs",
    "guardian": "ɡɑːdiən",
    "guardians": "ɡɑːdiənz",
    "guardianship": "ɡɑːdiənʃɪp",
    "guarding": "ɡɑːdɪŋ",
    "guardrail": "ɡɑːdreɪl",
    "guardroom": "ɡɑːdruːm",
    "guards": "ɡɑːdz",
    "guardsman": "ɡɑːdzmən",
    "guardsmen": "ɡɑːdzmɛn",
    "guavas": "ɡwɑːvəz",
    "guava": "ɡwɑːvɐ",
    "guck": "ɡʌk",
    "guddle": "ɡʌdəl",
    "gudgeon": "ɡʌdʒɒn",
    "gudgeons": "ɡʌdʒɒnz",
    "guerdon": "ɡɜːdən",
    "guerilla": "ɡɛrɪlɐ",
    "guerillas": "ɡɛrɪləz",
    "guerrilla": "ɡɛrɪlɐ",
    "guerrillas": "ɡɛrɪləz",
    "guessable": "ɡɛsəbəl",
    "guessed": "ɡɛst",
    "guesser": "ɡɛsɐ",
    "guessers": "ɡɛsəz",
    "guess": "ɡɛs",
    "guesses": "ɡɛsɪz",
    "guessing": "ɡɛsɪŋ",
    "guesstimate": "ɡɛstɪmət",
    "guesstimates": "ɡɛstɪməts",
    "guesswork": "ɡɛswɜːk",
    "guested": "ɡɛstɪd",
    "guest": "ɡɛst",
    "guesthouse": "ɡɛsthaʊs",
    "guesthouses": "ɡɛsthaʊsɪz",
    "guesting": "ɡɛstɪŋ",
    "guestroom": "ɡɛstruːm",
    "guestrooms": "ɡɛstruːmz",
    "guests": "ɡɛsts",
    "guffawed": "ɡʌfɔːd",
    "guffaw": "ɡʌfɔː",
    "guffaws": "ɡʌfɔːz",
    "guff": "ɡʌf",
    "guidance": "ɡaɪdəns",
    "guide": "ɡaɪd",
    "guidebook": "ɡaɪdbʊk",
    "guidebooks": "ɡaɪdbʊks",
    "guided": "ɡaɪdɪd",
    "guideline": "ɡaɪdlaɪn",
    "guidelines": "ɡaɪdlaɪnz",
    "guider": "ɡaɪdɐ",
    "guiders": "ɡaɪdəz",
    "guides": "ɡaɪdz",
    "guiding": "ɡaɪdɪŋ",
    "guidon": "ɡaɪdɒn",
    "guilder": "ɡɪldɐ",
    "guilders": "ɡɪldəz",
    "guildhall": "ɡɪldhɔːl",
    "guild": "ɡɪld",
    "guilds": "ɡɪldz",
    "guile": "ɡaɪl",
    "guileful": "ɡaɪlfəl",
    "guileless": "ɡaɪlləs",
    "guillemot": "ɡɪlɪmɒt",
    "guillemots": "ɡɪlɪmɒts",
    "guilloche": "ɡɪlɒtʃ",
    "guillotined": "ɡɪlətiːnd",
    "guillotine": "ɡɪlətiːn",
    "guillotines": "ɡɪlətiːnz",
    "guillotining": "ɡɪlətiːnɪŋ",
    "guiltier": "ɡɪltɪɐ",
    "guiltiest": "ɡɪltɪəst",
    "guiltiness": "ɡɪltɪnəs",
    "guiltless": "ɡɪltləs",
    "guilt": "ɡɪlt",
    "guilty": "ɡɪlti",
    "guinea": "ɡɪni",
    "guineas": "ɡɪniz",
    "guise": "ɡaɪz",
    "guises": "ɡaɪzɪz",
    "guitarists": "ɡɪtɑːrɪsts",
    "guitarist": "ɡɪtɑːrɪst",
    "guitars": "ɡɪtɑːz",
    "guitar": "ɡɪtɑː",
    "gulag": "ɡjʊlæɡ",
    "gulags": "ɡjʊlæɡz",
    "gula": "ɡjʊlɐ",
    "gulch": "ɡʌltʃ",
    "gules": "ɡjuːlz",
    "gulf": "ɡʌlf",
    "gulfs": "ɡʌlfs",
    "gulled": "ɡʌld",
    "gullet": "ɡʌlɪt",
    "gullets": "ɡʌlɪts",
    "gulley": "ɡʌli",
    "gullibility": "ɡʌlɪbɪlɪti",
    "gullible": "ɡʌləbəl",
    "gullies": "ɡʌliz",
    "gull": "ɡʌl",
    "gulls": "ɡʌlz",
    "gully": "ɡʌli",
    "gulped": "ɡʌlpt",
    "gulper": "ɡʌlpɐ",
    "gulping": "ɡʌlpɪŋ",
    "gulp": "ɡʌlp",
    "gulps": "ɡʌlps",
    "gumball": "ɡʌmbɔːl",
    "gumballs": "ɡʌmbɔːlz",
    "gumbo": "ɡʌmbəʊ",
    "gumboot": "ɡʌmbuːt",
    "gumboots": "ɡʌmbuːts",
    "gumdrop": "ɡʌmdrɒp",
    "gumdrops": "ɡʌmdrɒps",
    "gum": "ɡʌm",
    "gummas": "ɡʌməz",
    "gummed": "ɡʌmd",
    "gumming": "ɡʌmɪŋ",
    "gummy": "ɡʌmi",
    "gumption": "ɡʌmpʃən",
    "gumshoe": "ɡʌmʃuː",
    "gums": "ɡʌmz",
    "gumtree": "ɡʌmtriː",
    "gunboat": "ɡʌnbəʊt",
    "gunboats": "ɡʌnbəʊts",
    "guncotton": "ɡʌnkɒtən",
    "gunfighter": "ɡʌnfaɪtɐ",
    "gunfighters": "ɡʌnfaɪtəz",
    "gunfight": "ɡʌnfaɪt",
    "gunfights": "ɡʌnfaɪts",
    "gunfire": "ɡʌnfaɪə",
    "gunge": "ɡʌndʒ",
    "gungy": "ɡʌndʒi",
    "gunk": "ɡʌŋk",
    "gunky": "ɡʌŋki",
    "gunmaker": "ɡʌnmeɪkɐ",
    "gunman": "ɡʌnmən",
    "gunmen": "ɡʌnmɛn",
    "gunmetal": "ɡʌnmɛtəl",
    "gun": "ɡʌn",
    "gunned": "ɡʌnd",
    "gunnels": "ɡʌnəlz",
    "gunner": "ɡʌnɐ",
    "gunners": "ɡʌnəz",
    "gunnery": "ɡʌnəri",
    "gunning": "ɡʌnɪŋ",
    "gunny": "ɡʌni",
    "gunnysack": "ɡʌnɪsæk",
    "gunplay": "ɡʌnpleɪ",
    "gunpoint": "ɡʌnpɔɪnt",
    "gunpowder": "ɡʌnpaʊdɐ",
    "gunrunner": "ɡʌnrʌnɐ",
    "gunrunners": "ɡʌnrʌnəz",
    "gunrunning": "ɡʌnrʌnɪŋ",
    "gunship": "ɡʌnʃɪp",
    "gunships": "ɡʌnʃɪps",
    "gunshot": "ɡʌnʃɒt",
    "gunshots": "ɡʌnʃɒts",
    "gunslinger": "ɡʌnslɪŋɡɐ",
    "gunslingers": "ɡʌnslɪŋɡəz",
    "gunsmith": "ɡʌnsmɪθ",
    "gunsmiths": "ɡʌnsmɪθs",
    "guns": "ɡʌnz",
    "gunter": "ɡʌntɐ",
    "gunwale": "ɡʌnweɪl",
    "gunwales": "ɡʌnweɪlz",
    "guppies": "ɡʌpɪz",
    "guppy": "ɡʌpi",
    "gurdwara": "ɡɜːdwɑːrɐ",
    "gurge": "ɡɜːdʒ",
    "gurgled": "ɡɜːɡəld",
    "gurgle": "ɡɜːɡəl",
    "gurgles": "ɡɜːɡəlz",
    "gurgling": "ɡɜːɡlɪŋ",
    "gurnard": "ɡɜːnɑːd",
    "gurnards": "ɡɜːnɑːdz",
    "gurney": "ɡɜːni",
    "gurneys": "ɡɜːnɪz",
    "guru": "ɡjʊruː",
    "gurus": "ɡuːruːz",
    "gush": "ɡʌʃ",
    "gushed": "ɡʌʃt",
    "gusher": "ɡʌʃɐ",
    "gushes": "ɡʌʃɪz",
    "gushing": "ɡʌʃɪŋ",
    "gushy": "ɡʌʃi",
    "gusset": "ɡʌsɛt",
    "gussied": "ɡʌsɪd",
    "gussie": "ɡʌsi",
    "gussy": "ɡʌsi",
    "gustation": "ɡʌsteɪʃən",
    "gustatory": "ɡʌstətəri",
    "gusted": "ɡʌstɪd",
    "gusting": "ɡʌstɪŋ",
    "gusto": "ɡʌstəʊ",
    "gusts": "ɡʌsts",
    "gust": "ɡʌst",
    "gusty": "ɡʌsti",
    "gutlessness": "ɡʌtləsnəs",
    "gutless": "ɡʌtləs",
    "gutsiest": "ɡʌtsɪəst",
    "gutsiness": "ɡʌtsɪnəs",
    "guts": "ɡʌts",
    "gutsy": "ɡʌtsi",
    "gut": "ɡʌt",
    "gutta": "ɡʌtɐ",
    "gutted": "ɡʌtɪd",
    "guttered": "ɡʌtəd",
    "guttering": "ɡʌtərɪŋ",
    "guttersnipe": "ɡʌtəsnaɪp",
    "gutters": "ɡʌtəz",
    "gutter": "ɡʌtɐ",
    "gutting": "ɡʌtɪŋ",
    "guttural": "ɡʌtərəl",
    "gutty": "ɡʌti",
    "guvnors": "ɡʌvnəz",
    "guvnor": "ɡʌvnɐ",
    "guv": "ɡʌv",
    "guy": "ɡaɪ",
    "guyed": "ɡaɪd",
    "guys": "ɡaɪz",
    "guzzled": "ɡʌzəld",
    "guzzlers": "ɡʌzləz",
    "guzzler": "ɡʌzlɐ",
    "guzzles": "ɡʌzəlz",
    "guzzle": "ɡʌzəl",
    "guzzling": "ɡʌzlɪŋ",
    "gybe": "dʒaɪb",
    "gybing": "dʒaɪbɪŋ",
    "gym": "dʒɪm",
    "gymkhana": "dʒɪmkhɑːnɐ",
    "gymkhanas": "dʒɪmkhɑːnəz",
    "gymnasia": "dʒɪmneɪziə",
    "gymnasium": "dʒɪmneɪsiəm",
    "gymnasiums": "dʒɪmneɪsiəmz",
    "gymnast": "dʒɪmnɑːst",
    "gymnastic": "dʒɪmnɑːstɪk",
    "gymnastics": "dʒɪmnɑːstɪks",
    "gymnasts": "dʒɪmnɑːsts",
    "gyms": "dʒɪmz",
    "gymslip": "dʒɪmslɪp",
    "gynaecological": "ɡaɪniːkəlɒdʒɪkəl",
    "gynaecologist": "ɡaɪniːkɒlədʒɪst",
    "gynaecologists": "ɡaɪniːkɒlədʒɪsts",
    "gynaecology": "ɡaɪniːkɒlədʒi",
    "gynaecomastia": "ɡaɪniːkɒmɑːstʃɐ",
    "gyp": "dʒɪp",
    "gypsies": "dʒɪpsɪz",
    "gypsophila": "dʒɪpsəfɪlɐ",
    "gypsum": "dʒɪpsəm",
    "gypsy": "dʒɪpsi",
    "gyrated": "dʒaɪreɪtɪd",
    "gyrate": "dʒaɪreɪt",
    "gyrating": "dʒaɪreɪtɪŋ",
    "gyration": "dʒaɪreɪʃən",
    "gyrations": "dʒaɪreɪʃənz",
    "gyrator": "dʒaɪreɪtɐ",
    "gyratory": "dʒaɪrətəri",
    "gyre": "dʒaɪə",
    "gyres": "dʒaɪəz",
    "gyrfalcon": "dʒɪəfælkən",
    "gyro": "dʒaɪrəʊ",
    "gyroscope": "dʒaɪrəskəʊp",
    "gyroscopes": "dʒaɪrəskəʊps",
    "gyroscopic": "dʒaɪrəskɒpɪk",
    "gyros": "dʒaɪrəʊz",
    "gyrus": "dʒaɪrəs",
    "haar": "hɑː",
    "habanera": "hæbɐnərɐ",
    "haberdasher": "hæbədæʃɐ",
    "haberdashers": "hæbədæʃəz",
    "haberdashery": "hæbədæʃəri",
    "habiliments": "hæbɪlɪmənts",
    "habitability": "hæbɪtəbɪlɪti",
    "habitable": "hæbɪtəbəl",
    "habitat": "hæbɪtæt",
    "habitation": "hæbɪteɪʃən",
    "habitations": "hæbɪteɪʃənz",
    "habitats": "hæbɪtæts",
    "habited": "hæbɪtɪd",
    "habit": "hæbɪt",
    "habits": "hæbɪts",
    "habitual": "hɐbɪtʃuːəl",
    "habitually": "hɐbɪtʃuːəli",
    "habituated": "hæbɪtʃuːeɪtɪd",
    "habituate": "hæbɪtʃuːeɪt",
    "habituation": "hæbɪtʃuːeɪʃən",
    "hacienda": "hɑːsɪɛndɐ",
    "hacked": "hækt",
    "hacker": "hækɐ",
    "hackers": "hækəz",
    "hack": "hæk",
    "hacking": "hækɪŋ",
    "hackle": "hækəl",
    "hackles": "hækəlz",
    "hackman": "hækmən",
    "hackneyed": "hæknɪd",
    "hackney": "hækni",
    "hacksaw": "hæksɔː",
    "hacksaws": "hæksɔːz",
    "hacks": "hæks",
    "haddock": "hædək",
    "haddocks": "hædəks",
    "hade": "heɪd",
    "had": "hæd",
    "hadj": "hædʒ",
    "hadji": "hædʒi",
    "hadron": "hædrən",
    "hadrons": "hædrənz",
    "hadst": "hædst",
    "hae": "hiː",
    "haemangioma": "hiːmɐŋɡɪəʊmɐ",
    "haematite": "hiːmɐtaɪt",
    "haematological": "hiːmɐtəlɒdʒɪkəl",
    "haematologist": "hiːmɐtɒlədʒɪst",
    "haematologists": "hiːmɐtɒlədʒɪsts",
    "haematology": "hiːmɐtɒlədʒi",
    "haematoma": "hiːmɐtəʊmɐ",
    "haematomas": "hiːmɐtəʊməz",
    "haematuria": "hiːmətʃɔːriə",
    "haemodialysis": "hiːməʊdɪæləsɪs",
    "haemoglobin": "hiːməɡlɒbɪn",
    "haemophiliac": "hiːməfɪlɪæk",
    "haemophiliacs": "hiːməfɪlɪæks",
    "haemophilia": "hiːməfɪliə",
    "haemorrhaged": "hɛmərɪdʒd",
    "haemorrhage": "hɛmərɪdʒ",
    "haemorrhages": "hɛmərɪdʒɪz",
    "haemorrhaging": "hɛmərɪdʒɪŋ",
    "haemorrhoidectomy": "hɛmərɔɪdɛktəmi",
    "haemorrhoid": "hɛmərɔɪd",
    "haemorrhoids": "hɛmərɔɪdz",
    "haemostasis": "hiːməʊstæsiz",
    "haemostatic": "hiːməʊstætɪk",
    "hafiz": "hæfɪz",
    "hafnium": "hæfniəm",
    "haft": "hɑːft",
    "hagfish": "hæɡfɪʃ",
    "haggard": "hæɡəd",
    "haggis": "hæɡɪs",
    "haggled": "hæɡəld",
    "haggle": "hæɡəl",
    "haggler": "hæɡlɐ",
    "hagglers": "hæɡləz",
    "haggles": "hæɡəlz",
    "haggling": "hæɡlɪŋ",
    "hag": "hæɡ",
    "hagiographies": "hædʒɪɒɡrəfɪz",
    "hagiography": "hædʒɪɒɡrəfi",
    "hags": "hæɡz",
    "ha": "hɑː",
    "hah": "hɑː",
    "haiku": "haɪkuː",
    "hailed": "heɪld",
    "hailer": "heɪlɐ",
    "hail": "heɪl",
    "hailing": "heɪlɪŋ",
    "hails": "heɪlz",
    "hailstone": "heɪlstəʊn",
    "hailstones": "heɪlstəʊnz",
    "hailstorm": "heɪlstɔːm",
    "hailstorms": "heɪlstɔːmz",
    "hairball": "heəbɔːl",
    "hairballs": "heəbɔːlz",
    "hairband": "heəbænd",
    "hairbands": "heəbændz",
    "hairbrushes": "heəbrʌʃɪz",
    "hairbrush": "heəbrʌʃ",
    "haircare": "heəkeə",
    "haircut": "heəkʌt",
    "haircuts": "heəkʌts",
    "haircutting": "heəkʌtɪŋ",
    "hairdo": "heəduː",
    "hairdos": "heəduːz",
    "hairdresser": "heədrɛsɐ",
    "hairdressers": "heədrɛsəz",
    "hairdressing": "heədrɛsɪŋ",
    "hairdrier": "heədrɪɐ",
    "hairdryer": "heədraɪɐ",
    "hairdryers": "heədraɪəz",
    "haired": "heəd",
    "hairgrip": "heəɡrɪp",
    "hairgrips": "heəɡrɪps",
    "hair": "heə",
    "hairier": "heərɪɐ",
    "hairiest": "heərɪəst",
    "hairiness": "heərɪnəs",
    "hairless": "heələs",
    "hairline": "heəlaɪn",
    "hairlines": "heəlaɪnz",
    "hairnet": "heənɛt",
    "hairnets": "heənɛts",
    "hairpiece": "heəpiːs",
    "hairpieces": "heəpiːsɪz",
    "hairpin": "heəpɪn",
    "hairpins": "heəpɪnz",
    "hairs": "heəz",
    "hairspray": "heəspreɪ",
    "hairstreak": "heəstriːk",
    "hairstyle": "heəstaɪl",
    "hairstyles": "heəstaɪlz",
    "hairstyling": "heəstaɪlɪŋ",
    "hairstylist": "heəstɪlɪst",
    "hairstylists": "heəstɪlɪsts",
    "hairy": "heəri",
    "haj": "hædʒ",
    "haji": "hædʒi",
    "hajj": "hædʒ",
    "hake": "heɪk",
    "hakim": "hækɪm",
    "halal": "hæləl",
    "halcyon": "hælsɪən",
    "hale": "heɪl",
    "haler": "heɪlɐ",
    "hales": "heɪlz",
    "halfback": "hɑːfbæk",
    "halfhearted": "hɑːfhɑːtɪd",
    "half": "hɑːf",
    "halfpence": "hɑːfpəns",
    "halfpennies": "hɑːfpənɪz",
    "halfpenny": "hɑːfpəni",
    "halftime": "hɑːftaɪm",
    "halfway": "hɑːfweɪ",
    "halfwit": "hɑːfwɪt",
    "halfwits": "hɑːfwɪts",
    "halibut": "hælɪbʌt",
    "halide": "hælaɪd",
    "halite": "hælaɪt",
    "halitosis": "hælɪtəʊsɪs",
    "halleluiah": "hælɪluːjɐ",
    "hallelujah": "hælɪluːjɐ",
    "hallelujahs": "hælɪluːjəz",
    "hall": "hɔːl",
    "halliard": "hælɪəd",
    "hallmarked": "hɔːlmɑːkt",
    "hallmark": "hɔːlmɑːk",
    "hallmarking": "hɔːlmɑːkɪŋ",
    "hallmarks": "hɔːlmɑːks",
    "hallo": "hæləʊ",
    "halloo": "hæluː",
    "hallowed": "hæləʊd",
    "hallow": "hæləʊ",
    "hallows": "hæləʊz",
    "halls": "hɔːlz",
    "hallucinated": "hɐluːsɪneɪtɪd",
    "hallucinate": "hɐluːsɪneɪt",
    "hallucinating": "hɐluːsɪneɪtɪŋ",
    "hallucination": "hɐluːsɪneɪʃən",
    "hallucinations": "hɐluːsɪneɪʃənz",
    "hallucinatory": "hɐluːsɪnətəri",
    "hallucinogen": "hɐluːsɪnədʒən",
    "hallucinogenic": "hɐluːsɪnəʊdʒɛnɪk",
    "hallucinogenics": "hɐluːsɪnəʊdʒɛnɪks",
    "hallucinogens": "hɐluːsɪnədʒənz",
    "hallux": "hælʌks",
    "hallway": "hɔːlweɪ",
    "hallways": "hɔːlweɪz",
    "haloed": "heɪləʊd",
    "haloes": "heɪləʊz",
    "halogen": "hælədʒən",
    "halogens": "hælədʒənz",
    "halo": "heɪləʊ",
    "halon": "heɪlɒn",
    "halophyte": "heɪləfaɪt",
    "halos": "heɪləʊz",
    "halted": "hɒltɪd",
    "haltered": "hɒltəd",
    "halterneck": "hɒltənɛk",
    "halters": "hɒltəz",
    "halt": "hɒlt",
    "halting": "hɒltɪŋ",
    "haltingly": "hɒltɪŋli",
    "halts": "hɒlts",
    "halved": "hɑːvd",
    "halve": "hɑːv",
    "halves": "hɑːvz",
    "halving": "hɑːvɪŋ",
    "halyard": "hæljɑːd",
    "halyards": "hæljɑːdz",
    "hamadryad": "hæmɐdrɪæd",
    "hamadryads": "hæmɐdrɪædz",
    "hamartia": "hæmɑːʃɐ",
    "hamburger": "hæmbɜːɡɐ",
    "hamburgers": "hæmbɜːɡəz",
    "hamburg": "hæmbɜːɡ",
    "hamburgs": "hæmbɜːɡz",
    "hame": "heɪm",
    "hames": "heɪmz",
    "ham": "hæm",
    "hamlet": "hæmlət",
    "hamlets": "hæmləts",
    "hammed": "hæmd",
    "hammered": "hæməd",
    "hammer": "hæmɐ",
    "hammerhead": "hæməhɛd",
    "hammerheads": "hæməhɛdz",
    "hammering": "hæmərɪŋ",
    "hammerings": "hæmərɪŋz",
    "hammerlock": "hæməlɒk",
    "hammers": "hæməz",
    "hamming": "hæmɪŋ",
    "hammock": "hæmək",
    "hammocks": "hæməks",
    "hammy": "hæmi",
    "hampered": "hæmpəd",
    "hamper": "hæmpɐ",
    "hampering": "hæmpərɪŋ",
    "hampers": "hæmpəz",
    "hams": "hæmz",
    "hamster": "hæmstɐ",
    "hamsters": "hæmstəz",
    "hamstring": "hæmstrɪŋ",
    "hamstrings": "hæmstrɪŋz",
    "hamstrung": "hæmstrʌŋ",
    "hamza": "hæmzɐ",
    "hance": "hɑːns",
    "handbag": "hændbæɡ",
    "handbags": "hændbæɡz",
    "handball": "hændbɔːl",
    "handballs": "hændbɔːlz",
    "handbill": "hændbɪl",
    "handbills": "hændbɪlz",
    "handbook": "hændbʊk",
    "handbooks": "hændbʊks",
    "handbrake": "hændbreɪk",
    "handbrakes": "hændbreɪks",
    "handcart": "hændkɑːt",
    "handcarts": "hændkɑːts",
    "handclap": "hændklæp",
    "handclaps": "hændklæps",
    "handcrafted": "hændkrɑːftɪd",
    "handcraft": "hændkrɑːft",
    "handcrafting": "hændkrɑːftɪŋ",
    "handcrafts": "hændkrɑːfts",
    "handcuffed": "hændkʌft",
    "handcuff": "hændkʌf",
    "handcuffing": "hændkʌfɪŋ",
    "handcuffs": "hændkʌfs",
    "handed": "hændɪd",
    "handedness": "hændɪdnəs",
    "handful": "hændfəl",
    "handfuls": "hændfəlz",
    "handgrip": "hændɡrɪp",
    "handgun": "hændɡʌn",
    "handguns": "hændɡʌnz",
    "hand": "hænd",
    "handheld": "hændhɛld",
    "handhold": "hændhəʊld",
    "handholds": "hændhəʊldz",
    "handicap": "hændɪkæp",
    "handicapped": "hændɪkæpt",
    "handicapper": "hændɪkæpɐ",
    "handicappers": "hændɪkæpəz",
    "handicapping": "hændɪkæpɪŋ",
    "handicaps": "hændɪkæps",
    "handicraft": "hændɪkrɑːft",
    "handicrafts": "hændɪkrɑːfts",
    "handier": "hændɪɐ",
    "handiest": "hændɪəst",
    "handily": "hændɪli",
    "handiness": "hændɪnəs",
    "handing": "hændɪŋ",
    "handiwork": "hændɪwɜːk",
    "handkerchief": "hændkətʃiːf",
    "handkerchiefs": "hændkətʃiːfs",
    "handlebar": "hændəlbɑː",
    "handlebars": "hændəlbɑːz",
    "handled": "hændəld",
    "handle": "hændəl",
    "handler": "hændlɐ",
    "handlers": "hændləz",
    "handles": "hændəlz",
    "handless": "hændləs",
    "handling": "hændlɪŋ",
    "handmade": "hændmeɪd",
    "handmaiden": "hændmeɪdən",
    "handmaidens": "hændmeɪdənz",
    "handmaid": "hændmeɪd",
    "handoff": "hændɒf",
    "handout": "hændaʊt",
    "handouts": "hændaʊts",
    "handover": "hændəʊvɐ",
    "handovers": "hændəʊvəz",
    "handpicked": "hændpɪkt",
    "handpick": "hændpɪk",
    "handpicking": "hændpɪkɪŋ",
    "handrail": "hændreɪl",
    "handrails": "hændreɪlz",
    "handsaw": "hændsɔː",
    "handset": "hændsɛt",
    "handsets": "hændsɛts",
    "handsful": "hændzfəl",
    "hands": "hændz",
    "handshake": "hændʃeɪk",
    "handshakes": "hændʃeɪks",
    "handshaking": "hændʃeɪkɪŋ",
    "handsome": "hændsʌm",
    "handsomely": "hændsʌmli",
    "handsomeness": "hændsʌmnəs",
    "handsomer": "hændsəmɐ",
    "handsomest": "hændsəʊməst",
    "handspring": "hændsprɪŋ",
    "handsprings": "hændsprɪŋz",
    "handstand": "hændstænd",
    "handstands": "hændstændz",
    "handwork": "hændwɜːk",
    "handwoven": "hændwəʊvən",
    "handwriting": "hændraɪtɪŋ",
    "handwritten": "hændrɪtən",
    "handy": "hændi",
    "handyman": "hændɪmən",
    "handymen": "hændɪmɛn",
    "hangar": "hæŋɡɐ",
    "hangars": "hæŋɡəz",
    "hangdog": "hæŋdɒɡ",
    "hanged": "hæŋd",
    "hanger": "hæŋɐ",
    "hangers": "hæŋəz",
    "hang": "hæŋ",
    "hanging": "hæŋɪŋ",
    "hangings": "hæŋɪŋz",
    "hangman": "hæŋmən",
    "hangmen": "hæŋmɛn",
    "hangout": "hæŋɡaʊt",
    "hangouts": "hæŋɡaʊts",
    "hangover": "hæŋɡəʊvɐ",
    "hangovers": "hæŋɡəʊvəz",
    "hangs": "hæŋz",
    "hangups": "hæŋɡʌps",
    "hankered": "hæŋkəd",
    "hanker": "hæŋkɐ",
    "hankering": "hæŋkərɪŋ",
    "hankers": "hæŋkəz",
    "hank": "hæŋk",
    "hankie": "hæŋki",
    "hankies": "hæŋkiz",
    "hanks": "hæŋks",
    "hanky": "hæŋki",
    "hansel": "hænsəl",
    "hansom": "hænsəm",
    "hanuman": "hænjuːmən",
    "hap": "hæp",
    "haphazard": "hæphæzəd",
    "haphazardly": "hæphæzədli",
    "hapless": "hæpləs",
    "haploid": "hæplɔɪd",
    "haply": "hæpli",
    "happened": "hæpənd",
    "happen": "hæpən",
    "happening": "hæpənɪŋ",
    "happenings": "hæpənɪŋz",
    "happens": "hæpənz",
    "happenstance": "hæpənstəns",
    "happier": "hæpɪɐ",
    "happiest": "hæpɪəst",
    "happily": "hæpɪli",
    "happiness": "hæpɪnəs",
    "happy": "hæpi",
    "harangued": "hɐræŋd",
    "harangue": "hɐræŋ",
    "harangues": "hɐræŋz",
    "haranguing": "hɐræŋɪŋ",
    "harassed": "həræst",
    "harasser": "həræsɐ",
    "harasses": "həræsɪz",
    "harass": "həræs",
    "harassing": "həræsɪŋ",
    "harassment": "həræsmənt",
    "harbinger": "hɑːbɪndʒɐ",
    "harbingers": "hɑːbɪndʒəz",
    "harbor": "hɑːbə",
    "harbourage": "hɑːbɜːrɪdʒ",
    "harboured": "hɑːbəd",
    "harbour": "hɑːbə",
    "harbouring": "hɑːbɜːrɪŋ",
    "harbours": "hɑːbəz",
    "hardback": "hɑːdbæk",
    "hardbacks": "hɑːdbæks",
    "hardball": "hɑːdbɔːl",
    "hardboard": "hɑːdbɔːd",
    "hardcore": "hɑːdkɔː",
    "hardened": "hɑːdənd",
    "hardener": "hɑːdənɐ",
    "harden": "hɑːdən",
    "hardening": "hɑːdənɪŋ",
    "hardens": "hɑːdənz",
    "harder": "hɑːdɐ",
    "hardest": "hɑːdəst",
    "hardhat": "hɑːdhæt",
    "hardhats": "hɑːdhæts",
    "hard": "hɑːd",
    "hardheaded": "hɑːdhɛdɪd",
    "hardhearted": "hɑːdhɑːtɪd",
    "hardier": "hɑːdɪɐ",
    "hardiest": "hɑːdɪəst",
    "hardihood": "hɑːdɪhʊd",
    "hardiness": "hɑːdɪnəs",
    "hardline": "hɑːdlaɪn",
    "hardliner": "hɑːdlaɪnɐ",
    "hardliners": "hɑːdlaɪnəz",
    "hardly": "hɑːdli",
    "hardness": "hɑːdnəs",
    "hardpan": "hɑːdpæn",
    "hards": "hɑːdz",
    "hardship": "hɑːdʃɪp",
    "hardships": "hɑːdʃɪps",
    "hardtack": "hɑːdtæk",
    "hardtop": "hɑːdtɒp",
    "hardtops": "hɑːdtɒps",
    "hardware": "hɑːdweə",
    "hardwired": "hɑːdwaɪəd",
    "hardwood": "hɑːdwʊd",
    "hardwoods": "hɑːdwʊdz",
    "hardworking": "hɑːdwɜːkɪŋ",
    "hardy": "hɑːdi",
    "harebell": "heəbɛl",
    "harebells": "heəbɛlz",
    "harebrained": "heəbreɪnd",
    "hared": "heəd",
    "hare": "heə",
    "harelip": "heəlɪp",
    "harem": "hɑːriːm",
    "harems": "hɑːriːmz",
    "hares": "heəz",
    "haricot": "hærɪkɒt",
    "haricots": "hærɪkɒts",
    "haring": "heərɪŋ",
    "harked": "hɑːkt",
    "harkened": "hɑːkənd",
    "harken": "hɑːkən",
    "harkening": "hɑːkənɪŋ",
    "harkens": "hɑːkənz",
    "hark": "hɑːk",
    "harking": "hɑːkɪŋ",
    "harks": "hɑːks",
    "harlequinade": "hɑːlɪkwɪneɪd",
    "harlequin": "hɑːlɪkwɪn",
    "harlequins": "hɑːlɪkwɪnz",
    "harl": "hɑːl",
    "harlot": "hɑːlɒt",
    "harlotry": "hɑːlətri",
    "harlots": "hɑːlɒts",
    "harmattan": "hɑːmætən",
    "harmed": "hɑːmd",
    "harmer": "hɑːmɐ",
    "harmful": "hɑːmfəl",
    "harmfully": "hɑːmfəli",
    "harm": "hɑːm",
    "harming": "hɑːmɪŋ",
    "harmless": "hɑːmləs",
    "harmlessly": "hɑːmləsli",
    "harmonica": "hɑːmɒnɪkɐ",
    "harmonically": "hɑːmɒnɪkli",
    "harmonicas": "hɑːmɒnɪkəz",
    "harmonic": "hɑːmɒnɪk",
    "harmonics": "hɑːmɒnɪks",
    "harmonies": "hɑːmənɪz",
    "harmonious": "hɑːməʊnɪəs",
    "harmoniously": "hɑːməʊnɪəsli",
    "harmonisation": "hɑːmənaɪzeɪʃən",
    "harmonised": "hɑːmənaɪzd",
    "harmonise": "hɑːmənaɪz",
    "harmonises": "hɑːmənaɪzɪz",
    "harmonising": "hɑːmənaɪzɪŋ",
    "harmonium": "hɑːməʊniəm",
    "harmoniums": "hɑːməʊniəmz",
    "harmony": "hɑːməni",
    "harms": "hɑːmz",
    "harnessed": "hɑːnɪst",
    "harnesses": "hɑːnɪsɪz",
    "harness": "hɑːnɪs",
    "harnessing": "hɑːnɪsɪŋ",
    "harped": "hɑːpt",
    "harper": "hɑːpɐ",
    "harpers": "hɑːpəz",
    "harp": "hɑːp",
    "harpies": "hɑːpɪz",
    "harping": "hɑːpɪŋ",
    "harpist": "hɑːpɪst",
    "harpists": "hɑːpɪsts",
    "harpooned": "hɑːpuːnd",
    "harpooner": "hɑːpuːnɐ",
    "harpoon": "hɑːpuːn",
    "harpooning": "hɑːpuːnɪŋ",
    "harpoons": "hɑːpuːnz",
    "harps": "hɑːps",
    "harpsichord": "hɑːpsɪkɔːd",
    "harpsichords": "hɑːpsɪkɔːdz",
    "harpy": "hɑːpi",
    "harridan": "hærɪdən",
    "harridans": "hærɪdənz",
    "harried": "hærɪd",
    "harrier": "hærɪɐ",
    "harriers": "hæriəz",
    "harries": "hærɪz",
    "harrowed": "hærəʊd",
    "harrow": "hærəʊ",
    "harrowing": "hærəʊɪŋ",
    "harrows": "hærəʊz",
    "harrumph": "hærʌmf",
    "harrumphing": "hærʌmfɪŋ",
    "harry": "hæri",
    "harrying": "hærɪɪŋ",
    "harsher": "hɑːʃɐ",
    "harshest": "hɑːʃəst",
    "harsh": "hɑːʃ",
    "harshly": "hɑːʃli",
    "harshness": "hɑːʃnəs",
    "hartebeest": "hɑːtɪbiːst",
    "hart": "hɑːt",
    "hartshorn": "hɑːtʃɔːn",
    "harts": "hɑːts",
    "haruspicy": "hɑːrəspɪsi",
    "harvested": "hɑːvɪstɪd",
    "harvester": "hɑːvɪstɐ",
    "harvesters": "hɑːvɪstəz",
    "harvest": "hɑːvɪst",
    "harvesting": "hɑːvɪstɪŋ",
    "harvestman": "hɑːvɪstmən",
    "harvests": "hɑːvɪsts",
    "has": "hæz",
    "hashed": "hæʃt",
    "hash": "hæʃ",
    "hashing": "hæʃɪŋ",
    "hashish": "hæʃɪʃ",
    "haslet": "hæslət",
    "hasp": "hɑːsp",
    "hasps": "hɑːsps",
    "hassium": "hæsiəm",
    "hassled": "hæsəld",
    "hassle": "hæsəl",
    "hassles": "hæsəlz",
    "hassling": "hæslɪŋ",
    "hassock": "hæsək",
    "hassocks": "hæsəks",
    "hasted": "heɪstɪd",
    "haste": "heɪst",
    "hastened": "heɪstənd",
    "hasten": "heɪstən",
    "hastening": "heɪstənɪŋ",
    "hastens": "heɪstənz",
    "hast": "heɪst",
    "hastily": "heɪstɪli",
    "hastiness": "heɪstɪnəs",
    "hasting": "heɪstɪŋ",
    "hasty": "heɪsti",
    "hatband": "hætbænd",
    "hatbands": "hætbændz",
    "hatboxes": "hætbɒksɪz",
    "hatbox": "hætbɒks",
    "hatchback": "hætʃbæk",
    "hatchbacks": "hætʃbæks",
    "hatched": "hætʃt",
    "hatcher": "hætʃɐ",
    "hatcheries": "hætʃəriz",
    "hatchery": "hætʃəri",
    "hatches": "hætʃɪz",
    "hatchet": "hætʃɪt",
    "hatchets": "hætʃɪts",
    "hatch": "hætʃ",
    "hatching": "hætʃɪŋ",
    "hatchling": "hætʃlɪŋ",
    "hatchway": "hætʃweɪ",
    "hated": "heɪtɪd",
    "hateful": "heɪtfəl",
    "hatefully": "heɪtfəli",
    "hate": "heɪt",
    "hater": "heɪtɐ",
    "haters": "heɪtəz",
    "hates": "heɪts",
    "hat": "hæt",
    "hath": "hæθ",
    "hating": "heɪtɪŋ",
    "hatpin": "hætpɪn",
    "hatpins": "hætpɪnz",
    "hatred": "heɪtrɪd",
    "hatreds": "heɪtrɪdz",
    "hats": "hæts",
    "hatted": "hætɪd",
    "hatter": "hætɐ",
    "hatters": "hætəz",
    "hatting": "hætɪŋ",
    "haugh": "hɔː",
    "haughtily": "hɔːtɪli",
    "haughtiness": "hɔːtɪnəs",
    "haughty": "hɔːti",
    "haulage": "hɔːlɪdʒ",
    "hauled": "hɔːld",
    "hauler": "hɔːlɐ",
    "haulers": "hɔːləz",
    "haul": "hɔːl",
    "haulier": "hɔːliɐ",
    "hauliers": "hɔːliəz",
    "hauling": "hɔːlɪŋ",
    "hauls": "hɔːlz",
    "haunches": "hɔːntʃɪz",
    "haunch": "hɔːntʃ",
    "haunted": "hɔːntɪd",
    "haunt": "hɔːnt",
    "haunting": "hɔːntɪŋ",
    "hauntingly": "hɔːntɪŋli",
    "haunts": "hɔːnts",
    "hausfrau": "hɔːsfraʊ",
    "hauteur": "hɔːtɜː",
    "havelock": "heɪvlɒk",
    "haven": "heɪvən",
    "havens": "heɪvənz",
    "haver": "heɪvɐ",
    "havering": "heɪvərɪŋ",
    "haversack": "hævəsæk",
    "haversacks": "hævəsæks",
    "haves": "hævz",
    "having": "hævɪŋ",
    "havoc": "hævək",
    "hawed": "hɔːd",
    "hawfinches": "hɔːfɪntʃɪz",
    "hawfinch": "hɔːfɪntʃ",
    "haw": "hɔː",
    "hawing": "hɔːrɪŋ",
    "hawked": "hɔːkt",
    "hawker": "hɔːkɐ",
    "hawkers": "hɔːkəz",
    "hawk": "hɔːk",
    "hawking": "hɔːkɪŋ",
    "hawkings": "hɔːkɪŋz",
    "hawkish": "hɔːkɪʃ",
    "hawkshaw": "hɔːkʃɔː",
    "hawks": "hɔːks",
    "hawse": "hɔːz",
    "hawser": "hɔːzɐ",
    "hawsers": "hɔːzəz",
    "haws": "hɔːz",
    "hawthorn": "hɔːθɔːn",
    "hawthorns": "hɔːθɔːnz",
    "haycock": "heɪkɒk",
    "haycocks": "heɪkɒks",
    "hayfield": "heɪfiːld",
    "hay": "heɪ",
    "hayloft": "heɪlɒft",
    "haymaker": "heɪmeɪkɐ",
    "haymakers": "heɪmeɪkəz",
    "haymaking": "heɪmeɪkɪŋ",
    "hayrack": "heɪræk",
    "hayrick": "heɪrɪk",
    "hayride": "heɪraɪd",
    "hayseed": "heɪsiːd",
    "hays": "heɪz",
    "haystack": "heɪstæk",
    "haystacks": "heɪstæks",
    "hayward": "heɪwəd",
    "haywire": "heɪwaɪə",
    "hazarded": "hæzədɪd",
    "hazard": "hæzəd",
    "hazarding": "hæzədɪŋ",
    "hazardous": "hæzədəs",
    "hazardously": "hæzədəsli",
    "hazards": "hæzədz",
    "haze": "heɪz",
    "hazel": "heɪzəl",
    "hazelnut": "heɪzɪlnʌt",
    "hazelnuts": "heɪzɪlnʌts",
    "hazels": "heɪzəlz",
    "hazes": "heɪzɪz",
    "hazier": "heɪzɪɐ",
    "haziest": "heɪzɪəst",
    "hazily": "heɪzɪli",
    "haziness": "heɪzɪnəs",
    "hazing": "heɪzɪŋ",
    "hazy": "heɪzi",
    "headache": "hɛdeɪk",
    "headaches": "hɛdeɪks",
    "headachy": "hɛdeɪki",
    "headband": "hɛdbænd",
    "headbands": "hɛdbændz",
    "headbanger": "hɛdbæŋɡɐ",
    "headbangers": "hɛdbæŋɡəz",
    "headbanging": "hɛdbæŋɪŋ",
    "headboard": "hɛdbɔːd",
    "headbutted": "hɛdbʌtɪd",
    "headbutt": "hɛdbʌt",
    "headbutting": "hɛdbʌtɪŋ",
    "headbutts": "hɛdbʌts",
    "headcase": "hɛdkeɪs",
    "headcloth": "hɛdklɒθ",
    "headcount": "hɛdkaʊnt",
    "headdresses": "hɛddrɛsɪz",
    "headdress": "hɛddrɛs",
    "headed": "hɛdɪd",
    "header": "hɛdɐ",
    "headers": "hɛdəz",
    "headfirst": "hɛdfɜːst",
    "headgear": "hɛdɡiə",
    "head": "hɛd",
    "headhunted": "hɛdhʌntɪd",
    "headhunter": "hɛdhʌntɐ",
    "headhunters": "hɛdhʌntəz",
    "headhunting": "hɛdhʌntɪŋ",
    "headier": "hɛdɪɐ",
    "headiest": "hɛdɪəst",
    "headiness": "hɛdɪnəs",
    "heading": "hɛdɪŋ",
    "headings": "hɛdɪŋz",
    "headlamp": "hɛdlæmp",
    "headlamps": "hɛdlæmps",
    "headland": "hɛdlənd",
    "headlands": "hɛdləndz",
    "headless": "hɛdləs",
    "headlight": "hɛdlaɪt",
    "headlights": "hɛdlaɪts",
    "headlined": "hɛdlaɪnd",
    "headline": "hɛdlaɪn",
    "headliner": "hɛdlaɪnɐ",
    "headliners": "hɛdlaɪnəz",
    "headlines": "hɛdlaɪnz",
    "headlining": "hɛdlaɪnɪŋ",
    "headlock": "hɛdlɒk",
    "headlong": "hɛdlɒŋ",
    "headman": "hɛdmən",
    "headmaster": "hɛdmɑːstɐ",
    "headmasters": "hɛdmɑːstəz",
    "headmistresses": "hɛdmɪstrəsɪz",
    "headmistress": "hɛdmɪstrəs",
    "headphone": "hɛdfəʊn",
    "headphones": "hɛdfəʊnz",
    "headpiece": "hɛdpiːs",
    "headpieces": "hɛdpiːsɪz",
    "headquartered": "hɛdkwɔːtəd",
    "headquarter": "hɛdkwɔːtɐ",
    "headquarters": "hɛdkwɔːtəz",
    "headrest": "hɛdrɛst",
    "headrests": "hɛdrɛsts",
    "headroom": "hɛdruːm",
    "headscarf": "hɛdskɑːf",
    "headscarves": "hɛdskɑːvz",
    "headset": "hɛdsɛt",
    "headsets": "hɛdsɛts",
    "heads": "hɛdz",
    "headship": "hɛdʃɪp",
    "headshrinkers": "hɛdʃrɪŋkəz",
    "headsman": "hɛdzmən",
    "headstand": "hɛdstænd",
    "headstands": "hɛdstændz",
    "headstock": "hɛdstɒk",
    "headstone": "hɛdstəʊn",
    "headstones": "hɛdstəʊnz",
    "headstrong": "hɛdstrɒŋ",
    "headteacher": "hɛdtiːtʃɐ",
    "headteachers": "hɛdtiːtʃəz",
    "headwaters": "hɛdwɔːtəz",
    "headway": "hɛdweɪ",
    "headwind": "hɛdwɪnd",
    "headwinds": "hɛdwɪndz",
    "heady": "hɛdi",
    "healed": "hiːld",
    "healer": "hiːlɐ",
    "healers": "hiːləz",
    "heal": "hiːl",
    "healing": "hiːlɪŋ",
    "healings": "hiːlɪŋz",
    "heals": "hiːlz",
    "healthcare": "hɛlθkeə",
    "healthful": "hɛlθfəl",
    "health": "hɛlθ",
    "healthier": "hɛlθɪɐ",
    "healthiest": "hɛlθɪəst",
    "healthily": "hɛlθɪli",
    "healthiness": "hɛlθɪnəs",
    "healths": "hɛlθs",
    "healthy": "hɛlθi",
    "heaped": "hiːpt",
    "heap": "hiːp",
    "heaping": "hiːpɪŋ",
    "heaps": "hiːps",
    "heard": "hɜːd",
    "hearer": "hiərɐ",
    "hearers": "hiərəz",
    "hear": "hiə",
    "hearing": "hiərɪŋ",
    "hearings": "hiərɪŋz",
    "hearken": "hɑːkən",
    "hearsay": "hiəseɪ",
    "hearse": "hɜːs",
    "hearses": "hɜːsɪz",
    "hears": "hiəz",
    "heartache": "hɑːteɪk",
    "heartaches": "hɑːteɪks",
    "heartbeat": "hɑːtbiːt",
    "heartbeats": "hɑːtbiːts",
    "heartbreaker": "hɑːtbreɪkɐ",
    "heartbreak": "hɑːtbreɪk",
    "heartbreaking": "hɑːtbreɪkɪŋ",
    "heartbreakingly": "hɑːtbreɪkɪŋli",
    "heartbreaks": "hɑːtbreɪks",
    "heartbroken": "hɑːtbrəʊkən",
    "heartburn": "hɑːtbɜːn",
    "hearted": "hɑːtɪd",
    "heartened": "hɑːtənd",
    "hearten": "hɑːtən",
    "heartening": "hɑːtənɪŋ",
    "heartens": "hɑːtənz",
    "heartfelt": "hɑːtfɛlt",
    "hearth": "hɑːθ",
    "hearthrug": "hɑːθrʌɡ",
    "hearths": "hɑːθs",
    "heart": "hɑːt",
    "heartier": "hɑːtɪɐ",
    "hearties": "hɑːtɪz",
    "heartiest": "hɑːtɪəst",
    "heartily": "hɑːtɪli",
    "heartiness": "hɑːtɪnəs",
    "heartland": "hɑːtlənd",
    "heartlands": "hɑːtləndz",
    "heartless": "hɑːtləs",
    "heartlessly": "hɑːtləsli",
    "heartlessness": "hɑːtləsnəs",
    "heartrending": "hɑːtrɛndɪŋ",
    "heartsease": "hɑːtsiːs",
    "hearts": "hɑːts",
    "heartsick": "hɑːtsɪk",
    "heartstrings": "hɑːtstrɪŋz",
    "heartthrob": "hɑːtθrɒb",
    "heartthrobs": "hɑːtθrɒbz",
    "heartwarming": "hɑːtwɔːmɪŋ",
    "heartwood": "hɑːtwʊd",
    "hearty": "hɑːti",
    "heated": "hiːtɪd",
    "heater": "hiːtɐ",
    "heaters": "hiːtəz",
    "heathen": "hiːðən",
    "heathens": "hiːðənz",
    "heather": "hɛðɐ",
    "heathers": "hɛðəz",
    "heathery": "hɛðəri",
    "heath": "hiːθ",
    "heat": "hiːt",
    "heathland": "hiːθlənd",
    "heaths": "hiːθs",
    "heathy": "hiːθi",
    "heating": "hiːtɪŋ",
    "heatproof": "hiːtpruːf",
    "heats": "hiːts",
    "heatstroke": "hiːtstrəʊk",
    "heatwave": "hiːtweɪv",
    "heatwaves": "hiːtweɪvz",
    "heaved": "hiːvd",
    "heave": "hiːv",
    "heaven": "hɛvən",
    "heavenly": "hɛvənli",
    "heavens": "hɛvənz",
    "heavenward": "hɛvənwəd",
    "heavenwards": "hɛvənwədz",
    "heaver": "hiːvɐ",
    "heavers": "hiːvəz",
    "heaves": "hiːvz",
    "heavier": "hɛviɐ",
    "heavies": "hɛviz",
    "heaviest": "hɛviəst",
    "heavily": "hɛvili",
    "heaviness": "hɛvinəs",
    "heaving": "hiːvɪŋ",
    "heavy": "hɛvi",
    "heavyweight": "hɛviweɪt",
    "heavyweights": "hɛviweɪts",
    "hebdomadal": "hɛbdəmædəl",
    "hecatomb": "hɛkɐtuːm",
    "heck": "hɛk",
    "heckled": "hɛkəld",
    "heckle": "hɛkəl",
    "heckler": "hɛklɐ",
    "hecklers": "hɛkləz",
    "heckles": "hɛkəlz",
    "heckling": "hɛklɪŋ",
    "hectare": "hɛkteə",
    "hectares": "hɛkteəz",
    "hectically": "hɛktɪkli",
    "hectic": "hɛktɪk",
    "hectolitre": "hɛktəliːtɐ",
    "hectored": "hɛktəd",
    "hector": "hɛktɐ",
    "hectoring": "hɛktərɪŋ",
    "hectors": "hɛktəz",
    "heddle": "hɛdəl",
    "hedged": "hɛdʒd",
    "hedge": "hɛdʒ",
    "hedgehog": "hɛdʒhɒɡ",
    "hedgehogs": "hɛdʒhɒɡz",
    "hedger": "hɛdʒɐ",
    "hedgerow": "hɛdʒrəʊ",
    "hedgerows": "hɛdʒrəʊz",
    "hedgers": "hɛdʒəz",
    "hedges": "hɛdʒɪz",
    "hedging": "hɛdʒɪŋ",
    "hedonic": "hɛdɒnɪk",
    "hedonism": "hɛdənɪzəm",
    "hedonist": "hɛdənɪst",
    "hedonistic": "hɛdənɪstɪk",
    "hedonists": "hɛdənɪsts",
    "heeded": "hiːdɪd",
    "heed": "hiːd",
    "heeding": "hiːdɪŋ",
    "heedless": "hiːdləs",
    "heeds": "hiːdz",
    "heeled": "hiːld",
    "heeler": "hiːlɐ",
    "heel": "hiːl",
    "heeling": "hiːlɪŋ",
    "heels": "hiːlz",
    "hefted": "hɛftɪd",
    "heft": "hɛft",
    "heftier": "hɛftɪɐ",
    "heftiest": "hɛftɪəst",
    "heftily": "hɛftɪli",
    "hefting": "hɛftɪŋ",
    "hefts": "hɛfts",
    "hefty": "hɛfti",
    "hegemony": "hɛdʒɪməni",
    "heifer": "hɛfɐ",
    "heifers": "hɛfəz",
    "heightened": "haɪtənd",
    "heighten": "haɪtən",
    "heightening": "haɪtənɪŋ",
    "heightens": "haɪtənz",
    "height": "haɪt",
    "heights": "haɪts",
    "heinous": "heɪnəs",
    "heinously": "heɪnəsli",
    "heinousness": "heɪnəsnəs",
    "heir": "eə",
    "heiress": "eərɛs",
    "heiresses": "eərɛsɪz",
    "heirloom": "eəluːm",
    "heirlooms": "eəluːmz",
    "heirs": "eəz",
    "heisted": "haɪstɪd",
    "heist": "haɪst",
    "heists": "haɪsts",
    "held": "hɛld",
    "helianthus": "hɛliənθəs",
    "helical": "hɛlɪkəl",
    "helicon": "hɛlɪkən",
    "helicoptered": "hɛlɪkɒptəd",
    "helicopter": "hɛlɪkɒptɐ",
    "helicopters": "hɛlɪkɒptəz",
    "heliocentric": "hɛlɪəʊsɛntrɪk",
    "heliotrope": "hɛlɪɒtrəʊp",
    "heliotropes": "hɛlɪɒtrəʊps",
    "helipad": "hɛlɪpæd",
    "helipads": "hɛlɪpædz",
    "heliport": "hɛlɪpɔːt",
    "helium": "hiːliəm",
    "helix": "hiːlɪks",
    "hellbender": "hɛlbɛndɐ",
    "hellbent": "hɛlbənt",
    "hellcat": "hɛlkæt",
    "hellebore": "hɛlɪbɔː",
    "heller": "hɛlɐ",
    "hellfire": "hɛlfaɪə",
    "hell": "hɛl",
    "hellhole": "hɛlhəʊl",
    "hellhound": "hɛlhaʊnd",
    "hellhounds": "hɛlhaʊndz",
    "hellion": "hɛliən",
    "hellish": "hɛlɪʃ",
    "hellishly": "hɛlɪʃli",
    "hello": "hələʊ",
    "hellos": "hələʊz",
    "hells": "hɛlz",
    "helluva": "hɛləvɐ",
    "helmeted": "hɛlmɪtɪd",
    "helmet": "hɛlmɪt",
    "helmets": "hɛlmɪts",
    "helm": "hɛlm",
    "helms": "hɛlmz",
    "helmsman": "hɛlmzmən",
    "helmsmen": "hɛlmzmɛn",
    "helots": "hɛlɒts",
    "helped": "hɛlpt",
    "helper": "hɛlpɐ",
    "helpers": "hɛlpəz",
    "helpful": "hɛlpfəl",
    "helpfully": "hɛlpfəli",
    "helpfulness": "hɛlpfəlnəs",
    "help": "hɛlp",
    "helping": "hɛlpɪŋ",
    "helpings": "hɛlpɪŋz",
    "helpless": "hɛlpləs",
    "helplessly": "hɛlpləsli",
    "helplessness": "hɛlpləsnəs",
    "helpline": "hɛlplaɪn",
    "helplines": "hɛlplaɪnz",
    "helpmeet": "hɛlpmiːt",
    "helps": "hɛlps",
    "heme": "hiːm",
    "hem": "hɛm",
    "hemiplegia": "hɛmɪpliːdʒɐ",
    "hemisphere": "hɛmɪsfiə",
    "hemispheres": "hɛmɪsfiəz",
    "hemispherical": "hɛmɪsfɛrɪkəl",
    "hemline": "hɛmlaɪn",
    "hemlines": "hɛmlaɪnz",
    "hemlock": "hɛmlɒk",
    "hemmed": "hɛmd",
    "hemming": "hɛmɪŋ",
    "hemorrhagic": "hɛmərædʒɪk",
    "hemp": "hɛmp",
    "hems": "hɛmz",
    "henbane": "hɛnbeɪn",
    "henceforth": "hɛnsfɔːθ",
    "henceforward": "hɛnsɪfɔːwəd",
    "hence": "hɛns",
    "henchman": "hɛntʃmən",
    "henchmen": "hɛntʃmɛn",
    "henge": "hɛndʒ",
    "hen": "hɛn",
    "henhouse": "hɛnhaʊs",
    "henna": "hɛnɐ",
    "henpecked": "hɛnpɛkt",
    "henries": "hɛnrɪz",
    "henry": "hɛnri",
    "hens": "hɛnz",
    "hent": "hɛnt",
    "heparin": "hɛpərɪn",
    "hepatica": "hɛpætɪkɐ",
    "hepatic": "hɛpætɪk",
    "hepatitis": "hɛpɐtaɪtɪs",
    "hep": "hɛp",
    "hepper": "hɛpɐ",
    "heptagon": "hɛptəɡən",
    "heptarchy": "hɛptɑːki",
    "heptathlon": "hɛptæθlən",
    "heralded": "hɛrəldɪd",
    "herald": "hɛrəld",
    "heraldic": "hərældɪk",
    "heralding": "hɛrəldɪŋ",
    "heraldry": "hɛrəldri",
    "heralds": "hɛrəldz",
    "herbaceous": "hɜːbeɪʃəs",
    "herbage": "hɜːbɪdʒ",
    "herbal": "hɜːbəl",
    "herbalism": "hɜːbəlɪzəm",
    "herbalist": "hɜːbəlɪst",
    "herbalists": "hɜːbəlɪsts",
    "herbals": "hɜːbəlz",
    "herbarium": "hɜːbeəriəm",
    "herb": "hɜːb",
    "herbicide": "hɜːbɪsaɪd",
    "herbicides": "hɜːbɪsaɪdz",
    "herbivore": "hɜːbɪvɔː",
    "herbivores": "hɜːbɪvɔːz",
    "herbivorous": "hɜːbɪvərəs",
    "herbs": "hɜːbz",
    "herby": "hɜːbi",
    "herculean": "hɜːkjʊliən",
    "herded": "hɜːdɪd",
    "herder": "hɜːdɐ",
    "herders": "hɜːdəz",
    "herd": "hɜːd",
    "herding": "hɜːdɪŋ",
    "herds": "hɜːdz",
    "herdsman": "hɜːdzmən",
    "herdsmen": "hɜːdzmɛn",
    "hereabouts": "hiərɐbaʊts",
    "hereafter": "hiərɑːftɐ",
    "hereby": "hiəbaɪ",
    "hereditary": "hɪrɛdɪtəri",
    "heredity": "hərɛdɪti",
    "here": "hiə",
    "herein": "hiərɪn",
    "hereof": "hiərɒf",
    "hereon": "hiərɒn",
    "heres": "hiəz",
    "heresies": "hɛrəsɪz",
    "heresy": "hɛrəsi",
    "heretical": "hɪrɛtɪkəl",
    "heretic": "hɛrətɪk",
    "heretics": "hɛrətɪks",
    "heretofore": "hiətʊfɔː",
    "hereto": "hiətuː",
    "hereunder": "hiərʌndɐ",
    "herewith": "hiəwɪð",
    "her": "hɜː",
    "heriot": "hiərɪɒt",
    "heritability": "hɛrɪtəbɪlɪti",
    "heritable": "hɛrɪtəbəl",
    "heritage": "hɛrɪtɪdʒ",
    "heritages": "hɛrɪtɪdʒɪz",
    "hermaphrodite": "hɜːmæfrədaɪt",
    "hermaphrodites": "hɜːmɐfrədaɪts",
    "hermaphroditism": "hɜːmɐfrədɪtɪzəm",
    "hermeneutics": "hɜːmənjuːtɪks",
    "hermetically": "hɜːmɛtɪkli",
    "hermetic": "hɜːmɛtɪk",
    "herm": "hɜːm",
    "hermitage": "hɜːmɪtɪdʒ",
    "hermit": "hɜːmɪt",
    "hermits": "hɜːmɪts",
    "hern": "hɜːn",
    "hernia": "hɜːniɐ",
    "hernias": "hɜːniəz",
    "herniated": "hɜːnɪeɪtɪd",
    "herniating": "hɜːnɪeɪtɪŋ",
    "heroes": "hiərəʊz",
    "hero": "hiərəʊ",
    "heroically": "hɪrəʊɪkli",
    "heroic": "hɪrəʊɪk",
    "heroics": "hɪrəʊɪks",
    "heroine": "hɛrəʊɪn",
    "heroines": "hɛrəʊɪnz",
    "heroin": "hɛrəʊɪn",
    "heroism": "hɛrəʊɪzəm",
    "heron": "hɛrən",
    "heronries": "hɛrənrɪz",
    "heronry": "hɛrənri",
    "herons": "hɛrənz",
    "heros": "hiərəʊz",
    "herpes": "hɜːpiːz",
    "herpetic": "hɜːpɛtɪk",
    "herpetologist": "hɜːpɪtɒlədʒɪst",
    "herpetology": "hɜːpɪtɒlədʒi",
    "herringbone": "hɛrɪŋbəʊn",
    "herring": "hɛrɪŋ",
    "herrings": "hɛrɪŋz",
    "herself": "hɜːsɛlf",
    "hers": "hɜːz",
    "hertz": "hɜːts",
    "hes": "hiːz",
    "hesitance": "hɛsɪtəns",
    "hesitancy": "hɛsɪtənsi",
    "hesitant": "hɛsɪtənt",
    "hesitantly": "hɛsɪtəntli",
    "hesitated": "hɛsɪteɪtɪd",
    "hesitate": "hɛsɪteɪt",
    "hesitates": "hɛsɪteɪts",
    "hesitating": "hɛsɪteɪtɪŋ",
    "hesitation": "hɛsɪteɪʃən",
    "hesitations": "hɛsɪteɪʃənz",
    "hessian": "hɛʃən",
    "hessians": "hɛʃənz",
    "hest": "hɛst",
    "h": "eɪtʃ",
    "heterogeneous": "hɛtrəʊdʒəniəs",
    "hetero": "hɛtrəʊ",
    "heterosexual": "hɛtrəʊsɛkʃuːəl",
    "heterosexuality": "hɛtrəʊsɛkʃuːælɪti",
    "heterosexuals": "hɛtrəʊsɛkʃuːəlz",
    "heterosis": "hɛtrəʊsiz",
    "heth": "hɛθ",
    "hewed": "hjuːd",
    "hewer": "hjuːɐ",
    "hewers": "hjuːəz",
    "hew": "hjuː",
    "hewing": "hjuːɪŋ",
    "hewn": "hjuːn",
    "hexadecimal": "hɛksɐdɛsɪməl",
    "hexagonal": "hɛksæɡənəl",
    "hexagon": "hɛksəɡən",
    "hexagons": "hɛksəɡənz",
    "hexagram": "hɛksɐɡræm",
    "hexameter": "hɛksɐmiːtɐ",
    "hexameters": "hɛksɐmiːtəz",
    "hexapod": "hɛksɐpɒd",
    "hexed": "hɛkst",
    "hex": "hɛks",
    "heyday": "heɪdeɪ",
    "heydays": "heɪdeɪz",
    "hey": "heɪ",
    "hg": "eɪtʃdʒiː",
    "hiatus": "haɪeɪtəs",
    "hibernaculum": "haɪbənækjʊləm",
    "hibernal": "haɪbənəl",
    "hibernated": "haɪbəneɪtɪd",
    "hibernate": "haɪbəneɪt",
    "hibernates": "haɪbəneɪts",
    "hibernating": "haɪbəneɪtɪŋ",
    "hibernation": "haɪbəneɪʃən",
    "hibiscus": "hɪbɪskəs",
    "hiccoughs": "hɪkɒfz",
    "hiccup": "hɪkʌp",
    "hiccuping": "hɪkjuːpɪŋ",
    "hiccups": "hɪkʌps",
    "hic": "hɪk",
    "hickey": "hɪki",
    "hickeys": "hɪkɪz",
    "hick": "hɪk",
    "hickory": "hɪkəri",
    "hicks": "hɪks",
    "hidalgo": "hɪdælɡəʊ",
    "hidden": "hɪdən",
    "hideaway": "haɪdəweɪ",
    "hideaways": "haɪdəweɪz",
    "hidebound": "haɪdbaʊnd",
    "hided": "haɪdɪd",
    "hide": "haɪd",
    "hideous": "hɪdiəs",
    "hideously": "hɪdiəsli",
    "hideousness": "hɪdiəsnəs",
    "hideout": "haɪdaʊt",
    "hideouts": "haɪdaʊts",
    "hider": "haɪdɐ",
    "hiders": "haɪdəz",
    "hides": "haɪdz",
    "hid": "hɪd",
    "hiding": "haɪdɪŋ",
    "hidings": "haɪdɪŋz",
    "hie": "haɪ",
    "hierarchal": "haɪərɑːtʃəl",
    "hierarchical": "haɪərɑːkɪkəl",
    "hierarchically": "haɪərɑːkɪkli",
    "hierarchies": "haɪərɑːkɪz",
    "hierarchy": "haɪərɑːki",
    "hieratic": "haɪərætɪk",
    "hieroglyph": "haɪərəɡlɪf",
    "hieroglyphic": "haɪərəɡlɪfɪk",
    "hieroglyphics": "haɪərəɡlɪfɪks",
    "hieroglyphs": "haɪərəɡlɪfz",
    "highball": "haɪbɔːl",
    "highballs": "haɪbɔːlz",
    "highborn": "haɪbɔːn",
    "highbrow": "haɪbraʊ",
    "highbrows": "haɪbraʊz",
    "highchair": "haɪtʃeə",
    "higher": "haɪɐ",
    "highers": "haɪəz",
    "highest": "haɪəst",
    "highfalutin": "haɪfɐluːtɪn",
    "highflier": "haɪflaɪɐ",
    "high": "haɪ",
    "highish": "haɪɪʃ",
    "highlander": "haɪləndɐ",
    "highlanders": "haɪləndəz",
    "highland": "haɪlənd",
    "highlands": "haɪləndz",
    "highlighted": "haɪlaɪtɪd",
    "highlighter": "haɪlaɪtɐ",
    "highlighters": "haɪlaɪtəz",
    "highlight": "haɪlaɪt",
    "highlighting": "haɪlaɪtɪŋ",
    "highlights": "haɪlaɪts",
    "highline": "haɪlaɪn",
    "highly": "haɪli",
    "highness": "haɪnəs",
    "highpoint": "haɪpɔɪnt",
    "highroad": "haɪrəʊd",
    "highs": "haɪz",
    "hightailed": "haɪteɪld",
    "hightail": "haɪteɪl",
    "highway": "haɪweɪ",
    "highwayman": "haɪweɪmən",
    "highwaymen": "haɪweɪmɛn",
    "highways": "haɪweɪz",
    "hi": "haɪ",
    "hijacked": "haɪdʒækt",
    "hijacker": "haɪdʒækɐ",
    "hijackers": "haɪdʒækəz",
    "hijack": "haɪdʒæk",
    "hijacking": "haɪdʒækɪŋ",
    "hijackings": "haɪdʒækɪŋz",
    "hijacks": "haɪdʒæks",
    "hijinks": "haɪdʒɪŋks",
    "hiked": "haɪkt",
    "hike": "haɪk",
    "hiker": "haɪkɐ",
    "hikers": "haɪkəz",
    "hikes": "haɪks",
    "hiking": "haɪkɪŋ",
    "hilarious": "hɪleərɪəs",
    "hilariously": "hɪleərɪəsli",
    "hilariousness": "hɪleərɪəsnəs",
    "hilarity": "hɪlærɪti",
    "hillbillies": "hɪlbɪliz",
    "hillbilly": "hɪlbɪli",
    "hill": "hɪl",
    "hillier": "hɪliɐ",
    "hilliest": "hɪliəst",
    "hillock": "hɪlək",
    "hillocks": "hɪləks",
    "hills": "hɪlz",
    "hillside": "hɪlsaɪd",
    "hillsides": "hɪlsaɪdz",
    "hilltop": "hɪltɒp",
    "hilltops": "hɪltɒps",
    "hillwalking": "hɪlwɔːkɪŋ",
    "hilly": "hɪli",
    "hilt": "hɪlt",
    "hilts": "hɪlts",
    "him": "hɪm",
    "himself": "hɪmsɛlf",
    "hims": "hɪmz",
    "hindered": "hɪndəd",
    "hindering": "hɪndərɪŋ",
    "hinders": "hɪndəz",
    "hind": "haɪnd",
    "hindmost": "haɪndməʊst",
    "hindquarters": "haɪndkwɔːtəz",
    "hindrance": "hɪndrəns",
    "hindrances": "hɪndrənsɪz",
    "hinds": "haɪndz",
    "hindsight": "haɪndsaɪt",
    "hinged": "hɪndʒd",
    "hinge": "hɪndʒ",
    "hinges": "hɪndʒɪz",
    "hinging": "hɪndʒɪŋ",
    "hin": "hɪn",
    "hinnies": "hɪnɪz",
    "hinny": "hɪni",
    "hins": "hɪnz",
    "hinted": "hɪntɪd",
    "hinterland": "hɪntələnd",
    "hinterlands": "hɪntələndz",
    "hint": "hɪnt",
    "hinting": "hɪntɪŋ",
    "hints": "hɪnts",
    "hipbone": "hɪpbəʊn",
    "hiphop": "hɪphɒp",
    "hip": "hɪp",
    "hipness": "hɪpnəs",
    "hipped": "hɪpt",
    "hipper": "hɪpɐ",
    "hippest": "hɪpəst",
    "hippie": "hɪpi",
    "hippies": "hɪpɪz",
    "hipping": "hɪpɪŋ",
    "hippocampi": "hɪpəkæmpi",
    "hippocampus": "hɪpəkæmpəs",
    "hippodrome": "hɪpədrəʊm",
    "hippogriff": "hɪpəɡrɪf",
    "hippo": "hɪpəʊ",
    "hippopotami": "hɪpəpətɑːmi",
    "hippopotamuses": "hɪpəpɒtɐmjuːsɪz",
    "hippopotamus": "hɪpəpɒtæməs",
    "hippos": "hɪpəʊz",
    "hippy": "hɪpi",
    "hips": "hɪps",
    "hipster": "hɪpstɐ",
    "hipsters": "hɪpstəz",
    "hiragana": "hɜːrɐɡɑːnɐ",
    "hired": "haɪəd",
    "hire": "haɪə",
    "hireling": "haɪəlɪŋ",
    "hirer": "haɪərɐ",
    "hires": "haɪəz",
    "hiring": "haɪərɪŋ",
    "hirsute": "hɜːsuːt",
    "hirundine": "hɜːrəndiːn",
    "his": "hɪz",
    "hissed": "hɪst",
    "hisses": "hɪsɪz",
    "hiss": "hɪs",
    "hissing": "hɪsɪŋ",
    "histamine": "hɪstɐmiːn",
    "histamines": "hɪstɐmiːnz",
    "histogram": "hɪstəɡræm",
    "histology": "hɪstɒlədʒi",
    "histones": "hɪstəʊnz",
    "histoplasmosis": "hɪstəplɐzməʊsɪs",
    "historian": "hɪstɔːriən",
    "historians": "hɪstɔːriənz",
    "historical": "hɪstɒrɪkəl",
    "historically": "hɪstɒrɪkli",
    "historic": "hɪstɒrɪk",
    "historicism": "hɪstɔːrɪsɪzəm",
    "historicity": "hɪstɔːrɪsɪti",
    "histories": "hɪstəriz",
    "historiography": "hɪstɔːrɪɒɡrəfi",
    "history": "hɪstəri",
    "histrionic": "hɪstrɪɒnɪk",
    "histrionics": "hɪstrɪɒnɪks",
    "hitched": "hɪtʃt",
    "hitcher": "hɪtʃɐ",
    "hitchers": "hɪtʃəz",
    "hitches": "hɪtʃɪz",
    "hitchhiked": "hɪtʃhaɪkt",
    "hitchhike": "hɪtʃhaɪk",
    "hitchhiker": "hɪtʃhɪkɐ",
    "hitchhikers": "hɪtʃhɪkəz",
    "hitchhiking": "hɪtʃhaɪkɪŋ",
    "hitch": "hɪtʃ",
    "hitching": "hɪtʃɪŋ",
    "hither": "hɪðɐ",
    "hitherto": "hɪðətuː",
    "hit": "hɪt",
    "hits": "hɪts",
    "hitter": "hɪtɐ",
    "hitters": "hɪtəz",
    "hitting": "hɪtɪŋ",
    "hived": "haɪvd",
    "hive": "haɪv",
    "hives": "haɪvz",
    "hiving": "haɪvɪŋ",
    "hiya": "haɪɐ",
    "hl": "eɪtʃɛl",
    "hm": "eɪtʃɛm",
    "hmm": "həm",
    "hoagie": "həʊdʒi",
    "hoagy": "həʊdʒi",
    "hoarded": "hɔːdɪd",
    "hoarder": "hɔːdɐ",
    "hoarders": "hɔːdəz",
    "hoard": "hɔːd",
    "hoarding": "hɔːdɪŋ",
    "hoardings": "hɔːdɪŋz",
    "hoards": "hɔːdz",
    "hoarfrost": "hɔːfrɒst",
    "hoar": "hɔː",
    "hoarse": "hɔːs",
    "hoarsely": "hɔːsli",
    "hoarseness": "hɔːsnəs",
    "hoary": "hɔːri",
    "hoatzin": "həʊtsɪn",
    "hoaxed": "həʊkst",
    "hoaxer": "həʊksɐ",
    "hoaxers": "həʊksəz",
    "hoaxes": "həʊksɪz",
    "hoax": "həʊks",
    "hobbies": "hɒbɪz",
    "hobbit": "hɒbɪt",
    "hobbled": "hɒbəld",
    "hobble": "hɒbəl",
    "hobbles": "hɒbəlz",
    "hobbling": "hɒblɪŋ",
    "hobby": "hɒbi",
    "hobbyhorse": "hɒbɪhɔːs",
    "hobbyhorses": "hɒbɪhɔːsɪz",
    "hobbyist": "hɒbɪɪst",
    "hobbyists": "hɒbɪɪsts",
    "hobgoblin": "hɒbɡəblɪn",
    "hob": "hɒb",
    "hobnailed": "hɒbneɪld",
    "hobnail": "hɒbneɪl",
    "hobnails": "hɒbneɪlz",
    "hobnobbed": "hɒbnɒbd",
    "hobnobbing": "hɒbnɒbɪŋ",
    "hobnob": "hɒbnɒb",
    "hobnobs": "hɒbnɒbz",
    "hobo": "həʊbəʊ",
    "hobos": "həʊbəʊz",
    "hobs": "hɒbz",
    "hocked": "hɒkt",
    "hockey": "hɒki",
    "hock": "hɒk",
    "hocking": "hɒkɪŋ",
    "hocks": "hɒks",
    "hocus": "həʊkəs",
    "hodgepodge": "hɒdʒpɒdʒ",
    "hod": "hɒd",
    "hods": "hɒdz",
    "hoed": "həʊd",
    "hoedown": "həʊdaʊn",
    "hoe": "həʊ",
    "hoeing": "həʊɪŋ",
    "hoes": "həʊz",
    "hogan": "həʊɡən",
    "hogans": "həʊɡənz",
    "hogged": "hɒɡd",
    "hogger": "hɒɡɐ",
    "hogging": "hɒɡɪŋ",
    "hog": "hɒɡ",
    "hogshead": "hɒɡzhɛd",
    "hogs": "hɒɡz",
    "hogtied": "hɒɡtaɪd",
    "hogwash": "hɒɡwɒʃ",
    "hogweed": "hɒɡwiːd",
    "ho": "həʊ",
    "hoicked": "hɔɪkt",
    "hoick": "hɔɪk",
    "hoicking": "hɔɪkɪŋ",
    "hoisted": "hɔɪstɪd",
    "hoist": "hɔɪst",
    "hoisting": "hɔɪstɪŋ",
    "hoists": "hɔɪsts",
    "hokey": "həʊki",
    "hokum": "həʊkəm",
    "holdall": "həʊldɔːl",
    "holdalls": "həʊldɔːlz",
    "holden": "həʊldən",
    "holder": "həʊldɐ",
    "holders": "həʊldəz",
    "holdfast": "həʊldfɑːst",
    "hold": "həʊld",
    "holding": "həʊldɪŋ",
    "holdings": "həʊldɪŋz",
    "holdout": "həʊldaʊt",
    "holds": "həʊldz",
    "holed": "həʊld",
    "hole": "həʊl",
    "holes": "həʊlz",
    "holey": "həʊli",
    "holidayed": "hɒlɪdeɪd",
    "holiday": "hɒlɪdeɪ",
    "holidaying": "hɒlɪdeɪɪŋ",
    "holidaymaker": "hɒlɪdeɪmeɪkɐ",
    "holidaymakers": "hɒlɪdeɪmeɪkəz",
    "holidays": "hɒlɪdeɪz",
    "holier": "həʊliɐ",
    "holiest": "həʊliəst",
    "holiness": "həʊlinəs",
    "holing": "həʊlɪŋ",
    "holistically": "həlɪstɪkli",
    "holistic": "həlɪstɪk",
    "hollered": "hɒləd",
    "holler": "hɒlɐ",
    "hollering": "hɒlərɪŋ",
    "hollers": "hɒləz",
    "hollies": "hɒliz",
    "holloware": "hɒləʊeə",
    "hollowed": "hɒləʊd",
    "hollow": "hɒləʊ",
    "hollowing": "hɒləʊɪŋ",
    "hollowness": "hɒləʊnəs",
    "hollows": "hɒləʊz",
    "hollowware": "hɒləʊweə",
    "holly": "hɒli",
    "hollyhock": "hɒlɪhɒk",
    "hollyhocks": "hɒlɪhɒks",
    "holm": "həʊm",
    "holmium": "hɒlmiəm",
    "holocaust": "hɒləkɔːst",
    "hologram": "hɒləɡræm",
    "holograms": "hɒləɡræmz",
    "holograph": "hɒləɡræf",
    "holographic": "hɒləɡræfɪk",
    "holography": "həlɒɡrəfi",
    "holotype": "hɒlətaɪp",
    "holp": "hɒlp",
    "hols": "hɒlz",
    "holstered": "həʊlstəd",
    "holster": "həʊlstɐ",
    "holsters": "həʊlstəz",
    "holt": "həʊlt",
    "holy": "həʊli",
    "homage": "hɒmɪdʒ",
    "homages": "hɒmɪdʒɪz",
    "hombre": "hɒmbɐ",
    "hombres": "hɒmbəz",
    "homburg": "hɒmbɜːɡ",
    "homebody": "həʊmbɒdi",
    "homeboy": "həʊmbɔɪ",
    "homeboys": "həʊmbɔɪz",
    "homecoming": "həʊmkʌmɪŋ",
    "homecomings": "həʊmkʌmɪŋz",
    "homed": "həʊmd",
    "homegirl": "həʊmɡɜːl",
    "homegirls": "həʊmɡɜːlz",
    "homegrown": "həʊmɡrəʊn",
    "home": "həʊm",
    "homeland": "həʊmlənd",
    "homelands": "həʊmləndz",
    "homeless": "həʊmləs",
    "homelessness": "həʊmləsnəs",
    "homelier": "həʊmliɐ",
    "homeliness": "həʊmlinəs",
    "homely": "həʊmli",
    "homemade": "həʊmmeɪd",
    "homemaker": "həʊmmeɪkɐ",
    "homemakers": "həʊmmeɪkəz",
    "homemaking": "həʊmmeɪkɪŋ",
    "homeopath": "həʊmiːɒpɑːθ",
    "homeopathic": "həʊmiːəpæθɪk",
    "homeopaths": "həʊmiːɒpɑːθs",
    "homeopathy": "həʊmiːɒpəθi",
    "homeowner": "həʊməʊnɐ",
    "homeowners": "həʊməʊnəz",
    "homepage": "həʊmpeɪdʒ",
    "homered": "həʊməd",
    "homer": "həʊmɐ",
    "homeroom": "həʊmruːm",
    "homers": "həʊməz",
    "homes": "həʊmz",
    "homesick": "həʊmsɪk",
    "homesickness": "həʊmsɪknəs",
    "homespun": "həʊmspʌn",
    "homesteaders": "həʊmstɛdəz",
    "homestead": "həʊmstɛd",
    "homesteads": "həʊmstɛdz",
    "hometown": "həʊmtaʊn",
    "hometowns": "həʊmtaʊnz",
    "homeward": "həʊmwəd",
    "homewards": "həʊmwədz",
    "homeworkers": "həʊmwɜːkəz",
    "homework": "həʊmwɜːk",
    "homeworking": "həʊmwɜːkɪŋ",
    "homey": "həʊmi",
    "homeys": "həʊmɪz",
    "homicidal": "hɒmɪsaɪdəl",
    "homicide": "hɒmɪsaɪd",
    "homicides": "hɒmɪsaɪdz",
    "homie": "həʊmi",
    "homies": "həʊmɪz",
    "homilies": "hɒməliz",
    "homily": "hɒməli",
    "homing": "həʊmɪŋ",
    "hominid": "hɒmɪnɪd",
    "hominids": "hɒmɪnɪdz",
    "hominy": "hɒmɪni",
    "homoerotic": "hɒməʊərɒtɪk",
    "homogeneity": "hɒməʊdʒneɪti",
    "homogeneous": "həməʊdʒniəs",
    "homogenisation": "hɒməʊdʒnaɪzeɪʃən",
    "homogenised": "hɒməʊdʒnaɪzd",
    "homogenise": "hɒməʊdʒnaɪz",
    "homogenises": "hɒməʊdʒnaɪzɪz",
    "homogenising": "hɒməʊdʒnaɪzɪŋ",
    "homogenous": "həmɒdʒənəs",
    "homograft": "hɒməɡrɑːft",
    "homo": "həʊməʊ",
    "homonym": "hɒmənɪm",
    "homonyms": "hɒmənɪmz",
    "homophobe": "hɒməfəʊb",
    "homophobes": "hɒməfəʊbz",
    "homophobia": "hɒməfəʊbiə",
    "homophobic": "hɒməfəʊbɪk",
    "homophone": "hɒməfəʊn",
    "homophones": "hɒməfəʊnz",
    "homosexual": "həʊməʊsɛkʃuːəl",
    "homosexuality": "həʊməʊsɛkʃuːælɪti",
    "homosexuals": "həʊməʊsɛkʃuːəlz",
    "homos": "həʊməʊz",
    "homunculus": "həmʌnkjʊləs",
    "homy": "həʊmi",
    "honcho": "hɒntʃəʊ",
    "honchos": "hɒntʃəʊz",
    "honed": "həʊnd",
    "hone": "həʊn",
    "hones": "həʊnz",
    "honester": "ɒnɪstɐ",
    "honestly": "ɒnɪstli",
    "honest": "ɒnɪst",
    "honesty": "ɒnɪsti",
    "honeybee": "hʌnɪbiː",
    "honeybees": "hʌnɪbiːz",
    "honeybunch": "hʌnɪbʌntʃ",
    "honeycombed": "hʌnɪkəʊmd",
    "honeycomb": "hʌnɪkəʊm",
    "honeycombs": "hʌnɪkəʊmz",
    "honeydew": "hʌnɪdjuː",
    "honeyed": "hʌnɪd",
    "honey": "hʌni",
    "honeying": "hʌnɪɪŋ",
    "honeymooned": "hʌnɪmuːnd",
    "honeymooner": "hʌnɪmuːnɐ",
    "honeymooners": "hʌnɪmuːnəz",
    "honeymoon": "hʌnɪmuːn",
    "honeymooning": "hʌnɪmuːnɪŋ",
    "honeymoons": "hʌnɪmuːnz",
    "honeypot": "hʌnɪpɒt",
    "honeypots": "hʌnɪpɒts",
    "honeys": "hʌnɪz",
    "honeysuckle": "hʌnɪsʌkəl",
    "honeysuckles": "hʌnɪsʌkəlz",
    "hong": "hɒŋ",
    "hon": "hɒn",
    "honing": "həʊnɪŋ",
    "honked": "hɒŋkt",
    "honker": "hɒŋkɐ",
    "honkers": "hɒŋkəz",
    "honk": "hɒŋk",
    "honkies": "hɒŋkiz",
    "honking": "hɒŋkɪŋ",
    "honks": "hɒŋks",
    "honky": "hɒŋki",
    "honorable": "ɒnərəbəl",
    "honorary": "ɒnərəri",
    "honored": "ɒnəd",
    "honorific": "ɒnɔːrɪfɪk",
    "honor": "ɒnɐ",
    "honors": "ɒnəz",
    "honourable": "ɒnərəbəl",
    "honourably": "ɒnərəbli",
    "honoured": "ɒnəd",
    "honouring": "ɒnɜːrɪŋ",
    "honour": "ɒnɐ",
    "honours": "ɒnəz",
    "hons": "hɒnz",
    "hooch": "huːtʃ",
    "hooded": "hʊdɪd",
    "hood": "hʊd",
    "hooding": "hʊdɪŋ",
    "hoodlum": "hʊdləm",
    "hoodlums": "hʊdləmz",
    "hoodoo": "hʊduː",
    "hoodoos": "hʊduːz",
    "hoods": "hʊdz",
    "hoodwinked": "hʊdwɪŋkt",
    "hoodwink": "hʊdwɪŋk",
    "hoodwinking": "hʊdwɪŋkɪŋ",
    "hooey": "huːi",
    "hoofed": "huːft",
    "hoofer": "huːfɐ",
    "hoofers": "huːfəz",
    "hoof": "huːf",
    "hoofing": "huːfɪŋ",
    "hoofs": "huːfs",
    "hoo": "huː",
    "hookah": "hʊkɐ",
    "hooka": "hʊkɐ",
    "hooked": "hʊkt",
    "hooker": "hʊkɐ",
    "hookers": "hʊkəz",
    "hookey": "hʊki",
    "hook": "hʊk",
    "hooking": "hʊkɪŋ",
    "hooks": "hʊks",
    "hookworm": "hʊkwɜːm",
    "hooky": "hʊki",
    "hooligan": "huːlɪɡən",
    "hooliganism": "huːlɪɡənɪzəm",
    "hooligans": "huːlɪɡənz",
    "hooped": "huːpt",
    "hooper": "huːpɐ",
    "hoop": "huːp",
    "hooping": "huːpɪŋ",
    "hoopla": "huːplɐ",
    "hoopoe": "huːpəʊ",
    "hoopoes": "huːpəʊz",
    "hoops": "huːps",
    "hoorah": "hɔːrɐ",
    "hooray": "hɔːreɪ",
    "hoorays": "hɔːreɪz",
    "hoosegow": "huːsɪɡaʊ",
    "hooted": "huːtɪd",
    "hootenanny": "huːtənæni",
    "hooter": "huːtɐ",
    "hooters": "huːtəz",
    "hoot": "huːt",
    "hooting": "huːtɪŋ",
    "hoots": "huːts",
    "hoovered": "huːvəd",
    "hoover": "huːvɐ",
    "hoovering": "huːvərɪŋ",
    "hoovers": "huːvəz",
    "hooves": "huːvz",
    "hoped": "həʊpt",
    "hopeful": "həʊpfəl",
    "hopefully": "həʊpfəli",
    "hopefulness": "həʊpfəlnəs",
    "hopefuls": "həʊpfəlz",
    "hope": "həʊp",
    "hopeless": "həʊpləs",
    "hopelessly": "həʊpləsli",
    "hopelessness": "həʊpləsnəs",
    "hopes": "həʊps",
    "hop": "hɒp",
    "hoping": "həʊpɪŋ",
    "hoplite": "hɒplaɪt",
    "hopped": "hɒpt",
    "hopper": "hɒpɐ",
    "hoppers": "hɒpəz",
    "hopping": "hɒpɪŋ",
    "hopscotch": "hɒpskɒtʃ",
    "hops": "hɒps",
    "hora": "hɔːrɐ",
    "horary": "hərɑːri",
    "horas": "hɔːrəz",
    "horded": "hɔːdɪd",
    "horde": "hɔːd",
    "hordes": "hɔːdz",
    "hording": "hɔːdɪŋ",
    "horehound": "hɔːhaʊnd",
    "horizon": "həraɪzən",
    "horizons": "həraɪzənz",
    "horizontal": "hɒrɪzɒntəl",
    "horizontally": "hɒrɪzɒntəli",
    "horizontals": "hɒrɪzɒntəlz",
    "hormonal": "hɔːməʊnəl",
    "hormonally": "hɔːməʊnəli",
    "hormone": "hɔːməʊn",
    "hormones": "hɔːməʊnz",
    "hornbeam": "hɔːnbiːm",
    "hornbeams": "hɔːnbiːmz",
    "hornbill": "hɔːnbɪl",
    "hornbills": "hɔːnbɪlz",
    "horned": "hɔːnd",
    "hornet": "hɔːnɪt",
    "hornets": "hɔːnɪts",
    "horn": "hɔːn",
    "hornier": "hɔːnɪɐ",
    "horniest": "hɔːnɪəst",
    "hornless": "hɔːnləs",
    "hornpipe": "hɔːnpaɪp",
    "hornpipes": "hɔːnpaɪps",
    "horns": "hɔːnz",
    "hornwort": "hɔːnwɔːt",
    "horny": "hɔːni",
    "horological": "hɒrəlɒdʒɪkəl",
    "horologist": "hɒrɒlədʒɪst",
    "horologists": "hɒrɒlədʒɪsts",
    "horology": "hɒrɒlədʒi",
    "horoscope": "hɒrəskəʊp",
    "horoscopes": "hɒrəskəʊps",
    "horrendous": "hɒrɛndəs",
    "horrendously": "hɒrɛndəsli",
    "horrible": "hɒrɪbəl",
    "horribleness": "hɒrɪbəlnəs",
    "horribly": "hɒrɪbli",
    "horrid": "hɒrɪd",
    "horridly": "hɒrɪdli",
    "horrifically": "hɒrɪfɪkli",
    "horrific": "hɒrɪfɪk",
    "horrified": "hɒrɪfaɪd",
    "horrifies": "hɒrɪfaɪz",
    "horrify": "hɒrɪfaɪ",
    "horrifying": "hɒrɪfaɪɪŋ",
    "horrifyingly": "hɒrɪfaɪɪŋli",
    "horror": "hɒrɐ",
    "horrors": "hɒrəz",
    "horseback": "hɔːsbæk",
    "horseboxes": "hɔːsbɒksɪz",
    "horsebox": "hɔːsbɒks",
    "horsed": "hɔːsd",
    "horseflesh": "hɔːsflɛʃ",
    "horseflies": "hɔːsflaɪz",
    "horsefly": "hɔːsflaɪ",
    "horsehair": "hɔːsheə",
    "horsehide": "hɔːshaɪd",
    "horse": "hɔːs",
    "horseless": "hɔːsləs",
    "horseman": "hɔːsmən",
    "horsemanship": "hɔːsmənʃɪp",
    "horsemen": "hɔːsmɛn",
    "horseplay": "hɔːspleɪ",
    "horsepower": "hɔːspaʊɐ",
    "horseracing": "hɔːsreɪsɪŋ",
    "horseradishes": "hɔːsrɐdɪʃɪz",
    "horseradish": "hɔːsrɐdɪʃ",
    "horseshit": "hɔːsʃɪt",
    "horseshoe": "hɔːsʃuː",
    "horseshoes": "hɔːsʃuːz",
    "horses": "hɔːsɪz",
    "horsetail": "hɔːsteɪl",
    "horsetails": "hɔːsteɪlz",
    "horsewhip": "hɔːswɪp",
    "horsewhipped": "hɔːswɪpt",
    "horsewhipping": "hɔːswɪpɪŋ",
    "horsewoman": "hɔːswʊmən",
    "horsey": "hɔːsi",
    "horsiness": "hɔːsɪnəs",
    "horsing": "hɔːsɪŋ",
    "horst": "hɔːst",
    "horsy": "hɔːsi",
    "horticultural": "hɔːtɪkʌltʃərəl",
    "horticulturalist": "hɔːtɪkʌltʃərəlɪst",
    "horticulturalists": "hɔːtɪkʌltʃərəlɪsts",
    "horticulturally": "hɔːtɪkʌltʃərəli",
    "horticulture": "hɔːtɪkʌltʃɐ",
    "horticulturist": "hɔːtɪkʌltʃərɪst",
    "horticulturists": "hɔːtɪkʌltʃərɪsts",
    "hosanna": "həsænɐ",
    "hosannas": "həsænəz",
    "hosed": "həʊzd",
    "hose": "həʊz",
    "hosepipe": "həʊspaɪp",
    "hosepipes": "həʊspaɪps",
    "hoses": "həʊzɪz",
    "hos": "həʊz",
    "hosier": "həʊzɪɐ",
    "hosiery": "həʊsɪəri",
    "hosing": "həʊzɪŋ",
    "hospice": "hɒspɪs",
    "hospices": "hɒspɪsɪz",
    "hospitable": "hɒspɪtəbəl",
    "hospital": "hɒspɪtəl",
    "hospitalisation": "hɒspɪtəlaɪzeɪʃən",
    "hospitalised": "hɒspɪtəlaɪzd",
    "hospitalise": "hɒspɪtəlaɪz",
    "hospitalises": "hɒspɪtəlaɪzɪz",
    "hospitalising": "hɒspɪtəlaɪzɪŋ",
    "hospitality": "hɒspɪtælɪti",
    "hospitals": "hɒspɪtəlz",
    "hostage": "hɒstɪdʒ",
    "hostages": "hɒstɪdʒɪz",
    "hosta": "hɒstɐ",
    "hosted": "həʊstɪd",
    "hostel": "hɒstəl",
    "hostelling": "hɒstəlɪŋ",
    "hostelries": "hɒstəlrɪz",
    "hostelry": "hɒstəlri",
    "hostels": "hɒstəlz",
    "hostesses": "həʊstɛsɪz",
    "hostess": "həʊstɛs",
    "hostessing": "həʊstɛsɪŋ",
    "host": "həʊst",
    "hostile": "hɒstaɪl",
    "hostiles": "hɒstaɪlz",
    "hostilities": "həstɪlɪtiz",
    "hostility": "həstɪlɪti",
    "hosting": "həʊstɪŋ",
    "hosts": "həʊsts",
    "hotbed": "hɒtbɛd",
    "hotbeds": "hɒtbɛdz",
    "hotcakes": "hɒtkeɪks",
    "hotdog": "hɒtdɒɡ",
    "hotdogs": "hɒtdɒɡz",
    "hotel": "həʊtɛl",
    "hotelier": "həʊtɛliɐ",
    "hoteliers": "həʊtɛliəz",
    "hotels": "həʊtɛlz",
    "hotfooted": "hɒtfʊtɪd",
    "hotfoot": "hɒtfʊt",
    "hotfooting": "hɒtfʊtɪŋ",
    "hotfoots": "hɒtfʊts",
    "hothead": "hɒthɛd",
    "hotheads": "hɒthɛdz",
    "hothouse": "hɒthaʊs",
    "hothouses": "hɒthaʊsɪz",
    "hot": "hɒt",
    "hotline": "hɒtlaɪn",
    "hotlines": "hɒtlaɪnz",
    "hotly": "hɒtli",
    "hotness": "hɒtnəs",
    "hotplate": "hɒtpleɪt",
    "hotplates": "hɒtpleɪts",
    "hotpot": "hɒtpɒt",
    "hotpots": "hɒtpɒts",
    "hotshot": "hɒtʃɒt",
    "hotshots": "hɒtʃɒts",
    "hots": "hɒts",
    "hotspot": "hɒtspɒt",
    "hotspots": "hɒtspɒts",
    "hotspur": "hɒtspɔː",
    "hotted": "hɒtɪd",
    "hotter": "hɒtɐ",
    "hottest": "hɒtəst",
    "hotting": "hɒtɪŋ",
    "hough": "həʊ",
    "houmous": "hjuːməs",
    "hounded": "haʊndɪd",
    "hound": "haʊnd",
    "hounding": "haʊndɪŋ",
    "hounds": "haʊndz",
    "hour": "aʊə",
    "hourglass": "aʊəɡlɑːs",
    "hourly": "aʊəli",
    "hours": "aʊəz",
    "houseboat": "haʊsbəʊt",
    "houseboats": "haʊsbəʊts",
    "housebound": "haʊsbaʊnd",
    "houseboy": "haʊsbɔɪ",
    "housebreaker": "haʊsbreɪkɐ",
    "housebreakers": "haʊsbreɪkəz",
    "housebreak": "haʊsbreɪk",
    "housebreaking": "haʊsbreɪkɪŋ",
    "housebroken": "haʊsbrəʊkən",
    "housecleaning": "haʊskliːnɪŋ",
    "housecoat": "haʊskəʊt",
    "housed": "haʊzd",
    "housefly": "haʊsflaɪ",
    "houseful": "haʊsfəl",
    "householder": "haʊshəʊldɐ",
    "householders": "haʊshəʊldəz",
    "household": "haʊshəʊld",
    "households": "haʊshəʊldz",
    "househusband": "haʊshʌsbənd",
    "househusbands": "haʊshʌsbəndz",
    "housekeeper": "haʊskiːpɐ",
    "housekeepers": "haʊskiːpəz",
    "housekeeping": "haʊskiːpɪŋ",
    "houseleek": "haʊsliːk",
    "houseless": "haʊsləs",
    "housemaid": "haʊsmeɪd",
    "housemaids": "haʊsmeɪdz",
    "houseman": "haʊsmən",
    "housemaster": "haʊsmɑːstɐ",
    "housemate": "haʊsmeɪt",
    "housemates": "haʊsmeɪts",
    "housemen": "haʊsmɛn",
    "houseplant": "haʊsplænt",
    "houseplants": "haʊsplænts",
    "houseproud": "haʊspraʊd",
    "houseroom": "haʊsruːm",
    "houses": "haʊzɪz",
    "housetops": "haʊstɒps",
    "housewares": "haʊsweəz",
    "housewarming": "haʊswɔːmɪŋ",
    "housewifely": "haʊswaɪfli",
    "housewifery": "haʊswɪfəri",
    "housewives": "haʊswaɪvz",
    "housework": "haʊswɜːk",
    "housing": "haʊzɪŋ",
    "housings": "haʊzɪŋz",
    "hove": "həʊv",
    "hovel": "hɒvəl",
    "hovels": "hɒvəlz",
    "hovercraft": "hɒvəkrɑːft",
    "hovercrafts": "hɒvəkrɑːfts",
    "hovered": "hɒvəd",
    "hoverer": "hɒvərɐ",
    "hover": "hɒvɐ",
    "hovering": "hɒvərɪŋ",
    "hovers": "hɒvəz",
    "howdah": "haʊdɐ",
    "howdahs": "haʊdəz",
    "howdy": "haʊdi",
    "howe'er": "haʊeə",
    "however": "haʊɛvɐ",
    "how": "haʊ",
    "howitzer": "haʊɪtsɐ",
    "howitzers": "haʊɪtsəz",
    "howled": "haʊld",
    "howler": "haʊlɐ",
    "howlers": "haʊləz",
    "howl": "haʊl",
    "howling": "haʊlɪŋ",
    "howls": "haʊlz",
    "hows": "haʊz",
    "howsoever": "haʊsəʊɛvɐ",
    "hoyden": "hɔɪdən",
    "hoy": "hɔɪ",
    "huarache": "hjuːɐreɪk",
    "hubbies": "hʌbɪz",
    "hubbub": "hʌbʌb",
    "hubby": "hʌbi",
    "hubcap": "hʌbkæp",
    "hubcaps": "hʌbkæps",
    "hub": "hʌb",
    "hubris": "huːbrɪs",
    "hubristic": "hʌbrɪstɪk",
    "hubs": "hʌbz",
    "huckleberries": "hʌklɪbərɪz",
    "huckleberry": "hʌklɪbəri",
    "huckster": "hʌkstɐ",
    "hucksters": "hʌkstəz",
    "huddled": "hʌdəld",
    "huddle": "hʌdəl",
    "huddles": "hʌdəlz",
    "huddling": "hʌdlɪŋ",
    "hued": "hjuːd",
    "hues": "hjuːz",
    "huffed": "hʌft",
    "huff": "hʌf",
    "huffing": "hʌfɪŋ",
    "huffs": "hʌfs",
    "huffy": "hʌfi",
    "huge": "hjuːdʒ",
    "hugely": "hjuːdʒli",
    "hugeness": "hjuːdʒnəs",
    "huger": "huːɡɐ",
    "hugest": "hjuːdʒəst",
    "hugged": "hʌɡd",
    "hugger": "hʌɡɐ",
    "hugging": "hʌɡɪŋ",
    "hug": "hʌɡ",
    "hugs": "hʌɡz",
    "huh": "hʌ",
    "hula": "huːlɐ",
    "hulas": "huːləz",
    "hulk": "hʌlk",
    "hulking": "hʌlkɪŋ",
    "hulks": "hʌlks",
    "hulky": "hʌlki",
    "hullaballoo": "hʌlɐbæluː",
    "hullabaloo": "hʌlɐbæluː",
    "hullabaloos": "hʌlɐbæluːz",
    "hulled": "hʌld",
    "huller": "hʌlɐ",
    "hull": "hʌl",
    "hulling": "hʌlɪŋ",
    "hulls": "hʌlz",
    "humane": "hjuːmeɪn",
    "humanely": "hjuːmeɪnli",
    "human": "hjuːmən",
    "humanisation": "hjuːmɐnaɪzeɪʃən",
    "humanised": "hjuːmɐnaɪzd",
    "humanise": "hjuːmɐnaɪz",
    "humanises": "hjuːmɐnaɪzɪz",
    "humanising": "hjuːmɐnaɪzɪŋ",
    "humanism": "hjuːmənɪzəm",
    "humanist": "hjuːmɐnɪst",
    "humanistic": "hjuːmɐnɪstɪk",
    "humanists": "hjuːmɐnɪsts",
    "humanitarian": "hjuːmɐnɪteəriən",
    "humanitarianism": "hjuːmɐnɪteəriənɪzəm",
    "humanitarians": "hjuːmɐnɪteəriənz",
    "humanities": "hjuːmænɪtiz",
    "humanity": "hjuːmænɪti",
    "humankind": "hjuːmɐŋkaɪnd",
    "humanly": "hjuːmənli",
    "humanness": "hjuːmənnəs",
    "humanoid": "hjuːmɐnɔɪd",
    "humanoids": "hjuːmɐnɔɪdz",
    "humans": "hjuːmənz",
    "humbled": "hʌmbəld",
    "humble": "hʌmbəl",
    "humbleness": "hʌmbəlnəs",
    "humbler": "hʌmblɐ",
    "humbles": "hʌmbəlz",
    "humblest": "hʌmbləst",
    "humbling": "hʌmblɪŋ",
    "humbly": "hʌmbli",
    "humbuggery": "hʌmbəɡəri",
    "humbug": "hʌmbʌɡ",
    "humbugs": "hʌmbʌɡz",
    "humdinger": "hʌmdɪŋɡɐ",
    "humdingers": "hʌmdɪŋɡəz",
    "humdrum": "hʌmdrəm",
    "humectant": "hjuːmɛktənt",
    "humeral": "hjuːmərəl",
    "humerus": "hjuːmərəs",
    "hum": "hʌm",
    "humid": "hjuːmɪd",
    "humidified": "hjuːmɪdɪfaɪd",
    "humidifier": "hjuːmɪdɪfaɪə",
    "humidifiers": "hjuːmɪdɪfaɪəz",
    "humidify": "hjuːmɪdɪfaɪ",
    "humidity": "hjuːmɪdɪti",
    "humidor": "hjuːmɪdɔː",
    "humiliated": "hjuːmɪlɪeɪtɪd",
    "humiliate": "hjuːmɪlɪeɪt",
    "humiliates": "hjuːmɪlɪeɪts",
    "humiliating": "hjuːmɪlɪeɪtɪŋ",
    "humiliatingly": "hjuːmɪlɪeɪtɪŋli",
    "humiliation": "hjuːmɪlɪeɪʃən",
    "humiliations": "hjuːmɪlɪeɪʃənz",
    "humility": "hjuːmɪlɪti",
    "hummable": "hʌməbəl",
    "hummed": "hʌmd",
    "hummer": "hʌmɐ",
    "hummers": "hʌməz",
    "hummingbird": "hʌmɪŋbɜːd",
    "hummingbirds": "hʌmɪŋbɜːdz",
    "humming": "hʌmɪŋ",
    "hummock": "hʌmək",
    "hummus": "hʌməs",
    "humongous": "hjuːmɒŋɡəs",
    "humorist": "hjuːmɔːrɪst",
    "humorists": "hjuːmɔːrɪsts",
    "humorous": "hjuːmərəs",
    "humorously": "hjuːmərəsli",
    "humoured": "hjuːməd",
    "humour": "hjuːmɐ",
    "humouring": "hjuːmɜːrɪŋ",
    "humourless": "hjuːmələs",
    "humours": "hjuːməz",
    "humpbacked": "hʌmpbækt",
    "humpback": "hʌmpbæk",
    "humpbacks": "hʌmpbæks",
    "humped": "hʌmpt",
    "humph": "hʌmf",
    "hump": "hʌmp",
    "humping": "hʌmpɪŋ",
    "humps": "hʌmps",
    "humpy": "hʌmpi",
    "hums": "hʌmz",
    "humungous": "hjuːmʌŋɡəs",
    "humus": "hjuːməs",
    "hunchbacked": "hʌntʃbækt",
    "hunchback": "hʌntʃbæk",
    "hunchbacks": "hʌntʃbæks",
    "hunched": "hʌntʃt",
    "hunches": "hʌntʃɪz",
    "hunch": "hʌntʃ",
    "hunching": "hʌntʃɪŋ",
    "hundredfold": "hʌndrɪdfəʊld",
    "hundred": "hʌndrəd",
    "hundreds": "hʌndrədz",
    "hundredth": "hʌndrədθ",
    "hundredths": "hʌndrədθs",
    "hundredweight": "hʌndrɪdweɪt",
    "hundredweights": "hʌndrɪdweɪts",
    "hungered": "hʌŋɡəd",
    "hunger": "hʌŋɡɐ",
    "hungering": "hʌŋɡərɪŋ",
    "hungers": "hʌŋɡəz",
    "hung": "hʌŋ",
    "hungover": "hʌŋɡəʊvɐ",
    "hungrier": "hʌŋɡrɪɐ",
    "hungriest": "hʌŋɡrɪəst",
    "hungrily": "hʌŋɡrɪli",
    "hungry": "hʌŋɡri",
    "hun": "hʌn",
    "hunkered": "hʌŋkəd",
    "hunker": "hʌŋkɐ",
    "hunkering": "hʌŋkərɪŋ",
    "hunkers": "hʌŋkəz",
    "hunk": "hʌŋk",
    "hunkier": "hʌŋkiɐ",
    "hunkiest": "hʌŋkiəst",
    "hunks": "hʌŋks",
    "hunky": "hʌŋki",
    "hunted": "hʌntɪd",
    "hunter": "hʌntɐ",
    "hunters": "hʌntəz",
    "hunt": "hʌnt",
    "hunting": "hʌntɪŋ",
    "huntress": "hʌntrəs",
    "hunts": "hʌnts",
    "huntsman": "hʌntsmən",
    "huntsmen": "hʌntsmɛn",
    "hurdled": "hɜːdəld",
    "hurdle": "hɜːdəl",
    "hurdler": "hɜːdlɐ",
    "hurdlers": "hɜːdləz",
    "hurdles": "hɜːdəlz",
    "hurdling": "hɜːdlɪŋ",
    "hurled": "hɜːld",
    "hurler": "hɜːlɐ",
    "hurlers": "hɜːləz",
    "hurley": "hɜːli",
    "hurl": "hɜːl",
    "hurling": "hɜːlɪŋ",
    "hurls": "hɜːlz",
    "hurrah": "hərɑː",
    "hurrahs": "hərɑːz",
    "hurray": "həreɪ",
    "hurricane": "hʌrɪkeɪn",
    "hurricanes": "hʌrɪkeɪnz",
    "hurried": "hʌrɪd",
    "hurriedly": "hʌrɪdli",
    "hurries": "hʌrɪz",
    "hurry": "hʌri",
    "hurrying": "hʌrɪɪŋ",
    "hurst": "hɜːst",
    "hurter": "hɜːtɐ",
    "hurtful": "hɜːtfəl",
    "hurt": "hɜːt",
    "hurting": "hɜːtɪŋ",
    "hurtled": "hɜːtəld",
    "hurtle": "hɜːtəl",
    "hurtles": "hɜːtəlz",
    "hurtling": "hɜːtlɪŋ",
    "hurts": "hɜːts",
    "husbanded": "hʌsbəndɪd",
    "husband": "hʌsbənd",
    "husbanding": "hʌsbəndɪŋ",
    "husbandman": "hʌsbəndmən",
    "husbandmen": "hʌsbəndmɛn",
    "husbandry": "hʌsbəndri",
    "husbands": "hʌsbəndz",
    "hushed": "hʌʃt",
    "hushes": "hʌʃɪz",
    "hush": "hʌʃ",
    "hushing": "hʌʃɪŋ",
    "husked": "hʌskt",
    "husker": "hʌskɐ",
    "husk": "hʌsk",
    "huskies": "hʌskiz",
    "huskily": "hʌskili",
    "husking": "hʌskɪŋ",
    "husks": "hʌsks",
    "husky": "hʌski",
    "hussar": "hʌzɑː",
    "hussars": "hʌzɑːz",
    "hussies": "hʌsɪz",
    "hussy": "hʌsi",
    "hustings": "hʌstɪŋz",
    "hustled": "hʌsəld",
    "hustle": "hʌsəl",
    "hustler": "hʌslɐ",
    "hustlers": "hʌsləz",
    "hustles": "hʌsəlz",
    "hustling": "hʌslɪŋ",
    "hutches": "hʌtʃɪz",
    "hutch": "hʌtʃ",
    "hut": "hʌt",
    "hutments": "hʌtmənts",
    "huts": "hʌts",
    "hutzpah": "hʌtspɐ",
    "huzza": "həzɑː",
    "huzzah": "həzɑː",
    "hwan": "eɪtʃwæn",
    "hyacinth": "haɪɐsɪnθ",
    "hyacinths": "haɪɐsɪnθs",
    "hybrid": "haɪbrɪd",
    "hybridisation": "haɪbrɪdaɪzeɪʃən",
    "hybridised": "haɪbrɪdaɪzd",
    "hybridise": "haɪbrɪdaɪz",
    "hybridising": "haɪbrɪdaɪzɪŋ",
    "hybridity": "haɪbrɪdɪti",
    "hybrids": "haɪbrɪdz",
    "hydra": "haɪdrɐ",
    "hydrangea": "haɪdreɪndʒɐ",
    "hydrangeas": "haɪdreɪndʒəz",
    "hydrant": "haɪdrənt",
    "hydrants": "haɪdrənts",
    "hydrated": "haɪdreɪtɪd",
    "hydrate": "haɪdreɪt",
    "hydrates": "haɪdreɪts",
    "hydrating": "haɪdreɪtɪŋ",
    "hydration": "haɪdreɪʃən",
    "hydraulically": "haɪdrɔːlɪkli",
    "hydraulic": "haɪdrɔːlɪk",
    "hydraulics": "haɪdrɔːlɪks",
    "hydride": "haɪdraɪd",
    "hydrides": "haɪdraɪdz",
    "hydrocarbon": "haɪdrəkɑːbən",
    "hydrocarbons": "haɪdrəkɑːbənz",
    "hydrocephalus": "haɪdrəʊsfæləs",
    "hydrochloric": "haɪdrəklɔːrɪk",
    "hydrochloride": "haɪdrəklɔːraɪd",
    "hydrocortisone": "haɪdrəkɔːtɪsəʊn",
    "hydrodynamic": "haɪdrədaɪnæmɪk",
    "hydrodynamics": "haɪdrədaɪnæmɪks",
    "hydroelectric": "haɪdrəʊlɛktrɪk",
    "hydroelectricity": "haɪdrəʊlɪktrɪsɪti",
    "hydrofluoric": "haɪdrəflɔːrɪk",
    "hydrofoil": "haɪdrəfɔɪl",
    "hydrofoils": "haɪdrəfɔɪlz",
    "hydrogenated": "haɪdrəʊdʒəneɪtɪd",
    "hydrogen": "haɪdrədʒən",
    "hydrographic": "haɪdrəɡræfɪk",
    "hydro": "haɪdrəʊ",
    "hydrological": "haɪdrəlɒdʒɪkəl",
    "hydrology": "haɪdrɒlədʒi",
    "hydrolysis": "haɪdrɒləsɪs",
    "hydrometer": "haɪdrɒmɪtɐ",
    "hydropathic": "haɪdrəpæθɪk",
    "hydropathy": "haɪdrɒpəθi",
    "hydrophobia": "haɪdrəfəʊbiə",
    "hydrophobic": "haɪdrəfəʊbɪk",
    "hydrophone": "haɪdrəfəʊn",
    "hydrophones": "haɪdrəfəʊnz",
    "hydroplane": "haɪdrəpleɪn",
    "hydroplaning": "haɪdrəpleɪnɪŋ",
    "hydroponically": "haɪdrəpɒnɪkli",
    "hydroponic": "haɪdrəpɒnɪk",
    "hydroponics": "haɪdrəpɒnɪks",
    "hydropower": "haɪdrəpaʊɐ",
    "hydroquinone": "haɪdrəkwɪnɒn",
    "hydrostatic": "haɪdrəstætɪk",
    "hydrotherapy": "haɪdrəʊθɛrəpi",
    "hydrothermal": "haɪdrəðɜːməl",
    "hydrous": "haɪdrəs",
    "hydroxide": "haɪdrɒksaɪd",
    "hydroxides": "haɪdrɒksaɪdz",
    "hydroxy": "haɪdrɒksi",
    "hydroxyl": "haɪdrəksɪl",
    "hyena": "haɪiːnɐ",
    "hyenas": "haɪiːnəz",
    "hygiene": "haɪdʒiːn",
    "hygienically": "haɪdʒiːnɪkli",
    "hygienic": "haɪdʒiːnɪk",
    "hygienist": "haɪdʒiːnɪst",
    "hygrometer": "haɪɡrɒmɪtɐ",
    "hygroscopic": "haɪɡrəskɒpɪk",
    "hymen": "haɪmɛn",
    "hymens": "haɪmɛnz",
    "hymnal": "hɪmnəl",
    "hymnals": "hɪmnəlz",
    "hymnbook": "hɪmbʊk",
    "hymn": "hɪm",
    "hymnody": "hɪmnədi",
    "hymns": "hɪmz",
    "hyoid": "haɪɔɪd",
    "hyped": "haɪpt",
    "hype": "haɪp",
    "hyperactive": "haɪpəræktɪv",
    "hyperactivity": "haɪpərɐktɪvɪti",
    "hyperbaric": "haɪpəbærɪk",
    "hyperbola": "haɪpɜːbəlɐ",
    "hyperbole": "haɪpɜːbəli",
    "hyperbolic": "haɪpəbɒlɪk",
    "hyperboloid": "haɪpəbɒlɔɪd",
    "hypercritical": "haɪpəkrɪtɪkəl",
    "hypercube": "haɪpəkjuːb",
    "hyperfine": "haɪpəfaɪn",
    "hyperglycaemic": "haɪpəɡlɪkiːmɪk",
    "hyper": "haɪpɐ",
    "hyperinflation": "haɪpərɪnfleɪʃən",
    "hyperlink": "haɪpəlɪŋk",
    "hyperlinks": "haɪpəlɪŋks",
    "hypermarket": "haɪpəmɑːkɪt",
    "hypermarkets": "haɪpəmɑːkɪts",
    "hypermetropia": "haɪpəmɪtrəʊpiə",
    "hypersensitive": "haɪpɜːsənsɪtɪv",
    "hypersensitivity": "haɪpəsənsɪtɪvɪti",
    "hypersonic": "haɪpəsɒnɪk",
    "hyperspace": "haɪpəspeɪs",
    "hypertension": "haɪpətənʃən",
    "hypertensive": "haɪpətənsɪv",
    "hypertext": "haɪpətɛkst",
    "hyperthermia": "haɪpəθəmiə",
    "hyperthyroidism": "haɪpəðɪrɔɪdɪzəm",
    "hypertonic": "haɪpətɒnɪk",
    "hypertrophic": "haɪpətrɒfɪk",
    "hypertrophy": "haɪpətrəfi",
    "hyperventilated": "haɪpəvɛntɪleɪtɪd",
    "hyperventilate": "haɪpəvɛntɪleɪt",
    "hyperventilates": "haɪpəvɛntɪleɪts",
    "hyperventilating": "haɪpəvɛntɪleɪtɪŋ",
    "hyperventilation": "haɪpəvɛntɪleɪʃən",
    "hypes": "haɪps",
    "hyphae": "haɪfiː",
    "hyphenated": "haɪfəneɪtɪd",
    "hyphenate": "haɪfəneɪt",
    "hyphen": "haɪfən",
    "hyphens": "haɪfənz",
    "hyping": "haɪpɪŋ",
    "hypnosis": "hɪpnəʊsɪs",
    "hypnotherapist": "hɪpnəʊθɛreɪpɪst",
    "hypnotherapists": "hɪpnəʊθɛreɪpɪsts",
    "hypnotherapy": "hɪpnəʊθɛrəpi",
    "hypnotically": "hɪpnɒtɪkli",
    "hypnotic": "hɪpnɒtɪk",
    "hypnotics": "hɪpnɒtɪks",
    "hypnotised": "hɪpnətaɪzd",
    "hypnotise": "hɪpnətaɪz",
    "hypnotises": "hɪpnətaɪzɪz",
    "hypnotising": "hɪpnətaɪzɪŋ",
    "hypnotism": "hɪpnətɪzəm",
    "hypnotist": "hɪpnətɪst",
    "hypnotists": "hɪpnətɪsts",
    "hypoallergenic": "haɪpəʊælədʒɛnɪk",
    "hypocaust": "haɪpəʊkɔːst",
    "hypochlorite": "haɪpəʊklɔːraɪt",
    "hypochondriac": "haɪpəʊkɒndrɪæk",
    "hypochondriacs": "haɪpəʊkɒndrɪæks",
    "hypochondria": "haɪpəʊkɒndriɐ",
    "hypochondriasis": "haɪpəʊkɒndrɪæsiz",
    "hypocrisies": "hɪpɒkrəsɪz",
    "hypocrisy": "hɪpɒkrəsi",
    "hypocrite": "hɪpəkrɪt",
    "hypocrites": "hɪpəkrɪts",
    "hypocritical": "hɪpəkrɪtɪkəl",
    "hypocritically": "hɪpəkrɪtɪkli",
    "hypodermic": "haɪpədɜːmɪk",
    "hypodermics": "haɪpədɜːmɪks",
    "hypoglycaemia": "haɪpəʊɡlaɪkiːmiə",
    "hypoglycemic": "haɪpəʊɡlaɪsiːmɪk",
    "hypo": "haɪpəʊ",
    "hypoplasia": "haɪpəʊplæziə",
    "hypos": "haɪpəʊz",
    "hypostasis": "haɪpəʊsteɪsɪs",
    "hypotension": "haɪpəʊtɛnʃən",
    "hypotenuse": "haɪpɒtənjuːs",
    "hypothalamus": "haɪpəʊθælæməs",
    "hypothecated": "haɪpəʊθɛkeɪtɪd",
    "hypothermia": "haɪpəʊθɜːmiɐ",
    "hypothermic": "haɪpəʊθɜːmɪk",
    "hypotheses": "haɪpɒθəsiːz",
    "hypothesise": "haɪpɒθəsaɪz",
    "hypothesis": "haɪpɒθəsɪs",
    "hypothesising": "haɪpɒθəsaɪzɪŋ",
    "hypothetical": "haɪpəθɛtɪkəl",
    "hypothetically": "haɪpəθɛtɪkli",
    "hypotheticals": "haɪpəθɛtɪkəlz",
    "hypoxia": "haɪpɒksiə",
    "hyraxes": "haɪræksɪz",
    "hyrax": "haɪræks",
    "hyson": "haɪsən",
    "hyssop": "hɪsəp",
    "hysterectomies": "hɪstərɛktəmɪz",
    "hysterectomy": "hɪstərɛktəmi",
    "hysteresis": "hɪstəriːsɪs",
    "hysteria": "hɪstiərɪɐ",
    "hysterical": "hɪstɛrɪkəl",
    "hysterically": "hɪstɛrɪkli",
    "hysteric": "hɪstɛrɪk",
    "hysterics": "hɪstɛrɪks",
    "I": "aɪ",
    "iambic": "iəmbɪk",
    "iatrogenic": "aɪɐtrəʊdʒɛnɪk",
    "ibex": "aɪbɛks",
    "ibexes": "aɪbɛksɪz",
    "ibis": "aɪbɪs",
    "ibises": "aɪbaɪzɪz",
    "ibuprofen": "aɪbəprəʊfən",
    "ice": "aɪs",
    "iceberg": "aɪsbɜːɡ",
    "icebergs": "aɪsbɜːɡz",
    "icebound": "aɪsbaʊnd",
    "icebox": "aɪsbɒks",
    "icebreaker": "aɪsbreɪkɐ",
    "icebreakers": "aɪsbreɪkəz",
    "icecap": "aɪskæp",
    "icecaps": "aɪskæps",
    "iced": "aɪst",
    "icefall": "aɪsfɔːl",
    "icefalls": "aɪsfɔːlz",
    "icehouse": "aɪshaʊs",
    "iceman": "aɪsmən",
    "icepack": "aɪspæk",
    "icepick": "aɪspɪk",
    "icepicks": "aɪspɪks",
    "ices": "aɪsɪz",
    "ichneumon": "ɪknjuːmən",
    "ichthyology": "ɪkθɪɒlədʒi",
    "ichthyosaur": "ɪkθɪɒsɔː",
    "ichthyosaurs": "ɪkθɪɒsɔːz",
    "ichthyosaurus": "ɪkθɪəsɔːrəs",
    "icicle": "aɪsɪkəl",
    "icicles": "aɪsɪkəlz",
    "iciest": "aɪsɪəst",
    "icily": "aɪsɪli",
    "iciness": "aɪsɪnɛs",
    "icing": "aɪsɪŋ",
    "icings": "aɪsɪŋz",
    "ickier": "aɪkiɐ",
    "ickiness": "aɪkinəs",
    "icky": "aɪki",
    "icon": "aɪkɒn",
    "iconic": "aɪkɒnɪk",
    "iconically": "aɪkɒnɪkli",
    "iconoclasm": "aɪkənɒklæzəm",
    "iconoclast": "aɪkənɒklɑːst",
    "iconoclastic": "aɪkənəklɑːstɪk",
    "iconoclasts": "aɪkənɒklɑːsts",
    "iconographic": "aɪkənəɡræfɪk",
    "iconography": "aɪkənɒɡrəfi",
    "iconostasis": "aɪkənɒstɐsiz",
    "icons": "aɪkɒnz",
    "icosahedron": "aɪkəsɐhiːdrən",
    "icterus": "aɪktərəs",
    "icy": "aɪsi",
    "id": "aɪdiː",
    "idea": "aɪdiə",
    "ideal": "aɪdiəl",
    "idealisation": "aɪdiəlaɪzeɪʃən",
    "idealise": "aɪdiəlaɪz",
    "idealised": "aɪdiəlaɪzd",
    "idealising": "aɪdiəlaɪzɪŋ",
    "idealism": "aɪdiəlɪzəm",
    "idealist": "aɪdiəlɪst",
    "idealistic": "aɪdiəlɪstɪk",
    "idealistically": "aɪdiəlɪstɪkli",
    "idealists": "aɪdiəlɪsts",
    "ideally": "aɪdiəli",
    "idealogy": "aɪdiələdʒi",
    "ideals": "aɪdiəlz",
    "ideas": "aɪdiəz",
    "ideation": "aɪdiəʃən",
    "identical": "aɪdɛntɪkəl",
    "identically": "aɪdɛntɪkli",
    "identifiable": "aɪdɛntɪfaɪəbəl",
    "identifiably": "aɪdɛntɪfaɪəbli",
    "identification": "aɪdɛntɪfɪkeɪʃən",
    "identifications": "aɪdɛntɪfɪkeɪʃənz",
    "identified": "aɪdɛntɪfaɪd",
    "identifier": "aɪdɛntɪfaɪə",
    "identifiers": "aɪdɛntɪfaɪəz",
    "identifies": "aɪdɛntɪfaɪz",
    "identify": "aɪdɛntɪfaɪ",
    "identifying": "aɪdɛntɪfaɪɪŋ",
    "identikit": "aɪdɛntɪkɪt",
    "identities": "aɪdɛntɪtiz",
    "identity": "aɪdɛntɪti",
    "ideogram": "ɪdɪɒɡræm",
    "ideograms": "ɪdɪɒɡræmz",
    "ideological": "aɪdɪəlɒdʒɪkəl",
    "ideologically": "aɪdɪəlɒdʒɪkli",
    "ideologies": "aɪdɪɒlədʒɪz",
    "ideologist": "aɪdɪɒlədʒɪst",
    "ideologue": "aɪdɪɒlɒɡ",
    "ideologues": "aɪdɪɒlɒɡz",
    "ideology": "aɪdɪɒlədʒi",
    "ides": "aɪdz",
    "idiocy": "ɪdɪɒsi",
    "idiomatic": "ɪdɪəmætɪk",
    "idiom": "ɪdɪəm",
    "idioms": "ɪdɪəmz",
    "idiopathic": "ɪdɪəpæθɪk",
    "idiophone": "ɪdɪɒfəʊn",
    "idiosyncrasies": "ɪdɪɒsɪŋkrəsiz",
    "idiosyncrasy": "ɪdɪɒsɪŋkrəsi",
    "idiosyncratic": "ɪdɪɒsɪŋkrætɪk",
    "idiot": "ɪdɪət",
    "idiotically": "ɪdɪɒtɪkli",
    "idiotic": "ɪdɪɒtɪk",
    "idiots": "ɪdɪəts",
    "idle": "aɪdəl",
    "idled": "aɪdəld",
    "idleness": "aɪdəlnəs",
    "idlers": "aɪdləz",
    "idles": "aɪdəlz",
    "idling": "aɪdlɪŋ",
    "idly": "aɪdli",
    "idol": "aɪdəl",
    "idolaters": "aɪdəleɪtəz",
    "idolatrous": "aɪdəlætrəs",
    "idolatry": "aɪdɒlətri",
    "idolise": "aɪdəlaɪz",
    "idolised": "aɪdəlaɪzd",
    "idolises": "aɪdəlaɪzɪz",
    "idolising": "aɪdəlaɪzɪŋ",
    "idols": "aɪdəlz",
    "ids": "aɪdz",
    "idyll": "aɪdɪl",
    "idyllic": "aɪdɪlɪk",
    "idyllically": "aɪdɪlɪkli",
    "idylls": "aɪdɪlz",
    "if": "ɪf",
    "iffy": "ɪfi",
    "ifs": "ɪfs",
    "igloo": "ɪɡluː",
    "igloos": "ɪɡluːz",
    "igneous": "ɪɡniəs",
    "ignitable": "ɪɡnaɪtəbəl",
    "ignited": "ɪɡnaɪtɪd",
    "ignite": "ɪɡnaɪt",
    "igniter": "ɪɡnɪtɐ",
    "igniters": "ɪɡnɪtəz",
    "ignites": "ɪɡnaɪts",
    "igniting": "ɪɡnaɪtɪŋ",
    "ignition": "ɪɡnɪʃən",
    "ignoble": "ɪɡnəʊbəl",
    "ignominiously": "ɪɡnəmɪnɪəsli",
    "ignominious": "ɪɡnəmɪnɪəs",
    "ignominy": "ɪɡnəmɪni",
    "ignoramuses": "ɪɡnɔːreɪməsɪz",
    "ignoramus": "ɪɡnɔːreɪməs",
    "ignorance": "ɪɡnərəns",
    "ignorantly": "ɪɡnərəntli",
    "ignorant": "ɪɡnərənt",
    "ignored": "ɪɡnɔːd",
    "ignore": "ɪɡnɔː",
    "ignores": "ɪɡnɔːz",
    "ignoring": "ɪɡnɔːrɪŋ",
    "iguana": "ɪɡjuːɑːnɐ",
    "iguanas": "ɪɡjuːɑːnəz",
    "iguanodon": "ɪɡjuːænɒdən",
    "iguanodons": "ɪɡjuːænɒdənz",
    "ihram": "aɪhræm",
    "ikebana": "aɪkbɑːnɐ",
    "ikon": "aɪkən",
    "ilea": "ɪliə",
    "ileitis": "ɪleɪtiz",
    "ileum": "ɪliːəm",
    "ilex": "aɪlɛks",
    "iliac": "ɪlɪæk",
    "ilia": "ɪliɐ",
    "ilium": "ɪliəm",
    "ilk": "ɪlk",
    "illegality": "ɪliːɡælɪti",
    "illegal": "ɪliːɡəl",
    "illegally": "ɪliːɡəli",
    "illegals": "ɪliːɡəlz",
    "illegible": "ɪlɛdʒəbəl",
    "illegitimacy": "ɪlədʒɪtɪməsi",
    "illegitimate": "ɪlədʒɪtɪmət",
    "illegitimately": "ɪlədʒɪtɪmətli",
    "illiberal": "ɪlɪbərəl",
    "illicit": "ɪlɪsɪt",
    "illicitly": "ɪlɪsɪtli",
    "illimitable": "ɪlɪmɪtəbəl",
    "illiquid": "ɪlɪkwɪd",
    "illiteracy": "ɪlɪtərəsi",
    "illiterate": "ɪlɪtərət",
    "illiterates": "ɪlɪtərəts",
    "ill": "ɪl",
    "illnesses": "ɪlnəsɪz",
    "illness": "ɪlnəs",
    "illogical": "ɪlɒdʒɪkəl",
    "ills": "ɪlz",
    "illume": "ɪluːm",
    "illuminance": "ɪluːmɪnəns",
    "illuminant": "ɪluːmɪnənt",
    "illuminated": "ɪluːmɪneɪtɪd",
    "illuminate": "ɪluːmɪneɪt",
    "illuminates": "ɪluːmɪneɪts",
    "illuminati": "ɪluːmɪnɑːti",
    "illuminating": "ɪluːmɪneɪtɪŋ",
    "illumination": "ɪluːmɪneɪʃən",
    "illuminations": "ɪluːmɪneɪʃənz",
    "illuminator": "ɪluːmɪneɪtɐ",
    "illumine": "ɪluːmaɪn",
    "illusional": "ɪluːʒənəl",
    "illusionary": "ɪluːʒənəri",
    "illusionistic": "ɪluːʒənɪstɪk",
    "illusionist": "ɪluːʒənɪst",
    "illusionists": "ɪluːʒənɪsts",
    "illusion": "ɪluːʒən",
    "illusions": "ɪluːʒənz",
    "illusive": "ɪluːsɪv",
    "illusory": "ɪluːsəri",
    "illustrated": "ɪləstreɪtɪd",
    "illustrate": "ɪləstreɪt",
    "illustrates": "ɪləstreɪts",
    "illustrating": "ɪləstreɪtɪŋ",
    "illustration": "ɪləstreɪʃən",
    "illustrations": "ɪləstreɪʃənz",
    "illustrative": "ɪləstrətɪv",
    "illustrator": "ɪləstreɪtɐ",
    "illustrators": "ɪləstreɪtəz",
    "illustrious": "ɪlʌstrɪəs",
    "ilmenite": "ɪlmənaɪt",
    "imaged": "ɪmɪdʒd",
    "image": "ɪmɪdʒ",
    "imagery": "ɪmɪdʒri",
    "images": "ɪmɪdʒɪz",
    "imaginable": "ɪmædʒɪnəbəl",
    "imaginary": "ɪmædʒɪnəri",
    "imagination": "ɪmædʒɪneɪʃən",
    "imaginations": "ɪmædʒɪneɪʃənz",
    "imaginatively": "ɪmædʒɪnətɪvli",
    "imaginative": "ɪmædʒɪnətɪv",
    "imagined": "ɪmædʒɪnd",
    "imagine": "ɪmædʒɪn",
    "imagines": "ɪmædʒɪnz",
    "imaging": "ɪmɪdʒɪŋ",
    "imagining": "ɪmædʒɪnɪŋ",
    "imaginings": "ɪmædʒɪnɪŋz",
    "imagist": "ɪmædʒɪst",
    "imago": "ɪmeɪɡəʊ",
    "imam": "ɪmæm",
    "imams": "ɪmæmz",
    "imbalanced": "ɪmbælənst",
    "imbalance": "ɪmbæləns",
    "imbalances": "ɪmbælənsɪz",
    "imbecile": "ɪmbɛsaɪl",
    "imbeciles": "ɪmbɛsaɪlz",
    "imbecilic": "ɪmbɪsɪlɪk",
    "imbecility": "ɪmbɪsɪlɪti",
    "imbedded": "ɪmbɛdɪd",
    "imbed": "ɪmd",
    "imbibed": "ɪmbaɪbd",
    "imbibe": "ɪmbaɪb",
    "imbiber": "ɪmbɪbɐ",
    "imbibing": "ɪmbaɪbɪŋ",
    "imbroglio": "ɪmbrɒɡlɪəʊ",
    "imbued": "ɪmbjuːd",
    "imbue": "ɪmbjuː",
    "imbues": "ɪmbjuːz",
    "imbuing": "ɪmbjuːɪŋ",
    "imitated": "ɪmɪteɪtɪd",
    "imitate": "ɪmɪteɪt",
    "imitates": "ɪmɪteɪts",
    "imitating": "ɪmɪteɪtɪŋ",
    "imitation": "ɪmɪteɪʃən",
    "imitations": "ɪmɪteɪʃənz",
    "imitative": "ɪmɪteɪtɪv",
    "imitator": "ɪmɪteɪtɐ",
    "imitators": "ɪmɪteɪtəz",
    "immaculately": "ɪmækjʊlətli",
    "immaculate": "ɪmækjʊlət",
    "immaterial": "ɪmətiərɪəl",
    "immature": "ɪmətʃɔː",
    "immaturity": "ɪmətʃɔːrɪti",
    "immeasurable": "ɪmɛʒərəbəl",
    "immeasurably": "ɪmɛʒərəbli",
    "immediacy": "ɪmiːdɪəsi",
    "immediately": "ɪmiːdɪətli",
    "immediate": "ɪmiːdɪət",
    "immemorial": "ɪmɪmɔːrɪəl",
    "immensely": "ɪmɛnsli",
    "immense": "ɪmɛns",
    "immensity": "ɪmɛnsɪti",
    "immersed": "ɪmɜːsd",
    "immerse": "ɪmɜːs",
    "immerses": "ɪmɜːsɪz",
    "immersing": "ɪmɜːsɪŋ",
    "immersion": "ɪmɜːʃən",
    "immigrant": "ɪmɪɡrənt",
    "immigrants": "ɪmɪɡrənts",
    "immigrated": "ɪmɪɡreɪtɪd",
    "immigrate": "ɪmɪɡreɪt",
    "immigrating": "ɪmɪɡreɪtɪŋ",
    "immigration": "ɪmɪɡreɪʃən",
    "immigrations": "ɪmɪɡreɪʃənz",
    "imminence": "ɪmɪnəns",
    "imminently": "ɪmɪnəntli",
    "imminent": "ɪmɪnənt",
    "immobile": "ɪməʊbaɪl",
    "immobilisation": "ɪməʊbɪlaɪzeɪʃən",
    "immobilised": "ɪməʊbəlaɪzd",
    "immobilise": "ɪməʊbəlaɪz",
    "immobiliser": "ɪməʊbəlaɪzɐ",
    "immobilisers": "ɪməʊbəlaɪzəz",
    "immobilises": "ɪməʊbəlaɪzɪz",
    "immobilising": "ɪməʊbəlaɪzɪŋ",
    "immobility": "ɪməʊbɪlɪti",
    "immoderate": "ɪmɒdərət",
    "immodestly": "ɪmɒdəstli",
    "immodest": "ɪmɒdəst",
    "immodesty": "ɪmɒdəsti",
    "immolated": "ɪmɒleɪtɪd",
    "immolation": "ɪməleɪʃən",
    "immorality": "ɪmərælɪti",
    "immorally": "ɪmɒrəli",
    "immoral": "ɪmɒrəl",
    "immortalised": "ɪmɔːtəlaɪzd",
    "immortalise": "ɪmɔːtəlaɪz",
    "immortalises": "ɪmɔːtəlaɪzɪz",
    "immortalising": "ɪmɔːtəlaɪzɪŋ",
    "immortality": "ɪmɔːtælɪti",
    "immortal": "ɪmɔːtəl",
    "immortals": "ɪmɔːtəlz",
    "immovable": "ɪmuːvəbəl",
    "immoveable": "ɪmuːvəbəl",
    "immune": "ɪmjuːn",
    "immunisation": "ɪmjuːnaɪzeɪʃən",
    "immunisations": "ɪmjuːnaɪzeɪʃənz",
    "immunised": "ɪmjuːnaɪzd",
    "immunise": "ɪmjuːnaɪz",
    "immunising": "ɪmjuːnaɪzɪŋ",
    "immunity": "ɪmjuːnɪti",
    "immunodeficiency": "ɪmjuːnəʊdfɪʃənsi",
    "immunoglobulins": "ɪmjuːnəɡlɒbjʊlɪnz",
    "immunological": "ɪmjuːnəlɒdʒɪkəl",
    "immunology": "ɪmjuːnɒlədʒi",
    "immunosuppressant": "ɪmjuːnəsəprɛsənt",
    "immunosuppressants": "ɪmjuːnəsəprɛsənts",
    "immunosuppression": "ɪmjuːnəsəprɛʃən",
    "immured": "ɪmjɔːd",
    "immutable": "ɪmjuːtəbəl",
    "impacted": "ɪmpæktɪd",
    "impacting": "ɪmpæktɪŋ",
    "impaction": "ɪmpækʃən",
    "impaired": "ɪmpeəd",
    "impairing": "ɪmpeərɪŋ",
    "impairment": "ɪmpeəmənt",
    "impairments": "ɪmpeəmənts",
    "impair": "ɪmpeə",
    "impairs": "ɪmpeəz",
    "impala": "ɪmpɑːlɐ",
    "impalas": "ɪmpɑːləz",
    "impaled": "ɪmpeɪld",
    "impalement": "ɪmpeɪlmənt",
    "impale": "ɪmpeɪl",
    "impaler": "ɪmpeɪlɐ",
    "impales": "ɪmpeɪlz",
    "impaling": "ɪmpeɪlɪŋ",
    "imparted": "ɪmpɑːtɪd",
    "impartiality": "ɪmpɑːʃɪælɪti",
    "impartially": "ɪmpɑːʃəli",
    "impartial": "ɪmpɑːʃəl",
    "imparting": "ɪmpɑːtɪŋ",
    "impart": "ɪmpɑːt",
    "imparts": "ɪmpɑːts",
    "impassable": "ɪmpɑːsəbəl",
    "impasse": "ɪmpɑːs",
    "impassioned": "ɪmpæʃənd",
    "impassively": "ɪmpɑːsɪvli",
    "impassive": "ɪmpɑːsɪv",
    "impasto": "ɪmpɑːstəʊ",
    "impatience": "ɪmpeɪʃəns",
    "impatiens": "ɪmpeɪʃənz",
    "impatiently": "ɪmpeɪʃəntli",
    "impatient": "ɪmpeɪʃənt",
    "impeachable": "ɪmpiːtʃəbəl",
    "impeached": "ɪmpiːtʃt",
    "impeaching": "ɪmpiːtʃɪŋ",
    "impeachment": "ɪmpiːtʃmənt",
    "impeach": "ɪmpiːtʃ",
    "impearl": "ɪmpɜːl",
    "impeccable": "ɪmpɛkəbəl",
    "impeccably": "ɪmpɛkəbli",
    "impecunious": "ɪmpɪkjuːnɪəs",
    "impedance": "ɪmpiːdəns",
    "impeded": "ɪmpiːdɪd",
    "impede": "ɪmpiːd",
    "impedes": "ɪmpiːdz",
    "impedimenta": "ɪmpɛdɪmɛntɐ",
    "impediment": "ɪmpɛdɪmənt",
    "impediments": "ɪmpɛdɪmənts",
    "impeding": "ɪmpiːdɪŋ",
    "impelled": "ɪmpɛld",
    "impeller": "ɪmpɛlɐ",
    "impel": "ɪmpɛl",
    "impels": "ɪmpɛlz",
    "impending": "ɪmpɛndɪŋ",
    "impenetrable": "ɪmpɛnɪtrəbəl",
    "impenetrably": "ɪmpɛnɪtrəbli",
    "imperative": "ɪmpɛrətɪv",
    "imperatives": "ɪmpɛrətɪvz",
    "imperator": "ɪmpɜːreɪtɐ",
    "imperceptible": "ɪmpəsɛptəbəl",
    "imperceptibly": "ɪmpəsɛptəbli",
    "imperfection": "ɪmpəfɛkʃən",
    "imperfections": "ɪmpəfɛkʃənz",
    "imperfectly": "ɪmpɜːfɛktli",
    "imperfect": "ɪmpɜːfɛkt",
    "imperialism": "ɪmpiərɪəlɪzəm",
    "imperialistic": "ɪmpiərɪəlɪstɪk",
    "imperialist": "ɪmpiərɪəlɪst",
    "imperialists": "ɪmpiərɪəlɪsts",
    "imperial": "ɪmpiərɪəl",
    "imperials": "ɪmpiərɪəlz",
    "imperilled": "ɪmpɛrəld",
    "imperilling": "ɪmpɛrɪlɪŋ",
    "imperil": "ɪmpɛrəl",
    "imperious": "ɪmpiərɪəs",
    "imperiousness": "ɪmpiərɪəsnəs",
    "imperishable": "ɪmpɛrɪʃəbəl",
    "imperium": "ɪmpiərɪəm",
    "impermanence": "ɪmpɜːmənəns",
    "impermanent": "ɪmpɜːmənənt",
    "impermeable": "ɪmpɜːməbəl",
    "impersonality": "ɪmpɜːsənælɪti",
    "impersonal": "ɪmpɜːsənəl",
    "impersonated": "ɪmpɜːsəneɪtɪd",
    "impersonate": "ɪmpɜːsəneɪt",
    "impersonates": "ɪmpɜːsəneɪts",
    "impersonating": "ɪmpɜːsəneɪtɪŋ",
    "impersonation": "ɪmpɜːsəneɪʃən",
    "impersonations": "ɪmpɜːsəneɪʃənz",
    "impersonator": "ɪmpɜːsəneɪtɐ",
    "impersonators": "ɪmpɜːsəneɪtəz",
    "impertinence": "ɪmpɜːtɪnəns",
    "impertinently": "ɪmpɜːtɪnəntli",
    "impertinent": "ɪmpɜːtɪnənt",
    "impervious": "ɪmpɜːvɪəs",
    "impetigo": "ɪmpɛtɪɡəʊ",
    "impetuosity": "ɪmpɛtjuːɒsɪti",
    "impetuous": "ɪmpɛtʃuːəs",
    "impetuousness": "ɪmpɛtʃuːəsnəs",
    "impetus": "ɪmpɛtəs",
    "impiety": "ɪmpaɪəti",
    "impinged": "ɪmpɪndʒd",
    "impingement": "ɪmpɪndʒmənt",
    "impinge": "ɪmpɪndʒ",
    "impinges": "ɪmpɪndʒɪz",
    "impinging": "ɪmpɪndʒɪŋ",
    "impious": "ɪmpɪəs",
    "impishly": "ɪmpɪʃli",
    "impish": "ɪmpɪʃ",
    "implacable": "ɪmplækəbəl",
    "implacably": "ɪmplækəbli",
    "implantable": "ɪmplæntəbəl",
    "implantation": "ɪmplɑːnteɪʃən",
    "implanted": "ɪmplæntɪd",
    "implanting": "ɪmplæntɪŋ",
    "implausible": "ɪmplɔːzəbəl",
    "implausibly": "ɪmplɔːzəbli",
    "implementation": "ɪmplɪmənteɪʃən",
    "implementations": "ɪmplɪmənteɪʃənz",
    "implemented": "ɪmplɪməntɪd",
    "implementer": "ɪmplɪməntɐ",
    "implementing": "ɪmplɪməntɪŋ",
    "implicated": "ɪmplɪkeɪtɪd",
    "implicate": "ɪmplɪkeɪt",
    "implicates": "ɪmplɪkeɪts",
    "implicating": "ɪmplɪkeɪtɪŋ",
    "implication": "ɪmplɪkeɪʃən",
    "implications": "ɪmplɪkeɪʃənz",
    "implicitly": "ɪmplɪsɪtli",
    "implicit": "ɪmplɪsɪt",
    "implied": "ɪmplaɪd",
    "implies": "ɪmplaɪz",
    "imploded": "ɪmpləʊdɪd",
    "implode": "ɪmpləʊd",
    "implodes": "ɪmpləʊdz",
    "imploding": "ɪmpləʊdɪŋ",
    "implored": "ɪmplɔːd",
    "implore": "ɪmplɔː",
    "implores": "ɪmplɔːz",
    "imploring": "ɪmplɔːrɪŋ",
    "implosion": "ɪmpləʊʒən",
    "implying": "ɪmplaɪɪŋ",
    "imply": "ɪmplaɪ",
    "imp": "ɪmp",
    "impolitely": "ɪmpəlaɪtli",
    "impolite": "ɪmpəlaɪt",
    "impolitic": "ɪmpəlɪtɪk",
    "imponderable": "ɪmpɒndərəbəl",
    "imponderables": "ɪmpɒndərəbəlz",
    "importance": "ɪmpɔːtəns",
    "importantly": "ɪmpɔːtəntli",
    "important": "ɪmpɔːtənt",
    "importation": "ɪmpɔːteɪʃən",
    "imported": "ɪmpɔːtɪd",
    "importer": "ɪmpɔːtɐ",
    "importers": "ɪmpɔːtəz",
    "importing": "ɪmpɔːtɪŋ",
    "importunate": "ɪmpɔːtʌneɪt",
    "importuning": "ɪmpɔːtjuːnɪŋ",
    "imposed": "ɪmpəʊzd",
    "impose": "ɪmpəʊz",
    "imposes": "ɪmpəʊzɪz",
    "imposing": "ɪmpəʊzɪŋ",
    "imposition": "ɪmpəzɪʃən",
    "impositions": "ɪmpəzɪʃənz",
    "impossibilities": "ɪmpɒsəbɪlɪtiz",
    "impossibility": "ɪmpɒsəbɪlɪti",
    "impossible": "ɪmpɒsəbəl",
    "impossibly": "ɪmpɒsəbli",
    "imposter": "ɪmpɒstɐ",
    "imposters": "ɪmpɒstəz",
    "impost": "ɪmpɒst",
    "impostor": "ɪmpɒstɐ",
    "impostors": "ɪmpɒstəz",
    "imposture": "ɪmpɒstjɔː",
    "impotence": "ɪmpətəns",
    "impotently": "ɪmpətəntli",
    "impotent": "ɪmpətənt",
    "impounded": "ɪmpaʊndɪd",
    "impounding": "ɪmpaʊndɪŋ",
    "impoundment": "ɪmpaʊndmənt",
    "impound": "ɪmpaʊnd",
    "impounds": "ɪmpaʊndz",
    "impoverished": "ɪmpɒvərɪʃt",
    "impoverishes": "ɪmpɒvərɪʃɪz",
    "impoverishing": "ɪmpɒvərɪʃɪŋ",
    "impoverishment": "ɪmpɒvərɪʃmənt",
    "impoverish": "ɪmpɒvərɪʃ",
    "impracticable": "ɪmpræktɪkəbəl",
    "impracticality": "ɪmpræktɪkælɪti",
    "impractically": "ɪmpræktɪkli",
    "impractical": "ɪmpræktɪkəl",
    "imprecations": "ɪmprɪkeɪʃənz",
    "imprecise": "ɪmprɪsaɪs",
    "imprecision": "ɪmprɪsɪʒən",
    "impregnability": "ɪmprɛɡnəbɪlɪti",
    "impregnable": "ɪmprɛɡnəbəl",
    "impregnated": "ɪmprɛɡneɪtɪd",
    "impregnate": "ɪmprɛɡneɪt",
    "impregnates": "ɪmprɛɡneɪts",
    "impregnating": "ɪmprɛɡneɪtɪŋ",
    "impresario": "ɪmprɪsɑːrɪəʊ",
    "impresarios": "ɪmprɪsɑːrɪəʊz",
    "impressed": "ɪmprɛst",
    "impressing": "ɪmprɛsɪŋ",
    "impressionable": "ɪmprɛʃənəbəl",
    "impressionism": "ɪmprɛʃənɪzəm",
    "impressionistic": "ɪmprɛʃənɪstɪk",
    "impressionist": "ɪmprɛʃənɪst",
    "impressionists": "ɪmprɛʃənɪsts",
    "impression": "ɪmprɛʃən",
    "impressions": "ɪmprɛʃənz",
    "impressively": "ɪmprɛsɪvli",
    "impressive": "ɪmprɛsɪv",
    "impressiveness": "ɪmprɛsɪvnəs",
    "imprimatur": "ɪmprɪmətʃɔː",
    "imprinted": "ɪmprɪntɪd",
    "imprinting": "ɪmprɪntɪŋ",
    "imprisonable": "ɪmprɪzəʊnəbəl",
    "imprisoned": "ɪmprɪzənd",
    "imprisoning": "ɪmprɪzənɪŋ",
    "imprisonment": "ɪmprɪzənmənt",
    "imprisonments": "ɪmprɪzənmənts",
    "imprison": "ɪmprɪzən",
    "imprisons": "ɪmprɪzənz",
    "improbabilities": "ɪmprɒbəbɪlɪtiz",
    "improbability": "ɪmprɒbəbɪlɪti",
    "improbable": "ɪmprɒbəbəl",
    "improbably": "ɪmprɒbəbli",
    "impromptu": "ɪmprɒmptuː",
    "improperly": "ɪmprɒpəli",
    "improper": "ɪmprɒpɐ",
    "improprieties": "ɪmprəpraɪətɪz",
    "impropriety": "ɪmprəpraɪəti",
    "improved": "ɪmpruːvd",
    "improvement": "ɪmpruːvmənt",
    "improvements": "ɪmpruːvmənts",
    "improve": "ɪmpruːv",
    "improver": "ɪmpruːvɐ",
    "improves": "ɪmpruːvz",
    "improvidence": "ɪmprɒvɪdəns",
    "improvident": "ɪmprɒvɪdənt",
    "improving": "ɪmpruːvɪŋ",
    "improvisational": "ɪmprəvaɪzeɪʃənəl",
    "improvisation": "ɪmprəvaɪzeɪʃən",
    "improvisations": "ɪmprəvaɪzeɪʃənz",
    "improvisatory": "ɪmprəvɪsətəri",
    "improvised": "ɪmprəvaɪzd",
    "improvise": "ɪmprəvaɪz",
    "improviser": "ɪmprəvaɪzɐ",
    "improvisers": "ɪmprəvaɪzəz",
    "improvises": "ɪmprəvaɪzɪz",
    "improvising": "ɪmprəvaɪzɪŋ",
    "imprudence": "ɪmpruːdəns",
    "imprudent": "ɪmpruːdənt",
    "imps": "ɪmps",
    "impudence": "ɪmpjuːdəns",
    "impudent": "ɪmpjuːdənt",
    "impugned": "ɪmpjuːnd",
    "impugning": "ɪmpjuːnɪŋ",
    "impugn": "ɪmpjuːn",
    "impulse": "ɪmpʌls",
    "impulses": "ɪmpʌlsɪz",
    "impulsion": "ɪmpʌlʃən",
    "impulsively": "ɪmpʌlsɪvli",
    "impulsive": "ɪmpʌlsɪv",
    "impulsiveness": "ɪmpʌlsɪvnəs",
    "impulsivity": "ɪmpəlsɪvɪti",
    "impunity": "ɪmpjuːnɪti",
    "impure": "ɪmpjɔː",
    "impurities": "ɪmpjʊrɪtiz",
    "impurity": "ɪmpjʊrɪti",
    "imputation": "ɪmpjuːteɪʃən",
    "imputed": "ɪmpjuːtɪd",
    "impute": "ɪmpjuːt",
    "imputing": "ɪmpjuːtɪŋ",
    "inabilities": "ɪnɐbɪlətiz",
    "inability": "ɪnɐbɪləti",
    "inaccessibility": "ɪnɐksɛsəbɪlɪti",
    "inaccessible": "ɪnɐksɛsəbəl",
    "inaccuracies": "ɪnækjʊrəsɪz",
    "inaccuracy": "ɪnækjʊrəsi",
    "inaccurately": "ɪnækjʊrətli",
    "inaccurate": "ɪnækjʊrət",
    "inaction": "ɪnækʃən",
    "inactivate": "ɪnæktɪveɪt",
    "inactive": "ɪnæktɪv",
    "inactivity": "ɪnæktɪvɪti",
    "inadequacies": "ɪnædɪkwəsɪz",
    "inadequacy": "ɪnædɪkwəsi",
    "inadequately": "ɪnædɪkwətli",
    "inadequate": "ɪnædɪkwət",
    "inadmissible": "ɪnɐdmɪsəbəl",
    "inadvertently": "ɪnɐdvɜːtəntli",
    "inadvertent": "ɪnɐdvɜːtənt",
    "inadvisable": "ɪnɐdvaɪzəbəl",
    "inalienable": "ɪneɪliənəbəl",
    "inamorata": "ɪnæmɔːrɑːtɐ",
    "inane": "ɪneɪn",
    "inanimate": "ɪnænɪmət",
    "inanities": "ɪnænɪtɪz",
    "inanity": "ɪnænɪti",
    "inappropriately": "ɪnɐprəʊpriətli",
    "inappropriateness": "ɪnɐprəʊpriətnəs",
    "inappropriate": "ɪnɐprəʊpriət",
    "inapt": "ɪnæpt",
    "inarticulateness": "ɪnɑːtɪkjʊleɪtnəs",
    "inarticulate": "ɪnɑːtɪkjʊleɪt",
    "inartistic": "ɪnɑːtɪstɪk",
    "inasmuch": "ɪnɐsmʌtʃ",
    "inattention": "ɪnɐtɛnʃən",
    "inattentive": "ɪnɐtɛntɪv",
    "inaudible": "ɪnɔːdəbəl",
    "inaudibly": "ɪnɔːdəbli",
    "inaugural": "ɪnɔːɡjʊrəl",
    "inaugurated": "ɪnɔːɡjʊreɪtɪd",
    "inaugurate": "ɪnɔːɡjʊreɪt",
    "inaugurates": "ɪnɔːɡjʊreɪts",
    "inaugurating": "ɪnɔːɡjʊreɪtɪŋ",
    "inauguration": "ɪnɔːɡjʊreɪʃən",
    "inauspicious": "ɪnɔːspɪʃəs",
    "inauthentic": "ɪnɔːθɛntɪk",
    "inboard": "ɪnbɔːd",
    "inborn": "ɪnbɔːn",
    "inbound": "ɪnbaʊnd",
    "inbred": "ɪnbrɛd",
    "inbreeding": "ɪnbriːdɪŋ",
    "inbreed": "ɪnbriːd",
    "inbuilt": "ɪnbɪlt",
    "incalculable": "ɪnkælkjuːləbəl",
    "incalculably": "ɪnkælkjuːləbli",
    "incandescence": "ɪnkɐndɛsəns",
    "incandescent": "ɪnkɐndɛsənt",
    "incantation": "ɪnkɑːnteɪʃən",
    "incantations": "ɪnkɑːnteɪʃənz",
    "incapability": "ɪnkeɪpəbɪlɪti",
    "incapable": "ɪnkeɪpəbəl",
    "incapacitated": "ɪnkəpæsɪteɪtɪd",
    "incapacitate": "ɪnkəpæsɪteɪt",
    "incapacitating": "ɪnkəpæsɪteɪtɪŋ",
    "incapacitation": "ɪnkəpæsɪteɪʃən",
    "incapacity": "ɪnkəpæsɪti",
    "incarcerated": "ɪnkɑːsəreɪtɪd",
    "incarcerate": "ɪnkɑːsəreɪt",
    "incarcerating": "ɪnkɑːsəreɪtɪŋ",
    "incarceration": "ɪnkɑːsəreɪʃən",
    "incarnadine": "ɪnkɑːnɐdiːn",
    "incarnated": "ɪnkɑːneɪtɪd",
    "incarnate": "ɪnkɑːneɪt",
    "incarnates": "ɪnkɑːneɪts",
    "incarnation": "ɪnkɑːneɪʃən",
    "incarnations": "ɪnkɑːneɪʃənz",
    "incase": "ɪnkeɪs",
    "incautiously": "ɪnkɔːʃəsli",
    "incautious": "ɪnkɔːʃəs",
    "incendiaries": "ɪnsɛndjərɪz",
    "incendiary": "ɪnsɛndjəri",
    "incensed": "ɪnsɛnsd",
    "incenses": "ɪnsənsɪz",
    "incentive": "ɪnsɛntɪv",
    "incentives": "ɪnsɛntɪvz",
    "incentivisation": "ɪnsɛntɪvaɪzeɪʃən",
    "incentivise": "ɪnsɛntɪvaɪz",
    "inception": "ɪnsɛpʃən",
    "incept": "ɪnsɛpt",
    "incessantly": "ɪnsɛsəntli",
    "incessant": "ɪnsɛsənt",
    "incest": "ɪnsɛst",
    "incestuously": "ɪnsɛstʃuːəsli",
    "incestuous": "ɪnsɛstʃuːəs",
    "inched": "ɪntʃt",
    "inches": "ɪntʃɪz",
    "inching": "ɪntʃɪŋ",
    "inch": "ɪntʃ",
    "inchoate": "ɪntʃəʊt",
    "inchworm": "ɪntʃwɜːm",
    "incidence": "ɪnsɪdəns",
    "incidences": "ɪnsɪdənsɪz",
    "incidentally": "ɪnsɪdɛntəli",
    "incidental": "ɪnsɪdɛntəl",
    "incidentals": "ɪnsɪdɛntəlz",
    "incident": "ɪnsɪdənt",
    "incidents": "ɪnsɪdənts",
    "incinerated": "ɪnsɪnəreɪtɪd",
    "incinerate": "ɪnsɪnəreɪt",
    "incinerating": "ɪnsɪnəreɪtɪŋ",
    "incineration": "ɪnsɪnəreɪʃən",
    "incinerator": "ɪnsɪnəreɪtɐ",
    "incinerators": "ɪnsɪnəreɪtəz",
    "incipient": "ɪnsɪpiənt",
    "incised": "ɪnsaɪzd",
    "incise": "ɪnsaɪz",
    "incising": "ɪnsaɪzɪŋ",
    "incision": "ɪnsɪʒən",
    "incisions": "ɪnsɪʒənz",
    "incisiveness": "ɪnsaɪsɪvnəs",
    "incisive": "ɪnsaɪsɪv",
    "incisor": "ɪnsaɪzɐ",
    "incisors": "ɪnsaɪzəz",
    "incited": "ɪnsaɪtɪd",
    "incitement": "ɪnsaɪtmənt",
    "incitements": "ɪnsaɪtmənts",
    "incite": "ɪnsaɪt",
    "inciters": "ɪnsaɪtəz",
    "incites": "ɪnsaɪts",
    "inciting": "ɪnsaɪtɪŋ",
    "inclement": "ɪnklɛmənt",
    "inclination": "ɪnklɪneɪʃən",
    "inclinations": "ɪnklɪneɪʃənz",
    "inclined": "ɪnklaɪnd",
    "inclining": "ɪnklaɪnɪŋ",
    "inclinometer": "ɪnklɪnɒmɪtɐ",
    "inclose": "ɪnkləʊz",
    "included": "ɪnkluːdɪd",
    "include": "ɪnkluːd",
    "includes": "ɪnkluːdz",
    "including": "ɪnkluːdɪŋ",
    "inclusion": "ɪnkluːʒən",
    "inclusions": "ɪnkluːʒənz",
    "inclusively": "ɪnkluːsɪvli",
    "inclusiveness": "ɪnkluːsɪvnəs",
    "inclusive": "ɪnkluːsɪv",
    "incognito": "ɪnkɒɡniːtəʊ",
    "incoherence": "ɪnkəʊhiərəns",
    "incoherently": "ɪnkəʊhiərəntli",
    "incoherent": "ɪnkəʊhiərənt",
    "income": "ɪnkʌm",
    "incomer": "ɪnkʌmɐ",
    "incomers": "ɪnkʌməz",
    "incomes": "ɪnkʌmz",
    "incoming": "ɪnkʌmɪŋ",
    "incommunicado": "ɪnkəmjuːnɪkɑːdəʊ",
    "incommunicative": "ɪnkəmjuːnɪkətɪv",
    "incomparable": "ɪnkɒmpərəbəl",
    "incomparably": "ɪnkɒmpərəbli",
    "incompatibility": "ɪnkəmpætɪbɪlɪti",
    "incompatible": "ɪnkəmpætəbəl",
    "incompetence": "ɪnkɒmpɪtəns",
    "incompetency": "ɪnkɒmpɪtənsi",
    "incompetently": "ɪnkɒmpɪtəntli",
    "incompetent": "ɪnkɒmpɪtənt",
    "incompetents": "ɪnkɒmpɪtənts",
    "incompletely": "ɪnkəmpliːtli",
    "incompleteness": "ɪnkəmpliːtnəs",
    "incomplete": "ɪnkəmpliːt",
    "incompletion": "ɪnkəmpliːʃən",
    "incomprehensible": "ɪnkɒmprɪhɛnsəbəl",
    "incomprehensibly": "ɪnkɒmprɪhɛnsəbli",
    "incomprehension": "ɪnkɒmprɪhɛnʃən",
    "inconceivable": "ɪnkənsiːvəbəl",
    "inconceivably": "ɪnkənsiːvəbli",
    "inconclusively": "ɪnkənkluːsɪvli",
    "inconclusive": "ɪnkənkluːsɪv",
    "incongruity": "ɪnkɒnɡruːɪti",
    "incongruously": "ɪnkɒnɡruːəsli",
    "incongruous": "ɪnkɒnɡruːəs",
    "inconsequence": "ɪnkɒnsɪkwəns",
    "inconsequential": "ɪnkɒnsɪkwɛnʃəl",
    "inconsiderable": "ɪnkənsɪdərəbəl",
    "inconsiderate": "ɪnkənsɪdərət",
    "inconsistencies": "ɪnkənsɪstənsiz",
    "inconsistency": "ɪnkənsɪstənsi",
    "inconsistently": "ɪnkənsɪstəntli",
    "inconsistent": "ɪnkənsɪstənt",
    "inconsolable": "ɪnkɒnsəʊləbəl",
    "inconspicuously": "ɪnkənspɪkjuːəsli",
    "inconspicuous": "ɪnkənspɪkjuːəs",
    "inconstancy": "ɪnkɒnstənsi",
    "inconstant": "ɪnkɒnstənt",
    "incontestable": "ɪnkəntɛstəbəl",
    "incontestably": "ɪnkəntɛstəbli",
    "incontinence": "ɪnkɒntɪnəns",
    "incontinent": "ɪnkɒntɪnənt",
    "incontrovertible": "ɪnkɒntrəvɜːtəbəl",
    "incontrovertibly": "ɪnkɒntrəvɜːtəbli",
    "inconvenienced": "ɪnkənviːnɪənst",
    "inconvenience": "ɪnkənviːnɪəns",
    "inconveniences": "ɪnkənviːnɪənsɪz",
    "inconveniencing": "ɪnkənviːnɪənsɪŋ",
    "inconveniently": "ɪnkənviːnɪəntli",
    "inconvenient": "ɪnkənviːnɪənt",
    "incorporated": "ɪnkɔːpəreɪtɪd",
    "incorporates": "ɪnkɔːpəreɪts",
    "incorporating": "ɪnkɔːpəreɪtɪŋ",
    "incorporation": "ɪnkɔːpəreɪʃən",
    "incorrectly": "ɪnkərɛktli",
    "incorrectness": "ɪnkərɛktnəs",
    "incorrect": "ɪnkərɛkt",
    "incorrigible": "ɪnkɒrɪdʒəbəl",
    "incorruptible": "ɪnkərʌptəbəl",
    "increased": "ɪnkriːsd",
    "increasingly": "ɪnkriːsɪŋli",
    "increasing": "ɪnkriːsɪŋ",
    "incredibility": "ɪnkrɛdɪbɪlɪti",
    "incredible": "ɪnkrɛdɪbəl",
    "incredibly": "ɪnkrɛdɪbli",
    "incredulity": "ɪnkrɪdjʊlɪti",
    "incredulously": "ɪnkrɛdjʊləsli",
    "incredulous": "ɪnkrɛdjʊləs",
    "incrementally": "ɪnkrɪmɛntəli",
    "incremental": "ɪnkrɪmɛntəl",
    "increment": "ɪnkrɪmənt",
    "increments": "ɪnkrɪmənts",
    "incriminated": "ɪnkrɪmɪneɪtɪd",
    "incriminate": "ɪnkrɪmɪneɪt",
    "incriminates": "ɪnkrɪmɪneɪts",
    "incriminating": "ɪnkrɪmɪneɪtɪŋ",
    "incrimination": "ɪnkrɪmɪneɪʃən",
    "incubated": "ɪnkjuːbeɪtɪd",
    "incubate": "ɪnkjuːbeɪt",
    "incubates": "ɪnkjuːbeɪts",
    "incubating": "ɪnkjuːbeɪtɪŋ",
    "incubation": "ɪnkjuːbeɪʃən",
    "incubator": "ɪnkjuːbeɪtɐ",
    "incubators": "ɪnkjuːbeɪtəz",
    "incubus": "ɪnkjuːbəs",
    "inculcated": "ɪnkəlkeɪtɪd",
    "inculcate": "ɪnkəlkeɪt",
    "inculcates": "ɪnkəlkeɪts",
    "inculcating": "ɪnkəlkeɪtɪŋ",
    "incumbency": "ɪnkʌmbənsi",
    "incumbent": "ɪnkʌmbənt",
    "incumbents": "ɪnkʌmbənts",
    "incurable": "ɪnkjɔːrəbəl",
    "incurables": "ɪnkjʊrəbəlz",
    "incurably": "ɪnkjɔːrəbli",
    "incurious": "ɪnkjʊrɪəs",
    "incur": "ɪnkɜː",
    "incurred": "ɪnkɜːd",
    "incurring": "ɪnkɜːrɪŋ",
    "incursion": "ɪnkɜːʃən",
    "incursions": "ɪnkɜːʃənz",
    "incurs": "ɪnkɜːz",
    "incuse": "ɪnkjuːs",
    "incus": "ɪnkʌs",
    "indebted": "ɪndɛtɪd",
    "indebtedness": "ɪndɛtɪdnəs",
    "indecency": "ɪndiːsənsi",
    "indecently": "ɪndiːsəntli",
    "indecent": "ɪndiːsənt",
    "indecipherable": "ɪndɪsaɪfərəbəl",
    "indecision": "ɪndɪsɪʒən",
    "indecisively": "ɪndɪsaɪsɪvli",
    "indecisive": "ɪndɪsaɪsɪv",
    "indecisiveness": "ɪndɪsaɪsɪvnəs",
    "indecorous": "ɪndɛkərəs",
    "indeed": "ɪndiːd",
    "indefatigability": "ɪndɪfætɪɡəbɪlɪti",
    "indefatigable": "ɪndɪfætɪɡəbəl",
    "indefensible": "ɪndɪfɛnsəbəl",
    "indefensibly": "ɪndɪfɛnsəbli",
    "indefinable": "ɪndɪfaɪnəbəl",
    "indefinitely": "ɪndɛfɪnətli",
    "indefinite": "ɪndɛfɪnət",
    "indelible": "ɪndɛləbəl",
    "indelibly": "ɪndɛləbli",
    "indelicate": "ɪndɛlɪkət",
    "indemnified": "ɪndɛmnɪfaɪd",
    "indemnify": "ɪndɛmnɪfaɪ",
    "indemnity": "ɪndɛmnɪti",
    "indentation": "ɪndɛnteɪʃən",
    "indentations": "ɪndɛnteɪʃənz",
    "indented": "ɪndɛntɪd",
    "indentured": "ɪndɛntʃəd",
    "indenture": "ɪndɛntʃɐ",
    "indentures": "ɪndɛntʃəz",
    "independence": "ɪndɪpɛndəns",
    "independency": "ɪndɪpɛndənsi",
    "independently": "ɪndɪpɛndəntli",
    "independent": "ɪndɪpɛndənt",
    "independents": "ɪndɪpɛndənts",
    "indescribable": "ɪndɪskraɪbəbəl",
    "indescribably": "ɪndɪskraɪbəbli",
    "indestructible": "ɪndɪstrʌktəbəl",
    "indeterminable": "ɪndɪtɜːmɪnəbəl",
    "indeterminately": "ɪndɪtɜːmɪnətli",
    "indeterminate": "ɪndɪtɜːmɪnət",
    "indexation": "ɪndɪkseɪʃən",
    "indexed": "ɪndɛkst",
    "indexes": "ɪndɛksɪz",
    "indexing": "ɪndɛksɪŋ",
    "index": "ɪndɛks",
    "indicated": "ɪndɪkeɪtɪd",
    "indicate": "ɪndɪkeɪt",
    "indicates": "ɪndɪkeɪts",
    "indicating": "ɪndɪkeɪtɪŋ",
    "indication": "ɪndɪkeɪʃən",
    "indications": "ɪndɪkeɪʃənz",
    "indicative": "ɪndɪkətɪv",
    "indicator": "ɪndɪkeɪtɐ",
    "indicators": "ɪndɪkeɪtəz",
    "indices": "ɪndɪsiːz",
    "indicia": "ɪndɪʃɐ",
    "indictable": "ɪndɪktəbəl",
    "indicted": "ɪndaɪtɪd",
    "indicting": "ɪndaɪtɪŋ",
    "indictment": "ɪndaɪtmənt",
    "indictments": "ɪndaɪtmənts",
    "indict": "ɪndaɪt",
    "indie": "ɪndi",
    "indies": "ɪndiz",
    "indifference": "ɪndɪfrəns",
    "indifferently": "ɪndɪfrəntli",
    "indifferent": "ɪndɪfrənt",
    "indigenously": "ɪndɪdʒənəsli",
    "indigenous": "ɪndɪdʒənəs",
    "indigestible": "ɪndɪdʒɛstəbəl",
    "indigestion": "ɪndɪdʒɛstʃən",
    "indignantly": "ɪndɪɡnəntli",
    "indignant": "ɪndɪɡnənt",
    "indignation": "ɪndɪɡneɪʃən",
    "indignities": "ɪndɪɡnɪtiz",
    "indignity": "ɪndɪɡnɪti",
    "indigo": "ɪndɪɡəʊ",
    "indirection": "ɪndaɪrɛkʃən",
    "indirections": "ɪndaɪrɛkʃənz",
    "indirectly": "ɪndaɪrɛktli",
    "indirect": "ɪndaɪrɛkt",
    "indiscernible": "ɪndɪsɜːnəbəl",
    "indiscipline": "ɪndɪsɪplɪn",
    "indiscreet": "ɪndɪskriːt",
    "indiscrete": "ɪndɪskriːt",
    "indiscretion": "ɪndɪskrɛʃən",
    "indiscretions": "ɪndɪskrɛʃənz",
    "indiscriminately": "ɪndɪskrɪmɪnətli",
    "indiscriminate": "ɪndɪskrɪmɪnət",
    "indispensable": "ɪndɪspɛnsəbəl",
    "indisposed": "ɪndɪspəʊzd",
    "indisposition": "ɪndɪspəzɪʃən",
    "indisputable": "ɪndɪspjuːtəbəl",
    "indisputably": "ɪndɪspjuːtəbli",
    "indissolubly": "ɪndɪsəlʌbli",
    "indistinctly": "ɪndɪstɪŋktli",
    "indistinct": "ɪndɪstɪŋkt",
    "indistinguishable": "ɪndɪstɪŋɡwɪʃəbəl",
    "indium": "ɪndɪəm",
    "individualised": "ɪndɪvɪdʒuːəlaɪzd",
    "individualise": "ɪndɪvɪdʒuːəlaɪz",
    "individualism": "ɪndɪvɪdʒuːəlɪzəm",
    "individualistic": "ɪndɪvɪdʒuːəlɪstɪk",
    "individualist": "ɪndɪvɪdʒuːəlɪst",
    "individualists": "ɪndɪvɪdʒuːəlɪsts",
    "individuality": "ɪndɪvɪdjuːælɪti",
    "individually": "ɪndɪvɪdʒuːəli",
    "individual": "ɪndɪvɪdʒuːəl",
    "individuals": "ɪndɪvɪdʒuːəlz",
    "indivisible": "ɪndɪvɪzəbəl",
    "indoctrinated": "ɪndɒktrɪneɪtɪd",
    "indoctrinate": "ɪndɒktrɪneɪt",
    "indoctrinating": "ɪndɒktrɪneɪtɪŋ",
    "indoctrination": "ɪndɒktrɪneɪʃən",
    "indolence": "ɪndələns",
    "indolent": "ɪndələnt",
    "indomitability": "ɪndɒmɪtəbɪlɪti",
    "indomitable": "ɪndɒmɪtəbəl",
    "indoor": "ɪndɔː",
    "indoors": "ɪndɔːz",
    "indubitable": "ɪndjuːbɪtəbəl",
    "indubitably": "ɪndjuːbɪtəbli",
    "induced": "ɪndjuːst",
    "inducement": "ɪndjuːsmənt",
    "inducements": "ɪndjuːsmənts",
    "induce": "ɪndjuːs",
    "induces": "ɪndjuːsɪz",
    "inducing": "ɪndjuːsɪŋ",
    "inductance": "ɪndʌktəns",
    "inducted": "ɪndʌktɪd",
    "inductees": "ɪndʌktiːz",
    "inducting": "ɪndʌktɪŋ",
    "induction": "ɪndʌkʃən",
    "inductions": "ɪndʌkʃənz",
    "inductive": "ɪndʌktɪv",
    "induct": "ɪndʌkt",
    "inductor": "ɪndʌktɐ",
    "indulged": "ɪndʌldʒd",
    "indulgence": "ɪndʌldʒəns",
    "indulgences": "ɪndʌldʒənsɪz",
    "indulge": "ɪndʌldʒ",
    "indulgently": "ɪndʌldʒəntli",
    "indulgent": "ɪndʌldʒənt",
    "indulges": "ɪndʌldʒɪz",
    "indulging": "ɪndʌldʒɪŋ",
    "industrialisation": "ɪndʌstrɪəlaɪzeɪʃən",
    "industrialised": "ɪndʌstrɪəlaɪzd",
    "industrialise": "ɪndʌstrɪəlaɪz",
    "industrialising": "ɪndʌstrɪəlaɪzɪŋ",
    "industrialism": "ɪndʌstrɪəlɪzəm",
    "industrialist": "ɪndʌstrɪəlɪst",
    "industrialists": "ɪndʌstrɪəlɪsts",
    "industrially": "ɪndʌstrɪəli",
    "industrial": "ɪndʌstrɪəl",
    "industrials": "ɪndʌstrɪəlz",
    "industries": "ɪndʌstrɪz",
    "industriously": "ɪndʌstrɪəsli",
    "industrious": "ɪndʌstrɪəs",
    "industry": "ɪndʌstri",
    "inebriated": "ɪniːbrɪeɪtɪd",
    "inebriation": "ɪniːbrɪeɪʃən",
    "inedible": "ɪnɛdəbəl",
    "ineffable": "ɪnɛfəbəl",
    "ineffectively": "ɪnɪfɛktɪvli",
    "ineffectiveness": "ɪnɪfɛktɪvnəs",
    "ineffective": "ɪnɪfɛktɪv",
    "ineffectually": "ɪnɪfɛktʃuːəli",
    "ineffectual": "ɪnɪfɛktʃuːəl",
    "inefficiencies": "ɪnɪfɪʃənsɪz",
    "inefficiency": "ɪnɪfɪʃənsi",
    "inefficiently": "ɪnɪfɪʃəntli",
    "inefficient": "ɪnɪfɪʃənt",
    "inelastic": "ɪnɪlɑːstɪk",
    "inelegantly": "ɪnɛlɪɡəntli",
    "inelegant": "ɪnɛlɪɡənt",
    "ineligible": "ɪnɛlɪdʒəbəl",
    "ineluctably": "ɪnɪlʌktəbli",
    "ineptitude": "ɪnɛptɪtjuːd",
    "ineptly": "ɪnɛptli",
    "inept": "ɪnɛpt",
    "ineptness": "ɪnɛptnəs",
    "inequalities": "ɪniːkwɒlɪtiz",
    "inequality": "ɪniːkwɒlɪti",
    "inequitable": "ɪnɛkwɪtəbəl",
    "inequities": "ɪnɛkwɪtiz",
    "inequity": "ɪnɛkwɪti",
    "inerrant": "ɪnɛrənt",
    "inertial": "ɪnɜːʃəl",
    "inertia": "ɪnɜːʃɐ",
    "inert": "ɪnɜːt",
    "inescapable": "ɪnɪskeɪpəbəl",
    "inescapably": "ɪnɪskeɪpəbli",
    "inessential": "ɪnɪsɛnʃəl",
    "inestimable": "ɪnɛstɪməbəl",
    "inestimably": "ɪnɛstɪməbli",
    "inevitability": "ɪnɛvɪtəbɪlɪti",
    "inevitable": "ɪnɛvɪtəbəl",
    "inevitably": "ɪnɛvɪtəbli",
    "inexactitude": "ɪnɛɡzæktɪtjuːd",
    "inexact": "ɪnɛɡzækt",
    "inexcusable": "ɪnɛkskjuːsəbəl",
    "inexhaustible": "ɪnɛɡzɔːstəbəl",
    "inexorable": "ɪnɛksərəbəl",
    "inexorably": "ɪnɛksərəbli",
    "inexpensively": "ɪnɛkspɛnsɪvli",
    "inexpensive": "ɪnɛkspɛnsɪv",
    "inexperienced": "ɪnɛkspiərɪənst",
    "inexperience": "ɪnɛkspiərɪəns",
    "inexpertly": "ɪnɛkspɜːtli",
    "inexpert": "ɪnɛkspɜːt",
    "inexplicable": "ɪnɛksplɪkəbəl",
    "inexplicably": "ɪnɛksplɪkəbli",
    "inexpressible": "ɪnɛksprɛsəbəl",
    "inexpressibly": "ɪnɛksprɛsəbli",
    "inextinguishable": "ɪnɛkstɪŋɡwɪʃəbəl",
    "inextricable": "ɪnɛkstrɪkəbəl",
    "inextricably": "ɪnɛkstrɪkəbli",
    "infallibility": "ɪnfælɪbɪlɪti",
    "infallible": "ɪnfæləbəl",
    "infallibly": "ɪnfæləbli",
    "infamously": "ɪnfəməsli",
    "infamous": "ɪnfəməs",
    "infamy": "ɪnfəmi",
    "infancy": "ɪnfənsi",
    "infanta": "ɪnfɑːntɐ",
    "infante": "ɪnfɑːnt",
    "infanticide": "ɪnfɑːntɪsaɪd",
    "infantile": "ɪnfəntaɪl",
    "infant": "ɪnfənt",
    "infantryman": "ɪnfəntrɪmən",
    "infantrymen": "ɪnfəntrɪmɛn",
    "infantry": "ɪnfəntri",
    "infants": "ɪnfənts",
    "infarction": "ɪnfɑːkʃən",
    "infarct": "ɪnfɑːkt",
    "infatuated": "ɪnfætʃuːeɪtɪd",
    "infatuation": "ɪnfætʃuːeɪʃən",
    "infatuations": "ɪnfætʃuːeɪʃənz",
    "infected": "ɪnfɛktɪd",
    "infecting": "ɪnfɛktɪŋ",
    "infection": "ɪnfɛkʃən",
    "infections": "ɪnfɛkʃənz",
    "infectiously": "ɪnfɛkʃəsli",
    "infectiousness": "ɪnfɛkʃəsnəs",
    "infectious": "ɪnfɛkʃəs",
    "infective": "ɪnfɛktɪv",
    "infect": "ɪnfɛkt",
    "infects": "ɪnfɛkts",
    "infelicitous": "ɪnfɛlɪsɪtəs",
    "inference": "ɪnfərəns",
    "inferences": "ɪnfərənsɪz",
    "inferiority": "ɪnfiərɪɒrɪti",
    "inferior": "ɪnfiərɪɐ",
    "inferiors": "ɪnfiərɪəz",
    "infernally": "ɪnfɜːnəli",
    "infernal": "ɪnfɜːnəl",
    "infer": "ɪnfɜː",
    "inferno": "ɪnfɜːnəʊ",
    "infernos": "ɪnfɜːnəʊz",
    "inferred": "ɪnfɜːd",
    "inferring": "ɪnfɜːrɪŋ",
    "infers": "ɪnfɜːz",
    "infertile": "ɪnfɜːtaɪl",
    "infertility": "ɪnfɜːtɪlɪti",
    "infestation": "ɪnfɛsteɪʃən",
    "infestations": "ɪnfɛsteɪʃənz",
    "infested": "ɪnfɛstɪd",
    "infesting": "ɪnfɛstɪŋ",
    "infest": "ɪnfɛst",
    "infests": "ɪnfɛsts",
    "infidelities": "ɪnfɪdɛlɪtiz",
    "infidelity": "ɪnfɪdɛlɪti",
    "infidel": "ɪnfɪdəl",
    "infidels": "ɪnfɪdəlz",
    "infield": "ɪnfiːld",
    "infighting": "ɪnfaɪtɪŋ",
    "infilled": "ɪnfɪld",
    "infilling": "ɪnfɪlɪŋ",
    "infill": "ɪnfɪl",
    "infills": "ɪnfɪlz",
    "infiltrated": "ɪnfɪltreɪtɪd",
    "infiltrate": "ɪnfɪltreɪt",
    "infiltrates": "ɪnfɪltreɪts",
    "infiltrating": "ɪnfɪltreɪtɪŋ",
    "infiltration": "ɪnfɪltreɪʃən",
    "infiltrations": "ɪnfɪltreɪʃənz",
    "infiltrator": "ɪnfɪltreɪtɐ",
    "infiltrators": "ɪnfɪltreɪtəz",
    "infinitely": "ɪnfɪnətli",
    "infinite": "ɪnfɪnət",
    "infinitesimally": "ɪnfɪnətɛsɪməli",
    "infinitesimal": "ɪnfɪnətɛsɪməl",
    "infinitesimals": "ɪnfɪnətɛsɪməlz",
    "infinities": "ɪnfɪnɪtiz",
    "infinitive": "ɪnfɪnɪtɪv",
    "infinitives": "ɪnfɪnɪtɪvz",
    "infinity": "ɪnfɪnɪti",
    "infirmaries": "ɪnfɜːməriz",
    "infirmary": "ɪnfɜːməri",
    "infirmities": "ɪnfɜːmɪtiz",
    "infirmity": "ɪnfɜːmɪti",
    "infirm": "ɪnfɜːm",
    "inflamed": "ɪnfleɪmd",
    "inflame": "ɪnfleɪm",
    "inflames": "ɪnfleɪmz",
    "inflaming": "ɪnfleɪmɪŋ",
    "inflammable": "ɪnflæməbəl",
    "inflammation": "ɪnflæmeɪʃən",
    "inflammatory": "ɪnflæmətəri",
    "inflatable": "ɪnfleɪtəbəl",
    "inflatables": "ɪnfleɪtəbəlz",
    "inflated": "ɪnfleɪtɪd",
    "inflate": "ɪnfleɪt",
    "inflates": "ɪnfleɪts",
    "inflating": "ɪnfleɪtɪŋ",
    "inflationary": "ɪnfleɪʃənəri",
    "inflation": "ɪnfleɪʃən",
    "inflator": "ɪnfleɪtɐ",
    "inflected": "ɪnflɛktɪd",
    "inflection": "ɪnflɛkʃən",
    "inflections": "ɪnflɛkʃənz",
    "inflect": "ɪnflɛkt",
    "inflexibility": "ɪnflɛksɪbɪlɪti",
    "inflexible": "ɪnflɛksɪbəl",
    "inflexibly": "ɪnflɛksəbli",
    "inflicted": "ɪnflɪktɪd",
    "inflicting": "ɪnflɪktɪŋ",
    "infliction": "ɪnflɪkʃən",
    "inflict": "ɪnflɪkt",
    "inflicts": "ɪnflɪkts",
    "inflight": "ɪnflaɪt",
    "inflorescence": "ɪnflərɛsəns",
    "inflow": "ɪnfləʊ",
    "inflows": "ɪnfləʊz",
    "influenced": "ɪnfluːənst",
    "influence": "ɪnfluːəns",
    "influences": "ɪnfluːənsɪz",
    "influencing": "ɪnfluːənsɪŋ",
    "influentially": "ɪnfluːɛnʃəli",
    "influential": "ɪnfluːɛnʃəl",
    "influenza": "ɪnfluːɛnzɐ",
    "influxes": "ɪnflʌksɪz",
    "influx": "ɪnflʌks",
    "infomercial": "ɪnfəʊmɜːʃəl",
    "info": "ɪnfəʊ",
    "informality": "ɪnfɔːmælɪti",
    "informally": "ɪnfɔːməli",
    "informal": "ɪnfɔːməl",
    "informant": "ɪnfɔːmənt",
    "informants": "ɪnfɔːmənts",
    "informational": "ɪnfəmeɪʃənəl",
    "information": "ɪnfəmeɪʃən",
    "informative": "ɪnfɔːmətɪv",
    "informed": "ɪnfɔːmd",
    "informer": "ɪnfɔːmɐ",
    "informers": "ɪnfɔːməz",
    "informing": "ɪnfɔːmɪŋ",
    "inform": "ɪnfɔːm",
    "informs": "ɪnfɔːmz",
    "infraction": "ɪnfrækʃən",
    "infractions": "ɪnfrækʃənz",
    "infra": "ɪnfrɐ",
    "infrared": "ɪnfrərɛd",
    "infrastructural": "ɪnfrəstrʌktʃərəl",
    "infrastructure": "ɪnfrəstrʌktʃɐ",
    "infrastructures": "ɪnfrəstrʌktʃəz",
    "infrequently": "ɪnfriːkwəntli",
    "infrequent": "ɪnfriːkwənt",
    "infringed": "ɪnfrɪndʒd",
    "infringement": "ɪnfrɪndʒmənt",
    "infringements": "ɪnfrɪndʒmənts",
    "infringe": "ɪnfrɪndʒ",
    "infringer": "ɪnfrɪndʒɐ",
    "infringes": "ɪnfrɪndʒɪz",
    "infringing": "ɪnfrɪndʒɪŋ",
    "infuriated": "ɪnfjɔːrɪeɪtɪd",
    "infuriate": "ɪnfjɔːrɪeɪt",
    "infuriates": "ɪnfjɔːrɪeɪts",
    "infuriatingly": "ɪnfjɔːrɪeɪtɪŋli",
    "infuriating": "ɪnfjɔːrɪeɪtɪŋ",
    "infused": "ɪnfjuːzd",
    "infuse": "ɪnfjuːz",
    "infuser": "ɪnfjuːsɐ",
    "infusers": "ɪnfjuːsəz",
    "infuses": "ɪnfjuːzɪz",
    "infusing": "ɪnfjuːzɪŋ",
    "infusion": "ɪnfjuːʒən",
    "infusions": "ɪnfjuːʒənz",
    "ingeniously": "ɪndʒiːnɪəsli",
    "ingenious": "ɪndʒiːnɪəs",
    "ingeniousness": "ɪndʒiːnɪəsnəs",
    "ingenuity": "ɪndʒɪnjuːɪti",
    "ingenuous": "ɪndʒɛnjuːəs",
    "ingested": "ɪndʒɛstɪd",
    "ingesting": "ɪndʒɛstɪŋ",
    "ingestion": "ɪndʒɛstʃən",
    "ingest": "ɪndʒɛst",
    "ingests": "ɪndʒɛsts",
    "ingle": "ɪnɡliː",
    "inglenook": "ɪnɡlɛnʊk",
    "inglenooks": "ɪnɡlɛnʊks",
    "inglorious": "ɪnɡlɔːrɪəs",
    "ingoing": "ɪnɡəʊɪŋ",
    "ingot": "ɪŋɡət",
    "ingots": "ɪŋɡəts",
    "ingrained": "ɪnɡreɪnd",
    "ingrain": "ɪnɡreɪn",
    "ingrate": "ɪnɡreɪt",
    "ingrates": "ɪnɡreɪts",
    "ingratiated": "ɪnɡreɪʃɪeɪtɪd",
    "ingratiate": "ɪnɡreɪʃɪeɪt",
    "ingratiates": "ɪnɡreɪʃɪeɪts",
    "ingratiating": "ɪnɡreɪʃɪeɪtɪŋ",
    "ingratitude": "ɪnɡrætɪtjuːd",
    "ingredient": "ɪnɡriːdiənt",
    "ingredients": "ɪnɡriːdiənts",
    "ingress": "ɪnɡrɛs",
    "ingrowing": "ɪŋɡrəʊɪŋ",
    "ingrown": "ɪŋɡrəʊn",
    "inguinal": "ɪnɡɪnəl",
    "inhabitable": "ɪnhæbɪtəbəl",
    "inhabitant": "ɪnhæbɪtənt",
    "inhabitants": "ɪnhæbɪtənts",
    "inhabited": "ɪnhæbɪtɪd",
    "inhabiting": "ɪnhæbɪtɪŋ",
    "inhabit": "ɪnhæbɪt",
    "inhabits": "ɪnhæbɪts",
    "inhalant": "ɪnhælənt",
    "inhalation": "ɪnhɐleɪʃən",
    "inhalations": "ɪnhɐleɪʃənz",
    "inhaled": "ɪnheɪld",
    "inhale": "ɪnheɪl",
    "inhaler": "ɪnheɪlɐ",
    "inhalers": "ɪnheɪləz",
    "inhales": "ɪnheɪlz",
    "inhaling": "ɪnheɪlɪŋ",
    "inhere": "ɪnhiə",
    "inherently": "ɪnhiərəntli",
    "inherent": "ɪnhiərənt",
    "inhering": "ɪnhɜːrɪŋ",
    "inheritance": "ɪnhɛrɪtəns",
    "inheritances": "ɪnhɛrɪtənsɪz",
    "inherited": "ɪnhɛrɪtɪd",
    "inheriting": "ɪnhɛrɪtɪŋ",
    "inherit": "ɪnhɛrɪt",
    "inheritor": "ɪnhɛrɪtɐ",
    "inheritors": "ɪnhɛrɪtəz",
    "inherits": "ɪnhɛrɪts",
    "inhibited": "ɪnhɪbɪtɪd",
    "inhibiting": "ɪnhɪbɪtɪŋ",
    "inhibition": "ɪnhɪbɪʃən",
    "inhibitions": "ɪnhɪbɪʃənz",
    "inhibit": "ɪnhɪbɪt",
    "inhibitor": "ɪnhɪbɪtɐ",
    "inhibitors": "ɪnhɪbɪtəz",
    "inhibitory": "ɪnhɪbɪtəri",
    "inhibits": "ɪnhɪbɪts",
    "inhospitable": "ɪnhɒspɪtəbəl",
    "inhumanely": "ɪnhjuːmeɪnli",
    "inhumane": "ɪnhjuːmeɪn",
    "inhumanity": "ɪnhjuːmænɪti",
    "inhumanly": "ɪnhjuːmənli",
    "inhuman": "ɪnhjuːmən",
    "inimical": "ɪnɪmɪkəl",
    "inimitable": "ɪnɪmɪtəbəl",
    "inion": "ɪnaɪɒn",
    "iniquities": "ɪnɪkwɪtiz",
    "iniquitous": "ɪnɪkwɪtəs",
    "iniquity": "ɪnɪkwɪti",
    "initialised": "ɪnɪʃəlaɪzd",
    "initialise": "ɪnɪʃəlaɪz",
    "initialising": "ɪnɪʃəlaɪzɪŋ",
    "initialled": "ɪnɪʃəld",
    "initialling": "ɪnɪʃəlɪŋ",
    "initially": "ɪnɪʃəli",
    "initial": "ɪnɪʃəl",
    "initials": "ɪnɪʃəlz",
    "initiated": "ɪnɪʃɪeɪtɪd",
    "initiating": "ɪnɪʃɪeɪtɪŋ",
    "initiation": "ɪnɪʃɪeɪʃən",
    "initiations": "ɪnɪʃɪeɪʃənz",
    "initiative": "ɪnɪʃiətɪv",
    "initiatives": "ɪnɪʃiətɪvz",
    "initiator": "ɪnɪʃɪeɪtɐ",
    "initiators": "ɪnɪʃɪeɪtəz",
    "injected": "ɪndʒɛktɪd",
    "injecting": "ɪndʒɛktɪŋ",
    "injection": "ɪndʒɛkʃən",
    "injections": "ɪndʒɛkʃənz",
    "inject": "ɪndʒɛkt",
    "injector": "ɪndʒɛktɐ",
    "injectors": "ɪndʒɛktəz",
    "injects": "ɪndʒɛkts",
    "injudicious": "ɪndʒuːdɪʃəs",
    "injunction": "ɪndʒʌŋkʃən",
    "injunctions": "ɪndʒʌŋkʃənz",
    "injunctive": "ɪndʒʌŋktɪv",
    "injured": "ɪndʒəd",
    "injure": "ɪndʒɐ",
    "injures": "ɪndʒəz",
    "injuries": "ɪndʒərɪz",
    "injuring": "ɪndʒərɪŋ",
    "injurious": "ɪndʒɔːrɪəs",
    "injury": "ɪndʒəri",
    "injustice": "ɪndʒʌstɪs",
    "injustices": "ɪndʒʌstɪsɪz",
    "inkblot": "ɪŋkblɒt",
    "inkblots": "ɪŋkblɒts",
    "inked": "ɪŋkt",
    "inkiness": "ɪŋkinəs",
    "inking": "ɪŋkɪŋ",
    "inkle": "ɪŋkəl",
    "inkles": "ɪŋkəlz",
    "inkling": "ɪŋklɪŋ",
    "inklings": "ɪŋklɪŋz",
    "ink": "ɪŋk",
    "inks": "ɪŋks",
    "inkstand": "ɪŋkstænd",
    "inkstands": "ɪŋkstændz",
    "inkwell": "ɪŋkwɛl",
    "inkwells": "ɪŋkwɛlz",
    "inky": "ɪŋki",
    "inlaid": "ɪnleɪd",
    "inlaying": "ɪnleɪɪŋ",
    "inlet": "ɪnlət",
    "inlets": "ɪnləts",
    "inline": "ɪnlaɪn",
    "inly": "ɪnli",
    "inmate": "ɪnmeɪt",
    "inmates": "ɪnmeɪts",
    "inmost": "ɪnməʊst",
    "in": "ɪn",
    "innards": "ɪnədz",
    "innately": "ɪnneɪtli",
    "innate": "ɪnneɪt",
    "innermost": "ɪnəməʊst",
    "inner": "ɪnɐ",
    "inning": "ɪnɪŋ",
    "innings": "ɪnnɪŋz",
    "innit": "ɪnnɪt",
    "innkeeper": "ɪnkiːpɐ",
    "innkeepers": "ɪnkiːpəz",
    "inn": "ɪn",
    "innocence": "ɪnəsəns",
    "innocently": "ɪnəsəntli",
    "innocent": "ɪnəsənt",
    "innocents": "ɪnəsənts",
    "innocuously": "ɪnnɒkjuːəsli",
    "innocuous": "ɪnnɒkjuːəs",
    "innovated": "ɪnəveɪtɪd",
    "innovate": "ɪnəveɪt",
    "innovating": "ɪnəveɪtɪŋ",
    "innovation": "ɪnəveɪʃən",
    "innovations": "ɪnəveɪʃənz",
    "innovative": "ɪnəveɪtɪv",
    "innovator": "ɪnəveɪtɐ",
    "innovators": "ɪnəveɪtəz",
    "innovatory": "ɪnəvətəri",
    "inns": "ɪnz",
    "innuendoes": "ɪnnjuːɛndəʊz",
    "innuendo": "ɪnnjuːɛndəʊ",
    "innuendos": "ɪnnjuːɛndəʊz",
    "innumerable": "ɪnjuːmərəbəl",
    "innumeracy": "ɪnjuːmərəsi",
    "innumerate": "ɪnjuːməreɪt",
    "inoculated": "ɪnɒkjʊleɪtɪd",
    "inoculate": "ɪnɒkjʊleɪt",
    "inoculating": "ɪnɒkjʊleɪtɪŋ",
    "inoculation": "ɪnɒkjʊleɪʃən",
    "inoculations": "ɪnɒkjʊleɪʃənz",
    "inoculum": "ɪnɒkjʊləm",
    "inoffensive": "ɪnəfɛnsɪv",
    "inoperable": "ɪnɒpərəbəl",
    "inoperative": "ɪnɒpərətɪv",
    "inopportune": "ɪnɒpətjuːn",
    "inordinately": "ɪnɔːdɪnətli",
    "inordinate": "ɪnɔːdɪnət",
    "inorganic": "ɪnɔːɡænɪk",
    "inositol": "ɪnɒsɪtɒl",
    "inpatient": "ɪnpeɪʃənt",
    "inpatients": "ɪnpeɪʃənts",
    "input": "ɪnpʊt",
    "inputs": "ɪnpʊts",
    "inputted": "ɪnpʌtɪd",
    "inputting": "ɪnpʌtɪŋ",
    "inquest": "ɪnkwɛst",
    "inquests": "ɪnkwɛsts",
    "inquired": "ɪnkwaɪəd",
    "inquire": "ɪnkwaɪə",
    "inquirer": "ɪnkwaɪərɐ",
    "inquires": "ɪnkwaɪəz",
    "inquiries": "ɪnkwaɪərɪz",
    "inquiring": "ɪnkwaɪərɪŋ",
    "inquiry": "ɪnkwaɪəri",
    "inquisition": "ɪnkwɪsɪʃən",
    "inquisitions": "ɪnkwɪsɪʃənz",
    "inquisitively": "ɪnkwɪzɪtɪvli",
    "inquisitiveness": "ɪnkwɪzɪtɪvnəs",
    "inquisitive": "ɪnkwɪzɪtɪv",
    "inquisitorial": "ɪnkwɪsɪtɔːrɪəl",
    "inquisitor": "ɪnkwɪsɪtɐ",
    "inquisitors": "ɪnkwɪsɪtəz",
    "inroad": "ɪnrəʊd",
    "inroads": "ɪnrəʊdz",
    "inrush": "ɪnrʌʃ",
    "insalubrious": "ɪnsæluːbrɪəs",
    "insanely": "ɪnseɪnli",
    "insane": "ɪnseɪn",
    "insaner": "ɪnseɪnɐ",
    "insanitary": "ɪnsænɪtəri",
    "insanity": "ɪnsænɪti",
    "insatiable": "ɪnseɪʃɪəbəl",
    "insatiably": "ɪnseɪʃæbli",
    "inscribed": "ɪnskraɪbd",
    "inscribe": "ɪnskraɪb",
    "inscribing": "ɪnskraɪbɪŋ",
    "inscription": "ɪnskrɪpʃən",
    "inscriptions": "ɪnskrɪpʃənz",
    "inscrutable": "ɪnskruːtəbəl",
    "insecticidal": "ɪnsɛktɪsaɪdəl",
    "insecticide": "ɪnsɛktɪsaɪd",
    "insecticides": "ɪnsɛktɪsaɪdz",
    "insectivore": "ɪnsɛktɪvɔː",
    "insectivores": "ɪnsɛktɪvɔːz",
    "insectivorous": "ɪnsɛktɪvərəs",
    "insect": "ɪnsɛkt",
    "insects": "ɪnsɛkts",
    "insecurely": "ɪnsɪkjɔːli",
    "insecure": "ɪnsɪkjɔː",
    "insecurities": "ɪnsɪkjɔːrɪtiz",
    "insecurity": "ɪnsɪkjɔːrɪti",
    "inseminated": "ɪnsɛmɪneɪtɪd",
    "inseminate": "ɪnsɛmɪneɪt",
    "inseminating": "ɪnsɛmɪneɪtɪŋ",
    "insemination": "ɪnsɛmɪneɪʃən",
    "insensate": "ɪnsɛnseɪt",
    "insensibility": "ɪnsɛnsəbɪlɪti",
    "insensible": "ɪnsɛnsəbəl",
    "insensitively": "ɪnsɛnsɪtɪvli",
    "insensitive": "ɪnsɛnsɪtɪv",
    "insensitivity": "ɪnsɛnsɪtɪvɪti",
    "inseparable": "ɪnsɛpərəbəl",
    "inseparably": "ɪnsɛpərəbli",
    "inserted": "ɪnsɜːtɪd",
    "inserting": "ɪnsɜːtɪŋ",
    "insertion": "ɪnsɜːʃən",
    "insertions": "ɪnsɜːʃənz",
    "inshore": "ɪnʃɔː",
    "insider": "ɪnsaɪdɐ",
    "insiders": "ɪnsaɪdəz",
    "insides": "ɪnsaɪdz",
    "insidiously": "ɪnsɪdɪəsli",
    "insidious": "ɪnsɪdɪəs",
    "insightful": "ɪnsaɪtfəl",
    "insight": "ɪnsaɪt",
    "insights": "ɪnsaɪts",
    "insignia": "ɪnsɪɡniɐ",
    "insignias": "ɪnsɪɡniəz",
    "insignificance": "ɪnsɪɡnɪfɪkəns",
    "insignificantly": "ɪnsɪɡnɪfɪkəntli",
    "insignificant": "ɪnsɪɡnɪfɪkənt",
    "insincere": "ɪnsɪnsiə",
    "insincerity": "ɪnsɪnsɛrɪti",
    "insinuated": "ɪnsɪnjuːeɪtɪd",
    "insinuate": "ɪnsɪnjuːeɪt",
    "insinuating": "ɪnsɪnjuːeɪtɪŋ",
    "insinuation": "ɪnsɪnjuːeɪʃən",
    "insinuations": "ɪnsɪnjuːeɪʃənz",
    "insipid": "ɪnsɪpɪd",
    "insisted": "ɪnsɪstɪd",
    "insistence": "ɪnsɪstəns",
    "insistently": "ɪnsɪstəntli",
    "insistent": "ɪnsɪstənt",
    "insisting": "ɪnsɪstɪŋ",
    "insist": "ɪnsɪst",
    "insists": "ɪnsɪsts",
    "ins": "ɪnz",
    "insofar": "ɪnsəfɑː",
    "insolence": "ɪnsələns",
    "insole": "ɪnsəʊl",
    "insolently": "ɪnsələntli",
    "insolent": "ɪnsələnt",
    "insoles": "ɪnsəʊlz",
    "insoluble": "ɪnsɒljuːbəl",
    "insolvencies": "ɪnsɒlvənsiz",
    "insolvency": "ɪnsɒlvənsi",
    "insolvent": "ɪnsɒlvənt",
    "insomniac": "ɪnsɒmnɪæk",
    "insomniacs": "ɪnsɒmnɪæks",
    "insomnia": "ɪnsɒmniɐ",
    "insomuch": "ɪnsəmʌtʃ",
    "insouciance": "ɪnsaʊʃiəns",
    "insouciantly": "ɪnsaʊʃiəntli",
    "insouciant": "ɪnsaʊʃiənt",
    "inspected": "ɪnspɛktɪd",
    "inspecting": "ɪnspɛktɪŋ",
    "inspection": "ɪnspɛkʃən",
    "inspections": "ɪnspɛkʃənz",
    "inspect": "ɪnspɛkt",
    "inspectorate": "ɪnspɛktəreɪt",
    "inspectorates": "ɪnspɛktəreɪts",
    "inspector": "ɪnspɛktɐ",
    "inspectors": "ɪnspɛktəz",
    "inspects": "ɪnspɛkts",
    "inspirational": "ɪnspəreɪʃənəl",
    "inspiration": "ɪnspəreɪʃən",
    "inspirations": "ɪnspəreɪʃənz",
    "inspired": "ɪnspaɪəd",
    "inspire": "ɪnspaɪə",
    "inspirer": "ɪnspaɪərɐ",
    "inspires": "ɪnspaɪəz",
    "inspiring": "ɪnspaɪərɪŋ",
    "instabilities": "ɪnstəbɪlɪtiz",
    "instability": "ɪnstəbɪlɪti",
    "instable": "ɪnsteɪbəl",
    "installation": "ɪnstəleɪʃən",
    "installations": "ɪnstəleɪʃənz",
    "installed": "ɪnstɔːld",
    "installer": "ɪnstɔːlɐ",
    "installers": "ɪnstɔːləz",
    "installing": "ɪnstɔːlɪŋ",
    "installment": "ɪnstɔːlmənt",
    "installments": "ɪnstɔːlmənts",
    "install": "ɪnstɔːl",
    "installs": "ɪnstɔːlz",
    "instalment": "ɪnstɔːlmənt",
    "instalments": "ɪnstɔːlmənts",
    "instal": "ɪnstɔːl",
    "instanced": "ɪnstənst",
    "instance": "ɪnstəns",
    "instances": "ɪnstənsɪz",
    "instantaneously": "ɪnstɑːnteɪniəsli",
    "instantaneous": "ɪnstɑːnteɪniəs",
    "instantly": "ɪnstəntli",
    "instant": "ɪnstənt",
    "instants": "ɪnstənts",
    "instated": "ɪnsteɪtɪd",
    "instate": "ɪnsteɪt",
    "instead": "ɪnstɛd",
    "instep": "ɪnstɛp",
    "insteps": "ɪnstɛps",
    "instigated": "ɪnstɪɡeɪtɪd",
    "instigate": "ɪnstɪɡeɪt",
    "instigates": "ɪnstɪɡeɪts",
    "instigating": "ɪnstɪɡeɪtɪŋ",
    "instigation": "ɪnstɪɡeɪʃən",
    "instigator": "ɪnstɪɡeɪtɐ",
    "instigators": "ɪnstɪɡeɪtəz",
    "instillation": "ɪnstɪleɪʃən",
    "instilled": "ɪnstɪld",
    "instilling": "ɪnstɪlɪŋ",
    "instill": "ɪnstɪl",
    "instil": "ɪnstɪl",
    "instils": "ɪnstɪlz",
    "instinctively": "ɪnstɪŋktɪvli",
    "instinctive": "ɪnstɪŋktɪv",
    "instincts": "ɪnstɪŋkts",
    "instinctual": "ɪnstɪŋktʃuːəl",
    "instituted": "ɪnstɪtjuːtɪd",
    "institute": "ɪnstɪtjuːt",
    "institutes": "ɪnstɪtjuːts",
    "instituting": "ɪnstɪtjuːtɪŋ",
    "institutionalisation": "ɪnstɪtjuːʃənəlaɪzeɪʃən",
    "institutionalised": "ɪnstɪtjuːʃənəlaɪzd",
    "institutionalise": "ɪnstɪtjuːʃənəlaɪz",
    "institutionalising": "ɪnstɪtjuːʃənəlaɪzɪŋ",
    "institutionally": "ɪnstɪtjuːʃənəli",
    "institutional": "ɪnstɪtjuːʃənəl",
    "institution": "ɪnstɪtjuːʃən",
    "institutions": "ɪnstɪtjuːʃənz",
    "instructed": "ɪnstrʌktɪd",
    "instructing": "ɪnstrʌktɪŋ",
    "instructional": "ɪnstrʌkʃənəl",
    "instruction": "ɪnstrʌkʃən",
    "instructions": "ɪnstrʌkʃənz",
    "instructive": "ɪnstrʌktɪv",
    "instruct": "ɪnstrʌkt",
    "instructor": "ɪnstrʌktɐ",
    "instructors": "ɪnstrʌktəz",
    "instructs": "ɪnstrʌkts",
    "instrumentalist": "ɪnstrəmɛntəlɪst",
    "instrumentalists": "ɪnstrəmɛntəlɪsts",
    "instrumentally": "ɪnstrəmɛntəli",
    "instrumental": "ɪnstrəmɛntəl",
    "instrumentals": "ɪnstrəmɛntəlz",
    "instrumentation": "ɪnstrəmənteɪʃən",
    "instrumented": "ɪnstrəməntɪd",
    "instrumenting": "ɪnstrəməntɪŋ",
    "instrument": "ɪnstrəmənt",
    "instruments": "ɪnstrəmənts",
    "insubordinate": "ɪnsəbɔːdɪnət",
    "insubordination": "ɪnsəbɔːdɪneɪʃən",
    "insubstantial": "ɪnsəbstɑːnʃəl",
    "insufferable": "ɪnsʌfərəbəl",
    "insufferably": "ɪnsʌfərəbli",
    "insufficiency": "ɪnsəfɪʃənsi",
    "insufficiently": "ɪnsəfɪʃəntli",
    "insufficient": "ɪnsəfɪʃənt",
    "insula": "ɪnsjʊlɐ",
    "insularity": "ɪnsjʊlærɪti",
    "insular": "ɪnsjʊlɐ",
    "insulated": "ɪnsjʊleɪtɪd",
    "insulate": "ɪnsjʊleɪt",
    "insulates": "ɪnsjʊleɪts",
    "insulating": "ɪnsjʊleɪtɪŋ",
    "insulation": "ɪnsuːleɪʃən",
    "insulator": "ɪnsuːleɪtɐ",
    "insulators": "ɪnsuːleɪtəz",
    "insulin": "ɪnsuːlɪn",
    "insulted": "ɪnsʌltɪd",
    "insultingly": "ɪnsʌltɪŋli",
    "insulting": "ɪnsʌltɪŋ",
    "insuperable": "ɪnsuːpərəbəl",
    "insupportable": "ɪnsəpɔːtəbəl",
    "insurable": "ɪnʃɔːrəbəl",
    "insurance": "ɪnʃɔːrəns",
    "insurances": "ɪnʃɔːrənsɪz",
    "insured": "ɪnʃɔːd",
    "insureds": "ɪnʃɔːdz",
    "insure": "ɪnʃɔː",
    "insurer": "ɪnʃɔːrɐ",
    "insurers": "ɪnʃɔːrəz",
    "insures": "ɪnʃɔːz",
    "insurgence": "ɪnsɜːdʒəns",
    "insurgencies": "ɪnsɜːdʒənsiz",
    "insurgency": "ɪnsɜːdʒənsi",
    "insurgent": "ɪnsɜːdʒənt",
    "insurgents": "ɪnsɜːdʒənts",
    "insuring": "ɪnʃɔːrɪŋ",
    "insurmountable": "ɪnsəmaʊntəbəl",
    "insurrectionist": "ɪnsərɛkʃənɪst",
    "insurrection": "ɪnsərɛkʃən",
    "intact": "ɪntækt",
    "intaglio": "ɪntæɡlɪəʊ",
    "intake": "ɪnteɪk",
    "intakes": "ɪnteɪks",
    "intangible": "ɪntændʒəbəl",
    "intangibles": "ɪntændʒəbəlz",
    "integer": "ɪntɪdʒɐ",
    "integers": "ɪntɪdʒəz",
    "integrally": "ɪntɪɡrəli",
    "integrals": "ɪntɪɡrəlz",
    "integrated": "ɪntɪɡreɪtɪd",
    "integrate": "ɪntɪɡreɪt",
    "integrates": "ɪntɪɡreɪts",
    "integrating": "ɪntɪɡreɪtɪŋ",
    "integrationist": "ɪntɪɡreɪʃənɪst",
    "integration": "ɪntɪɡreɪʃən",
    "integrator": "ɪntɪɡreɪtɐ",
    "integrity": "ɪntɛɡrɪti",
    "intellect": "ɪntəlɛkt",
    "intellects": "ɪntəlɛkts",
    "intellectualised": "ɪntəlɛktʃuːəlaɪzd",
    "intellectualise": "ɪntəlɛktʃuːəlaɪz",
    "intellectualising": "ɪntəlɛktʃuːəlaɪzɪŋ",
    "intellectualism": "ɪntəlɛktʃuːəlɪzəm",
    "intellectually": "ɪntəlɛktʃuːəli",
    "intellectual": "ɪntəlɛktʃuːəl",
    "intellectuals": "ɪntəlɛktʃuːəlz",
    "intelligence": "ɪntɛlɪdʒəns",
    "intelligences": "ɪntɛlɪdʒənsɪz",
    "intelligently": "ɪntɛlɪdʒəntli",
    "intelligent": "ɪntɛlɪdʒənt",
    "intelligentsia": "ɪntɛlɪdʒɛntsiə",
    "intelligibility": "ɪntɛlɪdʒəbɪlɪti",
    "intelligible": "ɪntɛlɪdʒəbəl",
    "intemperance": "ɪntɛmpərəns",
    "intemperate": "ɪntɛmpərət",
    "intendant": "ɪntɛndənt",
    "intended": "ɪntɛndɪd",
    "intending": "ɪntɛndɪŋ",
    "intend": "ɪntɛnd",
    "intends": "ɪntɛndz",
    "intensely": "ɪntɛnsli",
    "intense": "ɪntɛns",
    "intensification": "ɪntɛnsɪfɪkeɪʃən",
    "intensified": "ɪntɛnsɪfaɪd",
    "intensifier": "ɪntɛnsɪfaɪə",
    "intensifies": "ɪntɛnsɪfaɪz",
    "intensifying": "ɪntɛnsɪfaɪɪŋ",
    "intensify": "ɪntɛnsɪfaɪ",
    "intensities": "ɪntɛnsɪtiz",
    "intensity": "ɪntɛnsɪti",
    "intensively": "ɪntɛnsɪvli",
    "intensive": "ɪntɛnsɪv",
    "intentionality": "ɪntɛnʃənælɪti",
    "intentionally": "ɪntɛnʃənəli",
    "intentional": "ɪntɛnʃənəl",
    "intentioned": "ɪntɛnʃənd",
    "intention": "ɪntɛnʃən",
    "intentions": "ɪntɛnʃənz",
    "intently": "ɪntɛntli",
    "intent": "ɪntɛnt",
    "intents": "ɪntɛnts",
    "interacted": "ɪntəræktɪd",
    "interacting": "ɪntəræktɪŋ",
    "interaction": "ɪntərækʃən",
    "interactions": "ɪntərækʃənz",
    "interactively": "ɪntəræktɪvli",
    "interactive": "ɪntəræktɪv",
    "interactivity": "ɪntəræktɪvɪti",
    "interact": "ɪntərækt",
    "interacts": "ɪntərækts",
    "interbank": "ɪntəbæŋk",
    "interbred": "ɪntəbrɛd",
    "interbreeding": "ɪntəbriːdɪŋ",
    "interbreed": "ɪntəbriːd",
    "intercede": "ɪntəsiːd",
    "intercedes": "ɪntəsiːdz",
    "interceding": "ɪntəsiːdɪŋ",
    "intercepted": "ɪntəsɛptɪd",
    "intercepting": "ɪntəsɛptɪŋ",
    "interception": "ɪntəsɛpʃən",
    "interceptions": "ɪntəsɛpʃənz",
    "interceptor": "ɪntəsɛptɐ",
    "interceptors": "ɪntəsɛptəz",
    "intercepts": "ɪntəsɛpts",
    "intercession": "ɪntəsɛʃən",
    "interchangeable": "ɪntətʃeɪndʒəbəl",
    "interchangeably": "ɪntətʃeɪndʒəbli",
    "interchanged": "ɪntətʃeɪndʒd",
    "interchanging": "ɪntətʃeɪndʒɪŋ",
    "intercity": "ɪntəsɪti",
    "intercom": "ɪntəkɒm",
    "intercoms": "ɪntəkɒmz",
    "interconnectedness": "ɪntəkənɛktɪdnəs",
    "interconnected": "ɪntəkənɛktɪd",
    "interconnecting": "ɪntəkənɛktɪŋ",
    "interconnection": "ɪntəkənɛkʃən",
    "interconnections": "ɪntəkənɛkʃənz",
    "interconnect": "ɪntəkənɛkt",
    "interconnects": "ɪntəkənɛkts",
    "intercontinental": "ɪntəkɒntɪnɛntəl",
    "intercostal": "ɪntəkɒstəl",
    "intercourse": "ɪntəkɔːs",
    "intercultural": "ɪntəkʌltʃərəl",
    "intercut": "ɪntəkʌt",
    "interdepartmental": "ɪntədɪpɑːtmɛntəl",
    "interdependence": "ɪntədɪpɛndəns",
    "interdependency": "ɪntədɪpɛndənsi",
    "interdependent": "ɪntədɪpɛndənt",
    "interdiction": "ɪntədɪkʃən",
    "interested": "ɪntrəstɪd",
    "interestingly": "ɪntrəstɪŋli",
    "interesting": "ɪntrəstɪŋ",
    "interest": "ɪntrəst",
    "interests": "ɪntrəsts",
    "interface": "ɪntəfeɪs",
    "interfaces": "ɪntəfeɪsɪz",
    "interfacing": "ɪntəfeɪsɪŋ",
    "interfaith": "ɪntəfeɪθ",
    "interfered": "ɪntəfiəd",
    "interference": "ɪntəfiərəns",
    "interferences": "ɪntəfiərənsɪz",
    "interfere": "ɪntəfiə",
    "interferes": "ɪntəfiəz",
    "interfering": "ɪntəfiərɪŋ",
    "interferometer": "ɪntəfiərɒmɪtɐ",
    "intergalactic": "ɪntəɡɐlæktɪk",
    "interglacial": "ɪntəɡleɪʃəl",
    "intergovernmental": "ɪntəɡʌvənmɛntəl",
    "interim": "ɪntərɪm",
    "interior": "ɪntiərɪɐ",
    "interiors": "ɪntiərɪəz",
    "interjected": "ɪntədʒɛktɪd",
    "interjecting": "ɪntədʒɛktɪŋ",
    "interjection": "ɪntədʒɛkʃən",
    "interjections": "ɪntədʒɛkʃənz",
    "interject": "ɪntədʒɛkt",
    "interlaced": "ɪntəleɪst",
    "interlace": "ɪntəleɪs",
    "interlacing": "ɪntəleɪsɪŋ",
    "interleaved": "ɪntəliːvd",
    "interleave": "ɪntəliːv",
    "interleaving": "ɪntəliːvɪŋ",
    "interlinked": "ɪntəlɪŋkt",
    "interlinking": "ɪntəlɪŋkɪŋ",
    "interlink": "ɪntəlɪŋk",
    "interlinks": "ɪntəlɪŋks",
    "interlocked": "ɪntəlɒkt",
    "interlocking": "ɪntəlɒkɪŋ",
    "interlock": "ɪntəlɒk",
    "interlocks": "ɪntəlɒks",
    "interlocutor": "ɪntələʊkjuːtɐ",
    "interlocutors": "ɪntələʊkjuːtəz",
    "interlope": "ɪntələʊp",
    "interloper": "ɪntələʊpɐ",
    "interlopers": "ɪntələʊpəz",
    "interlude": "ɪntəluːd",
    "interludes": "ɪntəluːdz",
    "intermarriage": "ɪntəmærɪdʒ",
    "intermarried": "ɪntəmærɪd",
    "intermarrying": "ɪntəmærɪɪŋ",
    "intermarry": "ɪntəmæri",
    "intermediaries": "ɪntəmiːdiːərɪz",
    "intermediary": "ɪntəmiːdiːəri",
    "intermediates": "ɪntəmiːdiəts",
    "interment": "ɪntɜːmənt",
    "intermezzo": "ɪntəmɛzəʊ",
    "interminable": "ɪntɜːmɪnəbəl",
    "interminably": "ɪntɜːmɪnəbli",
    "intermingled": "ɪntɜːmɪŋɡəld",
    "intermingle": "ɪntɜːmɪŋɡəl",
    "intermingling": "ɪntɜːmɪŋɡəlɪŋ",
    "intermission": "ɪntəmɪʃən",
    "intermissions": "ɪntəmɪʃənz",
    "intermit": "ɪntəmɪt",
    "intermittency": "ɪntəmɪtənsi",
    "intermittently": "ɪntəmɪtəntli",
    "intermittent": "ɪntəmɪtənt",
    "intermixing": "ɪntəmɪksɪŋ",
    "internalised": "ɪntɜːnəlaɪzd",
    "internalise": "ɪntɜːnəlaɪz",
    "internalising": "ɪntɜːnəlaɪzɪŋ",
    "internally": "ɪntɜːnəli",
    "internal": "ɪntɜːnəl",
    "internals": "ɪntɜːnəlz",
    "internationalisation": "ɪntənæʃənəlaɪzeɪʃən",
    "internationalised": "ɪntənæʃənəlaɪzd",
    "internationalise": "ɪntənæʃənəlaɪz",
    "internationalising": "ɪntənæʃənəlaɪzɪŋ",
    "internationalism": "ɪntənæʃənəlɪzəm",
    "internationalist": "ɪntənæʃənəlɪst",
    "internationalists": "ɪntənæʃənəlɪsts",
    "internationally": "ɪntənæʃənəli",
    "international": "ɪntənæʃənəl",
    "internationals": "ɪntənæʃənəlz",
    "internecine": "ɪntənɛsiːn",
    "interned": "ɪntɜːnd",
    "internee": "ɪntɜːniː",
    "internees": "ɪntɜːniːz",
    "interne": "ɪntəniː",
    "internet": "ɪntənɛt",
    "interning": "ɪntɜːnɪŋ",
    "internment": "ɪntɜːnmənt",
    "internship": "ɪntɜːnʃɪp",
    "internships": "ɪntɜːnʃɪps",
    "interoperability": "ɪntərɒpərəbɪlɪti",
    "interpersonal": "ɪntəpɜːsənəl",
    "interplanetary": "ɪntəplænɪtəri",
    "interplay": "ɪntəpleɪ",
    "interpolate": "ɪntɜːpəleɪt",
    "interposed": "ɪntəpəʊzd",
    "interpose": "ɪntəpəʊz",
    "interposition": "ɪntəpəzɪʃən",
    "interpretation": "ɪntɜːprɪteɪʃən",
    "interpretations": "ɪntɜːprɪteɪʃənz",
    "interpretative": "ɪntɜːprɪtətɪv",
    "interpreted": "ɪntɜːprɪtɪd",
    "interpreter": "ɪntɜːprɪtɐ",
    "interpreters": "ɪntɜːprɪtəz",
    "interpreting": "ɪntɜːprɪtɪŋ",
    "interpretive": "ɪntɜːprɪtɪv",
    "interpret": "ɪntɜːprɪt",
    "interprets": "ɪntɜːprɪts",
    "interracial": "ɪntəreɪʃəl",
    "interred": "ɪntɜːd",
    "interregnum": "ɪntərɪɡnʌm",
    "interrelated": "ɪntərɪleɪtɪd",
    "interrelate": "ɪntərɪleɪt",
    "interrelationship": "ɪntərɪleɪʃənʃɪp",
    "interrelationships": "ɪntərɪleɪʃənʃɪps",
    "interrogated": "ɪntɛrəɡeɪtɪd",
    "interrogate": "ɪntɛrəɡeɪt",
    "interrogates": "ɪntɛrəɡeɪts",
    "interrogating": "ɪntɛrəɡeɪtɪŋ",
    "interrogation": "ɪntɛrəɡeɪʃən",
    "interrogations": "ɪntɛrəɡeɪʃənz",
    "interrogative": "ɪntɛrəɡətɪv",
    "interrogator": "ɪntɛrəɡeɪtɐ",
    "interrogators": "ɪntɛrəɡeɪtəz",
    "interrogatory": "ɪntɪrɒɡətəri",
    "interrupted": "ɪntərʌptɪd",
    "interrupter": "ɪntərʌptɐ",
    "interrupting": "ɪntərʌptɪŋ",
    "interruption": "ɪntərʌpʃən",
    "interruptions": "ɪntərʌpʃənz",
    "interrupt": "ɪntərʌpt",
    "interrupts": "ɪntərʌpts",
    "intersected": "ɪntəsɛktɪd",
    "intersecting": "ɪntəsɛktɪŋ",
    "intersection": "ɪntəsɛkʃən",
    "intersections": "ɪntəsɛkʃənz",
    "intersect": "ɪntəsɛkt",
    "intersects": "ɪntəsɛkts",
    "intersession": "ɪntəsɛʃən",
    "interspersed": "ɪntəspɜːsd",
    "interspersing": "ɪntəspɜːsɪŋ",
    "interstate": "ɪntəsteɪt",
    "interstates": "ɪntəsteɪts",
    "interstellar": "ɪntəstɛlɐ",
    "interstices": "ɪntɜːstɪsɪz",
    "interstitial": "ɪntəstɪʃəl",
    "intertidal": "ɪntətaɪdəl",
    "intertwined": "ɪntətwaɪnd",
    "intertwine": "ɪntətwaɪn",
    "intertwines": "ɪntətwaɪnz",
    "intertwining": "ɪntətwaɪnɪŋ",
    "interval": "ɪntəvəl",
    "intervals": "ɪntəvəlz",
    "intervened": "ɪntəviːnd",
    "intervene": "ɪntəviːn",
    "intervenes": "ɪntəviːnz",
    "intervening": "ɪntəviːnɪŋ",
    "interventionism": "ɪntəvɛnʃənɪzəm",
    "interventionist": "ɪntəvɛnʃənɪst",
    "interventionists": "ɪntəvɛnʃənɪsts",
    "intervention": "ɪntəvɛnʃən",
    "interventions": "ɪntəvɛnʃənz",
    "interviewed": "ɪntəvjuːd",
    "interviewee": "ɪntəvjuːiː",
    "interviewees": "ɪntəvjuːiːz",
    "interviewer": "ɪntəvjuːɐ",
    "interviewers": "ɪntəvjuːəz",
    "interviewing": "ɪntəvjuːɪŋ",
    "interview": "ɪntəvjuː",
    "interviews": "ɪntəvjuːz",
    "interwar": "ɪntəwɔː",
    "interweaved": "ɪntəwiːvd",
    "interweave": "ɪntəwiːv",
    "interweaves": "ɪntəwiːvz",
    "interweaving": "ɪntəwiːvɪŋ",
    "interwoven": "ɪntəwəʊvən",
    "intestacy": "ɪntɛstəsi",
    "intestate": "ɪntɪsteɪt",
    "intestinal": "ɪntɛstɪnəl",
    "intestine": "ɪntɛstɪn",
    "intestines": "ɪntɛstɪnz",
    "intifada": "ɪntɪfɑːdɐ",
    "intimacies": "ɪntɪməsɪz",
    "intimacy": "ɪntɪməsi",
    "intimated": "ɪntɪmeɪtɪd",
    "intimately": "ɪntɪmətli",
    "intimating": "ɪntɪmeɪtɪŋ",
    "intimation": "ɪntɪmeɪʃən",
    "intimations": "ɪntɪmeɪʃənz",
    "intimidated": "ɪntɪmɪdeɪtɪd",
    "intimidate": "ɪntɪmɪdeɪt",
    "intimidates": "ɪntɪmɪdeɪts",
    "intimidatingly": "ɪntɪmɪdeɪtɪŋli",
    "intimidating": "ɪntɪmɪdeɪtɪŋ",
    "intimidation": "ɪntɪmɪdeɪʃən",
    "intimidatory": "ɪntɪmɪdətəri",
    "inti": "ɪntaɪ",
    "intolerable": "ɪntɒlərəbəl",
    "intolerably": "ɪntɒlərəbli",
    "intolerance": "ɪntɒlərəns",
    "intolerant": "ɪntɒlərənt",
    "intonation": "ɪntəneɪʃən",
    "intonations": "ɪntəneɪʃənz",
    "intoned": "ɪntəʊnd",
    "intone": "ɪntəʊn",
    "intones": "ɪntəʊnz",
    "into": "ɪntʊ",
    "intoxicant": "ɪntɒksɪkənt",
    "intoxicants": "ɪntɒksɪkənts",
    "intoxicated": "ɪntɒksɪkeɪtɪd",
    "intoxicate": "ɪntɒksɪkeɪt",
    "intoxicates": "ɪntɒksɪkeɪts",
    "intoxicating": "ɪntɒksɪkeɪtɪŋ",
    "intoxication": "ɪntɒksɪkeɪʃən",
    "intracardiac": "ɪntrəkɑːdɪæk",
    "intracranial": "ɪntrəkreɪnɪəl",
    "intractable": "ɪntræktəbəl",
    "intramural": "ɪntrəmjʊrəl",
    "intramuscular": "ɪntrəmʌskjʊlɐ",
    "intranet": "ɪntrənɛt",
    "intransigence": "ɪntrænsɪdʒəns",
    "intransigent": "ɪntrænsɪdʒənt",
    "intransitive": "ɪntrænsɪtɪv",
    "intraocular": "ɪntrərɒkjʊlɐ",
    "intrauterine": "ɪntrəjuːtəriːn",
    "intravenously": "ɪntrəvənəsli",
    "intravenous": "ɪntrəvənəs",
    "intrepidly": "ɪntrɛpɪdli",
    "intrepid": "ɪntrɛpɪd",
    "intricacies": "ɪntrɪkəsɪz",
    "intricacy": "ɪntrɪkəsi",
    "intricately": "ɪntrɪkətli",
    "intricate": "ɪntrɪkət",
    "intrigued": "ɪntriːɡd",
    "intriguer": "ɪntriːɡɐ",
    "intriguers": "ɪntriːɡəz",
    "intrigues": "ɪntriːɡz",
    "intriguingly": "ɪntriːɡɪŋli",
    "intriguing": "ɪntriːɡɪŋ",
    "intrinsically": "ɪntrɪnzɪkli",
    "intrinsic": "ɪntrɪnzɪk",
    "introduced": "ɪntrədjuːst",
    "introduce": "ɪntrədjuːs",
    "introduces": "ɪntrədjuːsɪz",
    "introducing": "ɪntrədjuːsɪŋ",
    "introduction": "ɪntrədʌkʃən",
    "introductions": "ɪntrədʌkʃənz",
    "introductory": "ɪntrədʌktəri",
    "intros": "ɪntrəʊz",
    "introspection": "ɪntrəspɛkʃən",
    "introspective": "ɪntrəspɛktɪv",
    "introversion": "ɪntrəvɜːʃən",
    "introverted": "ɪntrəvɜːtɪd",
    "intruded": "ɪntruːdɪd",
    "intrude": "ɪntruːd",
    "intruder": "ɪntruːdɐ",
    "intruders": "ɪntruːdəz",
    "intrudes": "ɪntruːdz",
    "intruding": "ɪntruːdɪŋ",
    "intrusion": "ɪntruːʒən",
    "intrusions": "ɪntruːʒənz",
    "intrusively": "ɪntruːsɪvli",
    "intrusive": "ɪntruːsɪv",
    "intubate": "ɪntjuːbeɪt",
    "intuited": "ɪntjuːɪtɪd",
    "intuition": "ɪntjuːɪʃən",
    "intuitions": "ɪntjuːɪʃənz",
    "intuitively": "ɪntjuːɪtɪvli",
    "intuitive": "ɪntjuːɪtɪv",
    "intuit": "ɪntjuːɪt",
    "intumescent": "ɪntjuːmɛsənt",
    "intussusception": "ɪntʌsəskɛpʃən",
    "inundated": "ɪnəndeɪtɪd",
    "inundate": "ɪnəndeɪt",
    "inundates": "ɪnəndeɪts",
    "inundating": "ɪnəndeɪtɪŋ",
    "inundation": "ɪnəndeɪʃən",
    "inured": "ɪnjɔːd",
    "inure": "ɪnjɔː",
    "invaded": "ɪnveɪdɪd",
    "invade": "ɪnveɪd",
    "invader": "ɪnveɪdɐ",
    "invaders": "ɪnveɪdəz",
    "invades": "ɪnveɪdz",
    "invading": "ɪnveɪdɪŋ",
    "invaginations": "ɪnvædʒɪneɪʃənz",
    "invalidated": "ɪnvælɪdeɪtɪd",
    "invalidate": "ɪnvælɪdeɪt",
    "invalidates": "ɪnvælɪdeɪts",
    "invalidating": "ɪnvælɪdeɪtɪŋ",
    "invalided": "ɪnvælaɪdɪd",
    "invalidity": "ɪnvælɪdɪti",
    "invalids": "ɪnvælɪdz",
    "invaluable": "ɪnvæljuːəbəl",
    "invariable": "ɪnveərɪəbəl",
    "invariably": "ɪnveərɪəbli",
    "invariant": "ɪnveəriənt",
    "invasion": "ɪnveɪʒən",
    "invasions": "ɪnveɪʒənz",
    "invasive": "ɪnveɪsɪv",
    "invective": "ɪnvɛktɪv",
    "inveigled": "ɪnveɪɡəld",
    "inveigle": "ɪnveɪɡəl",
    "inveigling": "ɪnveɪɡlɪŋ",
    "invented": "ɪnvɛntɪd",
    "inventing": "ɪnvɛntɪŋ",
    "invention": "ɪnvɛnʃən",
    "inventions": "ɪnvɛnʃənz",
    "inventively": "ɪnvɛntɪvli",
    "inventiveness": "ɪnvɛntɪvnəs",
    "inventive": "ɪnvɛntɪv",
    "invent": "ɪnvɛnt",
    "inventoried": "ɪnvəntrid",
    "inventories": "ɪnvəntriz",
    "inventor": "ɪnvɛntɐ",
    "inventors": "ɪnvɛntəz",
    "inventory": "ɪnvəntri",
    "invents": "ɪnvɛnts",
    "inversely": "ɪnvɜːsli",
    "inverses": "ɪnvɜːsɪz",
    "inversion": "ɪnvɜːʃən",
    "inversions": "ɪnvɜːʃənz",
    "invertebrate": "ɪnvɜːtɪbreɪt",
    "invertebrates": "ɪnvɜːtɪbreɪts",
    "inverted": "ɪnvɜːtɪd",
    "inverter": "ɪnvɜːtɐ",
    "inverting": "ɪnvɜːtɪŋ",
    "inverts": "ɪnvɜːts",
    "invested": "ɪnvɛstɪd",
    "investigated": "ɪnvɛstɪɡeɪtɪd",
    "investigate": "ɪnvɛstɪɡeɪt",
    "investigates": "ɪnvɛstɪɡeɪts",
    "investigating": "ɪnvɛstɪɡeɪtɪŋ",
    "investigation": "ɪnvɛstɪɡeɪʃən",
    "investigations": "ɪnvɛstɪɡeɪʃənz",
    "investigative": "ɪnvɛstɪɡətɪv",
    "investigator": "ɪnvɛstɪɡeɪtɐ",
    "investigators": "ɪnvɛstɪɡeɪtəz",
    "investigatory": "ɪnvɛstɪɡətəri",
    "investing": "ɪnvɛstɪŋ",
    "investiture": "ɪnvɛstɪtʃɐ",
    "investitures": "ɪnvɛstɪtʃəz",
    "investment": "ɪnvɛstmənt",
    "investments": "ɪnvɛstmənts",
    "invest": "ɪnvɛst",
    "investor": "ɪnvɛstɐ",
    "investors": "ɪnvɛstəz",
    "invests": "ɪnvɛsts",
    "inveterate": "ɪnvɛtəreɪt",
    "invidious": "ɪnvɪdɪəs",
    "invigilate": "ɪnvɪdʒɪleɪt",
    "invigilating": "ɪnvɪdʒɪleɪtɪŋ",
    "invigilator": "ɪnvɪdʒɪleɪtɐ",
    "invigilators": "ɪnvɪdʒɪleɪtəz",
    "invigorated": "ɪnvɪɡəreɪtɪd",
    "invigorate": "ɪnvɪɡəreɪt",
    "invigorates": "ɪnvɪɡəreɪts",
    "invigorating": "ɪnvɪɡəreɪtɪŋ",
    "invigoration": "ɪnvɪɡəreɪʃən",
    "invincibility": "ɪnvɪnsɪbɪlɪti",
    "invincible": "ɪnvɪnsəbəl",
    "inviolable": "ɪnvaɪələbəl",
    "inviolate": "ɪnvaɪəleɪt",
    "invisibility": "ɪnvɪzəbɪlɪti",
    "invisible": "ɪnvɪzəbəl",
    "invisibly": "ɪnvɪzəbli",
    "invitational": "ɪnvɪteɪʃənəl",
    "invitation": "ɪnvɪteɪʃən",
    "invitations": "ɪnvɪteɪʃənz",
    "invited": "ɪnvaɪtɪd",
    "invitees": "ɪnvaɪtiːz",
    "invitingly": "ɪnvaɪtɪŋli",
    "inviting": "ɪnvaɪtɪŋ",
    "invocation": "ɪnvəʊkeɪʃən",
    "invocations": "ɪnvəʊkeɪʃənz",
    "invoiced": "ɪnvɔɪst",
    "invoice": "ɪnvɔɪs",
    "invoices": "ɪnvɔɪsɪz",
    "invoicing": "ɪnvɔɪsɪŋ",
    "invoked": "ɪnvəʊkt",
    "invoke": "ɪnvəʊk",
    "invokes": "ɪnvəʊks",
    "invoking": "ɪnvəʊkɪŋ",
    "involuntarily": "ɪnvɒləntɛrəli",
    "involuntary": "ɪnvɒləntəri",
    "involved": "ɪnvɒlvd",
    "involvement": "ɪnvɒlvmənt",
    "involvements": "ɪnvɒlvmənts",
    "involve": "ɪnvɒlv",
    "involves": "ɪnvɒlvz",
    "involving": "ɪnvɒlvɪŋ",
    "invulnerability": "ɪnvʌlnərəbɪlɪti",
    "invulnerable": "ɪnvʌlnərəbəl",
    "inwardly": "ɪnwədli",
    "inwardness": "ɪnwədnəs",
    "inward": "ɪnwəd",
    "inwards": "ɪnwədz",
    "iodide": "aɪədaɪd",
    "iodine": "aɪədiːn",
    "ion": "aɪɒn",
    "ionic": "aɪɒnɪk",
    "ionisation": "aɪənaɪzeɪʃən",
    "ionise": "aɪənaɪz",
    "ionised": "aɪənaɪzd",
    "ionising": "aɪənaɪzɪŋ",
    "ionosphere": "aɪənɒsfiə",
    "ions": "aɪɒnz",
    "iota": "aɪəʊtɐ",
    "ipecac": "aɪpkæk",
    "ipomoea": "aɪpəmiə",
    "irascible": "ɪræsəbəl",
    "irate": "aɪreɪt",
    "ire": "aɪə",
    "iridescence": "ɪrɪdɛsəns",
    "iridescent": "ɪrɪdɛsənt",
    "iridium": "ɪrɪdiəm",
    "iris": "aɪrɪs",
    "irises": "aɪrɪsɪz",
    "iritis": "ɪraɪtɪs",
    "irked": "ɜːkt",
    "irk": "ɜːk",
    "irks": "ɜːks",
    "irksome": "ɜːksʌm",
    "iron": "aɪən",
    "ironclad": "aɪəŋklæd",
    "ironclads": "aɪəŋklædz",
    "ironed": "aɪənd",
    "ironer": "aɪənɐ",
    "ironical": "aɪrɒnɪkəl",
    "ironically": "aɪrɒnɪkli",
    "ironic": "aɪrɒnɪk",
    "ironies": "aɪrənɪz",
    "ironing": "aɪənɪŋ",
    "ironmaster": "aɪənmɑːstɐ",
    "ironmonger": "aɪənmʌŋɡɐ",
    "ironmongers": "aɪənmʌŋɡəz",
    "ironmongery": "aɪənməŋɡəri",
    "irons": "aɪənz",
    "ironsides": "aɪənsaɪdz",
    "ironstone": "aɪənstəʊn",
    "ironweed": "aɪənwiːd",
    "ironwood": "aɪənwʊd",
    "ironwork": "aɪənwɜːk",
    "ironworker": "aɪənwɜːkɐ",
    "ironworkers": "aɪənwɜːkəz",
    "ironworks": "aɪənwɜːks",
    "irradiated": "ɪreɪdɪeɪtɪd",
    "irradiate": "ɪreɪdɪeɪt",
    "irrational": "ɪræʃənəl",
    "irrationality": "ɪræʃənælɪti",
    "irrationally": "ɪræʃənəli",
    "irreconcilable": "ɪrɛkənsaɪləbəl",
    "irrecoverable": "ɪrɪkʌvərəbəl",
    "irredeemable": "ɪrɪdiːməbəl",
    "irredeemably": "ɪrɪdiːməbli",
    "irreducible": "ɪrɪdjuːsəbəl",
    "irrefutable": "ɪrɪfjuːtəbəl",
    "irrefutably": "ɪrɪfjuːtəbli",
    "irregular": "ɪrɛɡjuːlɐ",
    "irregularities": "ɪrɛɡjuːlærɪtiz",
    "irregularity": "ɪrɛɡjuːlærɪti",
    "irregularly": "ɪrɛɡjuːləli",
    "irregulars": "ɪrɛɡjuːləz",
    "irrelevance": "ɪrɛlɪvəns",
    "irrelevancy": "ɪrɛlɪvənsi",
    "irrelevant": "ɪrɛlɪvənt",
    "irreligious": "ɪrɪlɪdʒəs",
    "irreparable": "ɪrɛpərəbəl",
    "irreparably": "ɪrɪpɑːrəbli",
    "irreplaceable": "ɪrɪpleɪsəbəl",
    "irrepressible": "ɪrɪprɛsəbəl",
    "irrepressibly": "ɪrɪprɛsəbli",
    "irreproachable": "ɪrɪprəʊtʃəbəl",
    "irresistibility": "ɪrɪsɪstɪbɪlɪti",
    "irresistible": "ɪrɪsɪstəbəl",
    "irresistibly": "ɪrɪsɪstəbli",
    "irresolution": "ɪrɛzəluːʃən",
    "irrespective": "ɪrɪspɛktɪv",
    "irresponsibility": "ɪrɪspɒnsəbɪlɪti",
    "irresponsible": "ɪrɪspɒnsəbəl",
    "irresponsibly": "ɪrɪspɒnsəbli",
    "irretrievable": "ɪrɪtriːvəbəl",
    "irretrievably": "ɪrɪtriːvəbli",
    "irreverence": "ɪrɛvrəns",
    "irreverent": "ɪrɛvrənt",
    "irreverently": "ɪrɛvrəntli",
    "irreversible": "ɪrɪvɜːsəbəl",
    "irreversibly": "ɪrɪvɜːsəbli",
    "irrevocable": "ɪrɪvɒkəbəl",
    "irrevocably": "ɪrɪvɒkəbli",
    "irrigated": "ɪrɪɡeɪtɪd",
    "irrigate": "ɪrɪɡeɪt",
    "irrigating": "ɪrɪɡeɪtɪŋ",
    "irrigation": "ɪrɪɡeɪʃən",
    "irritability": "ɪrɪtəbɪlɪti",
    "irritable": "ɪrɪtəbəl",
    "irritably": "ɪrɪtəbli",
    "irritants": "ɪrɪtənts",
    "irritant": "ɪrɪtənt",
    "irritated": "ɪrɪteɪtɪd",
    "irritates": "ɪrɪteɪts",
    "irritate": "ɪrɪteɪt",
    "irritatingly": "ɪrɪteɪtɪŋli",
    "irritating": "ɪrɪteɪtɪŋ",
    "irritations": "ɪrɪteɪʃənz",
    "irritation": "ɪrɪteɪʃən",
    "ischaemia": "ɪskiːmiə",
    "ischaemic": "ɪskiːmɪk",
    "ischia": "ɪskiɐ",
    "ischium": "ɪstʃiəm",
    "isinglass": "ɪsɪŋɡlɑːs",
    "island": "aɪlənd",
    "islander": "aɪləndɐ",
    "islanders": "aɪləndəz",
    "islands": "aɪləndz",
    "isle": "aɪəl",
    "isles": "aɪəlz",
    "islet": "aɪlət",
    "islets": "aɪləts",
    "isms": "ɪzəmz",
    "ism": "ɪzəm",
    "isobar": "aɪsəbɑː",
    "isobars": "aɪsəbɑːz",
    "isolated": "aɪsəleɪtɪd",
    "isolates": "aɪsəleɪts",
    "isolating": "aɪsəleɪtɪŋ",
    "isolation": "aɪsəleɪʃən",
    "isolationism": "aɪsəleɪʃənɪzəm",
    "isolationist": "aɪsəleɪʃənɪst",
    "isolationists": "aɪsəleɪʃənɪsts",
    "isolator": "aɪsəleɪtɐ",
    "isolators": "aɪsəleɪtəz",
    "isomer": "aɪsəmɐ",
    "isomers": "aɪsəməz",
    "isometric": "aɪsəʊmɛtrɪk",
    "isomorphic": "aɪsəmɔːfɪk",
    "isopod": "aɪsəpɒd",
    "isopods": "aɪsəpɒdz",
    "isopropanol": "aɪsəprəʊpɐnɒl",
    "isopropyl": "aɪsəprəʊpaɪl",
    "isosceles": "aɪsɒsəliːz",
    "isotherm": "aɪsəðɜːm",
    "isotone": "aɪsətəʊn",
    "isotonic": "aɪsətɒnɪk",
    "isotope": "aɪsətəʊp",
    "isotopes": "aɪsətəʊps",
    "isotopic": "aɪsətɒpɪk",
    "issuance": "ɪsjuːəns",
    "issued": "ɪʃuːd",
    "issuers": "ɪʃuːəz",
    "issuer": "ɪʃuːɐ",
    "issues": "ɪʃuːz",
    "issue": "ɪʃuː",
    "issuing": "ɪʃuːɪŋ",
    "isthmian": "ɪsθmiən",
    "isthmuses": "ɪsθmjuːsɪz",
    "isthmus": "ɪsθməs",
    "is": "ɪz",
    "italics": "ɪtælɪks",
    "italic": "ɪtælɪk",
    "itched": "ɪtʃt",
    "itches": "ɪtʃɪz",
    "itchiness": "ɪtʃɪnəs",
    "itching": "ɪtʃɪŋ",
    "itch": "ɪtʃ",
    "itchy": "ɪtʃi",
    "item": "aɪtəm",
    "itemise": "aɪtəmaɪz",
    "itemised": "aɪtəmaɪzd",
    "itemiser": "aɪtəmaɪzɐ",
    "itemises": "aɪtəmaɪzɪz",
    "itemising": "aɪtəmaɪzɪŋ",
    "items": "aɪtəmz",
    "iterated": "ɪtəreɪtɪd",
    "iterate": "ɪtəreɪt",
    "iterating": "ɪtəreɪtɪŋ",
    "iterations": "ɪtəreɪʃənz",
    "iteration": "ɪtəreɪʃən",
    "iterative": "ɪtərətɪv",
    "itinerant": "aɪtɪnərənt",
    "itinerants": "aɪtɪnərənts",
    "itineraries": "aɪtɪnərəriz",
    "itinerary": "aɪtɪnərəri",
    "itself": "ɪtsɛlf",
    "its": "ɪts",
    "it": "ɪt",
    "ivies": "aɪvɪz",
    "ivories": "aɪvəriz",
    "ivory": "aɪvəri",
    "ivy": "aɪvi",
    "izzard": "ɪzəd",
    "jabbed": "dʒæbd",
    "jabber": "dʒæbɐ",
    "jabbering": "dʒæbərɪŋ",
    "jabbers": "dʒæbəz",
    "jabberwocky": "dʒæbəwɒki",
    "jabbing": "dʒæbɪŋ",
    "jab": "dʒæb",
    "jabiru": "dʒæbəruː",
    "jabot": "dʒæbɒt",
    "jabs": "dʒæbz",
    "jacaranda": "dʒækɐrændɐ",
    "jackal": "dʒækəl",
    "jackals": "dʒækəlz",
    "jackanapes": "dʒækɐneɪps",
    "jackass": "dʒækæs",
    "jackasses": "dʒækæsɪz",
    "jackboot": "dʒækbuːt",
    "jackboots": "dʒækbuːts",
    "jackdaw": "dʒækdɔː",
    "jackdaws": "dʒækdɔːz",
    "jack": "dʒæk",
    "jacked": "dʒækt",
    "jacket": "dʒækɪt",
    "jacketed": "dʒækɪtɪd",
    "jackets": "dʒækɪts",
    "jackfruit": "dʒækfruːt",
    "jackhammer": "dʒækhæmɐ",
    "jackhammers": "dʒækæməz",
    "jacking": "dʒækɪŋ",
    "jackknifed": "dʒæknaɪft",
    "jackknife": "dʒæknaɪf",
    "jackknifing": "dʒæknaɪfɪŋ",
    "jackknives": "dʒæknaɪvz",
    "jackpot": "dʒækpɒt",
    "jackpots": "dʒækpɒts",
    "jackrabbit": "dʒækrɐbɪt",
    "jackrabbits": "dʒækrɐbɪts",
    "jacks": "dʒæks",
    "jacobus": "dʒækɒbəs",
    "jacquard": "dʒækɑːd",
    "jactitation": "dʒæktɪteɪʃən",
    "jacuzzi": "dʒəkuːzi",
    "jaded": "dʒeɪdɪd",
    "jade": "dʒeɪd",
    "jadeite": "dʒeɪdaɪt",
    "jades": "dʒeɪdz",
    "jaeger": "dʒeɪɡɐ",
    "jag": "dʒæɡ",
    "jaggedness": "dʒæɡɪdnəs",
    "jaggery": "dʒæɡəri",
    "jaggy": "dʒæɡi",
    "jags": "dʒæɡz",
    "jaguar": "dʒæɡwɑː",
    "jaguars": "dʒæɡwɑːz",
    "jailbird": "dʒeɪlbɜːd",
    "jailbirds": "dʒeɪlbɜːdz",
    "jailbreak": "dʒeɪlbreɪk",
    "jail": "dʒeɪl",
    "jailed": "dʒeɪld",
    "jailer": "dʒeɪlɐ",
    "jailers": "dʒeɪləz",
    "jailhouse": "dʒeɪlhaʊs",
    "jailing": "dʒeɪlɪŋ",
    "jailor": "dʒeɪlɐ",
    "jailors": "dʒeɪləz",
    "jails": "dʒeɪlz",
    "ja": "jɑː",
    "jakes": "dʒeɪks",
    "jalopies": "dʒɐlɒpɪz",
    "jalopy": "dʒɐlɒpi",
    "jambalaya": "dʒæmbɐleɪɐ",
    "jamb": "dʒæm",
    "jamboree": "dʒæmbɔːriː",
    "jamborees": "dʒæmbɔːriːz",
    "jambs": "dʒæmz",
    "jam": "dʒæm",
    "jammed": "dʒæmd",
    "jammer": "dʒæmɐ",
    "jammiest": "dʒæmɪəst",
    "jamming": "dʒæmɪŋ",
    "jammy": "dʒæmi",
    "jampacked": "dʒæmpækt",
    "jams": "dʒæmz",
    "jane": "dʒeɪn",
    "jangled": "dʒæŋɡəld",
    "jangle": "dʒæŋɡəl",
    "jangles": "dʒæŋɡəlz",
    "jangling": "dʒæŋɡəlɪŋ",
    "jangly": "dʒæŋli",
    "janitor": "dʒænɪtɐ",
    "janitorial": "dʒænɪtɔːrɪəl",
    "janitors": "dʒænɪtəz",
    "japan": "dʒəpæn",
    "japanned": "dʒəpænd",
    "japanning": "dʒəpænɪŋ",
    "jape": "dʒeɪp",
    "japer": "dʒeɪpɐ",
    "japes": "dʒeɪps",
    "japing": "dʒeɪpɪŋ",
    "japonica": "dʒæpɒnɪkɐ",
    "japonicas": "dʒæpɒnɪkəz",
    "jar": "dʒɑː",
    "jarl": "dʒɑːl",
    "jarred": "dʒɑːd",
    "jarring": "dʒɑːrɪŋ",
    "jars": "dʒɑːz",
    "jasmine": "dʒæzmɪn",
    "jasmines": "dʒæzmɪnz",
    "jasper": "dʒɑːspɐ",
    "jaundiced": "dʒɔːndɪst",
    "jaundice": "dʒɔːndɪs",
    "jaunt": "dʒɔːnt",
    "jauntily": "dʒɔːntɪli",
    "jauntiness": "dʒɔːntɪnəs",
    "jaunting": "dʒɔːntɪŋ",
    "jaunts": "dʒɔːnts",
    "jaunty": "dʒɔːnti",
    "java": "dʒɑːvɐ",
    "javelin": "dʒævɪlɪn",
    "javelins": "dʒævɪlɪnz",
    "jawbone": "dʒɔːbəʊn",
    "jawbones": "dʒɔːbəʊnz",
    "jawbreaker": "dʒɔːbreɪkɐ",
    "jawbreakers": "dʒɔːbreɪkəz",
    "jaw": "dʒɔː",
    "jawed": "dʒɔːd",
    "jawing": "dʒɔːrɪŋ",
    "jawless": "dʒɔːləs",
    "jawline": "dʒɔːlaɪn",
    "jaws": "dʒɔːz",
    "jaybird": "dʒeɪbɜːd",
    "jay": "dʒeɪ",
    "jays": "dʒeɪz",
    "jaywalker": "dʒeɪwɔːkɐ",
    "jaywalking": "dʒeɪwɔːkɪŋ",
    "jazz": "dʒæz",
    "jazzed": "dʒæzd",
    "jazzier": "dʒæzɪɐ",
    "jazzing": "dʒæzɪŋ",
    "jazzman": "dʒæzmən",
    "jazzmen": "dʒæzmɛn",
    "jazzy": "dʒæzi",
    "j": "dʒeɪ",
    "jealous": "dʒɛləs",
    "jealousies": "dʒɛləsiz",
    "jealously": "dʒɛləsli",
    "jealousy": "dʒɛləsi",
    "jean": "dʒiːn",
    "jeans": "dʒiːnz",
    "jebel": "dʒɛbəl",
    "jeep": "dʒiːp",
    "jeepers": "dʒiːpəz",
    "jeeps": "dʒiːps",
    "jeer": "dʒiə",
    "jeered": "dʒiəd",
    "jeering": "dʒiərɪŋ",
    "jeers": "dʒiəz",
    "jeez": "dʒiːz",
    "jefe": "dʒiːf",
    "jejune": "dʒɛdʒjuːn",
    "jell": "dʒɛl",
    "jellied": "dʒɛlɪd",
    "jellies": "dʒɛlɪz",
    "jellified": "dʒɛlɪfaɪd",
    "jelling": "dʒɛlɪŋ",
    "jello": "dʒɛləʊ",
    "jellybean": "dʒɛlɪbiːn",
    "jellybeans": "dʒɛlɪbiːnz",
    "jelly": "dʒɛli",
    "jellyfish": "dʒɛlɪfɪʃ",
    "jellyfishes": "dʒɛlɪfɪʃɪz",
    "jemadar": "dʒɛmædɐ",
    "jemmied": "dʒɛmɪd",
    "jemmy": "dʒɛmi",
    "jennet": "dʒɛnɪt",
    "jennies": "dʒɛnɪz",
    "jenny": "dʒɛni",
    "jeopardised": "dʒɛpədaɪzd",
    "jeopardise": "dʒɛpədaɪz",
    "jeopardises": "dʒɛpədaɪzɪz",
    "jeopardising": "dʒɛpədaɪzɪŋ",
    "jeopardy": "dʒɛpədi",
    "jerboa": "dʒɜːbəʊɐ",
    "jerk": "dʒɜːk",
    "jerked": "dʒɜːkt",
    "jerkily": "dʒɜːkili",
    "jerkin": "dʒɜːkɪn",
    "jerking": "dʒɜːkɪŋ",
    "jerkins": "dʒɜːkɪnz",
    "jerks": "dʒɜːks",
    "jerky": "dʒɜːki",
    "jeroboam": "dʒɛrəbəʊəm",
    "jerrycan": "dʒɛrɪkən",
    "jerry": "dʒɛri",
    "jersey": "dʒɜːsi",
    "jerseys": "dʒɜːsɪz",
    "jess": "dʒɛs",
    "jest": "dʒɛst",
    "jested": "dʒɛstɪd",
    "jester": "dʒɛstɐ",
    "jesters": "dʒɛstəz",
    "jesting": "dʒɛstɪŋ",
    "jests": "dʒɛsts",
    "jet": "dʒɛt",
    "jetlag": "dʒɛtlæɡ",
    "jetliner": "dʒɛtlaɪnɐ",
    "jetliners": "dʒɛtlaɪnəz",
    "jetsam": "dʒɛtsəm",
    "jets": "dʒɛts",
    "jetted": "dʒɛtɪd",
    "jetties": "dʒɛtɪz",
    "jetting": "dʒɛtɪŋ",
    "jettison": "dʒɛtɪsən",
    "jettisoned": "dʒɛtɪsənd",
    "jettisoning": "dʒɛtɪsənɪŋ",
    "jettisons": "dʒɛtɪsənz",
    "jetty": "dʒɛti",
    "jewel": "dʒuːəl",
    "jewelled": "dʒuːəld",
    "jeweller": "dʒuːəlɐ",
    "jewellers": "dʒuːələz",
    "jewellery": "dʒuːələri",
    "jewelling": "dʒuːəlɪŋ",
    "jewelry": "dʒuːəlri",
    "jewels": "dʒuːəlz",
    "jezebel": "dʒɛzɛbəl",
    "jg": "dʒeɪdʒiː",
    "jibbed": "dʒɪbd",
    "jibber": "dʒɪbɐ",
    "jibbing": "dʒɪbɪŋ",
    "jib": "dʒɪb",
    "jibe": "dʒaɪb",
    "jibes": "dʒaɪbz",
    "jibing": "dʒaɪbɪŋ",
    "jibs": "dʒɪbz",
    "jiff": "dʒɪf",
    "jiffy": "dʒɪfi",
    "jig": "dʒɪɡ",
    "jigged": "dʒɪɡd",
    "jigger": "dʒɪɡɐ",
    "jiggered": "dʒɪɡəd",
    "jiggering": "dʒɪɡərɪŋ",
    "jigging": "dʒɪɡɪŋ",
    "jiggled": "dʒɪɡəld",
    "jiggle": "dʒɪɡəl",
    "jiggles": "dʒɪɡəlz",
    "jiggliest": "dʒɪɡliəst",
    "jiggling": "dʒɪɡlɪŋ",
    "jiggly": "dʒɪɡli",
    "jigsaw": "dʒɪɡsɔː",
    "jigsaws": "dʒɪɡsɔːz",
    "jigs": "dʒɪɡz",
    "jihad": "dʒɪhɑːd",
    "jill": "dʒɪl",
    "jilt": "dʒɪlt",
    "jilted": "dʒɪltɪd",
    "jilting": "dʒɪltɪŋ",
    "jimjams": "dʒɪmdʒæmz",
    "jimmied": "dʒɪmɪd",
    "jimmies": "dʒɪmɪz",
    "jimmy": "dʒɪmi",
    "jingled": "dʒɪŋɡəld",
    "jingle": "dʒɪŋɡəl",
    "jingles": "dʒɪŋɡəlz",
    "jingling": "dʒɪŋɡəlɪŋ",
    "jingly": "dʒɪŋli",
    "jingo": "dʒɪŋɡəʊ",
    "jingoism": "dʒɪŋɡəʊɪzəm",
    "jingoistic": "dʒɪŋɡəʊɪstɪk",
    "jink": "dʒɪŋk",
    "jinked": "dʒɪŋkt",
    "jinking": "dʒɪŋkɪŋ",
    "jinks": "dʒɪŋks",
    "jinn": "dʒɪn",
    "jinx": "dʒɪŋks",
    "jinxed": "dʒɪŋkst",
    "jinxes": "dʒɪŋksɪz",
    "jinxing": "dʒɪŋksɪŋ",
    "jitterbug": "dʒɪtəbʌɡ",
    "jitterbugging": "dʒɪtəbʌɡɪŋ",
    "jitter": "dʒɪtɐ",
    "jitteriness": "dʒɪtərinəs",
    "jitters": "dʒɪtəz",
    "jittery": "dʒɪtəri",
    "jived": "dʒaɪvd",
    "jive": "dʒaɪv",
    "jiver": "dʒaɪvɐ",
    "jives": "dʒaɪvz",
    "jiving": "dʒaɪvɪŋ",
    "joannes": "dʒəʊænz",
    "jobber": "dʒɒbɐ",
    "jobbers": "dʒɒbəz",
    "jobbing": "dʒɒbɪŋ",
    "jobless": "dʒɒbləs",
    "joblessness": "dʒɒbləsnəs",
    "jobs": "dʒɒbz",
    "jobsworth": "dʒɒbswɜːθ",
    "jobsworths": "dʒɒbswɜːθs",
    "jock": "dʒɒk",
    "jockey": "dʒɒki",
    "jockeyed": "dʒɒkɪd",
    "jockeying": "dʒɒkɪɪŋ",
    "jockeys": "dʒɒkɪz",
    "jocko": "dʒɒkəʊ",
    "jocks": "dʒɒks",
    "jockstrap": "dʒɒkstræp",
    "jockstraps": "dʒɒkstræps",
    "jocular": "dʒɒkjʊlɐ",
    "jocularity": "dʒɒkjʊlærɪti",
    "jocularly": "dʒɒkjʊləli",
    "jocund": "dʒɒkʌnd",
    "jodhpur": "dʒɒdpɔː",
    "jodhpurs": "dʒɒdpɔːz",
    "jo": "dʒəʊ",
    "joey": "dʒəʊi",
    "joeys": "dʒəʊɪz",
    "jog": "dʒɒɡ",
    "jogged": "dʒɒɡd",
    "jogger": "dʒɒɡɐ",
    "joggers": "dʒɒɡəz",
    "jogging": "dʒɒɡɪŋ",
    "joggled": "dʒɒɡəld",
    "joggle": "dʒɒɡəl",
    "joggling": "dʒɒɡlɪŋ",
    "jogs": "dʒɒɡz",
    "johannes": "dʒəʊhænz",
    "john": "dʒɒn",
    "johnnies": "dʒɒnɪz",
    "johnny": "dʒɒni",
    "johns": "dʒɒnz",
    "join": "dʒɔɪn",
    "joined": "dʒɔɪnd",
    "joiner": "dʒɔɪnɐ",
    "joiners": "dʒɔɪnəz",
    "joinery": "dʒɔɪnəri",
    "joining": "dʒɔɪnɪŋ",
    "joins": "dʒɔɪnz",
    "joint": "dʒɔɪnt",
    "jointed": "dʒɔɪntɪd",
    "jointer": "dʒɔɪntɐ",
    "jointing": "dʒɔɪntɪŋ",
    "jointly": "dʒɔɪntli",
    "joints": "dʒɔɪnts",
    "jointure": "dʒɔɪntʃɐ",
    "joist": "dʒɔɪst",
    "joists": "dʒɔɪsts",
    "jojoba": "dʒədʒəʊbɐ",
    "joked": "dʒəʊkt",
    "joke": "dʒəʊk",
    "joker": "dʒəʊkɐ",
    "jokers": "dʒəʊkəz",
    "jokes": "dʒəʊks",
    "jokester": "dʒəʊkstɐ",
    "jokey": "dʒəʊki",
    "jokiest": "dʒəʊkɪəst",
    "jokily": "dʒəʊkɪli",
    "joking": "dʒəʊkɪŋ",
    "jokingly": "dʒəʊkɪŋli",
    "jollied": "dʒɒlid",
    "jollier": "dʒɒliɐ",
    "jollies": "dʒɒliz",
    "jolliest": "dʒɒliəst",
    "jollification": "dʒɒlɪfɪkeɪʃən",
    "jolliness": "dʒɒlinəs",
    "jollity": "dʒɒlɪti",
    "jolly": "dʒɒli",
    "jollying": "dʒɒliɪŋ",
    "jolt": "dʒəʊlt",
    "jolted": "dʒəʊltɪd",
    "jolting": "dʒəʊltɪŋ",
    "jolts": "dʒəʊlts",
    "jolty": "dʒəʊlti",
    "jongleurs": "dʒɒŋɡlɜːz",
    "jonquil": "dʒɒnkwɪl",
    "jook": "dʒʊk",
    "josh": "dʒɒʃ",
    "joshing": "dʒɒʃɪŋ",
    "joss": "dʒɒs",
    "jostled": "dʒɒsəld",
    "jostle": "dʒɒsəl",
    "jostles": "dʒɒsəlz",
    "jostling": "dʒɒslɪŋ",
    "jot": "dʒɒt",
    "jots": "dʒɒts",
    "jotted": "dʒɒtɪd",
    "jotter": "dʒɒtɐ",
    "jotters": "dʒɒtəz",
    "jotting": "dʒɒtɪŋ",
    "jottings": "dʒɒtɪŋz",
    "joule": "dʒuːl",
    "joules": "dʒuːlz",
    "journal": "dʒɜːnəl",
    "journalese": "dʒɜːneɪliːz",
    "journalism": "dʒɜːnəlɪzəm",
    "journalist": "dʒɜːnəlɪst",
    "journalistically": "dʒɜːnəlɪstɪkli",
    "journalistic": "dʒɜːnəlɪstɪk",
    "journalists": "dʒɜːnəlɪsts",
    "journals": "dʒɜːnəlz",
    "journey": "dʒɜːni",
    "journeyed": "dʒɜːnɪd",
    "journeying": "dʒɜːnɪɪŋ",
    "journeyman": "dʒɜːnɪmən",
    "journeymen": "dʒɜːnɪmɛn",
    "journeys": "dʒɜːnɪz",
    "journo": "dʒɜːnəʊ",
    "journos": "dʒɜːnəʊz",
    "joust": "dʒaʊst",
    "jousted": "dʒaʊstɪd",
    "jouster": "dʒaʊstɐ",
    "jousters": "dʒaʊstəz",
    "jousting": "dʒaʊstɪŋ",
    "jousts": "dʒaʊsts",
    "jovial": "dʒəʊvɪəl",
    "joviality": "dʒəʊvɪælɪti",
    "jovially": "dʒəʊvɪəli",
    "jowl": "dʒaʊl",
    "jowls": "dʒaʊlz",
    "jowly": "dʒaʊli",
    "joy": "dʒɔɪ",
    "joyed": "dʒɔɪd",
    "joyful": "dʒɔɪfəl",
    "joyfully": "dʒɔɪfəli",
    "joyfulness": "dʒɔɪfəlnəs",
    "joying": "dʒɔɪɪŋ",
    "joyless": "dʒɔɪləs",
    "joyous": "dʒɔɪəs",
    "joyously": "dʒɔɪəsli",
    "joyousness": "dʒɔɪəsnəs",
    "joyride": "dʒɔɪraɪd",
    "joyrider": "dʒɔɪraɪdɐ",
    "joyriders": "dʒɔɪraɪdəz",
    "joyriding": "dʒɔɪraɪdɪŋ",
    "joys": "dʒɔɪz",
    "joystick": "dʒɔɪstɪk",
    "joysticks": "dʒɔɪstɪks",
    "juba": "dʒuːbɐ",
    "jubilant": "dʒuːbɪlənt",
    "jubilantly": "dʒuːbɪləntli",
    "jubilation": "dʒuːbɪleɪʃən",
    "jubilee": "dʒuːbɪliː",
    "jubilees": "dʒuːbɪliːz",
    "judder": "dʒʌdɐ",
    "juddered": "dʒʌdəd",
    "juddering": "dʒʌdərɪŋ",
    "judged": "dʒʌdʒd",
    "judge": "dʒʌdʒ",
    "judgemental": "dʒʌdʒmɛntəl",
    "judgement": "dʒʌdʒmənt",
    "judgements": "dʒʌdʒmənts",
    "judges": "dʒʌdʒɪz",
    "judging": "dʒʌdʒɪŋ",
    "judgmental": "dʒʌdʒmɛntəl",
    "judgment": "dʒʌdʒmənt",
    "judgments": "dʒʌdʒmənts",
    "judicial": "dʒuːdɪʃəl",
    "judicially": "dʒuːdɪʃəli",
    "judiciaries": "dʒuːdɪʃərɪz",
    "judiciary": "dʒuːdɪʃəri",
    "judicious": "dʒuːdɪʃəs",
    "judiciously": "dʒuːdɪʃəsli",
    "judo": "dʒuːdəʊ",
    "jug": "dʒʌɡ",
    "jugged": "dʒʌɡd",
    "juggernaut": "dʒʌɡənɔːt",
    "juggernauts": "dʒʌɡənɔːts",
    "juggins": "dʒʌɡɪnz",
    "juggled": "dʒʌɡəld",
    "juggle": "dʒʌɡəl",
    "juggler": "dʒʌɡlɐ",
    "jugglers": "dʒʌɡləz",
    "juggles": "dʒʌɡəlz",
    "juggling": "dʒʌɡlɪŋ",
    "jughead": "dʒʌɡhɛd",
    "jugs": "dʒʌɡz",
    "jugular": "dʒuːɡjʊlɐ",
    "juiced": "dʒuːst",
    "juice": "dʒuːs",
    "juicer": "dʒuːsɐ",
    "juicers": "dʒuːsəz",
    "juices": "dʒuːsɪz",
    "juicier": "dʒuːsɪɐ",
    "juiciest": "dʒuːsɪəst",
    "juiciness": "dʒuːsɪnɛs",
    "juicing": "dʒuːsɪŋ",
    "juicy": "dʒuːsi",
    "jujitsu": "dʒuːdʒɪtsuː",
    "jujubes": "dʒuːdʒuːbz",
    "juju": "dʒuːdʒuː",
    "jukebox": "dʒuːkbɒks",
    "jukeboxes": "dʒuːkbɒksɪz",
    "juke": "dʒuːk",
    "julep": "dʒuːlɛp",
    "juleps": "dʒuːlɛps",
    "julienne": "dʒuːlɪɛn",
    "jumbled": "dʒʌmbəld",
    "jumble": "dʒʌmbəl",
    "jumbles": "dʒʌmbəlz",
    "jumbling": "dʒʌmblɪŋ",
    "jumbo": "dʒʌmbəʊ",
    "jumbos": "dʒʌmbəʊz",
    "jumbuck": "dʒʌmbʌk",
    "jump": "dʒʌmp",
    "jumped": "dʒʌmpt",
    "jumper": "dʒʌmpɐ",
    "jumpers": "dʒʌmpəz",
    "jumpier": "dʒʌmpɪɐ",
    "jumpiness": "dʒʌmpɪnəs",
    "jumping": "dʒʌmpɪŋ",
    "jumps": "dʒʌmps",
    "jumpsuit": "dʒʌmpsuːt",
    "jumpsuits": "dʒʌmpsuːts",
    "jumpy": "dʒʌmpi",
    "junction": "dʒʌŋkʃən",
    "junctions": "dʒʌŋkʃənz",
    "juncture": "dʒʌŋktʃɐ",
    "junctures": "dʒʌŋktʃəz",
    "jun": "dʒʌn",
    "jungle": "dʒʌŋɡəl",
    "jungles": "dʒʌŋɡəlz",
    "jungliest": "dʒʌŋɡliəst",
    "jungly": "dʒʌŋli",
    "junior": "dʒuːnjɐ",
    "juniors": "dʒuːnjəz",
    "juniper": "dʒuːnɪpɐ",
    "junipers": "dʒuːnɪpəz",
    "junk": "dʒʌŋk",
    "junked": "dʒʌŋkt",
    "junkers": "dʒʌŋkəz",
    "junket": "dʒʌŋkɪt",
    "junkets": "dʒʌŋkɪts",
    "junkie": "dʒʌŋki",
    "junkies": "dʒʌŋkiz",
    "junking": "dʒʌŋkɪŋ",
    "junks": "dʒʌŋks",
    "junkyard": "dʒʌŋkjɑːd",
    "junky": "dʒʌŋki",
    "junta": "dʒʌntɐ",
    "juntas": "dʒʌntəz",
    "junto": "dʒʌntəʊ",
    "jura": "dʒjɔːrɐ",
    "jurat": "dʒjʊræt",
    "juries": "dʒɔːrɪz",
    "jurisdictional": "dʒɔːrɪsdɪkʃənəl",
    "jurisdiction": "dʒɔːrɪsdɪkʃən",
    "jurisdictions": "dʒɔːrɪsdɪkʃənz",
    "jurisprudence": "dʒɔːrɪspruːdəns",
    "jurist": "dʒɔːrɪst",
    "jurists": "dʒɔːrɪsts",
    "juror": "dʒjʊrɐ",
    "jurors": "dʒjʊrəz",
    "jury": "dʒɔːri",
    "jurymen": "dʒɔːrɪmɛn",
    "just": "dʒʌst",
    "juster": "dʒʌstɐ",
    "justice": "dʒʌstɪs",
    "justices": "dʒʌstɪsɪz",
    "justiciar": "dʒʌstɪʃər",
    "justifiable": "dʒʌstɪfaɪəbəl",
    "justifiably": "dʒʌstɪfaɪəbli",
    "justification": "dʒʌstɪfɪkeɪʃən",
    "justifications": "dʒʌstɪfɪkeɪʃənz",
    "justified": "dʒʌstɪfaɪd",
    "justifies": "dʒʌstɪfaɪz",
    "justify": "dʒʌstɪfaɪ",
    "justifying": "dʒʌstɪfaɪɪŋ",
    "justly": "dʒʌstli",
    "justness": "dʒʌstnəs",
    "jut": "dʒʌt",
    "jute": "dʒuːt",
    "juts": "dʒʌts",
    "jutted": "dʒʌtɪd",
    "jutting": "dʒʌtɪŋ",
    "jutty": "dʒʌti",
    "juvenal": "dʒuːviːnəl",
    "juvenile": "dʒuːvənaɪl",
    "juveniles": "dʒuːvənaɪlz",
    "juvenilia": "dʒuːvənɪliə",
    "juxtaposed": "dʒʌkstɐpəʊzd",
    "juxtapose": "dʒʌkstɐpəʊz",
    "juxtaposes": "dʒʌkstɐpəʊzɪz",
    "juxtaposing": "dʒʌkstɐpəʊzɪŋ",
    "juxtaposition": "dʒʌkstɐpəzɪʃən",
    "juxtapositions": "dʒʌkstɐpəzɪʃənz",
    "kabbalah": "kæbælɐ",
    "kab": "kæb",
    "kaboom": "kæbuːm",
    "kabuki": "kæbuːki",
    "kaddish": "kædɪʃ",
    "kadi": "kædi",
    "kafir": "kæfiə",
    "kaftan": "kɑːftən",
    "kaftans": "kɑːftənz",
    "kahuna": "kæhuːnɐ",
    "kail": "kaɪl",
    "kailyard": "kaɪljɑːd",
    "kain": "kaɪn",
    "kaiser": "kaɪzɐ",
    "kaisers": "kaɪzəz",
    "ka": "kɑː",
    "kaka": "kɑːkɐ",
    "kakapo": "kækɑːpəʊ",
    "kaki": "kæki",
    "kaleidoscope": "kəlaɪdəskəʊp",
    "kaleidoscopes": "kəlaɪdəskəʊps",
    "kaleidoscopically": "kəlaɪdəskɒpɪkli",
    "kaleidoscopic": "kəlaɪdəskɒpɪk",
    "kale": "keɪl",
    "kalian": "keɪliən",
    "kalif": "kælɪf",
    "kali": "kɑːli",
    "kalmia": "kælmiɐ",
    "kamikaze": "kæmɪkɑːzi",
    "kamikazes": "kæmɪkeɪzɪz",
    "kami": "kɑːmi",
    "kampong": "kæmpɒŋ",
    "kana": "kɑːnɐ",
    "kangaroo": "kæŋɡɐruː",
    "kangaroos": "kæŋɡɐruːz",
    "kanji": "kændʒi",
    "kaolin": "keɪəlɪn",
    "kaon": "keɪɒn",
    "kapok": "kæpɒk",
    "kappa": "kæpɐ",
    "kaput": "kɐpʊt",
    "karaoke": "kærɪəʊki",
    "karate": "kərɑːti",
    "karat": "kæræt",
    "karma": "kɑːmɐ",
    "karmically": "kɑːmɪkli",
    "karmic": "kɑːmɪk",
    "karst": "kɑːst",
    "kart": "kɑːt",
    "karts": "kɑːts",
    "kasha": "kæʃɐ",
    "kashmir": "kæʃmiə",
    "katabatic": "kætɐbætɪk",
    "katakana": "kætɐkɑːnɐ",
    "kat": "kæt",
    "katydid": "kætɪdɪd",
    "kauri": "kɔːri",
    "kava": "kɑːvɐ",
    "kayaked": "kaɪækt",
    "kayaker": "keɪeɪkɐ",
    "kayaking": "kaɪækɪŋ",
    "kayak": "kaɪæk",
    "kayaks": "kaɪæks",
    "kazoo": "kɐzuː",
    "kazoos": "kɐzuːz",
    "kb": "keɪbiː",
    "kc": "keɪsiː",
    "kea": "kiː",
    "keas": "kiːz",
    "kebab": "kəbæb",
    "kebabs": "kəbæbz",
    "keck": "kɛk",
    "kedge": "kɛdʒ",
    "kedgeree": "kɛdʒriː",
    "keek": "kiːk",
    "keeled": "kiːld",
    "keelhauled": "kiːlhɔːld",
    "keelhauling": "kiːlhɔːlɪŋ",
    "keeling": "kiːlɪŋ",
    "keel": "kiːl",
    "keels": "kiːlz",
    "keener": "kiːnɐ",
    "keenest": "kiːnəst",
    "keening": "kiːnɪŋ",
    "keen": "kiːn",
    "keenly": "kiːnli",
    "keenness": "kiːnnəs",
    "keens": "kiːnz",
    "keeper": "kiːpɐ",
    "keepers": "kiːpəz",
    "keeping": "kiːpɪŋ",
    "keep": "kiːp",
    "keepsake": "kiːpseɪk",
    "keepsakes": "kiːpseɪks",
    "keeps": "kiːps",
    "kef": "kɛf",
    "keg": "kɛɡ",
    "kegs": "kɛɡz",
    "keister": "kaɪstɐ",
    "kelly": "kɛli",
    "kelpie": "kɛlpaɪ",
    "kelp": "kɛlp",
    "kelson": "kɛlsən",
    "kelt": "kɛlt",
    "kelvin": "kɛlvɪn",
    "kelvins": "kɛlvɪnz",
    "kendo": "kɛndəʊ",
    "ken": "kɛn",
    "kennel": "kɛnəl",
    "kennelling": "kɛnəlɪŋ",
    "kennels": "kɛnəlz",
    "kenning": "kɛnɪŋ",
    "keno": "kiːnəʊ",
    "kens": "kɛnz",
    "kente": "kɛnt",
    "kent": "kɛnt",
    "kepi": "kɛpi",
    "kep": "kɛp",
    "kept": "kɛpt",
    "keratin": "kɛrɐtɪn",
    "keratitis": "kɛrɐtaɪtɪs",
    "keratosis": "kɛrɐtəʊsɪs",
    "kerbing": "kɜːbɪŋ",
    "kerb": "kɜːb",
    "kerbside": "kɜːbsaɪd",
    "kerbs": "kɜːbz",
    "kerbstone": "kɜːbstəʊn",
    "kerbstones": "kɜːbstəʊnz",
    "kerchief": "kɜːtʃiːf",
    "kerfuffle": "kɜːfʌfəl",
    "kerfuffles": "kɜːfʌfəlz",
    "kernel": "kɜːnəl",
    "kernels": "kɜːnəlz",
    "kern": "kɜːn",
    "kerosene": "kɛrəsiːn",
    "kerosine": "kɛrəsaɪn",
    "kerplunk": "kɜːplʌŋk",
    "kersey": "kɜːsi",
    "kestrel": "kɛstrəl",
    "kestrels": "kɛstrəlz",
    "ketches": "kɛtʃɪz",
    "ketch": "kɛtʃ",
    "ketchup": "kɛtʃʌp",
    "ketone": "kɛtəʊn",
    "ketones": "kɛtəʊnz",
    "kettledrums": "kɛtəldrəmz",
    "kettle": "kɛtəl",
    "kettles": "kɛtəlz",
    "keyboardist": "kiːbɔːdɪst",
    "keyboard": "kiːbɔːd",
    "keyboards": "kiːbɔːdz",
    "keycard": "kiːkɑːd",
    "keyed": "kiːd",
    "keyhole": "kiːhəʊl",
    "keyholes": "kiːhəʊlz",
    "keying": "kiːɪŋ",
    "key": "kiː",
    "keynote": "kiːnəʊt",
    "keynotes": "kiːnəʊts",
    "keypad": "kiːpæd",
    "keypads": "kiːpædz",
    "keyring": "kiːrɪŋ",
    "keys": "kiːz",
    "keystone": "kiːstəʊn",
    "keystones": "kiːstəʊnz",
    "keystroke": "kiːstrəʊk",
    "keystrokes": "kiːstrəʊks",
    "keyword": "kiːwɜːd",
    "keywords": "kiːwɜːdz",
    "khaki": "kɑːki",
    "khakis": "kɑːkiz",
    "khan": "kɑːn",
    "khans": "kɑːnz",
    "khat": "kɑːt",
    "khedive": "kɛdɪv",
    "kibbled": "kɪbəld",
    "kibble": "kɪbəl",
    "kibbles": "kɪbəlz",
    "kibbling": "kɪblɪŋ",
    "kibbutz": "kɪbʌts",
    "kiblah": "kɪblɐ",
    "kibosh": "kɪbɒʃ",
    "kickback": "kɪkbæk",
    "kickbacks": "kɪkbæks",
    "kickball": "kɪkbɔːl",
    "kickboxing": "kɪkbɒksɪŋ",
    "kicked": "kɪkt",
    "kicker": "kɪkɐ",
    "kickers": "kɪkəz",
    "kicking": "kɪkɪŋ",
    "kick": "kɪk",
    "kickoff": "kɪkɒf",
    "kickoffs": "kɪkɒfs",
    "kicks": "kɪks",
    "kickstand": "kɪkstænd",
    "kickstart": "kɪkstɑːt",
    "kicky": "kɪki",
    "kidded": "kɪdɪd",
    "kidder": "kɪdɐ",
    "kidders": "kɪdəz",
    "kiddie": "kɪdi",
    "kiddies": "kɪdɪz",
    "kidding": "kɪdɪŋ",
    "kiddo": "kɪdəʊ",
    "kiddos": "kɪdəʊz",
    "kiddy": "kɪdi",
    "kid": "kɪd",
    "kidnap": "kɪdnæp",
    "kidnapped": "kɪdnæpt",
    "kidnapper": "kɪdnæpɐ",
    "kidnappers": "kɪdnæpəz",
    "kidnapping": "kɪdnæpɪŋ",
    "kidnappings": "kɪdnæpɪŋz",
    "kidnaps": "kɪdnæps",
    "kidney": "kɪdni",
    "kidneys": "kɪdnɪz",
    "kids": "kɪdz",
    "kielbasa": "kiːlbɑːsɐ",
    "kier": "kiə",
    "kieselguhr": "kiːsɪlɡuːɐ",
    "kif": "kɪf",
    "ki": "kaɪ",
    "kike": "kaɪk",
    "kikes": "kaɪks",
    "killed": "kɪld",
    "killer": "kɪlɐ",
    "killers": "kɪləz",
    "killick": "kɪlɪk",
    "killing": "kɪlɪŋ",
    "killings": "kɪlɪŋz",
    "killjoy": "kɪldʒɔɪ",
    "killjoys": "kɪldʒɔɪz",
    "kill": "kɪl",
    "kills": "kɪlz",
    "kilning": "kɪlnɪŋ",
    "kiln": "kɪln",
    "kilns": "kɪlnz",
    "kilobits": "kɪləbɪts",
    "kilobyte": "kɪləbaɪt",
    "kilobytes": "kɪləbaɪts",
    "kilocalories": "kɪləkæləriz",
    "kilogram": "kɪləɡræm",
    "kilograms": "kɪləɡræmz",
    "kilohertz": "kɪləhɜːts",
    "kilojoules": "kɪlədʒuːlz",
    "kilo": "kiːləʊ",
    "kilometer": "kɪlɒmɪtɐ",
    "kilometers": "kɪlɒmɪtəz",
    "kilometre": "kɪləmiːtɐ",
    "kilometres": "kɪləmiːtəz",
    "kilos": "kiːləʊz",
    "kiloton": "kɪlətən",
    "kilotons": "kɪlətənz",
    "kilovolt": "kɪləvəʊlt",
    "kilovolts": "kɪləvəʊlts",
    "kilowatt": "kɪləwɒt",
    "kilowatts": "kɪləwɒts",
    "kilted": "kɪltɪd",
    "kilter": "kɪltɐ",
    "kilt": "kɪlt",
    "kilts": "kɪlts",
    "kimberlite": "kɪmbəlaɪt",
    "kimono": "kɪməʊnəʊ",
    "kimonos": "kɪməʊnəʊz",
    "kinaesthetic": "kɪniːsθɛtɪk",
    "kinase": "kɪneɪs",
    "kinda": "kaɪndɐ",
    "kindergartener": "kɪndəɡɑːtiːnɐ",
    "kindergarteners": "kɪndəɡɑːtənəz",
    "kindergarten": "kɪndəɡɑːtən",
    "kindergartens": "kɪndəɡɑːtənz",
    "kinder": "kaɪndɐ",
    "kindest": "kaɪndəst",
    "kind": "kaɪnd",
    "kindled": "kɪndəld",
    "kindle": "kɪndəl",
    "kindles": "kɪndəlz",
    "kindless": "kaɪndləs",
    "kindliness": "kaɪndlinəs",
    "kindling": "kɪndlɪŋ",
    "kindly": "kaɪndli",
    "kindnesses": "kaɪndnəsɪz",
    "kindness": "kaɪndnəs",
    "kindred": "kɪndrəd",
    "kinds": "kaɪndz",
    "kine": "kaɪn",
    "kinematic": "kaɪnmætɪk",
    "kinematograph": "kaɪnmɐtɒɡræf",
    "kinetic": "kɪnɛtɪk",
    "kinetics": "kɪnɛtɪks",
    "kinfolk": "kɪnfəʊk",
    "kingcup": "kɪŋkʌp",
    "kingdom": "kɪŋdəm",
    "kingdoms": "kɪŋdəmz",
    "kingfisher": "kɪŋfɪʃɐ",
    "kingfishers": "kɪŋfɪʃəz",
    "kingfish": "kɪŋfɪʃ",
    "king": "kɪŋ",
    "kingliness": "kɪŋlinəs",
    "kingly": "kɪŋli",
    "kingmaker": "kɪŋmeɪkɐ",
    "kingmakers": "kɪŋmeɪkəz",
    "kingpin": "kɪŋpɪn",
    "kingpins": "kɪŋpɪnz",
    "kingship": "kɪŋʃɪp",
    "kings": "kɪŋz",
    "kingwood": "kɪŋwʊd",
    "kinkajou": "kɪŋkɐdʒuː",
    "kinkajous": "kɪŋkædʒəs",
    "kinked": "kɪŋkt",
    "kinkier": "kɪŋkiɐ",
    "kinkiness": "kɪŋkinəs",
    "kinking": "kɪŋkɪŋ",
    "kink": "kɪŋk",
    "kin": "kɪn",
    "kinks": "kɪŋks",
    "kinky": "kɪŋki",
    "kino": "kiːnəʊ",
    "kinsfolk": "kɪnsfəʊk",
    "kinship": "kɪnʃɪp",
    "kinsman": "kɪnzmən",
    "kinsmen": "kɪnzmɛn",
    "kinswoman": "kɪnswʊmən",
    "kiosk": "kiːɒsk",
    "kiosks": "kiːɒsks",
    "kip": "kɪp",
    "kipped": "kɪpt",
    "kippered": "kɪpəd",
    "kippering": "kɪpərɪŋ",
    "kipper": "kɪpɐ",
    "kippers": "kɪpəz",
    "kipping": "kɪpɪŋ",
    "kips": "kɪps",
    "kirkman": "kɜːkmən",
    "kirsch": "kɜːʃ",
    "kirtle": "kɜːtəl",
    "kish": "kɪʃ",
    "kismet": "kɪsmɪt",
    "kissable": "kɪsəbəl",
    "kissed": "kɪst",
    "kisser": "kɪsɐ",
    "kissers": "kɪsəz",
    "kisses": "kɪsɪz",
    "kissing": "kɪsɪŋ",
    "kiss": "kɪs",
    "kissogram": "kɪsəɡræm",
    "kist": "kɪst",
    "kitbag": "kɪtbæɡ",
    "kitbags": "kɪtbæɡz",
    "kitchener": "kɪtʃənɐ",
    "kitchenette": "kɪtʃənɛt",
    "kitchen": "kɪtʃən",
    "kitchens": "kɪtʃənz",
    "kitchenware": "kɪtʃənweə",
    "kited": "kaɪtɪd",
    "kite": "kaɪt",
    "kites": "kaɪts",
    "kith": "kɪθ",
    "kiting": "kaɪtɪŋ",
    "kit": "kɪt",
    "kitsch": "kɪtʃ",
    "kitschy": "kɪtʃi",
    "kits": "kɪts",
    "kitted": "kɪtɪd",
    "kittenish": "kɪtənɪʃ",
    "kitten": "kɪtən",
    "kittens": "kɪtənz",
    "kitties": "kɪtɪz",
    "kitting": "kɪtɪŋ",
    "kittiwake": "kɪtɪweɪk",
    "kittiwakes": "kɪtɪweɪks",
    "kitty": "kɪti",
    "kiva": "kiːvɐ",
    "kiwifruit": "kɪwɪfruːt",
    "kiwi": "kiːwiː",
    "kiwis": "kiːwiːz",
    "k": "keɪ",
    "klaxon": "klæksən",
    "klaxons": "klæksənz",
    "kleptomaniac": "klɛptəmeɪnɪæk",
    "kleptomania": "klɛptəmeɪniə",
    "klutzes": "klʌtsɪz",
    "klutz": "klʌts",
    "klutzy": "klʌtsi",
    "knackered": "nækəd",
    "knackering": "nækərɪŋ",
    "knacker": "nækɐ",
    "knackers": "nækəz",
    "knack": "næk",
    "knacks": "næks",
    "knap": "næp",
    "knapped": "næpt",
    "knapping": "næpɪŋ",
    "knapsack": "næpsæk",
    "knapsacks": "næpsæks",
    "knapweed": "næpwiːd",
    "knave": "neɪv",
    "knavery": "neɪvəri",
    "knaves": "neɪvz",
    "knavish": "neɪvɪʃ",
    "kneaded": "niːdɪd",
    "kneader": "niːdɐ",
    "kneading": "niːdɪŋ",
    "knead": "niːd",
    "kneads": "niːdz",
    "kneecap": "niːkæp",
    "kneecapped": "niːkæpt",
    "kneecapping": "niːkæpɪŋ",
    "kneecaps": "niːkæps",
    "kneed": "niːd",
    "kneehole": "niːhəʊl",
    "kneeing": "niːɪŋ",
    "kneeled": "niːld",
    "kneeling": "niːlɪŋ",
    "kneel": "niːl",
    "kneels": "niːlz",
    "knee": "niː",
    "knees": "niːz",
    "knell": "nɛl",
    "knelt": "nɛlt",
    "knew": "njuː",
    "knickerbocker": "nɪkəbɒkɐ",
    "knickerbockers": "nɪkəbɒkəz",
    "knicker": "nɪkɐ",
    "knickers": "nɪkəz",
    "knickknack": "nɪkknæk",
    "knickknacks": "nɪkknæks",
    "knifed": "naɪft",
    "knife": "naɪf",
    "knifes": "naɪfs",
    "knifing": "naɪfɪŋ",
    "knighted": "naɪtɪd",
    "knighthood": "naɪthʊd",
    "knighthoods": "naɪthʊdz",
    "knighting": "naɪtɪŋ",
    "knightly": "naɪtli",
    "knight": "naɪt",
    "knights": "naɪts",
    "knish": "nɪʃ",
    "knit": "nɪt",
    "knits": "nɪts",
    "knitted": "nɪtɪd",
    "knitter": "nɪtɐ",
    "knitters": "nɪtəz",
    "knitting": "nɪtɪŋ",
    "knitwear": "nɪtweə",
    "knives": "naɪvz",
    "knobbed": "nɒbd",
    "knobbly": "nɒbli",
    "knobby": "nɒbi",
    "knob": "nɒb",
    "knobs": "nɒbz",
    "knockabout": "nɒkɐbaʊt",
    "knockdown": "nɒkdaʊn",
    "knockdowns": "nɒkdaʊnz",
    "knocked": "nɒkt",
    "knocker": "nɒkɐ",
    "knockers": "nɒkəz",
    "knocking": "nɒkɪŋ",
    "knockings": "nɒkɪŋz",
    "knock": "nɒk",
    "knockout": "nɒkaʊt",
    "knockouts": "nɒkaʊts",
    "knocks": "nɒks",
    "knockwurst": "nɒkwɜːst",
    "knoll": "nəʊl",
    "knolls": "nəʊlz",
    "knop": "nɒp",
    "knot": "nɒt",
    "knots": "nɒts",
    "knotted": "nɒtɪd",
    "knottier": "nɒtɪɐ",
    "knotting": "nɒtɪŋ",
    "knotty": "nɒti",
    "knotweed": "nɒtwiːd",
    "knout": "naʊt",
    "knowable": "nəʊəbəl",
    "knower": "nəʊɐ",
    "knowhow": "nəʊhaʊ",
    "knowingly": "nəʊɪŋli",
    "knowing": "nəʊɪŋ",
    "knowledgeable": "nɒlɪdʒəbəl",
    "knowledgeably": "nɒlɪdʒəbli",
    "knowledge": "nɒlɪdʒ",
    "know": "nəʊ",
    "known": "nəʊn",
    "knows": "nəʊz",
    "knuckled": "nʌkəld",
    "knuckleduster": "nʌklɪdʌstɐ",
    "knuckledusters": "nʌklɪdʌstəz",
    "knucklehead": "nʌkəlhɛd",
    "knuckleheads": "nʌklɪhɛdz",
    "knuckle": "nʌkəl",
    "knuckles": "nʌkəlz",
    "knuckling": "nʌklɪŋ",
    "knur": "nɜː",
    "koala": "kəʊɑːlɐ",
    "koalas": "kəʊɑːləz",
    "koan": "kəʊɑːn",
    "kob": "kɒb",
    "kobo": "kəʊbəʊ",
    "kohl": "kəʊl",
    "kohlrabi": "kəʊlrɐbaɪ",
    "kola": "kəʊlɐ",
    "kolo": "kəʊləʊ",
    "kookaburra": "kuːkɐbʌrɐ",
    "kookaburras": "kuːkɐbʌrəz",
    "kookie": "kuːki",
    "kookiest": "kuːkɪəst",
    "kookiness": "kuːkɪnəs",
    "kook": "kuːk",
    "kooks": "kuːks",
    "kooky": "kuːki",
    "kopecks": "kəʊpəks",
    "kopeks": "kəʊpəks",
    "kopje": "kɒpi",
    "kop": "kɒp",
    "kor": "kɔː",
    "korma": "kɔːmɐ",
    "koruna": "kɔːruːnɐ",
    "kosher": "kəʊʃɐ",
    "kos": "kɒs",
    "koto": "kəʊtəʊ",
    "kowtowed": "kaʊtaʊd",
    "kowtowing": "kaʊtaʊɪŋ",
    "kowtow": "kaʊtaʊ",
    "kowtows": "kaʊtaʊz",
    "kph": "keɪpiːeɪtʃ",
    "kraft": "krɑːft",
    "krait": "kreɪt",
    "kraits": "kreɪts",
    "kraken": "kreɪkən",
    "kraut": "kraʊt",
    "krauts": "kraʊts",
    "kremlin": "krɛmlɪn",
    "kreutzer": "krjuːtsɐ",
    "krill": "krɪl",
    "kris": "krɪs",
    "krone": "krəʊn",
    "kroner": "krəʊnɐ",
    "krugerrand": "kruːdʒɪrænd",
    "krypton": "krɪptən",
    "ks": "keɪɛs",
    "kuchen": "kuːtʃən",
    "kudo": "kjuːdəʊ",
    "kudos": "kjuːdəʊz",
    "kudu": "kuːduː",
    "kudus": "kjuːdəs",
    "kukri": "kʌkri",
    "kulak": "kjʊlæk",
    "kulaks": "kjʊlæks",
    "kumquat": "kʌmkwæt",
    "kumquats": "kʌmkwæts",
    "kuna": "kuːnɐ",
    "kurus": "kjʊrəs",
    "kvetch": "keɪvɛtʃ",
    "kwacha": "kwætʃɐ",
    "kwanza": "kwænzɐ",
    "kwashiorkor": "kwɒʃiəkɐ",
    "kw": "keɪdʌbəljuː",
    "kyat": "kaɪæt",
    "kyle": "kaɪl",
    "kyles": "kaɪlz",
    "kylix": "kaɪlɪks",
    "label": "leɪbəl",
    "labelled": "leɪbəld",
    "labelling": "leɪbəlɪŋ",
    "labels": "leɪbəlz",
    "labia": "leɪbiɐ",
    "labial": "leɪbɪəl",
    "lability": "ləbɪlɪti",
    "lab": "læb",
    "laboratories": "lɐbɒrətrɪz",
    "laboratory": "lɐbɒrətri",
    "laborious": "lɐbɔːrɪəs",
    "laboriously": "lɐbɔːrɪəsli",
    "labor": "leɪbɐ",
    "laboured": "leɪbəd",
    "labourer": "leɪbɜːrɐ",
    "labourers": "leɪbɜːrəz",
    "labouring": "leɪbɜːrɪŋ",
    "labour": "leɪbɐ",
    "labours": "leɪbəz",
    "labradorite": "læbrɐdɔːraɪt",
    "labs": "læbz",
    "laburnum": "læbɜːnəm",
    "laburnums": "læbɜːnəmz",
    "labyrinthian": "læbɪrɪnθiən",
    "labyrinthine": "læbərɪnθiːn",
    "labyrinth": "læbərɪnθ",
    "labyrinths": "læbərɪnθs",
    "laced": "leɪst",
    "lace": "leɪs",
    "lacerated": "læsəreɪtɪd",
    "lacerate": "læsəreɪt",
    "lacerating": "læsəreɪtɪŋ",
    "laceration": "læsəreɪʃən",
    "lacerations": "læsəreɪʃənz",
    "lacer": "leɪsɐ",
    "laces": "leɪsɪz",
    "lacewing": "leɪsuːɪŋ",
    "lacewings": "leɪsuːɪŋz",
    "lacework": "leɪswɜːk",
    "lachrymal": "lækrɪməl",
    "lachrymosity": "lækrɪmɒsɪti",
    "lacing": "leɪsɪŋ",
    "lacings": "leɪsɪŋz",
    "lackadaisical": "lækɐdeɪzɪkəl",
    "lacked": "lækt",
    "lackey": "læki",
    "lackeys": "lækɪz",
    "lacking": "lækɪŋ",
    "lack": "læk",
    "lacklustre": "læklʌstɐ",
    "lacks": "læks",
    "lac": "læk",
    "laconic": "lækɒnɪk",
    "lacquered": "lækəd",
    "lacquering": "lækərɪŋ",
    "lacquer": "lækɐ",
    "lacquers": "lækəz",
    "lacrimal": "lækrɪməl",
    "lacrosse": "lækrɒs",
    "lactam": "læktæm",
    "lactate": "lækteɪt",
    "lactating": "lækteɪtɪŋ",
    "lactation": "lækteɪʃən",
    "lactic": "læktɪk",
    "lactobacillus": "læktəbæsɪləs",
    "lactose": "læktəʊz",
    "lacuna": "lækuːnɐ",
    "lacy": "leɪsi",
    "laddered": "lædəd",
    "laddering": "lædərɪŋ",
    "ladder": "lædɐ",
    "ladders": "lædəz",
    "laddie": "lædi",
    "laddies": "lædɪz",
    "laddish": "lædɪʃ",
    "laddishness": "lædɪʃnəs",
    "lade": "leɪd",
    "laden": "leɪdən",
    "ladies": "leɪdɪz",
    "lading": "leɪdɪŋ",
    "lad": "læd",
    "ladled": "lædəld",
    "ladle": "leɪdəl",
    "ladles": "leɪdəlz",
    "ladling": "lædlɪŋ",
    "lads": "lædz",
    "ladybird": "leɪdɪbɜːd",
    "ladybirds": "leɪdɪbɜːdz",
    "ladybug": "leɪdɪbʌɡ",
    "ladybugs": "leɪdɪbʌɡz",
    "lady": "leɪdi",
    "ladylike": "leɪdɪlaɪk",
    "ladyship": "leɪdɪʃɪp",
    "ladyships": "leɪdɪʃɪps",
    "lagan": "læɡən",
    "lager": "lɑːɡɐ",
    "lagers": "lɑːɡəz",
    "laggard": "læɡəd",
    "lagged": "læɡd",
    "lagger": "læɡɐ",
    "lagging": "læɡɪŋ",
    "lag": "læɡ",
    "lagoon": "lɐɡuːn",
    "lagoons": "lɐɡuːnz",
    "lags": "læɡz",
    "laid": "leɪd",
    "lain": "leɪn",
    "laird": "leəd",
    "lairds": "leədz",
    "lair": "leə",
    "lairs": "leəz",
    "laity": "leɪəti",
    "lake": "leɪk",
    "laker": "leɪkɐ",
    "lakeside": "leɪksaɪd",
    "lakes": "leɪks",
    "lakh": "læk",
    "la": "læ",
    "lama": "lɑːmɐ",
    "lamas": "lɑːməz",
    "lambada": "læmbɑːdɐ",
    "lambasted": "læmbɑːstɪd",
    "lambasting": "læmbɑːstɪŋ",
    "lambast": "læmbɑːst",
    "lambasts": "læmbɑːsts",
    "lambda": "læmbdɐ",
    "lambed": "læmd",
    "lambert": "læmbət",
    "lamberts": "læmbəts",
    "lambing": "læmɪŋ",
    "lambkin": "læmbkɪn",
    "lamb": "læm",
    "lambs": "læmz",
    "lambswool": "læmbswʊl",
    "lameness": "leɪmnəs",
    "lamentable": "lɐmɛntəbəl",
    "lamentably": "lɐmɛntəbli",
    "lamentation": "lɐmɪnteɪʃən",
    "lamentations": "lɐmɪnteɪʃənz",
    "lamented": "lɐmɛntɪd",
    "lamenting": "lɐmɛntɪŋ",
    "lament": "lɐmɛnt",
    "laments": "lɐmɛnts",
    "lamer": "leɪmɐ",
    "lamest": "leɪməst",
    "lamia": "læmiɐ",
    "lamina": "læmɪnɐ",
    "laminar": "læmɪnɑː",
    "laminated": "læmɪneɪtɪd",
    "laminates": "læmɪneɪts",
    "laminating": "læmɪneɪtɪŋ",
    "lamination": "læmɪneɪʃən",
    "laming": "leɪmɪŋ",
    "laminitis": "læmɪnaɪtɪs",
    "lam": "læm",
    "lammergeier": "læmɜːdʒaɪɐ",
    "lammergeiers": "læmɜːdʒaɪəz",
    "lamming": "læmɪŋ",
    "lamp": "læmp",
    "lamplighter": "læmplaɪtɐ",
    "lamplight": "læmplaɪt",
    "lampooned": "læmpuːnd",
    "lampooning": "læmpuːnɪŋ",
    "lampoon": "læmpuːn",
    "lampoons": "læmpuːnz",
    "lamppost": "læmpəʊst",
    "lampposts": "læmpəʊsts",
    "lamprey": "læmpri",
    "lampreys": "læmprɪz",
    "lampshade": "læmpʃeɪd",
    "lampshades": "læmpʃeɪdz",
    "lamps": "læmps",
    "lams": "læmz",
    "lanai": "lænaɪ",
    "lanced": "lɑːnst",
    "lancelet": "lɑːnsɛlət",
    "lance": "lɑːns",
    "lancer": "lɑːnsɐ",
    "lancers": "lɑːnsəz",
    "lances": "lɑːnsɪz",
    "lancet": "lɑːnsɪt",
    "lancets": "lɑːnsɪts",
    "lancing": "lɑːnsɪŋ",
    "landau": "lændaʊ",
    "landaus": "lændaʊs",
    "landed": "lændɪd",
    "lander": "lændɐ",
    "landfall": "lændfɔːl",
    "landfill": "lændfɪl",
    "landfills": "lændfɪlz",
    "landform": "lændfɔːm",
    "landforms": "lændfɔːmz",
    "landholder": "lændhəʊldɐ",
    "landholders": "lændhəʊldəz",
    "landholding": "lændhəʊldɪŋ",
    "landholdings": "lændhəʊldɪŋz",
    "landing": "lændɪŋ",
    "landings": "lændɪŋz",
    "landladies": "lændleɪdɪz",
    "landlady": "lændleɪdi",
    "land": "lænd",
    "landless": "lændləs",
    "landlines": "lændlaɪnz",
    "landlocked": "lændlɒkt",
    "landlord": "lændlɔːd",
    "landlords": "lændlɔːdz",
    "landlubber": "lændlʌbɐ",
    "landlubbers": "lændlʌbəz",
    "landmark": "lændmɑːk",
    "landmarks": "lændmɑːks",
    "landmasses": "lændmæsɪz",
    "landmass": "lændmæs",
    "landmine": "lændmaɪn",
    "landmines": "lændmaɪnz",
    "landowner": "lændəʊnɐ",
    "landowners": "lændəʊnəz",
    "landowning": "lændaʊnɪŋ",
    "landscaped": "lændskeɪpt",
    "landscape": "lændskeɪp",
    "landscaper": "lændskeɪpɐ",
    "landscapers": "lændskeɪpəz",
    "landscapes": "lændskeɪps",
    "landscaping": "lændskeɪpɪŋ",
    "landscapist": "lændskeɪpɪst",
    "landside": "lændsaɪd",
    "lands": "lændz",
    "landslide": "lændslaɪd",
    "landslides": "lændslaɪdz",
    "landslip": "lændslɪp",
    "landslips": "lændslɪps",
    "landsman": "lændzmən",
    "landsmen": "lændzmɛn",
    "landward": "lændwəd",
    "lane": "leɪn",
    "lanes": "leɪnz",
    "langlauf": "læŋɡlɔːf",
    "language": "læŋɡwɪdʒ",
    "languages": "læŋɡwɪdʒɪz",
    "langue": "læŋ",
    "languid": "læŋɡwɪd",
    "languidly": "læŋɡwɪdli",
    "languished": "læŋɡwɪʃt",
    "languishes": "læŋɡwɪʃɪz",
    "languishing": "læŋɡwɪʃɪŋ",
    "languish": "læŋɡwɪʃ",
    "languor": "læŋɡjuːɐ",
    "languorous": "læŋɡjuːərəs",
    "languorously": "læŋɡjuːərəsli",
    "langur": "læŋɡɐ",
    "langurs": "læŋɡəz",
    "lank": "læŋk",
    "lanky": "læŋki",
    "lanner": "lænɐ",
    "lanolin": "lænəlɪn",
    "lantern": "lɑːntən",
    "lanterns": "lɑːntənz",
    "lanthanides": "lɑːnθɐnaɪdz",
    "lanthanum": "lɑːnθænəm",
    "lanyard": "lænjɑːd",
    "lanyards": "lænjɑːdz",
    "laparoscope": "læpɐrɒskəʊp",
    "laparoscopically": "læpɐrəskɒpɪkli",
    "laparoscopic": "læpɐrəskɒpɪk",
    "laparoscopy": "læpɐrɒskəpi",
    "laparotomy": "læpɐrəʊtəmi",
    "lapdog": "læpdɒɡ",
    "lapdogs": "læpdɒɡz",
    "lapel": "lɐpɛl",
    "lapels": "lɐpɛlz",
    "lapidary": "læpɪdəri",
    "lapin": "læpɪn",
    "lapins": "læpɪnz",
    "lap": "læp",
    "lapped": "læpt",
    "lappet": "læpɪt",
    "lapping": "læpɪŋ",
    "lapsed": "læpsd",
    "lapse": "læps",
    "lapses": "læpsɪz",
    "lapsing": "læpsɪŋ",
    "laps": "læps",
    "laptop": "læptɒp",
    "laptops": "læptɒps",
    "lapwing": "læpwɪŋ",
    "lapwings": "læpwɪŋz",
    "larboard": "lɑːbɔːd",
    "larcenist": "lɑːsənɪst",
    "larceny": "lɑːsəni",
    "larches": "lɑːtʃɪz",
    "larch": "lɑːtʃ",
    "larded": "lɑːdɪd",
    "larder": "lɑːdɐ",
    "larders": "lɑːdəz",
    "larding": "lɑːdɪŋ",
    "lard": "lɑːd",
    "lardon": "lɑːdən",
    "lards": "lɑːdz",
    "lardy": "lɑːdi",
    "lares": "leəz",
    "large": "lɑːdʒ",
    "largely": "lɑːdʒli",
    "largeness": "lɑːdʒnəs",
    "larger": "lɑːdʒɐ",
    "larges": "lɑːdʒɪz",
    "largesse": "lɑːdʒɛs",
    "largess": "lɑːdʒɛs",
    "largest": "lɑːdʒəst",
    "largish": "lɑːdʒɪʃ",
    "largo": "lɑːɡəʊ",
    "lariat": "leərɪæt",
    "lari": "lɑːri",
    "larked": "lɑːkt",
    "larking": "lɑːkɪŋ",
    "lark": "lɑːk",
    "larks": "lɑːks",
    "larkspur": "lɑːkspɔː",
    "lar": "lɑː",
    "larrikin": "lærɪkɪn",
    "larvae": "lɑːviː",
    "larval": "lɑːvəl",
    "larva": "lɑːvɐ",
    "laryngeal": "lærɪndʒiəl",
    "laryngitis": "lærɪndʒaɪtɪs",
    "laryngoscope": "lærɪŋɡɒskəʊp",
    "larynx": "lærɪŋks",
    "lasagna": "ləzænjɐ",
    "lasagnas": "ləzænjəz",
    "lasagne": "ləzænjɐ",
    "lasagnes": "læsæɡnɪz",
    "lascar": "læskɑː",
    "lascars": "læskɑːz",
    "lascivious": "lɐsɪvɪəs",
    "lasciviously": "lɐsɪvɪəsli",
    "lasciviousness": "lɐsɪvɪəsnəs",
    "laser": "leɪzɐ",
    "lasers": "leɪzəz",
    "lashed": "læʃt",
    "lashes": "læʃɪz",
    "lashing": "læʃɪŋ",
    "lashings": "læʃɪŋz",
    "lash": "læʃ",
    "lasing": "leɪsɪŋ",
    "lasses": "læsɪz",
    "lassie": "læsi",
    "lassies": "læsɪz",
    "lassitude": "læsɪtjuːd",
    "lass": "læs",
    "lassoed": "læsəʊd",
    "lassoes": "læsuːz",
    "lassoing": "læsuːɪŋ",
    "lasso": "læsuː",
    "lassos": "læsuːz",
    "lasted": "lɑːstɪd",
    "lasting": "lɑːstɪŋ",
    "last": "lɑːst",
    "lastly": "lɑːstli",
    "lasts": "lɑːsts",
    "latched": "lætʃt",
    "latches": "lætʃɪz",
    "latching": "lætʃɪŋ",
    "latch": "lætʃ",
    "latecomer": "leɪtkʌmɐ",
    "latecomers": "leɪtkʌməz",
    "lated": "leɪtɪd",
    "lateen": "lætiːn",
    "late": "leɪt",
    "lately": "leɪtli",
    "latency": "leɪtnsi",
    "lateness": "leɪtnəs",
    "latent": "leɪtənt",
    "lateral": "lætərəl",
    "laterally": "lætərəli",
    "laterals": "lætərəlz",
    "laterite": "lætəraɪt",
    "later": "leɪtɐ",
    "latest": "leɪtəst",
    "latex": "leɪtɛks",
    "lathe": "leɪð",
    "lathered": "lɑːðəd",
    "lathering": "lɑːðərɪŋ",
    "lathes": "leɪðz",
    "lathing": "leɪðɪŋ",
    "lath": "lɑːθ",
    "laths": "lɑːθs",
    "latino": "lætiːnəʊ",
    "latitude": "lætɪtjuːd",
    "latitudes": "lætɪtjuːdz",
    "latke": "lætk",
    "latkes": "lætks",
    "latrine": "lɐtriːn",
    "latrines": "lɐtriːnz",
    "lats": "læts",
    "latte": "lɑːteɪ",
    "latter": "lætɐ",
    "latterly": "lætəli",
    "lattes": "lɑːteɪs",
    "latticed": "lætɪst",
    "lattice": "lætɪs",
    "lattices": "lætɪsɪz",
    "latticework": "lætɪswɜːk",
    "laudable": "lɔːdəbəl",
    "laudanum": "lɔːdænəm",
    "lauded": "lɔːdɪd",
    "lauder": "lɔːdɐ",
    "lauding": "lɔːdɪŋ",
    "laud": "lɔːd",
    "laughable": "lɑːfəbəl",
    "laughably": "lɑːfəbli",
    "laughed": "lɑːfd",
    "laugher": "lɑːfɐ",
    "laughers": "lɑːfəz",
    "laughing": "lɑːfɪŋ",
    "laughingly": "lɑːfɪŋli",
    "laugh": "lɑːf",
    "laughs": "lɑːfz",
    "laughter": "lɑːftɐ",
    "launce": "lɔːns",
    "launched": "lɔːntʃt",
    "launcher": "lɔːntʃɐ",
    "launchers": "lɔːntʃəz",
    "launches": "lɔːntʃɪz",
    "launching": "lɔːntʃɪŋ",
    "launch": "lɔːntʃ",
    "launchpad": "lɔːntʃpæd",
    "laundered": "lɔːndəd",
    "launderer": "lɔːndərɐ",
    "launderers": "lɔːndərəz",
    "launderette": "lɔːndərɛt",
    "launderettes": "lɔːndərɛts",
    "laundering": "lɔːndərɪŋ",
    "launder": "lɔːndɐ",
    "laundresses": "lɔːndrɛsɪz",
    "laundress": "lɔːndrɛs",
    "laundrette": "lɔːndrɛt",
    "laundrettes": "lɔːndrɛts",
    "laundries": "lɔːndrɪz",
    "laundromat": "lɔːndrəmæt",
    "laundry": "lɔːndri",
    "laundryman": "lɔːndrɪmən",
    "laureate": "lɔːriːt",
    "laureates": "lɔːriːts",
    "laurel": "lɔːrəl",
    "laurels": "lɔːrəlz",
    "lavage": "lævɪdʒ",
    "lavaliere": "lævɐlieə",
    "lava": "lɑːvɐ",
    "lavas": "lɑːvəz",
    "lavatorial": "lævɐtɔːrɪəl",
    "lavatories": "lævətəriz",
    "lavatory": "lævətəri",
    "lave": "leɪv",
    "lavender": "lævəndɐ",
    "lavenders": "lævəndəz",
    "laver": "leɪvɐ",
    "lavers": "leɪvəz",
    "lavished": "lævɪʃt",
    "lavishes": "lævɪʃɪz",
    "lavishing": "lævɪʃɪŋ",
    "lavish": "lævɪʃ",
    "lavishly": "lævɪʃli",
    "lavishness": "lævɪʃnəs",
    "lav": "læv",
    "lavs": "lævz",
    "lawbreaker": "lɔːbreɪkɐ",
    "lawbreakers": "lɔːbreɪkəz",
    "lawbreaking": "lɔːbreɪkɪŋ",
    "lawful": "lɔːfəl",
    "lawfully": "lɔːfəli",
    "lawfulness": "lɔːfəlnəs",
    "lawless": "lɔːləs",
    "lawlessness": "lɔːləsnəs",
    "law": "lɔː",
    "lawmaker": "lɔːmeɪkɐ",
    "lawmakers": "lɔːmeɪkəz",
    "lawmaking": "lɔːmeɪkɪŋ",
    "lawman": "lɔːmən",
    "lawmen": "lɔːmɛn",
    "lawn": "lɔːn",
    "lawnmower": "lɔːnməʊɐ",
    "lawnmowers": "lɔːnməʊəz",
    "lawns": "lɔːnz",
    "laws": "lɔːz",
    "lawsuit": "lɔːsuːt",
    "lawsuits": "lɔːsuːts",
    "lawyer": "lɔɪɐ",
    "lawyerly": "lɔɪəli",
    "lawyers": "lɔɪəz",
    "laxative": "læksətɪv",
    "laxatives": "læksətɪvz",
    "laxer": "læksɐ",
    "laxity": "læksɪti",
    "lax": "læks",
    "laxly": "læksli",
    "layabout": "leɪɐbaʊt",
    "layabouts": "leɪɐbaʊts",
    "layered": "leɪəd",
    "layering": "leɪərɪŋ",
    "layette": "leɪɛt",
    "laying": "leɪɪŋ",
    "lay": "leɪ",
    "layman": "leɪmən",
    "laymen": "leɪmɛn",
    "layoff": "leɪɒf",
    "layoffs": "leɪɒfs",
    "layout": "leɪaʊt",
    "layouts": "leɪaʊts",
    "layover": "leɪəʊvɐ",
    "layperson": "leɪpəsən",
    "lays": "leɪz",
    "lazar": "leɪzɑː",
    "laze": "leɪz",
    "lazier": "leɪzɪɐ",
    "laziest": "leɪzɪəst",
    "lazily": "leɪzɪli",
    "laziness": "leɪzɪnəs",
    "lazing": "leɪzɪŋ",
    "lazuli": "leɪzjʊlaɪ",
    "lazybones": "leɪzɪbəʊnz",
    "lazy": "leɪzi",
    "leached": "liːtʃt",
    "leaches": "liːtʃɪz",
    "leaching": "liːtʃɪŋ",
    "leach": "liːtʃ",
    "leaded": "lɛdɪd",
    "leaden": "lɛdən",
    "leaderless": "liːdələs",
    "leader": "liːdɐ",
    "leadership": "liːdəʃɪp",
    "leaderships": "liːdəʃɪps",
    "leaders": "liːdəz",
    "leafage": "liːfɪdʒ",
    "leafed": "liːft",
    "leafier": "liːfiɐ",
    "leafiest": "liːfiəst",
    "leafing": "liːfɪŋ",
    "leafless": "liːfləs",
    "leafleted": "liːfliːtɪd",
    "leafleting": "liːfliːtɪŋ",
    "leaflet": "liːflət",
    "leaflets": "liːfləts",
    "leaf": "liːf",
    "leafs": "liːfs",
    "leafy": "liːfi",
    "league": "liːɡ",
    "leagues": "liːɡz",
    "leakage": "liːkɪdʒ",
    "leakages": "liːkɪdʒɪz",
    "leaked": "liːkt",
    "leaker": "liːkɐ",
    "leakiness": "liːkɪnəs",
    "leaking": "liːkɪŋ",
    "leak": "liːk",
    "leaks": "liːks",
    "leaky": "liːki",
    "lea": "liː",
    "leal": "liːl",
    "leaned": "liːnd",
    "leaner": "liːnɐ",
    "leanest": "liːnəst",
    "leaning": "liːnɪŋ",
    "leanings": "liːnɪŋz",
    "lean": "liːn",
    "leanness": "liːnnəs",
    "leans": "liːnz",
    "leaped": "liːpt",
    "leaper": "liːpɐ",
    "leapfrogged": "liːpfrɒɡd",
    "leapfrogging": "liːpfrɒɡɪŋ",
    "leapfrog": "liːpfrɒɡ",
    "leapfrogs": "liːpfrɒɡz",
    "leaping": "liːpɪŋ",
    "leap": "liːp",
    "leaps": "liːps",
    "leapt": "lɛpt",
    "learner": "lɜːnɐ",
    "learners": "lɜːnəz",
    "learning": "lɜːnɪŋ",
    "learn": "lɜːn",
    "learns": "lɜːnz",
    "learnt": "lɜːnt",
    "leaseback": "liːsbæk",
    "leased": "liːsd",
    "leaseholder": "liːshəʊldɐ",
    "leaseholders": "liːshəʊldəz",
    "leasehold": "liːshəʊld",
    "leaseholds": "liːshəʊldz",
    "lease": "liːs",
    "leases": "liːsɪz",
    "leashed": "liːʃt",
    "leashes": "liːʃɪz",
    "leash": "liːʃ",
    "leas": "liːz",
    "least": "liːst",
    "leatherback": "lɛðəbæk",
    "leatherbacks": "lɛðəbæks",
    "leatherette": "lɛðərɛt",
    "leatherjacket": "lɛðədʒækɪt",
    "leather": "lɛðɐ",
    "leatherneck": "lɛðənɛk",
    "leathern": "lɛðən",
    "leathers": "lɛðəz",
    "leathery": "lɛðəri",
    "leaved": "liːvd",
    "leave": "liːv",
    "leavened": "lɛvənd",
    "leavening": "lɛvənɪŋ",
    "leaven": "lɛvən",
    "leavens": "lɛvənz",
    "leaver": "liːvɐ",
    "leavers": "liːvəz",
    "leaves": "liːvz",
    "leaving": "liːvɪŋ",
    "leavings": "liːvɪŋz",
    "lebensraum": "lɛbənsraʊm",
    "lebkuchen": "lɛbkuːtʃən",
    "lecher": "lɛtʃɐ",
    "lecherous": "lɛtʃərəs",
    "lechery": "lɛtʃəri",
    "leches": "lɛtʃɪz",
    "leching": "lɛtʃɪŋ",
    "lecithin": "lɛsɪθɪn",
    "lectern": "lɛktən",
    "lecterns": "lɛktənz",
    "lection": "lɛkʃən",
    "lector": "lɛktɐ",
    "lectured": "lɛktʃəd",
    "lecture": "lɛktʃɐ",
    "lecturer": "lɛktʃərɐ",
    "lecturers": "lɛktʃərəz",
    "lectureship": "lɛktʃəʃɪp",
    "lectures": "lɛktʃəz",
    "lecturing": "lɛktʃərɪŋ",
    "lederhosen": "lɛdəhəʊzən",
    "ledge": "lɛdʒ",
    "ledger": "lɛdʒɐ",
    "ledgers": "lɛdʒəz",
    "ledges": "lɛdʒɪz",
    "led": "lɛd",
    "leeboard": "liːbɔːd",
    "leeched": "liːtʃt",
    "leeches": "liːtʃɪz",
    "leeching": "liːtʃɪŋ",
    "leech": "liːtʃ",
    "leek": "liːk",
    "leeks": "liːks",
    "lee": "liː",
    "leered": "liəd",
    "leering": "liərɪŋ",
    "leer": "liə",
    "leers": "liəz",
    "leery": "liəri",
    "lees": "liːz",
    "leet": "liːt",
    "leeward": "liːwəd",
    "leeway": "liːweɪ",
    "lefter": "lɛftɐ",
    "leftie": "lɛfti",
    "lefties": "lɛftɪz",
    "leftism": "lɛftɪzəm",
    "leftist": "lɛftɪst",
    "leftists": "lɛftɪsts",
    "left": "lɛft",
    "leftover": "lɛftəʊvɐ",
    "leftovers": "lɛftəʊvəz",
    "lefts": "lɛfts",
    "leftward": "lɛftwəd",
    "leftwards": "lɛftwədz",
    "lefty": "lɛfti",
    "legacies": "lɛɡəsɪz",
    "legacy": "lɛɡəsi",
    "legalese": "liːɡəliːz",
    "legalisation": "liːɡəlaɪzeɪʃən",
    "legalised": "liːɡəlaɪzd",
    "legalise": "liːɡəlaɪz",
    "legalises": "liːɡəlaɪzɪz",
    "legalising": "liːɡəlaɪzɪŋ",
    "legalism": "liːɡəlɪzəm",
    "legalistically": "liːɡəlɪstɪkli",
    "legalistic": "liːɡəlɪstɪk",
    "legalities": "liːɡælɪtiz",
    "legality": "liːɡælɪti",
    "legal": "liːɡəl",
    "legally": "liːɡəli",
    "legals": "liːɡəlz",
    "legation": "lɛɡeɪʃən",
    "legato": "lɛɡɑːtəʊ",
    "legendarily": "lɛdʒəndɛrəli",
    "legendary": "lɛdʒəndəri",
    "legend": "lɛdʒənd",
    "legends": "lɛdʒəndz",
    "legerdemain": "lɛdʒədɪmeɪn",
    "leggiest": "lɛɡɪəst",
    "legging": "lɛɡɪŋ",
    "leggings": "lɛɡɪŋz",
    "leggy": "lɛɡi",
    "leghorn": "lɛɡhɔːn",
    "leghorns": "lɛɡhɔːnz",
    "legibility": "lɛdʒəbɪlɪti",
    "legible": "lɛdʒəbəl",
    "legibly": "lɛdʒəbli",
    "legionaries": "liːdʒənəriz",
    "legionary": "liːdʒənəri",
    "legion": "liːdʒən",
    "legionnaire": "liːdʒəneə",
    "legionnaires": "liːdʒəneəz",
    "legions": "liːdʒənz",
    "legislated": "lɛdʒɪsleɪtɪd",
    "legislate": "lɛdʒɪsleɪt",
    "legislates": "lɛdʒɪsleɪts",
    "legislating": "lɛdʒɪsleɪtɪŋ",
    "legislation": "lɛdʒɪsleɪʃən",
    "legislative": "lɛdʒɪslətɪv",
    "legislatively": "lɛdʒɪslətɪvli",
    "legislator": "lɛdʒɪsleɪtɐ",
    "legislators": "lɛdʒɪsleɪtəz",
    "legislature": "lɛdʒɪslətʃɐ",
    "legislatures": "lɛdʒɪslətʃəz",
    "legitimacy": "lədʒɪtɪməsi",
    "legitimated": "lədʒɪtɪmeɪtɪd",
    "legitimately": "lədʒɪtɪmətli",
    "legitimisation": "lədʒɪtɪmaɪzeɪʃən",
    "legitimised": "lədʒɪtɪmaɪzd",
    "legitimise": "lədʒɪtɪmaɪz",
    "legitimises": "lədʒɪtɪmaɪzɪz",
    "legitimising": "lədʒɪtɪmaɪzɪŋ",
    "legit": "lədʒɪt",
    "leg": "lɛɡ",
    "legless": "lɛɡləs",
    "legroom": "lɛɡruːm",
    "legs": "lɛɡz",
    "legume": "lɛɡjuːm",
    "legumes": "lɛɡjuːmz",
    "leguminous": "lɛɡjuːmɪnəs",
    "legwarmer": "lɛɡwɔːmɐ",
    "legwarmers": "lɛɡwɔːməz",
    "legwork": "lɛɡwɜːk",
    "lei": "leɪ",
    "leishmaniasis": "lɛʃmeɪnɪæsiz",
    "leis": "leɪz",
    "leisured": "lɛʒəd",
    "leisure": "lɛʒɐ",
    "leisurely": "lɛʒəli",
    "leisurewear": "lɛsəruːeə",
    "leitmotif": "leɪtmətɪf",
    "lek": "lɛk",
    "leks": "lɛks",
    "l": "ɛl",
    "leman": "lɛmən",
    "lemma": "lɛmɐ",
    "lemme": "lɛmi",
    "lemming": "lɛmɪŋ",
    "lemmings": "lɛmɪŋz",
    "lemniscate": "lɛmnɪskeɪt",
    "lemonade": "lɛməneɪd",
    "lemonades": "lɛməneɪdz",
    "lemongrass": "lɛməŋɡrɑːs",
    "lemon": "lɛmən",
    "lemons": "lɛmənz",
    "lemony": "lɛməni",
    "lemur": "liːmɐ",
    "lemurs": "liːməz",
    "lender": "lɛndɐ",
    "lenders": "lɛndəz",
    "lending": "lɛndɪŋ",
    "lend": "lɛnd",
    "lends": "lɛndz",
    "lengthened": "lɛŋθənd",
    "lengthening": "lɛŋθənɪŋ",
    "lengthen": "lɛŋθən",
    "lengthens": "lɛŋθənz",
    "lengthier": "lɛŋθɪɐ",
    "length": "lɛŋθ",
    "lengths": "lɛŋθs",
    "lengthways": "lɛŋθweɪz",
    "lengthwise": "lɛŋθwaɪz",
    "lengthy": "lɛŋθi",
    "lenience": "liːnɪəns",
    "leniency": "liːnɪənsi",
    "lenient": "liːnɪənt",
    "leniently": "liːnɪəntli",
    "leno": "liːnəʊ",
    "lenses": "lɛnzɪz",
    "lensing": "lɛnzɪŋ",
    "lenten": "lɛntən",
    "lenticularis": "lɛntɪkjʊlɑːrɪs",
    "lenticular": "lɛntɪkjʊlɐ",
    "lentigo": "lɛntɪɡəʊ",
    "lentil": "lɛntəl",
    "lentils": "lɛntəlz",
    "lent": "lɛnt",
    "lento": "lɛntəʊ",
    "leone": "liːəʊn",
    "leonine": "liənaɪn",
    "leopard": "lɛpəd",
    "leopards": "lɛpədz",
    "leotard": "liətɑːd",
    "leotards": "liətɑːdz",
    "leper": "lɛpɐ",
    "lepers": "lɛpəz",
    "lepidopteran": "lɛpɪdɒptərən",
    "lepidopterist": "lɛpɪdɒptərɪst",
    "leporine": "lɛpɔːriːn",
    "leprechaun": "lɛprəkɔːn",
    "leprechauns": "lɛprəkɔːnz",
    "leprosy": "lɛprəsi",
    "leprous": "lɛprəs",
    "leptin": "lɛptɪn",
    "lept": "lɛpt",
    "lepton": "lɛptən",
    "leptons": "lɛptənz",
    "leptospirosis": "lɛptəspɪrəʊsɪs",
    "lesbianism": "lɛsbiənɪzəm",
    "lesbian": "lɛsbiən",
    "lesbians": "lɛsbiənz",
    "lesion": "liːʒən",
    "lesions": "liːʒənz",
    "lessee": "lɛsiː",
    "lessened": "lɛsənd",
    "lessening": "lɛsənɪŋ",
    "lessen": "lɛsən",
    "lessens": "lɛsənz",
    "lesser": "lɛsɐ",
    "less": "lɛs",
    "lesson": "lɛsən",
    "lessons": "lɛsənz",
    "lest": "lɛst",
    "letdown": "lɛtdaʊn",
    "letdowns": "lɛtdaʊnz",
    "lethality": "lɛθælɪti",
    "lethal": "liːθəl",
    "lethally": "liːθəli",
    "lethargic": "lɛθɑːdʒɪk",
    "lethargy": "lɛθədʒi",
    "lethe": "lɛð",
    "let": "lɛt",
    "lets": "lɛts",
    "letterboxes": "lɛtəbɒksɪz",
    "letterbox": "lɛtəbɒks",
    "lettered": "lɛtəd",
    "letterhead": "lɛtəhɛd",
    "letterheads": "lɛtəhɛdz",
    "lettering": "lɛtərɪŋ",
    "letter": "lɛtɐ",
    "letters": "lɛtəz",
    "letting": "lɛtɪŋ",
    "lettings": "lɛtɪŋz",
    "lettuce": "lɛtɪs",
    "lettuces": "lɛtɪsɪz",
    "letup": "lɛtʌp",
    "leucine": "luːsiːn",
    "leucocytes": "luːkəsaɪts",
    "leucotomies": "luːkɒtəmɪz",
    "leukaemia": "luːkiːmiə",
    "leukocytes": "luːkəsaɪts",
    "leu": "luː",
    "leva": "lɛvɐ",
    "levant": "ləvænt",
    "levee": "lɛviː",
    "levees": "lɛviːz",
    "levelled": "lɛvəld",
    "leveller": "lɛvəlɐ",
    "levellers": "lɛvɛləz",
    "level": "lɛvəl",
    "levelling": "lɛvəlɪŋ",
    "levels": "lɛvəlz",
    "leveraged": "liːvərɪdʒd",
    "leverage": "liːvərɪdʒ",
    "leverages": "liːvərɪdʒɪz",
    "leveraging": "liːvərɪdʒɪŋ",
    "levered": "liːvəd",
    "leveret": "liːvərət",
    "leverets": "liːvərəts",
    "levering": "liːvərɪŋ",
    "lever": "liːvɐ",
    "levers": "liːvəz",
    "leviathan": "lɛvaɪəθən",
    "leviathans": "lɛvaɪəθənz",
    "levied": "lɛvɪd",
    "levies": "lɛvɪz",
    "levin": "lɛvɪn",
    "levis": "lɛvɪs",
    "levitated": "lɛvɪteɪtɪd",
    "levitate": "lɛvɪteɪt",
    "levitates": "lɛvɪteɪts",
    "levitating": "lɛvɪteɪtɪŋ",
    "levitation": "lɛvɪteɪʃən",
    "levity": "lɛvɪti",
    "lev": "lɛv",
    "levying": "lɛvɪɪŋ",
    "levy": "lɛvi",
    "lewd": "luːd",
    "lewdly": "luːdli",
    "lewdness": "luːdnəs",
    "lewis": "luːiz",
    "lexicographer": "lɛksɪkɒɡrəfɐ",
    "lexicon": "lɛksɪkən",
    "ley": "leɪ",
    "leys": "leɪz",
    "liabilities": "laɪəbɪlɪtiz",
    "liability": "laɪəbɪlɪti",
    "liable": "laɪəbəl",
    "liaised": "lɪeɪzd",
    "liaise": "lɪeɪz",
    "liaises": "lɪeɪzɪz",
    "liaising": "lɪeɪzɪŋ",
    "liaison": "liːeɪzɒn",
    "liaisons": "liːeɪzɒnz",
    "liana": "laɪənɐ",
    "lianas": "laɪənəz",
    "liar": "laɪə",
    "liars": "laɪəz",
    "libation": "lɪbeɪʃən",
    "libations": "lɪbeɪʃənz",
    "libber": "lɪbɐ",
    "libbers": "lɪbəz",
    "libel": "laɪbəl",
    "libelled": "laɪbəld",
    "libelling": "laɪbəlɪŋ",
    "libellous": "laɪbələs",
    "libelous": "laɪbələs",
    "libels": "laɪbəlz",
    "liberalisation": "lɪbərəlaɪzeɪʃən",
    "liberalised": "lɪbərəlaɪzd",
    "liberalise": "lɪbərəlaɪz",
    "liberalising": "lɪbərəlaɪzɪŋ",
    "liberalism": "lɪbərəlɪzəm",
    "liberality": "lɪbərælɪti",
    "liberal": "lɪbərəl",
    "liberally": "lɪbərəli",
    "liberals": "lɪbərəlz",
    "liberated": "lɪbəreɪtɪd",
    "liberate": "lɪbəreɪt",
    "liberates": "lɪbəreɪts",
    "liberating": "lɪbəreɪtɪŋ",
    "liberation": "lɪbəreɪʃən",
    "liberator": "lɪbəreɪtɐ",
    "liberators": "lɪbəreɪtəz",
    "liber": "laɪbɐ",
    "libero": "lɪbeərəʊ",
    "libertarianism": "lɪbəteəriənɪzəm",
    "libertarian": "lɪbəteəriən",
    "libertarians": "lɪbəteəriənz",
    "liberties": "lɪbətɪz",
    "libertine": "lɪbətiːn",
    "libertines": "lɪbətiːnz",
    "liberty": "lɪbəti",
    "libidinous": "lɪbɪdɪnəs",
    "libido": "lɪbiːdəʊ",
    "libidos": "lɪbiːdəʊz",
    "lib": "lɪb",
    "libra": "laɪbrɐ",
    "librarian": "laɪbreəriən",
    "librarianship": "laɪbreəriənʃɪp",
    "librarians": "laɪbreəriənz",
    "libraries": "laɪbrəriz",
    "library": "laɪbrəri",
    "libration": "laɪbreɪʃən",
    "libretti": "lɪbrɛti",
    "librettist": "lɪbrɛtɪst",
    "librettists": "lɪbrɛtɪsts",
    "libretto": "lɪbrɛtəʊ",
    "librettos": "lɪbrɛtəʊz",
    "lice": "laɪs",
    "licenced": "laɪsənst",
    "licence": "laɪsəns",
    "licences": "laɪsənsɪz",
    "licencing": "laɪsənsɪŋ",
    "licensable": "laɪsənsəbəl",
    "licensed": "laɪsənsd",
    "licensee": "laɪsnsiː",
    "licensees": "laɪsnsiːz",
    "license": "laɪsəns",
    "licenses": "laɪsənsɪz",
    "licensing": "laɪsənsɪŋ",
    "licentious": "laɪsɛnʃəs",
    "licentiousness": "laɪsɛnʃəsnəs",
    "lichen": "laɪkən",
    "lichens": "laɪkənz",
    "licked": "lɪkt",
    "licker": "lɪkɐ",
    "licking": "lɪkɪŋ",
    "lick": "lɪk",
    "licks": "lɪks",
    "lickspittle": "lɪkspɪtəl",
    "licorice": "lɪkɔːrɪs",
    "lidded": "lɪdɪd",
    "lid": "lɪd",
    "lidless": "lɪdləs",
    "lidocaine": "lɪdəkeɪn",
    "lido": "liːdəʊ",
    "lidos": "liːdəʊz",
    "lids": "lɪdz",
    "lieder": "liːdɐ",
    "lief": "liːf",
    "lie": "laɪ",
    "lien": "liːən",
    "liens": "liːənz",
    "lies": "laɪz",
    "lieu": "luː",
    "lieutenant": "lɛftɛnənt",
    "lieutenants": "lɛftɛnənts",
    "lifebelt": "laɪfbɛlt",
    "lifebelts": "laɪfbɛlts",
    "lifeblood": "laɪfblʌd",
    "lifeboat": "laɪfbəʊt",
    "lifeboatmen": "laɪfbəʊtmɛn",
    "lifeboats": "laɪfbəʊts",
    "lifebuoy": "laɪfbɔɪ",
    "lifeforms": "laɪffɔːmz",
    "lifeguard": "laɪfɡɑːd",
    "lifeguards": "laɪfɡɑːdz",
    "life": "laɪf",
    "lifeless": "laɪfləs",
    "lifelessness": "laɪfləsnəs",
    "lifelike": "laɪflaɪk",
    "lifeline": "laɪflaɪn",
    "lifelines": "laɪflaɪnz",
    "lifelong": "laɪflɒŋ",
    "lifer": "laɪfɐ",
    "lifers": "laɪfəz",
    "lifesaver": "laɪfseɪvɐ",
    "lifesavers": "laɪfseɪvəz",
    "lifesaving": "laɪfseɪvɪŋ",
    "lifespan": "laɪfspæn",
    "lifespans": "laɪfspænz",
    "lifestyle": "laɪfstaɪl",
    "lifestyles": "laɪfstaɪlz",
    "lifetime": "laɪftaɪm",
    "lifetimes": "laɪftaɪmz",
    "lifted": "lɪftɪd",
    "lifter": "lɪftɐ",
    "lifters": "lɪftəz",
    "lifting": "lɪftɪŋ",
    "lift": "lɪft",
    "liftoff": "lɪftɒf",
    "lifts": "lɪfts",
    "ligament": "lɪɡəmənt",
    "ligaments": "lɪɡəmənts",
    "ligated": "liːɡeɪtɪd",
    "ligature": "lɪɡətʃɐ",
    "ligatures": "lɪɡətʃəz",
    "liger": "laɪdʒɐ",
    "lighted": "laɪtɪd",
    "lightened": "laɪtənd",
    "lightening": "laɪtənɪŋ",
    "lighten": "laɪtən",
    "lightens": "laɪtənz",
    "lighter": "laɪtɐ",
    "lighterman": "laɪtəmən",
    "lightermen": "laɪtəmɛn",
    "lighters": "laɪtəz",
    "lightest": "laɪtəst",
    "lightheaded": "laɪthɛdɪd",
    "lighthearted": "laɪthɑːtɪd",
    "lightheartedly": "laɪthɑːtɪdli",
    "lighthouse": "laɪthaʊs",
    "lighthouses": "laɪthaʊsɪz",
    "lighting": "laɪtɪŋ",
    "lightish": "laɪtɪʃ",
    "light": "laɪt",
    "lightless": "laɪtləs",
    "lightly": "laɪtli",
    "lightness": "laɪtnəs",
    "lightning": "laɪtnɪŋ",
    "lightnings": "laɪtnɪŋz",
    "lightship": "laɪtʃɪp",
    "lightships": "laɪtʃɪps",
    "lights": "laɪts",
    "lightweight": "laɪtweɪt",
    "lightweights": "laɪtweɪts",
    "lightyear": "laɪtjiə",
    "lignite": "lɪɡnaɪt",
    "likable": "laɪkəbəl",
    "likeability": "laɪkəbɪlɪti",
    "likeable": "laɪkəbəl",
    "liked": "laɪkt",
    "like": "laɪk",
    "likelier": "laɪkliɐ",
    "likeliest": "laɪkliəst",
    "likelihood": "laɪklihʊd",
    "likelihoods": "laɪklihʊdz",
    "likeliness": "laɪklinəs",
    "likely": "laɪkli",
    "likened": "laɪkənd",
    "likenesses": "laɪknəsɪz",
    "likeness": "laɪknəs",
    "likening": "laɪknɪŋ",
    "liken": "laɪkən",
    "likens": "laɪkənz",
    "liker": "laɪkɐ",
    "likes": "laɪks",
    "likest": "laɪkəst",
    "likewise": "laɪkwaɪz",
    "liking": "laɪkɪŋ",
    "li": "laɪ",
    "lilac": "laɪlək",
    "lilacs": "laɪləks",
    "lilies": "lɪliz",
    "lilliputian": "lɪlɪpjuːʃən",
    "lilo": "laɪləʊ",
    "lilos": "laɪləʊz",
    "lilting": "lɪltɪŋ",
    "lilt": "lɪlt",
    "lily": "lɪli",
    "limbered": "lɪmbəd",
    "limbering": "lɪmbərɪŋ",
    "limber": "lɪmbɐ",
    "limbers": "lɪmbəz",
    "limbic": "lɪmbɪk",
    "limbless": "lɪmləs",
    "limb": "lɪm",
    "limbo": "lɪmbəʊ",
    "limbos": "lɪmbəʊz",
    "limbs": "lɪmz",
    "limeade": "laɪmeɪd",
    "limed": "laɪmd",
    "lime": "laɪm",
    "limelight": "laɪmlaɪt",
    "limerick": "lɪmərɪk",
    "limericks": "lɪmərɪks",
    "limescale": "laɪmskeɪl",
    "limes": "laɪmz",
    "limestone": "laɪmstəʊn",
    "limewater": "laɪmwɔːtɐ",
    "limey": "laɪmi",
    "limeys": "laɪmɪz",
    "liminal": "lɪmɪnəl",
    "liming": "laɪmɪŋ",
    "limitation": "lɪmɪteɪʃən",
    "limitations": "lɪmɪteɪʃənz",
    "limited": "lɪmɪtɪd",
    "limiter": "lɪmɪtɐ",
    "limiters": "lɪmɪtəz",
    "limiting": "lɪmɪtɪŋ",
    "limitless": "lɪmɪtləs",
    "limit": "lɪmɪt",
    "limits": "lɪmɪts",
    "limo": "lɪməʊ",
    "limonene": "lɪməʊniːn",
    "limonite": "lɪmənaɪt",
    "limos": "lɪməʊz",
    "limousine": "lɪməziːn",
    "limousines": "lɪməziːnz",
    "limped": "lɪmpt",
    "limper": "lɪmpɐ",
    "limpet": "lɪmpɪt",
    "limpets": "lɪmpɪts",
    "limpid": "lɪmpɪd",
    "limping": "lɪmpɪŋ",
    "limp": "lɪmp",
    "limply": "lɪmpli",
    "limps": "lɪmps",
    "limy": "lɪmi",
    "linage": "lɪnɪdʒ",
    "linchpin": "lɪntʃpɪn",
    "linchpins": "lɪntʃpɪnz",
    "linden": "lɪndən",
    "lindens": "lɪndənz",
    "lindy": "lɪndi",
    "lineages": "lɪnɪɪdʒɪz",
    "lineal": "lɪniəl",
    "lineaments": "lɪniəmənts",
    "linear": "lɪniə",
    "linearly": "lɪniəli",
    "linebacker": "laɪnbækɐ",
    "lined": "laɪnd",
    "line": "laɪn",
    "lineman": "laɪnmən",
    "linen": "lɪnɪn",
    "linens": "lɪnɪnz",
    "liner": "laɪnɐ",
    "liners": "laɪnəz",
    "lines": "laɪnz",
    "linesman": "laɪnzmən",
    "linesmen": "laɪnzmɛn",
    "lineup": "laɪnʌp",
    "lingam": "lɪŋɡæm",
    "lingered": "lɪŋɡəd",
    "lingerie": "lɒnʒəri",
    "lingering": "lɪŋɡərɪŋ",
    "linger": "lɪŋɡɐ",
    "lingers": "lɪŋɡəz",
    "lingo": "lɪŋɡəʊ",
    "lingonberries": "lɪŋɡənbərɪz",
    "lings": "lɪŋz",
    "lingual": "lɪŋɡwəl",
    "lingua": "lɪŋɡjuːɐ",
    "linguine": "lɪŋɡwaɪn",
    "linguini": "lɪŋɡwiːni",
    "linguistically": "lɪŋɡwɪstɪkli",
    "linguistic": "lɪŋɡwɪstɪk",
    "linguistics": "lɪŋɡwɪstɪks",
    "linguist": "lɪŋɡwɪst",
    "linguists": "lɪŋɡwɪsts",
    "liniment": "lɪnɪmənt",
    "lining": "laɪnɪŋ",
    "linings": "laɪnɪŋz",
    "linkage": "lɪŋkɪdʒ",
    "linkages": "lɪŋkɪdʒɪz",
    "linked": "lɪŋkt",
    "linker": "lɪŋkɐ",
    "linking": "lɪŋkɪŋ",
    "link": "lɪŋk",
    "links": "lɪŋks",
    "linkup": "lɪŋkʌp",
    "linnet": "lɪnɪt",
    "linnets": "lɪnɪts",
    "linn": "lɪn",
    "linocut": "lɪnəkʌt",
    "linoleum": "lɪnəʊliːəm",
    "lino": "liːnəʊ",
    "linseed": "lɪnsiːd",
    "lintel": "lɪntəl",
    "lintels": "lɪntəlz",
    "lint": "lɪnt",
    "lionesses": "laɪənɛsɪz",
    "lioness": "laɪənɛs",
    "lionfish": "laɪənfɪʃ",
    "lionhearted": "laɪənhɑːtɪd",
    "lionised": "laɪənaɪzd",
    "lionise": "laɪənaɪz",
    "lionises": "laɪənaɪzɪz",
    "lion": "laɪən",
    "lions": "laɪənz",
    "lipase": "lɪpeɪs",
    "lipid": "lɪpɪd",
    "lipids": "lɪpɪdz",
    "lip": "lɪp",
    "lipoma": "lɪpəʊmɐ",
    "lipoprotein": "lɪpəprəʊtiːn",
    "liposuction": "lɪpəsʌkʃən",
    "lipped": "lɪpt",
    "lippy": "lɪpi",
    "lips": "lɪps",
    "lipstick": "lɪpstɪk",
    "lipsticks": "lɪpstɪks",
    "liquefaction": "lɪkwɪfækʃən",
    "liquefiable": "lɪkwɪfaɪəbəl",
    "liquefied": "lɪkwɪfaɪd",
    "liquefies": "lɪkwɪfaɪz",
    "liquefying": "lɪkwɪfaɪɪŋ",
    "liquefy": "lɪkwɪfaɪ",
    "liqueur": "lɪkjɔː",
    "liqueurs": "lɪkjɔːz",
    "liquidated": "lɪkwɪdeɪtɪd",
    "liquidate": "lɪkwɪdeɪt",
    "liquidating": "lɪkwɪdeɪtɪŋ",
    "liquidation": "lɪkwɪdeɪʃən",
    "liquidations": "lɪkwɪdeɪʃənz",
    "liquidator": "lɪkwɪdeɪtɐ",
    "liquidators": "lɪkwɪdeɪtəz",
    "liquidised": "lɪkwɪdaɪzd",
    "liquidise": "lɪkwɪdaɪz",
    "liquidiser": "lɪkwɪdaɪzɐ",
    "liquidisers": "lɪkwɪdaɪzəz",
    "liquidising": "lɪkwɪdaɪzɪŋ",
    "liquidity": "lɪkwɪdɪti",
    "liquid": "lɪkwɪd",
    "liquidness": "lɪkwɪdnəs",
    "liquids": "lɪkwɪdz",
    "liquified": "lɪkwɪfaɪd",
    "liquify": "lɪkwɪfaɪ",
    "liquored": "lɪkəd",
    "liquor": "lɪkɐ",
    "liquors": "lɪkəz",
    "lira": "liərɐ",
    "liras": "liərəz",
    "lire": "laɪə",
    "liriodendron": "lɪrɪəʊdɛndrən",
    "lisle": "laɪəl",
    "lis": "lɪs",
    "lisping": "lɪspɪŋ",
    "lisp": "lɪsp",
    "lisps": "lɪsps",
    "lissome": "lɪzsʌm",
    "listed": "lɪstɪd",
    "listenable": "lɪsənəbəl",
    "listened": "lɪsənd",
    "listener": "lɪsənɐ",
    "listeners": "lɪsənəz",
    "listening": "lɪsənɪŋ",
    "listen": "lɪsən",
    "listens": "lɪsənz",
    "listeria": "lɪstiərɪɐ",
    "lister": "lɪstɐ",
    "listers": "lɪstəz",
    "listing": "lɪstɪŋ",
    "listings": "lɪstɪŋz",
    "listless": "lɪstləs",
    "listlessly": "lɪstləsli",
    "listlessness": "lɪstləsnəs",
    "list": "lɪst",
    "lists": "lɪsts",
    "litanies": "lɪtənɪz",
    "litany": "lɪtəni",
    "litas": "liːtəz",
    "lite": "laɪt",
    "literacy": "lɪtərəsi",
    "literalism": "lɪtərəlɪzəm",
    "literal": "lɪtərəl",
    "literally": "lɪtərəli",
    "literary": "lɪtərəri",
    "literate": "lɪtərət",
    "literati": "lɪtərɑːti",
    "literature": "lɪtrɪtʃɐ",
    "lithe": "laɪð",
    "lithic": "lɪθɪk",
    "lithium": "lɪθiəm",
    "lithographed": "lɪθəɡræfd",
    "lithographic": "lɪθəɡræfɪk",
    "lithograph": "lɪθəɡræf",
    "lithographs": "lɪθəɡræfz",
    "lithography": "lɪθɒɡrəfi",
    "litigant": "lɪtɪɡənt",
    "litigants": "lɪtɪɡənts",
    "litigated": "lɪtɪɡeɪtɪd",
    "litigate": "lɪtɪɡeɪt",
    "litigating": "lɪtɪɡeɪtɪŋ",
    "litigation": "lɪtɪɡeɪʃən",
    "litigator": "lɪtɪɡeɪtɐ",
    "litigious": "lɪtɪdʒəs",
    "lit": "lɪt",
    "litmus": "lɪtməs",
    "litotes": "lɪtəʊts",
    "litre": "liːtɐ",
    "litres": "liːtəz",
    "litterbug": "lɪtəbʌɡ",
    "litterbugs": "lɪtəbʌɡz",
    "littered": "lɪtəd",
    "littering": "lɪtərɪŋ",
    "litter": "lɪtɐ",
    "litters": "lɪtəz",
    "little": "lɪtəl",
    "littleness": "lɪtəlnəs",
    "littler": "lɪtlɐ",
    "littlest": "lɪtləst",
    "littoral": "lɪtərəl",
    "liturgical": "lɪtɜːdʒɪkəl",
    "liturgies": "lɪtɜːdʒɪz",
    "liturgy": "lɪtɜːdʒi",
    "liveable": "lɪvəbəl",
    "lived": "lɪvd",
    "livelier": "laɪvlɪɐ",
    "liveliest": "laɪvlɪəst",
    "livelihood": "laɪvlihʊd",
    "livelihoods": "laɪvlihʊdz",
    "liveliness": "laɪvlɪnəs",
    "livelong": "laɪvlɒŋ",
    "lively": "laɪvli",
    "livened": "laɪvnd",
    "livening": "laɪvnɪŋ",
    "liven": "laɪvn",
    "livens": "laɪvnz",
    "liveried": "lɪvərid",
    "liveries": "lɪvəriz",
    "liverish": "lɪvərɪʃ",
    "liver": "lɪvɐ",
    "livers": "lɪvəz",
    "liverwort": "lɪvəwɔːt",
    "liverworts": "lɪvəwɔːts",
    "liverwurst": "lɪvəwɜːst",
    "livery": "lɪvəri",
    "livest": "laɪvst",
    "livestock": "laɪvstɒk",
    "lividity": "lɪvɪdɪti",
    "livid": "lɪvɪd",
    "living": "lɪvɪŋ",
    "livings": "lɪvɪŋz",
    "livre": "lɪvɐ",
    "lizard": "lɪzəd",
    "lizards": "lɪzədz",
    "llama": "lɑːmɐ",
    "llamas": "lɑːməz",
    "llanos": "ɬænəʊz",
    "lm": "ɛlɛm",
    "ln": "ɛlɛn",
    "loach": "ləʊtʃ",
    "loaded": "ləʊdɪd",
    "loader": "ləʊdɐ",
    "loaders": "ləʊdəz",
    "loading": "ləʊdɪŋ",
    "loadings": "ləʊdɪŋz",
    "load": "ləʊd",
    "loads": "ləʊdz",
    "loafer": "ləʊfɐ",
    "loafers": "ləʊfəz",
    "loafing": "ləʊfɪŋ",
    "loaf": "ləʊf",
    "loafs": "ləʊfs",
    "loam": "ləʊm",
    "loamy": "ləʊmi",
    "loaned": "ləʊnd",
    "loaner": "ləʊnɐ",
    "loaners": "ləʊnəz",
    "loaning": "ləʊnɪŋ",
    "loan": "ləʊn",
    "loans": "ləʊnz",
    "loathed": "ləʊðd",
    "loathe": "ləʊð",
    "loathers": "ləʊðəz",
    "loathes": "ləʊðz",
    "loathing": "ləʊðɪŋ",
    "loath": "ləʊθ",
    "loathsome": "ləʊθsʌm",
    "loathsomeness": "ləʊθsʌmnəs",
    "loaves": "ləʊvz",
    "lobar": "ləʊbɑː",
    "lobbed": "lɒbd",
    "lobbied": "lɒbɪd",
    "lobbies": "lɒbɪz",
    "lobbing": "lɒbɪŋ",
    "lobbying": "lɒbɪɪŋ",
    "lobbyist": "lɒbɪɪst",
    "lobbyists": "lɒbɪɪsts",
    "lobby": "lɒbi",
    "lobectomy": "ləbɛktəmi",
    "lobed": "ləʊbd",
    "lobe": "ləʊb",
    "lobelia": "ləʊbiːliə",
    "lobelias": "ləʊbiːliəz",
    "lobes": "ləʊbz",
    "lob": "lɒb",
    "loblolly": "lɒbləli",
    "lobo": "ləʊbəʊ",
    "lobotomies": "ləbɒtəmɪz",
    "lobotomised": "ləbɒtəmaɪzd",
    "lobotomise": "ləbɒtəmaɪz",
    "lobotomy": "ləbɒtəmi",
    "lobscouse": "lɒbskaʊs",
    "lobs": "lɒbz",
    "lobster": "lɒbstɐ",
    "lobsters": "lɒbstəz",
    "locale": "ləʊkɑːl",
    "locales": "ləʊkɑːlz",
    "localisation": "ləʊkəlaɪzeɪʃən",
    "localised": "ləʊkəlaɪzd",
    "localise": "ləʊkəlaɪz",
    "localising": "ləʊkəlaɪzɪŋ",
    "localism": "ləʊkəlɪzəm",
    "localities": "ləʊkælɪtiz",
    "locality": "ləʊkælɪti",
    "local": "ləʊkəl",
    "locally": "ləʊkəli",
    "locals": "ləʊkəlz",
    "located": "ləʊkeɪtɪd",
    "locate": "ləʊkeɪt",
    "locater": "ləʊkeɪtɐ",
    "locates": "ləʊkeɪts",
    "locating": "ləʊkeɪtɪŋ",
    "locational": "ləʊkeɪʃənəl",
    "location": "ləʊkeɪʃən",
    "locations": "ləʊkeɪʃənz",
    "locative": "ləʊkætɪv",
    "locator": "ləʊkeɪtɐ",
    "locators": "ləʊkeɪtəz",
    "loci": "ləʊsaɪ",
    "lockable": "lɒkəbəl",
    "locked": "lɒkt",
    "locker": "lɒkɐ",
    "lockers": "lɒkəz",
    "locket": "lɒkɪt",
    "lockets": "lɒkɪts",
    "locking": "lɒkɪŋ",
    "lockjaw": "lɒkdʒɔː",
    "lock": "lɒk",
    "lockout": "lɒkaʊt",
    "locks": "lɒks",
    "locksmith": "lɒksmɪθ",
    "locksmiths": "lɒksmɪθs",
    "lockstep": "lɒkstɛp",
    "lockup": "lɒkʌp",
    "lockups": "lɒkʌps",
    "loco": "ləʊkəʊ",
    "locomotion": "ləʊkəməʊʃən",
    "locomotive": "ləʊkəməʊtɪv",
    "locomotives": "ləʊkəməʊtɪvz",
    "locos": "ləʊkəʊz",
    "locum": "ləʊkəm",
    "locums": "ləʊkəmz",
    "locus": "ləʊkəs",
    "locust": "ləʊkʌst",
    "locusts": "ləʊkʌsts",
    "lode": "ləʊd",
    "loden": "ləʊdən",
    "lodes": "ləʊdz",
    "lodestar": "ləʊdstɑː",
    "lodestone": "ləʊdstəʊn",
    "lodged": "lɒdʒd",
    "lodge": "lɒdʒ",
    "lodger": "lɒdʒɐ",
    "lodgers": "lɒdʒəz",
    "lodges": "lɒdʒɪz",
    "lodging": "lɒdʒɪŋ",
    "lodgings": "lɒdʒɪŋz",
    "loess": "ləʊs",
    "lofted": "lɒftɪd",
    "loftier": "lɒftɪɐ",
    "loftiest": "lɒftɪəst",
    "loftily": "lɒftɪli",
    "loftiness": "lɒftɪnəs",
    "lofting": "lɒftɪŋ",
    "loft": "lɒft",
    "lofts": "lɒfts",
    "lofty": "lɒfti",
    "loganberries": "lɒɡɐnbərɪz",
    "loganberry": "lɒɡɐnbəri",
    "logan": "ləʊɡən",
    "logarithmic": "lɒɡərɪθmɪk",
    "logarithm": "lɒɡərɪθəm",
    "logarithms": "lɒɡərɪθəmz",
    "logbook": "lɒɡbʊk",
    "logbooks": "lɒɡbʊks",
    "loge": "ləʊdʒ",
    "logged": "lɒɡd",
    "loggerhead": "lɒɡəhɛd",
    "loggerheads": "lɒɡəhɛdz",
    "logger": "lɒɡɐ",
    "loggers": "lɒɡəz",
    "loggia": "lɒɡiɐ",
    "logging": "lɒɡɪŋ",
    "loggy": "lɒɡi",
    "logical": "lɒdʒɪkəl",
    "logically": "lɒdʒɪkli",
    "logician": "lədʒɪʃən",
    "logic": "lɒdʒɪk",
    "login": "lɒɡɪn",
    "logistical": "lədʒɪstɪkəl",
    "logistically": "lədʒɪstɪkli",
    "logistician": "lɒdʒɪstɪʃən",
    "logistic": "lədʒɪstɪk",
    "logistics": "lədʒɪstɪks",
    "logjam": "lɒɡdʒæm",
    "log": "lɒɡ",
    "logographic": "lɒɡəɡræfɪk",
    "logo": "ləʊɡəʊ",
    "logon": "lɒɡɒn",
    "logos": "ləʊɡəʊz",
    "logs": "lɒɡz",
    "logy": "ləʊɡi",
    "loincloth": "lɔɪŋklɒθ",
    "loincloths": "lɔɪŋklɒθs",
    "loin": "lɔɪn",
    "loins": "lɔɪnz",
    "loitered": "lɔɪtəd",
    "loitering": "lɔɪtərɪŋ",
    "loiter": "lɔɪtɐ",
    "loiters": "lɔɪtəz",
    "lo": "ləʊ",
    "lolled": "lɒld",
    "lollies": "lɒliz",
    "lolling": "lɒlɪŋ",
    "lollipop": "lɒlɪpɒp",
    "lollipops": "lɒlɪpɒps",
    "loll": "lɒl",
    "lolloping": "lɒləpɪŋ",
    "lollop": "lɒləp",
    "lollops": "lɒləps",
    "lolls": "lɒlz",
    "lollygagging": "lɒlɪɡæɡɪŋ",
    "lolly": "lɒli",
    "lollypop": "lɒlɪpɒp",
    "lollypops": "lɒlɪpɒps",
    "lone": "ləʊn",
    "lonelier": "ləʊnliɐ",
    "loneliest": "ləʊnliəst",
    "loneliness": "ləʊnlinəs",
    "lonely": "ləʊnli",
    "loner": "ləʊnɐ",
    "loners": "ləʊnəz",
    "lonesome": "ləʊnsʌm",
    "longboat": "lɒŋbəʊt",
    "longboats": "lɒŋbəʊts",
    "longbow": "lɒŋbəʊ",
    "longbows": "lɒŋbəʊz",
    "longed": "lɒŋd",
    "longer": "lɒŋɡɐ",
    "longest": "lɒŋɡəst",
    "longevity": "ləndʒɛvɪti",
    "longhaired": "ləŋheəd",
    "longhand": "lɒŋhænd",
    "longhorn": "lɒŋhɔːn",
    "longhorns": "lɒŋhɔːnz",
    "longhouse": "lɒŋhaʊs",
    "longhouses": "lɒŋhaʊzɪz",
    "longing": "lɒŋɪŋ",
    "longingly": "lɒŋɪŋli",
    "longings": "lɒŋɪŋz",
    "longish": "lɒŋɡɪʃ",
    "longitude": "lɒndʒɪtjuːd",
    "longitudes": "lɒndʒɪtjuːdz",
    "longitudinal": "lɒndʒɪtjuːdɪnəl",
    "longitudinally": "lɒndʒɪtjuːdɪnəli",
    "long": "lɒŋ",
    "longship": "lɒŋʃɪp",
    "longshore": "lɒŋʃɔː",
    "longshoreman": "lɒŋʃɔːmən",
    "longshoremen": "lɒŋʃɔːmɛn",
    "longsighted": "lɒŋsaɪtɪd",
    "longs": "lɒŋz",
    "longstanding": "lɒŋstændɪŋ",
    "longtime": "lɒŋtaɪm",
    "longways": "lɒŋweɪz",
    "looby": "luːbi",
    "loofah": "luːfɐ",
    "lookalike": "lʊkəlaɪk",
    "lookalikes": "lʊkəlaɪks",
    "looked": "lʊkt",
    "looker": "lʊkɐ",
    "lookers": "lʊkəz",
    "looking": "lʊkɪŋ",
    "look": "lʊk",
    "lookout": "lʊkaʊt",
    "lookouts": "lʊkaʊts",
    "looks": "lʊks",
    "loo": "luː",
    "loomed": "luːmd",
    "looming": "luːmɪŋ",
    "loom": "luːm",
    "looms": "luːmz",
    "looney": "luːni",
    "loonier": "luːnɪɐ",
    "loonies": "luːnɪz",
    "looniest": "luːnɪəst",
    "looniness": "luːnɪnəs",
    "loon": "luːn",
    "loons": "luːnz",
    "loony": "luːni",
    "looped": "luːpt",
    "looper": "luːpɐ",
    "loopers": "luːpəz",
    "loophole": "luːphəʊl",
    "loopholes": "luːphəʊlz",
    "looping": "luːpɪŋ",
    "loop": "luːp",
    "loops": "luːps",
    "loopy": "luːpi",
    "loosed": "luːsd",
    "loose": "luːs",
    "loosely": "luːsli",
    "loosened": "luːsənd",
    "looseness": "luːsnəs",
    "loosening": "luːsənɪŋ",
    "loosen": "luːsən",
    "loosens": "luːsənz",
    "looser": "luːzɐ",
    "looses": "luːsɪz",
    "loosest": "luːsəst",
    "loosestrife": "luːsɪstraɪf",
    "loosing": "luːsɪŋ",
    "loos": "luːz",
    "looted": "luːtɪd",
    "looter": "luːtɐ",
    "looters": "luːtəz",
    "looting": "luːtɪŋ",
    "loot": "luːt",
    "loots": "luːts",
    "loped": "ləʊpt",
    "lope": "ləʊp",
    "loper": "ləʊpɐ",
    "lopes": "ləʊps",
    "loping": "ləʊpɪŋ",
    "lop": "lɒp",
    "lopped": "lɒpt",
    "loppers": "lɒpəz",
    "lopping": "lɒpɪŋ",
    "loppy": "lɒpi",
    "lopsided": "lɒpsaɪdɪd",
    "lops": "lɒps",
    "loquacious": "ləkweɪʃəs",
    "loquitur": "lɒkwɪtʃɐ",
    "loran": "lɔːrən",
    "lorded": "lɔːdɪd",
    "lording": "lɔːdɪŋ",
    "lord": "lɔːd",
    "lordly": "lɔːdli",
    "lordosis": "lɔːdəʊsɪs",
    "lordship": "lɔːdʃɪp",
    "lordships": "lɔːdʃɪps",
    "lords": "lɔːdz",
    "lore": "lɔː",
    "lorgnette": "lɔːɡnɛt",
    "lorgnettes": "lɔːɡnɛts",
    "lorikeet": "lɔːrɪkiːt",
    "lorikeets": "lɔːrɪkiːts",
    "lorimer": "lɔːrɪmɐ",
    "lorises": "lɔːraɪzɪz",
    "loris": "lɔːrɪs",
    "lorn": "lɔːn",
    "lorries": "lɒrɪz",
    "lorry": "lɒri",
    "lose": "luːz",
    "loser": "luːzɐ",
    "losers": "luːzəz",
    "loses": "luːzɪz",
    "losing": "luːzɪŋ",
    "losses": "lɒsɪz",
    "loss": "lɒs",
    "lost": "lɒst",
    "loth": "lɒθ",
    "lotion": "ləʊʃən",
    "lotions": "ləʊʃənz",
    "lot": "lɒt",
    "lots": "lɒts",
    "lotteries": "lɒtəriz",
    "lottery": "lɒtəri",
    "lotto": "lɒtəʊ",
    "lotuses": "ləʊtəsɪz",
    "lotus": "ləʊtəs",
    "louche": "laʊtʃ",
    "louden": "laʊdən",
    "louder": "laʊdɐ",
    "loudest": "laʊdəst",
    "loudhailer": "laʊdheɪlɐ",
    "loud": "laʊd",
    "loudly": "laʊdli",
    "loudmouthed": "laʊdmaʊðd",
    "loudmouth": "laʊdmaʊθ",
    "loudmouths": "laʊdmaʊθs",
    "loudness": "laʊdnəs",
    "loudspeaker": "laʊdspiːkɐ",
    "loudspeakers": "laʊdspiːkəz",
    "lough": "lʌf",
    "loughs": "lʌfz",
    "louis": "luːi",
    "lounged": "laʊndʒd",
    "lounge": "laʊndʒ",
    "lounger": "laʊndʒɐ",
    "loungers": "laʊndʒəz",
    "lounges": "laʊndʒɪz",
    "lounging": "laʊndʒɪŋ",
    "loupe": "luːp",
    "loup": "luːp",
    "lour": "lɜː",
    "lours": "lɜːz",
    "loused": "laʊsd",
    "louse": "laʊs",
    "lousiest": "laʊsɪəst",
    "lousing": "laʊsɪŋ",
    "lousy": "laʊsi",
    "loutish": "laʊtɪʃ",
    "lout": "laʊt",
    "louts": "laʊts",
    "louvre": "luːvɐ",
    "louvres": "luːvəz",
    "lovable": "lʌvəbəl",
    "lovably": "lʌvəbli",
    "lovage": "lʌvɪdʒ",
    "loveable": "lʌvəbəl",
    "loveably": "lʌvəbli",
    "lovebird": "lʌvbɜːd",
    "lovebirds": "lʌvbɜːdz",
    "lovechild": "lʌvtʃaɪld",
    "loved": "lʌvd",
    "loveless": "lʌvləs",
    "lovelier": "lʌvliɐ",
    "lovelies": "lʌvliz",
    "loveliest": "lʌvliəst",
    "loveliness": "lʌvlinəs",
    "lovelock": "lʌvlɒk",
    "lovelorn": "lʌvlɔːn",
    "love": "lʌv",
    "lovely": "lʌvli",
    "lovemaking": "lʌvmeɪkɪŋ",
    "lover": "lʌvɐ",
    "loverly": "lʌvəli",
    "lovers": "lʌvəz",
    "lovesick": "lʌvsɪk",
    "lovesickness": "lʌvsɪknəs",
    "loves": "lʌvz",
    "lovey": "lʌvi",
    "loving": "lʌvɪŋ",
    "lovingly": "lʌvɪŋli",
    "lowball": "ləʊbɔːl",
    "lowborn": "ləʊbɔːn",
    "lowbrow": "ləʊbraʊ",
    "lowdown": "ləʊdaʊn",
    "lowed": "ləʊd",
    "lowercase": "ləʊəkeɪs",
    "lowery": "ləʊəri",
    "lowest": "ləʊəst",
    "lowing": "ləʊɪŋ",
    "lowish": "ləʊɪʃ",
    "lowlander": "ləʊləndɐ",
    "lowlanders": "ləʊləndəz",
    "lowland": "ləʊlənd",
    "lowlands": "ləʊləndz",
    "low": "ləʊ",
    "lowliest": "ləʊliəst",
    "lowlife": "ləʊlaɪf",
    "lowlifes": "ləʊlaɪfs",
    "lowliness": "ləʊlinəs",
    "lowly": "ləʊli",
    "lowness": "ləʊnəs",
    "lows": "ləʊz",
    "lox": "lɒks",
    "loyalism": "lɔɪəlɪzəm",
    "loyalist": "lɔɪəlɪst",
    "loyalists": "lɔɪəlɪsts",
    "loyal": "lɔɪəl",
    "loyally": "lɔɪəli",
    "loyalties": "lɔɪəltɪz",
    "loyalty": "lɔɪəlti",
    "lozenge": "ləʊzəndʒ",
    "lozenges": "ləʊzəndʒɪz",
    "ls": "ɛlɛs",
    "luau": "luːaʊ",
    "lubber": "lʌbɐ",
    "lubbers": "lʌbəz",
    "lubed": "luːbd",
    "lube": "luːb",
    "lubing": "luːbɪŋ",
    "lubricant": "luːbrɪkənt",
    "lubricants": "luːbrɪkənts",
    "lubricated": "luːbrɪkeɪtɪd",
    "lubricate": "luːbrɪkeɪt",
    "lubricates": "luːbrɪkeɪts",
    "lubricating": "luːbrɪkeɪtɪŋ",
    "lubrication": "luːbrɪkeɪʃən",
    "lubricious": "luːbrɪʃəs",
    "luce": "luːs",
    "lucent": "luːsənt",
    "lucerne": "luːsən",
    "lucidity": "luːsɪdɪti",
    "lucid": "luːsɪd",
    "lucidly": "luːsɪdli",
    "luciferase": "luːsɪfəreɪz",
    "luciferin": "luːsɪfərɪn",
    "lucifer": "luːsɪfɐ",
    "lucked": "lʌkt",
    "luckier": "lʌkiɐ",
    "luckiest": "lʌkiəst",
    "luckily": "lʌkili",
    "lucking": "lʌkɪŋ",
    "luckless": "lʌkləs",
    "luck": "lʌk",
    "lucks": "lʌks",
    "lucky": "lʌki",
    "lucrative": "luːkrətɪv",
    "lucre": "luːkɐ",
    "ludic": "luːdɪk",
    "ludicrous": "luːdɪkrəs",
    "ludicrously": "luːdɪkrəsli",
    "ludicrousness": "luːdɪkrəsnəs",
    "ludo": "luːdəʊ",
    "lues": "luːz",
    "luff": "lʌf",
    "luge": "luːdʒ",
    "luggage": "lʌɡɪdʒ",
    "lugged": "lʌɡd",
    "lugger": "lʌɡɐ",
    "luggers": "lʌɡəz",
    "lugging": "lʌɡɪŋ",
    "lughole": "lʌɡhəʊl",
    "lugholes": "lʌɡhəʊlz",
    "luging": "luːdʒɪŋ",
    "lug": "lʌɡ",
    "lugs": "lʌɡz",
    "lugubrious": "luːɡʌbrɪəs",
    "lugworm": "lʌɡwɜːm",
    "lugworms": "lʌɡwɜːmz",
    "lukewarm": "luːkwɔːm",
    "lullabies": "lʌləbaɪz",
    "lullaby": "lʌləbaɪ",
    "lulled": "lʌld",
    "lulling": "lʌlɪŋ",
    "lull": "lʌl",
    "lulls": "lʌlz",
    "lulu": "luːluː",
    "lulus": "luːləs",
    "lumbago": "lʌmbeɪɡəʊ",
    "lumbar": "lʌmbɑː",
    "lumbered": "lʌmbəd",
    "lumbering": "lʌmbərɪŋ",
    "lumberjack": "lʌmbədʒæk",
    "lumberjacks": "lʌmbədʒæks",
    "lumber": "lʌmbɐ",
    "lumbermen": "lʌmbəmɛn",
    "lumbers": "lʌmbəz",
    "lumberyard": "lʌmbəjɑːd",
    "lumen": "luːmɛn",
    "lumens": "luːmɛnz",
    "luminaries": "luːmɪnəriz",
    "luminary": "luːmɪnəri",
    "luminescence": "luːmɪnɛsəns",
    "luminescent": "luːmɪnɛsənt",
    "luminosity": "luːmɪnɒsɪti",
    "luminous": "luːmɪnəs",
    "lummox": "lʌmɒks",
    "lumped": "lʌmpt",
    "lumpen": "lʌmpən",
    "lumper": "lʌmpɐ",
    "lumpers": "lʌmpəz",
    "lumpfish": "lʌmpfɪʃ",
    "lumpier": "lʌmpɪɐ",
    "lumpiness": "lʌmpɪnəs",
    "lumping": "lʌmpɪŋ",
    "lump": "lʌmp",
    "lumps": "lʌmps",
    "lumpy": "lʌmpi",
    "lunacies": "luːnəsɪz",
    "lunacy": "luːnəsi",
    "lunar": "luːnɐ",
    "lunate": "luːneɪt",
    "lunatic": "luːnətɪk",
    "lunatics": "luːnətɪks",
    "lunchboxes": "lʌntʃbɒksɪz",
    "lunchbox": "lʌntʃbɒks",
    "lunched": "lʌntʃt",
    "luncheon": "lʌntʃən",
    "luncheons": "lʌntʃənz",
    "lunches": "lʌntʃɪz",
    "lunching": "lʌntʃɪŋ",
    "lunch": "lʌntʃ",
    "lunchroom": "lʌntʃ ruːm",
    "lunchtime": "lʌntʃtaɪm",
    "lunchtimes": "lʌntʃtaɪmz",
    "lune": "luːn",
    "lunette": "lʌnɛt",
    "lunettes": "lʌnɛts",
    "lunge": "lʌndʒ",
    "lunges": "lʌndʒɪz",
    "lungfish": "lʌŋfɪʃ",
    "lungful": "lʌŋfəl",
    "lungfuls": "lʌŋfəlz",
    "lunging": "lʌndʒɪŋ",
    "lung": "lʌŋ",
    "lungs": "lʌŋz",
    "lungworm": "lʌŋwɜːm",
    "lungwort": "lʌŋwɔːt",
    "lunkhead": "lʌŋkhɛd",
    "lunk": "lʌŋk",
    "lunula": "lʌnjʊlɐ",
    "lupin": "luːpɪn",
    "lupins": "luːpɪnz",
    "lupulin": "luːpjʊlɪn",
    "lupus": "luːpəs",
    "lurched": "lɜːtʃt",
    "lurcher": "lɜːtʃɐ",
    "lurchers": "lɜːtʃəz",
    "lurches": "lɜːtʃɪz",
    "lurching": "lɜːtʃɪŋ",
    "lurch": "lɜːtʃ",
    "lured": "lɔːd",
    "lure": "lɔː",
    "lures": "lɔːz",
    "lurex": "lɔːrɛks",
    "lurgy": "lɜːdʒi",
    "lurid": "lɔːrɪd",
    "luring": "lɔːrɪŋ",
    "lurked": "lɜːkt",
    "lurker": "lɜːkɐ",
    "lurkers": "lɜːkəz",
    "lurking": "lɜːkɪŋ",
    "lurk": "lɜːk",
    "lurks": "lɜːks",
    "lur": "lɜː",
    "luscious": "lʌʃəs",
    "lusciously": "lʌʃəsli",
    "lusciousness": "lʌʃəsnəs",
    "lusher": "lʌʃɐ",
    "lushes": "lʌʃɪz",
    "lushest": "lʌʃəst",
    "lush": "lʌʃ",
    "lushly": "lʌʃli",
    "lushness": "lʌʃnəs",
    "lusted": "lʌstɪd",
    "lustful": "lʌstfəl",
    "lustfully": "lʌstfəli",
    "lustily": "lʌstɪli",
    "lusting": "lʌstɪŋ",
    "lust": "lʌst",
    "lustre": "lʌstɐ",
    "lustreware": "lʌstruːeə",
    "lustrous": "lʌstrəs",
    "lustrum": "lʌstrəm",
    "lusts": "lʌsts",
    "lusty": "lʌsti",
    "lute": "luːt",
    "lutes": "luːts",
    "lutetium": "luːtiːtiəm",
    "luting": "luːtɪŋ",
    "luvvie": "lʌvi",
    "luxe": "lʌks",
    "lux": "lʌks",
    "luxuriantly": "lʌɡʒjʊriəntli",
    "luxuriant": "lʌɡʒjʊriənt",
    "luxuriated": "lʌɡʒjʊrɪeɪtɪd",
    "luxuriate": "lʌɡʒjʊrɪeɪt",
    "luxuriates": "lʌɡʒjʊrɪeɪts",
    "luxuriating": "lʌɡʒjʊrɪeɪtɪŋ",
    "luxuries": "lʌkʃəriz",
    "luxuriously": "lʌɡʒjʊrɪəsli",
    "luxurious": "lʌɡʒjʊrɪəs",
    "luxury": "lʌkʃəri",
    "lx": "ɛlɛks",
    "lycanthrope": "laɪkɑːnθrəʊp",
    "lycanthropy": "laɪkænθrəpi",
    "lyceum": "laɪsiːəm",
    "lychee": "liːtʃiː",
    "lychees": "liːtʃiːz",
    "lychnis": "lɪtʃniz",
    "lye": "laɪ",
    "lying": "laɪɪŋ",
    "lymphatic": "lɪmfætɪk",
    "lymph": "lɪmf",
    "lymphocyte": "lɪmfəsaɪt",
    "lymphocytes": "lɪmfəsaɪts",
    "lymphoid": "lɪmfɔɪd",
    "lymphoma": "lɪmfəʊmɐ",
    "lymphomas": "lɪmfəʊməz",
    "lynched": "lɪntʃt",
    "lynches": "lɪntʃɪz",
    "lynching": "lɪntʃɪŋ",
    "lynchings": "lɪntʃɪŋz",
    "lynch": "lɪntʃ",
    "lynchpin": "lɪntʃpɪn",
    "lynx": "lɪŋks",
    "lyonnaise": "laɪəneɪz",
    "lyrebird": "laɪrɪbɜːd",
    "lyre": "laɪə",
    "lyres": "laɪəz",
    "lyrical": "lɪrɪkəl",
    "lyrically": "lɪrɪkli",
    "lyricism": "lɪrɪsɪzəm",
    "lyricist": "lɪrɪsɪst",
    "lyricists": "lɪrɪsɪsts",
    "lyric": "lɪrɪk",
    "lyrics": "lɪrɪks",
    "lyse": "laɪz",
    "lyses": "laɪzɪz",
    "lysis": "laɪsiz",
    "lyssa": "lɪsɐ",
    "lytic": "lɪtɪk",
    "ma'am": "mææm",
    "macabre": "məkɑːbrɐ",
    "macadamia": "mækədeɪmiə",
    "macadamias": "mækədeɪmiəz",
    "macadam": "məkædəm",
    "macaque": "mækæk",
    "macaques": "mækæks",
    "macarena": "mækeənɐ",
    "macaroni": "mækɐrəʊni",
    "macaronis": "mækɐrəʊniz",
    "macaroon": "mækɐruːn",
    "macaroons": "mækɐruːnz",
    "macaw": "mækɔː",
    "macaws": "mækɔːz",
    "maced": "meɪsd",
    "mace": "meɪs",
    "macerated": "mæsəreɪtɪd",
    "macerate": "mæsəreɪt",
    "macerates": "mæsəreɪts",
    "macerating": "mæsəreɪtɪŋ",
    "maceration": "mæsəreɪʃən",
    "macerator": "mæsəreɪtɐ",
    "maces": "meɪsɪz",
    "machete": "mɐʃɛti",
    "machetes": "mɐʃɛtis",
    "machiavellian": "mækiəvɛliən",
    "machination": "mækɪneɪʃən",
    "machinations": "mækɪneɪʃənz",
    "machined": "məʃiːnd",
    "machine": "məʃiːn",
    "machinery": "məʃiːnəri",
    "machines": "məʃiːnz",
    "machining": "məʃiːnɪŋ",
    "machinist": "məʃiːnɪst",
    "machinists": "məʃiːnɪsts",
    "machismo": "mɐtʃɪzməʊ",
    "macho": "mætʃəʊ",
    "macing": "meɪsɪŋ",
    "macintoshes": "mækɪntɒʃɪz",
    "macintosh": "mækɪntɒʃ",
    "mackerel": "mækərəl",
    "mackerels": "mækərəlz",
    "mackintoshes": "mækɪntɒʃɪz",
    "mackintosh": "mækɪntɒʃ",
    "mackle": "mækəl",
    "mack": "mæk",
    "macks": "mæks",
    "mac": "mæk",
    "macrobiotic": "mækrəbaɪɒtɪk",
    "macroeconomic": "mækrəriːkənɒmɪk",
    "macroeconomics": "mækrəriːkənɒmɪks",
    "macro": "mækrəʊ",
    "macrophage": "mækrəfɪdʒ",
    "macrophages": "mækrəfɪdʒɪz",
    "macroscopic": "mækrəskɒpɪk",
    "macros": "mækrəʊz",
    "macs": "mæks",
    "macula": "mækjʊlɐ",
    "madame": "mædəm",
    "madam": "mædəm",
    "madams": "mædəmz",
    "madcap": "mædkæp",
    "maddened": "mædənd",
    "maddeningly": "mædənɪŋli",
    "maddening": "mædənɪŋ",
    "madden": "mædən",
    "maddens": "mædənz",
    "madder": "mædɐ",
    "maddest": "mædəst",
    "madding": "mædɪŋ",
    "made": "meɪd",
    "mademoiselle": "mædəməzɛl",
    "madhouse": "mædhaʊs",
    "madly": "mædli",
    "mad": "mæd",
    "madman": "mædmən",
    "madmen": "mædmɛn",
    "madness": "mædnəs",
    "madras": "mədrɑːs",
    "madrigal": "mædrɪɡəl",
    "madrigals": "mædrɪɡəlz",
    "mads": "mædz",
    "madwoman": "mædwʊmən",
    "maelstrom": "meɪlstrɒm",
    "maenads": "miːnædz",
    "maestoso": "maɪstəʊsəʊ",
    "maestri": "maɪstri",
    "maestro": "maɪstrəʊ",
    "maestros": "maɪstrəʊz",
    "mafia": "mæfiɐ",
    "mafias": "mæfiəz",
    "mafioso": "mæfɪəʊsəʊ",
    "magazine": "mæɡɐziːn",
    "magazines": "mæɡɐziːnz",
    "mage": "meɪdʒ",
    "magenta": "mədʒɛntɐ",
    "maggot": "mæɡət",
    "maggots": "mæɡəts",
    "maggoty": "mæɡɒti",
    "magically": "mædʒɪkli",
    "magical": "mædʒɪkəl",
    "magician": "mɐdʒɪʃən",
    "magicians": "mɐdʒɪʃənz",
    "magicked": "mædʒɪkt",
    "magicking": "mædʒɪkɪŋ",
    "magic": "mædʒɪk",
    "magics": "mædʒɪks",
    "magi": "meɪdʒaɪ",
    "magisterially": "mædʒɪstiərɪəli",
    "magisterial": "mædʒɪstiərɪəl",
    "magistracy": "mædʒɪstrəsi",
    "magistrate": "mædʒɪstreɪt",
    "magistrates": "mædʒɪstreɪts",
    "magma": "mæɡmɐ",
    "magmas": "mæɡməz",
    "magnanimity": "mæɡnɐnɪmɪti",
    "magnanimously": "mæɡnænɪməsli",
    "magnanimous": "mæɡnænɪməs",
    "magnate": "mæɡneɪt",
    "magnates": "mæɡneɪts",
    "magnesia": "mæɡniːziə",
    "magnesium": "mæɡniːziəm",
    "magnetically": "mæɡnɛtɪkli",
    "magnetic": "mæɡnɛtɪk",
    "magnetics": "mæɡnɛtɪks",
    "magnetised": "mæɡnɪtaɪzd",
    "magnetise": "mæɡnɪtaɪz",
    "magnetism": "mæɡnɪtɪzəm",
    "magnetite": "mæɡnɪtaɪt",
    "magnet": "mæɡnɪt",
    "magneto": "mæɡniːtəʊ",
    "magnetometer": "mæɡnɪtɒmɪtɐ",
    "magnetos": "mæɡniːtəʊz",
    "magnetosphere": "mæɡnɪtɒsfiə",
    "magnetron": "mæɡnɪtrɒn",
    "magnets": "mæɡnɪts",
    "magnification": "mæɡnɪfɪkeɪʃən",
    "magnifications": "mæɡnɪfɪkeɪʃənz",
    "magnificence": "mæɡnɪfɪsəns",
    "magnificently": "mæɡnɪfɪsəntli",
    "magnificent": "mæɡnɪfɪsənt",
    "magnific": "mæɡnɪfɪk",
    "magnifico": "mæɡnɪfɪkəʊ",
    "magnified": "mæɡnɪfaɪd",
    "magnifier": "mæɡnɪfaɪə",
    "magnifiers": "mæɡnɪfaɪəz",
    "magnifies": "mæɡnɪfaɪz",
    "magnifying": "mæɡnɪfaɪɪŋ",
    "magnify": "mæɡnɪfaɪ",
    "magnitude": "mæɡnɪtjuːd",
    "magnitudes": "mæɡnɪtjuːdz",
    "magnolia": "mæɡnəʊliə",
    "magnolias": "mæɡnəʊliəz",
    "magnum": "mæɡnəm",
    "magnums": "mæɡnəmz",
    "magpie": "mæɡpaɪ",
    "magpies": "mæɡpaɪz",
    "mags": "mæɡz",
    "magus": "mæɡəs",
    "maharajah": "mæhɐrædʒɐ",
    "maharajahs": "mæhɐrædʒəz",
    "maharaja": "mæhɐrɑːdʒɐ",
    "maharajas": "mæhɐrɑːdʒəz",
    "maharani": "mæhɐrɑːni",
    "maharishi": "mæhɑːriːʃi",
    "mahatma": "mæhætmɐ",
    "mahjong": "mɑːdʒɒŋ",
    "mahoganies": "məhɒɡənɪz",
    "mahogany": "məhɒɡəni",
    "mahout": "mæhaʊt",
    "mahouts": "mæhaʊts",
    "maidenhair": "meɪdənheə",
    "maidenhead": "meɪdənhɛd",
    "maidenhood": "meɪdənhʊd",
    "maiden": "meɪdən",
    "maidens": "meɪdənz",
    "maid": "meɪd",
    "maidservant": "meɪdsɜːvənt",
    "maidservants": "meɪdsɜːvənts",
    "maids": "meɪdz",
    "mailbag": "meɪlbæɡ",
    "mailbags": "meɪlbæɡz",
    "mailboxes": "meɪlbɒksɪz",
    "mailbox": "meɪlbɒks",
    "mailed": "meɪld",
    "mailer": "meɪlɐ",
    "mailers": "meɪləz",
    "mailing": "meɪlɪŋ",
    "mailings": "meɪlɪŋz",
    "mailman": "meɪlmən",
    "mail": "meɪl",
    "mailmen": "meɪlmɛn",
    "mailshot": "meɪlʃɒt",
    "mailshots": "meɪlʃɒts",
    "mails": "meɪlz",
    "maimed": "meɪmd",
    "maiming": "meɪmɪŋ",
    "maim": "meɪm",
    "maims": "meɪmz",
    "mainbrace": "meɪnbreɪs",
    "mainframe": "meɪnfreɪm",
    "mainland": "meɪnlənd",
    "mainline": "meɪnlaɪn",
    "mainlining": "meɪnlaɪnɪŋ",
    "mainly": "meɪnli",
    "main": "meɪn",
    "mainsail": "meɪnseɪl",
    "mainsheet": "meɪnʃiːt",
    "mains": "meɪnz",
    "mainspring": "meɪnsprɪŋ",
    "mainstay": "meɪnsteɪ",
    "mainstays": "meɪnsteɪz",
    "mainstreaming": "meɪnstriːmɪŋ",
    "mainstream": "meɪnstriːm",
    "maintainable": "meɪnteɪnəbəl",
    "maintained": "meɪnteɪnd",
    "maintainer": "meɪnteɪnɐ",
    "maintainers": "meɪnteɪnəz",
    "maintaining": "meɪnteɪnɪŋ",
    "maintain": "meɪnteɪn",
    "maintains": "meɪnteɪnz",
    "maintenance": "meɪntənəns",
    "maiolica": "meɪɒlɪkɐ",
    "maisonette": "meɪsəʊnɛt",
    "maisonettes": "meɪsəʊnɛts",
    "maize": "meɪz",
    "majestically": "mædʒɛstɪkli",
    "majestic": "mædʒɛstɪk",
    "majesties": "mædʒəstɪz",
    "majesty": "mædʒəsti",
    "majolica": "mædʒɒlɪkɐ",
    "majored": "meɪdʒəd",
    "majorette": "meɪdʒərɛt",
    "majorettes": "meɪdʒərɛts",
    "majoring": "meɪdʒərɪŋ",
    "majorities": "mədʒɒrɪtiz",
    "majority": "mədʒɒrɪti",
    "majorly": "meɪdʒəli",
    "major": "meɪdʒɐ",
    "majors": "meɪdʒəz",
    "make": "meɪk",
    "makeover": "meɪkəʊvɐ",
    "makeovers": "meɪkəʊvəz",
    "maker": "meɪkɐ",
    "makers": "meɪkəz",
    "makeshift": "meɪkʃɪft",
    "makes": "meɪks",
    "makeup": "meɪkʌp",
    "makeweight": "meɪkweɪt",
    "making": "meɪkɪŋ",
    "makings": "meɪkɪŋz",
    "mako": "mɑːkəʊ",
    "malachite": "mælɐtʃaɪt",
    "malacology": "mælɐkɒlədʒi",
    "maladies": "mælədɪz",
    "maladjusted": "mælɐdʒʌstɪd",
    "maladministration": "mælɐdmɪnɪstreɪʃən",
    "maladroit": "mælɐdrɔɪt",
    "malady": "mælədi",
    "malaise": "mæleɪz",
    "malamutes": "mælɐmjuːts",
    "malapropism": "mæleɪprɒpɪzəm",
    "malapropisms": "mæleɪprɒpɪzəmz",
    "malaprop": "mæleɪprɒp",
    "malarial": "mæleərɪəl",
    "malaria": "mæleəriə",
    "malarkey": "mælɑːki",
    "malarky": "mælɑːki",
    "malathion": "mælɑːθiən",
    "malcontent": "mælkəntɛnt",
    "malcontents": "mælkəntɛnts",
    "malefactor": "meɪlfæktɐ",
    "malefactors": "meɪlfæktəz",
    "male": "meɪl",
    "maleness": "meɪlnəs",
    "males": "meɪlz",
    "malevolence": "məlɛvələns",
    "malevolently": "məlɛvələntli",
    "malevolent": "məlɛvələnt",
    "malfeasance": "mælfiːzəns",
    "malformation": "mælfɔːmeɪʃən",
    "malformations": "mælfɔːmeɪʃənz",
    "malformed": "mælfɔːmd",
    "malfunctioned": "mælfʌŋkʃənd",
    "malfunctioning": "mælfʌŋkʃənɪŋ",
    "malfunction": "mælfʌŋkʃən",
    "malfunctions": "mælfʌŋkʃənz",
    "malice": "mælɪs",
    "maliciously": "mɐlɪʃəsli",
    "malicious": "mɐlɪʃəs",
    "maliciousness": "mɐlɪʃəsnəs",
    "malignancy": "məlɪɡnənsi",
    "malignant": "məlɪɡnənt",
    "maligned": "məlaɪnd",
    "maligning": "məlaɪnɪŋ",
    "malignity": "məlɪɡnɪti",
    "malign": "məlaɪn",
    "malingerer": "mɐlɪŋɡərɐ",
    "malingerers": "mɐlɪŋɡərəz",
    "malingering": "mɐlɪŋɡərɪŋ",
    "mallard": "mælɑːd",
    "mallards": "mælɑːdz",
    "malleability": "mæləbɪlɪti",
    "malleable": "mæləbəl",
    "mallee": "mæliː",
    "mallet": "mælɪt",
    "mallets": "mælɪts",
    "malleus": "mælɪəs",
    "mall": "mæl",
    "mallow": "mæləʊ",
    "mallows": "mæləʊz",
    "malls": "mælz",
    "malm": "mælm",
    "malmsey": "mælmsi",
    "malnourished": "mælnʌrɪʃt",
    "malnourishment": "mælnʌrɪʃmənt",
    "malnutrition": "mælnjuːtrɪʃən",
    "malodorous": "mæləʊdərəs",
    "malpractice": "mælpræktɪs",
    "malpractices": "mælpræktɪsɪz",
    "malted": "mɒltɪd",
    "malting": "mɒltɪŋ",
    "malt": "mɒlt",
    "maltose": "mɒltəʊz",
    "maltreated": "mæltriːtɪd",
    "maltreating": "mæltriːtɪŋ",
    "maltreatment": "mæltriːtmənt",
    "malts": "mɒlts",
    "malty": "mælti",
    "ma": "mɑː",
    "mama": "mɑːmɐ",
    "mamas": "mɑːmɐz",
    "mamba": "mæmbɐ",
    "mambas": "mæmbəz",
    "mambo": "mæmbəʊ",
    "mam": "mæm",
    "mammalian": "mæmeɪliən",
    "mammal": "mæməl",
    "mammals": "mæməlz",
    "mamma": "mæmɐ",
    "mammary": "mæməri",
    "mammas": "mæməz",
    "mammies": "mæmɪz",
    "mammogram": "mæməɡræm",
    "mammograms": "mæməɡræmz",
    "mammon": "mæmən",
    "mammoth": "mæməθ",
    "mammoths": "mæməθs",
    "mammy": "mæmi",
    "mams": "mæmz",
    "manacled": "mænəkəld",
    "manacle": "mænəkəl",
    "manacles": "mænəkəlz",
    "manageability": "mænɪdʒəbɪlɪti",
    "manageable": "mænɪdʒəbəl",
    "managed": "mænɪdʒd",
    "manage": "mænɪdʒ",
    "management": "mænɪdʒmənt",
    "managements": "mænɪdʒmənts",
    "manageresses": "mænɪdʒərɛsɪz",
    "manageress": "mænɪdʒərɛs",
    "managerially": "mænɐdʒiərɪəli",
    "managerial": "mænɐdʒiərɪəl",
    "manager": "mænɪdʒɐ",
    "managers": "mænɪdʒəz",
    "manages": "mænɪdʒɪz",
    "managing": "mænɪdʒɪŋ",
    "manakin": "mænɐkɪn",
    "manakins": "mænɐkɪnz",
    "mana": "mɑːnɐ",
    "mananas": "mænɑːnəz",
    "manatee": "mænɐtiː",
    "manatees": "mænɐtiːz",
    "manat": "mænæt",
    "mandarinate": "mændɑːrɪneɪt",
    "mandarin": "mændərɪn",
    "mandarins": "mændərɪnz",
    "mandated": "mændeɪtɪd",
    "mandates": "mændeɪts",
    "mandating": "mændeɪtɪŋ",
    "mandatory": "mændətəri",
    "mandible": "mændəbəl",
    "mandibles": "mændəbəlz",
    "mandibular": "mændɪbjʊlɐ",
    "mandolin": "mændəlɪn",
    "mandolins": "mændəlɪnz",
    "mandrake": "mændreɪk",
    "mandrakes": "mændreɪks",
    "mandrel": "mændrəl",
    "mandrill": "mændrɪl",
    "mandrills": "mændrɪlz",
    "maned": "meɪnd",
    "mane": "meɪn",
    "maneuver": "mənuːvɐ",
    "manfully": "mænfəli",
    "manful": "mænfəl",
    "manganate": "mæŋɡɐneɪt",
    "manganese": "mæŋɡəniːz",
    "mange": "mændʒ",
    "manger": "meɪndʒɐ",
    "mangers": "meɪndʒəz",
    "mangetout": "mɒnʒtuː",
    "mangled": "mæŋɡəld",
    "mangle": "mæŋɡəl",
    "mangler": "mæŋɡlɐ",
    "mangles": "mæŋɡəlz",
    "mangling": "mæŋɡəlɪŋ",
    "mangoes": "mæŋɡəʊz",
    "mango": "mæŋɡəʊ",
    "mangos": "mæŋɡəʊz",
    "mangosteen": "mæŋɡəstiːn",
    "mangrove": "mæŋɡrəʊv",
    "mangroves": "mæŋɡrəʊvz",
    "mangy": "meɪndʒi",
    "manhandled": "mænhændəld",
    "manhandle": "mænhændəl",
    "manhandling": "mænhɐndlɪŋ",
    "manhattan": "mænhætən",
    "manhattans": "mænhætənz",
    "manhole": "mænhəʊl",
    "manholes": "mænhəʊlz",
    "manhood": "mænhʊd",
    "manhunt": "mænhʌnt",
    "manhunts": "mænhʌnts",
    "maniacally": "mɐnaɪəkli",
    "maniacal": "mɐnaɪəkəl",
    "maniac": "meɪnɪæk",
    "maniacs": "meɪnɪæks",
    "mania": "meɪniɐ",
    "manically": "mænɪkli",
    "manic": "mænɪk",
    "manicotti": "mænɪkɒti",
    "manics": "mænɪks",
    "manicured": "mænɪkjɔːd",
    "manicure": "mænɪkjɔː",
    "manicures": "mænɪkjɔːz",
    "manicuring": "mænɪkjɔːrɪŋ",
    "manicurist": "mænɪkjʊrɪst",
    "manifestation": "mænɪfɪsteɪʃən",
    "manifestations": "mænɪfɪsteɪʃənz",
    "manifested": "mænɪfɛstɪd",
    "manifesting": "mænɪfɛstɪŋ",
    "manifestly": "mænɪfɛstli",
    "manifest": "mænɪfɛst",
    "manifestoes": "mænɪfɛstəʊz",
    "manifesto": "mænɪfɛstəʊ",
    "manifestos": "mænɪfɛstəʊz",
    "manifests": "mænɪfɛsts",
    "manifold": "mænɪfəʊld",
    "manifolds": "mænɪfəʊldz",
    "manikins": "mænɪkɪnz",
    "manilla": "mænɪlɐ",
    "manioc": "mænɪɒk",
    "manipulable": "mənɪpjʊləbəl",
    "manipulated": "mənɪpjʊleɪtɪd",
    "manipulate": "mənɪpjʊleɪt",
    "manipulates": "mənɪpjʊleɪts",
    "manipulating": "mənɪpjʊleɪtɪŋ",
    "manipulation": "mənɪpjʊleɪʃən",
    "manipulations": "mənɪpjʊleɪʃənz",
    "manipulative": "mənɪpjʊlətɪv",
    "manipulator": "mənɪpjʊleɪtɐ",
    "manipulators": "mənɪpjʊleɪtəz",
    "mankind": "mæŋkaɪnd",
    "manky": "mæŋki",
    "manliest": "mænliəst",
    "manliness": "mænlinəs",
    "manly": "mænli",
    "manmade": "mænmeɪd",
    "man": "mæn",
    "manna": "mænɐ",
    "manned": "mænd",
    "mannequin": "mænɪkwɪn",
    "mannequins": "mænɪkwɪnz",
    "mannered": "mænəd",
    "mannerism": "mænərɪzəm",
    "mannerisms": "mænərɪzəmz",
    "mannerist": "mænərɪst",
    "mannerly": "mænəli",
    "manner": "mænɐ",
    "manners": "mænəz",
    "mannikin": "mænɪkɪn",
    "manning": "mænɪŋ",
    "mannish": "mænɪʃ",
    "manoeuvrability": "mənuːvrəbɪlɪti",
    "manoeuvrable": "mənuːvrəbəl",
    "manoeuvred": "mənuːvrəd",
    "manoeuvre": "mənuːvɐ",
    "manoeuvres": "mənuːvəz",
    "manoeuvring": "mənuːvrɪŋ",
    "manoeuvrings": "mənuːvrɪŋz",
    "manometer": "mænɒmɪtɐ",
    "manometric": "mænəʊmɛtrɪk",
    "manorial": "mænɔːrɪəl",
    "manor": "mænɐ",
    "manors": "mænəz",
    "manpower": "mænpaʊɐ",
    "mansard": "mænsɑːd",
    "manse": "mæns",
    "manservant": "mænsɜːvənt",
    "manses": "mænsɪz",
    "mansion": "mænʃən",
    "mansions": "mænʃənz",
    "manslaughter": "mænslɔːtɐ",
    "mans": "mænz",
    "manta": "mɑːntɐ",
    "mantas": "mɑːntəz",
    "mantel": "mɑːntəl",
    "mantelpiece": "mɑːntəlpiːs",
    "mantelpieces": "mɑːntəlpiːsɪz",
    "mantelshelf": "mɑːntɪlʃɛlf",
    "mantes": "mɑːnts",
    "mantic": "mɑːntɪk",
    "mantises": "mɑːntaɪzɪz",
    "mantis": "mɑːntiz",
    "mantled": "mɑːntəld",
    "mantle": "mɑːntəl",
    "mantlepiece": "mɑːntəlpiːs",
    "mantlepieces": "mɑːntəlpiːsɪz",
    "mantles": "mɑːntəlz",
    "mantling": "mɑːntlɪŋ",
    "mantra": "mɑːntrɐ",
    "mantrap": "mɑːntræp",
    "mantraps": "mɑːntræps",
    "mantras": "mɑːntrəz",
    "mantua": "mɑːntjuːɐ",
    "manually": "mænjuːəli",
    "manual": "mænjuːəl",
    "manuals": "mænjuːəlz",
    "manubrium": "mænjuːbriəm",
    "manufactories": "mænjuːfæktəriz",
    "manufactory": "mænjuːfæktəri",
    "manufactured": "mænjuːfæktʃəd",
    "manufacture": "mænjuːfæktʃɐ",
    "manufacturer": "mænjuːfæktʃərɐ",
    "manufacturers": "mænjuːfæktʃərəz",
    "manufactures": "mænjuːfæktʃəz",
    "manufacturing": "mænjuːfæktʃərɪŋ",
    "manumission": "mænjuːmɪʃən",
    "manured": "mənjɔːd",
    "manure": "mənjɔː",
    "manures": "mənjɔːz",
    "manuring": "mənjɔːrɪŋ",
    "manuscript": "mænjuːskrɪpt",
    "manuscripts": "mænjuːskrɪpts",
    "many": "mɛni",
    "manzanilla": "mænzɐnɪlɐ",
    "maple": "meɪpəl",
    "maples": "meɪpəlz",
    "map": "mæp",
    "mapmaker": "mæpmeɪkɐ",
    "mapmakers": "mæpmeɪkəz",
    "mapped": "mæpt",
    "mapping": "mæpɪŋ",
    "maps": "mæps",
    "maquette": "mækɛt",
    "maquis": "mækwɪz",
    "marabou": "mærɐbuː",
    "marabous": "mæræbəs",
    "maraca": "mærækɐ",
    "maracas": "mærækəz",
    "mara": "mɑːrɐ",
    "marasca": "mæræskɐ",
    "maraschino": "mærɐstʃiːnəʊ",
    "maras": "mɑːrəz",
    "marathon": "mærəθən",
    "marathons": "mærəθənz",
    "marauded": "mərɔːdɪd",
    "marauder": "mərɔːdɐ",
    "marauders": "mərɔːdəz",
    "marauding": "mərɔːdɪŋ",
    "marbled": "mɑːbəld",
    "marbleised": "mɑːblaɪzd",
    "marble": "mɑːbəl",
    "marbles": "mɑːbəlz",
    "marbling": "mɑːblɪŋ",
    "marcasite": "mɑːkɐsaɪt",
    "marcel": "mɑːsɛl",
    "marched": "mɑːtʃt",
    "marcher": "mɑːtʃɐ",
    "marchers": "mɑːtʃəz",
    "marches": "mɑːtʃɪz",
    "marching": "mɑːtʃɪŋ",
    "marchioness": "mɑːʃənɛs",
    "march": "mɑːtʃ",
    "marc": "mɑːk",
    "mares": "meəz",
    "margarine": "mɑːdʒəriːn",
    "margarita": "mɑːɡəriːtɐ",
    "margaritas": "mɑːɡərɪtəz",
    "margay": "mɑːɡeɪ",
    "marge": "mɑːdʒ",
    "marginalia": "mɑːdʒɪneɪliə",
    "marginalisation": "mɑːdʒɪnəlaɪzeɪʃən",
    "marginalised": "mɑːdʒɪnəlaɪzd",
    "marginalise": "mɑːdʒɪnəlaɪz",
    "marginalises": "mɑːdʒɪnəlaɪzɪz",
    "marginalising": "mɑːdʒɪnəlaɪzɪŋ",
    "marginality": "mɑːdʒɪnælɪti",
    "marginally": "mɑːdʒɪnəli",
    "marginal": "mɑːdʒɪnəl",
    "marginals": "mɑːdʒɪnəlz",
    "margin": "mɑːdʒɪn",
    "margins": "mɑːdʒɪnz",
    "margrave": "mɑːɡreɪv",
    "marguerite": "mɑːɡəriːt",
    "marguerites": "mɑːɡəriːts",
    "mariachi": "mærɪætʃi",
    "mariachis": "mærɪætʃɪz",
    "marigold": "mærɪɡəʊld",
    "marigolds": "mærɪɡəʊldz",
    "marijuana": "mærɪwɑːnɐ",
    "marimba": "mærɪmbɐ",
    "marimbas": "mærɪmbəz",
    "marinaded": "mærɪneɪdɪd",
    "marinade": "mærɪneɪd",
    "marinades": "mærɪneɪdz",
    "marinading": "mærɪneɪdɪŋ",
    "marina": "məriːnɐ",
    "marinara": "mærɪnɑːrɐ",
    "marinas": "məriːnəz",
    "marinated": "mærɪneɪtɪd",
    "marinate": "mærɪneɪt",
    "marinates": "mærɪneɪts",
    "marinating": "mærɪneɪtɪŋ",
    "marination": "mærɪneɪʃən",
    "marine": "məriːn",
    "mariner": "mærɪnɐ",
    "mariners": "mærɪnəz",
    "marines": "məriːnz",
    "marionette": "mærɪəʊnɛt",
    "marionettes": "mærɪəʊnɛts",
    "marital": "mærɪtəl",
    "maritime": "mærɪtaɪm",
    "marjoram": "mɑːdʒɔːræm",
    "markdowns": "mɑːkdaʊnz",
    "markedly": "mɑːkɪdli",
    "marker": "mɑːkɐ",
    "markers": "mɑːkəz",
    "marketability": "mɑːkiːtəbɪlɪti",
    "marketable": "mɑːkɪtəbəl",
    "marketed": "mɑːkɪtɪd",
    "marketeer": "mɑːkɪtiə",
    "marketeers": "mɑːkɪtiəz",
    "marketer": "mɑːkɪtɐ",
    "marketers": "mɑːkɪtəz",
    "marketing": "mɑːkɪtɪŋ",
    "market": "mɑːkɪt",
    "marketplace": "mɑːkɪtpleɪs",
    "marketplaces": "mɑːkɪtpleɪsɪz",
    "markets": "mɑːkɪts",
    "markhor": "mɑːkhɐ",
    "marking": "mɑːkɪŋ",
    "markings": "mɑːkɪŋz",
    "markka": "mɑːkɐ",
    "mark": "mɑːk",
    "marksman": "mɑːksmən",
    "marksmanship": "mɑːksmənʃɪp",
    "marksmen": "mɑːksmɛn",
    "marks": "mɑːks",
    "markswoman": "mɑːkswʊmən",
    "markup": "mɑːkʌp",
    "marlin": "mɑːlɪn",
    "marlinspike": "mɑːlɪnspaɪk",
    "marl": "mɑːl",
    "marly": "mɑːli",
    "mar": "mɑː",
    "marmalade": "mɑːmɐleɪd",
    "marmite": "mɑːmaɪt",
    "marmoreal": "mɑːmɔːriəl",
    "marmoset": "mɑːməsɛt",
    "marmosets": "mɑːməsɛts",
    "marmot": "mɑːmɒt",
    "marmots": "mɑːmɒts",
    "marooned": "məruːnd",
    "marooning": "məruːnɪŋ",
    "maroon": "məruːn",
    "maroons": "məruːnz",
    "marquee": "mɑːkiː",
    "marquees": "mɑːkiːz",
    "marque": "mɑːk",
    "marques": "mɑːks",
    "marquesses": "mɑːkwɛsɪz",
    "marquess": "mɑːkwɛs",
    "marquetry": "mɑːkwɪtri",
    "marquise": "mɑːkwaɪz",
    "marquises": "mɑːrkiːɪz",
    "marquisette": "mɑːkwaɪsɛt",
    "marquis": "mɑːrkiː",
    "marred": "mɑːd",
    "marriageability": "mærɪdʒəbɪlɪti",
    "marriageable": "mærɪdʒəbəl",
    "marriage": "mærɪdʒ",
    "marriages": "mærɪdʒɪz",
    "married": "mærɪd",
    "marrieds": "mærɪdz",
    "marries": "mærɪz",
    "marring": "mɑːrɪŋ",
    "marron": "mærən",
    "marrowbone": "mærəʊbəʊn",
    "marrowbones": "mærəʊbəʊnz",
    "marrowfat": "mærəʊfæt",
    "marrow": "mærəʊ",
    "marrows": "mærəʊz",
    "marrying": "mærɪɪŋ",
    "marry": "mæri",
    "marseilles": "mɑːseɪlz",
    "marshalled": "mɑːʃəld",
    "marshaller": "mɑːʃɔːlɐ",
    "marshalling": "mɑːʃəlɪŋ",
    "marshal": "mɑːʃəl",
    "marshals": "mɑːʃəlz",
    "marshes": "mɑːʃɪz",
    "marshland": "mɑːʃlənd",
    "marshlands": "mɑːʃləndz",
    "marsh": "mɑːʃ",
    "marshmallow": "mɑːʃmɐləʊ",
    "marshmallows": "mɑːʃmɐləʊz",
    "marshy": "mɑːʃi",
    "mars": "mɑːz",
    "marsupial": "mɑːsuːpɪəl",
    "marsupials": "mɑːsuːpɪəlz",
    "marsupia": "mɑːsuːpiə",
    "marten": "mɑːtən",
    "martens": "mɑːtənz",
    "martially": "mɑːʃəli",
    "martial": "mɑːʃəl",
    "martian": "mɑːʃən",
    "martinet": "mɑːtɪnɛt",
    "martingale": "mɑːtɪŋɡeɪl",
    "martini": "mɑːtiːni",
    "martinis": "mɑːtiːnɪz",
    "martin": "mɑːtɪn",
    "martins": "mɑːtɪnz",
    "martlet": "mɑːtlət",
    "mart": "mɑːt",
    "marts": "mɑːts",
    "martyrdom": "mɑːtɪədəm",
    "martyred": "mɑːtəd",
    "martyr": "mɑːtɐ",
    "martyrs": "mɑːtəz",
    "marvelled": "mɑːvəld",
    "marvelling": "mɑːvəlɪŋ",
    "marvellously": "mɑːvələsli",
    "marvellous": "mɑːvələs",
    "marvellousness": "mɑːvələsnəs",
    "marvel": "mɑːvəl",
    "marvels": "mɑːvəlz",
    "marzipan": "mɑːzɪpæn",
    "mascara": "mæskɑːrɐ",
    "mascaras": "mæskɑːrəz",
    "mascot": "mæskɒt",
    "mascots": "mæskɒts",
    "masculine": "mæskjʊlɪn",
    "masculinity": "mæskjʊlɪnɪti",
    "maser": "meɪzɐ",
    "mashed": "mæʃt",
    "masher": "mæʃɐ",
    "mashers": "mæʃəz",
    "mashes": "mæʃɪz",
    "mashie": "mæʃi",
    "mashing": "mæʃɪŋ",
    "mash": "mæʃ",
    "masjid": "mæsdʒɪd",
    "masked": "mɑːskt",
    "masking": "mɑːskɪŋ",
    "mask": "mɑːsk",
    "masks": "mɑːsks",
    "mas": "mæs",
    "masochism": "mæsəkɪzəm",
    "masochistically": "mæsəkɪstɪkli",
    "masochistic": "mæsəkɪstɪk",
    "masochist": "mæsəkɪst",
    "masochists": "mæsəkɪsts",
    "masonic": "mæsɒnɪk",
    "mason": "meɪsən",
    "masonry": "meɪsɒnri",
    "masons": "meɪsənz",
    "masque": "mæsk",
    "masqueraded": "mæskwəreɪdɪd",
    "masquerade": "mæskwəreɪd",
    "masqueraders": "mæskwəreɪdəz",
    "masquerades": "mæskwəreɪdz",
    "masquerading": "mæskwəreɪdɪŋ",
    "masques": "mæsks",
    "massacred": "mæsəkəd",
    "massacre": "mæsəkɐ",
    "massacres": "mæsəkəz",
    "massacring": "mæsækrɪŋ",
    "massaged": "mæsɑːʒd",
    "massage": "mæsɑːʒ",
    "massages": "mæsɑːʒɪz",
    "massaging": "mæsɑːʒɪŋ",
    "massed": "mæst",
    "masses": "mæsɪz",
    "masseter": "mæsɛtɐ",
    "masseur": "mæsɜː",
    "masseurs": "mæsɜːz",
    "masseuse": "mæsɜːz",
    "masseuses": "mæsɜːzɪz",
    "massif": "mæsɪf",
    "massing": "mæsɪŋ",
    "massively": "mæsɪvli",
    "massive": "mæsɪv",
    "massiveness": "mæsɪvnəs",
    "massless": "mæsləs",
    "mass": "mæs",
    "massy": "mæsi",
    "mastaba": "mɑːstɑːbɐ",
    "mastectomies": "mɑːstɛktəmɪz",
    "mastectomy": "mɑːstɛktəmi",
    "masted": "mɑːstɪd",
    "masterclasses": "mɑːstəklɑːsɪz",
    "masterclass": "mɑːstəklɑːs",
    "mastered": "mɑːstəd",
    "masterfully": "mɑːstəfəli",
    "masterful": "mɑːstəfəl",
    "masterfulness": "mɑːstəfəlnəs",
    "mastering": "mɑːstərɪŋ",
    "masterly": "mɑːstəli",
    "masterminded": "mɑːstəmaɪndɪd",
    "masterminding": "mɑːstəmaɪndɪŋ",
    "mastermind": "mɑːstəmaɪnd",
    "masterminds": "mɑːstəmaɪndz",
    "master": "mɑːstɐ",
    "masterpiece": "mɑːstəpiːs",
    "masterpieces": "mɑːstəpiːsɪz",
    "mastership": "mɑːstəʃɪp",
    "masters": "mɑːstəz",
    "masterstroke": "mɑːstəstrəʊk",
    "masterstrokes": "mɑːstəstrəʊks",
    "masterwork": "mɑːstəwɜːk",
    "masterworks": "mɑːstəwɜːks",
    "mastery": "mɑːstəri",
    "masthead": "mɑːsthɛd",
    "mastheads": "mɑːsthɛdz",
    "masticated": "mɑːstɪkeɪtɪd",
    "masticate": "mɑːstɪkeɪt",
    "masticates": "mɑːstɪkeɪts",
    "mastication": "mɑːstɪkeɪʃən",
    "masticator": "mɑːstɪkeɪtɐ",
    "mastic": "mɑːstɪk",
    "mastiff": "mɑːstɪf",
    "mastiffs": "mɑːstɪfs",
    "mastitis": "mɑːstaɪtɪs",
    "mast": "mɑːst",
    "mastodon": "mæstədɒn",
    "mastoid": "mɑːstɔɪd",
    "masts": "mɑːsts",
    "masturbated": "mɑːstəbeɪtɪd",
    "masturbate": "mɑːstəbeɪt",
    "masturbates": "mɑːstəbeɪts",
    "masturbating": "mɑːstəbeɪtɪŋ",
    "masturbation": "mɑːstəbeɪʃən",
    "masturbator": "mɑːstəbeɪtɐ",
    "masturbatory": "mɑːstəbətəri",
    "matador": "mætɐdɔː",
    "matadors": "mætɐdɔːz",
    "matchbook": "mætʃbʊk",
    "matchbooks": "mætʃbʊks",
    "matchboxes": "mætʃbɒksɪz",
    "matchbox": "mætʃbɒks",
    "matched": "mætʃt",
    "matcher": "mætʃɐ",
    "matches": "mætʃɪz",
    "matching": "mætʃɪŋ",
    "matchless": "mætʃləs",
    "matchlock": "mætʃlɒk",
    "match": "mætʃ",
    "matchmaker": "mætʃmeɪkɐ",
    "matchmakers": "mætʃmeɪkəz",
    "matchmaking": "mætʃmeɪkɪŋ",
    "matchplay": "mætʃpleɪ",
    "matchstick": "mætʃstɪk",
    "matchsticks": "mætʃstɪks",
    "matchup": "mætʃʌp",
    "matchwood": "mætʃwʊd",
    "mated": "meɪtɪd",
    "matelote": "meɪtləʊt",
    "matelot": "meɪtlɒt",
    "materialisation": "mətiərɪəlaɪzeɪʃən",
    "materialised": "mətiərɪəlaɪzd",
    "materialise": "mətiərɪəlaɪz",
    "materialises": "mətiərɪəlaɪzɪz",
    "materialising": "mətiərɪəlaɪzɪŋ",
    "materialism": "mətiərɪəlɪzəm",
    "materialistic": "mətiərɪəlɪstɪk",
    "materialist": "mətiərɪəlɪst",
    "materiality": "mətiərɪælɪti",
    "materially": "mətiərɪəli",
    "material": "mətiərɪəl",
    "materials": "mətiərɪəlz",
    "mater": "meɪtɐ",
    "maternally": "mətɜːnəli",
    "maternal": "mətɜːnəl",
    "maternity": "mətɜːnɪti",
    "mates": "meɪts",
    "matey": "meɪti",
    "mateys": "meɪtɪz",
    "mathematically": "mæθɪmætɪkli",
    "mathematical": "mæθɪmætɪkəl",
    "mathematician": "mæθɪmɐtɪʃən",
    "mathematicians": "mæθɪmɐtɪʃənz",
    "mathematic": "mæθɪmætɪk",
    "mathematics": "mæθɪmætɪks",
    "math": "mæθ",
    "mating": "meɪtɪŋ",
    "matings": "meɪtɪŋz",
    "matin": "mætɪn",
    "matins": "mætɪnz",
    "mat": "mæt",
    "matriarchal": "mætrɪɑːkəl",
    "matriarch": "mætrɪɑːk",
    "matriarchs": "mætrɪɑːkz",
    "matriarchy": "mætrɪɑːki",
    "matrices": "meɪtrɪsiːz",
    "matricide": "mætrɪsaɪd",
    "matriculated": "mætrɪkjʊleɪtɪd",
    "matriculate": "mætrɪkjʊleɪt",
    "matriculation": "mætrɪkjʊleɪʃən",
    "matrilineal": "mætrɪlɪniəl",
    "matrimonial": "mætrɪməʊnɪəl",
    "matrimony": "mætrɪməni",
    "matrix": "meɪtrɪks",
    "matronly": "meɪtrənli",
    "matron": "meɪtrən",
    "matrons": "meɪtrənz",
    "mats": "mæts",
    "matted": "mætɪd",
    "matte": "mæt",
    "mattered": "mætəd",
    "mattering": "mætərɪŋ",
    "matter": "mætɐ",
    "matters": "mætəz",
    "matting": "mætɪŋ",
    "matt": "mæt",
    "mattock": "mætək",
    "mattocks": "mætəks",
    "mattresses": "mætrəsɪz",
    "mattress": "mætrəs",
    "matts": "mæts",
    "maturation": "mətʃɔːreɪʃən",
    "matured": "mətʃɔːd",
    "maturely": "mətʃɔːli",
    "mature": "mətʃɔː",
    "maturer": "mətʃɔːrɐ",
    "matures": "mətʃɔːz",
    "maturest": "mətʃɔːrəst",
    "maturing": "mətʃɔːrɪŋ",
    "maturities": "mətʃɔːrɪtiz",
    "maturity": "mətʃɔːrɪti",
    "matzo": "mætsəʊ",
    "matzos": "mætsəʊz",
    "maudlin": "mɔːdlɪn",
    "mauled": "mɔːld",
    "mauler": "mɔːlɐ",
    "mauling": "mɔːlɪŋ",
    "maul": "mɔːl",
    "mauls": "mɔːlz",
    "maulstick": "mɔːlstɪk",
    "maunder": "mɔːndɐ",
    "maundy": "mɔːndi",
    "maun": "mɔːn",
    "mausoleum": "mɔːsəliːəm",
    "mausoleums": "mɔːsəliːəmz",
    "mauve": "məʊv",
    "maven": "mævən",
    "maverick": "mævərɪk",
    "mavericks": "mævərɪks",
    "mavin": "mævɪn",
    "mavis": "meɪvɪs",
    "mawkish": "mɔːkɪʃ",
    "maw": "mɔː",
    "maws": "mɔːz",
    "maxed": "mækst",
    "maxes": "mæksɪz",
    "maxilla": "mæksɪlɐ",
    "maxillary": "mæksɪləri",
    "maxi": "mæksi",
    "maximally": "mæksɪməli",
    "maximal": "mæksɪməl",
    "maxima": "mæksɪmɐ",
    "maximisation": "mæksɪmaɪzeɪʃən",
    "maximised": "mæksɪmaɪzd",
    "maximise": "mæksɪmaɪz",
    "maximiser": "mæksɪmaɪzɐ",
    "maximises": "mæksɪmaɪzɪz",
    "maximising": "mæksɪmaɪzɪŋ",
    "maxim": "mæksɪm",
    "maxims": "mæksɪmz",
    "maximum": "mæksɪməm",
    "maximums": "mæksɪməmz",
    "maxing": "mæksɪŋ",
    "maxis": "mæksɪs",
    "maxwell": "mækswɛl",
    "maxwells": "mækswɛlz",
    "maya": "maɪə",
    "maybe": "meɪbiː",
    "maybes": "meɪbiːz",
    "mayday": "meɪdeɪ",
    "mayest": "meɪəst",
    "mayflies": "meɪflaɪz",
    "mayflower": "meɪflaʊɐ",
    "mayfly": "meɪflaɪ",
    "mayhem": "meɪhɛm",
    "may": "meɪ",
    "mayo": "meɪəʊ",
    "mayonnaise": "meɪəneɪz",
    "mayoral": "meərəl",
    "mayoralty": "meərəlti",
    "mayoress": "meərɛs",
    "mayor": "meə",
    "mayorship": "meəʃɪp",
    "mayors": "meəz",
    "maypole": "meɪpəʊl",
    "maypoles": "meɪpəʊlz",
    "mayst": "meɪst",
    "maze": "meɪz",
    "mazer": "meɪzɐ",
    "mazers": "meɪzəz",
    "mazes": "meɪzɪz",
    "mazurka": "mæzɜːkɐ",
    "mazurkas": "mæzɜːkəz",
    "mazy": "meɪzi",
    "mb": "ɛmbiː",
    "mead": "miːd",
    "meadowland": "miːdəʊlənd",
    "meadowlark": "miːdəʊlɑːk",
    "meadow": "mɛdəʊ",
    "meadows": "mɛdəʊz",
    "meadowsweet": "miːdəʊswiːt",
    "meager": "miːɡɐ",
    "meagre": "miːɡɐ",
    "mealie": "miːli",
    "meal": "miːl",
    "meals": "miːlz",
    "mealtime": "miːltaɪm",
    "mealtimes": "miːltaɪmz",
    "mealworm": "miːlwɜːm",
    "mealworms": "miːlwɜːmz",
    "mealy": "miːli",
    "meandered": "miːændəd",
    "meandering": "miːændərɪŋ",
    "meanderings": "miːændərɪŋz",
    "meander": "miːændɐ",
    "meanders": "miːændəz",
    "meaner": "miːnɐ",
    "meanest": "miːnəst",
    "meanie": "miːni",
    "meanies": "miːnɪz",
    "meaningfully": "miːnɪŋfəli",
    "meaningful": "miːnɪŋfəl",
    "meaningfulness": "miːnɪŋfəlnəs",
    "meaningless": "miːnɪŋləs",
    "meaning": "miːnɪŋ",
    "meanings": "miːnɪŋz",
    "meanly": "miːnli",
    "mean": "miːn",
    "meanness": "miːnnəs",
    "means": "miːnz",
    "meantime": "miːntaɪm",
    "meant": "mɛnt",
    "meanwhile": "miːnwaɪl",
    "meany": "miːni",
    "measles": "miːsəlz",
    "measly": "miːzli",
    "measurable": "mɛʒərəbəl",
    "measurably": "mɛʒərəbli",
    "measured": "mɛʒəd",
    "measureless": "mɛʒələs",
    "measurement": "mɛʒəmənt",
    "measurements": "mɛʒəmənts",
    "measure": "mɛʒɐ",
    "measurer": "mɛʒərɐ",
    "measures": "mɛʒəz",
    "measuring": "mɛʒərɪŋ",
    "meatball": "miːtbɔːl",
    "meatballs": "miːtbɔːlz",
    "meathead": "miːthɛd",
    "meatier": "miːtɪɐ",
    "meatiness": "miːtɪnəs",
    "meatless": "miːtləs",
    "meatloaf": "miːtləʊf",
    "meat": "miːt",
    "meatpacking": "miːtpækɪŋ",
    "meats": "miːts",
    "meatus": "miːtəs",
    "meaty": "miːti",
    "mecca": "mɛkɐ",
    "meccas": "mɛkəz",
    "mechanically": "mɪkænɪkli",
    "mechanical": "mɪkænɪkəl",
    "mechanic": "mɪkænɪk",
    "mechanics": "mɪkænɪks",
    "mechanisation": "mɛkɐnaɪzeɪʃən",
    "mechanised": "mɛkɐnaɪzd",
    "mechanise": "mɛkɐnaɪz",
    "mechanising": "mɛkɐnaɪzɪŋ",
    "mechanism": "mɛkənɪzəm",
    "mechanisms": "mɛkɐnɪzəmz",
    "mechanistic": "mɛkɐnɪstɪk",
    "mechanist": "mɛkɐnɪst",
    "medallion": "mədæliən",
    "medallions": "mədæliənz",
    "medallist": "mɛdɐlɪst",
    "medallists": "mɛdɐlɪsts",
    "medal": "mɛdəl",
    "medals": "mɛdəlz",
    "meddled": "mɛdəld",
    "meddle": "mɛdəl",
    "meddler": "mɛdlɐ",
    "meddlers": "mɛdləz",
    "meddlesome": "mɛdəlsʌm",
    "meddling": "mɛdlɪŋ",
    "medevac": "mɛdɪvæk",
    "mediaeval": "mɛdɪiːvəl",
    "medially": "miːdiːəli",
    "medial": "miːdiːəl",
    "media": "miːdiːɐ",
    "median": "miːdiːən",
    "medians": "miːdiːənz",
    "mediant": "miːdiːənt",
    "medias": "miːdiːəz",
    "mediated": "miːdɪeɪtɪd",
    "mediate": "miːdɪeɪt",
    "mediates": "miːdɪeɪts",
    "mediating": "miːdɪeɪtɪŋ",
    "mediation": "miːdɪeɪʃən",
    "mediator": "miːdɪeɪtɐ",
    "mediators": "miːdɪeɪtəz",
    "medicaid": "mɛdɪkeɪd",
    "medically": "mɛdɪkli",
    "medical": "mɛdɪkəl",
    "medicals": "mɛdɪkəlz",
    "medicare": "mɛdɪkeə",
    "medicated": "mɛdɪkeɪtɪd",
    "medicate": "mɛdɪkeɪt",
    "medicates": "mɛdɪkeɪts",
    "medicating": "mɛdɪkeɪtɪŋ",
    "medication": "mɛdɪkeɪʃən",
    "medications": "mɛdɪkeɪʃənz",
    "medicinally": "mɛdɪsɪnəli",
    "medicinal": "mɛdɪsɪnəl",
    "medicine": "mɛdsən",
    "medicines": "mɛdsənz",
    "medic": "mɛdɪk",
    "medico": "mɛdɪkəʊ",
    "medicos": "mɛdɪkəʊz",
    "medics": "mɛdɪks",
    "medievalist": "mɛdɪiːvəlɪst",
    "medieval": "mɛdɪiːvəl",
    "mediocre": "miːdɪəʊkɐ",
    "mediocrities": "miːdɪɒkrɪtiz",
    "mediocrity": "miːdɪɒkrɪti",
    "meditated": "mɛdɪteɪtɪd",
    "meditate": "mɛdɪteɪt",
    "meditates": "mɛdɪteɪts",
    "meditating": "mɛdɪteɪtɪŋ",
    "meditational": "mɛdɪteɪʃənəl",
    "meditation": "mɛdɪteɪʃən",
    "meditations": "mɛdɪteɪʃənz",
    "meditatively": "mɛdɪteɪtɪvli",
    "meditative": "mɛdɪteɪtɪv",
    "meditator": "mɛdɪteɪtɐ",
    "medium": "miːdiəm",
    "mediumship": "miːdiəmʃɪp",
    "mediums": "miːdiəmz",
    "medius": "miːdɪəs",
    "medlar": "mɛdlɐ",
    "medlars": "mɛdləz",
    "medley": "mɛdli",
    "medleys": "mɛdlɪz",
    "medulla": "mɛdʌlɐ",
    "medullary": "mɛdələri",
    "medusa": "mədjuːsɐ",
    "meed": "miːd",
    "meeker": "miːkɐ",
    "meekest": "miːkəst",
    "meekly": "miːkli",
    "meek": "miːk",
    "meekness": "miːknəs",
    "meerkat": "miəkæt",
    "meerkats": "miəkæts",
    "meerschaum": "miəstʃaʊm",
    "meeting": "miːtɪŋ",
    "meetings": "miːtɪŋz",
    "meetly": "miːtli",
    "meet": "miːt",
    "meets": "miːts",
    "megabit": "mɛɡəbɪt",
    "megabits": "mɛɡəbɪts",
    "megabucks": "mɛɡəbʌks",
    "megabyte": "mɛɡəbaɪt",
    "megabytes": "mɛɡəbaɪts",
    "megafauna": "mɛɡəfɔːnɐ",
    "megahertz": "mɛɡəhɜːts",
    "megalithic": "mɛɡəlɪθɪk",
    "megalith": "mɛɡəlɪθ",
    "megaliths": "mɛɡəlɪθs",
    "megalomaniac": "mɛɡələmeɪnɪæk",
    "megalomaniacs": "mɛɡələmeɪnɪæks",
    "megalomania": "mɛɡələmeɪniə",
    "megalopolis": "mɛɡəlɒpəliz",
    "mega": "mɛɡɐ",
    "megaphone": "mɛɡəfəʊn",
    "megaphones": "mɛɡəfəʊnz",
    "megapixel": "mɛɡəpɪksəl",
    "megapixels": "mɛɡəpɪksəlz",
    "megastar": "mɛɡəstɑː",
    "megastars": "mɛɡəstɑːz",
    "megaton": "mɛɡətən",
    "megatons": "mɛɡətənz",
    "megavolt": "mɛɡəvəʊlt",
    "megawatt": "mɛɡəwɒt",
    "megawatts": "mɛɡəwɒts",
    "meg": "mɛɡ",
    "megrim": "mɛɡrɪm",
    "megrims": "mɛɡrɪmz",
    "megs": "mɛɡz",
    "meiosis": "meɪəʊsɪs",
    "meitnerium": "meɪtniərɪəm",
    "melamine": "mɛlɐmiːn",
    "melancholia": "mɛlənkəʊliə",
    "melancholic": "mɛlənkɒlɪk",
    "melancholy": "mɛlənkɒli",
    "melange": "mɛlændʒ",
    "melanin": "mɛlɐnɪn",
    "melanite": "mɛlɐnaɪt",
    "melanoma": "mɛlɐnəʊmɐ",
    "melanomas": "mɛlɐnəʊməz",
    "melatonin": "mɛlɐtɒnɪn",
    "melded": "mɛldɪd",
    "melding": "mɛldɪŋ",
    "meld": "mɛld",
    "melds": "mɛldz",
    "mellifluous": "mɛlɪfluːəs",
    "mellowed": "mɛləʊd",
    "mellower": "mɛləʊɐ",
    "mellowing": "mɛləʊɪŋ",
    "mellow": "mɛləʊ",
    "mellowness": "mɛləʊnəs",
    "mellows": "mɛləʊz",
    "mel": "mɛl",
    "melodeon": "mɛləʊdɪən",
    "melodically": "mɛlɒdɪkli",
    "melodic": "mɛlɒdɪk",
    "melodies": "mɛlədɪz",
    "melodiously": "mɛləʊdɪəsli",
    "melodious": "mɛləʊdɪəs",
    "melodrama": "mɛlədrɑːmɐ",
    "melodramas": "mɛlədrɑːməz",
    "melodramatic": "mɛlədrɐmætɪk",
    "melodramatics": "mɛlədrɐmætɪks",
    "melody": "mɛlədi",
    "melon": "mɛlən",
    "melons": "mɛlənz",
    "meltdown": "mɛltdaʊn",
    "meltdowns": "mɛltdaʊnz",
    "melted": "mɛltɪd",
    "melter": "mɛltɐ",
    "meltingly": "mɛltɪŋli",
    "melting": "mɛltɪŋ",
    "melt": "mɛlt",
    "melton": "mɛltən",
    "melts": "mɛlts",
    "meltwater": "mɛltwɔːtɐ",
    "m": "ɛm",
    "member": "mɛmbɐ",
    "membership": "mɛmbəʃɪp",
    "memberships": "mɛmbəʃɪps",
    "members": "mɛmbəz",
    "membrane": "mɛmbreɪn",
    "membranes": "mɛmbreɪnz",
    "membranous": "mɛmbrænəs",
    "meme": "miːm",
    "mementoes": "məmɛntəʊz",
    "memento": "məmɛntəʊ",
    "mementos": "məmɛntəʊz",
    "me": "miː",
    "memoirist": "mɛmwɑːrɪst",
    "memoir": "mɛmwɑː",
    "memoirs": "mɛmwɑːz",
    "memo": "mɛməʊ",
    "memorabilia": "mɛmərɐbɪliə",
    "memorable": "mɛmərəbəl",
    "memorably": "mɛmərəbli",
    "memoranda": "mɛmərændɐ",
    "memorandum": "mɛmərændəm",
    "memorandums": "mɛmərændəmz",
    "memorialised": "mɛmɔːrɪəlaɪzd",
    "memorialise": "məmɔːrɪəlaɪz",
    "memorialises": "mɛmɔːrɪəlaɪzɪz",
    "memorialising": "mɛmɔːrɪəlaɪzɪŋ",
    "memorial": "məmɔːrɪəl",
    "memorials": "məmɔːrɪəlz",
    "memories": "mɛməriz",
    "memorisation": "mɛmɔːraɪzeɪʃən",
    "memorised": "mɛmɔːraɪzd",
    "memorise": "mɛmɔːraɪz",
    "memorises": "mɛmɔːraɪzɪz",
    "memorising": "mɛmɔːraɪzɪŋ",
    "memory": "mɛməri",
    "memos": "mɛməʊz",
    "memsahib": "mɛmsɐhɪb",
    "memsahibs": "mɛmsɐhɪbz",
    "mems": "mɛmz",
    "menaced": "mɛnɪst",
    "menace": "mɛnɪs",
    "menacer": "mɛneɪsɐ",
    "menaces": "mɛnɪsɪz",
    "menacingly": "mɛnɪsɪŋli",
    "menacing": "mɛnɪsɪŋ",
    "menage": "mɛnɪdʒ",
    "menagerie": "mənædʒjəri",
    "menageries": "mɛneɪdʒərɪz",
    "mendable": "mɛndəbəl",
    "mendacious": "mɛndeɪʃəs",
    "mendacity": "mɛndæsɪti",
    "mended": "mɛndɪd",
    "mendelevium": "mɛndɪliːviəm",
    "mender": "mɛndɐ",
    "menders": "mɛndəz",
    "mendicant": "mɛndɪkənt",
    "mending": "mɛndɪŋ",
    "mend": "mɛnd",
    "mends": "mɛndz",
    "mene": "miːn",
    "menfolk": "mɛnfəʊk",
    "menhir": "mɛnhiə",
    "menial": "miːnɪəl",
    "menials": "miːnɪəlz",
    "meningeal": "mɛnɪndʒiəl",
    "meninges": "mɛnɪndʒɪz",
    "meningitis": "mɛnɪndʒaɪtɪs",
    "meniscus": "mɛnɪskəs",
    "men": "mɛn",
    "menopausal": "mɛnəpɔːsəl",
    "menopause": "mɛnəpɔːz",
    "menorah": "mɛnɔːrɐ",
    "menschen": "mɛnstʃən",
    "mensch": "mɛnʃ",
    "menstrual": "mɛnstruːəl",
    "menstruate": "mɛnstruːeɪt",
    "menstruating": "mɛnstruːeɪtɪŋ",
    "menstruation": "mɛnstruːeɪʃən",
    "menswear": "mɛnsweə",
    "mentalism": "mɛntəlɪzəm",
    "mentalist": "mɛntəlɪst",
    "mentalists": "mɛntəlɪsts",
    "mentalities": "mɛntælɪtiz",
    "mentality": "mɛntælɪti",
    "mentally": "mɛntəli",
    "mental": "mɛntəl",
    "mentation": "mɛnteɪʃən",
    "mentholated": "mɛnθəleɪtɪd",
    "menthol": "mɛnθɒl",
    "mentioned": "mɛnʃənd",
    "mentioning": "mɛnʃənɪŋ",
    "mention": "mɛnʃən",
    "mentions": "mɛnʃənz",
    "mentored": "mɛntəd",
    "mentoring": "mɛntɔːrɪŋ",
    "mentor": "mɛntɔː",
    "mentorship": "mɛntɔːʃɪp",
    "mentors": "mɛntɔːz",
    "menu": "mɛnjuː",
    "menus": "mɛnjuːz",
    "meowed": "mɪaʊd",
    "meowing": "mɪaʊɪŋ",
    "meow": "mɪaʊ",
    "meows": "mɪaʊz",
    "mercantile": "mɜːkɑːntaɪl",
    "mercenaries": "mɜːsənəriz",
    "mercenary": "mɜːsənəri",
    "mercer": "mɜːsɐ",
    "mercers": "mɜːsəz",
    "merchandised": "mɜːtʃɐndaɪzd",
    "merchandise": "mɜːtʃɐndaɪz",
    "merchandiser": "mɜːtʃɐndaɪzɐ",
    "merchandisers": "mɜːtʃɐndaɪzəz",
    "merchandising": "mɜːtʃɐndaɪzɪŋ",
    "merchantman": "mɜːtʃɑːntmən",
    "merchantmen": "mɜːtʃɑːntmɛn",
    "merchant": "mɜːtʃənt",
    "merchants": "mɜːtʃənts",
    "mercies": "mɜːsɪz",
    "mercifully": "mɜːsɪfəli",
    "merciful": "mɜːsɪfəl",
    "mercilessly": "mɜːsɪləsli",
    "merciless": "mɜːsɪləs",
    "mercurial": "mɜːkjʊrɪəl",
    "mercuric": "mɜːkjʊrɪk",
    "mercury": "mɜːkjʊri",
    "mercy": "mɜːsi",
    "merely": "miəli",
    "mere": "miə",
    "merengue": "mɛrɛŋ",
    "meres": "miəz",
    "merest": "miərəst",
    "meretricious": "mɛrɪtrɪʃəs",
    "merganser": "mɜːɡænsɐ",
    "mergansers": "mɜːɡænsəz",
    "merged": "mɜːdʒd",
    "merge": "mɜːdʒ",
    "merger": "mɜːdʒɐ",
    "mergers": "mɜːdʒəz",
    "merges": "mɜːdʒɪz",
    "merging": "mɜːdʒɪŋ",
    "meridian": "mɛrɪdiən",
    "meridians": "mɛrɪdiənz",
    "meringue": "məræŋ",
    "meringues": "məræŋz",
    "merino": "mɛriːnəʊ",
    "merinos": "mɛriːnəʊz",
    "meristem": "mɛrɪstəm",
    "merited": "mɛrɪtɪd",
    "meritless": "mɛrɪtləs",
    "merit": "mɛrɪt",
    "meritocracy": "mɛrɪtɒkrəsi",
    "meritocratic": "mɛrɪtəkrætɪk",
    "meritocrat": "mɛrɪtɒkræt",
    "meritorious": "mɛrɪtɔːrɪəs",
    "merits": "mɛrɪts",
    "merle": "mɜːl",
    "merlin": "mɜːlɪn",
    "merlins": "mɜːlɪnz",
    "mermaid": "mɜːmeɪd",
    "mermaids": "mɜːmeɪdz",
    "merman": "mɜːmən",
    "mermen": "mɜːmɛn",
    "merrier": "mɛrɪɐ",
    "merriest": "mɛrɪəst",
    "merrily": "mɛrɪli",
    "merriment": "mɛrɪmənt",
    "merrymakers": "mɛrɪmeɪkəz",
    "merrymaking": "mɛrɪmeɪkɪŋ",
    "merry": "mɛri",
    "merrythought": "mɛrɪθɔːt",
    "mesa": "meɪsɐ",
    "mesas": "meɪsəz",
    "mescaline": "mɛskəlaɪn",
    "mescalin": "mɛskɐlɪn",
    "mescal": "mɛskəl",
    "mesdames": "mɛzdeɪmz",
    "mesentery": "mɛsɪntəri",
    "meshed": "mɛʃt",
    "meshes": "mɛʃɪz",
    "meshing": "mɛʃɪŋ",
    "mesh": "mɛʃ",
    "meshwork": "mɛʃwɜːk",
    "mesic": "mɛzɪk",
    "mesmeric": "mɛsmɛrɪk",
    "mesmerised": "mɛsməraɪzd",
    "mesmerise": "mɛsməraɪz",
    "mesmerises": "mɛsməraɪzɪz",
    "mesmerising": "mɛsməraɪzɪŋ",
    "mesmerism": "mɛsmərɪzəm",
    "mes": "mɛs",
    "meson": "miːzɒn",
    "mesons": "miːzɒnz",
    "mesosphere": "mɛsəsfiə",
    "mesquite": "mɛskiːt",
    "messaged": "mɛsɪdʒd",
    "message": "mɛsɪdʒ",
    "messages": "mɛsɪdʒɪz",
    "messaging": "mɛsɪdʒɪŋ",
    "messed": "mɛst",
    "messenger": "mɛsɪndʒɐ",
    "messengers": "mɛsɪndʒəz",
    "messes": "mɛsɪz",
    "messiah": "mɛsaɪə",
    "messiahs": "mɛsaɪəz",
    "messianic": "mɛsɪænɪk",
    "messier": "mɛsɪɐ",
    "messiest": "mɛsɪəst",
    "messieurs": "mɛsɪɜːz",
    "messily": "mɛsɪli",
    "messiness": "mɛsɪnəs",
    "messing": "mɛsɪŋ",
    "mess": "mɛs",
    "messy": "mɛsi",
    "mestizo": "mɛstɪzəʊ",
    "mestizos": "mɛstɪzəʊz",
    "metabolically": "mɛtəbɒlɪkli",
    "metabolic": "mɛtəbɒlɪk",
    "metabolised": "mətæbəlaɪzd",
    "metabolise": "mətæbəlaɪz",
    "metabolises": "mətæbəlaɪzɪz",
    "metabolising": "mətæbəlaɪzɪŋ",
    "metabolism": "mətæbəlɪzəm",
    "metabolisms": "mətæbəlɪzəmz",
    "metabolites": "mətæbəlaɪts",
    "metacarpal": "mɛtəkɑːpəl",
    "metacarpals": "mɛtəkɑːpəlz",
    "metacarpus": "mɛtəkɑːpəs",
    "metalled": "mɛtəld",
    "metallically": "mətælɪkli",
    "metallic": "mətælɪk",
    "metalloid": "mɛtəlɔɪd",
    "metallurgical": "mɛtɐlɜːdʒɪkəl",
    "metallurgist": "mɛtælədʒɪst",
    "metallurgists": "mɛtælədʒɪsts",
    "metallurgy": "mɛtælɜːdʒi",
    "metal": "mɛtəl",
    "metals": "mɛtəlz",
    "metalware": "mɛtəlweə",
    "metalworker": "mɛtəlwɜːkɐ",
    "metalworkers": "mɛtəlwɜːkəz",
    "metalworking": "mɛtəlwɜːkɪŋ",
    "metalwork": "mɛtəlwɜːk",
    "metamorphic": "mɛtəmɔːfɪk",
    "metamorphosed": "mɛtəmɔːfəʊzd",
    "metamorphose": "mɛtəmɔːfəʊz",
    "metamorphoses": "mɛtəmɔːfəʊzɪz",
    "metamorphosing": "mɛtəmɔːfəʊzɪŋ",
    "metamorphosis": "mɛtəmɔːfəsɪs",
    "metaphorically": "mɛtəfɒrɪkli",
    "metaphorical": "mɛtəfɒrɪkəl",
    "metaphoric": "mɛtəfɒrɪk",
    "metaphor": "mɛtəfɔː",
    "metaphors": "mɛtəfɔːz",
    "metaphysical": "mɛtəfɪzɪkəl",
    "metaphysic": "mɛtəfɪzɪk",
    "metaphysics": "mɛtəfɪzɪks",
    "metastases": "mɛtəsteɪsɪz",
    "metastasised": "mɛtəstæsaɪzd",
    "metastasis": "mɛtəstæsiz",
    "metastatic": "mɛtəstætɪk",
    "metatarsal": "mɛtətɑːsəl",
    "metatarsals": "mɛtətɑːsəlz",
    "meted": "miːtɪd",
    "mete": "miːt",
    "meteoric": "miːtɪɒrɪk",
    "meteorite": "miːtɪɔːraɪt",
    "meteorites": "miːtɪɔːraɪts",
    "meteor": "miːtɪɐ",
    "meteoroid": "miːtɪɔːrɔɪd",
    "meteoroids": "miːtɪɔːrɔɪdz",
    "meteorologically": "miːtɪɔːrəlɒdʒɪkli",
    "meteorological": "miːtɪɔːrəlɒdʒɪkəl",
    "meteorologist": "miːtɪɔːrɒlədʒɪst",
    "meteorologists": "miːtɪɔːrɒlədʒɪsts",
    "meteorology": "miːtɪɔːrɒlədʒi",
    "meteors": "miːtɪəz",
    "meterage": "miːtərɪdʒ",
    "metered": "miːtəd",
    "metering": "miːtərɪŋ",
    "meter": "miːtɐ",
    "meters": "miːtəz",
    "metes": "miːts",
    "methadone": "mɛθɐdəʊn",
    "methamphetamine": "mɛθɐmfɛtɐmiːn",
    "methane": "miːθeɪn",
    "methanol": "mɛθɐnɒl",
    "methinks": "miːθɪŋks",
    "methionine": "mɛθɪɒnaɪn",
    "methodically": "mɛθɒdɪkli",
    "methodical": "mɛθɒdɪkəl",
    "method": "mɛθəd",
    "methodologies": "mɛθədɒlədʒɪz",
    "methodology": "mɛθədɒlədʒi",
    "methods": "mɛθədz",
    "methought": "mɛθɔːt",
    "meths": "mɛθs",
    "methylated": "miːθɪleɪtɪd",
    "methyl": "miːθaɪl",
    "metical": "mɛtɪkəl",
    "metic": "mɛtɪk",
    "meticulously": "mɛtɪkjʊləsli",
    "meticulous": "mɛtɪkjʊləs",
    "meting": "miːtɪŋ",
    "met": "mɛt",
    "metre": "miːtɐ",
    "metres": "miːtəz",
    "metrically": "mɛtrɪkli",
    "metrical": "mɛtrɪkəl",
    "metricated": "mɛtrɪkeɪtɪd",
    "metrication": "mɛtrɪkeɪʃən",
    "metric": "mɛtrɪk",
    "metrics": "mɛtrɪks",
    "metro": "mɛtrəʊ",
    "metronome": "mɛtrənəʊm",
    "metronomes": "mɛtrənəʊmz",
    "metronomic": "mɛtrənɒmɪk",
    "metropolises": "mətrɒpəlɪsɪz",
    "metropolis": "mətrɒpəlɪs",
    "metropolitan": "mɛtrəpɒlɪtən",
    "metros": "mɛtrəʊz",
    "mettle": "mɛtəl",
    "mettlesome": "mɛtəlsʌm",
    "mewed": "mjuːd",
    "mewing": "mjuːɪŋ",
    "mewling": "mjuːlɪŋ",
    "mew": "mjuː",
    "mews": "mjuːz",
    "mezereum": "mɛzəriːəm",
    "mezuzah": "mɛzjuːzɐ",
    "mezzanine": "mɛzəniːn",
    "mezzanines": "mɛzəniːnz",
    "mezzo": "mɛzəʊ",
    "mezzos": "mɛzəʊz",
    "mezzotint": "mɛzətɪnt",
    "mezzotints": "mɛzətɪnts",
    "mf": "ɛmɛf",
    "mho": "ɛmeɪtʃəʊ",
    "miaowed": "miːaʊd",
    "miaowing": "miːaʊɪŋ",
    "miaow": "miːaʊ",
    "miaows": "miːaʊz",
    "miasma": "maɪæzmɐ",
    "miasmas": "maɪæzməz",
    "mica": "maɪkɐ",
    "mice": "maɪs",
    "mickey": "mɪki",
    "mickeys": "mɪkɪz",
    "mick": "mɪk",
    "micks": "mɪks",
    "mic": "maɪk",
    "micra": "mɪkrɐ",
    "microbe": "maɪkrəʊb",
    "microbes": "maɪkrəʊbz",
    "microbial": "maɪkrəʊbɪəl",
    "microbiological": "maɪkrəʊbaɪəlɒdʒɪkəl",
    "microbiologist": "maɪkrəʊbaɪɒlədʒɪst",
    "microbiologists": "maɪkrəʊbaɪɒlədʒɪsts",
    "microbiology": "maɪkrəʊbaɪɒlədʒi",
    "microbreweries": "maɪkrəʊbruːəriz",
    "microbrewery": "maɪkrəʊbruːəri",
    "microbus": "maɪkrəʊbəs",
    "microcephaly": "maɪkrəʊsɛfəli",
    "microchip": "maɪkrəʊtʃɪp",
    "microchips": "maɪkrəʊtʃɪps",
    "microclimate": "maɪkrəʊklaɪmət",
    "microcomputer": "maɪkrəʊkəmpjuːtɐ",
    "microcosmic": "maɪkrəʊkɒzmɪk",
    "microcosm": "maɪkrəʊkɒzəm",
    "microcosms": "maɪkrəʊkɒzəmz",
    "microcrystalline": "maɪkrəʊkrɪstɐlaɪn",
    "microdot": "maɪkrəʊdɒt",
    "microdots": "maɪkrəʊdɒts",
    "microeconomics": "maɪkrəʊiːkənɒmɪks",
    "microelectronics": "maɪkrəʊɛlɪktrɒnɪks",
    "microfiche": "maɪkrəʊfiːʃ",
    "microfilmed": "maɪkrəʊfɪlmd",
    "microfilm": "maɪkrəʊfɪlm",
    "microgram": "maɪkrəʊɡræm",
    "micrograms": "maɪkrəʊɡræmz",
    "micrograph": "maɪkrəɡræf",
    "microgravity": "maɪkrəʊɡrævɪti",
    "microlight": "maɪkrəʊlaɪt",
    "microlights": "maɪkrəʊlaɪts",
    "micro": "maɪkrəʊ",
    "micromanaged": "maɪkrəʊmænɪdʒd",
    "micromanage": "maɪkrəʊmænɪdʒ",
    "micromanagement": "maɪkrəʊmænɪdʒmənt",
    "micromanaging": "maɪkrəʊmænɪdʒɪŋ",
    "micrometers": "maɪkrəʊmiːtəz",
    "micron": "maɪkrɒn",
    "microns": "maɪkrɒnz",
    "microorganism": "maɪkrəʊɔːɡənɪzəm",
    "microorganisms": "maɪkrəʊɔːɡənɪzəmz",
    "microphone": "maɪkrəfəʊn",
    "microphones": "maɪkrəfəʊnz",
    "microprocessor": "maɪkrəʊprəʊsɛsɐ",
    "microprocessors": "maɪkrəʊprəʊsɛsəz",
    "microscope": "maɪkrəskəʊp",
    "microscopes": "maɪkrəskəʊps",
    "microscopically": "maɪkrəskɒpɪkli",
    "microscopic": "maɪkrəskɒpɪk",
    "microscopy": "maɪkrəskəpi",
    "microsecond": "maɪkrəʊsɛkənd",
    "microseconds": "maɪkrəʊsɛkəndz",
    "micros": "maɪkrəʊz",
    "microstructure": "maɪkrəʊstrʌktʃɐ",
    "microsurgery": "maɪkrəʊsɜːdʒəri",
    "microwavable": "maɪkrəʊweɪvəbəl",
    "microwaveable": "maɪkrəʊweɪvəbəl",
    "microwaved": "maɪkrəʊweɪvd",
    "microwave": "maɪkrəʊweɪv",
    "microwaves": "maɪkrəʊweɪvz",
    "microwaving": "maɪkrəʊweɪvɪŋ",
    "mics": "maɪks",
    "midair": "mɪdeə",
    "midday": "mɪddeɪ",
    "midden": "mɪdən",
    "middens": "mɪdənz",
    "middlebrow": "mɪdəlbraʊ",
    "middleman": "mɪdəlmæn",
    "middle": "mɪdəl",
    "middlemen": "mɪdəlmɛn",
    "middles": "mɪdəlz",
    "middleweight": "mɪdəlweɪt",
    "middleweights": "mɪdəlweɪts",
    "middling": "mɪdlɪŋ",
    "middy": "mɪdi",
    "midfielder": "mɪdfiːldɐ",
    "midfielders": "mɪdfiːldəz",
    "midfield": "mɪdfiːld",
    "midge": "mɪdʒ",
    "midges": "mɪdʒɪz",
    "midget": "mɪdʒɪt",
    "midgets": "mɪdʒɪts",
    "midi": "mɪdi",
    "midland": "mɪdlənd",
    "midlands": "mɪdləndz",
    "midlife": "mɪdlaɪf",
    "midline": "mɪdlaɪn",
    "mid": "mɪd",
    "midnight": "mɪdnaɪt",
    "midpoint": "mɪdpɔɪnt",
    "midrash": "mɪdræʃ",
    "midrib": "mɪdrɪb",
    "midribs": "mɪdrɪbz",
    "midriff": "mɪdrɪf",
    "midriffs": "mɪdrɪfs",
    "midsection": "mɪdsɛkʃən",
    "midshipman": "mɪdʃɪpmən",
    "midship": "mɪdʃɪp",
    "midshipmen": "mɪdʃɪpmɛn",
    "midships": "mɪdʃɪps",
    "midst": "mɪdst",
    "midstream": "mɪdstriːm",
    "midsummer": "mɪdsʌmɐ",
    "midterm": "mɪdtɜːm",
    "midterms": "mɪdtɜːmz",
    "midtown": "mɪdtaʊn",
    "midway": "mɪdweɪ",
    "midweek": "mɪdwiːk",
    "midwicket": "mɪdwɪkɪt",
    "midwife": "mɪdwaɪf",
    "midwifery": "mɪdwɪfəri",
    "midwifes": "mɪdwaɪfs",
    "midwinter": "mɪdwɪntɐ",
    "midwives": "mɪdwaɪvz",
    "midyear": "mɪdjiə",
    "mien": "miən",
    "miffed": "mɪft",
    "miff": "mɪf",
    "miffy": "mɪfi",
    "mightier": "maɪtɪɐ",
    "mightiest": "maɪtɪəst",
    "mightily": "maɪtɪli",
    "mightiness": "maɪtɪnəs",
    "might": "maɪt",
    "mights": "maɪts",
    "mighty": "maɪti",
    "mig": "mɪɡ",
    "mignonette": "mɪɡnənɛt",
    "mignon": "minjɒn",
    "migraine": "maɪɡreɪn",
    "migraines": "maɪɡreɪnz",
    "migrant": "maɪɡrənt",
    "migrants": "maɪɡrənts",
    "migrated": "maɪɡreɪtɪd",
    "migrate": "maɪɡreɪt",
    "migrates": "maɪɡreɪts",
    "migrating": "maɪɡreɪtɪŋ",
    "migrational": "maɪɡreɪʃənəl",
    "migration": "maɪɡreɪʃən",
    "migrations": "maɪɡreɪʃənz",
    "migratory": "maɪɡrætəri",
    "mihrab": "mɪhræb",
    "mikado": "mɪkɑːdəʊ",
    "miked": "maɪkt",
    "mike": "maɪk",
    "mikes": "maɪks",
    "mikveh": "mɪkveɪ",
    "miladies": "mɪleɪdɪz",
    "milady": "mɪleɪdi",
    "milch": "mɪltʃ",
    "milden": "maɪldən",
    "milder": "maɪldɐ",
    "mildest": "maɪldəst",
    "mildewed": "mɪldjuːd",
    "mildew": "mɪldjuː",
    "mildews": "mɪldjuːz",
    "mildly": "maɪldli",
    "mild": "maɪld",
    "mildness": "maɪldnəs",
    "mileage": "maɪlɪdʒ",
    "mileages": "maɪlɪdʒɪz",
    "mile": "maɪl",
    "miler": "maɪlɐ",
    "milers": "maɪləz",
    "miles": "maɪlz",
    "milestone": "maɪlstəʊn",
    "milestones": "maɪlstəʊnz",
    "milia": "mɪliɐ",
    "milieu": "miːljɜː",
    "militancy": "mɪlɪtənsi",
    "militantly": "mɪlɪtəntli",
    "militant": "mɪlɪtənt",
    "militants": "mɪlɪtənts",
    "militaries": "mɪlɪtəriz",
    "militarily": "mɪlɪtɛrəli",
    "militarisation": "mɪlɪtəraɪzeɪʃən",
    "militarised": "mɪlɪtəraɪzd",
    "militarise": "mɪlɪtəraɪz",
    "militarising": "mɪlɪtəraɪzɪŋ",
    "militarism": "mɪlɪtərɪzəm",
    "militaristic": "mɪlɪtɑːrɪstɪk",
    "militarist": "mɪlɪtɑːrɪst",
    "military": "mɪlɪtəri",
    "militated": "mɪlɪteɪtɪd",
    "militate": "mɪlɪteɪt",
    "militates": "mɪlɪteɪts",
    "militating": "mɪlɪteɪtɪŋ",
    "militiaman": "mɪlɪʃiəmən",
    "militia": "məlɪʃɐ",
    "militiamen": "mɪlɪʃiəmɛn",
    "militias": "məlɪʃəz",
    "milked": "mɪlkt",
    "milker": "mɪlkɐ",
    "milkers": "mɪlkəz",
    "milkier": "mɪlkiɐ",
    "milkiness": "mɪlkinəs",
    "milking": "mɪlkɪŋ",
    "milkmaid": "mɪlkmeɪd",
    "milkmaids": "mɪlkmeɪdz",
    "milkman": "mɪlkmən",
    "milkmen": "mɪlkmɛn",
    "milk": "mɪlk",
    "milkshake": "mɪlkʃeɪk",
    "milkshakes": "mɪlkʃeɪks",
    "milks": "mɪlks",
    "milksop": "mɪlksəp",
    "milkweed": "mɪlkwiːd",
    "milkwort": "mɪlkwɔːt",
    "milky": "mɪlki",
    "milled": "mɪld",
    "millenarian": "mɪlɪneəriən",
    "millennial": "mɪlɛnɪəl",
    "millennia": "mɪlɛniə",
    "millennium": "mɪlɛniəm",
    "millenniums": "mɪlɛniəmz",
    "miller": "mɪlɐ",
    "millers": "mɪləz",
    "millet": "mɪlɪt",
    "millibar": "mɪlɪbɑː",
    "millibars": "mɪlɪbɑːz",
    "milligram": "mɪlɪɡræm",
    "milligrams": "mɪlɪɡræmz",
    "millilitre": "mɪlɪliːtɐ",
    "millilitres": "mɪlɪliːtəz",
    "millimetre": "mɪlɪmiːtɐ",
    "millimetres": "mɪlɪmiːtəz",
    "milliner": "mɪlɪnɐ",
    "milliners": "mɪlɪnəz",
    "millinery": "mɪlɪnəri",
    "milling": "mɪlɪŋ",
    "millionaire": "mɪliəneə",
    "millionaires": "mɪliəneəz",
    "millionairess": "mɪliəneəs",
    "million": "mɪliən",
    "millions": "mɪliənz",
    "millionth": "mɪliənθ",
    "millionths": "mɪliənθs",
    "millipede": "mɪlɪpiːd",
    "millipedes": "mɪlɪpiːdz",
    "millisecond": "mɪlɪsɛkənd",
    "milliseconds": "mɪlɪsɛkəndz",
    "millivolts": "mɪlɪvəʊlts",
    "mill": "mɪl",
    "millpond": "mɪlpɒnd",
    "mills": "mɪlz",
    "millstone": "mɪlstəʊn",
    "millstones": "mɪlstəʊnz",
    "millstream": "mɪlstriːm",
    "millwright": "mɪlraɪt",
    "mil": "mɪl",
    "milo": "maɪləʊ",
    "milometer": "maɪlɒmɪtɐ",
    "milord": "maɪlɔːd",
    "milords": "maɪlɔːdz",
    "milos": "maɪləʊz",
    "mils": "mɪlz",
    "milt": "mɪlt",
    "mi": "maɪ",
    "mimed": "maɪmd",
    "mimes": "maɪmz",
    "mimicked": "mɪmɪkt",
    "mimicking": "mɪmɪkɪŋ",
    "mimic": "mɪmɪk",
    "mimicry": "mɪmɪkri",
    "mimics": "mɪmɪks",
    "miming": "maɪmɪŋ",
    "mim": "mɪm",
    "mimosa": "mɪməʊsɐ",
    "minable": "mɪnəbəl",
    "mina": "miːnɐ",
    "minaret": "mɪnərɛt",
    "minarets": "mɪnərɛts",
    "minas": "miːnəz",
    "minced": "mɪnst",
    "mincemeat": "mɪnsɪmiːt",
    "mince": "mɪns",
    "mincer": "mɪnsɐ",
    "mincers": "mɪnsəz",
    "minces": "mɪnsɪz",
    "mincing": "mɪnsɪŋ",
    "minded": "maɪndɪd",
    "mindedness": "maɪndɪdnəs",
    "minder": "maɪndɐ",
    "minders": "maɪndəz",
    "mindful": "maɪndfəl",
    "mindfulness": "maɪndfəlnəs",
    "minding": "maɪndɪŋ",
    "mindlessly": "maɪndləsli",
    "mindless": "maɪndləs",
    "mind": "maɪnd",
    "mindset": "maɪndsɛt",
    "mindsets": "maɪndsɛts",
    "minds": "maɪndz",
    "mined": "maɪnd",
    "minefield": "maɪnfiːld",
    "minefields": "maɪnfiːldz",
    "mine": "maɪn",
    "mineral": "mɪnərəl",
    "mineralogist": "mɪnərælədʒɪst",
    "mineralogy": "mɪnərælədʒi",
    "minerals": "mɪnərəlz",
    "miner": "maɪnɐ",
    "miners": "maɪnəz",
    "mineshaft": "maɪnʃɑːft",
    "mines": "maɪnz",
    "minestrone": "maɪnstrəʊn",
    "minesweeper": "maɪnswiːpɐ",
    "minesweepers": "maɪnswiːpəz",
    "mineworkers": "maɪnwɜːkəz",
    "mingled": "mɪŋɡəld",
    "mingle": "mɪŋɡəl",
    "mingles": "mɪŋɡəlz",
    "mingling": "mɪŋɡəlɪŋ",
    "mingy": "mɪndʒi",
    "miniature": "mɪnɪtʃɐ",
    "miniatures": "mɪnɪtʃəz",
    "miniaturisation": "mɪnɪtʃəraɪzeɪʃən",
    "miniaturised": "mɪnɪtʃəraɪzd",
    "miniaturise": "mɪnɪtʃəraɪz",
    "miniaturising": "mɪnɪtʃəraɪzɪŋ",
    "miniaturist": "mɪnɪtʃərɪst",
    "miniaturists": "mɪnɪtʃərɪsts",
    "minibar": "mɪnɪbɑː",
    "minibuses": "mɪnɪbʌsɪz",
    "minibus": "mɪnɪbʌs",
    "minicab": "mɪnɪkæb",
    "minicabs": "mɪnɪkæbz",
    "minicam": "mɪnɪkæm",
    "minimalism": "mɪnɪməlɪzəm",
    "minimalist": "mɪnɪməlɪst",
    "minimalists": "mɪnɪməlɪsts",
    "minimally": "mɪnɪməli",
    "minimal": "mɪnɪməl",
    "minima": "mɪnɪmɐ",
    "minimisation": "mɪnɪmaɪzeɪʃən",
    "minimised": "mɪnɪmaɪzd",
    "minimise": "mɪnɪmaɪz",
    "minimises": "mɪnɪmaɪzɪz",
    "minimising": "mɪnɪmaɪzɪŋ",
    "minim": "mɪnɪm",
    "mini": "mɪni",
    "minims": "mɪnɪmz",
    "minimum": "mɪnɪməm",
    "minimums": "mɪnɪməmz",
    "minimus": "mɪnɪməs",
    "mining": "maɪnɪŋ",
    "minion": "mɪnɪən",
    "minions": "mɪnɪənz",
    "miniscule": "mɪnɪskjuːl",
    "miniseries": "mɪnɪsəriz",
    "miniskirt": "mɪnɪskɜːt",
    "miniskirts": "mɪnɪskɜːts",
    "minis": "mɪnɪz",
    "ministered": "mɪnɪstəd",
    "ministerial": "mɪnɪstiərɪəl",
    "ministering": "mɪnɪstərɪŋ",
    "minister": "mɪnɪstɐ",
    "ministers": "mɪnɪstəz",
    "ministration": "mɪnɪstreɪʃən",
    "ministrations": "mɪnɪstreɪʃənz",
    "ministries": "mɪnɪstrɪz",
    "ministry": "mɪnɪstri",
    "minivan": "mɪnɪvæn",
    "minivans": "mɪnɪvænz",
    "miniver": "mɪnɪvɐ",
    "minke": "mɪŋk",
    "mink": "mɪŋk",
    "minks": "mɪŋks",
    "minnow": "mɪnəʊ",
    "minnows": "mɪnəʊz",
    "minorities": "maɪnɒrɪtiz",
    "minority": "maɪnɒrɪti",
    "minor": "maɪnɐ",
    "minors": "maɪnəz",
    "minster": "mɪnstɐ",
    "minsters": "mɪnstəz",
    "minstrel": "mɪnstrəl",
    "minstrels": "mɪnstrəlz",
    "minstrelsy": "mɪnstrɛlsi",
    "minted": "mɪntɪd",
    "minter": "mɪntɐ",
    "mintier": "mɪntɪɐ",
    "minting": "mɪntɪŋ",
    "mint": "mɪnt",
    "mints": "mɪnts",
    "minty": "mɪnti",
    "minuet": "mɪnjuːɛt",
    "minuets": "mɪnjuːɛts",
    "minuscule": "mɪnəskjuːl",
    "minuses": "maɪnəsɪz",
    "minus": "maɪnəs",
    "minuted": "mɪnɪtɪd",
    "minutely": "maɪnjuːtli",
    "minuteman": "mɪnɪtmən",
    "minutemen": "mɪnɪtmɛn",
    "minuteness": "maɪnjuːtnəs",
    "minutes": "mɪnɪts",
    "minutest": "maɪnjuːtəst",
    "minutiae": "mɪnjuːʃɪiː",
    "minutia": "mɪnjuːʃɐ",
    "minxes": "mɪŋksɪz",
    "minx": "mɪŋks",
    "miracle": "mɪrəkəl",
    "miracles": "mɪrəkəlz",
    "miraculously": "mɪrækjʊləsli",
    "miraculous": "mɪrækjʊləs",
    "mirage": "mɪrɑːʒ",
    "mirages": "mɪrɑːʒɪz",
    "mired": "maɪəd",
    "mire": "maɪə",
    "mirepoix": "maɪəpwæ",
    "mires": "maɪəz",
    "mirin": "mɪrɪn",
    "mirk": "mɜːk",
    "mir": "miə",
    "mirrored": "mɪrəd",
    "mirroring": "mɪrərɪŋ",
    "mirror": "mɪrɐ",
    "mirrors": "mɪrəz",
    "mirthful": "mɜːθfəl",
    "mirthlessly": "mɜːθləsli",
    "mirth": "mɜːθ",
    "mirza": "mɜːzɐ",
    "misadministration": "mɪsɐdmɪnɪstreɪʃən",
    "misadventure": "mɪsɐdvɛntʃɐ",
    "misadventures": "mɪsɐdvɛntʃəz",
    "misaligned": "mɪsɐlaɪnd",
    "misalignment": "mɪsɐlaɪnmənt",
    "misalliance": "mɪsɐlaɪəns",
    "misanthrope": "mɪsænθrəʊp",
    "misanthropic": "mɪsænθrɒpɪk",
    "misanthropy": "mɪsænθrəpi",
    "misapplication": "mɪsæplɪkeɪʃən",
    "misapplied": "mɪsɐplaɪd",
    "misapprehension": "mɪsæprɪhɛnʃən",
    "misapprehensions": "mɪsæprɪhɛnʃənz",
    "misappropriated": "mɪsɐprəʊprɪətɪd",
    "misappropriating": "mɪsɐprəʊprɪətɪŋ",
    "misappropriation": "mɪsɐprəʊprɪeɪʃən",
    "misbegotten": "mɪsbɪɡɒtən",
    "misbehaved": "mɪsbɪheɪvd",
    "misbehave": "mɪsbɪheɪv",
    "misbehaves": "mɪsbɪheɪvz",
    "misbehaving": "mɪsbɪheɪvɪŋ",
    "misbehaviour": "mɪsbɪheɪvjɐ",
    "miscalculated": "mɪskælkjʊleɪtɪd",
    "miscalculate": "mɪskælkjʊleɪt",
    "miscalculates": "mɪskælkjʊleɪts",
    "miscalculating": "mɪskælkjʊleɪtɪŋ",
    "miscalculation": "mɪskælkjʊleɪʃən",
    "miscalculations": "mɪskælkjʊleɪʃənz",
    "miscalled": "mɪskɔːld",
    "miscarriage": "mɪskærɪdʒ",
    "miscarriages": "mɪskærɪdʒɪz",
    "miscarried": "mɪskærɪd",
    "miscarrying": "mɪskærɪɪŋ",
    "miscarry": "mɪskæri",
    "miscasting": "mɪskɑːstɪŋ",
    "miscast": "mɪskɑːst",
    "miscegenation": "mɪsɛdʒəneɪʃən",
    "miscellanea": "mɪsɪleɪniə",
    "miscellaneous": "mɪsəleɪniəs",
    "miscellany": "mɪsɛləni",
    "mischief": "mɪstʃɪf",
    "mischievously": "mɪstʃɪvəsli",
    "mischievous": "mɪstʃɪvəs",
    "mischievousness": "mɪstʃɪvəsnəs",
    "miscommunication": "mɪskəmjuːnɪkeɪʃən",
    "misconceived": "mɪskənsiːvd",
    "misconception": "mɪskənsɛpʃən",
    "misconceptions": "mɪskənsɛpʃənz",
    "misconstrued": "mɪskənstruːd",
    "misconstrue": "mɪskənstruː",
    "misconstruing": "mɪskənstruːɪŋ",
    "miscounted": "mɪskaʊntɪd",
    "miscount": "mɪskaʊnt",
    "miscounts": "mɪskaʊnts",
    "miscreant": "mɪskriənt",
    "miscreants": "mɪskriənts",
    "miscued": "mɪskjuːd",
    "miscue": "mɪskjuː",
    "miscues": "mɪskjuːz",
    "miscuing": "mɪskjuːɪŋ",
    "misdeal": "mɪsdiːl",
    "misdeed": "mɪsdiːd",
    "misdeeds": "mɪsdiːdz",
    "misdemeanor": "mɪsdɪmiːnɐ",
    "misdemeanors": "mɪsdɪmiːnəz",
    "misdemeanour": "mɪsdɪmiːnɐ",
    "misdemeanours": "mɪsdɪmiːnəz",
    "misdiagnosed": "mɪsdaɪəɡnəʊzd",
    "misdiagnose": "mɪsdaɪəɡnəʊz",
    "misdiagnosing": "mɪsdaɪəɡnəʊzɪŋ",
    "misdiagnosis": "mɪsdaɪəɡnəʊsɪs",
    "misdirected": "mɪsdaɪrɛktɪd",
    "misdirection": "mɪsdaɪrɛkʃən",
    "misdirect": "mɪsdaɪrɛkt",
    "misdoings": "mɪsduːɪŋz",
    "mise": "mɪsiː",
    "miserable": "mɪzrəbəl",
    "miserableness": "mɪzrəbəlnəs",
    "miserably": "mɪzrəbli",
    "misericord": "maɪzərɪkɔːd",
    "miseries": "mɪzərɪz",
    "miserliness": "maɪzəlinəs",
    "miserly": "maɪzəli",
    "miser": "maɪzɐ",
    "misers": "maɪzəz",
    "misery": "mɪzəri",
    "misfield": "mɪsfiːld",
    "misfired": "mɪsfaɪəd",
    "misfire": "mɪsfaɪə",
    "misfires": "mɪsfaɪəz",
    "misfiring": "mɪsfaɪərɪŋ",
    "misfit": "mɪsfɪt",
    "misfits": "mɪsfɪts",
    "misfortune": "mɪsfɔːtʃuːn",
    "misfortunes": "mɪsfɔːtʃuːnz",
    "misgiving": "mɪsɡɪvɪŋ",
    "misgivings": "mɪsɡɪvɪŋz",
    "misguidedly": "mɪsɡaɪdɪdli",
    "misguided": "mɪsɡaɪdɪd",
    "misguide": "mɪsɡaɪd",
    "misguiding": "mɪsɡaɪdɪŋ",
    "mishandled": "mɪshændəld",
    "mishandle": "mɪshændəl",
    "mishandling": "mɪshændlɪŋ",
    "mishap": "mɪshæp",
    "mishaps": "mɪshæps",
    "misheard": "mɪshɜːd",
    "mishearing": "mɪshiərɪŋ",
    "mishears": "mɪshiəz",
    "mishit": "mɪshɪt",
    "mishits": "mɪshɪts",
    "mishmash": "mɪʃmæʃ",
    "misidentification": "mɪsaɪdɛntɪfɪkeɪʃən",
    "misidentified": "mɪsaɪdɛntɪfaɪd",
    "misinformation": "mɪsɪnfəmeɪʃən",
    "misinformed": "mɪsɪnfɔːmd",
    "misinforming": "mɪsɪnfɔːmɪŋ",
    "misinform": "mɪsɪnfɔːm",
    "misinterpretation": "mɪsɪntɜːprɪteɪʃən",
    "misinterpretations": "mɪsɪntɜːprɪteɪʃənz",
    "misinterpreted": "mɪsɪntɜːprɪtɪd",
    "misinterpreting": "mɪsɪntɜːprɪtɪŋ",
    "misinterpret": "mɪsɪntɜːprɪt",
    "misjudged": "mɪsdʒʌdʒd",
    "misjudgement": "mɪsdʒʌdʒmənt",
    "misjudgements": "mɪsdʒʌdʒmənts",
    "misjudge": "mɪsdʒʌdʒ",
    "misjudges": "mɪsdʒʌdʒɪz",
    "misjudging": "mɪsdʒʌdʒɪŋ",
    "misjudgment": "mɪsdʒʌdʒmənt",
    "misjudgments": "mɪsdʒʌdʒmənts",
    "mislabelled": "mɪsleɪbəld",
    "mislabelling": "mɪsleɪbəlɪŋ",
    "mislaid": "mɪsleɪd",
    "mislaying": "mɪsleɪɪŋ",
    "mislay": "mɪsleɪ",
    "misleadingly": "mɪsliːdɪŋli",
    "misleading": "mɪsliːdɪŋ",
    "mislead": "mɪsliːd",
    "misleads": "mɪsliːdz",
    "misled": "mɪslɛd",
    "mismanaged": "mɪsmænɪdʒd",
    "mismanagement": "mɪsmænɪdʒmənt",
    "mismanage": "mɪsmænɪdʒ",
    "mismanaging": "mɪsmænɪdʒɪŋ",
    "mismatched": "mɪsmætʃt",
    "mismatches": "mɪsmætʃɪz",
    "mismatching": "mɪsmætʃɪŋ",
    "mismatch": "mɪsmætʃ",
    "misnamed": "mɪsneɪmd",
    "misnaming": "mɪsneɪmɪŋ",
    "misnomer": "mɪsnəʊmɐ",
    "misogynistic": "mɪsɒdʒɪnɪstɪk",
    "misogynist": "mɪsɒdʒɪnɪst",
    "misogynists": "mɪsɒdʒɪnɪsts",
    "misogynous": "mɪsɒdʒɪnəs",
    "misogyny": "mɪsɒdʒɪni",
    "miso": "mɪsəʊ",
    "misperception": "mɪspəsɛpʃən",
    "misplaced": "mɪspleɪst",
    "misplace": "mɪspleɪs",
    "misplacing": "mɪspleɪsɪŋ",
    "misplayed": "mɪspleɪd",
    "misprinted": "mɪsprɪntɪd",
    "misprision": "mɪsprɪʒən",
    "mispronounced": "mɪsprənaʊnst",
    "mispronounce": "mɪsprənaʊns",
    "mispronounces": "mɪsprənaʊnsɪz",
    "mispronunciation": "mɪsprənʌnsɪeɪʃən",
    "misquotation": "mɪskwəʊteɪʃən",
    "misquoted": "mɪskwəʊtɪd",
    "misquote": "mɪskwəʊt",
    "misquotes": "mɪskwəʊts",
    "misquoting": "mɪskwəʊtɪŋ",
    "misreading": "mɪsriːdɪŋ",
    "misreads": "mɪsriːdz",
    "misremembered": "mɪsrɪmɛmbəd",
    "misreported": "mɪsrɪpɔːtɪd",
    "misreporting": "mɪsrɪpɔːtɪŋ",
    "misrepresentation": "mɪsrɛprɪzɛnteɪʃən",
    "misrepresentations": "mɪsrɛprɪzɛnteɪʃənz",
    "misrepresented": "mɪsrɛprɪzɛntɪd",
    "misrepresenting": "mɪsrɛprɪzɛntɪŋ",
    "misrepresent": "mɪsrɛprɪzɛnt",
    "misrepresents": "mɪsrɛprɪzɛnts",
    "misrule": "mɪsruːl",
    "missal": "mɪsəl",
    "missals": "mɪsəlz",
    "missed": "mɪst",
    "misses": "mɪsɪz",
    "misshaped": "mɪsʃeɪpt",
    "misshapen": "mɪsʃeɪpən",
    "missile": "mɪsaɪl",
    "missiles": "mɪsaɪlz",
    "missing": "mɪsɪŋ",
    "missionaries": "mɪʃənəriz",
    "missionary": "mɪʃənəri",
    "missioner": "mɪʃənɐ",
    "mission": "mɪʃən",
    "missions": "mɪʃənz",
    "missis": "mɪsɪs",
    "missive": "mɪsɪv",
    "missives": "mɪsɪvz",
    "miss": "mɪs",
    "misspeak": "mɪsspiːk",
    "misspelled": "mɪsspɛld",
    "misspelling": "mɪsspɛlɪŋ",
    "misspellings": "mɪsspɛlɪŋz",
    "misspell": "mɪsspɛl",
    "misspelt": "mɪsspɛlt",
    "misspending": "mɪsspɛndɪŋ",
    "misspent": "mɪsspɛnt",
    "misspoke": "mɪsspəʊk",
    "misspoken": "mɪsspəʊkən",
    "misstatement": "mɪssteɪtmənt",
    "misstep": "mɪsstɛp",
    "missteps": "mɪsstɛps",
    "missuses": "mɪsuːsɪz",
    "missus": "mɪsəs",
    "missy": "mɪsi",
    "mistake": "mɪsteɪk",
    "mistakenly": "mɪsteɪkənli",
    "mistaken": "mɪsteɪkən",
    "mistakes": "mɪsteɪks",
    "mistaking": "mɪsteɪkɪŋ",
    "misted": "mɪstɪd",
    "mister": "mɪstɐ",
    "misters": "mɪstəz",
    "misthrow": "mɪsθrəʊ",
    "mistier": "mɪstɪɐ",
    "mistimed": "mɪstaɪmd",
    "mistime": "mɪstaɪm",
    "mistimes": "mɪstaɪmz",
    "mistiming": "mɪstaɪmɪŋ",
    "mistiness": "mɪstɪnəs",
    "misting": "mɪstɪŋ",
    "mistletoe": "mɪsəltəʊ",
    "mist": "mɪst",
    "mistook": "mɪstʊk",
    "mistral": "mɪstrəl",
    "mistranslated": "mɪstrænsleɪtɪd",
    "mistranslation": "mɪstrænsleɪʃən",
    "mistreated": "mɪstriːtɪd",
    "mistreating": "mɪstriːtɪŋ",
    "mistreatment": "mɪstriːtmənt",
    "mistreat": "mɪstriːt",
    "mistresses": "mɪstrəsɪz",
    "mistress": "mɪstrəs",
    "mistrial": "mɪstraɪəl",
    "mistrusted": "mɪstrʌstɪd",
    "mistrustful": "mɪstrʌstfəl",
    "mistrusting": "mɪstrʌstɪŋ",
    "mistrust": "mɪstrʌst",
    "mists": "mɪsts",
    "misty": "mɪsti",
    "mistyped": "mɪstaɪpd",
    "misunderstanding": "mɪsʌndəstændɪŋ",
    "misunderstandings": "mɪsʌndəstændɪŋz",
    "misunderstand": "mɪsʌndəstænd",
    "misunderstands": "mɪsʌndəstændz",
    "misunderstood": "mɪsʌndəstʊd",
    "misused": "mɪsjuːzd",
    "misusing": "mɪsjuːzɪŋ",
    "mite": "maɪt",
    "mites": "maɪts",
    "mither": "mɪðɐ",
    "mitigated": "mɪtɪɡeɪtɪd",
    "mitigate": "mɪtɪɡeɪt",
    "mitigates": "mɪtɪɡeɪts",
    "mitigating": "mɪtɪɡeɪtɪŋ",
    "mitigation": "mɪtɪɡeɪʃən",
    "mitochondrial": "maɪtəkɒndrɪəl",
    "mitochondria": "maɪtəkɒndriə",
    "mitosis": "maɪtəʊsɪs",
    "mitrailleuse": "mɪtreɪlɜːz",
    "mitred": "mɪtrəd",
    "mitre": "maɪtɐ",
    "mitres": "maɪtəz",
    "mitten": "mɪtən",
    "mittens": "mɪtənz",
    "mitt": "mɪt",
    "mitts": "mɪts",
    "mitzvah": "mɪtsvɐ",
    "mixed": "mɪkst",
    "mixer": "mɪksɐ",
    "mixers": "mɪksəz",
    "mixes": "mɪksɪz",
    "mixing": "mɪksɪŋ",
    "mix": "mɪks",
    "mixologist": "mɪksɒlədʒɪst",
    "mixologists": "mɪksɒlədʒɪsts",
    "mixology": "mɪksɒlədʒi",
    "mixture": "mɪkstʃɐ",
    "mixtures": "mɪkstʃəz",
    "mixup": "mɪksʌp",
    "mizen": "maɪzən",
    "mizzenmast": "mɪzənmɑːst",
    "mizzen": "mɪzən",
    "mizzle": "mɪzəl",
    "mnemonic": "nɛmɒnɪk",
    "mnemonics": "nɛmɒnɪks",
    "moa": "məʊɐ",
    "moaned": "məʊnd",
    "moaner": "məʊnɐ",
    "moaners": "məʊnəz",
    "moaning": "məʊnɪŋ",
    "moan": "məʊn",
    "moans": "məʊnz",
    "moas": "məʊəz",
    "moated": "məʊtɪd",
    "moat": "məʊt",
    "moats": "məʊts",
    "mobbed": "mɒbd",
    "mobbing": "mɒbɪŋ",
    "mobiles": "məʊbaɪlz",
    "mobilisation": "məʊbɪlaɪzeɪʃən",
    "mobilised": "məʊbəlaɪzd",
    "mobilise": "məʊbəlaɪz",
    "mobilises": "məʊbəlaɪzɪz",
    "mobilising": "məʊbəlaɪzɪŋ",
    "mobility": "məʊbɪlɪti",
    "mob": "mɒb",
    "mobs": "mɒbz",
    "mobster": "mɒbstɐ",
    "mobsters": "mɒbstəz",
    "moccasin": "mɒkəsɪn",
    "moccasins": "mɒkəsɪnz",
    "mocha": "məʊkɐ",
    "mocked": "mɒkt",
    "mockeries": "mɒkəriz",
    "mocker": "mɒkɐ",
    "mockers": "mɒkəz",
    "mockery": "mɒkəri",
    "mockingbird": "mɒkɪŋbɜːd",
    "mockingbirds": "mɒkɪŋbɜːdz",
    "mockingly": "mɒkɪŋli",
    "mocking": "mɒkɪŋ",
    "mock": "mɒk",
    "mocks": "mɒks",
    "mockup": "mɒkʌp",
    "modalities": "məʊdælɪtiz",
    "modality": "məʊdælɪti",
    "modal": "məʊdəl",
    "modelled": "mɒdəld",
    "modeller": "mɒdəlɐ",
    "modellers": "mɒdɛləz",
    "modelling": "mɒdəlɪŋ",
    "model": "mɒdəl",
    "models": "mɒdəlz",
    "mode": "məʊd",
    "modem": "məʊdɛm",
    "modems": "məʊdɛmz",
    "moderated": "mɒdəreɪtɪd",
    "moderately": "mɒdərətli",
    "moderating": "mɒdəreɪtɪŋ",
    "moderation": "mɒdəreɪʃən",
    "moderator": "mɒdəreɪtɐ",
    "moderators": "mɒdəreɪtəz",
    "moderne": "mɒdən",
    "modernisation": "mɒdənaɪzeɪʃən",
    "modernisations": "mɒdənaɪzeɪʃənz",
    "modernised": "mɒdənaɪzd",
    "modernise": "mɒdənaɪz",
    "moderniser": "mɒdənaɪzɐ",
    "modernisers": "mɒdənaɪzəz",
    "modernises": "mɒdənaɪzɪz",
    "modernising": "mɒdənaɪzɪŋ",
    "modernism": "mɒdənɪzəm",
    "modernistic": "mɒdənɪstɪk",
    "modernist": "mɒdənɪst",
    "modernists": "mɒdənɪsts",
    "modernity": "mɒdənɪti",
    "modern": "mɒdən",
    "moderns": "mɒdənz",
    "modes": "məʊdz",
    "modestly": "mɒdəstli",
    "modest": "mɒdəst",
    "modesty": "mɒdəsti",
    "modicum": "mɒdɪkəm",
    "modification": "mɒdɪfɪkeɪʃən",
    "modifications": "mɒdɪfɪkeɪʃənz",
    "modified": "mɒdɪfaɪd",
    "modifies": "mɒdɪfaɪz",
    "modifying": "mɒdɪfaɪɪŋ",
    "modify": "mɒdɪfaɪ",
    "modish": "mɒdɪʃ",
    "mod": "mɒd",
    "mods": "mɒdz",
    "modularity": "mɒdjʊlærɪti",
    "modular": "mɒdjʊlɐ",
    "modulated": "mɒdjʊleɪtɪd",
    "modulate": "mɒdjʊleɪt",
    "modulates": "mɒdjʊleɪts",
    "modulating": "mɒdjʊleɪtɪŋ",
    "modulation": "mɒdjʊleɪʃən",
    "modulations": "mɒdjʊleɪʃənz",
    "modulator": "mɒdjʊleɪtɐ",
    "modulators": "mɒdjʊleɪtəz",
    "module": "mɒdjuːl",
    "modules": "mɒdjuːlz",
    "modulus": "mɒdjʊləs",
    "moggie": "mɒɡi",
    "moggy": "mɒɡi",
    "mog": "mɒɡ",
    "mogul": "məʊɡəl",
    "moguls": "məʊɡəlz",
    "mohair": "məʊheə",
    "moiled": "mɔɪld",
    "moil": "mɔɪl",
    "moi": "mwɑː",
    "moire": "mwɑː",
    "moistened": "mɔɪstənd",
    "moistening": "mɔɪstənɪŋ",
    "moisten": "mɔɪstən",
    "moistens": "mɔɪstənz",
    "moister": "mɔɪstɐ",
    "moistly": "mɔɪstli",
    "moist": "mɔɪst",
    "moistness": "mɔɪstnəs",
    "moisture": "mɔɪstʃɐ",
    "moisturised": "mɔɪstʃəraɪzd",
    "moisturise": "mɔɪstʃəraɪz",
    "moisturiser": "mɔɪstʃəraɪzɐ",
    "moisturisers": "mɔɪstʃəraɪzəz",
    "moisturises": "mɔɪstʃəraɪzɪz",
    "moisturising": "mɔɪstʃəraɪzɪŋ",
    "mojo": "məʊdʒəʊ",
    "moke": "məʊk",
    "mola": "məʊlɐ",
    "molar": "məʊlɐ",
    "molars": "məʊləz",
    "molas": "məʊləz",
    "molasses": "məlæsɪz",
    "molded": "məʊldɪd",
    "molding": "məʊldɪŋ",
    "mold": "məʊld",
    "molecular": "məlɛkjʊlɐ",
    "molecule": "mɒlɪkjuːl",
    "molecules": "mɒlɪkjuːlz",
    "molehill": "məʊlhɪl",
    "molehills": "məʊlhɪlz",
    "moleskin": "məʊlskɪn",
    "moles": "məʊlz",
    "molestation": "məlɪsteɪʃən",
    "molestations": "məlɪsteɪʃənz",
    "molested": "məlɛstɪd",
    "molester": "məlɛstɐ",
    "molesters": "məlɛstəz",
    "molesting": "məlɛstɪŋ",
    "molest": "məlɛst",
    "molests": "məlɛsts",
    "moline": "mɒliːn",
    "mollie": "mɒli",
    "mollies": "mɒliz",
    "mollified": "mɒlɪfaɪd",
    "mollify": "mɒlɪfaɪ",
    "moll": "mɒl",
    "molls": "mɒlz",
    "mollusc": "mɒlʌsk",
    "molluscs": "mɒlʌsks",
    "mollycoddled": "mɒlɪkɒdəld",
    "mollycoddle": "mɒlɪkɒdəl",
    "mollycoddling": "mɒlɪkɒdlɪŋ",
    "molly": "mɒli",
    "mols": "mɒlz",
    "molten": "məʊltən",
    "molybdenum": "məlɪbdənəm",
    "moly": "məʊli",
    "momentarily": "məʊməntɛrəli",
    "momentary": "məʊməntəri",
    "momently": "məʊməntli",
    "moment": "məʊmənt",
    "momentous": "məʊmɛntəs",
    "moments": "məʊmənts",
    "momentum": "məʊmɛntəm",
    "momma": "mɒmɐ",
    "mommas": "mɒməz",
    "mommies": "mɒmɪz",
    "mom": "mɒm",
    "mommy": "mɒmi",
    "moms": "mɒmz",
    "monad": "mɒnæd",
    "monarchical": "mənɑːkɪkəl",
    "monarchies": "mɒnəkɪz",
    "monarchist": "mɒnəkɪst",
    "monarchists": "mɒnəkɪsts",
    "monarch": "mɒnək",
    "monarchs": "mɒnəkz",
    "monarchy": "mɒnəki",
    "monarda": "mɒnɑːdɐ",
    "monasteries": "mɒnɑːstəriz",
    "monastery": "mɒnɑːstəri",
    "monasticism": "mənɑːstɪsɪzəm",
    "monastic": "mənɑːstɪk",
    "monde": "mɒnd",
    "monetarily": "mʌnɪtɛrəli",
    "monetarism": "mʌnɪtərɪzəm",
    "monetarist": "mʌnɪtɑːrɪst",
    "monetarists": "mʌnɪtɑːrɪsts",
    "monetary": "mʌnɪtəri",
    "monetise": "mɒnɪtaɪz",
    "monetising": "mɒnɪtaɪzɪŋ",
    "moneybag": "mʌnɪbæɡ",
    "moneybags": "mʌnɪbæɡz",
    "moneybox": "mʌnɪbɒks",
    "moneyed": "mʌnɪd",
    "moneylender": "mʌnɪləndɐ",
    "moneylenders": "mʌnɪlɛndəz",
    "moneymaker": "mʌnɪmeɪkɐ",
    "moneymakers": "mʌnɪmeɪkəz",
    "moneymaking": "mʌnɪmeɪkɪŋ",
    "money": "mʌni",
    "moneys": "mʌnɪz",
    "mongeese": "mɒndʒiːs",
    "mongering": "mʌŋɡərɪŋ",
    "monger": "mʌŋɡɐ",
    "mongers": "mʌŋɡəz",
    "mongol": "mɒŋɡɒl",
    "mongoloid": "mɒŋɡəlɔɪd",
    "mongols": "mɒŋɡɒlz",
    "mongo": "mɒŋɡəʊ",
    "mongoose": "mɒŋɡuːs",
    "mongooses": "mɒŋɡuːsɪz",
    "mongrel": "mɒŋɡrəl",
    "mongrels": "mɒŋɡrəlz",
    "monied": "mʌnɪd",
    "monies": "mʌnɪz",
    "moniker": "mɒnɪkɐ",
    "monikers": "mɒnɪkəz",
    "monitored": "mɒnɪtəd",
    "monitorial": "mɒnɪtɔːrɪəl",
    "monitoring": "mɒnɪtərɪŋ",
    "monitor": "mɒnɪtɐ",
    "monitors": "mɒnɪtəz",
    "monitory": "mɒnɪtəri",
    "monkeyed": "mʌnkɪd",
    "monkeying": "mʌnkɪɪŋ",
    "monkey": "mʌnki",
    "monkeys": "mʌnkɪz",
    "monkfish": "mʌnkfɪʃ",
    "monkish": "mʌnkɪʃ",
    "monk": "mʌnk",
    "monkshood": "mʌnkʃʊd",
    "monks": "mʌnks",
    "monocarpic": "mɒnəʊkɑːpɪk",
    "monochromatic": "mɒnəʊkrəʊmætɪk",
    "monochrome": "mɒnəʊkrəʊm",
    "monochromes": "mɒnəʊkrəʊmz",
    "monocled": "mɒnəʊkəld",
    "monocle": "mɒnəʊkəl",
    "monocles": "mɒnəʊkəlz",
    "monocoque": "mɒnəʊkəʊk",
    "monocular": "mɒnəʊkjʊlɐ",
    "monocultural": "mɒnəʊkʌltʃərəl",
    "monoculture": "mɒnəʊkʌltʃɐ",
    "monocytes": "mɒnəʊsaɪts",
    "monofilament": "mɒnəʊfɪləmənt",
    "monogamist": "mənɒɡɐmɪst",
    "monogamous": "mənɒɡɐməs",
    "monogamy": "mənɒɡæmi",
    "monogrammed": "mɒnəʊɡræmd",
    "monogram": "mɒnəʊɡræm",
    "monograms": "mɒnəʊɡræmz",
    "monograph": "mɒnəʊɡræf",
    "monolithic": "mɒnəʊlɪθɪk",
    "monolith": "mɒnəʊlɪθ",
    "monoliths": "mɒnəʊlɪθs",
    "monologue": "mɒnəʊlɒɡ",
    "monologues": "mɒnəʊlɒɡz",
    "monomaniac": "mɒnəʊmeɪnɪæk",
    "monomers": "mɒnəʊməz",
    "mono": "mɒnəʊ",
    "monomorphic": "mɒnəʊmɔːfɪk",
    "mononucleosis": "mɒnəʊnjuːklɪəʊsɪs",
    "monoplane": "mɒnəʊpleɪn",
    "monoplanes": "mɒnəʊpleɪnz",
    "monopolies": "mənɒpəlɪz",
    "monopolisation": "mənɒpəlaɪzeɪʃən",
    "monopolised": "mənɒpəlaɪzd",
    "monopolise": "mənɒpəlaɪz",
    "monopolises": "mənɒpəlaɪzɪz",
    "monopolising": "mənɒpəlaɪzɪŋ",
    "monopolistic": "mənɒpəlɪstɪk",
    "monopoly": "mənɒpəli",
    "monorail": "mɒnəʊreɪl",
    "monorails": "mɒnəʊreɪlz",
    "monosaccharide": "mɒnəʊsækɑːraɪd",
    "monosyllabic": "mɒnəʊsɪlæbɪk",
    "monosyllable": "mɒnəʊsɪləbəl",
    "monosyllables": "mɒnəʊsɪləbəlz",
    "monotheism": "mɒnəʊθiːɪzəm",
    "monotheistic": "mɒnəʊθiːɪstɪk",
    "monotheist": "mɒnəʊθiːɪst",
    "monotone": "mɒnətəʊn",
    "monotonously": "mənɒtənəsli",
    "monotonous": "mənɒtənəs",
    "monotony": "mənɒtəni",
    "monoxide": "mʌnɒksaɪd",
    "monozygotic": "mɒnəʊzɪɡɒtɪk",
    "monseigneur": "mɒnseɪnɜː",
    "monsieur": "məsjɜː",
    "monsignor": "mɒnsɪnjɐ",
    "monsoon": "mənsuːn",
    "monsoons": "mənsuːnz",
    "monster": "mɒnstɐ",
    "monsters": "mɒnstəz",
    "monstrance": "mɒnstrəns",
    "monstrosities": "mənstrɒsɪtiz",
    "monstrosity": "mənstrɒsɪti",
    "monstrously": "mɒnstrəsli",
    "monstrous": "mɒnstrəs",
    "montage": "mɒntɑːʒ",
    "montages": "mɒntɑːʒɪz",
    "montane": "mɒnteɪn",
    "monteith": "mɒntiːθ",
    "monte": "mɒnti",
    "montero": "mənteərəʊ",
    "montes": "mɒntis",
    "montgolfier": "mɒntɡəlfɪɐ",
    "monthlies": "mʌnθliz",
    "monthly": "mʌnθli",
    "month": "mʌnθ",
    "months": "mʌnθs",
    "monumentalised": "mɒnjuːmɛntəlaɪzd",
    "monumentality": "mɒnjuːmɛntælɪti",
    "monumentally": "mɒnjuːmɛntəli",
    "monumental": "mɒnjuːmɛntəl",
    "monument": "mɒnjuːmənt",
    "monuments": "mɒnjuːmənts",
    "mooched": "muːtʃt",
    "moocher": "muːtʃɐ",
    "mooches": "muːtʃɪz",
    "mooching": "muːtʃɪŋ",
    "mooch": "muːtʃ",
    "moodier": "muːdɪɐ",
    "moodiest": "muːdɪəst",
    "moodily": "muːdɪli",
    "moodiness": "muːdɪnəs",
    "mood": "muːd",
    "moods": "muːdz",
    "moody": "muːdi",
    "mooed": "muːd",
    "mooing": "muːɪŋ",
    "moolah": "muːlɐ",
    "moo": "muː",
    "moonbeam": "muːnbiːm",
    "moonbeams": "muːnbiːmz",
    "mooned": "muːnd",
    "moonfish": "muːnfɪʃ",
    "mooning": "muːnɪŋ",
    "moonless": "muːnləs",
    "moonlighted": "muːnlaɪtɪd",
    "moonlighting": "muːnlaɪtɪŋ",
    "moonlight": "muːnlaɪt",
    "moonlights": "muːnlaɪts",
    "moonlit": "muːnlɪt",
    "moon": "muːn",
    "moonraker": "muːnreɪkɐ",
    "moonrise": "muːnraɪz",
    "moonscape": "muːnskeɪp",
    "moonshine": "muːnʃaɪn",
    "moons": "muːnz",
    "moonstone": "muːnstəʊn",
    "moonstones": "muːnstəʊnz",
    "moonstruck": "muːnstrʌk",
    "moonwalk": "muːnwɔːk",
    "moony": "muːni",
    "moored": "mɔːd",
    "moorhen": "mɔːhən",
    "moorhens": "mɔːhənz",
    "mooring": "mɔːrɪŋ",
    "moorings": "mɔːrɪŋz",
    "moorland": "mɔːlənd",
    "moorlands": "mɔːləndz",
    "moor": "mɔː",
    "moors": "mɔːz",
    "moose": "muːs",
    "moos": "muːz",
    "mooted": "muːtɪd",
    "mooting": "muːtɪŋ",
    "moot": "muːt",
    "mopeds": "məʊpɛdz",
    "mope": "məʊp",
    "mopes": "məʊps",
    "mopey": "məʊpi",
    "moping": "məʊpɪŋ",
    "mop": "mɒp",
    "mopped": "mɒpt",
    "moppets": "mɒpɪts",
    "mopping": "mɒpɪŋ",
    "mops": "mɒps",
    "mopy": "məʊpi",
    "moquette": "məkɛt",
    "moraine": "məreɪn",
    "moraines": "məreɪnz",
    "morale": "məræl",
    "moralise": "mɒrəlaɪz",
    "moralising": "mɒrəlaɪzɪŋ",
    "moralistic": "mɒrəlɪstɪk",
    "moralist": "mɒrəlɪst",
    "moralists": "mɒrəlɪsts",
    "morality": "mɒrælɪti",
    "morally": "mɒrəli",
    "moral": "mɒrəl",
    "morals": "mɒrəlz",
    "mora": "mɔːrɐ",
    "morass": "mɒræs",
    "moratoria": "mɔːrɐtɔːriə",
    "moratorium": "mɔːrɐtɔːriəm",
    "moray": "mɔːreɪ",
    "morays": "mɔːreɪz",
    "morbidity": "mɔːbɪdɪti",
    "morbidly": "mɔːbɪdli",
    "morbid": "mɔːbɪd",
    "mordant": "mɔːdənt",
    "moreen": "mɔːrən",
    "moreish": "mɔːrɪʃ",
    "morello": "mɔːləʊ",
    "morel": "mɔːl",
    "morels": "mɔːlz",
    "more": "mɔː",
    "moreover": "mɔːrəʊvɐ",
    "mores": "mɔːz",
    "morganatic": "mɔːɡɐnætɪk",
    "morgen": "mɔːdʒən",
    "morgue": "mɔːɡ",
    "morgues": "mɔːɡz",
    "moribund": "mɔːrɪbʌnd",
    "morning": "mɔːnɪŋ",
    "mornings": "mɔːnɪŋz",
    "morn": "mɔːn",
    "morocco": "mərɒkəʊ",
    "moronic": "mɔːrɒnɪk",
    "moron": "mɔːrɒn",
    "morons": "mɔːrɒnz",
    "morosely": "mərəʊsli",
    "morose": "mərəʊs",
    "morphed": "mɔːfd",
    "morphia": "mɔːfiɐ",
    "morphine": "mɔːfiːn",
    "morphing": "mɔːfɪŋ",
    "morphological": "mɔːfəlɒdʒɪkəl",
    "morphology": "mɔːfɒlədʒi",
    "morphs": "mɔːfz",
    "morris": "mɒrɪs",
    "morrow": "mɒrəʊ",
    "morrows": "mɒrəʊz",
    "morsel": "mɔːsəl",
    "morsels": "mɔːsəlz",
    "morse": "mɔːs",
    "mortality": "mɔːtælɪti",
    "mortally": "mɔːtəli",
    "mortal": "mɔːtəl",
    "mortals": "mɔːtəlz",
    "mortarboard": "mɔːtɑːbɔːd",
    "mortarboards": "mɔːtɑːbɔːdz",
    "mortared": "mɔːteəd",
    "mortaring": "mɔːteərɪŋ",
    "mortar": "mɔːtɐ",
    "mortars": "mɔːtəz",
    "mortgageable": "mɔːɡɪdʒəbəl",
    "mortgaged": "mɔːɡɪdʒd",
    "mortgagee": "mɔːɡɪdʒiː",
    "mortgage": "mɔːɡɪdʒ",
    "mortgages": "mɔːɡɪdʒɪz",
    "mortgaging": "mɔːɡɪdʒɪŋ",
    "mortgagors": "mɔːɡɪɡəz",
    "mortice": "mɔːtɪs",
    "mortician": "mɔːtɪʃən",
    "morticians": "mɔːtɪʃənz",
    "mortification": "mɔːtɪfɪkeɪʃən",
    "mortified": "mɔːtɪfaɪd",
    "mortifyingly": "mɔːtɪfaɪɪŋli",
    "mortifying": "mɔːtɪfaɪɪŋ",
    "mortify": "mɔːtɪfaɪ",
    "mortise": "mɔːtaɪz",
    "mortising": "mɔːtaɪzɪŋ",
    "mortmain": "mɔːtmeɪn",
    "mort": "mɔːt",
    "mortuaries": "mɔːtjuːəriz",
    "mortuary": "mɔːtjuːəri",
    "mosaic": "məseɪɪk",
    "mosaics": "məseɪɪks",
    "moseyed": "məʊsɪd",
    "moseying": "məʊsɪɪŋ",
    "mosey": "məʊsi",
    "moshed": "mɒʃt",
    "moshing": "mɒʃɪŋ",
    "mosh": "mɒʃ",
    "mosque": "mɒsk",
    "mosques": "mɒsks",
    "mosquitoes": "məskiːtəʊz",
    "mosquito": "məskiːtəʊ",
    "mosquitos": "məskiːtəʊz",
    "mosses": "mɒsɪz",
    "moss": "mɒs",
    "mossy": "mɒsi",
    "mostly": "məʊstli",
    "most": "məʊst",
    "motel": "məʊtɛl",
    "motels": "məʊtɛlz",
    "mote": "məʊt",
    "motes": "məʊts",
    "motet": "mɒtɛt",
    "motets": "mɒtɛts",
    "mothballed": "mɒθbəld",
    "mothballing": "mɒθbɔːlɪŋ",
    "mothball": "mɒθbɔːl",
    "mothballs": "mɒθbɔːlz",
    "motherboard": "mʌðəbɔːd",
    "mothered": "mʌðəd",
    "motherfucker": "mʌðəfʌkɐ",
    "motherfuckers": "mʌðəfʌkəz",
    "motherfucking": "mʌðəfʌkɪŋ",
    "motherhood": "mʌðəhʊd",
    "mothering": "mʌðərɪŋ",
    "motherland": "mʌðələnd",
    "motherless": "mʌðələs",
    "motherliness": "mʌðəlinəs",
    "motherly": "mʌðəli",
    "mothers": "mʌðəz",
    "moths": "mɒθs",
    "mothy": "mɒθi",
    "motif": "məʊtiːf",
    "motifs": "məʊtiːfs",
    "motile": "məʊtaɪl",
    "motility": "məʊtɪlɪti",
    "motioned": "məʊʃənd",
    "motioning": "məʊʃənɪŋ",
    "motionless": "məʊʃənləs",
    "motion": "məʊʃən",
    "motions": "məʊʃənz",
    "motivated": "məʊtɪveɪtɪd",
    "motivate": "məʊtɪveɪt",
    "motivates": "məʊtɪveɪts",
    "motivating": "məʊtɪveɪtɪŋ",
    "motivational": "məʊtɪveɪʃənəl",
    "motivation": "məʊtɪveɪʃən",
    "motivations": "məʊtɪveɪʃənz",
    "motivator": "məʊtɪveɪtɐ",
    "motivators": "məʊtɪveɪtəz",
    "motiveless": "məʊtɪvləs",
    "motive": "məʊtɪv",
    "motives": "məʊtɪvz",
    "motley": "mɒtli",
    "mot": "mɒt",
    "motocross": "mɒtəkrɒs",
    "motorbike": "məʊtəbaɪk",
    "motorbikes": "məʊtəbaɪks",
    "motorbiking": "məʊtəbaɪkɪŋ",
    "motorboat": "məʊtəbəʊt",
    "motorboats": "məʊtəbəʊts",
    "motorcade": "məʊtəkeɪd",
    "motorcades": "məʊtəkeɪdz",
    "motorcar": "məʊtəkɑː",
    "motorcars": "məʊtəkɑːz",
    "motorcycle": "məʊtəsaɪkəl",
    "motorcycles": "məʊtəsaɪkəlz",
    "motorcycling": "məʊtəsaɪklɪŋ",
    "motorcyclist": "məʊtəsaɪklɪst",
    "motorcyclists": "məʊtəsaɪklɪsts",
    "motored": "məʊtəd",
    "motoring": "məʊtərɪŋ",
    "motorised": "məʊtəraɪzd",
    "motorist": "məʊtərɪst",
    "motorists": "məʊtərɪsts",
    "motorman": "məʊtəmən",
    "motor": "məʊtɐ",
    "motormouth": "məʊtəməθ",
    "motors": "məʊtəz",
    "motorway": "məʊtəweɪ",
    "motorways": "məʊtəweɪz",
    "mots": "mɒts",
    "motte": "mɒt",
    "mottled": "mɒtəld",
    "mottle": "mɒtəl",
    "mottling": "mɒtlɪŋ",
    "mottoes": "mɒtəʊz",
    "motto": "mɒtəʊ",
    "mottos": "mɒtəʊz",
    "mouflon": "muːflɒn",
    "moulded": "məʊldɪd",
    "mouldering": "məʊldərɪŋ",
    "moulder": "məʊldɐ",
    "moulders": "məʊldəz",
    "moulding": "məʊldɪŋ",
    "mouldings": "məʊldɪŋz",
    "mould": "məʊld",
    "moulds": "məʊldz",
    "mouldy": "məʊldi",
    "moulin": "muːlɪn",
    "moulted": "məʊltɪd",
    "moulting": "məʊltɪŋ",
    "moult": "məʊlt",
    "moults": "məʊlts",
    "mounded": "maʊndɪd",
    "mounding": "maʊndɪŋ",
    "mound": "maʊnd",
    "mounds": "maʊndz",
    "mountaineering": "maʊntɪniərɪŋ",
    "mountaineer": "maʊntɪniə",
    "mountaineers": "maʊntɪniəz",
    "mountain": "maʊntɪn",
    "mountainous": "maʊntɪnəs",
    "mountainside": "maʊntɪnsaɪd",
    "mountainsides": "maʊntɪnsaɪdz",
    "mountains": "maʊntɪnz",
    "mountaintop": "maʊntɪntɒp",
    "mountaintops": "maʊntɪntɒps",
    "mountebank": "maʊntɪbæŋk",
    "mounted": "maʊntɪd",
    "mounter": "maʊntɐ",
    "mounties": "maʊntɪz",
    "mounting": "maʊntɪŋ",
    "mountings": "maʊntɪŋz",
    "mount": "maʊnt",
    "mounts": "maʊnts",
    "mourned": "mɔːnd",
    "mourner": "mɔːnɐ",
    "mourners": "mɔːnəz",
    "mournfully": "mɔːnfəli",
    "mournful": "mɔːnfəl",
    "mourning": "mɔːnɪŋ",
    "mourn": "mɔːn",
    "mourns": "mɔːnz",
    "mouser": "maʊsɐ",
    "mouses": "maʊsɪz",
    "mousetrap": "maʊsɪtræp",
    "mousetraps": "maʊsɪtræps",
    "mousey": "maʊsi",
    "mousing": "maʊsɪŋ",
    "moussaka": "maʊsɑːkɐ",
    "mousseline": "muːsɪlaɪn",
    "mousse": "muːs",
    "mousses": "maʊsɪz",
    "moustached": "maʊstæʃt",
    "moustache": "məstɑːʃ",
    "moustaches": "məstɑːʃɪz",
    "moustachioed": "maʊstɐʃɪəʊd",
    "moustachio": "maʊstæʃɪəʊ",
    "mousy": "maʊsi",
    "mouthed": "maʊðd",
    "mouthful": "maʊθfəl",
    "mouthfuls": "maʊθfəlz",
    "mouthier": "maʊθɪɐ",
    "mouthing": "maʊθɪŋ",
    "mouthparts": "maʊθpɑːts",
    "mouthpiece": "maʊθpiːs",
    "mouthpieces": "maʊθpiːsɪz",
    "mouthwashes": "maʊθwɒʃɪz",
    "mouthwash": "maʊθwɒʃ",
    "mouthwatering": "maʊθwətərɪŋ",
    "mouthy": "maʊθi",
    "mouton": "maʊtən",
    "movable": "muːvəbəl",
    "moveable": "muːvəbəl",
    "moveables": "muːvəbəlz",
    "moved": "muːvd",
    "movement": "muːvmənt",
    "movements": "muːvmənts",
    "move": "muːv",
    "mover": "muːvɐ",
    "movers": "muːvəz",
    "moves": "muːvz",
    "moviegoer": "muːvɪeɪɡəʊɐ",
    "moviegoers": "muːvɪeɪɡəʊəz",
    "movie": "muːvi",
    "movies": "muːvɪz",
    "movingly": "muːvɪŋli",
    "moving": "muːvɪŋ",
    "mower": "məʊɐ",
    "mowers": "məʊəz",
    "mown": "məʊn",
    "moxie": "mɒksi",
    "mozzarella": "mɒzərɛlɐ",
    "ms": "ɛmɛs",
    "much": "mʌtʃ",
    "muchness": "mʌtʃnəs",
    "mucked": "mʌkt",
    "mucker": "mʌkɐ",
    "muckiest": "mʌkiəst",
    "mucking": "mʌkɪŋ",
    "muck": "mʌk",
    "muckraker": "mʌkreɪkɐ",
    "muckraking": "mʌkreɪkɪŋ",
    "mucks": "mʌks",
    "mucky": "mʌki",
    "mucosa": "mjuːkəʊsɐ",
    "mucous": "mjuːkəs",
    "mucus": "mjuːkəs",
    "muddied": "mʌdɪd",
    "muddier": "mʌdɪɐ",
    "muddies": "mʌdɪz",
    "muddiest": "mʌdɪəst",
    "muddiness": "mʌdɪnəs",
    "muddled": "mʌdəld",
    "muddle": "mʌdəl",
    "muddler": "mʌdlɐ",
    "muddles": "mʌdəlz",
    "muddling": "mʌdlɪŋ",
    "muddying": "mʌdɪɪŋ",
    "muddy": "mʌdi",
    "mudflat": "mʌdflæt",
    "mudflats": "mʌdflæts",
    "mudflow": "mʌdfləʊ",
    "mudflows": "mʌdfləʊz",
    "mudguard": "mʌdɡɑːd",
    "mudguards": "mʌdɡɑːdz",
    "mudlark": "mʌdlɑːk",
    "mudlarks": "mʌdlɑːks",
    "mud": "mʌd",
    "mudpack": "mʌdpæk",
    "mudra": "mʌdrɐ",
    "mudskipper": "mʌdskɪpɐ",
    "mudskippers": "mʌdskɪpəz",
    "mudslide": "mʌdslaɪd",
    "mudslides": "mʌdslaɪdz",
    "mudslinging": "mʌdslɪŋɪŋ",
    "mudstone": "mʌdstəʊn",
    "muenster": "mjuːənstɐ",
    "muesli": "mjuːsli",
    "muezzin": "mjuːzɪn",
    "muffed": "mʌft",
    "muffin": "mʌfɪn",
    "muffins": "mʌfɪnz",
    "muffled": "mʌfəld",
    "muffle": "mʌfəl",
    "muffler": "mʌflɐ",
    "mufflers": "mʌfləz",
    "muffles": "mʌfəlz",
    "muffling": "mʌflɪŋ",
    "muff": "mʌf",
    "muffs": "mʌfs",
    "mufti": "mʌfti",
    "mugful": "mʌɡfəl",
    "mugged": "mʌɡd",
    "mugger": "mʌɡɐ",
    "muggers": "mʌɡəz",
    "mugging": "mʌɡɪŋ",
    "muggings": "mʌɡɪŋz",
    "muggins": "mʌɡɪnz",
    "muggy": "mʌɡi",
    "mug": "mʌɡ",
    "mugshot": "mʌɡʃɒt",
    "mugshots": "mʌɡʃɒts",
    "mugs": "mʌɡz",
    "mugwump": "mʌɡwʌmp",
    "mujahedeen": "mjuːdʒɐhɛdiːn",
    "mujahedin": "mjuːdʒɐhɛdɪn",
    "mujahideen": "mjuːdʒɐhɪdiːn",
    "mukluks": "mʌklʌks",
    "mulatto": "mjʊlætəʊ",
    "mulberries": "mʌlbərɪz",
    "mulberry": "mʌlbəri",
    "mulched": "mʌltʃt",
    "mulches": "mʌltʃɪz",
    "mulching": "mʌltʃɪŋ",
    "mulch": "mʌltʃ",
    "mule": "mjuːl",
    "mules": "mjuːlz",
    "muley": "mjʊli",
    "mullah": "mʌlɐ",
    "mullahs": "mʌləz",
    "mulla": "mʌlɐ",
    "mulled": "mʌld",
    "mullein": "mʌlaɪn",
    "mullen": "mʌlən",
    "muller": "mʌlɐ",
    "mullet": "mʌlɪt",
    "mullets": "mʌlɪts",
    "mulley": "mʌli",
    "mulligan": "mʌlɪɡən",
    "mulligans": "mʌlɪɡənz",
    "mulligatawny": "mʌlɪɡætɔːni",
    "mulling": "mʌlɪŋ",
    "mullioned": "mʌliənd",
    "mullion": "mʌliən",
    "mullions": "mʌliənz",
    "mull": "mʌl",
    "mulls": "mʌlz",
    "multicellular": "mʌltɪsɛljʊlɐ",
    "multicoloured": "mʌltɪkʌləd",
    "multiculturalism": "mʌltɪkʌltʃərəlɪzəm",
    "multicultural": "mʌltɪkʌltʃərəl",
    "multidimensional": "mʌltɪdaɪmɛnʃənəl",
    "multidisciplinary": "mʌltɪdɪsɪplɪnəri",
    "multiethnic": "mʌltɪɛθnɪk",
    "multifaceted": "mʌltɪfæsɛtɪd",
    "multifarious": "mʌltɪfeərɪəs",
    "multifunctional": "mʌltɪfʌŋkʃənəl",
    "multilateralism": "mʌltɪlætərəlɪzəm",
    "multilaterally": "mʌltɪlætərəli",
    "multilateral": "mʌltɪlætərəl",
    "multilayered": "mʌltɪleɪəd",
    "multilayer": "mʌltɪleɪɐ",
    "multilingual": "mʌltɪlɪŋɡwəl",
    "multimedia": "mʌltɪmiːdiːɐ",
    "multimillionaire": "mʌltɪmɪliəneə",
    "multimillionaires": "mʌltɪmɪliəneəz",
    "multimillion": "mʌltɪmɪliən",
    "multinational": "mʌltɪnæʃənəl",
    "multinationals": "mʌltɪnæʃənəlz",
    "multiparty": "mʌltɪpɑːti",
    "multiple": "mʌltɪpəl",
    "multiples": "mʌltɪpəlz",
    "multiplexes": "mʌltɪplɛksɪz",
    "multiplex": "mʌltɪplɛks",
    "multiplication": "mʌltɪplɪkeɪʃən",
    "multiplications": "mʌltɪplɪkeɪʃənz",
    "multiplicity": "mʌltɪplɪsɪti",
    "multiplied": "mʌltɪplaɪd",
    "multiplier": "mʌltɪplaɪə",
    "multiplies": "mʌltɪplaɪz",
    "multiplying": "mʌltɪplaɪɪŋ",
    "multipurpose": "mʌltɪpɜːpəs",
    "multiracial": "mʌltɪreɪʃəl",
    "multitasking": "mʌltɪtɑːskɪŋ",
    "multitask": "mʌltɪtɑːsk",
    "multitude": "mʌltɪtjuːd",
    "multitudes": "mʌltɪtjuːdz",
    "multitudinous": "mʌltɪtjuːdɪnəs",
    "multivitamin": "mʌltɪvɪtəmɪn",
    "multivitamins": "mʌltɪvɪtəmɪnz",
    "mumbled": "mʌmbəld",
    "mumble": "mʌmbəl",
    "mumbles": "mʌmbəlz",
    "mumbling": "mʌmblɪŋ",
    "mumbly": "mʌmbli",
    "mummer": "mʌmɐ",
    "mummers": "mʌməz",
    "mummery": "mʌməri",
    "mummies": "mʌmɪz",
    "mummification": "mʌmɪfɪkeɪʃən",
    "mummified": "mʌmɪfaɪd",
    "mummifying": "mʌmɪfaɪɪŋ",
    "mummify": "mʌmɪfaɪ",
    "mum": "mʌm",
    "mummy": "mʌmi",
    "mump": "mʌmp",
    "mumps": "mʌmps",
    "mums": "mʌmz",
    "mu": "muː",
    "munched": "mʌntʃt",
    "muncher": "mʌntʃɐ",
    "munchers": "mʌntʃəz",
    "munches": "mʌntʃɪz",
    "munchies": "mʌntʃɪz",
    "munching": "mʌntʃɪŋ",
    "munchkin": "mʌntʃkɪn",
    "munchkins": "mʌntʃkɪnz",
    "mundane": "mʌndeɪn",
    "mundaneness": "mʌndeɪnnəs",
    "mundanity": "mʌndænɪti",
    "municipalities": "mjuːnɪsɪpælɪtiz",
    "municipality": "mjuːnɪsɪpælɪti",
    "municipal": "mjuːnɪsɪpəl",
    "munificence": "mjuːnɪfɪsəns",
    "munificent": "mjuːnɪfɪsənt",
    "muniment": "mjuːnɪmənt",
    "muniments": "mjuːnɪmənts",
    "munition": "mjuːnɪʃən",
    "munitions": "mjuːnɪʃənz",
    "muntjac": "mʌntdʒæk",
    "muntjacs": "mʌntdʒæks",
    "muon": "mjuːɒn",
    "muons": "mjuːɒnz",
    "muralist": "mjʊrəlɪst",
    "mural": "mjʊrəl",
    "murals": "mjʊrəlz",
    "murdered": "mɜːdəd",
    "murderer": "mɜːdərɐ",
    "murderers": "mɜːdərəz",
    "murderess": "mɜːdərəs",
    "murdering": "mɜːdərɪŋ",
    "murder": "mɜːdɐ",
    "murderously": "mɜːdərəsli",
    "murderous": "mɜːdərəs",
    "murders": "mɜːdəz",
    "mure": "mjɔː",
    "murex": "mjʊrɛks",
    "murkier": "mɜːkiɐ",
    "murkiest": "mɜːkiəst",
    "murkiness": "mɜːkinəs",
    "murk": "mɜːk",
    "murks": "mɜːks",
    "murky": "mɜːki",
    "murmuration": "mɜːmjʊreɪʃən",
    "murmurations": "mɜːmjʊreɪʃənz",
    "murmured": "mɜːməd",
    "murmuring": "mɜːmərɪŋ",
    "murmurings": "mɜːmərɪŋz",
    "murmur": "mɜːmɐ",
    "murmurs": "mɜːməz",
    "murphy": "mɜːfi",
    "murres": "mʌrz",
    "muscatel": "mʌskætəl",
    "muscat": "mʌskæt",
    "muscled": "mʌsəld",
    "muscleman": "mʌslɛmən",
    "musclemen": "mʌslɪmɛn",
    "muscle": "mʌsəl",
    "muscles": "mʌsəlz",
    "muscling": "mʌslɪŋ",
    "muscly": "mʌskli",
    "muscovado": "mʌskəvɑːdəʊ",
    "muscularity": "mʌskjʊlærɪti",
    "muscularly": "mʌskjʊləli",
    "muscular": "mʌskjʊlɐ",
    "musculature": "mʌskjʊlətʃɐ",
    "mused": "mjuːzd",
    "muse": "mjuːz",
    "muses": "mjuːzɪz",
    "musette": "mjuːzɛt",
    "musettes": "mjuːzɛts",
    "museum": "mjuːziəm",
    "museums": "mjuːziəmz",
    "mushed": "mʌʃt",
    "musher": "mʌʃɐ",
    "mushers": "mʌʃəz",
    "mushier": "mʌʃɪɐ",
    "mushing": "mʌʃɪŋ",
    "mushroomed": "mʌʃruːmd",
    "mushrooming": "mʌʃruːmɪŋ",
    "mushroom": "mʌʃruːm",
    "mushrooms": "mʌʃruːmz",
    "mushy": "mʌʃi",
    "musicality": "mjuːzɪkælɪti",
    "musically": "mjuːzɪkli",
    "musical": "mjuːzɪkəl",
    "musicals": "mjuːzɪkəlz",
    "musician": "mjuːzɪʃən",
    "musicianship": "mjuːzɪʃənʃɪp",
    "musicians": "mjuːzɪʃənz",
    "music": "mjuːzɪk",
    "musicologist": "mjuːzɪkɒlədʒɪst",
    "musicologists": "mjuːzɪkɒlədʒɪsts",
    "musicology": "mjuːzɪkɒlədʒi",
    "musing": "mjuːzɪŋ",
    "musings": "mjuːzɪŋz",
    "musketeer": "mʌskɪtiə",
    "musketeers": "mʌskɪtiəz",
    "musket": "mʌskɪt",
    "muskets": "mʌskɪts",
    "muskie": "mʌski",
    "muskiness": "mʌskinəs",
    "musk": "mʌsk",
    "muskrat": "mʌskræt",
    "muskrats": "mʌskræts",
    "musky": "mʌski",
    "muslin": "mʌslɪn",
    "mussed": "mʌst",
    "mussel": "mʌsəl",
    "mussels": "mʌsəlz",
    "muss": "mʌs",
    "mussy": "mʌsi",
    "mustachioed": "mʌstɐʃɪəʊd",
    "mustang": "mʌstæŋ",
    "mustangs": "mʌstæŋz",
    "mustard": "mʌstəd",
    "mustardy": "mʌstədi",
    "mustered": "mʌstəd",
    "mustering": "mʌstərɪŋ",
    "muster": "mʌstɐ",
    "musters": "mʌstəz",
    "musth": "mʌsθ",
    "mustiness": "mʌstɪnəs",
    "must": "mʌst",
    "musts": "mʌsts",
    "musty": "mʌsti",
    "mutability": "mjuːtəbɪlɪti",
    "mutable": "mjuːtəbəl",
    "mutant": "mjuːtənt",
    "mutants": "mjuːtənts",
    "mutated": "mjuːteɪtɪd",
    "mutate": "mjuːteɪt",
    "mutates": "mjuːteɪts",
    "mutating": "mjuːteɪtɪŋ",
    "mutation": "mjuːteɪʃən",
    "mutations": "mjuːteɪʃənz",
    "muted": "mjuːtɪd",
    "mute": "mjuːt",
    "muteness": "mjuːtnəs",
    "mutes": "mjuːts",
    "mutilated": "mjuːtɪleɪtɪd",
    "mutilate": "mjuːtɪleɪt",
    "mutilates": "mjuːtɪleɪts",
    "mutilating": "mjuːtɪleɪtɪŋ",
    "mutilation": "mjuːtɪleɪʃən",
    "mutilations": "mjuːtɪleɪʃənz",
    "mutineer": "mjuːtɪniə",
    "mutineers": "mjuːtɪniəz",
    "mutinied": "mjuːtɪnɪd",
    "mutinies": "mjuːtɪnɪz",
    "mutinous": "mjuːtɪnəs",
    "mutinying": "mjuːtɪnɪɪŋ",
    "mutiny": "mjuːtɪni",
    "mutism": "mjuːtɪzəm",
    "mut": "mʌt",
    "muts": "mʌts",
    "muttered": "mʌtəd",
    "muttering": "mʌtərɪŋ",
    "mutterings": "mʌtərɪŋz",
    "mutter": "mʌtɐ",
    "mutters": "mʌtəz",
    "mutt": "mʌt",
    "muttonhead": "mʌtənhɛd",
    "mutton": "mʌtən",
    "muttony": "mʌtəni",
    "mutts": "mʌts",
    "mutualise": "mjuːtʃuːəlaɪz",
    "mutualism": "mjuːtʃuːəlɪzəm",
    "mutuality": "mjuːtʃuːælɪti",
    "mutually": "mjuːtʃuːəli",
    "mutual": "mjuːtʃuːəl",
    "muumuu": "mjuːəmʌuː",
    "muzak": "mjuːzæk",
    "muzhik": "mʌʒɪk",
    "muzzled": "mʌzəld",
    "muzzle": "mʌzəl",
    "muzzles": "mʌzəlz",
    "muzzling": "mʌzlɪŋ",
    "muzz": "mʌz",
    "muzzy": "mʌzi",
    "myalgia": "maɪældʒɐ",
    "mycelia": "maɪsiːliə",
    "mycelium": "maɪsiːliəm",
    "mycobacterium": "maɪkəbɐktiərɪəm",
    "mycologist": "maɪkɒlədʒɪst",
    "mycology": "maɪkɒlədʒi",
    "mycorrhiza": "maɪkəraɪzɐ",
    "myelin": "maɪɪlɪn",
    "myelitis": "maɪɪlaɪtɪs",
    "myeloid": "maɪɪlɔɪd",
    "myeloma": "maɪɪləʊmɐ",
    "my": "maɪ",
    "mynah": "maɪnɐ",
    "myna": "miːnɐ",
    "myocardial": "maɪəkɑːdɪəl",
    "myocarditis": "maɪəkɑːdaɪtɪs",
    "myocardium": "maɪəkɑːdiəm",
    "myoglobin": "maɪəɡlɒbɪn",
    "myopia": "maɪəʊpiə",
    "myopic": "maɪɒpɪk",
    "myosin": "maɪəsɪn",
    "myosotis": "maɪəsəʊtiz",
    "myotonia": "maɪətəʊniə",
    "myriad": "mɪrɪæd",
    "myriads": "mɪrɪædz",
    "myrmidons": "mɪəmɪdənz",
    "myrrh": "mɜː",
    "myrtle": "mɜːtəl",
    "myself": "maɪsɛlf",
    "mys": "maɪz",
    "mysteries": "mɪstəriz",
    "mysteriously": "mɪstiərɪəsli",
    "mysterious": "mɪstiərɪəs",
    "mysteriousness": "mɪstiərɪəsnəs",
    "mystery": "mɪstəri",
    "mystically": "mɪstɪkli",
    "mystical": "mɪstɪkəl",
    "mysticism": "mɪstɪsɪzəm",
    "mystic": "mɪstɪk",
    "mystics": "mɪstɪks",
    "mystification": "mɪstɪfɪkeɪʃən",
    "mystified": "mɪstɪfaɪd",
    "mystifies": "mɪstɪfaɪz",
    "mystifying": "mɪstɪfaɪɪŋ",
    "mystify": "mɪstɪfaɪ",
    "mystique": "mɪstiːk",
    "mythically": "mɪθɪkli",
    "mythical": "mɪθɪkəl",
    "mythic": "mɪθɪk",
    "myth": "mɪθ",
    "mythological": "mɪθəlɒdʒɪkəl",
    "mythologies": "mɪθɒlədʒɪz",
    "mythologised": "mɪθɒlədʒaɪzd",
    "mythologise": "mɪθɒlədʒaɪz",
    "mythologising": "mɪθɒlədʒaɪzɪŋ",
    "mythology": "mɪθɒlədʒi",
    "mythos": "mɪθəʊz",
    "myths": "mɪθs",
    "myxoma": "maɪksəʊmɐ",
    "myxomatosis": "maɪksəmɐtəʊsɪs",
    "naan": "nɑːn",
    "naans": "nɑːnz",
    "nabbed": "næbd",
    "nabbing": "næbɪŋ",
    "nab": "næb",
    "nabob": "næbɒb",
    "nabobs": "næbɒbz",
    "nabs": "næbz",
    "nacelles": "neɪsəlz",
    "nacho": "nætʃəʊ",
    "nachos": "nætʃəʊz",
    "nacre": "nækɐ",
    "nacreous": "nækriəs",
    "nadir": "nædiə",
    "nae": "niː",
    "naevus": "niːvəs",
    "naffer": "næfɐ",
    "naffest": "næfəst",
    "naff": "næf",
    "nagged": "næɡd",
    "nagging": "næɡɪŋ",
    "nag": "næɡ",
    "nags": "næɡz",
    "nah": "nɑː",
    "naiad": "neɪæd",
    "naiads": "neɪædz",
    "naif": "naɪiːf",
    "nailbrush": "neɪlbrʌʃ",
    "nailed": "neɪld",
    "nailing": "neɪlɪŋ",
    "nail": "neɪl",
    "nails": "neɪlz",
    "naira": "neərɐ",
    "naively": "naɪiːvli",
    "naive": "naɪiːv",
    "naivety": "naɪiːvɪti",
    "nakedly": "neɪkɪdli",
    "naked": "neɪkɪd",
    "nakedness": "neɪkɪdnəs",
    "named": "neɪmd",
    "nameless": "neɪmləs",
    "namelessness": "neɪmləsnəs",
    "namely": "neɪmli",
    "name": "neɪm",
    "nameplate": "neɪmpleɪt",
    "nameplates": "neɪmpleɪts",
    "namer": "neɪmɐ",
    "namesake": "neɪmseɪk",
    "namesakes": "neɪmseɪks",
    "names": "neɪmz",
    "naming": "neɪmɪŋ",
    "nance": "næns",
    "nan": "næn",
    "nannies": "nænɪz",
    "nanny": "næni",
    "nanometre": "nænəʊmiːtɐ",
    "nanometres": "nænəʊmiːtəz",
    "nanosecond": "nænəʊsɛkənd",
    "nanoseconds": "nænəʊsɛkəndz",
    "nanotechnology": "nænəʊtɛknɒlədʒi",
    "nanotube": "nænəʊtjuːb",
    "nans": "nænz",
    "napalm": "neɪpɑːm",
    "nape": "neɪp",
    "napery": "neɪpəri",
    "napes": "neɪps",
    "naphthalene": "næfθeɪliːn",
    "naphtha": "næfθɐ",
    "napkin": "næpkɪn",
    "napkins": "næpkɪnz",
    "nap": "næp",
    "napoleon": "næpəʊlɪən",
    "napoleons": "næpəʊlɪənz",
    "napped": "næpt",
    "napper": "næpɐ",
    "nappers": "næpəz",
    "nappies": "næpɪz",
    "napping": "næpɪŋ",
    "nappy": "næpi",
    "naps": "næps",
    "narcissi": "nɑːsɪsi",
    "narcissism": "nɑːsɪsɪzəm",
    "narcissistic": "nɑːsɪsɪstɪk",
    "narcissist": "nɑːsɪsɪst",
    "narcissists": "nɑːsɪsɪsts",
    "narcissus": "nɑːsɪsəs",
    "narc": "nɑːk",
    "narcolepsy": "nɑːkəʊlɛpsi",
    "narcoleptic": "nɑːkəʊlɛptɪk",
    "narcosis": "nɑːkəʊsɪs",
    "narcotic": "nɑːkɒtɪk",
    "narcotics": "nɑːkɒtɪks",
    "narcs": "nɑːks",
    "nard": "nɑːd",
    "nares": "neəz",
    "narked": "nɑːkt",
    "narking": "nɑːkɪŋ",
    "nark": "nɑːk",
    "narks": "nɑːks",
    "narky": "nɑːki",
    "narrated": "nɐreɪtɪd",
    "narrate": "nɐreɪt",
    "narrates": "nɐreɪts",
    "narrating": "nɐreɪtɪŋ",
    "narration": "nɐreɪʃən",
    "narrations": "nɐreɪʃənz",
    "narrative": "nærətɪv",
    "narratives": "nærətɪvz",
    "narrator": "nɐreɪtɐ",
    "narrators": "nɐreɪtəz",
    "narrowed": "nærəʊd",
    "narrower": "nærəʊɐ",
    "narrowest": "nærəʊəst",
    "narrowing": "nærəʊɪŋ",
    "narrowly": "nærəʊli",
    "narrow": "nærəʊ",
    "narrowness": "nærəʊnəs",
    "narrows": "nærəʊz",
    "narwhal": "nɑːwəl",
    "narwhals": "nɑːwəlz",
    "nary": "neəri",
    "nasally": "neɪzəli",
    "nasal": "neɪzəl",
    "nascent": "neɪsənt",
    "nastier": "nɑːstɪɐ",
    "nastiest": "nɑːstɪəst",
    "nastily": "nɑːstɪli",
    "nastiness": "nɑːstɪnəs",
    "nasturtium": "nɑːstɜːtiəm",
    "nasturtiums": "nɑːstɜːtiəmz",
    "nasty": "nɑːsti",
    "natation": "næteɪʃən",
    "natch": "nætʃ",
    "nates": "neɪts",
    "nationalisation": "næʃənəlaɪzeɪʃən",
    "nationalisations": "næʃənəlaɪzeɪʃənz",
    "nationalised": "næʃənəlaɪzd",
    "nationalise": "næʃənəlaɪz",
    "nationalises": "næʃənəlaɪzɪz",
    "nationalising": "næʃənəlaɪzɪŋ",
    "nationalism": "næʃənəlɪzəm",
    "nationalistic": "næʃənəlɪstɪk",
    "nationalist": "næʃənəlɪst",
    "nationalists": "næʃənəlɪsts",
    "nationalities": "næʃənælɪtiz",
    "nationality": "næʃənælɪti",
    "nationally": "næʃənəli",
    "national": "næʃənəl",
    "nationals": "næʃənəlz",
    "nationhood": "neɪʃənhʊd",
    "nation": "neɪʃən",
    "nations": "neɪʃənz",
    "nationwide": "neɪʃənwaɪd",
    "native": "neɪtɪv",
    "natives": "neɪtɪvz",
    "nativities": "nɐtɪvɪtiz",
    "nativity": "nɐtɪvɪti",
    "natron": "neɪtrən",
    "nattered": "nætəd",
    "natterer": "nætərɐ",
    "nattering": "nætərɪŋ",
    "natterjack": "nætədʒæk",
    "natterjacks": "nætədʒæks",
    "natter": "nætɐ",
    "natters": "nætəz",
    "nattiest": "nætɪəst",
    "nattily": "nætɪli",
    "natty": "næti",
    "naturalisation": "nætʃərəlaɪzeɪʃən",
    "naturalised": "nætʃərəlaɪzd",
    "naturalise": "nætʃərəlaɪz",
    "naturalism": "nætʃərəlɪzəm",
    "naturalistically": "nætʃərəlɪstɪkli",
    "naturalistic": "nætʃərəlɪstɪk",
    "naturalist": "nætʃərəlɪst",
    "naturalists": "nætʃərəlɪsts",
    "naturally": "nætʃərəli",
    "natural": "nætʃərəl",
    "naturalness": "nætʃərəlnəs",
    "naturals": "nætʃərəlz",
    "natured": "neɪtʃəd",
    "nature": "neɪtʃɐ",
    "natures": "neɪtʃəz",
    "naturism": "neɪtʃərɪzəm",
    "naturist": "neɪtʃərɪst",
    "naturists": "neɪtʃərɪsts",
    "naturopath": "neɪtʃərɒpɑːθ",
    "naturopathy": "neɪtʃərɒpəθi",
    "naughtier": "nɔːtɪɐ",
    "naughtiest": "nɔːtɪəst",
    "naughtily": "nɔːtɪli",
    "naughtiness": "nɔːtɪnəs",
    "naught": "nɔːt",
    "naughty": "nɔːti",
    "nausea": "nɔːsɪɐ",
    "nauseated": "nɔːsɪeɪtɪd",
    "nauseate": "nɔːsɪeɪt",
    "nauseatingly": "nɔːsɪeɪtɪŋli",
    "nauseating": "nɔːsɪeɪtɪŋ",
    "nauseous": "nɔːsɪəs",
    "nautically": "nɔːtɪkli",
    "nautical": "nɔːtɪkəl",
    "nautilus": "nɔːtɪləs",
    "naval": "neɪvəl",
    "navel": "neɪvəl",
    "navels": "neɪvəlz",
    "navelwort": "neɪvlwɔːt",
    "nave": "neɪv",
    "naves": "neɪvz",
    "navies": "neɪvɪz",
    "navigable": "nævɪɡəbəl",
    "navigated": "nævɪɡeɪtɪd",
    "navigate": "nævɪɡeɪt",
    "navigates": "nævɪɡeɪts",
    "navigating": "nævɪɡeɪtɪŋ",
    "navigational": "nævɪɡeɪʃənəl",
    "navigation": "nævɪɡeɪʃən",
    "navigator": "nævɪɡeɪtɐ",
    "navigators": "nævɪɡeɪtəz",
    "navvies": "nævɪz",
    "navvy": "nævi",
    "navy": "neɪvi",
    "nawab": "næwɒb",
    "nay": "neɪ",
    "naysayer": "neɪseɪɐ",
    "naysayers": "neɪseɪəz",
    "nays": "neɪz",
    "neanderthal": "niːændəθɑːl",
    "neanderthals": "niːændəθɑːlz",
    "neap": "niːp",
    "nearby": "niəbaɪ",
    "neared": "niəd",
    "nearer": "niərɐ",
    "nearest": "niərəst",
    "nearing": "niərɪŋ",
    "nearish": "niərɪʃ",
    "nearly": "niəli",
    "nearness": "niənəs",
    "near": "niə",
    "nearside": "niəsaɪd",
    "nears": "niəz",
    "neatened": "niːtənd",
    "neatening": "niːtənɪŋ",
    "neaten": "niːtən",
    "neater": "niːtɐ",
    "neatest": "niːtəst",
    "neath": "niːθ",
    "neatly": "niːtli",
    "neatness": "niːtnəs",
    "neat": "niːt",
    "neb": "nɛb",
    "nebs": "nɛbz",
    "nebulae": "nɛbjʊliː",
    "nebula": "nɛbjʊlɐ",
    "nebular": "nɛbjʊlɐ",
    "nebulas": "nɛbjʊləz",
    "nebuliser": "nɛbjʊlaɪzɐ",
    "nebulosity": "nɛbjʊlɒsɪti",
    "nebulous": "nɛbjʊləs",
    "necessaries": "nɛsəsərɪz",
    "necessarily": "nɛsɪsɛrəli",
    "necessary": "nɛsəsəri",
    "necessitated": "nəsɛsɪteɪtɪd",
    "necessitate": "nəsɛsɪteɪt",
    "necessitates": "nəsɛsɪteɪts",
    "necessitating": "nəsɛsɪteɪtɪŋ",
    "necessities": "nəsɛsɪtɪz",
    "necessity": "nəsɛsɪti",
    "neckband": "nɛkbænd",
    "necked": "nɛkt",
    "neckerchief": "nɛkətʃiːf",
    "neckerchiefs": "nɛkətʃiːfs",
    "necking": "nɛkɪŋ",
    "necklace": "nɛkləs",
    "necklaces": "nɛkləsɪz",
    "necklacing": "nɛkləsɪŋ",
    "neckline": "nɛklaɪn",
    "necklines": "nɛklaɪnz",
    "neck": "nɛk",
    "necks": "nɛks",
    "necktie": "nɛktaɪ",
    "neckties": "nɛktɪz",
    "neckwear": "nɛkweə",
    "necromancer": "nɛkrəʊmənsɐ",
    "necromancers": "nɛkrəʊmɑːnsəz",
    "necromancy": "nɛkrəʊmənsi",
    "necrophiliac": "nɛkrəfɪlɪæk",
    "necrophilia": "nɛkrəfɪliə",
    "necrophilic": "nɛkrəfɪlɪk",
    "necropolis": "nɛkrɒpəliz",
    "necrosis": "nɛkrəʊsɪs",
    "necrotic": "nɛkrɒtɪk",
    "nectarine": "nɛktɑːriːn",
    "nectarines": "nɛktɑːriːnz",
    "nectar": "nɛktɐ",
    "needed": "niːdɪd",
    "needful": "niːdfəl",
    "neediest": "niːdɪəst",
    "neediness": "niːdɪnəs",
    "needing": "niːdɪŋ",
    "needlecraft": "niːdəlkrɑːft",
    "needled": "niːdəld",
    "needlefish": "niːdəlfɪʃ",
    "needle": "niːdəl",
    "needlepoint": "niːdəlpɔɪnt",
    "needles": "niːdəlz",
    "needlessly": "niːdləsli",
    "needless": "niːdləs",
    "needlewoman": "niːdəlwʊmən",
    "needlework": "niːdəlwɜːk",
    "needling": "niːdlɪŋ",
    "need": "niːd",
    "needs": "niːdz",
    "needy": "niːdi",
    "ne'er": "neə",
    "nefarious": "nəfeərɪəs",
    "negated": "nɪɡeɪtɪd",
    "negate": "nɪɡeɪt",
    "negates": "nɪɡeɪts",
    "negating": "nɪɡeɪtɪŋ",
    "negation": "nɪɡeɪʃən",
    "negations": "nɪɡeɪʃənz",
    "negatively": "nɛɡətɪvli",
    "negative": "nɛɡətɪv",
    "negativeness": "nɛɡətɪvnəs",
    "negatives": "nɛɡətɪvz",
    "negativism": "nɛɡɐtɪvɪzəm",
    "negativity": "nɛɡɐtɪvɪti",
    "negatory": "nɛɡətəri",
    "neglected": "nɪɡlɛktɪd",
    "neglecter": "nɛɡəlktɐ",
    "neglectful": "nɪɡlɛktfəl",
    "neglecting": "nɪɡlɛktɪŋ",
    "neglect": "nɪɡlɛkt",
    "neglects": "nɪɡlɛkts",
    "negligee": "nɛɡlɪʒeɪ",
    "negligees": "nɛɡlɪʒeɪz",
    "negligence": "nɛɡlɪdʒəns",
    "negligently": "nɛɡlɪdʒəntli",
    "negligent": "nɛɡlɪdʒənt",
    "negligible": "nɛɡlɪdʒəbəl",
    "negotiable": "nɪɡəʊʃɪəbəl",
    "negotiated": "nɪɡəʊʃɪeɪtɪd",
    "negotiate": "nɪɡəʊʃɪeɪt",
    "negotiates": "nɪɡəʊʃɪeɪts",
    "negotiating": "nɪɡəʊʃɪeɪtɪŋ",
    "negotiation": "nɪɡəʊʃɪeɪʃən",
    "negotiations": "nɪɡəʊʃɪeɪʃənz",
    "negotiator": "nɪɡəʊʃɪeɪtɐ",
    "negotiators": "nɪɡəʊʃɪeɪtəz",
    "negroid": "niːɡrɔɪd",
    "negro": "niːɡrəʊ",
    "negus": "nɛɡəs",
    "neighborhood": "neɪbəhʊd",
    "neighbors": "neɪbəz",
    "neighboured": "neɪbəd",
    "neighbourhood": "neɪbəhʊd",
    "neighbourhoods": "neɪbəhʊdz",
    "neighbouring": "neɪbɜːrɪŋ",
    "neighbourliness": "neɪbəlinəs",
    "neighbourly": "neɪbəli",
    "neighbour": "neɪbɐ",
    "neighbours": "neɪbəz",
    "neighed": "neɪd",
    "neighing": "neɪɪŋ",
    "neigh": "neɪ",
    "neighs": "neɪz",
    "neither": "naɪðɐ",
    "nelly": "nɛli",
    "nelson": "nɛlsən",
    "nelsons": "nɛlsənz",
    "nematode": "nɛmɐtəʊd",
    "nematodes": "nɛmɐtəʊdz",
    "nemeses": "nɛmɪsiːz",
    "nemesis": "nɛməsɪs",
    "n": "ɛn",
    "ne": "niː",
    "neoclassical": "niːəʊklæsɪkəl",
    "neoclassicism": "niːəʊklæsɪsɪzəm",
    "neoclassic": "niːəʊklæsɪk",
    "neoconservative": "niːəʊkɒnsəvətɪv",
    "neodymium": "niːəʊdɪmiəm",
    "neoliberalism": "niːəʊlɪbərəlɪzəm",
    "neoliberal": "niːəʊlɪbərəl",
    "neolithic": "niːəʊlɪθɪk",
    "neologism": "niːəʊlədʒɪzəm",
    "neologisms": "niːəʊlədʒɪzəmz",
    "neologist": "niːəʊlɒdʒɪst",
    "neonatal": "niːəʊneɪtəl",
    "neonate": "niːəʊneɪt",
    "neon": "niːɒn",
    "neophytes": "niːəʊfaɪts",
    "neoprene": "niːəʊpriːn",
    "nephew": "nɛfjuː",
    "nephews": "nɛfjuːz",
    "nephrectomy": "nɛfrɛktəmi",
    "nephrite": "nɛfraɪt",
    "nephritis": "nɛfraɪtɪs",
    "nephron": "nɛfrɒn",
    "nephrons": "nɛfrɒnz",
    "nepotism": "nɛpətɪzəm",
    "nepotistic": "nɛpətɪstɪk",
    "neptunium": "nɛptjuːniəm",
    "nerdiest": "nɜːdɪəst",
    "nerd": "nɜːd",
    "nerds": "nɜːdz",
    "nerdy": "nɜːdi",
    "nereid": "nɛreɪd",
    "nerval": "nɜːvəl",
    "nerved": "nɜːvd",
    "nerveless": "nɜːvləs",
    "nerve": "nɜːv",
    "nerveracking": "nɜːvərækɪŋ",
    "nerves": "nɜːvz",
    "nerving": "nɜːvɪŋ",
    "nervously": "nɜːvəsli",
    "nervousness": "nɜːvəsnəs",
    "nervous": "nɜːvəs",
    "nervy": "nɜːvi",
    "nesses": "nɛsɪz",
    "ness": "nɛs",
    "nested": "nɛstɪd",
    "nesting": "nɛstɪŋ",
    "nestled": "nɛsəld",
    "nestle": "nɛsəl",
    "nestles": "nɛsəlz",
    "nestling": "nɛslɪŋ",
    "nestlings": "nɛslɪŋz",
    "nest": "nɛst",
    "nests": "nɛsts",
    "netball": "nɛtbɔːl",
    "nether": "nɛðɐ",
    "netherworld": "nɛðəwɜːld",
    "netiquette": "nɛtɪkɛt",
    "net": "nɛt",
    "nets": "nɛts",
    "netsuke": "nɛtsuːk",
    "netted": "nɛtɪd",
    "netting": "nɛtɪŋ",
    "nettled": "nɛtəld",
    "nettle": "nɛtəl",
    "nettles": "nɛtəlz",
    "netty": "nɛti",
    "networked": "nɛtwɜːkt",
    "networking": "nɛtwɜːkɪŋ",
    "network": "nɛtwɜːk",
    "networks": "nɛtwɜːks",
    "neuralgia": "njuːrældʒɐ",
    "neuralgic": "njuːrældʒɪk",
    "neural": "njuːrəl",
    "neurasthenia": "njuːrɑːsθiːniə",
    "neuritis": "njuːraɪtɪs",
    "neurologically": "njuːrəlɒdʒɪkli",
    "neurological": "njuːrəlɒdʒɪkəl",
    "neurologist": "njuːrɒlədʒɪst",
    "neurologists": "njuːrɒlədʒɪsts",
    "neurology": "njuːrɒlədʒi",
    "neuroma": "njuːrəʊmɐ",
    "neuromuscular": "njuːrəmʌskjʊlɐ",
    "neuronal": "njuːrɒnəl",
    "neuron": "njuːrɒn",
    "neurons": "njuːrɒnz",
    "neuropathy": "njuːrɒpəθi",
    "neuroscience": "njuːrəsaɪəns",
    "neuroscientist": "njuːrəsaɪəntɪst",
    "neuroses": "njuːrəʊzɪz",
    "neurosis": "njuːrəʊsɪs",
    "neurosurgeon": "njuːrəsɜːdʒən",
    "neurosurgeons": "njuːrəsɜːdʒənz",
    "neurosurgery": "njuːrəsɜːdʒəri",
    "neurosurgical": "njuːrəsɜːdʒɪkəl",
    "neurotically": "njuːrɒtɪkli",
    "neuroticism": "njuːrɒtɪsɪzəm",
    "neurotic": "njuːrɒtɪk",
    "neurotics": "njuːrɒtɪks",
    "neurotransmitter": "njuːrətrænsmɪtɐ",
    "neurotransmitters": "njuːrətrænsmɪtəz",
    "neurovascular": "njuːrəvæskjʊlɐ",
    "neutered": "njuːtəd",
    "neutering": "njuːtərɪŋ",
    "neuter": "njuːtɐ",
    "neutralisation": "njuːtrəlaɪzeɪʃən",
    "neutralised": "njuːtrəlaɪzd",
    "neutralise": "njuːtrəlaɪz",
    "neutraliser": "njuːtrəlaɪzɐ",
    "neutralisers": "njuːtrəlaɪzəz",
    "neutralises": "njuːtrəlaɪzɪz",
    "neutralising": "njuːtrəlaɪzɪŋ",
    "neutrality": "njuːtrælɪti",
    "neutrally": "njuːtrəli",
    "neutral": "njuːtrəl",
    "neutrals": "njuːtrəlz",
    "neutrino": "njuːtriːnəʊ",
    "neutrinos": "njuːtriːnəʊz",
    "neutron": "njuːtrɒn",
    "neutrons": "njuːtrɒnz",
    "neutrophil": "njuːtrəfɪl",
    "nevermore": "nɛvəmɔː",
    "never": "nɛvɐ",
    "nevertheless": "nɛvəðəlɛs",
    "nevus": "nɛvəs",
    "newbie": "njuːbi",
    "newbies": "njuːbɪz",
    "newborn": "njuːbɔːn",
    "newborns": "njuːbɔːnz",
    "newcomer": "njuːkʌmɐ",
    "newcomers": "njuːkʌməz",
    "newel": "njuːəl",
    "newer": "njuːɐ",
    "newest": "njuːəst",
    "newfangled": "njuːfæŋɡəld",
    "newfound": "njuːfaʊnd",
    "newish": "njuːɪʃ",
    "newly": "njuːli",
    "newlywed": "njuːlɪwɛd",
    "newlyweds": "njuːlɪwɛdz",
    "newness": "njuːnəs",
    "new": "njuː",
    "newsagent": "njuːzeɪdʒənt",
    "newsagents": "njuːzeɪdʒənts",
    "newsboy": "njuːzbɔɪ",
    "newscaster": "njuːzkɑːstɐ",
    "newscasters": "njuːzkɑːstəz",
    "newscast": "njuːzkɑːst",
    "newscasts": "njuːzkɑːsts",
    "newsflash": "njuːzflæʃ",
    "newsgroup": "njuːzɡruːp",
    "newshound": "njuːzhaʊnd",
    "newshounds": "njuːzhaʊndz",
    "newsletter": "njuːzlɛtɐ",
    "newsletters": "njuːzlɛtəz",
    "newsman": "njuːzmæn",
    "newsmen": "njuːzmɛn",
    "news": "njuːz",
    "newspaperman": "njuːzpeɪpəmən",
    "newspapermen": "njuːzpeɪpəmɛn",
    "newspaper": "njuːzpeɪpɐ",
    "newspapers": "njuːzpeɪpəz",
    "newspeak": "njuːzpiːk",
    "newsprint": "njuːzprɪnt",
    "newsreader": "njuːzriːdɐ",
    "newsreaders": "njuːzriːdəz",
    "newsreel": "njuːzriːl",
    "newsreels": "njuːzriːlz",
    "newsroom": "njuːzruːm",
    "newsrooms": "njuːzruːmz",
    "newsstand": "njuːzstænd",
    "newsstands": "njuːzstændz",
    "newsworthy": "njuːzwɜːði",
    "newsy": "njuːzwaɪ",
    "newt": "njuːt",
    "newton": "njuːtən",
    "newtons": "njuːtənz",
    "newts": "njuːts",
    "nextdoor": "nɛkstdɔː",
    "next": "nɛkst",
    "nexus": "nɛksəs",
    "niacin": "naɪəsɪn",
    "nibbled": "nɪbəld",
    "nibble": "nɪbəl",
    "nibbler": "nɪblɐ",
    "nibblers": "nɪbləz",
    "nibbles": "nɪbəlz",
    "nibbling": "nɪblɪŋ",
    "niblick": "nɪblɪk",
    "nib": "nɪb",
    "nibs": "nɪbz",
    "nicely": "naɪsli",
    "niceness": "naɪsnəs",
    "nicer": "naɪsɐ",
    "nicest": "naɪsəst",
    "niceties": "naɪsətiz",
    "nicety": "naɪsəti",
    "niche": "niːʃ",
    "niches": "nɪʃɪz",
    "nicked": "nɪkt",
    "nickel": "nɪkəl",
    "nickelodeon": "nɪkɪləʊdɪən",
    "nickels": "nɪkəlz",
    "nicker": "nɪkɐ",
    "nickers": "nɪkəz",
    "nicking": "nɪkɪŋ",
    "nicknacks": "nɪknæks",
    "nicknamed": "nɪkneɪmd",
    "nickname": "nɪkneɪm",
    "nicknames": "nɪkneɪmz",
    "nick": "nɪk",
    "nicks": "nɪks",
    "nicotiana": "nɪkəʊʃiːænɐ",
    "nicotine": "nɪkətiːn",
    "nictating": "nɪkteɪtɪŋ",
    "nictitating": "nɪktɪteɪtɪŋ",
    "nidus": "nɪdəs",
    "niece": "niːs",
    "nieces": "niːsɪz",
    "niello": "nɪɛləʊ",
    "niff": "nɪf",
    "niffy": "nɪfi",
    "niftily": "nɪftɪli",
    "nifty": "nɪfti",
    "niggardly": "nɪɡədli",
    "niggard": "nɪɡəd",
    "nigger": "nɪɡɐ",
    "niggers": "nɪɡəz",
    "niggled": "nɪɡəld",
    "niggle": "nɪɡəl",
    "niggles": "nɪɡəlz",
    "niggling": "nɪɡlɪŋ",
    "nigh": "naɪ",
    "nightcap": "naɪtkæp",
    "nightclothes": "naɪtkləʊðz",
    "nightclubbing": "naɪtklʌbɪŋ",
    "nightclub": "naɪtklʌb",
    "nightclubs": "naɪtklʌbz",
    "nightdresses": "naɪtdrɛsɪz",
    "nightdress": "naɪtdrɛs",
    "nightfall": "naɪtfɔːl",
    "nightgown": "naɪtɡaʊn",
    "nightgowns": "naɪtɡaʊnz",
    "nighthawk": "naɪthɔːk",
    "nighthawks": "naɪthɔːks",
    "nightie": "naɪti",
    "nighties": "naɪtɪz",
    "nightingale": "naɪtɪŋɡeɪl",
    "nightingales": "naɪtɪŋɡeɪlz",
    "nightjar": "naɪtdʒɑː",
    "nightjars": "naɪtdʒɑːz",
    "nightlife": "naɪtlaɪf",
    "nightlight": "naɪtlaɪt",
    "nightlong": "naɪtlɒŋ",
    "nightly": "naɪtli",
    "nightmare": "naɪtmeə",
    "nightmares": "naɪtmeəz",
    "nightmarish": "naɪtmeərɪʃ",
    "night": "naɪt",
    "nightrider": "naɪtraɪdɐ",
    "nightshade": "naɪtʃeɪd",
    "nightshirt": "naɪtʃɜːt",
    "nights": "naɪts",
    "nightspot": "naɪtspɒt",
    "nightspots": "naɪtspɒts",
    "nightstand": "naɪtstænd",
    "nighttime": "naɪttaɪm",
    "nightwatchman": "naɪtwɒtʃmən",
    "nightwear": "naɪtweə",
    "nighty": "naɪti",
    "nihilism": "naɪəlɪzəm",
    "nihilistic": "naɪəlɪstɪk",
    "nihilist": "naɪəlɪst",
    "nihilists": "naɪəlɪsts",
    "nilgai": "nɪlɡaɪ",
    "nil": "nɪl",
    "nimbleness": "nɪmbəlnəs",
    "nimble": "nɪmbəl",
    "nimbler": "nɪmblɐ",
    "nimblest": "nɪmbləst",
    "nimbly": "nɪmbli",
    "nimbostratus": "nɪmbəstrætəs",
    "nimbus": "nɪmbəs",
    "nimby": "nɪmbi",
    "nim": "nɪm",
    "n'importe": "ɛnɪmpɔːt",
    "nimrod": "nɪmrɒd",
    "nimrods": "nɪmrɒdz",
    "nincompoop": "nɪnkəmpuːp",
    "nincompoops": "nɪnkəmpuːps",
    "ninefold": "naɪnfəʊld",
    "nine": "naɪn",
    "ninepence": "naɪnpəns",
    "ninepins": "naɪnpɪnz",
    "nines": "naɪnz",
    "nineteen": "naɪntiːn",
    "nineteenth": "naɪntiːnθ",
    "nineties": "naɪntɪz",
    "ninety": "naɪnti",
    "ninja": "nɪndʒɐ",
    "ninjas": "nɪndʒəz",
    "ninnies": "nɪnɪz",
    "ninny": "nɪni",
    "ninth": "naɪnθ",
    "ninths": "naɪnθs",
    "niobium": "nɪəʊbiəm",
    "nip": "nɪp",
    "nipped": "nɪpt",
    "nipper": "nɪpɐ",
    "nippers": "nɪpəz",
    "nippier": "nɪpɪɐ",
    "nipping": "nɪpɪŋ",
    "nipple": "nɪpəl",
    "nipples": "nɪpəlz",
    "nippy": "nɪpi",
    "nips": "nɪps",
    "nirvana": "nɜːvɑːnɐ",
    "nisi": "nɪsi",
    "nite": "naɪt",
    "nit": "nɪt",
    "nitpicking": "nɪtpɪkɪŋ",
    "nitpick": "nɪtpɪk",
    "nitrate": "naɪtreɪt",
    "nitrates": "naɪtreɪts",
    "nitrating": "naɪtreɪtɪŋ",
    "nitration": "naɪtreɪʃən",
    "nitric": "naɪtrɪk",
    "nitrite": "naɪtraɪt",
    "nitrites": "naɪtraɪts",
    "nitrocellulose": "naɪtrəʊsɛljuːləʊz",
    "nitrogen": "naɪtrədʒən",
    "nitrogenous": "naɪtrədʒənəs",
    "nitroglycerine": "naɪtrəʊɡlɪsəriːn",
    "nitroglycerin": "naɪtrəʊɡlɪsərɪn",
    "nitro": "naɪtrəʊ",
    "nitrous": "naɪtrəs",
    "nits": "nɪts",
    "nitty": "nɪti",
    "nitwit": "nɪtwɪt",
    "nitwits": "nɪtwɪts",
    "nixed": "nɪkst",
    "nix": "nɪks",
    "nobbled": "nɒbəld",
    "nobble": "nɒbəl",
    "nobbles": "nɒbəlz",
    "nobbling": "nɒblɪŋ",
    "nobby": "nɒbi",
    "nobelium": "nəʊbliəm",
    "nobility": "nəʊbɪlɪti",
    "nobleman": "nəʊbəlmən",
    "noblemen": "nəʊbəlmɛn",
    "noble": "nəʊbəl",
    "nobleness": "nəʊbəlnəs",
    "nobler": "nəʊblɐ",
    "nobles": "nəʊbəlz",
    "noblesse": "nəʊbləs",
    "noblest": "nəʊbləst",
    "noblewoman": "nəʊbəlwʊmən",
    "nobly": "nəʊbli",
    "nob": "nɒb",
    "nobodies": "nəʊbɒdiz",
    "nobody": "nəʊbɒdi",
    "nobs": "nɒbz",
    "nock": "nɒk",
    "nocks": "nɒks",
    "noctiluca": "nɒktɪluːkɐ",
    "noctilucent": "nɒktɪluːsənt",
    "noctule": "nɒktjuːl",
    "nocturnally": "nɒktɜːnəli",
    "nocturnal": "nɒktɜːnəl",
    "nocturne": "nɒktɜːn",
    "nocturnes": "nɒktɜːnz",
    "nodal": "nəʊdəl",
    "nodded": "nɒdɪd",
    "nodding": "nɒdɪŋ",
    "noddle": "nɒdəl",
    "noddles": "nɒdəlz",
    "noddy": "nɒdi",
    "node": "nəʊd",
    "nodes": "nəʊdz",
    "nod": "nɒd",
    "nods": "nɒdz",
    "nodule": "nɒdjuːl",
    "nodules": "nɒdjuːlz",
    "noel": "nəʊl",
    "noes": "nəʊz",
    "noggin": "nɒɡɪn",
    "noggins": "nɒɡɪnz",
    "nog": "nɒɡ",
    "nogs": "nɒɡz",
    "nohow": "nəʊhaʊ",
    "noil": "nɔɪl",
    "noiseless": "nɔɪzləs",
    "noisemaker": "nɔɪzɪmeɪkɐ",
    "noisemakers": "nɔɪzɪmeɪkəz",
    "noise": "nɔɪz",
    "noises": "nɔɪzɪz",
    "noisette": "nɔɪzɛt",
    "noisier": "nɔɪzɪɐ",
    "noisiest": "nɔɪzɪəst",
    "noisily": "nɔɪzɪli",
    "noisiness": "nɔɪzɪnəs",
    "noisome": "nɔɪsʌm",
    "noisy": "nɔɪzi",
    "nomadic": "nəʊmædɪk",
    "nomadism": "nəʊmeɪdɪzəm",
    "nomad": "nəʊmæd",
    "nomads": "nəʊmædz",
    "noma": "nəʊmɐ",
    "nomenclature": "nəmɛŋklətʃɐ",
    "nomen": "nəʊmɛn",
    "nominally": "nɒmɪnəli",
    "nominal": "nɒmɪnəl",
    "nominated": "nɒmɪneɪtɪd",
    "nominate": "nɒmɪneɪt",
    "nominates": "nɒmɪneɪts",
    "nominating": "nɒmɪneɪtɪŋ",
    "nomination": "nɒmɪneɪʃən",
    "nominations": "nɒmɪneɪʃənz",
    "nominative": "nɒmɪnətɪv",
    "nominator": "nɒmɪneɪtɐ",
    "nominee": "nɒmɪniː",
    "nominees": "nɒmɪniːz",
    "nonagenarian": "nɒneɪdʒəneəriən",
    "nonagenarians": "nɒneɪdʒəneəriənz",
    "nonbeliever": "nɒnbɪliːvɐ",
    "nonce": "nɒnsiː",
    "nonchalance": "nɒnʃələns",
    "nonchalantly": "nɒnʃələntli",
    "nonchalant": "nɒnʃələnt",
    "noncommittal": "nɒnkəmɪtəl",
    "nonconformist": "nɒnkənfɔːmɪst",
    "nonconformity": "nɒnkənfɔːmɪti",
    "nondescript": "nɒndɪskrɪpt",
    "nondisclosure": "nɒndɪskləʊʒɐ",
    "nonentities": "nɒnɛntɪtiz",
    "nonentity": "nɒnɛntɪti",
    "nones": "nʌnz",
    "nonesuch": "nɒnɛsʌtʃ",
    "nonetheless": "nʌnðəlɛs",
    "nonevent": "nɒnɪvɛnt",
    "nonexistent": "nɒnɛɡzɪstənt",
    "nonfiction": "nɒnfɪkʃən",
    "nongovernmental": "nɒnɡʌvənmɛntəl",
    "non": "nɒn",
    "nonpareil": "nɒnpeərɪl",
    "nonpayment": "nɒnpeɪmənt",
    "nonplused": "nɒnplʌsd",
    "nonplussed": "nɒnplʌst",
    "nonproliferation": "nɒnprəlɪfəreɪʃən",
    "nonsense": "nɒnsəns",
    "nonsenses": "nɒnsənsɪz",
    "nonsensical": "nɒnsɛnzɪkəl",
    "nonslip": "nɒnslɪp",
    "nonstick": "nɒnstɪk",
    "nonstop": "nɒnstɒp",
    "nonsuch": "nɒnsʌtʃ",
    "nonuniform": "nɒnjuːnɪfɔːm",
    "nonviolence": "nɒnvaɪələns",
    "noodle": "nuːdəl",
    "noodles": "nuːdəlz",
    "noodling": "nuːdlɪŋ",
    "nookie": "nʊki",
    "nook": "nʊk",
    "nooks": "nʊks",
    "nooky": "nʊki",
    "noonday": "nuːndeɪ",
    "noon": "nuːn",
    "noons": "nuːnz",
    "noontime": "nuːntaɪm",
    "noose": "nuːs",
    "nooses": "nuːsɪz",
    "nope": "nəʊp",
    "noradrenaline": "nɔːrɐdrɛnəlɪn",
    "noradrenalin": "nɔːrɐdrɛnɐlɪn",
    "norland": "nɔːlənd",
    "normalcy": "nɔːməlsi",
    "normalisation": "nɔːməlaɪzeɪʃən",
    "normalised": "nɔːməlaɪzd",
    "normalise": "nɔːməlaɪz",
    "normalises": "nɔːməlaɪzɪz",
    "normalising": "nɔːməlaɪzɪŋ",
    "normality": "nɔːmælɪti",
    "normally": "nɔːməli",
    "normal": "nɔːməl",
    "normals": "nɔːməlz",
    "normative": "nɔːmətɪv",
    "norm": "nɔːm",
    "norms": "nɔːmz",
    "nor": "nɔː",
    "northbound": "nɔːθbaʊnd",
    "northeasterly": "nɔːθiːstəli",
    "northeastern": "nɔːθiːstən",
    "northeast": "nɔːθiːst",
    "northeastwards": "nɔːθiːstwədz",
    "northerly": "nɔːðəli",
    "northerner": "nɔːðənɐ",
    "northerners": "nɔːðənəz",
    "northernmost": "nɔːðənməʊst",
    "northern": "nɔːðən",
    "norther": "nɔːðɐ",
    "north": "nɔːθ",
    "northward": "nɔːθwəd",
    "northwards": "nɔːθwədz",
    "northwesterly": "nɔːθwɛstəli",
    "northwestern": "nɔːθwɛstən",
    "northwest": "nɔːθwɛst",
    "nosebag": "nəʊsbæɡ",
    "noseband": "nəʊsbænd",
    "nosebleed": "nəʊsbliːd",
    "nosebleeds": "nəʊsbliːdz",
    "nosecone": "nəʊskəʊn",
    "nosedived": "nəʊzdaɪvd",
    "nosedive": "nəʊzdaɪv",
    "nosedives": "nəʊzdaɪvz",
    "nosediving": "nəʊzdaɪvɪŋ",
    "nosed": "nəʊzd",
    "nosegay": "nəʊsɡeɪ",
    "nosegays": "nəʊsɡeɪz",
    "nose": "nəʊz",
    "noses": "nəʊzɪz",
    "nosey": "nəʊsi",
    "noshed": "nɒʃt",
    "nosher": "nɒʃɐ",
    "noshers": "nɒʃəz",
    "noshes": "nɒʃɪz",
    "noshing": "nɒʃɪŋ",
    "nosh": "nɒʃ",
    "nosier": "nəʊzɪɐ",
    "nosiest": "nəʊzɪəst",
    "nosiness": "nəʊzɪnəs",
    "nosing": "nəʊzɪŋ",
    "nostalgia": "nəstældʒɐ",
    "nostalgically": "nəstældʒɪkli",
    "nostalgic": "nəstældʒɪk",
    "nostril": "nɒstrəl",
    "nostrils": "nɒstrəlz",
    "nostrum": "nɒstrəm",
    "nosy": "nəʊzi",
    "notable": "nəʊtəbəl",
    "notables": "nəʊtəbəlz",
    "notably": "nəʊtəbli",
    "notarised": "nəʊtəraɪzd",
    "notary": "nəʊtəri",
    "notated": "nəʊteɪtɪd",
    "notation": "nəʊteɪʃən",
    "notations": "nəʊteɪʃənz",
    "notched": "nɒtʃt",
    "notches": "nɒtʃɪz",
    "notching": "nɒtʃɪŋ",
    "notch": "nɒtʃ",
    "notebook": "nəʊtbʊk",
    "notebooks": "nəʊtbʊks",
    "noted": "nəʊtɪd",
    "notelet": "nəʊtlət",
    "note": "nəʊt",
    "notepad": "nəʊtpæd",
    "notepads": "nəʊtpædz",
    "notepaper": "nəʊtpeɪpɐ",
    "notes": "nəʊts",
    "noteworthy": "nəʊtwɜːði",
    "nothingness": "nʌθɪŋnəs",
    "nothing": "nʌθɪŋ",
    "nothings": "nʌθɪŋz",
    "noticeable": "nəʊtɪsəbəl",
    "noticeably": "nəʊtɪsəbli",
    "noticeboard": "nəʊtɪsbɔːd",
    "noticeboards": "nəʊtɪsbɔːdz",
    "noticed": "nəʊtɪsd",
    "notice": "nəʊtɪs",
    "notices": "nəʊtɪsɪz",
    "noticing": "nəʊtɪsɪŋ",
    "notifiable": "nəʊtɪfaɪəbəl",
    "notification": "nəʊtɪfɪkeɪʃən",
    "notifications": "nəʊtɪfɪkeɪʃənz",
    "notified": "nəʊtɪfaɪd",
    "notifies": "nəʊtɪfaɪz",
    "notifying": "nəʊtɪfaɪɪŋ",
    "notify": "nəʊtɪfaɪ",
    "noting": "nəʊtɪŋ",
    "notionally": "nəʊʃənəli",
    "notional": "nəʊʃənəl",
    "notion": "nəʊʃən",
    "notions": "nəʊʃənz",
    "not": "nɒt",
    "notochord": "nɒtəkɔːd",
    "notoriety": "nəʊtɔːraɪəti",
    "notoriously": "nəʊtɔːrɪəsli",
    "notorious": "nəʊtɔːrɪəs",
    "notwithstanding": "nɒtwɪðstændɪŋ",
    "nougat": "nuːɡæt",
    "nought": "nɔːt",
    "noughts": "nɔːts",
    "noun": "naʊn",
    "nouns": "naʊnz",
    "nourished": "nʌrɪʃt",
    "nourishes": "nʌrɪʃɪz",
    "nourishing": "nʌrɪʃɪŋ",
    "nourishment": "nʌrɪʃmənt",
    "nourish": "nʌrɪʃ",
    "nous": "nuːz",
    "novae": "nɒviː",
    "nova": "nəʊvɐ",
    "novas": "nəʊvəz",
    "novelisation": "nɒvɪlaɪzeɪʃən",
    "novelistic": "nɒvɪlɪstɪk",
    "novelist": "nɒvɪlɪst",
    "novelists": "nɒvɪlɪsts",
    "novella": "nɒvɛlɐ",
    "novellas": "nɒvɛləz",
    "novel": "nɒvəl",
    "novels": "nɒvəlz",
    "novelties": "nɒvəltɪz",
    "novelty": "nɒvəlti",
    "novice": "nɒvɪs",
    "novices": "nɒvɪsɪz",
    "nowadays": "naʊədeɪz",
    "nowhere": "nəʊweə",
    "now": "naʊ",
    "nowt": "naʊt",
    "noxiousness": "nɒkʃəsnəs",
    "noxious": "nɒkʃəs",
    "nozzle": "nɒzəl",
    "nozzles": "nɒzəlz",
    "nth": "ɛntiːeɪtʃ",
    "nuanced": "njuːənst",
    "nuance": "njuːəns",
    "nuances": "njuːənsɪz",
    "nubbin": "nʌbɪn",
    "nubbins": "nʌbɪnz",
    "nubbly": "nʌbli",
    "nubile": "njuːbaɪl",
    "nub": "nʌb",
    "nubs": "nʌbz",
    "nuclear": "njuːkliə",
    "nucleate": "njuːklɪeɪt",
    "nucleic": "njuːklɪɪk",
    "nuclei": "njuːklɪi",
    "nucleon": "njuːklɪən",
    "nucleotide": "njuːklɪɒtaɪd",
    "nucleotides": "njuːklɪɒtaɪdz",
    "nucleus": "njuːklɪəs",
    "nude": "njuːd",
    "nudes": "njuːdz",
    "nudged": "nʌdʒd",
    "nudge": "nʌdʒ",
    "nudges": "nʌdʒɪz",
    "nudging": "nʌdʒɪŋ",
    "nudibranch": "njuːdɪbrɑːntʃ",
    "nudibranchs": "njuːdɪbrɑːntʃz",
    "nudism": "njuːdɪzəm",
    "nudist": "njuːdɪst",
    "nudists": "njuːdɪsts",
    "nudity": "njuːdɪti",
    "nugget": "nʌɡɪt",
    "nuggets": "nʌɡɪts",
    "nuisance": "njuːsəns",
    "nuisances": "njuːsənsɪz",
    "nuked": "njuːkt",
    "nuke": "njuːk",
    "nukes": "njuːks",
    "nuking": "njuːkɪŋ",
    "nullified": "nʌlɪfaɪd",
    "nullifying": "nʌlɪfaɪɪŋ",
    "nullify": "nʌlɪfaɪ",
    "nullity": "nʌlɪti",
    "null": "nʌl",
    "numbed": "nʌmd",
    "numbered": "nʌmbəd",
    "numbering": "nʌmbərɪŋ",
    "numberless": "nʌmbələs",
    "numberplate": "nʌmbəpleɪt",
    "numbers": "nʌmbəz",
    "numbingly": "nʌmɪŋli",
    "numbing": "nʌmɪŋ",
    "numbles": "nʌmbəlz",
    "numbness": "nʌmnəs",
    "numb": "nʌm",
    "numbskull": "nʌmbskʌl",
    "numbskulls": "nʌmbskʌlz",
    "numbs": "nʌmz",
    "numeracy": "njuːmərəsi",
    "numeral": "njuːmərəl",
    "numerals": "njuːmərəlz",
    "numeration": "njuːməreɪʃən",
    "numerator": "njuːməreɪtɐ",
    "numerators": "njuːməreɪtəz",
    "numerically": "njuːmɛrɪkli",
    "numerical": "njuːmɛrɪkəl",
    "numeric": "njuːmɛrɪk",
    "numerology": "njuːmərɒlədʒi",
    "numerous": "njuːmərəs",
    "numinous": "njuːmɪnəs",
    "numismatist": "njuːmɪsmætɪst",
    "numismatists": "njuːmɪsmætɪsts",
    "nunciature": "nʌnsɪətʃɐ",
    "nuncio": "nʌnsɪəʊ",
    "nunneries": "nʌnəriz",
    "nunnery": "nʌnəri",
    "nuns": "nʌnz",
    "nu": "nuː",
    "nuptial": "nʌpʃəl",
    "nuptials": "nʌpʃəlz",
    "nursed": "nɜːsd",
    "nursemaid": "nɜːsmeɪd",
    "nursemaids": "nɜːsmeɪdz",
    "nurse": "nɜːs",
    "nurseries": "nɜːsəriz",
    "nurser": "nɜːsɐ",
    "nurseryman": "nɜːsərɪmən",
    "nurserymen": "nɜːsərɪmɛn",
    "nursery": "nɜːsəri",
    "nurses": "nɜːsɪz",
    "nursing": "nɜːsɪŋ",
    "nursling": "nɜːslɪŋ",
    "nurtured": "nɜːtʃəd",
    "nurture": "nɜːtʃɐ",
    "nurturer": "nɜːtʃərɐ",
    "nurtures": "nɜːtʃəz",
    "nurturing": "nɜːtʃərɪŋ",
    "nus": "nʌs",
    "nutbrown": "nʌtbraʊn",
    "nutcase": "nʌtkeɪs",
    "nutcases": "nʌtkeɪsɪz",
    "nutcracker": "nʌtkrækɐ",
    "nutcrackers": "nʌtkrækəz",
    "nuthatches": "nʌθætʃɪz",
    "nuthatch": "nʌθætʃ",
    "nuthouse": "nʌthaʊs",
    "nutmeg": "nʌtmɛɡ",
    "nutmegs": "nʌtmɛɡz",
    "nut": "nʌt",
    "nutria": "njuːtriɐ",
    "nutrient": "njuːtriənt",
    "nutrients": "njuːtriənts",
    "nutritionally": "njuːtrɪʃənəli",
    "nutritional": "njuːtrɪʃənəl",
    "nutritionist": "njuːtrɪʃənɪst",
    "nutritionists": "njuːtrɪʃənɪsts",
    "nutrition": "njuːtrɪʃən",
    "nutritious": "njuːtrɪʃəs",
    "nutritive": "njuːtrɪtɪv",
    "nutshell": "nʌtʃɛl",
    "nutshells": "nʌtʃɛlz",
    "nuts": "nʌts",
    "nutted": "nʌtɪd",
    "nutter": "nʌtɐ",
    "nutters": "nʌtəz",
    "nuttier": "nʌtɪɐ",
    "nuttiest": "nʌtɪəst",
    "nuttiness": "nʌtɪnəs",
    "nutting": "nʌtɪŋ",
    "nutty": "nʌti",
    "nutwood": "nʌtwʊd",
    "nuzzled": "nʌzəld",
    "nuzzle": "nʌzəl",
    "nuzzling": "nʌzlɪŋ",
    "nyala": "naɪɑːlɐ",
    "nyctalopia": "nɪktɐləʊpiə",
    "nylon": "naɪlɒn",
    "nylons": "naɪlɒnz",
    "nymphaea": "nɪmfiə",
    "nymphaeum": "nɪmfiːəm",
    "nymphet": "nɪmfɪt",
    "nymphets": "nɪmfɪts",
    "nymph": "nɪmf",
    "nymphomaniac": "nɪmfəmeɪnɪæk",
    "nympho": "nɪmfəʊ",
    "nymphs": "nɪmfz",
    "nystagmus": "nɪstæɡməs",
    "oaf": "əʊf",
    "oafish": "əʊfɪʃ",
    "oafs": "əʊfs",
    "oak": "əʊk",
    "oaken": "əʊkən",
    "oaks": "əʊks",
    "oakum": "əʊkəm",
    "oared": "ɔːd",
    "oarfish": "ɔːfɪʃ",
    "oarlock": "ɔːlɒk",
    "oar": "ɔː",
    "oarsman": "ɔːzmən",
    "oarsmen": "ɔːzmɛn",
    "oars": "ɔːz",
    "oarswoman": "ɔːswʊmən",
    "oases": "əʊeɪsiːz",
    "oasis": "əʊeɪsɪs",
    "oast": "əʊst",
    "oasts": "əʊsts",
    "oatcake": "əʊtkeɪk",
    "oatcakes": "əʊtkeɪks",
    "oaten": "əʊtən",
    "oat": "əʊt",
    "oath": "əʊθ",
    "oaths": "əʊθs",
    "oatmeal": "əʊtmiəl",
    "oats": "əʊts",
    "obduracy": "ɒbdjɔːrəsi",
    "obdurate": "ɒbdjɔːrət",
    "obeah": "əʊbɐ",
    "obedience": "əʊbiːdiəns",
    "obedient": "əʊbiːdiənt",
    "obediently": "əʊbiːdiəntli",
    "obeisance": "əʊbɪsəns",
    "obelisk": "ɒbəlɪsk",
    "obelisks": "ɒbəlɪsks",
    "obelus": "əʊbləs",
    "obese": "əʊbiːz",
    "obesity": "əʊbiːsəti",
    "obey": "əʊbeɪ",
    "obeyed": "əʊbeɪd",
    "obeying": "əʊbeɪɪŋ",
    "obeys": "əʊbeɪz",
    "obfuscate": "ɒbfəskeɪt",
    "obfuscating": "ɒbfəskeɪtɪŋ",
    "obfuscation": "ɒbfəskeɪʃən",
    "obi": "əʊbaɪ",
    "obit": "ɒbɪt",
    "obits": "ɒbɪts",
    "obituaries": "ɒbɪtʃɔːriz",
    "obituary": "ɒbɪtʃɔːri",
    "objected": "ɒbdʒɛktɪd",
    "objectification": "ɒbdʒɛktɪfɪkeɪʃən",
    "objectified": "ɒbdʒɛktɪfaɪd",
    "objectifies": "ɒbdʒɛktɪfaɪz",
    "objectify": "ɒbdʒɛktɪfaɪ",
    "objectifying": "ɒbdʒɛktɪfaɪɪŋ",
    "objecting": "ɒbdʒɛktɪŋ",
    "objectionable": "ɒbdʒɛkʃənəbəl",
    "objection": "ɒbdʒɛkʃən",
    "objections": "ɒbdʒɛkʃənz",
    "objective": "ɒbdʒɛktɪv",
    "objectively": "ɒbdʒɛktɪvli",
    "objectives": "ɒbdʒɛktɪvz",
    "objectivity": "ɒbdʒɪktɪvɪti",
    "objector": "ɒbdʒɛktɐ",
    "objectors": "ɒbdʒɛktəz",
    "objet": "ɒbdʒɛt",
    "oblation": "əbleɪtiən",
    "obligated": "ɒblɪɡeɪtɪd",
    "obligation": "ɒblɪɡeɪʃən",
    "obligations": "ɒblɪɡeɪʃənz",
    "obligatory": "əblɪɡətəri",
    "obliged": "əblaɪdʒd",
    "oblige": "əblaɪdʒ",
    "obliges": "əblaɪdʒɪz",
    "obliging": "əblaɪdʒɪŋ",
    "obligingly": "əblaɪdʒɪŋli",
    "oblique": "əbliːk",
    "obliquely": "əbliːkli",
    "obliques": "əbliːks",
    "obliquity": "əblɪkwɪti",
    "obliterated": "əblɪtəreɪtɪd",
    "obliterate": "əblɪtəreɪt",
    "obliterates": "əblɪtəreɪts",
    "obliterating": "əblɪtəreɪtɪŋ",
    "obliteration": "əblɪtəreɪʃən",
    "obliterator": "əblɪtəreɪtɐ",
    "oblivion": "əblɪviən",
    "oblivious": "əblɪvɪəs",
    "oblong": "ɒblɒŋ",
    "oblongs": "ɒblɒŋz",
    "obloquy": "ɒbləkwi",
    "obnoxious": "ɒbnɒkʃəs",
    "obnoxiously": "ɒbnɒkʃəsli",
    "obnoxiousness": "ɒbnɒkʃəsnəs",
    "oboe": "ɒbəʊ",
    "oboes": "əʊbəʊz",
    "oboist": "əʊbəʊɪst",
    "obscene": "ɒbsiːn",
    "obscenely": "ɒbsiːnli",
    "obscener": "ɒbsiːnɐ",
    "obscenities": "ɒbsɛnɪtiz",
    "obscenity": "ɒbsɛnɪti",
    "obscure": "ɒbskjɔː",
    "obscured": "ɒbskjɔːd",
    "obscurely": "ɒbskjɔːli",
    "obscurer": "ɒbskjʊrɐ",
    "obscures": "ɒbskjɔːz",
    "obscurest": "ɒbskjʊrəst",
    "obscuring": "ɒbskjɔːrɪŋ",
    "obscurity": "ɒbskjʊrɪti",
    "obsequies": "ɒbsɛkwɪz",
    "obsequious": "ɒbsɛkwɪəs",
    "obsequiousness": "ɒbsɛkwɪəsnəs",
    "observable": "ɒbzɜːvəbəl",
    "observance": "ɒbzɜːvəns",
    "observances": "ɒbzɜːvənsɪz",
    "observant": "ɒbzɜːvənt",
    "observational": "ɒbzəveɪʃənəl",
    "observationally": "ɒbzəveɪʃənəli",
    "observation": "ɒbzəveɪʃən",
    "observations": "ɒbzəveɪʃənz",
    "observatories": "ɒbzɜːvətəriz",
    "observatory": "ɒbzɜːvətəri",
    "observe": "ɒbzɜːv",
    "observed": "ɒbzɜːvd",
    "observer": "ɒbzɜːvɐ",
    "observers": "ɒbzɜːvəz",
    "observes": "ɒbzɜːvz",
    "observing": "ɒbzɜːvɪŋ",
    "obsess": "ɒbsɛs",
    "obsessed": "ɒbsɛst",
    "obsesses": "ɒbsɛsɪz",
    "obsessing": "ɒbsɛsɪŋ",
    "obsessional": "ɒbsɛʃənəl",
    "obsession": "ɒbsɛʃən",
    "obsessions": "ɒbsɛʃənz",
    "obsessive": "ɒbsɛsɪv",
    "obsessively": "ɒbsɛsɪvli",
    "obsessiveness": "ɒbsɛsɪvnəs",
    "obsessives": "ɒbsɛsɪvz",
    "obsidian": "ɒbsɪdiən",
    "obsolescence": "ɒbsəlɛsəns",
    "obsolescent": "ɒbsəlɛsənt",
    "obsolete": "ɒbsəliːt",
    "obstacle": "ɒbstəkəl",
    "obstacles": "ɒbstəkəlz",
    "obstetric": "ɒbstɛtrɪk",
    "obstetrician": "ɒbstɪtrɪʃən",
    "obstetricians": "ɒbstɪtrɪʃənz",
    "obstetrics": "ɒbstɛtrɪks",
    "obstinacy": "ɒbstɪnəsi",
    "obstinate": "ɒbstɪneɪt",
    "obstinately": "ɒbstɪneɪtli",
    "obstreperous": "ɒbstrɛpərəs",
    "obstruct": "ɒbstrʌkt",
    "obstructed": "ɒbstrʌktɪd",
    "obstructing": "ɒbstrʌktɪŋ",
    "obstruction": "ɒbstrʌkʃən",
    "obstructionist": "ɒbstrʌkʃənɪst",
    "obstructions": "ɒbstrʌkʃənz",
    "obstructive": "ɒbstrʌktɪv",
    "obstructiveness": "ɒbstrʌktɪvnəs",
    "obstructs": "ɒbstrʌkts",
    "obtainable": "ɒbteɪnəbəl",
    "obtain": "ɒbteɪn",
    "obtained": "ɒbteɪnd",
    "obtaining": "ɒbteɪnɪŋ",
    "obtains": "ɒbteɪnz",
    "obtrusive": "ɒbtruːsɪv",
    "obtuse": "ɒbtjuːs",
    "obtusely": "ɒbtjuːsli",
    "obtuseness": "ɒbtjuːsnəs",
    "obverse": "ɒbvɜːs",
    "obviate": "ɒbvɪeɪt",
    "obvious": "ɒbvɪəs",
    "obviously": "ɒbvɪəsli",
    "ocarina": "ɒkɐriːnɐ",
    "occasional": "əkeɪʒənəl",
    "occasionally": "əkeɪʒənəli",
    "occasioned": "əkeɪʒənd",
    "occasion": "əkeɪʒən",
    "occasioning": "əkeɪʒənɪŋ",
    "occasions": "əkeɪʒənz",
    "occidental": "ɒksɪdɛntəl",
    "occipital": "ɒksɪpɪtəl",
    "occluded": "əkluːdɪd",
    "occlude": "əkluːd",
    "occluding": "əkluːdɪŋ",
    "occlusion": "əkluːʒən",
    "occlusions": "əkluːʒənz",
    "occlusive": "əkluːsɪv",
    "occultation": "ɒkəlteɪʃən",
    "occult": "əkʌlt",
    "occultist": "ɒkəltɪst",
    "occupancy": "ɒkjʊpənsi",
    "occupant": "ɒkjʊpənt",
    "occupants": "ɒkjʊpənts",
    "occupational": "ɒkjʊpeɪʃənəl",
    "occupation": "ɒkjʊpeɪʃən",
    "occupations": "ɒkjʊpeɪʃənz",
    "occupied": "ɒkjʊpaɪd",
    "occupier": "ɒkjuːpaɪɐ",
    "occupiers": "ɒkjuːpaɪəz",
    "occupies": "ɒkjʊpaɪz",
    "occupying": "ɒkjʊpaɪɪŋ",
    "occupy": "ɒkjʊpaɪ",
    "occur": "əkɜː",
    "occurred": "əkɜːd",
    "occurrence": "əkɜːrəns",
    "occurrences": "əkɜːrənsɪz",
    "occurring": "əkɜːrɪŋ",
    "occurs": "əkɜːz",
    "ocean": "əʊʃən",
    "oceanic": "əʊʃɪænɪk",
    "oceanographer": "əʊʃənɒɡrəfɐ",
    "oceanographers": "əʊʃənɒɡrəfəz",
    "oceanographic": "əʊʃənəɡræfɪk",
    "oceanography": "əʊʃənɒɡrəfi",
    "oceans": "əʊʃənz",
    "ocelot": "ɒsəlɒt",
    "ocelots": "ɒsəlɒts",
    "och": "ɒk",
    "ochlocracy": "ɒtʃlɒkrəsi",
    "ochre": "əʊkɐ",
    "ochres": "əʊkəz",
    "ochrey": "ɒkri",
    "ocker": "ɒkɐ",
    "ockers": "ɒkəz",
    "o'clock": "əklɒk",
    "octagonal": "ɒktæɡənəl",
    "octagon": "ɒktəɡən",
    "octagons": "ɒktəɡənz",
    "octahedron": "ɒktɐhiːdrən",
    "octal": "ɒktəl",
    "octane": "ɒkteɪn",
    "octant": "ɒktənt",
    "octave": "ɒktɪv",
    "octaves": "ɒktɪvz",
    "octet": "ɒktɛt",
    "octogenarian": "ɒktədʒəneəriən",
    "octogenarians": "ɒktədʒəneəriənz",
    "octopi": "ɒktəpi",
    "octopod": "ɒktəpɒd",
    "octopuses": "ɒktəpjuːsɪz",
    "octopus": "ɒktəpəs",
    "ocular": "ɒkjʊlɐ",
    "oculist": "ɒkjʊlɪst",
    "oculus": "ɒkjʊləs",
    "odalisque": "əʊdɐlɪsk",
    "od": "ɒd",
    "oddball": "ɒdbɔːl",
    "oddballs": "ɒdbɔːlz",
    "odd": "ɒd",
    "odder": "ɒdɐ",
    "oddest": "ɒdəst",
    "oddities": "ɒdɪtiz",
    "oddity": "ɒdɪti",
    "oddly": "ɒdli",
    "oddment": "ɒdmənt",
    "oddments": "ɒdmənts",
    "oddness": "ɒdnəs",
    "odds": "ɒdz",
    "ode": "əʊd",
    "odeon": "əʊdɪən",
    "odes": "əʊdz",
    "odious": "əʊdɪəs",
    "odium": "əʊdiəm",
    "odometer": "əʊdɒmɪtɐ",
    "odometers": "əʊdɒmɪtəz",
    "odontoid": "əʊdəntɔɪd",
    "odorous": "əʊdərəs",
    "odors": "əʊdəz",
    "odour": "əʊdɐ",
    "odourless": "əʊdələs",
    "odours": "əʊdəz",
    "odyssey": "ɒdɪsi",
    "odysseys": "ɒdɪsɪz",
    "o": "əʊ",
    "oecology": "əʊkɒlədʒi",
    "oedema": "iːdɪmɐ",
    "oedipal": "iːdɪpəl",
    "oenology": "əʊnɒlədʒi",
    "oenophile": "əʊnəfaɪl",
    "o'er": "ɔː",
    "oersted": "əʊəstɪd",
    "oestrogen": "iːstrədʒən",
    "oestrus": "iːstrəs",
    "oeuvre": "ɜːvrɐ",
    "offal": "ɒfəl",
    "offbeat": "ɒfbiːt",
    "offcuts": "ɒfkʌts",
    "offed": "ɒft",
    "offences": "əfɛnsɪz",
    "offended": "əfɛndɪd",
    "offend": "əfɛnd",
    "offender": "əfɛndɐ",
    "offenders": "əfɛndəz",
    "offending": "əfɛndɪŋ",
    "offends": "əfɛndz",
    "offensive": "əfɛnsɪv",
    "offensively": "əfɛnsɪvli",
    "offensiveness": "əfɛnsɪvnəs",
    "offensives": "əfɛnsɪvz",
    "offered": "ɒfəd",
    "offerer": "ɒfərɐ",
    "offer": "ɒfɐ",
    "offering": "ɒfərɪŋ",
    "offerings": "ɒfərɪŋz",
    "offeror": "ɒfərɐ",
    "offers": "ɒfəz",
    "offertory": "ɒfətəri",
    "off": "ɒf",
    "offhand": "ɒfhænd",
    "office": "ɒfɪs",
    "officer": "ɒfɪsɐ",
    "officers": "ɒfɪsəz",
    "offices": "ɒfɪsɪz",
    "officialdom": "əfɪʃəldəm",
    "official": "əfɪʃəl",
    "officially": "əfɪʃəli",
    "officials": "əfɪʃəlz",
    "officiated": "əfɪʃɪeɪtɪd",
    "officiate": "əfɪʃɪeɪt",
    "officiates": "əfɪʃɪeɪts",
    "officiating": "əfɪʃɪeɪtɪŋ",
    "officious": "əfɪʃəs",
    "officiously": "əfɪʃəsli",
    "offing": "ɒfɪŋ",
    "offish": "ɒfɪʃ",
    "offline": "ɒflaɪn",
    "offloaded": "ɒfləʊdɪd",
    "offload": "ɒfləʊd",
    "offloading": "ɒfləʊdɪŋ",
    "offloads": "ɒfləʊdz",
    "offscreen": "ɒfskriːn",
    "offset": "ɒfsɛt",
    "offsets": "ɒfsɛts",
    "offsetting": "ɒfsɪtɪŋ",
    "offs": "ɒfs",
    "offshoot": "ɒfʃuːt",
    "offshoots": "ɒfʃuːts",
    "offshore": "ɒfʃɔː",
    "offside": "ɒfsaɪd",
    "offsides": "ɒfsaɪdz",
    "offspring": "ɒfsprɪŋ",
    "offsprings": "ɒfsprɪŋz",
    "offstage": "ɒfsteɪdʒ",
    "oftener": "ɒfənɐ",
    "often": "ɒfən",
    "oftentimes": "ɒfɪntaɪmz",
    "oft": "ɒft",
    "of": "ɒv",
    "ogee": "əʊdʒiː",
    "ogham": "ɒɡəm",
    "ogival": "ɒdʒɪvəl",
    "ogive": "ɒɡɪv",
    "ogled": "ɒɡəld",
    "ogle": "ɒɡəl",
    "ogler": "ɒɡlɐ",
    "ogling": "ɒɡlɪŋ",
    "ogre": "əʊɡɐ",
    "ogres": "əʊɡəz",
    "oh": "əʊ",
    "ohm": "əʊəm",
    "ohms": "əʊəmz",
    "oho": "əʊhəʊ",
    "ohs": "əʊz",
    "oik": "ɔɪk",
    "oiks": "ɔɪks",
    "oilbird": "ɔɪlbɜːd",
    "oilbirds": "ɔɪlbɜːdz",
    "oilcloth": "ɔɪlklɒθ",
    "oiled": "ɔɪld",
    "oilers": "ɔɪləz",
    "oilfield": "ɔɪlfiːld",
    "oilfields": "ɔɪlfiːldz",
    "oilier": "ɔɪliɐ",
    "oiliness": "ɔɪlinəs",
    "oiling": "ɔɪlɪŋ",
    "oilman": "ɔɪlmən",
    "oilmen": "ɔɪlmɛn",
    "oil": "ɔɪl",
    "oilseed": "ɔɪlsiːd",
    "oilskin": "ɔɪlskɪn",
    "oilskins": "ɔɪlskɪnz",
    "oils": "ɔɪlz",
    "oily": "ɔɪli",
    "oinked": "ɔɪŋkt",
    "oinking": "ɔɪŋkɪŋ",
    "oink": "ɔɪŋk",
    "oinks": "ɔɪŋks",
    "ointment": "ɔɪntmənt",
    "ointments": "ɔɪntmənts",
    "oi": "ɔɪ",
    "oka": "əʊkɐ",
    "okapi": "ɒkɐpi",
    "okayed": "əʊkeɪd",
    "oke": "əʊk",
    "okra": "əʊkrɐ",
    "olde": "əʊld",
    "old": "əʊld",
    "olden": "əʊldən",
    "older": "əʊldɐ",
    "oldest": "əʊldəst",
    "oldie": "əʊldi",
    "oldies": "əʊldɪz",
    "oldish": "əʊldɪʃ",
    "oldness": "əʊldnəs",
    "oldster": "əʊldstɐ",
    "oldsters": "əʊldstəz",
    "oldy": "əʊldi",
    "oleander": "əʊlɪændɐ",
    "oleanders": "əʊlɪændəz",
    "oles": "əʊlz",
    "olfaction": "ɒlfækʃən",
    "olfactory": "ɒlfæktəri",
    "oligarchies": "ɒlɪɡɑːkɪz",
    "oligarch": "ɒlɪɡɑːk",
    "oligarchs": "ɒlɪɡɑːkz",
    "oligarchy": "ɒlɪɡɑːki",
    "oligopoly": "ɒlɪɡɒpəli",
    "olio": "əʊlɪəʊ",
    "olive": "ɒlɪv",
    "olives": "ɒlɪvz",
    "olivine": "ɒlɪvaɪn",
    "olla": "ɒlɐ",
    "ologies": "ɒlədʒɪz",
    "ology": "ɒlədʒi",
    "oloroso": "ɒlɔːrəʊsəʊ",
    "ombudsman": "ɒmbʌdzmən",
    "ombudsmen": "ɒmbədzmɛn",
    "omega": "əʊmeɪɡɐ",
    "omegas": "əʊmeɪɡəz",
    "omelette": "ɒmlət",
    "omelettes": "ɒmləts",
    "omen": "əʊmɛn",
    "omens": "əʊmɛnz",
    "omentum": "əʊmɛntəm",
    "omer": "əʊmɐ",
    "omicron": "əʊmɪkrɒn",
    "ominously": "ɒmɪnəsli",
    "ominous": "ɒmɪnəs",
    "omission": "əʊmɪʃən",
    "omissions": "əʊmɪʃənz",
    "omit": "əʊmɪt",
    "omits": "əʊmɪts",
    "omitted": "əʊmɪtɪd",
    "omitting": "əʊmɪtɪŋ",
    "om": "ɒm",
    "omnibuses": "ɒmnɪbjuːsɪz",
    "omnibus": "ɒmnɪbəs",
    "omnipotence": "ɒmnɪpəʊtəns",
    "omnipotent": "ɒmnɪpəʊtənt",
    "omnipresence": "ɒmnɪprɛzəns",
    "omnipresent": "ɒmnɪprɛzənt",
    "omniscience": "ɒmnɪsɪəns",
    "omniscient": "ɒmnɪsiənt",
    "omnivore": "ɒmnɪvɔː",
    "omnivores": "ɒmnɪvɔːz",
    "omnivorous": "ɒmnɪvərəs",
    "omphalos": "ɒmfələʊz",
    "oms": "ɒmz",
    "onager": "ɒnɪdʒɐ",
    "once": "wɒns",
    "oncologist": "ɒnkɒlədʒɪst",
    "oncologists": "ɒnkɒlədʒɪsts",
    "oncology": "ɒnkɒlədʒi",
    "oncoming": "ɒnkʌmɪŋ",
    "oneness": "wɒnnəs",
    "onerous": "əʊnərəs",
    "onerously": "əʊnərəsli",
    "oneself": "wɒnsɛlf",
    "ones": "wɒnz",
    "one": "wɒn",
    "ongoing": "ɒŋɡəʊɪŋ",
    "onion": "ʌniən",
    "onions": "ʌniənz",
    "online": "ɒnlaɪn",
    "onlooker": "ɒnlʊkɐ",
    "onlookers": "ɒnlʊkəz",
    "only": "əʊnli",
    "on": "ɒn",
    "onomatopoeia": "ɒnəmætəpəʊiə",
    "onomatopoeic": "ɒnəmætəpəʊɪk",
    "onscreen": "ɒnskriːn",
    "onset": "ɒnsɛt",
    "onshore": "ɒnʃɔː",
    "onside": "ɒnsaɪd",
    "onslaught": "ɒnslɔːt",
    "onslaughts": "ɒnslɔːts",
    "onstage": "ɒnsteɪdʒ",
    "ontological": "ɒntəlɒdʒɪkəl",
    "ontology": "ɒntɒlədʒi",
    "onto": "ɒntʊ",
    "onus": "əʊnəs",
    "onward": "ɒnwəd",
    "onwards": "ɒnwədz",
    "onyx": "ɒnɪks",
    "oocyte": "uːsaɪt",
    "oodles": "uːdəlz",
    "oof": "uːf",
    "oohed": "uːd",
    "oohing": "uːɪŋ",
    "oohs": "uːz",
    "ooh": "uː",
    "oolite": "uːlaɪt",
    "oolitic": "uːlɪtɪk",
    "oology": "uːlədʒi",
    "oomph": "uːmf",
    "oophorectomy": "uːfɔːktəmi",
    "oops": "uːps",
    "oo": "uː",
    "oozed": "uːzd",
    "oozes": "uːzɪz",
    "ooze": "uːz",
    "ooziness": "uːzɪnəs",
    "oozing": "uːzɪŋ",
    "oozy": "uːzi",
    "opacity": "ɒpæsɪti",
    "opal": "əʊpəl",
    "opalescence": "əʊpəlɛsəns",
    "opalescent": "əʊpəlɛsənt",
    "opaline": "əʊpəlaɪn",
    "opals": "əʊpəlz",
    "opaque": "əʊpeɪk",
    "opaqueness": "əʊpeɪknəs",
    "oped": "ɒpɛd",
    "ope": "əʊp",
    "opencast": "əʊpənkɑːst",
    "opened": "əʊpənd",
    "open": "əʊpən",
    "opener": "əʊpənɐ",
    "openers": "əʊpənəz",
    "opening": "əʊpənɪŋ",
    "openings": "əʊpənɪŋz",
    "openly": "əʊpənli",
    "openness": "əʊpənnəs",
    "opens": "əʊpənz",
    "openwork": "əʊpənwɜːk",
    "operability": "ɒpərəbɪlɪti",
    "operable": "ɒpərəbəl",
    "operant": "ɒpərənt",
    "opera": "ɒpərɐ",
    "operas": "ɒpərəz",
    "operated": "ɒpəreɪtɪd",
    "operate": "ɒpəreɪt",
    "operates": "ɒpəreɪts",
    "operatic": "ɒpərætɪk",
    "operating": "ɒpəreɪtɪŋ",
    "operationally": "ɒpəreɪʃənəli",
    "operational": "ɒpəreɪʃənəl",
    "operation": "ɒpəreɪʃən",
    "operations": "ɒpəreɪʃənz",
    "operatively": "ɒpərətɪvli",
    "operative": "ɒpərətɪv",
    "operatives": "ɒpərətɪvz",
    "operator": "ɒpəreɪtɐ",
    "operators": "ɒpəreɪtəz",
    "operculum": "ɒpəkjʊləm",
    "operetta": "ɒpərɛtɐ",
    "operettas": "ɒpərɛtəz",
    "opes": "əʊps",
    "ophidian": "ɒfɪdiən",
    "ophthalmia": "ɒfθælmiə",
    "ophthalmic": "ɒfθælmɪk",
    "ophthalmologist": "ɒfθɐlmɒlədʒɪst",
    "ophthalmologists": "ɒfθɐlmɒlədʒɪsts",
    "ophthalmology": "ɒfθɐlmɒlədʒi",
    "ophthalmoscope": "ɒfθɐlmɒskəʊp",
    "opiates": "əʊpɪeɪts",
    "opine": "əʊpaɪn",
    "oping": "əʊpɪŋ",
    "opining": "əʊpaɪnɪŋ",
    "opinionated": "əpɪniəneɪtɪd",
    "opinion": "əpɪniən",
    "opinions": "əpɪniənz",
    "opioid": "əʊpɪɔɪd",
    "opium": "əʊpiəm",
    "opossum": "əpɒsəm",
    "opossums": "əpɒsəmz",
    "opponent": "əpəʊnənt",
    "opponents": "əpəʊnənts",
    "opportune": "ɒpətjuːn",
    "opportunism": "ɒpətjuːnɪzəm",
    "opportunistically": "ɒpətjuːnɪstɪkli",
    "opportunistic": "ɒpətjuːnɪstɪk",
    "opportunist": "ɒpətjuːnɪst",
    "opportunists": "ɒpətjuːnɪsts",
    "opportunities": "ɒpətjuːnɪtiz",
    "opportunity": "ɒpətjuːnɪti",
    "opposable": "əpəʊzəbəl",
    "opposed": "əpəʊzd",
    "oppose": "əpəʊz",
    "opposes": "əpəʊzɪz",
    "opposing": "əpəʊzɪŋ",
    "opposite": "ɒpəsɪt",
    "opposites": "ɒpəsɪts",
    "oppositional": "ɒpəzɪʃənəl",
    "opposition": "ɒpəzɪʃən",
    "oppositions": "ɒpəzɪʃənz",
    "oppressed": "əprɛst",
    "oppress": "əprɛs",
    "oppresses": "əprɛsɪz",
    "oppressing": "əprɛsɪŋ",
    "oppression": "əprɛʃən",
    "oppressions": "əprɛʃənz",
    "oppressive": "əprɛsɪv",
    "oppressively": "əprɛsɪvli",
    "oppressor": "əprɛsɐ",
    "oppressors": "əprɛsəz",
    "opprobrious": "ɒprɒbrɪəs",
    "opprobrium": "ɒprɒbriəm",
    "ops": "ɒps",
    "opted": "ɒptɪd",
    "optically": "ɒptɪkli",
    "optical": "ɒptɪkəl",
    "optician": "ɒptɪʃən",
    "opticians": "ɒptɪʃənz",
    "optic": "ɒptɪk",
    "optics": "ɒptɪks",
    "optimally": "ɒptɪməli",
    "optimal": "ɒptɪməl",
    "optima": "ɒptɪmɐ",
    "optime": "ɒptaɪm",
    "optimisation": "ɒptɪmaɪzeɪʃən",
    "optimised": "ɒptɪmaɪzd",
    "optimise": "ɒptɪmaɪz",
    "optimiser": "ɒptɪmaɪzɐ",
    "optimising": "ɒptɪmaɪzɪŋ",
    "optimism": "ɒptɪmɪzəm",
    "optimistically": "ɒptɪmɪstɪkli",
    "optimistic": "ɒptɪmɪstɪk",
    "optimist": "ɒptɪmɪst",
    "optimists": "ɒptɪmɪsts",
    "optimum": "ɒptɪməm",
    "opting": "ɒptɪŋ",
    "optionally": "ɒpʃənəli",
    "optional": "ɒpʃənəl",
    "optioned": "ɒpʃənd",
    "option": "ɒpʃən",
    "options": "ɒpʃənz",
    "optometrist": "ɒptəʊmɛtrɪst",
    "optometrists": "ɒptəʊmɛtrɪsts",
    "optometry": "ɒptəʊmətri",
    "opt": "ɒpt",
    "opts": "ɒpts",
    "opulence": "ɒpjʊləns",
    "opulently": "ɒpjʊləntli",
    "opulent": "ɒpjʊlənt",
    "opus": "ɒpəs",
    "oracle": "ɒrəkəl",
    "oracles": "ɒrəkəlz",
    "orally": "ɔːrəli",
    "oral": "ɔːrəl",
    "orangeade": "ɔːreɪndʒiːd",
    "orange": "ɒrɪndʒ",
    "orangery": "ɔːreɪndʒəri",
    "oranges": "ɒrɪndʒɪz",
    "orang": "ɔːræŋ",
    "orangs": "ɔːræŋz",
    "orangutan": "ɔːrɐŋɡjuːtən",
    "orangutans": "ɔːrɐŋɡjuːtənz",
    "ora": "ɔːrɐ",
    "orate": "ɔːreɪt",
    "oration": "ɔːreɪʃən",
    "orations": "ɔːreɪʃənz",
    "orator": "ɒrətɐ",
    "oratorical": "ɒrətɒrɪkəl",
    "oratorio": "ɒrətɔːrɪəʊ",
    "oratorios": "ɒrətɔːrɪəʊz",
    "orators": "ɒrətəz",
    "oratory": "ɒrətəri",
    "orbital": "ɔːbɪtəl",
    "orbitals": "ɔːbɪtəlz",
    "orbited": "ɔːbɪtɪd",
    "orbiter": "ɔːbɪtɐ",
    "orbiters": "ɔːbɪtəz",
    "orbiting": "ɔːbɪtɪŋ",
    "orbit": "ɔːbɪt",
    "orbits": "ɔːbɪts",
    "orb": "ɔːb",
    "orbs": "ɔːbz",
    "orca": "ɔːkɐ",
    "orcas": "ɔːkəz",
    "orchard": "ɔːtʃəd",
    "orchards": "ɔːtʃədz",
    "orchestral": "ɔːkɛstrəl",
    "orchestra": "ɔːkɛstrɐ",
    "orchestras": "ɔːkɛstrəz",
    "orchestrated": "ɔːkɪstreɪtɪd",
    "orchestrate": "ɔːkɪstreɪt",
    "orchestrates": "ɔːkɪstreɪts",
    "orchestrating": "ɔːkɪstreɪtɪŋ",
    "orchestration": "ɔːkɪstreɪʃən",
    "orchestrations": "ɔːkɪstreɪʃənz",
    "orchestrator": "ɔːkɪstreɪtɐ",
    "orchestrators": "ɔːkɪstreɪtəz",
    "orchidectomy": "ɔːkɪdɛktəmi",
    "orchid": "ɔːkɪd",
    "orchids": "ɔːkɪdz",
    "orchitis": "ɔːkaɪtɪs",
    "ordained": "ɔːdeɪnd",
    "ordaining": "ɔːdeɪnɪŋ",
    "ordain": "ɔːdeɪn",
    "ordains": "ɔːdeɪnz",
    "ordeal": "ɔːdiəl",
    "ordeals": "ɔːdiəlz",
    "ordered": "ɔːdəd",
    "orderer": "ɔːdərɐ",
    "ordering": "ɔːdərɪŋ",
    "orderlies": "ɔːdəliz",
    "orderliness": "ɔːdəlinəs",
    "orderly": "ɔːdəli",
    "order": "ɔːdɐ",
    "orders": "ɔːdəz",
    "ordinal": "ɔːdɪnəl",
    "ordinance": "ɔːdɪnəns",
    "ordinances": "ɔːdɪnənsɪz",
    "ordinaries": "ɔːdɪnəriz",
    "ordinarily": "ɔːdɪnɛrəli",
    "ordinariness": "ɔːdɪnərinəs",
    "ordinary": "ɔːdɪnəri",
    "ordinate": "ɔːdɪnət",
    "ordinates": "ɔːdɪnəts",
    "ordination": "ɔːdɪneɪʃən",
    "ordinations": "ɔːdɪneɪʃənz",
    "ordnance": "ɔːdnəns",
    "ordure": "ɔːdjɔː",
    "oregano": "ɒrɪɡɑːnəʊ",
    "ore": "ɔː",
    "ores": "ɔːz",
    "organdie": "ɔːɡændi",
    "organelle": "ɔːɡənɛl",
    "organelles": "ɔːɡənɛlz",
    "organically": "ɔːɡænɪkli",
    "organic": "ɔːɡænɪk",
    "organics": "ɔːɡænɪks",
    "organisationally": "ɔːɡɐnaɪzeɪʃənəli",
    "organisational": "ɔːɡɐnaɪzeɪʃənəl",
    "organisation": "ɔːɡɐnaɪzeɪʃən",
    "organisations": "ɔːɡɐnaɪzeɪʃənz",
    "organised": "ɔːɡɐnaɪzd",
    "organise": "ɔːɡɐnaɪz",
    "organiser": "ɔːɡɐnaɪzɐ",
    "organisers": "ɔːɡɐnaɪzəz",
    "organises": "ɔːɡɐnaɪzɪz",
    "organising": "ɔːɡɐnaɪzɪŋ",
    "organism": "ɔːɡənɪzəm",
    "organisms": "ɔːɡɐnɪzəmz",
    "organist": "ɔːɡɐnɪst",
    "organists": "ɔːɡɐnɪsts",
    "organ": "ɔːɡən",
    "organs": "ɔːɡənz",
    "organza": "ɔːɡænzɐ",
    "orgasmically": "ɔːɡæzmɪkli",
    "orgasmic": "ɔːɡæzmɪk",
    "orgasm": "ɔːɡæzəm",
    "orgasms": "ɔːɡæzəmz",
    "orgiastic": "ɔːdʒɪæstɪk",
    "orgies": "ɔːdʒɪz",
    "orgy": "ɔːdʒi",
    "oriel": "ɔːriːəl",
    "oriels": "ɔːriːəlz",
    "orientalised": "ɔːrɪɛntəlaɪzd",
    "orientalist": "ɔːrɪɛntəlɪst",
    "orientalists": "ɔːrɪɛntəlɪsts",
    "oriental": "ɔːrɪɛntəl",
    "orientals": "ɔːrɪɛntəlz",
    "orientated": "ɔːriənteɪtɪd",
    "orientate": "ɔːriənteɪt",
    "orientates": "ɔːriənteɪts",
    "orientating": "ɔːriənteɪtɪŋ",
    "orientation": "ɔːriənteɪʃən",
    "orientations": "ɔːriənteɪʃənz",
    "oriented": "ɔːriəntɪd",
    "orienteering": "ɔːriəntiərɪŋ",
    "orienteer": "ɔːriəntiə",
    "orienting": "ɔːriəntɪŋ",
    "orient": "ɔːriənt",
    "orients": "ɔːriənts",
    "orifice": "ɒrɪfɪs",
    "orifices": "ɒrɪfɪsɪz",
    "oriflamme": "ɒraɪflæm",
    "origami": "ɒrɪɡɑːmi",
    "original": "ərɪdʒɪnəl",
    "originality": "ərɪdʒɪnælɪti",
    "originally": "ərɪdʒɪnəli",
    "originals": "ərɪdʒɪnəlz",
    "originated": "ərɪdʒɪneɪtɪd",
    "originate": "ərɪdʒɪneɪt",
    "originates": "ərɪdʒɪneɪts",
    "originating": "ərɪdʒɪneɪtɪŋ",
    "origination": "ərɪdʒɪneɪʃən",
    "originator": "ərɪdʒɪneɪtɐ",
    "originators": "ərɪdʒɪneɪtəz",
    "origin": "ɒrɪdʒɪn",
    "origins": "ɒrɪdʒɪnz",
    "oriole": "ɔːrɪəʊl",
    "orioles": "ɔːrɪəʊlz",
    "orisons": "ɒrɪsənz",
    "orlop": "ɔːləp",
    "ormolu": "ɔːməluː",
    "ornamentally": "ɔːnəmɛntəli",
    "ornamental": "ɔːnəmɛntəl",
    "ornamentation": "ɔːnəmɛnteɪʃən",
    "ornamented": "ɔːnəməntɪd",
    "ornamenting": "ɔːnəməntɪŋ",
    "ornately": "ɔːneɪtli",
    "ornate": "ɔːneɪt",
    "ornery": "ɔːnəri",
    "ornithological": "ɔːnɪθəlɒdʒɪkəl",
    "ornithologist": "ɔːnɪθɒlədʒɪst",
    "ornithologists": "ɔːnɪθɒlədʒɪsts",
    "ornithology": "ɔːnɪθɒlədʒi",
    "ornithopter": "ɔːnɪθɒptɐ",
    "or": "ɔː",
    "orogeny": "ɔːrɒdʒəni",
    "orographic": "ɔːrəɡræfɪk",
    "orotund": "ɔːrətʌnd",
    "orphanage": "ɔːfənɪdʒ",
    "orphanages": "ɔːfənɪdʒɪz",
    "orphaned": "ɔːfənd",
    "orphan": "ɔːfən",
    "orphans": "ɔːfənz",
    "orpiment": "ɔːpɪmənt",
    "orrery": "ɒrəri",
    "orris": "ɒrɪs",
    "orthodontic": "ɔːθədɒntɪk",
    "orthodontics": "ɔːθədɒntɪks",
    "orthodontist": "ɔːθədɒntɪst",
    "orthodontists": "ɔːθədɒntɪsts",
    "orthodoxies": "ɔːθədɒksɪz",
    "orthodox": "ɔːθədɒks",
    "orthodoxy": "ɔːθədɒksi",
    "orthographic": "ɔːθəɡræfɪk",
    "orthopaedic": "ɔːθəpiːdɪk",
    "orthopaedics": "ɔːθəpiːdɪks",
    "orthopedic": "ɔːθəʊpiːdɪk",
    "orthopedics": "ɔːθəʊpiːdɪks",
    "orthotics": "ɔːθɒtɪks",
    "ortolan": "ɔːtəlæn",
    "ort": "ɔːt",
    "orts": "ɔːts",
    "oryx": "ɒrɪks",
    "orzo": "ɔːzəʊ",
    "oscillated": "ɒsɪleɪtɪd",
    "oscillate": "ɒsɪleɪt",
    "oscillates": "ɒsɪleɪts",
    "oscillating": "ɒsɪleɪtɪŋ",
    "oscillation": "ɒsɪleɪʃən",
    "oscillations": "ɒsɪleɪʃənz",
    "oscillator": "ɒsɪleɪtɐ",
    "oscillators": "ɒsɪleɪtəz",
    "oscillatory": "ɒsɪlətəri",
    "oscilloscope": "ɒsɪləskəʊp",
    "osculation": "ɒskjʊleɪʃən",
    "osculum": "ɒskjʊləm",
    "osier": "əʊzɪɐ",
    "osmium": "ɒzmiəm",
    "osmosis": "ɒzməʊsɪs",
    "osmotic": "ɒzmɒtɪk",
    "osprey": "ɒspri",
    "ospreys": "ɒsprɪz",
    "osseous": "ɒsiəs",
    "ossicle": "ɒsɪkəl",
    "ossicles": "ɒsɪkəlz",
    "ossification": "ɒsɪfɪkeɪʃən",
    "ossified": "ɒsɪfaɪd",
    "ossify": "ɒsɪfaɪ",
    "ossuary": "ɒsjuːəri",
    "ostensible": "ɒstɛnsəbəl",
    "ostensibly": "ɒstɛnsəbli",
    "ostentation": "ɒstənteɪʃən",
    "ostentatiously": "ɒstənteɪʃəsli",
    "ostentatious": "ɒstənteɪʃəs",
    "osteoarthritis": "ɒstɪɔːθraɪtɪs",
    "osteoblasts": "ɒstɪɒblɑːsts",
    "osteogenesis": "ɒstɪəʊdʒɛnɪsɪs",
    "osteology": "ɒstɪɒlədʒi",
    "osteomyelitis": "ɒstɪɒmɪɪlaɪtɪs",
    "osteopathic": "ɒstɪəpæθɪk",
    "osteopaths": "ɒstɪɒpɑːθs",
    "osteopath": "ɒstɪɒpɑːθ",
    "osteopathy": "ɒstɪɒpəθi",
    "osteoporosis": "ɒstɪɒpɔːrəʊsɪs",
    "osteotomy": "ɒstɪɒtəmi",
    "ostium": "ɒstiəm",
    "ostler": "ɒslɐ",
    "ostracised": "ɒstrɐsaɪzd",
    "ostracise": "ɒstrɐsaɪz",
    "ostracising": "ɒstrɐsaɪzɪŋ",
    "ostracism": "ɒstrɐsɪzəm",
    "ostriches": "ɒstrɪtʃɪz",
    "ostrich": "ɒstrɪtʃ",
    "other": "ʌðɐ",
    "otherness": "ʌðənəs",
    "others": "ʌðəz",
    "otherwise": "ʌðəwaɪz",
    "otherworld": "ʌðəwɜːld",
    "otherworldliness": "ʌðəwɜːldlinəs",
    "otherworldly": "ʌðəwɜːldli",
    "otic": "ɒtɪk",
    "otolith": "ɒtəlɪθ",
    "otoscope": "ɒtəskəʊp",
    "ottava": "ɒtɑːvɐ",
    "otters": "ɒtəz",
    "otter": "ɒtɐ",
    "ottomans": "ɒtəmənz",
    "ottoman": "ɒtəmən",
    "otto": "ɒtəʊ",
    "oubliette": "aʊblɪɛt",
    "ouch": "aʊtʃ",
    "oud": "aʊd",
    "ought": "ɔːt",
    "oui": "wiː",
    "ounce": "aʊns",
    "ounces": "aʊnsɪz",
    "our": "aʊə",
    "ours": "aʊəz",
    "ourself": "aʊəsɛlf",
    "ourselves": "aʊəsɛlvz",
    "oust": "aʊst",
    "ousted": "aʊstɪd",
    "ouster": "aʊstɐ",
    "ousting": "aʊstɪŋ",
    "ousts": "aʊsts",
    "outage": "aʊtɪdʒ",
    "outages": "aʊtɪdʒɪz",
    "out": "aʊt",
    "outback": "aʊtbæk",
    "outbacks": "aʊtbæks",
    "outbid": "aʊtbɪd",
    "outbidding": "aʊtbɪdɪŋ",
    "outboard": "aʊtbɔːd",
    "outbound": "aʊtbaʊnd",
    "outbreak": "aʊtbreɪk",
    "outbreaks": "aʊtbreɪks",
    "outbuilding": "aʊtbɪldɪŋ",
    "outbuildings": "aʊtbɪldɪŋz",
    "outburst": "aʊtbɜːst",
    "outbursts": "aʊtbɜːsts",
    "outcast": "aʊtkɑːst",
    "outcasts": "aʊtkɑːsts",
    "outclass": "aʊtklɑːs",
    "outclassed": "aʊtklɑːst",
    "outclasses": "aʊtklɑːsɪz",
    "outclassing": "aʊtklɑːsɪŋ",
    "outcome": "aʊtkʌm",
    "outcomes": "aʊtkʌmz",
    "outcries": "aʊtkraɪz",
    "outcrop": "aʊtkrɒp",
    "outcropping": "aʊtkrɒpɪŋ",
    "outcroppings": "aʊtkrɒpɪŋz",
    "outcrops": "aʊtkrɒps",
    "outdated": "aʊtdeɪtɪd",
    "outdid": "aʊtdɪd",
    "outdo": "aʊtduː",
    "outdoes": "aʊtdʌz",
    "outdoing": "aʊtduːɪŋ",
    "outdone": "aʊtdʌn",
    "outdoor": "aʊtdɔː",
    "outdoors": "aʊtdɔːz",
    "outdoorsy": "aʊtdɔːsi",
    "outdrew": "aʊtdruː",
    "outed": "aʊtɪd",
    "outer": "aʊtɐ",
    "outermost": "aʊtəməʊst",
    "outerwear": "aʊtɜːweə",
    "outface": "aʊtfeɪs",
    "outfaced": "aʊtfeɪsd",
    "outfall": "aʊtfɔːl",
    "outfalls": "aʊtfɔːlz",
    "outfield": "aʊtfiːld",
    "outfielder": "aʊtfiːldɐ",
    "outfight": "aʊtfaɪt",
    "outfit": "aʊtfɪt",
    "outfits": "aʊtfɪts",
    "outfitted": "aʊtfɪtɪd",
    "outfitter": "aʊtfɪtɐ",
    "outfitters": "aʊtfɪtəz",
    "outfitting": "aʊtfɪtɪŋ",
    "outflank": "aʊtflæŋk",
    "outflanked": "aʊtflæŋkt",
    "outflanking": "aʊtflæŋkɪŋ",
    "outflow": "aʊtfləʊ",
    "outflows": "aʊtfləʊz",
    "outfought": "aʊtfɔːt",
    "outfox": "aʊtfɒks",
    "outfoxed": "aʊtfɒkst",
    "outgoing": "aʊtɡəʊɪŋ",
    "outgoings": "aʊtɡəʊɪŋz",
    "outgrew": "aʊtɡruː",
    "outgrow": "aʊtɡrəʊ",
    "outgrowing": "aʊtɡrəʊɪŋ",
    "outgrown": "aʊtɡrəʊn",
    "outgrows": "aʊtɡrəʊz",
    "outgrowth": "aʊtɡrəʊθ",
    "outgrowths": "aʊtɡrəʊθs",
    "outguess": "aʊtɡɛs",
    "outgun": "aʊtɡʌn",
    "outgunned": "aʊtɡʌnd",
    "outhouse": "aʊthaʊs",
    "outhouses": "aʊthaʊzɪz",
    "outing": "aʊtɪŋ",
    "outings": "aʊtɪŋz",
    "outlaid": "aʊtleɪd",
    "outland": "aʊtlænd",
    "outlandish": "aʊtlændɪʃ",
    "outlandishly": "aʊtlændɪʃli",
    "outlands": "aʊtlændz",
    "outlast": "aʊtlɑːst",
    "outlasted": "aʊtlɑːstɪd",
    "outlaw": "aʊtlɔː",
    "outlawed": "aʊtlɔːd",
    "outlawing": "aʊtlɔːrɪŋ",
    "outlaws": "aʊtlɔːz",
    "outlay": "aʊtleɪ",
    "outlays": "aʊtleɪz",
    "outlet": "aʊtlɛt",
    "outlets": "aʊtlɛts",
    "outlier": "aʊtlaɪə",
    "outliers": "aʊtlaɪəz",
    "outline": "aʊtlaɪn",
    "outlined": "aʊtlaɪnd",
    "outlines": "aʊtlaɪnz",
    "outlining": "aʊtlaɪnɪŋ",
    "outlive": "aʊtlɪv",
    "outlived": "aʊtlɪvd",
    "outlives": "aʊtlɪvz",
    "outliving": "aʊtlɪvɪŋ",
    "outlook": "aʊtlʊk",
    "outlooks": "aʊtlʊks",
    "outlying": "aʊtlaɪɪŋ",
    "outmanoeuvre": "aʊtmənuːvɐ",
    "outmanoeuvred": "aʊtmənuːvrəd",
    "outmanoeuvres": "aʊtmənuːvəz",
    "outmatch": "aʊtmætʃ",
    "outmatched": "aʊtmætʃt",
    "outmoded": "aʊtməʊdɪd",
    "outnumber": "aʊtnʌmbɐ",
    "outnumbered": "aʊtnʌmbəd",
    "outnumbering": "aʊtnʌmbərɪŋ",
    "outnumbers": "aʊtnʌmbəz",
    "outpace": "aʊtpeɪs",
    "outpaced": "aʊtpeɪst",
    "outpaces": "aʊtpeɪsɪz",
    "outpacing": "aʊtpeɪsɪŋ",
    "outpatient": "aʊtpeɪʃənt",
    "outpatients": "aʊtpeɪʃənts",
    "outperform": "aʊtpəfɔːm",
    "outperformed": "aʊtpəfɔːmd",
    "outperforming": "aʊtpəfɔːmɪŋ",
    "outperforms": "aʊtpəfɔːmz",
    "outplay": "aʊtpleɪ",
    "outplayed": "aʊtpleɪd",
    "outplaying": "aʊtpleɪɪŋ",
    "outpointing": "aʊtpɔɪntɪŋ",
    "outpost": "aʊtpəʊst",
    "outposts": "aʊtpəʊsts",
    "outpouring": "aʊtpɔːrɪŋ",
    "outpourings": "aʊtpɔːrɪŋz",
    "output": "aʊtpʊt",
    "outputs": "aʊtpʊts",
    "outrace": "aʊtreɪs",
    "outrage": "aʊtreɪdʒ",
    "outraged": "aʊtreɪdʒd",
    "outrageous": "aʊtreɪdʒəs",
    "outrageously": "aʊtreɪdʒəsli",
    "outrageousness": "aʊtreɪdʒəsnəs",
    "outrages": "aʊtreɪdʒɪz",
    "outraging": "aʊtreɪdʒɪŋ",
    "outran": "aʊtræn",
    "outrange": "aʊtreɪndʒ",
    "outrank": "aʊtræŋk",
    "outranked": "aʊtræŋkt",
    "outranks": "aʊtræŋks",
    "outreaches": "aʊtriːtʃɪz",
    "outrider": "aʊtraɪdɐ",
    "outriders": "aʊtraɪdəz",
    "outrigger": "aʊtrɪɡɐ",
    "outroar": "aʊtrɔː",
    "outrun": "aʊtrʌn",
    "outrunning": "aʊtrʌnɪŋ",
    "outruns": "aʊtrʌnz",
    "outs": "aʊts",
    "outscore": "aʊtskɔː",
    "outscored": "aʊtskɔːd",
    "outscoring": "aʊtskɔːrɪŋ",
    "outsell": "aʊtsɛl",
    "outselling": "aʊtsɛlɪŋ",
    "outsells": "aʊtsɛlz",
    "outset": "aʊtsɛt",
    "outshine": "aʊtʃaɪn",
    "outshined": "aʊtʃaɪnd",
    "outshines": "aʊtʃaɪnz",
    "outshining": "aʊtʃaɪnɪŋ",
    "outshone": "aʊtʃɒn",
    "outsider": "aʊtsaɪdɐ",
    "outsiders": "aʊtsaɪdəz",
    "outsides": "aʊtsaɪdz",
    "outsize": "aʊtsaɪz",
    "outsized": "aʊtsaɪzd",
    "outskirt": "aʊtskɜːt",
    "outskirts": "aʊtskɜːts",
    "outsmart": "aʊtsmɑːt",
    "outsmarted": "aʊtsmɑːtɪd",
    "outsmarting": "aʊtsmɑːtɪŋ",
    "outsmarts": "aʊtsmɑːts",
    "outsold": "aʊtsəʊld",
    "outsoles": "aʊtsəʊlz",
    "outsource": "aʊtsɔːs",
    "outsourced": "aʊtsɔːsd",
    "outsources": "aʊtsɔːsɪz",
    "outsourcing": "aʊtsɔːsɪŋ",
    "outspan": "aʊtspæn",
    "outspend": "aʊtspɛnd",
    "outspending": "aʊtspɛndɪŋ",
    "outspent": "aʊtspɛnt",
    "outspoken": "aʊtspəʊkən",
    "outspokenly": "aʊtspəʊkənli",
    "outspokenness": "aʊtspəʊkənnəs",
    "outspread": "aʊtsprɛd",
    "outstanding": "aʊtstændɪŋ",
    "outstandingly": "aʊtstændɪŋli",
    "outstare": "aʊtsteə",
    "outstation": "aʊtsteɪʃən",
    "outstay": "aʊtsteɪ",
    "outstayed": "aʊtsteɪd",
    "outstaying": "aʊtsteɪɪŋ",
    "outstays": "aʊtsteɪz",
    "outstretch": "aʊtstrɛtʃ",
    "outstretched": "aʊtstrɛtʃt",
    "outstrip": "aʊtstrɪp",
    "outstripped": "aʊtstrɪpt",
    "outstripping": "aʊtstrɪpɪŋ",
    "outstrips": "aʊtstrɪps",
    "outta": "aʊttɑː",
    "outtake": "aʊtteɪk",
    "outtakes": "aʊtteɪks",
    "outthink": "aʊtθɪŋk",
    "outturn": "aʊttɜːn",
    "outvote": "aʊtvəʊt",
    "outvoted": "aʊtvəʊtɪd",
    "outward": "aʊtwəd",
    "outwardly": "aʊtwədli",
    "outwards": "aʊtwədz",
    "outweigh": "aʊtweɪ",
    "outweighed": "aʊtweɪd",
    "outweighing": "aʊtweɪɪŋ",
    "outweighs": "aʊtweɪz",
    "outwit": "aʊtwɪt",
    "outwith": "aʊtwɪð",
    "outwits": "aʊtwɪts",
    "outwitted": "aʊtwɪtɪd",
    "outwitting": "aʊtwɪtɪŋ",
    "outworked": "aʊtwɜːkt",
    "outworking": "aʊtwɜːkɪŋ",
    "outworn": "aʊtwɔːn",
    "ouzels": "uːzəlz",
    "ouzel": "uːzəl",
    "ouzo": "uːzəʊ",
    "ova": "əʊvɐ",
    "oval": "əʊvəl",
    "ovals": "əʊvəlz",
    "ovarian": "əʊveəriən",
    "ovaries": "əʊvəriz",
    "ovary": "əʊvəri",
    "ovate": "əʊveɪt",
    "ovation": "əʊveɪʃən",
    "ovations": "əʊveɪʃənz",
    "ovenproof": "ʌvənpruːf",
    "ovens": "ʌvənz",
    "oven": "ʌvən",
    "overabundance": "əʊvərɐbʌndəns",
    "overachieved": "əʊvərɐtʃiːvd",
    "overachiever": "əʊvərɐtʃiːvɐ",
    "overachievers": "əʊvərɐtʃiːvəz",
    "overachieving": "əʊvərɐtʃiːvɪŋ",
    "overacted": "əʊvəræktɪd",
    "overact": "əʊvərækt",
    "overacting": "əʊvəræktɪŋ",
    "overactive": "əʊvəræktɪv",
    "overalls": "əʊvərɔːlz",
    "overambitious": "əʊvəræmbɪʃəs",
    "overanalyse": "əʊvərænɐlaɪz",
    "overanxious": "əʊvəræŋʃəs",
    "overarching": "əʊvərɑːtʃɪŋ",
    "overarm": "əʊvərɑːm",
    "overate": "əʊvəreɪt",
    "overawed": "əʊvərɔːd",
    "overawe": "əʊvərɔː",
    "overawing": "əʊvərɔːrɪŋ",
    "overbalanced": "əʊvəbælənst",
    "overbalance": "əʊvəbæləns",
    "overbalancing": "əʊvəbælənsɪŋ",
    "overbear": "əʊvəbeə",
    "overbearing": "əʊvəbeərɪŋ",
    "overbite": "əʊvəbaɪt",
    "overblown": "əʊvəbləʊn",
    "overboard": "əʊvəbɔːd",
    "overbooked": "əʊvəbʊkt",
    "overbook": "əʊvəbʊk",
    "overbooking": "əʊvəbʊkɪŋ",
    "overbore": "əʊvəbɔː",
    "overbuilding": "əʊvəbɪldɪŋ",
    "overburdened": "əʊvəbɜːdənd",
    "overburden": "əʊvəbɜːdən",
    "overburdening": "əʊvəbɜːdənɪŋ",
    "overbuy": "əʊvəbaɪ",
    "overcame": "əʊvəkeɪm",
    "overcapacity": "əʊvəkəpæsɪti",
    "overcapitalised": "əʊvəkæpɪtəlaɪzd",
    "overcautious": "əʊvəkɔːʃəs",
    "overcharged": "əʊvətʃɑːdʒd",
    "overcharging": "əʊvətʃɑːdʒɪŋ",
    "overclothes": "əʊvəkləʊðz",
    "overcoat": "əʊvəkəʊt",
    "overcoats": "əʊvəkəʊts",
    "overcome": "əʊvəkʌm",
    "overcomes": "əʊvəkʌmz",
    "overcoming": "əʊvəkʌmɪŋ",
    "overcompensated": "əʊvəkɒmpənseɪtɪd",
    "overcompensate": "əʊvəkɒmpənseɪt",
    "overcompensating": "əʊvəkɒmpənseɪtɪŋ",
    "overcomplicated": "əʊvəkɒmplɪkeɪtɪd",
    "overconfidence": "əʊvəkɒnfɪdəns",
    "overconfident": "əʊvəkɒnfɪdənt",
    "overcooked": "əʊvəkʊkt",
    "overcook": "əʊvəkʊk",
    "overcooking": "əʊvəkʊkɪŋ",
    "overcooks": "əʊvəkʊks",
    "overcrowded": "əʊvəkraʊdɪd",
    "overcrowd": "əʊvəkraʊd",
    "overcrowding": "əʊvəkraʊdɪŋ",
    "overdeveloped": "əʊvədɪvɛləpt",
    "overdevelop": "əʊvədɪvɛləp",
    "overdevelopment": "əʊvədɪvɛləpmənt",
    "overdid": "əʊvədɪd",
    "overdoes": "əʊvədʌz",
    "overdo": "əʊvəduː",
    "overdoing": "əʊvəduːɪŋ",
    "overdone": "əʊvədʌn",
    "overdosed": "əʊvədəʊzd",
    "overdose": "əʊvədəʊz",
    "overdoses": "əʊvədəʊzɪz",
    "overdosing": "əʊvədəʊzɪŋ",
    "overdraft": "əʊvədrɑːft",
    "overdrafts": "əʊvədrɑːfts",
    "overdrawn": "əʊvədrɔːn",
    "overdressed": "əʊvədrɛst",
    "overdress": "əʊvədrɛs",
    "overdrew": "əʊvədruː",
    "overdrive": "əʊvədraɪv",
    "overdubbed": "əʊvədʌbd",
    "overdubbing": "əʊvədʌbɪŋ",
    "overdub": "əʊvədʌb",
    "overdubs": "əʊvədʌbz",
    "overdue": "əʊvədjuː",
    "overeager": "əʊvəriːɡɐ",
    "overeat": "əʊvəriːt",
    "overeating": "əʊvəriːtɪŋ",
    "overeducated": "əʊvərɛdʒuːkeɪtɪd",
    "overelaborate": "əʊvərɪlæbəreɪt",
    "overemotional": "əʊvərɪməʊʃənəl",
    "overemphasised": "əʊvərɛmfɐsaɪzd",
    "overemphasise": "əʊvərɛmfɐsaɪz",
    "overemphasis": "əʊvərɛmfɐsiz",
    "overemphasising": "əʊvərɛmfɐsaɪzɪŋ",
    "overenthusiasm": "əʊvərɛnθjuːzɪæzəm",
    "overenthusiastic": "əʊvərɛnθjuːzɪæstɪk",
    "overestimated": "əʊvərɛstɪmeɪtɪd",
    "overestimate": "əʊvərɛstɪmət",
    "overestimating": "əʊvərɛstɪmeɪtɪŋ",
    "overestimation": "əʊvərɛstɪmeɪʃən",
    "over": "əʊvɐ",
    "overexcited": "əʊvərɛksaɪtɪd",
    "overexcite": "əʊvərɛksaɪt",
    "overexerted": "əʊvərɛɡzɜːtɪd",
    "overexert": "əʊvərɛɡzɜːt",
    "overexposed": "əʊvərɛkspəʊzd",
    "overexposure": "əʊvərɛkspəʊʒɐ",
    "overextended": "əʊvərɛkstɛndɪd",
    "overextend": "əʊvərɛkstɛnd",
    "overfamiliar": "əʊvəfəmɪliə",
    "overfed": "əʊvəfɛd",
    "overfeed": "əʊvəfiːd",
    "overfeeding": "əʊvəfiːdɪŋ",
    "overfilled": "əʊvəfɪld",
    "overfill": "əʊvəfɪl",
    "overfilling": "əʊvəfɪlɪŋ",
    "overfills": "əʊvəfɪlz",
    "overfishing": "əʊvəfɪʃɪŋ",
    "overflew": "əʊvəfluː",
    "overflight": "əʊvəflaɪt",
    "overflowed": "əʊvəfləʊd",
    "overflowing": "əʊvəfləʊɪŋ",
    "overflown": "əʊvəfləʊn",
    "overfly": "əʊvəflaɪ",
    "overflying": "əʊvəflaɪɪŋ",
    "overfond": "əʊvəfɒnd",
    "overfull": "əʊvəfʊl",
    "overgeneralise": "əʊvədʒɛnərəlaɪz",
    "overgenerous": "əʊvədʒɛnərəs",
    "overgrazed": "əʊvəɡreɪzd",
    "overgraze": "əʊvəɡreɪz",
    "overgrazing": "əʊvəɡreɪzɪŋ",
    "overgrew": "əʊvəɡruː",
    "overground": "əʊvəɡraʊnd",
    "overgrow": "əʊvəɡrəʊ",
    "overgrowing": "əʊvəɡrəʊɪŋ",
    "overgrown": "əʊvəɡrəʊn",
    "overgrowth": "əʊvəɡrəʊθ",
    "overhand": "əʊvəhænd",
    "overhanging": "əʊvəhæŋɪŋ",
    "overhasty": "əʊvəheɪsti",
    "overhauled": "əʊvəhɔːld",
    "overhauling": "əʊvəhɔːlɪŋ",
    "overheads": "əʊvəhɛdz",
    "overheard": "əʊvəhɜːd",
    "overhear": "əʊvəhiə",
    "overhearing": "əʊvəhiərɪŋ",
    "overhears": "əʊvəhiəz",
    "overheated": "əʊvəhiːtɪd",
    "overheat": "əʊvəhiːt",
    "overheating": "əʊvəhiːtɪŋ",
    "overheats": "əʊvəhiːts",
    "overhung": "əʊvəhʌŋ",
    "overindulged": "əʊvərɪndʌldʒd",
    "overindulge": "əʊvərɪndʌldʒ",
    "overindulgence": "əʊvərɪndʌldʒəns",
    "overindulgent": "əʊvərɪndʌldʒənt",
    "overindulging": "əʊvərɪndʌldʒɪŋ",
    "overinflated": "əʊvərɪnfleɪtɪd",
    "overjoyed": "əʊvədʒɔɪd",
    "overkill": "əʊvəkɪl",
    "overlaid": "əʊvəleɪd",
    "overlain": "əʊvəleɪn",
    "overland": "əʊvəlænd",
    "overlapped": "əʊvəlæpt",
    "overlapping": "əʊvəlæpɪŋ",
    "overlaying": "əʊvəleɪɪŋ",
    "overleaf": "əʊvəliːf",
    "overloaded": "əʊvələʊdɪd",
    "overload": "əʊvələʊd",
    "overloading": "əʊvələʊdɪŋ",
    "overloads": "əʊvələʊdz",
    "overlong": "əʊvəlɒŋ",
    "overlooked": "əʊvəlʊkt",
    "overlooker": "əʊvəlʊkɐ",
    "overlooking": "əʊvəlʊkɪŋ",
    "overlooks": "əʊvəlʊks",
    "overlord": "əʊvəlɔːd",
    "overlords": "əʊvəlɔːdz",
    "overly": "əʊvəli",
    "overlying": "əʊvəlaɪɪŋ",
    "overmanned": "əʊvəmænd",
    "overmantel": "əʊvəmɑːntəl",
    "overmastering": "əʊvəmɑːstərɪŋ",
    "overmuch": "əʊvəmʌtʃ",
    "overnights": "əʊvənaɪts",
    "overoptimistic": "əʊvərɒptɪmɪstɪk",
    "overpaid": "əʊvəpeɪd",
    "overpasses": "əʊvəpɑːsɪz",
    "overpass": "əʊvəpɑːs",
    "overpay": "əʊvəpeɪ",
    "overpaying": "əʊvəpeɪɪŋ",
    "overpayment": "əʊvəpeɪmənt",
    "overpays": "əʊvəpeɪz",
    "overplayed": "əʊvəpleɪd",
    "overplay": "əʊvəpleɪ",
    "overplaying": "əʊvəpleɪɪŋ",
    "overplays": "əʊvəpleɪz",
    "overpopulated": "əʊvəpɒpjʊleɪtɪd",
    "overpopulation": "əʊvəpɒpjʊleɪʃən",
    "overpowered": "əʊvəpaʊəd",
    "overpower": "əʊvəpaʊɐ",
    "overpowering": "əʊvəpaʊərɪŋ",
    "overpoweringly": "əʊvəpaʊərɪŋli",
    "overpowers": "əʊvəpaʊəz",
    "overpriced": "əʊvəpraɪst",
    "overprice": "əʊvəpraɪs",
    "overpricing": "əʊvəpraɪsɪŋ",
    "overprinted": "əʊvəprɪntɪd",
    "overproduced": "əʊvəprədjuːst",
    "overproduction": "əʊvəprədʌkʃən",
    "overprotected": "əʊvəprətɛktɪd",
    "overprotection": "əʊvəprətɛkʃən",
    "overprotective": "əʊvəprətɛktɪv",
    "overqualified": "əʊvəkwɒlɪfaɪd",
    "overran": "əʊvəræn",
    "overrated": "əʊvəreɪtɪd",
    "overrate": "əʊvəreɪt",
    "overreached": "əʊvəriːtʃt",
    "overreach": "əʊvəriːtʃ",
    "overreaching": "əʊvəriːtʃɪŋ",
    "overreacted": "əʊvərɪæktɪd",
    "overreact": "əʊvərɪækt",
    "overreacting": "əʊvərɪæktɪŋ",
    "overreaction": "əʊvərɪækʃən",
    "overreacts": "əʊvərɪækts",
    "overregulate": "əʊvərɛɡjuːleɪt",
    "overregulation": "əʊvərɛɡjuːleɪʃən",
    "overrepresented": "əʊvərɛprɪzɛntɪd",
    "overridden": "əʊvərɪdən",
    "override": "əʊvəraɪd",
    "overrides": "əʊvəraɪdz",
    "overriding": "əʊvəraɪdɪŋ",
    "overripe": "əʊvəraɪp",
    "overrode": "əʊvərəʊd",
    "overruled": "əʊvəruːld",
    "overrule": "əʊvəruːl",
    "overrules": "əʊvəruːlz",
    "overruling": "əʊvəruːlɪŋ",
    "overrunning": "əʊvərʌnɪŋ",
    "overruns": "əʊvərʌnz",
    "oversaw": "əʊvəsɔː",
    "oversea": "əʊvəsiː",
    "oversee": "əʊvəsiː",
    "overseeing": "əʊvəsiːɪŋ",
    "overseen": "əʊvəsiːn",
    "overseer": "əʊvəsiə",
    "overseers": "əʊvəsiəz",
    "oversees": "əʊvəsiːz",
    "oversell": "əʊvəsɛl",
    "overselling": "əʊvəsɛlɪŋ",
    "oversensitive": "əʊvəsɛnsɪtɪv",
    "overset": "əʊvəsɛt",
    "overs": "əʊvəz",
    "oversexed": "əʊvəsɛkst",
    "overshadowed": "əʊvəʃædəʊd",
    "overshadow": "əʊvəʃædəʊ",
    "overshadowing": "əʊvəʃædəʊɪŋ",
    "overshadows": "əʊvəʃædəʊz",
    "overshoes": "əʊvəʃuːz",
    "overshoot": "əʊvəʃuːt",
    "overshooting": "əʊvəʃuːtɪŋ",
    "overshoots": "əʊvəʃuːts",
    "overshot": "əʊvəʃɒt",
    "oversight": "əʊvəsaɪt",
    "oversights": "əʊvəsaɪts",
    "oversimplification": "əʊvəsɪmplɪfɪkeɪʃən",
    "oversimplified": "əʊvəsɪmplɪfaɪd",
    "oversimplify": "əʊvəsɪmplɪfaɪ",
    "oversimplifying": "əʊvəsɪmplɪfaɪɪŋ",
    "oversized": "əʊvəsaɪzd",
    "oversize": "əʊvəsaɪz",
    "oversleep": "əʊvəsliːp",
    "oversleeping": "əʊvəsliːpɪŋ",
    "oversleeps": "əʊvəsliːps",
    "overslept": "əʊvəslɛpt",
    "oversold": "əʊvəsəʊld",
    "overspend": "əʊvəspɛnd",
    "overspending": "əʊvəspɛndɪŋ",
    "overspends": "əʊvəspɛndz",
    "overspent": "əʊvəspɛnt",
    "overspill": "əʊvəspɪl",
    "overspills": "əʊvəspɪlz",
    "overspread": "əʊvəsprɛd",
    "overstaffed": "əʊvəstɑːft",
    "overstated": "əʊvəsteɪtɪd",
    "overstate": "əʊvəsteɪt",
    "overstatement": "əʊvəsteɪtmənt",
    "overstates": "əʊvəsteɪts",
    "overstating": "əʊvəsteɪtɪŋ",
    "overstayed": "əʊvəsteɪd",
    "overstay": "əʊvəsteɪ",
    "overstaying": "əʊvəsteɪɪŋ",
    "oversteer": "əʊvəstiə",
    "overstep": "əʊvəstɛp",
    "overstepped": "əʊvəstɛpt",
    "overstepping": "əʊvəstɛpɪŋ",
    "oversteps": "əʊvəstɛps",
    "overstimulated": "əʊvəstɪmjʊleɪtɪd",
    "overstocked": "əʊvəstɒkt",
    "overstock": "əʊvəstɒk",
    "overstocking": "əʊvəstɒkɪŋ",
    "overstress": "əʊvəstrɛs",
    "overstretched": "əʊvəstrɛtʃt",
    "overstretch": "əʊvəstrɛtʃ",
    "overstretching": "əʊvəstrɛtʃɪŋ",
    "overstuffed": "əʊvəstʌft",
    "oversubscribed": "əʊvəsəbskraɪbd",
    "oversupplied": "əʊvəsəplaɪd",
    "oversupply": "əʊvəsəplaɪ",
    "oversweet": "əʊvəswiːt",
    "overtake": "əʊvəteɪk",
    "overtaken": "əʊvəteɪkən",
    "overtakes": "əʊvəteɪks",
    "overtaking": "əʊvəteɪkɪŋ",
    "overtaxed": "əʊvətækst",
    "overtax": "əʊvətæks",
    "overt": "əʊvɜːt",
    "overthrew": "əʊvəθruː",
    "overthrowing": "əʊvəθrəʊɪŋ",
    "overthrown": "əʊvəθrəʊn",
    "overtime": "əʊvətaɪm",
    "overtired": "əʊvətaɪəd",
    "overtly": "əʊvɜːtli",
    "overtone": "əʊvətəʊn",
    "overtones": "əʊvətəʊnz",
    "overtook": "əʊvətʊk",
    "overtopped": "əʊvətɒpt",
    "overture": "əʊvətjɔː",
    "overtures": "əʊvətjɔːz",
    "overturned": "əʊvətɜːnd",
    "overturn": "əʊvətɜːn",
    "overturning": "əʊvətɜːnɪŋ",
    "overturns": "əʊvətɜːnz",
    "overused": "əʊvəjuːzd",
    "overusing": "əʊvəjuːzɪŋ",
    "overvaluation": "əʊvəvæljuːeɪʃən",
    "overvalued": "əʊvəvæljuːd",
    "overvalue": "əʊvəvæljuː",
    "overview": "əʊvəvjuː",
    "overviews": "əʊvəvjuːz",
    "overweening": "əʊvəwiːnɪŋ",
    "overwhelmed": "əʊvəwɛlmd",
    "overwhelm": "əʊvəwɛlm",
    "overwhelming": "əʊvəwɛlmɪŋ",
    "overwhelmingly": "əʊvəwɛlmɪŋli",
    "overwhelms": "əʊvəwɛlmz",
    "overwind": "əʊvəwɪnd",
    "overwintered": "əʊvəwɪntəd",
    "overwinter": "əʊvəwɪntɐ",
    "overwintering": "əʊvəwɪntərɪŋ",
    "overworked": "əʊvəwɜːkt",
    "overworking": "əʊvəwɜːkɪŋ",
    "overwrite": "əʊvəraɪt",
    "overwritten": "əʊvərɪtən",
    "overwrought": "əʊvərɔːt",
    "overzealous": "əʊvəzɛləs",
    "oviduct": "əʊvɪdʌkt",
    "ovine": "əʊvaɪn",
    "ovipositor": "əʊvɪpɒsɪtɐ",
    "ovoid": "əʊvɔɪd",
    "ovoids": "əʊvɔɪdz",
    "ovulate": "ɒvjʊleɪt",
    "ovulating": "ɒvjʊleɪtɪŋ",
    "ovulation": "ɒvjʊleɪʃən",
    "ovules": "ɒvjuːlz",
    "ovule": "ɒvjuːl",
    "ovum": "əʊvəm",
    "ow": "əʊ",
    "owed": "əʊd",
    "owe": "əʊ",
    "owes": "əʊz",
    "owing": "əʊɪŋ",
    "owl": "aʊl",
    "owlet": "aʊlət",
    "owlets": "aʊləts",
    "owlish": "aʊlɪʃ",
    "owls": "aʊlz",
    "owned": "əʊnd",
    "own": "əʊn",
    "owner": "əʊnɐ",
    "owners": "əʊnəz",
    "ownership": "əʊnəʃɪp",
    "ownerships": "əʊnəʃɪps",
    "owning": "əʊnɪŋ",
    "owns": "əʊnz",
    "oxalic": "ɒksælɪk",
    "oxalis": "ɒksɑːliz",
    "oxblood": "ɒksblʌd",
    "oxbow": "ɒksbəʊ",
    "oxen": "ɒksən",
    "oxford": "ɒksfəd",
    "oxfords": "ɒksfədz",
    "oxidant": "ɒksɪdənt",
    "oxidants": "ɒksɪdənts",
    "oxidase": "ɒksɪdeɪs",
    "oxidation": "ɒksɪdeɪʃən",
    "oxidative": "ɒksɪdətɪv",
    "oxide": "ɒksaɪd",
    "oxides": "ɒksaɪdz",
    "oxidisation": "ɒksɪdaɪzeɪʃən",
    "oxidised": "ɒksɪdaɪzd",
    "oxidise": "ɒksɪdaɪz",
    "oxidiser": "ɒksɪdaɪzɐ",
    "oxidises": "ɒksɪdaɪzɪz",
    "oxidising": "ɒksɪdaɪzɪŋ",
    "ox": "ɒks",
    "oxpecker": "ɒkspɛkɐ",
    "oxtail": "ɒksteɪl",
    "oxtails": "ɒksteɪlz",
    "oxyacetylene": "ɒksɪɐsɛtɪliːn",
    "oxygenated": "ɒksɪdʒəneɪtɪd",
    "oxygenate": "ɒksɪdʒəneɪt",
    "oxygenates": "ɒksɪdʒəneɪts",
    "oxygenating": "ɒksɪdʒəneɪtɪŋ",
    "oxygenation": "ɒksɪdʒəneɪʃən",
    "oxygen": "ɒksɪdʒən",
    "oxymoron": "ɒksɪmɔːrɒn",
    "oxymorons": "ɒksɪmɔːrɒnz",
    "oxytocin": "ɒksɪtɒsɪn",
    "oyez": "ɔɪɛz",
    "oystercatcher": "ɔɪstəkætʃɐ",
    "oystercatchers": "ɔɪstəkætʃəz",
    "oyster": "ɔɪstɐ",
    "oysters": "ɔɪstəz",
    "ozone": "əʊzəʊn",
    "paced": "peɪst",
    "pacemaker": "peɪsmeɪkɐ",
    "pacemakers": "peɪsmeɪkəz",
    "pacemaking": "peɪsmeɪkɪŋ",
    "pacer": "peɪsɐ",
    "pacers": "peɪsəz",
    "pacesetter": "peɪssɛtɐ",
    "paces": "peɪsɪz",
    "pacey": "peɪsi",
    "pacha": "pætʃɐ",
    "pachisi": "pætʃɪsi",
    "pachyderm": "pætʃaɪdəm",
    "pachyderms": "pætʃaɪdəmz",
    "pachysandra": "pætʃɪsændrɐ",
    "pacier": "peɪsɪɐ",
    "pacifically": "pɐsɪfɪkli",
    "pacification": "pæsɪfɪkeɪʃən",
    "pacificism": "pæsɪfɪsɪzəm",
    "pacific": "pɐsɪfɪk",
    "pacified": "pæsɪfaɪd",
    "pacifier": "pæsɪfaɪə",
    "pacifiers": "pæsɪfaɪəz",
    "pacifies": "pæsɪfaɪz",
    "pacifism": "pæsɪfɪzəm",
    "pacifist": "pæsɪfɪst",
    "pacifists": "pæsɪfɪsts",
    "pacifying": "pæsɪfaɪɪŋ",
    "pacify": "pæsɪfaɪ",
    "pacing": "peɪsɪŋ",
    "packaged": "pækɪdʒd",
    "package": "pækɪdʒ",
    "packagers": "pækɪdʒəz",
    "packages": "pækɪdʒɪz",
    "packaging": "pækɪdʒɪŋ",
    "packed": "pækt",
    "packer": "pækɐ",
    "packers": "pækəz",
    "packet": "pækɪt",
    "packets": "pækɪts",
    "packhorse": "pækhɔːs",
    "packhorses": "pækhɔːsɪz",
    "packing": "pækɪŋ",
    "pack": "pæk",
    "packs": "pæks",
    "pact": "pækt",
    "pacts": "pækts",
    "pacy": "peɪsi",
    "padauk": "pædɔːk",
    "padded": "pædɪd",
    "paddies": "pædɪz",
    "padding": "pædɪŋ",
    "paddled": "pædəld",
    "paddle": "pædəl",
    "paddler": "pædlɐ",
    "paddlers": "pædləz",
    "paddles": "pædəlz",
    "paddling": "pædlɪŋ",
    "paddock": "pædək",
    "paddocks": "pædəks",
    "paddy": "pædi",
    "padlocked": "pædlɒkt",
    "padlocking": "pædlɒkɪŋ",
    "padlock": "pædlɒk",
    "padlocks": "pædlɒks",
    "padre": "pɑːdreɪ",
    "padres": "pɑːdreɪz",
    "pads": "pædz",
    "paean": "piən",
    "paeans": "piənz",
    "paediatrician": "piːdɪɐtrɪʃən",
    "paediatricians": "piːdɪɐtrɪʃənz",
    "paediatric": "piːdɪætrɪk",
    "paediatrics": "piːdɪætrɪks",
    "paedophile": "piːdəfaɪl",
    "paedophiles": "piːdəfaɪlz",
    "paedophilia": "piːdəfɪliə",
    "paedophilic": "piːdəfɪlɪk",
    "paella": "paɪɛlɐ",
    "paellas": "paɪɛləz",
    "paganism": "peɪɡənɪzəm",
    "pagan": "peɪɡən",
    "pagans": "peɪɡənz",
    "pageant": "pædʒənt",
    "pageantry": "pædʒəntri",
    "pageants": "pædʒənts",
    "pageboy": "peɪdʒbɔɪ",
    "pageboys": "peɪdʒbɔɪz",
    "paged": "peɪdʒd",
    "page": "peɪdʒ",
    "pager": "peɪdʒɐ",
    "pagers": "peɪdʒəz",
    "pages": "peɪdʒɪz",
    "paginated": "pædʒɪneɪtɪd",
    "pagination": "pædʒɪneɪʃən",
    "paging": "peɪdʒɪŋ",
    "pagoda": "pæɡəʊdɐ",
    "pagodas": "pæɡəʊdəz",
    "pah": "pɑː",
    "paid": "peɪd",
    "pail": "peɪl",
    "pails": "peɪlz",
    "pained": "peɪnd",
    "painfully": "peɪnfəli",
    "painful": "peɪnfəl",
    "paining": "peɪnɪŋ",
    "painkiller": "peɪŋkɪlɐ",
    "painkillers": "peɪŋkɪləz",
    "painkilling": "peɪŋkɪlɪŋ",
    "painlessly": "peɪnləsli",
    "painless": "peɪnləs",
    "pain": "peɪn",
    "pains": "peɪnz",
    "painstakingly": "peɪnsteɪkɪŋli",
    "painstaking": "peɪnsteɪkɪŋ",
    "paintball": "peɪntbɔːl",
    "paintbox": "peɪntbɒks",
    "paintbrushes": "peɪntbrʌʃɪz",
    "paintbrush": "peɪntbrʌʃ",
    "painted": "peɪntɪd",
    "painterly": "peɪntəli",
    "painter": "peɪntɐ",
    "painters": "peɪntəz",
    "painting": "peɪntɪŋ",
    "paintings": "peɪntɪŋz",
    "paint": "peɪnt",
    "paints": "peɪnts",
    "paintwork": "peɪntwɜːk",
    "painty": "peɪnti",
    "paired": "peəd",
    "pairing": "peərɪŋ",
    "pairings": "peərɪŋz",
    "pair": "peə",
    "pairs": "peəz",
    "paisano": "peɪsɑːnəʊ",
    "paisa": "peɪsɐ",
    "paisley": "peɪsli",
    "paisleys": "peɪslɪz",
    "pajama": "pɐdʒɑːmɐ",
    "pajamas": "pɐdʒɑːməz",
    "palace": "pælɪs",
    "palaces": "pælɪsɪz",
    "paladin": "pælɐdɪn",
    "palaeography": "pæliːɒɡrəfi",
    "palaeolithic": "pæliːəlɪθɪk",
    "palaeontological": "pæliːɒntəlɒdʒɪkəl",
    "palaeontologist": "pæliːəntɒlədʒɪst",
    "palaeontologists": "pæliːəntɒlədʒɪsts",
    "palaeontology": "pæliːəntɒlədʒi",
    "palais": "pæleɪ",
    "palanquin": "pælɐnkwɪn",
    "palatable": "pælətəbəl",
    "palate": "pælət",
    "palates": "pæləts",
    "palatial": "pæleɪʃəl",
    "palatine": "pælɐtiːn",
    "palaver": "pælɑːvɐ",
    "palazzo": "pælæzəʊ",
    "palely": "peɪlli",
    "paleness": "peɪlnəs",
    "pale": "peɪl",
    "paler": "peɪlɐ",
    "pales": "peɪlz",
    "palest": "peɪləst",
    "palette": "pælət",
    "palettes": "pæləts",
    "palfrey": "pælfri",
    "palimpsest": "pælɪmpsəst",
    "palindrome": "peɪlɪndrəʊm",
    "palindromes": "peɪlɪndrəʊmz",
    "palindromic": "peɪlɪndrɒmɪk",
    "palindromist": "peɪlɪndrəmɪst",
    "palings": "peɪlɪŋz",
    "palisade": "pælɪseɪd",
    "palisades": "pælɪseɪdz",
    "palladium": "pɐleɪdiəm",
    "pallbearer": "pælbeərɐ",
    "pallbearers": "pælbeərəz",
    "pallet": "pælɪt",
    "pallets": "pælɪts",
    "palliasse": "pælɪæs",
    "palliative": "pæliətɪv",
    "palliatives": "pæliətɪvz",
    "pallid": "pælɪd",
    "pallium": "pæliəm",
    "pallor": "pælɐ",
    "pall": "pɔːl",
    "palls": "pɔːlz",
    "pally": "pæli",
    "palmar": "pɑːmɐ",
    "palmate": "pɑːmeɪt",
    "palmed": "pɑːmd",
    "palmer": "pɑːmɐ",
    "palmers": "pɑːməz",
    "palmette": "pɑːmɛt",
    "palmier": "pɑːmɪɐ",
    "palming": "pɑːmɪŋ",
    "palmist": "pɑːmɪst",
    "palmistry": "pɑːmɪstri",
    "palmists": "pɑːmɪsts",
    "palm": "pɑːm",
    "palms": "pɑːmz",
    "palmtop": "pɑːmtɒp",
    "palmy": "pɑːmi",
    "palomino": "pælɒmɪnəʊ",
    "palominos": "pælɒmɪnəʊz",
    "palpable": "pælpəbəl",
    "palpably": "pælpəbli",
    "pal": "pæl",
    "palpated": "pælpeɪtɪd",
    "palpate": "pælpeɪt",
    "palpating": "pælpeɪtɪŋ",
    "palpation": "pælpeɪʃən",
    "palpitating": "pælpɪteɪtɪŋ",
    "palpitation": "pælpɪteɪʃən",
    "palpitations": "pælpɪteɪʃənz",
    "palp": "pælp",
    "palsied": "pɔːlzid",
    "pals": "pælz",
    "palter": "pɒltɐ",
    "paltry": "pɔːltri",
    "pampa": "pæmpɐ",
    "pampas": "pæmpəz",
    "pampered": "pæmpəd",
    "pampering": "pæmpərɪŋ",
    "pampero": "pæmpeərəʊ",
    "pamper": "pæmpɐ",
    "pampers": "pæmpəz",
    "pamphleteer": "pæmflɪtiə",
    "pamphleteers": "pæmflɪtiəz",
    "pamphlet": "pæmflət",
    "pamphlets": "pæmfləts",
    "panacea": "pænɐsiːɐ",
    "panache": "pɐnæʃ",
    "panama": "pænəmɑː",
    "panamas": "pænəmɑːz",
    "panatella": "pæneɪtɛlɐ",
    "panatellas": "pæneɪtɛləz",
    "pancaked": "pænkeɪkt",
    "pancake": "pænkeɪk",
    "pancakes": "pænkeɪks",
    "pancreas": "pænkriəs",
    "pancreatic": "pænkriːeɪtɪk",
    "pancreatitis": "pænkriːeɪtaɪtɪs",
    "pandanus": "pændænəs",
    "panda": "pændɐ",
    "pandas": "pændəz",
    "pandemic": "pændɛmɪk",
    "pandemics": "pændɛmɪks",
    "pandemonium": "pændɪməʊniəm",
    "pandered": "pændəd",
    "pandering": "pændərɪŋ",
    "pander": "pændɐ",
    "panders": "pændəz",
    "pandit": "pændɪt",
    "paned": "peɪnd",
    "panelled": "pænəld",
    "panelling": "pænəlɪŋ",
    "panellist": "pænɪlɪst",
    "panellists": "pænɪlɪsts",
    "panel": "pænəl",
    "panels": "pænəlz",
    "pane": "peɪn",
    "panes": "peɪnz",
    "panettone": "pænɪtəʊn",
    "panful": "pænfəl",
    "panga": "pæŋɡɐ",
    "pangolin": "pæŋɡəlɪn",
    "pangolins": "pæŋɡəlɪnz",
    "pang": "pæŋ",
    "pangs": "pæŋz",
    "panhandle": "pænhændəl",
    "panhandlers": "pænhændləz",
    "panhandling": "pænhɐndlɪŋ",
    "panicked": "pænɪkt",
    "panicking": "pænɪkɪŋ",
    "panicky": "pænɪki",
    "panicle": "pænɪkəl",
    "panicles": "pænɪkəlz",
    "panic": "pænɪk",
    "panics": "pænɪks",
    "panjandrum": "pændʒændrəm",
    "panned": "pænd",
    "panne": "pæn",
    "pannier": "pænɪɐ",
    "panniers": "pæniəz",
    "panning": "pænɪŋ",
    "panoply": "pænəpli",
    "panorama": "pænəræmɐ",
    "panoramas": "pænəræməz",
    "panoramic": "pænɔːræmɪk",
    "panpipe": "pænpaɪp",
    "panpipes": "pænpaɪps",
    "pansies": "pænzɪz",
    "pans": "pænz",
    "pansy": "pænzi",
    "pantaloon": "pɑːntɐluːn",
    "pantaloons": "pɑːntɐluːnz",
    "pantechnicon": "pɑːntɪknɪkən",
    "panted": "pɑːntɪd",
    "pantheon": "pɑːnθɪən",
    "panther": "pɑːnθɐ",
    "panthers": "pɑːnθəz",
    "panties": "pɑːntɪz",
    "pantiled": "pɑːntaɪld",
    "pantile": "pɑːntaɪl",
    "pantiles": "pɑːntaɪlz",
    "panting": "pɑːntɪŋ",
    "pantograph": "pɑːntəɡræf",
    "pantographs": "pɑːntəɡræfz",
    "pantomime": "pɑːntəmaɪm",
    "pantomimes": "pɑːntəmaɪmz",
    "pantomimic": "pɑːntəmɪmɪk",
    "panto": "pɑːntəʊ",
    "pantos": "pɑːntəʊz",
    "pant": "pɑːnt",
    "pantries": "pɑːntriz",
    "pantry": "pɑːntri",
    "pants": "pɑːnts",
    "pantsuit": "pɑːntsuːt",
    "pantyhose": "pɑːntɪhəʊz",
    "panty": "pɑːnti",
    "panzer": "pænzɐ",
    "panzers": "pænzəz",
    "pa": "pɑː",
    "papacy": "pæpəsi",
    "papal": "peɪpəl",
    "papa": "pɐpɑː",
    "paparazzi": "pɑːpərɑːtsi",
    "paparazzo": "pɑːpərɑːtsəʊ",
    "papas": "pɐpɑːz",
    "papaw": "pæpɔː",
    "papaya": "pɐpaɪɐ",
    "papayas": "pɐpaɪəz",
    "paperback": "peɪpəbæk",
    "paperbacks": "peɪpəbæks",
    "paperbark": "peɪpəbɑːk",
    "paperboy": "peɪpəbɔɪ",
    "paperboys": "peɪpəbɔɪz",
    "paperclip": "peɪpəklɪp",
    "paperclips": "peɪpəklɪps",
    "papered": "peɪpəd",
    "paperer": "peɪpərɐ",
    "papergirl": "peɪpəɡɜːl",
    "papering": "peɪpərɪŋ",
    "paperless": "peɪpələs",
    "paper": "peɪpɐ",
    "papers": "peɪpəz",
    "paperweight": "peɪpəweɪt",
    "paperweights": "peɪpəweɪts",
    "paperwork": "peɪpəwɜːk",
    "papery": "peɪpəri",
    "papillae": "pæpɪliː",
    "papilla": "pæpɪlɐ",
    "papillon": "pæpɪlən",
    "papillons": "pæpɪlənz",
    "papillote": "pæpɪləʊt",
    "papist": "peɪpɪst",
    "papists": "peɪpɪsts",
    "papoose": "pæpuːs",
    "pap": "pæp",
    "pappy": "pæpi",
    "paprika": "pæprɪkɐ",
    "paps": "pæps",
    "papyri": "pæpɪri",
    "papyrus": "pɐpaɪrəs",
    "parable": "pærəbəl",
    "parables": "pærəbəlz",
    "parabola": "pəræbəlɐ",
    "parabolas": "pəræbələz",
    "parabolic": "pærəbɒlɪk",
    "paracetamol": "pærəsɛtɐmɒl",
    "paracetamols": "pærəsɛtɐmɒlz",
    "parachuted": "pærəʃuːtɪd",
    "parachute": "pærəʃuːt",
    "parachutes": "pærəʃuːts",
    "parachuting": "pærəʃuːtɪŋ",
    "parachutist": "pærətʃuːtɪst",
    "parachutists": "pærətʃuːtɪsts",
    "paraded": "pəreɪdɪd",
    "parade": "pəreɪd",
    "parades": "pəreɪdz",
    "paradiddle": "pærədɪdəl",
    "paradiddles": "pærədɪdəlz",
    "paradigm": "pærədaɪm",
    "paradigms": "pærədaɪmz",
    "parading": "pəreɪdɪŋ",
    "paradise": "pærədaɪs",
    "paradises": "pærədaɪsɪz",
    "paradisiacal": "pærədɪsɪækəl",
    "paradoxes": "pærədɒksɪz",
    "paradoxically": "pærədɒksɪkli",
    "paradoxical": "pærədɒksɪkəl",
    "paradox": "pærədɒks",
    "paraesthesia": "pærərɪsθiːziə",
    "paraffin": "pærəfɪn",
    "paraglider": "pærəɡlaɪdɐ",
    "paragliding": "pærəɡlaɪdɪŋ",
    "paragon": "pærəɡən",
    "paragons": "pærəɡənz",
    "paragraph": "pærəɡræf",
    "paragraphs": "pærəɡræfz",
    "parakeet": "pærəkiːt",
    "parakeets": "pærəkiːts",
    "paralegal": "pærəliːɡəl",
    "paralegals": "pærəliːɡəlz",
    "parallax": "pærəlæks",
    "paralleled": "pærəlɛld",
    "paralleling": "pærələlɪŋ",
    "parallelogram": "pærəlɛləɡræm",
    "parallel": "pærəlɛl",
    "parallels": "pærəlɛlz",
    "paralysed": "pærəlaɪzd",
    "paralyse": "pærəlaɪz",
    "paralyses": "pærəlaɪzɪz",
    "paralysing": "pærəlaɪzɪŋ",
    "paralysis": "pəræləsɪs",
    "paralytically": "pærəlɪtɪkli",
    "paralytic": "pærəlɪtɪk",
    "paramagnetic": "pærəmɐɡnɛtɪk",
    "paramecium": "pærəmiːsiəm",
    "paramedic": "pærəmɛdɪk",
    "paramedics": "pærəmɛdɪks",
    "parameter": "pəræmɪtɐ",
    "parameters": "pəræmɪtəz",
    "parametric": "pærəmɛtrɪk",
    "paramilitaries": "pærəmɪlɪtəriz",
    "paramilitary": "pærəmɪlɪtəri",
    "paramo": "pærəməʊ",
    "paramount": "pærəmaʊnt",
    "paramour": "pærɐmɔː",
    "paranoiac": "pærənɔɪək",
    "paranoia": "pærənɔɪɐ",
    "paranoid": "pærənɔɪd",
    "paranormal": "pærənɔːməl",
    "parapet": "pærəpɪt",
    "parapets": "pærəpɪts",
    "paraphernalia": "pærəfəneɪliə",
    "paraphilia": "pærəfɪliə",
    "paraphrased": "pærəfreɪzd",
    "paraphrase": "pærəfreɪz",
    "paraphrasing": "pærəfreɪzɪŋ",
    "paraplegic": "pærəpliːdʒɪk",
    "paraplegics": "pærəpliːdʒɪks",
    "parapsychologist": "pærəsaɪkɒlədʒɪst",
    "parapsychology": "pærəsaɪkɒlədʒi",
    "paraquat": "pærəkwæt",
    "parascending": "pærəsəndɪŋ",
    "parasite": "pærəsaɪt",
    "parasites": "pærəsaɪts",
    "parasitical": "pærəsɪtɪkəl",
    "parasitic": "pærəsɪtɪk",
    "parasitology": "pærəsɪtɒlədʒi",
    "parasol": "pærəsɒl",
    "parasols": "pærəsɒlz",
    "paras": "pærəz",
    "parasympathetic": "pærəsɪmpəθɛtɪk",
    "paratrooper": "pærətruːpɐ",
    "paratroopers": "pærətruːpəz",
    "paratroop": "pærətruːp",
    "paratroops": "pærətruːps",
    "parboiled": "pɑːbɔɪld",
    "parboiling": "pɑːbɔɪlɪŋ",
    "parboil": "pɑːbɔɪl",
    "parcelled": "pɑːsəld",
    "parcelling": "pɑːsəlɪŋ",
    "parcel": "pɑːsəl",
    "parcels": "pɑːsəlz",
    "parched": "pɑːtʃt",
    "parching": "pɑːtʃɪŋ",
    "parchment": "pɑːtʃmənt",
    "parchments": "pɑːtʃmənts",
    "parch": "pɑːtʃ",
    "pardner": "pɑːdnɐ",
    "pardners": "pɑːdnəz",
    "pardonable": "pɑːdəʊnəbəl",
    "pardoned": "pɑːdənd",
    "pardoner": "pɑːdənɐ",
    "pardoning": "pɑːdənɪŋ",
    "pardon": "pɑːdən",
    "pardons": "pɑːdənz",
    "pard": "pɑːd",
    "pared": "peəd",
    "paregoric": "peəɡɒrɪk",
    "parentage": "peərəntɪdʒ",
    "parental": "pərɛntəl",
    "parented": "peərəntɪd",
    "parenteral": "peərəntərəl",
    "parenthesis": "pərɛnθəsɪs",
    "parenthood": "peərənthʊd",
    "parenting": "peərəntɪŋ",
    "parent": "peərənt",
    "parents": "peərənts",
    "pare": "peə",
    "pares": "peəz",
    "parfait": "pɑːfeɪt",
    "parfaits": "pɑːfeɪts",
    "pariah": "pəraɪə",
    "pariahs": "pəraɪəz",
    "parietal": "pæraɪətəl",
    "paring": "peərɪŋ",
    "parings": "peərɪŋz",
    "parishes": "pærɪʃɪz",
    "parishioner": "pærɪʃənɐ",
    "parishioners": "pærɪʃənəz",
    "parish": "pærɪʃ",
    "parities": "pærɪtiz",
    "parity": "pærɪti",
    "parka": "pɑːkɐ",
    "parkas": "pɑːkəz",
    "parked": "pɑːkt",
    "parking": "pɑːkɪŋ",
    "parkin": "pɑːkɪn",
    "parkland": "pɑːklənd",
    "park": "pɑːk",
    "parks": "pɑːks",
    "parkway": "pɑːkweɪ",
    "parkways": "pɑːkweɪz",
    "parky": "pɑːki",
    "parlance": "pɑːləns",
    "parlay": "pɑːleɪ",
    "parlays": "pɑːleɪz",
    "parley": "pɑːli",
    "parliamentarianism": "pɑːləmənteəriənɪzəm",
    "parliamentarian": "pɑːləmənteəriən",
    "parliamentarians": "pɑːləmənteəriənz",
    "parliamentary": "pɑːləmɛntəri",
    "parliament": "pɑːləmənt",
    "parliaments": "pɑːləmənts",
    "parlor": "pɑːlɐ",
    "parlourmaid": "pɑːləmeɪd",
    "parlour": "pɑːlɐ",
    "parlours": "pɑːləz",
    "parlous": "pɑːləs",
    "parmigiana": "pɑːmɪdʒiːænɐ",
    "parmigiano": "pɑːmɪdʒiənəʊ",
    "parochialism": "pærəkɪəlɪzəm",
    "parochial": "pærɒkɪəl",
    "parodic": "pærɒdɪk",
    "parodied": "pærədɪd",
    "parodies": "pærədɪz",
    "parodying": "pærədɪɪŋ",
    "parody": "pærədi",
    "paroled": "pərəʊld",
    "parolee": "pærəʊliː",
    "parolees": "pærəʊliːz",
    "parole": "pərəʊl",
    "paroles": "pərəʊlz",
    "parol": "pærɒl",
    "parotid": "pærətɪd",
    "paroxysms": "pærəksɪzəmz",
    "par": "pɑː",
    "parquet": "pɑːkeɪ",
    "parquetry": "pɑːkwɪtri",
    "parred": "pɑːd",
    "parried": "pærɪd",
    "parries": "pærɪz",
    "parring": "pɑːrɪŋ",
    "parroted": "pærətɪd",
    "parrotfish": "pærɒtfɪʃ",
    "parroting": "pærətɪŋ",
    "parrot": "pærət",
    "parrots": "pærəts",
    "parr": "pɑː",
    "parrying": "pærɪɪŋ",
    "parry": "pæri",
    "parsec": "pɑːsɛk",
    "parsecs": "pɑːsɛks",
    "parse": "pɑːs",
    "parser": "pɑːsɐ",
    "parsimonious": "pɑːsɪməʊnɪəs",
    "parsley": "pɑːsli",
    "parsnip": "pɑːsnɪp",
    "parsnips": "pɑːsnɪps",
    "parsonage": "pɑːsənɪdʒ",
    "parson": "pɑːsən",
    "parsons": "pɑːsənz",
    "pars": "pɑːz",
    "partaken": "pɑːteɪkən",
    "partake": "pɑːteɪk",
    "partaker": "pɑːteɪkɐ",
    "partakers": "pɑːteɪkəz",
    "partaking": "pɑːteɪkɪŋ",
    "parted": "pɑːtɪd",
    "parterre": "pɑːtɛrɐ",
    "parterres": "pɑːtɛrəz",
    "parthenogenesis": "pɑːθənəʊdʒɛnɪsɪs",
    "partiality": "pɑːʃɪælɪti",
    "partially": "pɑːʃəli",
    "partial": "pɑːʃəl",
    "partials": "pɑːʃəlz",
    "participant": "pɑːtɪsɪpənt",
    "participants": "pɑːtɪsɪpənts",
    "participated": "pɑːtɪsɪpeɪtɪd",
    "participate": "pɑːtɪsɪpeɪt",
    "participates": "pɑːtɪsɪpeɪts",
    "participating": "pɑːtɪsɪpeɪtɪŋ",
    "participation": "pɑːtɪsɪpeɪʃən",
    "participative": "pɑːtɪsɪpətɪv",
    "participatory": "pɑːtɪsɪpətəri",
    "participle": "pɑːtɪsɪpəl",
    "participles": "pɑːtɪsɪpəlz",
    "particle": "pɑːtɪkəl",
    "particles": "pɑːtɪkəlz",
    "particularity": "pətɪkjʊlærɪti",
    "particularly": "pətɪkjʊləli",
    "particular": "pətɪkjʊlɐ",
    "particulars": "pətɪkjʊləz",
    "particulate": "pətɪkjʊleɪt",
    "partied": "pɑːtɪd",
    "parties": "pɑːtɪz",
    "parting": "pɑːtɪŋ",
    "partings": "pɑːtɪŋz",
    "partisan": "pɑːtɪsən",
    "partisanship": "pɑːtɪsənʃɪp",
    "partisans": "pɑːtɪsənz",
    "partite": "pɑːtaɪt",
    "partitioned": "pɑːtɪʃənd",
    "partitioning": "pɑːtɪʃənɪŋ",
    "partition": "pɑːtɪʃən",
    "partitions": "pɑːtɪʃənz",
    "partizan": "pɑːtɪzən",
    "partly": "pɑːtli",
    "partnered": "pɑːtnəd",
    "partnering": "pɑːtnərɪŋ",
    "partner": "pɑːtnɐ",
    "partnership": "pɑːtnəʃɪp",
    "partnerships": "pɑːtnəʃɪps",
    "partners": "pɑːtnəz",
    "parton": "pɑːtən",
    "partook": "pɑːtʊk",
    "part": "pɑːt",
    "partridge": "pɑːtrɪdʒ",
    "partridges": "pɑːtrɪdʒɪz",
    "parts": "pɑːts",
    "partway": "pɑːtweɪ",
    "partying": "pɑːtɪɪŋ",
    "party": "pɑːti",
    "parvenu": "pɑːvənuː",
    "parvenus": "pɑːvənəs",
    "parve": "pɑːv",
    "pascal": "pæskəl",
    "paschal": "pæstʃəl",
    "pasha": "pæʃɐ",
    "pash": "pæʃ",
    "pas": "pæs",
    "passable": "pɑːsəbəl",
    "passably": "pɑːsəbli",
    "passade": "pɑːseɪd",
    "passage": "pæsɪdʒ",
    "passages": "pæsɪdʒɪz",
    "passageway": "pæsɪdʒweɪ",
    "passageways": "pæsɪdʒweɪz",
    "passant": "pɑːsənt",
    "passbook": "pɑːsbʊk",
    "passbooks": "pɑːsbʊks",
    "passed": "pɑːst",
    "passel": "pɑːsəl",
    "passenger": "pæsɪndʒɐ",
    "passengers": "pæsɪndʒəz",
    "passerby": "pæsəbaɪ",
    "passerine": "pɑːsəriːn",
    "passer": "pɑːsɐ",
    "passersby": "pæsəzbaɪ",
    "passers": "pɑːsəz",
    "passes": "pɑːsɪz",
    "passingly": "pɑːsɪŋli",
    "passing": "pɑːsɪŋ",
    "passionately": "pæʃənətli",
    "passionate": "pæʃənət",
    "passionflower": "pæʃənflaʊɐ",
    "passionless": "pæʃənləs",
    "passion": "pæʃən",
    "passions": "pæʃənz",
    "passively": "pɑːsɪvli",
    "passive": "pɑːsɪv",
    "passivity": "pɑːsɪvɪti",
    "passkey": "pɑːski",
    "passover": "pæsəʊvɐ",
    "passport": "pɑːspɔːt",
    "passports": "pɑːspɔːts",
    "pass": "pɑːs",
    "passus": "pɑːsəs",
    "password": "pɑːswɜːd",
    "passwords": "pɑːswɜːdz",
    "pasta": "pɑːstɐ",
    "pastas": "pɑːstəz",
    "pasted": "peɪstɪd",
    "pastel": "pɑːstəl",
    "pastels": "pɑːstəlz",
    "paste": "peɪst",
    "pastern": "pɐstɜːn",
    "pastes": "peɪsts",
    "pasteurisation": "pɑːstjuːraɪzeɪʃən",
    "pasteurised": "pɑːstjuːraɪzd",
    "pasteurise": "pɑːstjuːraɪz",
    "pasteuriser": "pɑːstjuːraɪzɐ",
    "pasteurising": "pɑːstjuːraɪzɪŋ",
    "pasticcio": "pɑːstɪksɪəʊ",
    "pastiche": "pɑːstiːʃ",
    "pastiches": "pɑːstɪtʃɪz",
    "pasties": "pɑːstɪz",
    "pastille": "pɑːstɪl",
    "pastilles": "pɑːstɪlz",
    "pastime": "pɑːstaɪm",
    "pastimes": "pɑːstaɪmz",
    "pasting": "peɪstɪŋ",
    "pastis": "pɑːstiz",
    "pastorale": "pɑːstɔːreɪl",
    "pastoralism": "pɑːstɔːrəlɪzəm",
    "pastoralist": "pɑːstɔːrəlɪst",
    "pastorally": "pɑːstərəli",
    "pastoral": "pɑːstərəl",
    "pastor": "pɑːstɐ",
    "pastors": "pɑːstəz",
    "past": "pɑːst",
    "pastrami": "pɑːstrɑːmi",
    "pastries": "peɪstriz",
    "pastry": "peɪstri",
    "pasts": "pɑːsts",
    "pastured": "pɑːstʃəd",
    "pastureland": "pɑːstʃərɛlənd",
    "pasture": "pɑːstʃɐ",
    "pastures": "pɑːstʃəz",
    "patched": "pætʃt",
    "patches": "pætʃɪz",
    "patchier": "pætʃɪɐ",
    "patchily": "pætʃɪli",
    "patching": "pætʃɪŋ",
    "patchouli": "pætʃuːli",
    "patch": "pætʃ",
    "patchwork": "pætʃwɜːk",
    "patchworks": "pætʃwɜːks",
    "patchy": "pætʃi",
    "patella": "peɪtɛlɐ",
    "patentable": "peɪtəntəbəl",
    "patented": "peɪtəntɪd",
    "patentee": "peɪtəntiː",
    "patentees": "peɪtəntiːz",
    "patenting": "peɪtəntɪŋ",
    "patently": "peɪtəntli",
    "patents": "peɪtənts",
    "paterfamilias": "pætəfɐmɪliəz",
    "paternalism": "pətɜːnəlɪzəm",
    "paternalistic": "pətɜːnəlɪstɪk",
    "paternalist": "pətɜːnəlɪst",
    "paternalists": "pətɜːnəlɪsts",
    "paternal": "pətɜːnəl",
    "paternity": "pətɜːnɪti",
    "paternoster": "pətɜːnɒstɐ",
    "pates": "pæteɪz",
    "pathetically": "pɐθɛtɪkli",
    "pathetic": "pɐθɛtɪk",
    "pathfinder": "pɑːθfaɪndɐ",
    "pathfinders": "pɑːθfaɪndəz",
    "pathic": "pæθɪk",
    "pathless": "pɑːθləs",
    "pathogenic": "pæθəʊdʒɛnɪk",
    "pathogen": "pæθədʒən",
    "pathogens": "pæθədʒənz",
    "pathologically": "pæθəlɒdʒɪkli",
    "pathological": "pæθəlɒdʒɪkəl",
    "pathologic": "pæθəlɒdʒɪk",
    "pathologies": "pæθɒlədʒɪz",
    "pathologist": "pæθɒlədʒɪst",
    "pathologists": "pæθɒlədʒɪsts",
    "pathology": "pæθɒlədʒi",
    "pathos": "peɪθɒs",
    "paths": "pɑːθs",
    "pathway": "pɑːθweɪ",
    "pathways": "pɑːθweɪz",
    "patience": "peɪʃəns",
    "patiently": "peɪʃəntli",
    "patient": "peɪʃənt",
    "patients": "peɪʃənts",
    "patina": "pætɪnɐ",
    "patinated": "pætɪneɪtɪd",
    "patination": "pætɪneɪʃən",
    "patio": "pætɪəʊ",
    "patios": "pætɪəʊz",
    "patisserie": "pætɪsəri",
    "patisseries": "pætɪsəriz",
    "pat": "pæt",
    "patriarchal": "pætrɪɑːkəl",
    "patriarch": "pætrɪɑːk",
    "patriarchs": "pætrɪɑːkz",
    "patriarchy": "pætrɪɑːki",
    "patrician": "pætrɪʃən",
    "patricians": "pætrɪʃənz",
    "patrimony": "pætrɪməni",
    "patriotically": "pætrɪɒtɪkli",
    "patriotic": "pætrɪɒtɪk",
    "patriotism": "pætrɪətɪzəm",
    "patriot": "pætrɪət",
    "patriots": "pætrɪəts",
    "patrolled": "pɐtrəʊld",
    "patrolling": "pɐtrəʊlɪŋ",
    "patrolman": "pɐtrəʊlmən",
    "patrolmen": "pɐtrəʊlmɛn",
    "patrol": "pɐtrəʊl",
    "patrols": "pɐtrəʊlz",
    "patronage": "pætrənɪdʒ",
    "patronages": "pætrənɪdʒɪz",
    "patroness": "pætrəʊnəs",
    "patronised": "pætrənaɪzd",
    "patronise": "pætrənaɪz",
    "patronises": "pætrənaɪzɪz",
    "patronisingly": "pætrənaɪzɪŋli",
    "patronising": "pætrənaɪzɪŋ",
    "patron": "peɪtrən",
    "patrons": "peɪtrənz",
    "patsies": "pætsɪz",
    "pats": "pæts",
    "patsy": "pætsi",
    "patted": "pætɪd",
    "patten": "pætən",
    "pattered": "pætəd",
    "pattering": "pætərɪŋ",
    "patterned": "pætənd",
    "patterning": "pætənɪŋ",
    "pattern": "pætən",
    "patterns": "pætənz",
    "patter": "pætɐ",
    "patters": "pætəz",
    "pattie": "pæti",
    "patties": "pætɪz",
    "patting": "pætɪŋ",
    "patty": "pæti",
    "paucity": "pɔːsɪti",
    "paulownia": "pɔːləʊniə",
    "paunch": "pɔːntʃ",
    "paunchy": "pɔːntʃi",
    "pauper": "pɔːpɐ",
    "paupers": "pɔːpəz",
    "paused": "pɔːzd",
    "pause": "pɔːz",
    "pauses": "pɔːzɪz",
    "pausing": "pɔːzɪŋ",
    "pavane": "pæveɪn",
    "pavan": "pævæn",
    "paved": "peɪvd",
    "pavement": "peɪvmənt",
    "pavements": "peɪvmənts",
    "pave": "peɪv",
    "paves": "peɪvz",
    "pavilion": "pɐvɪliən",
    "pavilions": "pɐvɪliənz",
    "paving": "peɪvɪŋ",
    "pavings": "peɪvɪŋz",
    "pavlova": "pævlʌvɐ",
    "pavlovas": "pævlʌvəz",
    "pawed": "pɔːd",
    "pawing": "pɔːrɪŋ",
    "pawnbroker": "pɔːnbrəʊkɐ",
    "pawnbrokers": "pɔːnbrəʊkəz",
    "pawnbroking": "pɔːnbrəʊkɪŋ",
    "pawned": "pɔːnd",
    "pawning": "pɔːnɪŋ",
    "pawn": "pɔːn",
    "pawnshop": "pɔːnʃɒp",
    "pawnshops": "pɔːnʃɒps",
    "pawns": "pɔːnz",
    "pawpaw": "pɔːpɔː",
    "paw": "pɔː",
    "paws": "pɔːz",
    "pax": "pæks",
    "payable": "peɪəbəl",
    "payback": "peɪbæk",
    "paybacks": "peɪbæks",
    "paycheck": "peɪtʃɛk",
    "payday": "peɪdeɪ",
    "paydays": "peɪdeɪz",
    "payed": "peɪd",
    "payee": "peɪiː",
    "payer": "peɪɐ",
    "payers": "peɪəz",
    "paying": "peɪɪŋ",
    "payload": "peɪləʊd",
    "payloads": "peɪləʊdz",
    "paymaster": "peɪmɑːstɐ",
    "paymasters": "peɪmɑːstəz",
    "payment": "peɪmənt",
    "payments": "peɪmənts",
    "payoff": "peɪɒf",
    "payoffs": "peɪɒfs",
    "payola": "peɪəʊlɐ",
    "payout": "peɪaʊt",
    "payouts": "peɪaʊts",
    "pay": "peɪ",
    "payphone": "peɪfəʊn",
    "payphones": "peɪfəʊnz",
    "payroll": "peɪrəʊl",
    "payrolls": "peɪrəʊlz",
    "payslip": "peɪslɪp",
    "payslips": "peɪslɪps",
    "pays": "peɪz",
    "peaceable": "piːsəbəl",
    "peaceably": "piːsəbli",
    "peacefully": "piːsfəli",
    "peacefulness": "piːsfəlnəs",
    "peaceful": "piːsfəl",
    "peacekeeper": "piːskiːpɐ",
    "peacekeepers": "piːskiːpəz",
    "peacekeeping": "piːskiːpɪŋ",
    "peacemaker": "piːsmeɪkɐ",
    "peacemakers": "piːsmeɪkəz",
    "peacemaking": "piːsmeɪkɪŋ",
    "peace": "piːs",
    "peacetime": "piːstaɪm",
    "peaches": "piːtʃɪz",
    "peach": "piːtʃ",
    "peachy": "piːtʃi",
    "peacock": "piːkɒk",
    "peacocks": "piːkɒks",
    "peafowl": "piːfaʊl",
    "peahen": "piːhən",
    "peahens": "piːhənz",
    "peaking": "piːkɪŋ",
    "peak": "piːk",
    "peaks": "piːks",
    "peaky": "piːki",
    "pealed": "piːld",
    "pealing": "piːlɪŋ",
    "peal": "piːl",
    "peals": "piːlz",
    "pean": "piən",
    "peans": "piənz",
    "peanut": "piːnʌt",
    "peanuts": "piːnʌts",
    "pea": "piː",
    "pearling": "pɜːlɪŋ",
    "pearl": "pɜːl",
    "pearls": "pɜːlz",
    "pearly": "pɜːli",
    "pear": "peə",
    "peart": "piət",
    "peasant": "pɛzənt",
    "peasantry": "pɛzəntri",
    "peasants": "pɛzənts",
    "pease": "piːz",
    "peashooter": "piːʃuːtɐ",
    "peashooters": "piːʃuːtəz",
    "peas": "piːz",
    "peat": "piːt",
    "peaty": "piːti",
    "peavey": "piːvi",
    "pebbled": "pɛbəld",
    "pebble": "pɛbəl",
    "pebbles": "pɛbəlz",
    "pebbly": "pɛbli",
    "pecan": "pɪkɑːn",
    "pecans": "pɪkɑːnz",
    "peccadilloes": "pɛkɐdɪləʊz",
    "peccadillo": "pɛkɐdɪləʊ",
    "peccadillos": "pɛkɐdɪləʊz",
    "peccaries": "pɛkəriz",
    "peccary": "pɛkəri",
    "pecked": "pɛkt",
    "pecker": "pɛkɐ",
    "peckers": "pɛkəz",
    "pecking": "pɛkɪŋ",
    "peckish": "pɛkɪʃ",
    "peck": "pɛk",
    "pecks": "pɛks",
    "pec": "pɛk",
    "pecs": "pɛks",
    "pectin": "pɛktɪn",
    "pectoralis": "pɛktɔːrɑːliz",
    "pectoral": "pɛktərəl",
    "pectorals": "pɛktərəlz",
    "peculiarities": "pɪkjuːlɪærɪtiz",
    "peculiarity": "pɪkjuːlɪærɪti",
    "peculiarly": "pɪkjuːliəli",
    "peculiar": "pɪkjuːliə",
    "pecuniary": "pɛkjuːnjəri",
    "pedagogue": "pɛdɐɡɒɡ",
    "pedagogy": "pɛdɐɡɒɡi",
    "pedalled": "pɛdəld",
    "pedalling": "pɛdəlɪŋ",
    "pedalo": "pɛdələʊ",
    "pedalos": "pɛdələʊz",
    "pedals": "pɛdəlz",
    "pedantic": "pɛdɑːntɪk",
    "pedant": "pɛdənt",
    "pedantry": "pɛdəntri",
    "pedants": "pɛdənts",
    "peddled": "pɛdəld",
    "peddle": "pɛdəl",
    "peddles": "pɛdəlz",
    "peddling": "pɛdlɪŋ",
    "pedestal": "pɛdɪstəl",
    "pedestals": "pɛdɪstəlz",
    "pedestrianisation": "pɛdɪstriənaɪzeɪʃən",
    "pedestrianised": "pɛdɪstriənaɪzd",
    "pedestrian": "pədɛstriən",
    "pedestrians": "pədɛstriənz",
    "pedicel": "pɛdɪsəl",
    "pedicle": "pɛdɪkəl",
    "pedicured": "pɛdɪkjɔːd",
    "pedicure": "pɛdɪkjɔː",
    "pedicures": "pɛdɪkjɔːz",
    "pedigree": "pɛdɪɡriː",
    "pedigrees": "pɛdɪɡriːz",
    "pediment": "pɛdɪmənt",
    "pediments": "pɛdɪmənts",
    "pedlar": "pɛdlɐ",
    "pedlars": "pɛdləz",
    "pedometer": "pɛdɒmɪtɐ",
    "pedometers": "pɛdɒmɪtəz",
    "peed": "piːd",
    "peeing": "piːɪŋ",
    "peekaboo": "piːkɐbuː",
    "peeked": "piːkt",
    "peeking": "piːkɪŋ",
    "peek": "piːk",
    "peeks": "piːks",
    "peeled": "piːld",
    "peeler": "piːlɐ",
    "peelers": "piːləz",
    "peeling": "piːlɪŋ",
    "peelings": "piːlɪŋz",
    "peel": "piːl",
    "peels": "piːlz",
    "peen": "piːn",
    "peeped": "piːpt",
    "peeper": "piːpɐ",
    "peepers": "piːpəz",
    "peephole": "piːphəʊl",
    "peepholes": "piːphəʊlz",
    "pee": "piː",
    "peeping": "piːpɪŋ",
    "peep": "piːp",
    "peepshow": "piːpʃəʊ",
    "peeps": "piːps",
    "peepul": "piːpʌl",
    "peerage": "piərɪdʒ",
    "peerages": "piərɪdʒɪz",
    "peered": "piəd",
    "peeresses": "piərəsɪz",
    "peeress": "piərəs",
    "peering": "piərɪŋ",
    "peerless": "piələs",
    "pees": "piːz",
    "peeved": "piːvd",
    "peeve": "piːv",
    "peeves": "piːvz",
    "peeving": "piːvɪŋ",
    "peevishly": "piːvɪʃli",
    "peevishness": "piːvɪʃnəs",
    "peevish": "piːvɪʃ",
    "peewee": "piːwiː",
    "peewit": "piːwɪt",
    "pegged": "pɛɡd",
    "pegging": "pɛɡɪŋ",
    "peg": "pɛɡ",
    "pegs": "pɛɡz",
    "peignoir": "peɪnwɑː",
    "pejoratively": "pədʒɒrətɪvli",
    "pejorative": "pədʒɒrətɪv",
    "peke": "piːk",
    "pekinese": "piːkɪniːz",
    "pekingese": "pɛkɪndʒiːz",
    "pekoe": "piːkəʊ",
    "pelagic": "pɛlædʒɪk",
    "pelargonium": "pɛlɑːɡəʊniəm",
    "pelham": "pɛləm",
    "pelican": "pɛlɪkən",
    "pelicans": "pɛlɪkənz",
    "pellagra": "pɛlæɡrɐ",
    "pelleted": "pɛliːtɪd",
    "pellet": "pɛlɪt",
    "pellets": "pɛlɪts",
    "pellmell": "pɛlmɛl",
    "pelmet": "pɛlmɪt",
    "pelmets": "pɛlmɪts",
    "pelota": "pɛləʊtɐ",
    "pelted": "pɛltɪd",
    "pelting": "pɛltɪŋ",
    "pelt": "pɛlt",
    "pelts": "pɛlts",
    "pelvic": "pɛlvɪk",
    "pelvises": "pɛlvaɪzɪz",
    "pelvis": "pɛlvɪs",
    "pemmican": "pɛmɪkən",
    "penalised": "pɛnəlaɪzd",
    "penalise": "pɛnəlaɪz",
    "penalises": "pɛnəlaɪzɪz",
    "penalising": "pɛnəlaɪzɪŋ",
    "penally": "piːnəli",
    "penal": "piːnəl",
    "penalties": "pɛnəltɪz",
    "penalty": "pɛnəlti",
    "penance": "pɛnəns",
    "penances": "pɛnənsɪz",
    "pence": "pɛns",
    "penchant": "pɒnʃɒn",
    "pencilled": "pɛnsəld",
    "pencilling": "pɛnsəlɪŋ",
    "pencil": "pɛnsəl",
    "pencils": "pɛnsəlz",
    "pendant": "pɛndənt",
    "pendants": "pɛndənts",
    "pendent": "pɛndənt",
    "pending": "pɛndɪŋ",
    "pendragon": "pɛndræɡən",
    "pendragons": "pɛndræɡənz",
    "pends": "pɛndz",
    "pendulous": "pɛndjʊləs",
    "pendulum": "pɛndjʊləm",
    "pendulums": "pɛndjʊləmz",
    "penetrable": "pɛnɪtrəbəl",
    "penetrated": "pɛnɪtreɪtɪd",
    "penetrate": "pɛnɪtreɪt",
    "penetrates": "pɛnɪtreɪts",
    "penetrating": "pɛnɪtreɪtɪŋ",
    "penetration": "pɛnɪtreɪʃən",
    "penetrative": "pɛnɪtrətɪv",
    "peng": "pɛŋ",
    "penguin": "pɛŋɡwɪn",
    "penguins": "pɛŋɡwɪnz",
    "penicillin": "pɛnɪsɪlɪn",
    "penicillium": "pɛnɪsɪliəm",
    "penile": "pɛnaɪl",
    "peninsula": "pənɪnsjʊlɐ",
    "peninsular": "pənɪnsjʊlɐ",
    "peninsulas": "pənɪnsjʊləz",
    "penises": "piːnɪsɪz",
    "penis": "piːnɪs",
    "penitence": "pɛnɪtəns",
    "penitential": "pɛnɪtɛnʃəl",
    "penitentiary": "pɛnɪtɛnʃjəri",
    "penitent": "pɛnɪtənt",
    "penknife": "pɛnnaɪf",
    "penknives": "pɛnnaɪvz",
    "penman": "pɛnmən",
    "penmanship": "pɛnmənʃɪp",
    "penname": "pɛnneɪm",
    "pennant": "pɛnənt",
    "pennants": "pɛnənts",
    "penna": "pɛnɐ",
    "penned": "pɛnd",
    "pennies": "pɛnɪz",
    "penniless": "pɛnɪləs",
    "penning": "pɛnɪŋ",
    "pennis": "pɛniz",
    "penny": "pɛni",
    "pennyroyal": "pɛnɪrɔɪəl",
    "pennyweight": "pɛnɪweɪt",
    "pennyweights": "pɛnɪweɪts",
    "pennyworth": "pɛnɪwɜːθ",
    "pen": "pɛn",
    "pensionable": "pɛnʃənəbəl",
    "pensioned": "pɛnʃənd",
    "pensioner": "pɛnʃənɐ",
    "pensioners": "pɛnʃənəz",
    "pensioning": "pɛnʃənɪŋ",
    "pensively": "pɛnsɪvli",
    "pensive": "pɛnsɪv",
    "pens": "pɛnz",
    "penstemon": "pɛnstɛmən",
    "pentacle": "pɛntəkəl",
    "pentacles": "pɛntəkəlz",
    "pentadactyl": "pɛntɐdæktaɪl",
    "pentagon": "pɛntəɡən",
    "pentagons": "pɛntəɡənz",
    "pentagram": "pɛntɐɡræm",
    "pentameter": "pɛntɐmiːtɐ",
    "pentameters": "pɛntɐmiːtəz",
    "pentangle": "pɛntæŋɡəl",
    "pentathlete": "pɛntɐθliːt",
    "pentathletes": "pɛntɐθliːts",
    "pentathlon": "pɛntæθlən",
    "pentatonic": "pɛntɐtɒnɪk",
    "penthouse": "pɛnthaʊs",
    "penthouses": "pɛnthaʊsɪz",
    "pentimento": "pɛntɪmɛntəʊ",
    "pentose": "pɛntəʊz",
    "pent": "pɛnt",
    "penultimately": "pɛnʌltɪmətli",
    "penultimate": "pɛnʌltɪmət",
    "penumbra": "pɛnʌmbrɐ",
    "penury": "pɛnjʊri",
    "peonies": "piənɪz",
    "peon": "piːən",
    "peons": "piːənz",
    "peony": "piəni",
    "peopled": "piːpəld",
    "people": "piːpəl",
    "peoples": "piːpəlz",
    "peopling": "piːplɪŋ",
    "pepped": "pɛpt",
    "pep": "pɛp",
    "peppercorn": "pɛpəkɔːn",
    "peppercorns": "pɛpəkɔːnz",
    "peppered": "pɛpəd",
    "peppering": "pɛpərɪŋ",
    "peppermint": "pɛpəmɪnt",
    "peppermints": "pɛpəmɪnts",
    "pepperoni": "pɛpərəʊni",
    "pepperonis": "pɛpərəʊniz",
    "pepper": "pɛpɐ",
    "peppers": "pɛpəz",
    "peppery": "pɛpəri",
    "pepping": "pɛpɪŋ",
    "peppy": "pɛpi",
    "pepsin": "pɛpsɪn",
    "peps": "pɛps",
    "peptic": "pɛptɪk",
    "peptide": "pɛptaɪd",
    "peptides": "pɛptaɪdz",
    "peradventure": "pɛrɐdvɛntʃɐ",
    "perambulated": "pəræmbjʊleɪtɪd",
    "perambulate": "pəræmbjʊleɪt",
    "perambulating": "pəræmbjʊleɪtɪŋ",
    "perambulation": "pɛrɐmbjʊleɪʃən",
    "perambulations": "pɛrɐmbjʊleɪʃənz",
    "perambulator": "pɛrɐmbjʊleɪtɐ",
    "perambulators": "pɛrɐmbjʊleɪtəz",
    "percale": "pɜːkeɪl",
    "perceivable": "pəsiːvəbəl",
    "perceived": "pəsiːvd",
    "perceive": "pəsiːv",
    "perceives": "pəsiːvz",
    "perceiving": "pəsiːvɪŋ",
    "percentage": "pəsɛntɪdʒ",
    "percentages": "pəsɛntɪdʒɪz",
    "percentile": "pəsɛntaɪl",
    "percent": "pəsɛnt",
    "perceptible": "pəsɛptəbəl",
    "perception": "pəsɛpʃən",
    "perceptions": "pəsɛpʃənz",
    "perceptively": "pəsɛptɪvli",
    "perceptive": "pəsɛptɪv",
    "perceptual": "pəsɛptʃuːəl",
    "perchance": "pɜːtʃɑːns",
    "perched": "pɜːtʃt",
    "perches": "pɜːtʃɪz",
    "perching": "pɜːtʃɪŋ",
    "perchlorate": "pɜːklɔːreɪt",
    "perch": "pɜːtʃ",
    "percolated": "pɜːkəleɪtɪd",
    "percolate": "pɜːkəleɪt",
    "percolates": "pɜːkəleɪts",
    "percolating": "pɜːkəleɪtɪŋ",
    "percolator": "pɜːkəleɪtɐ",
    "percussionist": "pəkʌʃənɪst",
    "percussionists": "pəkʌʃənɪsts",
    "percussion": "pəkʌʃən",
    "percussive": "pəkʌsɪv",
    "percutaneous": "pɜːkjuːteɪniəs",
    "perdition": "pɜːdɪʃən",
    "perdu": "pɜːduː",
    "peregrinations": "pɛrəɡrɪneɪʃənz",
    "peregrine": "pɛrəɡrɪn",
    "peregrines": "pɛrəɡrɪnz",
    "peremptorily": "pərɛmptərəli",
    "peremptory": "pɛrɪmptəri",
    "perennially": "pərɛnɪəli",
    "perennial": "pərɛnɪəl",
    "perennials": "pərɛnɪəlz",
    "perestroika": "pɛrɪstrɔɪkɐ",
    "perfecta": "pəfɛktɐ",
    "perfected": "pəfɛktɪd",
    "perfectibility": "pəfɛktɪbɪlɪti",
    "perfecting": "pəfɛktɪŋ",
    "perfectionism": "pəfɛkʃənɪzəm",
    "perfectionistic": "pəfɛkʃənɪstɪk",
    "perfectionist": "pəfɛkʃənɪst",
    "perfectionists": "pəfɛkʃənɪsts",
    "perfection": "pəfɛkʃən",
    "perfective": "pəfɛktɪv",
    "perfectly": "pɜːfɛktli",
    "perfecto": "pəfɛktəʊ",
    "perfects": "pɜːfɛkts",
    "perfidious": "pɜːfɪdɪəs",
    "perforated": "pɜːfəreɪtɪd",
    "perforate": "pɜːfəreɪt",
    "perforates": "pɜːfəreɪts",
    "perforating": "pɜːfəreɪtɪŋ",
    "perforation": "pɜːfəreɪʃən",
    "perforations": "pɜːfəreɪʃənz",
    "perforce": "pɜːfɔːs",
    "performance": "pəfɔːməns",
    "performances": "pəfɔːmənsɪz",
    "performed": "pəfɔːmd",
    "performer": "pəfɔːmɐ",
    "performers": "pəfɔːməz",
    "performing": "pəfɔːmɪŋ",
    "perform": "pəfɔːm",
    "performs": "pəfɔːmz",
    "perfumed": "pɜːfjuːmd",
    "perfumer": "pɜːfjuːmɐ",
    "perfumers": "pɜːfjuːməz",
    "perfumery": "pɜːfjuːməri",
    "perfuming": "pɜːfjuːmɪŋ",
    "perfunctory": "pəfʌŋktəri",
    "perfused": "pəfjuːzd",
    "perfuse": "pəfjuːz",
    "perfusing": "pəfjuːzɪŋ",
    "perfusionist": "pəfjuːʒənɪst",
    "perfusion": "pəfjuːʒən",
    "pergola": "pɜːɡəʊlɐ",
    "pergolas": "pɜːɡəʊləz",
    "perhaps": "pəhæps",
    "pericardial": "pɛrɪkɑːdɪəl",
    "pericarditis": "pɛrɪkɑːdaɪtɪs",
    "pericardium": "pɛrɪkɑːdiəm",
    "pericarp": "pɛrɪkɑːp",
    "peridot": "pɛrɪdɒt",
    "peridots": "pɛrɪdɒts",
    "perigee": "pɛrɪdʒiː",
    "perihelion": "pɛrɪhɛliən",
    "perilously": "pɛrɪləsli",
    "perilous": "pɛrɪləs",
    "peril": "pɛrəl",
    "perils": "pɛrəlz",
    "perimeter": "pərɪmɪtɐ",
    "perimeters": "pərɪmɪtəz",
    "perinatal": "pɛrɪneɪtəl",
    "perineal": "pɛrɪniəl",
    "perineum": "pɛrɪniːəm",
    "periodically": "piərɪɒdɪkli",
    "periodical": "piərɪɒdɪkəl",
    "periodicals": "piərɪɒdɪkəlz",
    "periodicity": "piərɪɒdɪsɪti",
    "periodontal": "piərɪədɒntəl",
    "periodontist": "piərɪədɒntɪst",
    "period": "piərɪəd",
    "periods": "piərɪədz",
    "peripatetic": "pɛrɪpɐtɛtɪk",
    "peri": "pɛri",
    "peripherality": "pərɪfərælɪti",
    "peripherally": "pərɪfərəli",
    "peripheral": "pərɪfərəl",
    "peripherals": "pərɪfərəlz",
    "peripheries": "pərɪfəriz",
    "periphery": "pərɪfəri",
    "periscope": "pɛrɪskəʊp",
    "periscopes": "pɛrɪskəʊps",
    "perishable": "pɛrɪʃəbəl",
    "perishables": "pɛrɪʃəbəlz",
    "perished": "pɛrɪʃt",
    "perisher": "pɛrɪʃɐ",
    "perishers": "pɛrɪʃəz",
    "perishes": "pɛrɪʃɪz",
    "perishing": "pɛrɪʃɪŋ",
    "perish": "pɛrɪʃ",
    "peris": "pɛrɪs",
    "peristalsis": "pɛrɪstælsɪs",
    "peristaltic": "pɛrɪstæltɪk",
    "peritoneal": "pɛrɪtəʊnəl",
    "peritoneum": "pɛrɪtəʊniːəm",
    "peritonitis": "pɛrɪtənaɪtɪs",
    "periwig": "pɛrɪwɪɡ",
    "periwinkle": "pɛrɪwɪŋkəl",
    "periwinkles": "pɛrɪwɪŋkəlz",
    "perjured": "pɜːdʒjɔːd",
    "perjure": "pɜːdʒjɔː",
    "perjurer": "pɜːdʒjʊrɐ",
    "perjuring": "pɜːdʒjɔːrɪŋ",
    "perjury": "pɜːdʒəri",
    "perked": "pɜːkt",
    "perkier": "pɜːkiɐ",
    "perkiest": "pɜːkiəst",
    "perkiness": "pɜːkinəs",
    "perking": "pɜːkɪŋ",
    "perk": "pɜːk",
    "perks": "pɜːks",
    "perky": "pɜːki",
    "perlite": "pɜːlaɪt",
    "permafrost": "pɜːmɐfrɒst",
    "permanence": "pɜːmənəns",
    "permanency": "pɜːmənənsi",
    "permanently": "pɜːmənəntli",
    "permanent": "pɜːmənənt",
    "permanents": "pɜːmənənts",
    "permanganate": "pɜːmənɡæneɪt",
    "permeability": "pɜːməbɪlɪti",
    "permeable": "pɜːməbəl",
    "permeated": "pɜːmɪeɪtɪd",
    "permeate": "pɜːmɪeɪt",
    "permeates": "pɜːmɪeɪts",
    "permeating": "pɜːmɪeɪtɪŋ",
    "permed": "pɜːmd",
    "perming": "pɜːmɪŋ",
    "permissible": "pəmɪsəbəl",
    "permission": "pəmɪʃən",
    "permissions": "pəmɪʃənz",
    "permissiveness": "pəmɪsɪvnəs",
    "permissive": "pəmɪsɪv",
    "permitted": "pəmɪtɪd",
    "permitting": "pəmɪtɪŋ",
    "permittivity": "pəmɪtɪvɪti",
    "perm": "pɜːm",
    "perms": "pɜːmz",
    "permutation": "pɜːmjuːteɪʃən",
    "permutations": "pɜːmjuːteɪʃənz",
    "pernicious": "pɜːnɪʃəs",
    "pernickety": "pɜːnɪkɪti",
    "peroxide": "pərɒksaɪd",
    "per": "pɜː",
    "perpendicular": "pɜːpəndɪkjʊlɐ",
    "perpetrated": "pɜːpɪtreɪtɪd",
    "perpetrate": "pɜːpɪtreɪt",
    "perpetrates": "pɜːpɪtreɪts",
    "perpetrating": "pɜːpɪtreɪtɪŋ",
    "perpetration": "pɜːpɪtreɪʃən",
    "perpetrator": "pɜːpɪtreɪtɐ",
    "perpetrators": "pɜːpɪtreɪtəz",
    "perpetually": "pəpɛtʃuːəli",
    "perpetual": "pəpɛtʃuːəl",
    "perpetuated": "pəpɛtʃuːeɪtɪd",
    "perpetuate": "pəpɛtʃuːeɪt",
    "perpetuates": "pəpɛtʃuːeɪts",
    "perpetuating": "pəpɛtʃuːeɪtɪŋ",
    "perpetuation": "pəpɛtʃuːeɪʃən",
    "perpetuity": "pəpɪtjuːɪti",
    "perplexed": "pəplɛkst",
    "perplexes": "pəplɛksɪz",
    "perplexingly": "pəplɛksɪŋli",
    "perplexing": "pəplɛksɪŋ",
    "perplexity": "pəplɛksɪti",
    "perplex": "pəplɛks",
    "perquisite": "pɜːkwɪsɪt",
    "perries": "pɛrɪz",
    "perron": "pɛrən",
    "perry": "pɛri",
    "persecuted": "pɜːsɪkjuːtɪd",
    "persecute": "pɜːsɪkjuːt",
    "persecutes": "pɜːsɪkjuːts",
    "persecuting": "pɜːsɪkjuːtɪŋ",
    "persecution": "pɜːsɪkjuːʃən",
    "persecutions": "pɜːsɪkjuːʃənz",
    "persecutor": "pɜːsɪkjuːtɐ",
    "persecutors": "pɜːsɪkjuːtəz",
    "perseverance": "pɜːsɪviərəns",
    "persevered": "pɜːsɪviəd",
    "persevere": "pɜːsɪviə",
    "perseveres": "pɜːsɪviəz",
    "persevering": "pɜːsɪviərɪŋ",
    "persimmon": "pɜːsɪmən",
    "persimmons": "pɜːsɪmənz",
    "persisted": "pəsɪstɪd",
    "persistence": "pəsɪstəns",
    "persistently": "pəsɪstəntli",
    "persistent": "pəsɪstənt",
    "persisting": "pəsɪstɪŋ",
    "persist": "pəsɪst",
    "persists": "pəsɪsts",
    "personable": "pɜːsənəbəl",
    "personae": "pɜːsəniː",
    "personage": "pɜːsənɪdʒ",
    "personages": "pɜːsənɪdʒɪz",
    "personalisation": "pɜːsənəlaɪzeɪʃən",
    "personalised": "pɜːsənəlaɪzd",
    "personalise": "pɜːsənəlaɪz",
    "personalises": "pɜːsənəlaɪzɪz",
    "personalising": "pɜːsənəlaɪzɪŋ",
    "personalities": "pɜːsənælɪtiz",
    "personality": "pɜːsənælɪti",
    "personally": "pɜːsənəli",
    "personal": "pɜːsənəl",
    "personals": "pɜːsənəlz",
    "personalty": "pɜːsənəlti",
    "persona": "pɜːsəʊnɐ",
    "personas": "pɜːsəʊnəz",
    "personification": "pɜːsɒnɪfɪkeɪʃən",
    "personified": "pɜːsɒnɪfaɪd",
    "personifies": "pɜːsɒnɪfaɪz",
    "personifying": "pɜːsɒnɪfaɪɪŋ",
    "personify": "pɜːsɒnɪfaɪ",
    "personnel": "pɜːsənɛl",
    "person": "pɜːsən",
    "persons": "pɜːsənz",
    "perspective": "pəspɛktɪv",
    "perspectives": "pəspɛktɪvz",
    "perspex": "pɜːspɛks",
    "perspicacious": "pəspɪkeɪʃəs",
    "perspicacity": "pəspɪkæsɪti",
    "perspiration": "pəspəreɪʃən",
    "perspired": "pəspaɪəd",
    "perspire": "pəspaɪə",
    "perspiring": "pəspaɪərɪŋ",
    "persuadable": "pəsweɪdəbəl",
    "persuaded": "pəsweɪdɪd",
    "persuade": "pəsweɪd",
    "persuader": "pəsweɪdɐ",
    "persuaders": "pəsweɪdəz",
    "persuades": "pəsweɪdz",
    "persuading": "pəsweɪdɪŋ",
    "persuasion": "pəsweɪʒən",
    "persuasions": "pəsweɪʒənz",
    "persuasively": "pəsweɪsɪvli",
    "persuasiveness": "pəsweɪsɪvnəs",
    "persuasive": "pəsweɪsɪv",
    "pertained": "pəteɪnd",
    "pertaining": "pəteɪnɪŋ",
    "pertain": "pəteɪn",
    "pertains": "pəteɪnz",
    "pertinently": "pɜːtɪnəntli",
    "pertinent": "pɜːtɪnənt",
    "pert": "pɜːt",
    "perturbation": "pətəbeɪʃən",
    "perturbations": "pətəbeɪʃənz",
    "perturbed": "pətɜːbd",
    "perturbing": "pətɜːbɪŋ",
    "perturb": "pətɜːb",
    "perturbs": "pətɜːbz",
    "pertussis": "pətʌsɪs",
    "perusal": "pəruːzəl",
    "perused": "pəruːzd",
    "peruse": "pəruːz",
    "peruses": "pəruːzɪz",
    "perusing": "pəruːzɪŋ",
    "pervaded": "pəveɪdɪd",
    "pervade": "pəveɪd",
    "pervades": "pəveɪdz",
    "pervading": "pəveɪdɪŋ",
    "pervasiveness": "pəveɪsɪvnəs",
    "pervasive": "pəveɪsɪv",
    "perversely": "pəvɜːsli",
    "perverse": "pəvɜːs",
    "perversion": "pəvɜːʃən",
    "perversions": "pəvɜːʃənz",
    "perversity": "pəvɜːsɪti",
    "perverted": "pəvɜːtɪd",
    "perverting": "pəvɜːtɪŋ",
    "pervious": "pɜːvɪəs",
    "pervs": "pɜːvz",
    "peseta": "pɛsɛtɐ",
    "pesetas": "pɛsɛtəz",
    "pesewas": "pɛsjuːəz",
    "peskier": "pɛskiɐ",
    "peskiness": "pɛskinəs",
    "pesky": "pɛski",
    "peso": "piːsəʊ",
    "pesos": "piːsəʊz",
    "pes": "pɛs",
    "pessary": "pɛsəri",
    "pessimism": "pɛsɪmɪzəm",
    "pessimistically": "pɛsɪmɪstɪkli",
    "pessimistic": "pɛsɪmɪstɪk",
    "pessimist": "pɛsɪmɪst",
    "pessimists": "pɛsɪmɪsts",
    "pestered": "pɛstəd",
    "pestering": "pɛstərɪŋ",
    "pester": "pɛstɐ",
    "pesters": "pɛstəz",
    "pesticide": "pɛstɪsaɪd",
    "pesticides": "pɛstɪsaɪdz",
    "pestilence": "pɛstɪləns",
    "pestilential": "pɛstɪlɛnʃəl",
    "pestilent": "pɛstɪlənt",
    "pestle": "pɛsəl",
    "pestles": "pɛsəlz",
    "pesto": "pɛstəʊ",
    "pest": "pɛst",
    "pests": "pɛsts",
    "pesty": "pɛsti",
    "petabytes": "pɛtɐbaɪts",
    "petalled": "pɛtɔːld",
    "petal": "pɛtəl",
    "petals": "pɛtəlz",
    "petard": "pɛtɑːd",
    "petered": "piːtəd",
    "petering": "piːtərɪŋ",
    "peter": "piːtɐ",
    "petersham": "piːtəʃəm",
    "peters": "piːtəz",
    "pethidine": "pɛθɪdiːn",
    "petiole": "pɛtɪəʊl",
    "petite": "pətiːt",
    "petites": "pɛtaɪts",
    "petitioned": "pətɪʃənd",
    "petitioner": "pətɪʃənɐ",
    "petitioners": "pɛtɪʃənəz",
    "petitioning": "pətɪʃənɪŋ",
    "petition": "pətɪʃən",
    "petitions": "pətɪʃənz",
    "petit": "pətiː",
    "pet": "pɛt",
    "petrel": "pɛtrəl",
    "petrels": "pɛtrəlz",
    "petrified": "pɛtrɪfaɪd",
    "petrifies": "pɛtrɪfaɪz",
    "petrifying": "pɛtrɪfaɪɪŋ",
    "petrify": "pɛtrɪfaɪ",
    "petrochemical": "pɛtrəʊkɛmɪkəl",
    "petrochemicals": "pɛtrəʊkɛmɪkəlz",
    "petroleum": "pətrəʊliːəm",
    "petrological": "pɛtrəlɒdʒɪkəl",
    "petrol": "pɛtrəl",
    "pets": "pɛts",
    "petted": "pɛtɪd",
    "petter": "pɛtɐ",
    "petticoat": "pɛtɪkəʊt",
    "petticoats": "pɛtɪkəʊts",
    "pettiest": "pɛtɪəst",
    "pettiness": "pɛtɪnəs",
    "petting": "pɛtɪŋ",
    "petty": "pɛti",
    "petulance": "pɛtjʊləns",
    "petulantly": "pɛtjʊləntli",
    "petulant": "pɛtjʊlənt",
    "petunia": "pətjuːniə",
    "petunias": "pətjuːniəz",
    "petuntse": "pɛtəntsi",
    "pewit": "pjuːɪt",
    "pew": "pjuː",
    "pews": "pjuːz",
    "pewter": "pjuːtɐ",
    "peyote": "peɪəʊt",
    "pfennig": "fɛnɪɡ",
    "pfennigs": "fɛnɪɡz",
    "phaeton": "fiːtən",
    "phage": "feɪdʒ",
    "phages": "feɪdʒɪz",
    "phagocytes": "fæɡəsaɪts",
    "phagocytosis": "fæɡəsɪtəʊsɪs",
    "phalanges": "fælændʒɪz",
    "phalanxes": "fælæŋksɪz",
    "phalanx": "fælæŋks",
    "phalarope": "fælɐrəʊp",
    "phalaropes": "fælɐrəʊps",
    "phallically": "fælɪkli",
    "phallic": "fælɪk",
    "phalluses": "fæləsɪz",
    "phallus": "fæləs",
    "phantasmagoria": "fɑːntɐzmɐɡɔːriə",
    "phantasmagorical": "fɑːntɐzmɐɡɒrɪkəl",
    "phantasm": "fɑːntæzəm",
    "phantom": "fɑːntəm",
    "phantoms": "fɑːntəmz",
    "pharaoh": "feərəʊ",
    "pharaohs": "feərəʊz",
    "pharisee": "færɪsiː",
    "pharisees": "færɪsiːz",
    "pharmaceutical": "fɑːmɐsuːtɪkəl",
    "pharmaceuticals": "fɑːmɐsuːtɪkəlz",
    "pharmacies": "fɑːməsɪz",
    "pharmacist": "fɑːmɐsɪst",
    "pharmacists": "fɑːmɐsɪsts",
    "pharmacological": "fɑːmɐkəlɒdʒɪkəl",
    "pharmacologist": "fɑːmɐkɒlədʒɪst",
    "pharmacologists": "fɑːmɐkɒlədʒɪsts",
    "pharmacology": "fɑːmɐkɒlədʒi",
    "pharmacopoeia": "fɑːmɐkəpəʊiə",
    "pharmacy": "fɑːməsi",
    "pharos": "færəʊz",
    "pharyngeal": "fɑːrɪndʒiəl",
    "pharyngitis": "fɑːrɪndʒaɪtɪs",
    "pharynx": "fɑːrɪŋks",
    "phased": "feɪzd",
    "phase": "feɪz",
    "phases": "feɪzɪz",
    "phasing": "feɪzɪŋ",
    "phat": "fæt",
    "pheasant": "fɛzənt",
    "pheasants": "fɛzənts",
    "phenobarbital": "fɛnəbɑːbɪtəl",
    "phenol": "fɛnɒl",
    "phenolic": "fɛnɒlɪk",
    "phenomena": "fɪnɒmɪnɐ",
    "phenomenal": "fɪnɒmɪnəl",
    "phenomenally": "fɪnɒmɪnəli",
    "phenomenology": "fɪnɒmɪnɒlədʒi",
    "phenomenon": "fɪnɒmɪnən",
    "phenomenons": "fɪnɒmɪnənz",
    "phenom": "fɛnəm",
    "phenotype": "fɛnətaɪp",
    "phenylalanine": "fiːnaɪlælɐnaɪn",
    "phenyl": "fiːnaɪl",
    "pheromonal": "fɛrəmɒnəl",
    "pheromone": "fɛrəməʊn",
    "pheromones": "fɛrəməʊnz",
    "phew": "fjuː",
    "phial": "faɪəl",
    "phials": "faɪəlz",
    "phi": "faɪ",
    "philanderer": "fɪlændərɐ",
    "philanderers": "fɪlændərəz",
    "philander": "fɪlændɐ",
    "philandering": "fɪlændərɪŋ",
    "philanthropic": "fɪlɐnθrɒpɪk",
    "philanthropist": "fɪlænθrəpɪst",
    "philanthropists": "fɪlænθrəpɪsts",
    "philanthropy": "fɪlænθrəpi",
    "philatelist": "fɪlætɪlɪst",
    "philatelists": "fɪlætɪlɪsts",
    "philately": "fɪlætli",
    "philharmonic": "fɪlhɑːmɒnɪk",
    "philippic": "fɪlɪpɪk",
    "philippics": "fɪlɪpɪks",
    "philistine": "fɪlɪstaɪn",
    "philistines": "fɪlɪstaɪnz",
    "philistinism": "fɪlɪstɪnɪzəm",
    "philological": "fɪləlɒdʒɪkəl",
    "philologist": "fɪlɒlədʒɪst",
    "philology": "fɪlɒlədʒi",
    "philomel": "fɪləʊməl",
    "philosopher": "fɪlɒsəfɐ",
    "philosophers": "fɪlɒsəfəz",
    "philosophical": "fɪləsɒfɪkəl",
    "philosophically": "fɪləsɒfɪkli",
    "philosophic": "fɪləsɒfɪk",
    "philosophies": "fɪlɒsəfɪz",
    "philosophise": "fɪlɒsəfaɪz",
    "philosophising": "fɪlɒsəfaɪzɪŋ",
    "philosophy": "fɪlɒsəfi",
    "phish": "fɪʃ",
    "phishing": "fɪʃɪŋ",
    "phiz": "fɪz",
    "phlebotomy": "flɛbɒtəmi",
    "phlegmatic": "flɛɡmætɪk",
    "phlegm": "flɛm",
    "phlegmy": "flɛmi",
    "phloem": "fləʊm",
    "phlox": "flɒks",
    "phobia": "fəʊbiɐ",
    "phobias": "fəʊbiəz",
    "phobic": "fəʊbɪk",
    "phobics": "fəʊbɪks",
    "phocomelia": "fɒkəmiːliə",
    "phoebe": "fiːbiː",
    "phoebes": "fiːbiːz",
    "phoenixes": "fiːnɪksɪz",
    "phoenix": "fiːnɪks",
    "phonecard": "fəʊnkɑːd",
    "phonecards": "fəʊnkɑːdz",
    "phoned": "fəʊnd",
    "phone": "fəʊn",
    "phonemes": "fəʊniːmz",
    "phones": "fəʊnz",
    "phonetically": "fənɛtɪkli",
    "phonetic": "fənɛtɪk",
    "phonetics": "fənɛtɪks",
    "phoney": "fəʊni",
    "phoneys": "fəʊnɪz",
    "phonic": "fɒnɪk",
    "phonics": "fɒnɪks",
    "phonies": "fəʊnɪz",
    "phoniness": "fəʊnɪnəs",
    "phoning": "fəʊnɪŋ",
    "phonogram": "fɒnəɡræm",
    "phonograph": "fɒnəɡræf",
    "phonographic": "fɒnəɡræfɪk",
    "phonographs": "fɒnəɡræfz",
    "phonological": "fɒnəlɒdʒɪkəl",
    "phony": "fəʊni",
    "phooey": "fuːi",
    "phosphate": "fɒsfeɪt",
    "phosphates": "fɒsfeɪts",
    "phosphorescence": "fɒsfərɛsəns",
    "phosphorescent": "fɒsfərɛsənt",
    "phosphor": "fɒsfɐ",
    "phosphoric": "fəsfɒrɪk",
    "phosphorous": "fɒsfərəs",
    "phosphorus": "fɒsfɔːrəs",
    "photochemical": "fəʊtəʊkɛmɪkəl",
    "photocopied": "fəʊtəkɒpɪd",
    "photocopier": "fəʊtəkɒpɪɐ",
    "photocopiers": "fəʊtəkɒpiəz",
    "photocopies": "fəʊtəkɒpɪz",
    "photocopy": "fəʊtəkɒpi",
    "photocopying": "fəʊtəkɒpɪɪŋ",
    "photoelectric": "fəʊtəʊɪlɛktrɪk",
    "photo": "fəʊtəʊ",
    "photogenic": "fəʊtəʊdʒɛnɪk",
    "photographed": "fəʊtəɡræfd",
    "photographer": "fətɒɡrəfɐ",
    "photographers": "fətɒɡrəfəz",
    "photograph": "fəʊtəɡræf",
    "photographically": "fəʊtəɡræfɪkli",
    "photographic": "fəʊtəɡræfɪk",
    "photographing": "fəʊtəɡræfɪŋ",
    "photographs": "fəʊtəɡræfz",
    "photography": "fətɒɡrəfi",
    "photojournalism": "fəʊtəʊdʒɜːnəlɪzəm",
    "photojournalist": "fəʊtəʊdʒɜːnəlɪst",
    "photojournalists": "fəʊtəʊdʒɜːnəlɪsts",
    "photometer": "fəʊtɒmɪtɐ",
    "photometric": "fəʊtəʊmɛtrɪk",
    "photomontage": "fəʊtəʊmɒntɑːʒ",
    "photon": "fəʊtɒn",
    "photons": "fəʊtɒnz",
    "photophobia": "fəʊtəʊfəʊbiɐ",
    "photorealism": "fəʊtəʊriəlɪzəm",
    "photoreceptor": "fəʊtəʊrɪsɛptɐ",
    "photosensitive": "fəʊtəʊsɛnsɪtɪv",
    "photos": "fəʊtəʊz",
    "photosphere": "fəʊtəʊsfiə",
    "photosynthesise": "fəʊtəʊsɪnθəsaɪz",
    "photosynthesises": "fəʊtəʊsɪnθəsaɪzɪz",
    "photosynthesis": "fəʊtəʊsɪnθəsɪs",
    "photosynthesising": "fəʊtəʊsɪnθəsaɪzɪŋ",
    "photosynthetic": "fəʊtəʊsɪnθɛtɪk",
    "photovoltaic": "fəʊtəʊvəʊlteɪɪk",
    "phrasebook": "freɪzbʊk",
    "phrased": "freɪzd",
    "phrase": "freɪz",
    "phraseology": "freɪsɒlədʒi",
    "phrases": "freɪzɪz",
    "phrasing": "freɪzɪŋ",
    "phrenic": "frɛnɪk",
    "phrenologist": "frɛnɒlədʒɪst",
    "phrenologists": "frɛnɒlədʒɪsts",
    "phrenology": "frɛnɒlədʒi",
    "phylacteries": "faɪlɐktəriz",
    "phyla": "faɪlɐ",
    "phylum": "faɪləm",
    "physical": "fɪzɪkəl",
    "physicality": "fɪzɪkælɪti",
    "physically": "fɪzɪkli",
    "physicals": "fɪzɪkəlz",
    "physic": "fɪzɪk",
    "physician": "fɪzɪʃən",
    "physicians": "fɪzɪʃənz",
    "physicist": "fɪzɪsɪst",
    "physicists": "fɪzɪsɪsts",
    "physics": "fɪzɪks",
    "physio": "fɪzɪəʊ",
    "physiognomy": "fɪzɪɒɡnəmi",
    "physiological": "fɪzɪəlɒdʒɪkəl",
    "physiologically": "fɪzɪəlɒdʒɪkli",
    "physiologist": "fɪzɪɒlədʒɪst",
    "physiologists": "fɪzɪɒlədʒɪsts",
    "physiology": "fɪzɪɒlədʒi",
    "physios": "fɪzɪəʊz",
    "physiotherapist": "fɪzɪəʊθɪreɪpɪst",
    "physiotherapists": "fɪzɪəʊθɪreɪpɪsts",
    "physiotherapy": "fɪzɪəʊθɪrəpi",
    "physique": "fɪziːk",
    "physiques": "fɪziːks",
    "phytoplankton": "faɪtəplæŋktən",
    "pianissimo": "piənɪsɪməʊ",
    "pianistic": "piənɪstɪk",
    "pianist": "piənɪst",
    "pianists": "piənɪsts",
    "pianoforte": "piənəfɔːteɪ",
    "pianola": "piənəʊlɐ",
    "pianolas": "piənəʊləz",
    "piano": "pɪænəʊ",
    "pianos": "pɪænəʊz",
    "piazza": "paɪəzɐ",
    "piazzas": "paɪəzəz",
    "pibroch": "pɪbrɒk",
    "picador": "pɪkɐdɔː",
    "pica": "piːkɐ",
    "picaresque": "pɪkeəsk",
    "piccalilli": "pɪkɐlɪli",
    "piccaninny": "pɪkɐnɪni",
    "piccolo": "pɪkɒləʊ",
    "piccolos": "pɪkɒləʊz",
    "pickaxe": "pɪkæks",
    "pickaxes": "pɪkæksɪz",
    "picked": "pɪkt",
    "picker": "pɪkɐ",
    "pickers": "pɪkəz",
    "picketed": "pɪkɪtɪd",
    "picketer": "pɪkɛtɐ",
    "picketers": "pɪkɛtəz",
    "picketing": "pɪkɪtɪŋ",
    "picket": "pɪkɪt",
    "pickets": "pɪkɪts",
    "pickier": "pɪkiɐ",
    "pickiest": "pɪkiəst",
    "picking": "pɪkɪŋ",
    "pickings": "pɪkɪŋz",
    "pickled": "pɪkəld",
    "pickle": "pɪkəl",
    "pickles": "pɪkəlz",
    "pickling": "pɪklɪŋ",
    "pick": "pɪk",
    "pickpocket": "pɪkpɒkɪt",
    "pickpockets": "pɪkpɒkɪts",
    "picks": "pɪks",
    "pickup": "pɪkʌp",
    "pickups": "pɪkʌps",
    "picky": "pɪki",
    "picnicked": "pɪknɪkt",
    "picnickers": "pɪknɪkəz",
    "picnicking": "pɪknɪkɪŋ",
    "picnic": "pɪknɪk",
    "picnics": "pɪknɪks",
    "picot": "piːkəʊt",
    "pic": "pɪk",
    "pics": "pɪks",
    "pictogram": "pɪktəɡræm",
    "pictographs": "pɪktəɡræfz",
    "pictorially": "pɪktɔːrɪəli",
    "pictorial": "pɪktɔːrɪəl",
    "pictorials": "pɪktɔːrɪəlz",
    "pictured": "pɪktʃəd",
    "picture": "pɪktʃɐ",
    "pictures": "pɪktʃəz",
    "picturesquely": "pɪktʃərɛskli",
    "picturesqueness": "pɪktʃərɛsknəs",
    "picturesque": "pɪktʃərɛsk",
    "picturing": "pɪktʃərɪŋ",
    "piddled": "pɪdəld",
    "piddle": "pɪdəl",
    "piddles": "pɪdəlz",
    "piddling": "pɪdlɪŋ",
    "piddly": "pɪdli",
    "piddock": "pɪdək",
    "pidgin": "pɪdʒɪn",
    "piebald": "piːbɔːld",
    "pieced": "piːst",
    "piecemeal": "piːsmiːl",
    "piece": "piːs",
    "pieces": "piːsɪz",
    "piecework": "piːswɜːk",
    "piecing": "piːsɪŋ",
    "piecrust": "paɪkrʌst",
    "piedmont": "piːdmɒnt",
    "pied": "paɪd",
    "pieing": "paɪɪŋ",
    "pie": "paɪ",
    "pierced": "piəst",
    "pierce": "piəs",
    "piercer": "piəsɐ",
    "pierces": "piəsɪz",
    "piercing": "piəsɪŋ",
    "piercings": "piəsɪŋz",
    "pier": "piə",
    "piers": "piəz",
    "pies": "paɪz",
    "piet": "paɪət",
    "piety": "paɪəti",
    "piezoelectric": "piːzəʊlɛktrɪk",
    "piffle": "pɪfəl",
    "piffling": "pɪflɪŋ",
    "pigeonholed": "pɪdʒənhəʊld",
    "pigeonhole": "pɪdʒənhəʊl",
    "pigeonholes": "pɪdʒənhəʊlz",
    "pigeonholing": "pɪdʒənhəʊlɪŋ",
    "pigeon": "pɪdʒən",
    "pigeons": "pɪdʒənz",
    "pigged": "pɪɡd",
    "piggery": "pɪɡəri",
    "piggies": "pɪɡɪz",
    "pigging": "pɪɡɪŋ",
    "piggish": "pɪɡɪʃ",
    "piggybacked": "pɪɡɪbækt",
    "piggybacking": "pɪɡɪbækɪŋ",
    "piggyback": "pɪɡɪbæk",
    "piggybacks": "pɪɡɪbæks",
    "piggy": "pɪɡi",
    "pigheaded": "pɪɡhɛdɪd",
    "piglet": "pɪɡlət",
    "piglets": "pɪɡləts",
    "pigling": "pɪɡlɪŋ",
    "pigmentation": "pɪɡmənteɪʃən",
    "pigmented": "pɪɡmɛntɪd",
    "pigment": "pɪɡmənt",
    "pigments": "pɪɡmənts",
    "pigmy": "pɪɡmi",
    "pignut": "pɪɡnʌt",
    "pignuts": "pɪɡnʌts",
    "pig": "pɪɡ",
    "pigpen": "pɪɡpən",
    "pigskin": "pɪɡskɪn",
    "pigs": "pɪɡz",
    "pigsties": "pɪɡstaɪz",
    "pigsty": "pɪɡstaɪ",
    "pigtailed": "pɪɡteɪld",
    "pigtail": "pɪɡteɪl",
    "pigtails": "pɪɡteɪlz",
    "pika": "piːkɐ",
    "piked": "paɪkt",
    "pikeman": "paɪkmən",
    "pike": "paɪk",
    "piker": "paɪkɐ",
    "pikes": "paɪks",
    "pikestaff": "paɪkstɑːf",
    "piking": "paɪkɪŋ",
    "pilaff": "pɪlæf",
    "pilaf": "pɪlæf",
    "pilaster": "pɪlɑːstɐ",
    "pilasters": "pɪlɑːstəz",
    "pilau": "pɪlaʊ",
    "pilchard": "pɪltʃəd",
    "pilchards": "pɪltʃədz",
    "piled": "paɪld",
    "pile": "paɪl",
    "piles": "paɪlz",
    "pileup": "paɪlʌp",
    "pileups": "paɪlʌps",
    "pilfered": "pɪlfəd",
    "pilferer": "pɪlfərɐ",
    "pilferers": "pɪlfərəz",
    "pilfering": "pɪlfərɪŋ",
    "pilfer": "pɪlfɐ",
    "pilfers": "pɪlfəz",
    "pilgrimage": "pɪlɡrɪmɪdʒ",
    "pilgrimages": "pɪlɡrɪmɪdʒɪz",
    "pilgrim": "pɪlɡrɪm",
    "pilgrims": "pɪlɡrɪmz",
    "piling": "paɪlɪŋ",
    "pilings": "paɪlɪŋz",
    "pillaged": "pɪlɪdʒd",
    "pillage": "pɪlɪdʒ",
    "pillagers": "pɪlɪdʒəz",
    "pillaging": "pɪlɪdʒɪŋ",
    "pillared": "pɪləd",
    "pillar": "pɪlɐ",
    "pillars": "pɪləz",
    "pillboxes": "pɪlbɒksɪz",
    "pillbox": "pɪlbɒks",
    "pilled": "pɪld",
    "pilling": "pɪlɪŋ",
    "pillion": "pɪliən",
    "pillock": "pɪlək",
    "pillocks": "pɪləks",
    "pilloried": "pɪlərid",
    "pillories": "pɪləriz",
    "pillory": "pɪləri",
    "pillowcase": "pɪləʊkeɪs",
    "pillowcases": "pɪləʊkeɪsɪz",
    "pillow": "pɪləʊ",
    "pillowslip": "pɪləʊslɪp",
    "pillows": "pɪləʊz",
    "pillowy": "pɪləʊi",
    "pill": "pɪl",
    "pills": "pɪlz",
    "pilotage": "paɪlɒtɪdʒ",
    "piloted": "paɪlətɪd",
    "piloting": "paɪlətɪŋ",
    "pilotless": "paɪlətləs",
    "pilot": "paɪlət",
    "pilots": "paɪləts",
    "pilsner": "pɪlsnɐ",
    "pimento": "pɪmɛntəʊ",
    "pimiento": "pɪmiəntəʊ",
    "pimientos": "pɪmiəntəʊz",
    "pimped": "pɪmpt",
    "pimpernel": "pɪmpənəl",
    "pimping": "pɪmpɪŋ",
    "pimpled": "pɪmpəld",
    "pimple": "pɪmpəl",
    "pimples": "pɪmpəlz",
    "pimply": "pɪmpli",
    "pimp": "pɪmp",
    "pimps": "pɪmps",
    "pinafore": "pɪnɐfɔː",
    "pinafores": "pɪnɐfɔːz",
    "pinball": "pɪnbɔːl",
    "pincer": "pɪnsɐ",
    "pincers": "pɪnsəz",
    "pinchbeck": "pɪntʃbɛk",
    "pinched": "pɪntʃt",
    "pincher": "pɪntʃɐ",
    "pinchers": "pɪntʃəz",
    "pinches": "pɪntʃɪz",
    "pinching": "pɪntʃɪŋ",
    "pinch": "pɪntʃ",
    "pincushion": "pɪnkʊʃən",
    "pincushions": "pɪnkʊʃənz",
    "pineal": "pɪniəl",
    "pineapple": "paɪnæpəl",
    "pineapples": "paɪnæpəlz",
    "pined": "paɪnd",
    "pine": "paɪn",
    "pinery": "paɪnəri",
    "pines": "paɪnz",
    "pineta": "paɪntɐ",
    "pinetum": "paɪntəm",
    "pinewood": "paɪnwʊd",
    "pinewoods": "paɪnwʊdz",
    "piney": "paɪni",
    "pinfold": "pɪnfəʊld",
    "pinged": "pɪŋd",
    "pinging": "pɪŋɪŋ",
    "ping": "pɪŋ",
    "pings": "pɪŋz",
    "pinhead": "pɪnhɛd",
    "pinheads": "pɪnhɛdz",
    "pinhole": "pɪnhəʊl",
    "pinholes": "pɪnhəʊlz",
    "pining": "paɪnɪŋ",
    "pinioned": "pɪniənd",
    "pinions": "pɪniənz",
    "pinked": "pɪŋkt",
    "pinker": "pɪŋkɐ",
    "pinkest": "pɪŋkəst",
    "pinkeye": "pɪŋkaɪ",
    "pinkie": "pɪŋki",
    "pinkies": "pɪŋkiz",
    "pinking": "pɪŋkɪŋ",
    "pinkish": "pɪŋkɪʃ",
    "pinkness": "pɪŋknəs",
    "pinko": "pɪnkəʊ",
    "pink": "pɪŋk",
    "pinks": "pɪŋks",
    "pinky": "pɪŋki",
    "pinnaces": "pɪnɪsɪz",
    "pinnacle": "pɪnəkəl",
    "pinnacles": "pɪnəkəlz",
    "pinna": "pɪnɐ",
    "pinnate": "pɪneɪt",
    "pinned": "pɪnd",
    "pinnies": "pɪnɪz",
    "pinning": "pɪnɪŋ",
    "pinny": "pɪni",
    "pinochle": "pɪnɒtʃəl",
    "pin": "pɪn",
    "pinpointed": "pɪnpɔɪntɪd",
    "pinpointing": "pɪnpɔɪntɪŋ",
    "pinpoint": "pɪnpɔɪnt",
    "pinpoints": "pɪnpɔɪnts",
    "pinprick": "pɪnprɪk",
    "pinpricks": "pɪnprɪks",
    "pins": "pɪnz",
    "pinstriped": "pɪnstraɪpt",
    "pinstripe": "pɪnstraɪp",
    "pinstripes": "pɪnstraɪps",
    "pintail": "pɪnteɪl",
    "pinto": "pɪntəʊ",
    "pint": "paɪnt",
    "pints": "paɪnts",
    "pinup": "pɪnʌp",
    "pinups": "pɪnʌps",
    "pinwheel": "pɪnwiːl",
    "pinwheels": "pɪnwiːlz",
    "pinxit": "pɪŋksɪt",
    "pinyin": "pɪnjɪn",
    "pioneered": "paɪəniəd",
    "pioneering": "paɪəniərɪŋ",
    "pioneer": "paɪəniə",
    "pioneers": "paɪəniəz",
    "pion": "pɪɒn",
    "pions": "pɪɒnz",
    "piously": "paɪəsli",
    "pious": "paɪəs",
    "pi": "paɪ",
    "piped": "paɪpt",
    "pipeful": "paɪpfəl",
    "pipeline": "paɪplaɪn",
    "pipelines": "paɪplaɪnz",
    "pipe": "paɪp",
    "piperine": "paɪpriːn",
    "piper": "paɪpɐ",
    "pipers": "paɪpəz",
    "pipes": "paɪps",
    "pipette": "pɪpɛt",
    "pipettes": "pɪpɛts",
    "pipework": "paɪpwɜːk",
    "piping": "paɪpɪŋ",
    "pipistrelle": "pɪpɪstrɛl",
    "pipistrelles": "pɪpɪstrɛlz",
    "pipit": "pɪpɪt",
    "pipits": "pɪpɪts",
    "pipkin": "pɪpkɪn",
    "pipped": "pɪpt",
    "pipping": "pɪpɪŋ",
    "pippin": "pɪpɪn",
    "pippins": "pɪpɪnz",
    "pip": "pɪp",
    "pips": "pɪps",
    "pipsqueak": "pɪpskwiːk",
    "pipsqueaks": "pɪpskwiːks",
    "piquancy": "pɪkwənsi",
    "piquant": "piːkənt",
    "piqued": "piːkd",
    "piquet": "pɪkeɪ",
    "piquing": "piːkɪŋ",
    "piracy": "paɪərəsi",
    "piranha": "pərɑːnɐ",
    "piranhas": "pərɑːnəz",
    "pirated": "paɪrətɪd",
    "pirate": "paɪrət",
    "pirates": "paɪrəts",
    "piratical": "pɜːrætɪkəl",
    "pirating": "paɪrətɪŋ",
    "pirog": "pɪrɒɡ",
    "pirogue": "pɪrəʊɡ",
    "pirouetted": "pɪraʊɪtɪd",
    "pirouette": "pɪraʊɛt",
    "pirouettes": "pɪraʊɛts",
    "pirouetting": "pɪraʊɪtɪŋ",
    "piscatorial": "pɪskɐtɔːrɪəl",
    "piscator": "pɪskeɪtɐ",
    "piscina": "pɪsɪnɐ",
    "pish": "pɪʃ",
    "piso": "paɪzəʊ",
    "pis": "pɪs",
    "pissed": "pɪst",
    "pisser": "pɪsɐ",
    "pisses": "pɪsɪz",
    "pissing": "pɪsɪŋ",
    "pissoir": "pɪswɑː",
    "piss": "pɪs",
    "pistachio": "pɪstæʃɪəʊ",
    "pistachios": "pɪstæʃɪəʊz",
    "piste": "pɪst",
    "pistes": "pɪsts",
    "pistol": "pɪstəl",
    "pistols": "pɪstəlz",
    "piston": "pɪstən",
    "pistons": "pɪstənz",
    "pita": "piːtɐ",
    "pitchblende": "pɪtʃbəlnd",
    "pitched": "pɪtʃt",
    "pitcher": "pɪtʃɐ",
    "pitchers": "pɪtʃəz",
    "pitches": "pɪtʃɪz",
    "pitchforking": "pɪtʃfɔːkɪŋ",
    "pitchfork": "pɪtʃfɔːk",
    "pitchforks": "pɪtʃfɔːks",
    "pitching": "pɪtʃɪŋ",
    "pitch": "pɪtʃ",
    "pitchy": "pɪtʃi",
    "piteously": "pɪtiəsli",
    "piteous": "pɪtiəs",
    "pitfall": "pɪtfɔːl",
    "pitfalls": "pɪtfɔːlz",
    "pithead": "pɪthɛd",
    "pitheads": "pɪthɛdz",
    "pithecanthropus": "pɪθɪkɑːnθrɒpəs",
    "pithier": "pɪθɪɐ",
    "pithily": "pɪθɪli",
    "pithos": "pɪθəʊz",
    "pith": "pɪθ",
    "pithy": "pɪθi",
    "pitiable": "pɪtɪəbəl",
    "pitied": "pɪtid",
    "pities": "pɪtiz",
    "pitifully": "pɪtɪfəli",
    "pitiful": "pɪtifəl",
    "pitilessly": "pɪtiləsli",
    "pitiless": "pɪtiləs",
    "pitman": "pɪtmən",
    "piton": "pɪtən",
    "pitons": "pɪtənz",
    "pit": "pɪt",
    "pits": "pɪts",
    "pittance": "pɪtəns",
    "pitta": "pɪtɐ",
    "pittas": "pɪtəz",
    "pitted": "pɪtɪd",
    "pitting": "pɪtɪŋ",
    "pituitary": "pɪtjuːɪtəri",
    "pitying": "pɪtiɪŋ",
    "pity": "pɪti",
    "pivotal": "pɪvətəl",
    "pivoted": "pɪvətɪd",
    "pivoting": "pɪvətɪŋ",
    "pivot": "pɪvət",
    "pivots": "pɪvəts",
    "pixelate": "pɪksɪleɪt",
    "pixel": "pɪksəl",
    "pixels": "pɪksəlz",
    "pixie": "pɪksi",
    "pixies": "pɪksɪz",
    "pixilated": "pɪksɪleɪtɪd",
    "pixilation": "pɪksɪleɪʃən",
    "pixillated": "pɪksɪleɪtɪd",
    "pix": "pɪks",
    "pizazz": "pɪzæz",
    "pizza": "piːtsɐ",
    "pizzas": "piːtsəz",
    "pizzazz": "piːtsæz",
    "pizzeria": "piːtsəriə",
    "pizzerias": "piːtsəriəz",
    "pizzicato": "piːtsɪkɑːtəʊ",
    "placard": "plækɑːd",
    "placards": "plækɑːdz",
    "placated": "plɐkeɪtɪd",
    "placate": "plɐkeɪt",
    "placates": "plɐkeɪts",
    "placating": "plɐkeɪtɪŋ",
    "placatory": "plɐkætəri",
    "placebo": "pləsiːbəʊ",
    "placebos": "pləsiːbəʊz",
    "placed": "pleɪst",
    "placeholder": "pleɪshəʊldɐ",
    "placeman": "pleɪsmən",
    "placemen": "pleɪsmɛn",
    "placement": "pleɪsmənt",
    "placements": "pleɪsmənts",
    "placental": "pləsɛntəl",
    "placenta": "pləsɛntɐ",
    "placentas": "pləsɛntəz",
    "place": "pleɪs",
    "placers": "pleɪsəz",
    "places": "pleɪsɪz",
    "placidity": "plæsɪdɪti",
    "placidly": "plæsɪdli",
    "placid": "plæsɪd",
    "placing": "pleɪsɪŋ",
    "placings": "pleɪsɪŋz",
    "placket": "plækɪt",
    "plagiarised": "pleɪdʒəraɪzd",
    "plagiarise": "pleɪdʒəraɪz",
    "plagiarising": "pleɪdʒəraɪzɪŋ",
    "plagiarism": "pleɪdʒərɪzəm",
    "plagiarist": "pleɪdʒərɪst",
    "plagued": "pleɪɡd",
    "plague": "pleɪɡ",
    "plagues": "pleɪɡz",
    "plaguing": "pleɪɡɪŋ",
    "plaice": "pleɪs",
    "plaid": "pleɪd",
    "plaids": "pleɪdz",
    "plainchant": "pleɪntʃənt",
    "plainclothes": "pleɪŋkləʊðz",
    "plainer": "pleɪnɐ",
    "plainest": "pleɪnəst",
    "plainly": "pleɪnli",
    "plainness": "pleɪnnəs",
    "plain": "pleɪn",
    "plainsong": "pleɪnsɒŋ",
    "plains": "pleɪnz",
    "plaintiff": "pleɪntɪf",
    "plaintiffs": "pleɪntɪfs",
    "plaintive": "pleɪntɪv",
    "plaint": "pleɪnt",
    "plaints": "pleɪnts",
    "plaited": "pleɪtɪd",
    "plaiting": "pleɪtɪŋ",
    "plait": "pleɪt",
    "plaits": "pleɪts",
    "planchette": "plɑːntʃɛt",
    "planed": "pleɪnd",
    "planeload": "pleɪnləʊd",
    "planeloads": "pleɪnləʊdz",
    "plane": "pleɪn",
    "planer": "pleɪnɐ",
    "planes": "pleɪnz",
    "planetarium": "plænɪteəriəm",
    "planetary": "plænɪtəri",
    "planetoid": "plænɪtɔɪd",
    "planet": "plænɪt",
    "planets": "plænɪts",
    "plangent": "plændʒənt",
    "planing": "pleɪnɪŋ",
    "planish": "plænɪʃ",
    "planked": "plæŋkt",
    "planking": "plæŋkɪŋ",
    "plank": "plæŋk",
    "planks": "plæŋks",
    "planktonic": "plæŋktɒnɪk",
    "plankton": "plæŋktən",
    "planned": "plænd",
    "planner": "plænɐ",
    "planners": "plænəz",
    "planning": "plænɪŋ",
    "plannings": "plænɪŋz",
    "plan": "plæn",
    "plans": "plænz",
    "plantain": "plɑːnteɪn",
    "plantains": "plɑːnteɪnz",
    "plantar": "plɑːntɐ",
    "plantation": "plɑːnteɪʃən",
    "plantations": "plɑːnteɪʃənz",
    "planted": "plæntɪd",
    "planter": "plɑːntɐ",
    "planters": "plɑːntəz",
    "plantigrade": "plɑːntɪɡreɪd",
    "planting": "plæntɪŋ",
    "plantings": "plæntɪŋz",
    "plant": "plænt",
    "plants": "plænts",
    "plaque": "plæk",
    "plaques": "plæks",
    "plash": "plæʃ",
    "plasma": "plæzmɐ",
    "plasmas": "plæzməz",
    "plasmic": "plæzmɪk",
    "plasmid": "plæzmɪd",
    "plasmodium": "plæzməʊdiəm",
    "plasm": "plæzəm",
    "plasterboard": "plɑːstəbɔːd",
    "plastered": "plɑːstəd",
    "plasterer": "plɑːstərɐ",
    "plasterers": "plɑːstərəz",
    "plastering": "plɑːstərɪŋ",
    "plaster": "plɑːstɐ",
    "plasters": "plɑːstəz",
    "plasterwork": "plɑːstəwɜːk",
    "plasticine": "plɑːstɪsiːn",
    "plasticiser": "plɑːstɪsaɪzɐ",
    "plasticity": "plɑːstɪsɪti",
    "plastic": "plɑːstɪk",
    "plastics": "plɑːstɪks",
    "plastique": "plɑːstiːk",
    "plateaued": "plætəʊd",
    "plateauing": "plætəʊɪŋ",
    "plateau": "plætəʊ",
    "plateaus": "plætəʊz",
    "plateaux": "plætəʊ",
    "plated": "pleɪtɪd",
    "plateful": "pleɪtfəl",
    "platefuls": "pleɪtfəlz",
    "platelet": "pleɪtlət",
    "platelets": "pleɪtləts",
    "platen": "pleɪtən",
    "plate": "pleɪt",
    "plater": "pleɪtɐ",
    "plates": "pleɪts",
    "platform": "plætfɔːm",
    "platforms": "plætfɔːmz",
    "plating": "pleɪtɪŋ",
    "platinum": "plætɪnəm",
    "platitude": "plætɪtjuːd",
    "platitudes": "plætɪtjuːdz",
    "platonically": "plætɒnɪkli",
    "platonic": "plætɒnɪk",
    "platoon": "plɐtuːn",
    "platoons": "plɐtuːnz",
    "plats": "plæts",
    "platted": "plætɪd",
    "platter": "plætɐ",
    "platters": "plætəz",
    "platting": "plætɪŋ",
    "platypuses": "plætɪpjuːsɪz",
    "platypus": "plætɪpəs",
    "plaudit": "plɔːdɪt",
    "plaudits": "plɔːdɪts",
    "plausibility": "plɔːzəbɪlɪti",
    "plausible": "plɔːzəbəl",
    "plausibly": "plɔːzəbli",
    "playable": "pleɪəbəl",
    "playacting": "pleɪæktɪŋ",
    "playa": "pleɪɐ",
    "playback": "pleɪbæk",
    "playbill": "pleɪbɪl",
    "playbook": "pleɪbʊk",
    "playboy": "pleɪbɔɪ",
    "playboys": "pleɪbɔɪz",
    "played": "pleɪd",
    "player": "pleɪɐ",
    "players": "pleɪəz",
    "playfully": "pleɪfəli",
    "playfulness": "pleɪfəlnəs",
    "playful": "pleɪfəl",
    "playgirl": "pleɪɡɜːl",
    "playgoers": "pleɪɡəʊəz",
    "playground": "pleɪɡraʊnd",
    "playgrounds": "pleɪɡraʊndz",
    "playgroup": "pleɪɡruːp",
    "playgroups": "pleɪɡruːps",
    "playhouse": "pleɪhaʊs",
    "playhouses": "pleɪhaʊzɪz",
    "playing": "pleɪɪŋ",
    "playlet": "pleɪlət",
    "playmate": "pleɪmeɪt",
    "playmates": "pleɪmeɪts",
    "playoff": "pleɪɒf",
    "playoffs": "pleɪɒfs",
    "playpen": "pleɪpən",
    "play": "pleɪ",
    "playroom": "pleɪruːm",
    "playrooms": "pleɪruːmz",
    "playschool": "pleɪskuːl",
    "plays": "pleɪz",
    "playsuit": "pleɪsuːt",
    "plaything": "pleɪθɪŋ",
    "playthings": "pleɪθɪŋz",
    "playtime": "pleɪtaɪm",
    "playwright": "pleɪraɪt",
    "playwrights": "pleɪraɪts",
    "playwriting": "pleɪraɪtɪŋ",
    "plaza": "plɑːzɐ",
    "plazas": "plɑːzəz",
    "pleached": "pliːtʃt",
    "pleaches": "pliːtʃɪz",
    "pleaching": "pliːtʃɪŋ",
    "pleach": "pliːtʃ",
    "pleaded": "pliːdɪd",
    "pleader": "pliːdɐ",
    "pleadingly": "pliːdɪŋli",
    "pleading": "pliːdɪŋ",
    "pleadings": "pliːdɪŋz",
    "plead": "pliːd",
    "pleads": "pliːdz",
    "plea": "pliː",
    "pleasance": "plɛzəns",
    "pleasanter": "plɛzɑːntɐ",
    "pleasantest": "plɛzɑːntəst",
    "pleasantly": "plɛzəntli",
    "pleasantness": "plɛzəntnəs",
    "pleasant": "plɛzənt",
    "pleasantries": "plɛzəntriz",
    "pleasantry": "plɛzəntri",
    "pleased": "pliːzd",
    "please": "pliːz",
    "pleases": "pliːzɪz",
    "pleasingly": "pliːzɪŋli",
    "pleasing": "pliːzɪŋ",
    "pleas": "pliːz",
    "pleasurable": "plɛʒərəbəl",
    "pleasurably": "plɛʒərəbli",
    "pleasured": "plɛʒəd",
    "pleasure": "plɛʒɐ",
    "pleasures": "plɛʒəz",
    "pleasuring": "plɛʒərɪŋ",
    "pleated": "pliːtɪd",
    "pleating": "pliːtɪŋ",
    "pleat": "pliːt",
    "pleats": "pliːts",
    "plebby": "plɛbi",
    "plebeian": "pləbiːən",
    "plebeians": "plɛbeɪənz",
    "plebe": "pliːb",
    "plebes": "pliːbz",
    "plebiscite": "plɛbɪsaɪt",
    "pleb": "plɛb",
    "plebs": "plɛbz",
    "plectrum": "plɛktrəm",
    "plectrums": "plɛktrəmz",
    "pledged": "plɛdʒd",
    "pledge": "plɛdʒ",
    "pledger": "plɛdʒɐ",
    "pledges": "plɛdʒɪz",
    "pledget": "plɛdʒɪt",
    "pledging": "plɛdʒɪŋ",
    "pled": "plɛd",
    "plena": "pliːnɐ",
    "plenary": "pliːnəri",
    "plenipotentiary": "plɛnɪpətɛnʃjəri",
    "plenitude": "plɛnɪtjuːd",
    "plenteously": "plɛntiəsli",
    "plenteous": "plɛntiəs",
    "plentifully": "plɛntɪfəli",
    "plentiful": "plɛntɪfəl",
    "plenty": "plɛnti",
    "plenum": "plɛnəm",
    "plesiosaur": "pliːzɪɒsɔː",
    "plesiosaurs": "pliːzɪɒsɔːz",
    "plesiosaurus": "pliːzɪəsɔːrəs",
    "plethora": "plɛθərɐ",
    "pleural": "plɜːrəl",
    "pleura": "plɜːrɐ",
    "pleurisy": "plɜːrəsi",
    "plexiglass": "plɛksɪɡlɑːs",
    "plexor": "plɛksɐ",
    "plexus": "plɛksəs",
    "pliability": "plaɪəbɪlɪti",
    "pliable": "plaɪəbəl",
    "pliant": "plaɪənt",
    "plied": "plaɪd",
    "plier": "plaɪə",
    "pliers": "plaɪəz",
    "plighting": "plaɪtɪŋ",
    "plight": "plaɪt",
    "plights": "plaɪts",
    "plimsoll": "plɪmsɒl",
    "plimsolls": "plɪmsɒlz",
    "plinth": "plɪnθ",
    "plinths": "plɪnθs",
    "plodded": "plɒdɪd",
    "plodder": "plɒdɐ",
    "plodders": "plɒdəz",
    "plodding": "plɒdɪŋ",
    "plod": "plɒd",
    "plods": "plɒdz",
    "plonked": "plɒŋkt",
    "plonker": "plɒŋkɐ",
    "plonkers": "plɒŋkəz",
    "plonking": "plɒŋkɪŋ",
    "plonk": "plɒŋk",
    "plonks": "plɒŋks",
    "plopped": "plɒpt",
    "plopping": "plɒpɪŋ",
    "plop": "plɒp",
    "plops": "plɒps",
    "plot": "plɒt",
    "plots": "plɒts",
    "plotted": "plɒtɪd",
    "plotter": "plɒtɐ",
    "plotters": "plɒtəz",
    "plotting": "plɒtɪŋ",
    "ploughboy": "plaʊbɔɪ",
    "ploughed": "plaʊd",
    "ploughing": "plaʊɪŋ",
    "ploughman": "plaʊmən",
    "ploughmen": "plaʊmɛn",
    "plough": "plaʊ",
    "ploughshare": "plaʊʃeə",
    "ploughshares": "plaʊʃeəz",
    "ploughs": "plaʊz",
    "plover": "plʌvɐ",
    "plovers": "plʌvəz",
    "plowman": "plaʊmən",
    "ploy": "plɔɪ",
    "ploys": "plɔɪz",
    "plucked": "plʌkt",
    "plucker": "plʌkɐ",
    "pluckiest": "plʌkiəst",
    "plucking": "plʌkɪŋ",
    "pluck": "plʌk",
    "plucks": "plʌks",
    "plucky": "plʌki",
    "plugged": "plʌɡd",
    "plugging": "plʌɡɪŋ",
    "plughole": "plʌɡhəʊl",
    "plugholes": "plʌɡhəʊlz",
    "plug": "plʌɡ",
    "plugs": "plʌɡz",
    "plumaged": "pluːmɪdʒd",
    "plumage": "pluːmɪdʒ",
    "plumbago": "plʌmbeɪɡəʊ",
    "plumbed": "plʌmd",
    "plumber": "plʌmɐ",
    "plumbers": "plʌməz",
    "plumbing": "plʌmɪŋ",
    "plumb": "plʌm",
    "plumbs": "plʌmz",
    "plumbum": "plʌmbəm",
    "plumed": "pluːmd",
    "plume": "pluːm",
    "plumes": "pluːmz",
    "pluming": "pluːmɪŋ",
    "plummer": "plʌmɐ",
    "plummeted": "plʌmɪtɪd",
    "plummeting": "plʌmɪtɪŋ",
    "plummet": "plʌmɪt",
    "plummets": "plʌmɪts",
    "plummy": "plʌmi",
    "plumose": "pluːməʊz",
    "plumped": "plʌmpt",
    "plumper": "plʌmpɐ",
    "plumpest": "plʌmpəst",
    "plumping": "plʌmpɪŋ",
    "plum": "plʌm",
    "plumpness": "plʌmpnəs",
    "plump": "plʌmp",
    "plumps": "plʌmps",
    "plums": "plʌmz",
    "plumy": "plʌmi",
    "plundered": "plʌndəd",
    "plunderer": "plʌndərɐ",
    "plunderers": "plʌndərəz",
    "plundering": "plʌndərɪŋ",
    "plunder": "plʌndɐ",
    "plunders": "plʌndəz",
    "plunged": "plʌndʒd",
    "plunge": "plʌndʒ",
    "plunger": "plʌndʒɐ",
    "plungers": "plʌndʒəz",
    "plunges": "plʌndʒɪz",
    "plunging": "plʌndʒɪŋ",
    "plunked": "plʌŋkt",
    "plunking": "plʌŋkɪŋ",
    "plunk": "plʌŋk",
    "pluperfect": "pluːpəfɛkt",
    "pluralising": "plɔːrəlaɪzɪŋ",
    "pluralism": "plɔːrəlɪzəm",
    "pluralistic": "plɔːrəlɪstɪk",
    "pluralist": "plɔːrəlɪst",
    "plurality": "plɔːrælɪti",
    "plural": "plɔːrəl",
    "plurals": "plɔːrəlz",
    "pluses": "plʌsɪz",
    "plusher": "plʌʃɐ",
    "plushest": "plʌʃəst",
    "plushness": "plʌʃnəs",
    "plush": "plʌʃ",
    "plushy": "plʌʃi",
    "plus": "plʌs",
    "plusses": "plʌsɪz",
    "plutocracy": "pluːtɒkrəsi",
    "plutocrat": "pluːtəkræt",
    "plutocrats": "pluːtəkræts",
    "plutonium": "pluːtəʊniəm",
    "pluviometer": "pluːvaɪɒmiːtɐ",
    "plying": "plaɪɪŋ",
    "ply": "plaɪ",
    "plywood": "plaɪwʊd",
    "pneumatically": "njuːmætɪkli",
    "pneumatic": "njuːmætɪk",
    "pneumatics": "njuːmætɪks",
    "pneumococcal": "njuːməkɒkəl",
    "pneumoconiosis": "njuːməkəʊnɪəʊsɪs",
    "pneumonectomy": "njuːmənɛktəmi",
    "pneumonia": "njuːməʊniə",
    "pneumonic": "njuːmɒnɪk",
    "pneumothorax": "njuːməθɔːræks",
    "poached": "pəʊtʃt",
    "poacher": "pəʊtʃɐ",
    "poachers": "pəʊtʃəz",
    "poaches": "pəʊtʃɪz",
    "poaching": "pəʊtʃɪŋ",
    "poach": "pəʊtʃ",
    "pochard": "pɒtʃəd",
    "pocked": "pɒkt",
    "pocketbook": "pɒkɪtbʊk",
    "pocketbooks": "pɒkɪtbʊks",
    "pocketed": "pɒkɪtɪd",
    "pocketful": "pɒkɪtfəl",
    "pocketing": "pɒkɪtɪŋ",
    "pocketknife": "pɒkɪtnaɪf",
    "pocket": "pɒkɪt",
    "pockets": "pɒkɪts",
    "pocking": "pɒkɪŋ",
    "pockmarked": "pɒkmɑːkt",
    "pockmark": "pɒkmɑːk",
    "pockmarks": "pɒkmɑːks",
    "pock": "pɒk",
    "pocks": "pɒks",
    "poco": "pəʊkəʊ",
    "podcast": "pɒdkɑːst",
    "podded": "pɒdɪd",
    "podding": "pɒdɪŋ",
    "podgy": "pɒdʒi",
    "podia": "pəʊdiɐ",
    "podiatrist": "pəʊdɪætrɪst",
    "podiatrists": "pəʊdɪætrɪsts",
    "podiatry": "pəʊdɪətri",
    "podium": "pəʊdiəm",
    "podiums": "pəʊdiəmz",
    "pod": "pɒd",
    "pods": "pɒdz",
    "poem": "pəʊɪm",
    "poems": "pəʊɪmz",
    "poe": "pəʊ",
    "poesy": "pəʊsi",
    "poetically": "pəʊɛtɪkli",
    "poetical": "pəʊɛtɪkəl",
    "poetic": "pəʊɛtɪk",
    "poetics": "pəʊɛtɪks",
    "poet": "pəʊɪt",
    "poetry": "pəʊɪtri",
    "poets": "pəʊɪts",
    "pogo": "pəʊɡəʊ",
    "pogrom": "pɒɡrɒm",
    "pogroms": "pɒɡrɒmz",
    "poignancy": "pɔɪnjənsi",
    "poignantly": "pɔɪnjəntli",
    "poignant": "pɔɪnjənt",
    "poilu": "pɔɪluː",
    "poinsettia": "pɔɪnsɛtiə",
    "poinsettias": "pɔɪnsɛtiəz",
    "pointedly": "pɔɪntɪdli",
    "pointed": "pɔɪntɪd",
    "pointer": "pɔɪntɐ",
    "pointers": "pɔɪntəz",
    "pointier": "pɔɪntɪɐ",
    "pointiest": "pɔɪntɪəst",
    "pointillism": "pɔɪntɪlɪzəm",
    "pointillist": "pɔɪntɪlɪst",
    "pointing": "pɔɪntɪŋ",
    "pointlessly": "pɔɪntləsli",
    "pointlessness": "pɔɪntləsnəs",
    "pointless": "pɔɪntləs",
    "point": "pɔɪnt",
    "points": "pɔɪnts",
    "pointy": "pɔɪnti",
    "poi": "pɔɪ",
    "poised": "pɔɪzd",
    "poising": "pɔɪzɪŋ",
    "poisoned": "pɔɪzənd",
    "poisoner": "pɔɪzənɐ",
    "poisoners": "pɔɪzənəz",
    "poisoning": "pɔɪzənɪŋ",
    "poisonings": "pɔɪzənɪŋz",
    "poisonously": "pɔɪzənəsli",
    "poisonous": "pɔɪzənəs",
    "poison": "pɔɪzən",
    "poisons": "pɔɪzənz",
    "poked": "pəʊkt",
    "poke": "pəʊk",
    "poker": "pəʊkɐ",
    "pokers": "pəʊkəz",
    "pokes": "pəʊks",
    "pokey": "pəʊki",
    "poking": "pəʊkɪŋ",
    "poky": "pəʊki",
    "polarisation": "pəʊləraɪzeɪʃən",
    "polarised": "pəʊləraɪzd",
    "polarise": "pəʊləraɪz",
    "polariser": "pəʊlɑːraɪzɐ",
    "polarises": "pəʊləraɪzɪz",
    "polarising": "pəʊləraɪzɪŋ",
    "polarities": "pəʊlærɪtiz",
    "polarity": "pəʊlærɪti",
    "polar": "pəʊlɐ",
    "polder": "pəʊldɐ",
    "poleaxed": "pəʊlækst",
    "poleaxe": "pəʊleɪks",
    "polecat": "pəʊlkæt",
    "polecats": "pəʊlkæts",
    "poled": "pəʊld",
    "polemical": "pɒlɛmɪkəl",
    "polemicist": "pɒlɛmɪsɪst",
    "polemicists": "pɒlɛmɪsɪsts",
    "polemic": "pɒlɛmɪk",
    "polemics": "pɒlɛmɪks",
    "polenta": "pəʊlɛntɐ",
    "pole": "pəʊl",
    "poles": "pəʊlz",
    "polestar": "pəʊlstɑː",
    "policed": "pəliːsd",
    "policeman": "pəliːsmən",
    "policemen": "pəliːsmɛn",
    "police": "pəliːs",
    "polices": "pəliːsɪz",
    "policewoman": "pəliːswʊmən",
    "policewomen": "pəliːswɪmɪn",
    "policies": "pɒlɪsɪz",
    "policing": "pəliːsɪŋ",
    "policyholder": "pɒlɪsɪhəʊldɐ",
    "policyholders": "pɒlɪsɪhəʊldəz",
    "policymakers": "pɒlɪsɪmeɪkəz",
    "policymaking": "pɒlɪsɪmeɪkɪŋ",
    "policy": "pɒlɪsi",
    "poling": "pəʊlɪŋ",
    "poliomyelitis": "pəʊlɪɒmɪɪlaɪtɪs",
    "polio": "pəʊlɪəʊ",
    "polished": "pɒlɪʃt",
    "polisher": "pɒlɪʃɐ",
    "polishers": "pɒlɪʃəz",
    "polishes": "pɒlɪʃɪz",
    "polishing": "pɒlɪʃɪŋ",
    "polis": "pəʊliz",
    "politburo": "pɒlɪtbjʊrəʊ",
    "politely": "pəlaɪtli",
    "politeness": "pəlaɪtnəs",
    "polite": "pəlaɪt",
    "politer": "pəlaɪtɐ",
    "politesse": "pəlaɪtəs",
    "politest": "pəlaɪtəst",
    "politically": "pəlɪtɪkli",
    "political": "pəlɪtɪkəl",
    "politician": "pɒlɪtɪʃən",
    "politicians": "pɒlɪtɪʃənz",
    "politicisation": "pɒlɪtɪsaɪzeɪʃən",
    "politicised": "pəlɪtɪsaɪzd",
    "politicise": "pəlɪtɪsaɪz",
    "politicises": "pəlɪtɪsaɪzɪz",
    "politicising": "pəlɪtɪsaɪzɪŋ",
    "politicking": "pɒlɪtɪkɪŋ",
    "politick": "pɒlɪtɪk",
    "politico": "pəlɪtɪkəʊ",
    "politicos": "pəlɪtɪkəʊz",
    "politic": "pɒlətɪk",
    "politics": "pɒlətɪks",
    "polities": "pɒlɪtiz",
    "polity": "pɒlɪti",
    "polka": "pɒlkɐ",
    "polkas": "pɒlkəz",
    "pollack": "pɒlæk",
    "pollacks": "pɒlæks",
    "pollarded": "pɒlɑːdɪd",
    "pollarding": "pɒlɑːdɪŋ",
    "pollard": "pɒlɑːd",
    "polled": "pəʊld",
    "pollen": "pɒlən",
    "pollens": "pɒlənz",
    "pollinated": "pɒlɪneɪtɪd",
    "pollinate": "pɒlɪneɪt",
    "pollinates": "pɒlɪneɪts",
    "pollinating": "pɒlɪneɪtɪŋ",
    "pollination": "pɒlɪneɪʃən",
    "pollinator": "pɒlɪneɪtɐ",
    "pollinators": "pɒlɪneɪtəz",
    "polling": "pəʊlɪŋ",
    "pollock": "pɒlək",
    "pollocks": "pɒləks",
    "pollster": "pɒlstɐ",
    "pollsters": "pɒlstəz",
    "pollutant": "pəluːtənt",
    "pollutants": "pəluːtənts",
    "polluted": "pəluːtɪd",
    "pollute": "pəluːt",
    "polluter": "pəluːtɐ",
    "polluters": "pəluːtəz",
    "pollutes": "pəluːts",
    "polluting": "pəluːtɪŋ",
    "pollution": "pəluːʃən",
    "pollutions": "pəluːʃənz",
    "pollywog": "pɒlɪwɒɡ",
    "polonaise": "pɒləneɪz",
    "polonaises": "pɒləneɪzɪz",
    "polonium": "pələʊniəm",
    "polo": "pəʊləʊ",
    "poltergeist": "pəʊltəɡaɪst",
    "poltergeists": "pəʊltəɡaɪsts",
    "poltroon": "pəʊltruːn",
    "polyandry": "pɒlɪændri",
    "polyanthus": "pɒlɪænθəs",
    "polycarbonate": "pɒlɪkɑːbəneɪt",
    "polychaete": "pɒlɪkiːt",
    "polychrome": "pɒlɪkrəʊm",
    "polychromy": "pɒlɪkrəmi",
    "polyester": "pɒlɪəstɐ",
    "polyesters": "pɒlɪɛstəz",
    "polyethylene": "pɒlɪɛθɪliːn",
    "polygamist": "pɒlɪɡæmɪst",
    "polygamists": "pɒlɪɡæmɪsts",
    "polygamous": "pɒlɪɡɐməs",
    "polygamy": "pɒlɪɡæmi",
    "polyglot": "pɒlɪɡlɒt",
    "polygonal": "pɒlɪɡənəl",
    "polygon": "pɒlɪɡən",
    "polygons": "pɒlɪɡənz",
    "polygraph": "pɒlɪɡræf",
    "polygraphs": "pɒlɪɡræfz",
    "polyhedra": "pɒlɪhiːdrɐ",
    "polymathic": "pɒlɪmæθɪk",
    "polymath": "pɒlɪmæθ",
    "polymaths": "pɒlɪmæθs",
    "polymeric": "pɒlɪmɛrɪk",
    "polymerisation": "pɒlɪməraɪzeɪʃən",
    "polymer": "pɒlɪmɐ",
    "polymers": "pɒlɪməz",
    "polymorphic": "pɒlɪmɔːfɪk",
    "polynomial": "pɒlɪnəʊmɪəl",
    "polynomials": "pɒlɪnəʊmɪəlz",
    "polypeptide": "pɒlɪpɛptaɪd",
    "polyphonic": "pɒlɪfɒnɪk",
    "polyphony": "pɒlɪfəni",
    "poly": "pɒli",
    "polyp": "pɒlɪp",
    "polypropylene": "pɒlɪprəʊpaɪliːn",
    "polyps": "pɒlɪps",
    "polys": "pɒlɪz",
    "polystyrene": "pɒlɪstaɪriːn",
    "polysyllabic": "pɒlɪsɪlæbɪk",
    "polytechnic": "pɒlɪtɛknɪk",
    "polytechnics": "pɒlɪtɛknɪks",
    "polytheistic": "pɒlɪθiːɪstɪk",
    "polythene": "pɒlɪθiːn",
    "polyunsaturated": "pɒlɪʌnsɐtʃəreɪtɪd",
    "polyunsaturates": "pɒlɪʌnsɐtʃəreɪts",
    "polyurethane": "pɒlɪjuːriːθeɪn",
    "polyvinyl": "pɒlɪvɪnaɪl",
    "pomace": "pɒmeɪs",
    "pomade": "pɒmeɪd",
    "pomander": "pɒmɑːndɐ",
    "pomegranate": "pɒmɪɡræneɪt",
    "pomegranates": "pɒmɪɡræneɪts",
    "pomelo": "pɒmiːləʊ",
    "pomelos": "pɒmiːləʊz",
    "pomfret": "pɒmfrɪt",
    "pommelled": "pɒməld",
    "pommel": "pɒməl",
    "pommels": "pɒməlz",
    "pommies": "pɒmɪz",
    "pommy": "pɒmi",
    "pomology": "pəmɒlədʒi",
    "pompadour": "pɒmpɐdɔː",
    "pom": "pɒm",
    "pompom": "pɒmpəm",
    "pompoms": "pɒmpəmz",
    "pomposity": "pəmpɒsɪti",
    "pompously": "pɒmpəsli",
    "pompousness": "pɒmpəsnəs",
    "pompous": "pɒmpəs",
    "pomp": "pɒmp",
    "poms": "pɒmz",
    "ponced": "pɒnst",
    "ponce": "pɒns",
    "ponces": "pɒnsɪz",
    "poncho": "pɒntʃəʊ",
    "ponchos": "pɒntʃəʊz",
    "poncing": "pɒnsɪŋ",
    "poncy": "pɒnsi",
    "pondered": "pɒndəd",
    "pondering": "pɒndərɪŋ",
    "ponderosa": "pɒndərəʊsɐ",
    "ponderously": "pɒndərəsli",
    "ponderous": "pɒndərəs",
    "ponder": "pɒndɐ",
    "ponders": "pɒndəz",
    "pond": "pɒnd",
    "ponds": "pɒndz",
    "pondweed": "pɒndwiːd",
    "pone": "pəʊn",
    "pones": "pəʊnz",
    "ponged": "pɒŋd",
    "ponging": "pɒŋɪŋ",
    "pong": "pɒŋ",
    "pongs": "pɒŋz",
    "ponied": "pəʊnɪd",
    "ponies": "pəʊnɪz",
    "pons": "pɒnz",
    "pontifex": "pɒntaɪfɛks",
    "pontiff": "pɒntɪf",
    "pontiffs": "pɒntɪfs",
    "pontifical": "pəntɪfɪkəl",
    "pontificating": "pəntɪfɪkeɪtɪŋ",
    "pontification": "pɒntɪfɪkeɪʃən",
    "pontine": "pɒntiːn",
    "pontoon": "pəntuːn",
    "pontoons": "pəntuːnz",
    "pony": "pəʊni",
    "ponytail": "pəʊnɪteɪl",
    "ponytails": "pəʊnɪteɪlz",
    "pooches": "puːtʃɪz",
    "pooch": "puːtʃ",
    "poodle": "puːdəl",
    "poodles": "puːdəlz",
    "pood": "puːd",
    "pooed": "puːd",
    "poof": "puːf",
    "poofs": "puːfs",
    "poofter": "puːftɐ",
    "poofters": "puːftəz",
    "poohed": "puːd",
    "poohing": "puːɪŋ",
    "pooh": "puː",
    "poohs": "puːz",
    "pooing": "puːɪŋ",
    "pooled": "puːld",
    "pooling": "puːlɪŋ",
    "pool": "puːl",
    "poolside": "puːlsaɪd",
    "pools": "puːlz",
    "poon": "puːn",
    "pooped": "puːpt",
    "pooping": "puːpɪŋ",
    "poop": "puːp",
    "poops": "puːps",
    "poo": "puː",
    "poorer": "pɔːrɐ",
    "poorest": "pɔːrəst",
    "poorhouse": "pɔːhaʊs",
    "poorly": "pɔːli",
    "poor": "pɔː",
    "poos": "puːz",
    "popcorn": "pɒpkɔːn",
    "pope": "pəʊp",
    "popery": "pəʊpəri",
    "popes": "pəʊps",
    "popgun": "pɒpɡʌn",
    "popinjay": "pɒpɪndʒeɪ",
    "popish": "pɒpɪʃ",
    "poplar": "pɒplɐ",
    "poplars": "pɒpləz",
    "poplin": "pɒplɪn",
    "popovers": "pɒpəʊvəz",
    "poppadom": "pɒpædəm",
    "poppadoms": "pɒpædəmz",
    "poppadum": "pəpædəm",
    "poppadums": "pəpædəmz",
    "poppa": "pɒpɐ",
    "popped": "pɒpt",
    "popper": "pɒpɐ",
    "poppers": "pɒpəz",
    "poppet": "pɒpɪt",
    "poppets": "pɒpɪts",
    "poppies": "pɒpɪz",
    "popping": "pɒpɪŋ",
    "popple": "pɒpəl",
    "pop": "pɒp",
    "poppycock": "pɒpɪkɒk",
    "poppy": "pɒpi",
    "pops": "pɒps",
    "populace": "pɒpjʊleɪs",
    "popularisation": "pɒpjʊləraɪzeɪʃən",
    "popularised": "pɒpjʊləraɪzd",
    "popularise": "pɒpjʊləraɪz",
    "populariser": "pɒpjʊlɑːraɪzɐ",
    "popularising": "pɒpjʊləraɪzɪŋ",
    "popularity": "pɒpjʊlærɪti",
    "popularly": "pɒpjʊləli",
    "popular": "pɒpjʊlɐ",
    "populated": "pɒpjʊleɪtɪd",
    "populate": "pɒpjʊleɪt",
    "populates": "pɒpjʊleɪts",
    "populating": "pɒpjʊleɪtɪŋ",
    "population": "pɒpjʊleɪʃən",
    "populations": "pɒpjʊleɪʃənz",
    "populism": "pɒpjuːlɪzəm",
    "populist": "pɒpjʊlɪst",
    "populists": "pɒpjʊlɪsts",
    "populous": "pɒpjʊləs",
    "porbeagle": "pɔːbiːɡəl",
    "porcelain": "pɔːsɪlɪn",
    "porcelains": "pɔːsɪlɪnz",
    "porches": "pɔːtʃɪz",
    "porch": "pɔːtʃ",
    "porcine": "pɔːsiːn",
    "porcupine": "pɔːkjuːpaɪn",
    "porcupines": "pɔːkjuːpaɪnz",
    "pored": "pɔːd",
    "pore": "pɔː",
    "pores": "pɔːz",
    "porgy": "pɔːdʒi",
    "poring": "pɔːrɪŋ",
    "porker": "pɔːkɐ",
    "porkers": "pɔːkəz",
    "porkier": "pɔːkiɐ",
    "porkies": "pɔːkiz",
    "porkpie": "pɔːkpaɪ",
    "pork": "pɔːk",
    "porky": "pɔːki",
    "pornographer": "pɔːnɒɡrəfɐ",
    "pornographers": "pɔːnɒɡrəfəz",
    "pornographic": "pɔːnəɡræfɪk",
    "pornography": "pɔːnɒɡrəfi",
    "porno": "pɔːnəʊ",
    "porn": "pɔːn",
    "porosity": "pɔːrɒsɪti",
    "porous": "pɔːrəs",
    "porphyria": "pɔːfɪriə",
    "porphyrin": "pɔːfɪrɪn",
    "porphyry": "pɔːfɪri",
    "porpoise": "pɔːpəs",
    "porpoises": "pɔːpəsɪz",
    "porpoising": "pɔːpəsɪŋ",
    "porridge": "pɒrɪdʒ",
    "porringer": "pɒrɪŋɐ",
    "porringers": "pɒrɪŋəz",
    "portability": "pɔːtəbɪlɪti",
    "portable": "pɔːtəbəl",
    "portables": "pɔːtəbəlz",
    "portage": "pɔːtɪdʒ",
    "portal": "pɔːtəl",
    "portals": "pɔːtəlz",
    "portamento": "pɔːtəmɛntəʊ",
    "portcullises": "pɔːtkəlaɪzɪz",
    "portcullis": "pɔːtkəliz",
    "ported": "pɔːtɪd",
    "portended": "pɔːtɛndɪd",
    "portend": "pɔːtɛnd",
    "portends": "pɔːtɛndz",
    "portentous": "pɔːtɛntəs",
    "portent": "pɔːtənt",
    "portents": "pɔːtənts",
    "porterage": "pɔːtərɪdʒ",
    "porterhouse": "pɔːtəhaʊs",
    "porter": "pɔːtɐ",
    "porters": "pɔːtəz",
    "portfolio": "pɔːtfəʊlɪəʊ",
    "portfolios": "pɔːtfəʊlɪəʊz",
    "porthole": "pɔːthəʊl",
    "portholes": "pɔːthəʊlz",
    "porticoes": "pɔːtɪkəʊz",
    "portico": "pɔːtɪkəʊ",
    "porticos": "pɔːtɪkəʊz",
    "porting": "pɔːtɪŋ",
    "portioned": "pɔːʃənd",
    "portioning": "pɔːʃənɪŋ",
    "portion": "pɔːʃən",
    "portions": "pɔːʃənz",
    "portly": "pɔːtli",
    "portmanteau": "pɔːtmɑːntəʊ",
    "portmanteaus": "pɔːtmɑːntəʊz",
    "port": "pɔːt",
    "portraitist": "pɔːtrɪtɪst",
    "portraitists": "pɔːtrɪtɪsts",
    "portrait": "pɔːtreɪt",
    "portraits": "pɔːtreɪts",
    "portraiture": "pɔːtrɪtʃɐ",
    "portrayal": "pɔːtreɪəl",
    "portrayals": "pɔːtreɪəlz",
    "portrayed": "pɔːtreɪd",
    "portrayer": "pɔːtreɪɐ",
    "portraying": "pɔːtreɪɪŋ",
    "portray": "pɔːtreɪ",
    "portrays": "pɔːtreɪz",
    "ports": "pɔːts",
    "posada": "pəsɑːdɐ",
    "posed": "pəʊzd",
    "pose": "pəʊz",
    "poser": "pəʊzɐ",
    "posers": "pəʊzəz",
    "poses": "pəʊzɪz",
    "poseur": "pəʊsɜː",
    "posher": "pɒʃɐ",
    "poshest": "pɒʃəst",
    "poshness": "pɒʃnəs",
    "posh": "pɒʃ",
    "posies": "pəʊzɪz",
    "posing": "pəʊzɪŋ",
    "posited": "pɒsɪtɪd",
    "positing": "pɒsɪtɪŋ",
    "positionally": "pəzɪʃənəli",
    "positional": "pəzɪʃənəl",
    "positioned": "pəzɪʃənd",
    "positioner": "pəzɪʃənɐ",
    "positioning": "pəzɪʃənɪŋ",
    "position": "pəzɪʃən",
    "positions": "pəzɪʃənz",
    "positively": "pɒzɪtɪvli",
    "positiveness": "pɒzɪtɪvnəs",
    "positive": "pɒzɪtɪv",
    "positives": "pɒzɪtɪvz",
    "positivism": "pɒzɪtɪvɪzəm",
    "positivity": "pɒzɪtɪvɪti",
    "posit": "pɒsɪt",
    "positron": "pɒsɪtrɒn",
    "positrons": "pɒsɪtrɒnz",
    "posits": "pɒsɪts",
    "posse": "pɒsi",
    "posses": "pɒsɪz",
    "possessed": "pəzɛst",
    "possesses": "pəzɛsɪz",
    "possessing": "pəzɛsɪŋ",
    "possession": "pəzɛʃən",
    "possessions": "pəzɛʃənz",
    "possessively": "pəzɛsɪvli",
    "possessiveness": "pəzɛsɪvnəs",
    "possessive": "pəzɛsɪv",
    "possessor": "pəzɛsɐ",
    "possessors": "pəzɛsəz",
    "possessory": "pəzɛsəri",
    "possess": "pəzɛs",
    "posset": "pɒsɛt",
    "possets": "pɒsɛts",
    "possibilities": "pɒsəbɪlɪtiz",
    "possibility": "pɒsəbɪlɪti",
    "possible": "pɒsəbəl",
    "possibles": "pɒsəbəlz",
    "possibly": "pɒsəbli",
    "possie": "pɒsi",
    "possum": "pɒsəm",
    "possums": "pɒsəmz",
    "postage": "pəʊstɪdʒ",
    "postal": "pəʊstəl",
    "postbag": "pəʊstbæɡ",
    "postbags": "pəʊstbæɡz",
    "postboxes": "pəʊstbɒksɪz",
    "postbox": "pəʊstbɒks",
    "postcard": "pəʊstkɑːd",
    "postcards": "pəʊstkɑːdz",
    "postcode": "pəʊstkəʊd",
    "postcodes": "pəʊstkəʊdz",
    "postdated": "pəʊstdeɪtɪd",
    "posted": "pəʊstɪd",
    "posteriorly": "pɒstiərɪəli",
    "posterior": "pɒstiərɪɐ",
    "posteriors": "pɒstiərɪəz",
    "posterity": "pɒstɛrɪti",
    "postern": "pəʊstən",
    "poster": "pəʊstɐ",
    "posters": "pəʊstəz",
    "postgraduate": "pəʊstɡrɐdjuːeɪt",
    "postgraduates": "pəʊstɡrɐdjuːeɪts",
    "posthumously": "pəʊsthjuːməsli",
    "posthumous": "pəʊsthjuːməs",
    "postie": "pəʊsti",
    "posties": "pəʊstɪz",
    "postillion": "pəʊstɪliən",
    "posting": "pəʊstɪŋ",
    "postings": "pəʊstɪŋz",
    "postlude": "pəʊstluːd",
    "postman": "pəʊstmən",
    "postmarked": "pəʊstmɑːkt",
    "postmark": "pəʊstmɑːk",
    "postmarks": "pəʊstmɑːks",
    "postmaster": "pəʊstmɑːstɐ",
    "postmasters": "pəʊstmɑːstəz",
    "postmen": "pəʊstmɛn",
    "postmistress": "pəʊstmɪstrəs",
    "postmodernism": "pəʊstmədənɪzəm",
    "postmodern": "pəʊstmɒdən",
    "postmortem": "pəʊstmɔːtəm",
    "postmortems": "pəʊstmɔːtəmz",
    "postnatally": "pəʊstneɪtəli",
    "postnatal": "pəʊstneɪtəl",
    "postpartum": "pəʊstpɑːtəm",
    "post": "pəʊst",
    "postponed": "pəʊstpəʊnd",
    "postponement": "pəʊstpəʊnmənt",
    "postponements": "pəʊstpəʊnmənts",
    "postpone": "pəʊstpəʊn",
    "postpones": "pəʊstpəʊnz",
    "postponing": "pəʊstpəʊnɪŋ",
    "postprandial": "pəʊstprændɪəl",
    "postscript": "pəʊstskrɪpt",
    "posts": "pəʊsts",
    "postulancy": "pɒstjʊlənsi",
    "postulated": "pɒstʃʊleɪtɪd",
    "postulates": "pɒstʃʊleɪts",
    "postulating": "pɒstʃʊleɪtɪŋ",
    "postural": "pɒstʃərəl",
    "posture": "pɒstʃɐ",
    "postures": "pɒstʃəz",
    "posturing": "pɒstʃərɪŋ",
    "postwar": "pəʊstwɔː",
    "postwoman": "pəʊstwʊmən",
    "posy": "pəʊzi",
    "potable": "pəʊtəbəl",
    "potage": "pɒtɪdʒ",
    "potages": "pɒtɪdʒɪz",
    "potash": "pɒtæʃ",
    "potassium": "pətæsiəm",
    "potations": "pəteɪʃənz",
    "potatoes": "pəteɪtəʊz",
    "potato": "pəteɪtəʊ",
    "potbellied": "pɒtbɛlɪd",
    "potbelly": "pɒtbɛli",
    "potboiler": "pɒtbɔɪlɐ",
    "potboilers": "pɒtbɔɪləz",
    "poteen": "pəʊtən",
    "potence": "pəʊtəns",
    "potency": "pəʊtənsi",
    "potentate": "pəʊtənteɪt",
    "potentates": "pəʊtənteɪts",
    "potentiality": "pətɛnʃɪælɪti",
    "potentially": "pətɛnʃəli",
    "potential": "pətɛnʃəl",
    "potentials": "pətɛnʃəlz",
    "potentilla": "pətɪntɪlɐ",
    "potently": "pəʊtəntli",
    "potent": "pəʊtənt",
    "potful": "pɒtfəl",
    "pothead": "pɒthɛd",
    "potheads": "pɒthɛdz",
    "potholed": "pɒthəʊld",
    "pothole": "pɒthəʊl",
    "potholer": "pɒthəʊlɐ",
    "potholers": "pɒthəʊləz",
    "potholes": "pɒthəʊlz",
    "potholing": "pɒthəʊlɪŋ",
    "potion": "pəʊʃən",
    "potions": "pəʊʃənz",
    "potluck": "pɒtlʌk",
    "potman": "pɒtmən",
    "potpourri": "pɒtpɔːri",
    "pot": "pɒt",
    "potsherds": "pɒtʃɜːdz",
    "potshots": "pɒtʃɒts",
    "pots": "pɒts",
    "pottage": "pɒtɪdʒ",
    "potted": "pɒtɪd",
    "pottered": "pɒtəd",
    "potteries": "pɒtəriz",
    "pottering": "pɒtərɪŋ",
    "potter": "pɒtɐ",
    "potters": "pɒtəz",
    "pottery": "pɒtəri",
    "potties": "pɒtɪz",
    "potting": "pɒtɪŋ",
    "pottle": "pɒtəl",
    "potto": "pɒtəʊ",
    "potty": "pɒti",
    "pouched": "paʊtʃt",
    "pouches": "paʊtʃɪz",
    "pouch": "paʊtʃ",
    "pouffe": "puːf",
    "pouf": "puːf",
    "poulterer": "pəʊltərɐ",
    "poultice": "pəʊltɪs",
    "poultices": "pəʊltɪsɪz",
    "poult": "pəʊlt",
    "poultry": "pəʊltri",
    "pounced": "paʊnst",
    "pounce": "paʊns",
    "pounces": "paʊnsɪz",
    "pouncing": "paʊnsɪŋ",
    "poundage": "paʊndɪdʒ",
    "pounded": "paʊndɪd",
    "pounder": "paʊndɐ",
    "pounders": "paʊndəz",
    "pounding": "paʊndɪŋ",
    "pound": "paʊnd",
    "pounds": "paʊndz",
    "pourable": "pɔːrəbəl",
    "poured": "pɔːd",
    "pourer": "pɔːrɐ",
    "pouring": "pɔːrɪŋ",
    "pour": "pɔː",
    "pours": "pɔːz",
    "pouter": "paʊtɐ",
    "pouting": "paʊtɪŋ",
    "pout": "paʊt",
    "pouts": "paʊts",
    "pouty": "paʊti",
    "poverty": "pɒvəti",
    "powdered": "paʊdəd",
    "powdering": "paʊdərɪŋ",
    "powder": "paʊdɐ",
    "powders": "paʊdəz",
    "powdery": "paʊdəri",
    "powerboat": "paʊəbəʊt",
    "powerboats": "paʊəbəʊts",
    "powered": "paʊəd",
    "powerfully": "paʊəfəli",
    "powerfulness": "paʊəfəlnəs",
    "powerful": "paʊəfəl",
    "powerhouse": "paʊəhaʊs",
    "powerhouses": "paʊəhaʊzɪz",
    "powering": "paʊərɪŋ",
    "powerlessly": "paʊələsli",
    "powerlessness": "paʊələsnəs",
    "powerless": "paʊələs",
    "power": "paʊɐ",
    "powers": "paʊəz",
    "pow": "paʊ",
    "powwow": "paʊwaʊ",
    "pox": "pɒks",
    "p": "piː",
    "ppm": "piːpiːɛm",
    "practicability": "præktɪsəbɪlɪti",
    "practicable": "præktɪkəbəl",
    "practicalities": "præktɪkælɪtiz",
    "practicality": "præktɪkælɪti",
    "practically": "præktɪkli",
    "practical": "præktɪkəl",
    "practicals": "præktɪkəlz",
    "practiced": "præktɪst",
    "practice": "præktɪs",
    "practices": "præktɪsɪz",
    "practicing": "præktɪsɪŋ",
    "practised": "præktɪsd",
    "practise": "præktɪs",
    "practiser": "præktaɪzɐ",
    "practises": "præktɪsɪz",
    "practising": "præktɪsɪŋ",
    "practitioner": "præktɪʃənɐ",
    "practitioners": "præktɪʃənəz",
    "praetorian": "priːtɔːriən",
    "praetor": "priːtɐ",
    "pragmatically": "præɡmætɪkli",
    "pragmatic": "præɡmætɪk",
    "pragmatics": "præɡmætɪks",
    "pragmatism": "præɡmətɪzəm",
    "pragmatist": "præɡmɐtɪst",
    "pragmatists": "præɡmɐtɪsts",
    "prairie": "preəri",
    "prairies": "preərɪz",
    "praised": "preɪzd",
    "praise": "preɪz",
    "praises": "preɪzɪz",
    "praiseworthy": "preɪzjuːɜːði",
    "praising": "preɪzɪŋ",
    "praline": "preɪlaɪn",
    "pralines": "preɪlaɪnz",
    "prams": "præmz",
    "pranced": "prɑːnst",
    "prance": "prɑːns",
    "prancer": "prɑːnsɐ",
    "prances": "prɑːnsɪz",
    "prancing": "prɑːnsɪŋ",
    "prandial": "prændɪəl",
    "pranged": "preɪndʒd",
    "pranging": "preɪndʒɪŋ",
    "prang": "præŋ",
    "prangs": "præŋz",
    "prank": "præŋk",
    "pranks": "præŋks",
    "prankster": "præŋkstɐ",
    "pranksters": "præŋkstəz",
    "praseodymium": "preɪsədɪmiəm",
    "prate": "preɪt",
    "prater": "preɪtɐ",
    "pratfall": "prætfɔːl",
    "pratfalls": "prætfɔːlz",
    "prating": "preɪtɪŋ",
    "prat": "præt",
    "prats": "præts",
    "prattle": "prætəl",
    "prattler": "prætlɐ",
    "prattles": "prætəlz",
    "prattling": "prætlɪŋ",
    "prawn": "prɔːn",
    "prawns": "prɔːnz",
    "praxis": "præksɪs",
    "prayed": "preɪd",
    "prayerful": "preəfəl",
    "praying": "preɪɪŋ",
    "pray": "preɪ",
    "prays": "preɪz",
    "preached": "priːtʃt",
    "preacher": "priːtʃɐ",
    "preachers": "priːtʃəz",
    "preaches": "priːtʃɪz",
    "preaching": "priːtʃɪŋ",
    "preachings": "priːtʃɪŋz",
    "preach": "priːtʃ",
    "preachy": "priːtʃi",
    "preamble": "priːæmbəl",
    "preambling": "priːɐmblɪŋ",
    "prearranged": "priəreɪndʒd",
    "precancerous": "prɪkænsərəs",
    "precariously": "prɪkeərɪəsli",
    "precariousness": "prɪkeərɪəsnəs",
    "precarious": "prɪkeərɪəs",
    "precautionary": "prɪkɔːʃənəri",
    "precaution": "prɪkɔːʃən",
    "precautions": "prɪkɔːʃənz",
    "precautious": "prɪkɔːʃəs",
    "preceded": "prɪsiːdɪd",
    "precedence": "prɛsɪdəns",
    "precedents": "prɛsɪdənts",
    "precede": "prɪsiːd",
    "precedes": "prɪsiːdz",
    "preceding": "prɪsiːdɪŋ",
    "precentor": "prɪsɛntɔː",
    "precentors": "prɪsɛntɔːz",
    "preceptory": "prɪsɛptəri",
    "precept": "priːsɛpt",
    "precepts": "priːsɛpts",
    "precession": "prɪsɛʃən",
    "precess": "prɪsɛs",
    "precinct": "priːsɪŋkt",
    "precincts": "priːsɪŋkts",
    "preciously": "prɛʃəsli",
    "preciousness": "prɛʃəsnəs",
    "precious": "prɛʃəs",
    "precipice": "prɛsɪpɪs",
    "precipices": "prɛsɪpɪsɪz",
    "precipitated": "prɪsɪpɪteɪtɪd",
    "precipitates": "prɪsɪpɪteɪts",
    "precipitating": "prɪsɪpɪteɪtɪŋ",
    "precipitation": "prɪsɪpɪteɪʃən",
    "precipitously": "prɪsɪpɪtəsli",
    "precipitous": "prɪsɪpɪtəs",
    "precisely": "prɪsaɪsli",
    "precise": "prɪsaɪs",
    "precision": "prɪsɪʒən",
    "precluded": "prɪkluːdɪd",
    "preclude": "prɪkluːd",
    "precludes": "prɪkluːdz",
    "precluding": "prɪkluːdɪŋ",
    "precociously": "prɪkəʊʃəsli",
    "precociousness": "prɪkəʊʃəsnəs",
    "precocious": "prɪkəʊʃəs",
    "preconceived": "priːkənsiːvd",
    "preconception": "priːkənsɛpʃən",
    "preconceptions": "priːkənsɛpʃənz",
    "precondition": "priːkəndɪʃən",
    "preconditions": "priːkəndɪʃənz",
    "precooked": "priːkʊkt",
    "precursor": "prɪkɜːsɐ",
    "precursors": "prɪkɜːsəz",
    "predating": "prɪdeɪtɪŋ",
    "predation": "prɪdeɪʃən",
    "predator": "prɛdətɐ",
    "predators": "prɛdətəz",
    "predatory": "prɛdətəri",
    "predeceased": "prɪdɛsiːsd",
    "predecessor": "priːdɪsɛsɐ",
    "predecessors": "priːdɪsɛsəz",
    "predefined": "priːdɪfaɪnd",
    "predestination": "prɪdɛstɪneɪʃən",
    "predestined": "prɪdɛstɪnd",
    "predestine": "prɪdɛstɪn",
    "predetermined": "prɪdɪtɜːmɪnd",
    "predetermine": "prɪdɪtɜːmɪn",
    "predicable": "prɪdɪkəbəl",
    "predicament": "prɪdɪkəmənt",
    "predicaments": "prɪdɪkəmənts",
    "predicated": "prɛdɪkeɪtɪd",
    "predicating": "prɛdɪkeɪtɪŋ",
    "predictability": "prɪdɪktəbɪlɪti",
    "predictable": "prɪdɪktəbəl",
    "predictably": "prɪdɪktəbli",
    "predicted": "prɪdɪktɪd",
    "predicting": "prɪdɪktɪŋ",
    "prediction": "prɪdɪkʃən",
    "predictions": "prɪdɪkʃənz",
    "predictive": "prɪdɪktɪv",
    "predictor": "prɪdɪktɐ",
    "predictors": "prɪdɪktəz",
    "predict": "prɪdɪkt",
    "predicts": "prɪdɪkts",
    "predilection": "priːdɪlɛkʃən",
    "predilections": "priːdɪlɛkʃənz",
    "predisposed": "priːdɪspəʊzd",
    "predispose": "priːdɪspəʊz",
    "predisposes": "priːdɪspəʊzɪz",
    "predisposition": "priːdɪspəzɪʃən",
    "predispositions": "priːdɪspəzɪʃənz",
    "predominance": "prɪdɒmɪnəns",
    "predominantly": "prɪdɒmɪnəntli",
    "predominant": "prɪdɒmɪnənt",
    "predominated": "prɪdɒmɪneɪtɪd",
    "predominately": "prɪdɒmɪneɪtli",
    "predominate": "prɪdɒmɪneɪt",
    "predominates": "prɪdɒmɪneɪts",
    "predominating": "prɪdɒmɪneɪtɪŋ",
    "preeminent": "priːɛmɪnənt",
    "preened": "priːnd",
    "preening": "priːnɪŋ",
    "preen": "priːn",
    "preens": "priːnz",
    "preexisting": "priːksɪstɪŋ",
    "prefabbed": "prɪfæbd",
    "prefab": "prɪfæb",
    "prefabricated": "prɪfæbrɪkeɪtɪd",
    "prefabricate": "prɪfæbrɪkeɪt",
    "prefabrication": "prɪfæbrɪkeɪʃən",
    "prefabs": "prɪfæbz",
    "prefaced": "prɛfəst",
    "preface": "prɛfəs",
    "prefaces": "prɛfəsɪz",
    "prefect": "priːfɛkt",
    "prefects": "priːfɛkts",
    "prefecture": "priːfɛktʃɐ",
    "preferable": "prɪfɜːrəbəl",
    "preferably": "prɛfrəbli",
    "preference": "prɛfrəns",
    "preferences": "prɛfrənsɪz",
    "preferentially": "prɛfərɛnʃəli",
    "preferential": "prɛfərɛnʃəl",
    "preferment": "prɪfɜːmənt",
    "prefer": "prɪfɜː",
    "preferred": "prɪfɜːd",
    "preferring": "prɪfɜːrɪŋ",
    "prefers": "prɪfɜːz",
    "prefigured": "prɪfɪɡəd",
    "prefigure": "prɪfɪɡɐ",
    "prefigures": "prɪfɪɡəz",
    "prefiguring": "prɪfɪɡərɪŋ",
    "prefixed": "priːfɪkst",
    "preflight": "prɪflaɪt",
    "preformed": "prɪfɔːmd",
    "preform": "prɪfɔːm",
    "prefrontal": "prɪfrʌntəl",
    "pregnancies": "prɛɡnənsɪz",
    "pregnancy": "prɛɡnənsi",
    "pregnant": "prɛɡnənt",
    "preheated": "prɪhiːtɪd",
    "preheat": "prɪhiːt",
    "prehensile": "prɪhɛnsaɪl",
    "prehistorical": "priːhɪstɒrɪkəl",
    "prehistoric": "priːhɪstɒrɪk",
    "prehistory": "priːhɪstəri",
    "prejudged": "prɪdʒʌdʒd",
    "prejudge": "prɪdʒʌdʒ",
    "prejudging": "prɪdʒʌdʒɪŋ",
    "prejudiced": "prɛdʒuːdɪst",
    "prejudice": "prɛdʒuːdɪs",
    "prejudices": "prɛdʒuːdɪsɪz",
    "prejudicial": "prɛdʒuːdɪʃəl",
    "prejudicing": "prɛdʒuːdɪsɪŋ",
    "prelacy": "prɪlæsi",
    "prelate": "prɛlət",
    "prelates": "prɛləts",
    "preliminaries": "prɪlɪmɪnəriz",
    "preliminary": "prɪlɪmɪnəri",
    "prelims": "prɪlɪmz",
    "prelude": "prɛljuːd",
    "preludes": "prɛljuːdz",
    "premarital": "prɪmærɪtəl",
    "prematurely": "prɪmətʃɔːli",
    "premature": "prɪmətʃɔː",
    "prematurity": "prɪmətʃɔːrɪti",
    "premeditated": "prɪmɛdɪteɪtɪd",
    "premeditate": "prɪmɛdɪteɪt",
    "premeditation": "prɪmɛdɪteɪʃən",
    "premenstrual": "prɪmɛnstruːəl",
    "premiered": "prɛmɪəd",
    "premiere": "prɛmieə",
    "premieres": "prɛmieəz",
    "premiering": "prɛmɪərɪŋ",
    "premier": "prɛmɪɐ",
    "premiership": "prɛmɪəʃɪp",
    "premiers": "prɛmɪəz",
    "premised": "prɛmɪsd",
    "premises": "prɛmɪsɪz",
    "premium": "priːmiəm",
    "premiums": "priːmiəmz",
    "premixed": "prɛmɪkst",
    "premolar": "priːməʊlɐ",
    "premolars": "priːməʊləz",
    "premonition": "prɪmənɪʃən",
    "premonitions": "prɪmənɪʃənz",
    "prenatal": "prɪneɪtəl",
    "prentice": "prɛntɪs",
    "prenuptial": "prɪnʌpʃəl",
    "preoccupation": "prɪɒkjʊpeɪʃən",
    "preoccupations": "prɪɒkjʊpeɪʃənz",
    "preoccupied": "prɪɒkjʊpaɪd",
    "preoccupies": "prɪɒkjʊpaɪz",
    "preoccupying": "prɪɒkjʊpaɪɪŋ",
    "preoccupy": "prɪɒkjʊpaɪ",
    "preoperative": "prɪəʊprətɪv",
    "preordained": "prɪɔːdeɪnd",
    "prepacked": "prɪpækt",
    "prepaid": "prɪpeɪd",
    "preparation": "prɛpəreɪʃən",
    "preparations": "prɛpəreɪʃənz",
    "preparatory": "prɪpærətəri",
    "preparedness": "prɪpeədnəs",
    "prepared": "prɪpeəd",
    "prepare": "prɪpeə",
    "preparer": "prɪpeərɐ",
    "prepares": "prɪpeəz",
    "preparing": "prɪpeərɪŋ",
    "prepayment": "prɪpeɪmənt",
    "prepay": "prɪpeɪ",
    "preplanned": "prɪplænd",
    "preponderance": "prɪpɒndərəns",
    "preponderant": "prɪpɒndərənt",
    "prepositionally": "prɛpəzɪʃənəli",
    "prepossessing": "prɪpəzɛsɪŋ",
    "preposterously": "prɪpɒstərəsli",
    "preposterousness": "prɪpɒstərəsnəs",
    "preposterous": "prɪpɒstərəs",
    "prepped": "prɛpt",
    "prep": "prɛp",
    "prepping": "prɛpɪŋ",
    "preppy": "prɛpi",
    "preps": "prɛps",
    "prepubescent": "prɪpjuːbɛsənt",
    "prepuce": "prɪpjuːs",
    "prequel": "priːkwəl",
    "prequels": "priːkwəlz",
    "prerecorded": "priːrɪkɔːdɪd",
    "prerecord": "priːrɪkɔːd",
    "prerequisite": "priːrɛkwɪsɪt",
    "prerequisites": "priːrɛkwɪsɪts",
    "prerevolutionary": "priːrɛvəluːʃənəri",
    "prerogative": "prɪrɒɡətɪv",
    "prerogatives": "prɪrɒɡətɪvz",
    "presaged": "prɛsɪdʒd",
    "presbyterianism": "prɪsbaɪtiərɪnɪzəm",
    "presbyterian": "prɪsbaɪtiərɪən",
    "presbytery": "prɪsbaɪtəri",
    "preschool": "priːskuːl",
    "prescience": "priːsiəns",
    "presciently": "priːsiəntli",
    "prescient": "priːsiənt",
    "prescribed": "prɪskraɪbd",
    "prescribe": "prɪskraɪb",
    "prescriber": "prɪskraɪbɐ",
    "prescribes": "prɪskraɪbz",
    "prescribing": "prɪskraɪbɪŋ",
    "prescription": "prɪskrɪpʃən",
    "prescriptions": "prɪskrɪpʃənz",
    "prescriptive": "prɪskrɪptɪv",
    "preseason": "prɪsiːzən",
    "presence": "prɛzəns",
    "presences": "prɛzənsɪz",
    "presentable": "prɪzɛntəbəl",
    "presentational": "prɛzənteɪʃənəl",
    "presentation": "prɛzənteɪʃən",
    "presentations": "prɛzənteɪʃənz",
    "presented": "prɪzɛntɪd",
    "presenter": "prɪzɛntɐ",
    "presenters": "prɪzɛntəz",
    "presentiment": "prɪzɛntɪmənt",
    "presenting": "prɪzɛntɪŋ",
    "presently": "prɛzəntli",
    "presentment": "prɪzɛntmənt",
    "preservationist": "prɪsəveɪʃənɪst",
    "preservationists": "prɪsəveɪʃənɪsts",
    "preservation": "prɪsəveɪʃən",
    "preservative": "prɪsɜːvətɪv",
    "preservatives": "prɪsɜːvətɪvz",
    "preserved": "prɪsɜːvd",
    "preserve": "prɪsɜːv",
    "preserver": "prɪsɜːvɐ",
    "preservers": "prɪsɜːvəz",
    "preserves": "prɪsɜːvz",
    "preserving": "prɪsɜːvɪŋ",
    "preset": "priːsɛt",
    "presets": "priːsɛts",
    "presided": "prɪsaɪdɪd",
    "presidencies": "prɛzɪdənsiz",
    "presidency": "prɛzɪdənsi",
    "presidential": "prɛzɪdɛnʃəl",
    "president": "prɛzɪdənt",
    "presidents": "prɛzɪdənts",
    "preside": "prɪsaɪd",
    "presides": "prɪsaɪdz",
    "presiding": "prɪsaɪdɪŋ",
    "presidio": "prɪsɪdɪəʊ",
    "presidium": "prɪsɪdiəm",
    "pressed": "prɛst",
    "presser": "prɛsɐ",
    "pressers": "prɛsəz",
    "presses": "prɛsɪz",
    "pressie": "prɛsi",
    "pressies": "prɛsɪz",
    "pressingly": "prɛsɪŋli",
    "pressing": "prɛsɪŋ",
    "pressings": "prɛsɪŋz",
    "pressman": "prɛsmən",
    "pressmen": "prɛsmɛn",
    "pressor": "prɛsɐ",
    "press": "prɛs",
    "pressured": "prɛʃəd",
    "pressure": "prɛʃɐ",
    "pressures": "prɛʃəz",
    "pressuring": "prɛʃərɪŋ",
    "pressurisation": "prɛʃəraɪzeɪʃən",
    "pressurised": "prɛʃəraɪzd",
    "pressurise": "prɛʃəraɪz",
    "pressurises": "prɛʃəraɪzɪz",
    "pressurising": "prɛʃəraɪzɪŋ",
    "prestidigitation": "prɛstɪdɪdʒɪteɪʃən",
    "prestige": "prɛstiːʒ",
    "prestigious": "prɛstɪdʒəs",
    "prestissimo": "prɛstɪsɪməʊ",
    "presto": "prɛstəʊ",
    "presumably": "prɪzjuːməbli",
    "presumed": "prɪzjuːmd",
    "presume": "prɪzjuːm",
    "presumes": "prɪzjuːmz",
    "presuming": "prɪzjuːmɪŋ",
    "presumption": "prɪsʌmpʃən",
    "presumptions": "prɪsʌmpʃənz",
    "presumptive": "prɪsʌmptɪv",
    "presumptuous": "prɪsʌmptʃuːəs",
    "presuppose": "priːsʌpəʊz",
    "presupposes": "priːsʌpəʊzɪz",
    "presupposing": "priːsʌpəʊzɪŋ",
    "presuppositions": "priːsʌpəzɪʃənz",
    "preteens": "prɪtiːnz",
    "pretence": "prɪtɛns",
    "pretences": "prɪtɛnsɪz",
    "pretended": "prɪtɛndɪd",
    "pretender": "prɪtɛndɐ",
    "pretenders": "prɪtɛndəz",
    "pretending": "prɪtɛndɪŋ",
    "pretend": "prɪtɛnd",
    "pretends": "prɪtɛndz",
    "pretension": "prɪtɛnʃən",
    "pretensions": "prɪtɛnʃənz",
    "pretentiously": "prɪtɛnʃəsli",
    "pretentiousness": "prɪtɛnʃəsnəs",
    "pretentious": "prɪtɛnʃəs",
    "preternatural": "prɪtənætʃərəl",
    "pretext": "priːtɛkst",
    "pretor": "prɪtɔː",
    "pretrial": "priːtraɪəl",
    "prettied": "prɪtid",
    "prettier": "prɪtiɐ",
    "pretties": "prɪtiz",
    "prettiest": "prɪtiəst",
    "prettification": "prɛtɪfɪkeɪʃən",
    "prettified": "prɛtɪfaɪd",
    "prettify": "prɛtɪfaɪ",
    "prettily": "prɪtili",
    "prettiness": "prɪtinəs",
    "prettying": "prɪtiɪŋ",
    "pretty": "prɪti",
    "pretzel": "prɛtsəl",
    "pretzels": "prɛtsəlz",
    "prevailed": "prɪveɪld",
    "prevailing": "prɪveɪlɪŋ",
    "prevail": "prɪveɪl",
    "prevails": "prɪveɪlz",
    "prevalence": "prɛvələns",
    "prevalent": "prɛvələnt",
    "prevaricated": "prɪværɪkeɪtɪd",
    "prevaricate": "prɪværɪkeɪt",
    "prevaricating": "prɪværɪkeɪtɪŋ",
    "prevarication": "prɪværɪkeɪʃən",
    "preventable": "prɪvɛntəbəl",
    "preventative": "prɪvɛntətɪv",
    "prevented": "prɪvɛntɪd",
    "preventer": "prɪvɛntɐ",
    "preventing": "prɪvɛntɪŋ",
    "prevention": "prɪvɛnʃən",
    "preventions": "prɪvɛnʃənz",
    "preventive": "prɪvɛntɪv",
    "prevent": "prɪvɛnt",
    "prevents": "prɪvɛnts",
    "previewed": "priːvjuːd",
    "previewing": "priːvjuːɪŋ",
    "preview": "priːvjuː",
    "previews": "priːvjuːz",
    "previously": "priːvɪəsli",
    "previous": "priːvɪəs",
    "prev": "prɛv",
    "prewar": "prɪwɔː",
    "preyed": "preɪd",
    "preying": "preɪɪŋ",
    "prey": "preɪ",
    "preys": "preɪz",
    "prezzie": "prɛzi",
    "prezzies": "prɛzɪz",
    "priapic": "praɪəpɪk",
    "priced": "praɪst",
    "priceless": "praɪsləs",
    "price": "praɪs",
    "prices": "praɪsɪz",
    "pricey": "praɪsi",
    "pricier": "praɪsɪɐ",
    "priciest": "praɪsɪəst",
    "pricing": "praɪsɪŋ",
    "pricked": "prɪkt",
    "pricker": "prɪkɐ",
    "pricket": "prɪkɪt",
    "pricking": "prɪkɪŋ",
    "prickled": "prɪkəld",
    "prickle": "prɪkəl",
    "prickles": "prɪkəlz",
    "prickliest": "prɪkliəst",
    "prickliness": "prɪklinəs",
    "prickling": "prɪklɪŋ",
    "prickly": "prɪkli",
    "prick": "prɪk",
    "pricks": "prɪks",
    "pricy": "praɪsi",
    "prided": "praɪdɪd",
    "prideful": "praɪdfəl",
    "pride": "praɪd",
    "prides": "praɪdz",
    "priding": "praɪdɪŋ",
    "pried": "praɪd",
    "prier": "praɪə",
    "priestesses": "priːstɛsɪz",
    "priestess": "priːstɛs",
    "priesthood": "priːsthʊd",
    "priesthoods": "priːsthʊdz",
    "priestly": "priːstli",
    "priest": "priːst",
    "priests": "priːsts",
    "priggish": "prɪɡɪʃ",
    "prig": "prɪɡ",
    "primacy": "praɪməsi",
    "primal": "praɪməl",
    "primaries": "praɪməriz",
    "primarily": "praɪmɛrəli",
    "primary": "praɪməri",
    "primate": "praɪmeɪt",
    "primates": "praɪmeɪts",
    "primavera": "priːməveərɐ",
    "primed": "praɪmd",
    "prime": "praɪm",
    "primero": "praɪmrəʊ",
    "primers": "praɪməz",
    "primes": "praɪmz",
    "primetime": "praɪmtaɪm",
    "primeval": "praɪmiːvəl",
    "priming": "praɪmɪŋ",
    "primitively": "prɪmɪtɪvli",
    "primitiveness": "prɪmɪtɪvnəs",
    "primitive": "prɪmɪtɪv",
    "primitives": "prɪmɪtɪvz",
    "primitivism": "prɪmɪtɪvɪzəm",
    "primly": "prɪmli",
    "primogeniture": "prɪməʊdʒnɪtʃɐ",
    "primo": "priːməʊ",
    "primordial": "prɪmɔːdɪəl",
    "primped": "prɪmpt",
    "primping": "prɪmpɪŋ",
    "prim": "prɪm",
    "primp": "prɪmp",
    "primrose": "prɪmrəʊz",
    "primroses": "prɪmrəʊzɪz",
    "primula": "prɪmjʊlɐ",
    "primulas": "prɪmjʊləz",
    "primus": "prɪməs",
    "princeling": "prɪnsəlɪŋ",
    "princely": "prɪnsli",
    "prince": "prɪns",
    "princes": "prɪnsɪz",
    "princesses": "prɪnsɛsɪz",
    "principalities": "prɪnsɪpælɪtiz",
    "principality": "prɪnsɪpælɪti",
    "principally": "prɪnsɪpəli",
    "principal": "prɪnsɪpəl",
    "principals": "prɪnsɪpəlz",
    "principled": "prɪnsɪpəld",
    "principle": "prɪnsɪpəl",
    "principles": "prɪnsɪpəlz",
    "prink": "prɪŋk",
    "printable": "prɪntəbəl",
    "printed": "prɪntɪd",
    "printer": "prɪntɐ",
    "printers": "prɪntəz",
    "printing": "prɪntɪŋ",
    "printmaker": "prɪntmeɪkɐ",
    "printmakers": "prɪntmeɪkəz",
    "printmaking": "prɪntmeɪkɪŋ",
    "printout": "prɪntaʊt",
    "printouts": "prɪntaʊts",
    "print": "prɪnt",
    "prints": "prɪnts",
    "prion": "praɪɒn",
    "prions": "praɪɒnz",
    "prioress": "praɪɔːs",
    "priories": "praɪəriz",
    "priorities": "praɪɒrɪtiz",
    "prioritisation": "praɪɒrɪtaɪzeɪʃən",
    "prioritised": "praɪɒrɪtaɪzd",
    "prioritise": "praɪɒrɪtaɪz",
    "prioritises": "praɪɒrɪtaɪzɪz",
    "prioritising": "praɪɒrɪtaɪzɪŋ",
    "priority": "praɪɒrɪti",
    "prior": "praɪɐ",
    "priors": "praɪəz",
    "priory": "praɪəri",
    "prised": "praɪzd",
    "prise": "praɪz",
    "prising": "praɪzɪŋ",
    "prismatic": "prɪsmætɪk",
    "prism": "prɪzəm",
    "prisms": "prɪzəmz",
    "prisoner": "prɪzənɐ",
    "prisoners": "prɪzənəz",
    "prison": "prɪzən",
    "prisons": "prɪzənz",
    "prissy": "prɪsi",
    "pristinely": "prɪstiːnli",
    "pristine": "prɪstiːn",
    "prithee": "prɪθiː",
    "privacy": "prɪvəsi",
    "privateer": "praɪvətiə",
    "privateers": "praɪvətiəz",
    "privately": "praɪvətli",
    "private": "praɪvət",
    "privates": "praɪvəts",
    "privation": "praɪveɪʃən",
    "privations": "praɪveɪʃənz",
    "privatisation": "praɪvətaɪzeɪʃən",
    "privatisations": "praɪvətaɪzeɪʃənz",
    "privatised": "praɪvətaɪzd",
    "privatise": "praɪvətaɪz",
    "privatises": "praɪvətaɪzɪz",
    "privatising": "praɪvətaɪzɪŋ",
    "privet": "prɪvɪt",
    "privets": "prɪvɪts",
    "privies": "prɪviz",
    "privileged": "prɪvɪlɪdʒd",
    "privilege": "prɪvɪlɪdʒ",
    "privileges": "prɪvɪlɪdʒɪz",
    "privileging": "prɪvɪlɪdʒɪŋ",
    "privily": "prɪvili",
    "privity": "prɪvɪti",
    "privy": "prɪvi",
    "prizefighter": "praɪzfaɪtɐ",
    "prizefighters": "praɪzfaɪtəz",
    "prize": "praɪz",
    "prizes": "praɪzɪz",
    "prizewinner": "praɪzwɪnɐ",
    "prizewinners": "praɪzwɪnəz",
    "prizewinning": "praɪzwɪnɪŋ",
    "proactively": "prəʊæktɪvli",
    "proactive": "prəʊæktɪv",
    "proactivity": "prəʊktɪvɪti",
    "proa": "prəʊɐ",
    "probabilistically": "prɒbəbɪlɪstɪkli",
    "probabilistic": "prɒbəbɪlɪstɪk",
    "probabilities": "prɒbəbɪlɪtiz",
    "probability": "prɒbəbɪlɪti",
    "probable": "prɒbəbəl",
    "probables": "prɒbəbəlz",
    "probably": "prɒbəbli",
    "probated": "prəʊbeɪtɪd",
    "probate": "prəʊbeɪt",
    "probates": "prəʊbeɪts",
    "probationary": "prəʊbeɪʃənəri",
    "probationer": "prəʊbeɪʃənɐ",
    "probationers": "prəʊbeɪʃənəz",
    "probation": "prəʊbeɪʃən",
    "probed": "prəʊbd",
    "probe": "prəʊb",
    "probes": "prəʊbz",
    "probing": "prəʊbɪŋ",
    "probity": "prɒbɪti",
    "problematical": "prɒbəlmætɪkəl",
    "problematic": "prɒbəlmætɪk",
    "problem": "prɒbləm",
    "problems": "prɒbləmz",
    "proboscis": "prəbɒskɪs",
    "procaine": "prɒkeɪn",
    "procedurally": "prəsiːdʒərəli",
    "procedural": "prəsiːdʒərəl",
    "procedure": "prəsiːdʒɐ",
    "procedures": "prəsiːdʒəz",
    "proceeded": "prəsiːdɪd",
    "proceeding": "prəsiːdɪŋ",
    "proceedings": "prəsiːdɪŋz",
    "proceed": "prəsiːd",
    "processional": "prəsɛʃənəl",
    "procession": "prəsɛʃən",
    "processions": "prəsɛʃənz",
    "processor": "prəʊsɛsɐ",
    "processors": "prəʊsɛsəz",
    "proclaimed": "prəkleɪmd",
    "proclaimers": "prəkleɪməz",
    "proclaiming": "prəkleɪmɪŋ",
    "proclaim": "prəkleɪm",
    "proclaims": "prəkleɪmz",
    "proclamation": "prɒklɐmeɪʃən",
    "proclamations": "prɒklɐmeɪʃənz",
    "proclivities": "prəklɪvɪtiz",
    "proclivity": "prəklɪvɪti",
    "proconsul": "prəʊkɒnsʌl",
    "procrastinated": "prəkrɑːstɪneɪtɪd",
    "procrastinate": "prəkrɑːstɪneɪt",
    "procrastinating": "prəkrɑːstɪneɪtɪŋ",
    "procrastination": "prɒkrɑːstɪneɪʃən",
    "procrastinator": "prəkrɑːstɪneɪtɐ",
    "procreate": "prɒkriːeɪt",
    "procreates": "prɒkriːeɪts",
    "procreating": "prɒkriːeɪtɪŋ",
    "procreation": "prɒkriːeɪʃən",
    "procreative": "prɒkriətɪv",
    "proctologist": "prɒktɒlədʒɪst",
    "proctologists": "prɒktɒlədʒɪsts",
    "proctor": "prɒktɐ",
    "procurator": "prəkjʊreɪtɐ",
    "procured": "prəkjɔːd",
    "procurement": "prəkjɔːmənt",
    "procurements": "prəkjɔːmənts",
    "procure": "prəkjɔː",
    "procurer": "prəkjʊrɐ",
    "procurers": "prəkjʊrəz",
    "procures": "prəkjɔːz",
    "procuress": "prəkjʊrɛs",
    "procuring": "prəkjɔːrɪŋ",
    "prodded": "prɒdɪd",
    "prodder": "prɒdɐ",
    "prodding": "prɒdɪŋ",
    "prodigal": "prɒdɪɡəl",
    "prodigies": "prɒdɪdʒɪz",
    "prodigiously": "prədɪdʒəsli",
    "prodigious": "prədɪdʒəs",
    "prodigy": "prɒdɪdʒi",
    "prod": "prɒd",
    "prods": "prɒdz",
    "produced": "prədjuːst",
    "producer": "prədjuːsɐ",
    "producers": "prədjuːsəz",
    "produces": "prədjuːsɪz",
    "producing": "prədjuːsɪŋ",
    "production": "prədʌkʃən",
    "productions": "prədʌkʃənz",
    "productively": "prədʌktɪvli",
    "productiveness": "prədʌktɪvnəs",
    "productive": "prədʌktɪv",
    "productivity": "prɒdəktɪvɪti",
    "product": "prɒdʌkt",
    "products": "prɒdʌkts",
    "profaned": "prəfeɪnd",
    "profane": "prəfeɪn",
    "profaning": "prəfeɪnɪŋ",
    "profanities": "prəfænɪtiz",
    "profanity": "prəfænɪti",
    "professed": "prəfɛst",
    "professes": "prəfɛsɪz",
    "professing": "prəfɛsɪŋ",
    "professionalisation": "prəfɛʃənəlaɪzeɪʃən",
    "professionalised": "prəfɛʃənəlaɪzd",
    "professionalise": "prəfɛʃənəlaɪz",
    "professionalising": "prəfɛʃənəlaɪzɪŋ",
    "professionalism": "prəfɛʃənəlɪzəm",
    "professionally": "prəfɛʃənəli",
    "professional": "prəfɛʃənəl",
    "professionals": "prəfɛʃənəlz",
    "profession": "prəfɛʃən",
    "professions": "prəfɛʃənz",
    "professorial": "prəfɪsɔːrɪəl",
    "professor": "prəfɛsɐ",
    "professorship": "prəfɛsəʃɪp",
    "professorships": "prəfɛsəʃɪps",
    "professors": "prəfɛsəz",
    "profess": "prəfɛs",
    "proffered": "prɒfəd",
    "proffering": "prɒfərɪŋ",
    "proffer": "prɒfɐ",
    "proffers": "prɒfəz",
    "proficiency": "prəfɪʃənsi",
    "proficiently": "prəfɪʃəntli",
    "proficient": "prəfɪʃənt",
    "profiled": "prəʊfaɪld",
    "profile": "prəʊfaɪl",
    "profiles": "prəʊfaɪlz",
    "profiling": "prəʊfaɪlɪŋ",
    "profitability": "prɒfɪtəbɪlɪti",
    "profitable": "prɒfɪtəbəl",
    "profitably": "prɒfɪtəbli",
    "profited": "prɒfɪtɪd",
    "profiteering": "prɒfɪtiərɪŋ",
    "profiteer": "prɒfɪtiə",
    "profiteers": "prɒfɪtiəz",
    "profiterole": "prəfɪtərəʊl",
    "profiteroles": "prəfɪtərəʊlz",
    "profiting": "prɒfɪtɪŋ",
    "profitless": "prɒfɪtləs",
    "profit": "prɒfɪt",
    "profits": "prɒfɪts",
    "profligacy": "prɒflɪɡəsi",
    "profligate": "prɒflɪɡeɪt",
    "proforma": "prɒfɔːmɐ",
    "profoundest": "prəfaʊndəst",
    "profoundly": "prəfaʊndli",
    "profound": "prəfaʊnd",
    "prof": "prɒf",
    "profs": "prɒfs",
    "profundities": "prəfʌndɪtiz",
    "profundity": "prəfʌndɪti",
    "profusely": "prəfjuːzli",
    "profuse": "prəfjuːz",
    "profusion": "prəfjuːʒən",
    "progenitor": "prəʊdʒɛnɪtɐ",
    "progenitors": "prəʊdʒɛnɪtəz",
    "progeny": "prɒdʒəni",
    "progesterone": "prəʊdʒɛstərəʊn",
    "prognoses": "prɒɡnəʊzɪz",
    "prognosis": "prɒɡnəʊsɪs",
    "prognosticate": "prəɡnɒstɪkeɪt",
    "prognostication": "prɒɡnəstɪkeɪʃən",
    "prognostications": "prɒɡnəstɪkeɪʃənz",
    "prognosticator": "prəɡnɒstɪkeɪtɐ",
    "prognostic": "prəɡnɒstɪk",
    "programmable": "prəʊɡrɐməbəl",
    "programmatic": "prəʊɡrɐmætɪk",
    "programmed": "prəʊɡræmd",
    "programme": "prəʊɡræm",
    "programmer": "prəʊɡræmɐ",
    "programmers": "prəʊɡræməz",
    "programmes": "prəʊɡræmz",
    "programming": "prəʊɡræmɪŋ",
    "program": "prəʊɡræm",
    "programs": "prəʊɡræmz",
    "progressed": "prəɡrɛst",
    "progressing": "prəɡrɛsɪŋ",
    "progression": "prəɡrɛʃən",
    "progressions": "prəɡrɛʃənz",
    "progressively": "prəɡrɛsɪvli",
    "progressiveness": "prəɡrɛsɪvnəs",
    "progressive": "prəɡrɛsɪv",
    "progressives": "prəɡrɛsɪvz",
    "prohibited": "prəhɪbɪtɪd",
    "prohibiting": "prəhɪbɪtɪŋ",
    "prohibitionists": "prəhɪbɪʃənɪsts",
    "prohibition": "prəhɪbɪʃən",
    "prohibitions": "prəhɪbɪʃənz",
    "prohibitively": "prəhɪbɪtɪvli",
    "prohibitive": "prəhɪbɪtɪv",
    "prohibit": "prəhɪbɪt",
    "prohibits": "prəhɪbɪts",
    "projected": "prədʒɛktɪd",
    "projectile": "prədʒɛktaɪl",
    "projectiles": "prədʒɛktaɪlz",
    "projecting": "prədʒɛktɪŋ",
    "projectionist": "prədʒɛkʃənɪst",
    "projectionists": "prədʒɛkʃənɪsts",
    "projection": "prədʒɛkʃən",
    "projections": "prədʒɛkʃənz",
    "projective": "prədʒɛktɪv",
    "projector": "prədʒɛktɐ",
    "projectors": "prədʒɛktəz",
    "prolactin": "prɒlɐktɪn",
    "prolapsed": "prɒlæpsd",
    "prole": "prəʊl",
    "proles": "prəʊlz",
    "proletarian": "prəʊlteəriən",
    "proletarians": "prəʊlteəriənz",
    "proletariat": "prəʊlteərɪæt",
    "proliferated": "prəlɪfəreɪtɪd",
    "proliferate": "prəlɪfəreɪt",
    "proliferates": "prəlɪfəreɪts",
    "proliferating": "prəlɪfəreɪtɪŋ",
    "proliferation": "prəlɪfəreɪʃən",
    "prolifically": "prəlɪfɪkli",
    "prolific": "prəlɪfɪk",
    "prolix": "prɒlɪks",
    "prologue": "prəʊlɒɡ",
    "prologues": "prəʊlɒɡz",
    "prolongation": "prələŋɡeɪʃən",
    "prolonged": "prəlɒŋd",
    "prolonging": "prəlɒŋɪŋ",
    "prolong": "prəlɒŋ",
    "prolongs": "prəlɒŋz",
    "promenade": "prɒmənɑːd",
    "promenaders": "prəʊmneɪdəz",
    "promenades": "prɒmənɑːdz",
    "promenading": "prɒmənɑːdɪŋ",
    "promethium": "prəʊmiːθiəm",
    "prominence": "prɒmɪnəns",
    "prominences": "prɒmɪnənsɪz",
    "prominently": "prɒmɪnəntli",
    "prominent": "prɒmɪnənt",
    "promiscuity": "prɒmɪskjuːɪti",
    "promiscuously": "prəmɪskjuːəsli",
    "promiscuous": "prəmɪskjuːəs",
    "promised": "prɒmɪsd",
    "promise": "prɒmɪs",
    "promises": "prɒmɪsɪz",
    "promisingly": "prɒmɪsɪŋli",
    "promising": "prɒmɪsɪŋ",
    "promissory": "prɒmɪssəri",
    "promontories": "prɒməntəriz",
    "promontory": "prɒməntəri",
    "promo": "prəʊməʊ",
    "promos": "prəʊməʊz",
    "promoted": "prəməʊtɪd",
    "promote": "prəməʊt",
    "promoter": "prəməʊtɐ",
    "promoters": "prəməʊtəz",
    "promotes": "prəməʊts",
    "promoting": "prəməʊtɪŋ",
    "promotional": "prəməʊʃənəl",
    "promotion": "prəməʊʃən",
    "promotions": "prəməʊʃənz",
    "prom": "prɒm",
    "prompted": "prɒmptɪd",
    "prompter": "prɒmptɐ",
    "prompters": "prɒmptəz",
    "prompting": "prɒmptɪŋ",
    "promptly": "prɒmptli",
    "promptness": "prɒmptnəs",
    "prompt": "prɒmpt",
    "prompts": "prɒmpts",
    "proms": "prɒmz",
    "promulgated": "prɒməlɡeɪtɪd",
    "promulgate": "prɒməlɡeɪt",
    "promulgating": "prɒməlɡeɪtɪŋ",
    "promulgation": "prɒməlɡeɪʃən",
    "promulgator": "prɒməlɡeɪtɐ",
    "pronation": "prəneɪʃən",
    "proneness": "prəʊnnəs",
    "prone": "prəʊn",
    "pronged": "prɒŋd",
    "pronghorn": "prɒŋhɔːn",
    "prong": "prɒŋ",
    "prongs": "prɒŋz",
    "pronounced": "prənaʊnst",
    "pronouncement": "prənaʊnsmənt",
    "pronouncements": "prənaʊnsmənts",
    "pronounce": "prənaʊns",
    "pronounces": "prənaʊnsɪz",
    "pronouncing": "prənaʊnsɪŋ",
    "pronoun": "prəʊnaʊn",
    "pronouns": "prəʊnaʊnz",
    "pronto": "prɒntəʊ",
    "pronunciation": "prənʌnsɪeɪʃən",
    "pronunciations": "prənʌnsɪeɪʃənz",
    "proofed": "pruːft",
    "proofing": "pruːfɪŋ",
    "proof": "pruːf",
    "proofreader": "pruːfriːdɐ",
    "proofreaders": "pruːfriːdəz",
    "proofreading": "pruːfriːdɪŋ",
    "proofread": "pruːfriːd",
    "proofs": "pruːfs",
    "propaganda": "prɒpɐɡændɐ",
    "propagandise": "prɒpɐɡændaɪz",
    "propagandist": "prɒpɐɡændɪst",
    "propagandists": "prɒpɐɡændɪsts",
    "propagated": "prɒpɐɡeɪtɪd",
    "propagate": "prɒpɐɡeɪt",
    "propagates": "prɒpɐɡeɪts",
    "propagating": "prɒpɐɡeɪtɪŋ",
    "propagation": "prɒpɐɡeɪʃən",
    "propagator": "prɒpɐɡeɪtɐ",
    "propagators": "prɒpɐɡeɪtəz",
    "propane": "prəʊpeɪn",
    "pro": "prəʊ",
    "propellant": "prəpɛlənt",
    "propellants": "prəpɛlənts",
    "propelled": "prəpɛld",
    "propeller": "prəpɛlɐ",
    "propellers": "prəpɛləz",
    "propelling": "prəpɛlɪŋ",
    "propellor": "prəpɛlɐ",
    "propellors": "prəpɛləz",
    "propel": "prəpɛl",
    "propels": "prəpɛlz",
    "propensities": "prəpɛnsɪtiz",
    "propensity": "prəpɛnsɪti",
    "properly": "prɒpəli",
    "proper": "prɒpɐ",
    "propertied": "prɒpətɪd",
    "properties": "prɒpətɪz",
    "property": "prɒpəti",
    "prophecies": "prɒfəsiz",
    "prophecy": "prɒfəsi",
    "prophesied": "prɒfəsɪd",
    "prophesies": "prɒfəsɪz",
    "prophesying": "prɒfəsɪɪŋ",
    "prophesy": "prɒfəsi",
    "prophetesses": "prɒfɪtɛsɪz",
    "prophetess": "prɒfɪtɛs",
    "prophetically": "prɒfɛtɪkli",
    "prophetic": "prɒfɛtɪk",
    "prophet": "prɒfɪt",
    "prophets": "prɒfɪts",
    "prophylactic": "prɒfɪlæktɪk",
    "prophylactics": "prɒfɪlæktɪks",
    "prophylaxis": "prɒfɪlæksɪs",
    "propinquity": "prəpɪnkwɪti",
    "propitiate": "prəpɪtɪeɪt",
    "propitious": "prəpɪʃəs",
    "proponent": "prəpəʊnənt",
    "proponents": "prəpəʊnənts",
    "proportionable": "prəpɔːʃənəbəl",
    "proportionality": "prəpɔːʃənælɪti",
    "proportionally": "prəpɔːʃənəli",
    "proportional": "prəpɔːʃənəl",
    "proportionately": "prəpɔːʃənətli",
    "proportioned": "prəpɔːʃənd",
    "proportion": "prəpɔːʃən",
    "proportions": "prəpɔːʃənz",
    "proposal": "prəpəʊzəl",
    "proposals": "prəpəʊzəlz",
    "proposed": "prəpəʊzd",
    "propose": "prəpəʊz",
    "proposer": "prəpəʊzɐ",
    "proposers": "prəpəʊzəz",
    "proposes": "prəpəʊzɪz",
    "proposing": "prəpəʊzɪŋ",
    "propositioned": "prɒpəzɪʃənd",
    "propositioning": "prɒpəzɪʃənɪŋ",
    "proposition": "prɒpəzɪʃən",
    "propositions": "prɒpəzɪʃənz",
    "propounded": "prəpaʊndɪd",
    "propounding": "prəpaʊndɪŋ",
    "propound": "prəpaʊnd",
    "propped": "prɒpt",
    "propping": "prɒpɪŋ",
    "prop": "prɒp",
    "proprietary": "prəpraɪətəri",
    "proprieties": "prəpraɪətɪz",
    "proprietorially": "prəpraɪətɔːrɪəli",
    "proprietorial": "prəpraɪətɔːrɪəl",
    "proprietor": "prəpraɪətɐ",
    "proprietors": "prəpraɪətəz",
    "proprietress": "prəpraɪətrəs",
    "propriety": "prəpraɪəti",
    "proprioception": "prɒprɪəʊspʃən",
    "props": "prɒps",
    "propulsion": "prəpʌlʃən",
    "propulsive": "prəpʌlsɪv",
    "propylene": "prəʊpaɪliːn",
    "prorogation": "prɔːrəɡeɪʃən",
    "prorogued": "prɔːrəʊɡd",
    "prorogue": "prɔːrəʊɡ",
    "prosaically": "prəseɪɪkli",
    "prosaic": "prəseɪɪk",
    "proscenium": "prəsiːniəm",
    "prosciutto": "prəsɪʌtəʊ",
    "proscribed": "prəskraɪbd",
    "proscribe": "prəskraɪb",
    "proscription": "prəskrɪpʃən",
    "proscriptions": "prəskrɪpʃənz",
    "proscriptive": "prəskrɪptɪv",
    "prosecutable": "prɒsɪkjuːtəbəl",
    "prosecuted": "prɒsɪkjuːtɪd",
    "prosecute": "prɒsɪkjuːt",
    "prosecutes": "prɒsɪkjuːts",
    "prosecuting": "prɒsɪkjuːtɪŋ",
    "prosecution": "prɒsɪkjuːʃən",
    "prosecutions": "prɒsɪkjuːʃənz",
    "prosecutor": "prɒsɪkjuːtɐ",
    "prosecutors": "prɒsɪkjuːtəz",
    "proselytise": "prɒslɪtaɪz",
    "proselytising": "prɒslɪtaɪzɪŋ",
    "prose": "prəʊz",
    "prosit": "prɒsɪt",
    "prospected": "prɒspɛktɪd",
    "prospecting": "prɒspɛktɪŋ",
    "prospectively": "prəspɛktɪvli",
    "prospective": "prəspɛktɪv",
    "prospector": "prəspɛktɐ",
    "prospectors": "prəspɛktəz",
    "prospectuses": "prəspɛktəsɪz",
    "prospectus": "prəspɛktəs",
    "prospered": "prɒspəd",
    "prospering": "prɒspərɪŋ",
    "prosperity": "prəspɛrɪti",
    "prosperous": "prɒspərəs",
    "prosper": "prɒspɐ",
    "prospers": "prɒspəz",
    "pros": "prəʊz",
    "prostate": "prɒsteɪt",
    "prostates": "prɒsteɪts",
    "prostatic": "prəstætɪk",
    "prostheses": "prɒsθəsiːz",
    "prosthesis": "prɒsθəsɪs",
    "prosthetic": "prəsθɛtɪk",
    "prosthetics": "prəsθɛtɪks",
    "prostituted": "prɒstɪtjuːtɪd",
    "prostitute": "prɒstɪtjuːt",
    "prostitutes": "prɒstɪtjuːts",
    "prostituting": "prɒstɪtjuːtɪŋ",
    "prostitution": "prɒstɪtjuːʃən",
    "prostrated": "prɒstreɪtɪd",
    "prostrating": "prɒstreɪtɪŋ",
    "prostration": "prəstreɪʃən",
    "protactinium": "prəʊtɐktɪniəm",
    "protagonist": "prəʊtæɡənɪst",
    "protagonists": "prəʊtæɡənɪsts",
    "protamine": "prəʊtɐmiːn",
    "protean": "prəʊtiən",
    "protease": "prəʊteɪs",
    "protected": "prətɛktɪd",
    "protecting": "prətɛktɪŋ",
    "protectionism": "prətɛkʃənɪzəm",
    "protectionist": "prətɛkʃənɪst",
    "protectionists": "prətɛkʃənɪsts",
    "protection": "prətɛkʃən",
    "protections": "prətɛkʃənz",
    "protectively": "prətɛktɪvli",
    "protectiveness": "prətɛktɪvnəs",
    "protective": "prətɛktɪv",
    "protectorate": "prətɛktəreɪt",
    "protectorates": "prətɛktəreɪts",
    "protector": "prətɛktɐ",
    "protectors": "prətɛktəz",
    "protect": "prətɛkt",
    "protects": "prətɛkts",
    "protein": "prəʊtiːn",
    "proteins": "prəʊtiːnz",
    "protestant": "prɒtɪstənt",
    "protestants": "prɒtɪstənts",
    "protestation": "prətɪsteɪʃən",
    "protestations": "prətɪsteɪʃənz",
    "protested": "prətɛstɪd",
    "protester": "prətɛstɐ",
    "protesters": "prətɛstəz",
    "protesting": "prətɛstɪŋ",
    "protestor": "prətɛstɐ",
    "protestors": "prətɛstəz",
    "prothesis": "prɒθəsɪs",
    "prothrombin": "prɒθrəmbɪn",
    "protists": "prɒtɪsts",
    "protocol": "prəʊtəkɒl",
    "protocols": "prəʊtəkɒlz",
    "proton": "prəʊtɒn",
    "protons": "prəʊtɒnz",
    "protoplasm": "prəʊtəʊplæzəm",
    "prototyped": "prəʊtəʊtaɪpd",
    "prototype": "prəʊtəʊtaɪp",
    "prototypes": "prəʊtəʊtaɪps",
    "prototypical": "prəʊtəʊtɪpɪkəl",
    "prototyping": "prəʊtəʊtaɪpɪŋ",
    "protozoan": "prəʊtəʊzəʊn",
    "protozoa": "prəʊtəʊzəʊɐ",
    "protracted": "prətræktɪd",
    "protractor": "prətræktɐ",
    "protractors": "prətræktəz",
    "protruded": "prətruːdɪd",
    "protrude": "prətruːd",
    "protrudes": "prətruːdz",
    "protruding": "prətruːdɪŋ",
    "protrusion": "prətruːʒən",
    "protrusions": "prətruːʒənz",
    "protuberance": "prətjuːbərəns",
    "protuberances": "prətjuːbərənsɪz",
    "protuberant": "prətjuːbərənt",
    "prouder": "praʊdɐ",
    "proudest": "praʊdəst",
    "proudly": "praʊdli",
    "proudness": "praʊdnəs",
    "proud": "praʊd",
    "provable": "pruːvəbəl",
    "provably": "pruːvəbli",
    "proved": "pruːvd",
    "provenance": "pruːvnəns",
    "provenances": "pruːvnənsɪz",
    "provender": "pruːvndɐ",
    "proven": "pruːvən",
    "prove": "pruːv",
    "proverbially": "prəvɜːbɪəli",
    "proverbial": "prəvɜːbɪəl",
    "proverb": "prɒvɜːb",
    "proverbs": "prɒvɜːbz",
    "prover": "pruːvɐ",
    "proves": "pruːvz",
    "provided": "prəvaɪdɪd",
    "providence": "prɒvɪdəns",
    "providential": "prɒvɪdɛnʃəl",
    "provident": "prɒvɪdənt",
    "provide": "prəvaɪd",
    "provider": "prəvaɪdɐ",
    "providers": "prəvaɪdəz",
    "provides": "prəvaɪdz",
    "providing": "prəvaɪdɪŋ",
    "province": "prɒvɪns",
    "provinces": "prɒvɪnsɪz",
    "provincially": "prəvɪnʃəli",
    "provincial": "prəvɪnʃəl",
    "provincials": "prəvɪnʃəlz",
    "proving": "pruːvɪŋ",
    "provisionally": "prəvɪʒənəli",
    "provisional": "prəvɪʒənəl",
    "provisioned": "prəvɪʒənd",
    "provisioning": "prəvɪʒənɪŋ",
    "provision": "prəvɪʒən",
    "provisions": "prəvɪʒənz",
    "proviso": "prəvaɪzəʊ",
    "provisos": "prəvaɪzəʊz",
    "provocateur": "prəvɒkɐtɜː",
    "provocateurs": "prəvɒkɐtɜːz",
    "provocation": "prɒvəkeɪʃən",
    "provocations": "prɒvəkeɪʃənz",
    "provocatively": "prəvɒkətɪvli",
    "provocative": "prəvɒkətɪv",
    "provoked": "prəvəʊkt",
    "provoke": "prəvəʊk",
    "provokes": "prəvəʊks",
    "provoking": "prəvəʊkɪŋ",
    "provolone": "prɒvələʊn",
    "provost": "prɒvɒst",
    "provosts": "prɒvɒsts",
    "prowess": "praʊɛs",
    "prowled": "praʊld",
    "prowler": "praʊlɐ",
    "prowlers": "praʊləz",
    "prowling": "praʊlɪŋ",
    "prowl": "praʊl",
    "prowls": "praʊlz",
    "prow": "praʊ",
    "prows": "praʊz",
    "proxies": "prɒksɪz",
    "proximal": "prɒksɪməl",
    "proximate": "prɒksɪmeɪt",
    "proximity": "prɒksɪmɪti",
    "proximo": "prɒksɪməʊ",
    "proxy": "prɒksi",
    "prudence": "pruːdəns",
    "prudential": "pruːdɛnʃəl",
    "prudently": "pruːdəntli",
    "prudent": "pruːdənt",
    "prude": "pruːd",
    "prudery": "pruːdəri",
    "prudes": "pruːdz",
    "prudishness": "pruːdɪʃnəs",
    "prudish": "pruːdɪʃ",
    "pruned": "pruːnd",
    "prunella": "prʌnɛlɐ",
    "prune": "pruːn",
    "pruners": "prjuːnəz",
    "prunes": "pruːnz",
    "pruning": "pruːnɪŋ",
    "prurience": "prɔːriəns",
    "prurient": "prɔːriənt",
    "prussic": "prʌsɪk",
    "pryer": "praɪɐ",
    "prying": "praɪɪŋ",
    "pry": "praɪ",
    "psalmist": "sɑːmɪst",
    "psalmists": "sɑːmɪsts",
    "psalmody": "sɑːmədi",
    "psalm": "sɑːm",
    "psalms": "sɑːmz",
    "psalter": "sɒltɐ",
    "psaltery": "sɒltəri",
    "psephological": "sɛfəlɒdʒɪkəl",
    "psephologist": "sɛfɒlədʒɪst",
    "psephologists": "sɛfɒlədʒɪsts",
    "psephology": "sɛfɒlədʒi",
    "pseudonyms": "suːdəʊnɪmz",
    "pseudonym": "suːdəʊnɪm",
    "pseudoscience": "suːdəʊsaɪəns",
    "pseudo": "suːdəʊ",
    "pshaw": "piːʃɔː",
    "psi": "saɪ",
    "psoriasis": "sɔːrɪæsiz",
    "ps": "piːɛs",
    "psst": "psst",
    "psychedelia": "saɪkɪdiːliə",
    "psychedelically": "saɪkɪdɛlɪkli",
    "psychedelic": "saɪkɪdɛlɪk",
    "psychedelics": "saɪkɪdɛlɪks",
    "psyched": "saɪkd",
    "psyche": "saɪkiː",
    "psyches": "saɪkiːɪz",
    "psychiatric": "saɪkɪætrɪk",
    "psychiatrist": "saɪkaɪətrɪst",
    "psychiatrists": "saɪkaɪətrɪsts",
    "psychiatry": "saɪkaɪətri",
    "psychically": "saɪkɪkli",
    "psychical": "saɪkɪkəl",
    "psychic": "saɪkɪk",
    "psychics": "saɪkɪks",
    "psyching": "saɪkɪŋ",
    "psychoactive": "saɪkəʊæktɪv",
    "psychoanalysed": "saɪkəʊænɐlaɪzd",
    "psychoanalyse": "saɪkəʊænɐlaɪz",
    "psychoanalysis": "saɪkəʊɐnæləsɪs",
    "psychoanalyst": "saɪkəʊænɐlɪst",
    "psychoanalysts": "saɪkəʊænɐlɪsts",
    "psychoanalytical": "saɪkəʊænɐlɪtɪkəl",
    "psychoanalytic": "saɪkəʊænɐlɪtɪk",
    "psychobabble": "saɪkəʊbæbəl",
    "psychodrama": "saɪkəʊdrɑːmɐ",
    "psycholinguistics": "saɪkəʊlɪŋɡwɪstɪks",
    "psychologically": "saɪkəlɒdʒɪkli",
    "psychological": "saɪkəlɒdʒɪkəl",
    "psychologies": "saɪkɒlədʒɪz",
    "psychologist": "saɪkɒlədʒɪst",
    "psychologists": "saɪkɒlədʒɪsts",
    "psychology": "saɪkɒlədʒi",
    "psychometric": "saɪkəʊmɛtrɪk",
    "psychometrics": "saɪkəʊmɛtrɪks",
    "psychometry": "saɪkəʊmətri",
    "psychoneuroses": "saɪkəʊnjuːrəʊzɪz",
    "psychopathic": "saɪkəʊpæθɪk",
    "psychopathology": "saɪkəʊpɐθɒlədʒi",
    "psychopath": "saɪkəʊpɑːθ",
    "psychopaths": "saɪkəʊpɑːθs",
    "psychopathy": "saɪkəʊpəθi",
    "psycho": "saɪkəʊ",
    "psychosexual": "saɪkəʊsɛkʃuːəl",
    "psychosis": "saɪkəʊsɪs",
    "psychosomatic": "saɪkəʊsəmætɪk",
    "psychos": "saɪkəʊz",
    "psychotherapeutic": "saɪkəʊθɛrəpjuːtɪk",
    "psychotherapist": "saɪkəʊθɛrəpɪst",
    "psychotherapists": "saɪkəʊθɛrəpɪsts",
    "psychotherapy": "saɪkəʊθɛrəpi",
    "psychotically": "saɪkɒtɪkli",
    "psychotic": "saɪkɒtɪk",
    "psychotics": "saɪkɒtɪks",
    "psychotropic": "saɪkəʊtrɒpɪk",
    "psych": "saɪk",
    "psychs": "saɪkz",
    "ptarmigan": "tɑːmɪɡən",
    "pterodactyls": "tɛrədæktaɪlz",
    "pterodactyl": "tɛrədæktaɪl",
    "pterosaurs": "tɛrəsɔːz",
    "pterosaur": "tɛrəsɔː",
    "ptomaine": "tɒmeɪn",
    "puberty": "pjuːbəti",
    "pubescent": "pjuːbɛsənt",
    "pubes": "pjuːbz",
    "pubic": "pjuːbɪk",
    "pubis": "pjuːbɪs",
    "publican": "pʌblɪkən",
    "publicans": "pʌblɪkənz",
    "publication": "pʌblɪkeɪʃən",
    "publications": "pʌblɪkeɪʃənz",
    "publicised": "pʌblɪsaɪzd",
    "publicise": "pʌblɪsaɪz",
    "publicising": "pʌblɪsaɪzɪŋ",
    "publicist": "pʌblɪsɪst",
    "publicists": "pʌblɪsɪsts",
    "publicity": "pʌblɪsɪti",
    "publicly": "pʌblɪkli",
    "public": "pʌblɪk",
    "publishable": "pʌblɪʃəbəl",
    "published": "pʌblɪʃt",
    "publisher": "pʌblɪʃɐ",
    "publishers": "pʌblɪʃəz",
    "publishes": "pʌblɪʃɪz",
    "publishing": "pʌblɪʃɪŋ",
    "publish": "pʌblɪʃ",
    "pub": "pʌb",
    "pubs": "pʌbz",
    "puce": "pjuːs",
    "pucka": "pʌkɐ",
    "puckered": "pʌkəd",
    "puckering": "pʌkərɪŋ",
    "pucker": "pʌkɐ",
    "puckers": "pʌkəz",
    "puckish": "pʌkɪʃ",
    "puck": "pʌk",
    "pucks": "pʌks",
    "pudding": "pʊdɪŋ",
    "puddings": "pʊdɪŋz",
    "puddled": "pʌdəld",
    "puddle": "pʌdəl",
    "puddles": "pʌdəlz",
    "puddling": "pʌdlɪŋ",
    "pudendum": "pjuːdəndəm",
    "pudgy": "pʌdʒi",
    "pud": "pʊd",
    "puds": "pʊdz",
    "pueblo": "pjuːbləʊ",
    "puerile": "pjuːraɪl",
    "puerperal": "pjuːəpərəl",
    "puffball": "pʌfbɔːl",
    "puffballs": "pʌfbɔːlz",
    "puffed": "pʌft",
    "puffer": "pʌfɐ",
    "puffers": "pʌfəz",
    "puffery": "pʌfəri",
    "puffier": "pʌfɪɐ",
    "puffiness": "pʌfɪnəs",
    "puffing": "pʌfɪŋ",
    "puffin": "pʌfɪn",
    "puffins": "pʌfɪnz",
    "puff": "pʌf",
    "puffs": "pʌfs",
    "puffy": "pʌfi",
    "pugilism": "pjuːdʒɪlɪzəm",
    "pugilistic": "pjuːdʒɪlɪstɪk",
    "pugilist": "pjuːdʒɪlɪst",
    "pugilists": "pjuːdʒɪlɪsts",
    "pugnacious": "pʌɡneɪʃəs",
    "pug": "pʌɡ",
    "pugs": "pʌɡz",
    "puissance": "pjuːɪsəns",
    "puissant": "pjuːɪsənt",
    "puked": "pjuːkt",
    "puke": "pjuːk",
    "pukes": "pjuːks",
    "puking": "pjuːkɪŋ",
    "pukka": "pʌkɐ",
    "pula": "pjʊlɐ",
    "puled": "pjuːld",
    "pullback": "pʊlbæk",
    "pullbacks": "pʊlbæks",
    "pulled": "pʊld",
    "puller": "pʊlɐ",
    "pullers": "pʊləz",
    "pullet": "pʊlɪt",
    "pullets": "pʊlɪts",
    "pulley": "pʊli",
    "pulleys": "pʊlɪz",
    "pulling": "pʊlɪŋ",
    "pullout": "pʊlaʊt",
    "pullover": "pʊləʊvɐ",
    "pullovers": "pʊləʊvəz",
    "pull": "pʊl",
    "pulls": "pʊlz",
    "pullulating": "pʊljʊleɪtɪŋ",
    "pulmonary": "pʌlmənəri",
    "pulped": "pʌlpt",
    "pulping": "pʌlpɪŋ",
    "pulpit": "pʌlpɪt",
    "pulpits": "pʌlpɪts",
    "pul": "pʌl",
    "pulp": "pʌlp",
    "pulps": "pʌlps",
    "pulpy": "pʌlpi",
    "pulsar": "pʌlsɑː",
    "pulsars": "pʌlsɑːz",
    "pulsated": "pʌlseɪtɪd",
    "pulsate": "pʌlseɪt",
    "pulsates": "pʌlseɪts",
    "pulsating": "pʌlseɪtɪŋ",
    "pulsation": "pʌlseɪʃən",
    "pulsations": "pʌlseɪʃənz",
    "pulsed": "pʌlzd",
    "pulse": "pʌls",
    "pulses": "pʌlsɪz",
    "pulsing": "pʌlsɪŋ",
    "pulverised": "pʌlvəraɪzd",
    "pulverise": "pʌlvəraɪz",
    "pulverises": "pʌlvəraɪzɪz",
    "pulverising": "pʌlvəraɪzɪŋ",
    "puma": "puːmɐ",
    "pumas": "puːməz",
    "pumice": "pjuːmɪs",
    "pummelled": "pʌməld",
    "pummelling": "pʌməlɪŋ",
    "pummel": "pʌməl",
    "pummels": "pʌməlz",
    "pumped": "pʌmpt",
    "pumpernickel": "pʌmpənɪkəl",
    "pumper": "pʌmpɐ",
    "pumping": "pʌmpɪŋ",
    "pumpkin": "pʌmpkɪn",
    "pumpkins": "pʌmpkɪnz",
    "pump": "pʌmp",
    "pumps": "pʌmps",
    "punchbag": "pʌntʃbæɡ",
    "punchbags": "pʌntʃbæɡz",
    "punchball": "pʌntʃbɔːl",
    "punchbowl": "pʌntʃbəʊl",
    "punched": "pʌntʃt",
    "puncheon": "pʌntʃən",
    "puncher": "pʌntʃɐ",
    "punchers": "pʌntʃəz",
    "punches": "pʌntʃɪz",
    "punchier": "pʌntʃɪɐ",
    "punching": "pʌntʃɪŋ",
    "punchline": "pʌntʃlaɪn",
    "punchlines": "pʌntʃlaɪnz",
    "punch": "pʌntʃ",
    "punchy": "pʌntʃi",
    "punctilious": "pʌŋktɪlɪəs",
    "punctuality": "pʌŋktʃuːælɪti",
    "punctually": "pʌŋktʃuːəli",
    "punctual": "pʌŋktʃuːəl",
    "punctuated": "pʌŋktʃuːeɪtɪd",
    "punctuate": "pʌŋktʃuːeɪt",
    "punctuates": "pʌŋktʃuːeɪts",
    "punctuating": "pʌŋktʃuːeɪtɪŋ",
    "punctuation": "pʌŋktʃuːeɪʃən",
    "punctuations": "pʌŋktʃuːeɪʃənz",
    "punctured": "pʌŋktʃəd",
    "puncture": "pʌŋktʃɐ",
    "punctures": "pʌŋktʃəz",
    "puncturing": "pʌŋktʃərɪŋ",
    "pundit": "pʌndɪt",
    "punditry": "pʌndɪtri",
    "pundits": "pʌndɪts",
    "pungency": "pʌndʒənsi",
    "pungently": "pʌndʒəntli",
    "pungent": "pʌndʒənt",
    "pung": "pʌŋ",
    "pungs": "pʌŋz",
    "puniness": "pjuːninəs",
    "punishable": "pʌnɪʃəbəl",
    "punished": "pʌnɪʃt",
    "punishes": "pʌnɪʃɪz",
    "punishingly": "pʌnɪʃɪŋli",
    "punishing": "pʌnɪʃɪŋ",
    "punishment": "pʌnɪʃmənt",
    "punishments": "pʌnɪʃmənts",
    "punish": "pʌnɪʃ",
    "punitively": "pjuːnɪtɪvli",
    "punitive": "pjuːnɪtɪv",
    "punk": "pʌŋk",
    "punks": "pʌŋks",
    "punnet": "pʌnɪt",
    "punnets": "pʌnɪts",
    "punning": "pʌnɪŋ",
    "pun": "pʌn",
    "puns": "pʌnz",
    "punted": "pʌntɪd",
    "punter": "pʌntɐ",
    "punters": "pʌntəz",
    "punting": "pʌntɪŋ",
    "punt": "pʌnt",
    "punts": "pʌnts",
    "puny": "pjuːni",
    "pupae": "pjuːpiː",
    "pupal": "pjuːpəl",
    "pupa": "pjuːpɐ",
    "pupas": "pjuːpəz",
    "pupate": "pjuːpeɪt",
    "pupates": "pjuːpeɪts",
    "pupating": "pjuːpeɪtɪŋ",
    "pupillage": "pjuːpɪlɪdʒ",
    "pupil": "pjuːpəl",
    "pupils": "pjuːpəlz",
    "pupped": "pʌpt",
    "puppeteer": "pʌpɪtiə",
    "puppeteers": "pʌpɪtiəz",
    "puppet": "pʌpɪt",
    "puppetry": "pʌpɪtri",
    "puppets": "pʌpɪts",
    "puppies": "pʌpɪz",
    "pupping": "pʌpɪŋ",
    "pup": "pʌp",
    "puppy": "pʌpi",
    "pups": "pʌps",
    "purchasable": "pɜːtʃɪsəbəl",
    "purchased": "pɜːtʃɪsd",
    "purchase": "pɜːtʃɪs",
    "purchaser": "pɜːtʃɪsɐ",
    "purchasers": "pɜːtʃɪsəz",
    "purchases": "pɜːtʃɪsɪz",
    "purchasing": "pɜːtʃɪsɪŋ",
    "purdah": "pɜːdɐ",
    "purebred": "pjʊrɛbrəd",
    "pureed": "pjɔːreɪd",
    "pureeing": "pjɔːreɪɪŋ",
    "puree": "pjɔːreɪ",
    "purees": "pjɔːreɪz",
    "purely": "pjɔːli",
    "pureness": "pjɔːnəs",
    "pure": "pjɔː",
    "purer": "pjʊrɐ",
    "purest": "pjʊrəst",
    "purgative": "pɜːɡətɪv",
    "purgatory": "pɜːɡətəri",
    "purged": "pɜːdʒd",
    "purge": "pɜːdʒ",
    "purges": "pɜːdʒɪz",
    "purging": "pɜːdʒɪŋ",
    "purification": "pjʊrɪfɪkeɪʃən",
    "purified": "pjʊrɪfaɪd",
    "purifier": "pjʊrɪfaɪə",
    "purifies": "pjʊrɪfaɪz",
    "purifying": "pjʊrɪfaɪɪŋ",
    "purify": "pjʊrɪfaɪ",
    "purism": "pjɔːrɪzəm",
    "purist": "pjɔːrɪst",
    "purists": "pjɔːrɪsts",
    "puritanical": "pjʊrɪtænɪkəl",
    "puritanism": "pjʊrɪtənɪzəm",
    "puritan": "pjʊrɪtən",
    "puritans": "pjʊrɪtənz",
    "purities": "pjʊrɪtiz",
    "purity": "pjʊrɪti",
    "purlin": "pɜːlɪn",
    "purloined": "pɜːlɔɪnd",
    "purloining": "pɜːlɔɪnɪŋ",
    "purloin": "pɜːlɔɪn",
    "purl": "pɜːl",
    "purpleness": "pɜːpəlnəs",
    "purple": "pɜːpəl",
    "purples": "pɜːpəlz",
    "purplish": "pɜːplɪʃ",
    "purportedly": "pɜːpɔːtɪdli",
    "purported": "pɜːpɔːtɪd",
    "purporting": "pɜːpɔːtɪŋ",
    "purports": "pɜːpɔːts",
    "purposed": "pɜːpəsd",
    "purposefully": "pɜːpəsfəli",
    "purposeful": "pɜːpəsfəl",
    "purposeless": "pɜːpəsləs",
    "purposely": "pɜːpəsli",
    "purpose": "pɜːpəs",
    "purposes": "pɜːpəsɪz",
    "purposing": "pɜːpəsɪŋ",
    "purpura": "pɜːpjɔːrɐ",
    "purred": "pɜːd",
    "purring": "pɜːrɪŋ",
    "purr": "pɜː",
    "purrs": "pɜːz",
    "pursed": "pɜːsd",
    "purse": "pɜːs",
    "purser": "pɜːsɐ",
    "pursers": "pɜːsəz",
    "purses": "pɜːsɪz",
    "pursing": "pɜːsɪŋ",
    "purslane": "pɜːsleɪn",
    "pursuance": "pəsjuːəns",
    "pursuant": "pəsjuːənt",
    "pursued": "pəsjuːd",
    "pursue": "pəsjuː",
    "pursuer": "pəsjuːɐ",
    "pursuers": "pəsjuːəz",
    "pursues": "pəsjuːz",
    "pursuing": "pəsjuːɪŋ",
    "pursuit": "pəsuːt",
    "pursuits": "pəsuːts",
    "purulent": "pjʊruːlənt",
    "purveyed": "pɜːveɪd",
    "purveying": "pɜːveɪɪŋ",
    "purveyor": "pɜːveɪɐ",
    "purveyors": "pɜːveɪəz",
    "purvey": "pɜːveɪ",
    "purview": "pɜːvjuː",
    "pushbike": "pʊʃbaɪk",
    "pushbikes": "pʊʃbaɪks",
    "pushcarts": "pʊʃkɑːts",
    "pushchair": "pʊʃtʃeə",
    "pushchairs": "pʊʃtʃeəz",
    "pushed": "pʊʃt",
    "pusher": "pʊʃɐ",
    "pushers": "pʊʃəz",
    "pushes": "pʊʃɪz",
    "pushing": "pʊʃɪŋ",
    "pushover": "pʊʃəʊvɐ",
    "pushovers": "pʊʃəʊvəz",
    "push": "pʊʃ",
    "pushy": "pʊʃi",
    "pusillanimous": "pjuːsɪlænɪməs",
    "pus": "pʌs",
    "pusses": "pʊsɪz",
    "pussies": "pʊsɪz",
    "puss": "pʊs",
    "pussycat": "pʊsɪkæt",
    "pussycats": "pʊsɪkæts",
    "pussyfooting": "pʊsɪfʊtɪŋ",
    "pussyfoot": "pʊsɪfʊt",
    "pustular": "pʌstjʊlɐ",
    "pustule": "pʌstjuːl",
    "pustules": "pʌstjuːlz",
    "putative": "pjuːtətɪv",
    "putdown": "pʌtdaʊn",
    "putdowns": "pʌtdaʊnz",
    "putrefaction": "pjuːtrɪfækʃən",
    "putrefied": "pjuːtrɪfaɪd",
    "putrefies": "pjuːtrɪfaɪz",
    "putrefying": "pjuːtrɪfaɪɪŋ",
    "putrefy": "pjuːtrɪfaɪ",
    "putrescence": "pjuːtrɛsəns",
    "putrescent": "pjuːtrɛsənt",
    "putrid": "pjuːtrɪd",
    "putsches": "pʌtʃɪz",
    "putsch": "pʌtʃ",
    "putted": "pʌtɪd",
    "puttees": "pʌtiːz",
    "puttering": "pʌtərɪŋ",
    "putters": "pʊtəz",
    "putto": "pʌtəʊ",
    "putt": "pʌt",
    "putts": "pʌts",
    "putty": "pʌti",
    "putz": "pʌts",
    "puzzled": "pʌzəld",
    "puzzlement": "pʌzəlmənt",
    "puzzle": "pʌzəl",
    "puzzler": "pʌzlɐ",
    "puzzlers": "pʌzləz",
    "puzzles": "pʌzəlz",
    "puzzling": "pʌzlɪŋ",
    "pye": "paɪ",
    "pygmies": "pɪɡmɪz",
    "pygmy": "pɪɡmi",
    "pyjama": "pədʒɑːmɐ",
    "pyjamas": "pədʒɑːməz",
    "pylon": "paɪlɒn",
    "pylons": "paɪlɒnz",
    "pyloric": "paɪlɒrɪk",
    "pylori": "paɪlɔːri",
    "pyramidal": "pɪræmɪdəl",
    "pyramid": "pɪrɐmɪd",
    "pyramids": "pɪrɐmɪdz",
    "pyre": "paɪə",
    "pyres": "paɪəz",
    "pyrexia": "paɪrɛksiə",
    "pyrite": "pɪraɪt",
    "pyrites": "paɪraɪtiːz",
    "pyroclastic": "paɪrəʊklɑːstɪk",
    "pyrography": "paɪrəʊɡræfi",
    "pyromaniac": "paɪrəʊmeɪnɪæk",
    "pyromaniacs": "paɪrəʊmeɪnɪæks",
    "pyromania": "paɪrəʊmeɪniɐ",
    "pyrosis": "paɪrəʊsɪs",
    "pyrotechnic": "paɪrəʊtɛknɪk",
    "pyrotechnics": "paɪrəʊtɛknɪks",
    "pyroxenes": "paɪrəʊziːnz",
    "pyrrhic": "pɪrhɪk",
    "python": "paɪθən",
    "pythons": "paɪθənz",
    "pzazz": "piːzæz",
    "qibla": "kɪblɐ",
    "qi": "kaɪ",
    "q": "kjuː",
    "quacked": "kwækt",
    "quackery": "kwækəri",
    "quacking": "kwækɪŋ",
    "quack": "kwæk",
    "quacks": "kwæks",
    "quad": "kwɒd",
    "quadrangle": "kwɒdræŋɡəl",
    "quadrangles": "kwɒdræŋɡəlz",
    "quadrant": "kwɒdrənt",
    "quadrants": "kwɒdrənts",
    "quadraphonic": "kwɒdrɐfɒnɪk",
    "quadratic": "kwɒdrætɪk",
    "quadrat": "kwɒdræt",
    "quadrennial": "kwɒdrɛnɪəl",
    "quadriceps": "kwɒdraɪsəps",
    "quadricycle": "kwɒdrɪsaɪkəl",
    "quadrilateral": "kwɒdrɪlætərəl",
    "quadrilaterals": "kwɒdrɪlætərəlz",
    "quadrille": "kwɒdrɪl",
    "quadrilles": "kwɒdrɪlz",
    "quadrillion": "kwɒdrɪliən",
    "quadripartite": "kwɒdrɪpɑːtaɪt",
    "quadriplegic": "kwɒdrɪpliːdʒɪk",
    "quadroon": "kwɒdruːn",
    "quadruped": "kwɒdruːpt",
    "quadrupeds": "kwɒdruːptz",
    "quadrupled": "kwɒdruːpəld",
    "quadruplets": "kwɒdruːpləts",
    "quadrupling": "kwɒdruːplɪŋ",
    "quads": "kwɒdz",
    "quaffed": "kwɒft",
    "quaffing": "kwɒfɪŋ",
    "quaff": "kwɒf",
    "quagga": "kwæɡɐ",
    "quag": "kwæɡ",
    "quagmire": "kwæɡmaɪə",
    "quagmires": "kwæɡmaɪəz",
    "quahog": "kwæhɒɡ",
    "quai": "kwaɪ",
    "quailed": "kweɪld",
    "quailing": "kweɪlɪŋ",
    "quail": "kweɪl",
    "quails": "kweɪlz",
    "quaintest": "kweɪntəst",
    "quaint": "kweɪnt",
    "quaintly": "kweɪntli",
    "quaintness": "kweɪntnəs",
    "quaked": "kweɪkt",
    "quake": "kweɪk",
    "quakes": "kweɪks",
    "quaking": "kweɪkɪŋ",
    "qua": "kwæ",
    "quale": "kwɒl",
    "qualification": "kwɒlɪfɪkeɪʃən",
    "qualifications": "kwɒlɪfɪkeɪʃənz",
    "qualified": "kwɒlɪfaɪd",
    "qualifier": "kwɒlɪfaɪə",
    "qualifiers": "kwɒlɪfaɪəz",
    "qualifies": "kwɒlɪfaɪz",
    "qualifying": "kwɒlɪfaɪɪŋ",
    "qualify": "kwɒlɪfaɪ",
    "qualitative": "kwɒlɪteɪtɪv",
    "qualitatively": "kwɒlɪteɪtɪvli",
    "qualities": "kwɒlɪtiz",
    "quality": "kwɒlɪti",
    "qualm": "kwɑːm",
    "qualms": "kwɑːmz",
    "quandary": "kwɒndəri",
    "quango": "kwɒnɡəʊ",
    "quangos": "kwɒnɡəʊz",
    "quanta": "kwɒntɐ",
    "quantifiable": "kwɒntɪfaɪəbəl",
    "quantification": "kwɒntɪfɪkeɪʃən",
    "quantified": "kwɒntɪfaɪd",
    "quantifying": "kwɒntɪfaɪɪŋ",
    "quantify": "kwɒntɪfaɪ",
    "quantitative": "kwɒntɪteɪtɪv",
    "quantitatively": "kwɒntɪteɪtɪvli",
    "quantities": "kwɒntɪtiz",
    "quantity": "kwɒntɪti",
    "quant": "kwɒnt",
    "quantum": "kwɒntəm",
    "quarantined": "kwɒrɑːntiːnd",
    "quarantine": "kwɒrɑːntiːn",
    "quarantining": "kwɒrɑːntiːnɪŋ",
    "quark": "kwɑːk",
    "quarks": "kwɑːks",
    "quarrel": "kwɒrəl",
    "quarrelled": "kwɒrəld",
    "quarrelling": "kwɒrəlɪŋ",
    "quarrels": "kwɒrəlz",
    "quarrelsome": "kwɒrəlsʌm",
    "quarried": "kwɒrɪd",
    "quarriers": "kwɒriəz",
    "quarries": "kwɒrɪz",
    "quarrying": "kwɒrɪɪŋ",
    "quarry": "kwɒri",
    "quarrymen": "kwɒrɪmɛn",
    "quarterbacking": "kwɔːtəbækɪŋ",
    "quarterback": "kwɔːtəbæk",
    "quarterbacks": "kwɔːtəbæks",
    "quarterdeck": "kwɔːtədɛk",
    "quartered": "kwɔːtəd",
    "quarterfinal": "kwɔːtəfaɪnəl",
    "quarterfinals": "kwɔːtəfaɪnəlz",
    "quartering": "kwɔːtərɪŋ",
    "quarter": "kwɔːtɐ",
    "quarterlies": "kwɔːtəliz",
    "quarterly": "kwɔːtəli",
    "quartermaster": "kwɔːtəmɑːstɐ",
    "quartermasters": "kwɔːtəmɑːstəz",
    "quarters": "kwɔːtəz",
    "quartet": "kwɔːtɛt",
    "quartets": "kwɔːtɛts",
    "quartic": "kwɔːtɪk",
    "quartile": "kwɔːtaɪl",
    "quart": "kwɔːt",
    "quarto": "kwɔːtəʊ",
    "quarts": "kwɔːts",
    "quartzite": "kwɔːtsaɪt",
    "quartz": "kwɔːts",
    "quasar": "kweɪzɑː",
    "quasars": "kweɪzɑːz",
    "quashed": "kwɒʃt",
    "quashes": "kwɒʃɪz",
    "quashing": "kwɒʃɪŋ",
    "quash": "kwɒʃ",
    "quasi": "kweɪzaɪ",
    "quaternary": "kwətɜːnəri",
    "quatrain": "kwætreɪn",
    "quatrains": "kwætreɪnz",
    "quatrefoil": "kwætrɪfɔɪl",
    "quatre": "kwætɐ",
    "quattrocento": "kwætrəʊsɛntəʊ",
    "quavering": "kweɪvərɪŋ",
    "quaver": "kweɪvɐ",
    "quavers": "kweɪvəz",
    "quavery": "kweɪvəri",
    "quay": "kiː",
    "quayside": "kiːsaɪd",
    "quaysides": "kiːsaɪdz",
    "quays": "kiːz",
    "queasiness": "kwiːzɪnəs",
    "queasy": "kwiːzi",
    "queendom": "kwiːndəm",
    "queening": "kwiːnɪŋ",
    "queen": "kwiːn",
    "queenly": "kwiːnli",
    "queens": "kwiːnz",
    "queered": "kwiəd",
    "queerest": "kwiərəst",
    "queer": "kwiə",
    "queerness": "kwiənəs",
    "queers": "kwiəz",
    "quelled": "kwɛld",
    "quelling": "kwɛlɪŋ",
    "quell": "kwɛl",
    "quenched": "kwɛntʃt",
    "quencher": "kwɛntʃɐ",
    "quenches": "kwɛntʃɪz",
    "quenching": "kwɛntʃɪŋ",
    "quench": "kwɛntʃ",
    "quenelle": "kwɛnɛl",
    "queried": "kwiərɪd",
    "queries": "kwiərɪz",
    "quern": "kwɜːn",
    "querns": "kwɜːnz",
    "querulous": "kwɜːjʊləs",
    "querying": "kwiərɪɪŋ",
    "query": "kwiəri",
    "quesadilla": "keɪsədiːɐ",
    "quested": "kwɛstɪd",
    "quester": "kwɛstɐ",
    "questing": "kwɛstɪŋ",
    "questionable": "kwɛstʃənəbəl",
    "questionably": "kwɛstʃənəbli",
    "questioned": "kwɛstʃənd",
    "questioner": "kwɛstʃənɐ",
    "questioners": "kwɛstʃənəz",
    "questioning": "kwɛstʃənɪŋ",
    "question": "kwɛstʃən",
    "questionnaire": "kwɛstʃəneə",
    "questionnaires": "kwɛstʃəneəz",
    "questions": "kwɛstʃənz",
    "quest": "kwɛst",
    "questor": "kwɛstɐ",
    "quests": "kwɛsts",
    "quetzal": "kwɛtsəl",
    "queued": "kjuːd",
    "queue": "kjuː",
    "queues": "kjuːz",
    "queuing": "kjuːɪŋ",
    "quibbled": "kwɪbəld",
    "quibble": "kwɪbəl",
    "quibbles": "kwɪbəlz",
    "quibbling": "kwɪblɪŋ",
    "quiche": "kiːʃ",
    "quiches": "kiːʃɪz",
    "quickened": "kwɪkənd",
    "quickening": "kwɪkənɪŋ",
    "quicken": "kwɪkən",
    "quickens": "kwɪkənz",
    "quicker": "kwɪkɐ",
    "quickest": "kwɪkəst",
    "quickfire": "kwɪkfaɪə",
    "quickie": "kwɪki",
    "quickies": "kwɪkiz",
    "quick": "kwɪk",
    "quicklime": "kwɪklaɪm",
    "quickly": "kwɪkli",
    "quickness": "kwɪknəs",
    "quicksand": "kwɪksænd",
    "quicksands": "kwɪksændz",
    "quicksilver": "kwɪksɪlvɐ",
    "quickstep": "kwɪkstɛp",
    "quicksteps": "kwɪkstɛps",
    "quiddity": "kwɪdɪti",
    "quid": "kwɪd",
    "quids": "kwɪdz",
    "quiescent": "kwɪɛsənt",
    "quieted": "kwaɪətɪd",
    "quietened": "kwaɪətənd",
    "quietening": "kwaɪətənɪŋ",
    "quieten": "kwaɪətən",
    "quietens": "kwaɪətənz",
    "quieter": "kwaɪətɐ",
    "quietest": "kwaɪətəst",
    "quieting": "kwaɪətɪŋ",
    "quiet": "kwaɪət",
    "quietly": "kwaɪətli",
    "quietness": "kwaɪətnəs",
    "quiets": "kwaɪəts",
    "quietude": "kwaɪətjuːd",
    "quiff": "kwɪf",
    "quiffs": "kwɪfs",
    "quill": "kwɪl",
    "quills": "kwɪlz",
    "quilted": "kwɪltɪd",
    "quilter": "kwɪltɐ",
    "quilting": "kwɪltɪŋ",
    "quilt": "kwɪlt",
    "quilts": "kwɪlts",
    "quinary": "kwɪnəri",
    "quince": "kwɪns",
    "quinces": "kwɪnsɪz",
    "quincunx": "kwɪnkʌŋks",
    "quinine": "kwɪnaɪn",
    "quin": "kwɪn",
    "quins": "kwɪnz",
    "quintain": "kwɪnteɪn",
    "quintessence": "kwɪntɛsəns",
    "quintessential": "kwɪntɪsɛnʃəl",
    "quintessentially": "kwɪntɪsɛnʃəli",
    "quintet": "kwɪntɛt",
    "quintets": "kwɪntɛts",
    "quintillion": "kwɪntɪliən",
    "quint": "kwɪnt",
    "quintuple": "kwɪntuːpəl",
    "quintuplets": "kwɪntuːpləts",
    "quinze": "kwɪnz",
    "quip": "kwɪp",
    "quipped": "kwɪpt",
    "quipping": "kwɪpɪŋ",
    "quips": "kwɪps",
    "quire": "kwaɪə",
    "quires": "kwaɪəz",
    "quirkier": "kwɜːkiɐ",
    "quirkiest": "kwɜːkiəst",
    "quirkiness": "kwɜːkinəs",
    "quirk": "kwɜːk",
    "quirks": "kwɜːks",
    "quirky": "kwɜːki",
    "quirt": "kwɜːt",
    "quisling": "kwɪslɪŋ",
    "quit": "kwɪt",
    "quits": "kwɪts",
    "quitted": "kwɪtɪd",
    "quitter": "kwɪtɐ",
    "quitters": "kwɪtəz",
    "quitting": "kwɪtɪŋ",
    "quivered": "kwɪvəd",
    "quivering": "kwɪvərɪŋ",
    "quiver": "kwɪvɐ",
    "quivers": "kwɪvəz",
    "quivery": "kwaɪvəri",
    "quixotic": "kwɪksɒtɪk",
    "quiz": "kwɪz",
    "quizmaster": "kwɪzmɑːstɐ",
    "quizmasters": "kwɪzmɑːstəz",
    "quizzed": "kwɪzd",
    "quizzer": "kwɪzɐ",
    "quizzers": "kwɪzəz",
    "quizzes": "kwɪzɪz",
    "quizzical": "kwɪzɪkəl",
    "quizzically": "kwɪzɪkli",
    "quizzing": "kwɪzɪŋ",
    "quod": "kwɒd",
    "quoit": "kwɔɪt",
    "quoits": "kwɔɪts",
    "quondam": "kwɒndəm",
    "quorate": "kwɔːreɪt",
    "quorum": "kwɔːrəm",
    "quotable": "kwəʊtəbəl",
    "quota": "kwəʊtɐ",
    "quotas": "kwəʊtəz",
    "quotation": "kwəʊteɪʃən",
    "quotations": "kwəʊteɪʃənz",
    "quoted": "kwəʊtɪd",
    "quote": "kwəʊt",
    "quotes": "kwəʊts",
    "quoth": "kwɒθ",
    "quotidian": "kwɒtɪdiən",
    "quotient": "kwəʊʃənt",
    "quoting": "kwəʊtɪŋ",
    "qwerty": "kjuːwɜːti",
    "r": "ɑː",
    "rabbi": "ræbaɪ",
    "rabbinic": "ræbɪnɪk",
    "rabbinical": "ræbɪnɪkəl",
    "rabbis": "ræbaɪz",
    "rabbit": "ræbɪt",
    "rabbiting": "ræbɪtɪŋ",
    "rabbits": "ræbɪts",
    "rabble": "ræbəl",
    "rabbles": "ræbəlz",
    "rabid": "reɪbɪd",
    "rabies": "reɪbɪz",
    "raccoon": "rækuːn",
    "raccoons": "rækuːnz",
    "racecourse": "reɪskɔːs",
    "racecourses": "reɪskɔːsɪz",
    "raced": "reɪsd",
    "race": "reɪs",
    "racegoer": "reɪsɡəʊɐ",
    "racegoers": "reɪsɡəʊəz",
    "racehorse": "reɪshɔːs",
    "racehorses": "reɪshɔːsɪz",
    "racemes": "rɐsiːmz",
    "racer": "reɪsɐ",
    "racers": "reɪsəz",
    "races": "reɪsɪz",
    "racetrack": "reɪstræk",
    "racetracks": "reɪstræks",
    "raceway": "reɪsweɪ",
    "rachitic": "rætʃɪtɪk",
    "racial": "reɪʃəl",
    "racialism": "reɪʃəlɪzəm",
    "racialist": "reɪʃəlɪst",
    "racialists": "reɪʃəlɪsts",
    "racially": "reɪʃəli",
    "racier": "reɪsɪɐ",
    "racing": "reɪsɪŋ",
    "racism": "reɪsɪzəm",
    "racist": "reɪsɪst",
    "racists": "reɪsɪsts",
    "rack": "ræk",
    "racked": "rækt",
    "racket": "rækɪt",
    "racketeer": "rækɪtiə",
    "racketeering": "rækɪtiərɪŋ",
    "racketeers": "rækɪtiəz",
    "racketing": "rækɪtɪŋ",
    "rackets": "rækɪts",
    "rackety": "rækɪti",
    "racking": "rækɪŋ",
    "racks": "ræks",
    "racon": "rækən",
    "raconteur": "rækəntɜː",
    "raconteurs": "rækəntɜːz",
    "racoon": "rækuːn",
    "racoons": "rækuːnz",
    "racquet": "rækeɪ",
    "racquetball": "rækwɪtbɔːl",
    "racquets": "rækeɪs",
    "racy": "reɪsi",
    "radar": "reɪdɑː",
    "radars": "reɪdɑːz",
    "raddle": "rædəl",
    "raddled": "rædəld",
    "radial": "reɪdɪəl",
    "radially": "reɪdɪəli",
    "radials": "reɪdɪəlz",
    "radiance": "reɪdiəns",
    "radians": "reɪdiənz",
    "radiant": "reɪdiənt",
    "radiantly": "reɪdiəntli",
    "radiated": "reɪdɪeɪtɪd",
    "radiate": "reɪdɪeɪt",
    "radiates": "reɪdɪeɪts",
    "radiating": "reɪdɪeɪtɪŋ",
    "radiation": "reɪdɪeɪʃən",
    "radiations": "reɪdɪeɪʃənz",
    "radiator": "reɪdɪeɪtɐ",
    "radiators": "reɪdɪeɪtəz",
    "radical": "rædɪkəl",
    "radicalisation": "rædɪkəlaɪzeɪʃən",
    "radicalise": "rædɪkəlaɪz",
    "radicalised": "rædɪkəlaɪzd",
    "radicalises": "rædɪkəlaɪzɪz",
    "radicalising": "rædɪkəlaɪzɪŋ",
    "radicalism": "rædɪkəlɪzəm",
    "radically": "rædɪkli",
    "radicals": "rædɪkəlz",
    "radicchio": "rædɪkɪəʊ",
    "radii": "reɪdɪaɪ",
    "radioactive": "reɪdɪəʊæktɪv",
    "radioactivity": "reɪdɪəʊæktɪvɪti",
    "radiocarbon": "reɪdɪəʊkɑːbən",
    "radio": "reɪdɪəʊ",
    "radioed": "reɪdɪəʊd",
    "radiogram": "reɪdɪəʊɡræm",
    "radiograms": "reɪdɪəʊɡræmz",
    "radiograph": "reɪdɪɒɡræf",
    "radiographer": "reɪdɪɒɡrəfɐ",
    "radiographers": "reɪdɪɒɡrəfəz",
    "radiographs": "reɪdɪɒɡræfz",
    "radiography": "reɪdɪɒɡrəfi",
    "radioing": "reɪdɪəʊɪŋ",
    "radiological": "reɪdɪəlɒdʒɪkəl",
    "radiologically": "reɪdɪəlɒdʒɪkli",
    "radiologist": "reɪdɪɒlədʒɪst",
    "radiologists": "reɪdɪɒlədʒɪsts",
    "radiology": "reɪdɪɒlədʒi",
    "radiophonic": "reɪdɪəʊfɒnɪk",
    "radios": "reɪdɪəʊz",
    "radiotherapist": "reɪdɪəʊθɛrəpɪst",
    "radiotherapists": "reɪdɪəʊθɛrəpɪsts",
    "radiotherapy": "reɪdɪəʊθɛrəpi",
    "radish": "rædɪʃ",
    "radishes": "rædɪʃɪz",
    "radium": "reɪdiəm",
    "radius": "reɪdɪəs",
    "radix": "reɪdɪks",
    "radon": "reɪdɒn",
    "rads": "rædz",
    "raff": "ræf",
    "raffia": "ræfiɐ",
    "raffish": "ræfɪʃ",
    "raffle": "ræfəl",
    "raffled": "ræfəld",
    "raffles": "ræfəlz",
    "raffling": "ræflɪŋ",
    "rafted": "rɑːftɪd",
    "rafter": "rɑːftɐ",
    "rafters": "rɑːftəz",
    "raft": "rɑːft",
    "rafting": "rɑːftɪŋ",
    "rafts": "rɑːfts",
    "raga": "rɑːɡɐ",
    "rag": "ræɡ",
    "ragamuffin": "ræɡɐmʌfɪn",
    "ragamuffins": "ræɡɐmʌfɪnz",
    "ragas": "rɑːɡəz",
    "ragbag": "ræɡbæɡ",
    "raged": "reɪdʒd",
    "rage": "reɪdʒ",
    "rages": "reɪdʒɪz",
    "ragga": "ræɡɐ",
    "raggedness": "ræɡɪdnəs",
    "raggedy": "ræɡədi",
    "ragging": "ræɡɪŋ",
    "raging": "reɪdʒɪŋ",
    "raglan": "ræɡlən",
    "ragman": "ræɡmən",
    "ragout": "ræɡaʊt",
    "ragouts": "ræɡaʊts",
    "rags": "ræɡz",
    "ragtag": "ræɡtæɡ",
    "ragtags": "ræɡtæɡz",
    "ragtime": "ræɡtaɪm",
    "ragtop": "ræɡtɒp",
    "ragweed": "ræɡwiːd",
    "ragwort": "ræɡwɔːt",
    "rah": "rɑː",
    "raid": "reɪd",
    "raided": "reɪdɪd",
    "raider": "reɪdɐ",
    "raiders": "reɪdəz",
    "raiding": "reɪdɪŋ",
    "raids": "reɪdz",
    "railcard": "reɪlkɑːd",
    "railed": "reɪld",
    "rail": "reɪl",
    "railhead": "reɪlhɛd",
    "railing": "reɪlɪŋ",
    "railings": "reɪlɪŋz",
    "railroaded": "reɪlrəʊdɪd",
    "railroad": "reɪlrəʊd",
    "railroading": "reɪlrəʊdɪŋ",
    "railroads": "reɪlrəʊdz",
    "rails": "reɪlz",
    "railway": "reɪlweɪ",
    "railwayman": "reɪlweɪmən",
    "railwaymen": "reɪlweɪmɛn",
    "railways": "reɪlweɪz",
    "raiment": "reɪmənt",
    "rainband": "reɪnbænd",
    "rainbow": "reɪnbəʊ",
    "rainbows": "reɪnbəʊz",
    "raincloud": "reɪŋklaʊd",
    "rainclouds": "reɪŋklaʊdz",
    "raincoat": "reɪnkəʊt",
    "raincoats": "reɪnkəʊts",
    "raindrop": "reɪndrɒp",
    "raindrops": "reɪndrɒps",
    "rained": "reɪnd",
    "rain": "reɪn",
    "rainfall": "reɪnfɔːl",
    "rainfalls": "reɪnfɔːlz",
    "rainforest": "reɪnfɒrɪst",
    "rainforests": "reɪnfɒrɪsts",
    "rainiest": "reɪnɪəst",
    "raining": "reɪnɪŋ",
    "rainless": "reɪnləs",
    "rainmaker": "reɪnmeɪkɐ",
    "rainproof": "reɪnpruːf",
    "rains": "reɪnz",
    "rainstorm": "reɪnstɔːm",
    "rainstorms": "reɪnstɔːmz",
    "rainwater": "reɪnwɔːtɐ",
    "rainy": "reɪni",
    "raised": "reɪzd",
    "raise": "reɪz",
    "raiser": "reɪzɐ",
    "raisers": "reɪzəz",
    "raises": "reɪzɪz",
    "raisin": "reɪzən",
    "raising": "reɪzɪŋ",
    "raisings": "reɪzɪŋz",
    "raisins": "reɪzənz",
    "raja": "rɑːdʒɐ",
    "raj": "rædʒ",
    "rajah": "rɑːdʒɑː",
    "rajahs": "rɑːdʒɑːz",
    "rajas": "rɑːdʒəz",
    "raked": "reɪkt",
    "rake": "reɪk",
    "raker": "reɪkɐ",
    "rakes": "reɪks",
    "raki": "ræki",
    "raking": "reɪkɪŋ",
    "rakish": "rækɪʃ",
    "rale": "reɪl",
    "rallentando": "ræləntændəʊ",
    "rallied": "rælid",
    "rallies": "ræliz",
    "rally": "ræli",
    "rallying": "ræliɪŋ",
    "ram": "ræm",
    "ramble": "ræmbəl",
    "rambled": "ræmbəld",
    "rambler": "ræmblɐ",
    "ramblers": "ræmbləz",
    "rambles": "ræmbəlz",
    "rambling": "ræmblɪŋ",
    "ramblings": "ræmblɪŋz",
    "rambunctious": "ræmbʌŋkʃəs",
    "rambutan": "ræmbjuːtən",
    "rambutans": "ræmbjuːtənz",
    "ramekin": "reɪmkɪn",
    "ramekins": "reɪmkɪnz",
    "ramen": "reɪmɛn",
    "ramie": "ræmi",
    "ramification": "ræmɪfɪkeɪʃən",
    "ramifications": "ræmɪfɪkeɪʃənz",
    "ramifying": "ræmɪfaɪɪŋ",
    "ramjet": "ræmdʒɛt",
    "rammed": "ræmd",
    "rammer": "ræmɐ",
    "rammers": "ræməz",
    "ramming": "ræmɪŋ",
    "ramp": "ræmp",
    "rampaged": "ræmpeɪdʒd",
    "rampageous": "ræmpeɪdʒəs",
    "rampaging": "ræmpeɪdʒɪŋ",
    "rampant": "ræmpənt",
    "rampantly": "ræmpəntli",
    "rampart": "ræmpɑːt",
    "ramparts": "ræmpɑːts",
    "ramped": "ræmpt",
    "ramps": "ræmps",
    "ramrod": "ræmrɒd",
    "rams": "ræmz",
    "ramshackle": "ræmʃækəl",
    "ran": "ræn",
    "rance": "rɑːns",
    "rancher": "rɑːntʃɐ",
    "ranchero": "rɑːntʃeərəʊ",
    "ranchers": "rɑːntʃəz",
    "ranches": "rɑːntʃɪz",
    "ranching": "rɑːntʃɪŋ",
    "ranch": "rɑːntʃ",
    "rancho": "rɑːntʃəʊ",
    "rancid": "rɑːnsɪd",
    "rancorous": "rɑːnkərəs",
    "rancour": "rɑːnkɐ",
    "rand": "rænd",
    "randan": "rændən",
    "randiest": "rændɪəst",
    "random": "rændəm",
    "randomise": "rændəmaɪz",
    "randomised": "rændəmaɪzd",
    "randomly": "rændəmli",
    "randomness": "rændəmnəs",
    "randy": "rændi",
    "rang": "ræŋ",
    "ranged": "reɪndʒd",
    "range": "reɪndʒ",
    "ranger": "reɪndʒɐ",
    "rangers": "reɪndʒəz",
    "ranges": "reɪndʒɪz",
    "ranging": "reɪndʒɪŋ",
    "rangy": "ræŋi",
    "rani": "ræni",
    "rank": "ræŋk",
    "ranked": "ræŋkt",
    "ranker": "ræŋkɐ",
    "rankest": "ræŋkəst",
    "ranking": "ræŋkɪŋ",
    "rankings": "ræŋkɪŋz",
    "rankle": "ræŋkəl",
    "rankled": "ræŋkəld",
    "rankles": "ræŋkəlz",
    "rankling": "ræŋklɪŋ",
    "ranks": "ræŋks",
    "ransack": "rænsæk",
    "ransacked": "rænsækt",
    "ransacking": "rænsækɪŋ",
    "ransom": "rænsəm",
    "ransomed": "rænsəmd",
    "ransoms": "rænsəmz",
    "ranted": "rɑːntɪd",
    "ranters": "rɑːntəz",
    "ranting": "rɑːntɪŋ",
    "rantings": "rɑːntɪŋz",
    "rant": "rɑːnt",
    "rants": "rɑːnts",
    "ranunculus": "rænʌnkjʊləs",
    "rapacious": "ræpeɪʃəs",
    "rapaciously": "ræpeɪʃəsli",
    "rapacity": "ræpæsɪti",
    "rap": "ræp",
    "raped": "reɪpt",
    "rape": "reɪp",
    "raper": "reɪpɐ",
    "rapers": "reɪpəz",
    "rapeseed": "reɪpsiːd",
    "rapes": "reɪps",
    "rapid": "ræpɪd",
    "rapidity": "ræpɪdɪti",
    "rapidly": "ræpɪdli",
    "rapids": "ræpɪdz",
    "rapier": "reɪpiə",
    "rapiers": "reɪpiəz",
    "rapine": "ræpaɪn",
    "raping": "reɪpɪŋ",
    "rapist": "reɪpɪst",
    "rapists": "reɪpɪsts",
    "rapped": "ræpt",
    "rappel": "ræpɛl",
    "rappelling": "ræpəlɪŋ",
    "rapper": "ræpɐ",
    "rappers": "ræpəz",
    "rapping": "ræpɪŋ",
    "rapport": "ræpɔː",
    "rapporteur": "ræpɔːtɜː",
    "rapprochement": "ræprɒʃmɔ̃",
    "raps": "ræps",
    "rapscallion": "ræpskæliən",
    "rapscallions": "ræpskæliənz",
    "rapt": "ræpt",
    "raptor": "ræptɐ",
    "raptorial": "ræptɔːrɪəl",
    "raptors": "ræptəz",
    "rapture": "ræptʃɐ",
    "raptures": "ræptʃəz",
    "rapturous": "ræptʃərəs",
    "rapturously": "ræptʃərəsli",
    "rarebit": "reəbɪt",
    "rared": "reəd",
    "rare": "reə",
    "rarefaction": "reəfækʃən",
    "rarefactions": "reəfækʃənz",
    "rarefied": "reəfaɪd",
    "rarely": "reəli",
    "rarer": "reərɐ",
    "rarest": "reərəst",
    "rarified": "rɑːrɪfaɪd",
    "raring": "reərɪŋ",
    "rarities": "reərətiz",
    "rarity": "reərəti",
    "rascally": "rɑːskəli",
    "rascal": "rɑːskəl",
    "rascals": "rɑːskəlz",
    "rased": "reɪzd",
    "rash": "ræʃ",
    "rasher": "ræʃɐ",
    "rashers": "ræʃəz",
    "rashes": "ræʃɪz",
    "rashly": "ræʃli",
    "rashness": "ræʃnəs",
    "raspberries": "rɑːsbərɪz",
    "raspberry": "rɑːsbəri",
    "rasper": "rɑːspɐ",
    "rasping": "rɑːspɪŋ",
    "rasp": "rɑːsp",
    "rasps": "rɑːsps",
    "raspy": "rɑːspi",
    "ratable": "reɪtəbəl",
    "rat": "ræt",
    "ratafia": "ræteɪfiə",
    "ratan": "rætən",
    "rata": "rɑːtɐ",
    "ratatouille": "rætətuːi",
    "ratbag": "rætbæɡ",
    "ratbags": "rætbæɡz",
    "ratchet": "rætʃɪt",
    "ratcheted": "rætʃɪtɪd",
    "ratcheting": "rætʃɪtɪŋ",
    "ratchets": "rætʃɪts",
    "rateable": "reɪtəbəl",
    "rated": "reɪtɪd",
    "rate": "reɪt",
    "ratel": "reɪtəl",
    "ratepayer": "reɪtpeɪɐ",
    "ratepayers": "reɪtpeɪəz",
    "rater": "reɪtɐ",
    "raters": "reɪtəz",
    "rates": "reɪts",
    "rath": "ræθ",
    "rather": "rɑːðɐ",
    "ratification": "rætɪfɪkeɪʃən",
    "ratified": "rætɪfaɪd",
    "ratify": "rætɪfaɪ",
    "ratifying": "rætɪfaɪɪŋ",
    "rating": "reɪtɪŋ",
    "ratings": "reɪtɪŋz",
    "ratio": "reɪʃɪəʊ",
    "ration": "ræʃən",
    "rational": "ræʃənəl",
    "rationale": "ræʃənæl",
    "rationales": "ræʃənælz",
    "rationalisation": "ræʃənəlaɪzeɪʃən",
    "rationalisations": "ræʃənəlaɪzeɪʃənz",
    "rationalise": "ræʃənəlaɪz",
    "rationalised": "ræʃənəlaɪzd",
    "rationalises": "ræʃənəlaɪzɪz",
    "rationalising": "ræʃənəlaɪzɪŋ",
    "rationalism": "ræʃənəlɪzəm",
    "rationalist": "ræʃənəlɪst",
    "rationalistic": "ræʃənəlɪstɪk",
    "rationalists": "ræʃənəlɪsts",
    "rationality": "ræʃənælɪti",
    "rationally": "ræʃənəli",
    "rationed": "ræʃənd",
    "rationing": "ræʃənɪŋ",
    "rations": "ræʃənz",
    "ratios": "reɪʃɪəʊz",
    "ratites": "rætaɪts",
    "ratlines": "rætlaɪnz",
    "rats": "ræts",
    "rattan": "rætən",
    "ratted": "rætɪd",
    "ratter": "rætɐ",
    "ratting": "rætɪŋ",
    "rattle": "rætəl",
    "rattled": "rætəld",
    "rattler": "rætlɐ",
    "rattlers": "rætləz",
    "rattles": "rætəlz",
    "rattlesnake": "rætəlsneɪk",
    "rattlesnakes": "rætəlsneɪks",
    "rattletrap": "rætəltræp",
    "rattling": "rætlɪŋ",
    "rattlings": "rætlɪŋz",
    "rattly": "rætli",
    "ratty": "ræti",
    "raucously": "rɔːkəsli",
    "raucousness": "rɔːkəsnəs",
    "raucous": "rɔːkəs",
    "raunchier": "rɔːntʃɪɐ",
    "raunchiest": "rɔːntʃɪəst",
    "raunchiness": "rɔːntʃɪnəs",
    "raunchy": "rɔːntʃi",
    "ravage": "rævɪdʒ",
    "ravaged": "rævɪdʒd",
    "ravages": "rævɪdʒɪz",
    "ravaging": "rævɪdʒɪŋ",
    "raved": "reɪvd",
    "rave": "reɪv",
    "ravelin": "rævɪlɪn",
    "ravelled": "rævəld",
    "ravening": "rævənɪŋ",
    "ravenous": "rævənəs",
    "ravenously": "rævənəsli",
    "raver": "reɪvɐ",
    "ravers": "reɪvəz",
    "raves": "reɪvz",
    "ravin": "rævɪn",
    "ravine": "rəviːn",
    "ravines": "rəviːnz",
    "raving": "reɪvɪŋ",
    "ravings": "reɪvɪŋz",
    "ravioli": "rævɪəʊli",
    "raviolis": "rævɪəʊliz",
    "ravish": "rævɪʃ",
    "ravished": "rævɪʃt",
    "ravishes": "rævɪʃɪz",
    "ravishing": "rævɪʃɪŋ",
    "ravishingly": "rævɪʃɪŋli",
    "ravishment": "rævɪʃmənt",
    "rawer": "ræwɐ",
    "rawest": "rɔːrəst",
    "rawhide": "rɔːhaɪd",
    "rawness": "rɔːnəs",
    "raw": "rɔː",
    "ray": "reɪ",
    "rayon": "reɪɒn",
    "rays": "reɪz",
    "razed": "reɪzd",
    "raze": "reɪz",
    "razing": "reɪzɪŋ",
    "razorback": "reɪzəbæk",
    "razorbill": "reɪzəbɪl",
    "razorbills": "reɪzəbɪlz",
    "razor": "reɪzɐ",
    "razors": "reɪzəz",
    "razz": "ræz",
    "razzamatazz": "ræzɐmɐtæz",
    "razzing": "ræzɪŋ",
    "razzmatazz": "ræzmɐtæz",
    "reabsorbed": "riːbsɔːbd",
    "reabsorb": "riːbsɔːb",
    "reabsorbing": "riːbsɔːbɪŋ",
    "reachable": "riːtʃəbəl",
    "reached": "riːtʃt",
    "reacher": "riːtʃɐ",
    "reaches": "riːtʃɪz",
    "reaching": "riːtʃɪŋ",
    "reach": "riːtʃ",
    "reacquainted": "riːkweɪntɪd",
    "reacquaint": "riːkweɪnt",
    "reacquainting": "riːkweɪntɪŋ",
    "reacquire": "riːkwaɪə",
    "react": "rɪækt",
    "reactant": "rɪæktənt",
    "reactants": "rɪæktənts",
    "reacted": "rɪæktɪd",
    "reacting": "rɪæktɪŋ",
    "reaction": "rɪækʃən",
    "reactionaries": "rɪækʃənəriz",
    "reactionary": "rɪækʃənəri",
    "reactions": "rɪækʃənz",
    "reactivate": "rɪæktɪveɪt",
    "reactivated": "rɪæktɪveɪtɪd",
    "reactivates": "rɪæktɪveɪts",
    "reactivating": "rɪæktɪveɪtɪŋ",
    "reactivation": "rɪæktɪveɪʃən",
    "reactive": "rɪæktɪv",
    "reactivity": "rɪɐktɪvɪti",
    "reactor": "rɪæktɐ",
    "reactors": "rɪæktəz",
    "reacts": "rɪækts",
    "readability": "riːdəbɪlɪti",
    "readable": "riːdəbəl",
    "readapt": "riːdæpt",
    "readdressed": "riːɐdrɛst",
    "readdress": "riːɐdrɛs",
    "readdressing": "riːɐdrɛsɪŋ",
    "reader": "riːdɐ",
    "readership": "riːdəʃɪp",
    "readerships": "riːdəʃɪps",
    "readers": "riːdəz",
    "readied": "rɛdɪd",
    "readier": "rɛdɪɐ",
    "readies": "rɛdɪz",
    "readiest": "rɛdɪəst",
    "readily": "rɛdɪli",
    "readiness": "rɛdɪnəs",
    "readings": "riːdɪŋz",
    "readjusted": "riːɐdʒʌstɪd",
    "readjust": "riːɐdʒʌst",
    "readjusting": "riːɐdʒʌstɪŋ",
    "readjustment": "riːɐdʒʌstmənt",
    "readjustments": "riːɐdʒʌstmənts",
    "readjusts": "riːɐdʒʌsts",
    "readmission": "riːdmɪʃən",
    "readmit": "riːdmɪt",
    "readmitted": "riːdmɪtɪd",
    "readout": "riːdaʊt",
    "readouts": "riːdaʊts",
    "reads": "riːdz",
    "ready": "rɛdi",
    "readying": "rɛdɪɪŋ",
    "reaffirmation": "riːæfəmeɪʃən",
    "reaffirmed": "riːɐfɜːmd",
    "reaffirm": "riːɐfɜːm",
    "reaffirming": "riːɐfɜːmɪŋ",
    "reaffirms": "riːɐfɜːmz",
    "reagent": "rɪeɪdʒənt",
    "reagents": "rɪeɪdʒənts",
    "realer": "riəlɐ",
    "reales": "riəlz",
    "realest": "riələst",
    "realigned": "riːɐlaɪnd",
    "realign": "riːɐlaɪn",
    "realigning": "riːɐlaɪnɪŋ",
    "realignment": "riːɐlaɪnmənt",
    "realignments": "riːɐlaɪnmənts",
    "realigns": "riːɐlaɪnz",
    "realisable": "riəlaɪzəbəl",
    "realisation": "riəlaɪzeɪʃən",
    "realisations": "riəlaɪzeɪʃənz",
    "realised": "riəlaɪzd",
    "realise": "riəlaɪz",
    "realises": "riəlaɪzɪz",
    "realising": "riəlaɪzɪŋ",
    "realism": "riəlɪzəm",
    "realistically": "riəlɪstɪkli",
    "realistic": "riəlɪstɪk",
    "realist": "riəlɪst",
    "realists": "riəlɪsts",
    "realities": "rɪælɪtiz",
    "reality": "rɪælɪti",
    "reallocated": "riːæləkeɪtɪd",
    "reallocate": "riːæləkeɪt",
    "reallocating": "riːæləkeɪtɪŋ",
    "reallocation": "riːæləkeɪʃən",
    "really": "riəli",
    "realm": "rɛlm",
    "realms": "rɛlmz",
    "realness": "riəlnəs",
    "realpolitik": "riəlpəlɪtɪk",
    "reals": "riəlz",
    "realtor": "riəltɐ",
    "realtors": "riəltəz",
    "realty": "riəlti",
    "reamed": "riːmd",
    "reamer": "riːmɐ",
    "ream": "riːm",
    "reaming": "riːmɪŋ",
    "reams": "riːmz",
    "reanalysed": "riːɐnælaɪzd",
    "reanalyse": "riːɐnælaɪz",
    "reanimated": "riːænɪmeɪtɪd",
    "reanimate": "riːænɪmeɪt",
    "reanimating": "riːænɪmeɪtɪŋ",
    "reanimation": "riːɐnɪmeɪʃən",
    "reaped": "riːpt",
    "reaper": "riːpɐ",
    "reapers": "riːpəz",
    "reaping": "riːpɪŋ",
    "reap": "riːp",
    "reappearance": "riːɐpiərəns",
    "reappeared": "riːɐpiəd",
    "reappearing": "riːɐpiərɪŋ",
    "reappear": "riːɐpiə",
    "reappears": "riːɐpiəz",
    "reapplied": "riːɐplaɪd",
    "reapplying": "riːɐplaɪɪŋ",
    "reapply": "riːɐplaɪ",
    "reappointed": "riːɐpɔɪntɪd",
    "reappointing": "riːɐpɔɪntɪŋ",
    "reappoint": "riːɐpɔɪnt",
    "reappointment": "riːɐpɔɪntmənt",
    "reappraisal": "riːɐpreɪsəl",
    "reappraised": "riːɐpreɪzd",
    "reappraise": "riːɐpreɪz",
    "reaps": "riːps",
    "reared": "riəd",
    "rearguard": "riəɡɑːd",
    "rear": "riə",
    "rearing": "riərɪŋ",
    "rearmament": "riːɑːməmənt",
    "rearmed": "riːɑːmd",
    "rearm": "riːɑːm",
    "rearming": "riːɑːmɪŋ",
    "rearranged": "riːɐreɪndʒd",
    "rearrange": "riːɐreɪndʒ",
    "rearrangement": "riːɐreɪndʒmənt",
    "rearrangements": "riːɐreɪndʒmənts",
    "rearranges": "riːɐreɪndʒɪz",
    "rearranging": "riːɐreɪndʒɪŋ",
    "rearrested": "riːɐrɛstɪd",
    "rears": "riəz",
    "rearward": "riəwəd",
    "reasonable": "riːzənəbəl",
    "reasonableness": "riːzənəbəlnəs",
    "reasonably": "riːzənəbli",
    "reasoned": "riːzənd",
    "reasoning": "riːzənɪŋ",
    "reason": "riːzən",
    "reasons": "riːzənz",
    "reassembled": "riːɐsɛmbəld",
    "reassemble": "riːɐsɛmbəl",
    "reassembles": "riːɐsɛmbəlz",
    "reassembling": "riːɐsɛmblɪŋ",
    "reassembly": "riːɐsɛmbli",
    "reasserted": "riːɐsɜːtɪd",
    "reasserting": "riːɐsɜːtɪŋ",
    "reassertion": "riːɐsɜːʃən",
    "reassert": "riːɐsɜːt",
    "reasserts": "riːɐsɜːts",
    "reassessed": "riːɐsɛst",
    "reassesses": "riːɐsɛsɪz",
    "reassessing": "riːɐsɛsɪŋ",
    "reassess": "riːɐsɛs",
    "reassessment": "riːɐsɛsmənt",
    "reassessments": "riːɐsɛsmənts",
    "reassigned": "riːɐsaɪnd",
    "reassigning": "riːɐsaɪnɪŋ",
    "reassign": "riːɐsaɪn",
    "reassignment": "riːɐsaɪnmənt",
    "reassume": "riːɐsuːm",
    "reassurance": "riːəʃjɔːrəns",
    "reassurances": "riːəʃjɔːrənsɪz",
    "reassured": "riːəʃjɔːd",
    "reassure": "riːəʃjɔː",
    "reassures": "riːəʃjɔːz",
    "reassuring": "riːəʃjɔːrɪŋ",
    "reassuringly": "riːəʃjɔːrɪŋli",
    "reattached": "riːɐtætʃt",
    "reattaching": "riːɐtætʃɪŋ",
    "reattach": "riːɐtætʃ",
    "reattachment": "riːɐtætʃmənt",
    "reawakened": "riːweɪkənd",
    "reawakening": "riːweɪknɪŋ",
    "reawaken": "riːweɪkən",
    "rebalanced": "rɪbælənst",
    "rebated": "riːbeɪtɪd",
    "rebate": "riːbeɪt",
    "rebates": "riːbeɪts",
    "rebating": "riːbeɪtɪŋ",
    "rebelled": "rɪbɛld",
    "rebelling": "rɪbɛlɪŋ",
    "rebellion": "rɪbɛliən",
    "rebellions": "rɪbɛliənz",
    "rebellious": "rɪbɛlɪəs",
    "rebelliousness": "rɪbɛlɪəsnəs",
    "rebid": "rɪbɪd",
    "rebirth": "rɪbɜːθ",
    "rebook": "rɛbʊk",
    "reboot": "rɪbuːt",
    "rebooted": "rɪbuːtɪd",
    "rebooting": "rɪbuːtɪŋ",
    "reborn": "rɪbɔːn",
    "rebounded": "rɪbaʊndɪd",
    "rebounding": "rɪbaʊndɪŋ",
    "rebroadcast": "rɪbrɔːdkɑːst",
    "rebuff": "rɪbʌf",
    "rebuffed": "rɪbʌft",
    "rebuffing": "rɪbʌfɪŋ",
    "rebuffs": "rɪbʌfs",
    "rebuild": "rɪbɪld",
    "rebuilding": "rɪbɪldɪŋ",
    "rebuilds": "rɪbɪldz",
    "rebuilt": "rɪbɪlt",
    "rebuke": "rɪbjuːk",
    "rebuked": "rɪbjuːkt",
    "rebukes": "rɪbjuːks",
    "rebuking": "rɪbjuːkɪŋ",
    "reburial": "rɪbɛrɪəl",
    "reburied": "rɪbrɪd",
    "rebury": "rɛbri",
    "reburying": "rɪbrɪɪŋ",
    "rebus": "rɪbjuːz",
    "rebut": "rɪbʌt",
    "rebuts": "rɪbʌts",
    "rebuttable": "rɪbʌtəbəl",
    "rebuttal": "rɪbʌtəl",
    "rebuttals": "rɪbʌtəlz",
    "rebutted": "rɪbʌtɪd",
    "rebutting": "rɪbʌtɪŋ",
    "recalcitrance": "rɪkælsɪtrəns",
    "recalcitrant": "rɪkælsɪtrənt",
    "recalculated": "rɪkælkjʊleɪtɪd",
    "recalculate": "rɪkælkjʊleɪt",
    "recalculating": "rɪkælkjʊleɪtɪŋ",
    "recalculation": "rɪkælkjʊleɪʃən",
    "recalibrate": "rɪkælɪbreɪt",
    "recalibrating": "rɪkælɪbreɪtɪŋ",
    "recalibration": "rɪkælɪbreɪʃən",
    "recalled": "rɪkɔːld",
    "recalling": "rɪkɔːlɪŋ",
    "recantation": "rɪkɑːnteɪʃən",
    "recanted": "rɪkɑːntɪd",
    "recanting": "rɪkɑːntɪŋ",
    "recant": "rɪkɑːnt",
    "recapitalisation": "rɪkæpɪtəlaɪzeɪʃən",
    "recapitalised": "rɪkæpɪtəlaɪzd",
    "recapitalise": "rɪkæpɪtəlaɪz",
    "recapitalising": "rɪkæpɪtəlaɪzɪŋ",
    "recapitulates": "rɪkɐpɪtʃʊleɪts",
    "recapitulation": "rɪkɐpɪtʃʊleɪʃən",
    "recaptured": "rɪkæptʃəd",
    "recapture": "rɪkæptʃɐ",
    "recaptures": "rɪkæptʃəz",
    "recapturing": "rɪkæptʃərɪŋ",
    "recasting": "rɪkɑːstɪŋ",
    "recast": "rɪkɑːst",
    "recce": "rɪksɛ",
    "recces": "rɪksɛɪz",
    "receded": "rɪsiːdɪd",
    "recede": "rɪsiːd",
    "recedes": "rɪsiːdz",
    "receding": "rɪsiːdɪŋ",
    "receipted": "rɪsiːtɪd",
    "receiptor": "rɪsiːtɐ",
    "receipt": "rɪsiːt",
    "receipts": "rɪsiːts",
    "receivable": "rɪsiːvəbəl",
    "receivables": "rɪsiːvəbəlz",
    "received": "rɪsiːvd",
    "receivership": "rɪsiːvəʃɪp",
    "receiver": "rɪsiːvɐ",
    "receivers": "rɪsiːvəz",
    "receive": "rɪsiːv",
    "receives": "rɪsiːvz",
    "receiving": "rɪsiːvɪŋ",
    "recent": "riːsənt",
    "recently": "riːsəntli",
    "receptacle": "rɪsɛptəkəl",
    "receptacles": "rɪsɛptəkəlz",
    "receptionist": "rɪsɛpʃənɪst",
    "receptionists": "rɪsɛpʃənɪsts",
    "reception": "rɪsɛpʃən",
    "receptions": "rɪsɛpʃənz",
    "receptive": "rɪsɛptɪv",
    "receptivity": "rɪsɪptɪvɪti",
    "receptor": "rɪsɛptɐ",
    "receptors": "rɪsɛptəz",
    "recept": "rɪsɛpt",
    "recessed": "riːsɛst",
    "recesses": "riːsɛsɪz",
    "recessional": "rɪsɛʃənəl",
    "recessionary": "rɪsɛʃənəri",
    "recession": "rɪsɛʃən",
    "recessions": "rɪsɛʃənz",
    "recessive": "rɪsɛsɪv",
    "rechargeable": "rɪtʃɑːdʒəbəl",
    "recharged": "rɪtʃɑːdʒd",
    "recharger": "rɪtʃɑːdʒɐ",
    "recharges": "rɪtʃɑːdʒɪz",
    "recharge": "rɪtʃɑːdʒ",
    "recharging": "rɪtʃɑːdʒɪŋ",
    "rechecked": "rɪtʃɛkt",
    "rechecking": "rɪtʃɛkɪŋ",
    "recheck": "rɪtʃɛk",
    "rechristened": "rɪkrɪstənd",
    "rechristen": "rɪkrɪstən",
    "recidivism": "rɪsɪdɪvɪzəm",
    "recidivist": "rɪsɪdɪvɪst",
    "recidivists": "rɪsɪdɪvɪsts",
    "recipe": "rɛsɪpiː",
    "recipes": "rɛsɪpiːz",
    "recipient": "rɪsɪpiənt",
    "recipients": "rɪsɪpiənts",
    "reciprocal": "rɪsɪprəkəl",
    "reciprocated": "rɪsɪprəkeɪtɪd",
    "reciprocate": "rɪsɪprəkeɪt",
    "reciprocates": "rɪsɪprəkeɪts",
    "reciprocating": "rɪsɪprəkeɪtɪŋ",
    "reciprocation": "rɪsɪprəkeɪʃən",
    "reciprocity": "rɪsɪprɒsɪti",
    "recirculate": "rɪsɜːkjʊleɪt",
    "recirculating": "rɪsɜːkjʊleɪtɪŋ",
    "recitalist": "rɪsɪtəlɪst",
    "recital": "rɪsaɪtəl",
    "recitals": "rɪsaɪtəlz",
    "recitations": "rɪsɪteɪʃənz",
    "recitation": "rɪsɪteɪʃən",
    "recitatives": "rɪsɪtətɪvz",
    "recitativo": "rɪsɪtɐtɪvəʊ",
    "recited": "rɪsaɪtɪd",
    "reciter": "rɪsaɪtɐ",
    "reciters": "rɪsaɪtəz",
    "recite": "rɪsaɪt",
    "recites": "rɪsaɪts",
    "reciting": "rɪsaɪtɪŋ",
    "reck": "rɛk",
    "reckless": "rɛkləs",
    "recklessly": "rɛkləsli",
    "recklessness": "rɛkləsnəs",
    "reckoned": "rɛkənd",
    "reckon": "rɛkən",
    "reckoner": "rɛkənɐ",
    "reckoning": "rɛkənɪŋ",
    "reckonings": "rɛkənɪŋz",
    "reckons": "rɛkənz",
    "reclaimable": "rɪkleɪməbəl",
    "reclaimed": "rɪkleɪmd",
    "reclaiming": "rɪkleɪmɪŋ",
    "reclaim": "rɪkleɪm",
    "reclaims": "rɪkleɪmz",
    "reclamation": "rɪklɐmeɪʃən",
    "reclassification": "rɪklæsɪfɪkeɪʃən",
    "reclassified": "rɪklæsɪfaɪd",
    "reclassifying": "rɪklæsɪfaɪɪŋ",
    "reclassify": "rɪklæsɪfaɪ",
    "reclined": "rɪklaɪnd",
    "recline": "rɪklaɪn",
    "recliner": "rɪklaɪnɐ",
    "recliners": "rɪklaɪnəz",
    "reclines": "rɪklaɪnz",
    "reclining": "rɪklaɪnɪŋ",
    "recluse": "rɪkluːs",
    "recluses": "rɪkluːsɪz",
    "reclusive": "rɪkluːsɪv",
    "recognisable": "rɛkəɡnaɪzəbəl",
    "recognisably": "rɛkəɡnaɪzəbli",
    "recognisance": "rɛkəɡnɪsəns",
    "recognised": "rɛkəɡnaɪzd",
    "recognise": "rɛkəɡnaɪz",
    "recognises": "rɛkəɡnaɪzɪz",
    "recognising": "rɛkəɡnaɪzɪŋ",
    "recognition": "rɛkəɡnɪʃən",
    "recognitions": "rɛkəɡnɪʃənz",
    "recoiled": "rɪkɔɪld",
    "recoiling": "rɪkɔɪlɪŋ",
    "recoils": "rɪkɔɪlz",
    "recoin": "rɪkɔɪn",
    "recollected": "rɪkəlɛktɪd",
    "recollecting": "rɪkəlɛktɪŋ",
    "recollection": "rɪkəlɛkʃən",
    "recollections": "rɪkəlɛkʃənz",
    "recollects": "rɪkəlɛkts",
    "recolonised": "rɪkɒlənaɪzd",
    "recolonise": "rɪkɒlənaɪz",
    "recolonising": "rɪkɒlənaɪzɪŋ",
    "recombination": "riːkɒmbɪneɪʃən",
    "recombined": "riːkəmbaɪnd",
    "recombine": "riːkəmbaɪn",
    "recombining": "riːkəmbaɪnɪŋ",
    "recommenced": "riːkəmɛnst",
    "recommence": "riːkəmɛns",
    "recommences": "riːkəmɛnsɪz",
    "recommencing": "riːkəmɛnsɪŋ",
    "recommendable": "rɛkəmɛndəbəl",
    "recommendation": "rɛkəmɛndeɪʃən",
    "recommendations": "rɛkəmɛndeɪʃənz",
    "recommended": "rɛkəmɛndɪd",
    "recommend": "rɛkəmɛnd",
    "recommending": "rɛkəmɛndɪŋ",
    "recommends": "rɛkəmɛndz",
    "recommissioned": "riːkəmɪʃənd",
    "recommission": "riːkəmɪʃən",
    "recommissioning": "riːkəmɪʃənɪŋ",
    "recommit": "riːkəmɪt",
    "recommitted": "riːkəmɪtɪd",
    "recommitting": "riːkəmɪtɪŋ",
    "recompensed": "rɛkəmpɛnsd",
    "recompense": "rɛkəmpɛns",
    "recomposed": "riːkəmpəʊzd",
    "recompose": "riːkəmpəʊz",
    "reconcilable": "rɛkənsaɪləbəl",
    "reconciled": "rɛkənsaɪld",
    "reconcile": "rɛkənsaɪl",
    "reconciles": "rɛkənsaɪlz",
    "reconciliation": "rɛkənsɪlɪeɪʃən",
    "reconciliations": "rɛkənsɪlɪeɪʃənz",
    "reconciliatory": "rɛkənsɪlɪətəri",
    "reconciling": "rɛkənsaɪlɪŋ",
    "recondense": "riːkəndɛns",
    "recondite": "riːkəndaɪt",
    "reconditioned": "riːkəndɪʃənd",
    "recondition": "riːkəndɪʃən",
    "reconditioning": "riːkəndɪʃənɪŋ",
    "reconfiguration": "riːkənfɪɡjʊreɪʃən",
    "reconfigured": "riːkənfɪɡəd",
    "reconfigure": "riːkənfɪɡɐ",
    "reconfiguring": "riːkənfɪɡərɪŋ",
    "reconfirmed": "riːkənfɜːmd",
    "reconfirm": "riːkənfɜːm",
    "reconfirms": "riːkənfɜːmz",
    "recon": "riːkɒn",
    "reconnaissance": "rɪkɒnɪsəns",
    "reconnected": "riːkənɛktɪd",
    "reconnect": "riːkənɛkt",
    "reconnecting": "riːkənɛktɪŋ",
    "reconnection": "riːkənɛkʃən",
    "reconnects": "riːkənɛkts",
    "reconnoitre": "riːkənɔɪtɐ",
    "reconnoitring": "riːkənɔɪtrɪŋ",
    "reconquered": "riːkɒnkəd",
    "reconquer": "riːkɒnkɐ",
    "reconquest": "riːkɒnkwɛst",
    "reconsecrated": "riːkɒnsɪkreɪtɪd",
    "reconsideration": "riːkənsɪdəreɪʃən",
    "reconsidered": "riːkənsɪdəd",
    "reconsider": "riːkənsɪdɐ",
    "reconsidering": "riːkənsɪdərɪŋ",
    "reconsiders": "riːkənsɪdəz",
    "reconstituted": "riːkɒnstɪtjuːtɪd",
    "reconstitute": "riːkɒnstɪtjuːt",
    "reconstituting": "riːkɒnstɪtjuːtɪŋ",
    "reconstitution": "riːkɒnstɪtjuːʃən",
    "reconstructed": "riːkənstrʌktɪd",
    "reconstruct": "riːkənstrʌkt",
    "reconstructing": "riːkənstrʌktɪŋ",
    "reconstruction": "riːkənstrʌkʃən",
    "reconstructions": "riːkənstrʌkʃənz",
    "reconstructive": "riːkənstrʌktɪv",
    "reconstructs": "riːkɒnstrʌkts",
    "reconvened": "riːkənviːnd",
    "reconvene": "riːkənviːn",
    "reconvenes": "riːkənviːnz",
    "reconvening": "riːkənviːnɪŋ",
    "reconverted": "riːkənvɜːtɪd",
    "recooked": "rɪkʊkt",
    "recordable": "rɪkɔːdəbəl",
    "recorded": "rɪkɔːdɪd",
    "recorder": "rɪkɔːdɐ",
    "recorders": "rɪkɔːdəz",
    "recording": "rɪkɔːdɪŋ",
    "recordings": "rɪkɔːdɪŋz",
    "recordist": "rɪkɔːdɪst",
    "recordists": "rɪkɔːdɪsts",
    "recounted": "rɪkaʊntɪd",
    "recounting": "rɪkaʊntɪŋ",
    "recounts": "rɪkaʊnts",
    "recouped": "rɪkuːpt",
    "recouping": "rɪkuːpɪŋ",
    "recoup": "rɪkuːp",
    "recoups": "rɪkuːps",
    "recourse": "rɪkɔːs",
    "recoverable": "rɪkʌvərəbəl",
    "recoveries": "rɪkʌvərɪz",
    "recovery": "rɪkʌvəri",
    "recreated": "riːkriːeɪtɪd",
    "recreates": "riːkriːeɪts",
    "recreating": "riːkriːeɪtɪŋ",
    "recreational": "rɛkriːeɪʃənəl",
    "recreations": "rɛkriːeɪʃənz",
    "recrimination": "rɪkrɪmɪneɪʃən",
    "recriminations": "rɪkrɪmɪneɪʃənz",
    "recruited": "rɪkruːtɪd",
    "recruiter": "rɪkruːtɐ",
    "recruiters": "rɪkruːtəz",
    "recruiting": "rɪkruːtɪŋ",
    "recruit": "rɪkruːt",
    "recruitment": "rɪkruːtmənt",
    "recruits": "rɪkruːts",
    "rectal": "rɛktəl",
    "rectally": "rɛktəli",
    "rectangle": "rɛktæŋɡəl",
    "rectangles": "rɛktæŋɡəlz",
    "rectangular": "rɛktænɡjʊlɐ",
    "rectification": "rɛktɪfɪkeɪʃən",
    "rectifications": "rɛktɪfɪkeɪʃənz",
    "rectified": "rɛktɪfaɪd",
    "rectifier": "rɛktɪfaɪə",
    "rectifiers": "rɛktɪfaɪəz",
    "rectify": "rɛktɪfaɪ",
    "rectifying": "rɛktɪfaɪɪŋ",
    "rectilinear": "rɛktɪlɪniə",
    "rectitude": "rɛktɪtjuːd",
    "recto": "rɛktəʊ",
    "rector": "rɛktɐ",
    "rectories": "rɛktəriz",
    "rectors": "rɛktəz",
    "rectory": "rɛktəri",
    "rectum": "rɛktəm",
    "rectums": "rɛktəmz",
    "rectus": "rɛktəs",
    "recumbent": "rɪkʌmbənt",
    "recuperated": "rɪkjuːpəreɪtɪd",
    "recuperate": "rɪkjuːpəreɪt",
    "recuperates": "rɪkjuːpəreɪts",
    "recuperating": "rɪkjuːpəreɪtɪŋ",
    "recuperation": "rɪkjuːpəreɪʃən",
    "recuperative": "rɪkjuːpərətɪv",
    "recur": "rɪkɜː",
    "recurred": "rɪkɜːd",
    "recurrence": "rɪkʌrəns",
    "recurrences": "rɪkʌrənsɪz",
    "recurrent": "rɪkʌrənt",
    "recurrently": "rɪkʌrəntli",
    "recurring": "rɪkɜːrɪŋ",
    "recurs": "rɪkɜːz",
    "recurved": "rɪkɜːvd",
    "recurve": "rɪkɜːv",
    "recusancy": "rɪkjuːsənsi",
    "recusant": "rɪkjuːsənt",
    "recusants": "rɪkjuːsənts",
    "recut": "rɪkʌt",
    "recyclable": "rɪsaɪkələbəl",
    "recyclables": "rɪsaɪkləbəlz",
    "recycled": "rɪsaɪkəld",
    "recycler": "rɪsaɪklɐ",
    "recyclers": "rɪsaɪkləz",
    "recycle": "rɪsaɪkəl",
    "recycles": "rɪsaɪkəlz",
    "recycling": "rɪsaɪklɪŋ",
    "redact": "rɪdækt",
    "redacted": "rɪdæktɪd",
    "redaction": "rɪdækʃən",
    "redan": "rɪdæn",
    "redbird": "rɛdbɜːd",
    "redbreast": "rɛdbrɛst",
    "redbreasts": "rɛdbrɛsts",
    "redbrick": "rɛdbrɪk",
    "redcoat": "rɛdkəʊt",
    "redcoats": "rɛdkəʊts",
    "redcurrant": "rɛdkʌrənt",
    "redcurrants": "rɛdkʌrənts",
    "redd": "rɛd",
    "reddened": "rɛdənd",
    "redden": "rɛdən",
    "reddening": "rɛdənɪŋ",
    "redder": "rɛdɐ",
    "reddest": "rɛdəst",
    "reddish": "rɛdɪʃ",
    "redecorated": "riːdɛkəreɪtɪd",
    "redecorate": "riːdɛkəreɪt",
    "redecorating": "riːdɛkəreɪtɪŋ",
    "redecoration": "riːdɛkəreɪʃən",
    "red": "rɛd",
    "rede": "rɪdɛ",
    "rededicated": "riːdɛdɪkeɪtɪd",
    "rededicate": "riːdɛdɪkeɪt",
    "rededication": "riːdɛdɪkeɪʃən",
    "redeemable": "rɪdiːməbəl",
    "redeem": "rɪdiːm",
    "redeemed": "rɪdiːmd",
    "redeemer": "rɪdiːmɐ",
    "redeeming": "rɪdiːmɪŋ",
    "redeems": "rɪdiːmz",
    "redefined": "riːdɪfaɪnd",
    "redefine": "riːdɪfaɪn",
    "redefines": "riːdɪfaɪnz",
    "redefining": "riːdɪfaɪnɪŋ",
    "redefinition": "riːdɛfɪnɪʃən",
    "redelivered": "riːdɪlɪvəd",
    "redelivery": "riːdɪlɪvəri",
    "redemption": "rɪdɛmpʃən",
    "redemptive": "rɪdɛmptɪv",
    "redeployed": "riːdɪplɔɪd",
    "redeploy": "riːdɪplɔɪ",
    "redeploying": "riːdɪplɔɪɪŋ",
    "redeployment": "riːdɪplɔɪmənt",
    "redesigned": "riːdɪzaɪnd",
    "redesign": "riːdɪzaɪn",
    "redesigning": "riːdɪzaɪnɪŋ",
    "redesigns": "riːdɪzaɪnz",
    "redeveloped": "riːdɪvɛləpt",
    "redevelop": "riːdɪvɛləp",
    "redeveloping": "riːdɪvɛləpɪŋ",
    "redevelopment": "riːdɪvɛləpmənt",
    "redheaded": "rɛdhɛdɪd",
    "redhead": "rɛdhɛd",
    "redheads": "rɛdhɛdz",
    "redial": "riːdaɪəl",
    "redid": "rɪdɪd",
    "redirected": "riːdaɪrɛktɪd",
    "redirect": "riːdaɪrɛkt",
    "redirecting": "riːdaɪrɛktɪŋ",
    "redirection": "riːdaɪrɛkʃən",
    "redirects": "riːdaɪrɛkts",
    "rediscovered": "riːdɪskʌvəd",
    "rediscover": "riːdɪskʌvɐ",
    "rediscovering": "riːdɪskʌvərɪŋ",
    "rediscovers": "riːdɪskʌvəz",
    "rediscovery": "riːdɪskʌvəri",
    "redisplayed": "riːdɪspleɪd",
    "redistributed": "riːdɪstrɪbjuːtɪd",
    "redistribute": "riːdɪstrɪbjuːt",
    "redistributes": "riːdɪstrɪbjuːts",
    "redistributing": "riːdɪstrɪbjuːtɪŋ",
    "redistribution": "riːdɪstrɪbjuːʃən",
    "redistributive": "riːdɪstrɪbjuːtɪv",
    "redline": "rɛdlaɪn",
    "redlines": "rɛdlaɪnz",
    "redly": "rɛdli",
    "redneck": "rɛdnɛk",
    "rednecks": "rɛdnɛks",
    "redness": "rɛdnəs",
    "redoing": "riːduːɪŋ",
    "redolent": "rɛdələnt",
    "redone": "riːdʌn",
    "redouble": "rɪdʌbəl",
    "redoubled": "rɪdʌbəld",
    "redoubles": "rɪdʌbəlz",
    "redoubling": "rɪdʌblɪŋ",
    "redoubtable": "rɪdaʊtəbəl",
    "redoubt": "rɪdaʊt",
    "redoubts": "rɪdaʊts",
    "redpoll": "rɛdpɒl",
    "redpolls": "rɛdpɒlz",
    "redrafted": "riːdrɑːftɪd",
    "redraft": "riːdrɑːft",
    "redrafting": "riːdrɑːftɪŋ",
    "redrafts": "riːdrɑːfts",
    "redraw": "riːdrɔː",
    "redrawing": "riːdrɔːrɪŋ",
    "redrawn": "riːdrɔːn",
    "redraws": "riːdrɔːz",
    "redressed": "riːdrɛst",
    "redresses": "riːdrɛsɪz",
    "redressing": "riːdrɛsɪŋ",
    "redrew": "riːdruː",
    "reds": "rɛdz",
    "redshank": "rɛdʃæŋk",
    "redshanks": "rɛdʃæŋks",
    "redskin": "rɛdskɪn",
    "redskins": "rɛdskɪnz",
    "redstart": "rɛdstɑːt",
    "redstarts": "rɛdstɑːts",
    "reduced": "rɪdjuːst",
    "reduce": "rɪdjuːs",
    "reducer": "rɪdjuːsɐ",
    "reduces": "rɪdjuːsɪz",
    "reducible": "rɪdjuːsəbəl",
    "reducing": "rɪdjuːsɪŋ",
    "reduction": "rɪdʌkʃən",
    "reductionism": "rɪdʌkʃənɪzəm",
    "reductionist": "rɪdʌkʃənɪst",
    "reductions": "rɪdʌkʃənz",
    "reductive": "rɪdʌktɪv",
    "redundancies": "rɪdʌndənsɪz",
    "redundancy": "rɪdʌndənsi",
    "redundant": "rɪdʌndənt",
    "redux": "rɪdʌks",
    "redwing": "rɛdwɪŋ",
    "redwings": "rɛdwɪŋz",
    "redwood": "rɛdwʊd",
    "redwoods": "rɛdwʊdz",
    "reedbuck": "riːdbʌk",
    "reed": "riːd",
    "reeding": "riːdɪŋ",
    "reedited": "riːdɪtɪd",
    "reediting": "riːdɪtɪŋ",
    "reeds": "riːdz",
    "reeducate": "riːɛdʒuːkeɪt",
    "reedy": "riːdi",
    "reefer": "riːfɐ",
    "reefers": "riːfəz",
    "reef": "riːf",
    "reefs": "riːfs",
    "reeked": "riːkt",
    "reek": "riːk",
    "reeking": "riːkɪŋ",
    "reeks": "riːks",
    "reeky": "riːki",
    "reelected": "riːlɛktɪd",
    "reelection": "riːlɛkʃən",
    "reeled": "riːld",
    "reel": "riːl",
    "reeling": "riːlɪŋ",
    "reels": "riːlz",
    "reemerged": "riːɪmɜːdʒd",
    "reemerge": "riːɪmɜːdʒ",
    "reemergence": "riːɪmɜːdʒəns",
    "reemployed": "riːɛmplɔɪd",
    "reemploy": "riːɛmplɔɪ",
    "reenacted": "riːɛnæktɪd",
    "reenact": "riːɛnækt",
    "reenacting": "riːɛnæktɪŋ",
    "reenactment": "riːɛnæktmənt",
    "reenactments": "riːɛnæktmənts",
    "reenforce": "riːɛnfɔːs",
    "reengage": "riːɛnɡeɪdʒ",
    "reentered": "riːɛntəd",
    "reenter": "riːɛntɐ",
    "reentering": "riːɛntərɪŋ",
    "reestablished": "riːɪstæblɪʃt",
    "reestablish": "riːɪstæblɪʃ",
    "reest": "riːɛst",
    "reevaluate": "riːɪvæljuːeɪt",
    "reevaluation": "riːɪvæljuːeɪʃən",
    "reeve": "riːv",
    "reeves": "riːvz",
    "reexamination": "riːɛɡzæmɪneɪʃən",
    "reexamine": "riːɛɡzæmɪn",
    "reexamining": "riːɛɡzæmɪnɪŋ",
    "refaced": "rɪfeɪst",
    "refacing": "rɪfeɪsɪŋ",
    "refashioned": "rɪfæʃənd",
    "refashion": "rɪfæʃən",
    "refashioning": "rɪfæʃənɪŋ",
    "refectory": "rɪfɛktəri",
    "ref": "rɛf",
    "refereed": "rɛfəriːd",
    "referee": "rɛfəriː",
    "refereeing": "rɛfəriːɪŋ",
    "referees": "rɛfəriːz",
    "referenced": "rɛfrənst",
    "reference": "rɛfrəns",
    "references": "rɛfrənsɪz",
    "referencing": "rɛfrənsɪŋ",
    "referenda": "rɛfərɛndɐ",
    "referendum": "rɛfərɛndəm",
    "referendums": "rɛfərɛndəmz",
    "referent": "rɪfrɛnt",
    "referential": "rɪfərɛnʃəl",
    "refer": "rɪfɜː",
    "referral": "rɪfɜːrəl",
    "referrals": "rɪfɜːrəlz",
    "referred": "rɪfɜːd",
    "referring": "rɪfɜːrɪŋ",
    "refers": "rɪfɜːz",
    "refight": "rɪfaɪt",
    "refillable": "rɪfɪləbəl",
    "refilled": "rɪfɪld",
    "refilling": "rɪfɪlɪŋ",
    "refinanced": "rɪfaɪnænst",
    "refinance": "rɪfaɪnæns",
    "refinancing": "rɪfaɪnænsɪŋ",
    "refined": "rɪfaɪnd",
    "refine": "rɪfaɪn",
    "refinement": "rɪfaɪnmənt",
    "refinements": "rɪfaɪnmənts",
    "refiner": "rɪfɪnɐ",
    "refineries": "rɪfaɪnərɪz",
    "refiners": "rɪfɪnəz",
    "refinery": "rɪfaɪnəri",
    "refines": "rɪfaɪnz",
    "refining": "rɪfaɪnɪŋ",
    "refinished": "rɪfɪnɪʃt",
    "refinishing": "rɪfɪnɪʃɪŋ",
    "refitted": "riːfɪtɪd",
    "refitting": "riːfɪtɪŋ",
    "reflate": "rɪfleɪt",
    "reflected": "rɪflɛktɪd",
    "reflect": "rɪflɛkt",
    "reflecting": "rɪflɛktɪŋ",
    "reflection": "rɪflɛkʃən",
    "reflections": "rɪflɛkʃənz",
    "reflective": "rɪflɛktɪv",
    "reflectively": "rɪflɛktɪvli",
    "reflector": "rɪflɛktɐ",
    "reflectors": "rɪflɛktəz",
    "reflects": "rɪflɛkts",
    "reflexes": "riːflɛksɪz",
    "reflexive": "rɪflɛksɪv",
    "reflexively": "rɪflɛksɪvli",
    "reflexologist": "rɪflɪksɒlədʒɪst",
    "reflexology": "rɪflɪksɒlədʒi",
    "refloated": "rɪfləʊtɪd",
    "refloat": "rɪfləʊt",
    "refloating": "rɪfləʊtɪŋ",
    "reflower": "rɪflaʊɐ",
    "reflux": "riːflʌks",
    "refocused": "rɪfəʊkəsd",
    "refocuses": "rɪfəʊkəsɪz",
    "refocus": "rɪfəʊkəs",
    "refocusing": "rɪfəʊkəsɪŋ",
    "refolding": "rɪfəʊldɪŋ",
    "reforestation": "rɪfɒrɪsteɪʃən",
    "reforest": "rɪfɒrɪst",
    "reformat": "rɪfɔːmæt",
    "reformation": "rɪfɔːmeɪʃən",
    "reformatories": "rɪfɔːmətəriz",
    "reformatory": "rɪfɔːmətəri",
    "reformed": "rɪfɔːmd",
    "reformer": "rɪfɔːmɐ",
    "reformers": "rɪfɔːməz",
    "reforming": "rɪfɔːmɪŋ",
    "reformist": "rɪfɔːmɪst",
    "reformists": "rɪfɔːmɪsts",
    "reformulated": "rɪfɔːmjʊleɪtɪd",
    "reformulate": "rɪfɔːmjʊleɪt",
    "reformulating": "rɪfɔːmjʊleɪtɪŋ",
    "reformulation": "rɪfɔːmjʊleɪʃən",
    "refound": "rɪfaʊnd",
    "refracted": "rɪfræktɪd",
    "refract": "rɪfrækt",
    "refracting": "rɪfræktɪŋ",
    "refraction": "rɪfrækʃən",
    "refractive": "rɪfræktɪv",
    "refractometer": "rɪfrɐktɒmɪtɐ",
    "refractor": "rɪfræktɐ",
    "refractors": "rɪfræktəz",
    "refractory": "rɪfræktəri",
    "refracts": "rɪfrækts",
    "refrained": "rɪfreɪnd",
    "refrain": "rɪfreɪn",
    "refraining": "rɪfreɪnɪŋ",
    "refrains": "rɪfreɪnz",
    "refreeze": "rɪfriːz",
    "refreezes": "rɪfriːzɪz",
    "refreezing": "rɪfriːzɪŋ",
    "refreshed": "rɪfrɛʃt",
    "refresher": "rɪfrɛʃɐ",
    "refreshers": "rɪfrɛʃəz",
    "refreshes": "rɪfrɛʃɪz",
    "refreshing": "rɪfrɛʃɪŋ",
    "refreshingly": "rɪfrɛʃɪŋli",
    "refreshment": "rɪfrɛʃmənt",
    "refreshments": "rɪfrɛʃmənts",
    "refrigerant": "rɪfrɪdʒərənt",
    "refrigerated": "rɪfrɪdʒəreɪtɪd",
    "refrigerate": "rɪfrɪdʒəreɪt",
    "refrigerating": "rɪfrɪdʒəreɪtɪŋ",
    "refrigeration": "rɪfrɪdʒəreɪʃən",
    "refrigerator": "rɪfrɪdʒəreɪtɐ",
    "refrigerators": "rɪfrɪdʒəreɪtəz",
    "refrozen": "rɪfrəʊzən",
    "refs": "rɛfs",
    "refuel": "rɪfjuːl",
    "refuelled": "rɪfjuːld",
    "refuelling": "rɪfjuːlɪŋ",
    "refuels": "rɪfjuːlz",
    "refugee": "rɛfjuːdʒiː",
    "refuge": "rɛfjuːdʒ",
    "refugees": "rɛfjuːdʒiːz",
    "refuges": "rɛfjuːdʒɪz",
    "refundable": "rɪfʌndəbəl",
    "refunded": "rɪfʌndɪd",
    "refunding": "rɪfʌndɪŋ",
    "refurbished": "rɪfɜːbɪʃt",
    "refurbishes": "rɪfɜːbɪʃɪz",
    "refurbish": "rɪfɜːbɪʃ",
    "refurbishing": "rɪfɜːbɪʃɪŋ",
    "refurbishment": "rɪfɜːbɪʃmənt",
    "refurbishments": "rɪfɜːbɪʃmənts",
    "refurnished": "rɪfɜːnɪʃt",
    "refurnish": "rɪfɜːnɪʃ",
    "refurnishing": "rɪfɜːnɪʃɪŋ",
    "refusal": "rɪfjuːsəl",
    "refusals": "rɪfjuːsəlz",
    "refused": "rɪfjuːzd",
    "refuseniks": "rɪfjuːsənɪks",
    "refuses": "rɪfjuːzɪz",
    "refusing": "rɪfjuːzɪŋ",
    "refutable": "rɪfjuːtəbəl",
    "refutation": "rɪfjuːteɪʃən",
    "refuted": "rɪfjuːtɪd",
    "refute": "rɪfjuːt",
    "refutes": "rɪfjuːts",
    "refuting": "rɪfjuːtɪŋ",
    "regained": "rɪɡeɪnd",
    "regain": "rɪɡeɪn",
    "regaining": "rɪɡeɪnɪŋ",
    "regains": "rɪɡeɪnz",
    "regaled": "rɪɡeɪld",
    "regale": "rɪɡeɪl",
    "regales": "rɪɡeɪlz",
    "regalia": "rɪɡeɪliə",
    "regal": "riːɡəl",
    "regaling": "rɪɡeɪlɪŋ",
    "regality": "rɪɡælɪti",
    "regally": "riːɡəli",
    "regard": "rɪɡɑːd",
    "regarded": "rɪɡɑːdɪd",
    "regarding": "rɪɡɑːdɪŋ",
    "regardless": "rɪɡɑːdləs",
    "regards": "rɪɡɑːdz",
    "regather": "rɪɡæðɐ",
    "regathered": "rɪɡæðəd",
    "regatta": "rɪɡætɐ",
    "regattas": "rɪɡætəz",
    "regency": "riːdʒənsi",
    "regenerated": "riːdʒɛnəreɪtɪd",
    "regenerates": "riːdʒɛnəreɪts",
    "regenerating": "riːdʒɛnəreɪtɪŋ",
    "regeneration": "riːdʒɛnəreɪʃən",
    "regenerations": "riːdʒɛnəreɪʃənz",
    "regenerative": "riːdʒɛnərətɪv",
    "regenerator": "riːdʒɛnəreɪtɐ",
    "regent": "riːdʒənt",
    "regents": "riːdʒənts",
    "reggae": "rɪɡiː",
    "regicide": "rɪdʒɪsaɪd",
    "regime": "reɪʒiːm",
    "regimen": "rɛdʒɪmən",
    "regimental": "rɛdʒɪmɛntəl",
    "regimentation": "rɛdʒɪmənteɪʃən",
    "regimented": "rɛdʒɪməntɪd",
    "regiment": "rɛdʒɪmənt",
    "regiments": "rɛdʒɪmənts",
    "regimes": "reɪʒiːmz",
    "regional": "riːdʒənəl",
    "regionalism": "riːdʒənəlɪzəm",
    "regionally": "riːdʒənəli",
    "region": "riːdʒən",
    "regions": "riːdʒənz",
    "registered": "rɛdʒɪstəd",
    "register": "rɛdʒɪstɐ",
    "registering": "rɛdʒɪstərɪŋ",
    "registers": "rɛdʒɪstəz",
    "registrants": "rɛdʒɪstrənts",
    "registrar": "rɛdʒɪstrɑː",
    "registrars": "rɛdʒɪstrɑːz",
    "registration": "rɛdʒɪstreɪʃən",
    "registrations": "rɛdʒɪstreɪʃənz",
    "registries": "rɛdʒɪstrɪz",
    "registry": "rɛdʒɪstri",
    "reglaze": "rɪɡleɪz",
    "regnal": "rɪɡnæl",
    "regnant": "rɪɡnɑːnt",
    "regolith": "rɪɡɒlɪθ",
    "regraded": "rɪɡreɪdɪd",
    "regrade": "rɪɡreɪd",
    "regrading": "rɪɡreɪdɪŋ",
    "regressed": "rɪɡrɛst",
    "regresses": "rɪɡrɛsɪz",
    "regressing": "rɪɡrɛsɪŋ",
    "regression": "rɪɡrɛʃən",
    "regressive": "rɪɡrɛsɪv",
    "regret": "rɪɡrɛt",
    "regretful": "rɪɡrɛtfəl",
    "regretfully": "rɪɡrɛtfəli",
    "regrets": "rɪɡrɛts",
    "regrettable": "rɪɡrɛtəbəl",
    "regrettably": "rɪɡrɛtəbli",
    "regretted": "rɪɡrɛtɪd",
    "regretting": "rɪɡrɛtɪŋ",
    "regrouped": "rɪɡruːpt",
    "regrouping": "rɪɡruːpɪŋ",
    "regroups": "rɪɡruːps",
    "regroup": "rɪɡruːp",
    "regrow": "rɪɡrəʊ",
    "regrowing": "rɪɡrəʊɪŋ",
    "regrown": "rɪɡrəʊn",
    "regrows": "rɪɡrəʊz",
    "regrowth": "rɪɡrəʊθ",
    "regular": "rɛɡjuːlɐ",
    "regularisation": "rɛɡjuːləraɪzeɪʃən",
    "regularised": "rɛɡjuːləraɪzd",
    "regularise": "rɛɡjuːləraɪz",
    "regularities": "rɛɡjuːlærɪtiz",
    "regularity": "rɛɡjuːlærɪti",
    "regularly": "rɛɡjuːləli",
    "regulars": "rɛɡjuːləz",
    "regulated": "rɛɡjuːleɪtɪd",
    "regulate": "rɛɡjuːleɪt",
    "regulates": "rɛɡjuːleɪts",
    "regulating": "rɛɡjuːleɪtɪŋ",
    "regulation": "rɛɡjuːleɪʃən",
    "regulations": "rɛɡjuːleɪʃənz",
    "regulator": "rɛɡjuːleɪtɐ",
    "regulators": "rɛɡjuːleɪtəz",
    "regulatory": "rɛɡjuːleɪtəri",
    "regulus": "rɛɡjuːləs",
    "regurgitated": "rɪɡɜːdʒɪteɪtɪd",
    "regurgitate": "rɪɡɜːdʒɪteɪt",
    "regurgitates": "rɪɡɜːdʒɪteɪts",
    "regurgitating": "rɪɡɜːdʒɪteɪtɪŋ",
    "regurgitation": "rɪɡɜːdʒɪteɪʃən",
    "rehabbed": "rɪhæbd",
    "rehab": "rɪhæb",
    "rehabilitated": "rɪhəbɪlɪteɪtɪd",
    "rehabilitate": "rɪhəbɪlɪteɪt",
    "rehabilitates": "rɪhəbɪlɪteɪts",
    "rehabilitating": "rɪhəbɪlɪteɪtɪŋ",
    "rehabilitation": "rɪhəbɪlɪteɪʃən",
    "rehabilitative": "rɪhəbɪlɪteɪtɪv",
    "rehabs": "rɪhæbz",
    "rehang": "rɪhæŋ",
    "rehanging": "rɪhæŋɪŋ",
    "rehashed": "rɪhæʃt",
    "rehashing": "rɪhæʃɪŋ",
    "reheard": "rɪhɜːd",
    "rehearsal": "rɪhɜːsəl",
    "rehearsals": "rɪhɜːsəlz",
    "rehearsed": "rɪhɜːsd",
    "rehearse": "rɪhɜːs",
    "rehearses": "rɪhɜːsɪz",
    "rehears": "rɪhiəz",
    "rehearsing": "rɪhɜːsɪŋ",
    "reheated": "rɪhiːtɪd",
    "reheat": "rɪhiːt",
    "reheating": "rɪhiːtɪŋ",
    "reheats": "rɪhiːts",
    "rehired": "rɪhaɪəd",
    "rehire": "rɪhaɪə",
    "rehiring": "rɪhaɪərɪŋ",
    "rehoused": "rɪhaʊsd",
    "rehouse": "rɛhaʊs",
    "rehousing": "rɪhaʊsɪŋ",
    "rehung": "rɪhʌŋ",
    "rehydrate": "rɪhaɪdreɪt",
    "reigned": "reɪnd",
    "reign": "reɪn",
    "reigning": "reɪnɪŋ",
    "reignited": "riːɪɡnaɪtɪd",
    "reignite": "riːɪɡnaɪt",
    "reigniting": "riːɪɡnaɪtɪŋ",
    "reigns": "reɪnz",
    "reimbursed": "riːɪmbɜːsd",
    "reimburse": "riːɪmbɜːs",
    "reimbursement": "riːɪmbɜːsmənt",
    "reimbursements": "riːɪmbɜːsmənts",
    "reimburses": "riːɪmbɜːsɪz",
    "reimbursing": "riːɪmbɜːsɪŋ",
    "reimposed": "riːɪmpəʊzd",
    "reimpose": "riːɪmpəʊz",
    "reincarnated": "riːɪnkɑːneɪtɪd",
    "reincarnation": "riːɪnkɑːneɪʃən",
    "reincarnations": "riːɪnkɑːneɪʃənz",
    "reincorporated": "riːɪnkɔːpəreɪtɪd",
    "reindeer": "reɪndiə",
    "reindeers": "reɪndiəz",
    "reined": "reɪnd",
    "rein": "reɪn",
    "reinfect": "riːɪnfɛkt",
    "reinfection": "riːɪnfɛkʃən",
    "reinforced": "riːɪnfɔːst",
    "reinforce": "riːɪnfɔːs",
    "reinforcement": "riːɪnfɔːsmənt",
    "reinforcements": "riːɪnfɔːsmənts",
    "reinforces": "riːɪnfɔːsɪz",
    "reinforcing": "riːɪnfɔːsɪŋ",
    "reining": "reɪnɪŋ",
    "reins": "reɪnz",
    "reinserted": "riːɪnsɜːtɪd",
    "reinsert": "riːɪnsɜːt",
    "reinsertion": "riːɪnsɜːʃən",
    "reinspect": "riːɪnspɛkt",
    "reinstalled": "riːɪnstɔːld",
    "reinstalling": "riːɪnstɔːlɪŋ",
    "reinstall": "riːɪnstɔːl",
    "reinstated": "riːɪnsteɪtɪd",
    "reinstate": "riːɪnsteɪt",
    "reinstatement": "riːɪnsteɪtmənt",
    "reinstates": "riːɪnsteɪts",
    "reinstating": "riːɪnsteɪtɪŋ",
    "reinsurance": "riːɪnʃɔːrəns",
    "reinsure": "riːɪnʃɔː",
    "reintegrated": "riːɪntɪɡreɪtɪd",
    "reintegrate": "riːɪntɪɡreɪt",
    "reintegrating": "riːɪntɪɡreɪtɪŋ",
    "reintegration": "riːɪntɪɡreɪʃən",
    "reinter": "riːɪntɜː",
    "reinterpretation": "riːɪntɜːprɪteɪʃən",
    "reinterpreted": "riːɪntɜːprɪtɪd",
    "reinterpreting": "riːɪntɜːprɪtɪŋ",
    "reinterpret": "riːɪntɜːprɪt",
    "reinterprets": "riːɪntɜːprɪts",
    "reintroduced": "riːɪntrədjuːst",
    "reintroduce": "riːɪntrədjuːs",
    "reintroduces": "riːɪntrədjuːsɪz",
    "reintroducing": "riːɪntrədjuːsɪŋ",
    "reintroduction": "riːɪntrədʌkʃən",
    "reintroductions": "riːɪntrədʌkʃənz",
    "reinvented": "riːɪnvɛntɪd",
    "reinventing": "riːɪnvɛntɪŋ",
    "reinvent": "riːɪnvɛnt",
    "reinvention": "riːɪnvɛnʃən",
    "reinventions": "riːɪnvɛnʃənz",
    "reinvents": "riːɪnvɛnts",
    "reinvested": "riːɪnvɛstɪd",
    "reinvestigate": "riːɪnvɛstɪɡeɪt",
    "reinvestigation": "riːɪnvɛstɪɡeɪʃən",
    "reinvesting": "riːɪnvɛstɪŋ",
    "reinvest": "riːɪnvɛst",
    "reinvestment": "riːɪnvɛstmənt",
    "reinvigorated": "riːɪnvɪɡəreɪtɪd",
    "reinvigorate": "riːɪnvɪɡəreɪt",
    "reinvigorates": "riːɪnvɪɡəreɪts",
    "reinvigorating": "riːɪnvɪɡəreɪtɪŋ",
    "reinvigoration": "riːɪnvɪɡəreɪʃən",
    "reis": "raɪz",
    "reissued": "riːɪʃuːd",
    "reissue": "riːɪʃuː",
    "reissuing": "riːɪʃuːɪŋ",
    "reiterated": "riːɪtəreɪtɪd",
    "reiterate": "riːɪtəreɪt",
    "reiterates": "riːɪtəreɪts",
    "reiterating": "riːɪtəreɪtɪŋ",
    "reiteration": "riːɪtəreɪʃən",
    "rejected": "rɪdʒɛktɪd",
    "rejecting": "rɪdʒɛktɪŋ",
    "rejection": "rɪdʒɛkʃən",
    "rejections": "rɪdʒɛkʃənz",
    "rejig": "rɪdʒɪɡ",
    "rejigged": "rɪdʒɪɡd",
    "rejigging": "rɪdʒɪɡɪŋ",
    "rejoiced": "rɪdʒɔɪst",
    "rejoice": "rɪdʒɔɪs",
    "rejoices": "rɪdʒɔɪsɪz",
    "rejoicing": "rɪdʒɔɪsɪŋ",
    "rejuvenated": "rɪdʒuːvəneɪtɪd",
    "rejuvenate": "rɪdʒuːvəneɪt",
    "rejuvenates": "rɪdʒuːvəneɪts",
    "rejuvenating": "rɪdʒuːvəneɪtɪŋ",
    "rejuvenation": "rɪdʒuːvəneɪʃən",
    "rejuvenator": "rɪdʒuːvəneɪtɐ",
    "rekindled": "rɪkɪndəld",
    "rekindle": "rɪkɪndəl",
    "rekindles": "rɪkɪndəlz",
    "rekindling": "rɪkɪndlɪŋ",
    "relabel": "rɪleɪbəl",
    "relabelled": "rɪleɪbəld",
    "relaid": "rɪleɪd",
    "relapsed": "rɪlæpsd",
    "relapses": "rɪlæpsɪz",
    "relapsing": "rɪlæpsɪŋ",
    "relatable": "rɪleɪtəbəl",
    "related": "rɪleɪtɪd",
    "relate": "rɪleɪt",
    "relates": "rɪleɪts",
    "relating": "rɪleɪtɪŋ",
    "relational": "rɪleɪʃənəl",
    "relation": "rɪleɪʃən",
    "relationship": "rɪleɪʃənʃɪp",
    "relationships": "rɪleɪʃənʃɪps",
    "relations": "rɪleɪʃənz",
    "relative": "rɛlətɪv",
    "relatively": "rɛlətɪvli",
    "relatives": "rɛlətɪvz",
    "relativism": "rɪlætɪvɪzəm",
    "relativity": "rɪlɐtɪvɪti",
    "relaunched": "rɪlɔːntʃt",
    "relaunches": "rɪlɔːntʃɪz",
    "relaunching": "rɪlɔːntʃɪŋ",
    "relaunch": "rɪlɔːntʃ",
    "relaxant": "rɪlæksənt",
    "relaxants": "rɪlæksənts",
    "relaxation": "rɪlɐkseɪʃən",
    "relaxations": "rɪlɐkseɪʃənz",
    "relaxed": "rɪlækst",
    "relaxer": "rɪlæksɐ",
    "relaxes": "rɪlæksɪz",
    "relaxing": "rɪlæksɪŋ",
    "relax": "rɪlæks",
    "relayed": "riːleɪd",
    "relearned": "rɪlɜːnd",
    "relearning": "rɪlɜːnɪŋ",
    "relearn": "rɪlɜːn",
    "releasable": "rɪliːsəbəl",
    "released": "rɪliːsd",
    "releases": "rɪliːsɪz",
    "releasing": "rɪliːsɪŋ",
    "relegated": "rɛlɪɡeɪtɪd",
    "relegate": "rɛlɪɡeɪt",
    "relegates": "rɛlɪɡeɪts",
    "relegating": "rɛlɪɡeɪtɪŋ",
    "relegation": "rɛlɪɡeɪʃən",
    "relented": "rɪlɛntɪd",
    "relenting": "rɪlɛntɪŋ",
    "relent": "rɪlɛnt",
    "relentless": "rɪlɛntləs",
    "relentlessly": "rɪlɛntləsli",
    "relentlessness": "rɪlɛntləsnəs",
    "relents": "rɪlɛnts",
    "relevance": "rɛlɪvəns",
    "relevancy": "rɛlɪvənsi",
    "relevant": "rɛlɪvənt",
    "relevantly": "rɛlɪvəntli",
    "reliability": "rɪlaɪəbɪlɪti",
    "reliable": "rɪlaɪəbəl",
    "reliably": "rɪlaɪəbli",
    "reliance": "rɪlaɪəns",
    "reliant": "rɪlaɪənt",
    "relic": "rɛlɪk",
    "relics": "rɛlɪks",
    "relict": "rɪlɪkt",
    "relied": "rɪlaɪd",
    "relief": "rɪliːf",
    "reliefs": "rɪliːfs",
    "relies": "rɪlaɪz",
    "relieved": "rɪliːvd",
    "relieve": "rɪliːv",
    "reliever": "rɪliːvɐ",
    "relievers": "rɪliːvəz",
    "relieves": "rɪliːvz",
    "relieving": "rɪliːvɪŋ",
    "relighting": "rɪlaɪtɪŋ",
    "relight": "rɪlaɪt",
    "religionist": "rɪlɪdʒənɪst",
    "religionists": "rɪlɪdʒənɪsts",
    "religion": "rɪlɪdʒən",
    "religions": "rɪlɪdʒənz",
    "religiosity": "rɪlɪdʒɪɒsɪti",
    "religious": "rɪlɪdʒəs",
    "religiously": "rɪlɪdʒəsli",
    "religiousness": "rɪlɪdʒəsnəs",
    "relined": "rɪlaɪnd",
    "reline": "rɪlaɪn",
    "relining": "rɪlaɪnɪŋ",
    "relinking": "rɪlɪŋkɪŋ",
    "relink": "rɪlɪŋk",
    "relinquished": "rɪlɪnkwɪʃt",
    "relinquishes": "rɪlɪnkwɪʃɪz",
    "relinquishing": "rɪlɪnkwɪʃɪŋ",
    "relinquish": "rɪlɪnkwɪʃ",
    "reliquaries": "rɪlɪkwəriz",
    "reliquary": "rɪlɪkwəri",
    "relished": "rɛlɪʃt",
    "relish": "rɛlɪʃ",
    "relishes": "rɛlɪʃɪz",
    "relishing": "rɛlɪʃɪŋ",
    "relit": "rɪlɪt",
    "relived": "rɪlɪvd",
    "relive": "rɪlɪv",
    "relives": "rɪlɪvz",
    "reliving": "rɪlɪvɪŋ",
    "reloaded": "rɪləʊdɪd",
    "reloading": "rɪləʊdɪŋ",
    "reload": "rɪləʊd",
    "reloads": "rɪləʊdz",
    "relocated": "rɪləʊkeɪtɪd",
    "relocate": "rɪləʊkeɪt",
    "relocates": "rɪləʊkeɪts",
    "relocating": "rɪləʊkeɪtɪŋ",
    "relocation": "rɪləʊkeɪʃən",
    "reluctance": "rɪlʌktəns",
    "reluctant": "rɪlʌktənt",
    "reluctantly": "rɪlʌktəntli",
    "relying": "rɪlaɪɪŋ",
    "rely": "rɪlaɪ",
    "remade": "rɪmeɪd",
    "remaindered": "rɪmeɪndəd",
    "remainder": "rɪmeɪndɐ",
    "remainders": "rɪmeɪndəz",
    "remained": "rɪmeɪnd",
    "remaining": "rɪmeɪnɪŋ",
    "remain": "rɪmeɪn",
    "remains": "rɪmeɪnz",
    "remaking": "rɪmeɪkɪŋ",
    "remanded": "rɪmɑːndɪd",
    "remanding": "rɪmɑːndɪŋ",
    "remand": "rɪmɑːnd",
    "remands": "rɪmɑːndz",
    "remarkable": "rɪmɑːkəbəl",
    "remarkably": "rɪmɑːkəbli",
    "remarque": "rɪmɑːk",
    "remarriage": "rɪmærɪdʒ",
    "remarried": "rɪmærɪd",
    "remarries": "rɪmærɪz",
    "remarrying": "rɪmærɪɪŋ",
    "remarry": "rɪmæri",
    "remastered": "rɪmɑːstəd",
    "rematches": "rɪmætʃɪz",
    "rematch": "rɪmætʃ",
    "remediable": "rɛmədiəbəl",
    "remedial": "rɪmiːdɪəl",
    "remediation": "rɪmiːdɪeɪʃən",
    "remedied": "rɛmədid",
    "remedies": "rɛmədiz",
    "remedy": "rɛmədi",
    "remedying": "rɛmədiɪŋ",
    "remembered": "rɪmɛmbəd",
    "remembering": "rɪmɛmbərɪŋ",
    "remember": "rɪmɛmbɐ",
    "remembers": "rɪmɛmbəz",
    "remembrance": "rɪmɛmbrəns",
    "remembrancer": "rɪmɛmbrənsɐ",
    "remembrances": "rɪmɛmbrənsɪz",
    "reminded": "rɪmaɪndɪd",
    "reminder": "rɪmaɪndɐ",
    "reminders": "rɪmaɪndəz",
    "remindful": "rɪmaɪndfəl",
    "reminding": "rɪmaɪndɪŋ",
    "remind": "rɪmaɪnd",
    "reminds": "rɪmaɪndz",
    "reminisced": "rɛmɪnɪst",
    "reminisce": "rɛmɪnɪs",
    "reminiscence": "rɛmɪnɪsəns",
    "reminiscences": "rɛmɪnɪsənsɪz",
    "reminiscent": "rɛmɪnɪsənt",
    "reminisces": "rɛmɪnɪsɪz",
    "reminiscing": "rɛmɪnɪsɪŋ",
    "remission": "rɪmɪʃən",
    "remissions": "rɪmɪʃənz",
    "remiss": "rɪmɪs",
    "remit": "riːmɪt",
    "remits": "riːmɪts",
    "remittance": "rɪmɪtəns",
    "remittances": "rɪmɪtənsɪz",
    "remitted": "riːmɪtɪd",
    "remitting": "riːmɪtɪŋ",
    "remixed": "rɪmɪkst",
    "remixes": "rɪmɪksɪz",
    "remixing": "rɪmɪksɪŋ",
    "remix": "rɪmɪks",
    "remnant": "rɛmnənt",
    "remnants": "rɛmnənts",
    "remodelled": "rɪmɒdəld",
    "remodelling": "rɪmɒdəlɪŋ",
    "remodel": "rɪmɒdəl",
    "remonstrance": "rɛmɒnstrəns",
    "remonstrated": "rɛmənstreɪtɪd",
    "remonstrate": "rɛmənstreɪt",
    "remonstrates": "rɛmənstreɪts",
    "remonstrating": "rɛmənstreɪtɪŋ",
    "remonstration": "rɛmənstreɪʃən",
    "remoras": "rɪmɔːrəz",
    "remorseful": "rɪmɔːsfəl",
    "remorselessly": "rɪmɔːsləsli",
    "remorseless": "rɪmɔːsləs",
    "remorse": "rɪmɔːs",
    "remortgaged": "rɪmɔːɡɪdʒd",
    "remortgage": "rɪmɔːɡɪdʒ",
    "remortgaging": "rɪmɔːɡɪdʒɪŋ",
    "remotely": "rɪməʊtli",
    "remote": "rɪməʊt",
    "remoteness": "rɪməʊtnəs",
    "remoter": "rɪməʊtɐ",
    "remotes": "rɪməʊts",
    "remotest": "rɪməʊtəst",
    "remoulded": "rɪməʊldɪd",
    "remoulding": "rɪməʊldɪŋ",
    "remould": "rɪməʊld",
    "remounted": "rɪmaʊntɪd",
    "remounting": "rɪmaʊntɪŋ",
    "removable": "rɪmuːvəbəl",
    "removal": "rɪmuːvəl",
    "removals": "rɪmuːvəlz",
    "removed": "rɪmuːvd",
    "remove": "rɪmuːv",
    "remover": "rɪmuːvɐ",
    "removers": "rɪmuːvəz",
    "removes": "rɪmuːvz",
    "removing": "rɪmuːvɪŋ",
    "rems": "rɛmz",
    "remunerated": "rɪmjuːnəreɪtɪd",
    "remunerate": "rɪmjuːnəreɪt",
    "remuneration": "rɪmjuːnəreɪʃən",
    "remunerations": "rɪmjuːnəreɪʃənz",
    "remunerative": "rɪmjuːnərətɪv",
    "renaissance": "rɪneɪsəns",
    "renal": "riːnəl",
    "renamed": "rɪneɪmd",
    "rename": "rɪneɪm",
    "renaming": "rɪneɪmɪŋ",
    "renationalised": "rɪneɪʃənəlaɪzd",
    "rencontre": "rɛnkɒntɐ",
    "rend": "rɛnd",
    "rendered": "rɛndəd",
    "render": "rɛndɐ",
    "rendering": "rɛndərɪŋ",
    "renderings": "rɛndərɪŋz",
    "renders": "rɛndəz",
    "rendezvoused": "rɒndɪvuːd",
    "rendezvousing": "rɒndɪvuːɪŋ",
    "rending": "rɛndɪŋ",
    "rendition": "rɛndɪʃən",
    "renditions": "rɛndɪʃənz",
    "rends": "rɛndz",
    "renegade": "rɛnəɡeɪd",
    "renegades": "rɛnəɡeɪdz",
    "reneged": "rɪnɛdʒd",
    "renege": "rɪnɛdʒ",
    "reneges": "rɪnɛdʒɪz",
    "reneging": "rɪnɛdʒɪŋ",
    "renegotiated": "rɪnɪɡəʊʃɪeɪtɪd",
    "renegotiate": "rɪnɪɡəʊʃɪeɪt",
    "renegotiates": "rɪnɪɡəʊʃɪeɪts",
    "renegotiating": "rɪnɪɡəʊʃɪeɪtɪŋ",
    "renegotiation": "rɪnɪɡəʊʃɪeɪʃən",
    "renewable": "rɪnjuːəbəl",
    "renewal": "rɪnjuːəl",
    "renewals": "rɪnjuːəlz",
    "renewed": "rɪnjuːd",
    "renewing": "rɪnjuːɪŋ",
    "renew": "rɪnjuː",
    "renews": "rɪnjuːz",
    "rennet": "rɛnɪt",
    "renominated": "rɪnɒmɪneɪtɪd",
    "renounced": "rɪnaʊnst",
    "renouncement": "rɪnaʊnsmənt",
    "renounce": "rɪnaʊns",
    "renounces": "rɪnaʊnsɪz",
    "renouncing": "rɪnaʊnsɪŋ",
    "renovated": "rɛnəveɪtɪd",
    "renovate": "rɛnəveɪt",
    "renovates": "rɛnəveɪts",
    "renovating": "rɛnəveɪtɪŋ",
    "renovation": "rɛnəveɪʃən",
    "renovations": "rɛnəveɪʃənz",
    "renovator": "rɛnəveɪtɐ",
    "renovators": "rɛnəveɪtəz",
    "renowned": "rɪnaʊnd",
    "renown": "rɪnaʊn",
    "rentable": "rɛntəbəl",
    "rental": "rɛntəl",
    "rentals": "rɛntəlz",
    "rented": "rɛntɪd",
    "rent": "rɛnt",
    "renter": "rɛntɐ",
    "renters": "rɛntəz",
    "renting": "rɛntɪŋ",
    "rents": "rɛnts",
    "renumbered": "rɪnʌmbəd",
    "renunciation": "rɪnʌnsɪeɪʃən",
    "reoccupied": "rɪɒkjʊpaɪd",
    "reoccupy": "rɪɒkjʊpaɪ",
    "reoccur": "rɪəkɜː",
    "reoccurred": "rɪəkɜːd",
    "reoccurrence": "rɪəkɜːrəns",
    "reoccurring": "rɪəkɜːrɪŋ",
    "reopened": "rɪəʊpənd",
    "reopen": "rɪəʊpən",
    "reopening": "rɪəʊpnɪŋ",
    "reopens": "rɪəʊpənz",
    "reordered": "rɪɔːdəd",
    "reordering": "rɪɔːdərɪŋ",
    "reorder": "rɪɔːdɐ",
    "reorganisation": "rɪɔːɡɐnaɪzeɪʃən",
    "reorganisations": "rɪɔːɡɐnaɪzeɪʃənz",
    "reorganised": "rɪɔːɡɐnaɪzd",
    "reorganise": "rɪɔːɡɐnaɪz",
    "reorganises": "rɪɔːɡɐnaɪzɪz",
    "reorganising": "rɪɔːɡɐnaɪzɪŋ",
    "reorientate": "rɪɔːriənteɪt",
    "reorientation": "rɪɔːriənteɪʃən",
    "reorient": "rɪɔːriənt",
    "repackaged": "rɪpækɪdʒd",
    "repackage": "rɪpækɪdʒ",
    "repackaging": "rɪpækɪdʒɪŋ",
    "repacked": "rɪpækt",
    "repacking": "rɪpækɪŋ",
    "repack": "rɪpæk",
    "repaid": "rɪpeɪd",
    "repainted": "rɪpeɪntɪd",
    "repainting": "rɪpeɪntɪŋ",
    "repairable": "rɪpeərəbəl",
    "repaired": "rɪpeəd",
    "repairer": "rɪpeərɐ",
    "repairers": "rɪpeərəz",
    "repairing": "rɪpeərɪŋ",
    "repairman": "rɪpeəmən",
    "repairs": "rɪpeəz",
    "reparation": "rɪpɐreɪʃən",
    "reparations": "rɪpɐreɪʃənz",
    "repartee": "rɛpɑːteɪ",
    "repast": "rɪpɑːst",
    "repatriated": "rɪpætrɪeɪtɪd",
    "repatriating": "rɪpætrɪeɪtɪŋ",
    "repatriation": "rɪpætrɪeɪʃən",
    "repatriations": "rɪpætrɪeɪʃənz",
    "repaved": "rɪpeɪvd",
    "repave": "rɪpeɪv",
    "repaving": "rɪpeɪvɪŋ",
    "repayable": "rɪpeɪəbəl",
    "repaying": "rɪpeɪɪŋ",
    "repayment": "rɪpeɪmənt",
    "repayments": "rɪpeɪmənts",
    "repay": "rɪpeɪ",
    "repays": "rɪpeɪz",
    "repealed": "rɪpiːld",
    "repealing": "rɪpiːlɪŋ",
    "repeal": "rɪpiːl",
    "repeals": "rɪpiːlz",
    "repeatability": "rɪpiːtəbɪlɪti",
    "repeatable": "rɪpiːtəbəl",
    "repeatedly": "rɪpiːtɪdli",
    "repeated": "rɪpiːtɪd",
    "repeater": "rɪpiːtɐ",
    "repeaters": "rɪpiːtəz",
    "repeating": "rɪpiːtɪŋ",
    "repeat": "rɪpiːt",
    "repeats": "rɪpiːts",
    "repechage": "rɪpɛtʃɪdʒ",
    "repellant": "rɪpɛlənt",
    "repellants": "rɪpɛlənts",
    "repelled": "rɪpɛld",
    "repellent": "rɪpɛlənt",
    "repellents": "rɪpɛlənts",
    "repelling": "rɪpɛlɪŋ",
    "repel": "rɪpɛl",
    "repels": "rɪpɛlz",
    "repentance": "rɪpɛntəns",
    "repentant": "rɪpɛntənt",
    "repented": "rɪpɛntɪd",
    "repenting": "rɪpɛntɪŋ",
    "repents": "rɪpɛnts",
    "rep": "rɛp",
    "repercussion": "rɪpəkʌʃən",
    "repercussions": "rɪpəkʌʃənz",
    "repertoire": "rɛpətwɑː",
    "repertoires": "rɛpətwɑːz",
    "repertory": "rɛpətəri",
    "repetition": "rɛpətɪʃən",
    "repetitions": "rɛpətɪʃənz",
    "repetitious": "rɛpətɪʃəs",
    "repetitively": "rɪpɛtɪtɪvli",
    "repetitiveness": "rɪpɛtɪtɪvnəs",
    "repetitive": "rɪpɛtɪtɪv",
    "rephrased": "rɪfreɪzd",
    "rephrase": "rɪfreɪz",
    "replaceable": "rɪpleɪsəbəl",
    "replaced": "rɪpleɪst",
    "replacement": "rɪpleɪsmənt",
    "replacements": "rɪpleɪsmənts",
    "replace": "rɪpleɪs",
    "replaces": "rɪpleɪsɪz",
    "replacing": "rɪpleɪsɪŋ",
    "replanted": "rɪplæntɪd",
    "replanting": "rɪplæntɪŋ",
    "replant": "rɪplænt",
    "replants": "rɪplænts",
    "replayed": "riːpleɪd",
    "replaying": "riːpleɪɪŋ",
    "replenished": "rɪplɛnɪʃt",
    "replenishes": "rɪplɛnɪʃɪz",
    "replenishing": "rɪplɛnɪʃɪŋ",
    "replenishment": "rɪplɛnɪʃmənt",
    "replenish": "rɪplɛnɪʃ",
    "replete": "rɪpliːt",
    "repletion": "rɪpliːʃən",
    "replica": "rɛplɪkɐ",
    "replicas": "rɛplɪkəz",
    "replicated": "rɛplɪkeɪtɪd",
    "replicate": "rɛplɪkeɪt",
    "replicates": "rɛplɪkeɪts",
    "replicating": "rɛplɪkeɪtɪŋ",
    "replication": "rɛplɪkeɪʃən",
    "replications": "rɛplɪkeɪʃənz",
    "replicator": "rɛplɪkeɪtɐ",
    "replied": "rɪplaɪd",
    "replies": "rɪplaɪz",
    "replying": "rɪplaɪɪŋ",
    "reply": "rɪplaɪ",
    "repopulated": "rɪpɒpjʊleɪtɪd",
    "repopulate": "rɪpɒpjʊleɪt",
    "reportable": "rɪpɔːtəbəl",
    "reportage": "rɪpɔːtɪdʒ",
    "reportedly": "rɪpɔːtɪdli",
    "reported": "rɪpɔːtɪd",
    "reporter": "rɪpɔːtɐ",
    "reporters": "rɪpɔːtəz",
    "reporting": "rɪpɔːtɪŋ",
    "reports": "rɪpɔːts",
    "reposed": "rɪpəʊzd",
    "repose": "rɪpəʊz",
    "reposes": "rɪpəʊzɪz",
    "reposing": "rɪpəʊzɪŋ",
    "repositioned": "rɪpəzɪʃənd",
    "repositioning": "rɪpəzɪʃənɪŋ",
    "reposition": "rɪpəzɪʃən",
    "repositions": "rɪpəzɪʃənz",
    "repositories": "rɪpɒsɪtəriz",
    "repository": "rɪpɒsɪtəri",
    "repossessed": "rɪpəzɛst",
    "repossessing": "rɪpəzɛsɪŋ",
    "repossession": "rɪpəzɛʃən",
    "repossessions": "rɪpəzɛʃənz",
    "repossess": "rɪpəzɛs",
    "repp": "rɛp",
    "reprehensible": "rɪprɪhɛnsəbəl",
    "representational": "rɛprɪzɛnteɪʃənəl",
    "representation": "rɛprɪzɛnteɪʃən",
    "representations": "rɛprɪzɛnteɪʃənz",
    "representative": "rɛprɪzɛntətɪv",
    "representatives": "rɛprɪzɛntətɪvz",
    "repressed": "rɪprɛst",
    "represses": "rɪprɛsɪz",
    "repressing": "rɪprɛsɪŋ",
    "repression": "rɪprɛʃən",
    "repressions": "rɪprɛʃənz",
    "repressiveness": "rɪprɛsɪvnəs",
    "repressive": "rɪprɛsɪv",
    "repricing": "rɪpraɪsɪŋ",
    "reprieved": "rɪpriːvd",
    "reprieve": "rɪpriːv",
    "reprimanded": "rɛprɪmɑːndɪd",
    "reprimand": "rɛprɪmɑːnd",
    "reprimanding": "rɛprɪmɑːndɪŋ",
    "reprimands": "rɛprɪmɑːndz",
    "reprinted": "rɪprɪntɪd",
    "reprinting": "rɪprɪntɪŋ",
    "reprisal": "rɪpraɪzəl",
    "reprisals": "rɪpraɪzəlz",
    "reprised": "rɪpraɪzd",
    "reprises": "rɪpraɪzɪz",
    "reprising": "rɪpraɪzɪŋ",
    "reproached": "rɪprəʊtʃt",
    "reproaches": "rɪprəʊtʃɪz",
    "reproachful": "rɪprəʊtʃfəl",
    "reproaching": "rɪprəʊtʃɪŋ",
    "reproach": "rɪprəʊtʃ",
    "reprobate": "rɪprɒbeɪt",
    "reprobates": "rɪprɒbeɪts",
    "reprocessed": "rɪprəʊsɛst",
    "reprocessing": "rɪprəʊsɛsɪŋ",
    "reprocess": "rɪprəʊsɛs",
    "reproduced": "rɪprədjuːst",
    "reproduce": "rɪprədjuːs",
    "reproducer": "rɪprədjuːsɐ",
    "reproduces": "rɪprədjuːsɪz",
    "reproducible": "rɪprədjuːsəbəl",
    "reproducing": "rɪprədjuːsɪŋ",
    "reproduction": "rɪprədʌkʃən",
    "reproductions": "rɪprədʌkʃənz",
    "reproductive": "rɪprədʌktɪv",
    "reprogrammed": "rɪprəʊɡræmd",
    "reprogramming": "rɪprəʊɡræmɪŋ",
    "reprogram": "rɪprəʊɡræm",
    "repro": "rɪprəʊ",
    "reproved": "rɪpruːvd",
    "reprove": "rɪpruːv",
    "reproving": "rɪpruːvɪŋ",
    "reps": "rɛps",
    "reptile": "rɛptaɪl",
    "reptiles": "rɛptaɪlz",
    "reptilian": "rɛptɪliən",
    "republicanism": "rɪpʌblɪkənɪzəm",
    "republican": "rɪpʌblɪkən",
    "republicans": "rɪpʌblɪkənz",
    "republic": "rɪpʌblɪk",
    "republics": "rɪpʌblɪks",
    "republished": "rɪpʌblɪʃt",
    "republish": "rɪpʌblɪʃ",
    "repudiated": "rɪpjuːdɪeɪtɪd",
    "repudiate": "rɪpjuːdɪeɪt",
    "repudiates": "rɪpjuːdɪeɪts",
    "repudiation": "rɪpjuːdɪeɪʃən",
    "repugnance": "rɪpʌɡnəns",
    "repugnant": "rɪpʌɡnənt",
    "repulsed": "rɪpʌlzd",
    "repulse": "rɪpʌls",
    "repulses": "rɪpʌlsɪz",
    "repulsion": "rɪpʌlʃən",
    "repulsiveness": "rɪpʌlsɪvnəs",
    "repulsive": "rɪpʌlsɪv",
    "repurchased": "rɪpɜːtʃɪsd",
    "repurchase": "rɪpɜːtʃɪs",
    "reputable": "rɛpjuːtəbəl",
    "reputably": "rɪpjuːtəbli",
    "reputation": "rɛpjuːteɪʃən",
    "reputations": "rɛpjuːteɪʃənz",
    "reputedly": "rɪpjuːtɪdli",
    "reputed": "rɪpjuːtɪd",
    "repute": "rɪpjuːt",
    "requested": "rɪkwɛstɪd",
    "requesting": "rɪkwɛstɪŋ",
    "request": "rɪkwɛst",
    "requests": "rɪkwɛsts",
    "requiem": "rɛkwɪɛm",
    "requiems": "rɛkwɪɛmz",
    "requiescat": "rɪkwɪɛsæt",
    "required": "rɪkwaɪəd",
    "require": "rɪkwaɪə",
    "requirement": "rɪkwaɪəmənt",
    "requirements": "rɪkwaɪəmənts",
    "requires": "rɪkwaɪəz",
    "requiring": "rɪkwaɪərɪŋ",
    "requisite": "rɛkwɪsɪt",
    "requisites": "rɛkwɪsɪts",
    "requisitioned": "rɛkwɪsɪʃənd",
    "requisition": "rɛkwɪsɪʃən",
    "requisitioning": "rɛkwɪsɪʃənɪŋ",
    "requisitions": "rɛkwɪsɪʃənz",
    "requital": "rɪkwɪtəl",
    "requite": "rɪkwaɪt",
    "requiting": "rɪkwaɪtɪŋ",
    "reran": "rɪræn",
    "rereading": "rɪriːdɪŋ",
    "rerecorded": "rɪrɛkɔːdɪd",
    "rerecord": "rɪrɛkɔːd",
    "reredos": "rɪriːdəʊz",
    "rerelease": "riːrɪliːs",
    "rerouted": "rɪruːtɪd",
    "reroute": "rɪruːt",
    "rerouting": "rɪruːtɪŋ",
    "rerunning": "rɪrʌnɪŋ",
    "resale": "riːseɪl",
    "resales": "riːseɪlz",
    "rescheduled": "rɪstʃɛdjuːld",
    "reschedules": "rɪstʃɛdjuːlz",
    "reschedule": "rɪstʃɛdjuːl",
    "rescheduling": "rɪstʃɛdjuːlɪŋ",
    "rescinded": "rɪsɪndɪd",
    "rescind": "rɪsɪnd",
    "rescission": "rɪsɪʃən",
    "rescued": "rɛskjuːd",
    "rescue": "rɛskjuː",
    "rescuer": "rɛskjuːɐ",
    "rescuers": "rɛskjuːəz",
    "rescues": "rɛskjuːz",
    "rescuing": "rɛskjuːɪŋ",
    "resealable": "rɪsiːləbəl",
    "resealed": "rɪsiːld",
    "resealing": "rɪsiːlɪŋ",
    "reseal": "rɪsiːl",
    "researched": "rɪsɜːtʃt",
    "researchers": "rɪsɜːtʃəz",
    "researcher": "rɪsɜːtʃɐ",
    "researches": "rɪsɜːtʃɪz",
    "researching": "rɪsɜːtʃɪŋ",
    "reseated": "rɪsiːtɪd",
    "resected": "rɪsɛktɪd",
    "resection": "rɪsɛkʃən",
    "resections": "rɪsɛkʃənz",
    "resect": "rɪsɛkt",
    "reseeded": "rɪsiːdɪd",
    "reseeding": "rɪsiːdɪŋ",
    "reseed": "rɪsiːd",
    "reselect": "riːsɪlɛkt",
    "reseller": "riːsɛlɐ",
    "resellers": "riːsɛləz",
    "reselling": "riːsɛlɪŋ",
    "resell": "riːsɛl",
    "resells": "riːsɛlz",
    "resemblance": "rɪsɛmbləns",
    "resemblances": "rɪsɛmblənsɪz",
    "resembled": "rɪsɛmbəld",
    "resemble": "rɪsɛmbəl",
    "resembles": "rɪsɛmbəlz",
    "resembling": "rɪsɛmblɪŋ",
    "resend": "rɪsɛnd",
    "resented": "rɪsɛntɪd",
    "resentfully": "rɪsɛntfəli",
    "resentful": "rɪsɛntfəl",
    "resenting": "rɪsɛntɪŋ",
    "resentment": "rɪsɛntmənt",
    "resentments": "rɪsɛntmənts",
    "resents": "rɪsɛnts",
    "reservation": "rɛzəveɪʃən",
    "reservations": "rɛzəveɪʃənz",
    "reservists": "rɪsɜːvɪsts",
    "reservist": "rɪsɜːvɪst",
    "reservoir": "rɛzəvwɑː",
    "reservoirs": "rɛzəvwɑːz",
    "reset": "rɪsɛt",
    "resets": "rɪsɛts",
    "resetting": "rɪsɛtɪŋ",
    "resettled": "rɪsɛtəld",
    "resettlement": "rɪsɛtəlmənt",
    "resettle": "rɪsɛtəl",
    "resettling": "rɪsɛtlɪŋ",
    "reshaped": "rɪʃeɪpt",
    "reshape": "rɪʃeɪp",
    "reshapes": "rɪʃeɪps",
    "reshaping": "rɪʃeɪpɪŋ",
    "resh": "rɛʃ",
    "reshuffled": "rɪʃʌfəld",
    "reshuffle": "rɪʃʌfəl",
    "reshuffles": "rɪʃʌfəlz",
    "reshuffling": "rɪʃʌflɪŋ",
    "resided": "rɪsaɪdɪd",
    "residence": "rɛzɪdəns",
    "residences": "rɛzɪdənsɪz",
    "residencies": "rɛzɪdənsiz",
    "residency": "rɛzɪdənsi",
    "resident": "rɛzɪdənt",
    "residential": "rɛzɪdɛnʃəl",
    "residents": "rɛzɪdənts",
    "resides": "rɪsaɪdz",
    "residing": "rɪsaɪdɪŋ",
    "residual": "rɪsɪdʒuːəl",
    "residuals": "rɪsɪdʒuːəlz",
    "residuary": "rɪsɪdjuːəri",
    "residue": "rɛsɪdjuː",
    "residues": "rɛsɪdjuːz",
    "resignations": "rɪzɪɡneɪʃənz",
    "resignation": "rɪzɪɡneɪʃən",
    "resile": "rɪsaɪl",
    "resilience": "rɪsɪliəns",
    "resiliency": "rɪsɪliənsi",
    "resiliently": "rɪsɪliəntli",
    "resilient": "rɪsɪliənt",
    "resined": "rɛzɪnd",
    "resin": "rɛzɪn",
    "resinous": "rɪsɪnəs",
    "resins": "rɛzɪnz",
    "resistances": "rɪsɪstənsɪz",
    "resistance": "rɪsɪstəns",
    "resistant": "rɪsɪstənt",
    "resisted": "rɪsɪstɪd",
    "resisters": "rɪsɪstəz",
    "resister": "rɪsɪstɐ",
    "resistible": "rɪsɪstəbəl",
    "resisting": "rɪsɪstɪŋ",
    "resistors": "rɪsɪstəz",
    "resistor": "rɪsɪstɐ",
    "resists": "rɪsɪsts",
    "resist": "rɪsɪst",
    "resiting": "rɪsaɪtɪŋ",
    "resits": "rɪsɪts",
    "resit": "rɪsɪt",
    "resitting": "rɪsɪtɪŋ",
    "resizing": "rɪsaɪzɪŋ",
    "resold": "riːsəʊld",
    "resoled": "rɪzəʊld",
    "resoling": "rɪzəʊlɪŋ",
    "resolute": "rɛzəluːt",
    "resolutely": "rɛzəluːtli",
    "resolution": "rɛzəluːʃən",
    "resolutions": "rɛzəluːʃənz",
    "resolvable": "rɪzɒlvəbəl",
    "resonance": "rɛzənəns",
    "resonances": "rɛzənənsɪz",
    "resonant": "rɛzənənt",
    "resonantly": "rɛzənəntli",
    "resonated": "rɛzəneɪtɪd",
    "resonate": "rɛzəneɪt",
    "resonates": "rɛzəneɪts",
    "resonating": "rɛzəneɪtɪŋ",
    "resonator": "rɛzəneɪtɐ",
    "resounded": "rɪzaʊndɪd",
    "resoundingly": "rɪzaʊndɪŋli",
    "resounding": "rɪzaʊndɪŋ",
    "resounds": "rɪzaʊndz",
    "resourced": "rɪzɔːsd",
    "resourcefully": "rɪzɔːsfəli",
    "resourcefulness": "rɪzɔːsfəlnəs",
    "resourceful": "rɪzɔːsfəl",
    "resources": "rɪzɔːsɪz",
    "resource": "rɪzɔːs",
    "resourcing": "rɪzɔːsɪŋ",
    "respectability": "rɪspɛktəbɪlɪti",
    "respectable": "rɪspɛktəbəl",
    "respectably": "rɪspɛktəbli",
    "respected": "rɪspɛktɪd",
    "respecter": "rɪspɛktɐ",
    "respecters": "rɪspɛktəz",
    "respectfully": "rɪspɛktfəli",
    "respectful": "rɪspɛktfəl",
    "respecting": "rɪspɛktɪŋ",
    "respectively": "rɪspɛktɪvli",
    "respective": "rɪspɛktɪv",
    "respect": "rɪspɛkt",
    "respects": "rɪspɛkts",
    "respiration": "rɛspɪreɪʃən",
    "respirator": "rɪspɪreɪtɐ",
    "respirators": "rɪspɪreɪtəz",
    "respiratory": "rɪspɪrətəri",
    "respire": "rɪspaɪə",
    "respite": "rɛspaɪt",
    "respites": "rɛspaɪts",
    "resplendent": "rɪsplɛndənt",
    "responded": "rɪspɒndɪd",
    "respondence": "rɪspɒndəns",
    "respondent": "rɪspɒndənt",
    "respondents": "rɪspɒndənts",
    "responder": "rɪspɒndɐ",
    "responders": "rɪspɒndəz",
    "responding": "rɪspɒndɪŋ",
    "respond": "rɪspɒnd",
    "responds": "rɪspɒndz",
    "response": "rɪspɒns",
    "responses": "rɪspɒnsɪz",
    "responsibilities": "rɪspɒnsəbɪlɪtiz",
    "responsibility": "rɪspɒnsəbɪlɪti",
    "responsible": "rɪspɒnsəbəl",
    "responsibly": "rɪspɒnsəbli",
    "responsiveness": "rɪspɒnsɪvnəs",
    "responsive": "rɪspɒnsɪv",
    "resprayed": "rɪspreɪd",
    "respraying": "rɪspreɪɪŋ",
    "restack": "rɪstæk",
    "restage": "rɪsteɪdʒ",
    "restarted": "rɪstɑːtɪd",
    "restarting": "rɪstɑːtɪŋ",
    "restarts": "rɪstɑːts",
    "restart": "rɪstɑːt",
    "restated": "rɪsteɪtɪd",
    "restatement": "rɪsteɪtmənt",
    "restate": "rɪsteɪt",
    "restating": "rɪsteɪtɪŋ",
    "restaurant": "rɛstrɒnt",
    "restauranteur": "rɪstɔːrɑːntɜː",
    "restaurants": "rɛstrɒnts",
    "restaurateurs": "rɪstɔːrɐtɜːz",
    "restaurateur": "rɪstɔːrɐtɜː",
    "rested": "rɛstɪd",
    "rester": "rɪstɜː",
    "rest": "rɛst",
    "restful": "rɛstfəl",
    "restitution": "rɪstɪtjuːʃən",
    "restive": "rɛstɪv",
    "restless": "rɛstləs",
    "restlessly": "rɛstləsli",
    "restlessness": "rɛstləsnəs",
    "restocked": "rɪstɒkt",
    "restocking": "rɪstɒkɪŋ",
    "restocks": "rɪstɒks",
    "restock": "rɪstɒk",
    "restorable": "rɪstɔːrəbəl",
    "restoration": "rɛstəreɪʃən",
    "restorations": "rɛstəreɪʃənz",
    "restorative": "rɪstɔːrətɪv",
    "restored": "rɪstɔːd",
    "restorers": "rɪstɔːrəz",
    "restorer": "rɪstɔːrɐ",
    "restores": "rɪstɔːz",
    "restoring": "rɪstɔːrɪŋ",
    "restrained": "rɪstreɪnd",
    "restraining": "rɪstreɪnɪŋ",
    "restrains": "rɪstreɪnz",
    "restrain": "rɪstreɪn",
    "restraints": "rɪstreɪnts",
    "restraint": "rɪstreɪnt",
    "restricted": "rɪstrɪktɪd",
    "restricting": "rɪstrɪktɪŋ",
    "restrictions": "rɪstrɪkʃənz",
    "restriction": "rɪstrɪkʃən",
    "restrictive": "rɪstrɪktɪv",
    "restricts": "rɪstrɪkts",
    "restrict": "rɪstrɪkt",
    "restring": "rɛstrɪŋ",
    "restringing": "rɪstrɪŋɪŋ",
    "restroom": "rɛstruːm",
    "restrooms": "rɛstruːmz",
    "restructured": "rɪstrʌktʃəd",
    "restructures": "rɪstrʌktʃəz",
    "restructure": "rɪstrʌktʃɐ",
    "restructurings": "rɪstrʌktʃərɪŋz",
    "restructuring": "rɪstrʌktʃərɪŋ",
    "restrung": "rɪstrʌŋ",
    "rests": "rɛsts",
    "restudy": "rɪstʌdi",
    "restyled": "rɪstaɪld",
    "restyle": "rɪstaɪl",
    "restyling": "rɪstaɪlɪŋ",
    "resubmit": "rɪsəbmɪt",
    "resubmitted": "rɪsəbmɪtɪd",
    "resubmitting": "rɪsəbmɪtɪŋ",
    "resultant": "rɪzʌltənt",
    "resulted": "rɪzʌltɪd",
    "resulting": "rɪzʌltɪŋ",
    "results": "rɪzʌlts",
    "result": "rɪzʌlt",
    "resumed": "rɪzjuːmd",
    "resumes": "rɪzjuːmz",
    "resuming": "rɪzjuːmɪŋ",
    "resumption": "rɪsʌmpʃən",
    "resupplied": "rɪsəplaɪd",
    "resupplies": "rɪsəplaɪz",
    "resupply": "rɪsəplaɪ",
    "resurfaced": "rɪsɜːfɪst",
    "resurface": "rɪsɜːfɪs",
    "resurfaces": "rɪsɜːfɪsɪz",
    "resurfacing": "rɪsɜːfɪsɪŋ",
    "resurgence": "rɪsɜːdʒəns",
    "resurgent": "rɪsɜːdʒənt",
    "resurge": "rɪsɜːdʒ",
    "resurrected": "rɪsərɛktɪd",
    "resurrecting": "rɪsərɛktɪŋ",
    "resurrection": "rɪsərɛkʃən",
    "resurrect": "rɪsərɛkt",
    "resurrects": "rɪsərɛkts",
    "resuscitated": "rɪsʌsɪteɪtɪd",
    "resuscitates": "rɪsʌsɪteɪts",
    "resuscitate": "rɪsʌsɪteɪt",
    "resuscitating": "rɪsʌsɪteɪtɪŋ",
    "resuscitation": "rɪsʌsɪteɪʃən",
    "retailed": "riːteɪld",
    "retailer": "riːteɪlɐ",
    "retailers": "riːteɪləz",
    "retailing": "riːteɪlɪŋ",
    "retail": "riːteɪl",
    "retails": "riːteɪlz",
    "retained": "rɪteɪnd",
    "retainers": "rɪteɪnəz",
    "retainer": "rɪteɪnɐ",
    "retaining": "rɪteɪnɪŋ",
    "retains": "rɪteɪnz",
    "retain": "rɪteɪn",
    "retaken": "rɪteɪkən",
    "retaking": "rɪteɪkɪŋ",
    "retaliated": "rɪtælɪeɪtɪd",
    "retaliates": "rɪtælɪeɪts",
    "retaliate": "rɪtælɪeɪt",
    "retaliating": "rɪtælɪeɪtɪŋ",
    "retaliation": "rɪtælɪeɪʃən",
    "retaliatory": "rɪtælɪətəri",
    "retardant": "rɪtɑːdənt",
    "retardation": "rɪtɑːdeɪʃən",
    "retarded": "rɪtɑːdɪd",
    "retarding": "rɪtɑːdɪŋ",
    "retards": "rɪtɑːdz",
    "retched": "rɛtʃd",
    "retches": "rɪtʃɛz",
    "retch": "rɛtʃ",
    "retching": "rɛtʃɪŋ",
    "retelling": "rɪtɛlɪŋ",
    "retells": "rɪtɛlz",
    "retell": "rɪtɛl",
    "retentions": "rɪtɛnʃənz",
    "retention": "rɪtɛnʃən",
    "retentive": "rɪtɛntɪv",
    "retested": "rɪtɛstɪd",
    "retesting": "rɪtɛstɪŋ",
    "rete": "rɪtɛ",
    "rethinking": "rɪθɪŋkɪŋ",
    "rethought": "rɪθɔːt",
    "retiarius": "rɛʃaɪərɪəs",
    "reticence": "rɛtɪsəns",
    "reticent": "rɛtɪsənt",
    "reticular": "rɛtɪkjʊlɐ",
    "reticulated": "rɛtɪkjʊleɪtɪd",
    "reticule": "rɛtɪkjuːl",
    "reticulum": "rɛtɪkjʊləm",
    "retied": "rɪtaɪd",
    "retinae": "rɛtɪniː",
    "retina": "rɛtɪnɐ",
    "retinal": "rɛtɪnəl",
    "retinas": "rɛtɪnəz",
    "retinitis": "rɛtɪnaɪtɪs",
    "retinol": "rɛtɪnɒl",
    "retinue": "rɛtɪnjuː",
    "retinues": "rɛtɪnjuːz",
    "retired": "rɪtaɪəd",
    "retirees": "rɪtaɪəriːz",
    "retiree": "rɪtaɪəriː",
    "retirements": "rɪtaɪəmənts",
    "retirement": "rɪtaɪəmənt",
    "retires": "rɪtaɪəz",
    "retire": "rɪtaɪə",
    "retiring": "rɪtaɪərɪŋ",
    "retitled": "riːtaɪtəld",
    "retold": "rɪtəʊld",
    "retook": "rɪtʊk",
    "retooled": "rɪtuːld",
    "retool": "rɪtuːl",
    "retorted": "rɪtɔːtɪd",
    "retorting": "rɪtɔːtɪŋ",
    "retorts": "rɪtɔːts",
    "retort": "rɪtɔːt",
    "retouched": "rɪtʌtʃt",
    "retouching": "rɪtʌtʃɪŋ",
    "retouch": "rɪtʌtʃ",
    "retraced": "rɪtreɪst",
    "retraces": "rɪtreɪsɪz",
    "retrace": "rɪtreɪs",
    "retracing": "rɪtreɪsɪŋ",
    "retractable": "rɪtræktəbəl",
    "retracted": "rɪtræktɪd",
    "retracting": "rɪtræktɪŋ",
    "retraction": "rɪtrækʃən",
    "retractors": "rɪtræktəz",
    "retractor": "rɪtræktɐ",
    "retracts": "rɪtrækts",
    "retract": "rɪtrækt",
    "retrained": "rɪtreɪnd",
    "retraining": "rɪtreɪnɪŋ",
    "retrain": "rɪtreɪn",
    "retreading": "rɪtrɛdɪŋ",
    "retreated": "rɪtriːtɪd",
    "retreating": "rɪtriːtɪŋ",
    "retreats": "rɪtriːts",
    "retreat": "rɪtriːt",
    "retrenched": "rɪtrɛntʃt",
    "retrenching": "rɪtrɛntʃɪŋ",
    "retrenchment": "rɪtrɛntʃmənt",
    "retrench": "rɪtrɛntʃ",
    "retrial": "riːtraɪəl",
    "retrials": "riːtraɪəlz",
    "retribution": "rɛtrɪbjuːʃən",
    "retributive": "rɛtrɪbjuːtɪv",
    "retried": "riːtraɪd",
    "retrievable": "rɪtriːvəbəl",
    "retrievals": "rɪtriːvəlz",
    "retrieval": "rɪtriːvəl",
    "retrieved": "rɪtriːvd",
    "retrievers": "rɪtriːvəz",
    "retriever": "rɪtriːvɐ",
    "retrieves": "rɪtriːvz",
    "retrieve": "rɪtriːv",
    "retrieving": "rɪtriːvɪŋ",
    "retroactive": "rɛtrəʊæktɪv",
    "retroactively": "rɛtrəʊæktɪvli",
    "retro": "rɛtrəʊ",
    "retrofit": "rɛtrəʊfɪt",
    "retrograde": "rɛtrəʊɡreɪd",
    "retrogressive": "rɛtrəʊɡrɛsɪv",
    "retrospect": "rɛtrəʊspɛkt",
    "retrospection": "rɛtrəʊspɛkʃən",
    "retrospective": "rɛtrəʊspɛktɪv",
    "retrospectively": "rɛtrəʊspɛktɪvli",
    "retrospectives": "rɛtrəʊspɛktɪvz",
    "retroviruses": "rɛtrəʊvaɪrəsɪz",
    "retry": "riːtraɪ",
    "rets": "rɛts",
    "retsina": "rɪtsɪnɐ",
    "retted": "rɛtɪd",
    "retting": "rɛtɪŋ",
    "retune": "rɪtjuːn",
    "retuning": "rɪtjuːnɪŋ",
    "returnable": "rɪtɜːnəbəl",
    "returned": "rɪtɜːnd",
    "returnee": "rɪtɜːniː",
    "returners": "rɪtɜːnəz",
    "returner": "rɪtɜːnɐ",
    "returning": "rɪtɜːnɪŋ",
    "returns": "rɪtɜːnz",
    "retyped": "rɪtaɪpd",
    "retype": "rɪtaɪp",
    "reunification": "riːjuːnɪfɪkeɪʃən",
    "reunified": "riːjuːnɪfaɪd",
    "reunify": "riːjuːnɪfaɪ",
    "reunifying": "riːjuːnɪfaɪɪŋ",
    "reunion": "riːjuːniən",
    "reunions": "riːjuːniənz",
    "reunited": "riːjuːnaɪtɪd",
    "reunite": "riːjuːnaɪt",
    "reunites": "riːjuːnaɪts",
    "reuniting": "riːjuːnaɪtɪŋ",
    "reupholstered": "rjuːfɒlstəd",
    "reupholstering": "rjuːfəlstərɪŋ",
    "reupholster": "rjuːfɒlstɐ",
    "reusable": "riːjuːzəbəl",
    "reused": "riːjuːzd",
    "reuse": "riːjuːz",
    "reuses": "riːjuːzɪz",
    "reusing": "riːjuːzɪŋ",
    "revaluation": "rɪvæljuːeɪʃən",
    "revalued": "rɪvæljuːd",
    "revalues": "rɪvæljuːz",
    "revalue": "rɪvæljuː",
    "revaluing": "rɪvæljuːɪŋ",
    "revamped": "rɪvæmpt",
    "revamping": "rɪvæmpɪŋ",
    "revamps": "rɪvæmps",
    "revamp": "rɪvæmp",
    "revanchist": "rɪvɑːnkɪst",
    "revealed": "rɪviːld",
    "revealingly": "rɪviːlɪŋli",
    "revealing": "rɪviːlɪŋ",
    "reveals": "rɪviːlz",
    "reveal": "rɪviːl",
    "reveille": "rɪveɪl",
    "revelation": "rɛvɪleɪʃən",
    "revelations": "rɛvɪleɪʃənz",
    "revelatory": "rɛvɪlətəri",
    "revel": "rɛvəl",
    "revelled": "rɛvəld",
    "reveller": "rɛvəlɐ",
    "revellers": "rɛvɛləz",
    "revelling": "rɛvəlɪŋ",
    "revelries": "rɛvəlrɪz",
    "revelry": "rɛvəlri",
    "revels": "rɛvəlz",
    "revenant": "rɛvənənt",
    "revenged": "rɪvɛndʒd",
    "revengeful": "rɪvɛndʒfəl",
    "revenger": "rɪvɛndʒɐ",
    "revenges": "rɪvɛndʒɪz",
    "revenge": "rɪvɛndʒ",
    "revenging": "rɪvɛndʒɪŋ",
    "revenue": "rɛvənjuː",
    "revenues": "rɛvənjuːz",
    "reverberant": "rɪvɜːbərənt",
    "reverberated": "rɪvɜːbəreɪtɪd",
    "reverberates": "rɪvɜːbəreɪts",
    "reverberate": "rɪvɜːbəreɪt",
    "reverberating": "rɪvɜːbəreɪtɪŋ",
    "reverberations": "rɪvɜːbəreɪʃənz",
    "reverberation": "rɪvɜːbəreɪʃən",
    "reverb": "rɪvɜːb",
    "revered": "rɪviəd",
    "reverence": "rɛvrəns",
    "reverend": "rɛvərɛnd",
    "reverends": "rɛvərɛndz",
    "reverent": "rɛvrənt",
    "reverential": "rɛvərɛnʃəl",
    "reverently": "rɛvrəntli",
    "reveres": "rɪviəz",
    "revere": "rɪviə",
    "reverie": "rɛvəri",
    "reveries": "rɪvəriz",
    "revering": "rɪviərɪŋ",
    "reversals": "rɪvɜːsəlz",
    "reversal": "rɪvɜːsəl",
    "reversed": "rɪvɜːsd",
    "reverser": "rɪvɜːsɐ",
    "reverses": "rɪvɜːsɪz",
    "reverse": "rɪvɜːs",
    "reversibility": "rɪvɜːsəbɪlɪti",
    "reversible": "rɪvɜːsəbəl",
    "reversing": "rɪvɜːsɪŋ",
    "reversion": "rɪvɜːʃən",
    "reverted": "rɪvɜːtɪd",
    "reverting": "rɪvɜːtɪŋ",
    "reverts": "rɪvɜːts",
    "revert": "rɪvɜːt",
    "revery": "rɪvəri",
    "rev": "rɛv",
    "reviewable": "rɪvjuːəbəl",
    "reviewed": "rɪvjuːd",
    "reviewers": "rɪvjuːəz",
    "reviewer": "rɪvjuːɐ",
    "reviewing": "rɪvjuːɪŋ",
    "reviews": "rɪvjuːz",
    "reviled": "rɪvaɪld",
    "revile": "rɪvaɪl",
    "revised": "rɪvaɪzd",
    "reviser": "rɪvaɪzɐ",
    "revises": "rɪvaɪzɪz",
    "revise": "rɪvaɪz",
    "revising": "rɪvaɪzɪŋ",
    "revisionism": "rɪvɪʒənɪzəm",
    "revisionists": "rɪvɪʒənɪsts",
    "revisionist": "rɪvɪʒənɪst",
    "revisions": "rɪvɪʒənz",
    "revision": "rɪvɪʒən",
    "revisited": "rɪvɪzɪtɪd",
    "revisiting": "rɪvɪzɪtɪŋ",
    "revisits": "rɪvɪzɪts",
    "revisit": "rɪvɪzɪt",
    "revitalisation": "rɪvaɪtəlaɪzeɪʃən",
    "revitalised": "rɪvaɪtəlaɪzd",
    "revitalises": "rɪvaɪtəlaɪzɪz",
    "revitalise": "rɪvaɪtəlaɪz",
    "revitalising": "rɪvaɪtəlaɪzɪŋ",
    "revivalism": "rɪvaɪvəlɪzəm",
    "revivalists": "rɪvaɪvəlɪsts",
    "revivalist": "rɪvaɪvəlɪst",
    "revivals": "rɪvaɪvəlz",
    "revival": "rɪvaɪvəl",
    "revived": "rɪvaɪvd",
    "reviver": "rɪvaɪvɐ",
    "revives": "rɪvaɪvz",
    "revive": "rɪvaɪv",
    "revivify": "rɪvɪvɪfaɪ",
    "reviving": "rɪvaɪvɪŋ",
    "revocation": "rɪvəkeɪʃən",
    "revoked": "rɪvəʊkt",
    "revoke": "rɪvəʊk",
    "revoking": "rɪvəʊkɪŋ",
    "revolted": "rɪvəʊltɪd",
    "revoltingly": "rɪvəʊltɪŋli",
    "revolting": "rɪvəʊltɪŋ",
    "revolts": "rɪvəʊlts",
    "revolt": "rɪvəʊlt",
    "revolutionaries": "rɛvəluːʃənəriz",
    "revolutionary": "rɛvəluːʃənəri",
    "revolution": "rɛvəluːʃən",
    "revolutionised": "rɛvəluːʃənaɪzd",
    "revolutionise": "rɛvəluːʃənaɪz",
    "revolutionises": "rɛvəluːʃənaɪzɪz",
    "revolutionising": "rɛvəluːʃənaɪzɪŋ",
    "revolutionist": "rɛvəluːʃənɪst",
    "revolutions": "rɛvəluːʃənz",
    "revolved": "rɪvɒlvd",
    "revolvers": "rɪvɒlvəz",
    "revolver": "rɪvɒlvɐ",
    "revolves": "rɪvɒlvz",
    "revolve": "rɪvɒlv",
    "revolving": "rɪvɒlvɪŋ",
    "revs": "rɛvz",
    "revues": "rɪvjuːz",
    "revue": "rɪvjuː",
    "revulsion": "rɪvʌlʃən",
    "revved": "rɛvd",
    "revving": "rɛvɪŋ",
    "rewarded": "rɪwɔːdɪd",
    "rewarding": "rɪwɔːdɪŋ",
    "rewards": "rɪwɔːdz",
    "reward": "rɪwɔːd",
    "rewinding": "rɪwaɪndɪŋ",
    "rewinds": "rɪwaɪndz",
    "rewired": "rɪwaɪəd",
    "rewires": "rɪwaɪəz",
    "rewire": "rɪwaɪə",
    "rewiring": "rɪwaɪərɪŋ",
    "reworded": "rɪwɜːdɪd",
    "reworked": "rɪwɜːkt",
    "reworking": "rɪwɜːkɪŋ",
    "reworks": "rɪwɜːks",
    "rework": "rɪwɜːk",
    "rewound": "rɪwaʊnd",
    "rewriting": "rɪraɪtɪŋ",
    "rewritten": "rɪrɪtən",
    "rewrote": "rɪrəʊt",
    "rezoned": "rɪzəʊnd",
    "rhapsodies": "ræpsədɪz",
    "rhapsodise": "ræpsədaɪz",
    "rhapsodising": "ræpsədaɪzɪŋ",
    "rhapsody": "ræpsədi",
    "rhea": "riː",
    "rheas": "riːz",
    "rhenium": "riːniəm",
    "rheostat": "rɪɒstæt",
    "rhesus": "rɛsəs",
    "rhetorical": "rɛtɒrɪkəl",
    "rhetorically": "rɛtɒrɪkli",
    "rhetoric": "rɛtərɪk",
    "rhetorician": "rɛtɔːrɪʃən",
    "rheumatics": "ruːmætɪks",
    "rheumatic": "ruːmætɪk",
    "rheumatism": "ruːmətɪzəm",
    "rheumatoid": "ruːmɐtɔɪd",
    "rheum": "ruːm",
    "rheumy": "ruːmi",
    "rhinestone": "raɪnstəʊn",
    "rhinestones": "raɪnstəʊnz",
    "rhinitis": "raɪnaɪtɪs",
    "rhino": "raɪnəʊ",
    "rhinoceros": "raɪnɒsərəs",
    "rhinoceroses": "raɪnɒsərəsɪz",
    "rhinoplasty": "raɪnəplɐsti",
    "rhinos": "raɪnəʊz",
    "rhizobium": "raɪzəʊbiəm",
    "rhizome": "raɪzəʊm",
    "rhizomes": "raɪzəʊmz",
    "rhizotomy": "raɪzɒtəmi",
    "rhodium": "rəʊdiəm",
    "rhododendron": "rəʊdədɛndrən",
    "rhododendrons": "rəʊdədɛndrənz",
    "rho": "rəʊ",
    "rhomboid": "rɒmbɔɪd",
    "rhombus": "rɒmbəs",
    "rhos": "rəʊz",
    "rhubarb": "ruːbɑːb",
    "rhyme": "raɪm",
    "rhymed": "raɪmd",
    "rhymer": "raɪmɐ",
    "rhymers": "raɪməz",
    "rhymes": "raɪmz",
    "rhyming": "raɪmɪŋ",
    "rhyolite": "raɪəlaɪt",
    "rhythm": "rɪðəm",
    "rhythmical": "rɪðmɪkəl",
    "rhythmically": "rɪðmɪkli",
    "rhythmic": "rɪðmɪk",
    "rhythms": "rɪðəmz",
    "ria": "raɪɐ",
    "rial": "raɪəl",
    "rialto": "raɪəltəʊ",
    "riata": "raɪətɐ",
    "ribald": "rɪbɔːld",
    "ribaldry": "rɪbəldri",
    "riband": "rɪbænd",
    "rib": "rɪb",
    "ribbed": "rɪbd",
    "ribbing": "rɪbɪŋ",
    "ribbon": "rɪbən",
    "ribbons": "rɪbənz",
    "ribcage": "rɪbkeɪdʒ",
    "riboflavin": "rɪbəflævɪn",
    "ribosome": "riːbəʊsəʊm",
    "ribs": "rɪbz",
    "ribwort": "rɪbwɔːt",
    "rice": "raɪs",
    "riced": "raɪst",
    "ricer": "raɪsɐ",
    "ricers": "raɪsəz",
    "rices": "raɪsɪz",
    "richer": "rɪtʃɐ",
    "richest": "rɪtʃəst",
    "riches": "rɪtʃɪz",
    "richly": "rɪtʃli",
    "richness": "rɪtʃnəs",
    "rich": "rɪtʃ",
    "ricing": "raɪsɪŋ",
    "ricked": "rɪkt",
    "rickets": "rɪkɪts",
    "rickety": "rɪkɪti",
    "rickey": "rɪki",
    "rick": "rɪk",
    "rickshaw": "rɪkʃɔː",
    "rickshaws": "rɪkʃɔːz",
    "ricks": "rɪks",
    "ricocheted": "rɪkəʃeɪd",
    "ricocheting": "rɪkəʃɪtɪŋ",
    "ricochet": "rɪkəʃeɪ",
    "ricochets": "rɪkəʃeɪs",
    "ricotta": "rɪkɒtɐ",
    "rictus": "rɪktəs",
    "rid": "rɪd",
    "riddance": "rɪdəns",
    "ridden": "rɪdən",
    "ridding": "rɪdɪŋ",
    "riddled": "rɪdəld",
    "riddle": "rɪdəl",
    "riddler": "rɪdlɐ",
    "riddles": "rɪdəlz",
    "riddling": "rɪdlɪŋ",
    "ride": "raɪd",
    "rider": "raɪdɐ",
    "riderless": "raɪdələs",
    "riders": "raɪdəz",
    "rides": "raɪdz",
    "ridged": "rɪdʒd",
    "ridge": "rɪdʒ",
    "ridges": "rɪdʒɪz",
    "ridging": "rɪdʒɪŋ",
    "ridgy": "rɪdʒi",
    "ridiculed": "rɪdɪkjuːld",
    "ridicule": "rɪdɪkjuːl",
    "ridicules": "rɪdɪkjuːlz",
    "ridiculing": "rɪdɪkjuːlɪŋ",
    "ridiculous": "rɪdɪkjʊləs",
    "ridiculously": "rɪdɪkjʊləsli",
    "ridiculousness": "rɪdɪkjʊləsnəs",
    "riding": "raɪdɪŋ",
    "rids": "rɪdz",
    "riel": "riːl",
    "rife": "raɪf",
    "riff": "rɪf",
    "riffing": "rɪfɪŋ",
    "riffle": "rɪfəl",
    "riffling": "rɪflɪŋ",
    "riffraff": "rɪfræf",
    "riffs": "rɪfs",
    "rifle": "raɪfəl",
    "rifled": "raɪfəld",
    "rifleman": "raɪflɛmən",
    "riflemen": "raɪflɪmɛn",
    "rifles": "raɪfəlz",
    "rifling": "raɪflɪŋ",
    "rifted": "rɪftɪd",
    "rift": "rɪft",
    "rifts": "rɪfts",
    "rig": "rɪɡ",
    "rigatoni": "rɪɡɐtəʊni",
    "rigged": "rɪɡd",
    "rigger": "rɪɡɐ",
    "riggers": "rɪɡəz",
    "rigging": "rɪɡɪŋ",
    "right": "raɪt",
    "righted": "raɪtɪd",
    "righteous": "raɪtʃəs",
    "righteously": "raɪtʃəsli",
    "righteousness": "raɪtʃəsnəs",
    "righter": "raɪtɐ",
    "rightful": "raɪtfəl",
    "rightfully": "raɪtfəli",
    "righting": "raɪtɪŋ",
    "rightist": "raɪtɪst",
    "rightly": "raɪtli",
    "rightness": "raɪtnəs",
    "righto": "raɪtəʊ",
    "rights": "raɪts",
    "rightward": "raɪtwəd",
    "rightwards": "raɪtwədz",
    "rigid": "rɪdʒɪd",
    "rigidities": "rɪdʒɪdɪtiz",
    "rigidity": "rɪdʒɪdɪti",
    "rigidly": "rɪdʒɪdli",
    "rigmarole": "rɪɡmərəʊl",
    "rigor": "rɪɡɐ",
    "rigorous": "rɪɡərəs",
    "rigorously": "rɪɡərəsli",
    "rigors": "rɪɡəz",
    "rigour": "rɪɡɐ",
    "rigours": "rɪɡəz",
    "rigs": "rɪɡz",
    "rile": "raɪl",
    "riled": "raɪld",
    "riles": "raɪlz",
    "riling": "raɪlɪŋ",
    "rille": "rɪl",
    "rill": "rɪl",
    "rills": "rɪlz",
    "rime": "raɪm",
    "rimed": "raɪmd",
    "rimes": "raɪmz",
    "rimless": "rɪmləs",
    "rim": "rɪm",
    "rimmed": "rɪmd",
    "rimming": "rɪmɪŋ",
    "rims": "rɪmz",
    "rind": "raɪnd",
    "rinderpest": "raɪndəpəst",
    "rinds": "raɪndz",
    "ringed": "rɪŋɡd",
    "ringer": "rɪŋɐ",
    "ringers": "rɪŋəz",
    "ringgit": "rɪŋdʒɪt",
    "ringing": "rɪŋɪŋ",
    "ringleader": "rɪŋɡliːdɐ",
    "ringleaders": "rɪŋɡliːdəz",
    "ringlet": "rɪŋɡlət",
    "ringlets": "rɪŋɡləts",
    "ringmaster": "rɪŋmɑːstɐ",
    "ringmasters": "rɪŋmɑːstəz",
    "ring": "rɪŋ",
    "ringside": "rɪŋsaɪd",
    "rings": "rɪŋz",
    "ringtail": "rɪŋteɪl",
    "ringtails": "rɪŋteɪlz",
    "ringworm": "rɪŋwɜːm",
    "rink": "rɪŋk",
    "rinks": "rɪŋks",
    "rinsed": "rɪnsd",
    "rinse": "rɪns",
    "rinser": "rɪnsɐ",
    "rinses": "rɪnsɪz",
    "rinsing": "rɪnsɪŋ",
    "riot": "raɪət",
    "rioted": "raɪətɪd",
    "rioter": "raɪətɐ",
    "rioters": "raɪətəz",
    "rioting": "raɪətɪŋ",
    "riotous": "raɪətəs",
    "riotously": "raɪətəsli",
    "riots": "raɪəts",
    "riparian": "rɪpeəriən",
    "ripcord": "rɪpkɔːd",
    "ripcords": "rɪpkɔːdz",
    "ripe": "raɪp",
    "ripen": "raɪpən",
    "ripened": "raɪpənd",
    "ripeness": "raɪpnəs",
    "ripening": "raɪpnɪŋ",
    "ripens": "raɪpənz",
    "riper": "raɪpɐ",
    "ripest": "raɪpəst",
    "ripieno": "rɪpiənəʊ",
    "ripoff": "rɪpɒf",
    "riposte": "rɪpɒst",
    "rip": "rɪp",
    "ripped": "rɪpt",
    "ripper": "rɪpɐ",
    "rippers": "rɪpəz",
    "ripping": "rɪpɪŋ",
    "rippled": "rɪpəld",
    "ripple": "rɪpəl",
    "ripples": "rɪpəlz",
    "rippling": "rɪplɪŋ",
    "ripply": "rɪpli",
    "rips": "rɪps",
    "riptide": "rɪptaɪd",
    "riptides": "rɪptaɪdz",
    "rise": "raɪz",
    "risen": "rɪzən",
    "riser": "raɪzɐ",
    "risers": "raɪzəz",
    "rises": "raɪzɪz",
    "rishi": "riːʃi",
    "risible": "rɪzəbəl",
    "rising": "raɪzɪŋ",
    "risings": "raɪzɪŋz",
    "risked": "rɪskt",
    "riskier": "rɪskiɐ",
    "riskiest": "rɪskiəst",
    "riskily": "rɪskili",
    "riskiness": "rɪskinəs",
    "risking": "rɪskɪŋ",
    "risk": "rɪsk",
    "risks": "rɪsks",
    "risky": "rɪski",
    "risottos": "rɪsɒtəʊz",
    "risotto": "rɪsɒtəʊ",
    "rissole": "rɪsəʊl",
    "rissoles": "rɪsəʊlz",
    "rite": "raɪt",
    "rites": "raɪts",
    "ritualised": "rɪtʃuːəlaɪzd",
    "ritualism": "rɪtʃuːəlɪzəm",
    "ritualistic": "rɪtʃuːəlɪstɪk",
    "ritually": "rɪtʃuːəli",
    "rituals": "rɪtʃuːəlz",
    "ritual": "rɪtʃuːəl",
    "ritzier": "rɪtsɪɐ",
    "ritzy": "rɪtsi",
    "rivage": "rɪvɪdʒ",
    "rival": "raɪvəl",
    "rivalled": "raɪvəld",
    "rivalling": "raɪvəlɪŋ",
    "rivalries": "raɪvəlrɪz",
    "rivalry": "raɪvəlri",
    "rivals": "raɪvəlz",
    "rive": "raɪv",
    "rived": "raɪvd",
    "riven": "rɪvən",
    "riverbanks": "rɪvəbæŋks",
    "riverbank": "rɪvəbæŋk",
    "riverbeds": "rɪvəbɛdz",
    "riverbed": "rɪvəbɛd",
    "riverboats": "rɪvəbəʊts",
    "riverboat": "rɪvəbəʊt",
    "riverfront": "rɪvəfrʌnt",
    "riverhead": "rɪvəhɛd",
    "riverine": "rɪvəriːn",
    "riverside": "rɪvəsaɪd",
    "rivers": "rɪvəz",
    "rives": "raɪvz",
    "riveted": "rɪvɪtɪd",
    "riveters": "rɪvɛtəz",
    "riveter": "rɪvɛtɐ",
    "riveting": "rɪvɪtɪŋ",
    "rivets": "rɪvɪts",
    "rivet": "rɪvɪt",
    "riviera": "rɪviɛrɐ",
    "rivulets": "rɪvjʊləts",
    "rivulet": "rɪvjʊlət",
    "riyal": "rɪjəl",
    "roaches": "rəʊtʃɪz",
    "roach": "rəʊtʃ",
    "roadblock": "rəʊdblɒk",
    "roadblocks": "rəʊdblɒks",
    "road": "rəʊd",
    "roadhog": "rəʊdhɒɡ",
    "roadhouse": "rəʊdhaʊs",
    "roadie": "rəʊdi",
    "roadies": "rəʊdɪz",
    "roadkill": "rəʊdkɪl",
    "roadrunner": "rəʊdrʌnɐ",
    "roadrunners": "rəʊdrʌnəz",
    "roads": "rəʊdz",
    "roadshow": "rəʊdʃəʊ",
    "roadshows": "rəʊdʃəʊz",
    "roadside": "rəʊdsaɪd",
    "roadsides": "rəʊdsaɪdz",
    "roadster": "rəʊdstɐ",
    "roadsters": "rəʊdstəz",
    "roadway": "rəʊdweɪ",
    "roadways": "rəʊdweɪz",
    "roadwork": "rəʊdwɜːk",
    "roadworks": "rəʊdwɜːks",
    "roadworthy": "rəʊdwɜːði",
    "roamed": "rəʊmd",
    "roam": "rəʊm",
    "roamer": "rəʊmɐ",
    "roamers": "rəʊməz",
    "roaming": "rəʊmɪŋ",
    "roams": "rəʊmz",
    "roan": "rəʊn",
    "roared": "rɔːd",
    "roarer": "rɔːrɐ",
    "roarers": "rɔːrəz",
    "roaring": "rɔːrɪŋ",
    "roar": "rɔː",
    "roars": "rɔːz",
    "roasted": "rəʊstɪd",
    "roaster": "rəʊstɐ",
    "roasters": "rəʊstəz",
    "roast": "rəʊst",
    "roasting": "rəʊstɪŋ",
    "roasts": "rəʊsts",
    "rob": "rɒb",
    "robbed": "rɒbd",
    "robber": "rɒbɐ",
    "robberies": "rɒbəriz",
    "robbers": "rɒbəz",
    "robbery": "rɒbəri",
    "robbin": "rɒbɪn",
    "robbing": "rɒbɪŋ",
    "robed": "rəʊbd",
    "robe": "rəʊb",
    "robes": "rəʊbz",
    "robin": "rɒbɪn",
    "robing": "rəʊbɪŋ",
    "robinia": "rəbɪniə",
    "robins": "rɒbɪnz",
    "robles": "rɒbəlz",
    "robot": "rəʊbɒt",
    "robotically": "rəʊbɒtɪkli",
    "robotic": "rəʊbɒtɪk",
    "robotics": "rəʊbɒtɪks",
    "robots": "rəʊbɒts",
    "robs": "rɒbz",
    "robust": "rəʊbʌst",
    "robustly": "rəʊbʌstli",
    "robustness": "rəʊbʌstnəs",
    "roc": "rɒk",
    "rockabilly": "rɒkɐbɪli",
    "rockaway": "rɒkəweɪ",
    "rocked": "rɒkt",
    "rockeries": "rɒkəriz",
    "rocker": "rɒkɐ",
    "rockers": "rɒkəz",
    "rockery": "rɒkəri",
    "rocketed": "rɒkɪtɪd",
    "rocketeer": "rɒkɪtiə",
    "rocketing": "rɒkɪtɪŋ",
    "rocket": "rɒkɪt",
    "rocketry": "rɒkɪtri",
    "rockets": "rɒkɪts",
    "rockfall": "rɒkfɔːl",
    "rockfish": "rɒkfɪʃ",
    "rockier": "rɒkiɐ",
    "rockiness": "rɒkinəs",
    "rocking": "rɒkɪŋ",
    "rock": "rɒk",
    "rockrose": "rɒkrəʊz",
    "rocks": "rɒks",
    "rocky": "rɒki",
    "rococo": "rəkəʊkəʊ",
    "rod": "rɒd",
    "rode": "rəʊd",
    "rodent": "rəʊdənt",
    "rodents": "rəʊdənts",
    "rodeo": "rəʊdɪəʊ",
    "rodeos": "rəʊdɪəʊz",
    "rods": "rɒdz",
    "roebuck": "rəʊbʌk",
    "roe": "rəʊ",
    "roentgen": "rəʊntdʒən",
    "roes": "rəʊz",
    "rogation": "rəɡeɪʃən",
    "roger": "rɒdʒɐ",
    "rogered": "rɒdʒəd",
    "rogering": "rɒdʒərɪŋ",
    "rogers": "rɒdʒəz",
    "rogue": "rəʊɡ",
    "roguery": "rəʊɡri",
    "rogues": "rəʊɡz",
    "roguishly": "rɒɡwɪʃli",
    "roguish": "rɒɡwɪʃ",
    "roiling": "rɔɪlɪŋ",
    "roils": "rɔɪlz",
    "roistering": "rɔɪstərɪŋ",
    "role": "rəʊl",
    "roles": "rəʊlz",
    "rollaway": "rəʊləweɪ",
    "rollback": "rəʊlbæk",
    "rollbacks": "rəʊlbæks",
    "rolled": "rəʊld",
    "roll": "rəʊl",
    "rollerblading": "rəʊləbleɪdɪŋ",
    "rollercoaster": "rəʊləkəʊstɐ",
    "roller": "rəʊlɐ",
    "rollers": "rəʊləz",
    "rollerskate": "rəʊləskeɪt",
    "rollicking": "rəʊlɪkɪŋ",
    "rolling": "rəʊlɪŋ",
    "rollmop": "rəʊlməp",
    "rollmops": "rəʊlməps",
    "rollover": "rəʊləʊvɐ",
    "rollovers": "rəʊləʊvəz",
    "rolls": "rəʊlz",
    "romaine": "rɒmeɪn",
    "romanced": "rəʊmænst",
    "romancer": "rəʊmænsɐ",
    "romances": "rəʊmænsɪz",
    "romancing": "rəʊmænsɪŋ",
    "roman": "rəʊmən",
    "romantically": "rəʊmæntɪkli",
    "romantic": "rəʊmæntɪk",
    "romanticised": "rəʊmæntɪsaɪzd",
    "romanticise": "rəʊmæntɪsaɪz",
    "romanticises": "rəʊmæntɪsaɪzɪz",
    "romanticising": "rəʊmæntɪsaɪzɪŋ",
    "romanticism": "rəʊmæntɪsɪzəm",
    "romanticist": "rəʊmæntɪsɪst",
    "romantics": "rəʊmæntɪks",
    "romeo": "rəʊmɪəʊ",
    "romeos": "rəʊmɪəʊz",
    "romped": "rɒmpt",
    "romper": "rɒmpɐ",
    "rompers": "rɒmpəz",
    "romping": "rɒmpɪŋ",
    "romp": "rɒmp",
    "romps": "rɒmps",
    "rondeau": "rɒndəʊ",
    "rondelle": "rɒndɛl",
    "rondel": "rɒndəl",
    "ronde": "rɒnd",
    "rondo": "rɒndəʊ",
    "roods": "ruːdz",
    "rood": "ruːd",
    "roofed": "ruːft",
    "roofers": "ruːfəz",
    "roofer": "ruːfɐ",
    "roofing": "ruːfɪŋ",
    "roofless": "ruːfləs",
    "roofs": "ruːfs",
    "rooftops": "ruːftɒps",
    "rooftop": "ruːftɒp",
    "roof": "ruːf",
    "rooked": "rʊkt",
    "rookeries": "rʊkəriz",
    "rookery": "rʊkəri",
    "rookie": "rʊki",
    "rookies": "rʊkɪz",
    "rooking": "rʊkɪŋ",
    "rook": "rʊk",
    "rooks": "rʊks",
    "rooky": "rʊki",
    "roomed": "ruːmd",
    "roomfuls": "ruːmfəlz",
    "roomful": "ruːmfəl",
    "roomier": "ruːmɪɐ",
    "roominess": "ruːmɪnəs",
    "rooming": "ruːmɪŋ",
    "roommates": "ruːmeɪts",
    "roommate": "ruːmeɪt",
    "rooms": "ruːmz",
    "room": "ruːm",
    "roomy": "ruːmi",
    "roosted": "ruːstɪd",
    "roosters": "ruːstəz",
    "rooster": "ruːstɐ",
    "roosting": "ruːstɪŋ",
    "roosts": "ruːsts",
    "roost": "ruːst",
    "rooted": "ruːtɪd",
    "rooters": "ruːtəz",
    "rooter": "ruːtɐ",
    "rooting": "ruːtɪŋ",
    "rootlessness": "ruːtləsnəs",
    "rootless": "ruːtləs",
    "rootlets": "ruːtləts",
    "rootlike": "ruːtlaɪk",
    "rootstock": "ruːtstɒk",
    "roots": "ruːts",
    "root": "ruːt",
    "roo": "ruː",
    "roped": "rəʊpt",
    "rope": "rəʊp",
    "roper": "rəʊpɐ",
    "ropers": "rəʊpəz",
    "ropes": "rəʊps",
    "ropey": "rəʊpi",
    "roping": "rəʊpɪŋ",
    "ropy": "rəʊpi",
    "roque": "rəʊk",
    "rorqual": "rɔːkwəl",
    "rosaries": "rəʊzəriz",
    "rosary": "rəʊzəri",
    "roseate": "rəʊzeɪt",
    "rosebay": "rəʊzbeɪ",
    "rosebud": "rəʊzbʌd",
    "rosebuds": "rəʊzbʌdz",
    "rosebush": "rəʊzbʊʃ",
    "rosemary": "rəʊzməri",
    "roses": "rəʊzɪz",
    "rosette": "rəʊzɛt",
    "rosettes": "rəʊzɛts",
    "rosewater": "rəʊzwɔːtɐ",
    "rosewood": "rəʊzwʊd",
    "rosier": "rəʊzɪɐ",
    "rosiest": "rəʊzɪəst",
    "rosin": "rɒsɪn",
    "rostering": "rɒstərɪŋ",
    "rosters": "rɒstəz",
    "roster": "rɒstɐ",
    "rostra": "rɒstrɐ",
    "rostrums": "rɒstrəmz",
    "rostrum": "rɒstrəm",
    "rosy": "rəʊzi",
    "rota": "rəʊtɐ",
    "rotary": "rəʊtəri",
    "rotas": "rəʊtəz",
    "rotated": "rəʊteɪtɪd",
    "rotate": "rəʊteɪt",
    "rotates": "rəʊteɪts",
    "rotating": "rəʊteɪtɪŋ",
    "rotational": "rəʊteɪʃənəl",
    "rotation": "rəʊteɪʃən",
    "rotations": "rəʊteɪʃənz",
    "rotator": "rəʊteɪtɐ",
    "rote": "rəʊt",
    "rotgut": "rɒtɡʌt",
    "rotisserie": "rəʊtɪsəri",
    "rotor": "rəʊtɐ",
    "rotors": "rəʊtəz",
    "rots": "rɒts",
    "rot": "rɒt",
    "rotted": "rɒtɪd",
    "rottenest": "rɒtənəst",
    "rottenness": "rɒtənnəs",
    "rotten": "rɒtən",
    "rotters": "rɒtəz",
    "rotter": "rɒtɐ",
    "rotting": "rɒtɪŋ",
    "rottweilers": "rɒtweɪləz",
    "rottweiler": "rɒtweɪlɐ",
    "rotunda": "rɒtʌndɐ",
    "rotund": "rəʊtʌnd",
    "roubles": "ruːbəlz",
    "rouble": "ruːbəl",
    "rouged": "ruːʒd",
    "rouges": "ruːʒz",
    "rouge": "ruːʒ",
    "roughage": "rʌfɪdʒ",
    "roughcast": "rʌfkɑːst",
    "roughcasting": "rʌfkɑːstɪŋ",
    "roughed": "rʌfd",
    "roughened": "rʌfənd",
    "roughen": "rʌfən",
    "roughening": "rʌfənɪŋ",
    "rougher": "rʌfɐ",
    "roughest": "rʌfəst",
    "rough": "rʌf",
    "roughhouse": "rʌfhaʊs",
    "roughing": "rʌfɪŋ",
    "roughish": "rʌfɪʃ",
    "roughly": "rʌfli",
    "roughneck": "rʌfnɛk",
    "roughnecks": "rʌfnɛks",
    "roughness": "rʌfnəs",
    "roughs": "rʌfz",
    "roughshod": "rʌfʃɒd",
    "roulade": "ruːleɪd",
    "roulette": "ruːlɛt",
    "roundabout": "raʊndɐbaʊt",
    "roundabouts": "raʊndɐbaʊts",
    "round": "raʊnd",
    "rounded": "raʊndɪd",
    "roundel": "raʊndəl",
    "roundelay": "raʊndɪleɪ",
    "roundels": "raʊndəlz",
    "rounder": "raʊndɐ",
    "rounders": "raʊndəz",
    "roundest": "raʊndəst",
    "roundhouse": "raʊndhaʊs",
    "roundhouses": "raʊndhaʊzɪz",
    "rounding": "raʊndɪŋ",
    "roundish": "raʊndɪʃ",
    "roundly": "raʊndli",
    "roundness": "raʊndnəs",
    "rounds": "raʊndz",
    "roundtrip": "raʊndtrɪp",
    "roundup": "raʊndʌp",
    "roundworm": "raʊndwɜːm",
    "roundworms": "raʊndwɜːmz",
    "rouse": "raʊz",
    "roused": "raʊzd",
    "rouser": "raʊsɐ",
    "rouses": "raʊzɪz",
    "rousing": "raʊzɪŋ",
    "roustabout": "raʊstɐbaʊt",
    "roust": "raʊst",
    "rousting": "raʊstɪŋ",
    "routeing": "ruːtɪŋ",
    "routers": "ruːtəz",
    "routes": "ruːts",
    "route": "ruːt",
    "routinely": "ruːtiːnli",
    "routines": "ruːtiːnz",
    "routs": "raʊts",
    "roux": "ruː",
    "roved": "rəʊvd",
    "rove": "rəʊv",
    "rover": "rəʊvɐ",
    "rovers": "rəʊvəz",
    "roves": "rəʊvz",
    "roving": "rəʊvɪŋ",
    "rowan": "rəʊən",
    "rowans": "rəʊənz",
    "rowboat": "rəʊbəʊt",
    "rowdier": "raʊdɪɐ",
    "rowdies": "raʊdɪz",
    "rowdiest": "raʊdɪəst",
    "rowdiness": "raʊdɪnəs",
    "rowdy": "raʊdi",
    "rower": "rəʊɐ",
    "rowers": "rəʊəz",
    "rowlock": "rəʊlɒk",
    "rowlocks": "rəʊlɒks",
    "royalist": "rɔɪəlɪst",
    "royalists": "rɔɪəlɪsts",
    "royally": "rɔɪəli",
    "royal": "rɔɪəl",
    "royals": "rɔɪəlz",
    "royalties": "rɔɪəltɪz",
    "royalty": "rɔɪəlti",
    "rs": "ɑːrɛs",
    "rubato": "ruːbɑːtəʊ",
    "rub": "rʌb",
    "rubbed": "rʌbd",
    "rubber": "rʌbɐ",
    "rubberiness": "rʌbərinəs",
    "rubberised": "rʌbəraɪzd",
    "rubberneckers": "rʌbənɛkəz",
    "rubbernecking": "rʌbənɛkɪŋ",
    "rubbers": "rʌbəz",
    "rubbery": "rʌbəri",
    "rubbing": "rʌbɪŋ",
    "rubbings": "rʌbɪŋz",
    "rubbish": "rʌbɪʃ",
    "rubbished": "rʌbɪʃt",
    "rubbishes": "rʌbɪʃɪz",
    "rubbishing": "rʌbɪʃɪŋ",
    "rubbishy": "rʌbɪʃi",
    "rubble": "rʌbəl",
    "rubbly": "rʌbli",
    "rubdown": "rʌbdaʊn",
    "rubella": "ruːbɛlɐ",
    "rubel": "ruːbəl",
    "rubes": "ruːbz",
    "rube": "ruːb",
    "rubicund": "ruːbɪkʌnd",
    "rubidium": "ruːbɪdiəm",
    "rubies": "ruːbiz",
    "rubrics": "ruːbrɪks",
    "rubric": "ruːbrɪk",
    "rubs": "rʌbz",
    "ruby": "ruːbi",
    "ruched": "rʌtʃt",
    "ruche": "rʌtʃ",
    "ruching": "rʌtʃɪŋ",
    "rucked": "rʌkt",
    "rucking": "rʌkɪŋ",
    "ruck": "rʌk",
    "rucksack": "rʌksæk",
    "rucksacks": "rʌksæks",
    "rucks": "rʌks",
    "ruckus": "rʌkəs",
    "ruction": "rʌkʃən",
    "ructions": "rʌkʃənz",
    "rudbeckia": "rʌdbɛkiə",
    "rudd": "rʌd",
    "rudder": "rʌdɐ",
    "rudderless": "rʌdələs",
    "rudders": "rʌdəz",
    "ruddock": "rʌdək",
    "ruddy": "rʌdi",
    "rudely": "ruːdli",
    "rudeness": "ruːdnəs",
    "ruder": "ruːdɐ",
    "rudest": "ruːdəst",
    "rude": "ruːd",
    "rudimentary": "ruːdɪmɛntəri",
    "rudiments": "ruːdɪmənts",
    "rued": "ruːd",
    "ruefully": "ruːfəli",
    "rueful": "ruːfəl",
    "rues": "ruːz",
    "rue": "ruː",
    "ruffed": "rʌft",
    "ruff": "rʌf",
    "ruffian": "rʌfiən",
    "ruffians": "rʌfiənz",
    "ruffled": "rʌfəld",
    "ruffle": "rʌfəl",
    "ruffles": "rʌfəlz",
    "ruffling": "rʌflɪŋ",
    "ruffly": "rʌfli",
    "ruffs": "rʌfs",
    "rufiyaa": "ruːfɪjɑː",
    "rufous": "ruːfəs",
    "rug": "rʌɡ",
    "rugby": "rʌɡbi",
    "ruggedly": "rʌɡɪdli",
    "ruggedness": "rʌɡɪdnəs",
    "rugger": "rʌɡɐ",
    "rugging": "rʌɡɪŋ",
    "rugs": "rʌɡz",
    "ruination": "ruːɪneɪʃən",
    "ruined": "ruːɪnd",
    "ruing": "ruːɪŋ",
    "ruining": "ruːɪnɪŋ",
    "ruinously": "ruːɪnəsli",
    "ruinous": "ruːɪnəs",
    "ruins": "ruːɪnz",
    "ruin": "ruːɪn",
    "ruled": "ruːld",
    "rulers": "ruːləz",
    "ruler": "ruːlɐ",
    "rules": "ruːlz",
    "rule": "ruːl",
    "rulings": "ruːlɪŋz",
    "ruling": "ruːlɪŋ",
    "rumba": "rʌmbɐ",
    "rumbas": "rʌmbəz",
    "rumbled": "rʌmbəld",
    "rumble": "rʌmbəl",
    "rumbler": "rʌmblɐ",
    "rumbles": "rʌmbəlz",
    "rumbling": "rʌmblɪŋ",
    "rumblings": "rʌmblɪŋz",
    "rumbly": "rʌmbli",
    "rumbustious": "rʌmbʌsʃəs",
    "rumen": "ruːmɛn",
    "ruminants": "ruːmɪnənts",
    "ruminant": "ruːmɪnənt",
    "ruminate": "ruːmɪneɪt",
    "ruminating": "ruːmɪneɪtɪŋ",
    "ruminations": "ruːmɪneɪʃənz",
    "ruminative": "ruːmɪnətɪv",
    "rum": "rʌm",
    "rummaged": "rʌmɪdʒd",
    "rummage": "rʌmɪdʒ",
    "rummager": "rʌmɪdʒɐ",
    "rummages": "rʌmɪdʒɪz",
    "rummaging": "rʌmɪdʒɪŋ",
    "rummer": "rʌmɐ",
    "rummy": "rʌmi",
    "rumored": "ruːməd",
    "rumors": "ruːməz",
    "rumoured": "ruːməd",
    "rumours": "ruːməz",
    "rumour": "ruːmɐ",
    "rumpled": "rʌmpəld",
    "rumple": "rʌmpəl",
    "rump": "rʌmp",
    "rumps": "rʌmps",
    "rumpus": "rʌmpəs",
    "rums": "rʌmz",
    "runabout": "rʌnɐbaʊt",
    "runabouts": "rʌnɐbaʊts",
    "runaround": "rʌnɐraʊnd",
    "runaway": "rʌnəweɪ",
    "runaways": "rʌnəweɪz",
    "rundle": "rʌndəl",
    "rundown": "rʌndaʊn",
    "runes": "ruːnz",
    "rune": "ruːn",
    "rung": "rʌŋ",
    "rungs": "rʌŋz",
    "runic": "ruːnɪk",
    "run": "rʌn",
    "runnable": "rʌnəbəl",
    "runnels": "rʌnəlz",
    "runner": "rʌnɐ",
    "runners": "rʌnəz",
    "runnier": "rʌnɪɐ",
    "running": "rʌnɪŋ",
    "runny": "rʌni",
    "runoff": "rʌnɒf",
    "runs": "rʌnz",
    "runt": "rʌnt",
    "runts": "rʌnts",
    "runty": "rʌnti",
    "runway": "rʌnweɪ",
    "runways": "rʌnweɪz",
    "rupees": "ruːpiːz",
    "rupee": "ruːpiː",
    "rupiah": "ruːpaɪə",
    "ruptured": "rʌptʃəd",
    "rupture": "rʌptʃɐ",
    "ruptures": "rʌptʃəz",
    "rupturing": "rʌptʃərɪŋ",
    "rurally": "rɔːrəli",
    "rural": "rɔːrəl",
    "ruses": "ruːzɪz",
    "ruse": "ruːs",
    "rush": "rʌʃ",
    "rushed": "rʌʃt",
    "rusher": "rʌʃɐ",
    "rushers": "rʌʃəz",
    "rushes": "rʌʃɪz",
    "rushing": "rʌʃɪŋ",
    "rushy": "rʌʃi",
    "rusk": "rʌsk",
    "rusks": "rʌsks",
    "russet": "rʌsɛt",
    "russets": "rʌsɛts",
    "russety": "rʌsɪti",
    "rusted": "rʌstɪd",
    "rusticated": "rʌstɪkeɪtɪd",
    "rusticate": "rʌstɪkeɪt",
    "rusticity": "rʌstɪsɪti",
    "rustics": "rʌstɪks",
    "rustic": "rʌstɪk",
    "rustier": "rʌstɪɐ",
    "rustiness": "rʌstɪnəs",
    "rusting": "rʌstɪŋ",
    "rustled": "rʌsəld",
    "rustler": "rʌslɐ",
    "rustlers": "rʌsləz",
    "rustle": "rʌsəl",
    "rustles": "rʌsəlz",
    "rustling": "rʌslɪŋ",
    "rustlings": "rʌslɪŋz",
    "rustproof": "rʌstpruːf",
    "rusts": "rʌsts",
    "rust": "rʌst",
    "rusty": "rʌsti",
    "rutabaga": "ruːtɐbɑːɡɐ",
    "ruthenium": "ruːθiːniəm",
    "rutherfordium": "ruːðəfɔːdiəm",
    "ruthlessly": "ruːθləsli",
    "ruthlessness": "ruːθləsnəs",
    "ruthless": "ruːθləs",
    "ruths": "ruːθs",
    "ruth": "ruːθ",
    "rutile": "ruːtaɪl",
    "ruts": "rʌts",
    "rut": "rʌt",
    "rutted": "rʌtɪd",
    "rutting": "rʌtɪŋ",
    "rutty": "rʌti",
    "rya": "raɪɐ",
    "rye": "raɪ",
    "sabayon": "sæbeɪən",
    "sabbath": "sæbɑːθ",
    "sabbatical": "sɐbætɪkəl",
    "sabbaticals": "sæbætɪkəlz",
    "sabin": "sæbɪn",
    "sable": "seɪbəl",
    "sables": "seɪbəlz",
    "sabotaged": "sæbətɑːʒd",
    "sabotage": "sæbətɑːʒ",
    "sabotages": "sæbətɑːʒɪz",
    "sabotaging": "sæbətɑːʒɪŋ",
    "saboteur": "sæbətɜː",
    "saboteurs": "sæbətɜːz",
    "sabot": "sæbɒt",
    "sabots": "sæbɒts",
    "sabra": "sæbrɐ",
    "sabre": "seɪbɐ",
    "sabres": "seɪbəz",
    "saccharine": "sækərɪn",
    "saccharin": "sækərɪn",
    "sachet": "sæʃeɪ",
    "sachets": "sæʃeɪs",
    "sackbut": "sækbʌt",
    "sackcloth": "sækklɒθ",
    "sacked": "sækt",
    "sacker": "sækɐ",
    "sackful": "sækfəl",
    "sackfuls": "sækfəlz",
    "sacking": "sækɪŋ",
    "sackings": "sækɪŋz",
    "sack": "sæk",
    "sacks": "sæks",
    "sacral": "sækrəl",
    "sacramental": "sækrəmɛntəl",
    "sacrament": "sækrəmənt",
    "sacraments": "sækrəmənts",
    "sacra": "sækrɐ",
    "sacredly": "sækrɪdli",
    "sacredness": "seɪkrədnəs",
    "sacred": "seɪkrəd",
    "sacrificed": "sækrɪfaɪst",
    "sacrifice": "sækrɪfaɪs",
    "sacrifices": "sækrɪfaɪsɪz",
    "sacrificial": "sækrɪfɪʃəl",
    "sacrificing": "sækrɪfaɪsɪŋ",
    "sacrilege": "sækrɪlɪdʒ",
    "sacrilegious": "sækrɪlɪdʒəs",
    "sacristan": "sækrɪstæn",
    "sacristy": "sækrɪsti",
    "sacrosanct": "sækrəsɑːnkt",
    "sacrum": "seɪkrəm",
    "sac": "sæk",
    "sacs": "sæks",
    "saddened": "sædənd",
    "saddening": "sædənɪŋ",
    "sadden": "sædən",
    "saddens": "sædənz",
    "sadder": "sædɐ",
    "saddest": "sædəst",
    "saddleback": "sædəlbæk",
    "saddlebacks": "sædəlbæks",
    "saddlebag": "sædəlbæɡ",
    "saddlebags": "sædəlbæɡz",
    "saddled": "sædəld",
    "saddler": "sædlɐ",
    "saddlers": "sædləz",
    "saddlery": "sædəlri",
    "saddle": "sædəl",
    "saddles": "sædəlz",
    "saddling": "sædlɪŋ",
    "sades": "seɪdz",
    "sadhu": "sædhuː",
    "sadhus": "sædhəs",
    "sadism": "seɪdɪzəm",
    "sadistically": "sɐdɪstɪkli",
    "sadistic": "sɐdɪstɪk",
    "sadist": "seɪdɪst",
    "sadists": "seɪdɪsts",
    "sadly": "sædli",
    "sadness": "sædnəs",
    "sadomasochism": "seɪdəʊmæsəkɪzəm",
    "sadomasochistic": "seɪdəʊmæsəkɪstɪk",
    "sad": "sæd",
    "safari": "sɐfɑːri",
    "safaris": "sæfɑːrɪs",
    "safecracker": "seɪfkrækɐ",
    "safeguarded": "seɪfɡɑːdɪd",
    "safeguarding": "seɪfɡɑːdɪŋ",
    "safeguard": "seɪfɡɑːd",
    "safeguards": "seɪfɡɑːdz",
    "safekeeping": "seɪfkiːpɪŋ",
    "safelight": "seɪflaɪt",
    "safely": "seɪfli",
    "safeness": "seɪfnəs",
    "safer": "seɪfɐ",
    "safe": "seɪf",
    "safes": "seɪfs",
    "safest": "seɪfəst",
    "safeties": "seɪftiz",
    "safety": "seɪfti",
    "safflower": "sæflaʊɐ",
    "saffron": "sæfrɒn",
    "saffrons": "sæfrɒnz",
    "sagacious": "sæɡeɪʃəs",
    "sagacity": "sæɡæsɪti",
    "saga": "sɑːɡɐ",
    "sagas": "sɑːɡəz",
    "sagebrush": "seɪdʒbrʌʃ",
    "sagely": "seɪdʒli",
    "sager": "seɪdʒɐ",
    "sage": "seɪdʒ",
    "sages": "seɪdʒɪz",
    "sagged": "sæɡd",
    "sagging": "sæɡɪŋ",
    "saggy": "sæɡi",
    "sagittal": "sædʒɪtəl",
    "sago": "seɪɡəʊ",
    "sag": "sæɡ",
    "sags": "sæɡz",
    "saguaro": "sæɡærəʊ",
    "sahib": "sæhɪb",
    "sahibs": "sæhɪbz",
    "said": "sɛd",
    "saiga": "seɪɡɐ",
    "sailboat": "seɪlbəʊt",
    "sailboats": "seɪlbəʊts",
    "sailcloth": "seɪlklɒθ",
    "sailed": "seɪld",
    "sailer": "seɪlɐ",
    "sailfish": "seɪlfɪʃ",
    "sailing": "seɪlɪŋ",
    "sailings": "seɪlɪŋz",
    "sailor": "seɪlɐ",
    "sailors": "seɪləz",
    "sail": "seɪl",
    "sails": "seɪlz",
    "sainted": "seɪntɪd",
    "sainthood": "seɪnthʊd",
    "saintliness": "seɪntlinəs",
    "saintly": "seɪntli",
    "saint": "seɪnt",
    "saints": "seɪnts",
    "saith": "seɪθ",
    "saker": "seɪkɐ",
    "sakes": "seɪks",
    "saki": "sæki",
    "sakis": "sækiz",
    "salaam": "sælɑːm",
    "salaciousness": "sæleɪʃəsnəs",
    "salacious": "sæleɪʃəs",
    "salade": "sæleɪd",
    "salad": "sæləd",
    "salads": "sælədz",
    "salamander": "sælɐmɑːndɐ",
    "salamanders": "sælɐmɑːndəz",
    "salami": "sɐlɑːmi",
    "salamis": "sɐlɑːmiz",
    "salaried": "sælərid",
    "salaries": "sæləriz",
    "salary": "sæləri",
    "saleability": "seɪləbɪlɪti",
    "saleable": "seɪləbəl",
    "saleroom": "seɪlruːm",
    "salerooms": "seɪlruːmz",
    "sale": "seɪl",
    "salesgirl": "seɪlsɡɜːl",
    "saleslady": "seɪlsleɪdi",
    "salesman": "seɪlzmən",
    "salesmanship": "seɪlzmənʃɪp",
    "salesmen": "seɪlzmɛn",
    "salespeople": "seɪlspiːpəl",
    "salesperson": "seɪlspəsən",
    "salesroom": "seɪlsruːm",
    "sales": "seɪlz",
    "saleswoman": "seɪlswʊmən",
    "salicin": "sælɪsɪn",
    "salicylate": "sælɪsɪleɪt",
    "salicylic": "sælɪsɪlɪk",
    "salience": "seɪliəns",
    "salient": "seɪliənt",
    "salina": "seɪliːnɐ",
    "saline": "seɪlaɪn",
    "salinity": "seɪlɪnɪti",
    "salivary": "sælɪvəri",
    "saliva": "sɐlaɪvɐ",
    "salivated": "sælɪveɪtɪd",
    "salivate": "sælɪveɪt",
    "salivates": "sælɪveɪts",
    "salivating": "sælɪveɪtɪŋ",
    "salivation": "sælɪveɪʃən",
    "sallet": "sælɪt",
    "sallied": "sælid",
    "sallies": "sæliz",
    "sallow": "sæləʊ",
    "sally": "sæli",
    "salmagundi": "sælmɐɡʌndi",
    "salmonella": "sælməʊnɛlɐ",
    "salmon": "sæmən",
    "salmons": "sæmənz",
    "salon": "sælɒn",
    "salons": "sælɒnz",
    "saloon": "sɐluːn",
    "saloons": "sɐluːnz",
    "sal": "sæl",
    "salsa": "sælsɐ",
    "salsas": "sælsəz",
    "salsify": "sælsɪfaɪ",
    "saltation": "sɒlteɪʃən",
    "salted": "sɒltɪd",
    "salter": "sɒltɐ",
    "saltier": "sɒltɪɐ",
    "saltiest": "sɒltɪəst",
    "saltine": "sɒltiːn",
    "saltines": "sɒltiːnz",
    "saltiness": "sɒltɪnəs",
    "salting": "sɒltɪŋ",
    "saltire": "sɒltaɪə",
    "saltires": "sɒltaɪəz",
    "saltpetre": "sɒltpɛtɐ",
    "salt": "sɒlt",
    "salts": "sɒlts",
    "saltwater": "sɒltwɔːtɐ",
    "saltworks": "sɒltwɜːks",
    "salty": "sɒlti",
    "salubrious": "sæluːbrɪəs",
    "salutary": "sæluːtəri",
    "salutation": "sæluːteɪʃən",
    "salutations": "sæluːteɪʃənz",
    "saluted": "səluːtɪd",
    "salute": "səluːt",
    "salutes": "səluːts",
    "saluting": "səluːtɪŋ",
    "salvageable": "sælvɪdʒəbəl",
    "salvaged": "sælvɪdʒd",
    "salvage": "sælvɪdʒ",
    "salvages": "sælvɪdʒɪz",
    "salvaging": "sælvɪdʒɪŋ",
    "salvation": "sælveɪʃən",
    "salved": "sælvd",
    "salver": "sælvɐ",
    "salvers": "sælvəz",
    "salves": "sælvz",
    "salvia": "sælviɐ",
    "salvias": "sælviəz",
    "salving": "sælvɪŋ",
    "salvoes": "sælvəʊz",
    "salvo": "sælvəʊ",
    "salvos": "sælvəʊz",
    "samaritan": "sɐmærɪtən",
    "samarium": "sɐmeəriəm",
    "sambaing": "sæmbeɪŋ",
    "sambar": "sæmbɑː",
    "samba": "sæmbɐ",
    "sambas": "sæmbəz",
    "sambo": "sæmbəʊ",
    "sameness": "seɪmnəs",
    "same": "seɪm",
    "samey": "seɪmi",
    "samizdat": "sæmɪzdæt",
    "samosa": "sæməʊsɐ",
    "samosas": "sæməʊsəz",
    "samovar": "sæmuːvɑː",
    "samovars": "sæmuːvɑːz",
    "sampan": "sæmpæn",
    "sampans": "sæmpænz",
    "samphire": "sæmfaɪə",
    "sampled": "sɑːmpəld",
    "sampler": "sɑːmplɐ",
    "samplers": "sɑːmpləz",
    "sample": "sɑːmpəl",
    "samples": "sɑːmpəlz",
    "sampling": "sɑːmplɪŋ",
    "samsara": "sæmsɑːrɐ",
    "samurai": "sæmjʊraɪ",
    "sanatorium": "sænɐtɔːriəm",
    "sancta": "sɑːnktɐ",
    "sanctification": "sɑːnktɪfɪkeɪʃən",
    "sanctified": "sɑːnktɪfaɪd",
    "sanctifies": "sɑːnktɪfaɪz",
    "sanctifying": "sɑːnktɪfaɪɪŋ",
    "sanctify": "sɑːnktɪfaɪ",
    "sanctimonious": "sɑːnktɪməʊnɪəs",
    "sanctimony": "sɑːnktɪməni",
    "sanctioned": "sɑːnkʃənd",
    "sanctioning": "sɑːnkʃənɪŋ",
    "sanction": "sɑːnkʃən",
    "sanctions": "sɑːnkʃənz",
    "sanctity": "sɑːnktɪti",
    "sanctuaries": "sɑːnktjuːəriz",
    "sanctuary": "sɑːnktjuːəri",
    "sanctum": "sɑːnktəm",
    "sanctums": "sɑːnktəmz",
    "sandalled": "sændəld",
    "sandal": "sændəl",
    "sandals": "sændəlz",
    "sandalwood": "sændəlwʊd",
    "sandbagged": "sændbæɡd",
    "sandbagging": "sændbæɡɪŋ",
    "sandbag": "sændbæɡ",
    "sandbags": "sændbæɡz",
    "sandbank": "sændbæŋk",
    "sandbanks": "sændbæŋks",
    "sandbar": "sændbɑː",
    "sandbars": "sændbɑːz",
    "sandblasted": "sændblɑːstɪd",
    "sandblasting": "sændblɑːstɪŋ",
    "sandblast": "sændblɑːst",
    "sandbox": "sændbɒks",
    "sandcastle": "sændkɑːsəl",
    "sandcastles": "sændkɑːsəlz",
    "sanded": "sændɪd",
    "sander": "sændɐ",
    "sanders": "sændəz",
    "sandflies": "sændflaɪz",
    "sandier": "sændɪɐ",
    "sanding": "sændɪŋ",
    "sandman": "sændmən",
    "sandmen": "sændmɛn",
    "sandpapered": "sændpeɪpəd",
    "sandpaper": "sændpeɪpɐ",
    "sandpiper": "sændpɪpɐ",
    "sandpipers": "sændpɪpəz",
    "sandpit": "sændpɪt",
    "sandpits": "sændpɪts",
    "sand": "sænd",
    "sands": "sændz",
    "sandstone": "sændstəʊn",
    "sandstones": "sændstəʊnz",
    "sandstorm": "sændstɔːm",
    "sandstorms": "sændstɔːmz",
    "sandwiched": "sændwɪtʃt",
    "sandwiches": "sændwɪtʃɪz",
    "sandwiching": "sændwɪtʃɪŋ",
    "sandwich": "sændwɪtʃ",
    "sandy": "sændi",
    "sanely": "seɪnli",
    "saner": "seɪnɐ",
    "sane": "seɪn",
    "sanest": "seɪnəst",
    "sangfroid": "sæŋfrɔɪd",
    "sangria": "sæŋɡriɐ",
    "sang": "sæŋ",
    "sangs": "sæŋz",
    "sanguinary": "sæŋɡwɪnəri",
    "sanguine": "sæŋɡwɪn",
    "sanitarium": "sænɪteəriəm",
    "sanitary": "sænɪtəri",
    "sanitation": "sænɪteɪʃən",
    "sanitised": "sænɪtaɪzd",
    "sanitiser": "sænɪtaɪzɐ",
    "sanitise": "sænɪtaɪz",
    "sanitising": "sænɪtaɪzɪŋ",
    "sanity": "sænɪti",
    "sank": "sæŋk",
    "sans": "sænz",
    "sapling": "sæplɪŋ",
    "saplings": "sæplɪŋz",
    "sapodilla": "sæpədɪlɐ",
    "saponification": "sæpənɪfɪkeɪʃən",
    "saponin": "sæpənɪn",
    "sapped": "sæpt",
    "sapper": "sæpɐ",
    "sappers": "sæpəz",
    "sapphic": "sæfɪk",
    "sapphire": "sæfaɪə",
    "sapphires": "sæfaɪəz",
    "sapping": "sæpɪŋ",
    "sappy": "sæpi",
    "sap": "sæp",
    "saps": "sæps",
    "sapwood": "sæpwʊd",
    "saran": "særən",
    "sarcasm": "sɑːkæzəm",
    "sarcasms": "sɑːkæzəmz",
    "sarcastically": "sɑːkɑːstɪkli",
    "sarcastic": "sɑːkɑːstɪk",
    "sarcoid": "sɑːkɔɪd",
    "sarcoma": "sɑːkəʊmɐ",
    "sarcophagi": "sɑːkɒfəɡaɪ",
    "sarcophaguses": "sɑːkɒfəɡjuːsɪz",
    "sarcophagus": "sɑːkɒfəɡəs",
    "sardines": "sɑːdiːnz",
    "sardonically": "sɑːdɒnɪkli",
    "sardonic": "sɑːdɒnɪk",
    "sardonyx": "sɑːdənɪks",
    "sard": "sɑːd",
    "sards": "sɑːdz",
    "sargasso": "sɑːɡæsəʊ",
    "sargassum": "sɑːɡəʃəm",
    "sarge": "sɑːdʒ",
    "sari": "sɑːri",
    "saris": "sɑːrɪs",
    "sarky": "sɑːki",
    "sarnie": "sɑːni",
    "sarnies": "sɑːnɪz",
    "sarong": "særɒŋ",
    "sarongs": "særɒŋz",
    "saros": "særəʊz",
    "sarracenia": "særeɪsiːniə",
    "sarsaparilla": "sɑːsɐpɐrɪlɐ",
    "sarsen": "sɑːsən",
    "sartorially": "sɑːtɔːrɪəli",
    "sartorial": "sɑːtɔːrɪəl",
    "sartorius": "sɑːtɔːrɪəs",
    "sashayed": "sæʃeɪd",
    "sashaying": "sæʃeɪɪŋ",
    "sashay": "sæʃeɪ",
    "sashays": "sæʃeɪz",
    "sashes": "sæʃɪz",
    "sash": "sæʃ",
    "saskatoon": "sɑːskɐtuːn",
    "sassafras": "sæsɐfræs",
    "sassing": "sæsɪŋ",
    "sass": "sæs",
    "sassy": "sæsi",
    "satang": "seɪtəŋ",
    "satanic": "sɐtænɪk",
    "satanism": "seɪtənɪzəm",
    "satanist": "seɪtənɪst",
    "satanists": "seɪtənɪsts",
    "satay": "sæteɪ",
    "satchel": "sætʃəl",
    "satchels": "sætʃəlz",
    "sated": "seɪtɪd",
    "satellite": "sætəlaɪt",
    "satellites": "sætəlaɪts",
    "sate": "seɪt",
    "sates": "seɪts",
    "satiated": "seɪʃɪeɪtɪd",
    "satiate": "seɪʃɪeɪt",
    "satiation": "seɪʃɪeɪʃən",
    "satiety": "sætaɪəti",
    "sating": "seɪtɪŋ",
    "satin": "sætɪn",
    "satins": "sætɪnz",
    "satinwood": "sætɪnwʊd",
    "satiny": "sætɪni",
    "satire": "sætaɪə",
    "satires": "sætaɪəz",
    "satirically": "sɐtɪrɪkli",
    "satirical": "sɐtɪrɪkəl",
    "satiric": "sɐtɪrɪk",
    "satirised": "sætɪraɪzd",
    "satirise": "sætɪraɪz",
    "satirises": "sætɪraɪzɪz",
    "satirising": "sætɪraɪzɪŋ",
    "satirist": "sætɪrɪst",
    "satirists": "sætɪrɪsts",
    "sati": "sæti",
    "satisfaction": "sætɪsfækʃən",
    "satisfactions": "sætɪsfækʃənz",
    "satisfactorily": "sætɪsfæktərəli",
    "satisfactory": "sætɪsfæktəri",
    "satisfied": "sætɪsfaɪd",
    "satisfies": "sætɪsfaɪz",
    "satisfyingly": "sætɪsfaɪɪŋli",
    "satisfying": "sætɪsfaɪɪŋ",
    "satisfy": "sætɪsfaɪ",
    "sat": "sæt",
    "satsuma": "sætsuːmɐ",
    "satsumas": "sætsuːməz",
    "saturated": "sætʃəreɪtɪd",
    "saturate": "sætʃəreɪt",
    "saturates": "sætʃəreɪts",
    "saturating": "sætʃəreɪtɪŋ",
    "saturation": "sætʃəreɪʃən",
    "saturnalia": "sætəneɪliə",
    "saturnine": "sætənaɪn",
    "satyagraha": "sætɪɐɡrɑːhɐ",
    "satyr": "sætɐ",
    "satyrs": "sætəz",
    "sauced": "sɔːst",
    "saucepan": "sɔːspən",
    "saucepans": "sɔːspənz",
    "saucer": "sɔːsɐ",
    "saucers": "sɔːsəz",
    "sauce": "sɔːs",
    "sauces": "sɔːsɪz",
    "sauciest": "sɔːsɪəst",
    "sauciness": "sɔːsɪnɛs",
    "saucing": "sɔːsɪŋ",
    "saucy": "sɔːsi",
    "sauerbraten": "saʊəbreɪtən",
    "sauerkraut": "saʊəkraʊt",
    "sauna": "sɔːnɐ",
    "saunas": "sɔːnəz",
    "sauntered": "sɔːntəd",
    "sauntering": "sɔːntərɪŋ",
    "saunter": "sɔːntɐ",
    "saunters": "sɔːntəz",
    "saurian": "sɔːriən",
    "sauropod": "sɔːrəpɒd",
    "sauropods": "sɔːrəpɒdz",
    "sausage": "sɒsɪdʒ",
    "sausages": "sɒsɪdʒɪz",
    "sauted": "sɔːteɪɪd",
    "sauterne": "sɔːtən",
    "sauternes": "sɔːtənz",
    "savaged": "sævɪdʒd",
    "savagely": "sævɪdʒli",
    "savagery": "sævɪdʒri",
    "savage": "sævɪdʒ",
    "savages": "sævɪdʒɪz",
    "savaging": "sævɪdʒɪŋ",
    "savannahs": "sɐvænəz",
    "savannah": "sɐvænɐ",
    "savanna": "sævænɐ",
    "savannas": "sævænəz",
    "savant": "sævənt",
    "savants": "sævənts",
    "savarin": "sævərɪn",
    "saveable": "seɪvəbəl",
    "saved": "seɪvd",
    "saveloy": "seɪvlɔɪ",
    "saver": "seɪvɐ",
    "savers": "seɪvəz",
    "save": "seɪv",
    "saves": "seɪvz",
    "saving": "seɪvɪŋ",
    "savings": "seɪvɪŋz",
    "saviour": "seɪvjɐ",
    "saviours": "seɪvjəz",
    "savory": "seɪvəri",
    "savoured": "seɪvəd",
    "savouries": "seɪvɜːrɪz",
    "savouriness": "seɪvərɪnəs",
    "savouring": "seɪvɜːrɪŋ",
    "savour": "seɪvɐ",
    "savours": "seɪvəz",
    "savoury": "seɪvɜːri",
    "savoys": "sɐvɔɪz",
    "savoy": "sɐvɔɪ",
    "savvier": "sævɪɐ",
    "savvy": "sævi",
    "sawbones": "sɔːbəʊnz",
    "sawbuck": "sɔːbʌk",
    "sawdust": "sɔːdʌst",
    "sawed": "sɔːd",
    "sawer": "sæwɐ",
    "sawfish": "sɔːfɪʃ",
    "sawflies": "sɔːflaɪz",
    "sawfly": "sɔːflaɪ",
    "sawing": "sɔːrɪŋ",
    "sawmill": "sɔːmɪl",
    "sawmills": "sɔːmɪlz",
    "sawn": "sɔːn",
    "saw": "sɔː",
    "saws": "sɔːz",
    "sawtooth": "sɔːtuːθ",
    "sawyer": "sɔɪɐ",
    "sawyers": "sɔɪəz",
    "saxes": "sæksɪz",
    "saxifrage": "sæksɪfrɪdʒ",
    "saxifrages": "sæksɪfrɪdʒɪz",
    "saxophone": "sæksəfəʊn",
    "saxophones": "sæksəfəʊnz",
    "saxophonist": "sæksɒfənɪst",
    "saxophonists": "sæksɒfənɪsts",
    "sax": "sæks",
    "sayer": "seɪɐ",
    "saying": "seɪɪŋ",
    "sayings": "seɪɪŋz",
    "sayonara": "saɪənɑːrɐ",
    "say": "seɪ",
    "says": "sɛz",
    "scabbard": "skæbəd",
    "scabbards": "skæbədz",
    "scabbed": "skæbd",
    "scabbing": "skæbɪŋ",
    "scabby": "skæbi",
    "scabies": "skeɪbɪz",
    "scabious": "skæbɪəs",
    "scabrous": "skæbrəs",
    "scab": "skæb",
    "scabs": "skæbz",
    "scad": "skæd",
    "scads": "skædz",
    "scaffolding": "skæfəʊldɪŋ",
    "scaffold": "skæfəʊld",
    "scaffolds": "skæfəʊldz",
    "scag": "skæɡ",
    "scalability": "skeɪləbɪlɪti",
    "scalable": "skeɪləbəl",
    "scalded": "skɒldɪd",
    "scalding": "skɒldɪŋ",
    "scald": "skɒld",
    "scalds": "skɒldz",
    "scaled": "skeɪld",
    "scalene": "skeɪliːn",
    "scaler": "skeɪlɐ",
    "scale": "skeɪl",
    "scales": "skeɪlz",
    "scaling": "skeɪlɪŋ",
    "scallion": "skæliən",
    "scallions": "skæliənz",
    "scalloped": "skæləpd",
    "scalloping": "skæləpɪŋ",
    "scallop": "skæləp",
    "scallops": "skæləps",
    "scallywag": "skɔːlɪwæɡ",
    "scallywags": "skɔːlɪwæɡz",
    "scalped": "skælpt",
    "scalpel": "skælpəl",
    "scalpels": "skælpəlz",
    "scalpers": "skælpəz",
    "scalping": "skælpɪŋ",
    "scalp": "skælp",
    "scalps": "skælps",
    "scaly": "skeɪli",
    "scammed": "skæmd",
    "scamming": "skæmɪŋ",
    "scampered": "skæmpəd",
    "scampering": "skæmpərɪŋ",
    "scamper": "skæmpɐ",
    "scampers": "skæmpəz",
    "scampi": "skæmpi",
    "scamp": "skæmp",
    "scamps": "skæmps",
    "scam": "skæm",
    "scams": "skæmz",
    "scandalised": "skændəlaɪzd",
    "scandalise": "skændəlaɪz",
    "scandalises": "skændəlaɪzɪz",
    "scandalising": "skændəlaɪzɪŋ",
    "scandalously": "skændələsli",
    "scandalous": "skændələs",
    "scandal": "skændəl",
    "scandals": "skændəlz",
    "scandium": "skændiəm",
    "scanned": "skænd",
    "scanner": "skænɐ",
    "scanners": "skænəz",
    "scanning": "skænɪŋ",
    "scansion": "skænʃən",
    "scan": "skæn",
    "scans": "skænz",
    "scanties": "skɑːntɪz",
    "scantily": "skɑːntɪli",
    "scant": "skɑːnt",
    "scants": "skɑːnts",
    "scanty": "skɑːnti",
    "scapegoated": "skeɪpɡəʊtɪd",
    "scapegoating": "skeɪpɡəʊtɪŋ",
    "scapegoat": "skeɪpɡəʊt",
    "scapegoats": "skeɪpɡəʊts",
    "scape": "skeɪp",
    "scapes": "skeɪps",
    "scaphoid": "skæfɔɪd",
    "scapulae": "skæpjʊliː",
    "scapular": "skæpjʊlɐ",
    "scapula": "skæpjʊlɐ",
    "scarab": "skæræb",
    "scaramouch": "skærɐmaʊtʃ",
    "scarcely": "skeəsli",
    "scarcer": "skeəsɐ",
    "scarce": "skeəs",
    "scarcest": "skeəsəst",
    "scarcity": "skeəsɪti",
    "scarecrow": "skeəkrəʊ",
    "scarecrows": "skeəkrəʊz",
    "scared": "skeəd",
    "scaremongering": "skeəməŋɡərɪŋ",
    "scaremonger": "skeəmʌŋɡɐ",
    "scaremongers": "skeəmʌŋɡəz",
    "scare": "skeə",
    "scares": "skeəz",
    "scarf": "skɑːf",
    "scarfs": "skɑːfs",
    "scarier": "skeəriɐ",
    "scariest": "skeəriəst",
    "scarified": "skærɪfaɪd",
    "scarifying": "skærɪfaɪɪŋ",
    "scarify": "skærɪfaɪ",
    "scarily": "skeərili",
    "scariness": "skeərinəs",
    "scaring": "skeərɪŋ",
    "scarlatina": "skɑːlɐtiːnɐ",
    "scarlet": "skɑːlət",
    "scarpered": "skɑːpəd",
    "scarpering": "skɑːpərɪŋ",
    "scarper": "skɑːpɐ",
    "scarpers": "skɑːpəz",
    "scarp": "skɑːp",
    "scarred": "skɑːd",
    "scarring": "skɑːrɪŋ",
    "scar": "skɑː",
    "scars": "skɑːz",
    "scarves": "skɑːvz",
    "scary": "skeəri",
    "scathe": "skeɪð",
    "scathingly": "skeɪðɪŋli",
    "scathing": "skeɪðɪŋ",
    "scatological": "skætəlɒdʒɪkəl",
    "scat": "skæt",
    "scats": "skæts",
    "scatterbrained": "skætəbreɪnd",
    "scatterbrain": "skætəbreɪn",
    "scatterbrains": "skætəbreɪnz",
    "scattered": "skætəd",
    "scattering": "skætərɪŋ",
    "scatter": "skætɐ",
    "scatters": "skætəz",
    "scatting": "skætɪŋ",
    "scatty": "skæti",
    "scavenged": "skævəndʒd",
    "scavenger": "skævɪndʒɐ",
    "scavengers": "skævɪndʒəz",
    "scavenge": "skævəndʒ",
    "scavenges": "skævəndʒɪz",
    "scavenging": "skævɪndʒɪŋ",
    "scenario": "sənɑːriəʊ",
    "scenarios": "sənɑːriəʊz",
    "scending": "sɛndɪŋ",
    "scenery": "siːnəri",
    "scene": "siːn",
    "scenes": "siːnz",
    "scenic": "siːnɪk",
    "scented": "sɛntɪd",
    "scenting": "sɛntɪŋ",
    "scentless": "sɛntləs",
    "scent": "sɛnt",
    "scents": "sɛnts",
    "sceptically": "skɛptɪkli",
    "sceptical": "skɛptɪkəl",
    "scepticism": "skɛptɪsɪzəm",
    "sceptic": "skɛptɪk",
    "sceptics": "skɛptɪks",
    "sceptred": "skɛptəd",
    "sceptre": "sɛptɐ",
    "sceptres": "sɛptəz",
    "schadenfreude": "ʃædənfrɔɪd",
    "scheduled": "ʃɛdjuːld",
    "schedule": "ʃɛdjuːl",
    "scheduler": "ʃɛdjʊlɐ",
    "schedulers": "ʃɛdjʊləz",
    "schedules": "ʃɛdjuːlz",
    "scheduling": "ʃɛdjuːlɪŋ",
    "schema": "skiːmɐ",
    "schematic": "skiːmætɪk",
    "schematics": "skiːmætɪks",
    "schematised": "skiːmɐtaɪzd",
    "schemed": "skiːmd",
    "schemer": "skiːmɐ",
    "schemers": "skiːməz",
    "scheme": "skiːm",
    "schemes": "skiːmz",
    "scheming": "skiːmɪŋ",
    "scherzo": "ʃɜːzəʊ",
    "schiller": "ʃɪlɐ",
    "schilling": "ʃɪlɪŋ",
    "schillings": "ʃɪlɪŋz",
    "schismatic": "skɪsmætɪk",
    "schism": "skɪzəm",
    "schisms": "skɪzəmz",
    "schistosomiasis": "ʃɪstəsəʊmɪæsiz",
    "schist": "ʃɪst",
    "schizoid": "skɪtsɔɪd",
    "schizophrenia": "skɪtsəfriːniə",
    "schizophrenic": "skɪtsəfrɛnɪk",
    "schizophrenics": "skɪtsəfrɛnɪks",
    "schizo": "skɪtsəʊ",
    "schlep": "ʃlɛp",
    "schlepped": "ʃlɛpt",
    "schlepping": "ʃlɛpɪŋ",
    "schlock": "ʃlɒk",
    "schmaltz": "ʃmælts",
    "schmaltzy": "ʃmæltsi",
    "schmoe": "ʃməʊ",
    "schmoozed": "ʃmuːzd",
    "schmooze": "ʃmuːz",
    "schmoozer": "ʃmuːzɐ",
    "schmoozers": "ʃmuːzəz",
    "schmoozing": "ʃmuːzɪŋ",
    "schmuck": "ʃmʌk",
    "schmucks": "ʃmʌks",
    "schnapps": "ʃnæps",
    "schnauzer": "ʃnɔːzɐ",
    "schnauzers": "ʃnɔːzəz",
    "schnitzel": "ʃnɪtsəl",
    "schnitzels": "ʃnɪtsəlz",
    "schnoz": "ʃnɒz",
    "schnozzle": "ʃnɒzəl",
    "scholarly": "skɒləli",
    "scholarship": "skɒləʃɪp",
    "scholarships": "skɒləʃɪps",
    "scholar": "skɒlɐ",
    "scholars": "skɒləz",
    "scholasticism": "skəlɑːstɪsɪzəm",
    "scholastic": "skəlɑːstɪk",
    "schoolbag": "skuːlbæɡ",
    "schoolbags": "skuːlbæɡz",
    "schoolbook": "skuːlbʊk",
    "schoolbooks": "skuːlbʊks",
    "schoolboy": "skuːlbɔɪ",
    "schoolboys": "skuːlbɔɪz",
    "schoolchildren": "skuːltʃɪldrən",
    "schoolchild": "skuːltʃaɪld",
    "schooldays": "skuːldeɪz",
    "schooled": "skuːld",
    "schoolfellows": "skuːlfɪləʊz",
    "schoolfriend": "skuːlfrɛnd",
    "schoolgirl": "skuːlɡɜːl",
    "schoolgirls": "skuːlɡɜːlz",
    "schoolhouse": "skuːlhaʊs",
    "schoolhouses": "skuːlhaʊzɪz",
    "schooling": "skuːlɪŋ",
    "schoolkid": "skuːlkɪd",
    "schoolkids": "skuːlkɪdz",
    "schoolmarm": "skuːlmɑːm",
    "schoolmaster": "skuːlmɑːstɐ",
    "schoolmasters": "skuːlmɑːstəz",
    "schoolmate": "skuːlmeɪt",
    "schoolmates": "skuːlmeɪts",
    "schoolmistresses": "skuːlmɪstrəsɪz",
    "schoolmistress": "skuːlmɪstrəs",
    "schoolroom": "skuːlruːm",
    "schoolrooms": "skuːlruːmz",
    "school": "skuːl",
    "schools": "skuːlz",
    "schoolteacher": "skuːltiːtʃɐ",
    "schoolteachers": "skuːltiːtʃəz",
    "schoolwork": "skuːlwɜːk",
    "schoolyard": "skuːljɑːd",
    "schoolyards": "skuːljɑːdz",
    "schooner": "skuːnɐ",
    "schooners": "skuːnəz",
    "schtick": "ʃtɪk",
    "schuss": "ʃʌs",
    "schwa": "ʃwɑː",
    "sciatica": "saɪætɪkɐ",
    "sciatic": "saɪətɪk",
    "science": "saɪəns",
    "sciences": "saɪənsɪz",
    "scientifically": "saɪəntɪfɪkli",
    "scientific": "saɪəntɪfɪk",
    "scientist": "saɪəntɪst",
    "scientists": "saɪəntɪsts",
    "scilla": "sɪlɐ",
    "scimitar": "sɪmɪtɐ",
    "scimitars": "sɪmɪtəz",
    "scintilla": "sɪntɪlɐ",
    "scintillated": "sɪntɪleɪtɪd",
    "scintillate": "sɪntɪleɪt",
    "scintillating": "sɪntɪleɪtɪŋ",
    "scintillation": "sɪntɪleɪʃən",
    "scion": "sɪɒn",
    "scions": "sɪɒnz",
    "scirocco": "sɪrɒkəʊ",
    "scission": "sɪʃən",
    "scissored": "sɪsəd",
    "scissoring": "sɪsərɪŋ",
    "scissor": "sɪsɐ",
    "scissors": "sɪsəz",
    "sclera": "skliər",
    "sclerosis": "sklərəʊsɪs",
    "sclerotic": "sklərɒtɪk",
    "scoffed": "skɒft",
    "scoffer": "skɒfɐ",
    "scoffing": "skɒfɪŋ",
    "scoff": "skɒf",
    "scoffs": "skɒfs",
    "scolded": "skəʊldɪd",
    "scolding": "skəʊldɪŋ",
    "scold": "skəʊld",
    "scolds": "skəʊldz",
    "scoliosis": "skəʊlɪəʊsɪs",
    "scollops": "skɒləps",
    "sconce": "skɒns",
    "sconces": "skɒnsɪz",
    "scones": "skəʊnz",
    "scooped": "skuːpt",
    "scooper": "skuːpɐ",
    "scoopful": "skuːpfəl",
    "scooping": "skuːpɪŋ",
    "scoop": "skuːp",
    "scoops": "skuːps",
    "scooted": "skuːtɪd",
    "scooter": "skuːtɐ",
    "scooters": "skuːtəz",
    "scooting": "skuːtɪŋ",
    "scoot": "skuːt",
    "scoots": "skuːts",
    "scoped": "skəʊpd",
    "scope": "skəʊp",
    "scopes": "skəʊps",
    "scoping": "skəʊpɪŋ",
    "scorbutic": "skɔːbjuːtɪk",
    "scorched": "skɔːtʃt",
    "scorcher": "skɔːtʃɐ",
    "scorches": "skɔːtʃɪz",
    "scorching": "skɔːtʃɪŋ",
    "scorch": "skɔːtʃ",
    "scoreboard": "skɔːbɔːd",
    "scoreboards": "skɔːbɔːdz",
    "scorecard": "skɔːkɑːd",
    "scorecards": "skɔːkɑːdz",
    "scored": "skɔːd",
    "scorekeeper": "skɔːkiːpɐ",
    "scoreless": "skɔːləs",
    "scoreline": "skɔːlaɪn",
    "scorelines": "skɔːlaɪnz",
    "scorer": "skɔːrɐ",
    "scorers": "skɔːrəz",
    "score": "skɔː",
    "scores": "skɔːz",
    "scoring": "skɔːrɪŋ",
    "scorned": "skɔːnd",
    "scornfully": "skɔːnfəli",
    "scornful": "skɔːnfəl",
    "scorning": "skɔːnɪŋ",
    "scorn": "skɔːn",
    "scorns": "skɔːnz",
    "scorpion": "skɔːpiən",
    "scorpions": "skɔːpiənz",
    "scotched": "skɒtʃt",
    "scotches": "skɒtʃɪz",
    "scotching": "skɒtʃɪŋ",
    "scotch": "skɒtʃ",
    "scotchs": "skɒtʃz",
    "scotia": "skəʊʃɐ",
    "scoundrel": "skaʊndrəl",
    "scoundrels": "skaʊndrəlz",
    "scoured": "skaʊəd",
    "scourer": "skaʊərɐ",
    "scourers": "skaʊərəz",
    "scourged": "skɜːdʒd",
    "scourger": "skaʊədʒɐ",
    "scourge": "skɜːdʒ",
    "scourges": "skɜːdʒɪz",
    "scourging": "skaʊədʒɪŋ",
    "scouring": "skaʊərɪŋ",
    "scour": "skaʊə",
    "scours": "skaʊəz",
    "scouted": "skaʊtɪd",
    "scouting": "skaʊtɪŋ",
    "scoutmaster": "skaʊtmɑːstɐ",
    "scout": "skaʊt",
    "scouts": "skaʊts",
    "scowled": "skaʊld",
    "scowling": "skaʊlɪŋ",
    "scowl": "skaʊl",
    "scowls": "skaʊlz",
    "scow": "skaʊ",
    "scrabbled": "skræbəld",
    "scrabblers": "skræbləz",
    "scrabble": "skræbəl",
    "scrabbling": "skræblɪŋ",
    "scraggly": "skræɡli",
    "scraggy": "skræɡi",
    "scrag": "skræɡ",
    "scrags": "skræɡz",
    "scrambled": "skræmbəld",
    "scrambler": "skræmblɐ",
    "scramblers": "skræmbləz",
    "scramble": "skræmbəl",
    "scrambles": "skræmbəlz",
    "scrambling": "skræmblɪŋ",
    "scrammed": "skræmd",
    "scramming": "skræmɪŋ",
    "scram": "skræm",
    "scrams": "skræmz",
    "scrapbook": "skræpbʊk",
    "scrapbooks": "skræpbʊks",
    "scraped": "skreɪpt",
    "scraper": "skreɪpɐ",
    "scrapers": "skreɪpəz",
    "scrape": "skreɪp",
    "scrapes": "skreɪps",
    "scrapheap": "skræfiːp",
    "scrapie": "skræpaɪ",
    "scraping": "skreɪpɪŋ",
    "scrapings": "skreɪpɪŋz",
    "scrapped": "skræpt",
    "scrapper": "skræpɐ",
    "scrappers": "skræpəz",
    "scrappiest": "skræpɪəst",
    "scrappiness": "skræpɪnəs",
    "scrapping": "skræpɪŋ",
    "scrapple": "skræpəl",
    "scrappy": "skræpi",
    "scrap": "skræp",
    "scraps": "skræps",
    "scrapyard": "skræpjɑːd",
    "scrapyards": "skræpjɑːdz",
    "scratchcard": "skrætʃkɑːd",
    "scratchcards": "skrætʃkɑːdz",
    "scratched": "skrætʃt",
    "scratcher": "skrætʃɐ",
    "scratches": "skrætʃɪz",
    "scratchier": "skrætʃɪɐ",
    "scratchiness": "skrætʃɪnəs",
    "scratching": "skrætʃɪŋ",
    "scratchings": "skrætʃɪŋz",
    "scratch": "skrætʃ",
    "scratchy": "skrætʃi",
    "scrawled": "skrɔːld",
    "scrawling": "skrɔːlɪŋ",
    "scrawl": "skrɔːl",
    "scrawls": "skrɔːlz",
    "scrawly": "skrɔːli",
    "scrawnier": "skrɔːnɪɐ",
    "scrawny": "skrɔːni",
    "screamed": "skriːmd",
    "screamer": "skriːmɐ",
    "screamers": "skriːməz",
    "screamingly": "skriːmɪŋli",
    "screaming": "skriːmɪŋ",
    "scream": "skriːm",
    "screams": "skriːmz",
    "screeched": "skriːtʃt",
    "screeches": "skriːtʃɪz",
    "screeching": "skriːtʃɪŋ",
    "screech": "skriːtʃ",
    "screechy": "skriːtʃi",
    "screed": "skriːd",
    "screeds": "skriːdz",
    "screened": "skriːnd",
    "screener": "skriːnɐ",
    "screening": "skriːnɪŋ",
    "screenings": "skriːnɪŋz",
    "screenplay": "skriːnpleɪ",
    "screenplays": "skriːnpleɪz",
    "screen": "skriːn",
    "screens": "skriːnz",
    "screenwriter": "skriːnraɪtɐ",
    "screenwriters": "skriːnraɪtəz",
    "screenwriting": "skriːnraɪtɪŋ",
    "scree": "skriː",
    "screes": "skriːz",
    "screwball": "skruːbɔːl",
    "screwdriver": "skruːdraɪvɐ",
    "screwdrivers": "skruːdraɪvəz",
    "screwed": "skruːd",
    "screwing": "skruːɪŋ",
    "screw": "skruː",
    "screws": "skruːz",
    "screwy": "skruːi",
    "scribbled": "skrɪbəld",
    "scribbler": "skrɪblɐ",
    "scribble": "skrɪbəl",
    "scribbles": "skrɪbəlz",
    "scribbling": "skrɪblɪŋ",
    "scribblings": "skrɪblɪŋz",
    "scribed": "skraɪbd",
    "scribers": "skraɪbəz",
    "scribe": "skraɪb",
    "scribes": "skraɪbz",
    "scribing": "skraɪbɪŋ",
    "scrimmage": "skrɪmɪdʒ",
    "scrimped": "skrɪmpt",
    "scrimping": "skrɪmpɪŋ",
    "scrimp": "skrɪmp",
    "scrimshawed": "skrɪmʃɔːd",
    "scrimshaw": "skrɪmʃɔː",
    "scrimshaws": "skrɪmʃɔːz",
    "scrim": "skrɪm",
    "scrip": "skrɪp",
    "scrips": "skrɪps",
    "scripted": "skrɪptɪd",
    "scripting": "skrɪptɪŋ",
    "scriptoria": "skrɪptɔːriə",
    "scriptorium": "skrɪptɔːriəm",
    "script": "skrɪpt",
    "scripts": "skrɪpts",
    "scriptural": "skrɪptʃərəl",
    "scripture": "skrɪptʃɐ",
    "scriptures": "skrɪptʃəz",
    "scriptwriter": "skrɪptraɪtɐ",
    "scriptwriters": "skrɪptraɪtəz",
    "scriptwriting": "skrɪptraɪtɪŋ",
    "scrivener": "skrɪvənɐ",
    "scriveners": "skrɪvənəz",
    "scrod": "skrɒd",
    "scrofula": "skrɒfjʊlɐ",
    "scrofulous": "skrɒfjʊləs",
    "scrolled": "skrəʊld",
    "scrolling": "skrəʊlɪŋ",
    "scroll": "skrəʊl",
    "scrolls": "skrəʊlz",
    "scrooge": "skruːdʒ",
    "scrooges": "skruːdʒɪz",
    "scroop": "skruːp",
    "scrotal": "skrəʊtəl",
    "scrotum": "skrəʊtəm",
    "scrotums": "skrəʊtəmz",
    "scrounged": "skraʊndʒd",
    "scrounger": "skraʊndʒɐ",
    "scroungers": "skraʊndʒəz",
    "scrounge": "skraʊndʒ",
    "scrounging": "skraʊndʒɪŋ",
    "scrubbed": "skrʌbd",
    "scrubber": "skrʌbɐ",
    "scrubbers": "skrʌbəz",
    "scrubbing": "skrʌbɪŋ",
    "scrubby": "skrʌbi",
    "scrubland": "skrʌblənd",
    "scrub": "skrʌb",
    "scrubs": "skrʌbz",
    "scruffier": "skrʌfɪɐ",
    "scruffiest": "skrʌfɪəst",
    "scruffily": "skrʌfɪli",
    "scruffiness": "skrʌfɪnəs",
    "scruff": "skrʌf",
    "scruffs": "skrʌfs",
    "scruffy": "skrʌfi",
    "scrumhalf": "skrʌmhɑːf",
    "scrummage": "skrʌmɪdʒ",
    "scrummages": "skrʌmɪdʒɪz",
    "scrummaging": "skrʌmɪdʒɪŋ",
    "scrumming": "skrʌmɪŋ",
    "scrumped": "skrʌmpt",
    "scrumping": "skrʌmpɪŋ",
    "scrump": "skrʌmp",
    "scrumptiously": "skrʌmpʃəsli",
    "scrumptious": "skrʌmpʃəs",
    "scrumpy": "skrʌmpi",
    "scrum": "skrʌm",
    "scrums": "skrʌmz",
    "scrunched": "skrʌntʃt",
    "scrunches": "skrʌntʃɪz",
    "scrunchie": "skrʌntʃi",
    "scrunchies": "skrʌntʃɪz",
    "scrunching": "skrʌntʃɪŋ",
    "scrunch": "skrʌntʃ",
    "scrunchy": "skrʌntʃi",
    "scruple": "skruːpəl",
    "scruples": "skruːpəlz",
    "scrupulously": "skruːpjʊləsli",
    "scrupulous": "skruːpjʊləs",
    "scrutable": "skruːtəbəl",
    "scrutineer": "skruːtɪniə",
    "scrutineers": "skruːtɪniəz",
    "scrutinised": "skruːtɪnaɪzd",
    "scrutinise": "skruːtɪnaɪz",
    "scrutinises": "skruːtɪnaɪzɪz",
    "scrutinising": "skruːtɪnaɪzɪŋ",
    "scrutiny": "skruːtɪni",
    "scuba": "skuːbɐ",
    "scudding": "skʌdɪŋ",
    "scud": "skʌd",
    "scuds": "skʌdz",
    "scuffed": "skʌft",
    "scuffing": "skʌfɪŋ",
    "scuffled": "skʌfəld",
    "scuffler": "skʌflɐ",
    "scuffle": "skʌfəl",
    "scuffles": "skʌfəlz",
    "scuffling": "skʌflɪŋ",
    "scuff": "skʌf",
    "scuffs": "skʌfs",
    "sculler": "skʌlɐ",
    "scullers": "skʌləz",
    "scullery": "skʌləri",
    "sculling": "skʌlɪŋ",
    "scullion": "skʌliən",
    "scull": "skʌl",
    "sculls": "skʌlz",
    "sculpted": "skʌlptɪd",
    "sculpting": "skʌlptɪŋ",
    "sculptor": "skʌlptɐ",
    "sculptors": "skʌlptəz",
    "sculptress": "skʌlptrəs",
    "sculpt": "skʌlpt",
    "sculpts": "skʌlpts",
    "sculptural": "skʌlptʃərəl",
    "sculptured": "skʌlptʃəd",
    "sculpture": "skʌlptʃɐ",
    "sculptures": "skʌlptʃəz",
    "scumbag": "skʌmbæɡ",
    "scumbags": "skʌmbæɡz",
    "scumble": "skʌmbəl",
    "scummiest": "skʌmɪəst",
    "scummy": "skʌmi",
    "scum": "skʌm",
    "scums": "skʌmz",
    "scuppered": "skʌpəd",
    "scuppering": "skʌpərɪŋ",
    "scupper": "skʌpɐ",
    "scuppers": "skʌpəz",
    "scurf": "skɜːf",
    "scurfy": "skɜːfi",
    "scurried": "skʌrɪd",
    "scurries": "skʌrɪz",
    "scurrilous": "skʌrɪləs",
    "scurrying": "skʌrɪɪŋ",
    "scurry": "skʌri",
    "scurvy": "skɜːvi",
    "scutes": "skjuːts",
    "scut": "skʌt",
    "scuts": "skʌts",
    "scutter": "skʌtɐ",
    "scuttlebutt": "skʌtəlbʌt",
    "scuttled": "skʌtəld",
    "scuttle": "skʌtəl",
    "scuttles": "skʌtəlz",
    "scuttling": "skʌtlɪŋ",
    "scutum": "skjuːtəm",
    "scuzzy": "skʌzi",
    "scythed": "saɪθd",
    "scythe": "saɪð",
    "scythes": "saɪðz",
    "scything": "saɪθɪŋ",
    "seabed": "siːbɛd",
    "seabeds": "siːbɛdz",
    "seabird": "siːbɜːd",
    "seabirds": "siːbɜːdz",
    "seaboard": "siːbɔːd",
    "seaborgium": "siːbɔːdʒəm",
    "seaborne": "siːbɔːn",
    "seacoast": "siːkəʊst",
    "seadog": "siːdɒɡ",
    "seafarer": "siːfeərɐ",
    "seafarers": "siːfeərəz",
    "seafaring": "siːfeərɪŋ",
    "seafloor": "siːflɔː",
    "seafood": "siːfuːd",
    "seafront": "siːfrʌnt",
    "seafronts": "siːfrʌnts",
    "seagoing": "siːɡəʊɪŋ",
    "seagull": "siːɡʌl",
    "seagulls": "siːɡʌlz",
    "seahorse": "siːhɔːs",
    "seahorses": "siːhɔːsɪz",
    "sealable": "siːləbəl",
    "sealant": "siːlənt",
    "sealants": "siːlənts",
    "sealed": "siːld",
    "sealer": "siːlɐ",
    "sealers": "siːləz",
    "sealing": "siːlɪŋ",
    "seal": "siːl",
    "sealskin": "siːlskɪn",
    "seals": "siːlz",
    "seamanship": "siːmənʃɪp",
    "seaman": "siːmən",
    "seamark": "siːmɑːk",
    "seamed": "siːmd",
    "seamen": "siːmɛn",
    "seamier": "siːmɪɐ",
    "seaming": "siːmɪŋ",
    "seamlessly": "siːmləsli",
    "seamless": "siːmləs",
    "seamount": "siːmaʊnt",
    "seamounts": "siːmaʊnts",
    "seam": "siːm",
    "seams": "siːmz",
    "seamstresses": "siːmstrəsɪz",
    "seamstress": "siːmstrəs",
    "seamy": "siːmi",
    "seaplane": "siːpleɪn",
    "seaplanes": "siːpleɪnz",
    "seaport": "siːpɔːt",
    "seaports": "siːpɔːts",
    "searched": "sɜːtʃt",
    "searchers": "sɜːtʃəz",
    "searcher": "sɜːtʃɐ",
    "searches": "sɜːtʃɪz",
    "searchingly": "sɜːtʃɪŋli",
    "searching": "sɜːtʃɪŋ",
    "searchlights": "sɜːtʃlaɪts",
    "searchlight": "sɜːtʃlaɪt",
    "search": "sɜːtʃ",
    "seared": "siəd",
    "searingly": "siərɪŋli",
    "searing": "siərɪŋ",
    "sear": "siə",
    "sears": "siəz",
    "seascape": "siːskeɪp",
    "seascapes": "siːskeɪps",
    "seashell": "siːʃɛl",
    "seashells": "siːʃɛlz",
    "seashore": "siːʃɔː",
    "seashores": "siːʃɔːz",
    "sea": "siː",
    "seasickness": "siːsɪknəs",
    "seasick": "siːsɪk",
    "seaside": "siːsaɪd",
    "seasides": "siːsaɪdz",
    "seasonable": "siːzənəbəl",
    "seasonality": "siːzənælɪti",
    "seasonally": "siːzənəli",
    "seasonal": "siːzənəl",
    "seasoned": "siːzənd",
    "seasoning": "siːzənɪŋ",
    "seasonings": "siːzənɪŋz",
    "season": "siːzən",
    "seasons": "siːzənz",
    "seas": "siːz",
    "seatbelt": "siːtbɛlt",
    "seated": "siːtɪd",
    "seating": "siːtɪŋ",
    "seat": "siːt",
    "seats": "siːts",
    "seawall": "siːwɔːl",
    "seaward": "siːwəd",
    "seawards": "siːwədz",
    "seawater": "siːwɔːtɐ",
    "seaway": "siːweɪ",
    "seaways": "siːweɪz",
    "seaweed": "siːwiːd",
    "seaweeds": "siːwiːdz",
    "seaworthiness": "siːwəðɪnəs",
    "seaworthy": "siːwɜːði",
    "sebaceous": "sɛbeɪʃəs",
    "seborrhoeic": "sɛbərəʊɪk",
    "sebum": "sɛbəm",
    "secateurs": "sɛkɐtɜːz",
    "secco": "sɛkəʊ",
    "seceded": "sɛsiːdɪd",
    "secede": "sɛsiːd",
    "seceding": "sɛsiːdɪŋ",
    "secessionism": "sɛsɛʃənɪzəm",
    "secessionist": "sɛsɛʃənɪst",
    "secessionists": "sɛsɛʃənɪsts",
    "secession": "sɛsɛʃən",
    "sech": "sɛtʃ",
    "secluded": "sɪkluːdɪd",
    "seclude": "sɪkluːd",
    "seclusion": "sɪkluːʒən",
    "secondaries": "sɛkəndəriz",
    "secondary": "sɛkəndəri",
    "seconder": "sɛkəndɐ",
    "secondhand": "sɛkəndhænd",
    "secondly": "sɛkəndli",
    "secondment": "səkɒndmənt",
    "secrecy": "siːkrəsi",
    "secretarial": "sɛkrɪteərɪəl",
    "secretariat": "sɛkrɪteərɪæt",
    "secretaries": "sɛkrətrɪz",
    "secretary": "sɛkrətri",
    "secrete": "sɪkriːt",
    "secretes": "sɪkriːts",
    "secretion": "sɪkriːʃən",
    "secretions": "sɪkriːʃənz",
    "secretively": "siːkrətɪvli",
    "secretive": "siːkrətɪv",
    "secretly": "siːkrətli",
    "secrets": "siːkrəts",
    "secs": "sɛks",
    "sectarianism": "sɛkteəriənɪzəm",
    "sectarian": "sɛkteəriən",
    "sectional": "sɛkʃənəl",
    "sectioned": "sɛkʃənd",
    "sectioning": "sɛkʃənɪŋ",
    "section": "sɛkʃən",
    "sections": "sɛkʃənz",
    "sector": "sɛktɐ",
    "sectors": "sɛktəz",
    "sect": "sɛkt",
    "sects": "sɛkts",
    "secularisation": "sɛkjʊləraɪzeɪʃən",
    "secularised": "sɛkjʊləraɪzd",
    "secularism": "sɛkjʊlərɪzəm",
    "secularist": "sɛkjʊlərɪst",
    "secularists": "sɛkjʊlərɪsts",
    "secularity": "sɛkjʊlærɪti",
    "secular": "sɛkjʊlɐ",
    "secured": "sɪkjɔːd",
    "securely": "sɪkjɔːli",
    "secure": "sɪkjɔː",
    "secures": "sɪkjɔːz",
    "securing": "sɪkjɔːrɪŋ",
    "securities": "sɪkjɔːrɪtiz",
    "security": "sɪkjɔːrɪti",
    "sedan": "sɪdæn",
    "sedans": "sɪdænz",
    "sedated": "sɪdeɪtɪd",
    "sedately": "sɪdeɪtli",
    "sedate": "sɪdeɪt",
    "sedates": "sɪdeɪts",
    "sedating": "sɪdeɪtɪŋ",
    "sedation": "sɛdeɪʃən",
    "sedative": "sɛdətɪv",
    "sedatives": "sɛdətɪvz",
    "sedentary": "sɛdəntəri",
    "sedge": "sɛdʒ",
    "sedges": "sɛdʒɪz",
    "sedimentary": "sɛdɪmɛntəri",
    "sedimentation": "sɛdɪmənteɪʃən",
    "sediment": "sɛdɪmənt",
    "sediments": "sɛdɪmənts",
    "sedition": "sɛdɪʃən",
    "seditious": "sɛdɪʃəs",
    "seduced": "sɪdjuːst",
    "seducer": "sɪdjuːsɐ",
    "seducers": "sɪdjuːsəz",
    "seduce": "sɪdjuːs",
    "seduces": "sɪdjuːsɪz",
    "seducing": "sɪdjuːsɪŋ",
    "seduction": "sɪdʌkʃən",
    "seductions": "sɪdʌkʃənz",
    "seductively": "sɪdʌktɪvli",
    "seductiveness": "sɪdʌktɪvnəs",
    "seductive": "sɪdʌktɪv",
    "seductress": "sɪdʌktrəs",
    "sedum": "sɛdəm",
    "sedums": "sɛdəmz",
    "seedbed": "siːdbɛd",
    "seedbeds": "siːdbɛdz",
    "seeded": "siːdɪd",
    "seeder": "siːdɐ",
    "seeders": "siːdəz",
    "seedier": "siːdɪɐ",
    "seediest": "siːdɪəst",
    "seediness": "siːdɪnəs",
    "seeding": "siːdɪŋ",
    "seedless": "siːdləs",
    "seedling": "siːdlɪŋ",
    "seedlings": "siːdlɪŋz",
    "seedpods": "siːdpɒdz",
    "seed": "siːd",
    "seeds": "siːdz",
    "seedy": "siːdi",
    "seeing": "siːɪŋ",
    "seeker": "siːkɐ",
    "seekers": "siːkəz",
    "seeking": "siːkɪŋ",
    "seek": "siːk",
    "seeks": "siːks",
    "seel": "siːl",
    "seemed": "siːmd",
    "seemingly": "siːmɪŋli",
    "seeming": "siːmɪŋ",
    "seemliness": "siːmlinəs",
    "seemly": "siːmli",
    "seem": "siːm",
    "seems": "siːmz",
    "seen": "siːn",
    "seepage": "siːpɪdʒ",
    "seeped": "siːpt",
    "seeping": "siːpɪŋ",
    "seep": "siːp",
    "seeps": "siːps",
    "seers": "siəz",
    "seersucker": "siəsʌkɐ",
    "seesawing": "siːsɔːrɪŋ",
    "seesaw": "siːsɔː",
    "seesaws": "siːsɔːz",
    "see": "siː",
    "sees": "siːz",
    "seethed": "siːθd",
    "seethe": "siːð",
    "seethes": "siːðz",
    "seething": "siːðɪŋ",
    "segmental": "sɛɡmɛntəl",
    "segmentation": "sɛɡmənteɪʃən",
    "segmented": "sɛɡmɛntɪd",
    "segmenting": "sɛɡməntɪŋ",
    "segno": "sɛɡnəʊ",
    "segregated": "sɛɡrɪɡeɪtɪd",
    "segregate": "sɛɡrɪɡeɪt",
    "segregating": "sɛɡrɪɡeɪtɪŋ",
    "segregationist": "sɛɡrɪɡeɪʃənɪst",
    "segregation": "sɛɡrɪɡeɪʃən",
    "segueing": "sɛɡweɪɪŋ",
    "segue": "sɛɡweɪ",
    "segues": "sɛɡweɪz",
    "seigneur": "seɪnɜː",
    "seiner": "seɪnɐ",
    "seine": "seɪn",
    "seines": "seɪnz",
    "seismically": "saɪzmɪkli",
    "seismic": "saɪzmɪk",
    "seismograph": "saɪzməɡræf",
    "seismographs": "saɪzməɡræfz",
    "seismological": "saɪzməlɒdʒɪkəl",
    "seismologist": "saɪzmɒlədʒɪst",
    "seismologists": "saɪzmɒlədʒɪsts",
    "seismology": "saɪzmɒlədʒi",
    "seismometer": "saɪzmɒmɪtɐ",
    "seismometers": "saɪzmɒmɪtəz",
    "seized": "siːzd",
    "seize": "siːz",
    "seizes": "siːzɪz",
    "seizing": "siːzɪŋ",
    "seizure": "siːʒɐ",
    "seizures": "siːʒəz",
    "seldom": "sɛldəm",
    "selectable": "sɪlɛktəbəl",
    "selected": "sɪlɛktɪd",
    "selecting": "sɪlɛktɪŋ",
    "selection": "sɪlɛkʃən",
    "selections": "sɪlɛkʃənz",
    "selectively": "sɪlɛktɪvli",
    "selective": "sɪlɛktɪv",
    "selectivity": "sɪlɪktɪvɪti",
    "selector": "sɪlɛktɐ",
    "selectors": "sɪlɛktəz",
    "select": "sɪlɛkt",
    "selects": "sɪlɛkts",
    "selenium": "sɛliːniəm",
    "selfheal": "sɛlfhiəl",
    "selfishly": "sɛlfɪʃli",
    "selfishness": "sɛlfɪʃnəs",
    "selfish": "sɛlfɪʃ",
    "selflessly": "sɛlfləsli",
    "selflessness": "sɛlfləsnəs",
    "selfless": "sɛlfləs",
    "selfsame": "sɛlfseɪm",
    "self": "sɛlf",
    "seller": "sɛlɐ",
    "sellers": "sɛləz",
    "selling": "sɛlɪŋ",
    "selloff": "sɛlɒf",
    "sellotaped": "sɛləteɪpt",
    "sellotape": "sɛləteɪp",
    "sellotaping": "sɛləteɪpɪŋ",
    "sellout": "sɛlaʊt",
    "sell": "sɛl",
    "sells": "sɛlz",
    "seltzer": "sɛltsɐ",
    "seltzers": "sɛltsəz",
    "selvage": "sɛlvɪdʒ",
    "selves": "sɛlvz",
    "semantically": "səmæntɪkli",
    "semanticist": "səmæntɪsɪst",
    "semantic": "səmæntɪk",
    "semantics": "səmæntɪks",
    "semaphore": "sɛmɐfɔː",
    "semblance": "sɛmbləns",
    "semen": "siːmən",
    "semester": "səmɛstɐ",
    "semesters": "səmɛstəz",
    "semiaquatic": "sɛmɪəkwætɪk",
    "semiautomatic": "sɛmɪɔːtəmætɪk",
    "semibreve": "sɛmɪbriːv",
    "semibreves": "sɛmɪbriːvz",
    "semicircle": "sɛmɪsɜːkəl",
    "semicircles": "sɛmɪsɜːkəlz",
    "semicircular": "sɛmɪsɜːkjʊlɐ",
    "semicolon": "sɛmɪkəʊlən",
    "semiconductor": "sɛmɪkəndʌktɐ",
    "semiconductors": "sɛmɪkəndʌktəz",
    "semiconscious": "sɛmɪkɒnʃəs",
    "semidetached": "sɛmɪdɪtætʃt",
    "semifinalist": "sɛmɪfaɪnəlɪst",
    "semifinalists": "sɛmɪfaɪnəlɪsts",
    "semifinal": "sɛmɪfaɪnəl",
    "semifinals": "sɛmɪfaɪnəlz",
    "seminally": "sɛmɪnəli",
    "seminal": "sɛmɪnəl",
    "seminarian": "sɛmɪneəriən",
    "seminarians": "sɛmɪneəriənz",
    "seminaries": "sɛmɪnəriz",
    "seminar": "sɛmɪnɑː",
    "seminars": "sɛmɪnɑːz",
    "seminary": "sɛmɪnəri",
    "semiotic": "sɛmɪɒtɪk",
    "semiotics": "sɛmɪɒtɪks",
    "semipermeable": "sɛmɪpɜːməbəl",
    "semiprecious": "sɛmɪprɛʃəs",
    "semiquaver": "sɛmɪkweɪvɐ",
    "semiquavers": "sɛmɪkweɪvəz",
    "semirigid": "sɛmɪrɪdʒɪd",
    "semi": "sɛmi",
    "semis": "sɛmiz",
    "semitone": "sɛmɪtəʊn",
    "semitones": "sɛmɪtəʊnz",
    "semolina": "sɛməliːnɐ",
    "senate": "sɛnət",
    "senates": "sɛnəts",
    "senatorial": "sɛnətɔːrɪəl",
    "senator": "sɛnətɐ",
    "senators": "sɛnətəz",
    "sender": "sɛndɐ",
    "senders": "sɛndəz",
    "sending": "sɛndɪŋ",
    "sendoff": "sɛndɒf",
    "send": "sɛnd",
    "sends": "sɛndz",
    "senile": "siːnaɪl",
    "senility": "siːnɪlɪti",
    "seniority": "siːnɪɒrɪti",
    "senior": "siːnjɐ",
    "seniors": "siːnjəz",
    "senna": "sɛnɐ",
    "senora": "sɛnɔːrɐ",
    "senoras": "sɛnɔːrəz",
    "senores": "sɛnɔːz",
    "senorita": "sɛnɔːriːtɐ",
    "senoritas": "sɛnɔːrɪtəz",
    "senor": "sɛnɐ",
    "senors": "sɛnəz",
    "sensationalised": "sɛnseɪʃənəlaɪzd",
    "sensationalise": "sɛnseɪʃənəlaɪz",
    "sensationalising": "sɛnseɪʃənəlaɪzɪŋ",
    "sensationalism": "sɛnseɪʃənəlɪzəm",
    "sensationalist": "sɛnseɪʃənəlɪst",
    "sensationally": "sɛnseɪʃənəli",
    "sensational": "sɛnseɪʃənəl",
    "sensation": "sɛnseɪʃən",
    "sensations": "sɛnseɪʃənz",
    "sensed": "sɛnsd",
    "senselessly": "sɛnsləsli",
    "senselessness": "sɛnsləsnəs",
    "senseless": "sɛnsləs",
    "sense": "sɛns",
    "senses": "sɛnsɪz",
    "sensibilities": "sɛnsəbɪlɪtiz",
    "sensibility": "sɛnsəbɪlɪti",
    "sensibleness": "sɛnsəbəlnəs",
    "sensible": "sɛnsəbəl",
    "sensibly": "sɛnsəbli",
    "sensing": "sɛnsɪŋ",
    "sensitisation": "sɛnsɪtaɪzeɪʃən",
    "sensitised": "sɛnsɪtaɪzd",
    "sensitise": "sɛnsɪtaɪz",
    "sensitises": "sɛnsɪtaɪzɪz",
    "sensitising": "sɛnsɪtaɪzɪŋ",
    "sensitively": "sɛnsɪtɪvli",
    "sensitiveness": "sɛnsɪtɪvnəs",
    "sensitive": "sɛnsɪtɪv",
    "sensitivities": "sɛnsɪtɪvɪtiz",
    "sensitivity": "sɛnsɪtɪvɪti",
    "sensor": "sɛnsɐ",
    "sensors": "sɛnsəz",
    "sensory": "sɛnsəri",
    "sens": "sɛns",
    "sensualist": "sɛnsjuːəlɪst",
    "sensuality": "sɛnsjuːælɪti",
    "sensually": "sɛnsjuːəli",
    "sensual": "sɛnsjuːəl",
    "sensuousness": "sɛnsjuːəsnəs",
    "sensuous": "sɛnsjuːəs",
    "sentenced": "sɛntənst",
    "sentence": "sɛntəns",
    "sentences": "sɛntənsɪz",
    "sentencing": "sɛntənsɪŋ",
    "sente": "sɛnt",
    "sentience": "sɛnʃəns",
    "sentient": "sɛnʃənt",
    "sentimentalised": "sɛntɪmɛntəlaɪzd",
    "sentimentalise": "sɛntɪmɛntəlaɪz",
    "sentimentalist": "sɛntɪmɛntəlɪst",
    "sentimentality": "sɛntɪmɛntælɪti",
    "sentimentally": "sɛntɪmɛntəli",
    "sentimental": "sɛntɪmɛntəl",
    "sentiment": "sɛntɪmənt",
    "sentiments": "sɛntɪmənts",
    "sentinel": "sɛntɪnəl",
    "sentinels": "sɛntɪnəlz",
    "sentries": "sɛntrɪz",
    "sentry": "sɛntri",
    "sent": "sɛnt",
    "sepal": "sɛpəl",
    "sepals": "sɛpəlz",
    "separable": "sɛpərəbəl",
    "separated": "sɛpəreɪtɪd",
    "separately": "sɛprətli",
    "separateness": "sɛprətnəs",
    "separating": "sɛpəreɪtɪŋ",
    "separation": "sɛpəreɪʃən",
    "separations": "sɛpəreɪʃənz",
    "separatism": "sɛpərətɪzəm",
    "separatist": "sɛpərætɪst",
    "separatists": "sɛpərætɪsts",
    "separator": "sɛpəreɪtɐ",
    "sepia": "siːpiɐ",
    "sepoy": "sɛpɔɪ",
    "sepsis": "sɛpsɪs",
    "septal": "sɛptəl",
    "septet": "sɛptɛt",
    "septicaemia": "sɛptɪkiːmiə",
    "septicaemic": "sɛptɪkiːmɪk",
    "septic": "sɛptɪk",
    "sept": "sɛpt",
    "septs": "sɛpts",
    "septuagenarian": "sɛptjuːeɪdʒneəriən",
    "septuagenarians": "sɛptjuːeɪdʒneəriənz",
    "septum": "sɛptəm",
    "sepulchral": "sɛpʌlkrəl",
    "sepulchre": "sɛpʌlkɐ",
    "sequelae": "siːkwɪliː",
    "sequel": "siːkwəl",
    "sequels": "siːkwəlz",
    "sequenced": "siːkwənst",
    "sequencer": "siːkwənsɐ",
    "sequencers": "siːkwənsəz",
    "sequence": "siːkwəns",
    "sequences": "siːkwənsɪz",
    "sequencing": "siːkwənsɪŋ",
    "sequentially": "siːkwɛnʃəli",
    "sequential": "siːkwɛnʃəl",
    "sequestered": "siːkwɛstəd",
    "sequestering": "siːkwɛstərɪŋ",
    "sequester": "siːkwɛstɐ",
    "sequestrated": "siːkwɪstreɪtɪd",
    "sequestration": "siːkwɪstreɪʃən",
    "sequined": "siːkwɪnd",
    "sequinned": "sɛkwɪnd",
    "sequin": "sɛkwɪn",
    "sequins": "sɛkwɪnz",
    "sequoia": "sɛkwɔɪɐ",
    "sequoias": "sɛkwɔɪəz",
    "seraglio": "səræɡlɪəʊ",
    "serai": "sɛraɪ",
    "seraphic": "sɛrəfɪk",
    "seraphim": "sɛrəfɪm",
    "seraph": "sɛrəf",
    "seraphs": "sɛrəfz",
    "sera": "siərɐ",
    "serenaded": "sɛrɪneɪdɪd",
    "serenade": "sɛrɪneɪd",
    "serenades": "sɛrɪneɪdz",
    "serenading": "sɛrɪneɪdɪŋ",
    "serena": "sɛriːnɐ",
    "serendipitous": "sɛrɪndɪpɪtəs",
    "serendipity": "sɛrɪndɪpɪti",
    "serenely": "səriːnli",
    "serene": "səriːn",
    "serenity": "sɛrɛnɪti",
    "sere": "siə",
    "serfdom": "sɜːfdəm",
    "serf": "sɜːf",
    "serfs": "sɜːfs",
    "sergeant": "sɑːdʒənt",
    "sergeants": "sɑːdʒənts",
    "serge": "sɜːdʒ",
    "serialisation": "siərɪəlaɪzeɪʃən",
    "serialisations": "siərɪəlaɪzeɪʃənz",
    "serialised": "siərɪəlaɪzd",
    "serialising": "siərɪəlaɪzɪŋ",
    "serialism": "siərɪəlɪzəm",
    "serially": "siərɪəli",
    "serial": "siərɪəl",
    "serials": "siərɪəlz",
    "sericulture": "sɛrɪkʌltʃɐ",
    "series": "siəriz",
    "serif": "sɛrɪf",
    "serin": "sɛrɪn",
    "seriocomic": "siərɪəkɒmɪk",
    "seriously": "siərɪəsli",
    "seriousness": "siərɪəsnəs",
    "serious": "siərɪəs",
    "serjeant": "sɜːdʒiːnt",
    "sermonise": "sɜːmənaɪz",
    "sermon": "sɜːmən",
    "sermons": "sɜːmənz",
    "serological": "sɛrəlɒdʒɪkəl",
    "serology": "sərɒlədʒi",
    "serotonin": "sɛrətəʊnɪn",
    "serous": "sɛrəs",
    "serpentine": "sɜːpɪntaɪn",
    "serpent": "sɜːpənt",
    "serpents": "sɜːpənts",
    "serrated": "sɛreɪtɪd",
    "serrate": "sɛreɪt",
    "serration": "sɛreɪʃən",
    "serrations": "sɛreɪʃənz",
    "serried": "sɛrɪd",
    "serum": "sɛrəm",
    "servals": "sɜːvəlz",
    "serval": "sɜːvəl",
    "servants": "sɜːvənts",
    "servant": "sɜːvənt",
    "served": "sɜːvd",
    "servers": "sɜːvəz",
    "server": "sɜːvɐ",
    "servery": "sɜːvəri",
    "serves": "sɜːvz",
    "serve": "sɜːv",
    "serviceable": "sɜːvɪsəbəl",
    "serviced": "sɜːvɪsd",
    "serviceman": "sɜːvɪsmən",
    "servicemen": "sɜːvɪsmɛn",
    "services": "sɜːvɪsɪz",
    "service": "sɜːvɪs",
    "servicewoman": "sɜːvɪswʊmən",
    "servicewomen": "sɜːvɪswɪmɪn",
    "servicing": "sɜːvɪsɪŋ",
    "serviettes": "sɜːvɪɛts",
    "serviette": "sɜːvɪɛt",
    "servile": "sɜːvaɪl",
    "servility": "sɜːvɪlɪti",
    "servings": "sɜːvɪŋz",
    "serving": "sɜːvɪŋ",
    "servitor": "sɜːvɪtɐ",
    "servitude": "sɜːvɪtjuːd",
    "servos": "sɜːvəʊz",
    "servo": "sɜːvəʊ",
    "s": "ɛs",
    "sesame": "sɛsɐmi",
    "sessile": "sɛsaɪl",
    "session": "sɛʃən",
    "sessions": "sɛʃənz",
    "sesterce": "sɛstəs",
    "setae": "sɛtiː",
    "setback": "sɛtbæk",
    "setbacks": "sɛtbæks",
    "set": "sɛt",
    "sets": "sɛts",
    "settee": "sɛtiː",
    "settees": "sɛtiːz",
    "setter": "sɛtɐ",
    "setters": "sɛtəz",
    "setting": "sɛtɪŋ",
    "settings": "sɛtɪŋz",
    "settled": "sɛtəld",
    "settlement": "sɛtəlmənt",
    "settlements": "sɛtəlmənts",
    "settler": "sɛtlɐ",
    "settlers": "sɛtləz",
    "settle": "sɛtəl",
    "settles": "sɛtəlz",
    "settling": "sɛtlɪŋ",
    "sett": "sɛt",
    "setts": "sɛts",
    "setup": "sɛtʌp",
    "setups": "sɛtʌps",
    "sevenfold": "sɛvənfəʊld",
    "sevenpence": "sɛvənpəns",
    "seven": "sɛvən",
    "sevens": "sɛvənz",
    "seventeen": "sɛvəntiːn",
    "seventeenth": "sɛvəntiːnθ",
    "seventh": "sɛvənθ",
    "sevenths": "sɛvənθs",
    "seventies": "sɛvəntɪz",
    "seventieth": "sɛvɪntiəθ",
    "seventy": "sɛvənti",
    "severally": "sɛvrəli",
    "several": "sɛvrəl",
    "severance": "sɛvərəns",
    "severed": "sɛvəd",
    "severely": "sɪviəli",
    "severest": "səviərəst",
    "severe": "sɪviə",
    "severing": "sɛvərɪŋ",
    "severity": "səvɛrɪti",
    "sever": "sɛvɐ",
    "severs": "sɛvəz",
    "sewage": "suːɪdʒ",
    "sewed": "səʊd",
    "sewerage": "suːərɪdʒ",
    "sewing": "səʊɪŋ",
    "sewn": "səʊn",
    "sew": "səʊ",
    "sews": "səʊz",
    "sexed": "sɛkst",
    "sexes": "sɛksɪz",
    "sexier": "sɛksɪɐ",
    "sexiest": "sɛksɪəst",
    "sexily": "sɛksɪli",
    "sexiness": "sɛksɪnəs",
    "sexing": "sɛksɪŋ",
    "sexism": "sɛksɪzəm",
    "sexist": "sɛksɪst",
    "sexists": "sɛksɪsts",
    "sexless": "sɛksləs",
    "sexologist": "sɛksɒlədʒɪst",
    "sexpot": "sɛkspɒt",
    "sexpots": "sɛkspɒts",
    "sex": "sɛks",
    "sextant": "sɛkstənt",
    "sextants": "sɛkstənts",
    "sextet": "sɛkstɛt",
    "sexton": "sɛkstən",
    "sextons": "sɛkstənz",
    "sext": "sɛkst",
    "sextuplets": "sɛkstuːpləts",
    "sexualities": "sɛkʃuːælɪtiz",
    "sexuality": "sɛkʃuːælɪti",
    "sexually": "sɛkʃuːəli",
    "sexual": "sɛkʃuːəl",
    "sexy": "sɛksi",
    "sfumato": "ɛsfjuːmɑːtəʊ",
    "sgraffito": "ɛsɡræfiːtəʊ",
    "shabbier": "ʃæbɪɐ",
    "shabbily": "ʃæbɪli",
    "shabbiness": "ʃæbɪnəs",
    "shabby": "ʃæbi",
    "shack": "ʃæk",
    "shacked": "ʃækt",
    "shacking": "ʃækɪŋ",
    "shackle": "ʃækəl",
    "shackled": "ʃækəld",
    "shackles": "ʃækəlz",
    "shackling": "ʃæklɪŋ",
    "shacks": "ʃæks",
    "shad": "ʃæd",
    "shaded": "ʃeɪdɪd",
    "shade": "ʃeɪd",
    "shades": "ʃeɪdz",
    "shadier": "ʃeɪdɪɐ",
    "shadiest": "ʃeɪdɪəst",
    "shading": "ʃeɪdɪŋ",
    "shadings": "ʃeɪdɪŋz",
    "shadow": "ʃædəʊ",
    "shadowboxing": "ʃædəʊbɒksɪŋ",
    "shadowed": "ʃædəʊd",
    "shadowing": "ʃædəʊɪŋ",
    "shadowless": "ʃædəʊləs",
    "shadows": "ʃædəʊz",
    "shadowy": "ʃædəʊi",
    "shady": "ʃeɪdi",
    "shafted": "ʃɑːftɪd",
    "shaft": "ʃɑːft",
    "shafting": "ʃɑːftɪŋ",
    "shafts": "ʃɑːfts",
    "shag": "ʃæɡ",
    "shagged": "ʃæɡd",
    "shagginess": "ʃæɡɪnəs",
    "shagging": "ʃæɡɪŋ",
    "shaggy": "ʃæɡi",
    "shagreen": "ʃɐɡriːn",
    "shags": "ʃæɡz",
    "shah": "ʃɑː",
    "shahs": "ʃɑːz",
    "shaikh": "ʃeɪk",
    "shakedown": "ʃeɪkdaʊn",
    "shake": "ʃeɪk",
    "shaken": "ʃeɪkən",
    "shaker": "ʃeɪkɐ",
    "shakers": "ʃeɪkəz",
    "shakes": "ʃeɪks",
    "shakeup": "ʃeɪkʌp",
    "shakier": "ʃeɪkɪɐ",
    "shakily": "ʃeɪkɪli",
    "shakiness": "ʃeɪkɪnəs",
    "shaking": "ʃeɪkɪŋ",
    "shaky": "ʃeɪki",
    "shale": "ʃeɪl",
    "shaley": "ʃeɪli",
    "shall": "ʃæl",
    "shallop": "ʃæləp",
    "shallot": "ʃælɒt",
    "shallots": "ʃælɒts",
    "shallow": "ʃæləʊ",
    "shallower": "ʃæləʊɐ",
    "shallowest": "ʃæləʊəst",
    "shallowly": "ʃæləʊli",
    "shallowness": "ʃæləʊnəs",
    "shallows": "ʃæləʊz",
    "shalom": "ʃæləm",
    "shalt": "ʃælt",
    "sham": "ʃæm",
    "shaman": "ʃæmən",
    "shamanic": "ʃæmænɪk",
    "shamanism": "ʃæmənɪzəm",
    "shamanistic": "ʃæmɐnɪstɪk",
    "shamans": "ʃæmənz",
    "shamble": "ʃæmbəl",
    "shambled": "ʃæmbəld",
    "shambles": "ʃæmbəlz",
    "shambling": "ʃæmblɪŋ",
    "shambolic": "ʃæmbɒlɪk",
    "shamed": "ʃeɪmd",
    "shame": "ʃeɪm",
    "shamefaced": "ʃeɪmfeɪst",
    "shamefacedly": "ʃeɪmfeɪsɪdli",
    "shameful": "ʃeɪmfəl",
    "shamefully": "ʃeɪmfəli",
    "shameless": "ʃeɪmləs",
    "shamelessly": "ʃeɪmləsli",
    "shamelessness": "ʃeɪmləsnəs",
    "shames": "ʃeɪmz",
    "shaming": "ʃeɪmɪŋ",
    "shammies": "ʃæmɪz",
    "shammy": "ʃæmi",
    "shampoo": "ʃæmpuː",
    "shampooed": "ʃæmpuːd",
    "shampooing": "ʃæmpuːɪŋ",
    "shampoos": "ʃæmpuːz",
    "shamrock": "ʃæmrɒk",
    "shamrocks": "ʃæmrɒks",
    "shams": "ʃæmz",
    "shamus": "ʃæməs",
    "shandies": "ʃændɪz",
    "shandy": "ʃændi",
    "shanghai": "ʃæŋhaɪ",
    "shanghaied": "ʃæŋheɪəd",
    "shank": "ʃæŋk",
    "shanks": "ʃæŋks",
    "shanny": "ʃæni",
    "shanties": "ʃɑːntɪz",
    "shantung": "ʃɑːntʌŋ",
    "shanty": "ʃɑːnti",
    "shantytown": "ʃɑːntɪtaʊn",
    "shantytowns": "ʃɑːntɪtaʊnz",
    "shaped": "ʃeɪpt",
    "shape": "ʃeɪp",
    "shapeless": "ʃeɪpləs",
    "shapelessness": "ʃeɪpləsnəs",
    "shapely": "ʃeɪpli",
    "shaper": "ʃeɪpɐ",
    "shapers": "ʃeɪpəz",
    "shapes": "ʃeɪps",
    "shaping": "ʃeɪpɪŋ",
    "shard": "ʃɑːd",
    "shards": "ʃɑːdz",
    "sharecropper": "ʃeəkrɒpɐ",
    "sharecroppers": "ʃeəkrɒpəz",
    "shared": "ʃeəd",
    "share": "ʃeə",
    "shareholder": "ʃeəhəʊldɐ",
    "shareholders": "ʃeəhəʊldəz",
    "shareholding": "ʃeəhəʊldɪŋ",
    "shareholdings": "ʃeəhəʊldɪŋz",
    "sharer": "ʃeərɐ",
    "sharers": "ʃeərəz",
    "shares": "ʃeəz",
    "shareware": "ʃeəweə",
    "sharia": "ʃeəriɐ",
    "sharing": "ʃeərɪŋ",
    "sharking": "ʃɑːkɪŋ",
    "shark": "ʃɑːk",
    "sharkskin": "ʃɑːkskɪn",
    "sharks": "ʃɑːks",
    "sharpened": "ʃɑːpənd",
    "sharpener": "ʃɑːpənɐ",
    "sharpeners": "ʃɑːpənəz",
    "sharpening": "ʃɑːpənɪŋ",
    "sharpen": "ʃɑːpən",
    "sharpens": "ʃɑːpənz",
    "sharper": "ʃɑːpɐ",
    "sharpest": "ʃɑːpəst",
    "sharpie": "ʃɑːpaɪ",
    "sharpies": "ʃɑːpɪz",
    "sharpish": "ʃɑːpɪʃ",
    "sharply": "ʃɑːpli",
    "sharpness": "ʃɑːpnəs",
    "sharp": "ʃɑːp",
    "sharpshooter": "ʃɑːpʃuːtɐ",
    "sharpshooters": "ʃɑːpʃuːtəz",
    "sharpshooting": "ʃɑːpʃuːtɪŋ",
    "sharps": "ʃɑːps",
    "sharpy": "ʃɑːpi",
    "shashlik": "ʃæʃlɪk",
    "shat": "ʃæt",
    "shatter": "ʃætɐ",
    "shattered": "ʃætəd",
    "shattering": "ʃætərɪŋ",
    "shatteringly": "ʃætərɪŋli",
    "shatterproof": "ʃætəpruːf",
    "shatters": "ʃætəz",
    "shaved": "ʃeɪvd",
    "shave": "ʃeɪv",
    "shaven": "ʃeɪvən",
    "shaver": "ʃeɪvɐ",
    "shavers": "ʃeɪvəz",
    "shaves": "ʃeɪvz",
    "shaving": "ʃeɪvɪŋ",
    "shavings": "ʃeɪvɪŋz",
    "shawl": "ʃɔːl",
    "shawls": "ʃɔːlz",
    "shawm": "ʃɔːm",
    "shaw": "ʃɔː",
    "shay": "ʃeɪ",
    "shaykh": "ʃeɪk",
    "sheaf": "ʃiːf",
    "sheared": "ʃiəd",
    "shearer": "ʃiərɐ",
    "shearers": "ʃiərəz",
    "shear": "ʃiə",
    "shearing": "ʃiərɪŋ",
    "shearings": "ʃiərɪŋz",
    "shears": "ʃiəz",
    "shearwater": "ʃiəwɔːtɐ",
    "shearwaters": "ʃiəwɔːtəz",
    "sheathed": "ʃiːðd",
    "sheathe": "ʃiːð",
    "sheathing": "ʃiːðɪŋ",
    "sheath": "ʃiːθ",
    "sheaths": "ʃiːθs",
    "sheaves": "ʃiːvz",
    "shebang": "ʃɪbæŋ",
    "shebeen": "ʃɛbiːn",
    "shebeens": "ʃɛbiːnz",
    "shedding": "ʃɛdɪŋ",
    "shed": "ʃɛd",
    "sheds": "ʃɛdz",
    "sheen": "ʃiːn",
    "sheeny": "ʃiːni",
    "sheepdog": "ʃiːpdɒɡ",
    "sheepdogs": "ʃiːpdɒɡz",
    "sheep": "ʃiːp",
    "sheepish": "ʃiːpɪʃ",
    "sheepishly": "ʃiːpɪʃli",
    "sheepshank": "ʃiːpʃæŋk",
    "sheepskin": "ʃiːpskɪn",
    "sheepskins": "ʃiːpskɪnz",
    "sheered": "ʃiəd",
    "sheer": "ʃiə",
    "sheering": "ʃiərɪŋ",
    "sheerness": "ʃiənəs",
    "sheers": "ʃiəz",
    "sheeted": "ʃiːtɪd",
    "sheeting": "ʃiːtɪŋ",
    "sheet": "ʃiːt",
    "sheets": "ʃiːts",
    "she": "ʃiː",
    "sheik": "ʃeɪk",
    "sheikh": "ʃeɪk",
    "sheikhs": "ʃeɪkz",
    "sheiks": "ʃeɪks",
    "sheila": "ʃiːlɐ",
    "sheilas": "ʃiːləz",
    "shekel": "ʃɛkəl",
    "shekels": "ʃɛkəlz",
    "shelduck": "ʃɛldʌk",
    "shelducks": "ʃɛldʌks",
    "shelf": "ʃɛlf",
    "shellac": "ʃɛlæk",
    "shellacked": "ʃɛlækt",
    "shellacking": "ʃɛlækɪŋ",
    "shelled": "ʃɛld",
    "shell": "ʃɛl",
    "shellfire": "ʃɛlfaɪə",
    "shellfish": "ʃɛlfɪʃ",
    "shelling": "ʃɛlɪŋ",
    "shellings": "ʃɛlɪŋz",
    "shells": "ʃɛlz",
    "shellshocked": "ʃɛlʃɒkt",
    "shelly": "ʃɛli",
    "sheltered": "ʃɛltəd",
    "shelter": "ʃɛltɐ",
    "sheltering": "ʃɛltərɪŋ",
    "shelters": "ʃɛltəz",
    "shelved": "ʃɛlvd",
    "shelve": "ʃɛlv",
    "shelves": "ʃɛlvz",
    "shelving": "ʃɛlvɪŋ",
    "shenanigan": "ʃɪnænɪɡən",
    "shenanigans": "ʃɪnænɪɡənz",
    "shepherded": "ʃɛpədɪd",
    "shepherd": "ʃɛpəd",
    "shepherdess": "ʃɛpədɛs",
    "shepherdesses": "ʃɛpədɛsɪz",
    "shepherding": "ʃɛpədɪŋ",
    "shepherds": "ʃɛpədz",
    "sherbert": "ʃɜːbət",
    "sherbet": "ʃɜːbɪt",
    "sherbets": "ʃɜːbɪts",
    "sherd": "ʃɜːd",
    "sherds": "ʃɜːdz",
    "sherif": "ʃɛrɪf",
    "sheriff": "ʃɛrɪf",
    "sheriffs": "ʃɛrɪfs",
    "sherries": "ʃɛrɪz",
    "sherry": "ʃɛri",
    "sh": "ɛseɪtʃ",
    "shes": "ʃɪz",
    "shew": "ʃəʊ",
    "shh": "ɛseɪtʃeɪtʃ",
    "shiatsu": "ʃaɪətsuː",
    "shibboleth": "ʃɪbəʊləθ",
    "shied": "ʃaɪd",
    "shielded": "ʃiːldɪd",
    "shield": "ʃiːld",
    "shielding": "ʃiːldɪŋ",
    "shields": "ʃiːldz",
    "shier": "ʃiə",
    "shies": "ʃaɪz",
    "shiest": "ʃiːst",
    "shifted": "ʃɪftɪd",
    "shifter": "ʃɪftɐ",
    "shifters": "ʃɪftəz",
    "shift": "ʃɪft",
    "shifting": "ʃɪftɪŋ",
    "shiftless": "ʃɪftləs",
    "shifts": "ʃɪfts",
    "shifty": "ʃɪfti",
    "shigella": "ʃaɪdʒɛlɐ",
    "shikari": "ʃɪkɑːri",
    "shiksa": "ʃɪksɐ",
    "shillelagh": "ʃɪleɪlɐ",
    "shillelaghs": "ʃɪleɪləz",
    "shilling": "ʃɪlɪŋ",
    "shillings": "ʃɪlɪŋz",
    "shill": "ʃɪl",
    "shills": "ʃɪlz",
    "shim": "ʃɪm",
    "shimmered": "ʃɪməd",
    "shimmering": "ʃɪmərɪŋ",
    "shimmer": "ʃɪmɐ",
    "shimmers": "ʃɪməz",
    "shimmery": "ʃɪməri",
    "shimmied": "ʃɪmɪd",
    "shimmies": "ʃɪmɪz",
    "shimming": "ʃɪmɪŋ",
    "shimmying": "ʃɪmɪɪŋ",
    "shimmy": "ʃɪmi",
    "shims": "ʃɪmz",
    "shinbone": "ʃɪnbəʊn",
    "shindig": "ʃɪndɪɡ",
    "shindigs": "ʃɪndɪɡz",
    "shindy": "ʃɪndi",
    "shine": "ʃaɪn",
    "shined": "ʃaɪnd",
    "shiner": "ʃaɪnɐ",
    "shiners": "ʃaɪnəz",
    "shines": "ʃaɪnz",
    "shingled": "ʃɪŋɡəld",
    "shingle": "ʃɪŋɡəl",
    "shingler": "ʃɪŋɡlɐ",
    "shingles": "ʃɪŋɡəlz",
    "shinier": "ʃaɪnɪɐ",
    "shiniest": "ʃaɪnɪəst",
    "shininess": "ʃaɪnɪnəs",
    "shining": "ʃaɪnɪŋ",
    "shinned": "ʃɪnd",
    "shinning": "ʃɪnɪŋ",
    "shinny": "ʃɪni",
    "shins": "ʃɪnz",
    "shiny": "ʃaɪni",
    "shipboard": "ʃɪpbɔːd",
    "shipbuilder": "ʃɪpbɪldɐ",
    "shipbuilders": "ʃɪpbɪldəz",
    "shipbuilding": "ʃɪpbɪldɪŋ",
    "shipload": "ʃɪpləʊd",
    "shiploads": "ʃɪpləʊdz",
    "shipman": "ʃɪpmən",
    "shipmate": "ʃɪpmeɪt",
    "shipmates": "ʃɪpmeɪts",
    "shipment": "ʃɪpmənt",
    "shipments": "ʃɪpmənts",
    "shipowner": "ʃɪpaʊnɐ",
    "ship": "ʃɪp",
    "shipped": "ʃɪpt",
    "shippen": "ʃɪpən",
    "shipper": "ʃɪpɐ",
    "shippers": "ʃɪpəz",
    "shipping": "ʃɪpɪŋ",
    "shipshape": "ʃɪpʃeɪp",
    "ships": "ʃɪps",
    "shipworm": "ʃɪpwɜːm",
    "shipwrecked": "ʃɪprɛkt",
    "shipwreck": "ʃɪprɛk",
    "shipwrecks": "ʃɪprɛks",
    "shipwright": "ʃɪpraɪt",
    "shipwrights": "ʃɪpraɪts",
    "shipyard": "ʃɪpjɑːd",
    "shipyards": "ʃɪpjɑːdz",
    "shire": "ʃaɪə",
    "shires": "ʃaɪəz",
    "shirked": "ʃɜːkt",
    "shirker": "ʃɜːkɐ",
    "shirkers": "ʃɜːkəz",
    "shirking": "ʃɜːkɪŋ",
    "shirks": "ʃɜːks",
    "shirted": "ʃɜːtɪd",
    "shirting": "ʃɜːtɪŋ",
    "shirtless": "ʃɜːtləs",
    "shirtsleeves": "ʃɜːtsliːvz",
    "shirts": "ʃɜːts",
    "shirt": "ʃɜːt",
    "shirtwaist": "ʃɜːtweɪst",
    "shirty": "ʃɜːti",
    "shitfaced": "ʃɪtfeɪst",
    "shitheads": "ʃɪthɛdz",
    "shithead": "ʃɪthɛd",
    "shitload": "ʃɪtləʊd",
    "shits": "ʃɪts",
    "shit": "ʃɪt",
    "shitted": "ʃɪtɪd",
    "shittier": "ʃɪtɪɐ",
    "shittiest": "ʃɪtɪəst",
    "shitting": "ʃɪtɪŋ",
    "shitty": "ʃɪti",
    "shivah": "ʃɪvɐ",
    "shiva": "ʃiːvɐ",
    "shive": "ʃaɪv",
    "shivered": "ʃɪvəd",
    "shivering": "ʃɪvərɪŋ",
    "shivers": "ʃɪvəz",
    "shiver": "ʃɪvɐ",
    "shivery": "ʃɪvəri",
    "shiv": "ʃɪv",
    "shlep": "ʃlɛp",
    "shmooze": "ɛseɪtʃmuːz",
    "shmuck": "ɛseɪtʃmʌk",
    "shoal": "ʃəʊl",
    "shoaling": "ʃəʊlɪŋ",
    "shoals": "ʃəʊlz",
    "shoat": "ʃəʊt",
    "shockable": "ʃɒkəbəl",
    "shocked": "ʃɒkt",
    "shocker": "ʃɒkɐ",
    "shockers": "ʃɒkəz",
    "shocking": "ʃɒkɪŋ",
    "shockingly": "ʃɒkɪŋli",
    "shock": "ʃɒk",
    "shockproof": "ʃɒkpruːf",
    "shocks": "ʃɒks",
    "shockwave": "ʃɒkweɪv",
    "shod": "ʃɒd",
    "shoddily": "ʃɒdɪli",
    "shoddiness": "ʃɒdɪnəs",
    "shoddy": "ʃɒdi",
    "shoebox": "ʃuːbɒks",
    "shoed": "ʃuːd",
    "shoehorned": "ʃuːhɔːnd",
    "shoehorning": "ʃuːhɔːnɪŋ",
    "shoehorns": "ʃuːhɔːnz",
    "shoehorn": "ʃuːhɔːn",
    "shoeing": "ʃuːɪŋ",
    "shoelaces": "ʃuːleɪsɪz",
    "shoelace": "ʃuːleɪs",
    "shoeless": "ʃuːləs",
    "shoemakers": "ʃuːmeɪkəz",
    "shoemaker": "ʃuːmeɪkɐ",
    "shoemaking": "ʃuːmeɪkɪŋ",
    "shoeshine": "ʃuːʃaɪn",
    "shoestring": "ʃuːstrɪŋ",
    "shoes": "ʃuːz",
    "shoe": "ʃuː",
    "shofar": "ʃɒfɑː",
    "shogunate": "ʃɒɡəneɪt",
    "shogun": "ʃɒɡʌn",
    "shoguns": "ʃɒɡʌnz",
    "shone": "ʃɒn",
    "shooed": "ʃuːd",
    "shooing": "ʃuːɪŋ",
    "shook": "ʃʊk",
    "shoon": "ʃuːn",
    "shoos": "ʃuːz",
    "shooters": "ʃuːtəz",
    "shooter": "ʃuːtɐ",
    "shootings": "ʃuːtɪŋz",
    "shooting": "ʃuːtɪŋ",
    "shootouts": "ʃuːtaʊts",
    "shootout": "ʃuːtaʊt",
    "shoots": "ʃuːts",
    "shoot": "ʃuːt",
    "shoo": "ʃuː",
    "shopaholic": "ʃɒpɐhɒlɪk",
    "shopaholics": "ʃɒpɐhɒlɪks",
    "shopfitting": "ʃɒpfɪtɪŋ",
    "shopfront": "ʃɒpfrʌnt",
    "shopfronts": "ʃɒpfrʌnts",
    "shopkeeper": "ʃɒpkiːpɐ",
    "shopkeepers": "ʃɒpkiːpəz",
    "shopkeeping": "ʃɒpkiːpɪŋ",
    "shoplifted": "ʃɒplɪftɪd",
    "shoplifter": "ʃɒplɪftɐ",
    "shoplifters": "ʃɒplɪftəz",
    "shoplifting": "ʃɒplɪftɪŋ",
    "shoplift": "ʃɒplɪft",
    "shoplifts": "ʃɒplɪfts",
    "shop": "ʃɒp",
    "shopped": "ʃɒpt",
    "shoppe": "ʃɒp",
    "shopper": "ʃɒpɐ",
    "shoppers": "ʃɒpəz",
    "shopping": "ʃɒpɪŋ",
    "shops": "ʃɒps",
    "shorebirds": "ʃɔːbɜːdz",
    "shored": "ʃɔːd",
    "shoreline": "ʃɔːlaɪn",
    "shorelines": "ʃɔːlaɪnz",
    "shore": "ʃɔː",
    "shores": "ʃɔːz",
    "shoreward": "ʃɔːwɔːd",
    "shoring": "ʃɔːrɪŋ",
    "shorn": "ʃɔːn",
    "shortage": "ʃɔːtɪdʒ",
    "shortages": "ʃɔːtɪdʒɪz",
    "shortbread": "ʃɔːtbrɛd",
    "shortcake": "ʃɔːtkeɪk",
    "shortcakes": "ʃɔːtkeɪks",
    "shortchanged": "ʃɔːtʃeɪndʒd",
    "shortcoming": "ʃɔːtkʌmɪŋ",
    "shortcomings": "ʃɔːtkʌmɪŋz",
    "shortcrust": "ʃɔːtkrʌst",
    "shortcut": "ʃɔːtkʌt",
    "shortcuts": "ʃɔːtkʌts",
    "shorted": "ʃɔːtɪd",
    "shortened": "ʃɔːtənd",
    "shortening": "ʃɔːtənɪŋ",
    "shorten": "ʃɔːtən",
    "shortens": "ʃɔːtənz",
    "shorter": "ʃɔːtɐ",
    "shortest": "ʃɔːtəst",
    "shortfall": "ʃɔːtfɔːl",
    "shortfalls": "ʃɔːtfɔːlz",
    "shorthanded": "ʃɔːthændɪd",
    "shorthand": "ʃɔːthænd",
    "shorthorn": "ʃɔːθɔːn",
    "shorthorns": "ʃɔːθɔːnz",
    "shortie": "ʃɔːti",
    "shorties": "ʃɔːtɪz",
    "shorting": "ʃɔːtɪŋ",
    "shortish": "ʃɔːtɪʃ",
    "shortlisted": "ʃɔːtlɪstɪd",
    "shortlisting": "ʃɔːtlɪstɪŋ",
    "shortlist": "ʃɔːtlɪst",
    "shortlists": "ʃɔːtlɪsts",
    "shortly": "ʃɔːtli",
    "shortness": "ʃɔːtnəs",
    "short": "ʃɔːt",
    "shortsighted": "ʃɔːtsaɪtɪd",
    "shorts": "ʃɔːts",
    "shortstop": "ʃɔːtstɒp",
    "shortwave": "ʃɔːtweɪv",
    "shorty": "ʃɔːti",
    "shote": "ʃəʊt",
    "shotguns": "ʃɒtɡʌnz",
    "shotgun": "ʃɒtɡʌn",
    "shots": "ʃɒts",
    "shot": "ʃɒt",
    "should": "ʃʊd",
    "shouldered": "ʃəʊldəd",
    "shoulder": "ʃəʊldɐ",
    "shouldering": "ʃəʊldərɪŋ",
    "shoulders": "ʃəʊldəz",
    "shouldst": "ʃʊdst",
    "shout": "ʃaʊt",
    "shouted": "ʃaʊtɪd",
    "shouter": "ʃaʊtɐ",
    "shouters": "ʃaʊtəz",
    "shouting": "ʃaʊtɪŋ",
    "shouts": "ʃaʊts",
    "shoved": "ʃʌvd",
    "shovelers": "ʃʌvələz",
    "shoveler": "ʃʌvəlɐ",
    "shovelfuls": "ʃʌvɛlfəlz",
    "shovelful": "ʃʌvəlfəl",
    "shovelled": "ʃʌvəld",
    "shovellers": "ʃʌvɛləz",
    "shoveller": "ʃʌvəlɐ",
    "shovelling": "ʃʌvəlɪŋ",
    "shovels": "ʃʌvəlz",
    "shovel": "ʃʌvəl",
    "shoves": "ʃʌvz",
    "shove": "ʃʌv",
    "shoving": "ʃʌvɪŋ",
    "showbiz": "ʃəʊbɪz",
    "showboat": "ʃəʊbəʊt",
    "showboating": "ʃəʊbəʊtɪŋ",
    "showcased": "ʃəʊkeɪst",
    "showcase": "ʃəʊkeɪs",
    "showcases": "ʃəʊkeɪsɪz",
    "showcasing": "ʃəʊkeɪsɪŋ",
    "showdown": "ʃəʊdaʊn",
    "showdowns": "ʃəʊdaʊnz",
    "show": "ʃəʊ",
    "showed": "ʃəʊd",
    "showered": "ʃaʊəd",
    "showering": "ʃaʊərɪŋ",
    "showery": "ʃaʊəri",
    "showgirl": "ʃəʊɡɜːl",
    "showgirls": "ʃəʊɡɜːlz",
    "showground": "ʃəʊɡraʊnd",
    "showgrounds": "ʃəʊɡraʊndz",
    "showiest": "ʃəʊɪəst",
    "showing": "ʃəʊɪŋ",
    "showings": "ʃəʊɪŋz",
    "showjumping": "ʃəʊdʒʌmpɪŋ",
    "showman": "ʃəʊmən",
    "showmanship": "ʃəʊmənʃɪp",
    "showmen": "ʃəʊmɛn",
    "shown": "ʃəʊn",
    "showoff": "ʃəʊɒf",
    "showoffs": "ʃəʊɒfs",
    "showpiece": "ʃəʊpiːs",
    "showpieces": "ʃəʊpiːsɪz",
    "showplace": "ʃəʊpleɪs",
    "showroom": "ʃəʊruːm",
    "showrooms": "ʃəʊruːmz",
    "shows": "ʃəʊz",
    "showstopper": "ʃəʊstɒpɐ",
    "showstoppers": "ʃəʊstɒpəz",
    "showstopping": "ʃəʊstɒpɪŋ",
    "showtime": "ʃəʊtaɪm",
    "showy": "ʃəʊi",
    "shrank": "ʃræŋk",
    "shrapnel": "ʃræpnəl",
    "shredded": "ʃrɛdɪd",
    "shredder": "ʃrɛdɐ",
    "shredders": "ʃrɛdəz",
    "shredding": "ʃrɛdɪŋ",
    "shred": "ʃrɛd",
    "shreds": "ʃrɛdz",
    "shrewder": "ʃruːdɐ",
    "shrewdest": "ʃruːdəst",
    "shrewdly": "ʃruːdli",
    "shrewdness": "ʃruːdnəs",
    "shrewd": "ʃruːd",
    "shrewish": "ʃruːɪʃ",
    "shrews": "ʃruːz",
    "shrew": "ʃruː",
    "shrieked": "ʃriːkt",
    "shriek": "ʃriːk",
    "shrieking": "ʃriːkɪŋ",
    "shrieks": "ʃriːks",
    "shrift": "ʃrɪft",
    "shrike": "ʃraɪk",
    "shriller": "ʃrɪlɐ",
    "shrill": "ʃrɪl",
    "shrills": "ʃrɪlz",
    "shrimper": "ʃrɪmpɐ",
    "shrimpers": "ʃrɪmpəz",
    "shrimping": "ʃrɪmpɪŋ",
    "shrimp": "ʃrɪmp",
    "shrimps": "ʃrɪmps",
    "shrine": "ʃraɪn",
    "shrines": "ʃraɪnz",
    "shrinkage": "ʃrɪŋkɪdʒ",
    "shrinker": "ʃrɪŋkɐ",
    "shrinking": "ʃrɪŋkɪŋ",
    "shrink": "ʃrɪŋk",
    "shrinks": "ʃrɪŋks",
    "shrivelled": "ʃrɪvəld",
    "shrivelling": "ʃrɪvəlɪŋ",
    "shrivels": "ʃrɪvəlz",
    "shrivel": "ʃrɪvəl",
    "shriven": "ʃrɪvən",
    "shroud": "ʃraʊd",
    "shrouded": "ʃraʊdɪd",
    "shrouding": "ʃraʊdɪŋ",
    "shrouds": "ʃraʊdz",
    "shrove": "ʃrəʊv",
    "shrub": "ʃrʌb",
    "shrubberies": "ʃrʌbəriz",
    "shrubbery": "ʃrʌbəri",
    "shrubby": "ʃrʌbi",
    "shrubs": "ʃrʌbz",
    "shrug": "ʃrʌɡ",
    "shrugged": "ʃrʌɡd",
    "shrugging": "ʃrʌɡɪŋ",
    "shrugs": "ʃrʌɡz",
    "shrunken": "ʃrʌŋkən",
    "shrunk": "ʃrʌŋk",
    "shtick": "ɛseɪtʃtɪk",
    "shucked": "ʃʌkt",
    "shucking": "ʃʌkɪŋ",
    "shuck": "ʃʌk",
    "shucks": "ʃʌks",
    "shudder": "ʃʌdɐ",
    "shuddered": "ʃʌdəd",
    "shuddering": "ʃʌdərɪŋ",
    "shudders": "ʃʌdəz",
    "shuffleboard": "ʃʌfəlbɔːd",
    "shuffled": "ʃʌfəld",
    "shuffle": "ʃʌfəl",
    "shuffler": "ʃʌflɐ",
    "shuffles": "ʃʌfəlz",
    "shuffling": "ʃʌflɪŋ",
    "shul": "ʃʌl",
    "shun": "ʃʌn",
    "shunned": "ʃʌnd",
    "shunning": "ʃʌnɪŋ",
    "shuns": "ʃʌnz",
    "shunted": "ʃʌntɪd",
    "shunting": "ʃʌntɪŋ",
    "shunt": "ʃʌnt",
    "shunts": "ʃʌnts",
    "shush": "ʃʌʃ",
    "shushed": "ʃʌʃt",
    "shushes": "ʃʌʃɪz",
    "shushing": "ʃʌʃɪŋ",
    "shutdowns": "ʃʌtdaʊnz",
    "shutdown": "ʃʌtdaʊn",
    "shuteye": "ʃʌtaɪ",
    "shuts": "ʃʌts",
    "shut": "ʃʌt",
    "shuttered": "ʃʌtəd",
    "shuttering": "ʃʌtərɪŋ",
    "shutters": "ʃʌtəz",
    "shutter": "ʃʌtɐ",
    "shutting": "ʃʌtɪŋ",
    "shuttlecocks": "ʃʌtəlkɒks",
    "shuttlecock": "ʃʌtəlkɒk",
    "shuttled": "ʃʌtəld",
    "shuttles": "ʃʌtəlz",
    "shuttle": "ʃʌtəl",
    "shuttling": "ʃʌtlɪŋ",
    "shy": "ʃaɪ",
    "shyer": "ʃaɪɐ",
    "shyest": "ʃaɪəst",
    "shying": "ʃaɪɪŋ",
    "shylock": "ʃaɪlɒk",
    "shyly": "ʃaɪli",
    "shyness": "ʃaɪnəs",
    "shyster": "ʃaɪstɐ",
    "shysters": "ʃaɪstəz",
    "siamang": "saɪəmæŋ",
    "siamangs": "saɪəmæŋz",
    "sibilance": "sɪbɪləns",
    "sibilant": "sɪbɪlənt",
    "sibling": "sɪblɪŋ",
    "siblings": "sɪblɪŋz",
    "sib": "sɪb",
    "sibs": "sɪbz",
    "sibylline": "sɪbɪlaɪn",
    "sibyl": "sɪbɪl",
    "sickbay": "sɪkbeɪ",
    "sickbed": "sɪkbd",
    "sicked": "sɪkt",
    "sickened": "sɪkənd",
    "sickener": "sɪkənɐ",
    "sickeningly": "sɪkənɪŋli",
    "sickening": "sɪkənɪŋ",
    "sicken": "sɪkən",
    "sickens": "sɪkənz",
    "sicker": "sɪkɐ",
    "sickest": "sɪkəst",
    "sickie": "sɪki",
    "sickies": "sɪkiz",
    "sicking": "sɪkɪŋ",
    "sickle": "sɪkəl",
    "sickles": "sɪkəlz",
    "sickly": "sɪkli",
    "sicknesses": "sɪknəsɪz",
    "sickness": "sɪknəs",
    "sicko": "sɪkəʊ",
    "sickos": "sɪkəʊz",
    "sickroom": "sɪkruːm",
    "sick": "sɪk",
    "sicks": "sɪks",
    "sic": "sɪk",
    "sics": "sɪks",
    "sidearm": "saɪdɑːm",
    "sidearms": "saɪdɑːmz",
    "sidebar": "saɪdbɑː",
    "sideboard": "saɪdbɔːd",
    "sideboards": "saɪdbɔːdz",
    "sideburns": "saɪdbɜːnz",
    "sidecar": "saɪdkɑː",
    "sidecars": "saɪdkɑːz",
    "sided": "saɪdɪd",
    "sidekick": "saɪdkɪk",
    "sidekicks": "saɪdkɪks",
    "sidelights": "saɪdlaɪts",
    "sidelined": "saɪdlaɪnd",
    "sideline": "saɪdlaɪn",
    "sidelines": "saɪdlaɪnz",
    "sideling": "saɪdəlɪŋ",
    "sidelining": "saɪdlaɪnɪŋ",
    "sidelong": "saɪdlɒŋ",
    "sideman": "saɪdmən",
    "sidemen": "saɪdmɛn",
    "sidereal": "saɪdiərɪəl",
    "siderite": "saɪdɪraɪt",
    "side": "saɪd",
    "sidesaddle": "saɪdsædəl",
    "sideshow": "saɪdʃəʊ",
    "sideshows": "saɪdʃəʊz",
    "sides": "saɪdz",
    "sidestepped": "saɪdstɛpt",
    "sidestepping": "saɪdstɛpɪŋ",
    "sidestep": "saɪdstɛp",
    "sidesteps": "saɪdstɛps",
    "sideswiped": "saɪdswaɪpt",
    "sideswipe": "saɪdswaɪp",
    "sideswipes": "saɪdswaɪps",
    "sidetracked": "saɪdtrækt",
    "sidetrack": "saɪdtræk",
    "sidetracks": "saɪdtræks",
    "sidewalk": "saɪdwɔːk",
    "sidewalks": "saɪdwɔːks",
    "sidewall": "saɪdwɔːl",
    "sidewalls": "saɪdwɔːlz",
    "sideward": "saɪdwəd",
    "sidewards": "saɪdwədz",
    "sideways": "saɪdweɪz",
    "sidewinder": "saɪdwaɪndɐ",
    "sidewinders": "saɪdwaɪndəz",
    "siding": "saɪdɪŋ",
    "sidings": "saɪdɪŋz",
    "sidled": "saɪdəld",
    "sidle": "saɪdəl",
    "sidles": "saɪdəlz",
    "sidling": "saɪdlɪŋ",
    "siege": "siːdʒ",
    "sieges": "siːdʒɪz",
    "siemens": "siːmɛnz",
    "sienna": "siːɛnɐ",
    "sierra": "siːeərɐ",
    "sierras": "siːeərəz",
    "siesta": "siːɛstɐ",
    "siestas": "siːɛstəz",
    "sieved": "sɪvd",
    "sieves": "sɪvz",
    "sieve": "sɪv",
    "sieving": "sɪvɪŋ",
    "sifted": "sɪftɪd",
    "sifter": "sɪftɐ",
    "sifters": "sɪftəz",
    "sifting": "sɪftɪŋ",
    "sift": "sɪft",
    "sifts": "sɪfts",
    "sighed": "saɪd",
    "sighing": "saɪɪŋ",
    "sigh": "saɪ",
    "sighs": "saɪz",
    "sightedness": "saɪtɪdnəs",
    "sighted": "saɪtɪd",
    "sighting": "saɪtɪŋ",
    "sightings": "saɪtɪŋz",
    "sightless": "saɪtləs",
    "sightly": "saɪtli",
    "sight": "saɪt",
    "sightseeing": "saɪtsiːɪŋ",
    "sightseer": "saɪtsiə",
    "sightseers": "saɪtsiəz",
    "sights": "saɪts",
    "sigma": "sɪɡmɐ",
    "sigmoid": "sɪɡmɔɪd",
    "signage": "saɪnɪdʒ",
    "signalled": "sɪɡnəld",
    "signaller": "sɪɡnɔːlɐ",
    "signallers": "sɪɡnɔːləz",
    "signalling": "sɪɡnəlɪŋ",
    "signally": "sɪɡnəli",
    "signalman": "sɪɡnælmən",
    "signalmen": "sɪɡnɐlmɛn",
    "signal": "sɪɡnəl",
    "signals": "sɪɡnəlz",
    "signatories": "sɪɡnətəriz",
    "signatory": "sɪɡnətəri",
    "signature": "sɪɡnɪtʃɐ",
    "signatures": "sɪɡnɪtʃəz",
    "signed": "saɪnd",
    "signer": "saɪnɐ",
    "signers": "saɪnəz",
    "signet": "sɪɡnɪt",
    "signets": "sɪɡnɪts",
    "significance": "sɪɡnɪfɪkəns",
    "significances": "sɪɡnɪfɪkənsɪz",
    "significantly": "sɪɡnɪfɪkəntli",
    "significant": "sɪɡnɪfɪkənt",
    "signified": "sɪɡnɪfaɪd",
    "signifier": "sɪɡnɪfaɪə",
    "signifies": "sɪɡnɪfaɪz",
    "signifying": "sɪɡnɪfaɪɪŋ",
    "signify": "sɪɡnɪfaɪ",
    "signing": "saɪnɪŋ",
    "signings": "saɪnɪŋz",
    "signora": "sɪnjɔːrɐ",
    "signore": "sɪnjɔː",
    "signories": "sɪnjɔːrɪz",
    "signorina": "sɪnjɔːriːnɐ",
    "signori": "sɪnjɔːri",
    "signor": "sɪnjɔː",
    "signposted": "saɪnpəʊstɪd",
    "signposting": "saɪnpəʊstɪŋ",
    "signpost": "saɪnpəʊst",
    "signposts": "saɪnpəʊsts",
    "sign": "saɪn",
    "signs": "saɪnz",
    "sika": "siːkɐ",
    "silage": "saɪlɪdʒ",
    "silenced": "saɪlənst",
    "silencer": "saɪlənsɐ",
    "silencers": "saɪlənsəz",
    "silence": "saɪləns",
    "silences": "saɪlənsɪz",
    "silencing": "saɪlənsɪŋ",
    "silently": "saɪləntli",
    "silent": "saɪlənt",
    "silents": "saɪlənts",
    "silenus": "saɪlənəs",
    "silesia": "saɪliːziə",
    "silhouetted": "sɪlʊwɛtɪd",
    "silhouette": "sɪlʊwɛt",
    "silhouettes": "sɪlʊwɛts",
    "silica": "sɪlɪkɐ",
    "silicate": "sɪlɪkeɪt",
    "silicone": "sɪlɪkəʊn",
    "silicon": "sɪlɪkən",
    "silicosis": "sɪlɪkəʊsɪs",
    "silken": "sɪlkən",
    "silkier": "sɪlkiɐ",
    "silkiest": "sɪlkiəst",
    "silkiness": "sɪlkinəs",
    "silkscreen": "sɪlkskriːn",
    "silk": "sɪlk",
    "silks": "sɪlks",
    "silkweed": "sɪlkwiːd",
    "silkworm": "sɪlkwɜːm",
    "silkworms": "sɪlkwɜːmz",
    "silky": "sɪlki",
    "sillier": "sɪliɐ",
    "sillies": "sɪliz",
    "silliest": "sɪliəst",
    "silliness": "sɪlinəs",
    "sill": "sɪl",
    "sills": "sɪlz",
    "silly": "sɪli",
    "silo": "saɪləʊ",
    "silos": "saɪləʊz",
    "siltation": "sɪlteɪʃən",
    "silted": "sɪltɪd",
    "silting": "sɪltɪŋ",
    "silt": "sɪlt",
    "silts": "sɪlts",
    "siltstone": "sɪltstəʊn",
    "silty": "sɪlti",
    "silvan": "sɪlvən",
    "silva": "sɪlvɐ",
    "silvered": "sɪlvəd",
    "silverfish": "sɪlvəfɪʃ",
    "silvering": "sɪlvərɪŋ",
    "silverside": "sɪlvəsaɪd",
    "silversides": "sɪlvəsaɪdz",
    "silver": "sɪlvɐ",
    "silversmith": "sɪlvəsmɪθ",
    "silversmiths": "sɪlvəsmɪθs",
    "silvers": "sɪlvəz",
    "silverware": "sɪlvəweə",
    "silvery": "sɪlvəri",
    "sima": "siːmɐ",
    "simba": "sɪmbɐ",
    "simian": "sɪmiən",
    "similarities": "sɪmɪlærɪtiz",
    "similarity": "sɪmɪlærɪti",
    "similarly": "sɪmɪləli",
    "similar": "sɪmɪlɐ",
    "simile": "sɪmɪli",
    "similes": "sɪmɪlɪz",
    "simmered": "sɪməd",
    "simmering": "sɪmərɪŋ",
    "simmer": "sɪmɐ",
    "simmers": "sɪməz",
    "simpatico": "sɪmpætɪkəʊ",
    "simpered": "sɪmpəd",
    "simpering": "sɪmpərɪŋ",
    "simper": "sɪmpɐ",
    "simpers": "sɪmpəz",
    "simpleminded": "sɪmplɪmaɪndɪd",
    "simpleness": "sɪmpəlnəs",
    "simpler": "sɪmplɐ",
    "simple": "sɪmpəl",
    "simplest": "sɪmpləst",
    "simpleton": "sɪmpəltən",
    "simpletons": "sɪmpəltənz",
    "simplex": "sɪmplɛks",
    "simplicities": "sɪmplɪsɪtiz",
    "simplicity": "sɪmplɪsɪti",
    "simplification": "sɪmplɪfɪkeɪʃən",
    "simplifications": "sɪmplɪfɪkeɪʃənz",
    "simplified": "sɪmplɪfaɪd",
    "simplifies": "sɪmplɪfaɪz",
    "simplifying": "sɪmplɪfaɪɪŋ",
    "simplify": "sɪmplɪfaɪ",
    "simplistically": "sɪmplɪstɪkli",
    "simplistic": "sɪmplɪstɪk",
    "simply": "sɪmpli",
    "simp": "sɪmp",
    "simulacrum": "sɪmjʊleɪkrəm",
    "simulant": "sɪmjʊlənt",
    "simulated": "sɪmjʊleɪtɪd",
    "simulate": "sɪmjʊleɪt",
    "simulates": "sɪmjʊleɪts",
    "simulating": "sɪmjʊleɪtɪŋ",
    "simulation": "sɪmjʊleɪʃən",
    "simulations": "sɪmjʊleɪʃənz",
    "simulator": "sɪmjʊleɪtɐ",
    "simulators": "sɪmjʊleɪtəz",
    "simulcast": "sɪməlkɑːst",
    "simultaneity": "sɪməlteɪnɪti",
    "simultaneously": "sɪməlteɪniəsli",
    "simultaneous": "sɪməlteɪniəs",
    "sincerely": "sɪnsiəli",
    "sincere": "sɪnsiə",
    "sincerest": "sɪnsiərəst",
    "sincerity": "sɪnsɛrɪti",
    "since": "sɪns",
    "sine": "saɪn",
    "sines": "saɪnz",
    "sinew": "sɪnjuː",
    "sinews": "sɪnjuːz",
    "sinewy": "sɪnjuːi",
    "sinfonia": "sɪnfəʊniə",
    "sinfonietta": "sɪnfəʊnɪɛtɐ",
    "sinfully": "sɪnfəli",
    "sinfulness": "sɪnfəlnəs",
    "sinful": "sɪnfəl",
    "singable": "sɪŋəbəl",
    "singalong": "sɪŋɡɐlɒŋ",
    "singalongs": "sɪŋɡɐlɒŋz",
    "singed": "sɪndʒd",
    "singeing": "sɪndʒɪŋ",
    "singers": "sɪŋəz",
    "singe": "sɪndʒ",
    "singing": "sɪŋɪŋ",
    "singled": "sɪŋɡəld",
    "singleness": "sɪŋɡəlnəs",
    "single": "sɪŋɡəl",
    "singles": "sɪŋɡəlz",
    "singleton": "sɪŋɡəltən",
    "singletons": "sɪŋɡəltənz",
    "singlet": "sɪŋɡlət",
    "singlets": "sɪŋɡləts",
    "singling": "sɪŋɡəlɪŋ",
    "singly": "sɪŋɡli",
    "sing": "sɪŋ",
    "singsong": "sɪŋsɒŋ",
    "singsongs": "sɪŋsɒŋz",
    "sings": "sɪŋz",
    "singularity": "sɪŋɡjʊlærɪti",
    "singularly": "sɪŋɡjʊləli",
    "singular": "sɪŋɡjʊlɐ",
    "sinisterly": "sɪnɪstəli",
    "sinister": "sɪnɪstɐ",
    "sinker": "sɪŋkɐ",
    "sinkhole": "sɪŋkhəʊl",
    "sinkholes": "sɪŋkhəʊlz",
    "sinking": "sɪŋkɪŋ",
    "sinkings": "sɪŋkɪŋz",
    "sink": "sɪŋk",
    "sinks": "sɪŋks",
    "sinless": "sɪnləs",
    "sinned": "sɪnd",
    "sinner": "sɪnɐ",
    "sinners": "sɪnəz",
    "sinning": "sɪnɪŋ",
    "sinology": "sɪnɒlədʒi",
    "sins": "sɪnz",
    "sinter": "sɪntɐ",
    "sinuous": "sɪnjuːəs",
    "sinuses": "saɪnəsɪz",
    "sinusitis": "sɪnjuːsaɪtɪs",
    "sinus": "saɪnəs",
    "siphoned": "saɪfənd",
    "siphoning": "saɪfənɪŋ",
    "siphonophore": "saɪfənɒfɔː",
    "siphon": "saɪfən",
    "siphons": "saɪfənz",
    "sipped": "sɪpt",
    "sippers": "sɪpəz",
    "sipping": "sɪpɪŋ",
    "sip": "sɪp",
    "sips": "sɪps",
    "sired": "saɪəd",
    "siree": "saɪəriː",
    "siren": "saɪərən",
    "sirens": "saɪərənz",
    "sire": "saɪə",
    "sires": "saɪəz",
    "siring": "saɪərɪŋ",
    "sirloin": "sɜːlɔɪn",
    "sirloins": "sɜːlɔɪnz",
    "sirocco": "sɪrɒkəʊ",
    "sirrah": "sɜːrɐ",
    "sirree": "sɜːriː",
    "sir": "sɜː",
    "sirs": "sɜːz",
    "sisal": "sɪsəl",
    "si": "siː",
    "siskin": "sɪskɪn",
    "siskins": "sɪskɪnz",
    "sissies": "sɪsɪz",
    "sis": "sɪs",
    "sissy": "sɪsi",
    "sisterhoods": "sɪstəhʊdz",
    "sisterhood": "sɪstəhʊd",
    "sisterly": "sɪstəli",
    "sisters": "sɪstəz",
    "sister": "sɪstɐ",
    "sitars": "sɪtəz",
    "sitar": "sɪtɐ",
    "sitcoms": "sɪtkɒmz",
    "sitcom": "sɪtkɒm",
    "sited": "saɪtɪd",
    "site": "saɪt",
    "sites": "saɪts",
    "siting": "saɪtɪŋ",
    "sits": "sɪts",
    "sit": "sɪt",
    "sitters": "sɪtəz",
    "sitter": "sɪtɐ",
    "sittings": "sɪtɪŋz",
    "sitting": "sɪtɪŋ",
    "situated": "sɪtʃuːeɪtɪd",
    "situates": "sɪtʃuːeɪts",
    "situate": "sɪtʃuːeɪt",
    "situating": "sɪtʃuːeɪtɪŋ",
    "situational": "sɪtʃuːeɪʃənəl",
    "situationism": "sɪtʃuːeɪʃənɪzəm",
    "situationist": "sɪtʃuːeɪʃənɪst",
    "situations": "sɪtʃuːeɪʃənz",
    "situation": "sɪtʃuːeɪʃən",
    "situs": "sɪtəs",
    "sixes": "sɪksɪz",
    "sixfold": "sɪksfəʊld",
    "sixpence": "sɪkspəns",
    "sixpences": "sɪkspənsɪz",
    "sixpenny": "sɪkspəni",
    "six": "sɪks",
    "sixteen": "sɪkstiːn",
    "sixteens": "sɪkstiːnz",
    "sixteenth": "sɪkstiːnθ",
    "sixth": "sɪksθ",
    "sixths": "sɪksθs",
    "sixties": "sɪkstɪz",
    "sixty": "sɪksti",
    "sizable": "saɪzəbəl",
    "sizeable": "saɪzəbəl",
    "sized": "saɪzd",
    "sizer": "saɪzɐ",
    "size": "saɪz",
    "sizes": "saɪzɪz",
    "sizing": "saɪzɪŋ",
    "sizzled": "sɪzəld",
    "sizzlers": "sɪzləz",
    "sizzler": "sɪzlɐ",
    "sizzles": "sɪzəlz",
    "sizzle": "sɪzəl",
    "sizzling": "sɪzlɪŋ",
    "ska": "skɑː",
    "skateboarder": "skeɪtbɔːdɐ",
    "skateboarders": "skeɪtbɔːdəz",
    "skateboarding": "skeɪtbɔːdɪŋ",
    "skateboard": "skeɪtbɔːd",
    "skateboards": "skeɪtbɔːdz",
    "skated": "skeɪtɪd",
    "skater": "skeɪtɐ",
    "skaters": "skeɪtəz",
    "skate": "skeɪt",
    "skates": "skeɪts",
    "skating": "skeɪtɪŋ",
    "skatole": "skætəʊl",
    "skat": "skæt",
    "skedaddled": "skɛdædəld",
    "skedaddle": "skɛdædəl",
    "skeeter": "skiːtɐ",
    "skeet": "skiːt",
    "skeg": "skɛɡ",
    "skein": "skeɪn",
    "skeins": "skeɪnz",
    "skeletal": "skɛlɪtəl",
    "skeleton": "skɛlɪtən",
    "skeletons": "skɛlɪtənz",
    "skelp": "skɛlp",
    "skep": "skɛp",
    "skeps": "skɛps",
    "skerries": "skɛrɪz",
    "skerry": "skɛri",
    "sketchbook": "skɛtʃbʊk",
    "sketchbooks": "skɛtʃbʊks",
    "sketched": "skɛtʃt",
    "sketcher": "skɛtʃɐ",
    "sketches": "skɛtʃɪz",
    "sketchier": "skɛtʃɪɐ",
    "sketchily": "skɛtʃɪli",
    "sketchiness": "skɛtʃɪnəs",
    "sketching": "skɛtʃɪŋ",
    "sketchpad": "skɛtʃpæd",
    "sketch": "skɛtʃ",
    "sketchy": "skɛtʃi",
    "skewbald": "skjuːbɔːld",
    "skewed": "skjuːd",
    "skewered": "skjuːəd",
    "skewering": "skjuːərɪŋ",
    "skewer": "skjuːɐ",
    "skewers": "skjuːəz",
    "skewing": "skjuːɪŋ",
    "skew": "skjuː",
    "skews": "skjuːz",
    "skidded": "skɪdɪd",
    "skidding": "skɪdɪŋ",
    "skidpan": "skɪdpæn",
    "skid": "skɪd",
    "skids": "skɪdz",
    "skies": "skaɪz",
    "skiffle": "skɪfəl",
    "skiff": "skɪf",
    "skiffs": "skɪfs",
    "skiing": "skiːɪŋ",
    "skilfully": "skɪlfəli",
    "skilful": "skɪlfəl",
    "skilled": "skɪld",
    "skillet": "skɪlɪt",
    "skillfully": "skɪlfəli",
    "skillful": "skɪlfəl",
    "skilling": "skɪlɪŋ",
    "skill": "skɪl",
    "skills": "skɪlz",
    "skimmed": "skɪmd",
    "skimmer": "skɪmɐ",
    "skimmers": "skɪməz",
    "skimmia": "skɪmiɐ",
    "skimming": "skɪmɪŋ",
    "skimped": "skɪmpt",
    "skimpier": "skɪmpɪɐ",
    "skimping": "skɪmpɪŋ",
    "skimp": "skɪmp",
    "skimpy": "skɪmpi",
    "skim": "skɪm",
    "skims": "skɪmz",
    "skincare": "skɪnkeə",
    "skinflint": "skɪnflɪnt",
    "skinflints": "skɪnflɪnts",
    "skinful": "skɪnfəl",
    "skinhead": "skɪnhɛd",
    "skinheads": "skɪnhɛdz",
    "skink": "skɪŋk",
    "skinks": "skɪŋks",
    "skinless": "skɪnləs",
    "skinned": "skɪnd",
    "skinner": "skɪnɐ",
    "skinners": "skɪnəz",
    "skinnier": "skɪnɪɐ",
    "skinniest": "skɪnɪəst",
    "skinning": "skɪnɪŋ",
    "skinny": "skɪni",
    "skin": "skɪn",
    "skins": "skɪnz",
    "skintight": "skɪntaɪt",
    "skint": "skɪnt",
    "skipjack": "skɪpdʒæk",
    "skipped": "skɪpt",
    "skippered": "skɪpəd",
    "skippering": "skɪpərɪŋ",
    "skipper": "skɪpɐ",
    "skippers": "skɪpəz",
    "skipping": "skɪpɪŋ",
    "skip": "skɪp",
    "skips": "skɪps",
    "skirling": "skɜːlɪŋ",
    "skirl": "skɜːl",
    "skirmished": "skɜːmɪʃt",
    "skirmishers": "skɜːmɪʃəz",
    "skirmishes": "skɜːmɪʃɪz",
    "skirmishing": "skɜːmɪʃɪŋ",
    "skirmish": "skɜːmɪʃ",
    "skirret": "skɜːrɪt",
    "skirted": "skɜːtɪd",
    "skirting": "skɜːtɪŋ",
    "skirt": "skɜːt",
    "skirts": "skɜːts",
    "ski": "skiː",
    "skis": "skiːz",
    "skite": "skaɪt",
    "skit": "skɪt",
    "skits": "skɪts",
    "skittered": "skɪtəd",
    "skittering": "skɪtərɪŋ",
    "skitter": "skɪtɐ",
    "skitters": "skɪtəz",
    "skittish": "skɪtɪʃ",
    "skittled": "skɪtəld",
    "skittle": "skɪtəl",
    "skittles": "skɪtəlz",
    "skittling": "skɪtlɪŋ",
    "skived": "skaɪvd",
    "skiver": "skaɪvɐ",
    "skivers": "skaɪvəz",
    "skive": "skaɪv",
    "skives": "skaɪvz",
    "skiving": "skaɪvɪŋ",
    "skivvied": "skɪvɪd",
    "skivvies": "skɪvɪz",
    "skivvying": "skɪvɪɪŋ",
    "skivvy": "skɪvi",
    "skol": "skɒl",
    "skua": "skuːɐ",
    "skuas": "skuːəz",
    "skulduggery": "skʌldəɡəri",
    "skulked": "skʌlkt",
    "skulker": "skʌlkɐ",
    "skulking": "skʌlkɪŋ",
    "skulk": "skʌlk",
    "skulks": "skʌlks",
    "skullcap": "skʌlkæp",
    "skullduggery": "skʌldəɡəri",
    "skull": "skʌl",
    "skulls": "skʌlz",
    "skunk": "skʌŋk",
    "skunks": "skʌŋks",
    "skydived": "skaɪdaɪvd",
    "skydiver": "skaɪdaɪvɐ",
    "skydivers": "skaɪdaɪvəz",
    "skydive": "skaɪdaɪv",
    "skydives": "skaɪdaɪvz",
    "skydiving": "skaɪdaɪvɪŋ",
    "skyed": "skaɪd",
    "skyhook": "skaɪhʊk",
    "skying": "skaɪɪŋ",
    "skylarking": "skaɪlɑːkɪŋ",
    "skylark": "skaɪlɑːk",
    "skylarks": "skaɪlɑːks",
    "skylight": "skaɪlaɪt",
    "skylights": "skaɪlaɪts",
    "skyline": "skaɪlaɪn",
    "skylines": "skaɪlaɪnz",
    "skyrocketed": "skaɪrɒkɪtɪd",
    "skyrocketing": "skaɪrəkɪtɪŋ",
    "skyrocket": "skaɪrɒkɪt",
    "skyrockets": "skaɪrɒkɪts",
    "skyscape": "skaɪskeɪp",
    "skyscraper": "skaɪskreɪpɐ",
    "skyscrapers": "skaɪskreɪpəz",
    "sky": "skaɪ",
    "skyward": "skaɪwəd",
    "skywards": "skaɪwədz",
    "skyway": "skaɪweɪ",
    "skywriting": "skaɪraɪtɪŋ",
    "slabbed": "slæbd",
    "slabbering": "slæbərɪŋ",
    "slabber": "slæbɐ",
    "slab": "slæb",
    "slabs": "slæbz",
    "slacked": "slækt",
    "slackened": "slækənd",
    "slackening": "slækənɪŋ",
    "slacken": "slækən",
    "slackens": "slækənz",
    "slacker": "slækɐ",
    "slackers": "slækəz",
    "slacking": "slækɪŋ",
    "slackly": "slækli",
    "slackness": "slæknəs",
    "slack": "slæk",
    "slacks": "slæks",
    "slagged": "slæɡd",
    "slagging": "slæɡɪŋ",
    "slaggy": "slæɡi",
    "slag": "slæɡ",
    "slags": "slæɡz",
    "slain": "sleɪn",
    "slaked": "sleɪkt",
    "slake": "sleɪk",
    "slaking": "sleɪkɪŋ",
    "slaloming": "slæləmɪŋ",
    "slalom": "slæləm",
    "slaloms": "slæləmz",
    "slammed": "slæmd",
    "slammer": "slæmɐ",
    "slammers": "slæməz",
    "slamming": "slæmɪŋ",
    "slam": "slæm",
    "slams": "slæmz",
    "slandered": "slɑːndəd",
    "slanderer": "slɑːndərɐ",
    "slandering": "slɑːndərɪŋ",
    "slanderous": "slɑːndərəs",
    "slander": "slɑːndɐ",
    "slanders": "slɑːndəz",
    "slanging": "slæŋɪŋ",
    "slang": "slæŋ",
    "slangy": "slæŋi",
    "slanted": "slɑːntɪd",
    "slanting": "slɑːntɪŋ",
    "slant": "slɑːnt",
    "slants": "slɑːnts",
    "slapdash": "slæpdæʃ",
    "slapped": "slæpt",
    "slapper": "slæpɐ",
    "slappers": "slæpəz",
    "slapping": "slæpɪŋ",
    "slap": "slæp",
    "slaps": "slæps",
    "slapstick": "slæpstɪk",
    "slashed": "slæʃt",
    "slasher": "slæʃɐ",
    "slashes": "slæʃɪz",
    "slashing": "slæʃɪŋ",
    "slash": "slæʃ",
    "slated": "sleɪtɪd",
    "slater": "sleɪtɐ",
    "slaters": "sleɪtəz",
    "slate": "sleɪt",
    "slates": "sleɪts",
    "slathered": "slɑːðəd",
    "slathering": "slɑːðərɪŋ",
    "slather": "slɑːðɐ",
    "slating": "sleɪtɪŋ",
    "slat": "slæt",
    "slats": "slæts",
    "slatted": "slætɪd",
    "slatternly": "slætənli",
    "slattern": "slætən",
    "slatterns": "slætənz",
    "slaughtered": "slɔːtəd",
    "slaughterer": "slɔːtərɐ",
    "slaughterhouse": "slɔːtəhaʊs",
    "slaughterhouses": "slɔːtəhaʊzɪz",
    "slaughtering": "slɔːtərɪŋ",
    "slaughter": "slɔːtɐ",
    "slaughters": "slɔːtəz",
    "slaved": "sleɪvd",
    "slaveholders": "sleɪvhəʊldəz",
    "slavering": "slævərɪŋ",
    "slavery": "sleɪvəri",
    "slave": "sleɪv",
    "slaves": "sleɪvz",
    "slaving": "sleɪvɪŋ",
    "slavishly": "sleɪvɪʃli",
    "slavish": "sleɪvɪʃ",
    "slaw": "slɔː",
    "slayed": "sleɪd",
    "slayer": "sleɪɐ",
    "slayers": "sleɪəz",
    "slaying": "sleɪɪŋ",
    "slayings": "sleɪɪŋz",
    "slay": "sleɪ",
    "slays": "sleɪz",
    "sleazebag": "sliːzɪbæɡ",
    "sleazeball": "sliːzɪbɔːl",
    "sleaze": "sliːz",
    "sleazier": "sliːzɪɐ",
    "sleazy": "sliːzi",
    "sledding": "slɛdɪŋ",
    "sledged": "slɛdʒd",
    "sledgehammer": "slɛdʒhæmɐ",
    "sledgehammers": "slɛdʒhæməz",
    "sledge": "slɛdʒ",
    "sledges": "slɛdʒɪz",
    "sledging": "slɛdʒɪŋ",
    "sled": "slɛd",
    "sleds": "slɛdz",
    "sleeker": "sliːkɐ",
    "sleekit": "sliːkɪt",
    "sleekness": "sliːknəs",
    "sleek": "sliːk",
    "sleeper": "sliːpɐ",
    "sleepers": "sliːpəz",
    "sleepier": "sliːpɪɐ",
    "sleepiest": "sliːpɪəst",
    "sleepily": "sliːpɪli",
    "sleepiness": "sliːpɪnəs",
    "sleeping": "sliːpɪŋ",
    "sleeplessness": "sliːpləsnəs",
    "sleepless": "sliːpləs",
    "sleepover": "sliːpəʊvɐ",
    "sleepovers": "sliːpəʊvəz",
    "sleep": "sliːp",
    "sleeps": "sliːps",
    "sleepwalked": "sliːpwɔːkt",
    "sleepwalker": "sliːpwɔːkɐ",
    "sleepwalkers": "sliːpwɔːkəz",
    "sleepwalking": "sliːpwɔːkɪŋ",
    "sleepwalk": "sliːpwɔːk",
    "sleepwalks": "sliːpwɔːks",
    "sleepwear": "sliːpweə",
    "sleepyhead": "sliːpɪhɛd",
    "sleepy": "sliːpi",
    "sleeting": "sliːtɪŋ",
    "sleet": "sliːt",
    "sleety": "sliːti",
    "sleeved": "sliːvd",
    "sleeveless": "sliːvləs",
    "sleeve": "sliːv",
    "sleeves": "sliːvz",
    "sleighed": "sleɪd",
    "sleighing": "sleɪɪŋ",
    "sleigh": "sleɪ",
    "sleighs": "sleɪz",
    "sleight": "slaɪt",
    "sleights": "slaɪts",
    "slenderer": "slɛndərɐ",
    "slenderest": "slɛndərəst",
    "slenderness": "slɛndənəs",
    "slender": "slɛndɐ",
    "slept": "slɛpt",
    "sleuthing": "sluːθɪŋ",
    "sleuth": "sluːθ",
    "sleuths": "sluːθs",
    "slewed": "sluːd",
    "slewing": "sluːɪŋ",
    "slew": "sluː",
    "slews": "sluːz",
    "sliced": "slaɪst",
    "slicer": "slaɪsɐ",
    "slicers": "slaɪsəz",
    "slice": "slaɪs",
    "slices": "slaɪsɪz",
    "slicing": "slaɪsɪŋ",
    "slicked": "slɪkt",
    "slicker": "slɪkɐ",
    "slickers": "slɪkəz",
    "slickest": "slɪkəst",
    "slickly": "slɪkli",
    "slickness": "slɪknəs",
    "slick": "slɪk",
    "slicks": "slɪks",
    "slider": "slaɪdɐ",
    "sliders": "slaɪdəz",
    "slide": "slaɪd",
    "slides": "slaɪdz",
    "sliding": "slaɪdɪŋ",
    "slid": "slɪd",
    "slighted": "slaɪtɪd",
    "slighter": "slaɪtɐ",
    "slightest": "slaɪtəst",
    "slightingly": "slaɪtɪŋli",
    "slighting": "slaɪtɪŋ",
    "slightly": "slaɪtli",
    "slight": "slaɪt",
    "slights": "slaɪts",
    "slime": "slaɪm",
    "slimes": "slaɪmz",
    "slimier": "slaɪmɪɐ",
    "slimiest": "slaɪmɪəst",
    "sliminess": "slaɪmɪnəs",
    "slimline": "slɪmlaɪn",
    "slimly": "slɪmli",
    "slimmed": "slɪmd",
    "slimmer": "slɪmɐ",
    "slimmers": "slɪməz",
    "slimmest": "slɪməst",
    "slimming": "slɪmɪŋ",
    "slimness": "slɪmnəs",
    "slim": "slɪm",
    "slims": "slɪmz",
    "slimy": "slaɪmi",
    "slingback": "slɪŋbæk",
    "slingbacks": "slɪŋbæks",
    "slinger": "slɪŋɡɐ",
    "slingers": "slɪŋɡəz",
    "slinging": "slɪŋɪŋ",
    "slingshot": "slɪŋʃɒt",
    "slingshots": "slɪŋʃɒts",
    "sling": "slɪŋ",
    "slings": "slɪŋz",
    "slinking": "slɪŋkɪŋ",
    "slink": "slɪŋk",
    "slinks": "slɪŋks",
    "slinky": "slɪŋki",
    "slipknot": "slɪpknɒt",
    "slipover": "slɪpəʊvɐ",
    "slippage": "slɪpɪdʒ",
    "slipped": "slɪpt",
    "slipperier": "slɪpəriɐ",
    "slipperiest": "slɪpiərɪəst",
    "slipperiness": "slɪpərinəs",
    "slipper": "slɪpɐ",
    "slippers": "slɪpəz",
    "slippery": "slɪpəri",
    "slippier": "slɪpɪɐ",
    "slipping": "slɪpɪŋ",
    "slippy": "slɪpi",
    "slipshod": "slɪpʃɒd",
    "slip": "slɪp",
    "slips": "slɪps",
    "slipstream": "slɪpstriːm",
    "slipway": "slɪpweɪ",
    "slipways": "slɪpweɪz",
    "slithered": "slɪðəd",
    "slithering": "slɪðərɪŋ",
    "slither": "slɪðɐ",
    "slithers": "slɪðəz",
    "slithery": "slɪðəri",
    "slit": "slɪt",
    "slits": "slɪts",
    "slitter": "slɪtɐ",
    "slitting": "slɪtɪŋ",
    "slivered": "slɪvəd",
    "slivering": "slɪvərɪŋ",
    "slivers": "slɪvəz",
    "slivovitz": "slɪvəvɪts",
    "slobbered": "slɒbəd",
    "slobbering": "slɒbərɪŋ",
    "slobber": "slɒbɐ",
    "slobbers": "slɒbəz",
    "slobbery": "slɒbəri",
    "slobbing": "slɒbɪŋ",
    "slob": "slɒb",
    "slobs": "slɒbz",
    "sloe": "sləʊ",
    "sloes": "sləʊz",
    "sloganeering": "slɒɡɐniərɪŋ",
    "slogan": "sləʊɡən",
    "slogans": "sləʊɡənz",
    "slogged": "slɒɡd",
    "slogging": "slɒɡɪŋ",
    "slog": "slɒɡ",
    "slogs": "slɒɡz",
    "sloop": "sluːp",
    "sloops": "sluːps",
    "sloped": "sləʊpt",
    "slope": "sləʊp",
    "slopes": "sləʊps",
    "sloping": "sləʊpɪŋ",
    "slopped": "slɒpt",
    "sloppier": "slɒpɪɐ",
    "sloppily": "slɒpɪli",
    "sloppiness": "slɒpɪnəs",
    "slopping": "slɒpɪŋ",
    "sloppy": "slɒpi",
    "slop": "slɒp",
    "slops": "slɒps",
    "sloshed": "slɒʃt",
    "sloshes": "slɒʃɪz",
    "sloshing": "slɒʃɪŋ",
    "slosh": "slɒʃ",
    "sloshy": "slɒʃi",
    "slothfulness": "slɒθfəlnəs",
    "slothful": "slɒθfəl",
    "sloth": "slɒθ",
    "sloths": "slɒθs",
    "slot": "slɒt",
    "slots": "slɒts",
    "slotted": "slɒtɪd",
    "slotting": "slɒtɪŋ",
    "slouched": "slaʊtʃt",
    "slouches": "slaʊtʃɪz",
    "slouching": "slaʊtʃɪŋ",
    "slouch": "slaʊtʃ",
    "slouchy": "slaʊtʃi",
    "sloughed": "slʌfd",
    "sloughing": "slʌfɪŋ",
    "slovenliness": "slʌvənlinəs",
    "slovenly": "slʌvənli",
    "slowcoaches": "sləʊkəʊtʃɪz",
    "slowcoach": "sləʊkəʊtʃ",
    "slowdown": "sləʊdaʊn",
    "slowdowns": "sləʊdaʊnz",
    "slowed": "sləʊd",
    "slower": "sləʊɐ",
    "slowest": "sləʊəst",
    "slowing": "sləʊɪŋ",
    "slowish": "sləʊɪʃ",
    "slowly": "sləʊli",
    "slowness": "sləʊnəs",
    "slowpoke": "sləʊpəʊk",
    "slow": "sləʊ",
    "slows": "sləʊz",
    "slowworm": "sləʊwɜːm",
    "slowworms": "sləʊwɜːmz",
    "slub": "slʌb",
    "sludge": "slʌdʒ",
    "sludgy": "slʌdʒi",
    "sluggard": "slʌɡəd",
    "slugged": "slʌɡd",
    "slugger": "slʌɡɐ",
    "slugging": "slʌɡɪŋ",
    "sluggishly": "slʌɡɪʃli",
    "sluggishness": "slʌɡɪʃnəs",
    "sluggish": "slʌɡɪʃ",
    "slug": "slʌɡ",
    "slugs": "slʌɡz",
    "sluiced": "sluːst",
    "sluice": "sluːs",
    "sluices": "sluːsɪz",
    "sluicing": "sluːsɪŋ",
    "slumbered": "slʌmbəd",
    "slumbering": "slʌmbərɪŋ",
    "slumber": "slʌmbɐ",
    "slumbers": "slʌmbəz",
    "slumlord": "slʌmlɔːd",
    "slumming": "slʌmɪŋ",
    "slummy": "slʌmi",
    "slumped": "slʌmpt",
    "slumping": "slʌmpɪŋ",
    "slump": "slʌmp",
    "slumps": "slʌmps",
    "slum": "slʌm",
    "slums": "slʌmz",
    "slung": "slʌŋ",
    "slunk": "slʌŋk",
    "slurped": "slɜːpt",
    "slurping": "slɜːpɪŋ",
    "slurp": "slɜːp",
    "slurps": "slɜːps",
    "slurred": "slɜːd",
    "slurring": "slɜːrɪŋ",
    "slurry": "slʌri",
    "slur": "slɜː",
    "slurs": "slɜːz",
    "slush": "slʌʃ",
    "slushy": "slʌʃi",
    "slut": "slʌt",
    "sluts": "slʌts",
    "sluttier": "slʌtɪɐ",
    "sluttish": "slʌtɪʃ",
    "slutty": "slʌti",
    "slyly": "slaɪli",
    "sly": "slaɪ",
    "smacked": "smækt",
    "smacker": "smækɐ",
    "smackers": "smækəz",
    "smacking": "smækɪŋ",
    "smack": "smæk",
    "smacks": "smæks",
    "smaller": "smɔːlɐ",
    "smallest": "smɔːləst",
    "smallholder": "smɔːlhəʊldɐ",
    "smallholders": "smɔːlhəʊldəz",
    "smallholding": "smɔːlhəʊldɪŋ",
    "smallholdings": "smɔːlhəʊldɪŋz",
    "smallish": "smɔːlɪʃ",
    "smallness": "smɔːlnəs",
    "smallpox": "smɔːlpɒks",
    "small": "smɔːl",
    "smalls": "smɔːlz",
    "smarm": "smɑːm",
    "smarmy": "smɑːmi",
    "smarted": "smɑːtɪd",
    "smartened": "smɑːtənd",
    "smartening": "smɑːtənɪŋ",
    "smarten": "smɑːtən",
    "smartens": "smɑːtənz",
    "smarter": "smɑːtɐ",
    "smartest": "smɑːtəst",
    "smarties": "smɑːtɪz",
    "smarting": "smɑːtɪŋ",
    "smartly": "smɑːtli",
    "smartness": "smɑːtnəs",
    "smart": "smɑːt",
    "smarts": "smɑːts",
    "smartypants": "smɑːtɪpənts",
    "smarty": "smɑːti",
    "smashed": "smæʃt",
    "smasher": "smæʃɐ",
    "smashers": "smæʃəz",
    "smashes": "smæʃɪz",
    "smashing": "smæʃɪŋ",
    "smash": "smæʃ",
    "smattering": "smætərɪŋ",
    "smeared": "smiəd",
    "smearing": "smiərɪŋ",
    "smear": "smiə",
    "smears": "smiəz",
    "smeary": "smiəri",
    "smelled": "smɛld",
    "smellier": "smɛliɐ",
    "smelliest": "smɛliəst",
    "smelliness": "smɛlinəs",
    "smelling": "smɛlɪŋ",
    "smell": "smɛl",
    "smells": "smɛlz",
    "smelly": "smɛli",
    "smelted": "smɛltɪd",
    "smelter": "smɛltɐ",
    "smelters": "smɛltəz",
    "smelting": "smɛltɪŋ",
    "smelt": "smɛlt",
    "smew": "smjuː",
    "smidgen": "smɪdʒən",
    "smidgeon": "smɪdʒɒn",
    "smidge": "smɪdʒ",
    "smiled": "smaɪld",
    "smiler": "smaɪlɐ",
    "smile": "smaɪl",
    "smiles": "smaɪlz",
    "smiley": "smaɪli",
    "smileys": "smaɪlɪz",
    "smilingly": "smaɪlɪŋli",
    "smiling": "smaɪlɪŋ",
    "smirched": "smɜːtʃt",
    "smirked": "smɜːkt",
    "smirker": "smɜːkɐ",
    "smirking": "smɜːkɪŋ",
    "smirk": "smɜːk",
    "smirks": "smɜːks",
    "smirky": "smɜːki",
    "smite": "smaɪt",
    "smites": "smaɪts",
    "smithereens": "smɪθəriːnz",
    "smithies": "smɪθɪz",
    "smith": "smɪθ",
    "smiths": "smɪθs",
    "smithy": "smɪθi",
    "smiting": "smaɪtɪŋ",
    "smit": "smɪt",
    "smitten": "smɪtən",
    "smocked": "smɒkt",
    "smocking": "smɒkɪŋ",
    "smock": "smɒk",
    "smocks": "smɒks",
    "smoggy": "smɒɡi",
    "smog": "smɒɡ",
    "smogs": "smɒɡz",
    "smoked": "sməʊkt",
    "smokehouse": "sməʊkhaʊs",
    "smokehouses": "sməʊkhaʊzɪz",
    "smokeless": "sməʊkləs",
    "smoker": "sməʊkɐ",
    "smokers": "sməʊkəz",
    "smokescreen": "sməʊkskriːn",
    "smokescreens": "sməʊkskriːnz",
    "smoke": "sməʊk",
    "smokes": "sməʊks",
    "smokestack": "sməʊkstæk",
    "smokestacks": "sməʊkstæks",
    "smokey": "sməʊki",
    "smokier": "sməʊkɪɐ",
    "smokiness": "sməʊkɪnəs",
    "smoking": "sməʊkɪŋ",
    "smoky": "sməʊki",
    "smoldering": "sməʊldərɪŋ",
    "smolt": "sməʊlt",
    "smooched": "smuːtʃt",
    "smooches": "smuːtʃɪz",
    "smooching": "smuːtʃɪŋ",
    "smooch": "smuːtʃ",
    "smoochy": "smuːtʃi",
    "smoothed": "smuːðd",
    "smoother": "smuːðɐ",
    "smoothers": "smuːðəz",
    "smoothes": "smuːðz",
    "smoothest": "smuːðəst",
    "smoothie": "smuːði",
    "smoothies": "smuːðɪz",
    "smoothing": "smuːðɪŋ",
    "smoothly": "smuːðli",
    "smoothness": "smuːðnəs",
    "smooth": "smuːð",
    "smooths": "smuːðs",
    "smoothy": "smuːði",
    "smote": "sməʊt",
    "smothered": "smʌðəd",
    "smothering": "smʌðərɪŋ",
    "smother": "smʌðɐ",
    "smothers": "smʌðəz",
    "smouldered": "sməʊldəd",
    "smouldering": "sməʊldərɪŋ",
    "smoulder": "sməʊldɐ",
    "smoulders": "sməʊldəz",
    "smriti": "ɛsɛmriːti",
    "smudged": "smʌdʒd",
    "smudge": "smʌdʒ",
    "smudges": "smʌdʒɪz",
    "smudging": "smʌdʒɪŋ",
    "smudgy": "smʌdʒi",
    "smugger": "smʌɡɐ",
    "smuggest": "smʌɡəst",
    "smuggled": "smʌɡəld",
    "smuggler": "smʌɡlɐ",
    "smugglers": "smʌɡləz",
    "smuggle": "smʌɡəl",
    "smuggles": "smʌɡəlz",
    "smuggling": "smʌɡlɪŋ",
    "smugly": "smʌɡli",
    "smugness": "smʌɡnəs",
    "smug": "smʌɡ",
    "smut": "smʌt",
    "smuts": "smʌts",
    "smuttiness": "smʌtɪnəs",
    "smutty": "smʌti",
    "snacked": "snækt",
    "snacking": "snækɪŋ",
    "snack": "snæk",
    "snacks": "snæks",
    "snaffled": "snæfəld",
    "snaffle": "snæfəl",
    "snaffling": "snæflɪŋ",
    "snafu": "snæfuː",
    "snagged": "snæɡd",
    "snagging": "snæɡɪŋ",
    "snaggletooth": "snæɡəltuːθ",
    "snag": "snæɡ",
    "snags": "snæɡz",
    "snail": "sneɪl",
    "snails": "sneɪlz",
    "snakebite": "sneɪkbaɪt",
    "snakebites": "sneɪkbaɪts",
    "snaked": "sneɪkt",
    "snakelike": "sneɪklaɪk",
    "snakeskin": "sneɪkskɪn",
    "snake": "sneɪk",
    "snakes": "sneɪks",
    "snaking": "sneɪkɪŋ",
    "snaky": "sneɪki",
    "snapback": "snæpbæk",
    "snapdragon": "snæpdræɡən",
    "snapdragons": "snæpdræɡənz",
    "snapped": "snæpt",
    "snapper": "snæpɐ",
    "snappers": "snæpəz",
    "snappier": "snæpɪɐ",
    "snappiest": "snæpɪəst",
    "snappily": "snæpɪli",
    "snapping": "snæpɪŋ",
    "snappy": "snæpi",
    "snapshot": "snæpʃɒt",
    "snapshots": "snæpʃɒts",
    "snap": "snæp",
    "snaps": "snæps",
    "snared": "sneəd",
    "snare": "sneə",
    "snares": "sneəz",
    "snaring": "sneərɪŋ",
    "snarled": "snɑːld",
    "snarling": "snɑːlɪŋ",
    "snarl": "snɑːl",
    "snarls": "snɑːlz",
    "snarly": "snɑːli",
    "snatched": "snætʃt",
    "snatcher": "snætʃɐ",
    "snatchers": "snætʃəz",
    "snatches": "snætʃɪz",
    "snatching": "snætʃɪŋ",
    "snatch": "snætʃ",
    "snatchy": "snætʃi",
    "snazzier": "snæzɪɐ",
    "snazziest": "snæzɪəst",
    "snazzy": "snæzi",
    "sneaked": "sniːkt",
    "sneaker": "sniːkɐ",
    "sneakers": "sniːkəz",
    "sneakier": "sniːkɪɐ",
    "sneakiest": "sniːkɪəst",
    "sneakily": "sniːkɪli",
    "sneakiness": "sniːkɪnəs",
    "sneaking": "sniːkɪŋ",
    "sneak": "sniːk",
    "sneaks": "sniːks",
    "sneaky": "sniːki",
    "sneck": "snɛk",
    "sneered": "sniəd",
    "sneeringly": "sniərɪŋli",
    "sneering": "sniərɪŋ",
    "sneer": "sniə",
    "sneers": "sniəz",
    "sneezed": "sniːzd",
    "sneeze": "sniːz",
    "sneezes": "sniːzɪz",
    "sneezing": "sniːzɪŋ",
    "snickering": "snɪkərɪŋ",
    "snicker": "snɪkɐ",
    "snickers": "snɪkəz",
    "snick": "snɪk",
    "snicks": "snɪks",
    "snidely": "snaɪdli",
    "snider": "snaɪdɐ",
    "snide": "snaɪd",
    "snidey": "snaɪdi",
    "sniffed": "snɪft",
    "sniffer": "snɪfɐ",
    "sniffers": "snɪfəz",
    "sniffing": "snɪfɪŋ",
    "sniffled": "snɪfəld",
    "sniffle": "snɪfəl",
    "sniffles": "snɪfəlz",
    "sniffling": "snɪflɪŋ",
    "sniff": "snɪf",
    "sniffs": "snɪfs",
    "sniffy": "snɪfi",
    "snifter": "snɪftɐ",
    "snifters": "snɪftəz",
    "sniggered": "snɪɡəd",
    "sniggerer": "snɪɡərɐ",
    "sniggering": "snɪɡərɪŋ",
    "snigger": "snɪɡɐ",
    "sniggers": "snɪɡəz",
    "sniggle": "snɪɡəl",
    "sniped": "snaɪpt",
    "sniper": "snaɪpɐ",
    "snipers": "snaɪpəz",
    "snipe": "snaɪp",
    "snipes": "snaɪps",
    "sniping": "snaɪpɪŋ",
    "snipped": "snɪpt",
    "snippet": "snɪpɪt",
    "snippets": "snɪpɪts",
    "snipping": "snɪpɪŋ",
    "snippy": "snɪpi",
    "snip": "snɪp",
    "snips": "snɪps",
    "snitched": "snɪtʃt",
    "snitches": "snɪtʃɪz",
    "snitching": "snɪtʃɪŋ",
    "snitch": "snɪtʃ",
    "snit": "snɪt",
    "snivelling": "snɪvəlɪŋ",
    "snivel": "snɪvəl",
    "snobbery": "snɒbəri",
    "snobbishness": "snɒbɪʃnəs",
    "snobbish": "snɒbɪʃ",
    "snobby": "snɒbi",
    "snob": "snɒb",
    "snobs": "snɒbz",
    "snogged": "snɒɡd",
    "snogging": "snɒɡɪŋ",
    "snog": "snɒɡ",
    "snogs": "snɒɡz",
    "snood": "snuːd",
    "snoods": "snuːdz",
    "snookered": "snuːkəd",
    "snookering": "snuːkərɪŋ",
    "snooker": "snuːkɐ",
    "snookers": "snuːkəz",
    "snook": "snʊk",
    "snooks": "snʊks",
    "snooped": "snuːpt",
    "snooper": "snuːpɐ",
    "snoopers": "snuːpəz",
    "snooping": "snuːpɪŋ",
    "snoop": "snuːp",
    "snoops": "snuːps",
    "snoopy": "snuːpi",
    "snoot": "snuːt",
    "snooty": "snuːti",
    "snoozed": "snuːzd",
    "snoozer": "snuːzɐ",
    "snooze": "snuːz",
    "snoozes": "snuːzɪz",
    "snoozing": "snuːzɪŋ",
    "snored": "snɔːd",
    "snorer": "snɔːrɐ",
    "snorers": "snɔːrəz",
    "snore": "snɔː",
    "snores": "snɔːz",
    "snoring": "snɔːrɪŋ",
    "snorkelled": "snɔːkəld",
    "snorkelling": "snɔːkəlɪŋ",
    "snorkel": "snɔːkəl",
    "snorkels": "snɔːkəlz",
    "snorted": "snɔːtɪd",
    "snorter": "snɔːtɐ",
    "snorters": "snɔːtəz",
    "snorting": "snɔːtɪŋ",
    "snort": "snɔːt",
    "snorts": "snɔːts",
    "snot": "snɒt",
    "snots": "snɒts",
    "snotty": "snɒti",
    "snout": "snaʊt",
    "snouts": "snaʊts",
    "snowballed": "snəʊbəld",
    "snowballing": "snəʊbɔːlɪŋ",
    "snowball": "snəʊbɔːl",
    "snowballs": "snəʊbɔːlz",
    "snowbank": "snəʊbæŋk",
    "snowbird": "snəʊbɜːd",
    "snowbirds": "snəʊbɜːdz",
    "snowboarded": "snəʊbɔːdɪd",
    "snowboarder": "snəʊbɔːdɐ",
    "snowboarders": "snəʊbɔːdəz",
    "snowboarding": "snəʊbɔːdɪŋ",
    "snowboard": "snəʊbɔːd",
    "snowboards": "snəʊbɔːdz",
    "snowbound": "snəʊbaʊnd",
    "snowcap": "snəʊkæp",
    "snowdrift": "snəʊdrɪft",
    "snowdrifts": "snəʊdrɪfts",
    "snowdrop": "snəʊdrɒp",
    "snowdrops": "snəʊdrɒps",
    "snowed": "snəʊd",
    "snowfall": "snəʊfɔːl",
    "snowfalls": "snəʊfɔːlz",
    "snowfield": "snəʊfiːld",
    "snowfields": "snəʊfiːldz",
    "snowflake": "snəʊfleɪk",
    "snowflakes": "snəʊfleɪks",
    "snowier": "snəʊɪɐ",
    "snowiest": "snəʊɪəst",
    "snowing": "snəʊɪŋ",
    "snowline": "snəʊlaɪn",
    "snowman": "snəʊmən",
    "snowmen": "snəʊmɛn",
    "snowmobile": "snəʊməbiːl",
    "snowmobiles": "snəʊməbiːlz",
    "snowmobiling": "snəʊməbiːlɪŋ",
    "snowplough": "snəʊplaʊ",
    "snowploughs": "snəʊplaʊz",
    "snowshoe": "snəʊʃuː",
    "snowshoes": "snəʊʃuːz",
    "snow": "snəʊ",
    "snows": "snəʊz",
    "snowstorm": "snəʊstɔːm",
    "snowstorms": "snəʊstɔːmz",
    "snowy": "snəʊi",
    "snubbed": "snʌbd",
    "snubbing": "snʌbɪŋ",
    "snub": "snʌb",
    "snubs": "snʌbz",
    "snuck": "snʌk",
    "snuffboxes": "snʌfbɒksɪz",
    "snuffbox": "snʌfbɒks",
    "snuffed": "snʌft",
    "snuffer": "snʌfɐ",
    "snuffers": "snʌfəz",
    "snuffing": "snʌfɪŋ",
    "snuffled": "snʌfəld",
    "snuffle": "snʌfəl",
    "snuffles": "snʌfəlz",
    "snuffling": "snʌflɪŋ",
    "snuffly": "snʌfli",
    "snuff": "snʌf",
    "snuffs": "snʌfs",
    "snuffy": "snʌfi",
    "snugger": "snʌɡɐ",
    "snuggled": "snʌɡəld",
    "snuggle": "snʌɡəl",
    "snuggles": "snʌɡəlz",
    "snuggling": "snʌɡlɪŋ",
    "snugly": "snʌɡli",
    "snugness": "snʌɡnəs",
    "snug": "snʌɡ",
    "snugs": "snʌɡz",
    "soaked": "səʊkt",
    "soaker": "səʊkɐ",
    "soakers": "səʊkəz",
    "soaking": "səʊkɪŋ",
    "soak": "səʊk",
    "soaks": "səʊks",
    "soapboxes": "səʊpbɒksɪz",
    "soapbox": "səʊpbɒks",
    "soaped": "səʊpt",
    "soaping": "səʊpɪŋ",
    "soap": "səʊp",
    "soaps": "səʊps",
    "soapstone": "səʊpstəʊn",
    "soapsuds": "səʊpsʌdz",
    "soapy": "səʊpi",
    "soared": "sɔːd",
    "soaring": "sɔːrɪŋ",
    "soar": "sɔː",
    "soars": "sɔːz",
    "soave": "səʊv",
    "soba": "səʊbɐ",
    "sobbed": "sɒbd",
    "sobbing": "sɒbɪŋ",
    "sobered": "səʊbəd",
    "sobering": "səʊbərɪŋ",
    "soberly": "səʊbəli",
    "soberness": "səʊbənəs",
    "sober": "səʊbɐ",
    "sobers": "səʊbəz",
    "sobriety": "səbraɪəti",
    "sobriquet": "sɒbrɪkeɪ",
    "sob": "sɒb",
    "sobs": "sɒbz",
    "soccer": "sɒkɐ",
    "sociability": "səʊʃiəbɪlɪti",
    "sociable": "səʊʃiəbəl",
    "sociably": "səʊʃiəbli",
    "socialisation": "səʊʃəlaɪzeɪʃən",
    "socialised": "səʊʃəlaɪzd",
    "socialiser": "səʊʃəlaɪzɐ",
    "socialise": "səʊʃəlaɪz",
    "socialises": "səʊʃəlaɪzɪz",
    "socialising": "səʊʃəlaɪzɪŋ",
    "socialism": "səʊʃəlɪzəm",
    "socialistic": "səʊʃəlɪstɪk",
    "socialist": "səʊʃəlɪst",
    "socialists": "səʊʃəlɪsts",
    "socialite": "səʊʃəlaɪt",
    "socialites": "səʊʃəlaɪts",
    "sociality": "səʊʃɪælɪti",
    "socially": "səʊʃəli",
    "social": "səʊʃəl",
    "socials": "səʊʃəlz",
    "societal": "səsaɪətəl",
    "societies": "səsaɪətɪz",
    "society": "səsaɪəti",
    "socioeconomic": "səʊsɪəʊkənɒmɪk",
    "sociologically": "səʊsɪəlɒdʒɪkli",
    "sociological": "səʊsɪəlɒdʒɪkəl",
    "sociologist": "səʊsɪɒlədʒɪst",
    "sociologists": "səʊsɪɒlədʒɪsts",
    "sociology": "səʊsɪɒlədʒi",
    "sociopathic": "səʊsɪəpæθɪk",
    "sociopath": "səʊsɪɒpɑːθ",
    "sociopaths": "səʊsɪɒpɑːθs",
    "sociopolitical": "səʊsɪɒpəlɪtɪkəl",
    "socked": "sɒkt",
    "socket": "sɒkɪt",
    "sockets": "sɒkɪts",
    "sockeye": "sɒkaɪ",
    "socking": "sɒkɪŋ",
    "sock": "sɒk",
    "socks": "sɒks",
    "socle": "sɒkəl",
    "soda": "səʊdɐ",
    "sodas": "səʊdəz",
    "sodded": "sɒdɪd",
    "sodden": "sɒdən",
    "sodding": "sɒdɪŋ",
    "sodium": "səʊdiəm",
    "sodomised": "sɒdəmaɪzd",
    "sodomise": "sɒdəmaɪz",
    "sodomising": "sɒdəmaɪzɪŋ",
    "sodomite": "sɒdəmaɪt",
    "sodomites": "sɒdəmaɪts",
    "sodomy": "sɒdəmi",
    "sod": "sɒd",
    "sods": "sɒdz",
    "soever": "səʊɛvɐ",
    "sofabed": "sɒfeɪbd",
    "sofar": "sɒfɑː",
    "sofa": "səʊfɐ",
    "sofas": "səʊfəz",
    "soffit": "sɒfɪt",
    "softball": "sɒftbɔːl",
    "softened": "sɒfənd",
    "softener": "sɒfənɐ",
    "softeners": "sɒfənəz",
    "softening": "sɒfənɪŋ",
    "soften": "sɒfən",
    "softens": "sɒfənz",
    "softer": "sɒftɐ",
    "softest": "sɒftəst",
    "softie": "sɒfti",
    "softies": "sɒftɪz",
    "softly": "sɒftli",
    "softness": "sɒftnəs",
    "soft": "sɒft",
    "software": "sɒftweə",
    "softwood": "sɒftwʊd",
    "softwoods": "sɒftwʊdz",
    "softy": "sɒfti",
    "soggier": "sɒɡɪɐ",
    "soggiest": "sɒɡɪəst",
    "sogginess": "sɒɡɪnəs",
    "soggy": "sɒɡi",
    "soh": "səʊ",
    "soiled": "sɔɪld",
    "soiling": "sɔɪlɪŋ",
    "soil": "sɔɪl",
    "soils": "sɔɪlz",
    "sojourned": "səʊdʒɜːnd",
    "sojourner": "səʊdʒɜːnɐ",
    "sojourn": "səʊdʒɜːn",
    "sojourns": "səʊdʒɜːnz",
    "solace": "sɒlɪs",
    "solano": "səlɑːnəʊ",
    "solanum": "sɒlænəm",
    "solarium": "səʊleəriəm",
    "solar": "səʊlɐ",
    "sola": "səʊlɐ",
    "soldered": "sɒldəd",
    "soldering": "sɒldərɪŋ",
    "solder": "sɒldɐ",
    "solders": "sɒldəz",
    "soldiered": "səʊldʒəd",
    "soldiering": "səʊldʒərɪŋ",
    "soldierly": "səʊldʒəli",
    "soldier": "səʊldʒɐ",
    "soldiers": "səʊldʒəz",
    "soldiery": "səʊldɪəri",
    "sold": "səʊld",
    "solecism": "səʊlsɪzəm",
    "soled": "səʊld",
    "solely": "səʊlli",
    "solemnisation": "sɒlɪmnaɪzeɪʃən",
    "solemnised": "sɒlɪmnaɪzd",
    "solemnise": "sɒlɪmnaɪz",
    "solemnity": "sɒlɛmnɪti",
    "solemnly": "sɒləmli",
    "solemn": "sɒləm",
    "solenoid": "səʊlənɔɪd",
    "solenoids": "səʊlənɔɪdz",
    "sole": "səʊl",
    "solferino": "sɒlfəriːnəʊ",
    "solicitation": "səlɪsɪteɪʃən",
    "solicited": "səlɪsɪtɪd",
    "soliciting": "səlɪsɪtɪŋ",
    "solicitor": "səlɪsɪtɐ",
    "solicitors": "səlɪsɪtəz",
    "solicitous": "səlɪsɪtəs",
    "solicit": "səlɪsɪt",
    "solicits": "səlɪsɪts",
    "solicitude": "səlɪsɪtjuːd",
    "solidarity": "sɒlɪdærɪti",
    "solider": "sɒlaɪdɐ",
    "solidification": "səlɪdɪfɪkeɪʃən",
    "solidified": "səlɪdɪfaɪd",
    "solidifies": "səlɪdɪfaɪz",
    "solidifying": "səlɪdɪfaɪɪŋ",
    "solidify": "səlɪdɪfaɪ",
    "solidity": "səlɪdɪti",
    "solidly": "sɒlɪdli",
    "solidness": "sɒlɪdnəs",
    "solid": "sɒlɪd",
    "solids": "sɒlɪdz",
    "solidus": "sɒlɪdəs",
    "soliloquies": "səlɪləkwɪz",
    "soliloquy": "səlɪləkwi",
    "soling": "səʊlɪŋ",
    "solipsism": "sɒlɪpsɪzəm",
    "soli": "səʊli",
    "solitaire": "sɒlɪteə",
    "solitaires": "sɒlɪteəz",
    "solitary": "sɒlɪtəri",
    "solitude": "sɒlɪtjuːd",
    "solitudes": "sɒlɪtjuːdz",
    "soloing": "səʊləʊɪŋ",
    "soloist": "səʊləʊɪst",
    "soloists": "səʊləʊɪsts",
    "solon": "sɒlɒn",
    "solo": "səʊləʊ",
    "solos": "səʊləʊz",
    "sols": "sɒlz",
    "solstice": "sɒlstɪs",
    "solstices": "sɒlstɪsɪz",
    "solubility": "sɒljuːbɪlɪti",
    "soluble": "sɒljuːbəl",
    "solus": "sɒluːz",
    "solute": "sɒljuːt",
    "solution": "səluːʃən",
    "solutions": "səluːʃənz",
    "solvable": "sɒlvəbəl",
    "solved": "sɒlvd",
    "solvency": "sɒlvənsi",
    "solvent": "sɒlvənt",
    "solvents": "sɒlvənts",
    "solver": "sɒlvɐ",
    "solvers": "sɒlvəz",
    "solve": "sɒlv",
    "solves": "sɒlvz",
    "solving": "sɒlvɪŋ",
    "soma": "səʊmɐ",
    "somas": "səʊməz",
    "somatic": "səmætɪk",
    "sombrely": "sɒmbəli",
    "sombreness": "sɒmbənəs",
    "sombrero": "səmbreərəʊ",
    "sombreros": "səmbreərəʊz",
    "sombre": "sɒmbɐ",
    "somebodies": "sʌmbɒdɪz",
    "somebody": "sʌmbɒdi",
    "someday": "sʌmdeɪ",
    "somehow": "sʌmhaʊ",
    "someone": "sʌmwɒn",
    "someones": "sʌmwɒnz",
    "someplace": "sʌmpleɪs",
    "somersaulted": "sʌməsɒltɪd",
    "somersaulting": "sʌməsɒltɪŋ",
    "somersault": "sʌməsɒlt",
    "somersaults": "sʌməsɒlts",
    "somerset": "sʌməsɛt",
    "some": "sʌm",
    "something": "sʌmθɪŋ",
    "somethings": "sʌmθɪŋz",
    "sometime": "sʌmtaɪm",
    "sometimes": "sʌmtaɪmz",
    "someway": "sʌmweɪ",
    "somewhat": "sʌmwɒt",
    "somewhere": "sʌmweə",
    "sommelier": "sɒmɛliə",
    "sommeliers": "sɒmɛliəz",
    "somnambulism": "sɒmnɐmbjuːlɪzəm",
    "som": "sɒm",
    "sonar": "səʊnɑː",
    "sonars": "səʊnɑːz",
    "sonata": "sənɑːtɐ",
    "sonatas": "sənɑːtəz",
    "sonatina": "sɒnɐtiːnɐ",
    "sone": "səʊn",
    "sones": "sʌnz",
    "songbird": "sɒŋbɜːd",
    "songbirds": "sɒŋbɜːdz",
    "songbook": "sɒŋbʊk",
    "songbooks": "sɒŋbʊks",
    "song": "sɒŋ",
    "songs": "sɒŋz",
    "songster": "sɒŋstɐ",
    "songsters": "sɒŋstəz",
    "songstress": "sɒŋstrəs",
    "songwriter": "sɒŋraɪtɐ",
    "songwriters": "sɒŋraɪtəz",
    "songwriting": "sɒŋraɪtɪŋ",
    "sonically": "sɒnɪkli",
    "sonic": "sɒnɪk",
    "sonics": "sɒnɪks",
    "sonneteer": "sɒnɪtiə",
    "sonnet": "sɒnɪt",
    "sonnets": "sɒnɪts",
    "sonny": "sʌni",
    "sonofabitch": "sɒnəfæbɪtʃ",
    "sonogram": "sɒnəɡræm",
    "sonorities": "sənɒrɪtiz",
    "sonority": "sənɒrɪti",
    "sonorous": "sɒnərəs",
    "son": "sʌn",
    "sons": "sʌnz",
    "sooner": "suːnɐ",
    "soonest": "suːnəst",
    "soon": "suːn",
    "soothed": "suːðd",
    "soother": "suːðɐ",
    "soothes": "suːðz",
    "soothe": "suːð",
    "soothingly": "suːðɪŋli",
    "soothing": "suːðɪŋ",
    "soothsayers": "suːθseɪəz",
    "soothsayer": "suːθseɪɐ",
    "sooth": "suːð",
    "soot": "sʊt",
    "sooty": "sʊti",
    "sophism": "sɒfɪzəm",
    "sophisticated": "səfɪstɪkeɪtɪd",
    "sophisticate": "səfɪstɪkeɪt",
    "sophisticates": "səfɪstɪkeɪts",
    "sophistication": "səfɪstɪkeɪʃən",
    "sophistry": "sɒfɪstri",
    "sophomore": "sɒfəmɔː",
    "sophomores": "sɒfəmɔːz",
    "sophomoric": "sɒfəmɒrɪk",
    "soporific": "sɒpɔːrɪfɪk",
    "sopping": "sɒpɪŋ",
    "soppy": "sɒpi",
    "soprano": "səprɑːnəʊ",
    "sopranos": "səprɑːnəʊz",
    "sop": "sɒp",
    "sops": "sɒps",
    "sora": "sɔːrɐ",
    "sorbet": "sɔːbeɪ",
    "sorbets": "sɔːbeɪs",
    "sorbitol": "sɔːbɪtɒl",
    "sorcerer": "sɔːsərɐ",
    "sorcerers": "sɔːsərəz",
    "sorceress": "sɔːsərəs",
    "sorcery": "sɔːsəri",
    "sordid": "sɔːdɪd",
    "sorely": "sɔːli",
    "soreness": "sɔːnəs",
    "sorer": "sɔːrɐ",
    "sore": "sɔː",
    "sores": "sɔːz",
    "sorest": "sɔːst",
    "sorghum": "sɔːɡəm",
    "sorn": "sɔːn",
    "sororicide": "sɔːrɔːrɪsaɪd",
    "sororities": "sɔːrɒrɪtiz",
    "sorority": "sɔːrɒrɪti",
    "sorrel": "sɒrəl",
    "sorrier": "sɒrɪɐ",
    "sorriest": "sɒrɪəst",
    "sorrowful": "sɒrəʊfəl",
    "sorrow": "sɒrəʊ",
    "sorrows": "sɒrəʊz",
    "sorry": "sɒri",
    "sortable": "sɔːtəbəl",
    "sorta": "sɔːtɐ",
    "sorted": "sɔːtɪd",
    "sorter": "sɔːtɐ",
    "sorters": "sɔːtəz",
    "sortie": "sɔːti",
    "sorties": "sɔːtɪz",
    "sorting": "sɔːtɪŋ",
    "sort": "sɔːt",
    "sorts": "sɔːts",
    "so": "səʊ",
    "sos": "sɒs",
    "sots": "sɒts",
    "sot": "sɒt",
    "soubise": "saʊbaɪz",
    "soubrette": "saʊbrɛt",
    "soubriquet": "saʊbrɪkeɪ",
    "sough": "səʊ",
    "sought": "sɔːt",
    "souk": "saʊk",
    "souks": "saʊks",
    "souled": "səʊld",
    "soulfulness": "səʊlfəlnəs",
    "soulful": "səʊlfəl",
    "soulless": "səʊlɛs",
    "soul": "səʊl",
    "souls": "səʊlz",
    "soundbite": "saʊndbaɪt",
    "soundbites": "saʊndbaɪts",
    "soundboard": "saʊndbɔːd",
    "sounded": "saʊndɪd",
    "sounder": "saʊndɐ",
    "sounders": "saʊndəz",
    "soundest": "saʊndəst",
    "sounding": "saʊndɪŋ",
    "soundings": "saʊndɪŋz",
    "soundless": "saʊndləs",
    "soundly": "saʊndli",
    "soundness": "saʊndnəs",
    "soundproofed": "saʊndpruːft",
    "soundproofing": "saʊndpruːfɪŋ",
    "soundproof": "saʊndpruːf",
    "sound": "saʊnd",
    "sounds": "saʊndz",
    "soundstage": "saʊndsteɪdʒ",
    "soundtrack": "saʊndtræk",
    "soundtracks": "saʊndtræks",
    "souped": "suːpt",
    "souping": "suːpɪŋ",
    "soups": "suːps",
    "soup": "suːp",
    "soupy": "suːpi",
    "sourced": "sɔːsd",
    "source": "sɔːs",
    "sources": "sɔːsɪz",
    "sourcing": "sɔːsɪŋ",
    "sourdough": "saʊədəʊ",
    "sourdoughs": "saʊədəʊz",
    "soured": "saʊəd",
    "sourest": "saʊərəst",
    "souring": "saʊərɪŋ",
    "sourness": "saʊənəs",
    "sourpuss": "saʊəpʊs",
    "sour": "saʊə",
    "sours": "saʊəz",
    "sousaphone": "saʊsɐfəʊn",
    "soused": "saʊsd",
    "souse": "saʊs",
    "sousing": "saʊsɪŋ",
    "sous": "suːz",
    "sou": "suː",
    "souterrain": "saʊtɪreɪn",
    "souter": "saʊtɐ",
    "southbound": "saʊθbaʊnd",
    "southeasterly": "saʊθiːstəli",
    "southeastern": "saʊθiːstən",
    "southeast": "saʊθiːst",
    "southeastwards": "saʊθiːstwədz",
    "southerlies": "sʌðəliz",
    "southerly": "sʌðəli",
    "southerner": "sʌðənɐ",
    "southerners": "sʌðənəz",
    "southernly": "sʌðənli",
    "southernmost": "sʌðənməʊst",
    "southern": "sʌðən",
    "southerns": "sʌðənz",
    "southland": "saʊθlənd",
    "southpaw": "saʊθpɔː",
    "southpaws": "saʊθpɔːz",
    "south": "saʊθ",
    "southward": "saʊθwəd",
    "southwards": "saʊθwədz",
    "southwesterly": "saʊθwɛstəli",
    "southwestern": "saʊθwɛstən",
    "southwest": "saʊθwɛst",
    "souvenirs": "suːvəniəz",
    "souvenir": "suːvəniə",
    "sovereigns": "sɒvərɪnz",
    "sovereign": "sɒvərɪn",
    "sovereignty": "sɒvərɪnti",
    "soviet": "səʊviət",
    "soviets": "səʊviəts",
    "sowed": "səʊd",
    "sower": "səʊɐ",
    "sowers": "səʊəz",
    "sowing": "səʊɪŋ",
    "sown": "səʊn",
    "sox": "sɒks",
    "soya": "sɔɪɐ",
    "soybean": "sɔɪbiːn",
    "soybeans": "sɔɪbiːnz",
    "soy": "sɔɪ",
    "sozzled": "sɒzəld",
    "spacecraft": "speɪskrɑːft",
    "spacecrafts": "speɪskrɑːfts",
    "spaced": "speɪst",
    "spaceflight": "speɪsflaɪt",
    "spaceless": "speɪsləs",
    "spaceman": "speɪsmən",
    "spacemen": "speɪsmɛn",
    "spaceport": "speɪspɔːt",
    "spacer": "speɪsɐ",
    "spacers": "speɪsəz",
    "spaceship": "speɪsʃɪp",
    "spaceships": "speɪsʃɪps",
    "space": "speɪs",
    "spaces": "speɪsɪz",
    "spacesuit": "speɪssuːt",
    "spacesuits": "speɪssuːts",
    "spacewalking": "speɪswɔːkɪŋ",
    "spacewalk": "speɪswɔːk",
    "spacewalks": "speɪswɔːks",
    "spacey": "speɪsi",
    "spacial": "spæʃəl",
    "spacing": "speɪsɪŋ",
    "spacings": "speɪsɪŋz",
    "spaciousness": "speɪʃəsnəs",
    "spacious": "speɪʃəs",
    "spacy": "speɪsi",
    "spaded": "speɪdɪd",
    "spader": "speɪdɐ",
    "spade": "speɪd",
    "spades": "speɪdz",
    "spadework": "speɪdwɜːk",
    "spaghetti": "spɐɡɛti",
    "spake": "speɪk",
    "spall": "spɔːl",
    "spammers": "spæməz",
    "spamming": "spæmɪŋ",
    "spam": "spæm",
    "spandex": "spændɛks",
    "spandrel": "spændrəl",
    "spandrels": "spændrəlz",
    "spangled": "spæŋɡəld",
    "spangle": "spæŋɡəl",
    "spangles": "spæŋɡəlz",
    "spangling": "spæŋɡəlɪŋ",
    "spangly": "spæŋli",
    "spang": "spæŋ",
    "spaniel": "spænjəl",
    "spaniels": "spænjəlz",
    "spanked": "spæŋkt",
    "spanker": "spæŋkɐ",
    "spankers": "spæŋkəz",
    "spanking": "spæŋkɪŋ",
    "spank": "spæŋk",
    "spanks": "spæŋks",
    "spanned": "spænd",
    "spanner": "spænɐ",
    "spanners": "spænəz",
    "spanning": "spænɪŋ",
    "span": "spæn",
    "spans": "spænz",
    "spared": "speəd",
    "spareness": "speənəs",
    "spareribs": "speərɪbz",
    "spare": "speə",
    "spares": "speəz",
    "sparge": "spɑːdʒ",
    "sparingly": "speərɪŋli",
    "sparing": "speərɪŋ",
    "sparked": "spɑːkt",
    "sparkier": "spɑːkiɐ",
    "sparkiest": "spɑːkiəst",
    "sparking": "spɑːkɪŋ",
    "sparkled": "spɑːkəld",
    "sparkler": "spɑːklɐ",
    "sparklers": "spɑːkləz",
    "sparkle": "spɑːkəl",
    "sparkles": "spɑːkəlz",
    "sparklingly": "spɑːkəlɪŋli",
    "sparkling": "spɑːklɪŋ",
    "sparkly": "spɑːkli",
    "spark": "spɑːk",
    "sparks": "spɑːks",
    "sparky": "spɑːki",
    "sparred": "spɑːd",
    "sparring": "spɑːrɪŋ",
    "sparrowgrass": "spærəʊɡrɑːs",
    "sparrowhawk": "spærəʊhɔːk",
    "sparrowhawks": "spærəʊhɔːks",
    "sparrow": "spærəʊ",
    "sparrows": "spærəʊz",
    "sparsely": "spɑːsli",
    "sparseness": "spɑːsnəs",
    "sparser": "spɑːsɐ",
    "sparse": "spɑːs",
    "sparsest": "spɑːsəst",
    "sparsity": "spɑːsɪti",
    "spar": "spɑː",
    "spars": "spɑːz",
    "spartan": "spɑːtən",
    "spasmodic": "spæzmɒdɪk",
    "spasm": "spæzəm",
    "spasms": "spæzəmz",
    "spa": "spɑː",
    "spas": "spɑːz",
    "spasticity": "spɑːstɪsɪti",
    "spastic": "spɑːstɪk",
    "spastics": "spɑːstɪks",
    "spate": "speɪt",
    "spates": "speɪts",
    "spatially": "speɪʃəli",
    "spatial": "speɪʃəl",
    "spat": "spæt",
    "spats": "spæts",
    "spattered": "spætəd",
    "spattering": "spætərɪŋ",
    "spatter": "spætɐ",
    "spatters": "spætəz",
    "spatula": "spætjʊlɐ",
    "spatulas": "spætjʊləz",
    "spawned": "spɔːnd",
    "spawning": "spɔːnɪŋ",
    "spawn": "spɔːn",
    "spawns": "spɔːnz",
    "spayed": "speɪd",
    "spaying": "speɪɪŋ",
    "spay": "speɪ",
    "speakeasies": "spiːkiːzɪz",
    "speakeasy": "spiːkiːzi",
    "speakerphone": "spiːkəfəʊn",
    "speaker": "spiːkɐ",
    "speakers": "spiːkəz",
    "speaking": "spiːkɪŋ",
    "speak": "spiːk",
    "speaks": "spiːks",
    "speared": "spiəd",
    "spearfish": "spiəfɪʃ",
    "spearheaded": "spiəhɛdɪd",
    "spearheading": "spiəhɛdɪŋ",
    "spearhead": "spiəhɛd",
    "spearheads": "spiəhɛdz",
    "spearing": "spiərɪŋ",
    "spearman": "spiəmən",
    "spearmint": "spiəmɪnt",
    "spear": "spiə",
    "spears": "spiəz",
    "specced": "spɛkst",
    "speccing": "spɛksɪŋ",
    "specialisation": "spɛʃəlaɪzeɪʃən",
    "specialisations": "spɛʃəlaɪzeɪʃənz",
    "specialised": "spɛʃəlaɪzd",
    "specialise": "spɛʃəlaɪz",
    "specialises": "spɛʃəlaɪzɪz",
    "specialising": "spɛʃəlaɪzɪŋ",
    "specialism": "spɛʃəlɪzəm",
    "specialisms": "spɛʃəlɪzəmz",
    "specialist": "spɛʃəlɪst",
    "specialists": "spɛʃəlɪsts",
    "specialities": "spɛʃɪælɪtiz",
    "speciality": "spɛʃɪælɪti",
    "specially": "spɛʃəli",
    "specialness": "spɛʃəlnəs",
    "special": "spɛʃəl",
    "specials": "spɛʃəlz",
    "speciation": "spɛʃɪeɪʃən",
    "specie": "spɛsi",
    "species": "spiːsiːz",
    "specifically": "spəsɪfɪkli",
    "specification": "spɛsɪfɪkeɪʃən",
    "specifications": "spɛsɪfɪkeɪʃənz",
    "specificity": "spɛsɪfɪsɪti",
    "specific": "spəsɪfɪk",
    "specifics": "spəsɪfɪks",
    "specified": "spɛsɪfaɪd",
    "specifiers": "spɛsɪfaɪəz",
    "specifies": "spɛsɪfaɪz",
    "specifying": "spɛsɪfaɪɪŋ",
    "specify": "spɛsɪfaɪ",
    "specimen": "spɛsɪmən",
    "specimens": "spɛsɪmənz",
    "specious": "spiːʃəs",
    "specked": "spɛkt",
    "speckled": "spɛkəld",
    "speckle": "spɛkəl",
    "speckles": "spɛkəlz",
    "speckling": "spɛklɪŋ",
    "speck": "spɛk",
    "specks": "spɛks",
    "spec": "spɛk",
    "specs": "spɛks",
    "spectacled": "spɛktəkəld",
    "spectacle": "spɛktəkəl",
    "spectacles": "spɛktəkəlz",
    "spectacularly": "spɛktækjʊləli",
    "spectacular": "spɛktækjʊlɐ",
    "spectaculars": "spɛktækjʊləz",
    "spectate": "spɛkteɪt",
    "spectating": "spɛkteɪtɪŋ",
    "spectator": "spɛkteɪtɐ",
    "spectators": "spɛkteɪtəz",
    "spectral": "spɛktrəl",
    "spectra": "spɛktrɐ",
    "spectre": "spɛktɐ",
    "spectres": "spɛktəz",
    "spectrograph": "spɛktrəɡræf",
    "spectrometer": "spɛktrɒmɪtɐ",
    "spectrometers": "spɛktrɒmɪtəz",
    "spectrometry": "spɛktrɒmətri",
    "spectroscope": "spɛktrəskəʊp",
    "spectroscopy": "spɛktrɒskəpi",
    "spectrum": "spɛktrəm",
    "spectrums": "spɛktrəmz",
    "specular": "spɛkjʊlɐ",
    "speculated": "spɛkjʊleɪtɪd",
    "speculate": "spɛkjʊleɪt",
    "speculates": "spɛkjʊleɪts",
    "speculating": "spɛkjʊleɪtɪŋ",
    "speculation": "spɛkjʊleɪʃən",
    "speculations": "spɛkjʊleɪʃənz",
    "speculatively": "spɛkjʊlətɪvli",
    "speculative": "spɛkjʊlətɪv",
    "speculator": "spɛkjʊleɪtɐ",
    "speculators": "spɛkjʊleɪtəz",
    "speculum": "spɛkjʊləm",
    "sped": "spɛd",
    "speeches": "spiːtʃɪz",
    "speechifying": "spiːtʃɪfaɪɪŋ",
    "speechless": "spiːtʃləs",
    "speechmaker": "spiːtʃmeɪkɐ",
    "speechmaking": "spiːtʃmeɪkɪŋ",
    "speech": "spiːtʃ",
    "speechwriter": "spiːtʃraɪtɐ",
    "speechwriters": "spiːtʃraɪtəz",
    "speedball": "spiːdbɔːl",
    "speedboat": "spiːdbəʊt",
    "speedboats": "spiːdbəʊts",
    "speeded": "spiːdɪd",
    "speeder": "spiːdɐ",
    "speeders": "spiːdəz",
    "speedier": "spiːdɪɐ",
    "speediest": "spiːdɪəst",
    "speedily": "spiːdɪli",
    "speediness": "spiːdɪnəs",
    "speeding": "spiːdɪŋ",
    "speedometer": "spiːdɒmɪtɐ",
    "speedometers": "spiːdɒmɪtəz",
    "speed": "spiːd",
    "speeds": "spiːdz",
    "speedster": "spiːdstɐ",
    "speedsters": "spiːdstəz",
    "speedway": "spiːdweɪ",
    "speedwell": "spiːdwɛl",
    "speedy": "spiːdi",
    "speleological": "spɛlɪəlɒdʒɪkəl",
    "spellbinding": "spɛlbaɪndɪŋ",
    "spellbound": "spɛlbaʊnd",
    "spellchecker": "spɛltʃɛkɐ",
    "spelled": "spɛld",
    "speller": "spɛlɐ",
    "spellers": "spɛləz",
    "spelling": "spɛlɪŋ",
    "spellings": "spɛlɪŋz",
    "spell": "spɛl",
    "spells": "spɛlz",
    "spelter": "spɛltɐ",
    "spelt": "spɛlt",
    "spelunking": "spɛlʌŋkɪŋ",
    "spencer": "spɛnsɐ",
    "spence": "spɛns",
    "spendable": "spɛndəbəl",
    "spender": "spɛndɐ",
    "spenders": "spɛndəz",
    "spending": "spɛndɪŋ",
    "spend": "spɛnd",
    "spends": "spɛndz",
    "spendthrift": "spɛndθrɪft",
    "spendthrifts": "spɛndθrɪfts",
    "spent": "spɛnt",
    "spermicide": "spɜːmɪsaɪd",
    "sperm": "spɜːm",
    "sperms": "spɜːmz",
    "spewed": "spjuːd",
    "spewer": "spjuːɐ",
    "spewing": "spjuːɪŋ",
    "spew": "spjuː",
    "spews": "spjuːz",
    "sphagnum": "sfæɡnəm",
    "sphere": "sfiə",
    "spheres": "sfiəz",
    "spherical": "sfɛrɪkəl",
    "spheroid": "sfɛrɔɪd",
    "spheroids": "sfɛrɔɪdz",
    "sphincter": "sfɪŋktɐ",
    "sphincters": "sfɪŋktəz",
    "sphinxes": "sfɪŋksɪz",
    "sphinx": "sfɪŋks",
    "sphygmomanometer": "sfɪɡməmɐnɒmɪtɐ",
    "spica": "spiːkɐ",
    "spiccato": "spɪkɑːtəʊ",
    "spiced": "spaɪst",
    "spicer": "spaɪsɐ",
    "spice": "spaɪs",
    "spices": "spaɪsɪz",
    "spicier": "spaɪsɪɐ",
    "spiciest": "spaɪsɪəst",
    "spiciness": "spɪsɪnɛs",
    "spicing": "spaɪsɪŋ",
    "spick": "spɪk",
    "spicks": "spɪks",
    "spic": "spɪk",
    "spics": "spɪks",
    "spicy": "spaɪsi",
    "spider": "spaɪdɐ",
    "spiders": "spaɪdəz",
    "spidery": "spaɪdəri",
    "spied": "spaɪd",
    "spiel": "spiːl",
    "spies": "spaɪz",
    "spiffed": "spɪft",
    "spiffing": "spɪfɪŋ",
    "spiff": "spɪf",
    "spiffy": "spɪfi",
    "spigot": "spɪɡət",
    "spigots": "spɪɡəts",
    "spiked": "spaɪkt",
    "spike": "spaɪk",
    "spikes": "spaɪks",
    "spikier": "spaɪkɪɐ",
    "spikiness": "spaɪkɪnəs",
    "spiking": "spaɪkɪŋ",
    "spiky": "spaɪki",
    "spile": "spaɪl",
    "spillage": "spɪlɪdʒ",
    "spillages": "spɪlɪdʒɪz",
    "spilled": "spɪld",
    "spiller": "spɪlɐ",
    "spilling": "spɪlɪŋ",
    "spillover": "spɪləʊvɐ",
    "spill": "spɪl",
    "spills": "spɪlz",
    "spillway": "spɪlweɪ",
    "spilt": "spɪlt",
    "spinach": "spɪnɪtʃ",
    "spinal": "spaɪnəl",
    "spindle": "spɪndəl",
    "spindles": "spɪndəlz",
    "spindly": "spɪndli",
    "spindrift": "spɪndrɪft",
    "spineless": "spaɪnləs",
    "spinel": "spɪnəl",
    "spine": "spaɪn",
    "spines": "spaɪnz",
    "spinet": "spɪnɪt",
    "spinets": "spɪnɪts",
    "spiniest": "spaɪnɪəst",
    "spinifex": "spɪnaɪfɛks",
    "spinnaker": "spɪneɪkɐ",
    "spinnakers": "spɪneɪkəz",
    "spinnerets": "spɪnərəts",
    "spinner": "spɪnɐ",
    "spinners": "spɪnəz",
    "spinney": "spɪni",
    "spinning": "spɪnɪŋ",
    "spinoff": "spɪnɒf",
    "spinous": "spɪnəs",
    "spin": "spɪn",
    "spins": "spɪnz",
    "spinsterhood": "spɪnstəhʊd",
    "spinsterish": "spɪnstərɪʃ",
    "spinster": "spɪnstɐ",
    "spinsters": "spɪnstəz",
    "spiny": "spaɪni",
    "spiracle": "spɪrəkəl",
    "spiracles": "spɪrəkəlz",
    "spiraea": "spɪriə",
    "spiraled": "spaɪərəld",
    "spiralled": "spaɪərəld",
    "spiralling": "spaɪərəlɪŋ",
    "spirally": "spaɪərəli",
    "spiral": "spaɪərəl",
    "spirals": "spaɪərəlz",
    "spire": "spaɪə",
    "spires": "spaɪəz",
    "spirited": "spɪrɪtɪd",
    "spiriting": "spɪrɪtɪŋ",
    "spiritless": "spɪrɪtləs",
    "spirit": "spɪrɪt",
    "spirits": "spɪrɪts",
    "spiritualism": "spɪrɪtʃuːəlɪzəm",
    "spiritualist": "spɪrɪtʃuːəlɪst",
    "spiritualists": "spɪrɪtʃuːəlɪsts",
    "spirituality": "spɪrɪtʃuːælɪti",
    "spiritually": "spɪrɪtʃuːəli",
    "spiritual": "spɪrɪtʃuːəl",
    "spirituals": "spɪrɪtʃuːəlz",
    "spirograph": "spɪrəɡræf",
    "spirometer": "spɪrɒmɪtɐ",
    "spirt": "spɜːt",
    "spital": "spɪtəl",
    "spitball": "spɪtbɔːl",
    "spitefully": "spaɪtfəli",
    "spiteful": "spaɪtfəl",
    "spite": "spaɪt",
    "spitfire": "spɪtfaɪə",
    "spitfires": "spɪtfaɪəz",
    "spiting": "spaɪtɪŋ",
    "spit": "spɪt",
    "spits": "spɪts",
    "spitted": "spɪtɪd",
    "spitter": "spɪtɐ",
    "spitting": "spɪtɪŋ",
    "spittle": "spɪtəl",
    "spittoon": "spɪtuːn",
    "spittoons": "spɪtuːnz",
    "spitz": "spɪts",
    "spiv": "spɪv",
    "spivs": "spɪvz",
    "splashdown": "splæʃdaʊn",
    "splashed": "splæʃt",
    "splasher": "splæʃɐ",
    "splashes": "splæʃɪz",
    "splashing": "splæʃɪŋ",
    "splash": "splæʃ",
    "splashy": "splæʃi",
    "splat": "splæt",
    "splats": "splæts",
    "splatted": "splætɪd",
    "splattered": "splætəd",
    "splattering": "splætərɪŋ",
    "splatter": "splætɐ",
    "splatters": "splætəz",
    "splatting": "splætɪŋ",
    "splayed": "spleɪd",
    "splaying": "spleɪɪŋ",
    "splay": "spleɪ",
    "splays": "spleɪz",
    "spleen": "spliːn",
    "spleens": "spliːnz",
    "spleenwort": "spliːnwɔːt",
    "splendidly": "splɛndɪdli",
    "splendid": "splɛndɪd",
    "splendiferous": "splɛndɪfərəs",
    "splendorous": "splɛndərəs",
    "splendor": "splɛndɐ",
    "splendour": "splɛndɐ",
    "splendours": "splɛndəz",
    "splenectomy": "splɛnɛktəmi",
    "splenetic": "splɛnɛtɪk",
    "splenic": "splɛnɪk",
    "spliced": "splaɪst",
    "splice": "splaɪs",
    "splices": "splaɪsɪz",
    "splicing": "splaɪsɪŋ",
    "spliff": "splɪf",
    "spliffs": "splɪfs",
    "splinted": "splɪntɪd",
    "splintered": "splɪntəd",
    "splintering": "splɪntərɪŋ",
    "splinter": "splɪntɐ",
    "splinters": "splɪntəz",
    "splintery": "splɪntəri",
    "splinting": "splɪntɪŋ",
    "splint": "splɪnt",
    "splints": "splɪnts",
    "split": "splɪt",
    "splits": "splɪts",
    "splitter": "splɪtɐ",
    "splitters": "splɪtəz",
    "splitting": "splɪtɪŋ",
    "splodge": "splɒdʒ",
    "splodges": "splɒdʒɪz",
    "sploshed": "splɒʃt",
    "sploshes": "splɒʃɪz",
    "sploshing": "splɒʃɪŋ",
    "splosh": "splɒʃ",
    "splotches": "splɒtʃɪz",
    "splotch": "splɒtʃ",
    "splurged": "splɜːdʒd",
    "splurge": "splɜːdʒ",
    "splurging": "splɜːdʒɪŋ",
    "spluttered": "splʌtəd",
    "spluttering": "splʌtərɪŋ",
    "splutter": "splʌtɐ",
    "splutters": "splʌtəz",
    "spoilage": "spɔɪlɪdʒ",
    "spoiled": "spɔɪld",
    "spoiler": "spɔɪlɐ",
    "spoilers": "spɔɪləz",
    "spoiling": "spɔɪlɪŋ",
    "spoil": "spɔɪl",
    "spoilsport": "spɔɪlspɔːt",
    "spoilsports": "spɔɪlspɔːts",
    "spoils": "spɔɪlz",
    "spoilt": "spɔɪlt",
    "spoken": "spəʊkən",
    "spokeshave": "spəʊkʃeɪv",
    "spokesman": "spəʊksmən",
    "spokesmen": "spəʊksmɛn",
    "spoke": "spəʊk",
    "spokespeople": "spəʊkspiːpəl",
    "spokesperson": "spəʊkspəsən",
    "spokespersons": "spəʊkspəsənz",
    "spokes": "spəʊks",
    "spokeswoman": "spəʊkswʊmən",
    "spokeswomen": "spəʊkswɪmɪn",
    "spondylitis": "spɒndɪlaɪtɪs",
    "sponged": "spʌndʒd",
    "sponger": "spʌndʒɐ",
    "spongers": "spʌndʒəz",
    "sponge": "spʌndʒ",
    "sponges": "spʌndʒɪz",
    "sponginess": "spʌndʒɪnəs",
    "sponging": "spʌnɡɪŋ",
    "spongy": "spʌndʒi",
    "sponsored": "spɒnsəd",
    "sponsoring": "spɒnsərɪŋ",
    "sponsorship": "spɒnsəʃɪp",
    "sponsorships": "spɒnsəʃɪps",
    "sponsor": "spɒnsɐ",
    "sponsors": "spɒnsəz",
    "spontaneity": "spɒnteɪnɪti",
    "spontaneously": "spɒnteɪniəsli",
    "spontaneous": "spɒnteɪniəs",
    "spoofed": "spuːft",
    "spoofing": "spuːfɪŋ",
    "spoofs": "spuːfs",
    "spooked": "spuːkt",
    "spookier": "spuːkɪɐ",
    "spookiest": "spuːkɪəst",
    "spookily": "spuːkɪli",
    "spookiness": "spuːkɪnəs",
    "spooking": "spuːkɪŋ",
    "spook": "spuːk",
    "spooks": "spuːks",
    "spooky": "spuːki",
    "spooled": "spuːld",
    "spooling": "spuːlɪŋ",
    "spool": "spuːl",
    "spools": "spuːlz",
    "spoonbill": "spuːnbɪl",
    "spoonbills": "spuːnbɪlz",
    "spoondrift": "spuːndrɪft",
    "spooned": "spuːnd",
    "spoonerism": "spuːnərɪzəm",
    "spoonerisms": "spuːnərɪzəmz",
    "spoonfed": "spuːnfɛd",
    "spoonful": "spuːnfəl",
    "spoonfuls": "spuːnfəlz",
    "spooning": "spuːnɪŋ",
    "spoon": "spuːn",
    "spoons": "spuːnz",
    "spoony": "spuːni",
    "spoor": "spɔː",
    "sporadically": "spɔːrædɪkli",
    "sporadic": "spɔːrædɪk",
    "spore": "spɔː",
    "spores": "spɔːz",
    "sporing": "spɔːrɪŋ",
    "sporran": "spɒrən",
    "sporrans": "spɒrənz",
    "sported": "spɔːtɪd",
    "sportier": "spɔːtɪɐ",
    "sportiest": "spɔːtɪəst",
    "sportiness": "spɔːtɪnəs",
    "sportingly": "spɔːtɪŋli",
    "sporting": "spɔːtɪŋ",
    "sportive": "spɔːtɪv",
    "sportscaster": "spɔːtskɑːstɐ",
    "sportsmanlike": "spɔːtsmənlaɪk",
    "sportsmanship": "spɔːtsmənʃɪp",
    "sportsman": "spɔːtsmən",
    "sportsmen": "spɔːtsmɛn",
    "sportspeople": "spɔːtspiːpəl",
    "sportsperson": "spɔːtspəsən",
    "sport": "spɔːt",
    "sports": "spɔːts",
    "sportswear": "spɔːtsweə",
    "sportswoman": "spɔːtswʊmən",
    "sportswomen": "spɔːtswɪmɪn",
    "sportswriter": "spɔːtsraɪtɐ",
    "sporty": "spɔːti",
    "spotlessly": "spɒtləsli",
    "spotless": "spɒtləs",
    "spotlighted": "spɒtlaɪtɪd",
    "spotlighting": "spɒtlaɪtɪŋ",
    "spotlight": "spɒtlaɪt",
    "spotlights": "spɒtlaɪts",
    "spotlit": "spɒtlɪt",
    "spot": "spɒt",
    "spots": "spɒts",
    "spotted": "spɒtɪd",
    "spotter": "spɒtɐ",
    "spotters": "spɒtəz",
    "spottier": "spɒtɪɐ",
    "spottiest": "spɒtɪəst",
    "spotting": "spɒtɪŋ",
    "spotty": "spɒti",
    "spousal": "spaʊsəl",
    "spouse": "spaʊs",
    "spouses": "spaʊsɪz",
    "spouted": "spaʊtɪd",
    "spouting": "spaʊtɪŋ",
    "spout": "spaʊt",
    "spouts": "spaʊts",
    "sprained": "spreɪnd",
    "spraining": "spreɪnɪŋ",
    "sprain": "spreɪn",
    "sprains": "spreɪnz",
    "sprang": "spræŋ",
    "sprat": "spræt",
    "sprats": "spræts",
    "sprawled": "sprɔːld",
    "sprawling": "sprɔːlɪŋ",
    "sprawl": "sprɔːl",
    "sprawls": "sprɔːlz",
    "sprayed": "spreɪd",
    "sprayer": "spreɪɐ",
    "sprayers": "spreɪəz",
    "spraying": "spreɪɪŋ",
    "spray": "spreɪ",
    "sprays": "spreɪz",
    "spreadable": "sprɛdəbəl",
    "spreadeagled": "sprɛdiːɡəld",
    "spreader": "sprɛdɐ",
    "spreaders": "sprɛdəz",
    "spreading": "sprɛdɪŋ",
    "spreadsheet": "sprɛdʃiːt",
    "spreadsheets": "sprɛdʃiːts",
    "spread": "sprɛd",
    "spreads": "sprɛdz",
    "spree": "spriː",
    "sprees": "spriːz",
    "sprigged": "sprɪɡd",
    "sprightlier": "spraɪtliɐ",
    "sprightliness": "spraɪtlinəs",
    "sprightly": "spraɪtli",
    "sprig": "sprɪɡ",
    "sprigs": "sprɪɡz",
    "springboard": "sprɪŋbɔːd",
    "springboards": "sprɪŋbɔːdz",
    "springbok": "sprɪŋbɒk",
    "springboks": "sprɪŋbɒks",
    "springer": "sprɪŋɐ",
    "springers": "sprɪŋəz",
    "springier": "sprɪŋɪɐ",
    "springiest": "sprɪŋɪəst",
    "springiness": "sprɪŋɪnəs",
    "springing": "sprɪŋɪŋ",
    "springlike": "sprɪŋlaɪk",
    "spring": "sprɪŋ",
    "springs": "sprɪŋz",
    "springtail": "sprɪŋteɪl",
    "springtails": "sprɪŋteɪlz",
    "springtime": "sprɪŋtaɪm",
    "springwood": "sprɪŋwʊd",
    "springy": "sprɪŋi",
    "sprinkled": "sprɪŋkəld",
    "sprinkler": "sprɪŋklɐ",
    "sprinklers": "sprɪŋkləz",
    "sprinkle": "sprɪŋkəl",
    "sprinkles": "sprɪŋkəlz",
    "sprinkling": "sprɪŋklɪŋ",
    "sprinklings": "sprɪŋklɪŋz",
    "sprinted": "sprɪntɪd",
    "sprinter": "sprɪntɐ",
    "sprinters": "sprɪntəz",
    "sprinting": "sprɪntɪŋ",
    "sprint": "sprɪnt",
    "sprints": "sprɪnts",
    "sprite": "spraɪt",
    "sprites": "spraɪts",
    "sprit": "sprɪt",
    "sprits": "sprɪts",
    "spritzed": "sprɪtsd",
    "spritzer": "sprɪtsɐ",
    "spritzers": "sprɪtsəz",
    "spritz": "sprɪts",
    "sprocket": "sprɒkɪt",
    "sprockets": "sprɒkɪts",
    "sprog": "sprɒɡ",
    "sprogs": "sprɒɡz",
    "sprouted": "spraʊtɪd",
    "sprouting": "spraʊtɪŋ",
    "sprout": "spraʊt",
    "sprouts": "spraʊts",
    "spruced": "spruːst",
    "spruce": "spruːs",
    "spruces": "spruːsɪz",
    "sprucing": "spruːsɪŋ",
    "sprue": "spruː",
    "sprung": "sprʌŋ",
    "spry": "spraɪ",
    "spud": "spʌd",
    "spuds": "spʌdz",
    "spume": "spjuːm",
    "spumes": "spjuːmz",
    "spunk": "spʌŋk",
    "spunky": "spʌŋki",
    "spun": "spʌn",
    "spurge": "spɜːdʒ",
    "spuriously": "spjʊrɪəsli",
    "spurious": "spjʊrɪəs",
    "spurned": "spɜːnd",
    "spurning": "spɜːnɪŋ",
    "spurn": "spɜːn",
    "spurns": "spɜːnz",
    "spurred": "spɜːd",
    "spurring": "spɜːrɪŋ",
    "spur": "spɜː",
    "spurs": "spɜːz",
    "spurted": "spɜːtɪd",
    "spurting": "spɜːtɪŋ",
    "spurtle": "spɜːtəl",
    "spurt": "spɜːt",
    "spurts": "spɜːts",
    "sputa": "spjuːtɐ",
    "sputnik": "spʌtnɪk",
    "sputniks": "spʌtnɪks",
    "sputtering": "spʌtərɪŋ",
    "sputters": "spʌtəz",
    "sputum": "spjuːtəm",
    "spyglass": "spaɪɡlɑːs",
    "spyhole": "spaɪhəʊl",
    "spying": "spaɪɪŋ",
    "spymaster": "spaɪmɑːstɐ",
    "spymasters": "spaɪmɑːstəz",
    "spy": "spaɪ",
    "squabbled": "skwɒbəld",
    "squabble": "skwɒbəl",
    "squabbles": "skwɒbəlz",
    "squabbling": "skwɒblɪŋ",
    "squab": "skwɒb",
    "squabs": "skwɒbz",
    "squadron": "skwɒdrən",
    "squadrons": "skwɒdrənz",
    "squad": "skwɒd",
    "squads": "skwɒdz",
    "squalid": "skwɒlɪd",
    "squalling": "skwɒlɪŋ",
    "squall": "skwɒl",
    "squalls": "skwɒlz",
    "squally": "skwɒli",
    "squalor": "skwɒlɐ",
    "squandered": "skwɒndəd",
    "squandering": "skwɒndərɪŋ",
    "squander": "skwɒndɐ",
    "squanders": "skwɒndəz",
    "squared": "skweəd",
    "squarely": "skweəli",
    "squareness": "skweənəs",
    "squarer": "skweərɐ",
    "square": "skweə",
    "squares": "skweəz",
    "squarest": "skweərəst",
    "squaring": "skweərɪŋ",
    "squarish": "skweərɪʃ",
    "squashed": "skwɒʃt",
    "squashes": "skwɒʃɪz",
    "squashing": "skwɒʃɪŋ",
    "squash": "skwɒʃ",
    "squashy": "skwɒʃi",
    "squat": "skwɒt",
    "squats": "skwɒts",
    "squatted": "skwɒtɪd",
    "squatter": "skwɒtɐ",
    "squatters": "skwɒtəz",
    "squatting": "skwɒtɪŋ",
    "squawked": "skwɔːkt",
    "squawker": "skwɔːkɐ",
    "squawking": "skwɔːkɪŋ",
    "squawk": "skwɔːk",
    "squawks": "skwɔːks",
    "squaw": "skwɔː",
    "squaws": "skwɔːz",
    "squeaked": "skwiːkt",
    "squeaker": "skwiːkɐ",
    "squeakiest": "skwiːkɪəst",
    "squeaking": "skwiːkɪŋ",
    "squeak": "skwiːk",
    "squeaks": "skwiːks",
    "squeaky": "skwiːki",
    "squealed": "skwiːld",
    "squealer": "skwiːlɐ",
    "squealers": "skwiːləz",
    "squealing": "skwiːlɪŋ",
    "squeal": "skwiːl",
    "squeals": "skwiːlz",
    "squeamishness": "skwiːmɪʃnəs",
    "squeamish": "skwiːmɪʃ",
    "squeegeed": "skwiːdʒiːd",
    "squeegee": "skwiːdʒiː",
    "squeegees": "skwiːdʒiːz",
    "squeezable": "skwiːzəbəl",
    "squeezebox": "skwiːzbɒks",
    "squeezed": "skwiːzd",
    "squeezer": "skwiːzɐ",
    "squeezers": "skwiːzəz",
    "squeeze": "skwiːz",
    "squeezes": "skwiːzɪz",
    "squeezing": "skwiːzɪŋ",
    "squelched": "skwɛltʃt",
    "squelchiest": "skwɛltʃɪəst",
    "squelching": "skwɛltʃɪŋ",
    "squelch": "skwɛltʃ",
    "squelchy": "skwɛltʃi",
    "squib": "skwɪb",
    "squibs": "skwɪbz",
    "squid": "skwɪd",
    "squidgy": "skwɪdʒi",
    "squids": "skwɪdz",
    "squiffy": "skwɪfi",
    "squiggled": "skwɪɡəld",
    "squiggle": "skwɪɡəl",
    "squiggles": "skwɪɡəlz",
    "squiggling": "skwɪɡlɪŋ",
    "squiggly": "skwɪɡli",
    "squill": "skwɪl",
    "squinted": "skwɪntɪd",
    "squinting": "skwɪntɪŋ",
    "squint": "skwɪnt",
    "squints": "skwɪnts",
    "squinty": "skwɪnti",
    "squirearchy": "skwaɪərɑːki",
    "squire": "skwaɪə",
    "squires": "skwaɪəz",
    "squirmed": "skwɜːmd",
    "squirming": "skwɜːmɪŋ",
    "squirm": "skwɜːm",
    "squirms": "skwɜːmz",
    "squirmy": "skwɜːmi",
    "squirreled": "skwɪrəld",
    "squirreling": "skwɜːrəlɪŋ",
    "squirrelled": "skwɪrəld",
    "squirrelling": "skwɜːrəlɪŋ",
    "squirrel": "skwɪrəl",
    "squirrels": "skwɪrəlz",
    "squirted": "skwɜːtɪd",
    "squirting": "skwɜːtɪŋ",
    "squirt": "skwɜːt",
    "squirts": "skwɜːts",
    "squished": "skwɪʃt",
    "squishes": "skwɪʃɪz",
    "squishier": "skwɪʃɪɐ",
    "squishiest": "skwɪʃɪəst",
    "squishing": "skwɪʃɪŋ",
    "squish": "skwɪʃ",
    "squishy": "skwɪʃi",
    "sri": "sriː",
    "ss": "ɛsɛs",
    "ssh": "ɛsɛseɪtʃ",
    "stabbed": "stæbd",
    "stabber": "stæbɐ",
    "stabbings": "stæbɪŋz",
    "stabbing": "stæbɪŋ",
    "stabilisation": "steɪbɪlaɪzeɪʃən",
    "stabilised": "steɪbəlaɪzd",
    "stabilisers": "steɪbəlaɪzəz",
    "stabiliser": "steɪbəlaɪzɐ",
    "stabilises": "steɪbəlaɪzɪz",
    "stabilise": "steɪbəlaɪz",
    "stabilising": "steɪbəlaɪzɪŋ",
    "stability": "stəbɪlɪti",
    "stabled": "steɪbəld",
    "stableman": "steɪbəlmən",
    "stablemates": "steɪbəlmeɪts",
    "stablemate": "steɪbəlmeɪt",
    "stabler": "steɪblɐ",
    "stables": "steɪbəlz",
    "stable": "steɪbəl",
    "stabling": "steɪblɪŋ",
    "stably": "steɪbli",
    "stabs": "stæbz",
    "stab": "stæb",
    "staccato": "stɐkɑːtəʊ",
    "stacked": "stækt",
    "stacker": "stækɐ",
    "stacking": "stækɪŋ",
    "stacks": "stæks",
    "stack": "stæk",
    "stadia": "steɪdiɐ",
    "stadiums": "steɪdiəmz",
    "stadium": "steɪdiəm",
    "staffed": "stɑːft",
    "staffers": "stæfəz",
    "staffer": "stæfɐ",
    "staffing": "stɑːfɪŋ",
    "staffroom": "stɑːfruːm",
    "staff": "stɑːf",
    "stagecoaches": "steɪdʒɪkəʊtʃɪz",
    "stagecoach": "steɪdʒɪkəʊtʃ",
    "stagecraft": "steɪdʒɪkrɑːft",
    "staged": "steɪdʒd",
    "stagefright": "steɪdʒɪfraɪt",
    "stagehands": "steɪdʒɪhændz",
    "stagehand": "steɪdʒɪhænd",
    "stages": "steɪdʒɪz",
    "stage": "steɪdʒ",
    "stagey": "steɪdʒi",
    "stagflation": "stæɡfleɪʃən",
    "staggered": "stæɡəd",
    "staggeringly": "stæɡərɪŋli",
    "staggering": "stæɡərɪŋ",
    "staggers": "stæɡəz",
    "stagger": "stæɡɐ",
    "staghounds": "stæɡhaʊndz",
    "staging": "steɪdʒɪŋ",
    "stagnant": "stæɡnənt",
    "stagnated": "stæɡneɪtɪd",
    "stagnates": "stæɡneɪts",
    "stagnate": "stæɡneɪt",
    "stagnating": "stæɡneɪtɪŋ",
    "stagnation": "stæɡneɪʃən",
    "stags": "stæɡz",
    "stag": "stæɡ",
    "stagy": "steɪdʒi",
    "staid": "steɪd",
    "stained": "steɪnd",
    "stainer": "steɪnɐ",
    "staining": "steɪnɪŋ",
    "stainless": "steɪnləs",
    "stains": "steɪnz",
    "stain": "steɪn",
    "staircases": "steəkeɪsɪz",
    "staircase": "steəkeɪs",
    "stairs": "steəz",
    "stair": "steə",
    "stairways": "steəweɪz",
    "stairway": "steəweɪ",
    "stairwells": "steəwɛlz",
    "stairwell": "steəwɛl",
    "staked": "steɪkt",
    "stakeholders": "steɪkhəʊldəz",
    "stakeholder": "steɪkhəʊldɐ",
    "stakeouts": "steɪkaʊts",
    "stakeout": "steɪkaʊt",
    "stakes": "steɪks",
    "stake": "steɪk",
    "staking": "steɪkɪŋ",
    "stalactites": "stælɐktaɪts",
    "stalactite": "stælɐktaɪt",
    "stalagmites": "stælɐɡmaɪts",
    "stalagmite": "stælɐɡmaɪt",
    "stalag": "stælæɡ",
    "stalemates": "steɪlmeɪts",
    "stalemate": "steɪlmeɪt",
    "staleness": "steɪlnəs",
    "staler": "steɪlɐ",
    "stale": "steɪl",
    "stalked": "stɔːkt",
    "stalkers": "stɔːkəz",
    "stalker": "stɔːkɐ",
    "stalking": "stɔːkɪŋ",
    "stalks": "stɔːks",
    "stalk": "stɔːk",
    "stalky": "stɔːki",
    "stalled": "stɔːld",
    "stallholders": "stɔːlhəʊldəz",
    "stallholder": "stɔːlhəʊldɐ",
    "stalling": "stɔːlɪŋ",
    "stallions": "stæliənz",
    "stallion": "stæliən",
    "stalls": "stɔːlz",
    "stall": "stɔːl",
    "stalwarts": "stɔːlwɔːts",
    "stalwart": "stɔːlwɔːt",
    "stamens": "steɪmɛnz",
    "stamen": "steɪmɛn",
    "stamina": "stæmɪnɐ",
    "stammered": "stæməd",
    "stammerers": "stæmərəz",
    "stammerer": "stæmərɐ",
    "stammering": "stæmərɪŋ",
    "stammers": "stæməz",
    "stammer": "stæmɐ",
    "stampeded": "stæmpiːdɪd",
    "stampedes": "stæmpiːdz",
    "stampede": "stæmpiːd",
    "stampeding": "stæmpiːdɪŋ",
    "stamped": "stæmpt",
    "stampers": "stæmpəz",
    "stamper": "stæmpɐ",
    "stamping": "stæmpɪŋ",
    "stamps": "stæmps",
    "stamp": "stæmp",
    "stances": "stɑːnsɪz",
    "stance": "stɑːns",
    "stanchions": "stɑːnʃənz",
    "stanchion": "stɑːnʃən",
    "standalone": "stændɐləʊn",
    "standardisation": "stændədaɪzeɪʃən",
    "standardised": "stændədaɪzd",
    "standardises": "stændədaɪzɪz",
    "standardise": "stændədaɪz",
    "standardising": "stændədaɪzɪŋ",
    "standards": "stændədz",
    "standard": "stændəd",
    "standbys": "stændbaɪz",
    "standby": "stændbaɪ",
    "standee": "stændiː",
    "standers": "stændəz",
    "stander": "stændɐ",
    "standfast": "stændfɑːst",
    "standings": "stændɪŋz",
    "standing": "stændɪŋ",
    "standoffish": "stændɒfɪʃ",
    "standoff": "stændɒf",
    "standouts": "stændaʊts",
    "standout": "stændaʊt",
    "standpipes": "stændpaɪps",
    "standpipe": "stændpaɪp",
    "standpoints": "stændpɔɪnts",
    "standpoint": "stændpɔɪnt",
    "stands": "stændz",
    "stand": "stænd",
    "standstill": "stændstɪl",
    "standup": "stændʌp",
    "stane": "steɪn",
    "stang": "stæŋ",
    "stanhope": "stænhəʊp",
    "stank": "stæŋk",
    "stannic": "stænɪk",
    "stanzas": "stænzəz",
    "stanza": "stænzɐ",
    "stapes": "steɪps",
    "staph": "stæf",
    "staphylococcus": "stæfɪlɒkɒkəs",
    "stapled": "steɪpəld",
    "staplers": "steɪpləz",
    "stapler": "steɪplɐ",
    "staples": "steɪpəlz",
    "staple": "steɪpəl",
    "stapling": "steɪplɪŋ",
    "starboard": "stɑːbəd",
    "starched": "stɑːtʃt",
    "starches": "stɑːtʃɪz",
    "starchiness": "stɑːtʃɪnəs",
    "starching": "stɑːtʃɪŋ",
    "starch": "stɑːtʃ",
    "starchy": "stɑːtʃi",
    "stardom": "stɑːdəm",
    "stardust": "stɑːdʌst",
    "stared": "steəd",
    "starer": "steərɐ",
    "stares": "steəz",
    "stare": "steə",
    "starfish": "stɑːfɪʃ",
    "starflower": "stɑːflaʊɐ",
    "stargazers": "stɑːɡeɪzəz",
    "stargazer": "stɑːɡeɪzɐ",
    "stargaze": "stɑːɡeɪz",
    "stargazing": "stɑːɡeɪzɪŋ",
    "staring": "steərɪŋ",
    "starkers": "stɑːkəz",
    "starker": "stɑːkɐ",
    "starkest": "stɑːkəst",
    "starkly": "stɑːkli",
    "starkness": "stɑːknəs",
    "stark": "stɑːk",
    "starless": "stɑːləs",
    "starlets": "stɑːləts",
    "starlet": "stɑːlət",
    "starlight": "stɑːlaɪt",
    "starlings": "stɑːlɪŋz",
    "starling": "stɑːlɪŋ",
    "starlit": "stɑːlɪt",
    "starred": "stɑːd",
    "starriest": "stɑːrɪəst",
    "starring": "stɑːrɪŋ",
    "starry": "stɑːri",
    "stars": "stɑːz",
    "star": "stɑː",
    "starstruck": "stɑːstrʌk",
    "started": "stɑːtɪd",
    "starters": "stɑːtəz",
    "starter": "stɑːtɐ",
    "starting": "stɑːtɪŋ",
    "startled": "stɑːtəld",
    "startles": "stɑːtəlz",
    "startle": "stɑːtəl",
    "startlingly": "stɑːtəlɪŋli",
    "startling": "stɑːtlɪŋ",
    "starts": "stɑːts",
    "start": "stɑːt",
    "startups": "stɑːtʌps",
    "startup": "stɑːtʌp",
    "starvation": "stɑːveɪʃən",
    "starved": "stɑːvd",
    "starveling": "stɑːvəlɪŋ",
    "starves": "stɑːvz",
    "starve": "stɑːv",
    "starving": "stɑːvɪŋ",
    "stashed": "stæʃt",
    "stashes": "stæʃɪz",
    "stashing": "stæʃɪŋ",
    "stash": "stæʃ",
    "stasis": "steɪsɪs",
    "statecraft": "steɪtkrɑːft",
    "stated": "steɪtɪd",
    "statehood": "steɪthʊd",
    "stateless": "steɪtləs",
    "stately": "steɪtli",
    "statements": "steɪtmənts",
    "statement": "steɪtmənt",
    "staterooms": "steɪtruːmz",
    "stateside": "steɪtsaɪd",
    "statesmanlike": "steɪtsmənlaɪk",
    "statesmanship": "steɪtsmənʃɪp",
    "statesman": "steɪtsmən",
    "statesmen": "steɪtsmɛn",
    "states": "steɪts",
    "state": "steɪt",
    "stateswoman": "steɪtswʊmən",
    "statically": "stætɪkli",
    "statics": "stætɪks",
    "static": "stætɪk",
    "stating": "steɪtɪŋ",
    "stationary": "steɪʃənəri",
    "stationed": "steɪʃənd",
    "stationers": "steɪʃənəz",
    "stationer": "steɪʃənɐ",
    "stationery": "steɪʃənəri",
    "stationing": "steɪʃənɪŋ",
    "stationmasters": "steɪʃənmɑːstəz",
    "stationmaster": "steɪʃənmɑːstɐ",
    "stations": "steɪʃənz",
    "station": "steɪʃən",
    "statism": "steɪtɪzəm",
    "statistically": "stɐtɪstɪkli",
    "statistical": "stɐtɪstɪkəl",
    "statisticians": "stætɪstɪʃənz",
    "statistician": "stætɪstɪʃən",
    "statistics": "stɐtɪstɪks",
    "statistic": "stɐtɪstɪk",
    "statist": "stætɪst",
    "stator": "steɪtɐ",
    "stats": "stæts",
    "statuary": "stætʃuːəri",
    "statuesque": "stætʃuːɛsk",
    "statues": "stætʃuːz",
    "statue": "stætʃuː",
    "statuettes": "stætʃuːɛts",
    "statuette": "stætʃuːɛt",
    "stature": "stætʃɐ",
    "statuses": "steɪtəsɪz",
    "status": "steɪtəs",
    "statutes": "stætʃuːts",
    "statute": "stætʃuːt",
    "statutorily": "stætʃuːtərəli",
    "statutory": "stætʃuːtəri",
    "staunched": "stɔːntʃt",
    "staunchest": "stɔːntʃəst",
    "staunching": "stɔːntʃɪŋ",
    "staunchly": "stɔːntʃli",
    "staunchness": "stɔːntʃnəs",
    "staunch": "stɔːntʃ",
    "staved": "steɪvd",
    "staves": "steɪvz",
    "stave": "steɪv",
    "staving": "steɪvɪŋ",
    "stayed": "steɪd",
    "stayers": "steɪəz",
    "stayer": "steɪɐ",
    "staying": "steɪɪŋ",
    "staysail": "steɪseɪl",
    "stays": "steɪz",
    "stay": "steɪ",
    "steadfastly": "stɛdfɑːstli",
    "steadfastness": "stɛdfɑːstnəs",
    "steadfast": "stɛdfɑːst",
    "steadied": "stɛdɪd",
    "steadier": "stɛdɪɐ",
    "steadies": "stɛdɪz",
    "steadiest": "stɛdɪəst",
    "steadily": "stɛdɪli",
    "steadiness": "stɛdɪnəs",
    "steading": "stɛdɪŋ",
    "steads": "stɛdz",
    "stead": "stɛd",
    "steadying": "stɛdɪɪŋ",
    "steady": "stɛdi",
    "steakhouses": "steɪkhaʊzɪz",
    "steakhouse": "steɪkhaʊs",
    "steaks": "steɪks",
    "steak": "steɪk",
    "stealer": "stiːlɐ",
    "stealing": "stiːlɪŋ",
    "steals": "stiːlz",
    "steal": "stiːl",
    "stealthiest": "stɛlθɪəst",
    "stealthily": "stɛlθɪli",
    "stealth": "stɛlθ",
    "stealthy": "stɛlθi",
    "steamboats": "stiːmbəʊts",
    "steamboat": "stiːmbəʊt",
    "steamed": "stiːmd",
    "steamers": "stiːməz",
    "steamer": "stiːmɐ",
    "steamier": "stiːmɪɐ",
    "steaminess": "stiːmɪnəs",
    "steaming": "stiːmɪŋ",
    "steamrolled": "stiːmrəʊld",
    "steamrollered": "stiːmrəʊləd",
    "steamrollering": "stiːmrəʊlərɪŋ",
    "steamrollers": "stiːmrəʊləz",
    "steamroller": "stiːmrəʊlɐ",
    "steamrolling": "stiːmrəʊlɪŋ",
    "steamroll": "stiːmrəʊl",
    "steamships": "stiːmʃɪps",
    "steamship": "stiːmʃɪp",
    "steams": "stiːmz",
    "steam": "stiːm",
    "steamy": "stiːmi",
    "stearic": "steərɪk",
    "steatite": "stiːtaɪt",
    "steeds": "stiːdz",
    "steed": "stiːd",
    "steeled": "stiːld",
    "steelhead": "stiːlhɛd",
    "steelier": "stiːliɐ",
    "steeliness": "stiːlinəs",
    "steeling": "stiːlɪŋ",
    "steelmaker": "stiːlmeɪkɐ",
    "steels": "stiːlz",
    "steel": "stiːl",
    "steelworkers": "stiːlwɜːkəz",
    "steelworker": "stiːlwɜːkɐ",
    "steelworks": "stiːlwɜːks",
    "steelwork": "stiːlwɜːk",
    "steely": "stiːli",
    "steenbok": "stiːnbɒk",
    "steeped": "stiːpt",
    "steepening": "stiːpənɪŋ",
    "steepen": "stiːpən",
    "steeper": "stiːpɐ",
    "steepest": "stiːpəst",
    "steeping": "stiːpɪŋ",
    "steeplechasers": "stiːplɪtʃeɪsəz",
    "steeplechaser": "stiːplɪtʃeɪsɐ",
    "steeplechase": "stiːplɪtʃeɪs",
    "steeplechasing": "stiːplɪtʃeɪsɪŋ",
    "steeplejacks": "stiːplɪdʒæks",
    "steeplejack": "stiːplɪdʒæk",
    "steeples": "stiːpəlz",
    "steeple": "stiːpəl",
    "steeply": "stiːpli",
    "steepness": "stiːpnəs",
    "steeps": "stiːps",
    "steep": "stiːp",
    "steerable": "stiərəbəl",
    "steerage": "stiərɪdʒ",
    "steered": "stiəd",
    "steerer": "stiərɐ",
    "steering": "stiərɪŋ",
    "steersman": "stiəzmən",
    "steers": "stiəz",
    "steer": "stiə",
    "stegosaur": "stɛɡəsɔː",
    "stegosaurus": "stɛɡəsɔːrəs",
    "steins": "staɪnz",
    "stein": "staɪn",
    "stelae": "stɛliː",
    "stela": "stɛlɐ",
    "stellar": "stɛlɐ",
    "stemmed": "stɛmd",
    "stemming": "stɛmɪŋ",
    "stems": "stɛmz",
    "stem": "stɛm",
    "stemware": "stɛmweə",
    "stenches": "stɛntʃɪz",
    "stench": "stɛntʃ",
    "stencilled": "stɛnsəld",
    "stencilling": "stɛnsəlɪŋ",
    "stencils": "stɛnsəlz",
    "stencil": "stɛnsəl",
    "stenographers": "stɛnɒɡrəfəz",
    "stenographer": "stɛnɒɡrəfɐ",
    "stenosis": "stɛnəʊsɪs",
    "steno": "stiːnəʊ",
    "stentorian": "stɛntɔːriən",
    "stent": "stɛnt",
    "stepbrothers": "stɛpbrʌðəz",
    "stepbrother": "stɛpbrʌðɐ",
    "stepchildren": "stɛptʃɪldrən",
    "stepchild": "stɛptʃaɪld",
    "stepdaughters": "stɛpdɔːtəz",
    "stepdaughter": "stɛpdɔːtɐ",
    "stepfathers": "stɛpfɑːðəz",
    "stepfather": "stɛpfɑːðɐ",
    "stepladders": "stɛplædəz",
    "stepladder": "stɛplædɐ",
    "stepmothers": "stɛpmʌðəz",
    "stepmother": "stɛpmʌðɐ",
    "stepped": "stɛpt",
    "steppers": "stɛpəz",
    "stepper": "stɛpɐ",
    "steppes": "stɛps",
    "steppe": "stɛp",
    "stepping": "stɛpɪŋ",
    "stepsisters": "stɛpsɪstəz",
    "stepsister": "stɛpsɪstɐ",
    "stepsons": "stɛpsənz",
    "stepson": "stɛpsən",
    "steps": "stɛps",
    "step": "stɛp",
    "stereographic": "stɛrɪəʊɡræfɪk",
    "stereograph": "stɛrɪəʊɡræf",
    "stereophonic": "stɛrɪəʊfɒnɪk",
    "stereoscopes": "stɛrɪəʊskəʊps",
    "stereoscope": "stɛrɪəʊskəʊp",
    "stereoscopic": "stɛrɪəʊskɒpɪk",
    "stereoscopy": "stɛrɪəʊskəpi",
    "stereos": "stɛrɪəʊz",
    "stereo": "stɛrɪəʊ",
    "stereotyped": "stɛrɪəʊtaɪpd",
    "stereotypes": "stɛrɪəʊtaɪps",
    "stereotype": "stɛrɪəʊtaɪp",
    "stereotypically": "stɛrɪəʊtɪpɪkli",
    "stereotypical": "stɛrɪəʊtɪpɪkəl",
    "stereotypic": "stɛrɪəʊtɪpɪk",
    "stereotyping": "stɛrɪəʊtaɪpɪŋ",
    "sterile": "stɛraɪl",
    "sterilisations": "stɛrɪlaɪzeɪʃənz",
    "sterilisation": "stɛrɪlaɪzeɪʃən",
    "sterilised": "stɛrəlaɪzd",
    "sterilisers": "stɛrəlaɪzəz",
    "steriliser": "stɛrəlaɪzɐ",
    "sterilises": "stɛrəlaɪzɪz",
    "sterilise": "stɛrəlaɪz",
    "sterilising": "stɛrəlaɪzɪŋ",
    "sterility": "stɛrɪlɪti",
    "sterling": "stɜːlɪŋ",
    "sterna": "stɜːnɐ",
    "sterner": "stɜːnɐ",
    "sternest": "stɜːnəst",
    "sternly": "stɜːnli",
    "sternness": "stɜːnnəs",
    "sterns": "stɜːnz",
    "stern": "stɜːn",
    "sternums": "stɜːnəmz",
    "sternum": "stɜːnəm",
    "sternutation": "stɜːnjuːteɪʃən",
    "steroidal": "stɛrɔɪdəl",
    "steroids": "stɛrɔɪdz",
    "steroid": "stɛrɔɪd",
    "stethoscopes": "stɛθəskəʊps",
    "stethoscope": "stɛθəskəʊp",
    "stetsons": "stɛtsənz",
    "stetson": "stɛtsən",
    "stets": "stɛts",
    "stet": "stɛt",
    "stevedores": "stiːvɪdɔːz",
    "stevedore": "stiːvɪdɔː",
    "stewarded": "stjuːədɪd",
    "stewardesses": "stjuːədɛsɪz",
    "stewardess": "stjuːədɛs",
    "stewarding": "stjuːədɪŋ",
    "stewardship": "stjuːədʃɪp",
    "stewards": "stjuːədz",
    "steward": "stjuːəd",
    "stewed": "stjuːd",
    "stewing": "stjuːɪŋ",
    "stews": "stjuːz",
    "stew": "stjuː",
    "stibnite": "stɪbnaɪt",
    "stich": "stɪtʃ",
    "stickers": "stɪkəz",
    "sticker": "stɪkɐ",
    "stickier": "stɪkiɐ",
    "stickies": "stɪkiz",
    "stickiest": "stɪkiəst",
    "stickily": "stɪkili",
    "stickiness": "stɪkinəs",
    "sticking": "stɪkɪŋ",
    "sticklebacks": "stɪklɪbæks",
    "stickleback": "stɪklɪbæk",
    "sticklers": "stɪkləz",
    "stickler": "stɪklɐ",
    "stickle": "stɪkəl",
    "stickpin": "stɪkpɪn",
    "sticks": "stɪks",
    "stick": "stɪk",
    "sticky": "stɪki",
    "sties": "staɪz",
    "stiffed": "stɪft",
    "stiffened": "stɪfənd",
    "stiffeners": "stɪfənəz",
    "stiffener": "stɪfənɐ",
    "stiffening": "stɪfənɪŋ",
    "stiffens": "stɪfənz",
    "stiffen": "stɪfən",
    "stiffer": "stɪfɐ",
    "stiffest": "stɪfəst",
    "stiffing": "stɪfɪŋ",
    "stiffish": "stɪfɪʃ",
    "stiffly": "stɪfli",
    "stiffness": "stɪfnəs",
    "stiffs": "stɪfs",
    "stiff": "stɪf",
    "stifled": "staɪfəld",
    "stifles": "staɪfəlz",
    "stifle": "staɪfəl",
    "stiflingly": "staɪfəlɪŋli",
    "stifling": "staɪflɪŋ",
    "stigmas": "stɪɡməz",
    "stigma": "stɪɡmɐ",
    "stigmata": "stɪɡmɑːtɐ",
    "stigmatisation": "stɪɡmɐtaɪzeɪʃən",
    "stigmatised": "stɪɡmɐtaɪzd",
    "stigmatises": "stɪɡmɐtaɪzɪz",
    "stigmatise": "stɪɡmɐtaɪz",
    "stigmatising": "stɪɡmɐtaɪzɪŋ",
    "stiles": "staɪlz",
    "stile": "staɪl",
    "stilettoes": "stɪlɛtəʊz",
    "stilettos": "stɪlɛtəʊz",
    "stiletto": "stɪlɛtəʊ",
    "stillbirths": "stɪlbɜːθs",
    "stillbirth": "stɪlbɜːθ",
    "stillborn": "stɪlbɔːn",
    "stilled": "stɪld",
    "stiller": "stɪlɐ",
    "stillest": "stɪləst",
    "stilling": "stɪlɪŋ",
    "stillness": "stɪlnəs",
    "stills": "stɪlz",
    "still": "stɪl",
    "stilted": "stɪltɪd",
    "stilts": "stɪlts",
    "stilt": "stɪlt",
    "stimulants": "stɪmjʊlənts",
    "stimulant": "stɪmjʊlənt",
    "stimulated": "stɪmjʊleɪtɪd",
    "stimulates": "stɪmjʊleɪts",
    "stimulate": "stɪmjʊleɪt",
    "stimulating": "stɪmjʊleɪtɪŋ",
    "stimulation": "stɪmjʊleɪʃən",
    "stimulative": "stɪmjʊlətɪv",
    "stimulator": "stɪmjʊleɪtɐ",
    "stimuli": "stɪmjʊlaɪ",
    "stimulus": "stɪmjʊləs",
    "stingers": "stɪŋɡəz",
    "stinger": "stɪŋɡɐ",
    "stingier": "stɪndʒiɐ",
    "stinginess": "stɪndʒinəs",
    "stinging": "stɪŋɪŋ",
    "stingrays": "stɪŋɡreɪz",
    "stingray": "stɪŋɡreɪ",
    "stings": "stɪŋz",
    "sting": "stɪŋ",
    "stinkers": "stɪŋkəz",
    "stinker": "stɪŋkɐ",
    "stinkhorn": "stɪŋkhɔːn",
    "stinkier": "stɪŋkiɐ",
    "stinkiest": "stɪŋkiəst",
    "stinking": "stɪŋkɪŋ",
    "stinko": "stɪnkəʊ",
    "stinks": "stɪŋks",
    "stink": "stɪŋk",
    "stinkweed": "stɪŋkwiːd",
    "stinky": "stɪŋki",
    "stinted": "stɪntɪd",
    "stinting": "stɪntɪŋ",
    "stints": "stɪnts",
    "stint": "stɪnt",
    "stipendiary": "staɪpndjəri",
    "stipend": "staɪpənd",
    "stipe": "staɪp",
    "stippled": "stɪpəld",
    "stipple": "stɪpəl",
    "stippling": "stɪplɪŋ",
    "stipulated": "stɪpjʊleɪtɪd",
    "stipulates": "stɪpjʊleɪts",
    "stipulating": "stɪpjʊleɪtɪŋ",
    "stipulations": "stɪpjʊleɪʃənz",
    "stipulation": "stɪpjʊleɪʃən",
    "stirk": "stɜːk",
    "stirred": "stɜːd",
    "stirrers": "stɜːrəz",
    "stirrer": "stɜːrɐ",
    "stirringly": "stɜːrɪŋli",
    "stirrings": "stɜːrɪŋz",
    "stirring": "stɜːrɪŋ",
    "stirrups": "stɪrʌps",
    "stirrup": "stɪrʌp",
    "stirs": "stɜːz",
    "stir": "stɜː",
    "stitched": "stɪtʃt",
    "stitchers": "stɪtʃəz",
    "stitches": "stɪtʃɪz",
    "stitching": "stɪtʃɪŋ",
    "stitch": "stɪtʃ",
    "stoats": "stəʊts",
    "stoat": "stəʊt",
    "stob": "stɒb",
    "stochastic": "stətʃɑːstɪk",
    "stockades": "stɒkeɪdz",
    "stockade": "stɒkeɪd",
    "stockbrokers": "stɒkbrəʊkəz",
    "stockbroker": "stɒkbrəʊkɐ",
    "stockbroking": "stɒkbrəʊkɪŋ",
    "stocked": "stɒkt",
    "stockholders": "stɒkhəʊldəz",
    "stockholder": "stɒkhəʊldɐ",
    "stockier": "stɒkiɐ",
    "stockings": "stɒkɪŋz",
    "stocking": "stɒkɪŋ",
    "stockists": "stɒkɪsts",
    "stockist": "stɒkɪst",
    "stockman": "stɒkmən",
    "stockmen": "stɒkmɛn",
    "stockpiled": "stɒkpaɪld",
    "stockpiles": "stɒkpaɪlz",
    "stockpile": "stɒkpaɪl",
    "stockpiling": "stɒkpaɪlɪŋ",
    "stockpots": "stɒkpɒts",
    "stockpot": "stɒkpɒt",
    "stockroom": "stɒkruːm",
    "stocks": "stɒks",
    "stock": "stɒk",
    "stocktaking": "stɒkteɪkɪŋ",
    "stockyards": "stɒkjɑːdz",
    "stockyard": "stɒkjɑːd",
    "stocky": "stɒki",
    "stodge": "stɒdʒ",
    "stodgier": "stɒdʒɪɐ",
    "stodgy": "stɒdʒi",
    "stogie": "stəʊdʒi",
    "stogy": "stəʊɡi",
    "stoically": "stəʊɪkli",
    "stoical": "stəʊɪkəl",
    "stoicism": "stəʊɪsɪzəm",
    "stoics": "stəʊɪks",
    "stoic": "stəʊɪk",
    "stoked": "stəʊkt",
    "stokers": "stəʊkəz",
    "stoker": "stəʊkɐ",
    "stokes": "stəʊks",
    "stoke": "stəʊk",
    "stoking": "stəʊkɪŋ",
    "stolen": "stəʊlən",
    "stoles": "stəʊlz",
    "stole": "stəʊl",
    "stolid": "stɒlɪd",
    "stolons": "stɒlɒnz",
    "stomachache": "stʌməkeɪk",
    "stomaching": "stʌməkɪŋ",
    "stomachs": "stʌməkz",
    "stomach": "stʌmək",
    "stoma": "stəʊmɐ",
    "stomata": "stəʊmətɐ",
    "stomatitis": "stɒmɐtaɪtɪs",
    "stomped": "stɒmpt",
    "stomping": "stɒmpɪŋ",
    "stomps": "stɒmps",
    "stomp": "stɒmp",
    "stonechats": "stəʊntʃæts",
    "stonechat": "stəʊntʃæt",
    "stonecrop": "stəʊnkrɒp",
    "stonecutters": "stəʊnkʌtəz",
    "stonecutter": "stəʊnkʌtɐ",
    "stoned": "stəʊnd",
    "stonefish": "stəʊnfɪʃ",
    "stoneflies": "stəʊnflaɪz",
    "stonefly": "stəʊnflaɪ",
    "stonemasons": "stəʊnmeɪsənz",
    "stonemason": "stəʊnmeɪsən",
    "stones": "stəʊnz",
    "stone": "stəʊn",
    "stonewalled": "stəʊnwɔːld",
    "stonewalling": "stəʊnwɔːlɪŋ",
    "stonewalls": "stəʊnwɔːlz",
    "stonewall": "stəʊnwɔːl",
    "stoneware": "stəʊnweə",
    "stonewashed": "stəʊnwɒʃt",
    "stonework": "stəʊnwɜːk",
    "stoney": "stəʊni",
    "stonier": "stəʊnɪɐ",
    "stoning": "stəʊnɪŋ",
    "stonking": "stɒŋkɪŋ",
    "stony": "stəʊni",
    "stood": "stʊd",
    "stooges": "stuːdʒɪz",
    "stooge": "stuːdʒ",
    "stook": "stʊk",
    "stools": "stuːlz",
    "stool": "stuːl",
    "stooped": "stuːpt",
    "stooping": "stuːpɪŋ",
    "stoops": "stuːps",
    "stoop": "stuːp",
    "stopcock": "stɒpkɒk",
    "stope": "stəʊp",
    "stopgap": "stɒpɡæp",
    "stopovers": "stɒpəʊvəz",
    "stopover": "stɒpəʊvɐ",
    "stoppable": "stɒpəbəl",
    "stoppages": "stɒpɪdʒɪz",
    "stoppage": "stɒpɪdʒ",
    "stopped": "stɒpt",
    "stoppered": "stɒpəd",
    "stoppers": "stɒpəz",
    "stopper": "stɒpɐ",
    "stopping": "stɒpɪŋ",
    "stops": "stɒps",
    "stop": "stɒp",
    "stopwatches": "stɒpwɒtʃɪz",
    "stopwatch": "stɒpwɒtʃ",
    "storage": "stɔːrɪdʒ",
    "storax": "stɔːræks",
    "stored": "stɔːd",
    "storefront": "stɔːfrʌnt",
    "storehouses": "stɔːhaʊzɪz",
    "storehouse": "stɔːhaʊs",
    "storekeepers": "stɔːkiːpəz",
    "storekeeper": "stɔːkiːpɐ",
    "storerooms": "stɔːruːmz",
    "storeroom": "stɔːruːm",
    "stores": "stɔːz",
    "store": "stɔː",
    "storeys": "stɔːrɪz",
    "storey": "stɔːri",
    "storied": "stɔːrɪd",
    "stories": "stɔːrɪz",
    "storing": "stɔːrɪŋ",
    "storks": "stɔːks",
    "stork": "stɔːk",
    "stormed": "stɔːmd",
    "stormier": "stɔːmɪɐ",
    "stormiest": "stɔːmɪəst",
    "storming": "stɔːmɪŋ",
    "storms": "stɔːmz",
    "storm": "stɔːm",
    "stormtroopers": "stɔːmtruːpəz",
    "stormy": "stɔːmi",
    "storyboards": "stɔːrɪbɔːdz",
    "storyboard": "stɔːrɪbɔːd",
    "storybooks": "stɔːrɪbʊks",
    "storybook": "stɔːrɪbʊk",
    "storyline": "stɔːrɪlaɪn",
    "story": "stɔːri",
    "storytellers": "stɔːrɪtɛləz",
    "storyteller": "stɔːrɪtɛlɐ",
    "storytelling": "stɔːrɪtɛlɪŋ",
    "stoups": "stuːps",
    "stoup": "stuːp",
    "stour": "stɔː",
    "stoutest": "staʊtəst",
    "stoutly": "staʊtli",
    "stouts": "staʊts",
    "stout": "staʊt",
    "stovepipe": "stəʊvpaɪp",
    "stover": "stəʊvɐ",
    "stoves": "stəʊvz",
    "stove": "stəʊv",
    "stowage": "stəʊɪdʒ",
    "stowaways": "stəʊəweɪz",
    "stowaway": "stəʊəweɪ",
    "stowed": "stəʊd",
    "stowing": "stəʊɪŋ",
    "stows": "stəʊz",
    "stow": "stəʊ",
    "strabismus": "stræbɪsməs",
    "straddled": "strædəld",
    "straddles": "strædəlz",
    "straddle": "strædəl",
    "straddling": "strædlɪŋ",
    "strafed": "streɪft",
    "strafes": "streɪfs",
    "strafe": "streɪf",
    "strafing": "streɪfɪŋ",
    "straggled": "stræɡəld",
    "stragglers": "stræɡləz",
    "straggler": "stræɡlɐ",
    "straggle": "stræɡəl",
    "straggling": "stræɡlɪŋ",
    "straggly": "stræɡli",
    "straightaways": "streɪtəweɪz",
    "straightaway": "streɪtəweɪ",
    "straightened": "streɪtənd",
    "straighteners": "streɪtənəz",
    "straightener": "streɪtənɐ",
    "straightening": "streɪtənɪŋ",
    "straightens": "streɪtənz",
    "straighten": "streɪtən",
    "straighter": "streɪtɐ",
    "straightest": "streɪtəst",
    "straightforwardly": "streɪtfɔːwədli",
    "straightforwardness": "streɪtfɔːwədnəs",
    "straightforward": "streɪtfɔːwəd",
    "straightjacket": "streɪtdʒækɪt",
    "straightly": "streɪtli",
    "straightness": "streɪtnəs",
    "straights": "streɪts",
    "straight": "streɪt",
    "straightway": "streɪtweɪ",
    "strained": "streɪnd",
    "strainers": "streɪnəz",
    "strainer": "streɪnɐ",
    "straining": "streɪnɪŋ",
    "strains": "streɪnz",
    "strain": "streɪn",
    "straitened": "streɪtənd",
    "straitjacketed": "streɪtdʒɐkɪtɪd",
    "straitjackets": "streɪtdʒækɪts",
    "straitjacket": "streɪtdʒækɪt",
    "straits": "streɪts",
    "strait": "streɪt",
    "strakes": "streɪks",
    "strake": "streɪk",
    "stranded": "strændɪd",
    "stranding": "strændɪŋ",
    "strands": "strændz",
    "strand": "strænd",
    "strangely": "streɪndʒli",
    "strangeness": "streɪndʒnəs",
    "strangers": "streɪndʒəz",
    "stranger": "streɪndʒɐ",
    "strange": "streɪndʒ",
    "strangest": "streɪndʒəst",
    "strangled": "stræŋɡəld",
    "stranglehold": "stræŋɡəlhəʊld",
    "stranglers": "stræŋɡləz",
    "strangler": "stræŋɡlɐ",
    "strangles": "stræŋɡəlz",
    "strangle": "stræŋɡəl",
    "strangling": "stræŋɡəlɪŋ",
    "strangulated": "strænɡjʊleɪtɪd",
    "strangulate": "strænɡjʊleɪt",
    "strangulation": "strænɡjʊleɪʃən",
    "strapless": "stræpləs",
    "strapped": "stræpt",
    "strapping": "stræpɪŋ",
    "straps": "stræps",
    "strap": "stræp",
    "stratagems": "stræteɪdʒəmz",
    "stratagem": "stræteɪdʒəm",
    "strata": "strɑːtɐ",
    "strategically": "strətiːdʒɪkli",
    "strategical": "strətiːdʒɪkəl",
    "strategic": "strətiːdʒɪk",
    "strategies": "strætədʒɪz",
    "strategists": "strætɪdʒɪsts",
    "strategist": "strætɪdʒɪst",
    "strategy": "strætədʒi",
    "strathspey": "stræθspi",
    "strath": "stræθ",
    "stratification": "strætɪfɪkeɪʃən",
    "stratified": "strætɪfaɪd",
    "stratify": "strætɪfaɪ",
    "stratigraphy": "strætɪɡrəfi",
    "stratocumulus": "strætəkjuːmjʊləs",
    "stratosphere": "strætəsfiə",
    "stratospheric": "strætəsfɛrɪk",
    "stratum": "strɑːtəm",
    "stratus": "strætəs",
    "strawberries": "strɔːbərɪz",
    "strawberry": "strɔːbəri",
    "strawing": "strɔːrɪŋ",
    "straws": "strɔːz",
    "straw": "strɔː",
    "strayed": "streɪd",
    "straying": "streɪɪŋ",
    "strays": "streɪz",
    "stray": "streɪ",
    "streaked": "striːkt",
    "streakers": "striːkəz",
    "streaker": "striːkɐ",
    "streaking": "striːkɪŋ",
    "streaks": "striːks",
    "streak": "striːk",
    "streaky": "striːki",
    "streamed": "striːmd",
    "streamers": "striːməz",
    "streamer": "striːmɐ",
    "streaming": "striːmɪŋ",
    "streamlined": "striːmlaɪnd",
    "streamliner": "striːmlaɪnɐ",
    "streamlines": "striːmlaɪnz",
    "streamline": "striːmlaɪn",
    "streamlining": "striːmlaɪnɪŋ",
    "streams": "striːmz",
    "stream": "striːm",
    "streamy": "striːmi",
    "stree": "striː",
    "streetcar": "striːtkɑː",
    "streetlamps": "striːtlæmps",
    "streetlamp": "striːtlæmp",
    "streetlights": "striːtlaɪts",
    "streetlight": "striːtlaɪt",
    "streets": "striːts",
    "street": "striːt",
    "streetwalkers": "striːtwɔːkəz",
    "streetwalker": "striːtwɔːkɐ",
    "streetwise": "striːtwaɪz",
    "strengthened": "strɛŋθənd",
    "strengtheners": "strɛŋθənəz",
    "strengthening": "strɛŋθənɪŋ",
    "strengthens": "strɛŋθənz",
    "strengthen": "strɛŋθən",
    "strengths": "strɛŋθs",
    "strength": "strɛŋθ",
    "strenuously": "strɛnjuːəsli",
    "strenuous": "strɛnjuːəs",
    "strep": "strɛp",
    "streptococcal": "strɛptəkɒkəl",
    "streptococci": "strɛptəkɒkaɪ",
    "streptococcus": "strɛptəkɒkəs",
    "streptomycin": "strɛptəmɪsɪn",
    "stressed": "strɛst",
    "stresses": "strɛsɪz",
    "stressful": "strɛsfəl",
    "stressing": "strɛsɪŋ",
    "stressor": "strɛsɐ",
    "stress": "strɛs",
    "stretchable": "strɛtʃəbəl",
    "stretched": "strɛtʃt",
    "stretchered": "strɛtʃəd",
    "stretchers": "strɛtʃəz",
    "stretcher": "strɛtʃɐ",
    "stretches": "strɛtʃɪz",
    "stretchier": "strɛtʃɪɐ",
    "stretchiest": "strɛtʃɪəst",
    "stretchiness": "strɛtʃɪnəs",
    "stretching": "strɛtʃɪŋ",
    "stretchmarks": "strɛtʃmɑːks",
    "stretch": "strɛtʃ",
    "stretchy": "strɛtʃi",
    "streusel": "strjuːsəl",
    "strewed": "struːd",
    "strewing": "struːɪŋ",
    "strewn": "struːn",
    "strew": "struː",
    "strewth": "struːθ",
    "striated": "straɪeɪtɪd",
    "striations": "straɪeɪʃənz",
    "striation": "straɪeɪʃən",
    "stricken": "strɪkən",
    "strickle": "strɪkəl",
    "strick": "strɪk",
    "stricter": "strɪktɐ",
    "strictest": "strɪktəst",
    "strictly": "strɪktli",
    "strictness": "strɪktnəs",
    "strict": "strɪkt",
    "strictures": "strɪktʃəz",
    "stricture": "strɪktʃɐ",
    "stridency": "straɪdnsi",
    "stridently": "straɪdəntli",
    "strident": "straɪdənt",
    "strider": "straɪdɐ",
    "strides": "straɪdz",
    "stride": "straɪd",
    "striding": "straɪdɪŋ",
    "stridor": "strɪdɔː",
    "stridulating": "strɪdjʊleɪtɪŋ",
    "stridulation": "strɪdjʊleɪʃən",
    "strife": "straɪf",
    "strigil": "strɪdʒɪl",
    "strikers": "straɪkəz",
    "striker": "straɪkɐ",
    "strikes": "straɪks",
    "strike": "straɪk",
    "strikingly": "straɪkɪŋli",
    "striking": "straɪkɪŋ",
    "stringed": "strɪŋɡd",
    "stringency": "strɪndʒənsi",
    "stringently": "strɪndʒəntli",
    "stringent": "strɪndʒənt",
    "stringers": "strɪŋəz",
    "stringer": "strɪŋɐ",
    "stringier": "strɪŋɪɐ",
    "stringiness": "strɪŋɪnəs",
    "stringing": "strɪŋɪŋ",
    "strings": "strɪŋz",
    "string": "strɪŋ",
    "stringy": "strɪŋi",
    "striped": "straɪpt",
    "stripers": "straɪpəz",
    "stripes": "straɪps",
    "stripe": "straɪp",
    "stripey": "straɪpi",
    "striping": "straɪpɪŋ",
    "stripling": "strɪplɪŋ",
    "stripped": "strɪpt",
    "strippers": "strɪpəz",
    "stripper": "strɪpɐ",
    "stripping": "strɪpɪŋ",
    "strips": "strɪps",
    "strip": "strɪp",
    "striptease": "strɪptiːz",
    "stripy": "straɪpi",
    "strived": "straɪvd",
    "striven": "strɪvən",
    "strives": "straɪvz",
    "strive": "straɪv",
    "strivings": "straɪvɪŋz",
    "striving": "straɪvɪŋ",
    "strobes": "strəʊbz",
    "strobe": "strəʊb",
    "strode": "strəʊd",
    "stroganoff": "strɒɡɐnɒf",
    "stroked": "strəʊkt",
    "strokes": "strəʊks",
    "stroke": "strəʊk",
    "stroking": "strəʊkɪŋ",
    "strolled": "strəʊld",
    "strollers": "strəʊləz",
    "stroller": "strəʊlɐ",
    "strolling": "strəʊlɪŋ",
    "strolls": "strəʊlz",
    "stroll": "strəʊl",
    "stromatolites": "strɒmɐtɒlaɪts",
    "strongbox": "strɒŋbɒks",
    "stronger": "strɒŋɡɐ",
    "strongest": "strɒŋɡəst",
    "strongholds": "strɒŋhəʊldz",
    "stronghold": "strɒŋhəʊld",
    "strongish": "strɒŋɡɪʃ",
    "strongly": "strɒŋli",
    "strongman": "strɒŋmən",
    "strongmen": "strɒŋmɛn",
    "strongroom": "strɒŋɡruːm",
    "strong": "strɒŋ",
    "strontium": "strɒntiəm",
    "strophe": "strɒf",
    "stropped": "strɒpt",
    "stroppier": "strɒpɪɐ",
    "stroppiness": "strɒpɪnəs",
    "stropping": "strɒpɪŋ",
    "stroppy": "strɒpi",
    "strops": "strɒps",
    "strop": "strɒp",
    "stroud": "straʊd",
    "strove": "strəʊv",
    "struck": "strʌk",
    "structuralist": "strʌktʃərəlɪst",
    "structurally": "strʌktʃərəli",
    "structural": "strʌktʃərəl",
    "structured": "strʌktʃəd",
    "structureless": "strʌktʃələs",
    "structures": "strʌktʃəz",
    "structure": "strʌktʃɐ",
    "structuring": "strʌktʃərɪŋ",
    "strudels": "struːdəlz",
    "strudel": "struːdəl",
    "struggled": "strʌɡəld",
    "struggler": "strʌɡlɐ",
    "struggles": "strʌɡəlz",
    "struggle": "strʌɡəl",
    "struggling": "strʌɡlɪŋ",
    "strummed": "strʌmd",
    "strumming": "strʌmɪŋ",
    "strumpets": "strʌmpɪts",
    "strumpet": "strʌmpɪt",
    "strums": "strʌmz",
    "strum": "strʌm",
    "strung": "strʌŋ",
    "struts": "strʌts",
    "strut": "strʌt",
    "strutted": "strʌtɪd",
    "strutter": "strʌtɐ",
    "strutting": "strʌtɪŋ",
    "strychnine": "strɪkniːn",
    "stubbed": "stʌbd",
    "stubbier": "stʌbɪɐ",
    "stubbing": "stʌbɪŋ",
    "stubble": "stʌbəl",
    "stubbly": "stʌbli",
    "stubbornly": "stʌbənli",
    "stubbornness": "stʌbənnəs",
    "stubborn": "stʌbən",
    "stubby": "stʌbi",
    "stubs": "stʌbz",
    "stub": "stʌb",
    "stuccoed": "stʌkəʊd",
    "stucco": "stʌkəʊ",
    "stuck": "stʌk",
    "studbook": "stʌdbʊk",
    "studded": "stʌdɪd",
    "studding": "stʌdɪŋ",
    "students": "stjuːdənts",
    "student": "stjuːdənt",
    "studied": "stʌdɪd",
    "studier": "stʌdɪɐ",
    "studies": "stʌdɪz",
    "studios": "stjuːdɪəʊz",
    "studio": "stjuːdɪəʊ",
    "studiously": "stjuːdɪəsli",
    "studious": "stjuːdɪəs",
    "studs": "stʌdz",
    "stud": "stʌd",
    "studying": "stʌdɪɪŋ",
    "study": "stʌdi",
    "stuffed": "stʌft",
    "stuffer": "stʌfɐ",
    "stuffiness": "stʌfɪnəs",
    "stuffing": "stʌfɪŋ",
    "stuffs": "stʌfs",
    "stuff": "stʌf",
    "stuffy": "stʌfi",
    "stultified": "stʌltɪfaɪd",
    "stultifying": "stʌltɪfaɪɪŋ",
    "stumbled": "stʌmbəld",
    "stumbles": "stʌmbəlz",
    "stumble": "stʌmbəl",
    "stumbling": "stʌmblɪŋ",
    "stumped": "stʌmpt",
    "stumper": "stʌmpɐ",
    "stumping": "stʌmpɪŋ",
    "stumps": "stʌmps",
    "stump": "stʌmp",
    "stumpy": "stʌmpi",
    "stung": "stʌŋ",
    "stunk": "stʌŋk",
    "stunned": "stʌnd",
    "stunners": "stʌnəz",
    "stunner": "stʌnɐ",
    "stunningly": "stʌnɪŋli",
    "stunning": "stʌnɪŋ",
    "stuns": "stʌnz",
    "stun": "stʌn",
    "stunted": "stʌntɪd",
    "stunting": "stʌntɪŋ",
    "stuntman": "stʌntmən",
    "stuntmen": "stʌntmɛn",
    "stunts": "stʌnts",
    "stunt": "stʌnt",
    "stupa": "stjuːpɐ",
    "stupefaction": "stjuːpɪfækʃən",
    "stupefied": "stjuːpɪfaɪd",
    "stupefying": "stjuːpɪfaɪɪŋ",
    "stupefy": "stjuːpɪfaɪ",
    "stupendously": "stjuːpɛndəsli",
    "stupendous": "stjuːpɛndəs",
    "stupe": "stjuːp",
    "stupider": "stjuːpɪdɐ",
    "stupidest": "stjuːpɪdəst",
    "stupidities": "stjuːpɪdɪtiz",
    "stupidity": "stjuːpɪdɪti",
    "stupidly": "stjuːpɪdli",
    "stupidness": "stjuːpɪdnəs",
    "stupids": "stjuːpɪdz",
    "stupid": "stjuːpɪd",
    "stupor": "stjuːpɐ",
    "sturdier": "stɜːdɪɐ",
    "sturdiest": "stɜːdɪəst",
    "sturdily": "stɜːdɪli",
    "sturdiness": "stɜːdɪnəs",
    "sturdy": "stɜːdi",
    "sturgeons": "stɜːdʒənz",
    "sturgeon": "stɜːdʒən",
    "stuttered": "stʌtəd",
    "stutterer": "stʌtərɐ",
    "stuttering": "stʌtərɪŋ",
    "stutters": "stʌtəz",
    "stutter": "stʌtɐ",
    "stye": "staɪ",
    "styled": "staɪld",
    "styles": "staɪlz",
    "style": "staɪl",
    "styling": "staɪlɪŋ",
    "stylisation": "staɪlaɪzeɪʃən",
    "stylised": "staɪlaɪzd",
    "stylise": "staɪlaɪz",
    "stylishly": "staɪlɪʃli",
    "stylish": "staɪlɪʃ",
    "stylistically": "staɪlɪstɪkli",
    "stylistics": "staɪlɪstɪks",
    "stylistic": "staɪlɪstɪk",
    "stylists": "staɪlɪsts",
    "stylist": "staɪlɪst",
    "stylus": "staɪləs",
    "stymied": "staɪmɪd",
    "stymie": "staɪmi",
    "stymying": "staɪmɪɪŋ",
    "styrene": "staɪriːn",
    "styrofoam": "staɪrəfəʊm",
    "sty": "staɪ",
    "suasion": "sweɪʒən",
    "suavely": "swɑːvli",
    "suave": "swɑːv",
    "suavity": "sjuːævɪti",
    "subaltern": "sʌbɒltən",
    "subaqua": "sʌbækwɐ",
    "subatomic": "sʌbɐtɒmɪk",
    "subbase": "sʌbeɪs",
    "subbed": "sʌbd",
    "subbing": "sʌbɪŋ",
    "subclavian": "sʌbklæviən",
    "subcommittee": "sʌbkəmɪtiː",
    "subconsciously": "sʌbkɒnʃəsli",
    "subconsciousness": "sʌbkɒnʃəsnəs",
    "subconscious": "sʌbkɒnʃəs",
    "subcontinental": "sʌbkəntɪnɛntəl",
    "subcontinent": "sʌbkəntɪnənt",
    "subcontracted": "sʌbkəntræktɪd",
    "subcontracting": "sʌbkəntræktɪŋ",
    "subcontractor": "sʌbkəntræktɐ",
    "subcontractors": "sʌbkəntræktəz",
    "subculture": "sʌbkʌltʃɐ",
    "subcultures": "sʌbkʌltʃəz",
    "subcutaneous": "sʌbkjuːteɪniəs",
    "subdivided": "sʌbdɪvaɪdɪd",
    "subdivide": "sʌbdɪvaɪd",
    "subdividing": "sʌbdɪvaɪdɪŋ",
    "subdivision": "sʌbdɪvɪʒən",
    "subdivisions": "sʌbdɪvɪʒənz",
    "subduction": "sʌbdʌkʃən",
    "subdued": "sʌbdjuːd",
    "subdue": "sʌbdjuː",
    "subdues": "sʌbdjuːz",
    "subduing": "sʌbdjuːɪŋ",
    "subdural": "sʌbdjɔːrəl",
    "subeditor": "sʌbɪdɪtɐ",
    "subfloor": "sʌbflɔː",
    "subgroup": "sʌbɡruːp",
    "subgroups": "sʌbɡruːps",
    "subhuman": "sʌbhjuːmən",
    "subito": "sʌbiːtəʊ",
    "subjected": "sʌbdʒɛktɪd",
    "subjecting": "sʌbdʒɛktɪŋ",
    "subjection": "sʌbdʒɛkʃən",
    "subjectively": "sʌbdʒɛktɪvli",
    "subjective": "sʌbdʒɛktɪv",
    "subjectivity": "sʌbdʒɪktɪvɪti",
    "subjugated": "sʌbdʒuːɡeɪtɪd",
    "subjugate": "sʌbdʒuːɡeɪt",
    "subjugating": "sʌbdʒuːɡeɪtɪŋ",
    "subjugation": "sʌbdʒuːɡeɪʃən",
    "subjunctive": "sʌbdʒəŋktɪv",
    "sublease": "sʌbliːs",
    "sublet": "sʌblət",
    "subletting": "sʌblɪtɪŋ",
    "sublimated": "sʌblɪmeɪtɪd",
    "sublimate": "sʌblɪmeɪt",
    "sublimation": "sʌblɪmeɪʃən",
    "sublimely": "sʌblaɪmli",
    "sublime": "sʌblaɪm",
    "subliminally": "sʌblɪmɪnəli",
    "subliminal": "sʌblɪmɪnəl",
    "subliming": "sʌblaɪmɪŋ",
    "sublimity": "sʌblɪmɪti",
    "sublingual": "sʌblɪŋɡwəl",
    "submariner": "sʌbməriːnɐ",
    "submariners": "sʌbmɐrɪnəz",
    "submarine": "sʌbməriːn",
    "submarines": "sʌbməriːnz",
    "submerged": "səbmɜːdʒd",
    "submerge": "səbmɜːdʒ",
    "submerges": "səbmɜːdʒɪz",
    "submerging": "səbmɜːdʒɪŋ",
    "submersible": "səbmɜːsəbəl",
    "submersibles": "səbmɜːsəbəlz",
    "submersion": "səbmɜːʃən",
    "submission": "səbmɪʃən",
    "submissions": "səbmɪʃənz",
    "submissively": "səbmɪsɪvli",
    "submissiveness": "səbmɪsɪvnəs",
    "submissive": "səbmɪsɪv",
    "submit": "səbmɪt",
    "submits": "səbmɪts",
    "submitted": "səbmɪtɪd",
    "submitters": "səbmɪtəz",
    "submitting": "səbmɪtɪŋ",
    "subnormal": "sʌbnɔːməl",
    "suboptimal": "sʌbɒptɪməl",
    "suborbital": "sʌbɔːbɪtəl",
    "subordinated": "sʌbɔːdɪnətɪd",
    "subordinating": "sʌbɔːdɪnətɪŋ",
    "subordination": "sʌbɔːdɪneɪʃən",
    "suborned": "sʌbɔːnd",
    "suborning": "sʌbɔːnɪŋ",
    "subplot": "sʌbplɒt",
    "subplots": "sʌbplɒts",
    "subpoenaed": "suːpiːnəd",
    "subpoenas": "suːpiːnəz",
    "subpoena": "suːpiːnɐ",
    "subregion": "sʌbriːdʒən",
    "sub": "sʌb",
    "subscribed": "səbskraɪbd",
    "subscriber": "səbskraɪbɐ",
    "subscribers": "səbskraɪbəz",
    "subscribe": "səbskraɪb",
    "subscribes": "səbskraɪbz",
    "subscribing": "səbskraɪbɪŋ",
    "subscription": "sʌbskrɪpʃən",
    "subscriptions": "sʌbskrɪpʃənz",
    "subscript": "sʌbskrɪpt",
    "subsection": "sʌbsɛkʃən",
    "subsections": "sʌbsɛkʃənz",
    "subsequently": "sʌbsɪkwəntli",
    "subsequent": "sʌbsɪkwənt",
    "subservience": "sʌbsɜːviəns",
    "subservient": "sʌbsɜːviənt",
    "subset": "sʌbsɛt",
    "subsets": "sʌbsɛts",
    "subsided": "səbsaɪdɪd",
    "subsidence": "sʌbsɪdəns",
    "subside": "səbsaɪd",
    "subsides": "səbsaɪdz",
    "subsidiaries": "sʌbsɪdjərɪz",
    "subsidiarity": "sʌbsɪdɪærɪti",
    "subsidiary": "sʌbsɪdjəri",
    "subsidies": "sʌbsɪdɪz",
    "subsiding": "səbsaɪdɪŋ",
    "subsidisation": "sʌbsɪdaɪzeɪʃən",
    "subsidised": "sʌbsɪdaɪzd",
    "subsidise": "sʌbsɪdaɪz",
    "subsidises": "sʌbsɪdaɪzɪz",
    "subsidising": "sʌbsɪdaɪzɪŋ",
    "subsidy": "sʌbsɪdi",
    "subsisted": "sʌbsɪstɪd",
    "subsistence": "sʌbsɪstəns",
    "subsisting": "sʌbsɪstɪŋ",
    "subsist": "sʌbsɪst",
    "subsoil": "sʌbsɔɪl",
    "subsonic": "sʌbsɒnɪk",
    "subspace": "sʌbspeɪs",
    "subspecies": "sʌbspiːsiːz",
    "subs": "sʌbz",
    "substance": "sʌbstəns",
    "substances": "sʌbstənsɪz",
    "substandard": "sʌbstændəd",
    "substantially": "səbstænʃəli",
    "substantial": "səbstænʃəl",
    "substantiated": "səbstænʃɪeɪtɪd",
    "substantiate": "səbstænʃɪeɪt",
    "substantiates": "səbstænʃɪeɪts",
    "substantiating": "səbstænʃɪeɪtɪŋ",
    "substantiation": "səbstænʃɪeɪʃən",
    "substantively": "səbstæntɪvli",
    "substantive": "səbstæntɪv",
    "substation": "sʌbsteɪʃən",
    "substations": "sʌbsteɪʃənz",
    "substituted": "sʌbstɪtjuːtɪd",
    "substitute": "sʌbstɪtjuːt",
    "substitutes": "sʌbstɪtjuːts",
    "substituting": "sʌbstɪtjuːtɪŋ",
    "substitution": "sʌbstɪtjuːʃən",
    "substitutions": "sʌbstɪtjuːʃənz",
    "substrate": "sʌbstreɪt",
    "substrates": "sʌbstreɪts",
    "substructure": "sʌbstrʌktʃɐ",
    "subsumed": "sʌbsuːmd",
    "subsume": "sʌbsuːm",
    "subsuming": "sʌbsuːmɪŋ",
    "subterfuge": "sʌbtəfjuːdʒ",
    "subterfuges": "sʌbtəfjuːdʒɪz",
    "subterranean": "sʌbtɪreɪniən",
    "subtext": "sʌbtɛkst",
    "subtextual": "sʌbtɪkstʃuːəl",
    "subtitled": "sʌbtaɪtəld",
    "subtitle": "sʌbtaɪtəl",
    "subtitles": "sʌbtaɪtəlz",
    "subtitling": "sʌbtaɪtlɪŋ",
    "subtleness": "sʌtəlnəs",
    "subtler": "sʌtlɐ",
    "subtle": "sʌtəl",
    "subtlest": "sʌtləst",
    "subtleties": "sʌtəltɪz",
    "subtlety": "sʌtəlti",
    "subtly": "sʌtəli",
    "subtotal": "sʌbtəʊtəl",
    "subtracted": "sʌbtræktɪd",
    "subtracting": "sʌbtræktɪŋ",
    "subtraction": "sʌbtrækʃən",
    "subtractions": "sʌbtrækʃənz",
    "subtract": "sʌbtrækt",
    "subtracts": "sʌbtrækts",
    "subtropical": "sʌbtrɒpɪkəl",
    "subtype": "sʌbtaɪp",
    "suburbanisation": "səbɜːbɐnaɪzeɪʃən",
    "suburbanised": "səbɜːbɐnaɪzd",
    "suburbanites": "səbɜːbɐnaɪts",
    "suburban": "səbɜːbən",
    "suburbans": "səbɜːbənz",
    "suburbia": "sʌbɜːbiə",
    "suburb": "sʌbɜːb",
    "suburbs": "sʌbɜːbz",
    "subvention": "səbvɛnʃən",
    "subversion": "səbvɜːʃən",
    "subversiveness": "səbvɜːsɪvnəs",
    "subversive": "səbvɜːsɪv",
    "subversives": "səbvɜːsɪvz",
    "subverted": "səbvɜːtɪd",
    "subverting": "səbvɜːtɪŋ",
    "subverts": "səbvɜːts",
    "subway": "sʌbweɪ",
    "subways": "sʌbweɪz",
    "subzero": "sʌbzeərəʊ",
    "succeeded": "səksiːdɪd",
    "succeeding": "səksiːdɪŋ",
    "succeed": "səksiːd",
    "succeeds": "səksiːdz",
    "successes": "səksɛsɪz",
    "successfully": "səksɛsfəli",
    "successful": "səksɛsfəl",
    "successional": "səksɛʃənəl",
    "succession": "səksɛʃən",
    "successions": "səksɛʃənz",
    "successively": "səksɛsɪvli",
    "successive": "səksɛsɪv",
    "successor": "səksɛsɐ",
    "successors": "səksɛsəz",
    "success": "səksɛs",
    "succinctly": "səksɪŋktli",
    "succinctness": "səksɪŋktnəs",
    "succinct": "səksɪŋkt",
    "succotash": "səkɒtæʃ",
    "succour": "səkɜː",
    "succubus": "səkjuːbəs",
    "succulence": "sʌkjʊləns",
    "succulent": "sʌkjʊlənt",
    "succulents": "sʌkjʊlənts",
    "succumbed": "səkʌmd",
    "succumbing": "səkʌmɪŋ",
    "succumb": "səkʌm",
    "succumbs": "səkʌmz",
    "suchlike": "sʌtʃlaɪk",
    "such": "sʌtʃ",
    "sucked": "sʌkt",
    "suckered": "sʌkəd",
    "suckering": "sʌkərɪŋ",
    "sucker": "sʌkɐ",
    "suckers": "sʌkəz",
    "sucking": "sʌkɪŋ",
    "suckled": "sʌkəld",
    "suckle": "sʌkəl",
    "suckles": "sʌkəlz",
    "suckling": "sʌklɪŋ",
    "sucklings": "sʌklɪŋz",
    "suck": "sʌk",
    "sucks": "sʌks",
    "sucre": "sʌkɐ",
    "sucrose": "sʌkrəʊz",
    "suctioning": "sʌkʃənɪŋ",
    "suction": "sʌkʃən",
    "suddenly": "sʌdənli",
    "suddenness": "sʌdənnəs",
    "sudden": "sʌdən",
    "sud": "sʌd",
    "suds": "sʌdz",
    "suede": "sweɪd",
    "sued": "suːd",
    "suer": "suːɐ",
    "sues": "suːz",
    "suet": "suːɪt",
    "sufferance": "sʌfərəns",
    "suffered": "sʌfəd",
    "sufferer": "sʌfərɐ",
    "sufferers": "sʌfərəz",
    "suffering": "sʌfərɪŋ",
    "sufferings": "sʌfərɪŋz",
    "suffer": "sʌfɐ",
    "suffers": "sʌfəz",
    "sufficed": "səfaɪst",
    "suffice": "səfaɪs",
    "suffices": "səfaɪsɪz",
    "sufficiency": "səfɪʃənsi",
    "sufficiently": "səfɪʃəntli",
    "sufficient": "səfɪʃənt",
    "suffixes": "sʌfɪksɪz",
    "suffix": "sʌfɪks",
    "suffocated": "sʌfəkeɪtɪd",
    "suffocate": "sʌfəkeɪt",
    "suffocates": "sʌfəkeɪts",
    "suffocating": "sʌfəkeɪtɪŋ",
    "suffocation": "sʌfəkeɪʃən",
    "suffragan": "sʌfræɡən",
    "suffrage": "sʌfrɪdʒ",
    "suffragette": "sʌfrɐdʒɛt",
    "suffragettes": "sʌfrɐdʒɛts",
    "suffragist": "sʌfrɐdʒɪst",
    "suffragists": "sʌfrɐdʒɪsts",
    "suffused": "sʌfjuːzd",
    "suffuse": "sʌfjuːz",
    "suffuses": "sʌfjuːzɪz",
    "suffusing": "sʌfjuːzɪŋ",
    "sugar": "ʃʊɡɐ",
    "sugarcane": "ʃʊɡəkeɪn",
    "sugarcoat": "ʃʊɡəkəʊt",
    "sugared": "ʃʊɡəd",
    "sugariness": "ʃʊɡərɪnəs",
    "sugaring": "ʃʊɡərɪŋ",
    "sugarplum": "ʃʊɡəpləm",
    "sugars": "ʃʊɡəz",
    "sugary": "ʃʊɡəri",
    "suggested": "sədʒɛstɪd",
    "suggestibility": "sədʒɛstɪbɪlɪti",
    "suggestible": "sədʒɛstəbəl",
    "suggesting": "sədʒɛstɪŋ",
    "suggestion": "sədʒɛstʃən",
    "suggestions": "sədʒɛstʃənz",
    "suggestively": "sədʒɛstɪvli",
    "suggestiveness": "sədʒɛstɪvnəs",
    "suggestive": "sədʒɛstɪv",
    "suggest": "sədʒɛst",
    "suggests": "sədʒɛsts",
    "suicidally": "suːɪsaɪdəli",
    "suicidal": "suːɪsaɪdəl",
    "suicides": "suːɪsaɪdz",
    "suicide": "suːɪsaɪd",
    "suing": "suːɪŋ",
    "suitability": "suːtəbɪlɪti",
    "suitable": "suːtəbəl",
    "suitably": "suːtəbli",
    "suitcases": "suːtkeɪsɪz",
    "suitcase": "suːtkeɪs",
    "suited": "suːtɪd",
    "suites": "swiːts",
    "suiting": "suːtɪŋ",
    "suitors": "suːtəz",
    "suitor": "suːtɐ",
    "suits": "suːts",
    "suit": "suːt",
    "sukkah": "sʌkɐ",
    "sulcus": "sʌlkəs",
    "sulfate": "sʌlfeɪt",
    "sulfide": "sʌlfaɪd",
    "sulfur": "sʌlfɜː",
    "sulked": "sʌlkt",
    "sulkies": "sʌlkiz",
    "sulking": "sʌlkɪŋ",
    "sulk": "sʌlk",
    "sulks": "sʌlks",
    "sulky": "sʌlki",
    "sullenness": "sʌlənnəs",
    "sullen": "sʌlən",
    "sullied": "sʌlid",
    "sullying": "sʌliɪŋ",
    "sully": "sʌli",
    "sulphate": "sʌlfeɪt",
    "sulphates": "sʌlfeɪts",
    "sulphide": "sʌlfaɪd",
    "sulphides": "sʌlfaɪdz",
    "sulphured": "sʌlfjɔːd",
    "sulphuric": "sʌlfjʊrɪk",
    "sulphurous": "sʌlfərəs",
    "sulphur": "sʌlfɐ",
    "sulphurs": "sʌlfəz",
    "sultana": "sʌltɑːnɐ",
    "sultanas": "sʌltɑːnəz",
    "sultanate": "sʌltɐneɪt",
    "sultan": "sʌltən",
    "sultans": "sʌltənz",
    "sultry": "sʌltri",
    "sumac": "suːmæk",
    "summaries": "sʌməriz",
    "summarily": "sʌmɛrəli",
    "summarised": "sʌməraɪzd",
    "summariser": "sʌməraɪzɐ",
    "summarise": "sʌməraɪz",
    "summarises": "sʌməraɪzɪz",
    "summarising": "sʌməraɪzɪŋ",
    "summary": "sʌməri",
    "summation": "sʌmeɪʃən",
    "summat": "sʌmæt",
    "summed": "sʌmd",
    "summerhouse": "sʌməhaʊs",
    "summerhouses": "sʌməhaʊzɪz",
    "summering": "sʌmərɪŋ",
    "summersault": "sʌməsɒlt",
    "summer": "sʌmɐ",
    "summers": "sʌməz",
    "summertime": "sʌmətaɪm",
    "summery": "sʌməri",
    "summing": "sʌmɪŋ",
    "summitry": "sʌmɪtri",
    "summit": "sʌmɪt",
    "summits": "sʌmɪts",
    "summoned": "sʌmənd",
    "summoner": "sʌmənɐ",
    "summoning": "sʌmənɪŋ",
    "summonsed": "sʌmənzd",
    "summonses": "sʌmənzɪz",
    "summon": "sʌmən",
    "summons": "sʌmənz",
    "sumo": "suːməʊ",
    "sump": "sʌmp",
    "sumps": "sʌmps",
    "sumpter": "sʌmptɐ",
    "sumptuary": "sʌmptjuːəri",
    "sumptuously": "sʌmptʃuːəsli",
    "sumptuousness": "sʌmptʃuːəsnəs",
    "sumptuous": "sʌmptʃuːəs",
    "sum": "sʌm",
    "sums": "sʌmz",
    "sunbathed": "sʌnbeɪðd",
    "sunbather": "sʌnbeɪðɐ",
    "sunbathers": "sʌnbeɪðəz",
    "sunbathe": "sʌnbeɪð",
    "sunbathes": "sʌnbeɪðz",
    "sunbathing": "sʌnbeɪðɪŋ",
    "sunbeam": "sʌnbiːm",
    "sunbeams": "sʌnbiːmz",
    "sunbed": "sʌnbd",
    "sunbeds": "sʌnbdz",
    "sunblock": "sʌnblɒk",
    "sunburned": "sʌnbɜːnd",
    "sunburn": "sʌnbɜːn",
    "sunburns": "sʌnbɜːnz",
    "sunburnt": "sʌnbɜːnt",
    "sunburst": "sʌnbɜːst",
    "suncream": "sʌŋkriːm",
    "sundae": "sʌndeɪ",
    "sundaes": "sʌndeɪz",
    "sundeck": "sʌndɛk",
    "sundered": "sʌndəd",
    "sunder": "sʌndɐ",
    "sundew": "sʌndjuː",
    "sundews": "sʌndjuːz",
    "sundial": "sʌndaɪəl",
    "sundials": "sʌndaɪəlz",
    "sundowner": "sʌndaʊnɐ",
    "sundowners": "sʌndaʊnəz",
    "sundown": "sʌndaʊn",
    "sundress": "sʌndrɛs",
    "sunfish": "sʌnfɪʃ",
    "sunflower": "sʌnflaʊɐ",
    "sunflowers": "sʌnflaʊəz",
    "sunglasses": "sʌŋɡlɑːsɪz",
    "sunglass": "sʌŋɡlɑːs",
    "sung": "sʌŋ",
    "sunhat": "sʌnhæt",
    "sunhats": "sʌnhæts",
    "sunken": "sʌŋkən",
    "sunk": "sʌŋk",
    "sunlamp": "sʌnlæmp",
    "sunless": "sʌnləs",
    "sunlight": "sʌnlaɪt",
    "sunlit": "sʌnlɪt",
    "sunned": "sʌnd",
    "sunnier": "sʌnɪɐ",
    "sunniest": "sʌnɪəst",
    "sunniness": "sʌnɪnəs",
    "sunning": "sʌnɪŋ",
    "sunny": "sʌni",
    "sunrise": "sʌnraɪz",
    "sunrises": "sʌnraɪzɪz",
    "sunroof": "sʌnruːf",
    "sunroofs": "sʌnruːfs",
    "sunroom": "sʌnruːm",
    "sunscreen": "sʌnskriːn",
    "sunscreens": "sʌnskriːnz",
    "sunset": "sʌnsɛt",
    "sunsets": "sʌnsɛts",
    "sunshade": "sʌnʃeɪd",
    "sunshades": "sʌnʃeɪdz",
    "sunshine": "sʌnʃaɪn",
    "sunshiny": "sʌnʃɪni",
    "sun": "sʌn",
    "sunspot": "sʌnspɒt",
    "sunspots": "sʌnspɒts",
    "suns": "sʌnz",
    "sunstone": "sʌnstəʊn",
    "sunstroke": "sʌnstrəʊk",
    "suntanned": "sʌntænd",
    "suntan": "sʌntæn",
    "suntans": "sʌntænz",
    "suntrap": "sʌntræp",
    "sunward": "sʌnwəd",
    "sunwise": "sʌnwaɪz",
    "superabundance": "suːpərɐbʌndəns",
    "superannuated": "suːpərænjuːeɪtɪd",
    "superannuation": "suːpərænjuːeɪʃən",
    "superbly": "suːpɜːbli",
    "superb": "suːpɜːb",
    "superbugs": "suːpəbʌɡz",
    "superbug": "suːpəbʌɡ",
    "supercalifragilisticexpialidocious": "suːpəkælɪfrædʒɪlɪstaɪskspɪɐlɪdəʊʃəs",
    "supercalifragilistic": "suːpəkælɪfrædʒɪlɪstɪk",
    "supercharged": "suːpətʃɑːdʒd",
    "supercharger": "suːpətʃɑːdʒɐ",
    "supercharge": "suːpətʃɑːdʒ",
    "supercharging": "suːpətʃɑːdʒɪŋ",
    "supercilious": "suːpəsɪlɪəs",
    "supercity": "suːpəsɪti",
    "supercollider": "suːpəkəlaɪdɐ",
    "supercomputers": "suːpəkəmpjuːtəz",
    "supercomputer": "suːpəkəmpjuːtɐ",
    "superconducting": "suːpəkəndʌktɪŋ",
    "superconductivity": "suːpəkɒndəktɪvɪti",
    "superconductors": "suːpəkəndʌktəz",
    "superconductor": "suːpəkəndʌktɐ",
    "superconduct": "suːpəkəndʌkt",
    "supercontinent": "suːpəkɒntɪnənt",
    "supercooled": "suːpəkuːld",
    "supercool": "suːpəkuːl",
    "superfecundation": "suːpəfɛkəndeɪʃən",
    "superficiality": "suːpəfɪʃɪælɪti",
    "superficially": "suːpəfɪʃəli",
    "superficial": "suːpəfɪʃəl",
    "superfine": "suːpəfaɪn",
    "superfluity": "suːpəfljuːɪti",
    "superfluous": "suːpɜːfluːəs",
    "supergiants": "suːpədʒaɪənts",
    "superglue": "suːpəɡluː",
    "supergrasses": "suːpəɡrɑːsɪz",
    "supergrass": "suːpəɡrɑːs",
    "superheated": "suːpəhiːtɪd",
    "superheat": "suːpəhiːt",
    "superheavy": "suːpəhɛvi",
    "superheroes": "suːpəhiərəʊz",
    "superheros": "suːpəhiərəʊz",
    "superhero": "suːpəhiərəʊ",
    "superhighways": "suːpəhaɪweɪz",
    "superhighway": "suːpəhaɪweɪ",
    "superhumanly": "suːpəhjuːmənli",
    "superhuman": "suːpəhjuːmən",
    "superimposed": "suːpərɪmpəʊzd",
    "superimpose": "suːpərɪmpəʊz",
    "superimposing": "suːpərɪmpəʊzɪŋ",
    "superimposition": "suːpərɪmpəzɪʃən",
    "superintended": "suːpərɪntɛndɪd",
    "superintendence": "suːpərɪntɛndəns",
    "superintendents": "suːpərɪntɛndənts",
    "superintendent": "suːpərɪntɛndənt",
    "superintending": "suːpərɪntɛndɪŋ",
    "superiority": "suːpiərɪɒrɪti",
    "superiors": "suːpiərɪəz",
    "superior": "suːpiərɪɐ",
    "superlatively": "suːpɜːlətɪvli",
    "superlatives": "suːpɜːlətɪvz",
    "superlative": "suːpɜːlətɪv",
    "superliner": "suːpəlaɪnɐ",
    "superman": "suːpəmæn",
    "supermarkets": "suːpəmɑːkɪts",
    "supermarket": "suːpəmɑːkɪt",
    "supermen": "suːpəmɛn",
    "supermodels": "suːpəmɒdəlz",
    "supermodel": "suːpəmɒdəl",
    "supermom": "suːpəmɒm",
    "supernational": "suːpənæʃənəl",
    "supernaturally": "suːpənætʃərəli",
    "supernaturals": "suːpənætʃərəlz",
    "supernatural": "suːpənætʃərəl",
    "supernormal": "suːpənɔːməl",
    "supernovae": "suːpənɒviː",
    "supernovas": "suːpənəʊvəz",
    "supernova": "suːpənəʊvɐ",
    "supernumerary": "suːpənjuːmərəri",
    "superpowers": "suːpəpaʊəz",
    "superpower": "suːpəpaʊɐ",
    "superrich": "suːpərɪtʃ",
    "supersaturated": "suːpəsætʃəreɪtɪd",
    "superscribed": "suːpəskraɪbd",
    "superscription": "suːpəskrɪpʃən",
    "superseded": "suːpəsiːdɪd",
    "supersedes": "suːpəsiːdz",
    "supersede": "suːpəsiːd",
    "superseding": "suːpəsiːdɪŋ",
    "supersensitive": "suːpəsɛnsɪtɪv",
    "supersized": "suːpəsaɪzd",
    "supersize": "suːpəsaɪz",
    "supersmart": "suːpəsmɑːt",
    "supersonic": "suːpəsɒnɪk",
    "superspy": "suːpəspaɪ",
    "supers": "suːpəz",
    "superstars": "suːpəstɑːz",
    "superstar": "suːpəstɑː",
    "superstate": "suːpəsteɪt",
    "superstitions": "suːpəstɪʃənz",
    "superstition": "suːpəstɪʃən",
    "superstitious": "suːpəstɪʃəs",
    "superstores": "suːpəstɔːz",
    "superstore": "suːpəstɔː",
    "superstrength": "suːpəstrɛŋθ",
    "superstrong": "suːpəstrɒŋ",
    "superstructure": "suːpəstrʌktʃɐ",
    "super": "suːpɐ",
    "supertankers": "suːpətæŋkəz",
    "supertanker": "suːpətæŋkɐ",
    "supertax": "suːpətæks",
    "supervenes": "suːpəviːnz",
    "supervised": "suːpəvaɪzd",
    "supervises": "suːpəvaɪzɪz",
    "supervise": "suːpəvaɪz",
    "supervising": "suːpəvaɪzɪŋ",
    "supervisions": "suːpəvɪʒənz",
    "supervision": "suːpəvɪʒən",
    "supervisors": "suːpəvaɪzəz",
    "supervisor": "suːpəvaɪzɐ",
    "supervisory": "suːpəvɪsəri",
    "superwoman": "suːpəwʊmən",
    "superwomen": "suːpəwɪmɪn",
    "supine": "suːpaɪn",
    "supped": "sʌpt",
    "supper": "sʌpɐ",
    "suppers": "sʌpəz",
    "suppertime": "sʌpətaɪm",
    "supping": "sʌpɪŋ",
    "supplanted": "səplæntɪd",
    "supplanting": "səplæntɪŋ",
    "supplant": "səplænt",
    "supplemental": "sʌplɪmɛntəl",
    "supplementary": "sʌplɪmɛntəri",
    "supplementation": "sʌplɪmənteɪʃən",
    "supplemented": "sʌplɪməntɪd",
    "supplementing": "sʌplɪməntɪŋ",
    "suppleness": "sʌpəlnəs",
    "supple": "sʌpəl",
    "suppliant": "səplaɪənt",
    "supplicant": "sʌplɪkənt",
    "supplicants": "sʌplɪkənts",
    "supplication": "sʌplɪkeɪʃən",
    "supplications": "sʌplɪkeɪʃənz",
    "supplied": "səplaɪd",
    "supplier": "səplaɪə",
    "suppliers": "səplaɪəz",
    "supplies": "səplaɪz",
    "supplying": "səplaɪɪŋ",
    "supportable": "səpɔːtəbəl",
    "supported": "səpɔːtɪd",
    "supporter": "səpɔːtɐ",
    "supporters": "səpɔːtəz",
    "supporting": "səpɔːtɪŋ",
    "supportively": "səpɔːtɪvli",
    "supportiveness": "səpɔːtɪvnəs",
    "supportive": "səpɔːtɪv",
    "support": "səpɔːt",
    "supports": "səpɔːts",
    "supposedly": "sʌpəʊzɪdli",
    "suppose": "sʌpəʊz",
    "supposes": "sʌpəʊzɪz",
    "supposing": "sʌpəʊzɪŋ",
    "supposition": "sʌpəzɪʃən",
    "suppositions": "sʌpəzɪʃənz",
    "suppositories": "sʌpəsɪtəriz",
    "suppository": "sʌpəsɪtəri",
    "suppressant": "səprɛsənt",
    "suppressants": "səprɛsənts",
    "suppressed": "səprɛst",
    "suppresses": "səprɛsɪz",
    "suppressing": "səprɛsɪŋ",
    "suppression": "səprɛʃən",
    "suppressive": "səprɛsɪv",
    "suppress": "səprɛs",
    "suppurating": "sʌpjʊreɪtɪŋ",
    "supranational": "sʌprɐneɪʃənəl",
    "supraorbital": "sʌpreɪɔːbɪtəl",
    "supra": "sʌprɐ",
    "supremacists": "suːprɛmɐsɪsts",
    "supremacist": "suːprɛmɐsɪst",
    "supremacy": "suːprɛməsi",
    "supremely": "suːpriːmli",
    "supreme": "suːpriːm",
    "supremos": "suːpriːməʊz",
    "supremo": "suːpriːməʊ",
    "sup": "sʌp",
    "sups": "sʌps",
    "sura": "sɜːrɐ",
    "suras": "sɜːrəz",
    "surcease": "sɜːsiːs",
    "surcharges": "sɜːtʃɑːdʒɪz",
    "surcharge": "sɜːtʃɑːdʒ",
    "surcharging": "sɜːtʃɑːdʒɪŋ",
    "surd": "sɜːd",
    "surefire": "ʃɔːfaɪə",
    "surefooted": "ʃɔːfʊtɪd",
    "surely": "ʃɔːli",
    "sureness": "ʃɔːnəs",
    "sure": "ʃɔː",
    "surer": "ʃɔːrɐ",
    "surest": "ʃɔːrəst",
    "sureties": "ʃɔːrətiz",
    "surety": "ʃɔːrəti",
    "surfaced": "sɜːfɪst",
    "surface": "sɜːfɪs",
    "surfaces": "sɜːfɪsɪz",
    "surfacing": "sɜːfɪsɪŋ",
    "surfactant": "sɜːfæktənt",
    "surfactants": "sɜːfæktənts",
    "surfboard": "sɜːfbɔːd",
    "surfboards": "sɜːfbɔːdz",
    "surfed": "sɜːft",
    "surfeited": "sɜːfɪtɪd",
    "surfeit": "sɜːfɪt",
    "surfer": "sɜːfɐ",
    "surfers": "sɜːfəz",
    "surfing": "sɜːfɪŋ",
    "surf": "sɜːf",
    "surfs": "sɜːfs",
    "surged": "sɜːdʒd",
    "surgeonfish": "sɜːdʒənfɪʃ",
    "surgeon": "sɜːdʒən",
    "surgeons": "sɜːdʒənz",
    "surgeries": "sɜːdʒəriz",
    "surgery": "sɜːdʒəri",
    "surge": "sɜːdʒ",
    "surges": "sɜːdʒɪz",
    "surgically": "sɜːdʒɪkli",
    "surgical": "sɜːdʒɪkəl",
    "surging": "sɜːdʒɪŋ",
    "surly": "sɜːli",
    "surmised": "səmaɪzd",
    "surmising": "səmaɪzɪŋ",
    "surmountable": "səmaʊntəbəl",
    "surmounted": "səmaʊntɪd",
    "surmounting": "səmaʊntɪŋ",
    "surmount": "səmaʊnt",
    "surmounts": "səmaʊnts",
    "surname": "sɜːneɪm",
    "surnames": "sɜːneɪmz",
    "surpassed": "səpɑːst",
    "surpasses": "səpɑːsɪz",
    "surpassing": "səpɑːsɪŋ",
    "surpass": "səpɑːs",
    "surplice": "sɜːplɪs",
    "surplices": "sɜːplɪsɪz",
    "surpluses": "sɜːpləsɪz",
    "surplus": "sɜːpləs",
    "surprised": "səpraɪzd",
    "surprise": "səpraɪz",
    "surprises": "səpraɪzɪz",
    "surprisingly": "səpraɪzɪŋli",
    "surprising": "səpraɪzɪŋ",
    "surrealism": "səriəlɪzəm",
    "surrealistic": "səriəlɪstɪk",
    "surrealist": "səriəlɪst",
    "surrealists": "səriəlɪsts",
    "surreality": "sərɪælɪti",
    "surreally": "səriəli",
    "surreal": "səriəl",
    "surrendered": "sərɛndəd",
    "surrendering": "sərɛndərɪŋ",
    "surrender": "sərɛndɐ",
    "surrenders": "sərɛndəz",
    "surreptitiously": "sərɪptɪʃəsli",
    "surreptitious": "sərɪptɪʃəs",
    "surrey": "sʌri",
    "surreys": "sʌrɪz",
    "surrogacy": "sərɒɡəsi",
    "surrogate": "sʌrəɡeɪt",
    "surrogates": "sʌrəɡeɪts",
    "surrounded": "səraʊndɪd",
    "surrounding": "səraʊndɪŋ",
    "surroundings": "səraʊndɪŋz",
    "surround": "səraʊnd",
    "surrounds": "səraʊndz",
    "surtitles": "sɜːtaɪtəlz",
    "surtout": "sɜːtaʊt",
    "surveillance": "səveɪləns",
    "surveyed": "səveɪd",
    "surveying": "səveɪɪŋ",
    "surveyor": "səveɪɐ",
    "surveyors": "səveɪəz",
    "survivability": "səvaɪvəbɪlɪti",
    "survivable": "səvaɪvəbəl",
    "survivalist": "səvaɪvəlɪst",
    "survivalists": "səvaɪvəlɪsts",
    "survival": "səvaɪvəl",
    "survivals": "səvaɪvəlz",
    "survived": "səvaɪvd",
    "survive": "səvaɪv",
    "survives": "səvaɪvz",
    "surviving": "səvaɪvɪŋ",
    "survivor": "səvaɪvɐ",
    "survivors": "səvaɪvəz",
    "susceptibilities": "səsɛptɪbɪlɪtiz",
    "susceptibility": "səsɛptɪbɪlɪti",
    "susceptible": "səsɛptəbəl",
    "sushi": "suːʃi",
    "suspected": "səspɛktɪd",
    "suspecting": "səspɛktɪŋ",
    "suspended": "səspɛndɪd",
    "suspender": "səspɛndɐ",
    "suspenders": "səspɛndəz",
    "suspending": "səspɛndɪŋ",
    "suspend": "səspɛnd",
    "suspends": "səspɛndz",
    "suspenseful": "səspɛnsfəl",
    "suspense": "səspɛns",
    "suspension": "səspɛnʃən",
    "suspensions": "səspɛnʃənz",
    "suspicion": "səspɪʃən",
    "suspicions": "səspɪʃənz",
    "suspiciously": "səspɪʃəsli",
    "suspicious": "səspɪʃəs",
    "sussed": "sʌst",
    "susses": "sʌsɪz",
    "sussing": "sʌsɪŋ",
    "suss": "sʌs",
    "sustainability": "səsteɪnəbɪlɪti",
    "sustainable": "səsteɪnəbəl",
    "sustainably": "səsteɪnəbli",
    "sustained": "səsteɪnd",
    "sustainer": "səsteɪnɐ",
    "sustaining": "səsteɪnɪŋ",
    "sustain": "səsteɪn",
    "sustains": "səsteɪnz",
    "sustenance": "sʌstənəns",
    "sutra": "sʌtrɐ",
    "sutured": "suːtʃəd",
    "sutures": "suːtʃəz",
    "suture": "suːtʃɐ",
    "suturing": "suːtʃərɪŋ",
    "svelter": "svɛltɐ",
    "svelte": "svɛlt",
    "swabbed": "swɒbd",
    "swabber": "swɒbɐ",
    "swabbing": "swɒbɪŋ",
    "swabs": "swɒbz",
    "swab": "swɒb",
    "swaddled": "swɒdəld",
    "swaddle": "swɒdəl",
    "swaddling": "swɒdlɪŋ",
    "swagged": "swæɡd",
    "swaggered": "swæɡəd",
    "swaggerer": "swæɡərɐ",
    "swaggering": "swæɡərɪŋ",
    "swaggers": "swæɡəz",
    "swagger": "swæɡɐ",
    "swagman": "swæɡmən",
    "swags": "swæɡz",
    "swag": "swæɡ",
    "swain": "sweɪn",
    "swale": "sweɪl",
    "swallowed": "swɒləʊd",
    "swallower": "swɒləʊɐ",
    "swallowing": "swɒləʊɪŋ",
    "swallows": "swɒləʊz",
    "swallow": "swɒləʊ",
    "swallowtails": "swɒləʊteɪlz",
    "swallowtail": "swɒləʊteɪl",
    "swamis": "swɑːmiz",
    "swami": "swɑːmi",
    "swamped": "swɒmpt",
    "swamping": "swɒmpɪŋ",
    "swamplands": "swɑːmpləndz",
    "swampland": "swɑːmplənd",
    "swamps": "swɒmps",
    "swamp": "swɒmp",
    "swampy": "swɒmpi",
    "swam": "swæm",
    "swanked": "swæŋkt",
    "swankier": "swæŋkiɐ",
    "swankiest": "swæŋkiəst",
    "swanking": "swæŋkɪŋ",
    "swank": "swæŋk",
    "swanky": "swæŋki",
    "swanned": "swɒnd",
    "swanning": "swɒnɪŋ",
    "swansdown": "swɒnsdaʊn",
    "swansong": "swɒnsɒŋ",
    "swans": "swɒnz",
    "swan": "swɒn",
    "swapped": "swɒpt",
    "swappers": "swɒpəz",
    "swapper": "swɒpɐ",
    "swapping": "swɒpɪŋ",
    "swaps": "swɒps",
    "swap": "swɒp",
    "sward": "swɔːd",
    "swarmed": "swɔːmd",
    "swarming": "swɔːmɪŋ",
    "swarms": "swɔːmz",
    "swarm": "swɔːm",
    "swarthy": "swɔːði",
    "swart": "swɔːt",
    "swashbucklers": "swɒʃbʌkləz",
    "swashbuckler": "swɒʃbʌklɐ",
    "swashbuckling": "swɒʃbəklɪŋ",
    "swashes": "swɒʃɪz",
    "swashing": "swɒʃɪŋ",
    "swash": "swɒʃ",
    "swastikas": "swɑːstɪkəz",
    "swastika": "swɑːstɪkɐ",
    "swatches": "swɒtʃɪz",
    "swatch": "swɒtʃ",
    "swathed": "sweɪðd",
    "swathes": "sweɪðz",
    "swathe": "sweɪð",
    "swathing": "swɒθɪŋ",
    "swaths": "swɒθs",
    "swath": "swɒθ",
    "swats": "swɒts",
    "swat": "swɒt",
    "swatted": "swɒtɪd",
    "swatters": "swɒtəz",
    "swatter": "swɒtɐ",
    "swatting": "swɒtɪŋ",
    "swayed": "sweɪd",
    "swaying": "sweɪɪŋ",
    "sways": "sweɪz",
    "sway": "sweɪ",
    "swearers": "sweərəz",
    "swearing": "sweərɪŋ",
    "swears": "sweəz",
    "swear": "sweə",
    "swearwords": "sweəwɜːdz",
    "swearword": "sweəwɜːd",
    "sweatbands": "swɛtbændz",
    "sweatband": "swɛtbænd",
    "sweatbox": "swɛtbɒks",
    "sweated": "swɛtɪd",
    "sweaters": "swɛtəz",
    "sweater": "swɛtɐ",
    "sweatier": "swɛtɪɐ",
    "sweatiest": "swɛtɪəst",
    "sweatiness": "swɛtɪnəs",
    "sweating": "swɛtɪŋ",
    "sweatpants": "swɛtpənts",
    "sweatshirts": "swɛtʃɜːts",
    "sweatshirt": "swɛtʃɜːt",
    "sweatshops": "swɛtʃɒps",
    "sweatshop": "swɛtʃɒp",
    "sweats": "swɛts",
    "sweatsuit": "swɛtsuːt",
    "sweat": "swɛt",
    "sweaty": "swɛti",
    "swedes": "swiːdz",
    "swede": "swiːd",
    "sweeny": "swiːni",
    "sweepers": "swiːpəz",
    "sweeper": "swiːpɐ",
    "sweepings": "swiːpɪŋz",
    "sweeping": "swiːpɪŋ",
    "sweeps": "swiːps",
    "sweepstakes": "swiːpsteɪks",
    "sweepstake": "swiːpsteɪk",
    "sweep": "swiːp",
    "sweetbreads": "swiːtbrɛdz",
    "sweetbread": "swiːtbrɛd",
    "sweetcorn": "swiːtkɔːn",
    "sweetened": "swiːtənd",
    "sweeteners": "swiːtənəz",
    "sweetener": "swiːtənɐ",
    "sweetening": "swiːtənɪŋ",
    "sweetens": "swiːtənz",
    "sweeten": "swiːtən",
    "sweeter": "swiːtɐ",
    "sweetest": "swiːtəst",
    "sweethearts": "swiːthɑːts",
    "sweetheart": "swiːthɑːt",
    "sweeties": "swiːtɪz",
    "sweetie": "swiːti",
    "sweeting": "swiːtɪŋ",
    "sweetish": "swiːtɪʃ",
    "sweetly": "swiːtli",
    "sweetmeats": "swiːtmiːts",
    "sweetmeat": "swiːtmiːt",
    "sweetness": "swiːtnəs",
    "sweetshop": "swiːtʃɒp",
    "sweets": "swiːts",
    "sweet": "swiːt",
    "swelled": "swɛld",
    "swellings": "swɛlɪŋz",
    "swelling": "swɛlɪŋ",
    "swells": "swɛlz",
    "swell": "swɛl",
    "sweltered": "swɛltəd",
    "swelteringly": "swɛltərɪŋli",
    "sweltering": "swɛltərɪŋ",
    "swelter": "swɛltɐ",
    "swept": "swɛpt",
    "swerved": "swɜːvd",
    "swerves": "swɜːvz",
    "swerve": "swɜːv",
    "swerving": "swɜːvɪŋ",
    "swifter": "swɪftɐ",
    "swiftest": "swɪftəst",
    "swiftlets": "swɪftləts",
    "swiftly": "swɪftli",
    "swiftness": "swɪftnəs",
    "swifts": "swɪfts",
    "swift": "swɪft",
    "swigged": "swɪɡd",
    "swigging": "swɪɡɪŋ",
    "swigs": "swɪɡz",
    "swig": "swɪɡ",
    "swilled": "swɪld",
    "swilling": "swɪlɪŋ",
    "swill": "swɪl",
    "swimmers": "swɪməz",
    "swimmer": "swɪmɐ",
    "swimmingly": "swɪmɪŋli",
    "swimming": "swɪmɪŋ",
    "swims": "swɪmz",
    "swimsuits": "swɪmsuːts",
    "swimsuit": "swɪmsuːt",
    "swim": "swɪm",
    "swimwear": "swɪmweə",
    "swindled": "swɪndəld",
    "swindlers": "swɪndləz",
    "swindler": "swɪndlɐ",
    "swindles": "swɪndəlz",
    "swindle": "swɪndəl",
    "swindling": "swɪndlɪŋ",
    "swineherd": "swaɪnhɜːd",
    "swines": "swaɪnz",
    "swine": "swaɪn",
    "swingeing": "swɪndʒɪŋ",
    "swingers": "swɪŋɡəz",
    "swingle": "swɪŋɡəl",
    "swings": "swɪŋz",
    "swing": "swɪŋ",
    "swinish": "swɪnɪʃ",
    "swiped": "swaɪpt",
    "swipes": "swaɪps",
    "swipe": "swaɪp",
    "swiping": "swaɪpɪŋ",
    "swirled": "swɜːld",
    "swirling": "swɜːlɪŋ",
    "swirls": "swɜːlz",
    "swirl": "swɜːl",
    "swirly": "swɜːli",
    "swished": "swɪʃt",
    "swishes": "swɪʃɪz",
    "swishing": "swɪʃɪŋ",
    "swish": "swɪʃ",
    "swishy": "swɪʃi",
    "switchbacks": "swɪtʃbæks",
    "switchback": "swɪtʃbæk",
    "switchblades": "swɪtʃbleɪdz",
    "switchblade": "swɪtʃbleɪd",
    "switchboards": "swɪtʃbɔːdz",
    "switchboard": "swɪtʃbɔːd",
    "switched": "swɪtʃt",
    "switcheroo": "swɪtʃəruː",
    "switchers": "swɪtʃəz",
    "switcher": "swɪtʃɐ",
    "switches": "swɪtʃɪz",
    "switchgear": "swɪtʃɡiə",
    "switching": "swɪtʃɪŋ",
    "switchover": "swɪtʃəʊvɐ",
    "switch": "swɪtʃ",
    "swivelled": "swɪvəld",
    "swivelling": "swɪvəlɪŋ",
    "swivels": "swɪvəlz",
    "swivel": "swɪvəl",
    "swiz": "swɪz",
    "swizzle": "swɪzəl",
    "swizz": "swɪz",
    "swollen": "swəʊlən",
    "swooned": "swuːnd",
    "swooning": "swuːnɪŋ",
    "swoons": "swuːnz",
    "swoon": "swuːn",
    "swooped": "swuːpt",
    "swooping": "swuːpɪŋ",
    "swoops": "swuːps",
    "swoop": "swuːp",
    "swooshed": "swuːʃt",
    "swooshes": "swuːʃɪz",
    "swooshing": "swuːʃɪŋ",
    "swoosh": "swuːʃ",
    "swopped": "swɒpt",
    "swopping": "swɒpɪŋ",
    "swop": "swɒp",
    "swordcraft": "sɔːdkrɑːft",
    "swordfish": "sɔːdfɪʃ",
    "swordplay": "sɔːdpleɪ",
    "swordsmanship": "sɔːdzmənʃɪp",
    "swordsman": "sɔːdzmən",
    "swordsmen": "sɔːdzmɛn",
    "sword": "sɔːd",
    "swords": "sɔːdz",
    "swore": "swɔː",
    "sworn": "swɔːn",
    "swots": "swɒts",
    "swot": "swɒt",
    "swotted": "swɒtɪd",
    "swotting": "swɒtɪŋ",
    "swound": "swaʊnd",
    "swum": "swʌm",
    "swung": "swʌŋ",
    "sybaritic": "sɪbɑːrɪtɪk",
    "sycamore": "sɪkɐmɔː",
    "sycamores": "sɪkɐmɔːz",
    "sycophancy": "sɪkəfənsi",
    "sycophantic": "sɪkəfɑːntɪk",
    "sycophant": "sɪkɒfənt",
    "sycophants": "sɪkɒfənts",
    "syllabic": "sɪlæbɪk",
    "syllable": "sɪləbəl",
    "syllables": "sɪləbəlz",
    "syllabub": "sɪlɐbʌb",
    "syllabubs": "sɪlɐbʌbz",
    "syllabuses": "sɪlɐbjuːsɪz",
    "syllabus": "sɪlæbəs",
    "syllogism": "sɪlədʒɪzəm",
    "sylph": "sɪlf",
    "sylvan": "sɪlvən",
    "symbiosis": "sɪmbaɪəʊsɪs",
    "symbiotically": "sɪmbaɪɒtɪkli",
    "symbiotic": "sɪmbaɪɒtɪk",
    "symbolically": "sɪmbɒlɪkli",
    "symbolical": "sɪmbɒlɪkəl",
    "symbolic": "sɪmbɒlɪk",
    "symbolised": "sɪmbəlaɪzd",
    "symbolise": "sɪmbəlaɪz",
    "symbolises": "sɪmbəlaɪzɪz",
    "symbolising": "sɪmbəlaɪzɪŋ",
    "symbolism": "sɪmbəlɪzəm",
    "symbolist": "sɪmbəlɪst",
    "symbology": "sɪmbɒlədʒi",
    "symbol": "sɪmbəl",
    "symbols": "sɪmbəlz",
    "symmetrically": "sɪmɛtrɪkli",
    "symmetrical": "sɪmɛtrɪkəl",
    "symmetric": "sɪmɛtrɪk",
    "symmetries": "sɪmətrɪz",
    "symmetry": "sɪmətri",
    "sympathetically": "sɪmpəθɛtɪkli",
    "sympathetic": "sɪmpəθɛtɪk",
    "sympathies": "sɪmpəθɪz",
    "sympathised": "sɪmpəθaɪzd",
    "sympathiser": "sɪmpəθaɪzɐ",
    "sympathisers": "sɪmpəθaɪzəz",
    "sympathise": "sɪmpəθaɪz",
    "sympathises": "sɪmpəθaɪzɪz",
    "sympathising": "sɪmpəθaɪzɪŋ",
    "sympathy": "sɪmpəθi",
    "symphonia": "sɪmfəʊniə",
    "symphonic": "sɪmfɒnɪk",
    "symphonies": "sɪmfənɪz",
    "symphonist": "sɪmfənɪst",
    "symphonists": "sɪmfənɪsts",
    "symphony": "sɪmfəni",
    "symposium": "sɪmpəʊsiəm",
    "symptomatic": "sɪmptəmætɪk",
    "symptomless": "sɪmptəmləs",
    "symptom": "sɪmptəm",
    "symptoms": "sɪmptəmz",
    "synaesthesia": "sɪniːsθiːziə",
    "synagogue": "sɪnɐɡɒɡ",
    "synagogues": "sɪnɐɡɒɡz",
    "synapse": "sɪnæps",
    "synapses": "sɪnæpsɪz",
    "synaptic": "sɪnæptɪk",
    "synced": "sɪŋkt",
    "synched": "sɪnkt",
    "synching": "sɪnkɪŋ",
    "synchromesh": "sɪnkrəʊmʃ",
    "synchronicity": "sɪnkrənɪsɪti",
    "synchronisation": "sɪnkrənaɪzeɪʃən",
    "synchronised": "sɪnkrənaɪzd",
    "synchronise": "sɪnkrənaɪz",
    "synchronises": "sɪnkrənaɪzɪz",
    "synchronising": "sɪnkrənaɪzɪŋ",
    "synchronous": "sɪnkrənəs",
    "synchrony": "sɪnkrəni",
    "synchro": "sɪnkrəʊ",
    "synchrotron": "sɪnkrətrɒn",
    "synch": "sɪnk",
    "synchs": "sɪnkz",
    "syncing": "sɪŋkɪŋ",
    "syncopated": "sɪnkəpeɪtɪd",
    "syncopating": "sɪnkəpeɪtɪŋ",
    "syncopation": "sɪnkəpeɪʃən",
    "syncope": "sɪnkəʊp",
    "sync": "sɪŋk",
    "syncs": "sɪŋks",
    "syndicated": "sɪndɪkeɪtɪd",
    "syndication": "sɪndɪkeɪʃən",
    "syndrome": "sɪndrəʊm",
    "syndromes": "sɪndrəʊmz",
    "synergies": "sɪnədʒɪz",
    "synergistic": "sɪnədʒɪstɪk",
    "synergy": "sɪnədʒi",
    "syne": "saɪn",
    "synod": "sɪnɒd",
    "synonymous": "sɪnɒnɪməs",
    "synonym": "sɪnənɪm",
    "synonyms": "sɪnənɪmz",
    "synopsis": "sɪnɒpsɪs",
    "synoptic": "sɪnɒptɪk",
    "synovial": "sɪnəʊvɪəl",
    "syntax": "sɪntæks",
    "synthesised": "sɪnθəsaɪzd",
    "synthesise": "sɪnθəsaɪz",
    "synthesises": "sɪnθəsaɪzɪz",
    "synthesising": "sɪnθəsaɪzɪŋ",
    "synthesis": "sɪnθəsɪs",
    "synthesizer": "sɪnθəsaɪzɐ",
    "synthesizers": "sɪnθɪsaɪzəz",
    "synthetically": "sɪnθɛtɪkli",
    "synthetic": "sɪnθɛtɪk",
    "synthetics": "sɪnθɛtɪks",
    "sypher": "saɪfɐ",
    "syphilis": "sɪfəlɪs",
    "syphilitic": "saɪfɪlɪtɪk",
    "syphoned": "saɪfɒnd",
    "syphon": "saɪfɒn",
    "syringa": "sɪrɪndʒɐ",
    "syringed": "sɪrɪndʒd",
    "syringe": "sɪrɪndʒ",
    "syringing": "sɪrɪndʒɪŋ",
    "syringomyelia": "sɪrɪndʒəmɪiːliə",
    "syrinx": "sɪrɪŋks",
    "syrup": "sɪrʌp",
    "syrups": "sɪrʌps",
    "syrupy": "sɪrʌpi",
    "systematically": "sɪstəmætɪkli",
    "systematic": "sɪstəmætɪk",
    "systemically": "sɪstɛmɪkli",
    "systemic": "sɪstɛmɪk",
    "systems": "sɪstəmz",
    "system": "sɪstəm",
    "systole": "sɪstəʊl",
    "systolic": "sɪstɒlɪk",
    "syzygy": "sɪzɪdʒi",
    "tabards": "tæbɑːdz",
    "tabard": "tæbɑːd",
    "tabbed": "tæbd",
    "tabbies": "tæbɪz",
    "tabbouleh": "tæbuːleɪ",
    "tabby": "tæbi",
    "tabernacles": "tæbənəkəlz",
    "tabernacle": "tæbənəkəl",
    "tablas": "tæbləz",
    "tabla": "tæblɐ",
    "tableaus": "tæbləʊz",
    "tableau": "tæbləʊ",
    "tableaux": "teɪbləʊ",
    "tablecloths": "teɪbəlklɒθs",
    "tablecloth": "teɪbəlklɒθ",
    "tabled": "teɪbəld",
    "tableland": "teɪbəllənd",
    "tablespoonfuls": "teɪbəlspuːnfəlz",
    "tablespoonful": "teɪbəlspuːnfəl",
    "tablespoons": "teɪbəlspuːnz",
    "tablespoon": "teɪbəlspuːn",
    "tables": "teɪbəlz",
    "table": "teɪbəl",
    "tabletops": "teɪbəltɒps",
    "tabletop": "teɪbəltɒp",
    "tablets": "tæbləts",
    "tablet": "tæblət",
    "tableware": "teɪbəlweə",
    "tabling": "teɪblɪŋ",
    "tabloids": "tæblɔɪdz",
    "tabloid": "tæblɔɪd",
    "taboos": "tæbuːz",
    "taboo": "tæbuː",
    "tabor": "tæbɐ",
    "tabouleh": "tæbuːleɪ",
    "tabs": "tæbz",
    "tab": "tæb",
    "tabular": "tæbjʊlɐ",
    "tabulated": "tæbjʊleɪtɪd",
    "tabulate": "tæbjʊleɪt",
    "tabulating": "tæbjʊleɪtɪŋ",
    "tabulation": "tæbjʊleɪʃən",
    "taches": "tæʃɪz",
    "tache": "tæʃ",
    "tachographs": "tækəɡræfz",
    "tachograph": "tækəɡræf",
    "tachometer": "tækɒmɪtɐ",
    "tach": "tæk",
    "tachycardia": "tækɪkɑːdiə",
    "tachyons": "tækɪənz",
    "tachyon": "tækɪən",
    "tacitly": "tæsɪtli",
    "tacit": "tæsɪt",
    "taciturn": "tæsɪtɜːn",
    "tacked": "tækt",
    "tackers": "tækəz",
    "tacker": "tækɐ",
    "tackier": "tækiɐ",
    "tackiest": "tækiəst",
    "tackiness": "tækinəs",
    "tacking": "tækɪŋ",
    "tackled": "tækəld",
    "tacklers": "tækləz",
    "tackler": "tæklɐ",
    "tackles": "tækəlz",
    "tackle": "tækəl",
    "tackling": "tæklɪŋ",
    "tacks": "tæks",
    "tack": "tæk",
    "tacky": "tæki",
    "tacos": "tɑːkəʊz",
    "taco": "tɑːkəʊ",
    "tactfully": "tæktfəli",
    "tactful": "tæktfəl",
    "tactically": "tæktɪkli",
    "tactical": "tæktɪkəl",
    "tacticians": "tæktɪʃənz",
    "tactician": "tæktɪʃən",
    "tactics": "tæktɪks",
    "tactic": "tæktɪk",
    "tactile": "tæktaɪl",
    "taction": "tækʃən",
    "tactless": "tæktləs",
    "tact": "tækt",
    "tadpoles": "tædpəʊlz",
    "tadpole": "tædpəʊl",
    "tad": "tæd",
    "taed": "tiːd",
    "taenia": "tiːniɐ",
    "ta'en": "tæən",
    "taffeta": "tæfɪtɐ",
    "taffy": "tæfi",
    "tagged": "tæɡd",
    "taggers": "tæɡəz",
    "tagger": "tæɡɐ",
    "tagging": "tæɡɪŋ",
    "tagliatelle": "tæɡlɪeɪtəl",
    "tags": "tæɡz",
    "tag": "tæɡ",
    "tahini": "tæhiːni",
    "taiga": "teɪɡɐ",
    "tailbacks": "teɪlbæks",
    "tailback": "teɪlbæk",
    "tailboard": "teɪlbɔːd",
    "tailbone": "teɪlbəʊn",
    "tailcoat": "teɪlkəʊt",
    "tailed": "teɪld",
    "tailgated": "teɪlɡeɪtɪd",
    "tailgate": "teɪlɡeɪt",
    "tailgating": "teɪlɡeɪtɪŋ",
    "tailings": "teɪlɪŋz",
    "tailing": "teɪlɪŋ",
    "tailless": "teɪlɛs",
    "taille": "teɪl",
    "tailored": "teɪləd",
    "tailoring": "teɪlərɪŋ",
    "tailors": "teɪləz",
    "tailor": "teɪlɐ",
    "tailpiece": "teɪlpiːs",
    "tailpipes": "teɪlpaɪps",
    "tailpipe": "teɪlpaɪp",
    "tailplane": "teɪlpleɪn",
    "tailspin": "teɪlspɪn",
    "tails": "teɪlz",
    "tail": "teɪl",
    "tailwinds": "teɪlwɪndz",
    "tailwind": "teɪlwɪnd",
    "tainted": "teɪntɪd",
    "tain": "teɪn",
    "tainting": "teɪntɪŋ",
    "taints": "teɪnts",
    "taint": "teɪnt",
    "taipan": "teɪpæn",
    "taka": "tɑːkɐ",
    "takeaways": "teɪkəweɪz",
    "takeaway": "teɪkəweɪ",
    "taken": "teɪkən",
    "takeoffs": "teɪkɒfs",
    "takeoff": "teɪkɒf",
    "takeout": "teɪkaʊt",
    "takeovers": "teɪkəʊvəz",
    "takeover": "teɪkəʊvɐ",
    "takers": "teɪkəz",
    "taker": "teɪkɐ",
    "takes": "teɪks",
    "take": "teɪk",
    "takings": "teɪkɪŋz",
    "taking": "teɪkɪŋ",
    "takin": "tækɪn",
    "talas": "tɑːləz",
    "tala": "tɑːlɐ",
    "talc": "tælk",
    "talcum": "tælkəm",
    "talented": "tæləntɪd",
    "talentless": "tæləntləs",
    "talents": "tælənts",
    "talent": "tælənt",
    "tale": "teɪl",
    "talipes": "tælaɪps",
    "talismanic": "tælɪsmænɪk",
    "talismans": "tælɪsmənz",
    "talisman": "tælɪsmən",
    "tali": "tɑːli",
    "talkative": "tɔːkətɪv",
    "talked": "tɔːkt",
    "talkers": "tɔːkəz",
    "talker": "tɔːkɐ",
    "talkies": "tɔːkiz",
    "talkie": "tɔːki",
    "talking": "tɔːkɪŋ",
    "talks": "tɔːks",
    "talk": "tɔːk",
    "talky": "tɔːki",
    "tallboys": "tɔːlbɔɪz",
    "tallboy": "tɔːlbɔɪ",
    "taller": "tɔːlɐ",
    "tallest": "tɔːləst",
    "tallied": "tælɪd",
    "tallies": "tælɪz",
    "tallish": "tælɪʃ",
    "tallness": "tɔːlnəs",
    "tallow": "tæləʊ",
    "tall": "tɔːl",
    "tallyho": "tælɪhəʊ",
    "tallying": "tælɪɪŋ",
    "tallyman": "tælɪmən",
    "tallymen": "tælɪmɛn",
    "tally": "tæli",
    "taloned": "tælɒnd",
    "talons": "tælɒnz",
    "talon": "tælɒn",
    "talus": "tæləs",
    "tamales": "tæmeɪlz",
    "tamale": "tæmeɪl",
    "tamandua": "tæmɑːndjuːɐ",
    "tamarack": "tæmɐræk",
    "tamarinds": "tæmərɪndz",
    "tamarind": "tæmərɪnd",
    "tamarins": "tæmərɪnz",
    "tamarin": "tæmərɪn",
    "tamarisk": "tæmərɪsk",
    "tamari": "tæməri",
    "tambourines": "tæmbəriːnz",
    "tambourine": "tæmbəriːn",
    "tambourin": "tæmbərɪn",
    "tambour": "tæmbɐ",
    "tambura": "tæmbjɔːrɐ",
    "tamed": "teɪmd",
    "tamely": "teɪmli",
    "tameness": "teɪmnəs",
    "tamers": "teɪməz",
    "tamer": "teɪmɐ",
    "tames": "teɪmz",
    "tamest": "teɪməst",
    "tame": "teɪm",
    "taming": "teɪmɪŋ",
    "tammy": "tæmi",
    "tamoxifen": "tæməksaɪfən",
    "tamped": "tæmpt",
    "tampered": "tæmpəd",
    "tampering": "tæmpərɪŋ",
    "tampers": "tæmpəz",
    "tamper": "tæmpɐ",
    "tamping": "tæmpɪŋ",
    "tampons": "tæmpɒnz",
    "tampon": "tæmpɒn",
    "tamp": "tæmp",
    "tams": "tæmz",
    "tam": "tæm",
    "tanagers": "tænɪdʒəz",
    "tana": "tɑːnɐ",
    "tandems": "tændəmz",
    "tandem": "tændəm",
    "tandoori": "tændɔːri",
    "tangelo": "tændʒiːləʊ",
    "tangentially": "tændʒɛnʃəli",
    "tangential": "tændʒɛnʃəl",
    "tangents": "tændʒənts",
    "tangent": "tændʒənt",
    "tangerines": "tændʒəriːnz",
    "tangerine": "tændʒəriːn",
    "tangibility": "tændʒəbɪlɪti",
    "tangible": "tændʒəbəl",
    "tangibly": "tændʒəbli",
    "tangier": "tæŋɪɐ",
    "tanginess": "tæŋɪnəs",
    "tangled": "tæŋɡəld",
    "tangles": "tæŋɡəlz",
    "tangle": "tæŋɡəl",
    "tangling": "tæŋɡəlɪŋ",
    "tangoed": "tæŋɡəʊd",
    "tangoing": "tæŋɡəʊɪŋ",
    "tangos": "tæŋɡəʊz",
    "tango": "tæŋɡəʊ",
    "tangs": "tæŋz",
    "tangy": "tæŋi",
    "tankards": "tæŋkədz",
    "tankard": "tæŋkəd",
    "tanked": "tæŋkt",
    "tankers": "tæŋkəz",
    "tanker": "tæŋkɐ",
    "tankful": "tæŋkfəl",
    "tanking": "tæŋkɪŋ",
    "tanks": "tæŋks",
    "tank": "tæŋk",
    "tannage": "tænɪdʒ",
    "tanned": "tænd",
    "tanneries": "tænəriz",
    "tanners": "tænəz",
    "tanner": "tænɐ",
    "tannery": "tænəri",
    "tannic": "tænɪk",
    "tanning": "tænɪŋ",
    "tannins": "tænɪnz",
    "tannin": "tænɪn",
    "tans": "tænz",
    "tansy": "tænzi",
    "tan": "tæn",
    "tantalised": "tɑːntəlaɪzd",
    "tantalises": "tɑːntəlaɪzɪz",
    "tantalise": "tɑːntəlaɪz",
    "tantalisingly": "tɑːntəlaɪzɪŋli",
    "tantalising": "tɑːntəlaɪzɪŋ",
    "tantalum": "tɑːntæləm",
    "tantamount": "tɑːntɐmaʊnt",
    "tanto": "tɑːntəʊ",
    "tantra": "tɑːntrɐ",
    "tantric": "tɑːntrɪk",
    "tantrums": "tɑːntrəmz",
    "tantrum": "tɑːntrəm",
    "tapas": "tɑːpəz",
    "taped": "teɪpt",
    "tapered": "teɪpəd",
    "tapering": "teɪpərɪŋ",
    "tapers": "teɪpəz",
    "taper": "teɪpɐ",
    "tapes": "teɪps",
    "tapestries": "tæpəstrɪz",
    "tapestry": "tæpəstri",
    "tape": "teɪp",
    "tapetum": "tæpɛtəm",
    "tapeworms": "teɪpwɜːmz",
    "tapeworm": "teɪpwɜːm",
    "taping": "teɪpɪŋ",
    "tapioca": "tæpɪəʊkɐ",
    "tapirs": "tæpiəz",
    "tapir": "tæpiə",
    "tapis": "tæpiz",
    "tapped": "tæpt",
    "tappers": "tæpəz",
    "tapper": "tæpɐ",
    "tappets": "tæpɪts",
    "tappings": "tæpɪŋz",
    "tapping": "tæpɪŋ",
    "taproom": "teɪpruːm",
    "taproot": "teɪpruːt",
    "taps": "tæps",
    "tapster": "tæpstɐ",
    "tap": "tæp",
    "taramasalata": "tærɐmeɪzɐlɑːtɐ",
    "tarantella": "tærɑːntɛlɐ",
    "tarantulas": "təræntjʊləz",
    "tarantula": "təræntjʊlɐ",
    "taraxacum": "tærɐksækəm",
    "tardigrades": "tɑːdɪɡreɪdz",
    "tardigrade": "tɑːdɪɡreɪd",
    "tardiness": "tɑːdɪnəs",
    "tardy": "tɑːdi",
    "tares": "teəz",
    "tare": "teə",
    "targe": "tɑːdʒ",
    "targeted": "tɑːɡɪtɪd",
    "targeting": "tɑːɡɪtɪŋ",
    "targets": "tɑːɡɪts",
    "target": "tɑːɡɪt",
    "tariffs": "tærɪfs",
    "tariff": "tærɪf",
    "tarmacadam": "tɑːmɐkædəm",
    "tarmacked": "tɑːmækt",
    "tarmacking": "tɑːmækɪŋ",
    "tarmac": "tɑːmæk",
    "tarnation": "tɑːneɪʃən",
    "tarnished": "tɑːnɪʃt",
    "tarnishes": "tɑːnɪʃɪz",
    "tarnishing": "tɑːnɪʃɪŋ",
    "tarnish": "tɑːnɪʃ",
    "tarns": "tɑːnz",
    "tarn": "tɑːn",
    "taro": "tærəʊ",
    "tarot": "tærɒt",
    "tarpan": "tɑːpæn",
    "tarpaulins": "tɑːpəlɪnz",
    "tarpaulin": "tɑːpəlɪn",
    "tarpon": "tɑːpɒn",
    "tarps": "tɑːps",
    "tarp": "tɑːp",
    "tarragon": "tærəɡən",
    "tarred": "tɑːd",
    "tarried": "tærɪd",
    "tarring": "tɑːrɪŋ",
    "tarrying": "tærɪɪŋ",
    "tarsals": "tɑːsəlz",
    "tarsiers": "tɑːsiəz",
    "tarsier": "tɑːsɪɐ",
    "tars": "tɑːz",
    "tarsus": "tɑːsəs",
    "tar": "tɑː",
    "tartans": "tɑːtənz",
    "tartan": "tɑːtən",
    "tartaric": "tɑːtærɪk",
    "tartars": "tɑːtəz",
    "tartar": "tɑːtɐ",
    "tarted": "tɑːtɪd",
    "tarter": "tɑːtɐ",
    "tarting": "tɑːtɪŋ",
    "tartlets": "tɑːtləts",
    "tartlet": "tɑːtlət",
    "tartly": "tɑːtli",
    "tartness": "tɑːtnəs",
    "tartrate": "tɑːtreɪt",
    "tartrazine": "tɑːtreɪziːn",
    "tarts": "tɑːts",
    "tart": "tɑːt",
    "tarty": "tɑːti",
    "tasked": "tɑːskt",
    "taskforce": "tæskfɔːs",
    "tasking": "tɑːskɪŋ",
    "taskmasters": "tɑːskmɑːstəz",
    "taskmaster": "tɑːskmɑːstɐ",
    "tasks": "tɑːsks",
    "task": "tɑːsk",
    "tasselled": "tæsəld",
    "tassels": "tæsəlz",
    "tassel": "tæsəl",
    "tasse": "tæs",
    "tass": "tæs",
    "tasted": "teɪstɪd",
    "tastefully": "teɪstfəli",
    "tasteful": "teɪstfəl",
    "tastelessly": "teɪstləsli",
    "tastelessness": "teɪstləsnəs",
    "tasteless": "teɪstləs",
    "tasters": "teɪstəz",
    "taster": "teɪstɐ",
    "tastes": "teɪsts",
    "taste": "teɪst",
    "tastier": "teɪstɪɐ",
    "tastiest": "teɪstɪəst",
    "tastily": "teɪstɪli",
    "tastings": "teɪstɪŋz",
    "tasting": "teɪstɪŋ",
    "tasty": "teɪsti",
    "ta": "tɑː",
    "tatami": "tætɑːmi",
    "taters": "teɪtəz",
    "tater": "teɪtɐ",
    "tats": "tæts",
    "tat": "tæt",
    "tattered": "tætəd",
    "tatters": "tætəz",
    "tatter": "tætɐ",
    "tattier": "tætɪɐ",
    "tatties": "tætɪz",
    "tattie": "tæti",
    "tattler": "tætlɐ",
    "tattle": "tætəl",
    "tattletale": "tætəlteɪl",
    "tattooed": "tætuːd",
    "tattooing": "tætuːɪŋ",
    "tattooists": "tætuːɪsts",
    "tattooist": "tætuːɪst",
    "tattoos": "tætuːz",
    "tattoo": "tætuː",
    "tatty": "tæti",
    "taught": "tɔːt",
    "taunted": "tɔːntɪd",
    "taunter": "tɔːntɐ",
    "taunting": "tɔːntɪŋ",
    "taunts": "tɔːnts",
    "taunt": "tɔːnt",
    "taupe": "tɔːp",
    "taurine": "tɔːriːn",
    "taus": "taʊs",
    "tau": "taʊ",
    "tauter": "tɔːtɐ",
    "tautly": "tɔːtli",
    "tautness": "tɔːtnəs",
    "tautological": "tɔːtəlɒdʒɪkəl",
    "tautology": "tɔːtɒlədʒi",
    "taut": "tɔːt",
    "tavernas": "tævənəz",
    "taverna": "tævənɐ",
    "taverner": "tævənɐ",
    "taverns": "tævənz",
    "tavern": "tævən",
    "tawdriness": "tɔːdrɪnəs",
    "tawdry": "tɔːdri",
    "tawny": "tɔːni",
    "taw": "tɔː",
    "taxable": "tæksəbəl",
    "taxation": "tækseɪʃən",
    "taxed": "tækst",
    "taxicabs": "tæksɪkæbz",
    "taxicab": "tæksɪkæb",
    "taxidermists": "tæksɪdəmɪsts",
    "taxidermist": "tæksɪdəmɪst",
    "taxidermy": "tæksɪdəmi",
    "taxied": "tæksid",
    "taxies": "tæksiz",
    "taxiing": "tæksiɪŋ",
    "taxing": "tæksɪŋ",
    "taxi": "tæksi",
    "taxiways": "tæksɪweɪz",
    "taxman": "tæksmən",
    "taxmen": "tæksmɛn",
    "taxonomic": "tæksənɒmɪk",
    "taxonomists": "tæksɒnəmɪsts",
    "taxonomy": "tæksɒnəmi",
    "taxon": "tæksən",
    "taxpayers": "tækspeɪəz",
    "taxpayer": "tækspeɪɐ",
    "taxpaying": "tækspeɪɪŋ",
    "tax": "tæks",
    "tazza": "tæzɐ",
    "teabags": "tiːbæɡz",
    "teabag": "tiːbæɡ",
    "teacakes": "tiːkeɪks",
    "teacake": "tiːkeɪk",
    "teachable": "tiːtʃəbəl",
    "teachers": "tiːtʃəz",
    "teacher": "tiːtʃɐ",
    "teaches": "tiːtʃɪz",
    "teachings": "tiːtʃɪŋz",
    "teaching": "tiːtʃɪŋ",
    "teach": "tiːtʃ",
    "teacups": "tiːkʌps",
    "teacup": "tiːkʌp",
    "teahouse": "tiːhaʊs",
    "teak": "tiːk",
    "teakwood": "tiːkwʊd",
    "teals": "tiːlz",
    "teal": "tiːl",
    "teamed": "tiːmd",
    "teaming": "tiːmɪŋ",
    "teammates": "tiːmeɪts",
    "teammate": "tiːmeɪt",
    "teamsters": "tiːmstəz",
    "teamster": "tiːmstɐ",
    "teams": "tiːmz",
    "team": "tiːm",
    "teamwork": "tiːmwɜːk",
    "teapots": "tiːpɒts",
    "teapot": "tiːpɒt",
    "tearaways": "teərəweɪz",
    "tearaway": "teərəweɪ",
    "teardrops": "tiədrɒps",
    "teardrop": "tiədrɒp",
    "teared": "teəd",
    "tearfully": "tiəfəli",
    "tearfulness": "tiəfəlnəs",
    "tearful": "tiəfəl",
    "teargas": "tiəɡæs",
    "tearing": "teərɪŋ",
    "tearjerker": "tiədʒəkɐ",
    "tearless": "tiələs",
    "tearooms": "teəruːmz",
    "tearoom": "teəruːm",
    "teary": "tiəri",
    "teased": "tiːzd",
    "teasels": "tiːzəlz",
    "teasel": "tiːzəl",
    "teasers": "tiːzəz",
    "teaser": "tiːzɐ",
    "teases": "tiːzɪz",
    "tease": "tiːz",
    "teashops": "tiːʃɒps",
    "teashop": "tiːʃɒp",
    "teasingly": "tiːzɪŋli",
    "teasing": "tiːzɪŋ",
    "teaspoonfuls": "tiːspuːnfəlz",
    "teaspoonful": "tiːspuːnfəl",
    "teaspoons": "tiːspuːnz",
    "teaspoon": "tiːspuːn",
    "teas": "tiːz",
    "tea": "tiː",
    "teatimes": "tiːtaɪmz",
    "teatime": "tiːtaɪm",
    "teats": "tiːts",
    "teat": "tiːt",
    "teazle": "tiːzəl",
    "techies": "tɛkɪz",
    "techie": "tɛki",
    "technetium": "tɛkniːtiəm",
    "technicalities": "tɛknɪkælɪtiz",
    "technicality": "tɛknɪkælɪti",
    "technically": "tɛknɪkli",
    "technical": "tɛknɪkəl",
    "technicians": "tɛknɪʃənz",
    "technician": "tɛknɪʃən",
    "technicolor": "tɛknɪkʌlɐ",
    "technics": "tɛknɪks",
    "technic": "tɛknɪk",
    "techniques": "tɛkniːks",
    "technique": "tɛkniːk",
    "technocratic": "tɛknəkrætɪk",
    "technocrats": "tɛknəkræts",
    "technocrat": "tɛknəkræt",
    "technologically": "tɛknəlɒdʒɪkli",
    "technological": "tɛknəlɒdʒɪkəl",
    "technologies": "tɛknɒlədʒɪz",
    "technologists": "tɛknɒlədʒɪsts",
    "technologist": "tɛknɒlədʒɪst",
    "technology": "tɛknɒlədʒi",
    "technophobe": "tɛknəfəʊb",
    "techno": "tɛknəʊ",
    "techs": "tɛks",
    "techy": "tɛki",
    "tectonics": "tɛktɒnɪks",
    "tectonic": "tɛktɒnɪk",
    "tedder": "tɛdɐ",
    "teddies": "tɛdɪz",
    "teddy": "tɛdi",
    "tediously": "tiːdɪəsli",
    "tediousness": "tiːdɪəsnəs",
    "tedious": "tiːdɪəs",
    "tedium": "tiːdiəm",
    "teds": "tɛdz",
    "teed": "tiːd",
    "teeing": "tiːɪŋ",
    "teemed": "tiːmd",
    "teeming": "tiːmɪŋ",
    "teems": "tiːmz",
    "teem": "tiːm",
    "teenaged": "tiːneɪdʒd",
    "teenagers": "tiːneɪdʒəz",
    "teenager": "tiːneɪdʒɐ",
    "teenage": "tiːneɪdʒ",
    "teeniest": "tiːnɪəst",
    "teensiest": "tiːnzɪəst",
    "teens": "tiːnz",
    "teensy": "tiːnzi",
    "teen": "tiːn",
    "teenyboppers": "tiːnɪbəpəz",
    "teenybopper": "tiːnɪbəpɐ",
    "teeny": "tiːni",
    "teepees": "tiːpiːz",
    "teepee": "tiːpiː",
    "tees": "tiːz",
    "teetered": "tiːtəd",
    "teetering": "tiːtərɪŋ",
    "teeters": "tiːtəz",
    "teeter": "tiːtɐ",
    "teethed": "tiːθd",
    "teething": "tiːðɪŋ",
    "teeth": "tiːθ",
    "tee": "tiː",
    "teetotalism": "tiːtəʊtəlɪzəm",
    "teetotallers": "tiːtəʊtɔːləz",
    "teetotaller": "tiːtəʊtɔːlɐ",
    "teetotal": "tiːtəʊtəl",
    "tefillin": "tɛfɪlɪn",
    "telecaster": "tɛlɪkɑːstɐ",
    "telecast": "tɛlɪkɑːst",
    "telecommunications": "tɛlɪkəmjuːnɪkeɪʃənz",
    "telecommunication": "tɛlɪkəmjuːnɪkeɪʃən",
    "telecoms": "tɛlɪkɒmz",
    "teleconference": "tɛlɪkɒnfrəns",
    "teleconferencing": "tɛlɪkɒnfrənsɪŋ",
    "telegenic": "tɛlɪdʒɛnɪk",
    "telegrams": "tɛlɪɡræmz",
    "telegram": "tɛlɪɡræm",
    "telegraphed": "tɛlɪɡræfd",
    "telegrapher": "tɛlɪɡrəfɐ",
    "telegraphic": "tɛlɪɡræfɪk",
    "telegraphing": "tɛlɪɡræfɪŋ",
    "telegraphs": "tɛlɪɡræfz",
    "telegraph": "tɛlɪɡræf",
    "telegraphy": "tɛlɪɡrəfi",
    "telekinesis": "tɛlɪkəniːsɪs",
    "telekinetic": "tɛlɪkaɪnɛtɪk",
    "telemarketer": "tɛlɪmɑːkiːtɐ",
    "telemarketing": "tɛlɪmɑːkɪtɪŋ",
    "telemark": "tɛlɪmɑːk",
    "telemetry": "təlɛmətri",
    "teleological": "tɛlɪəlɒdʒɪkəl",
    "telepathically": "tɛlɪpæθɪkli",
    "telepathic": "tɛlɪpæθɪk",
    "telepathy": "təlɛpəθi",
    "telephoned": "tɛlɪfəʊnd",
    "telephones": "tɛlɪfəʊnz",
    "telephone": "tɛlɪfəʊn",
    "telephonic": "tɛlɪfɒnɪk",
    "telephoning": "tɛlɪfəʊnɪŋ",
    "telephonist": "təlɛfənɪst",
    "telephony": "təlɛfəni",
    "telephoto": "tɛlɪfəʊtəʊ",
    "teleprinters": "tɛlɪprɪntəz",
    "teleprinter": "tɛlɪprɪntɐ",
    "teleprompter": "tɛlɪprɒmptɐ",
    "telesales": "tɛlɪseɪlz",
    "telescopes": "tɛlɪskəʊps",
    "telescope": "tɛlɪskəʊp",
    "telescopically": "tɛlɪskɒpɪkli",
    "telescopic": "tɛlɪskɒpɪk",
    "telescoping": "tɛlɪskəʊpɪŋ",
    "teletext": "tɛlɪtɛkst",
    "telethons": "tɛlɪθənz",
    "telethon": "tɛlɪθən",
    "teletype": "tɛlɪtaɪp",
    "televangelist": "tɛlɪvændʒɪlɪst",
    "teleview": "tɛlɪvjuː",
    "televised": "tɛlɪvaɪzd",
    "televise": "tɛlɪvaɪz",
    "televising": "tɛlɪvaɪzɪŋ",
    "televisions": "tɛlɪvɪʒənz",
    "television": "tɛlɪvɪʒən",
    "televisor": "tɛlɪvaɪzɐ",
    "televisual": "tɛlɪvɪʒuːəl",
    "teleworking": "tɛlɪwɜːkɪŋ",
    "telexed": "tɛlɪkst",
    "telexes": "tɛlɪksɪz",
    "telex": "tɛlɪks",
    "telfer": "tɛlfɐ",
    "telic": "tɛlɪk",
    "tellers": "tɛləz",
    "teller": "tɛlɐ",
    "tellies": "tɛliz",
    "tellingly": "tɛlɪŋli",
    "telling": "tɛlɪŋ",
    "tells": "tɛlz",
    "telltale": "tɛlteɪl",
    "tell": "tɛl",
    "telluric": "tɛlɔːrɪk",
    "tellurium": "tɛlɔːriəm",
    "telly": "tɛli",
    "telophase": "tɛləfeɪz",
    "telson": "tɛlsən",
    "temerity": "tɛmɛrɪti",
    "temped": "tɛmpt",
    "tempeh": "tɛmpeɪ",
    "temperamentally": "tɛmprəmɛntəli",
    "temperamental": "tɛmprəmɛntəl",
    "temperaments": "tɛmprəmənts",
    "temperament": "tɛmprəmənt",
    "temperance": "tɛmpərəns",
    "tempera": "tɛmpərɐ",
    "temperate": "tɛmpərət",
    "temperatures": "tɛmprɪtʃəz",
    "temperature": "tɛmprɪtʃɐ",
    "tempered": "tɛmpəd",
    "tempering": "tɛmpərɪŋ",
    "tempers": "tɛmpəz",
    "temper": "tɛmpɐ",
    "tempests": "tɛmpəsts",
    "tempest": "tɛmpəst",
    "tempestuous": "tɛmpɛstʃuːəs",
    "temping": "tɛmpɪŋ",
    "tempi": "tɛmpi",
    "templates": "tɛmpleɪts",
    "template": "tɛmpleɪt",
    "temples": "tɛmpəlz",
    "temple": "tɛmpəl",
    "temporally": "tɛmpərəli",
    "temporal": "tɛmpərəl",
    "temporarily": "tɛmpərɛrəli",
    "temporary": "tɛmprəri",
    "temporised": "tɛmpɔːraɪzd",
    "tempos": "tɛmpəʊz",
    "tempo": "tɛmpəʊ",
    "temps": "tɛmps",
    "temptations": "tɛmpteɪʃənz",
    "temptation": "tɛmpteɪʃən",
    "tempted": "tɛmptɪd",
    "temp": "tɛmp",
    "tempters": "tɛmptəz",
    "tempter": "tɛmptɐ",
    "temptingly": "tɛmptɪŋli",
    "tempting": "tɛmptɪŋ",
    "temptresses": "tɛmptrəsɪz",
    "temptress": "tɛmptrəs",
    "tempts": "tɛmpts",
    "tempt": "tɛmpt",
    "tempura": "tɛmpjɔːrɐ",
    "tenable": "tɛnəbəl",
    "tenaciously": "tɛneɪʃəsli",
    "tenacious": "tɛneɪʃəs",
    "tenacity": "tɛnæsɪti",
    "tenancies": "tɛnənsɪz",
    "tenancy": "tɛnənsi",
    "tenantable": "tɛnəntəbəl",
    "tenanted": "tɛnəntɪd",
    "tenanting": "tɛnəntɪŋ",
    "tenantry": "tɛnəntri",
    "tenants": "tɛnənts",
    "tenant": "tɛnənt",
    "tench": "tɛntʃ",
    "tendance": "tɛndəns",
    "tended": "tɛndɪd",
    "tendencies": "tɛndənsiz",
    "tendency": "tɛndənsi",
    "tendentious": "tɛndɛnʃəs",
    "tendered": "tɛndəd",
    "tenderer": "tɛndərɐ",
    "tenderest": "tɛndərəst",
    "tenderfoot": "tɛndəfʊt",
    "tendering": "tɛndərɪŋ",
    "tenderised": "tɛndɪraɪzd",
    "tenderiser": "tɛndɪraɪzɐ",
    "tenderises": "tɛndɪraɪzɪz",
    "tenderise": "tɛndɪraɪz",
    "tenderising": "tɛndɪraɪzɪŋ",
    "tenderloins": "tɛndəlɔɪnz",
    "tenderloin": "tɛndəlɔɪn",
    "tenderly": "tɛndəli",
    "tenderness": "tɛndənəs",
    "tenders": "tɛndəz",
    "tender": "tɛndɐ",
    "tending": "tɛndɪŋ",
    "tendinitis": "tɛndɪnaɪtɪs",
    "tendonitis": "tɛndənaɪtɪs",
    "tendons": "tɛndənz",
    "tendon": "tɛndən",
    "tendrils": "tɛndrəlz",
    "tendril": "tɛndrəl",
    "tends": "tɛndz",
    "tend": "tɛnd",
    "tenements": "tɛnəmənts",
    "tenement": "tɛnəmənt",
    "tenets": "tɛnɪts",
    "tenet": "tɛnɪt",
    "tenfold": "tɛnfəʊld",
    "tenners": "tɛnəz",
    "tenner": "tɛnɐ",
    "tennis": "tɛnɪs",
    "tenons": "tɛnɒnz",
    "tenon": "tɛnɒn",
    "tenors": "tɛnəz",
    "tenor": "tɛnɐ",
    "tenpins": "tɛnpɪnz",
    "tenpin": "tɛnpɪn",
    "tenrecs": "tɛnrɛks",
    "tenrec": "tɛnrɛk",
    "tensed": "tɛnsd",
    "tensely": "tɛnsli",
    "tenseness": "tɛnsnəs",
    "tenser": "tɛnsɐ",
    "tenses": "tɛnsɪz",
    "tensest": "tɛnsəst",
    "tense": "tɛns",
    "tensile": "tɛnsaɪl",
    "tensing": "tɛnsɪŋ",
    "tensioned": "tɛnʃənd",
    "tensions": "tɛnʃənz",
    "tension": "tɛnʃən",
    "tensor": "tɛnsɐ",
    "tens": "tɛnz",
    "tentacled": "tɛntəkəld",
    "tentacles": "tɛntəkəlz",
    "tentacle": "tɛntəkəl",
    "tentatively": "tɛntətɪvli",
    "tentativeness": "tɛntətɪvnəs",
    "tentative": "tɛntətɪv",
    "tented": "tɛntɪd",
    "ten": "tɛn",
    "tenterhooks": "tɛntəhʊks",
    "tenter": "tɛntɐ",
    "tenths": "tɛnθs",
    "tenth": "tɛnθ",
    "tenting": "tɛntɪŋ",
    "tents": "tɛnts",
    "tent": "tɛnt",
    "tenuously": "tɛnjuːəsli",
    "tenuous": "tɛnjuːəs",
    "tenured": "tɛnjəd",
    "tenures": "tɛnjəz",
    "tenure": "tɛnjɐ",
    "tepees": "tiːpiːz",
    "tepee": "tiːpiː",
    "tephra": "tɛfrɐ",
    "tepid": "tɛpɪd",
    "tequilas": "təkiːləz",
    "tequila": "təkiːlɐ",
    "terabytes": "tɛrəbaɪts",
    "terbium": "tɜːbiəm",
    "tercentenary": "tɜːsəntiːnəri",
    "tercet": "tɜːsɪt",
    "terephthalate": "tɛrɪfθæleɪt",
    "teriyaki": "tɛrɪjæki",
    "termed": "tɜːmd",
    "terminally": "tɜːmɪnəli",
    "terminals": "tɜːmɪnəlz",
    "terminal": "tɜːmɪnəl",
    "terminated": "tɜːmɪneɪtɪd",
    "terminates": "tɜːmɪneɪts",
    "terminate": "tɜːmɪneɪt",
    "terminating": "tɜːmɪneɪtɪŋ",
    "terminations": "tɜːmɪneɪʃənz",
    "termination": "tɜːmɪneɪʃən",
    "terminators": "tɜːmɪneɪtəz",
    "terminator": "tɜːmɪneɪtɐ",
    "terming": "tɜːmɪŋ",
    "termini": "tɜːmɪnaɪ",
    "terminological": "tɜːmɪnəlɒdʒɪkəl",
    "terminologies": "tɜːmɪnɒlədʒɪz",
    "terminology": "tɜːmɪnɒlədʒi",
    "terminuses": "tɜːmɪnjuːsɪz",
    "terminus": "tɜːmɪnəs",
    "termites": "tɜːmaɪts",
    "termite": "tɜːmaɪt",
    "termly": "tɜːmli",
    "terms": "tɜːmz",
    "term": "tɜːm",
    "ternary": "tɜːnəri",
    "terns": "tɜːnz",
    "tern": "tɜːn",
    "terpenes": "tɜːpiːnz",
    "terpsichorean": "tɜːpsɪkɔːriən",
    "terraced": "tɛrɪst",
    "terraces": "tɛrɪsɪz",
    "terrace": "tɛrɪs",
    "terracing": "tɛrɪsɪŋ",
    "terracotta": "tɛrɐkɒtɐ",
    "terraform": "tɛrɐfɔːm",
    "terrains": "təreɪnz",
    "terrain": "təreɪn",
    "terrapins": "tɛrɐpɪnz",
    "terrapin": "tɛrɐpɪn",
    "terrarium": "tɛreəriəm",
    "terra": "tɛrɐ",
    "terrazzo": "tɛræzəʊ",
    "terrestrials": "tərɛstrɪəlz",
    "terrestrial": "tərɛstrɪəl",
    "terrible": "tɛrəbəl",
    "terribly": "tɛrəbli",
    "terriers": "tɛriəz",
    "terrier": "tɛrɪɐ",
    "terrifically": "tərɪfɪkli",
    "terrific": "tərɪfɪk",
    "terrified": "tɛrɪfaɪd",
    "terrifies": "tɛrɪfaɪz",
    "terrifyingly": "tɛrɪfaɪɪŋli",
    "terrifying": "tɛrɪfaɪɪŋ",
    "terrify": "tɛrɪfaɪ",
    "terrines": "tɛriːnz",
    "terrine": "tɛriːn",
    "territoriality": "tɛrɪtɔːrɪælɪti",
    "territorially": "tɛrɪtɔːrɪəli",
    "territorials": "tɛrɪtɔːrɪəlz",
    "territorial": "tɛrɪtɔːrɪəl",
    "territories": "tɛrɪtəriz",
    "territory": "tɛrɪtəri",
    "terrorised": "tɛrəraɪzd",
    "terrorises": "tɛrəraɪzɪz",
    "terrorise": "tɛrəraɪz",
    "terrorising": "tɛrəraɪzɪŋ",
    "terrorism": "tɛrərɪzəm",
    "terrorists": "tɛrərɪsts",
    "terrorist": "tɛrərɪst",
    "terrors": "tɛrəz",
    "terror": "tɛrɐ",
    "terry": "tɛri",
    "terse": "tɜːs",
    "tertiary": "tɜːʃjəri",
    "tesla": "tɛslɐ",
    "tessellated": "tɛsɪleɪtɪd",
    "tessellate": "tɛsɪleɪt",
    "tessellation": "tɛsɪleɪʃən",
    "tesserae": "tɛsəriː",
    "tessera": "tɛsərɐ",
    "testable": "tɛstəbəl",
    "testaments": "tɛstəmənts",
    "testament": "tɛstəmənt",
    "testa": "tɛstɐ",
    "testate": "tɪsteɪt",
    "testator": "tɛsteɪtɐ",
    "tested": "tɛstɪd",
    "testers": "tɛstəz",
    "testes": "tɛstiːz",
    "testicles": "tɛstɪkəlz",
    "testicle": "tɛstɪkəl",
    "testicular": "tɛstɪkjʊlɐ",
    "testified": "tɛstɪfaɪd",
    "testifies": "tɛstɪfaɪz",
    "testifying": "tɛstɪfaɪɪŋ",
    "testify": "tɛstɪfaɪ",
    "testily": "tɛstɪli",
    "testimonials": "tɛstɪməʊnɪəlz",
    "testimonial": "tɛstɪməʊnɪəl",
    "testimonies": "tɛstɪmənɪz",
    "testimony": "tɛstɪməni",
    "testings": "tɛstɪŋz",
    "testing": "tɛstɪŋ",
    "testis": "tɛstiz",
    "teston": "tɛstən",
    "testosterone": "tɛstɒstərəʊn",
    "tests": "tɛsts",
    "test": "tɛst",
    "testudo": "tɛstjuːdəʊ",
    "testy": "tɛsti",
    "tetanic": "tɛtænɪk",
    "tetanus": "tɛtənəs",
    "tetchily": "tɛtʃɪli",
    "tetchiness": "tɛtʃɪnəs",
    "tetchy": "tɛtʃi",
    "tethered": "tɛðəd",
    "tethering": "tɛðərɪŋ",
    "tethers": "tɛðəz",
    "tether": "tɛðɐ",
    "teth": "tɛθ",
    "tetrachloride": "tɛtrɐklɔːraɪd",
    "tetracycline": "tɛtrɐsaɪklaɪn",
    "tetrahedron": "tɛtrɐhiːdrən",
    "tetralogy": "tɛtrælədʒi",
    "tetrapods": "tɛtrɐpɒdz",
    "tetrapod": "tɛtrɐpɒd",
    "tetra": "tɛtrɐ",
    "tetroxide": "tɛtrɒksaɪd",
    "textbooks": "tɛkstbʊks",
    "textbook": "tɛkstbʊk",
    "textiles": "tɛkstaɪlz",
    "textile": "tɛkstaɪl",
    "texts": "tɛksts",
    "text": "tɛkst",
    "textually": "tɛkstʃuːəli",
    "textual": "tɛkstʃuːəl",
    "texturally": "tɛkstʃərəli",
    "textural": "tɛkstʃərəl",
    "textured": "tɛkstʃəd",
    "textures": "tɛkstʃəz",
    "texture": "tɛkstʃɐ",
    "texturing": "tɛkstʃərɪŋ",
    "thalamus": "θælæməs",
    "thaler": "θeɪlɐ",
    "thalidomide": "θælɪdɒmaɪd",
    "thallium": "θæliəm",
    "than": "ðɐn",
    "thanes": "θeɪnz",
    "thane": "θeɪn",
    "thanked": "θæŋkt",
    "thankfully": "θæŋkfəli",
    "thankfulness": "θæŋkfəlnəs",
    "thankful": "θæŋkfəl",
    "thanking": "θæŋkɪŋ",
    "thankless": "θæŋkləs",
    "thanksgivings": "θæŋksɡɪvɪŋz",
    "thanksgiving": "θæŋksɡɪvɪŋ",
    "thanks": "θæŋks",
    "thank": "θæŋk",
    "thar": "θɑː",
    "thatched": "θætʃt",
    "thatchers": "θætʃəz",
    "thatcher": "θætʃɐ",
    "thatches": "θætʃɪz",
    "thatching": "θætʃɪŋ",
    "thatch": "θætʃ",
    "that": "ðæt",
    "thawed": "θɔːd",
    "thawing": "θɔːrɪŋ",
    "thaws": "θɔːz",
    "thaw": "θɔː",
    "theaters": "θiətəz",
    "theater": "θiətɐ",
    "theatregoers": "θiətrɪɡəʊəz",
    "theatregoer": "θiətrɪɡəʊɐ",
    "theatres": "θiətəz",
    "theatre": "θiətɐ",
    "theatricality": "θiːætrɪkælɪti",
    "theatrically": "θiːætrɪkli",
    "theatricals": "θiːætrɪkəlz",
    "theatrical": "θiːætrɪkəl",
    "theatrics": "θiːætrɪks",
    "thebes": "θiːbz",
    "thee": "ðiː",
    "thees": "ðiːz",
    "thefts": "θɛfts",
    "theft": "θɛft",
    "their": "ðeə",
    "theirs": "ðeəz",
    "theism": "θiːɪzəm",
    "theistic": "θiːɪstɪk",
    "theist": "θiːɪst",
    "thematically": "θiːmætɪkli",
    "thematic": "θiːmætɪk",
    "them": "ðɛm",
    "themed": "θiːmd",
    "themes": "θiːmz",
    "theme": "θiːm",
    "themselves": "ðɛmsɛlvz",
    "thence": "ðɛns",
    "thenceforth": "θɛnsɪfɔːθ",
    "then": "ðɛn",
    "theocracy": "θɪɒkrəsi",
    "theocratic": "θiːəkrætɪk",
    "theodolite": "θiːədɒlaɪt",
    "theologians": "θiːələʊdʒənz",
    "theologian": "θiːələʊdʒən",
    "theologically": "θiːəlɒdʒɪkli",
    "theological": "θiːəlɒdʒɪkəl",
    "theology": "θɪɒlədʒi",
    "theorems": "θiərəmz",
    "theorem": "θiərəm",
    "theoretically": "θiərɛtɪkli",
    "theoretical": "θiərɛtɪkəl",
    "theoreticians": "θiərɪtɪʃənz",
    "theoretician": "θiərɪtɪʃən",
    "theoretic": "θiərɛtɪk",
    "theories": "θiərɪz",
    "theorised": "θiəraɪzd",
    "theorise": "θiəraɪz",
    "theorising": "θiəraɪzɪŋ",
    "theorists": "θiərɪsts",
    "theorist": "θiərɪst",
    "theory": "θiəri",
    "theosophist": "θiːəsɒfɪst",
    "theosophy": "θiːəsɒfi",
    "therapeutically": "θɛrəpjuːtɪkli",
    "therapeutics": "θɛrəpjuːtɪks",
    "therapeutic": "θɛrəpjuːtɪk",
    "therapies": "θɛrəpɪz",
    "therapists": "θɛrəpɪsts",
    "therapist": "θɛrəpɪst",
    "therapy": "θɛrəpi",
    "thereabout": "ðeərɐbaʊt",
    "thereabouts": "ðeərɐbaʊts",
    "thereafter": "ðeərɑːftɐ",
    "thereat": "ðeəræt",
    "thereby": "ðeəbaɪ",
    "there": "ðeə",
    "therefore": "ðeəfɔː",
    "therefrom": "ðeəfrɒm",
    "therein": "ðeərɪn",
    "thereof": "ðeərɒv",
    "thereon": "ðeərɒn",
    "thereto": "ðeətuː",
    "thereupon": "ðeərʌpɒn",
    "therewith": "ðeəwɪð",
    "thermae": "θɜːmiː",
    "thermally": "θɜːməli",
    "thermals": "θɜːməlz",
    "thermal": "θɜːməl",
    "thermic": "θɜːmɪk",
    "thermocline": "θɜːməklaɪn",
    "thermodynamics": "θɜːmədaɪnæmɪks",
    "thermodynamic": "θɜːmədaɪnæmɪk",
    "thermogenesis": "θɜːməʊdʒɛnɪsɪs",
    "thermometers": "θɜːmɒmɪtəz",
    "thermometer": "θɜːmɒmɪtɐ",
    "thermonuclear": "θɜːmənjuːkliə",
    "thermoplastic": "θɜːməplɑːstɪk",
    "thermoses": "θɜːməsɪz",
    "thermosetting": "θɜːməʊsətɪŋ",
    "thermosphere": "θɜːməsfiə",
    "thermostatic": "θɜːməʊstætɪk",
    "thermostats": "θɜːməʊstæts",
    "thermostat": "θɜːməʊstæt",
    "thermos": "θɜːməs",
    "therm": "θɜːm",
    "theropod": "θɛrəpɒd",
    "thesaurus": "θɛsɔːrəs",
    "these": "ðiːz",
    "theses": "θəsiːz",
    "thesis": "θiːsɪs",
    "thespians": "θɛspiənz",
    "thespian": "θɛspiən",
    "thetas": "θiːtəz",
    "theta": "θiːtɐ",
    "thetic": "θɛtɪk",
    "thews": "θjuːz",
    "they": "ðeɪ",
    "thiamine": "θaɪəmaɪn",
    "thickened": "θɪkənd",
    "thickeners": "θɪkənəz",
    "thickener": "θɪkənɐ",
    "thickenings": "θɪkənɪŋz",
    "thickening": "θɪkənɪŋ",
    "thickens": "θɪkənz",
    "thicken": "θɪkən",
    "thicker": "θɪkɐ",
    "thickest": "θɪkəst",
    "thickets": "θɪkɪts",
    "thicket": "θɪkɪt",
    "thickhead": "θɪkhɛd",
    "thickish": "θɪkɪʃ",
    "thickly": "θɪkli",
    "thicknesses": "θɪknəsɪz",
    "thickness": "θɪknəs",
    "thickos": "θɪkəʊz",
    "thicko": "θɪkəʊ",
    "thickset": "θɪksɛt",
    "thick": "θɪk",
    "thief": "θiːf",
    "thieved": "θiːvd",
    "thievery": "θiːvəri",
    "thieves": "θiːvz",
    "thieve": "θiːv",
    "thieving": "θiːvɪŋ",
    "thighbone": "θaɪbəʊn",
    "thighs": "θaɪz",
    "thigh": "θaɪ",
    "thimbleful": "θɪmbəlfəl",
    "thimbles": "θɪmbəlz",
    "thimble": "θɪmbəl",
    "thine": "ðaɪn",
    "thingamabobs": "θɪŋɡɐmæbɒbz",
    "thingamabob": "θɪŋɡɐmæbɒb",
    "thingamajigs": "θɪŋɡɐmædʒɪɡz",
    "thingamajig": "θɪŋɡɐmædʒɪɡ",
    "thingies": "θɪŋɪz",
    "things": "θɪŋz",
    "thingumabob": "θɪŋɡjuːmæbɒb",
    "thingumajig": "θɪŋəmədʒɪɡ",
    "thingummies": "θɪŋɡəmɪz",
    "thingummy": "θɪŋɡəmi",
    "thingy": "θɪŋi",
    "thing": "θɪŋ",
    "thinkable": "θɪŋkəbəl",
    "thinkers": "θɪŋkəz",
    "thinker": "θɪŋkɐ",
    "thinking": "θɪŋkɪŋ",
    "thinks": "θɪŋks",
    "think": "θɪŋk",
    "thinly": "θɪnli",
    "thinned": "θɪnd",
    "thinners": "θɪnəz",
    "thinner": "θɪnɐ",
    "thinness": "θɪnnəs",
    "thinnest": "θɪnəst",
    "thinning": "θɪnɪŋ",
    "thinnish": "θɪnɪʃ",
    "thins": "θɪnz",
    "thin": "θɪn",
    "thirdly": "θɜːdli",
    "thirds": "θɜːdz",
    "third": "θɜːd",
    "thirsted": "θɜːstɪd",
    "thirstier": "θɜːstɪɐ",
    "thirsting": "θɜːstɪŋ",
    "thirsts": "θɜːsts",
    "thirsty": "θɜːsti",
    "thirst": "θɜːst",
    "thirteenth": "θɜːtiːnθ",
    "thirteen": "θɜːtiːn",
    "thirties": "θɜːtɪz",
    "thirtieth": "θɜːtiəθ",
    "thirty": "θɜːti",
    "this": "ðɪs",
    "thistledown": "θɪsəldaʊn",
    "thistles": "θɪsəlz",
    "thistle": "θɪsəl",
    "thistly": "θɪstli",
    "thither": "ðɪðɐ",
    "tho": "ðəʊ",
    "thole": "thəʊl",
    "thongs": "θɒŋz",
    "thong": "θɒŋ",
    "thoracic": "θɔːræsɪk",
    "thoracotomy": "θɔːrɐkɒtəmi",
    "thorax": "θɔːræks",
    "thorium": "θɔːriəm",
    "thornier": "θɔːnɪɐ",
    "thorniest": "θɔːnɪəst",
    "thorns": "θɔːnz",
    "thorny": "θɔːni",
    "thorn": "θɔːn",
    "thoroughbreds": "θʌrəbrɛdz",
    "thoroughbred": "θʌrəbrɛd",
    "thoroughfares": "θʌrəfeəz",
    "thoroughfare": "θʌrəfeə",
    "thoroughgoing": "θʌrəɡəʊɪŋ",
    "thoroughly": "θʌrəli",
    "thoroughness": "θʌrənəs",
    "thorough": "θʌrɐ",
    "thorp": "θɔːp",
    "those": "ðəʊz",
    "though": "ðəʊ",
    "thoughtfully": "θɔːtfəli",
    "thoughtfulness": "θɔːtfəlnəs",
    "thoughtful": "θɔːtfəl",
    "thoughtlessly": "θɔːtləsli",
    "thoughtlessness": "θɔːtləsnəs",
    "thoughtless": "θɔːtləs",
    "thoughts": "θɔːts",
    "thought": "θɔːt",
    "thousands": "θaʊzəndz",
    "thousandths": "θaʊzəndθs",
    "thousandth": "θaʊzəndθ",
    "thousand": "θaʊzənd",
    "thous": "ðaʊz",
    "thralls": "θrɔːlz",
    "thrall": "θrɔːl",
    "thrashed": "θræʃt",
    "thrashers": "θræʃəz",
    "thrasher": "θræʃɐ",
    "thrashes": "θræʃɪz",
    "thrashing": "θræʃɪŋ",
    "thrash": "θræʃ",
    "thrawn": "θrɔːn",
    "threadbare": "θrɛdbeə",
    "threaded": "θrɛdɪd",
    "threader": "θrɛdɐ",
    "threading": "θrɛdɪŋ",
    "threadlike": "θrɛdlaɪk",
    "threads": "θrɛdz",
    "thready": "θrɛdi",
    "thread": "θrɛd",
    "threatened": "θrɛtənd",
    "threateningly": "θrɛtənɪŋli",
    "threatening": "θrɛtənɪŋ",
    "threatens": "θrɛtənz",
    "threaten": "θrɛtən",
    "threats": "θrɛts",
    "threat": "θrɛt",
    "threefold": "θriːfəʊld",
    "threepence": "θriːpəns",
    "threepenny": "θriːpəni",
    "threescore": "θriːskɔː",
    "threesomes": "θriːsʌmz",
    "threesome": "θriːsʌm",
    "threes": "θriːz",
    "three": "θriː",
    "threnody": "θrɛnədi",
    "threshed": "θrɛʃt",
    "threshers": "θrɛʃəz",
    "thresher": "θrɛʃɐ",
    "threshing": "θrɛʃɪŋ",
    "thresholds": "θrɛʃəʊldz",
    "threshold": "θrɛʃəʊld",
    "thresh": "θrɛʃ",
    "threw": "θruː",
    "thrice": "θraɪs",
    "thriftily": "θrɪftɪli",
    "thriftiness": "θrɪftɪnəs",
    "thrifts": "θrɪfts",
    "thrifty": "θrɪfti",
    "thrift": "θrɪft",
    "thrilled": "θrɪld",
    "thrillers": "θrɪləz",
    "thriller": "θrɪlɐ",
    "thrillingly": "θrɪlɪŋli",
    "thrilling": "θrɪlɪŋ",
    "thrills": "θrɪlz",
    "thrill": "θrɪl",
    "thrived": "θraɪvd",
    "thrives": "θraɪvz",
    "thrive": "θraɪv",
    "thriving": "θraɪvɪŋ",
    "throated": "θrəʊtɪd",
    "throats": "θrəʊts",
    "throaty": "θrəʊti",
    "throat": "θrəʊt",
    "throbbed": "θrɒbd",
    "throbbing": "θrɒbɪŋ",
    "throbs": "θrɒbz",
    "throb": "θrɒb",
    "throes": "θrəʊz",
    "throe": "θrəʊ",
    "thromboembolism": "θrɒmbəʊmbəʊlɪzəm",
    "thrombosis": "θrəmbəʊsɪs",
    "thrombus": "θrɒmbəs",
    "throned": "θrəʊnd",
    "thrones": "θrəʊnz",
    "throne": "θrəʊn",
    "thronged": "θrɒŋd",
    "thronging": "θrɒŋɪŋ",
    "throngs": "θrɒŋz",
    "throng": "θrɒŋ",
    "throttled": "θrɒtəld",
    "throttles": "θrɒtəlz",
    "throttle": "θrɒtəl",
    "throttling": "θrɒtlɪŋ",
    "throughout": "θruːaʊt",
    "throughput": "θruːpʊt",
    "throughway": "θruːweɪ",
    "through": "θruː",
    "throwaway": "θrəʊəweɪ",
    "throwbacks": "θrəʊbæks",
    "throwback": "θrəʊbæk",
    "throwers": "θrəʊəz",
    "thrower": "θrəʊɐ",
    "throwing": "θrəʊɪŋ",
    "thrown": "θrəʊn",
    "throws": "θrəʊz",
    "throw": "θrəʊ",
    "thrumming": "θrʌmɪŋ",
    "thrums": "θrʌmz",
    "thrum": "θrʌm",
    "thrushes": "θrʌʃɪz",
    "thrush": "θrʌʃ",
    "thrusters": "θrʌstəz",
    "thruster": "θrʌstɐ",
    "thrusting": "θrʌstɪŋ",
    "thrusts": "θrʌsts",
    "thrust": "θrʌst",
    "thru": "θruː",
    "thudded": "θʌdɪd",
    "thudding": "θʌdɪŋ",
    "thuds": "θʌdz",
    "thud": "θʌd",
    "thuggee": "θʌɡiː",
    "thuggery": "θʌɡəri",
    "thuggish": "θʌɡɪʃ",
    "thugs": "θʌɡz",
    "thug": "θʌɡ",
    "thuja": "θjuːdʒɐ",
    "thulium": "θjuːliəm",
    "thumbed": "θʌmd",
    "thumbing": "θʌmɪŋ",
    "thumbnails": "θʌmbneɪlz",
    "thumbnail": "θʌmbneɪl",
    "thumbprints": "θʌmbprɪnts",
    "thumbprint": "θʌmbprɪnt",
    "thumbscrews": "θʌmbskruːz",
    "thumbscrew": "θʌmbskruː",
    "thumbs": "θʌmz",
    "thumbtack": "θʌmbtæk",
    "thumb": "θʌm",
    "thumped": "θʌmpt",
    "thumping": "θʌmpɪŋ",
    "thumps": "θʌmps",
    "thump": "θʌmp",
    "thunderbolts": "θʌndəbəʊlts",
    "thunderbolt": "θʌndəbəʊlt",
    "thunderclaps": "θʌndəklæps",
    "thunderclap": "θʌndəklæp",
    "thunderclouds": "θʌndəklaʊdz",
    "thundercloud": "θʌndəklaʊd",
    "thundered": "θʌndəd",
    "thunderer": "θʌndərɐ",
    "thunderheads": "θʌndəhɛdz",
    "thunderhead": "θʌndəhɛd",
    "thundering": "θʌndərɪŋ",
    "thunderous": "θʌndərəs",
    "thundershower": "θʌndəʃəʊɐ",
    "thunderstorms": "θʌndəstɔːmz",
    "thunderstorm": "θʌndəstɔːm",
    "thunderstruck": "θʌndəstrʌk",
    "thunders": "θʌndəz",
    "thundery": "θʌndəri",
    "thunder": "θʌndɐ",
    "thurible": "θjɔːrəbəl",
    "thurifer": "θjʊrɪfɐ",
    "thus": "ðʌs",
    "thusly": "ðʌsli",
    "thwacked": "θwækt",
    "thwacker": "θwækɐ",
    "thwacking": "θwækɪŋ",
    "thwacks": "θwæks",
    "thwack": "θwæk",
    "thwarted": "θwɔːtɪd",
    "thwarting": "θwɔːtɪŋ",
    "thwarts": "θwɔːts",
    "thwart": "θwɔːt",
    "thy": "ðaɪ",
    "thylacine": "θaɪlɐsiːn",
    "thyme": "taɪm",
    "thymine": "θaɪmaɪn",
    "thymus": "θaɪməs",
    "thyroids": "θaɪrɔɪdz",
    "thyroid": "θaɪrɔɪd",
    "thyroxine": "θaɪrəksaɪn",
    "thyroxin": "θaɪrəksɪn",
    "thyself": "θaɪsɛlf",
    "tiaras": "tɪɑːrəz",
    "tiara": "tɪɑːrɐ",
    "tibial": "tɪbɪəl",
    "tibia": "tɪbiɐ",
    "tical": "tɪkəl",
    "ticked": "tɪkt",
    "tickers": "tɪkəz",
    "ticker": "tɪkɐ",
    "ticketed": "tɪkɪtɪd",
    "ticketing": "tɪkɪtɪŋ",
    "tickets": "tɪkɪts",
    "ticket": "tɪkɪt",
    "ticking": "tɪkɪŋ",
    "tickled": "tɪkəld",
    "ticklers": "tɪkləz",
    "tickler": "tɪklɐ",
    "tickles": "tɪkəlz",
    "tickle": "tɪkəl",
    "tickling": "tɪklɪŋ",
    "ticklish": "tɪklɪʃ",
    "tickly": "tɪkli",
    "ticks": "tɪks",
    "ticktack": "tɪktæk",
    "tick": "tɪk",
    "ticktock": "tɪktɒk",
    "tics": "tɪks",
    "tic": "tɪk",
    "tidal": "taɪdəl",
    "tiddlers": "tɪdləz",
    "tiddler": "tɪdlɐ",
    "tiddly": "tɪdli",
    "tiddlywinks": "tɪdlɪwɪŋks",
    "tiddlywink": "tɪdlɪwɪŋk",
    "tided": "taɪdɪd",
    "tideless": "taɪdləs",
    "tidemark": "taɪdmɑːk",
    "tides": "taɪdz",
    "tide": "taɪd",
    "tideway": "taɪdweɪ",
    "tidied": "taɪdid",
    "tidier": "taɪdiɐ",
    "tidies": "taɪdiz",
    "tidiest": "taɪdiəst",
    "tidily": "taɪdili",
    "tidiness": "taɪdinəs",
    "tidings": "taɪdɪŋz",
    "tiding": "taɪdɪŋ",
    "tidying": "taɪdiɪŋ",
    "tidy": "taɪdi",
    "tiebreaker": "taɪbreɪkɐ",
    "tiebreak": "taɪbreɪk",
    "tied": "taɪd",
    "tieing": "taɪɪŋ",
    "tiepins": "taɪpɪnz",
    "tiepin": "taɪpɪn",
    "tiered": "tiəd",
    "ties": "taɪz",
    "tie": "taɪ",
    "tiffin": "tɪfɪn",
    "tiffs": "tɪfs",
    "tiff": "tɪf",
    "tigerish": "taɪɡərɪʃ",
    "tigers": "taɪɡəz",
    "tiger": "taɪɡɐ",
    "tightened": "taɪtənd",
    "tightener": "taɪtənɐ",
    "tightening": "taɪtənɪŋ",
    "tightens": "taɪtənz",
    "tighten": "taɪtən",
    "tighter": "taɪtɐ",
    "tightest": "taɪtəst",
    "tightly": "taɪtli",
    "tightness": "taɪtnəs",
    "tightrope": "taɪtrəʊp",
    "tights": "taɪts",
    "tight": "taɪt",
    "tightwad": "taɪtwɒd",
    "tigon": "tɪɡɒn",
    "tigresses": "taɪɡrɛsɪz",
    "tigress": "taɪɡrɛs",
    "tiki": "tɪki",
    "tilbury": "tɪlbri",
    "tilde": "tɪldɐ",
    "tiled": "taɪld",
    "tilers": "taɪləz",
    "tiler": "taɪlɐ",
    "tiles": "taɪlz",
    "tile": "taɪl",
    "tiling": "taɪlɪŋ",
    "tillage": "tɪlɪdʒ",
    "tilled": "tɪld",
    "tillers": "tɪləz",
    "tiller": "tɪlɐ",
    "tilling": "tɪlɪŋ",
    "tills": "tɪlz",
    "till": "tɪl",
    "tilted": "tɪltɪd",
    "tilter": "tɪltɐ",
    "tilth": "tɪlθ",
    "tilting": "tɪltɪŋ",
    "til": "tɪl",
    "tilts": "tɪlts",
    "tilt": "tɪlt",
    "timbales": "tɪmbeɪlz",
    "timbale": "tɪmbeɪl",
    "timbered": "tɪmbəd",
    "timbering": "tɪmbərɪŋ",
    "timberland": "tɪmbələnd",
    "timbers": "tɪmbəz",
    "timber": "tɪmbɐ",
    "timberwork": "tɪmbəwɜːk",
    "timbrel": "tɪmbrəl",
    "timbres": "tæmbəz",
    "timbre": "tæmbɐ",
    "timecard": "taɪmkɑːd",
    "timed": "taɪmd",
    "timekeepers": "taɪmkiːpəz",
    "timekeeper": "taɪmkiːpɐ",
    "timekeeping": "taɪmkiːpɪŋ",
    "timelessly": "taɪmləsli",
    "timelessness": "taɪmləsnəs",
    "timeless": "taɪmləs",
    "timeliness": "taɪmlinəs",
    "timeline": "taɪmlaɪn",
    "timely": "taɪmli",
    "timeout": "taɪmaʊt",
    "timepieces": "taɪmpiːsɪz",
    "timepiece": "taɪmpiːs",
    "timers": "taɪməz",
    "timer": "taɪmɐ",
    "timescales": "taɪmskeɪlz",
    "timescale": "taɪmskeɪl",
    "timeshares": "taɪmʃeəz",
    "timeshare": "taɪmʃeə",
    "times": "taɪmz",
    "timetabled": "taɪmteɪbəld",
    "timetables": "taɪmteɪbəlz",
    "timetable": "taɪmteɪbəl",
    "timetabling": "taɪmteɪblɪŋ",
    "time": "taɪm",
    "timeworn": "taɪmwɔːn",
    "timezones": "taɪmzəʊnz",
    "timezone": "taɪmzəʊn",
    "timidity": "tɪmɪdɪti",
    "timidly": "tɪmɪdli",
    "timid": "tɪmɪd",
    "timings": "taɪmɪŋz",
    "timing": "taɪmɪŋ",
    "timorous": "tɪmərəs",
    "timothy": "tɪməθi",
    "timpanist": "tɪmpɐnɪst",
    "timpani": "tɪmpɑːni",
    "tinctures": "tɪŋktʃəz",
    "tincture": "tɪŋktʃɐ",
    "tinderbox": "tɪndəbɒks",
    "tinder": "tɪndɐ",
    "tinea": "tɪniə",
    "tined": "taɪnd",
    "tines": "taɪnz",
    "tine": "taɪn",
    "tinfoil": "tɪnfɔɪl",
    "tinges": "tɪndʒɪz",
    "tinge": "tɪndʒ",
    "tingled": "tɪŋɡəld",
    "tingles": "tɪŋɡəlz",
    "tingle": "tɪŋɡəl",
    "tinglier": "tɪŋɡliɐ",
    "tingling": "tɪŋɡəlɪŋ",
    "tingly": "tɪŋli",
    "tings": "tɪŋz",
    "ting": "tɪŋ",
    "tinier": "taɪniɐ",
    "tiniest": "taɪniəst",
    "tinkered": "tɪŋkəd",
    "tinkerers": "tɪŋkərəz",
    "tinkerer": "tɪŋkərɐ",
    "tinkering": "tɪŋkərɪŋ",
    "tinkers": "tɪŋkəz",
    "tinker": "tɪŋkɐ",
    "tinkled": "tɪŋkəld",
    "tinkles": "tɪŋkəlz",
    "tinkle": "tɪŋkəl",
    "tinkling": "tɪŋklɪŋ",
    "tinkly": "tɪŋkli",
    "tinned": "tɪnd",
    "tinner": "tɪnɐ",
    "tinniest": "tɪnɪəst",
    "tinniness": "tɪnɪnəs",
    "tinning": "tɪnɪŋ",
    "tinnitus": "tɪnɪtəs",
    "tinny": "tɪni",
    "tinplate": "tɪnpleɪt",
    "tinpot": "tɪnpɒt",
    "tinselled": "tɪnsəld",
    "tinselling": "tɪnsəlɪŋ",
    "tinsel": "tɪnsəl",
    "tinsmith": "tɪnsmɪθ",
    "tins": "tɪnz",
    "tinted": "tɪntɪd",
    "tinter": "tɪntɐ",
    "tinting": "tɪntɪŋ",
    "tintinnabulation": "tɪntɪnæbjʊleɪʃən",
    "tin": "tɪn",
    "tints": "tɪnts",
    "tint": "tɪnt",
    "tintype": "tɪntaɪp",
    "tinware": "tɪnweə",
    "tinworks": "tɪnwɜːks",
    "tiny": "taɪni",
    "tipis": "tɪpiz",
    "tipi": "tɪpi",
    "tipped": "tɪpt",
    "tippers": "tɪpəz",
    "tipper": "tɪpɐ",
    "tippet": "tɪpɪt",
    "tippexed": "tɪpɛkst",
    "tippex": "tɪpɛks",
    "tipping": "tɪpɪŋ",
    "tippled": "tɪpəld",
    "tippler": "tɪplɐ",
    "tipples": "tɪpəlz",
    "tipple": "tɪpəl",
    "tipstaff": "tɪpstɑːf",
    "tipsters": "tɪpstəz",
    "tipster": "tɪpstɐ",
    "tips": "tɪps",
    "tipsy": "tɪpsi",
    "tiptoed": "tɪptəʊd",
    "tiptoeing": "tɪptəʊɪŋ",
    "tiptoes": "tɪptəʊz",
    "tiptoe": "tɪptəʊ",
    "tiptop": "tɪptɒp",
    "tip": "tɪp",
    "tirades": "taɪreɪdz",
    "tirade": "taɪreɪd",
    "tiramisu": "tɪræmɪsuː",
    "tireder": "taɪədɐ",
    "tiredness": "taɪədnəs",
    "tired": "taɪəd",
    "tirelessly": "taɪələsli",
    "tireless": "taɪələs",
    "tiresome": "taɪəsʌm",
    "tires": "taɪəz",
    "tire": "taɪə",
    "tiring": "taɪərɪŋ",
    "tiro": "taɪrəʊ",
    "tisane": "tɪseɪn",
    "tissues": "tɪʃuːz",
    "tissue": "tɪʃuː",
    "ti": "taɪ",
    "titania": "tɪtɑːniə",
    "titanic": "taɪtænɪk",
    "titanium": "taɪteɪniəm",
    "titans": "taɪtənz",
    "titan": "taɪtən",
    "titbits": "tɪtbɪts",
    "titbit": "tɪtbɪt",
    "titch": "tɪtʃ",
    "titchy": "tɪtʃi",
    "titfer": "tɪtfɐ",
    "tithes": "taɪðz",
    "tithe": "taɪð",
    "tithing": "taɪðɪŋ",
    "titian": "tɪʃən",
    "titillated": "tɪtɪleɪtɪd",
    "titillate": "tɪtɪleɪt",
    "titillating": "tɪtɪleɪtɪŋ",
    "titillation": "tɪtɪleɪʃən",
    "titi": "tiːti",
    "titivated": "tɪtɪveɪtɪd",
    "titivate": "tɪtɪveɪt",
    "titivating": "tɪtɪveɪtɪŋ",
    "titivation": "tɪtɪveɪʃən",
    "titled": "taɪtəld",
    "titles": "taɪtəlz",
    "title": "taɪtəl",
    "titling": "taɪtlɪŋ",
    "titmouse": "tɪtmaʊs",
    "titrated": "tɪtreɪtɪd",
    "titrate": "tɪtreɪt",
    "titres": "tɪtəz",
    "titre": "tɪtɐ",
    "tits": "tɪts",
    "tittered": "tɪtəd",
    "tittering": "tɪtərɪŋ",
    "titters": "tɪtəz",
    "titter": "tɪtɐ",
    "titties": "tɪtɪz",
    "tittle": "tɪtəl",
    "tit": "tɪt",
    "titty": "tɪti",
    "titular": "tɪtjʊlɐ",
    "tizz": "tɪz",
    "tizzy": "tɪzi",
    "toadfish": "təʊdfɪʃ",
    "toadflax": "təʊdflæks",
    "toadies": "təʊdɪz",
    "toads": "təʊdz",
    "toadstools": "təʊdstuːlz",
    "toadstool": "təʊdstuːl",
    "toad": "təʊd",
    "toadying": "təʊdɪɪŋ",
    "toady": "təʊdi",
    "toasted": "təʊstɪd",
    "toasters": "təʊstəz",
    "toaster": "təʊstɐ",
    "toasties": "təʊstɪz",
    "toasting": "təʊstɪŋ",
    "toastmasters": "təʊstmɑːstəz",
    "toastmaster": "təʊstmɑːstɐ",
    "toasts": "təʊsts",
    "toast": "təʊst",
    "toasty": "təʊsti",
    "tobacconists": "təbækənɪsts",
    "tobacconist": "təbækənɪst",
    "tobaccos": "təbækəʊz",
    "tobacco": "təbækəʊ",
    "tobogganing": "təbɒɡənɪŋ",
    "tobogganist": "tɒbəɡænɪst",
    "toboggans": "təbɒɡənz",
    "toboggan": "təbɒɡən",
    "toccata": "təkɑːtɐ",
    "today": "tədeɪ",
    "toddies": "tɒdɪz",
    "toddled": "tɒdəld",
    "toddlers": "tɒdləz",
    "toddler": "tɒdlɐ",
    "toddles": "tɒdəlz",
    "toddle": "tɒdəl",
    "toddling": "tɒdlɪŋ",
    "toddy": "tɒdi",
    "tod": "tɒd",
    "toecaps": "təʊkæps",
    "toecap": "təʊkæp",
    "toed": "təʊd",
    "toehold": "təʊhəʊld",
    "toeing": "təʊɪŋ",
    "toenails": "təʊneɪlz",
    "toenail": "təʊneɪl",
    "toerags": "təʊəræɡz",
    "toerag": "təʊəræɡ",
    "toes": "təʊz",
    "toe": "təʊ",
    "toffees": "tɒfiːz",
    "toffee": "tɒfiː",
    "toffs": "tɒfs",
    "toff": "tɒf",
    "toft": "tɒft",
    "tofu": "təʊfuː",
    "togas": "təʊɡəz",
    "toga": "təʊɡɐ",
    "togetherness": "təɡɛðənəs",
    "together": "təɡɛðɐ",
    "togged": "tɒɡd",
    "toggles": "tɒɡəlz",
    "toggle": "tɒɡəl",
    "toggling": "tɒɡlɪŋ",
    "togs": "tɒɡz",
    "tog": "tɒɡ",
    "toiled": "tɔɪld",
    "toilers": "tɔɪləz",
    "toiler": "tɔɪlɐ",
    "toileted": "tɔɪliːtɪd",
    "toileting": "tɔɪliːtɪŋ",
    "toile": "tɔɪl",
    "toiletries": "tɔɪlɪtrɪz",
    "toiletry": "tɔɪlɪtri",
    "toilets": "tɔɪləts",
    "toilette": "tɔɪlɛt",
    "toilet": "tɔɪlət",
    "toiling": "tɔɪlɪŋ",
    "toils": "tɔɪlz",
    "toil": "tɔɪl",
    "tokay": "tɒkeɪ",
    "tokenism": "təʊkiːnɪzəm",
    "tokens": "təʊkənz",
    "token": "təʊkən",
    "toke": "təʊk",
    "toking": "təʊkɪŋ",
    "tolar": "təʊlɐ",
    "tola": "təʊlɐ",
    "tolbooth": "tɒlbuːθ",
    "told": "təʊld",
    "tolerable": "tɒlərəbəl",
    "tolerably": "tɒlərəbli",
    "tolerances": "tɒlərənsɪz",
    "tolerance": "tɒlərəns",
    "tolerant": "tɒlərənt",
    "tolerated": "tɒləreɪtɪd",
    "tolerates": "tɒləreɪts",
    "tolerate": "tɒləreɪt",
    "tolerating": "tɒləreɪtɪŋ",
    "toleration": "tɒləreɪʃən",
    "tole": "təʊl",
    "tollbooth": "təʊlbuːθ",
    "tolled": "təʊld",
    "tollgate": "təʊlɡeɪt",
    "tolling": "təʊlɪŋ",
    "tolls": "təʊlz",
    "toll": "təʊl",
    "tolly": "təʊli",
    "toluene": "tɒljuːiːn",
    "tomahawks": "tɒmɐhɔːks",
    "tomahawk": "tɒmɐhɔːk",
    "tomatoes": "təmɑːtəʊz",
    "tomato": "təmɑːtəʊ",
    "tombola": "təmbəʊlɐ",
    "tomboyish": "tɒmbɔɪɪʃ",
    "tomboys": "tɒmbɔɪz",
    "tomboy": "tɒmbɔɪ",
    "tombstones": "tuːmstəʊnz",
    "tombstone": "tuːmstəʊn",
    "tombs": "tuːmz",
    "tomb": "tuːm",
    "tomcats": "tɒmkæts",
    "tomcat": "tɒmkæt",
    "tomes": "təʊmz",
    "tome": "təʊm",
    "tomfoolery": "tɒmfuːləri",
    "tommyrot": "tɒmɪrɒt",
    "tomography": "təmɒɡrəfi",
    "tomorrows": "təmɒrəʊz",
    "tomorrow": "təmɒrəʊ",
    "tompion": "tɒmpiən",
    "toms": "tɒmz",
    "tom": "tɒm",
    "tonalities": "təʊnælɪtiz",
    "tonality": "təʊnælɪti",
    "tonally": "təʊnəli",
    "tonal": "təʊnəl",
    "toned": "təʊnd",
    "toneless": "təʊnləs",
    "toners": "təʊnəz",
    "toner": "təʊnɐ",
    "tones": "təʊnz",
    "tone": "təʊn",
    "tonga": "tɒŋɡɐ",
    "tonged": "tɒŋd",
    "tongs": "tɒŋz",
    "tong": "tɒŋ",
    "tongued": "tʌŋd",
    "tongues": "tʌŋz",
    "tongue": "tʌŋ",
    "tonguing": "tʌŋɪŋ",
    "tonics": "tɒnɪks",
    "tonic": "tɒnɪk",
    "tonight": "tənaɪt",
    "toning": "təʊnɪŋ",
    "tonnages": "tʌnɪdʒɪz",
    "tonnage": "tʌnɪdʒ",
    "tonnes": "tʌnz",
    "tonne": "tʌn",
    "tonsillar": "tɒnsɪlɐ",
    "tonsillectomy": "tɒnsɪlɛktəmi",
    "tonsillitis": "tɒnsɪlaɪtɪs",
    "tonsils": "tɒnsəlz",
    "tonsil": "tɒnsəl",
    "tons": "tʌnz",
    "tonsure": "tɒnʒɐ",
    "tontine": "tɒntiːn",
    "ton": "tʌn",
    "tony": "təʊni",
    "took": "tʊk",
    "toolbar": "tuːlbɑː",
    "toolboxes": "tuːlbɒksɪz",
    "toolbox": "tuːlbɒks",
    "tooled": "tuːld",
    "tooling": "tuːlɪŋ",
    "toolkit": "tuːlkɪt",
    "toolmakers": "tuːlmeɪkəz",
    "toolmaker": "tuːlmeɪkɐ",
    "tools": "tuːlz",
    "tool": "tuːl",
    "tooted": "tuːtɪd",
    "tooter": "tuːtɐ",
    "toothache": "tuːθeɪk",
    "toothbrushes": "tuːθbrʌʃɪz",
    "toothbrush": "tuːθbrʌʃ",
    "toothed": "tuːθd",
    "toothless": "tuːθləs",
    "toothpastes": "tuːθpeɪsts",
    "toothpaste": "tuːθpeɪst",
    "toothpicks": "tuːθpɪks",
    "toothpick": "tuːθpɪk",
    "toothsome": "tuːθsʌm",
    "tooth": "tuːθ",
    "toothy": "tuːθi",
    "tooting": "tuːtɪŋ",
    "tootled": "tuːtəld",
    "tootles": "tuːtəlz",
    "tootle": "tuːtəl",
    "tootling": "tuːtlɪŋ",
    "tootsies": "tuːtsɪz",
    "tootsie": "tuːtsi",
    "toot": "tuːt",
    "too": "tuː",
    "topaz": "tɒpæz",
    "topcoat": "tɒpkəʊt",
    "toped": "təʊpt",
    "toper": "təʊpɐ",
    "tope": "təʊp",
    "topiary": "təʊpjəri",
    "topicality": "tɒpɪkælɪti",
    "topically": "tɒpɪkli",
    "topical": "tɒpɪkəl",
    "topics": "tɒpɪks",
    "topic": "tɒpɪk",
    "toping": "təʊpɪŋ",
    "topi": "təʊpi",
    "topknot": "tɒpknɒt",
    "topless": "tɒpləs",
    "topmost": "tɒpməʊst",
    "topnotch": "tɒpnɒtʃ",
    "topographers": "təpɒɡrəfəz",
    "topographically": "tɒpəɡræfɪkli",
    "topographical": "tɒpəɡræfɪkəl",
    "topographic": "tɒpəɡræfɪk",
    "topography": "təpɒɡrəfi",
    "topological": "tɒpəlɒdʒɪkəl",
    "topology": "təpɒlədʒi",
    "topped": "tɒpt",
    "toppers": "tɒpəz",
    "topper": "tɒpɐ",
    "toppings": "tɒpɪŋz",
    "topping": "tɒpɪŋ",
    "toppled": "tɒpəld",
    "topples": "tɒpəlz",
    "topple": "tɒpəl",
    "toppling": "tɒplɪŋ",
    "topsails": "tɒpseɪlz",
    "topsail": "tɒpseɪl",
    "topsides": "tɒpsaɪdz",
    "topside": "tɒpsaɪd",
    "topsoil": "tɒpsɔɪl",
    "topspin": "tɒpspɪn",
    "tops": "tɒps",
    "top": "tɒp",
    "toque": "təʊk",
    "torah": "tɔːrɐ",
    "tora": "tɔːrɐ",
    "torchbearers": "tɔːtʃbeərəz",
    "torchbearer": "tɔːtʃbeərɐ",
    "torched": "tɔːtʃt",
    "torches": "tɔːtʃɪz",
    "torching": "tɔːtʃɪŋ",
    "torchlight": "tɔːtʃlaɪt",
    "torchlit": "tɔːtʃlɪt",
    "torch": "tɔːtʃ",
    "torchwood": "tɔːtʃwʊd",
    "toreadors": "tɔːriːdɔːz",
    "toreador": "tɔːriːdɔː",
    "toreros": "tɔːrəʊz",
    "torero": "tɔːrəʊ",
    "tore": "tɔː",
    "tori": "tɔːri",
    "tormented": "tɔːmɛntɪd",
    "tormenters": "tɔːmɛntəz",
    "tormentil": "tɔːmɛntəl",
    "tormenting": "tɔːmɛntɪŋ",
    "tormentors": "tɔːmɛntɔːz",
    "tormentor": "tɔːmɛntɔː",
    "tornadoes": "tɔːneɪdəʊz",
    "tornados": "tɔːneɪdəʊz",
    "tornado": "tɔːneɪdəʊ",
    "torn": "tɔːn",
    "torpedoed": "tɔːpiːdəʊd",
    "torpedoes": "tɔːpiːdəʊz",
    "torpedoing": "tɔːpiːdəʊɪŋ",
    "torpedos": "tɔːpiːdəʊz",
    "torpedo": "tɔːpiːdəʊ",
    "torpid": "tɔːpɪd",
    "torpor": "tɔːpɐ",
    "torque": "tɔːk",
    "torquing": "tɔːkɪŋ",
    "torrential": "tərɛnʃəl",
    "torrents": "tɒrənts",
    "torrent": "tɒrənt",
    "torrid": "tɒrɪd",
    "torr": "tɔː",
    "torsion": "tɔːʃən",
    "torsos": "tɔːsəʊz",
    "torso": "tɔːsəʊ",
    "tors": "tɔːz",
    "tortellini": "tɔːtɪliːni",
    "tortes": "tɔːts",
    "torte": "tɔːt",
    "tortillas": "tɔːtiːɐz",
    "tortilla": "tɔːtiːɐ",
    "tortious": "tɔːʃəs",
    "tor": "tɔː",
    "tortoiseshells": "tɔːtəsʃɛlz",
    "tortoiseshell": "tɔːtəsʃɛl",
    "tortoises": "tɔːtəsɪz",
    "tortoise": "tɔːtəs",
    "torts": "tɔːts",
    "tort": "tɔːt",
    "tortuously": "tɔːtʃuːəsli",
    "tortuous": "tɔːtʃuːəs",
    "tortured": "tɔːtʃəd",
    "torturers": "tɔːtʃərəz",
    "torturer": "tɔːtʃərɐ",
    "tortures": "tɔːtʃəz",
    "torture": "tɔːtʃɐ",
    "torturing": "tɔːtʃərɪŋ",
    "torturous": "tɔːtʃərəs",
    "torus": "tɔːrəs",
    "tosh": "tɒʃ",
    "tossed": "tɒst",
    "tossers": "tɒsəz",
    "tosser": "tɒsɐ",
    "tosses": "tɒsɪz",
    "tossing": "tɒsɪŋ",
    "tosspot": "tɒspɒt",
    "toss": "tɒs",
    "tost": "tɒst",
    "totaliser": "təʊtəlaɪzɐ",
    "totalitarianism": "təʊtælɪteəriənɪzəm",
    "totalitarian": "təʊtælɪteəriən",
    "totality": "təʊtælɪti",
    "totalled": "təʊtəld",
    "totalling": "təʊtəlɪŋ",
    "totally": "təʊtəli",
    "totals": "təʊtəlz",
    "total": "təʊtəl",
    "toted": "təʊtɪd",
    "totemic": "tɒtɛmɪk",
    "totems": "təʊtəmz",
    "totem": "təʊtəm",
    "totes": "təʊts",
    "tote": "təʊt",
    "toting": "təʊtɪŋ",
    "tots": "tɒts",
    "totted": "tɒtɪd",
    "tottered": "tɒtəd",
    "tottering": "tɒtərɪŋ",
    "totters": "tɒtəz",
    "totter": "tɒtɐ",
    "tottery": "tɒtəri",
    "totting": "tɒtɪŋ",
    "tot": "tɒt",
    "to": "tuː",
    "toucans": "tuːkənz",
    "toucan": "tuːkən",
    "touchable": "tʌtʃəbəl",
    "touchdowns": "tʌtʃdaʊnz",
    "touchdown": "tʌtʃdaʊn",
    "touched": "tʌtʃt",
    "touches": "tʌtʃɪz",
    "touchier": "tʌtʃɪɐ",
    "touchiness": "tʌtʃɪnəs",
    "touchingly": "tʌtʃɪŋli",
    "touchings": "tʌtʃɪŋz",
    "touching": "tʌtʃɪŋ",
    "touchlines": "tʌtʃlaɪnz",
    "touchline": "tʌtʃlaɪn",
    "touchpaper": "tʌtʃpeɪpɐ",
    "touchscreens": "tʌtʃskriːnz",
    "touchscreen": "tʌtʃskriːn",
    "touchstones": "tʌtʃstəʊnz",
    "touchstone": "tʌtʃstəʊn",
    "touch": "tʌtʃ",
    "touchwood": "tʌtʃwʊd",
    "touchy": "tʌtʃi",
    "toughed": "tʌfd",
    "toughened": "tʌfənd",
    "toughening": "tʌfənɪŋ",
    "toughens": "tʌfənz",
    "toughen": "tʌfən",
    "tougher": "tʌfɐ",
    "toughest": "tʌfəst",
    "toughies": "tʌfɪz",
    "toughie": "tʌfi",
    "toughing": "tʌfɪŋ",
    "toughly": "tʌfli",
    "toughness": "tʌfnəs",
    "toughs": "tʌfz",
    "tough": "tʌf",
    "toupees": "tuːpeɪz",
    "toupee": "tuːpeɪ",
    "toured": "tɔːd",
    "tourers": "tɔːrəz",
    "tourer": "tɔːrɐ",
    "touring": "tɔːrɪŋ",
    "tourism": "tɔːrɪzəm",
    "touristic": "tɔːrɪstɪk",
    "tourists": "tɔːrɪsts",
    "tourist": "tɔːrɪst",
    "touristy": "tɔːrɪsti",
    "tourmaline": "tɔːməlaɪn",
    "tournaments": "tɔːnəmənts",
    "tournament": "tɔːnəmənt",
    "tournedos": "tɔːniːdəʊz",
    "tourney": "tɔːni",
    "tourniquets": "tɔːnɪkeɪs",
    "tourniquet": "tɔːnɪkeɪ",
    "tour": "tɔː",
    "tousled": "taʊsəld",
    "tousle": "taʊsəl",
    "touted": "taʊtɪd",
    "touting": "taʊtɪŋ",
    "touts": "taʊts",
    "tout": "taʊt",
    "towards": "tʊwɔːdz",
    "toward": "tʊwɔːd",
    "towed": "təʊd",
    "towelette": "taʊɪlɛt",
    "towelled": "taʊəld",
    "towelling": "taʊəlɪŋ",
    "towels": "taʊəlz",
    "towel": "taʊəl",
    "towered": "taʊəd",
    "towering": "taʊərɪŋ",
    "towing": "təʊɪŋ",
    "towline": "təʊlaɪn",
    "townhouses": "taʊnhaʊzɪz",
    "townhouse": "taʊnhaʊs",
    "townies": "taʊnɪz",
    "townie": "taʊni",
    "townscape": "taʊnskeɪp",
    "townsfolk": "taʊnsfəʊk",
    "townships": "taʊnʃɪps",
    "township": "taʊnʃɪp",
    "townsman": "taʊnzmən",
    "townsmen": "taʊnzmɛn",
    "townspeople": "taʊnspiːpəl",
    "towns": "taʊnz",
    "townswomen": "taʊnswɪmɪn",
    "town": "taʊn",
    "towny": "taʊni",
    "towpaths": "təʊpɑːθs",
    "towpath": "təʊpɑːθ",
    "towrope": "təʊrəʊp",
    "tows": "təʊz",
    "tow": "təʊ",
    "toxaemia": "tɒksiːmiə",
    "toxically": "tɒksɪkli",
    "toxicity": "tɒksɪsɪti",
    "toxicologists": "tɒksɪkɒlədʒɪsts",
    "toxicologist": "tɒksɪkɒlədʒɪst",
    "toxicology": "tɒksɪkɒlədʒi",
    "toxics": "tɒksɪks",
    "toxic": "tɒksɪk",
    "toxins": "tɒksɪnz",
    "toxin": "tɒksɪn",
    "toxoplasmosis": "tɒksəplɐzməʊsɪs",
    "toyboy": "tɔɪbɔɪ",
    "toyed": "tɔɪd",
    "toying": "tɔɪɪŋ",
    "toyshop": "tɔɪʃɒp",
    "toys": "tɔɪz",
    "toy": "tɔɪ",
    "traceability": "treɪsəbɪlɪti",
    "traceable": "treɪsəbəl",
    "traced": "treɪst",
    "tracers": "treɪsəz",
    "tracer": "treɪsɐ",
    "tracery": "treɪsəri",
    "traces": "treɪsɪz",
    "trace": "treɪs",
    "tracheal": "trɐkiːl",
    "trachea": "trɐkiə",
    "tracheostomy": "trɐkɪɒstəmi",
    "tracheotomies": "trɐkɪɒtəmɪz",
    "tracheotomy": "trɐkɪɒtəmi",
    "trachoma": "trækəʊmɐ",
    "tracings": "treɪsɪŋz",
    "tracing": "treɪsɪŋ",
    "trackable": "trækəbəl",
    "tracked": "trækt",
    "trackers": "trækəz",
    "tracker": "trækɐ",
    "tracking": "trækɪŋ",
    "trackless": "trækləs",
    "tracks": "træks",
    "tracksuits": "træksuːts",
    "tracksuit": "træksuːt",
    "track": "træk",
    "trackways": "trækweɪz",
    "trackway": "trækweɪ",
    "tractable": "træktəbəl",
    "traction": "trækʃən",
    "tractive": "træktɪv",
    "tractors": "træktəz",
    "tractor": "træktɐ",
    "tracts": "trækts",
    "tract": "trækt",
    "tradable": "treɪdəbəl",
    "traded": "treɪdɪd",
    "trademarked": "treɪdmɑːkt",
    "trademarks": "treɪdmɑːks",
    "trademark": "treɪdmɑːk",
    "traders": "treɪdəz",
    "trader": "treɪdɐ",
    "tradesman": "treɪdzmən",
    "tradesmen": "treɪdzmɛn",
    "tradespeople": "treɪdspiːpəl",
    "trades": "treɪdz",
    "tradeswomen": "treɪdswɪmɪn",
    "trade": "treɪd",
    "tradings": "treɪdɪŋz",
    "trading": "treɪdɪŋ",
    "traditionalism": "trɐdɪʃənəlɪzəm",
    "traditionalists": "trɐdɪʃənəlɪsts",
    "traditionalist": "trɐdɪʃənəlɪst",
    "traditionally": "trɐdɪʃənəli",
    "traditional": "trɐdɪʃənəl",
    "traditions": "trɐdɪʃənz",
    "tradition": "trɐdɪʃən",
    "trad": "træd",
    "traduced": "trædjuːst",
    "traduce": "trædjuːs",
    "trafficked": "træfɪkt",
    "traffickers": "træfɪkəz",
    "trafficker": "træfɪkɐ",
    "trafficking": "træfɪkɪŋ",
    "traffics": "træfɪks",
    "traffic": "træfɪk",
    "tragedians": "trædʒiːdiənz",
    "tragedies": "trædʒədɪz",
    "tragedy": "trædʒədi",
    "tragically": "trædʒɪkli",
    "tragical": "trædʒɪkəl",
    "tragicomedy": "trædʒɪkɒmədi",
    "tragic": "trædʒɪk",
    "tragopan": "trædʒəpæn",
    "tragus": "trædʒəs",
    "trailblazers": "treɪlbleɪzəz",
    "trailblazer": "treɪlbleɪzɐ",
    "trailblazing": "treɪlbleɪzɪŋ",
    "trailed": "treɪld",
    "trailers": "treɪləz",
    "trailer": "treɪlɐ",
    "trailing": "treɪlɪŋ",
    "trails": "treɪlz",
    "trail": "treɪl",
    "trainable": "treɪnəbəl",
    "trained": "treɪnd",
    "trainees": "treɪniːz",
    "trainee": "treɪniː",
    "trainers": "treɪnəz",
    "trainer": "treɪnɐ",
    "trainings": "treɪnɪŋz",
    "training": "treɪnɪŋ",
    "trainloads": "treɪnləʊdz",
    "trainload": "treɪnləʊd",
    "trainspotters": "treɪnspɒtəz",
    "trainspotter": "treɪnspɒtɐ",
    "trainspotting": "treɪnspɒtɪŋ",
    "trains": "treɪnz",
    "train": "treɪn",
    "traipsed": "treɪpsd",
    "traipses": "treɪpsɪz",
    "traipse": "treɪps",
    "traipsing": "treɪpsɪŋ",
    "traitorous": "treɪtərəs",
    "traitors": "treɪtəz",
    "traitor": "treɪtɐ",
    "traits": "treɪts",
    "trait": "treɪt",
    "trajectories": "trədʒɛktərɪz",
    "trajectory": "trədʒɛktəri",
    "tramcars": "træmkɑːz",
    "tramcar": "træmkɑː",
    "tramlines": "træmlaɪnz",
    "tramline": "træmlaɪn",
    "trammed": "træmd",
    "trammelled": "træməld",
    "trammels": "træməlz",
    "trammel": "træməl",
    "tramped": "træmpt",
    "tramper": "træmpɐ",
    "tramping": "træmpɪŋ",
    "trampled": "trɑːmpəld",
    "tramples": "trɑːmpəlz",
    "trample": "trɑːmpəl",
    "trampling": "trɑːmplɪŋ",
    "trampolines": "træmpəliːnz",
    "trampoline": "træmpəliːn",
    "trampolining": "træmpəliːnɪŋ",
    "trampolinist": "træmpəlɪnɪst",
    "tramps": "træmps",
    "tramp": "træmp",
    "tramroad": "træmrəʊd",
    "trams": "træmz",
    "tram": "træm",
    "tramways": "træmweɪz",
    "tramway": "træmweɪ",
    "trances": "trɑːnsɪz",
    "trance": "trɑːns",
    "tranches": "trɑːntʃɪz",
    "tranche": "trɑːntʃ",
    "tranquility": "trænkwɪlɪti",
    "tranquillised": "trænkwɪlaɪzd",
    "tranquillisers": "trænkwɪlaɪzəz",
    "tranquilliser": "trænkwɪlaɪzɐ",
    "tranquillise": "trænkwɪlaɪz",
    "tranquillising": "trænkwɪlaɪzɪŋ",
    "tranquillity": "trænkwɪlɪti",
    "tranquillizers": "trænkwɪlaɪzəz",
    "tranquillizer": "trænkwɪlaɪzɐ",
    "tranquil": "trænkwɪl",
    "transacted": "trænsæktɪd",
    "transacting": "trænsæktɪŋ",
    "transactional": "trænsækʃənəl",
    "transactions": "trænsækʃənz",
    "transaction": "trænsækʃən",
    "transact": "trænsækt",
    "transatlantic": "trænsɐtlɑːntɪk",
    "transceivers": "trænsiːvəz",
    "transceiver": "trænsiːvɐ",
    "transcended": "trænsɛndɪd",
    "transcendence": "trænsɛndəns",
    "transcendentalism": "trænsɪndɛntəlɪzəm",
    "transcendental": "trænsɪndɛntəl",
    "transcendent": "trænsɛndənt",
    "transcending": "trænsɛndɪŋ",
    "transcends": "trænsɛndz",
    "transcend": "trænsɛnd",
    "transcontinental": "trænskɒntɪnɛntəl",
    "transcribed": "trænskraɪbd",
    "transcribes": "trænskraɪbz",
    "transcribe": "trænskraɪb",
    "transcribing": "trænskraɪbɪŋ",
    "transcriptions": "trænskrɪpʃənz",
    "transcription": "trænskrɪpʃən",
    "transcripts": "trænskrɪpts",
    "transcript": "trænskrɪpt",
    "transdermal": "trænsdɜːməl",
    "transducers": "trænsdjuːsəz",
    "transducer": "trænsdjuːsɐ",
    "transduction": "trænsdʌkʃən",
    "transected": "trænsɛktɪd",
    "transects": "trænsɛkts",
    "transepts": "trænsɛpts",
    "transept": "trænsɛpt",
    "transferability": "trænsfɜːrəbɪlɪti",
    "transferable": "trænsfɜːrəbəl",
    "transferal": "trænsfɜːrəl",
    "transference": "trænsfɜːrəns",
    "transferor": "trænsfɜːrɐ",
    "transferrable": "trænsfɜːrəbəl",
    "transferred": "trænsfɜːd",
    "transferring": "trænsfɜːrɪŋ",
    "transfiguration": "trænsfɪɡjʊreɪʃən",
    "transfigured": "trænsfɪɡəd",
    "transfixed": "trænsfɪkst",
    "transfixing": "trænsfɪksɪŋ",
    "transfix": "trænsfɪks",
    "transformational": "trænsfɔːmeɪʃənəl",
    "transformations": "trænsfɔːmeɪʃənz",
    "transformation": "trænsfɔːmeɪʃən",
    "transformed": "trænsfɔːmd",
    "transformers": "trænsfɔːməz",
    "transformer": "trænsfɔːmɐ",
    "transforming": "trænsfɔːmɪŋ",
    "transforms": "trænsfɔːmz",
    "transfused": "trænsfjuːzd",
    "transfuser": "trænsfjuːsɐ",
    "transfuse": "trænsfjuːz",
    "transfusions": "trænsfjuːʒənz",
    "transfusion": "trænsfjuːʒən",
    "transgendered": "trænsdʒɛndəd",
    "transgender": "trænsdʒɛndɐ",
    "transgenic": "trænsdʒɛnɪk",
    "transgressed": "trænsɡrɛst",
    "transgresses": "trænsɡrɛsɪz",
    "transgressing": "trænsɡrɛsɪŋ",
    "transgressions": "trænsɡrɛʃənz",
    "transgression": "trænsɡrɛʃən",
    "transgressive": "trænsɡrɛsɪv",
    "transgressors": "trænsɡrɛsəz",
    "transgressor": "trænsɡrɛsɐ",
    "transgress": "trænsɡrɛs",
    "transience": "trænsiəns",
    "transients": "trænsiənts",
    "transient": "trænsiənt",
    "transistors": "trænzɪstəz",
    "transistor": "trænzɪstɐ",
    "transiting": "trænsɪtɪŋ",
    "transitional": "trænsɪʃənəl",
    "transitioned": "trænsɪʃənd",
    "transitioning": "trænsɪʃənɪŋ",
    "transitions": "trænsɪʃənz",
    "transition": "trænsɪʃən",
    "transitive": "trænsɪtɪv",
    "transitory": "trænsɪtəri",
    "transits": "trænsɪts",
    "transit": "trænsɪt",
    "translatable": "trænsleɪtəbəl",
    "translated": "trænsleɪtɪd",
    "translates": "trænsleɪts",
    "translate": "trænsleɪt",
    "translating": "trænsleɪtɪŋ",
    "translational": "trænsleɪʃənəl",
    "translations": "trænsleɪʃənz",
    "translation": "trænsleɪʃən",
    "translators": "trænsleɪtəz",
    "translator": "trænsleɪtɐ",
    "translocation": "trænsləʊkeɪʃən",
    "translucence": "trænsluːsəns",
    "translucency": "trænsluːsənsi",
    "translucent": "trænsluːsənt",
    "translunar": "trænsluːnɐ",
    "transmigrated": "trænsmɪɡreɪtɪd",
    "transmigration": "trænsmɪɡreɪʃən",
    "transmissions": "trænsmɪʃənz",
    "transmission": "trænsmɪʃən",
    "transmits": "trænsmɪts",
    "transmittable": "trænsmɪtəbəl",
    "transmit": "trænsmɪt",
    "transmitted": "trænsmɪtɪd",
    "transmitters": "trænsmɪtəz",
    "transmitter": "trænsmɪtɐ",
    "transmitting": "trænsmɪtɪŋ",
    "transmogrification": "trænsmɒɡrɪfɪkeɪʃən",
    "transmogrified": "trænsmɒɡrɪfaɪd",
    "transmutation": "trænsmjuːteɪʃən",
    "transmuted": "trænsmjuːtɪd",
    "transmute": "trænsmjuːt",
    "transmuting": "trænsmjuːtɪŋ",
    "transnational": "trænsnæʃənəl",
    "transoceanic": "trænsəʊʃɪænɪk",
    "transom": "trænsəm",
    "transonic": "trænsɒnɪk",
    "transpacific": "trænspɐsɪfɪk",
    "transparencies": "trænspærənsiz",
    "transparency": "trænspærənsi",
    "transparently": "trænspærəntli",
    "transparent": "trænspærənt",
    "transpiration": "trænspəreɪʃən",
    "transpired": "trænspaɪəd",
    "transpires": "trænspaɪəz",
    "transpire": "trænspaɪə",
    "transpiring": "trænspaɪərɪŋ",
    "transplantation": "trænsplɑːnteɪʃən",
    "transplanted": "trænsplæntɪd",
    "transplanting": "trænsplæntɪŋ",
    "transponders": "trænspɒndəz",
    "transponder": "trænspɒndɐ",
    "transportable": "trænspɔːtəbəl",
    "transportation": "trænspɔːteɪʃən",
    "transported": "trænspɔːtɪd",
    "transporters": "trænspɔːtəz",
    "transporter": "trænspɔːtɐ",
    "transporting": "trænspɔːtɪŋ",
    "transposable": "trænspəʊzəbəl",
    "transposed": "trænspəʊzd",
    "transposes": "trænspəʊzɪz",
    "transposing": "trænspəʊzɪŋ",
    "transposition": "trænspəzɪʃən",
    "transsexuals": "trænsɛkʃuːəlz",
    "transsexual": "trænsɛkʃuːəl",
    "transubstantiation": "trænsəbstænʃɪeɪʃən",
    "transuranic": "trænsərænɪk",
    "transversely": "trænsvɜːsli",
    "transverse": "trænsvɜːs",
    "transvestism": "trænsvɛstɪzəm",
    "transvestites": "trænsvɛstaɪts",
    "transvestite": "trænsvɛstaɪt",
    "trapdoors": "træpdɔːz",
    "trapdoor": "træpdɔː",
    "trapezes": "trəpiːzɪz",
    "trapeze": "trəpiːz",
    "trapezium": "trəpiːziəm",
    "trapezius": "trəpiːzɪəs",
    "trapezoid": "træpɪzɔɪd",
    "trapped": "træpt",
    "trappers": "træpəz",
    "trapper": "træpɐ",
    "trappings": "træpɪŋz",
    "trapping": "træpɪŋ",
    "traps": "træps",
    "trap": "træp",
    "trashcan": "træʃkæn",
    "trashed": "træʃt",
    "trashes": "træʃɪz",
    "trashing": "træʃɪŋ",
    "trash": "træʃ",
    "trashy": "træʃi",
    "trattoria": "trætɔːriə",
    "traumas": "trɔːməz",
    "traumatically": "trɔːmætɪkli",
    "traumatic": "trɔːmætɪk",
    "traumatised": "trɔːmɐtaɪzd",
    "traumatise": "trɔːmɐtaɪz",
    "traumatising": "trɔːmɐtaɪzɪŋ",
    "trauma": "trɔːmɐ",
    "travails": "trɐveɪlz",
    "travail": "trɐveɪl",
    "travelled": "trævəld",
    "travellers": "trævɛləz",
    "traveller": "trævəlɐ",
    "travellings": "trævəlɪŋz",
    "travelling": "trævəlɪŋ",
    "travelogues": "trævɪlɒɡz",
    "travelogue": "trævɪlɒɡ",
    "travels": "trævəlz",
    "travel": "trævəl",
    "traversed": "trɐvɜːsd",
    "traverses": "trɐvɜːsɪz",
    "traverse": "trɐvɜːs",
    "traversing": "trɐvɜːsɪŋ",
    "travertine": "trævətiːn",
    "travesties": "trævəstiz",
    "travesty": "trævəsti",
    "trawled": "trɔːld",
    "trawlers": "trɔːləz",
    "trawler": "trɔːlɐ",
    "trawling": "trɔːlɪŋ",
    "trawls": "trɔːlz",
    "trawl": "trɔːl",
    "trays": "treɪz",
    "tray": "treɪ",
    "treacherously": "trɛtʃərəsli",
    "treacherous": "trɛtʃərəs",
    "treachery": "trɛtʃəri",
    "treacle": "triːkəl",
    "treacly": "triːkli",
    "treader": "trɛdɐ",
    "treading": "trɛdɪŋ",
    "treadles": "trɛdəlz",
    "treadle": "trɛdəl",
    "treadmills": "trɛdmɪlz",
    "treadmill": "trɛdmɪl",
    "treads": "trɛdz",
    "tread": "trɛd",
    "treasonable": "triːzənəbəl",
    "treasonous": "triːzənəs",
    "treason": "triːzən",
    "treasured": "trɛʒəd",
    "treasurers": "trɛʒərəz",
    "treasurer": "trɛʒərɐ",
    "treasures": "trɛʒəz",
    "treasure": "trɛʒɐ",
    "treasuries": "trɛʒərɪz",
    "treasuring": "trɛʒərɪŋ",
    "treasury": "trɛʒəri",
    "treatable": "triːtəbəl",
    "treated": "triːtɪd",
    "treater": "triːtɐ",
    "treaties": "triːtɪz",
    "treating": "triːtɪŋ",
    "treatises": "triːtɪzɪz",
    "treatise": "triːtɪz",
    "treatments": "triːtmənts",
    "treatment": "triːtmənt",
    "treats": "triːts",
    "treat": "triːt",
    "treaty": "triːti",
    "trebled": "trɛbəld",
    "trebles": "trɛbəlz",
    "treble": "trɛbəl",
    "trebling": "trɛblɪŋ",
    "trebuchet": "trɛbʊʃeɪ",
    "trecento": "trɛsɛntəʊ",
    "treed": "triːd",
    "treeless": "triːləs",
    "treeline": "triːlaɪn",
    "treen": "triːn",
    "treenware": "triːnweə",
    "trees": "triːz",
    "tree": "triː",
    "treetops": "triːtɒps",
    "treetop": "triːtɒp",
    "trefoils": "trɛfɔɪlz",
    "trefoil": "trɛfɔɪl",
    "tref": "trɛf",
    "trekked": "trɛkt",
    "trekkers": "trɛkəz",
    "trekker": "trɛkɐ",
    "trekking": "trɛkɪŋ",
    "treks": "trɛks",
    "trek": "trɛk",
    "trellises": "trɛlaɪzɪz",
    "trellising": "trɛlaɪzɪŋ",
    "trellis": "trɛliz",
    "trelliswork": "trɛlɪzwɜːk",
    "trembled": "trɛmbəld",
    "trembler": "trɛmblɐ",
    "trembles": "trɛmbəlz",
    "tremble": "trɛmbəl",
    "tremblingly": "trɛmbəlɪŋli",
    "trembling": "trɛmblɪŋ",
    "trembly": "trɛmbli",
    "tremendously": "trəmɛndəsli",
    "tremendous": "trəmɛndəs",
    "tremolo": "trɛmɒləʊ",
    "tremors": "trɛməz",
    "tremor": "trɛmɐ",
    "tremulous": "trɛmjʊləs",
    "trenchantly": "trɛntʃəntli",
    "trenchant": "trɛntʃənt",
    "trenched": "trɛntʃt",
    "trenchermen": "trɛntʃəmɛn",
    "trenchers": "trɛntʃəz",
    "trencher": "trɛntʃɐ",
    "trenches": "trɛntʃɪz",
    "trenching": "trɛntʃɪŋ",
    "trench": "trɛntʃ",
    "trended": "trɛndɪd",
    "trendier": "trɛndɪɐ",
    "trendies": "trɛndɪz",
    "trendiest": "trɛndɪəst",
    "trendiness": "trɛndɪnəs",
    "trending": "trɛndɪŋ",
    "trendsetters": "trɛndsɛtəz",
    "trendsetter": "trɛndsɛtɐ",
    "trendsetting": "trɛndsɪtɪŋ",
    "trends": "trɛndz",
    "trend": "trɛnd",
    "trendy": "trɛndi",
    "trepanned": "trɛpænd",
    "trepanning": "trɛpænɪŋ",
    "trepidation": "trɛpɪdeɪʃən",
    "treponema": "trɛpəʊnmɐ",
    "trespassed": "trɛspəst",
    "trespassers": "trɛspəsəz",
    "trespasser": "trɛspəsɐ",
    "trespasses": "trɛspəsɪz",
    "trespassing": "trɛspəsɪŋ",
    "trespass": "trɛspəs",
    "tressel": "trɛsəl",
    "tresses": "trɛsɪz",
    "tress": "trɛs",
    "trestles": "trɛsəlz",
    "trestle": "trɛsəl",
    "tret": "trɛt",
    "trews": "truːz",
    "trey": "treɪ",
    "triads": "traɪædz",
    "triad": "traɪæd",
    "triage": "triːɑːʒ",
    "trialled": "traɪəld",
    "trialling": "traɪɔːlɪŋ",
    "trials": "traɪəlz",
    "trial": "traɪəl",
    "triangles": "traɪæŋɡəlz",
    "triangle": "traɪæŋɡəl",
    "triangular": "traɪænɡjʊlɐ",
    "triangulated": "traɪænɡjʊleɪtɪd",
    "triangulates": "traɪænɡjʊleɪts",
    "triangulate": "traɪænɡjʊleɪt",
    "triangulating": "traɪænɡjʊleɪtɪŋ",
    "triangulation": "traɪænɡjʊleɪʃən",
    "triathletes": "traɪɐθliːts",
    "triathlete": "traɪɐθliːt",
    "triathlons": "traɪæθlənz",
    "triathlon": "traɪæθlən",
    "tribalism": "traɪbəlɪzəm",
    "tribally": "traɪbəli",
    "tribal": "traɪbəl",
    "tribesman": "traɪbsmən",
    "tribesmen": "traɪbsmɛn",
    "tribes": "traɪbz",
    "tribeswomen": "traɪbswɪmɪn",
    "tribe": "traɪb",
    "tribulations": "trɪbjʊleɪʃənz",
    "tribulation": "trɪbjʊleɪʃən",
    "tribunals": "traɪbjuːnəlz",
    "tribunal": "traɪbjuːnəl",
    "tribunes": "trɪbjuːnz",
    "tribune": "trɪbjuːn",
    "tributaries": "trɪbjuːtəriz",
    "tributary": "trɪbjuːtəri",
    "tributes": "trɪbjuːts",
    "tribute": "trɪbjuːt",
    "triceps": "traɪsɛps",
    "triceratops": "traɪsɛrətɒps",
    "trice": "traɪs",
    "trichology": "trɪkɒlədʒi",
    "tricked": "trɪkt",
    "tricker": "trɪkɐ",
    "trickery": "trɪkəri",
    "trickier": "trɪkiɐ",
    "trickiest": "trɪkiəst",
    "trickiness": "trɪkinəs",
    "tricking": "trɪkɪŋ",
    "trickled": "trɪkəld",
    "trickles": "trɪkəlz",
    "trickle": "trɪkəl",
    "trickling": "trɪklɪŋ",
    "tricksters": "trɪkstəz",
    "trickster": "trɪkstɐ",
    "tricks": "trɪks",
    "tricksy": "trɪksi",
    "trick": "trɪk",
    "tricky": "trɪki",
    "triclinium": "trɪklɪniəm",
    "tricolours": "traɪkʌləz",
    "tricolour": "traɪkʌlɐ",
    "tricorne": "traɪkɔːn",
    "tricorn": "traɪkɔːn",
    "tricuspid": "traɪkəspɪd",
    "tricycles": "traɪsɪkəlz",
    "tricycle": "traɪsɪkəl",
    "tricyclics": "traɪsaɪklɪks",
    "tricyclic": "traɪsaɪklɪk",
    "tridents": "traɪdənts",
    "trident": "traɪdənt",
    "tried": "traɪd",
    "triennial": "traɪnɪəl",
    "triers": "traɪəz",
    "tries": "traɪz",
    "triffids": "trɪfɪdz",
    "triffid": "trɪfɪd",
    "trifled": "traɪfəld",
    "trifles": "traɪfəlz",
    "trifle": "traɪfəl",
    "trifling": "traɪflɪŋ",
    "trifolium": "traɪfəʊliəm",
    "triforium": "traɪfɔːriəm",
    "triform": "traɪfɔːm",
    "trigeminal": "traɪdʒɛmɪnəl",
    "triggered": "trɪɡəd",
    "triggerfish": "trɪɡəfɪʃ",
    "triggering": "trɪɡərɪŋ",
    "triggers": "trɪɡəz",
    "trigger": "trɪɡɐ",
    "triglycerides": "trɪɡlɪsəraɪdz",
    "trigonometric": "trɪɡənəʊmɛtrɪk",
    "trigonometry": "trɪɡənɒmətri",
    "trig": "trɪɡ",
    "trikes": "traɪks",
    "trike": "traɪk",
    "trilateral": "traɪlɐtərəl",
    "trilby": "trɪlbi",
    "trilingual": "traɪlɪŋɡwəl",
    "trilled": "trɪld",
    "trilling": "trɪlɪŋ",
    "trillions": "trɪliənz",
    "trillionths": "trɪliənθs",
    "trillionth": "trɪliənθ",
    "trillion": "trɪliən",
    "trillium": "trɪliəm",
    "trills": "trɪlz",
    "trill": "trɪl",
    "trilobites": "traɪləbaɪts",
    "trilobite": "traɪləbaɪt",
    "trilogies": "trɪlədʒiz",
    "trilogy": "trɪlədʒi",
    "trimaran": "traɪməræn",
    "trimesters": "traɪmɛstəz",
    "trimester": "traɪmɛstɐ",
    "trimly": "trɪmli",
    "trimmed": "trɪmd",
    "trimmers": "trɪməz",
    "trimmer": "trɪmɐ",
    "trimmings": "trɪmɪŋz",
    "trimming": "trɪmɪŋ",
    "trims": "trɪmz",
    "trim": "trɪm",
    "trine": "traɪn",
    "trinitrotoluene": "trɪnaɪtrəʊtəljuːiːn",
    "trinity": "trɪnɪti",
    "trinkets": "trɪŋkɪts",
    "trinket": "trɪŋkɪt",
    "triolet": "traɪɒlət",
    "trios": "triːəʊz",
    "trio": "triːəʊ",
    "trioxide": "traɪɒksaɪd",
    "tripartite": "traɪpɑːtaɪt",
    "tripe": "traɪp",
    "triplane": "trɪpleɪn",
    "tripled": "trɪpəld",
    "triples": "trɪpəlz",
    "triple": "trɪpəl",
    "triplets": "trɪpləts",
    "triplet": "trɪplət",
    "triplex": "trɪplɛks",
    "triplicated": "trɪplɪkətɪd",
    "tripling": "trɪplɪŋ",
    "triply": "trɪpli",
    "tripods": "traɪpɒdz",
    "tripod": "traɪpɒd",
    "tripoli": "trɪpəli",
    "tripos": "traɪpəʊz",
    "tripped": "trɪpt",
    "trippers": "trɪpəz",
    "tripper": "trɪpɐ",
    "tripping": "trɪpɪŋ",
    "trips": "trɪps",
    "trip": "trɪp",
    "triptychs": "trɪptɪtʃz",
    "triptych": "trɪptɪtʃ",
    "tripwires": "trɪpwaɪəz",
    "tripwire": "trɪpwaɪə",
    "triremes": "traɪriːmz",
    "trireme": "traɪriːm",
    "triste": "trɪst",
    "trite": "traɪt",
    "tritium": "traɪtiəm",
    "triumphalism": "traɪəmfəlɪzəm",
    "triumphalist": "traɪəmfəlɪst",
    "triumphal": "traɪʌmfəl",
    "triumphantly": "traɪʌmfəntli",
    "triumphant": "traɪʌmfənt",
    "triumphed": "traɪʌmfd",
    "triumphing": "traɪʌmfɪŋ",
    "triumphs": "traɪʌmfz",
    "triumph": "traɪʌmf",
    "triumvirate": "traɪʌmvɪreɪt",
    "trivets": "traɪvɪts",
    "trivet": "traɪvɪt",
    "trivialisation": "trɪvɪəlaɪzeɪʃən",
    "trivialised": "trɪvɪəlaɪzd",
    "trivialises": "trɪvɪəlaɪzɪz",
    "trivialise": "trɪvɪəlaɪz",
    "trivialising": "trɪvɪəlaɪzɪŋ",
    "trivialities": "trɪvɪælɪtiz",
    "triviality": "trɪvɪælɪti",
    "trivially": "trɪvɪəli",
    "trivial": "trɪvɪəl",
    "trivia": "trɪviɐ",
    "trocar": "trɒkɑː",
    "troche": "trəʊk",
    "trodden": "trɒdən",
    "trod": "trɒd",
    "troglodytes": "trɒɡlədaɪts",
    "troglodyte": "trɒɡlədaɪt",
    "troikas": "trɔɪkəz",
    "troika": "trɔɪkɐ",
    "trolled": "trəʊld",
    "troller": "trəʊlɐ",
    "trolleybus": "trɒlɪbəs",
    "trolleys": "trɒlɪz",
    "trolley": "trɒli",
    "trollies": "trəʊlɪz",
    "trolling": "trəʊlɪŋ",
    "trollops": "trɒləps",
    "trollop": "trɒləp",
    "trolls": "trəʊlz",
    "troll": "trəʊl",
    "trolly": "trəʊli",
    "trombones": "trɒmbəʊnz",
    "trombone": "trɒmbəʊn",
    "trombonists": "trɒmbəʊnɪsts",
    "trombonist": "trɒmbəʊnɪst",
    "trommel": "trɒməl",
    "trompe": "trɒmp",
    "tromping": "trɒmpɪŋ",
    "tromp": "trɒmp",
    "trooped": "truːpt",
    "troopers": "truːpəz",
    "trooper": "truːpɐ",
    "trooping": "truːpɪŋ",
    "troopships": "truːpʃɪps",
    "troopship": "truːpʃɪp",
    "troops": "truːps",
    "troop": "truːp",
    "tropes": "trəʊps",
    "trope": "trəʊp",
    "trophic": "trɒfɪk",
    "trophies": "trəʊfiz",
    "trophy": "trəʊfi",
    "tropically": "trɒpɪkli",
    "tropical": "trɒpɪkəl",
    "tropics": "trɒpɪks",
    "tropism": "trəʊpɪzəm",
    "troposphere": "trɒpəsfiə",
    "troth": "trɒθ",
    "trots": "trɒts",
    "trotted": "trɒtɪd",
    "trotters": "trɒtəz",
    "trotter": "trɒtɐ",
    "trotting": "trɒtɪŋ",
    "trot": "trɒt",
    "troubadours": "truːbədɔːz",
    "troubadour": "truːbədɔː",
    "troubled": "trʌbəld",
    "troublemakers": "trʌbəlmeɪkəz",
    "troublemaker": "trʌbəlmeɪkɐ",
    "troublemaking": "trʌbəlmeɪkɪŋ",
    "troubleshooters": "trʌbəlʃuːtəz",
    "troubleshooter": "trʌbəlʃuːtɐ",
    "troubleshooting": "trʌbəlʃuːtɪŋ",
    "troubleshoot": "trʌbəlʃuːt",
    "troublesome": "trʌbəlsʌm",
    "troubles": "trʌbəlz",
    "trouble": "trʌbəl",
    "troubling": "trʌblɪŋ",
    "troughs": "trɒfz",
    "trough": "trɒf",
    "trounced": "traʊnst",
    "trounces": "traʊnsɪz",
    "trounce": "traʊns",
    "trouncing": "traʊnsɪŋ",
    "troupers": "truːpəz",
    "trouper": "truːpɐ",
    "troupes": "truːps",
    "troupe": "truːp",
    "trousers": "traʊsəz",
    "trouser": "traʊsɐ",
    "trousseau": "traʊsəʊ",
    "trouts": "traʊts",
    "trout": "traʊt",
    "troves": "trəʊvz",
    "trove": "trəʊv",
    "trowelling": "traʊəlɪŋ",
    "trowels": "traʊəlz",
    "trowel": "traʊəl",
    "trow": "trəʊ",
    "troy": "trɔɪ",
    "truancy": "truːənsi",
    "truanted": "truːəntɪd",
    "truanting": "truːəntɪŋ",
    "truants": "truːənts",
    "truant": "truːənt",
    "truces": "truːsɪz",
    "truce": "truːs",
    "trucked": "trʌkt",
    "truckers": "trʌkəz",
    "trucker": "trʌkɐ",
    "trucking": "trʌkɪŋ",
    "truckles": "trʌkəlz",
    "truckle": "trʌkəl",
    "truckloads": "trʌkləʊdz",
    "truckload": "trʌkləʊd",
    "trucks": "trʌks",
    "truck": "trʌk",
    "truculence": "trʌkjʊləns",
    "truculent": "trʌkjʊlənt",
    "trudged": "trʌdʒd",
    "trudges": "trʌdʒɪz",
    "trudge": "trʌdʒ",
    "trudging": "trʌdʒɪŋ",
    "trued": "truːd",
    "truelove": "truːəlʌv",
    "trueness": "truːnəs",
    "truer": "truːɐ",
    "truest": "truːəst",
    "trues": "truːz",
    "true": "truː",
    "truffles": "trʌfəlz",
    "truffle": "trʌfəl",
    "trugs": "trʌɡz",
    "trug": "trʌɡ",
    "truing": "truːɪŋ",
    "truisms": "truːɪzəmz",
    "truism": "truːɪzəm",
    "trull": "trʌl",
    "truly": "truːli",
    "trumped": "trʌmpt",
    "trumpery": "trʌmpəri",
    "trumpeted": "trʌmpɪtɪd",
    "trumpeters": "trʌmpɛtəz",
    "trumpeter": "trʌmpɛtɐ",
    "trumpeting": "trʌmpɪtɪŋ",
    "trumpets": "trʌmpɪts",
    "trumpet": "trʌmpɪt",
    "trumping": "trʌmpɪŋ",
    "trumps": "trʌmps",
    "trump": "trʌmp",
    "truncated": "trʌnkeɪtɪd",
    "truncate": "trʌnkeɪt",
    "truncation": "trʌnkeɪʃən",
    "truncheons": "trʌntʃənz",
    "truncheon": "trʌntʃən",
    "trundled": "trʌndəld",
    "trundles": "trʌndəlz",
    "trundle": "trʌndəl",
    "trundling": "trʌndlɪŋ",
    "trunking": "trʌŋkɪŋ",
    "trunks": "trʌŋks",
    "trunk": "trʌŋk",
    "trunnion": "trʌniən",
    "trussed": "trʌst",
    "trusses": "trʌsɪz",
    "trussing": "trʌsɪŋ",
    "truss": "trʌs",
    "trusted": "trʌstɪd",
    "trustees": "trʌstiːz",
    "trustee": "trʌstiː",
    "trustful": "trʌstfəl",
    "trustingly": "trʌstɪŋli",
    "trusting": "trʌstɪŋ",
    "trusts": "trʌsts",
    "trust": "trʌst",
    "trustworthiness": "trʌstwəðɪnəs",
    "trustworthy": "trʌstwɜːði",
    "trusty": "trʌsti",
    "truthfully": "truːθfəli",
    "truthfulness": "truːθfəlnəs",
    "truthful": "truːθfəl",
    "truths": "truːθs",
    "truth": "truːθ",
    "trying": "traɪɪŋ",
    "tryouts": "traɪaʊts",
    "tryout": "traɪaʊt",
    "trypanosomiasis": "traɪpɐnəsəʊmɪæsiz",
    "trypsin": "trɪpsɪn",
    "tryptophan": "trɪptɒfən",
    "trysting": "trɪstɪŋ",
    "trysts": "trɪsts",
    "tryst": "trɪst",
    "try": "traɪ",
    "tsarina": "tsɑːriːnɐ",
    "tsarist": "tsɑːrɪst",
    "tsars": "tsɑːz",
    "tsar": "tsɑː",
    "tsetse": "tsɛtsi",
    "ts": "tiːɛs",
    "tsunamis": "tsuːnɑːmiz",
    "tsunami": "tsuːnɑːmi",
    "t": "tiː",
    "tuatara": "tjuːɐtɑːrɐ",
    "tubal": "tjuːbəl",
    "tubas": "tjuːbəz",
    "tuba": "tjuːbɐ",
    "tubby": "tʌbi",
    "tubed": "tjuːbd",
    "tubercles": "tjuːbəkəlz",
    "tubercular": "tjuːbəkjʊlɐ",
    "tuberculosis": "tjuːbəkjʊləʊsɪs",
    "tuberculous": "tjuːbəkjʊləs",
    "tuberous": "tjuːbərəs",
    "tubers": "tjuːbəz",
    "tuber": "tjuːbɐ",
    "tubes": "tjuːbz",
    "tube": "tjuːb",
    "tubing": "tjuːbɪŋ",
    "tubs": "tʌbz",
    "tub": "tʌb",
    "tubular": "tjuːbjʊlɐ",
    "tubules": "tjuːbjuːlz",
    "tucked": "tʌkt",
    "tuckered": "tʌkəd",
    "tuckers": "tʌkəz",
    "tucker": "tʌkɐ",
    "tucking": "tʌkɪŋ",
    "tucks": "tʌks",
    "tuck": "tʌk",
    "tufa": "tjuːfɐ",
    "tuff": "tʌf",
    "tufted": "tʌftɪd",
    "tufts": "tʌfts",
    "tuft": "tʌft",
    "tufty": "tʌfti",
    "tugboats": "tʌɡbəʊts",
    "tugboat": "tʌɡbəʊt",
    "tugged": "tʌɡd",
    "tugging": "tʌɡɪŋ",
    "tugrik": "tʌɡrɪk",
    "tugs": "tʌɡz",
    "tug": "tʌɡ",
    "tuition": "tjuːɪʃən",
    "tui": "tjuːi",
    "tulips": "tjuːlɪps",
    "tulip": "tjuːlɪp",
    "tulle": "tʌl",
    "tumbledown": "tʌmbəldaʊn",
    "tumbled": "tʌmbəld",
    "tumblers": "tʌmbləz",
    "tumbler": "tʌmblɐ",
    "tumbles": "tʌmbəlz",
    "tumble": "tʌmbəl",
    "tumbleweeds": "tʌmbəlwiːdz",
    "tumbleweed": "tʌmbəlwiːd",
    "tumbling": "tʌmblɪŋ",
    "tumbrel": "tʌmbrəl",
    "tumescence": "tjuːmɛsəns",
    "tumescent": "tjuːmɛsənt",
    "tummies": "tʌmɪz",
    "tummy": "tʌmi",
    "tumorous": "tjuːmərəs",
    "tumours": "tjuːməz",
    "tumour": "tjuːmɐ",
    "tums": "tʌmz",
    "tum": "tʌm",
    "tumuli": "tjuːmjʊlaɪ",
    "tumult": "tjuːmʌlt",
    "tumultuous": "tjuːmʌltʃuːəs",
    "tumulus": "tjuːmjʊləs",
    "tunas": "tjuːnəz",
    "tuna": "tjuːnɐ",
    "tundra": "tʌndrɐ",
    "tuned": "tjuːnd",
    "tunefulness": "tjuːnfəlnəs",
    "tuneful": "tjuːnfəl",
    "tunelessly": "tjuːnləsli",
    "tuneless": "tjuːnləs",
    "tuners": "tjuːnəz",
    "tuner": "tjuːnɐ",
    "tunesmith": "tjuːnsmɪθ",
    "tunes": "tjuːnz",
    "tune": "tjuːn",
    "tungsten": "tʌŋstən",
    "tunicates": "tjuːnɪkeɪts",
    "tunicate": "tjuːnɪkeɪt",
    "tunics": "tjuːnɪks",
    "tunic": "tjuːnɪk",
    "tunings": "tjuːnɪŋz",
    "tuning": "tjuːnɪŋ",
    "tunnelled": "tʌnəld",
    "tunnellers": "tʌnələz",
    "tunneller": "tʌnəlɐ",
    "tunnelling": "tʌnəlɪŋ",
    "tunnels": "tʌnəlz",
    "tunnel": "tʌnəl",
    "tunny": "tʌni",
    "tuns": "tʌnz",
    "tun": "tʌn",
    "tupelo": "tjuːpiːləʊ",
    "tuppence": "tʌpəns",
    "tuppenny": "tʌpəni",
    "turbaned": "tɜːbeɪnd",
    "turbans": "tɜːbənz",
    "turban": "tɜːbən",
    "turbary": "tɜːbəri",
    "turbidity": "tɜːbɪdɪti",
    "turbid": "tɜːbɪd",
    "turbines": "tɜːbaɪnz",
    "turbine": "tɜːbaɪn",
    "turbocharged": "tɜːbətʃɑːdʒd",
    "turbochargers": "tɜːbətʃɑːdʒəz",
    "turbocharger": "tɜːbətʃɑːɡɐ",
    "turbocharge": "tɜːbətʃɑːdʒ",
    "turboprop": "tɜːbəprɒp",
    "turbos": "tɜːbəʊz",
    "turbo": "tɜːbəʊ",
    "turbots": "tɜːbɒts",
    "turbot": "tɜːbɒt",
    "turbulence": "tɜːbjʊləns",
    "turbulently": "tɜːbjʊləntli",
    "turbulent": "tɜːbjʊlənt",
    "turds": "tɜːdz",
    "turd": "tɜːd",
    "tureens": "tjəriːnz",
    "tureen": "tjəriːn",
    "turfed": "tɜːft",
    "turfing": "tɜːfɪŋ",
    "turfs": "tɜːfs",
    "turf": "tɜːf",
    "turfy": "tɜːfi",
    "turgidity": "tɜːdʒɪdɪti",
    "turgid": "tɜːdʒɪd",
    "turgor": "tɜːɡɐ",
    "turkeys": "tɜːkɪz",
    "turkey": "tɜːki",
    "turmeric": "tɜːmɛrɪk",
    "turmoils": "tɜːmɔɪlz",
    "turmoil": "tɜːmɔɪl",
    "turnabout": "tɜːnɐbaʊt",
    "turnarounds": "tɜːnɐraʊndz",
    "turnaround": "tɜːnɐraʊnd",
    "turncoats": "tɜːnkəʊts",
    "turncoat": "tɜːnkəʊt",
    "turndown": "tɜːndaʊn",
    "turned": "tɜːnd",
    "turners": "tɜːnəz",
    "turner": "tɜːnɐ",
    "turnings": "tɜːnɪŋz",
    "turning": "tɜːnɪŋ",
    "turnips": "tɜːnɪps",
    "turnip": "tɜːnɪp",
    "turnkeys": "tɜːnkiːz",
    "turnkey": "tɜːnkiː",
    "turnoff": "tɜːnɒf",
    "turnouts": "tɜːnaʊts",
    "turnout": "tɜːnaʊt",
    "turnovers": "tɜːnəʊvəz",
    "turnover": "tɜːnəʊvɐ",
    "turnpikes": "tɜːnpaɪks",
    "turnpike": "tɜːnpaɪk",
    "turnspit": "tɜːnspɪt",
    "turnstiles": "tɜːnstaɪlz",
    "turnstile": "tɜːnstaɪl",
    "turns": "tɜːnz",
    "turnstones": "tɜːnstəʊnz",
    "turnstone": "tɜːnstəʊn",
    "turntables": "tɜːnteɪbəlz",
    "turntable": "tɜːnteɪbəl",
    "turn": "tɜːn",
    "turpentine": "tɜːpɪntaɪn",
    "turpitude": "tɜːpɪtjuːd",
    "turps": "tɜːps",
    "turquoises": "tɜːkwɔɪsɪz",
    "turquoise": "tɜːkwɔɪs",
    "turreted": "tʌrɪtɪd",
    "turrets": "tʌrɪts",
    "turret": "tʌrɪt",
    "turtlenecks": "tɜːtəlnɛks",
    "turtleneck": "tɜːtəlnɛk",
    "turtles": "tɜːtəlz",
    "turtle": "tɜːtəl",
    "tushy": "tʌʃi",
    "tusked": "tʌskt",
    "tusker": "tʌskɐ",
    "tusks": "tʌsks",
    "tusk": "tʌsk",
    "tussled": "tʌsəld",
    "tussles": "tʌsəlz",
    "tussle": "tʌsəl",
    "tussling": "tʌslɪŋ",
    "tussocks": "tʌsəks",
    "tussock": "tʌsək",
    "tussocky": "tʌsəki",
    "tutelage": "tjuːtɛlɪdʒ",
    "tutored": "tjuːtəd",
    "tutorials": "tjuːtɔːrɪəlz",
    "tutorial": "tjuːtɔːrɪəl",
    "tutoring": "tjuːtərɪŋ",
    "tutors": "tjuːtəz",
    "tutor": "tjuːtɐ",
    "tuts": "tʌts",
    "tutted": "tʌtɪd",
    "tutting": "tʌtɪŋ",
    "tutti": "tʌti",
    "tut": "tʌt",
    "tutus": "tjuːtəs",
    "tutu": "tuːtuː",
    "tuxedoes": "tʌksiːdəʊz",
    "tuxedos": "tʌksiːdəʊz",
    "tuxedo": "tʌksiːdəʊ",
    "tuxes": "tʌksɪz",
    "tux": "tʌks",
    "twaddler": "twɒdlɐ",
    "twaddle": "twɒdəl",
    "twain": "tweɪn",
    "twanged": "twæŋd",
    "twanging": "twæŋɪŋ",
    "twangs": "twæŋz",
    "twang": "twæŋ",
    "twangy": "twæŋi",
    "twas": "twɒz",
    "twats": "twæts",
    "twat": "twæt",
    "twayblade": "tweɪbleɪd",
    "tweaked": "twiːkt",
    "tweaking": "twiːkɪŋ",
    "tweaks": "twiːks",
    "tweak": "twiːk",
    "tweedily": "twiːdɪli",
    "tweeds": "twiːdz",
    "tweed": "twiːd",
    "tweedy": "twiːdi",
    "tweeness": "twiːnəs",
    "tween": "twiːn",
    "tweeny": "twiːni",
    "tweeted": "twiːtɪd",
    "tweeters": "twiːtəz",
    "tweeter": "twiːtɐ",
    "tweeting": "twiːtɪŋ",
    "tweets": "twiːts",
    "tweet": "twiːt",
    "twee": "twiː",
    "tweezers": "twiːzəz",
    "tweeze": "twiːz",
    "twelfths": "twɛlfθs",
    "twelfth": "twɛlfθ",
    "twelvemonth": "twɛlvɪmʌnθ",
    "twelves": "twɛlvz",
    "twelve": "twɛlv",
    "twenties": "twɛntɪz",
    "twentieth": "twɛntiəθ",
    "twenty": "twɛnti",
    "twerps": "twɜːps",
    "twerp": "twɜːp",
    "twice": "twaɪs",
    "twiddled": "twɪdəld",
    "twiddler": "twɪdlɐ",
    "twiddles": "twɪdəlz",
    "twiddle": "twɪdəl",
    "twiddling": "twɪdlɪŋ",
    "twiddly": "twɪdli",
    "twigged": "twɪɡd",
    "twigging": "twɪɡɪŋ",
    "twiggy": "twɪɡi",
    "twigs": "twɪɡz",
    "twig": "twɪɡ",
    "twilight": "twaɪlaɪt",
    "twilit": "twɪlɪt",
    "twill": "twɪl",
    "twined": "twaɪnd",
    "twines": "twaɪnz",
    "twine": "twaɪn",
    "twinged": "twɪndʒd",
    "twinges": "twɪndʒɪz",
    "twinge": "twɪndʒ",
    "twinging": "twɪŋɪŋ",
    "twining": "twaɪnɪŋ",
    "twinkled": "twɪŋkəld",
    "twinkler": "twɪŋklɐ",
    "twinkles": "twɪŋkəlz",
    "twinkle": "twɪŋkəl",
    "twinkling": "twɪŋklɪŋ",
    "twinkly": "twɪŋkli",
    "twink": "twɪŋk",
    "twinned": "twɪnd",
    "twinning": "twɪnɪŋ",
    "twinsets": "twɪnsɛts",
    "twinset": "twɪnsɛt",
    "twins": "twɪnz",
    "twin": "twɪn",
    "twirled": "twɜːld",
    "twirlers": "twɜːləz",
    "twirler": "twɜːlɐ",
    "twirling": "twɜːlɪŋ",
    "twirls": "twɜːlz",
    "twirl": "twɜːl",
    "twirly": "twɜːli",
    "twisted": "twɪstɪd",
    "twisters": "twɪstəz",
    "twister": "twɪstɐ",
    "twistiest": "twɪstɪəst",
    "twisting": "twɪstɪŋ",
    "twists": "twɪsts",
    "twist": "twɪst",
    "twisty": "twɪsti",
    "twitched": "twɪtʃt",
    "twitches": "twɪtʃɪz",
    "twitchier": "twɪtʃɪɐ",
    "twitching": "twɪtʃɪŋ",
    "twitch": "twɪtʃ",
    "twitchy": "twɪtʃi",
    "twits": "twɪts",
    "twittered": "twɪtəd",
    "twittering": "twɪtərɪŋ",
    "twitters": "twɪtəz",
    "twitter": "twɪtɐ",
    "twittery": "twɪtəri",
    "twit": "twɪt",
    "twixt": "twɪkst",
    "twofold": "tuːfəʊld",
    "twopence": "tuːpəns",
    "twopenny": "tuːpəni",
    "twosomes": "tuːsʌmz",
    "twosome": "tuːsʌm",
    "twos": "tuːz",
    "two": "tuː",
    "tycoons": "taɪkuːnz",
    "tycoon": "taɪkuːn",
    "tyg": "tɪɡ",
    "tying": "taɪɪŋ",
    "tykes": "taɪks",
    "tyke": "taɪk",
    "tympanic": "tɪmpænɪk",
    "tympanum": "tɪmpænəm",
    "typecasting": "taɪpkɑːstɪŋ",
    "typecast": "taɪpkɑːst",
    "typed": "taɪpd",
    "typefaces": "taɪpfeɪsɪz",
    "typeface": "taɪpfeɪs",
    "typescript": "taɪpskrɪpt",
    "typeset": "taɪpsɛt",
    "typesetters": "taɪpsɛtəz",
    "typesetter": "taɪpsɛtɐ",
    "typesetting": "taɪpsɪtɪŋ",
    "types": "taɪps",
    "type": "taɪp",
    "typewriters": "taɪpraɪtəz",
    "typewriter": "taɪpraɪtɐ",
    "typewriting": "taɪpraɪtɪŋ",
    "typewritten": "taɪprɪtən",
    "typhoid": "taɪfɔɪd",
    "typhoons": "taɪfuːnz",
    "typhoon": "taɪfuːn",
    "typhus": "taɪfəs",
    "typically": "tɪpɪkli",
    "typical": "tɪpɪkəl",
    "typified": "tɪpɪfaɪd",
    "typifies": "tɪpɪfaɪz",
    "typifying": "tɪpɪfaɪɪŋ",
    "typify": "tɪpɪfaɪ",
    "typing": "taɪpɪŋ",
    "typists": "taɪpɪsts",
    "typist": "taɪpɪst",
    "typographer": "taɪpɒɡrəfɐ",
    "typographical": "taɪpəɡræfɪkəl",
    "typography": "taɪpɒɡrəfi",
    "typos": "taɪpəʊz",
    "typo": "taɪpəʊ",
    "tyrannically": "tɪrænɪkli",
    "tyrannical": "tɪrænɪkəl",
    "tyrannic": "tɪrænɪk",
    "tyrannies": "tɪrəniz",
    "tyrannosaurs": "tɪrænəsɔːz",
    "tyrannosaur": "tɪrænəsɔː",
    "tyrannosaurus": "tɪrɐnəsɔːrəs",
    "tyrannous": "tɪrænəs",
    "tyranny": "tɪrəni",
    "tyrants": "taɪrənts",
    "tyrant": "taɪrənt",
    "tyres": "taɪəz",
    "tyre": "taɪə",
    "tyro": "taɪrəʊ",
    "tzarina": "tsɑːriːnɐ",
    "tzar": "tsɑː",
    "ubiquitous": "juːbɪkwɪtəs",
    "ubiquity": "juːbɪkwɪti",
    "udder": "ʌdɐ",
    "udders": "ʌdəz",
    "udo": "juːdəʊ",
    "ufology": "juːfɒlədʒi",
    "ugh": "ʌɡ",
    "uglier": "ʌɡliɐ",
    "ugliest": "ʌɡliəst",
    "uglification": "ʌɡlɪfɪkeɪʃən",
    "ugliness": "ʌɡlinəs",
    "ugly": "ʌɡli",
    "uh": "ʌ",
    "u": "juː",
    "ukase": "juːkeɪs",
    "ukelele": "juːkɪlɛl",
    "ukulele": "juːkəleɪli",
    "ukuleles": "juːkəleɪliz",
    "ulcerated": "ʌlsəreɪtɪd",
    "ulceration": "ʌlsəreɪʃən",
    "ulcerations": "ʌlsəreɪʃənz",
    "ulcerative": "ʌlsərətɪv",
    "ulcer": "ʌlsɐ",
    "ulcerous": "ʌlsərəs",
    "ulcers": "ʌlsəz",
    "ulna": "ʌlnɐ",
    "ulnar": "ʌlnɑː",
    "ulster": "ʌlstɐ",
    "ulsters": "ʌlstəz",
    "ulterior": "ʌltiərɪɐ",
    "ultima": "ʌltɪmɐ",
    "ultimate": "ʌltɪmət",
    "ultimately": "ʌltɪmətli",
    "ultimatum": "ʌltɪmeɪtəm",
    "ultimatums": "ʌltɪmeɪtəmz",
    "ultimo": "ʌltɪməʊ",
    "ultralight": "ʊltrɐlaɪt",
    "ultra": "ʌltrɐ",
    "ultramarine": "ʊltrɐməriːn",
    "ultramodern": "ʊltrɐmɒdən",
    "ultras": "ʌltrəz",
    "ultrasonic": "ʊltrɐsɒnɪk",
    "ultrasound": "ʊltrɐsaʊnd",
    "ultrasounds": "ʊltrɐsaʊndz",
    "ultraviolet": "ʊltrɐvaɪələt",
    "ululate": "ʌljʊleɪt",
    "umbel": "ʌmbəl",
    "umber": "ʌmbɐ",
    "umbilical": "ʌmbɪlɪkəl",
    "umbilicus": "ʌmbɪlɪkəs",
    "umbrage": "ʌmbrɪdʒ",
    "umbra": "ʌmbrɐ",
    "umbrella": "ʌmbrɛlɐ",
    "umbrellas": "ʌmbrɛləz",
    "umlaut": "ʌmlaʊt",
    "umlauts": "ʌmlaʊts",
    "um": "ʌm",
    "umpired": "ʌmpaɪəd",
    "umpire": "ʌmpaɪə",
    "umpires": "ʌmpaɪəz",
    "umpiring": "ʌmpaɪərɪŋ",
    "ump": "ʌmp",
    "umpteen": "ʌmptiːn",
    "umpteenth": "ʌmptiːnθ",
    "unabashedly": "ʌnɐbæʃɪdli",
    "unabashed": "ʌnɐbæʃt",
    "unabated": "ʌnɐbeɪtɪd",
    "unable": "ʌneɪbəl",
    "unabridged": "ʌnɐbrɪdʒd",
    "unacademic": "ʌnækədɛmɪk",
    "unacceptable": "ʌnɐksɛptəbəl",
    "unacceptably": "ʌnɐksɛptəbli",
    "unaccompanied": "ʌnɐkʌmpənɪd",
    "unaccomplished": "ʌnɐkɒmplɪʃt",
    "unaccountable": "ʌnɐkaʊntəbəl",
    "unaccountably": "ʌnɐkaʊntəbli",
    "unaccounted": "ʌnɐkaʊntɪd",
    "unaccredited": "ʌnɐkrɛdɪtɪd",
    "unaccustomed": "ʌnɐkʌstəmd",
    "unachievable": "ʌnɐtʃiːvəbəl",
    "unacknowledged": "ʌnɐknɒlɪdʒd",
    "unacquainted": "ʌnɐkweɪntɪd",
    "unaddressed": "ʌnɐdrɛst",
    "unadjusted": "ʌnɐdʒʌstɪd",
    "unadorned": "ʌnɐdɔːnd",
    "unadulterated": "ʌnɐdʌltəreɪtɪd",
    "unadventurous": "ʌnɐdvɛntʃərəs",
    "unadvisable": "ʌnɐdvaɪzəbəl",
    "unadvisedly": "ʌnɐdvaɪzɪdli",
    "unadvised": "ʌnɐdvaɪzd",
    "unaesthetic": "ʌniːsθɛtɪk",
    "unaffected": "ʌnɐfɛktɪd",
    "unaffiliated": "ʌnɐfɪlɪeɪtɪd",
    "unaffordable": "ʌnɐfɔːdəbəl",
    "unafraid": "ʌnɐfreɪd",
    "unaggressive": "ʌnɐɡrɛsɪv",
    "unaided": "ʌneɪdɪd",
    "unalienable": "ʌneɪliənəbəl",
    "unalike": "juːnəlaɪk",
    "unallocated": "ʌnæləkeɪtɪd",
    "unalloyed": "ʌnælɔɪd",
    "unalterable": "ʌnɒltərəbəl",
    "unaltered": "ʌnɒltəd",
    "unambiguously": "ʌnæmbɪɡjuːəsli",
    "unambiguous": "ʌnæmbɪɡjuːəs",
    "unambitious": "ʌnæmbɪʃəs",
    "unamended": "ʌnɐmɛndɪd",
    "unamused": "ʌnɐmjuːzd",
    "unanchored": "ʌnænkəd",
    "unanimity": "juːnɐnɪmɪti",
    "unanimous": "juːnænɪməs",
    "unanimously": "juːnænɪməsli",
    "unannounced": "ʌnɐnaʊnst",
    "unanswerable": "ʌnɑːnsərəbəl",
    "unanswered": "ʌnɑːnsəd",
    "unanticipated": "ʌnæntɪsɪpeɪtɪd",
    "unapologetic": "ʌnɐpɒlədʒɛtɪk",
    "unapparent": "ʌnɐpærənt",
    "unappealing": "ʌnɐpiːlɪŋ",
    "unappetising": "ʌnæpɪtaɪzɪŋ",
    "unappreciated": "ʌnɐpriːʃɪeɪtɪd",
    "unappreciative": "ʌnɐpriːʃiətɪv",
    "unapproachable": "ʌnɐprəʊtʃəbəl",
    "unapproved": "ʌnɐpruːvd",
    "unapt": "ʌnæpt",
    "unarguable": "ʌnɑːɡjuːəbəl",
    "unarguably": "ʌnɑːɡjuːəbli",
    "unarmed": "ʌnɑːmd",
    "unashamedly": "ʌnɐʃeɪmɪdli",
    "unashamed": "ʌnɐʃeɪmd",
    "unasked": "ʌnɑːskt",
    "unassailable": "ʌnɐseɪləbəl",
    "unassertive": "ʌnɐsɜːtɪv",
    "unassisted": "ʌnɐsɪstɪd",
    "unassociated": "ʌnɐsəʊsɪeɪtɪd",
    "unassumingly": "ʌnɐsuːmɪŋli",
    "unassuming": "ʌnɐsuːmɪŋ",
    "unathletic": "ʌnæθlɛtɪk",
    "unattached": "ʌnɐtætʃt",
    "unattainable": "ʌnɐteɪnəbəl",
    "unattended": "ʌnɐtɛndɪd",
    "unattractiveness": "ʌnɐtræktɪvnəs",
    "unattractive": "ʌnɐtræktɪv",
    "unattributed": "ʌnɐtrɪbjuːtɪd",
    "unaudited": "ʌnɔːdɪtɪd",
    "unauthentic": "ʌnɔːθɛntɪk",
    "unauthorised": "ʌnɔːθɔːraɪzd",
    "unavailability": "ʌnɐveɪləbɪlɪti",
    "unavailable": "ʌnɐveɪləbəl",
    "unavoidable": "ʌnɐvɔɪdəbəl",
    "unavoidably": "ʌnɐvɔɪdəbli",
    "unaware": "ʌnəweə",
    "unawares": "ʌnəweəz",
    "unbaked": "ʌnbeɪkt",
    "unbalanced": "ʌnbælənst",
    "unbalance": "ʌnbæləns",
    "unbalances": "ʌnbælənsɪz",
    "unbalancing": "ʌnbælənsɪŋ",
    "unbanned": "ʌnbænd",
    "unbaptised": "ʌnbæptaɪzd",
    "unbarred": "ʌnbɑːd",
    "unbearable": "ʌnbeərəbəl",
    "unbearably": "ʌnbeərəbli",
    "unbeatable": "ʌnbiːtəbəl",
    "unbeaten": "ʌnbiːtən",
    "unbecoming": "ʌnbɪkʌmɪŋ",
    "unbeknown": "ʌnbɪnəʊn",
    "unbeknownst": "ʌnbɪnəʊnst",
    "unbelief": "ʌnbɪliːf",
    "unbelievable": "ʌnbɪliːvəbəl",
    "unbelievably": "ʌnbɪliːvəbli",
    "unbeliever": "ʌnbɪliːvɐ",
    "unbelievers": "ʌnbɪliːvəz",
    "unbelieving": "ʌnbɪliːvɪŋ",
    "unbending": "ʌnbɛndɪŋ",
    "unbend": "ʌnbɛnd",
    "unbiased": "ʌnbaɪəst",
    "unbidden": "ʌnbɪdən",
    "unbleached": "ʌnbliːtʃt",
    "unblemished": "ʌnblɛmɪʃt",
    "unblessed": "ʌnblɛst",
    "unblinking": "ʌnblɪŋkɪŋ",
    "unblocked": "ʌnblɒkt",
    "unblocking": "ʌnblɒkɪŋ",
    "unblock": "ʌnblɒk",
    "unblocks": "ʌnblɒks",
    "unbolted": "ʌnbəʊltɪd",
    "unbolt": "ʌnbəʊlt",
    "unborn": "ʌnbɔːn",
    "unbounded": "ʌnbaʊndɪd",
    "unbound": "ʌnbaʊnd",
    "unbowed": "ʌnbaʊd",
    "unbraced": "ʌnbreɪst",
    "unbraided": "ʌnbreɪdɪd",
    "unbranded": "ʌnbrændɪd",
    "unbreakable": "ʌnbreɪkəbəl",
    "unbreathable": "ʌnbriːðəbəl",
    "unbridgeable": "ʌnbrɪdʒəbəl",
    "unbridled": "ʌnbraɪdəld",
    "unbroken": "ʌnbrəʊkən",
    "unbruised": "ʌnbruːzd",
    "unbuckled": "ʌnbʌkəld",
    "unbuckle": "ʌnbʌkəl",
    "unbuild": "ʌnbɪld",
    "unbundled": "ʌnbʌndəld",
    "unburdened": "ʌnbɜːdənd",
    "unburdening": "ʌnbɜːdənɪŋ",
    "unburden": "ʌnbɜːdən",
    "unburied": "ʌnbɛrɪd",
    "unburned": "ʌnbɜːnd",
    "unburnt": "ʌnbɜːnt",
    "unbuttoned": "ʌnbʌtənd",
    "unbuttoning": "ʌnbʌtənɪŋ",
    "unbutton": "ʌnbʌtən",
    "uncaged": "ʌnkeɪdʒd",
    "uncalled": "ʌnkɔːld",
    "uncannily": "ʌnkænɪli",
    "uncanny": "ʌnkæni",
    "uncapped": "ʌnkæpt",
    "uncaring": "ʌnkeərɪŋ",
    "unceasingly": "ʌnsiːsɪŋli",
    "unceasing": "ʌnsiːsɪŋ",
    "uncelebrated": "ʌnsɛləbreɪtɪd",
    "uncensored": "ʌnsɛnsəd",
    "unceremoniously": "ʌnsɛrɪməʊnɪəsli",
    "unceremonious": "ʌnsɛrɪməʊnɪəs",
    "uncertainly": "ʌnsɜːtənli",
    "uncertain": "ʌnsɜːtən",
    "uncertainties": "ʌnsɜːtəntɪz",
    "uncertainty": "ʌnsɜːtənti",
    "uncertified": "ʌnsɜːtɪfaɪd",
    "unchained": "ʌntʃeɪnd",
    "unchain": "ʌntʃeɪn",
    "unchallengeable": "ʌntʃælɪndʒəbəl",
    "unchallenged": "ʌntʃælɪndʒd",
    "unchangeable": "ʌntʃeɪndʒəbəl",
    "unchanged": "ʌntʃeɪndʒd",
    "unchanging": "ʌntʃeɪndʒɪŋ",
    "uncharacteristically": "ʌnkærɪktərɪstɪkli",
    "uncharacteristic": "ʌnkærɪktərɪstɪk",
    "uncharged": "ʌntʃɑːdʒd",
    "uncharismatic": "ʌnkærɪsmætɪk",
    "uncharitable": "ʌntʃærɪtəbəl",
    "uncharitably": "ʌntʃærɪtəbli",
    "uncharted": "ʌntʃɑːtɪd",
    "unchartered": "ʌntʃɑːtəd",
    "unchaste": "ʌntʃeɪst",
    "unchecked": "ʌntʃɛkt",
    "unchivalrous": "ʌnʃɪvəlrəs",
    "unchristian": "ʌnkrɪstʃən",
    "unchurched": "ʌntʃɜːtʃt",
    "uncircumcised": "ʌnsɜːkəmsaɪzd",
    "uncivilised": "ʌnsɪvəlaɪzd",
    "uncivil": "ʌnsɪvəl",
    "unclad": "ʌnklæd",
    "unclaimed": "ʌnkleɪmd",
    "unclassified": "ʌnklæsɪfaɪd",
    "uncleaned": "ʌnkliːnd",
    "uncleanness": "ʌnkliːnnəs",
    "unclean": "ʌnkliːn",
    "unclear": "ʌnkliə",
    "unclenched": "ʌnklɛntʃt",
    "unclench": "ʌnklɛntʃ",
    "uncle": "ʌŋkəl",
    "uncles": "ʌŋkəlz",
    "unclimbable": "ʌnklaɪməbəl",
    "unclimbed": "ʌnklaɪmd",
    "unclogged": "ʌnklɒɡd",
    "unclogging": "ʌnklɒɡɪŋ",
    "unclog": "ʌnklɒɡ",
    "unclothed": "ʌnkləʊðd",
    "unclouded": "ʌnklaʊdɪd",
    "uncluttered": "ʌnklʌtəd",
    "uncoated": "ʌnkəʊtɪd",
    "uncoiled": "ʌnkɔɪld",
    "uncoil": "ʌnkɔɪl",
    "uncollected": "ʌnkəlɛktɪd",
    "uncoloured": "ʌnkʌləd",
    "uncomfortableness": "ʌnkʌmftəbəlnəs",
    "uncomfortable": "ʌnkʌmftəbəl",
    "uncomfortably": "ʌnkʌmftəbli",
    "uncommercial": "ʌnkəmɜːʃəl",
    "uncommitted": "ʌnkəmɪtɪd",
    "uncommonly": "ʌnkɒmənli",
    "uncommon": "ʌnkɒmən",
    "uncommunicative": "ʌnkəmjuːnɪkətɪv",
    "uncompetitive": "ʌnkəmpɛtɪtɪv",
    "uncomplainingly": "ʌnkəmpleɪnɪŋli",
    "uncomplaining": "ʌnkəmpleɪnɪŋ",
    "uncompleted": "ʌnkəmpliːtɪd",
    "uncomplicated": "ʌnkɒmplɪkeɪtɪd",
    "uncomplimentary": "ʌnkɒmplɪmɛntəri",
    "uncomprehending": "ʌnkɒmprɪhɛndɪŋ",
    "uncompromisingly": "ʌnkɒmprəmaɪzɪŋli",
    "uncompromising": "ʌnkɒmprəmaɪzɪŋ",
    "unconceivable": "ʌnkənsiːvəbəl",
    "unconcerned": "ʌnkənsɜːnd",
    "unconcern": "ʌnkənsɜːn",
    "unconditionally": "ʌnkəndɪʃənəli",
    "unconditional": "ʌnkəndɪʃənəl",
    "unconditioned": "ʌnkəndɪʃənd",
    "unconfined": "ʌnkənfaɪnd",
    "unconfirmed": "ʌnkənfɜːmd",
    "unconformity": "ʌnkənfɔːmɪti",
    "uncongenial": "ʌnkəndʒiːnɪəl",
    "unconnected": "ʌnkənɛktɪd",
    "unconquerable": "ʌnkɒnkərəbəl",
    "unconquered": "ʌnkɒnkəd",
    "unconscionable": "ʌnkɒnʃənəbəl",
    "unconsciously": "ʌnkɒnʃəsli",
    "unconsciousness": "ʌnkɒnʃəsnəs",
    "unconscious": "ʌnkɒnʃəs",
    "unconsecrated": "ʌnkɒnsɪkreɪtɪd",
    "unconsidered": "ʌnkənsɪdəd",
    "unconstitutionally": "ʌnkɒnstɪtjuːʃənəli",
    "unconstitutional": "ʌnkɒnstɪtjuːʃənəl",
    "unconstrained": "ʌnkənstreɪnd",
    "unconsummated": "ʌnkɒnsəmeɪtɪd",
    "uncontainable": "ʌnkənteɪnəbəl",
    "uncontaminated": "ʌnkəntæmɪneɪtɪd",
    "uncontentious": "ʌnkəntɛnʃəs",
    "uncontested": "ʌnkəntɛstɪd",
    "uncontrollable": "ʌnkəntrəʊləbəl",
    "uncontrollably": "ʌnkəntrəʊləbli",
    "uncontrolled": "ʌnkəntrəʊld",
    "uncontroversially": "ʌnkɒntrəvɜːʃəli",
    "uncontroversial": "ʌnkɒntrəvɜːʃəl",
    "unconventionally": "ʌnkənvɛnʃənəli",
    "unconventional": "ʌnkənvɛnʃənəl",
    "unconverted": "ʌnkənvɜːtɪd",
    "unconvinced": "ʌnkənvɪnst",
    "unconvincingly": "ʌnkənvɪnsɪŋli",
    "unconvincing": "ʌnkənvɪnsɪŋ",
    "uncooked": "ʌnkʊkt",
    "uncool": "ʌnkuːl",
    "uncooperative": "ʌnkəʊɒpərətɪv",
    "uncoordinated": "ʌnkəʊɔːdɪneɪtɪd",
    "uncorked": "ʌnkɔːkt",
    "uncorking": "ʌnkɔːkɪŋ",
    "uncork": "ʌnkɔːk",
    "uncorks": "ʌnkɔːks",
    "uncorrected": "ʌnkərɛktɪd",
    "uncorroborated": "ʌnkərɒbəreɪtɪd",
    "uncorrupted": "ʌnkərʌptɪd",
    "uncountable": "ʌnkaʊntəbəl",
    "uncounted": "ʌnkaʊntɪd",
    "uncoupled": "ʌnkʌpəld",
    "uncouple": "ʌnkʌpəl",
    "uncouth": "ʌnkuːθ",
    "uncovered": "ʌnkʌvəd",
    "uncovering": "ʌnkʌvərɪŋ",
    "uncover": "ʌnkʌvɐ",
    "uncovers": "ʌnkʌvəz",
    "uncreated": "ʌnkriːeɪtɪd",
    "uncreative": "ʌnkriːeɪtɪv",
    "uncredited": "ʌnkrɛdɪtɪd",
    "uncritical": "ʌnkrɪtɪkəl",
    "uncrossable": "ʌnkrɒsəbəl",
    "uncrossed": "ʌnkrɒst",
    "uncross": "ʌnkrɒs",
    "uncrowded": "ʌnkraʊdɪd",
    "uncrowned": "ʌnkraʊnd",
    "unction": "ʌnktɪɒn",
    "unctuousness": "ʌnktjuːuːznəs",
    "unctuous": "ʌnktjuːuːz",
    "uncultivated": "ʌnkʌltɪveɪtɪd",
    "uncultured": "ʌnkʌltʃəd",
    "uncured": "ʌnkjɔːd",
    "uncurled": "ʌnkɜːld",
    "uncurling": "ʌnkɜːlɪŋ",
    "uncurl": "ʌnkɜːl",
    "uncurls": "ʌnkɜːlz",
    "uncut": "ʌnkʌt",
    "undamaged": "ʌndæmɪdʒd",
    "undated": "ʌndeɪtɪd",
    "undaunted": "ʌndɔːntɪd",
    "undead": "ʌndɛd",
    "undecided": "ʌndɪsaɪdɪd",
    "undecideds": "ʌndɪsaɪdɪdz",
    "undeclared": "ʌndɪkleəd",
    "undecorated": "ʌndɛkəreɪtɪd",
    "undefeated": "ʌndɪfiːtɪd",
    "undefended": "ʌndɪfɛndɪd",
    "undefiled": "ʌndɪfaɪld",
    "undefinable": "ʌndɪfaɪnəbəl",
    "undefined": "ʌndɪfaɪnd",
    "undeliverable": "ʌndɪlɪvərəbəl",
    "undelivered": "ʌndɪlɪvəd",
    "undemanding": "ʌndɪmɑːndɪŋ",
    "undemocratic": "ʌndɛməkrætɪk",
    "undemonstrative": "ʌndəmɒnstrətɪv",
    "undeniable": "ʌndɪnaɪəbəl",
    "undeniably": "ʌndɪnaɪəbli",
    "undependable": "ʌndɪpɛndəbəl",
    "underachieved": "ʌndərɐtʃiːvd",
    "underachievement": "ʌndərɐtʃiːvmənt",
    "underachiever": "ʌndərɐtʃiːvɐ",
    "underachievers": "ʌndərɐtʃiːvəz",
    "underachieving": "ʌndərɐtʃiːvɪŋ",
    "underactive": "ʌndəræktɪv",
    "underaged": "ʌndəreɪdʒd",
    "underage": "ʌndəreɪdʒ",
    "underarm": "ʌndərɑːm",
    "underarms": "ʌndərɑːmz",
    "underbelly": "ʌndəbɛli",
    "underbidder": "ʌndəbɪdɐ",
    "underbid": "ʌndəbɪd",
    "underbite": "ʌndəbaɪt",
    "underbody": "ʌndəbɒdi",
    "undercarriage": "ʌndəkærɪdʒ",
    "undercharged": "ʌndətʃɑːdʒd",
    "undercharging": "ʌndətʃɑːdʒɪŋ",
    "underclasses": "ʌndəklɑːsɪz",
    "underclass": "ʌndəklɑːs",
    "underclothes": "ʌndəkləʊðz",
    "underclothing": "ʌndəkləʊðɪŋ",
    "undercoat": "ʌndəkəʊt",
    "undercooked": "ʌndəkʊkt",
    "undercover": "ʌndəkʌvɐ",
    "undercroft": "ʌndəkrɒft",
    "undercurrent": "ʌndəkʌrənt",
    "undercurrents": "ʌndəkʌrənts",
    "undercuts": "ʌndəkʌts",
    "undercutting": "ʌndəkʌtɪŋ",
    "underdeveloped": "ʌndədɪvɛləpt",
    "underdevelopment": "ʌndədɪvɛləpmənt",
    "underdog": "ʌndədɒɡ",
    "underdogs": "ʌndədɒɡz",
    "underdone": "ʌndədʌn",
    "underdressed": "ʌndədrɛst",
    "undereducated": "ʌndərɛdʒuːkeɪtɪd",
    "underemployed": "ʌndərɛmplɔɪd",
    "underemployment": "ʌndərɛmplɔɪmənt",
    "underestimated": "ʌndərɛstɪmeɪtɪd",
    "underestimating": "ʌndərɛstɪmeɪtɪŋ",
    "underestimation": "ʌndərɛstɪmeɪʃən",
    "underexposed": "ʌndərɛkspəʊzd",
    "underfed": "ʌndəfɛd",
    "underfloor": "ʌndəflɔː",
    "underfoot": "ʌndəfʊt",
    "underfunded": "ʌndəfʌndɪd",
    "underfunding": "ʌndəfʌndɪŋ",
    "underfund": "ʌndəfʌnd",
    "underfur": "ʌndəfɜː",
    "undergarment": "ʌndəɡɑːmənt",
    "undergarments": "ʌndəɡɑːmənts",
    "underglaze": "ʌndəɡleɪz",
    "undergoes": "ʌndəɡəʊz",
    "undergoing": "ʌndəɡəʊɪŋ",
    "undergo": "ʌndəɡəʊ",
    "undergone": "ʌndəɡɒn",
    "undergrad": "ʌndəɡræd",
    "undergrads": "ʌndəɡrædz",
    "undergraduate": "ʌndəɡrædjuːət",
    "undergraduates": "ʌndəɡrædjuːəts",
    "undergrounds": "ʌndəɡraʊndz",
    "undergrowth": "ʌndəɡrəʊθ",
    "underhanded": "ʌndəhændɪd",
    "underhand": "ʌndəhænd",
    "underinvestment": "ʌndərɪnvɛstmənt",
    "underlaid": "ʌndəleɪd",
    "underlayer": "ʌndəleɪɐ",
    "underlays": "ʌndəleɪz",
    "underlie": "ʌndəlaɪ",
    "underlies": "ʌndəlaɪz",
    "underlined": "ʌndəlaɪnd",
    "underling": "ʌndɜːlɪŋ",
    "underlings": "ʌndəlɪŋz",
    "underlining": "ʌndəlaɪnɪŋ",
    "underlinings": "ʌndəlaɪnɪŋz",
    "underlying": "ʌndəlaɪɪŋ",
    "undermanned": "ʌndəmænd",
    "undermined": "ʌndəmaɪnd",
    "undermine": "ʌndəmaɪn",
    "underminer": "ʌndəmaɪnɐ",
    "undermines": "ʌndəmaɪnz",
    "undermining": "ʌndəmaɪnɪŋ",
    "under": "ʌndɐ",
    "underneath": "ʌndəniːθ",
    "undernourished": "ʌndənʌrɪʃt",
    "underpaid": "ʌndəpeɪd",
    "underpainting": "ʌndəpeɪntɪŋ",
    "underpants": "ʌndəpɑːnts",
    "underparts": "ʌndəpɑːts",
    "underpasses": "ʌndəpɑːsɪz",
    "underpaying": "ʌndəpeɪɪŋ",
    "underpayment": "ʌndəpeɪmənt",
    "underpayments": "ʌndəpeɪmənts",
    "underpay": "ʌndəpeɪ",
    "underperformed": "ʌndəpəfɔːmd",
    "underpin": "ʌndəpɪn",
    "underpinned": "ʌndəpɪnd",
    "underpinning": "ʌndəpɪnɪŋ",
    "underpinnings": "ʌndəpɪnɪŋz",
    "underpins": "ʌndəpɪnz",
    "underplayed": "ʌndəpleɪd",
    "underplaying": "ʌndəpleɪɪŋ",
    "underplay": "ʌndəpleɪ",
    "underplays": "ʌndəpleɪz",
    "underpopulated": "ʌndəpɒpjʊleɪtɪd",
    "underpowered": "ʌndəpaʊəd",
    "underpricing": "ʌndəpraɪsɪŋ",
    "underprivileged": "ʌndəprɪvɪlɪdʒd",
    "underrated": "ʌndəreɪtɪd",
    "underrate": "ʌndəreɪt",
    "underrates": "ʌndəreɪts",
    "underrating": "ʌndəreɪtɪŋ",
    "underrepresented": "ʌndərɛprɪzɛntɪd",
    "underscored": "ʌndəskɔːd",
    "underscore": "ʌndəskɔː",
    "underscores": "ʌndəskɔːz",
    "underscoring": "ʌndəskɔːrɪŋ",
    "undersea": "ʌndəsiː",
    "undersecretary": "ʌndəsɛkrətri",
    "underselling": "ʌndəsɛlɪŋ",
    "undersell": "ʌndəsɛl",
    "undersells": "ʌndəsɛlz",
    "underset": "ʌndəsɛt",
    "undershirt": "ʌndəʃɜːt",
    "undershooting": "ʌndəʃuːtɪŋ",
    "undershoot": "ʌndəʃuːt",
    "undershorts": "ʌndəʃɔːts",
    "undershot": "ʌndəʃɒt",
    "underside": "ʌndəsaɪd",
    "undersides": "ʌndəsaɪdz",
    "undersigned": "ʌndəsaɪnd",
    "undersized": "ʌndəsaɪzd",
    "undersize": "ʌndəsaɪz",
    "underskirt": "ʌndəskɜːt",
    "undersold": "ʌndəsəʊld",
    "underspending": "ʌndəspɛndɪŋ",
    "underspend": "ʌndəspɛnd",
    "underspent": "ʌndəspɛnt",
    "understaffed": "ʌndəstɑːft",
    "understandable": "ʌndəstændəbəl",
    "understandably": "ʌndəstændəbli",
    "understanding": "ʌndəstændɪŋ",
    "understandings": "ʌndəstændɪŋz",
    "understand": "ʌndəstænd",
    "understands": "ʌndəstændz",
    "understated": "ʌndəsteɪtɪd",
    "understatement": "ʌndəsteɪtmənt",
    "understatements": "ʌndəsteɪtmənts",
    "understate": "ʌndəsteɪt",
    "understates": "ʌndəsteɪts",
    "understating": "ʌndəsteɪtɪŋ",
    "understood": "ʌndəstʊd",
    "understorey": "ʌndəstɔːri",
    "understory": "ʌndəstɔːri",
    "understudied": "ʌndəstʌdɪd",
    "understudies": "ʌndəstʌdɪz",
    "understudying": "ʌndəstʌdɪɪŋ",
    "understudy": "ʌndəstʌdi",
    "undersurface": "ʌndəsɜːfɪs",
    "undertake": "ʌndəteɪk",
    "undertaken": "ʌndəteɪkən",
    "undertaker": "ʌndəteɪkɐ",
    "undertakers": "ʌndəteɪkəz",
    "undertakes": "ʌndəteɪks",
    "underthings": "ʌndəθɪŋz",
    "undertone": "ʌndətəʊn",
    "undertones": "ʌndətəʊnz",
    "undertook": "ʌndətʊk",
    "undertow": "ʌndətəʊ",
    "underused": "ʌndəjuːzd",
    "underutilised": "ʌndəjuːtəlaɪzd",
    "undervaluation": "ʌndəvæljuːeɪʃən",
    "undervalued": "ʌndəvæljuːd",
    "undervalue": "ʌndəvæljuː",
    "undervalues": "ʌndəvæljuːz",
    "undervaluing": "ʌndəvæljuːɪŋ",
    "underwater": "ʌndəwɔːtɐ",
    "underway": "ʌndəweɪ",
    "underwear": "ʌndəweə",
    "underweight": "ʌndəweɪt",
    "underwent": "ʌndəwɛnt",
    "underwhelmed": "ʌndəwɛlmd",
    "underwhelming": "ʌndəwɛlmɪŋ",
    "underwhelm": "ʌndəwɛlm",
    "underwing": "ʌndɜːwərɪŋ",
    "underwings": "ʌndəwɪŋz",
    "underwood": "ʌndəwʊd",
    "underwoods": "ʌndəwʊdz",
    "underworld": "ʌndəwɜːld",
    "underwrite": "ʌndəraɪt",
    "underwriter": "ʌndəraɪtɐ",
    "underwriters": "ʌndəraɪtəz",
    "underwrites": "ʌndəraɪts",
    "underwriting": "ʌndəraɪtɪŋ",
    "underwritten": "ʌndərɪtən",
    "underwrote": "ʌndərəʊt",
    "undeservedly": "ʌndɪzɜːvɪdli",
    "undeserved": "ʌndɪzɜːvd",
    "undeserving": "ʌndɪzɜːvɪŋ",
    "undesirability": "ʌndɪzaɪərəbɪlɪti",
    "undesirable": "ʌndɪzaɪərəbəl",
    "undesirables": "ʌndɪzaɪərəbəlz",
    "undetectable": "ʌndɪtɛktəbəl",
    "undetected": "ʌndɪtɛktɪd",
    "undetermined": "ʌndɪtɜːmɪnd",
    "undeterred": "ʌndɪtɜːd",
    "undeveloped": "ʌndɪvɛləpt",
    "undiagnosed": "ʌndaɪəɡnəʊzd",
    "undid": "ʌndɪd",
    "undies": "ʌndiz",
    "undifferentiated": "ʌndɪfərɛnʃɪeɪtɪd",
    "undigested": "ʌndaɪdʒɛstɪd",
    "undignified": "ʌndɪɡnɪfaɪd",
    "undiluted": "ʌndaɪluːtɪd",
    "undiminished": "ʌndɪmɪnɪʃt",
    "undimmed": "ʌndɪmd",
    "undiplomatic": "ʌndɪpləmætɪk",
    "undirected": "ʌndaɪrɛktɪd",
    "undischarged": "ʌndɪstʃɑːdʒd",
    "undisciplined": "ʌndɪsɪplɪnd",
    "undisclosed": "ʌndɪskləʊzd",
    "undiscovered": "ʌndɪskʌvəd",
    "undisguised": "ʌndɪsɡaɪzd",
    "undismayed": "ʌndɪsmeɪd",
    "undisputed": "ʌndɪspjuːtɪd",
    "undistinguished": "ʌndɪstɪŋɡwɪʃt",
    "undisturbed": "ʌndɪstɜːbd",
    "undivided": "ʌndɪvaɪdɪd",
    "undocumented": "ʌndɒkjuːməntɪd",
    "undoes": "ʌndʌz",
    "undoing": "ʌnduːɪŋ",
    "undomesticated": "ʌndəmɛstɪkeɪtɪd",
    "undo": "ʌnduː",
    "undone": "ʌndʌn",
    "undoubtedly": "ʌndaʊtɪdli",
    "undoubted": "ʌndaʊtɪd",
    "undramatic": "ʌndrəmætɪk",
    "undreamed": "ʌndriːmd",
    "undreamt": "ʌndrɛmpt",
    "undressed": "ʌndrɛst",
    "undresses": "ʌndrɛsɪz",
    "undressing": "ʌndrɛsɪŋ",
    "undress": "ʌndrɛs",
    "undrinkable": "ʌndrɪŋkəbəl",
    "undue": "ʌndjuː",
    "undulant": "ʌndjʊlənt",
    "undulated": "ʌndjʊleɪtɪd",
    "undulate": "ʌndjʊleɪt",
    "undulates": "ʌndjʊleɪts",
    "undulating": "ʌndjʊleɪtɪŋ",
    "undulation": "ʌndjʊleɪʃən",
    "undulations": "ʌndjʊleɪʃənz",
    "unduly": "ʌndjuːli",
    "undyed": "ʌndaɪd",
    "undying": "ʌndaɪɪŋ",
    "unearned": "ʌnɜːnd",
    "unearthed": "ʌnɜːθd",
    "unearthing": "ʌnɜːθɪŋ",
    "unearthly": "ʌnɜːθli",
    "unearth": "ʌnɜːθ",
    "unearths": "ʌnɜːθs",
    "unease": "ʌniːz",
    "uneasily": "ʌniːzɪli",
    "uneasiness": "ʌniːzɪnəs",
    "uneasy": "ʌniːzi",
    "uneatable": "ʌniːtəbəl",
    "uneaten": "ʌniːtən",
    "uneconomical": "ʌniːkənɒmɪkəl",
    "uneconomic": "ʌniːkənɒmɪk",
    "unedifying": "ʌnɛdɪfaɪɪŋ",
    "unedited": "ʌnɛdɪtɪd",
    "uneducated": "ʌnɛdʒuːkeɪtɪd",
    "unelectable": "ʌnɪlɛktəbəl",
    "unelected": "ʌnɪlɛktɪd",
    "unemotional": "ʌnɪməʊʃənəl",
    "unemployable": "ʌnɛmplɔɪəbəl",
    "unemployed": "ʌnɛmplɔɪd",
    "unemployment": "ʌnɛmplɔɪmənt",
    "unenclosed": "ʌnɛnkləʊzd",
    "unencumbered": "ʌnɛnkʌmbəd",
    "unending": "ʌnɛndɪŋ",
    "unendurable": "ʌnɛndjɔːrəbəl",
    "unenforceable": "ʌnɛnfɔːsəbəl",
    "unenforced": "ʌnɛnfɔːst",
    "unengaged": "ʌnɛnɡeɪdʒd",
    "unenjoyable": "ʌnɛndʒɔɪəbəl",
    "unenlightened": "ʌnɛnlaɪtənd",
    "unenthusiastic": "ʌnɛnθjuːzɪæstɪk",
    "unenviable": "ʌnɛnvɪəbəl",
    "unequalled": "ʌniːkwəld",
    "unequally": "ʌniːkwəli",
    "unequal": "ʌniːkwəl",
    "unequipped": "ʌnɪkwɪpt",
    "unequivocally": "ʌnɪkwɪvəkəli",
    "unequivocal": "ʌnɪkwɪvəkəl",
    "unerringly": "ʌnɜːrɪŋli",
    "unerring": "ʌnɜːrɪŋ",
    "unescorted": "ʌnɛskɔːtɪd",
    "unethically": "ʌnɛθɪkli",
    "unethical": "ʌnɛθɪkəl",
    "unevenly": "ʌniːvənli",
    "unevenness": "ʌniːvənnəs",
    "uneven": "ʌniːvən",
    "uneventful": "ʌnɪvɛntfəl",
    "unexamined": "ʌnɛɡzæmɪnd",
    "unexcelled": "ʌnɛksɛld",
    "unexceptional": "ʌnɛksɛpʃənəl",
    "unexcited": "ʌnɛksaɪtɪd",
    "unexciting": "ʌnɛksaɪtɪŋ",
    "unexercised": "ʌnɛksəsaɪzd",
    "unexpectedly": "ʌnɛkspɛktɪdli",
    "unexpected": "ʌnɛkspɛktɪd",
    "unexpired": "ʌnɛkspaɪəd",
    "unexplainable": "ʌnɛkspleɪnəbəl",
    "unexplainably": "ʌnɛkspleɪnəbli",
    "unexplained": "ʌnɛkspleɪnd",
    "unexploded": "ʌnɛkspləʊdɪd",
    "unexploited": "ʌnɛksplɔɪtɪd",
    "unexplored": "ʌnɛksplɔːd",
    "unexposed": "ʌnɛkspəʊzd",
    "unexpressed": "ʌnɛksprɛst",
    "unexpurgated": "ʌnɛkspɜːɡeɪtɪd",
    "unfailingly": "ʌnfeɪlɪŋli",
    "unfailing": "ʌnfeɪlɪŋ",
    "unfairer": "ʌnfeərɐ",
    "unfairly": "ʌnfeəli",
    "unfairness": "ʌnfeənəs",
    "unfair": "ʌnfeə",
    "unfaithful": "ʌnfeɪθfəl",
    "unfaltering": "ʌnfɒltərɪŋ",
    "unfamiliarity": "ʌnfəmɪlɪærɪti",
    "unfamiliar": "ʌnfəmɪliə",
    "unfashionable": "ʌnfæʃənəbəl",
    "unfashionably": "ʌnfæʃənəbli",
    "unfastened": "ʌnfɑːsənd",
    "unfasten": "ʌnfɑːsən",
    "unfathomable": "ʌnfæðəməbəl",
    "unfathomably": "ʌnfæðəməbli",
    "unfavourable": "ʌnfeɪvərəbəl",
    "unfavourably": "ʌnfeɪvərəbli",
    "unfazed": "ʌnfeɪzd",
    "unfeasible": "ʌnfiːzəbəl",
    "unfed": "ʌnfɛd",
    "unfeeling": "ʌnfiːlɪŋ",
    "unfeigned": "ʌnfeɪnd",
    "unfelt": "ʌnfɛlt",
    "unfeminine": "ʌnfɛmənɪn",
    "unfenced": "ʌnfɛnst",
    "unfermented": "ʌnfɜːmɛntɪd",
    "unfertilised": "ʌnfɜːtəlaɪzd",
    "unfettered": "ʌnfɛtəd",
    "unfilled": "ʌnfɪld",
    "unfiltered": "ʌnfɪltəd",
    "unfinished": "ʌnfɪnɪʃt",
    "unfired": "ʌnfaɪəd",
    "unfitness": "ʌnfɪtnəs",
    "unfit": "ʌnfɪt",
    "unfitted": "ʌnfɪtɪd",
    "unfitting": "ʌnfɪtɪŋ",
    "unfixed": "ʌnfɪkst",
    "unfix": "ʌnfɪks",
    "unflagging": "ʌnflæɡɪŋ",
    "unflappable": "ʌnflæpəbəl",
    "unflattering": "ʌnflætərɪŋ",
    "unfledged": "ʌnflɛdʒd",
    "unflinchingly": "ʌnflɪntʃɪŋli",
    "unflinching": "ʌnflɪntʃɪŋ",
    "unfocused": "ʌnfəʊkəsd",
    "unfolded": "ʌnfəʊldɪd",
    "unfolding": "ʌnfəʊldɪŋ",
    "unfold": "ʌnfəʊld",
    "unfolds": "ʌnfəʊldz",
    "unforced": "ʌnfɔːst",
    "unforeseeable": "ʌnfɔːsiːəbəl",
    "unforeseen": "ʌnfɔːsiːn",
    "unforgettable": "ʌnfəɡɛtəbəl",
    "unforgettably": "ʌnfəɡɛtəbli",
    "unforgivable": "ʌnfəɡɪvəbəl",
    "unforgivably": "ʌnfəɡɪvəbli",
    "unforgiven": "ʌnfəɡɪvən",
    "unforgiving": "ʌnfəɡɪvɪŋ",
    "unforgotten": "ʌnfəɡɒtən",
    "unformed": "ʌnfɔːmd",
    "unfortified": "ʌnfɔːtɪfaɪd",
    "unfortunately": "ʌnfɔːtʃənətli",
    "unfortunate": "ʌnfɔːtʃənət",
    "unfortunates": "ʌnfɔːtʃənəts",
    "unfounded": "ʌnfaʊndɪd",
    "unframed": "ʌnfreɪmd",
    "unfree": "ʌnfriː",
    "unfreeze": "ʌnfriːz",
    "unfreezes": "ʌnfriːzɪz",
    "unfreezing": "ʌnfriːzɪŋ",
    "unfriended": "ʌnfrɛndɪd",
    "unfriendliness": "ʌnfrɛndlinəs",
    "unfriendly": "ʌnfrɛndli",
    "unfroze": "ʌnfrəʊz",
    "unfrozen": "ʌnfrəʊzən",
    "unfulfilled": "ʌnfʊlfɪld",
    "unfunded": "ʌnfʌndɪd",
    "unfunny": "ʌnfʌni",
    "unfurled": "ʌnfɜːld",
    "unfurling": "ʌnfɜːlɪŋ",
    "unfurl": "ʌnfɜːl",
    "unfurls": "ʌnfɜːlz",
    "unfurnished": "ʌnfɜːnɪʃt",
    "unfussy": "ʌnfʌsi",
    "ungainly": "ʌnɡeɪnli",
    "ungenerous": "ʌndʒɛnərəs",
    "ungentlemanly": "ʌndʒɛntəlmənli",
    "ungentle": "ʌndʒɛntəl",
    "unglamorous": "ʌnɡlæmərəs",
    "unglazed": "ʌnɡleɪzd",
    "unglued": "ʌnɡluːd",
    "ungodly": "ʌnɡɒdli",
    "ungovernable": "ʌnɡʌvənəbəl",
    "ungoverned": "ʌnɡʌvənd",
    "ungraceful": "ʌnɡreɪsfəl",
    "ungraciously": "ʌnɡreɪʃəsli",
    "ungracious": "ʌnɡreɪʃəs",
    "ungraded": "ʌnɡreɪdɪd",
    "ungrammatical": "ʌnɡrɐmætɪkəl",
    "ungrateful": "ʌnɡreɪtfəl",
    "ungrounded": "ʌnɡraʊndɪd",
    "unguarded": "ʌnɡɑːdɪd",
    "unguent": "ʌnɡənt",
    "unguents": "ʌnɡənts",
    "unguessable": "ʌnɡɪsəbəl",
    "unguided": "ʌnɡaɪdɪd",
    "ungulate": "ʌnɡjʊleɪt",
    "ungulates": "ʌnɡjʊleɪts",
    "unhallowed": "ʌnhæləʊd",
    "unhampered": "ʌnhæmpəd",
    "unhandled": "ʌnhændəld",
    "unhand": "ʌnhænd",
    "unhappier": "ʌnhæpɪɐ",
    "unhappiest": "ʌnhæpɪəst",
    "unhappily": "ʌnhæpɪli",
    "unhappiness": "ʌnhæpɪnəs",
    "unhappy": "ʌnhæpi",
    "unharmed": "ʌnhɑːmd",
    "unhatched": "ʌnhætʃt",
    "unhealed": "ʌnhiːld",
    "unhealthier": "ʌnhɛlθɪɐ",
    "unhealthiest": "ʌnhɛlθɪəst",
    "unhealthily": "ʌnhɛlθɪli",
    "unhealthiness": "ʌnhɛlθɪnəs",
    "unhealthy": "ʌnhɛlθi",
    "unheard": "ʌnhɜːd",
    "unheated": "ʌnhiːtɪd",
    "unheeded": "ʌnhiːdɪd",
    "unhelpfully": "ʌnhɛlpfəli",
    "unhelpful": "ʌnhɛlpfəl",
    "unheralded": "ʌnhɛrəldɪd",
    "unheroic": "ʌnhɪrəʊɪk",
    "unhesitatingly": "ʌnhɛsɪteɪtɪŋli",
    "unhindered": "ʌnhɪndəd",
    "unhinged": "ʌnhɪndʒd",
    "unhinge": "ʌnhɪndʒ",
    "unhistorical": "ʌnhɪstɒrɪkəl",
    "unhitched": "ʌnhɪtʃt",
    "unhitch": "ʌnhɪtʃ",
    "unholy": "ʌnhəʊli",
    "unhooked": "ʌnhʊkt",
    "unhooking": "ʌnhʊkɪŋ",
    "unhook": "ʌnhʊk",
    "unhooks": "ʌnhʊks",
    "unhorsed": "ʌnhɔːsd",
    "unhurried": "ʌnhʌrɪd",
    "unhurt": "ʌnhɜːt",
    "unhygienic": "ʌnhaɪdʒiːnɪk",
    "unicameral": "juːnɪkæmrəl",
    "unicellular": "juːnɪsɛljʊlɐ",
    "unicorn": "juːnɪkɔːn",
    "unicorns": "juːnɪkɔːnz",
    "unicycle": "juːnɪsaɪkəl",
    "unicycles": "juːnɪsaɪkəlz",
    "unicyclist": "juːnɪsaɪklɪst",
    "unicyclists": "juːnɪsaɪklɪsts",
    "unidentifiable": "ʌnaɪdɛntɪfaɪəbəl",
    "unidentified": "ʌnaɪdɛntɪfaɪd",
    "unification": "juːnɪfɪkeɪʃən",
    "unified": "juːnɪfaɪd",
    "unifier": "juːnɪfaɪɐ",
    "unifies": "juːnɪfaɪz",
    "uniformed": "juːnɪfɔːmd",
    "uniformitarianism": "juːnɪfɔːmɪteəriənɪzəm",
    "uniformity": "juːnɪfɔːmɪti",
    "uniform": "juːnɪfɔːm",
    "uniformly": "juːnɪfɔːmli",
    "uniforms": "juːnɪfɔːmz",
    "unifying": "juːnɪfaɪɪŋ",
    "unify": "juːnɪfaɪ",
    "uni": "juːni",
    "unilateralism": "juːnɪlætərəlɪzəm",
    "unilateralist": "juːnɪlætərəlɪst",
    "unilateral": "juːnɪlætərəl",
    "unilaterally": "juːnɪlætərəli",
    "unimaginable": "ʌnɪmædʒɪnəbəl",
    "unimaginably": "ʌnɪmædʒɪnəbli",
    "unimaginatively": "ʌnɪmædʒɪnətɪvli",
    "unimaginative": "ʌnɪmædʒɪnətɪv",
    "unimagined": "ʌnɪmædʒɪnd",
    "unimpaired": "ʌnɪmpeəd",
    "unimpeachable": "ʌnɪmpiːtʃəbəl",
    "unimpeachably": "ʌnɪmpiːtʃəbli",
    "unimpeded": "ʌnɪmpiːdɪd",
    "unimportance": "ʌnɪmpɔːtəns",
    "unimportant": "ʌnɪmpɔːtənt",
    "unimpressed": "ʌnɪmprɛst",
    "unimpressive": "ʌnɪmprɛsɪv",
    "unimproved": "ʌnɪmpruːvd",
    "unincorporated": "ʌnɪnkɔːpəreɪtɪd",
    "uninfected": "ʌnɪnfɛktɪd",
    "uninformed": "ʌnɪnfɔːmd",
    "uninhabitable": "ʌnɪnhæbɪtəbəl",
    "uninhabited": "ʌnɪnhæbɪtɪd",
    "uninhibited": "ʌnɪnhɪbɪtɪd",
    "uninitiated": "ʌnɪnɪʃɪeɪtɪd",
    "uninjured": "ʌnɪndʒəd",
    "uninspired": "ʌnɪnspaɪəd",
    "uninspiring": "ʌnɪnspaɪərɪŋ",
    "uninstall": "ʌnɪnstɔːl",
    "uninsulated": "ʌnɪnsjʊleɪtɪd",
    "uninsurable": "ʌnɪnʃɔːrəbəl",
    "uninsured": "ʌnɪnʃɔːd",
    "unintelligent": "ʌnɪntɛlɪdʒənt",
    "unintelligible": "ʌnɪntɛlɪdʒəbəl",
    "unintended": "ʌnɪntɛndɪd",
    "unintentionally": "ʌnɪntɛnʃənəli",
    "unintentional": "ʌnɪntɛnʃənəl",
    "uninterested": "ʌnɪntərəstɪd",
    "uninteresting": "ʌnɪntərəstɪŋ",
    "uninterrupted": "ʌnɪntərʌptɪd",
    "uninvited": "ʌnɪnvaɪtɪd",
    "uninviting": "ʌnɪnvaɪtɪŋ",
    "uninvolved": "ʌnɪnvɒlvd",
    "unionise": "juːniənaɪz",
    "unionism": "juːniənɪzəm",
    "unionist": "juːniənɪst",
    "unionists": "juːniənɪsts",
    "union": "juːniən",
    "unions": "juːniənz",
    "unique": "juːniːk",
    "uniquely": "juːniːkli",
    "uniqueness": "juːniːknəs",
    "unisex": "juːnɪsɛks",
    "unis": "juːniz",
    "unison": "juːnɪsən",
    "unitary": "juːnɪtəri",
    "united": "juːnaɪtɪd",
    "unite": "juːnaɪt",
    "unites": "juːnaɪts",
    "unities": "juːnɪtɪz",
    "uniting": "juːnaɪtɪŋ",
    "unit": "juːnɪt",
    "units": "juːnɪts",
    "unity": "juːnɪti",
    "universalism": "juːnɪvɜːsəlɪzəm",
    "universalist": "juːnɪvɜːsəlɪst",
    "universality": "juːnɪvɜːsælɪti",
    "universal": "juːnɪvɜːsəl",
    "universally": "juːnɪvɜːsəli",
    "universals": "juːnɪvɜːsəlz",
    "universe": "juːnɪvɜːs",
    "universes": "juːnɪvɜːsɪz",
    "universities": "juːnɪvɜːsɪtiz",
    "university": "juːnɪvɜːsɪti",
    "univocal": "juːnɪvɒkəl",
    "unjam": "ʌndʒæm",
    "unjustifiable": "ʌndʒʌstɪfaɪəbəl",
    "unjustifiably": "ʌndʒʌstɪfaɪəbli",
    "unjustified": "ʌndʒʌstɪfaɪd",
    "unjustly": "ʌndʒʌstli",
    "unjust": "ʌndʒʌst",
    "unkempt": "ʌnkɛmpt",
    "unkept": "ʌnkɛpt",
    "unkindest": "ʌnkaɪndəst",
    "unkindly": "ʌnkaɪndli",
    "unkindness": "ʌnkaɪndnəs",
    "unkind": "ʌnkaɪnd",
    "unkissed": "ʌnkɪst",
    "unknot": "ʌnnɒt",
    "unknotted": "ʌnnɒtɪd",
    "unknotting": "ʌnnɒtɪŋ",
    "unknowable": "ʌnnəʊəbəl",
    "unknowingly": "ʌnnəʊɪŋli",
    "unknowing": "ʌnnəʊɪŋ",
    "unknown": "ʌnnəʊn",
    "unknowns": "ʌnnəʊnz",
    "unlabelled": "ʌnleɪbəld",
    "unlace": "ʌnleɪs",
    "unladylike": "ʌnleɪdɪlaɪk",
    "unlamented": "ʌnlɐmɛntɪd",
    "unlatched": "ʌnlætʃt",
    "unlawfully": "ʌnlɔːfəli",
    "unlawful": "ʌnlɔːfəl",
    "unleaded": "ʌnlɛdɪd",
    "unlearned": "ʌnlɜːnd",
    "unlearning": "ʌnlɜːnɪŋ",
    "unlearn": "ʌnlɜːn",
    "unleashed": "ʌnliːʃt",
    "unleashes": "ʌnliːʃɪz",
    "unleashing": "ʌnliːʃɪŋ",
    "unleash": "ʌnliːʃ",
    "unleavened": "ʌnlɛvənd",
    "unless": "ʌnlɛs",
    "unlettered": "ʌnlɛtəd",
    "unlicensed": "ʌnlaɪsənsd",
    "unlikable": "ʌnlaɪkəbəl",
    "unlikeable": "ʌnlaɪkəbəl",
    "unlikeliest": "ʌnlaɪkliəst",
    "unlikelihood": "ʌnlaɪklihʊd",
    "unlikely": "ʌnlaɪkli",
    "unlike": "ʌnlaɪk",
    "unlimited": "ʌnlɪmɪtɪd",
    "unlined": "ʌnlaɪnd",
    "unlinked": "ʌnlɪŋkt",
    "unlisted": "ʌnlɪstɪd",
    "unlit": "ʌnlɪt",
    "unlivable": "ʌnlɪvəbəl",
    "unlived": "ʌnlɪvd",
    "unloaded": "ʌnləʊdɪd",
    "unloading": "ʌnləʊdɪŋ",
    "unload": "ʌnləʊd",
    "unloads": "ʌnləʊdz",
    "unlocked": "ʌnlɒkt",
    "unlocking": "ʌnlɒkɪŋ",
    "unlock": "ʌnlɒk",
    "unlocks": "ʌnlɒks",
    "unloose": "ʌnluːs",
    "unloosen": "ʌnluːsən",
    "unlovable": "ʌnlʌvəbəl",
    "unloved": "ʌnlʌvd",
    "unlovely": "ʌnlʌvli",
    "unloving": "ʌnlʌvɪŋ",
    "unluckier": "ʌnlʌkiɐ",
    "unluckiest": "ʌnlʌkiəst",
    "unluckily": "ʌnlʌkili",
    "unluckiness": "ʌnlʌkinəs",
    "unlucky": "ʌnlʌki",
    "unmade": "ʌnmeɪd",
    "unmaintained": "ʌnmeɪnteɪnd",
    "unmake": "ʌnmeɪk",
    "unmaking": "ʌnmeɪkɪŋ",
    "unmanageable": "ʌnmænɪdʒəbəl",
    "unmanly": "ʌnmænli",
    "unmanned": "ʌnmænd",
    "unmannerly": "ʌnmænəli",
    "unmapped": "ʌnmæpt",
    "unmarked": "ʌnmɑːkt",
    "unmarketable": "ʌnmɑːkɪtəbəl",
    "unmarred": "ʌnmɑːd",
    "unmarriageable": "ʌnmærɪdʒəbəl",
    "unmarried": "ʌnmærɪd",
    "unmasked": "ʌnmɑːskt",
    "unmasking": "ʌnmɑːskɪŋ",
    "unmask": "ʌnmɑːsk",
    "unmasks": "ʌnmɑːsks",
    "unmatchable": "ʌnmætʃəbəl",
    "unmatched": "ʌnmætʃt",
    "unmeaning": "ʌnmiːnɪŋ",
    "unmeasurable": "ʌnmɛʒərəbəl",
    "unmediated": "ʌnmiːdɪeɪtɪd",
    "unmelted": "ʌnmɛltɪd",
    "unmemorable": "ʌnmɛmərəbəl",
    "unmentionable": "ʌnmɛnʃənəbəl",
    "unmentionables": "ʌnmɛnʃənəbəlz",
    "unmentioned": "ʌnmɛnʃənd",
    "unmercifully": "ʌnmɜːsɪfəli",
    "unmerciful": "ʌnmɜːsɪfəl",
    "unmet": "ʌnmɛt",
    "unmissable": "ʌnmɪsəbəl",
    "unmistakable": "ʌnmɪsteɪkəbəl",
    "unmistakably": "ʌnmɪsteɪkəbli",
    "unmistakeable": "ʌnmɪsteɪkəbəl",
    "unmistakeably": "ʌnmɪsteɪkəbli",
    "unmitigatedly": "ʌnmɪtɪɡeɪtɪdli",
    "unmitigated": "ʌnmɪtɪɡeɪtɪd",
    "unmixed": "ʌnmɪkst",
    "unmodified": "ʌnmɒdɪfaɪd",
    "unmolested": "ʌnməlɛstɪd",
    "unmonitored": "ʌnmɒnɪtəd",
    "unmotivated": "ʌnməʊtɪveɪtɪd",
    "unmounted": "ʌnmaʊntɪd",
    "unmourned": "ʌnmɔːnd",
    "unmoved": "ʌnmuːvd",
    "unmoving": "ʌnmuːvɪŋ",
    "unmown": "ʌnməʊn",
    "unmusical": "ʌnmjuːzɪkəl",
    "unmuzzled": "ʌnmʌzəld",
    "unnameable": "ʌnneɪməbəl",
    "unnamed": "ʌnneɪmd",
    "unnaturally": "ʌnnætʃərəli",
    "unnatural": "ʌnnætʃərəl",
    "unnavigable": "ʌnnævaɪdʒəbəl",
    "unnecessarily": "ʌnnɛsɪsɛrəli",
    "unnecessary": "ʌnnɛsəsəri",
    "unneeded": "ʌnniːdɪd",
    "unnerved": "ʌnnɜːvd",
    "unnerve": "ʌnnɜːv",
    "unnerves": "ʌnnɜːvz",
    "unnervingly": "ʌnnɜːvɪŋli",
    "unnerving": "ʌnnɜːvɪŋ",
    "unnoticeable": "ʌnnəʊtɪsəbəl",
    "unnoticed": "ʌnnəʊtɪsd",
    "unnumbered": "ʌnnʌmbəd",
    "unobservable": "ʌnɒbzɜːvəbəl",
    "unobservant": "ʌnɒbzɜːvənt",
    "unobserved": "ʌnɒbzɜːvd",
    "unobstructed": "ʌnɒbstrʌktɪd",
    "unobtainable": "ʌnɒbteɪnəbəl",
    "unobtrusively": "ʌnɒbtruːsɪvli",
    "unobtrusive": "ʌnɒbtruːsɪv",
    "unoccupied": "ʌnɒkjʊpaɪd",
    "unofficially": "ʌnəfɪʃəli",
    "unofficial": "ʌnəfɪʃəl",
    "unopened": "ʌnəʊpənd",
    "unopposed": "ʌnəpəʊzd",
    "unorganised": "ʌnɔːɡɐnaɪzd",
    "unoriginality": "ʌnərɪdʒɪnælɪti",
    "unoriginal": "ʌnərɪdʒɪnəl",
    "unorthodox": "ʌnɔːθədɒks",
    "unostentatious": "ʌnɒstənteɪʃəs",
    "unpacked": "ʌnpækt",
    "unpacking": "ʌnpækɪŋ",
    "unpack": "ʌnpæk",
    "unpacks": "ʌnpæks",
    "unpaid": "ʌnpeɪd",
    "unpainted": "ʌnpeɪntɪd",
    "unpalatable": "ʌnpælətəbəl",
    "unparalleled": "ʌnpærəlɛld",
    "unpardonable": "ʌnpɑːdəʊnəbəl",
    "unpardonably": "ʌnpɑːdəʊnəbli",
    "unparliamentary": "ʌnpɑːləmɛntəri",
    "unpasteurised": "ʌnpɑːstjuːraɪzd",
    "unpatriotic": "ʌnpætrɪɒtɪk",
    "unpaved": "ʌnpeɪvd",
    "unpeeled": "ʌnpiːld",
    "unpeople": "ʌnpiːpəl",
    "unperson": "ʌnpɜːsən",
    "unpersuaded": "ʌnpəsweɪdɪd",
    "unperturbed": "ʌnpətɜːbd",
    "unpicked": "ʌnpɪkt",
    "unpicking": "ʌnpɪkɪŋ",
    "unpick": "ʌnpɪk",
    "unpicks": "ʌnpɪks",
    "unpin": "ʌnpɪn",
    "unplaced": "ʌnpleɪst",
    "unplanned": "ʌnplænd",
    "unplayable": "ʌnpleɪəbəl",
    "unplayed": "ʌnpleɪd",
    "unpleasantly": "ʌnplɛzəntli",
    "unpleasantness": "ʌnplɛzəntnəs",
    "unpleasant": "ʌnplɛzənt",
    "unpleased": "ʌnpliːzd",
    "unpleasing": "ʌnpliːzɪŋ",
    "unploughed": "ʌnplaʊd",
    "unplugged": "ʌnplʌɡd",
    "unplugging": "ʌnplʌɡɪŋ",
    "unplug": "ʌnplʌɡ",
    "unplumbed": "ʌnplʌmd",
    "unpolished": "ʌnpɒlɪʃt",
    "unpolitical": "ʌnpəlɪtɪkəl",
    "unpolluted": "ʌnpəluːtɪd",
    "unpopularity": "ʌnpɒpjʊlærɪti",
    "unpopular": "ʌnpɒpjʊlɐ",
    "unpopulated": "ʌnpɒpjʊleɪtɪd",
    "unposed": "ʌnpəʊzd",
    "unpractical": "ʌnpræktɪkəl",
    "unpractised": "ʌnpræktɪsd",
    "unprecedentedly": "ʌnprɪsɛdəntɪdli",
    "unprecedented": "ʌnprɛsɪdəntɪd",
    "unpredictability": "ʌnprɪdɪktəbɪlɪti",
    "unpredictable": "ʌnprɪdɪktəbəl",
    "unpredictably": "ʌnprɪdɪktəbli",
    "unpredicted": "ʌnprɪdɪktɪd",
    "unprejudiced": "ʌnprɛdʒuːdɪst",
    "unprepared": "ʌnprɪpeəd",
    "unprepossessing": "ʌnprɪpəzɛsɪŋ",
    "unpresentable": "ʌnprɪzɛntəbəl",
    "unpressurised": "ʌnprɛʃəraɪzd",
    "unpretentious": "ʌnprɪtɛnʃəs",
    "unprincipled": "ʌnprɪnsɪpəld",
    "unprintable": "ʌnprɪntəbəl",
    "unprivileged": "ʌnprɪvɪlɪdʒd",
    "unproblematic": "ʌnprɒbəlmætɪk",
    "unprocessed": "ʌnprəʊsɛst",
    "unproductive": "ʌnprədʌktɪv",
    "unprofessionally": "ʌnprəfɛʃənəli",
    "unprofessional": "ʌnprəfɛʃənəl",
    "unprofitable": "ʌnprɒfɪtəbəl",
    "unpromising": "ʌnprɒmɪsɪŋ",
    "unprompted": "ʌnprɒmptɪd",
    "unpronounceable": "ʌnprənaʊnsəbəl",
    "unprotected": "ʌnprətɛktɪd",
    "unprovable": "ʌnpruːvəbəl",
    "unproved": "ʌnpruːvd",
    "unproven": "ʌnpruːvən",
    "unprovoked": "ʌnprəvəʊkt",
    "unpublicised": "ʌnpʌblɪsaɪzd",
    "unpublishable": "ʌnpʌblɪʃəbəl",
    "unpublished": "ʌnpʌblɪʃt",
    "unpunctual": "ʌnpʌŋktʃuːəl",
    "unpunished": "ʌnpʌnɪʃt",
    "unqualified": "ʌnkwɒlɪfaɪd",
    "unquantifiable": "ʌnkwɒntɪfaɪəbəl",
    "unquantified": "ʌnkwɒntɪfaɪd",
    "unquenchable": "ʌnkwɛntʃəbəl",
    "unquestionable": "ʌnkwɛstʃənəbəl",
    "unquestionably": "ʌnkwɛstʃənəbli",
    "unquestioned": "ʌnkwɛstʃənd",
    "unquestioningly": "ʌnkwɛstʃənɪŋli",
    "unquestioning": "ʌnkwɛstʃənɪŋ",
    "unquiet": "ʌnkwaɪət",
    "unquote": "ʌnkwəʊt",
    "unraised": "ʌnreɪzd",
    "unravelled": "ʌnrævəld",
    "unravelling": "ʌnrævəlɪŋ",
    "unravel": "ʌnrævəl",
    "unravels": "ʌnrævəlz",
    "unreachable": "ʌnriːtʃəbəl",
    "unreadable": "ʌnriːdəbəl",
    "unread": "ʌnrɛd",
    "unready": "ʌnrɛdi",
    "unrealised": "ʌnriəlaɪzd",
    "unrealistically": "ʌnriəlɪstɪkli",
    "unrealistic": "ʌnriəlɪstɪk",
    "unreality": "ʌnrɪælɪti",
    "unreal": "ʌnriəl",
    "unreasonableness": "ʌnriːzənəbəlnəs",
    "unreasonable": "ʌnriːzənəbəl",
    "unreasonably": "ʌnriːzənəbli",
    "unreasoning": "ʌnriːzənɪŋ",
    "unreason": "ʌnriːzən",
    "unreceptive": "ʌnrɪsɛptɪv",
    "unrecognisable": "ʌnrɛkəɡnaɪzəbəl",
    "unrecognisably": "ʌnrɛkəɡnaɪzəbli",
    "unrecognised": "ʌnrɛkəɡnaɪzd",
    "unreconciled": "ʌnrɛkənsaɪld",
    "unreconstructed": "ʌnriːkənstrʌktɪd",
    "unrecorded": "ʌnrɪkɔːdɪd",
    "unredeemed": "ʌnrɪdiːmd",
    "unrefined": "ʌnrɪfaɪnd",
    "unreflective": "ʌnrɪflɛktɪv",
    "unreformed": "ʌnrɪfɔːmd",
    "unregarded": "ʌnrɪɡɑːdɪd",
    "unregistered": "ʌnrɛdʒɪstəd",
    "unregulated": "ʌnrɛɡjuːleɪtɪd",
    "unrehearsed": "ʌnrɪhɜːsd",
    "unrelated": "ʌnrɪleɪtɪd",
    "unreleased": "ʌnrɪliːsd",
    "unrelentingly": "ʌnrɪlɛntɪŋli",
    "unrelenting": "ʌnrɪlɛntɪŋ",
    "unreliability": "ʌnrɪlaɪəbɪlɪti",
    "unreliable": "ʌnrɪlaɪəbəl",
    "unrelieved": "ʌnrɪliːvd",
    "unremarkable": "ʌnrɪmɑːkəbəl",
    "unremarked": "ʌnrɪmɑːkt",
    "unremembered": "ʌnrɪmɛmbəd",
    "unremittingly": "ʌnriːmɪtɪŋli",
    "unremitting": "ʌnriːmɪtɪŋ",
    "unrepairable": "ʌnrɪpeərəbəl",
    "unrepeatable": "ʌnrɪpiːtəbəl",
    "unrepentant": "ʌnrɪpɛntənt",
    "unreported": "ʌnrɪpɔːtɪd",
    "unrepresentative": "ʌnrɛprɪzɛntətɪv",
    "unrepresented": "ʌnrɛprɪzɛntɪd",
    "unrequited": "ʌnrɪkwaɪtɪd",
    "unreservedly": "ʌnrɪsɜːvɪdli",
    "unreserved": "ʌnrɪsɜːvd",
    "unresolvable": "ʌnrɪzɒlvəbəl",
    "unresolved": "ʌnrɪzɒlvd",
    "unresponsive": "ʌnrɪspɒnsɪv",
    "unrest": "ʌnrɛst",
    "unrestrained": "ʌnrɪstreɪnd",
    "unrestricted": "ʌnrɪstrɪktɪd",
    "unreturnable": "ʌnrɪtɜːnəbəl",
    "unreturned": "ʌnrɪtɜːnd",
    "unrewarded": "ʌnrɪwɔːdɪd",
    "unrewarding": "ʌnrɪwɔːdɪŋ",
    "unrhymed": "ʌnraɪmd",
    "unrighteous": "ʌnraɪtʃəs",
    "unripe": "ʌnraɪp",
    "unrivalled": "ʌnraɪvəld",
    "unrolled": "ʌnrəʊld",
    "unrolling": "ʌnrəʊlɪŋ",
    "unroll": "ʌnrəʊl",
    "unromantic": "ʌnrəʊmæntɪk",
    "unruffled": "ʌnrʌfəld",
    "unruliness": "ʌnruːlinəs",
    "unruly": "ʌnruːli",
    "unsaddle": "ʌnsædəl",
    "unsaddling": "ʌnsædlɪŋ",
    "unsafely": "ʌnseɪfli",
    "unsafe": "ʌnseɪf",
    "unsaid": "ʌnsɛd",
    "unsalable": "ʌnseɪləbəl",
    "unsaleable": "ʌnseɪləbəl",
    "unsalted": "ʌnsɒltɪd",
    "unsanctioned": "ʌnsɑːnkʃənd",
    "unsanitary": "ʌnsænɪtəri",
    "unsatisfactory": "ʌnsætɪsfæktəri",
    "unsatisfied": "ʌnsætɪsfaɪd",
    "unsatisfying": "ʌnsætɪsfaɪɪŋ",
    "unsaturated": "ʌnsætʃəreɪtɪd",
    "unsaved": "ʌnseɪvd",
    "unsavoury": "ʌnseɪvɜːri",
    "unsay": "ʌnseɪ",
    "unscarred": "ʌnskɑːd",
    "unscathed": "ʌnskeɪðd",
    "unscheduled": "ʌnʃɛdjuːld",
    "unschooled": "ʌnskuːld",
    "unscientific": "ʌnsaɪəntɪfɪk",
    "unscrambled": "ʌnskræmbəld",
    "unscramble": "ʌnskræmbəl",
    "unscrambling": "ʌnskræmblɪŋ",
    "unscratched": "ʌnskrætʃt",
    "unscrewed": "ʌnskruːd",
    "unscrewing": "ʌnskruːɪŋ",
    "unscrew": "ʌnskruː",
    "unscrews": "ʌnskruːz",
    "unscripted": "ʌnskrɪptɪd",
    "unscrupulously": "ʌnskruːpjʊləsli",
    "unscrupulous": "ʌnskruːpjʊləs",
    "unsealed": "ʌnsiːld",
    "unseal": "ʌnsiːl",
    "unsearchable": "ʌnsɜːtʃəbəl",
    "unseasonable": "ʌnsiːzənəbəl",
    "unseasonably": "ʌnsiːzənəbli",
    "unseasonal": "ʌnsiːzənəl",
    "unseasoned": "ʌnsiːzənd",
    "unseated": "ʌnsiːtɪd",
    "unseating": "ʌnsiːtɪŋ",
    "unseat": "ʌnsiːt",
    "unseats": "ʌnsiːts",
    "unseaworthy": "ʌnsiːwɜːði",
    "unsecured": "ʌnsɪkjɔːd",
    "unseeded": "ʌnsiːdɪd",
    "unseeing": "ʌnsiːɪŋ",
    "unseemly": "ʌnsiːmli",
    "unseen": "ʌnsiːn",
    "unsegmented": "ʌnsɛɡmɛntɪd",
    "unselfconsciously": "ʌnsɛlfkɒnʃəsli",
    "unselfconscious": "ʌnsɛlfkɒnʃəs",
    "unselfishly": "ʌnsɛlfɪʃli",
    "unselfishness": "ʌnsɛlfɪʃnəs",
    "unselfish": "ʌnsɛlfɪʃ",
    "unsellable": "ʌnsɛləbəl",
    "unsentimental": "ʌnsɛntɪmɛntəl",
    "unsent": "ʌnsɛnt",
    "unserious": "ʌnsiərɪəs",
    "unserviceable": "ʌnsɜːvɪsəbəl",
    "unset": "ʌnsɛt",
    "unsettled": "ʌnsɛtəld",
    "unsettle": "ʌnsɛtəl",
    "unsettles": "ʌnsɛtəlz",
    "unsettlingly": "ʌnsɛtəlɪŋli",
    "unsettling": "ʌnsɛtlɪŋ",
    "unsexed": "ʌnsɛkst",
    "unsex": "ʌnsɛks",
    "unshackled": "ʌnʃækəld",
    "unshakable": "ʌnʃeɪkəbəl",
    "unshakeable": "ʌnʃeɪkəbəl",
    "unshaken": "ʌnʃeɪkən",
    "unshaped": "ʌnʃeɪpt",
    "unshaven": "ʌnʃeɪvən",
    "unsheathed": "ʌnʃiːðd",
    "unsheathe": "ʌnʃiːð",
    "unshockable": "ʌnʃɒkəbəl",
    "unsighted": "ʌnsaɪtɪd",
    "unsightly": "ʌnsaɪtli",
    "unsigned": "ʌnsaɪnd",
    "unsinkable": "ʌnsɪŋkəbəl",
    "unskilled": "ʌnskɪld",
    "unsliced": "ʌnslaɪst",
    "unsmiling": "ʌnsmaɪlɪŋ",
    "unsociable": "ʌnsəʊʃiəbəl",
    "unsocial": "ʌnsəʊʃəl",
    "unsoiled": "ʌnsɔɪld",
    "unsold": "ʌnsəʊld",
    "unsolicited": "ʌnsəlɪsɪtɪd",
    "unsolvable": "ʌnsɒlvəbəl",
    "unsolved": "ʌnsɒlvd",
    "unsophisticated": "ʌnsəfɪstɪkeɪtɪd",
    "unsorted": "ʌnsɔːtɪd",
    "unsound": "ʌnsaʊnd",
    "unsparingly": "ʌnspeərɪŋli",
    "unsparing": "ʌnspeərɪŋ",
    "unspeakable": "ʌnspiːkəbəl",
    "unspeakably": "ʌnspiːkəbli",
    "unspecific": "ʌnspəsɪfɪk",
    "unspecified": "ʌnspɛsɪfaɪd",
    "unspectacular": "ʌnspɛktækjʊlɐ",
    "unspent": "ʌnspɛnt",
    "unspiritual": "ʌnspɪrɪtʃuːəl",
    "unspoiled": "ʌnspɔɪld",
    "unspoilt": "ʌnspɔɪlt",
    "unspoken": "ʌnspəʊkən",
    "unsporting": "ʌnspɔːtɪŋ",
    "unsportsmanlike": "ʌnspɔːtsmənlaɪk",
    "unspotted": "ʌnspɒtɪd",
    "unsprung": "ʌnsprʌŋ",
    "unstable": "ʌnsteɪbəl",
    "unstained": "ʌnsteɪnd",
    "unsteadily": "ʌnstɛdɪli",
    "unsteadiness": "ʌnstɛdɪnəs",
    "unsteady": "ʌnstɛdi",
    "unsticking": "ʌnstɪkɪŋ",
    "unstick": "ʌnstɪk",
    "unstintingly": "ʌnstɪntɪŋli",
    "unstinting": "ʌnstɪntɪŋ",
    "unstirred": "ʌnstɜːd",
    "unstoppable": "ʌnstɒpəbəl",
    "unstrap": "ʌnstræp",
    "unstrapped": "ʌnstræpt",
    "unstressed": "ʌnstrɛst",
    "unstructured": "ʌnstrʌktʃəd",
    "unstrung": "ʌnstrʌŋ",
    "unstuck": "ʌnstʌk",
    "unstudied": "ʌnstʌdɪd",
    "unstylish": "ʌnstaɪlɪʃ",
    "unsubscribe": "ʌnsəbskraɪb",
    "unsubsidised": "ʌnsʌbsɪdaɪzd",
    "unsubstantiated": "ʌnsəbstænʃɪeɪtɪd",
    "unsubtle": "ʌnsʌtəl",
    "unsubtly": "ʌnsʌtəli",
    "unsuccessfully": "ʌnsəksɛsfəli",
    "unsuccessful": "ʌnsəksɛsfəl",
    "unsuitability": "ʌnsuːtəbɪlɪti",
    "unsuitable": "ʌnsuːtəbəl",
    "unsuitably": "ʌnsuːtəbli",
    "unsuited": "ʌnsuːtɪd",
    "unsullied": "ʌnsʌlid",
    "unsung": "ʌnsʌŋ",
    "unsupervised": "ʌnsuːpəvaɪzd",
    "unsupportable": "ʌnsəpɔːtəbəl",
    "unsupported": "ʌnsəpɔːtɪd",
    "unsuppressed": "ʌnsəprɛst",
    "unsure": "ʌnʃɔː",
    "unsurpassable": "ʌnsəpɑːsəbəl",
    "unsurpassed": "ʌnsəpɑːst",
    "unsurprised": "ʌnsəpraɪzd",
    "unsurprisingly": "ʌnsəpraɪzɪŋli",
    "unsurprising": "ʌnsəpraɪzɪŋ",
    "unsuspected": "ʌnsəspɛktɪd",
    "unsuspecting": "ʌnsəspɛktɪŋ",
    "unsustainable": "ʌnsəsteɪnəbəl",
    "unsweetened": "ʌnswiːtənd",
    "unswervingly": "ʌnswɜːvɪŋli",
    "unswerving": "ʌnswɜːvɪŋ",
    "unsympathetic": "ʌnsɪmpəθɛtɪk",
    "untagged": "ʌntæɡd",
    "untainted": "ʌnteɪntɪd",
    "untalented": "ʌntæləntɪd",
    "untamed": "ʌnteɪmd",
    "untangled": "ʌntæŋɡəld",
    "untangle": "ʌntæŋɡəl",
    "untangles": "ʌntæŋɡəlz",
    "untangling": "ʌntæŋɡəlɪŋ",
    "untapped": "ʌntæpt",
    "untarnished": "ʌntɑːnɪʃt",
    "untasted": "ʌnteɪstɪd",
    "untasteful": "ʌnteɪstfəl",
    "untaught": "ʌntɔːt",
    "untaxed": "ʌntækst",
    "unteachable": "ʌntiːtʃəbəl",
    "unteach": "ʌntiːtʃ",
    "untempered": "ʌntɛmpəd",
    "untenable": "ʌntɛnəbəl",
    "untenanted": "ʌntɛnəntɪd",
    "untended": "ʌntɛndɪd",
    "untested": "ʌntɛstɪd",
    "untethered": "ʌntɛðəd",
    "unthankful": "ʌnθæŋkfəl",
    "unthinkable": "ʌnθɪŋkəbəl",
    "unthinkably": "ʌnθɪŋkəbli",
    "unthinkingly": "ʌnθɪŋkɪŋli",
    "unthinking": "ʌnθɪŋkɪŋ",
    "unthought": "ʌnθɔːt",
    "unthread": "ʌnθrɛd",
    "untidier": "ʌntaɪdiɐ",
    "untidiest": "ʌntaɪdiəst",
    "untidily": "ʌntaɪdili",
    "untidiness": "ʌntaɪdinəs",
    "untidy": "ʌntaɪdi",
    "untied": "ʌntaɪd",
    "untie": "ʌntaɪ",
    "unties": "ʌntaɪz",
    "until": "ʌntɪl",
    "untimely": "ʌntaɪmli",
    "untiring": "ʌntaɪərɪŋ",
    "untitled": "ʌntaɪtəld",
    "untold": "ʌntəʊld",
    "unto": "ʌntʊ",
    "untouchable": "ʌntʌtʃəbəl",
    "untouchables": "ʌntʌtʃəbəlz",
    "untouched": "ʌntʌtʃt",
    "untoward": "ʌntʊwɔːd",
    "untraceable": "ʌntreɪsəbəl",
    "untraditional": "ʌntrɐdɪʃənəl",
    "untrained": "ʌntreɪnd",
    "untrammelled": "ʌntræməld",
    "untranslated": "ʌntrænsleɪtɪd",
    "untreatable": "ʌntriːtəbəl",
    "untreated": "ʌntriːtɪd",
    "untried": "ʌntraɪd",
    "untrimmed": "ʌntrɪmd",
    "untrodden": "ʌntrɒdən",
    "untroubled": "ʌntrʌbəld",
    "untrue": "ʌntruː",
    "untrustworthy": "ʌntrʌstwɜːði",
    "untruthful": "ʌntruːθfəl",
    "untruth": "ʌntruːθ",
    "untruths": "ʌntruːθs",
    "untuck": "ʌntʌk",
    "untuned": "ʌntjuːnd",
    "unturned": "ʌntɜːnd",
    "untutored": "ʌntjuːtəd",
    "untwisted": "ʌntwɪstɪd",
    "untwisting": "ʌntwɪstɪŋ",
    "untwist": "ʌntwɪst",
    "untying": "ʌntaɪɪŋ",
    "untypical": "ʌntɪpɪkəl",
    "unusable": "ʌnjuːzəbəl",
    "unusually": "ʌnjuːʒuːəli",
    "unusual": "ʌnjuːʒuːəl",
    "unutterable": "ʌnʌtərəbəl",
    "unutterably": "ʌnʌtərəbli",
    "unvalued": "ʌnvæljuːd",
    "unvarnished": "ʌnvɑːnɪʃt",
    "unvarying": "ʌnveəriɪŋ",
    "unveiled": "ʌnveɪld",
    "unveiling": "ʌnveɪlɪŋ",
    "unveil": "ʌnveɪl",
    "unveils": "ʌnveɪlz",
    "unventilated": "ʌnvɛntɪleɪtɪd",
    "unverifiable": "ʌnvɛrɪfaɪəbəl",
    "unverified": "ʌnvɛrɪfaɪd",
    "unversed": "ʌnvɜːsd",
    "unvisited": "ʌnvɪzɪtɪd",
    "unwanted": "ʌnwɒntɪd",
    "unwarranted": "ʌnwɒrəntɪd",
    "unwary": "ʌnweəri",
    "unwashed": "ʌnwɒʃt",
    "unwatchable": "ʌnwɒtʃəbəl",
    "unwatched": "ʌnwɒtʃt",
    "unwavering": "ʌnweɪvərɪŋ",
    "unwearable": "ʌnweərəbəl",
    "unwearied": "ʌnwiərɪd",
    "unwed": "ʌnwɛd",
    "unwelcome": "ʌnwɛlkʌm",
    "unwelcoming": "ʌnwɛlkʌmɪŋ",
    "unwell": "ʌnwɛl",
    "unwholesome": "ʌnhəʊlsʌm",
    "unwieldy": "ʌnwiːldi",
    "unwillingly": "ʌnwɪlɪŋli",
    "unwillingness": "ʌnwɪlɪŋnəs",
    "unwilling": "ʌnwɪlɪŋ",
    "unwinding": "ʌnwaɪndɪŋ",
    "unwind": "ʌnwaɪnd",
    "unwinds": "ʌnwaɪndz",
    "unwisely": "ʌnwaɪzli",
    "unwise": "ʌnwaɪz",
    "unwittingly": "ʌnwɪtɪŋli",
    "unwitting": "ʌnwɪtɪŋ",
    "unwonted": "ʌnwɒntɪd",
    "unworkable": "ʌnwɜːkəbəl",
    "unworldly": "ʌnwɜːldli",
    "unworn": "ʌnwɔːn",
    "unworried": "ʌnwʌrɪd",
    "unworthiest": "ʌnwɜːðɪəst",
    "unworthiness": "ʌnwɜːðɪnəs",
    "unworthy": "ʌnwɜːði",
    "unwound": "ʌnwaʊnd",
    "unwrap": "ʌnræp",
    "unwrapped": "ʌnræpt",
    "unwrapping": "ʌnræpɪŋ",
    "unwraps": "ʌnræps",
    "unwritten": "ʌnrɪtən",
    "unyielding": "ʌnjiːldɪŋ",
    "unyoked": "ʌnjəʊkt",
    "unzip": "ʌnzɪp",
    "unzipped": "ʌnzɪpt",
    "unzipping": "ʌnzɪpɪŋ",
    "unzips": "ʌnzɪps",
    "upbeat": "ʌpbiːt",
    "upbraided": "ʌpbreɪdɪd",
    "upbraiding": "ʌpbreɪdɪŋ",
    "upbraid": "ʌpbreɪd",
    "upbringing": "ʌpbrɪŋɪŋ",
    "upbringings": "ʌpbrɪŋɪŋz",
    "upcoming": "ʌpkʌmɪŋ",
    "updated": "ʌpdeɪtɪd",
    "updates": "ʌpdeɪts",
    "updating": "ʌpdeɪtɪŋ",
    "updo": "ʌpdəʊ",
    "updraught": "ʌpdrɑːft",
    "updraughts": "ʌpdrɑːfts",
    "upended": "ʌpɛndɪd",
    "upend": "ʌpɛnd",
    "upends": "ʌpɛndz",
    "upfront": "ʌpfrʌnt",
    "upgraded": "ʌpɡreɪdɪd",
    "upgrading": "ʌpɡreɪdɪŋ",
    "upheaval": "ʌphiːvəl",
    "upheavals": "ʌphiːvəlz",
    "upheld": "ʌphɛld",
    "uphill": "ʌphɪl",
    "uphills": "ʌphɪlz",
    "upholder": "ʌphəʊldɐ",
    "upholders": "ʌphəʊldəz",
    "upholding": "ʌphəʊldɪŋ",
    "uphold": "ʌphəʊld",
    "upholds": "ʌphəʊldz",
    "upholstered": "ʌpəʊlstəd",
    "upholsterer": "ʌpəʊlstərɐ",
    "upholsterers": "ʌpəʊlstərəz",
    "upholstering": "ʌpəʊlstərɪŋ",
    "upholster": "ʌpəʊlstɐ",
    "upholstery": "ʌpəʊlstəri",
    "upkeep": "ʌpkiːp",
    "upland": "ʌplənd",
    "uplands": "ʌpləndz",
    "uplifted": "ʌplɪftɪd",
    "uplifting": "ʌplɪftɪŋ",
    "uplifts": "ʌplɪfts",
    "uploaded": "ʌpləʊdɪd",
    "uploading": "ʌpləʊdɪŋ",
    "upload": "ʌpləʊd",
    "uploads": "ʌpləʊdz",
    "upmarket": "ʌpmɑːkɪt",
    "upmost": "ʌpməʊst",
    "upon": "əpɒn",
    "up": "ʌp",
    "upped": "ʌpt",
    "uppercase": "ʌpəkeɪs",
    "uppercut": "ʌpəkʌt",
    "uppercuts": "ʌpəkʌts",
    "uppermost": "ʌpəməʊst",
    "upper": "ʌpɐ",
    "uppers": "ʌpəz",
    "upping": "ʌpɪŋ",
    "uppish": "ʌpɪʃ",
    "uppity": "ʌpɪti",
    "upraised": "ʌpreɪzd",
    "uprated": "ʌpreɪtɪd",
    "uprate": "ʌpreɪt",
    "uprating": "ʌpreɪtɪŋ",
    "uprightness": "ʌpraɪtnəs",
    "upright": "ʌpraɪt",
    "uprights": "ʌpraɪts",
    "uprise": "ʌpraɪz",
    "uprising": "ʌpraɪzɪŋ",
    "uprisings": "ʌpraɪzɪŋz",
    "upriver": "ʌprɪvɐ",
    "uproariously": "ʌprɔːrɪəsli",
    "uproarious": "ʌprɔːrɪəs",
    "uproar": "ʌprɔː",
    "uproars": "ʌprɔːz",
    "uprooted": "ʌpruːtɪd",
    "uprooting": "ʌpruːtɪŋ",
    "uproot": "ʌpruːt",
    "uproots": "ʌpruːts",
    "upscale": "ʌpskeɪl",
    "upsetting": "ʌpsɛtɪŋ",
    "upshot": "ʌpʃɒt",
    "upshots": "ʌpʃɒts",
    "upside": "ʌpsaɪd",
    "upsides": "ʌpsaɪdz",
    "upsilon": "ʌpsɪlən",
    "ups": "ʌps",
    "upstaged": "ʌpsteɪdʒd",
    "upstage": "ʌpsteɪdʒ",
    "upstages": "ʌpsteɪdʒɪz",
    "upstaging": "ʌpsteɪdʒɪŋ",
    "upstanding": "ʌpstændɪŋ",
    "upstart": "ʌpstɑːt",
    "upstarts": "ʌpstɑːts",
    "upstate": "ʌpsteɪt",
    "upstream": "ʌpstriːm",
    "upsurge": "ʌpsɜːdʒ",
    "upswell": "ʌpswɛl",
    "upswing": "ʌpswɪŋ",
    "uptake": "ʌpteɪk",
    "uptakes": "ʌpteɪks",
    "uptick": "ʌptɪk",
    "uptight": "ʌptaɪt",
    "uptown": "ʌptaʊn",
    "upturned": "ʌptɜːnd",
    "upturning": "ʌptɜːnɪŋ",
    "upturn": "ʌptɜːn",
    "upturns": "ʌptɜːnz",
    "upwardly": "ʌpwədli",
    "upward": "ʌpwəd",
    "upwards": "ʌpwədz",
    "upwelling": "ʌpwəlɪŋ",
    "upwell": "ʌpwɛl",
    "upwind": "ʌpwɪnd",
    "uranium": "jɔːreɪniəm",
    "urban": "ɜːbən",
    "urbane": "ɜːbeɪn",
    "urbanisation": "ɜːbɐnaɪzeɪʃən",
    "urbanised": "ɜːbɐnaɪzd",
    "urbanism": "ɜːbənɪzəm",
    "urbanite": "ɜːbɐnaɪt",
    "urchins": "ɜːtʃɪnz",
    "urchin": "ɜːtʃɪn",
    "urea": "jɔːriə",
    "ureter": "jɔːrɛtɐ",
    "urethane": "jɔːriːθeɪn",
    "urethra": "jɔːrɛθrɐ",
    "urethral": "jɔːrɛθrəl",
    "urged": "ɜːdʒd",
    "urge": "ɜːdʒ",
    "urgency": "ɜːdʒənsi",
    "urgent": "ɜːdʒənt",
    "urgently": "ɜːdʒəntli",
    "urges": "ɜːdʒɪz",
    "urging": "ɜːdʒɪŋ",
    "urgings": "ɜːdʒɪŋz",
    "uric": "jɔːrɪk",
    "urinal": "jɔːrɪnəl",
    "urinals": "jɔːrɪnəlz",
    "urinalysis": "jɔːrɪnæləsɪs",
    "urinary": "jɔːrɪnəri",
    "urinated": "jɔːrɪneɪtɪd",
    "urinate": "jɔːrɪneɪt",
    "urinates": "jɔːrɪneɪts",
    "urinating": "jɔːrɪneɪtɪŋ",
    "urination": "jɔːrɪneɪʃən",
    "urine": "jɔːrɪn",
    "urn": "ɜːn",
    "urns": "ɜːnz",
    "urological": "jɔːrəlɒdʒɪkəl",
    "urologist": "jɔːrɒlədʒɪst",
    "urologists": "jɔːrɒlədʒɪsts",
    "urology": "jɔːrɒlədʒi",
    "ursine": "ɜːsaɪn",
    "urticaria": "ɜːtɪkeəriə",
    "urushiol": "jɔːrəʃɪɒl",
    "urus": "jɔːrəs",
    "usability": "juːzəbɪlɪti",
    "usable": "juːzəbəl",
    "usage": "juːsɪdʒ",
    "usages": "juːsɪdʒɪz",
    "useable": "juːzəbəl",
    "useful": "juːsfəl",
    "usefully": "juːzfəli",
    "usefulness": "juːsfəlnəs",
    "useless": "juːsləs",
    "uselessly": "juːsləsli",
    "uselessness": "juːsləsnəs",
    "user": "juːzɐ",
    "username": "juːzəneɪm",
    "users": "juːzəz",
    "usher": "ʌʃɐ",
    "ushered": "ʌʃəd",
    "usherette": "ʌʃərɛt",
    "usherettes": "ʌʃərɛts",
    "ushering": "ʌʃərɪŋ",
    "ushers": "ʌʃəz",
    "using": "juːzɪŋ",
    "us": "ʌs",
    "usual": "juːʒuːəl",
    "usually": "juːʒuːəli",
    "usurer": "juːzjʊrɐ",
    "usurers": "juːzjʊrəz",
    "usurpation": "juːzɜːpeɪʃən",
    "usurped": "juːzɜːpt",
    "usurper": "juːzɜːpɐ",
    "usurping": "juːzɜːpɪŋ",
    "usurp": "juːzɜːp",
    "usury": "juːzjʊri",
    "utensil": "juːtɛnsəl",
    "utensils": "juːtɛnsəlz",
    "uteri": "juːtəri",
    "uterine": "juːtəriːn",
    "uterus": "juːtərəs",
    "utile": "juːtaɪl",
    "utilisation": "juːtɪlaɪzeɪʃən",
    "utilised": "juːtəlaɪzd",
    "utilise": "juːtəlaɪz",
    "utilises": "juːtəlaɪzɪz",
    "utilising": "juːtəlaɪzɪŋ",
    "utilitarianism": "juːtɪlɪteəriənɪzəm",
    "utilitarian": "juːtɪlɪteəriən",
    "utilitarians": "juːtɪlɪteəriənz",
    "utilities": "juːtɪlɪtiz",
    "utility": "juːtɪlɪti",
    "utmost": "ʌtməʊst",
    "utopia": "juːtəʊpiə",
    "utopianism": "juːtəʊpiənɪzəm",
    "utopian": "juːtəʊpiən",
    "utopians": "juːtəʊpiənz",
    "utopias": "juːtəʊpiəz",
    "uts": "ʌts",
    "ut": "ʌt",
    "utterances": "ʌtərənsɪz",
    "utterance": "ʌtərəns",
    "uttered": "ʌtəd",
    "uttering": "ʌtərɪŋ",
    "utterly": "ʌtəli",
    "uttermost": "ʌtəməʊst",
    "utters": "ʌtəz",
    "utter": "ʌtɐ",
    "uvula": "juːvjʊlɐ",
    "uxorious": "ʌksɔːrɪəs",
    "uxoriousness": "ʌksɔːrɪəsnəs",
    "vacancies": "veɪkənsɪz",
    "vacancy": "veɪkənsi",
    "vacantly": "veɪkəntli",
    "vacant": "veɪkənt",
    "vacated": "veɪkeɪtɪd",
    "vacates": "veɪkeɪts",
    "vacate": "veɪkeɪt",
    "vacating": "veɪkeɪtɪŋ",
    "vacationing": "veɪkeɪʃənɪŋ",
    "vacations": "veɪkeɪʃənz",
    "vacation": "veɪkeɪʃən",
    "vaccinated": "væksɪneɪtɪd",
    "vaccinates": "væksɪneɪts",
    "vaccinate": "væksɪneɪt",
    "vaccinating": "væksɪneɪtɪŋ",
    "vaccinations": "væksɪneɪʃənz",
    "vaccination": "væksɪneɪʃən",
    "vaccinator": "væksɪneɪtɐ",
    "vaccines": "væksiːnz",
    "vaccine": "væksiːn",
    "vaccinia": "væksɪniə",
    "vacillated": "væsɪleɪtɪd",
    "vacillates": "væsɪleɪts",
    "vacillating": "væsɪleɪtɪŋ",
    "vacillation": "væsɪleɪʃən",
    "vacuity": "vækjuːɪti",
    "vacuousness": "vækjuːəsnəs",
    "vacuous": "vækjuːəs",
    "vacuumed": "vækjuːmd",
    "vacuuming": "vækjuːmɪŋ",
    "vacuums": "vækjuːmz",
    "vacuum": "vækjuːm",
    "vac": "væk",
    "vagabonds": "væɡɐbɒndz",
    "vagabond": "væɡɐbɒnd",
    "vagal": "væɡəl",
    "vagaries": "veɪɡərɪz",
    "vagary": "veɪɡəri",
    "vaginally": "vædʒɪnəli",
    "vaginal": "vædʒɪnəl",
    "vaginas": "vədʒaɪnəz",
    "vagina": "vədʒaɪnɐ",
    "vagrancy": "veɪɡrənsi",
    "vagrants": "veɪɡrənts",
    "vagrant": "veɪɡrənt",
    "vaguely": "veɪɡli",
    "vagueness": "veɪɡnəs",
    "vaguer": "veɪɡɐ",
    "vaguest": "veɪɡəst",
    "vague": "veɪɡ",
    "vagus": "væɡəs",
    "vail": "veɪl",
    "vainest": "veɪnəst",
    "vaingloriousness": "veɪŋɡlɔːrɪəsnəs",
    "vainglorious": "veɪŋɡlɔːrɪəs",
    "vainglory": "veɪŋɡləri",
    "vainly": "veɪnli",
    "vain": "veɪn",
    "vair": "veə",
    "valances": "vælənsɪz",
    "valance": "væləns",
    "valediction": "vælɪdɪkʃən",
    "valedictorian": "vælɪdɪktɔːriən",
    "valedictory": "vælɪdɪktəri",
    "valency": "veɪlnsi",
    "valentines": "væləntaɪnz",
    "valentine": "væləntaɪn",
    "valerian": "væliərɪən",
    "vales": "veɪlz",
    "valeted": "væliːtɪd",
    "valeting": "væliːtɪŋ",
    "valets": "væleɪs",
    "valet": "væleɪ",
    "valgus": "vælɡəs",
    "valiantly": "vælɪəntli",
    "valiant": "vælɪənt",
    "validated": "vælɪdeɪtɪd",
    "validates": "vælɪdeɪts",
    "validate": "vælɪdeɪt",
    "validating": "vælɪdeɪtɪŋ",
    "validation": "vælɪdeɪʃən",
    "validity": "vælɪdɪti",
    "validly": "vælɪdli",
    "valid": "vælɪd",
    "valises": "vɐliːsɪz",
    "valise": "vɐliːs",
    "valleys": "vælɪz",
    "valley": "væli",
    "valorous": "vælərəs",
    "valor": "vælɐ",
    "valour": "vælɐ",
    "valse": "væls",
    "valuables": "væljuːəbəlz",
    "valuable": "væljuːəbəl",
    "valuations": "væljuːeɪʃənz",
    "valuation": "væljuːeɪʃən",
    "valued": "væljuːd",
    "valueless": "væljuːləs",
    "valuers": "væljuːəz",
    "valuer": "væljuːɐ",
    "values": "væljuːz",
    "value": "væljuː",
    "valuing": "væljuːɪŋ",
    "valves": "vælvz",
    "valve": "vælv",
    "vamoosed": "væmuːsd",
    "vamoose": "væmuːs",
    "vamped": "væmpt",
    "vamping": "væmpɪŋ",
    "vampires": "væmpaɪəz",
    "vampire": "væmpaɪə",
    "vampirism": "væmpaɪərɪzəm",
    "vampish": "væmpɪʃ",
    "vamps": "væmps",
    "vamp": "væmp",
    "vampy": "væmpi",
    "vanadium": "væneɪdiəm",
    "vandalised": "vændəlaɪzd",
    "vandalise": "vændəlaɪz",
    "vandalising": "vændəlaɪzɪŋ",
    "vandalism": "vændəlɪzəm",
    "vandals": "vændəlz",
    "vandal": "vændəl",
    "vanda": "vændɐ",
    "vanes": "veɪnz",
    "vane": "veɪn",
    "vanguard": "væŋɡɑːd",
    "vanillas": "vɐnɪləz",
    "vanilla": "vɐnɪlɐ",
    "vanished": "vænɪʃt",
    "vanisher": "vænɪʃɐ",
    "vanishes": "vænɪʃɪz",
    "vanishingly": "vænɪʃɪŋli",
    "vanishing": "vænɪʃɪŋ",
    "vanish": "vænɪʃ",
    "vanities": "vænɪtiz",
    "vanity": "vænɪti",
    "vanning": "vænɪŋ",
    "vanquished": "vænkwɪʃt",
    "vanquishes": "vænkwɪʃɪz",
    "vanquishing": "vænkwɪʃɪŋ",
    "vanquish": "vænkwɪʃ",
    "vans": "vænz",
    "vantages": "vɑːntɪdʒɪz",
    "vantage": "vɑːntɪdʒ",
    "van": "væn",
    "vapid": "væpɪd",
    "vaporetto": "veɪpɔːrɛtəʊ",
    "vaporisation": "veɪpɔːraɪzeɪʃən",
    "vaporised": "veɪpɔːraɪzd",
    "vaporisers": "veɪpɔːraɪzəz",
    "vaporiser": "veɪpɔːraɪzɐ",
    "vaporises": "veɪpɔːraɪzɪz",
    "vaporise": "veɪpɔːraɪz",
    "vaporising": "veɪpɔːraɪzɪŋ",
    "vaporous": "veɪpərəs",
    "vapors": "veɪpəz",
    "vapor": "veɪpɐ",
    "vapours": "veɪpəz",
    "vapour": "veɪpɐ",
    "vara": "vɑːrɐ",
    "variability": "veərɪəbɪlɪti",
    "variables": "veərɪəbəlz",
    "variable": "veərɪəbəl",
    "variances": "veəriənsɪz",
    "variance": "veəriəns",
    "variants": "veəriənts",
    "variant": "veəriənt",
    "variations": "veərɪeɪʃənz",
    "variation": "veərɪeɪʃən",
    "varicella": "væraɪsɛlɐ",
    "varices": "værɪsɪz",
    "varicose": "værɪkəʊs",
    "varied": "veərid",
    "variegated": "veərɪɡeɪtɪd",
    "variegation": "veərɪɡeɪʃən",
    "varies": "veəriz",
    "varietal": "veəraɪətəl",
    "varieties": "vəraɪətiz",
    "variety": "vəraɪəti",
    "variola": "veərɪəʊlɐ",
    "variously": "veərɪəsli",
    "various": "veərɪəs",
    "varlets": "vɑːləts",
    "varlet": "vɑːlət",
    "varmints": "vɑːmɪnts",
    "varmint": "vɑːmɪnt",
    "varnished": "vɑːnɪʃt",
    "varnishes": "vɑːnɪʃɪz",
    "varnishing": "vɑːnɪʃɪŋ",
    "varnish": "vɑːnɪʃ",
    "varsity": "vɑːsɪti",
    "varying": "veəriɪŋ",
    "vary": "veəri",
    "vasa": "vɑːsɐ",
    "vascular": "væskjʊlɐ",
    "vasectomies": "veɪsɛktəmɪz",
    "vasectomy": "væzɛktəmi",
    "vases": "vɑːzɪz",
    "vase": "vɑːz",
    "vasodilator": "væsɒdɪleɪtɐ",
    "vassals": "væsəlz",
    "vassal": "væsəl",
    "vaster": "vɑːstɐ",
    "vastly": "vɑːstli",
    "vastness": "vɑːstnəs",
    "vast": "vɑːst",
    "vasty": "vɑːsti",
    "vas": "væs",
    "vats": "væts",
    "vatting": "vætɪŋ",
    "vat": "væt",
    "vaudeville": "vɔːdəvɪl",
    "vaudevillians": "vɔːdəvɪliənz",
    "vaudevillian": "vɔːdəvɪliən",
    "vaulted": "vɒltɪd",
    "vaulters": "vɒltəz",
    "vaulter": "vɒltɐ",
    "vaulting": "vɒltɪŋ",
    "vaults": "vɒlts",
    "vault": "vɒlt",
    "vaunted": "vɔːntɪd",
    "vaunting": "vɔːntɪŋ",
    "vav": "væv",
    "veal": "viːl",
    "vectored": "vɛktəd",
    "vectoring": "vɛktərɪŋ",
    "vectors": "vɛktəz",
    "vector": "vɛktɐ",
    "vedette": "vɛdɛt",
    "vedic": "vɛdɪk",
    "veep": "viːp",
    "veered": "viəd",
    "veering": "viərɪŋ",
    "veers": "viəz",
    "veer": "viə",
    "veganism": "viːɡənɪzəm",
    "vegans": "viːɡənz",
    "vegan": "viːɡən",
    "vegetables": "vɛdʒɪtəbəlz",
    "vegetable": "vɛdʒɪtəbəl",
    "vegetarianism": "vɛdʒɪteəriənɪzəm",
    "vegetarians": "vɛdʒɪteəriənz",
    "vegetarian": "vɛdʒɪteəriən",
    "vegetated": "vɛdʒɪteɪtɪd",
    "vegetate": "vɛdʒɪteɪt",
    "vegetating": "vɛdʒɪteɪtɪŋ",
    "vegetational": "vɛdʒɪteɪʃənəl",
    "vegetation": "vɛdʒɪteɪʃən",
    "vegetatively": "vɛdʒɪteɪtɪvli",
    "vegetative": "vɛdʒɪteɪtɪv",
    "veggies": "vɛdʒɪz",
    "veggie": "vɛdʒi",
    "vegging": "vɛdʒɪŋ",
    "vegs": "vɛdʒz",
    "veg": "vɛdʒ",
    "vehemence": "viəməns",
    "vehemently": "viəməntli",
    "vehement": "viəmənt",
    "vehicles": "viəkəlz",
    "vehicle": "viəkəl",
    "vehicular": "vɛhɪkjʊlɐ",
    "veiled": "veɪld",
    "veiling": "veɪlɪŋ",
    "veils": "veɪlz",
    "veil": "veɪl",
    "veined": "veɪnd",
    "veining": "veɪnɪŋ",
    "veins": "veɪnz",
    "vein": "veɪn",
    "veiny": "veɪni",
    "vela": "vɛlɐ",
    "veldt": "vɛlt",
    "veld": "vɛld",
    "vellum": "vɛləm",
    "veloce": "vələʊs",
    "velocipede": "vəlɒsɪpiːd",
    "velocities": "vəlɒsɪtiz",
    "velocity": "vəlɒsɪti",
    "velodromes": "vɛlədrəʊmz",
    "velodrome": "vɛlədrəʊm",
    "velour": "vɛlɐ",
    "velum": "vɛləm",
    "velveteen": "vɛlvɪtiːn",
    "velvets": "vɛlvɪts",
    "velvet": "vɛlvɪt",
    "velvety": "vɛlvɪti",
    "venality": "vɛnælɪti",
    "venal": "viːnəl",
    "vena": "viːnɐ",
    "vendace": "vɛndeɪs",
    "vended": "vɛndɪd",
    "vendee": "vɛndiː",
    "vender": "vɛndɐ",
    "vendettas": "vɛndɛtəz",
    "vendetta": "vɛndɛtɐ",
    "vending": "vɛndɪŋ",
    "vendors": "vɛndəz",
    "vendor": "vɛndɐ",
    "vends": "vɛndz",
    "vend": "vɛnd",
    "veneered": "vɛniəd",
    "veneering": "vɛniərɪŋ",
    "veneers": "vɛniəz",
    "veneer": "vɛniə",
    "venerable": "vɛnərəbəl",
    "venerated": "vɛnəreɪtɪd",
    "venerate": "vɛnəreɪt",
    "venerating": "vɛnəreɪtɪŋ",
    "veneration": "vɛnəreɪʃən",
    "venereal": "vɛniərɪəl",
    "venetian": "vɛnɛʃən",
    "vengeance": "vɛndʒəns",
    "vengefulness": "vɛndʒfəlnəs",
    "vengeful": "vɛndʒfəl",
    "venge": "vɛndʒ",
    "venial": "viːnɪəl",
    "venison": "vɛnɪsən",
    "venomous": "vɛnəməs",
    "venom": "vɛnəm",
    "venous": "vɛnəs",
    "vented": "vɛntɪd",
    "ventilated": "vɛntɪleɪtɪd",
    "ventilates": "vɛntɪleɪts",
    "ventilate": "vɛntɪleɪt",
    "ventilating": "vɛntɪleɪtɪŋ",
    "ventilation": "vɛntɪleɪʃən",
    "ventilators": "vɛntɪleɪtəz",
    "ventilator": "vɛntɪleɪtɐ",
    "venting": "vɛntɪŋ",
    "ventrally": "vɛntrəli",
    "ventral": "vɛntrəl",
    "ventre": "vɛntɐ",
    "ventricles": "vɛntrɪkəlz",
    "ventricle": "vɛntrɪkəl",
    "ventricular": "vɛntrɪkjʊlɐ",
    "ventriloquism": "vɛntrɪləkwɪzəm",
    "ventriloquists": "vɛntrɪləkwɪsts",
    "ventriloquist": "vɛntrɪləkwɪst",
    "vents": "vɛnts",
    "ventured": "vɛntʃəd",
    "venturesome": "vɛntʃəsʌm",
    "ventures": "vɛntʃəz",
    "venture": "vɛntʃɐ",
    "venturing": "vɛntʃərɪŋ",
    "vent": "vɛnt",
    "venues": "vɛnjuːz",
    "venue": "vɛnjuː",
    "veracious": "vəreɪʃəs",
    "veracity": "vəræsɪti",
    "verandah": "vɛrændɐ",
    "verandas": "vərændəz",
    "veranda": "vərændɐ",
    "verbalisation": "vɜːbəlaɪzeɪʃən",
    "verbalised": "vɜːbəlaɪzd",
    "verbalise": "vɜːbəlaɪz",
    "verbalising": "vɜːbəlaɪzɪŋ",
    "verbally": "vɜːbəli",
    "verbals": "vɜːbəlz",
    "verbal": "vɜːbəl",
    "verbatim": "vɜːbeɪtɪm",
    "verbenas": "vɜːbiːnəz",
    "verbena": "vɜːbiːnɐ",
    "verbiage": "vɜːbɪdʒ",
    "verbose": "vɜːbəʊz",
    "verbosity": "vɜːbɒsɪti",
    "verboten": "vɜːbəʊtən",
    "verbs": "vɜːbz",
    "verb": "vɜːb",
    "verdant": "vɜːdənt",
    "verdicts": "vɜːdɪkts",
    "verdict": "vɜːdɪkt",
    "verdigris": "vɜːdɪɡrɪs",
    "verdure": "vɜːdjɔː",
    "verey": "vɛri",
    "verged": "vɜːdʒd",
    "vergers": "vɜːdʒəz",
    "verger": "vɜːdʒɐ",
    "verges": "vɜːdʒɪz",
    "verge": "vɜːdʒ",
    "verging": "vɜːdʒɪŋ",
    "veriest": "viərɪəst",
    "verifiable": "vɛrɪfaɪəbəl",
    "verifiably": "vɛrɪfaɪəbli",
    "verification": "vɛrɪfɪkeɪʃən",
    "verified": "vɛrɪfaɪd",
    "verifies": "vɛrɪfaɪz",
    "verifying": "vɛrɪfaɪɪŋ",
    "verify": "vɛrɪfaɪ",
    "verily": "vɛrɪli",
    "verisimilitude": "vɛrɪsɪmɪlɪtjuːd",
    "verismo": "vɛrɪsməʊ",
    "veritable": "vɛrɪtəbəl",
    "verite": "vɛraɪt",
    "verities": "vɛrɪtiz",
    "verity": "vɛrɪti",
    "verjuice": "vɜːdʒuːs",
    "vermicelli": "vɜːmɪtʃɛli",
    "vermiculite": "vɜːmɪkjʊlaɪt",
    "vermiform": "vɜːmɪfɔːm",
    "vermilion": "vɜːmɪliən",
    "vermillion": "vɜːmɪliən",
    "vermin": "vɜːmɪn",
    "vermouth": "vɜːməθ",
    "vernacular": "vɜːnækjʊlɐ",
    "vernal": "vɜːnəl",
    "vernier": "vɜːnɪɐ",
    "veronica": "vərɒnɪkɐ",
    "verrucas": "vɛruːkəz",
    "verruca": "vɛruːkɐ",
    "versatile": "vɜːsətaɪl",
    "versatility": "vɜːsətɪlɪti",
    "versed": "vɜːsd",
    "verses": "vɜːsɪz",
    "verse": "vɜːs",
    "versing": "vɜːsɪŋ",
    "versions": "vɜːʃənz",
    "version": "vɜːʃən",
    "verso": "vɜːsəʊ",
    "versus": "vɜːsɪz",
    "vertebrae": "vɜːtɪbriː",
    "vertebral": "vɜːtɪbrəl",
    "vertebras": "vɜːtɪbrəz",
    "vertebrates": "vɜːtɪbreɪts",
    "vertebrate": "vɜːtɪbreɪt",
    "vertebra": "vɜːtɪbrɐ",
    "vertex": "vɜːtɛks",
    "verticality": "vɜːtɪkælɪti",
    "vertically": "vɜːtɪkli",
    "verticals": "vɜːtɪkəlz",
    "vertical": "vɜːtɪkəl",
    "vertices": "vɜːtɪsiːz",
    "vertiginous": "vɜːtɪdʒɪnəs",
    "vertigo": "vɜːtɪɡəʊ",
    "vervets": "vɜːvɪts",
    "vervet": "vɜːvɪt",
    "verve": "vɜːv",
    "very": "vɛri",
    "vesicles": "vɛsɪkəlz",
    "vesicular": "vɛsɪkjʊlɐ",
    "vespers": "vɛspəz",
    "vesper": "vɛspɐ",
    "vessels": "vɛsəlz",
    "vessel": "vɛsəl",
    "vestal": "vɛstəl",
    "vesta": "vɛstɐ",
    "vested": "vɛstɪd",
    "vestibular": "vɛstɪbjʊlɐ",
    "vestibule": "vɛstɪbjuːl",
    "vestiges": "vɛstɪdʒɪz",
    "vestige": "vɛstɪdʒ",
    "vestigial": "vɛstɪdʒəl",
    "vesting": "vɛstɪŋ",
    "vestments": "vɛstmənts",
    "vestment": "vɛstmənt",
    "vestry": "vɛstri",
    "vests": "vɛsts",
    "vesture": "vɛstʃɐ",
    "vest": "vɛst",
    "vetches": "vɛtʃɪz",
    "vetch": "vɛtʃ",
    "veterans": "vɛtərənz",
    "veteran": "vɛtərən",
    "veterinarians": "vɛtərɪneəriənz",
    "veterinarian": "vɛtərɪneəriən",
    "veterinary": "vɛtərɪnəri",
    "vetiver": "vɛtɪvɐ",
    "vetoed": "viːtəʊd",
    "vetoes": "viːtəʊz",
    "vetoing": "viːtəʊɪŋ",
    "veto": "viːtəʊ",
    "vets": "vɛts",
    "vetted": "vɛtɪd",
    "vetting": "vɛtɪŋ",
    "vet": "vɛt",
    "vexations": "vɛkseɪʃənz",
    "vexation": "vɛkseɪʃən",
    "vexatiously": "vɛkseɪʃəsli",
    "vexatious": "vɛkseɪʃəs",
    "vexed": "vɛkst",
    "vexes": "vɛksɪz",
    "vexillology": "vɛksɪlɒlədʒi",
    "vexing": "vɛksɪŋ",
    "vex": "vɛks",
    "vhf": "viːeɪtʃɛf",
    "viability": "vaɪəbɪlɪti",
    "viable": "vaɪəbəl",
    "viably": "vaɪəbli",
    "viaducts": "vaɪədʌkts",
    "viaduct": "vaɪədʌkt",
    "vials": "vaɪəlz",
    "vial": "vaɪəl",
    "viator": "vaɪətɐ",
    "via": "vaɪɐ",
    "vibes": "vaɪbz",
    "vibe": "vaɪb",
    "vibrancy": "vaɪbrənsi",
    "vibrantly": "vaɪbrəntli",
    "vibrant": "vaɪbrənt",
    "vibraphone": "vaɪbrɐfəʊn",
    "vibrated": "vaɪbreɪtɪd",
    "vibrates": "vaɪbreɪts",
    "vibrate": "vaɪbreɪt",
    "vibrating": "vaɪbreɪtɪŋ",
    "vibrational": "vaɪbreɪʃənəl",
    "vibrations": "vaɪbreɪʃənz",
    "vibration": "vaɪbreɪʃən",
    "vibrators": "vaɪbreɪtəz",
    "vibrator": "vaɪbreɪtɐ",
    "vibrato": "vɪbrɑːtəʊ",
    "vibrio": "vaɪbrɪəʊ",
    "vibrissae": "vaɪbrɪsiː",
    "viburnums": "vɪbɜːnəmz",
    "viburnum": "vɪbɜːnəm",
    "vicarages": "vɪkɐrɪdʒɪz",
    "vicarage": "vɪkærɪdʒ",
    "vicariously": "vɪkeərɪəsli",
    "vicarious": "vɪkeərɪəs",
    "vicars": "vɪkəz",
    "vicar": "vɪkɐ",
    "viced": "vaɪst",
    "viceregal": "vaɪsriːɡəl",
    "viceroys": "vaɪsrɔɪz",
    "viceroy": "vaɪsrɔɪ",
    "vices": "vaɪsɪz",
    "vichyssoise": "vɪtʃɪsɔɪs",
    "vicinities": "vɪsɪnɪtiz",
    "vicinity": "vɪsɪnɪti",
    "viciously": "vɪʃəsli",
    "viciousness": "vɪʃəsnəs",
    "vicious": "vɪʃəs",
    "vicissitudes": "vɪsɪsɪtjuːdz",
    "victimisation": "vɪktɪmaɪzeɪʃən",
    "victimised": "vɪktɪmaɪzd",
    "victimise": "vɪktɪmaɪz",
    "victimising": "vɪktɪmaɪzɪŋ",
    "victimless": "vɪktɪmləs",
    "victims": "vɪktɪmz",
    "victim": "vɪktɪm",
    "victoria": "vɪktɔːriə",
    "victories": "vɪktəriz",
    "victoriously": "vɪktɔːrɪəsli",
    "victorious": "vɪktɔːrɪəs",
    "victors": "vɪktəz",
    "victor": "vɪktɐ",
    "victory": "vɪktəri",
    "victualler": "vɪktʃuːɔːlɐ",
    "victualling": "vɪktʃuːɔːlɪŋ",
    "victuals": "vɪktʃuːəlz",
    "videoed": "vɪdɪəʊd",
    "videoing": "vɪdɪəʊɪŋ",
    "videophone": "vɪdɪəʊfəʊn",
    "videos": "vɪdɪəʊz",
    "videotaped": "vɪdiːəʊteɪpt",
    "videotapes": "vɪdiːəʊteɪps",
    "videotape": "vɪdiːəʊteɪp",
    "videotaping": "vɪdiːəʊteɪpɪŋ",
    "video": "vɪdɪəʊ",
    "vide": "vaɪd",
    "vied": "vaɪd",
    "vies": "vaɪz",
    "vie": "vaɪ",
    "viewable": "vjuːəbəl",
    "viewed": "vjuːd",
    "viewership": "vjuːəʃɪp",
    "viewers": "vjuːəz",
    "viewer": "vjuːɐ",
    "viewfinders": "vjuːfaɪndəz",
    "viewfinder": "vjuːfaɪndɐ",
    "viewings": "vjuːɪŋz",
    "viewing": "vjuːɪŋ",
    "viewpoints": "vjuːpɔɪnts",
    "viewpoint": "vjuːpɔɪnt",
    "views": "vjuːz",
    "view": "vjuː",
    "vigilance": "vɪdʒɪləns",
    "vigilantes": "vɪdʒɪlæntis",
    "vigilante": "vɪdʒɪlænti",
    "vigilantism": "vɪdʒɪləntɪzəm",
    "vigilantly": "vɪdʒɪləntli",
    "vigilant": "vɪdʒɪlənt",
    "vigils": "vɪdʒɪlz",
    "vigil": "vɪdʒɪl",
    "vignettes": "vɪnjɛts",
    "vignette": "vɪnjɛt",
    "vigorously": "vɪɡərəsli",
    "vigorous": "vɪɡərəs",
    "vigour": "vɪɡɐ",
    "vikings": "vaɪkɪŋz",
    "viking": "vaɪkɪŋ",
    "vilely": "vaɪlli",
    "vileness": "vaɪlnəs",
    "vilest": "vaɪləst",
    "vile": "vaɪl",
    "vilification": "vɪlɪfɪkeɪʃən",
    "vilified": "vɪlɪfaɪd",
    "vilifying": "vɪlɪfaɪɪŋ",
    "vilify": "vɪlɪfaɪ",
    "villagers": "vɪlɪdʒəz",
    "villager": "vɪlɪdʒɐ",
    "villages": "vɪlɪdʒɪz",
    "village": "vɪlɪdʒ",
    "villainesses": "vɪlənəsɪz",
    "villainess": "vɪleɪnəs",
    "villainous": "vɪlənəs",
    "villains": "vɪlənz",
    "villain": "vɪlən",
    "villainy": "vɪləni",
    "villas": "vɪləz",
    "villa": "vɪlɐ",
    "villeins": "vɪlaɪnz",
    "villein": "vɪlaɪn",
    "villi": "vɪlaɪ",
    "vim": "vɪm",
    "vinaigrette": "vɪneɪɡrɛt",
    "vina": "viːnɐ",
    "vindaloos": "vɪndɐluːz",
    "vindicated": "vɪndɪkeɪtɪd",
    "vindicates": "vɪndɪkeɪts",
    "vindicate": "vɪndɪkeɪt",
    "vindicating": "vɪndɪkeɪtɪŋ",
    "vindication": "vɪndɪkeɪʃən",
    "vindictively": "vɪndɪktɪvli",
    "vindictiveness": "vɪndɪktɪvnəs",
    "vindictive": "vɪndɪktɪv",
    "vinegarette": "vɪnɪɡərɛt",
    "vinegars": "vɪnɪɡəz",
    "vinegar": "vɪnɪɡɐ",
    "vinegary": "vɪnɪɡəri",
    "vinery": "vaɪnəri",
    "vines": "vaɪnz",
    "vine": "vaɪn",
    "vineyards": "vɪnjədz",
    "vineyard": "vɪnjəd",
    "viniculture": "vɪnɪkʌltʃɐ",
    "vino": "viːnəʊ",
    "vintages": "vɪntɪdʒɪz",
    "vintage": "vɪntɪdʒ",
    "vintners": "vɪntnəz",
    "vintner": "vɪntnɐ",
    "vinyls": "vaɪnɪlz",
    "vinyl": "vaɪnɪl",
    "violas": "vaɪəʊləz",
    "violated": "vaɪəleɪtɪd",
    "violates": "vaɪəleɪts",
    "violate": "vaɪəleɪt",
    "violating": "vaɪəleɪtɪŋ",
    "violations": "vaɪəleɪʃənz",
    "violation": "vaɪəleɪʃən",
    "violators": "vaɪəleɪtəz",
    "violator": "vaɪəleɪtɐ",
    "violence": "vaɪələns",
    "violently": "vaɪələntli",
    "violent": "vaɪələnt",
    "violets": "vaɪələts",
    "violet": "vaɪələt",
    "violinists": "vaɪəlɪnɪsts",
    "violinist": "vaɪəlɪnɪst",
    "violins": "vaɪəlɪnz",
    "violin": "vaɪəlɪn",
    "viol": "vaɪəl",
    "vipers": "vaɪpəz",
    "viper": "vaɪpɐ",
    "virago": "vɜːreɪɡəʊ",
    "virally": "vaɪərəli",
    "viral": "vaɪərəl",
    "vire": "vaɪə",
    "virga": "vɜːɡɐ",
    "virginals": "vɜːdʒaɪnəlz",
    "virginal": "vɜːdʒaɪnəl",
    "virginity": "vɜːdʒɪnɪti",
    "virgins": "vɜːdʒɪnz",
    "virgin": "vɜːdʒɪn",
    "viridian": "vɪrɪdiən",
    "virile": "vɪraɪl",
    "virility": "vɪrɪlɪti",
    "virologists": "vɪrɒlədʒɪsts",
    "virologist": "vɪrɒlədʒɪst",
    "virology": "vɪrɒlədʒi",
    "virtually": "vɜːtʃuːəli",
    "virtual": "vɜːtʃuːəl",
    "virtues": "vɜːtʃuːz",
    "virtue": "vɜːtʃuː",
    "virtuosic": "vɜːtjuːɒzɪk",
    "virtuosity": "vɜːtjuːɒsɪti",
    "virtuosi": "vɜːtjuːəʊsi",
    "virtuosos": "vɜːtjuːəʊsəʊz",
    "virtuoso": "vɜːtjuːəʊsəʊ",
    "virtuously": "vɜːtʃuːəsli",
    "virtuous": "vɜːtʃuːəs",
    "virtus": "vɜːtəs",
    "virtu": "vɜːtuː",
    "virulence": "vɪrələns",
    "virulently": "vɪrələntli",
    "virulent": "vɪrələnt",
    "viruses": "vaɪrəsɪz",
    "virus": "vaɪrəs",
    "visaged": "vɪsɪdʒd",
    "visages": "vɪsɪdʒɪz",
    "visage": "vɪsɪdʒ",
    "visas": "viːzəz",
    "visa": "viːzɐ",
    "viscerally": "vɪsərəli",
    "visceral": "vɪsərəl",
    "viscera": "vɪsərɐ",
    "viscidity": "vɪsɪdɪti",
    "viscose": "vɪskəʊs",
    "viscosity": "vɪskɒsɪti",
    "viscountcy": "vaɪkaʊntsi",
    "viscountess": "vaɪkaʊntɛs",
    "viscounts": "vaɪkaʊnts",
    "viscount": "vaɪkaʊnt",
    "viscous": "vɪskəs",
    "vised": "vaɪzd",
    "visibility": "vɪzəbɪlɪti",
    "visible": "vɪzəbəl",
    "visibly": "vɪzəbli",
    "visionaries": "vɪʒənəriz",
    "visionary": "vɪʒənəri",
    "visioned": "vɪʒənd",
    "visions": "vɪʒənz",
    "vision": "vɪʒən",
    "visitations": "vɪzɪteɪʃənz",
    "visitation": "vɪzɪteɪʃən",
    "visited": "vɪzɪtɪd",
    "visiting": "vɪzɪtɪŋ",
    "visitors": "vɪzɪtəz",
    "visitor": "vɪzɪtɐ",
    "visits": "vɪzɪts",
    "visit": "vɪzɪt",
    "visored": "vɪsəd",
    "visors": "vaɪzəz",
    "visor": "vaɪzɐ",
    "vistas": "vɪstəz",
    "vista": "vɪstɐ",
    "visualisations": "vɪʒuːəlaɪzeɪʃənz",
    "visualisation": "vɪʒuːəlaɪzeɪʃən",
    "visualised": "vɪʒuːəlaɪzd",
    "visualiser": "vɪʒuːəlaɪzɐ",
    "visualises": "vɪʒuːəlaɪzɪz",
    "visualise": "vɪʒuːəlaɪz",
    "visualising": "vɪʒuːəlaɪzɪŋ",
    "visually": "vɪʒuːəli",
    "visuals": "vɪʒuːəlz",
    "visual": "vɪʒuːəl",
    "vitae": "vɪtiː",
    "vitalised": "vaɪtəlaɪzd",
    "vitalise": "vaɪtəlaɪz",
    "vitalising": "vaɪtælɪsɪŋ",
    "vitality": "vaɪtælɪti",
    "vitally": "vaɪtəli",
    "vitals": "vaɪtəlz",
    "vital": "vaɪtəl",
    "vitamins": "vɪtəmɪnz",
    "vitamin": "vɪtəmɪn",
    "vitas": "viːtəz",
    "vita": "viːtɐ",
    "vitiate": "vɪʃɪeɪt",
    "viticulture": "vɪtɪkʌltʃɐ",
    "vitreous": "vɪtriəs",
    "vitrification": "vɪtrɪfɪkeɪʃən",
    "vitrified": "vɪtrɪfaɪd",
    "vitrify": "vɪtrɪfaɪ",
    "vitrines": "vɪtriːnz",
    "vitrine": "vɪtriːn",
    "vitriolic": "vɪtrɪɒlɪk",
    "vitriol": "vɪtriːəl",
    "vittles": "vɪtəlz",
    "vituperative": "vɪtjuːpərətɪv",
    "vivace": "vɪveɪs",
    "vivaciousness": "vɪveɪʃəsnəs",
    "vivacious": "vɪveɪʃəs",
    "vivacity": "vɪvæsɪti",
    "vivarium": "vɪveəriəm",
    "vivas": "viːvəz",
    "vive": "vaɪv",
    "vividly": "vɪvɪdli",
    "vividness": "vɪvɪdnəs",
    "vivid": "vɪvɪd",
    "vivisection": "vɪvɪsɛkʃən",
    "vixens": "vɪksənz",
    "vixen": "vɪksən",
    "vizier": "vaɪzɪɐ",
    "vocabularies": "vəʊkæbjʊləriz",
    "vocabulary": "vəʊkæbjʊləri",
    "vocalisations": "vəʊkəlaɪzeɪʃənz",
    "vocalisation": "vəʊkəlaɪzeɪʃən",
    "vocalised": "vəʊkəlaɪzd",
    "vocalise": "vəʊkəlaɪz",
    "vocalising": "vəʊkəlaɪzɪŋ",
    "vocalists": "vəʊkəlɪsts",
    "vocalist": "vəʊkəlɪst",
    "vocally": "vəʊkəli",
    "vocals": "vəʊkəlz",
    "vocal": "vəʊkəl",
    "vocationally": "vəʊkeɪʃənəli",
    "vocational": "vəʊkeɪʃənəl",
    "vocations": "vəʊkeɪʃənz",
    "vocation": "vəʊkeɪʃən",
    "vocative": "vəʊkətɪv",
    "vociferously": "vəʊsɪfərəsli",
    "vociferous": "vəʊsɪfərəs",
    "vodkas": "vɒdkəz",
    "vodka": "vɒdkɐ",
    "voes": "vəʊz",
    "voe": "vəʊ",
    "vogues": "vəʊɡz",
    "vogue": "vəʊɡ",
    "voguish": "vɒɡwɪʃ",
    "voiced": "vɔɪst",
    "voiceless": "vɔɪsləs",
    "voiceover": "vɔɪsəʊvɐ",
    "voiceprint": "vɔɪsprɪnt",
    "voices": "vɔɪsɪz",
    "voice": "vɔɪs",
    "voicing": "vɔɪsɪŋ",
    "voidable": "vɔɪdəbəl",
    "voided": "vɔɪdɪd",
    "voiding": "vɔɪdɪŋ",
    "voids": "vɔɪdz",
    "void": "vɔɪd",
    "voile": "vɔɪl",
    "voiture": "vɔɪtʃɐ",
    "volant": "vɒlənt",
    "volar": "vəʊlɐ",
    "volatiles": "vɒlɐtaɪlz",
    "volatile": "vɒlɐtaɪl",
    "volatility": "vɒlɐtɪlɪti",
    "volcanically": "vɒlkænɪkli",
    "volcanic": "vɒlkænɪk",
    "volcanism": "vɒlkɐnɪzəm",
    "volcanoes": "vɒlkeɪnəʊz",
    "volcanologist": "vɒlkɐnɒlədʒɪst",
    "volcanology": "vɒlkɐnɒlədʒi",
    "volcanos": "vɒlkeɪnəʊz",
    "volcano": "vɒlkeɪnəʊ",
    "voles": "vəʊlz",
    "vole": "vəʊl",
    "volition": "vəlɪʃən",
    "volleyball": "vɒlɪbɔːl",
    "volleyed": "vɒlɪd",
    "volleyer": "vɒleɪɐ",
    "volleying": "vɒlɪɪŋ",
    "volleys": "vɒlɪz",
    "volley": "vɒli",
    "voltages": "vəʊltɪdʒɪz",
    "voltage": "vəʊltɪdʒ",
    "voltaic": "vəʊlteɪɪk",
    "voltmeter": "vəʊltmiːtɐ",
    "volts": "vəʊlts",
    "volt": "vəʊlt",
    "voluble": "vɒlʌbəl",
    "volubly": "vɒlʌbli",
    "volumed": "vɒljuːmd",
    "volumes": "vɒljuːmz",
    "volumetric": "vɒljuːmɛtrɪk",
    "volume": "vɒljuːm",
    "voluminous": "vəluːmɪnəs",
    "voluntarily": "vɒləntɛrəli",
    "voluntarism": "vɒləntərɪzəm",
    "voluntary": "vɒləntəri",
    "volunteered": "vɒləntiəd",
    "volunteering": "vɒləntiərɪŋ",
    "volunteerism": "vɒləntiərɪzəm",
    "volunteers": "vɒləntiəz",
    "volunteer": "vɒləntiə",
    "voluptuousness": "vəlʌptʃuːəsnəs",
    "voluptuous": "vəlʌptʃuːəs",
    "volute": "vɒluːt",
    "vomited": "vɒmɪtɪd",
    "vomiting": "vɒmɪtɪŋ",
    "vomitous": "vɒmɪtəs",
    "vomits": "vɒmɪts",
    "vomit": "vɒmɪt",
    "voodoo": "vuːduː",
    "voraciously": "vɔːreɪʃəsli",
    "voracious": "vɔːreɪʃəs",
    "voracity": "vɔːræsɪti",
    "vortexes": "vɔːtɛksɪz",
    "vortex": "vɔːtɛks",
    "vortices": "vɔːtɪsiːz",
    "voted": "vəʊtɪd",
    "voters": "vəʊtəz",
    "voter": "vəʊtɐ",
    "votes": "vəʊts",
    "vote": "vəʊt",
    "voting": "vəʊtɪŋ",
    "votive": "vəʊtɪv",
    "vouched": "vaʊtʃt",
    "vouchers": "vaʊtʃəz",
    "voucher": "vaʊtʃɐ",
    "vouches": "vaʊtʃɪz",
    "vouching": "vaʊtʃɪŋ",
    "vouchsafe": "vaʊtʃseɪf",
    "vouch": "vaʊtʃ",
    "vowed": "vaʊd",
    "vowels": "vaʊəlz",
    "vowel": "vaʊəl",
    "vowing": "vaʊɪŋ",
    "vows": "vaʊz",
    "vow": "vaʊ",
    "voyaged": "vɔɪɪdʒd",
    "voyagers": "vɔɪɪdʒəz",
    "voyager": "vɔɪɪdʒɐ",
    "voyages": "vɔɪɪdʒɪz",
    "voyage": "vɔɪɪdʒ",
    "voyaging": "vɔɪɪdʒɪŋ",
    "voyeurism": "vɔɪərɪzəm",
    "voyeuristic": "vɔɪjuːrɪstɪk",
    "voyeurs": "vɔɪɜːz",
    "voyeur": "vɔɪɜː",
    "vs": "viːɛs",
    "vulcanisation": "vʌlkɐnaɪzeɪʃən",
    "vulcanised": "vʌlkɐnaɪzd",
    "vulcanite": "vʌlkɐnaɪt",
    "vulcanologist": "vʌlkɐnɒlədʒɪst",
    "vulgarian": "vʌlɡeəriən",
    "vulgarisation": "vʌlɡəraɪzeɪʃən",
    "vulgarised": "vʌlɡəraɪzd",
    "vulgarities": "vʌlɡærɪtiz",
    "vulgarity": "vʌlɡærɪti",
    "vulgarly": "vʌlɡəli",
    "vulgar": "vʌlɡɐ",
    "vulgate": "vʌlɡeɪt",
    "vulnerabilities": "vʌlnərəbɪlɪtiz",
    "vulnerability": "vʌlnərəbɪlɪti",
    "vulnerable": "vʌlnərəbəl",
    "vulnerably": "vʌlnərəbli",
    "vulpine": "vʌlpaɪn",
    "vultures": "vʌltʃəz",
    "vulture": "vʌltʃɐ",
    "vulval": "vʌlvəl",
    "vulva": "vʌlvɐ",
    "v": "viː",
    "vying": "vaɪɪŋ",
    "wabble": "wɒbəl",
    "wackier": "wækiɐ",
    "wackiest": "wækiəst",
    "wackiness": "wækinəs",
    "wackos": "wækəʊz",
    "wacko": "wækəʊ",
    "wack": "wæk",
    "wacky": "wæki",
    "wadding": "wɒdɪŋ",
    "waddled": "wɒdəld",
    "waddler": "wɒdlɐ",
    "waddles": "wɒdəlz",
    "waddle": "wɒdəl",
    "waddling": "wɒdlɪŋ",
    "waded": "weɪdɪd",
    "waders": "weɪdəz",
    "wader": "weɪdɐ",
    "wades": "weɪdz",
    "wade": "weɪd",
    "wadges": "wɒdʒɪz",
    "wading": "weɪdɪŋ",
    "wadis": "wɒdɪz",
    "wadi": "wɒdi",
    "wads": "wɒdz",
    "wad": "wɒd",
    "wafers": "weɪfəz",
    "wafer": "weɪfɐ",
    "waffled": "wɒfəld",
    "waffler": "wɒflɐ",
    "waffles": "wɒfəlz",
    "waffle": "wɒfəl",
    "waffling": "wɒflɪŋ",
    "wafted": "wɑːftɪd",
    "wafting": "wɑːftɪŋ",
    "wafts": "wɑːfts",
    "waft": "wɑːft",
    "waged": "weɪdʒd",
    "wagered": "weɪdʒəd",
    "wagering": "weɪdʒərɪŋ",
    "wagers": "weɪdʒəz",
    "wager": "weɪdʒɐ",
    "wages": "weɪdʒɪz",
    "wage": "weɪdʒ",
    "wagged": "wæɡd",
    "wagging": "wæɡɪŋ",
    "waggish": "wæɡɪʃ",
    "waggled": "wæɡəld",
    "waggles": "wæɡəlz",
    "waggle": "wæɡəl",
    "waggling": "wæɡlɪŋ",
    "waggly": "wæɡli",
    "waging": "weɪdʒɪŋ",
    "wagoner": "wæɡənɐ",
    "wagons": "wæɡənz",
    "wagon": "wæɡən",
    "wags": "wæɡz",
    "wagtails": "wæɡteɪlz",
    "wagtail": "wæɡteɪl",
    "wag": "wæɡ",
    "wahoo": "wæhuː",
    "waifs": "weɪfs",
    "waif": "weɪf",
    "wailed": "weɪld",
    "wailers": "weɪləz",
    "wailing": "weɪlɪŋ",
    "wails": "weɪlz",
    "wail": "weɪl",
    "wainscoting": "weɪnskəʊtɪŋ",
    "wainscot": "weɪnskɒt",
    "wains": "weɪnz",
    "wain": "weɪn",
    "wainwrights": "weɪnraɪts",
    "wainwright": "weɪnraɪt",
    "waistbands": "weɪstbændz",
    "waistband": "weɪstbænd",
    "waistcoats": "weɪstkəʊts",
    "waistcoat": "weɪstkəʊt",
    "waisted": "weɪstɪd",
    "waistlines": "weɪslaɪnz",
    "waistline": "weɪslaɪn",
    "waists": "weɪsts",
    "waist": "weɪst",
    "waited": "weɪtɪd",
    "waiters": "weɪtəz",
    "waiter": "weɪtɐ",
    "waiting": "weɪtɪŋ",
    "waitresses": "weɪtrəsɪz",
    "waitressing": "weɪtrəsɪŋ",
    "waitress": "weɪtrəs",
    "waits": "weɪts",
    "wait": "weɪt",
    "waived": "weɪvd",
    "waivers": "weɪvəz",
    "waiver": "weɪvɐ",
    "waives": "weɪvz",
    "waive": "weɪv",
    "waiving": "weɪvɪŋ",
    "waked": "weɪkt",
    "wakefulness": "weɪkfəlnəs",
    "wakeful": "weɪkfəl",
    "wakened": "weɪkənd",
    "wakening": "weɪknɪŋ",
    "wakens": "weɪkənz",
    "waken": "weɪkən",
    "wakes": "weɪks",
    "wake": "weɪk",
    "waking": "weɪkɪŋ",
    "wales": "weɪlz",
    "wale": "weɪl",
    "walkable": "wɔːkəbəl",
    "walkabouts": "wɔːkɐbaʊts",
    "walkabout": "wɔːkɐbaʊt",
    "walkaway": "wɔːkəweɪ",
    "walked": "wɔːkt",
    "walkers": "wɔːkəz",
    "walker": "wɔːkɐ",
    "walkies": "wɔːkiz",
    "walking": "wɔːkɪŋ",
    "walkouts": "wɔːkaʊts",
    "walkout": "wɔːkaʊt",
    "walkovers": "wɔːkəʊvəz",
    "walkover": "wɔːkəʊvɐ",
    "walks": "wɔːks",
    "walkways": "wɔːkweɪz",
    "walkway": "wɔːkweɪ",
    "walk": "wɔːk",
    "wallabies": "wɒlæbɪz",
    "wallaby": "wɒlæbi",
    "wallahs": "wɒləz",
    "wallah": "wɒlɐ",
    "wallaroo": "wɒlɐruː",
    "walled": "wɔːld",
    "wallets": "wɒlɪts",
    "wallet": "wɒlɪt",
    "wallflowers": "wɔːlflaʊəz",
    "wallflower": "wɔːlflaʊɐ",
    "wallies": "wɒliz",
    "walling": "wɔːlɪŋ",
    "walloped": "wɒləpd",
    "walloper": "wɒləʊpɐ",
    "walloping": "wɒləpɪŋ",
    "wallops": "wɒləps",
    "wallop": "wɒləp",
    "wallowed": "wɒləʊd",
    "wallowing": "wɒləʊɪŋ",
    "wallows": "wɒləʊz",
    "wallow": "wɒləʊ",
    "wallpapered": "wɔːlpeɪpəd",
    "wallpapering": "wɔːlpeɪpərɪŋ",
    "wallpapers": "wɔːlpeɪpəz",
    "wallpaper": "wɔːlpeɪpɐ",
    "walls": "wɔːlz",
    "wall": "wɔːl",
    "wally": "wɒli",
    "walnuts": "wɒlnʌts",
    "walnut": "wɒlnʌt",
    "walruses": "wɒlrəsɪz",
    "walrus": "wɒlrəs",
    "waltzed": "wɒltsd",
    "waltzers": "wɒltsəz",
    "waltzer": "wɒltsɐ",
    "waltzes": "wɒltsɪz",
    "waltzing": "wɒltsɪŋ",
    "waltz": "wɒlts",
    "wampum": "wæmpəm",
    "wandered": "wɒndəd",
    "wanderers": "wɒndərəz",
    "wanderer": "wɒndərɐ",
    "wanderings": "wɒndərɪŋz",
    "wandering": "wɒndərɪŋ",
    "wanderlust": "wɒndəlʌst",
    "wanders": "wɒndəz",
    "wander": "wɒndɐ",
    "wands": "wɒndz",
    "wand": "wɒnd",
    "waned": "weɪnd",
    "wanes": "weɪnz",
    "wane": "weɪn",
    "wangled": "wænɡəld",
    "wanglers": "wænɡləz",
    "wangles": "wænɡəlz",
    "wangle": "wænɡəl",
    "wangling": "wænɡəlɪŋ",
    "waning": "weɪnɪŋ",
    "wanked": "wænkt",
    "wankers": "wænkəz",
    "wanker": "wænkɐ",
    "wanking": "wænkɪŋ",
    "wanks": "wænks",
    "wank": "wænk",
    "wanly": "wænli",
    "wannabees": "wɒnɐbiːz",
    "wannabee": "wɒnɐbiː",
    "wannabes": "wɒnɐbiːz",
    "wannabe": "wɒnɐbiː",
    "wanna": "wɒnɐ",
    "wantage": "wɒntɪdʒ",
    "wanted": "wɒntɪd",
    "wanting": "wɒntɪŋ",
    "wantonly": "wɒntənli",
    "wantonness": "wɒntənnəs",
    "wantons": "wɒntənz",
    "wanton": "wɒntən",
    "wants": "wɒnts",
    "want": "wɒnt",
    "wan": "wæn",
    "warbled": "wɔːbəld",
    "warblers": "wɔːbləz",
    "warbler": "wɔːblɐ",
    "warbles": "wɔːbəlz",
    "warble": "wɔːbəl",
    "warbling": "wɔːblɪŋ",
    "warded": "wɔːdɪd",
    "wardens": "wɔːdənz",
    "warden": "wɔːdən",
    "warders": "wɔːdəz",
    "warder": "wɔːdɐ",
    "warding": "wɔːdɪŋ",
    "wardresses": "wɔːdrɛsɪz",
    "wardrobes": "wɔːdrəʊbz",
    "wardrobe": "wɔːdrəʊb",
    "wardroom": "wɔːdruːm",
    "wards": "wɔːdz",
    "ward": "wɔːd",
    "warehouseman": "weəhaʊsɛmən",
    "warehousemen": "weəhaʊsɛmɛn",
    "warehouses": "weəhaʊzɪz",
    "warehouse": "weəhaʊs",
    "warehousing": "weəhaʊsɪŋ",
    "wares": "weəz",
    "warfare": "wɔːfeə",
    "warfarin": "wɔːfərɪn",
    "warheads": "wɔːhɛdz",
    "warhead": "wɔːhɛd",
    "warhorses": "wɔːhɔːsɪz",
    "warhorse": "wɔːhɔːs",
    "warier": "weəriɐ",
    "warily": "weərili",
    "wariness": "weərinəs",
    "waring": "weərɪŋ",
    "warlike": "wɔːlaɪk",
    "warlocks": "wɔːlɒks",
    "warlock": "wɔːlɒk",
    "warlords": "wɔːlɔːdz",
    "warlord": "wɔːlɔːd",
    "warmed": "wɔːmd",
    "warmers": "wɔːməz",
    "warmer": "wɔːmɐ",
    "warmest": "wɔːməst",
    "warming": "wɔːmɪŋ",
    "warmish": "wɔːmɪʃ",
    "warmly": "wɔːmli",
    "warmness": "wɔːmnəs",
    "warmongering": "wɔːməŋɡərɪŋ",
    "warmongers": "wɔːmʌŋɡəz",
    "warmonger": "wɔːmʌŋɡɐ",
    "warms": "wɔːmz",
    "warmth": "wɔːmθ",
    "warmups": "wɔːmʌps",
    "warmup": "wɔːmʌp",
    "warm": "wɔːm",
    "warned": "wɔːnd",
    "warnings": "wɔːnɪŋz",
    "warning": "wɔːnɪŋ",
    "warns": "wɔːnz",
    "warn": "wɔːn",
    "warpaint": "wɔːpeɪnt",
    "warpath": "wɔːpɑːθ",
    "warped": "wɔːpt",
    "warper": "wɔːpɐ",
    "warping": "wɔːpɪŋ",
    "warplanes": "wɔːpleɪnz",
    "warplane": "wɔːpleɪn",
    "warps": "wɔːps",
    "warp": "wɔːp",
    "warranted": "wɒrəntɪd",
    "warrantee": "wɒrɑːntiː",
    "warranties": "wɒrəntɪz",
    "warranting": "wɒrəntɪŋ",
    "warrants": "wɒrənts",
    "warrant": "wɒrənt",
    "warranty": "wɒrənti",
    "warred": "wɔːd",
    "warreners": "wɒrənəz",
    "warrener": "wɒrənɐ",
    "warrens": "wɒrənz",
    "warren": "wɒrən",
    "warring": "wɔːrɪŋ",
    "warriors": "wɒrɪəz",
    "warrior": "wɒrɪɐ",
    "warships": "wɔːʃɪps",
    "warship": "wɔːʃɪp",
    "wars": "wɔːz",
    "warthogs": "wɔːthɒɡz",
    "warthog": "wɔːthɒɡ",
    "wartiest": "wɔːtɪəst",
    "wartime": "wɔːtaɪm",
    "warts": "wɔːts",
    "wart": "wɔːt",
    "warty": "wɔːti",
    "war": "wɔː",
    "wary": "weəri",
    "wasabi": "wɐsɑːbi",
    "washable": "wɒʃəbəl",
    "washbasins": "wɒʃbeɪsənz",
    "washbasin": "wɒʃbeɪsən",
    "washboards": "wɒʃbɔːdz",
    "washboard": "wɒʃbɔːd",
    "washday": "wɒʃdeɪ",
    "washed": "wɒʃt",
    "washers": "wɒʃəz",
    "washer": "wɒʃɐ",
    "washerwoman": "wɒʃəwʊmən",
    "washerwomen": "wɒʃəwɪmɪn",
    "washes": "wɒʃɪz",
    "washhouses": "wɒʃhaʊzɪz",
    "washhouse": "wɒʃhaʊs",
    "washings": "wɒʃɪŋz",
    "washing": "wɒʃɪŋ",
    "washin": "wɒʃɪn",
    "washouts": "wɒʃaʊts",
    "washout": "wɒʃaʊt",
    "washrooms": "wɒʃruːmz",
    "washroom": "wɒʃruːm",
    "washstands": "wɒʃstændz",
    "washstand": "wɒʃstænd",
    "washtub": "wɒʃtʌb",
    "wash": "wɒʃ",
    "washy": "wɒʃi",
    "waspish": "wɒspɪʃ",
    "wasps": "wɒsps",
    "wasp": "wɒsp",
    "wassailing": "wɒseɪlɪŋ",
    "wassail": "wɒseɪl",
    "wastage": "weɪstɪdʒ",
    "wastebaskets": "weɪstbɑːskɪts",
    "wastebasket": "weɪstbɑːskɪt",
    "wasted": "weɪstɪd",
    "wastefully": "weɪstfəli",
    "wastefulness": "weɪstfəlnəs",
    "wasteful": "weɪstfəl",
    "wastelands": "weɪstləndz",
    "wasteland": "weɪstlənd",
    "wastepaper": "weɪstpeɪpɐ",
    "wasters": "weɪstəz",
    "waster": "weɪstɐ",
    "wastes": "weɪsts",
    "waste": "weɪst",
    "wasting": "weɪstɪŋ",
    "wastrel": "wɑːstrəl",
    "wast": "wɒst",
    "was": "wɒz",
    "watchable": "wɒtʃəbəl",
    "watchdogs": "wɒtʃdɒɡz",
    "watchdog": "wɒtʃdɒɡ",
    "watched": "wɒtʃt",
    "watchers": "wɒtʃəz",
    "watcher": "wɒtʃɐ",
    "watches": "wɒtʃɪz",
    "watchfulness": "wɒtʃfəlnəs",
    "watchful": "wɒtʃfəl",
    "watching": "wɒtʃɪŋ",
    "watchmakers": "wɒtʃmeɪkəz",
    "watchmaker": "wɒtʃmeɪkɐ",
    "watchmaking": "wɒtʃmeɪkɪŋ",
    "watchman": "wɒtʃmən",
    "watchmen": "wɒtʃmɛn",
    "watchtowers": "wɒtʃtaʊəz",
    "watchtower": "wɒtʃtaʊɐ",
    "watchwords": "wɒtʃwɜːdz",
    "watchword": "wɒtʃwɜːd",
    "watch": "wɒtʃ",
    "waterbed": "wɔːtəbɛd",
    "waterbirds": "wɔːtəbɜːdz",
    "waterborne": "wɔːtəbɔːn",
    "waterbuck": "wɔːtəbʌk",
    "watercolourists": "wɔːtəkʌlərɪsts",
    "watercolourist": "wɔːtəkʌlərɪst",
    "watercolours": "wɔːtəkʌləz",
    "watercolour": "wɔːtəkʌlɐ",
    "watercourses": "wɔːtəkɔːsɪz",
    "watercourse": "wɔːtəkɔːs",
    "watercraft": "wɔːtəkrɑːft",
    "watercress": "wɔːtəkrɛs",
    "watered": "wɔːtəd",
    "waterfalls": "wɔːtəfɔːlz",
    "waterfall": "wɔːtəfɔːl",
    "waterfowl": "wɔːtəfaʊl",
    "waterfronts": "wɔːtəfrʌnts",
    "waterfront": "wɔːtəfrʌnt",
    "waterholes": "wɔːtəhəʊlz",
    "waterhole": "wɔːtəhəʊl",
    "wateriest": "wɔːtiərɪəst",
    "wateriness": "wɔːtərinəs",
    "watering": "wɔːtərɪŋ",
    "waterless": "wɔːtələs",
    "waterlilies": "wɔːtəllɪz",
    "waterlily": "wɔːtəlili",
    "waterline": "wɔːtəlaɪn",
    "waterlogged": "wɔːtəlɒɡd",
    "waterlog": "wɔːtəlɒɡ",
    "waterloo": "wɔːtəluː",
    "waterman": "wɔːtəmən",
    "watermarked": "wɔːtəmɑːkt",
    "watermarks": "wɔːtəmɑːks",
    "watermark": "wɔːtəmɑːk",
    "watermelons": "wɔːtəmɛlənz",
    "watermelon": "wɔːtəmɛlən",
    "watermen": "wɔːtəmɛn",
    "watermills": "wɔːtəmɪlz",
    "watermill": "wɔːtəmɪl",
    "waterproofed": "wɔːtəpruːft",
    "waterproofing": "wɔːtəpruːfɪŋ",
    "waterproofs": "wɔːtəpruːfs",
    "waterproof": "wɔːtəpruːf",
    "waterscape": "wɔːtəskeɪp",
    "watershed": "wɔːtəʃɛd",
    "waterside": "wɔːtəsaɪd",
    "waterspouts": "wɔːtəspaʊts",
    "waterspout": "wɔːtəspaʊt",
    "waters": "wɔːtəz",
    "watertight": "wɔːtətaɪt",
    "waterways": "wɔːtəweɪz",
    "waterway": "wɔːtəweɪ",
    "waterwheels": "wɔːtəwiːlz",
    "waterwheel": "wɔːtəwiːl",
    "waterworks": "wɔːtəwɜːks",
    "water": "wɔːtɐ",
    "watery": "wɔːtəri",
    "wattage": "wɒtɪdʒ",
    "wattled": "wɒtəld",
    "wattles": "wɒtəlz",
    "wattle": "wɒtəl",
    "wattling": "wɒtlɪŋ",
    "watts": "wɒts",
    "watt": "wɒt",
    "wat": "wæt",
    "waveband": "weɪvbænd",
    "waved": "weɪvd",
    "waveforms": "weɪvfɔːmz",
    "waveform": "weɪvfɔːm",
    "wavelengths": "weɪvlɛŋθs",
    "wavelength": "weɪvlɛŋθ",
    "wavelike": "weɪvlaɪk",
    "wavered": "weɪvəd",
    "waverers": "weɪvrəz",
    "wavering": "weɪvərɪŋ",
    "wavers": "weɪvəz",
    "waver": "weɪvɐ",
    "waves": "weɪvz",
    "wave": "weɪv",
    "wavier": "weɪvɪɐ",
    "waving": "weɪvɪŋ",
    "wavy": "weɪvi",
    "waw": "wɔː",
    "waxed": "wækst",
    "waxen": "wæksən",
    "waxes": "wæksɪz",
    "waxiness": "wæksinəs",
    "waxing": "wæksɪŋ",
    "wax": "wæks",
    "waxwings": "wækswɪŋz",
    "waxwing": "wækswɪŋ",
    "waxworks": "wækswɜːks",
    "waxwork": "wækswɜːk",
    "waxy": "wæksi",
    "waybill": "weɪbɪl",
    "wayfarers": "weɪfeərəz",
    "wayfarer": "weɪfeərɐ",
    "wayfaring": "weɪfeərɪŋ",
    "waylaid": "weɪleɪd",
    "waylay": "weɪleɪ",
    "waymarked": "weɪmɑːkt",
    "waysides": "weɪsaɪdz",
    "wayside": "weɪsaɪd",
    "ways": "weɪz",
    "waywardness": "weɪwədnəs",
    "wayward": "weɪwəd",
    "way": "weɪ",
    "wazoo": "wæzuː",
    "w": "dʌbəljuː",
    "weakened": "wiːkənd",
    "weakening": "wiːkənɪŋ",
    "weakens": "wiːkənz",
    "weaken": "wiːkən",
    "weaker": "wiːkɐ",
    "weakest": "wiːkəst",
    "weakish": "wiːkɪʃ",
    "weaklings": "wiːklɪŋz",
    "weakling": "wiːklɪŋ",
    "weakly": "wiːkli",
    "weaknesses": "wiːknəsɪz",
    "weakness": "wiːknəs",
    "weak": "wiːk",
    "weald": "wiːld",
    "weals": "wiːlz",
    "wealthier": "wɛlθɪɐ",
    "wealthiest": "wɛlθɪəst",
    "wealth": "wɛlθ",
    "wealthy": "wɛlθi",
    "weal": "wiːl",
    "weaned": "wiːnd",
    "weaner": "wiːnɐ",
    "weaning": "wiːnɪŋ",
    "weans": "wiːnz",
    "wean": "wiːn",
    "weaponry": "wɛpənri",
    "weapons": "wɛpənz",
    "weapon": "wɛpən",
    "wearable": "weərəbəl",
    "wearers": "weərəz",
    "wearer": "weərɐ",
    "wearied": "wiərɪd",
    "wearier": "wiərɪɐ",
    "wearily": "wiərɪli",
    "weariness": "wiərɪnəs",
    "wearing": "weərɪŋ",
    "wearisome": "weərisʌm",
    "wears": "weəz",
    "wearyingly": "wiərɪɪŋli",
    "wearying": "wiərɪɪŋ",
    "weary": "wiəri",
    "weaselling": "wiːsɛlɪŋ",
    "weaselly": "wiːzəli",
    "weasels": "wiːzəlz",
    "weasel": "wiːzəl",
    "weatherboarding": "wɛðəbɔːdɪŋ",
    "weatherboard": "wɛðəbɔːd",
    "weathercock": "wɛðəkɒk",
    "weathered": "wɛðəd",
    "weathering": "wɛðərɪŋ",
    "weatherly": "wɛðəli",
    "weatherman": "wɛðəmən",
    "weathermen": "wɛðəmɛn",
    "weatherproofing": "wɛðəpruːfɪŋ",
    "weatherproof": "wɛðəpruːf",
    "weathers": "wɛðəz",
    "weathervane": "wɛðəveɪn",
    "weather": "wɛðɐ",
    "weaved": "wiːvd",
    "weaverbird": "wiːvəbɜːd",
    "weavers": "wiːvəz",
    "weaver": "wiːvɐ",
    "weaves": "wiːvz",
    "weave": "wiːv",
    "weaving": "wiːvɪŋ",
    "webbed": "wɛbd",
    "webbing": "wɛbɪŋ",
    "webby": "wɛbi",
    "webcast": "wɛbkɑːst",
    "weber": "wɛbɐ",
    "webpage": "wɛbpeɪdʒ",
    "websites": "wɛbsaɪts",
    "website": "wɛbsaɪt",
    "webs": "wɛbz",
    "web": "wɛb",
    "wedded": "wɛdɪd",
    "weddings": "wɛdɪŋz",
    "wedding": "wɛdɪŋ",
    "wedged": "wɛdʒd",
    "wedges": "wɛdʒɪz",
    "wedge": "wɛdʒ",
    "wedgies": "wɛdʒɪz",
    "wedgie": "wɛdʒi",
    "wedging": "wɛdʒɪŋ",
    "wedlock": "wɛdlɒk",
    "weds": "wɛdz",
    "wed": "wɛd",
    "weeded": "wiːdɪd",
    "weeders": "wiːdəz",
    "weeder": "wiːdɐ",
    "weediness": "wiːdɪnəs",
    "weeding": "wiːdɪŋ",
    "weedkillers": "wiːdkɪləz",
    "weedkiller": "wiːdkɪlɐ",
    "weeds": "wiːdz",
    "weed": "wiːd",
    "weedy": "wiːdi",
    "weeing": "wiːɪŋ",
    "weekdays": "wiːkdeɪz",
    "weekday": "wiːkdeɪ",
    "weekenders": "wiːkɛndəz",
    "weekender": "wiːkɛndɐ",
    "weekending": "wiːkɛndɪŋ",
    "weekends": "wiːkɛndz",
    "weekend": "wiːkɛnd",
    "weeklies": "wiːkliz",
    "weekly": "wiːkli",
    "weeknight": "wiːknaɪt",
    "weeks": "wiːks",
    "week": "wiːk",
    "weeniest": "wiːnɪəst",
    "weenies": "wiːnɪz",
    "weenie": "wiːni",
    "weening": "wiːnɪŋ",
    "weensiest": "wiːnzɪəst",
    "weensy": "wiːnzi",
    "ween": "wiːn",
    "weeny": "wiːni",
    "weepers": "wiːpəz",
    "weepiest": "wiːpɪəst",
    "weepies": "wiːpɪz",
    "weepie": "wiːpaɪ",
    "weeping": "wiːpɪŋ",
    "weeps": "wiːps",
    "weep": "wiːp",
    "weepy": "wiːpi",
    "weer": "wiə",
    "wees": "wiːz",
    "weever": "wiːvɐ",
    "weevils": "wiːvəlz",
    "weevil": "wiːvəl",
    "wee": "wiː",
    "wefts": "wɛfts",
    "weft": "wɛft",
    "weigela": "waɪdʒɛlɐ",
    "weighbridge": "weɪbrɪdʒ",
    "weighed": "weɪd",
    "weighing": "weɪɪŋ",
    "weighs": "weɪz",
    "weighted": "weɪtɪd",
    "weightier": "weɪtɪɐ",
    "weightiest": "weɪtɪəst",
    "weightiness": "weɪtɪnəs",
    "weightings": "weɪtɪŋz",
    "weighting": "weɪtɪŋ",
    "weightlessly": "weɪtləsli",
    "weightlessness": "weɪtləsnəs",
    "weightless": "weɪtləs",
    "weightlifters": "weɪtlɪftəz",
    "weightlifter": "weɪtlɪftɐ",
    "weightlifting": "weɪtlɪftɪŋ",
    "weights": "weɪts",
    "weight": "weɪt",
    "weighty": "weɪti",
    "weigh": "weɪ",
    "weirder": "wiədɐ",
    "weirdest": "wiədəst",
    "weirdies": "wiədɪz",
    "weirdly": "wiədli",
    "weirdness": "wiədnəs",
    "weirdos": "wiədəʊz",
    "weirdo": "wiədəʊ",
    "weird": "wiəd",
    "weirs": "wiəz",
    "weir": "wiə",
    "weka": "wɛkɐ",
    "welched": "wɛltʃt",
    "welching": "wɛltʃɪŋ",
    "welch": "wɛltʃ",
    "welcomed": "wɛlkʌmd",
    "welcomes": "wɛlkʌmz",
    "welcome": "wɛlkʌm",
    "welcoming": "wɛlkʌmɪŋ",
    "welded": "wɛldɪd",
    "welders": "wɛldəz",
    "welder": "wɛldɐ",
    "welding": "wɛldɪŋ",
    "welds": "wɛldz",
    "weld": "wɛld",
    "welfare": "wɛlfeə",
    "welkin": "wɛlkɪn",
    "welled": "wɛld",
    "wellheads": "wɛlhɛdz",
    "wellhead": "wɛlhɛd",
    "wellies": "wɛliz",
    "wellie": "wɛli",
    "wellingtons": "wɛlɪŋtənz",
    "wellington": "wɛlɪŋtən",
    "welling": "wɛlɪŋ",
    "wellness": "wɛlnəs",
    "wellsprings": "wɛlsprɪŋz",
    "wellspring": "wɛlsprɪŋ",
    "wells": "wɛlz",
    "well": "wɛl",
    "welly": "wɛli",
    "welshed": "wɛlʃɛd",
    "welsher": "wɛlʃɐ",
    "welsh": "wɛlʃ",
    "welterweights": "wɛltəweɪts",
    "welterweight": "wɛltəweɪt",
    "welter": "wɛltɐ",
    "welting": "wɛltɪŋ",
    "welts": "wɛlts",
    "welt": "wɛlt",
    "wenches": "wɛntʃɪz",
    "wench": "wɛntʃ",
    "wended": "wɛndɪd",
    "wendigo": "wɛndɪɡəʊ",
    "wending": "wɛndɪŋ",
    "wends": "wɛndz",
    "wend": "wɛnd",
    "wens": "wɛnz",
    "went": "wɛnt",
    "wen": "wɛn",
    "wept": "wɛpt",
    "were": "wɜː",
    "werewolf": "weəwʊlf",
    "werewolves": "weəwʊlvz",
    "wert": "wɜːt",
    "westbound": "wɛstbaʊnd",
    "westerlies": "wɛstəliz",
    "westerly": "wɛstəli",
    "westerners": "wɛstənəz",
    "westerner": "wɛstənɐ",
    "westernised": "wɛstənaɪzd",
    "westernmost": "wɛstənməʊst",
    "westerns": "wɛstənz",
    "western": "wɛstən",
    "westers": "wɛstəz",
    "wester": "wɛstɐ",
    "westwards": "wɛstwədz",
    "westward": "wɛstwəd",
    "west": "wɛst",
    "wetbacks": "wɛtbæks",
    "wetback": "wɛtbæk",
    "wether": "wɛðɐ",
    "wetlands": "wɛtləndz",
    "wetland": "wɛtlənd",
    "wetly": "wɛtli",
    "wetness": "wɛtnəs",
    "wetsuits": "wɛtsuːts",
    "wetsuit": "wɛtsuːt",
    "wets": "wɛts",
    "wettable": "wɛtəbəl",
    "wetted": "wɛtɪd",
    "wetters": "wɛtəz",
    "wetter": "wɛtɐ",
    "wettest": "wɛtəst",
    "wetting": "wɛtɪŋ",
    "wet": "wɛt",
    "we": "wiː",
    "whacked": "wækt",
    "whackers": "wækəz",
    "whacker": "wækɐ",
    "whackiest": "wækiəst",
    "whacking": "wækɪŋ",
    "whacks": "wæks",
    "whack": "wæk",
    "whacky": "wæki",
    "whaleback": "weɪlbæk",
    "whalebone": "weɪlbəʊn",
    "whaled": "weɪld",
    "whalers": "weɪləz",
    "whaler": "weɪlɐ",
    "whales": "weɪlz",
    "whale": "weɪl",
    "whaling": "weɪlɪŋ",
    "whammed": "wæmd",
    "whammies": "wæmɪz",
    "whammy": "wæmi",
    "whams": "wæmz",
    "wham": "wæm",
    "whapping": "wæpɪŋ",
    "whap": "wæp",
    "wharfage": "wɔːfɪdʒ",
    "wharfinger": "wɔːfɪŋɡɐ",
    "wharfs": "wɔːfs",
    "wharf": "wɔːf",
    "wharves": "wɔːvz",
    "whatchamacallit": "wɒttʃɐmækɐlɪt",
    "whate'er": "wɒteə",
    "whatever": "wɒtɛvɐ",
    "whatnot": "wɒtnɒt",
    "whatshername": "wɒtʃəneɪm",
    "whatshisname": "wɒtʃɪzneɪm",
    "whatsits": "wɒtsɪts",
    "whatsit": "wɒtsɪt",
    "whatsoever": "wɒtsəʊɛvɐ",
    "whats": "wɒts",
    "what": "wɒt",
    "wheal": "wiːl",
    "wheatears": "wiːtiəz",
    "wheatear": "wiːtiə",
    "wheaten": "wiːtən",
    "wheatgerm": "wiːtdʒɜːm",
    "wheatmeal": "wiːtmiəl",
    "wheat": "wiːt",
    "wheedled": "wiːdəld",
    "wheedle": "wiːdəl",
    "wheedling": "wiːdlɪŋ",
    "wheelbarrows": "wiːlbærəʊz",
    "wheelbarrow": "wiːlbærəʊ",
    "wheelbase": "wiːlbeɪs",
    "wheelchairs": "wiːltʃeəz",
    "wheelchair": "wiːltʃeə",
    "wheeled": "wiːld",
    "wheelers": "wiːləz",
    "wheeler": "wiːlɐ",
    "wheelhouse": "wiːlhaʊs",
    "wheelies": "wiːliz",
    "wheelie": "wiːli",
    "wheeling": "wiːlɪŋ",
    "wheelman": "wiːlmən",
    "wheels": "wiːlz",
    "wheel": "wiːl",
    "wheelwright": "wiːlraɪt",
    "wheen": "wiːn",
    "whee": "wiː",
    "wheezed": "wiːzd",
    "wheezes": "wiːzɪz",
    "wheeze": "wiːz",
    "wheezing": "wiːzɪŋ",
    "wheezy": "wiːzi",
    "whelks": "wɛlks",
    "whelk": "wɛlk",
    "whelmed": "wɛlmd",
    "whelming": "wɛlmɪŋ",
    "whelping": "wɛlpɪŋ",
    "whelps": "wɛlps",
    "whelp": "wɛlp",
    "whence": "wɛns",
    "whene'er": "wɛneə",
    "whenever": "wɛnɛvɐ",
    "whens": "wɛnz",
    "when": "wɛn",
    "whereabouts": "weərɐbaʊts",
    "whereabout": "weərɐbaʊt",
    "whereas": "weərəz",
    "whereat": "weəræt",
    "whereby": "weəbaɪ",
    "where'er": "weərɐ",
    "wherefores": "weəfɔːz",
    "wherefore": "weəfɔː",
    "wherein": "weərɪn",
    "whereof": "weərɒf",
    "whereon": "weərɒn",
    "wheresoever": "weəsəʊɛvɐ",
    "wheres": "weəz",
    "whereto": "weətəʊ",
    "whereupon": "weərəpɒn",
    "wherever": "weərɛvɐ",
    "where": "weə",
    "wherewithal": "weəwɪðɔːl",
    "wherewith": "weəwɪð",
    "wherries": "wɛrɪz",
    "wherry": "wɛri",
    "whether": "wɛðɐ",
    "whetstone": "wɛtstəʊn",
    "whets": "wɛts",
    "whetted": "wɛtɪd",
    "whetting": "wɛtɪŋ",
    "whet": "wɛt",
    "whew": "fjuː",
    "whey": "weɪ",
    "whichever": "wɪtʃɛvɐ",
    "which": "wɪtʃ",
    "whickers": "wɪkəz",
    "whicker": "wɪkɐ",
    "whiffed": "wɪft",
    "whiffle": "wɪfəl",
    "whiffs": "wɪfs",
    "whiff": "wɪf",
    "whiled": "waɪld",
    "whiles": "waɪlz",
    "while": "waɪl",
    "whiling": "waɪlɪŋ",
    "whilst": "waɪlst",
    "whimpered": "wɪmpəd",
    "whimpering": "wɪmpərɪŋ",
    "whimpers": "wɪmpəz",
    "whimper": "wɪmpɐ",
    "whimsical": "wɪmzɪkəl",
    "whimsies": "wɪmzɪz",
    "whims": "wɪmz",
    "whimsy": "wɪmzi",
    "whim": "wɪm",
    "whinchat": "wɪntʃæt",
    "whined": "waɪnd",
    "whiners": "waɪnəz",
    "whiner": "waɪnɐ",
    "whines": "waɪnz",
    "whine": "waɪn",
    "whiney": "waɪni",
    "whinged": "wɪndʒd",
    "whingeing": "wɪndʒɪŋ",
    "whingers": "wɪŋɡəz",
    "whinger": "wɪŋɡɐ",
    "whinges": "wɪndʒɪz",
    "whinge": "wɪndʒ",
    "whinging": "wɪndʒɪŋ",
    "whingy": "wɪŋi",
    "whining": "waɪnɪŋ",
    "whinnied": "wɪnɪd",
    "whinnies": "wɪnɪz",
    "whinnying": "wɪnɪɪŋ",
    "whinny": "wɪni",
    "whins": "wɪnz",
    "whin": "wɪn",
    "whiny": "waɪni",
    "whiplashes": "wɪplæʃɪz",
    "whiplash": "wɪplæʃ",
    "whipped": "wɪpt",
    "whippersnappers": "wɪpəsnæpəz",
    "whippersnapper": "wɪpəsnæpɐ",
    "whipper": "wɪpɐ",
    "whippets": "wɪpɪts",
    "whippet": "wɪpɪt",
    "whippings": "wɪpɪŋz",
    "whipping": "wɪpɪŋ",
    "whippoorwills": "wɪpɔːwɪlz",
    "whippoorwill": "wɪpɔːwɪl",
    "whips": "wɪps",
    "whip": "wɪp",
    "whirled": "wɜːld",
    "whirler": "wɜːlɐ",
    "whirligig": "wɜːlɪdʒɪɡ",
    "whirling": "wɜːlɪŋ",
    "whirlpools": "wɜːlpuːlz",
    "whirlpool": "wɜːlpuːl",
    "whirls": "wɜːlz",
    "whirlwinds": "wɜːlwɪndz",
    "whirlwind": "wɜːlwɪnd",
    "whirl": "wɜːl",
    "whirlybird": "wɜːlɪbɜːd",
    "whirly": "wɜːli",
    "whirred": "wɜːd",
    "whirring": "wɜːrɪŋ",
    "whirrs": "wɜːz",
    "whirr": "wɜː",
    "whirs": "wɜːz",
    "whir": "wɜː",
    "whish": "wɪʃ",
    "whisked": "wɪskt",
    "whiskered": "wɪskəd",
    "whiskers": "wɪskəz",
    "whisker": "wɪskɐ",
    "whiskery": "wɪskəri",
    "whiskeys": "wɪskɪz",
    "whiskey": "wɪski",
    "whiskies": "wɪskiz",
    "whisking": "wɪskɪŋ",
    "whisks": "wɪsks",
    "whisk": "wɪsk",
    "whiskys": "wɪskiz",
    "whisky": "wɪski",
    "whispered": "wɪspəd",
    "whisperers": "wɪspərəz",
    "whisperer": "wɪspərɐ",
    "whisperings": "wɪspərɪŋz",
    "whispering": "wɪspərɪŋ",
    "whispers": "wɪspəz",
    "whisper": "wɪspɐ",
    "whispery": "wɪspəri",
    "whistled": "wɪsəld",
    "whistlers": "wɪsləz",
    "whistler": "wɪslɐ",
    "whistles": "wɪsəlz",
    "whistle": "wɪsəl",
    "whistling": "wɪslɪŋ",
    "whist": "wɪst",
    "whitebait": "waɪtbeɪt",
    "whitebeam": "waɪtbiːm",
    "whiteboards": "waɪtbɔːdz",
    "whiteboard": "waɪtbɔːd",
    "whitecaps": "waɪtkæps",
    "whited": "waɪtɪd",
    "whitefish": "waɪtfɪʃ",
    "whitefly": "waɪtflaɪ",
    "whiteheads": "waɪthɛdz",
    "whitehead": "waɪthɛd",
    "whitely": "waɪtli",
    "whitened": "waɪtənd",
    "whitener": "waɪtnɐ",
    "whiteness": "waɪtnəs",
    "whitening": "waɪtnɪŋ",
    "whitens": "waɪtənz",
    "whiten": "waɪtən",
    "whiteouts": "waɪtaʊts",
    "whiteout": "waɪtaʊt",
    "whiter": "waɪtɐ",
    "whitesmith": "waɪtsmɪθ",
    "whitest": "waɪtəst",
    "whites": "waɪts",
    "whitetail": "waɪtteɪl",
    "whitethroat": "waɪtθrəʊt",
    "whitewashed": "waɪtwɒʃt",
    "whitewashes": "waɪtwɒʃɪz",
    "whitewashing": "waɪtwɒʃɪŋ",
    "whitewash": "waɪtwɒʃ",
    "white": "waɪt",
    "whitewater": "waɪtwɔːtɐ",
    "whiteys": "waɪtɪz",
    "whitey": "waɪti",
    "whither": "wɪðɐ",
    "whitings": "waɪtɪŋz",
    "whiting": "waɪtɪŋ",
    "whitish": "waɪtɪʃ",
    "whits": "wɪts",
    "whittled": "wɪtəld",
    "whittles": "wɪtəlz",
    "whittle": "wɪtəl",
    "whittling": "wɪtlɪŋ",
    "whit": "wɪt",
    "whity": "waɪti",
    "whiz": "wɪz",
    "whizzed": "wɪzd",
    "whizzes": "wɪzɪz",
    "whizzing": "wɪzɪŋ",
    "whizz": "wɪz",
    "whoa": "wəʊ",
    "whodunit": "huːdjuːnɪt",
    "whodunnit": "huːdənɪt",
    "whodunnits": "huːdənɪts",
    "whoever": "huːɛvɐ",
    "who": "huː",
    "wholefood": "həʊlfuːd",
    "wholefoods": "həʊlfuːdz",
    "wholegrain": "həʊlɡreɪn",
    "wholehearted": "həʊlhɑːtɪd",
    "wholeheartedly": "həʊlhɑːtɪdli",
    "wholeheartedness": "həʊlhɑːtɪdnəs",
    "whole": "həʊl",
    "wholemeal": "həʊlmiəl",
    "wholeness": "həʊlnəs",
    "wholesale": "həʊlseɪl",
    "wholesaler": "həʊlseɪlɐ",
    "wholesalers": "həʊlseɪləz",
    "wholesaling": "həʊlseɪlɪŋ",
    "wholes": "həʊlz",
    "wholesome": "həʊlsʌm",
    "wholesomeness": "həʊlsʌmnəs",
    "wholewheat": "həʊlwiːt",
    "wholly": "həʊli",
    "whomever": "huːmɛvɐ",
    "whom": "huːm",
    "whomp": "huːmp",
    "whomping": "huːmpɪŋ",
    "whomsoever": "huːmsəʊɛvɐ",
    "whooped": "wuːpt",
    "whoopee": "wuːpiː",
    "whoopers": "wuːpəz",
    "whooper": "wuːpɐ",
    "whooping": "wuːpɪŋ",
    "whoops": "wuːps",
    "whooshed": "wuːʃt",
    "whooshes": "wuːʃɪz",
    "whooshing": "wuːʃɪŋ",
    "whoosh": "wuːʃ",
    "whopped": "wɒpt",
    "whoppers": "wɒpəz",
    "whopper": "wɒpɐ",
    "whopping": "wɒpɪŋ",
    "whops": "wɒps",
    "whop": "wɒp",
    "whoredom": "wɔːdəm",
    "whore": "hɔː",
    "whorehouse": "hɔːhaʊs",
    "whorehouses": "hɔːhaʊzɪz",
    "whoreish": "wɔːreɪʃ",
    "whores": "hɔːz",
    "whoreson": "wɔːsən",
    "whoring": "wɔːrɪŋ",
    "whorls": "wɔːlz",
    "whorl": "wɔːl",
    "whose": "huːz",
    "whosoever": "huːsəʊɛvɐ",
    "whoso": "huːsəʊ",
    "whupped": "wʌpt",
    "whupping": "wʌpɪŋ",
    "whup": "wʌp",
    "whys": "waɪz",
    "why": "waɪ",
    "wickeder": "wɪkɛdɐ",
    "wickedest": "wɪkɛdəst",
    "wickedly": "wɪkɪdli",
    "wickedness": "wɪkɪdnəs",
    "wickers": "wɪkəz",
    "wicker": "wɪkɐ",
    "wickerwork": "wɪkəwɜːk",
    "wicketkeepers": "wɪkɪtkiːpəz",
    "wicketkeeper": "wɪkɪtkiːpɐ",
    "wickets": "wɪkɪts",
    "wicket": "wɪkɪt",
    "wicks": "wɪks",
    "wick": "wɪk",
    "widdershins": "wɪdəʃɪnz",
    "widely": "waɪdli",
    "widened": "waɪdənd",
    "wideness": "waɪdnəs",
    "widening": "waɪdnɪŋ",
    "widens": "waɪdənz",
    "widen": "waɪdən",
    "wider": "waɪdɐ",
    "widespread": "waɪdsprɛd",
    "widest": "waɪdəst",
    "wides": "waɪdz",
    "wide": "waɪd",
    "widgeon": "wɪdʒɒn",
    "widgets": "wɪdʒɪts",
    "widget": "wɪdʒɪt",
    "widowed": "wɪdəʊd",
    "widowers": "wɪdəʊəz",
    "widower": "wɪdəʊɐ",
    "widowhood": "wɪdəʊhʊd",
    "widows": "wɪdəʊz",
    "widow": "wɪdəʊ",
    "widths": "wɪdθs",
    "widthways": "wɪdθweɪz",
    "width": "wɪdθ",
    "widthwise": "wɪdθwaɪz",
    "wielded": "wiːldɪd",
    "wielders": "wiːldəz",
    "wielder": "wiːldɐ",
    "wielding": "wiːldɪŋ",
    "wields": "wiːldz",
    "wield": "wiːld",
    "wieners": "wiənəz",
    "wiener": "wiənɐ",
    "wienies": "wiənɪz",
    "wienie": "wiəni",
    "wifeless": "waɪfləs",
    "wifely": "waɪfli",
    "wife": "waɪf",
    "wigeon": "wɪdʒən",
    "wigged": "wɪɡd",
    "wigging": "wɪɡɪŋ",
    "wiggled": "wɪɡəld",
    "wigglers": "wɪɡləz",
    "wiggler": "wɪɡlɐ",
    "wiggles": "wɪɡəlz",
    "wiggle": "wɪɡəl",
    "wiggling": "wɪɡlɪŋ",
    "wiggly": "wɪɡli",
    "wight": "waɪt",
    "wigs": "wɪɡz",
    "wig": "wɪɡ",
    "wigwams": "wɪɡwæmz",
    "wigwam": "wɪɡwæm",
    "wiki": "wɪki",
    "wildcats": "waɪldkæts",
    "wildcat": "waɪldkæt",
    "wildebeests": "waɪldɪbiːsts",
    "wildebeest": "waɪldɪbiːst",
    "wildernesses": "wɪldənəsɪz",
    "wilderness": "wɪldənəs",
    "wilder": "waɪldɐ",
    "wildest": "waɪldəst",
    "wildfires": "waɪldfaɪəz",
    "wildfire": "waɪldfaɪə",
    "wildflowers": "waɪldflaʊəz",
    "wildflower": "waɪldflaʊɐ",
    "wildfowl": "waɪldfaʊl",
    "wilding": "waɪldɪŋ",
    "wildlife": "waɪldlaɪf",
    "wildly": "waɪldli",
    "wildness": "waɪldnəs",
    "wilds": "waɪldz",
    "wild": "waɪld",
    "wildwood": "waɪldwʊd",
    "wiles": "waɪlz",
    "wile": "waɪl",
    "wilfully": "wɪlfəli",
    "wilful": "wɪlfəl",
    "wilier": "waɪliɐ",
    "wiliest": "waɪliəst",
    "wiling": "waɪlɪŋ",
    "willed": "wɪld",
    "willets": "wɪlɪts",
    "willet": "wɪlɪt",
    "willful": "wɪlfəl",
    "willies": "wɪliz",
    "willie": "wɪli",
    "willingly": "wɪlɪŋli",
    "willingness": "wɪlɪŋnəs",
    "willing": "wɪlɪŋ",
    "willows": "wɪləʊz",
    "willow": "wɪləʊ",
    "willowy": "wɪləʊi",
    "willpower": "wɪlpaʊɐ",
    "wills": "wɪlz",
    "will": "wɪl",
    "willy": "wɪli",
    "wilted": "wɪltɪd",
    "wilting": "wɪltɪŋ",
    "wilts": "wɪlts",
    "wilt": "wɪlt",
    "wily": "waɪli",
    "wimble": "wɪmbəl",
    "wimped": "wɪmpt",
    "wimping": "wɪmpɪŋ",
    "wimpish": "wɪmpɪʃ",
    "wimples": "wɪmpəlz",
    "wimple": "wɪmpəl",
    "wimpling": "wɪmplɪŋ",
    "wimps": "wɪmps",
    "wimp": "wɪmp",
    "wimpy": "wɪmpi",
    "winced": "wɪnst",
    "winces": "wɪnsɪz",
    "wince": "wɪns",
    "winched": "wɪntʃt",
    "winches": "wɪntʃɪz",
    "winching": "wɪntʃɪŋ",
    "winch": "wɪntʃ",
    "wincing": "wɪnsɪŋ",
    "windage": "wɪndɪdʒ",
    "windbags": "wɪndbæɡz",
    "windbag": "wɪndbæɡ",
    "windblown": "wɪndbləʊn",
    "windbreaker": "wɪndbreɪkɐ",
    "windbreaks": "wɪndbreɪks",
    "windbreak": "wɪndbreɪk",
    "windcheater": "wɪndtʃiːtɐ",
    "windchill": "wɪndtʃɪl",
    "winders": "waɪndəz",
    "winder": "waɪndɐ",
    "windfalls": "wɪndfɔːlz",
    "windfall": "wɪndfɔːl",
    "windhover": "wɪndhəʊvɐ",
    "windier": "wɪndɪɐ",
    "windiest": "wɪndɪəst",
    "windings": "waɪndɪŋz",
    "windjammer": "wɪndʒæmɐ",
    "windlass": "wɪndlɑːs",
    "windless": "wɪndləs",
    "windmilling": "wɪndmɪlɪŋ",
    "windmills": "wɪndmɪlz",
    "windmill": "wɪndmɪl",
    "windowed": "wɪndəʊd",
    "windowless": "wɪndəʊləs",
    "windowpanes": "wɪndəʊpeɪnz",
    "windowpane": "wɪndəʊpeɪn",
    "windowsills": "wɪndəʊsɪlz",
    "windowsill": "wɪndəʊsɪl",
    "windows": "wɪndəʊz",
    "window": "wɪndəʊ",
    "windpipe": "wɪndpaɪp",
    "windproof": "wɪndpruːf",
    "windscreens": "wɪndskriːnz",
    "windscreen": "wɪndskriːn",
    "windshields": "wɪndʃiːldz",
    "windshield": "wɪndʃiːld",
    "windsock": "wɪndsɒk",
    "windstorms": "wɪndstɔːmz",
    "windstorm": "wɪndstɔːm",
    "windsurfers": "wɪndsɜːfəz",
    "windsurfer": "wɪndsɜːfɐ",
    "windsurfing": "wɪndsɜːfɪŋ",
    "windsurf": "wɪndsɜːf",
    "windswept": "wɪndswɛpt",
    "windup": "wɪndʌp",
    "windward": "wɪndwəd",
    "wined": "waɪnd",
    "wineglass": "waɪnɡlɑːs",
    "winemakers": "waɪnmeɪkəz",
    "winemaker": "waɪnmeɪkɐ",
    "wineries": "waɪnəriz",
    "winery": "waɪnəri",
    "wines": "waɪnz",
    "wine": "waɪn",
    "wingdings": "wɪŋdɪŋz",
    "wingding": "wɪŋdɪŋ",
    "wingers": "wɪŋɡəz",
    "winger": "wɪŋɡɐ",
    "winging": "wɪŋɪŋ",
    "wingless": "wɪŋləs",
    "winglet": "wɪŋɡlət",
    "wingspans": "wɪŋspænz",
    "wingspan": "wɪŋspæn",
    "wings": "wɪŋz",
    "wingtips": "wɪŋtɪps",
    "wingtip": "wɪŋtɪp",
    "wing": "wɪŋ",
    "wining": "waɪnɪŋ",
    "winked": "wɪŋkt",
    "winkers": "wɪŋkəz",
    "winker": "wɪŋkɐ",
    "winking": "wɪŋkɪŋ",
    "winkled": "wɪŋkəld",
    "winkles": "wɪŋkəlz",
    "winkle": "wɪŋkəl",
    "winkling": "wɪŋklɪŋ",
    "winks": "wɪŋks",
    "wink": "wɪŋk",
    "winnable": "wɪnəbəl",
    "winners": "wɪnəz",
    "winner": "wɪnɐ",
    "winningly": "wɪnɪŋli",
    "winnings": "wɪnɪŋz",
    "winning": "wɪnɪŋ",
    "winnowed": "wɪnəʊd",
    "winnowing": "wɪnəʊɪŋ",
    "winnows": "wɪnəʊz",
    "winnow": "wɪnəʊ",
    "winos": "waɪnəʊz",
    "winsome": "wɪnsʌm",
    "wins": "wɪnz",
    "wintered": "wɪntəd",
    "wintergreen": "wɪntəɡriːn",
    "wintering": "wɪntərɪŋ",
    "winters": "wɪntəz",
    "wintertime": "wɪntətaɪm",
    "winter": "wɪntɐ",
    "wintery": "wɪntəri",
    "wintriness": "wɪntrɪnəs",
    "wintry": "wɪntri",
    "win": "wɪn",
    "winy": "waɪni",
    "wiped": "waɪpt",
    "wipers": "waɪpəz",
    "wiper": "waɪpɐ",
    "wipes": "waɪps",
    "wipe": "waɪp",
    "wiping": "waɪpɪŋ",
    "wired": "waɪəd",
    "wirehaired": "waɪəheəd",
    "wireless": "waɪələs",
    "wireman": "waɪəmən",
    "wires": "waɪəz",
    "wiretapping": "waɪətæpɪŋ",
    "wiretaps": "waɪətæps",
    "wiretap": "waɪətæp",
    "wire": "waɪə",
    "wirework": "waɪəwɜːk",
    "wiring": "waɪərɪŋ",
    "wiry": "waɪəri",
    "wisdom": "wɪsdəm",
    "wiseacres": "waɪsækəz",
    "wiseacre": "waɪsækɐ",
    "wisecracking": "waɪskrækɪŋ",
    "wisecracks": "waɪskræks",
    "wisecrack": "waɪskræk",
    "wised": "waɪzd",
    "wiseguys": "waɪsɡaɪz",
    "wiseguy": "waɪsɡaɪ",
    "wisely": "waɪzli",
    "wiser": "waɪzɐ",
    "wisest": "waɪsəst",
    "wises": "waɪzɪz",
    "wise": "waɪz",
    "wishbones": "wɪʃbəʊnz",
    "wishbone": "wɪʃbəʊn",
    "wished": "wɪʃt",
    "wishers": "wɪʃəz",
    "wisher": "wɪʃɐ",
    "wishes": "wɪʃɪz",
    "wishful": "wɪʃfəl",
    "wishing": "wɪʃɪŋ",
    "wish": "wɪʃ",
    "wising": "waɪzɪŋ",
    "wisps": "wɪsps",
    "wisp": "wɪsp",
    "wispy": "wɪspi",
    "wisterias": "wɪstiərɪəz",
    "wisteria": "wɪstiərɪɐ",
    "wistfully": "wɪstfəli",
    "wistfulness": "wɪstfəlnəs",
    "wistful": "wɪstfəl",
    "wist": "wɪst",
    "witchcraft": "wɪtʃkrɑːft",
    "witchdoctors": "wɪtʃdɒktəz",
    "witchdoctor": "wɪtʃdɒktɐ",
    "witched": "wɪtʃt",
    "witchery": "wɪtʃəri",
    "witches": "wɪtʃɪz",
    "witching": "wɪtʃɪŋ",
    "witch": "wɪtʃ",
    "witchy": "wɪtʃi",
    "withal": "wɪðæl",
    "withdrawals": "wɪðdrɔːlz",
    "withdrawal": "wɪðdrɔːl",
    "withdrawing": "wɪðdrɔːrɪŋ",
    "withdrawn": "wɪðdrɔːn",
    "withdraws": "wɪðdrɔːz",
    "withdraw": "wɪðdrɔː",
    "withdrew": "wɪðdruː",
    "withed": "wɪðd",
    "withered": "wɪðəd",
    "witheringly": "wɪðərɪŋli",
    "withering": "wɪðərɪŋ",
    "withers": "wɪðəz",
    "wither": "wɪðɐ",
    "withe": "wɪð",
    "withheld": "wɪðhɛld",
    "withholding": "wɪðhəʊldɪŋ",
    "withholds": "wɪðhəʊldz",
    "withhold": "wɪðhəʊld",
    "withies": "wɪθɪz",
    "withing": "wɪðɪŋ",
    "within": "wɪðɪn",
    "without": "wɪðaʊt",
    "withstanding": "wɪðstændɪŋ",
    "withstands": "wɪðstændz",
    "withstand": "wɪðstænd",
    "withstood": "wɪðstʊd",
    "with": "wɪð",
    "witlessness": "wɪtləsnəs",
    "witless": "wɪtləs",
    "witnessed": "wɪtnəst",
    "witnesses": "wɪtnəsɪz",
    "witnessing": "wɪtnəsɪŋ",
    "witness": "wɪtnəs",
    "wits": "wɪts",
    "witted": "wɪtɪd",
    "wittered": "wɪtəd",
    "wittering": "wɪtərɪŋ",
    "witters": "wɪtəz",
    "witter": "wɪtɐ",
    "witticisms": "wɪtɪsɪzəmz",
    "witticism": "wɪtɪsɪzəm",
    "wittier": "wɪtɪɐ",
    "wittiest": "wɪtɪəst",
    "wittily": "wɪtɪli",
    "wittingly": "wɪtɪŋli",
    "witting": "wɪtɪŋ",
    "witty": "wɪti",
    "wit": "wɪt",
    "wives": "waɪvz",
    "wive": "waɪv",
    "wizardly": "wɪzədli",
    "wizardry": "wɪzədri",
    "wizards": "wɪzədz",
    "wizard": "wɪzəd",
    "wizened": "wɪzənd",
    "wiz": "wɪz",
    "woad": "wəʊd",
    "wobbled": "wɒbəld",
    "wobbler": "wɒblɐ",
    "wobbles": "wɒbəlz",
    "wobble": "wɒbəl",
    "wobblier": "wɒbliɐ",
    "wobbliest": "wɒbliəst",
    "wobbliness": "wɒblinəs",
    "wobbling": "wɒblɪŋ",
    "wobbly": "wɒbli",
    "wodges": "wɒdʒɪz",
    "wodge": "wɒdʒ",
    "woebegone": "wəʊbɪɡɒn",
    "woefully": "wəʊfəli",
    "woeful": "wəʊfəl",
    "woes": "wəʊz",
    "woe": "wəʊ",
    "wogs": "wɒɡz",
    "wog": "wɒɡ",
    "woken": "wəʊkən",
    "woke": "wəʊk",
    "woks": "wɒks",
    "wok": "wɒk",
    "wolds": "wəʊldz",
    "wold": "wəʊld",
    "wolfed": "wʊlft",
    "wolffish": "wʊlffɪʃ",
    "wolfhounds": "wʊlfhaʊndz",
    "wolfhound": "wʊlfhaʊnd",
    "wolfing": "wʊlfɪŋ",
    "wolfish": "wʊlfɪʃ",
    "wolframite": "wʊlfrɐmaɪt",
    "wolfram": "wʊlfræm",
    "wolfsbane": "wʊlfsbeɪn",
    "wolfs": "wʊlfs",
    "wolf": "wʊlf",
    "wolverines": "wʊlvəriːnz",
    "wolverine": "wʊlvəriːn",
    "wolver": "wʊlvɐ",
    "wolves": "wʊlvz",
    "womanhood": "wʊmənhʊd",
    "womanised": "wʊmənaɪzd",
    "womanisers": "wʊmənaɪzəz",
    "womaniser": "wʊmənaɪzɐ",
    "womanise": "wʊmənaɪz",
    "womanish": "wʊmənɪʃ",
    "womanising": "wʊmənaɪzɪŋ",
    "womankind": "wʊməŋkaɪnd",
    "womanliness": "wʊmənlinəs",
    "womanly": "wʊmənli",
    "woman": "wʊmən",
    "wombats": "wɒmbæts",
    "wombat": "wɒmbæt",
    "wombs": "wuːmz",
    "womb": "wuːm",
    "womenfolk": "wɪmɪnfəʊk",
    "women": "wɪmɪn",
    "wondered": "wʌndəd",
    "wonderfully": "wʌndəfəli",
    "wonderfulness": "wʌndəfəlnəs",
    "wonderful": "wʌndəfəl",
    "wonderingly": "wʌndərɪŋli",
    "wondering": "wʌndərɪŋ",
    "wonderlands": "wʌndələndz",
    "wonderland": "wʌndələnd",
    "wonderment": "wʌndəmənt",
    "wonders": "wʌndəz",
    "wonder": "wʌndɐ",
    "wondrously": "wʌndrəsli",
    "wondrous": "wʌndrəs",
    "wonkier": "wɒnkiɐ",
    "wonks": "wɒnks",
    "wonk": "wɒnk",
    "wonky": "wɒnki",
    "wonted": "wɒntɪd",
    "wontons": "wɒntənz",
    "wonton": "wɒntən",
    "wont": "wɒnt",
    "woodbine": "wʊdbaɪn",
    "woodblock": "wʊdblɒk",
    "woodcarvers": "wʊdkɑːvəz",
    "woodcarver": "wʊdkɑːvɐ",
    "woodcarvings": "wʊdkɑːvɪŋz",
    "woodcarving": "wʊdkɑːvɪŋ",
    "woodchuck": "wʊdtʃʌk",
    "woodcocks": "wʊdkɒks",
    "woodcock": "wʊdkɒk",
    "woodcraft": "wʊdkrɑːft",
    "woodcuts": "wʊdkʌts",
    "woodcutters": "wʊdkʌtəz",
    "woodcutter": "wʊdkʌtɐ",
    "woodcutting": "wʊdkʌtɪŋ",
    "woodcut": "wʊdkʌt",
    "wooded": "wʊdɪd",
    "wooden": "wʊdən",
    "woodier": "wʊdɪɐ",
    "woodiness": "wʊdɪnəs",
    "wooding": "wʊdɪŋ",
    "woodlands": "wʊdləndz",
    "woodland": "wʊdlənd",
    "woodlice": "wʊdlɪs",
    "woodlouse": "wʊdlaʊs",
    "woodman": "wʊdmən",
    "woodmen": "wʊdmɛn",
    "woodpeckers": "wʊdpɛkəz",
    "woodpecker": "wʊdpɛkɐ",
    "woodpile": "wʊdpaɪl",
    "woodruff": "wʊdrʌf",
    "woodshed": "wʊdʃɛd",
    "woodsman": "wʊdzmən",
    "woodsmen": "wʊdzmɛn",
    "woods": "wʊdz",
    "woodsy": "wʊdsi",
    "wood": "wʊd",
    "woodwinds": "wʊdwɪndz",
    "woodwind": "wʊdwɪnd",
    "woodworkers": "wʊdwɜːkəz",
    "woodworker": "wʊdwɜːkɐ",
    "woodworking": "wʊdwɜːkɪŋ",
    "woodwork": "wʊdwɜːk",
    "woodworms": "wʊdwɜːmz",
    "woodworm": "wʊdwɜːm",
    "woody": "wʊdi",
    "wooed": "wuːd",
    "wooer": "wuːɐ",
    "woofed": "wuːft",
    "woofers": "wuːfəz",
    "woofer": "wuːfɐ",
    "woofing": "wuːfɪŋ",
    "woofs": "wuːfs",
    "woof": "wuːf",
    "wooing": "wuːɪŋ",
    "woolen": "wʊlən",
    "woolies": "wʊliz",
    "woollens": "wʊlənz",
    "woollen": "wʊlən",
    "woollier": "wʊliɐ",
    "woollies": "wʊliz",
    "woolly": "wʊli",
    "woolpack": "wʊlpæk",
    "woolsack": "wʊlsæk",
    "wools": "wʊlz",
    "wool": "wʊl",
    "wooly": "wʊli",
    "woomera": "wuːmərɐ",
    "woops": "wuːps",
    "woos": "wuːz",
    "woo": "wuː",
    "woozy": "wuːzi",
    "wops": "wɒps",
    "wop": "wɒp",
    "wordage": "wɜːdɪdʒ",
    "worded": "wɜːdɪd",
    "wordiness": "wɜːdɪnəs",
    "wordings": "wɜːdɪŋz",
    "wording": "wɜːdɪŋ",
    "wordlessly": "wɜːdləsli",
    "wordless": "wɜːdləs",
    "wordplay": "wɜːdpleɪ",
    "wordsmiths": "wɜːdsmɪθs",
    "wordsmith": "wɜːdsmɪθ",
    "words": "wɜːdz",
    "word": "wɜːd",
    "wordy": "wɜːdi",
    "wore": "wɔː",
    "workability": "wɜːkəbɪlɪti",
    "workable": "wɜːkəbəl",
    "workaday": "wɜːkɐdeɪ",
    "workaholics": "wɜːkɐhɒlɪks",
    "workaholic": "wɜːkɐhɒlɪk",
    "workbenches": "wɜːkbɛntʃɪz",
    "workbench": "wɜːkbɛntʃ",
    "workbook": "wɜːkbʊk",
    "workday": "wɜːkdeɪ",
    "worked": "wɜːkt",
    "workers": "wɜːkəz",
    "worker": "wɜːkɐ",
    "workfare": "wɜːkfeə",
    "workforces": "wɜːkfɔːsɪz",
    "workforce": "wɜːkfɔːs",
    "workhorses": "wɜːkhɔːsɪz",
    "workhorse": "wɜːkhɔːs",
    "workhouses": "wɜːkhaʊzɪz",
    "workhouse": "wɜːkhaʊs",
    "workingmen": "wɜːkɪŋmɛn",
    "workings": "wɜːkɪŋz",
    "working": "wɜːkɪŋ",
    "workloads": "wɜːkləʊdz",
    "workload": "wɜːkləʊd",
    "workmanlike": "wɜːkmənlaɪk",
    "workmanship": "wɜːkmənʃɪp",
    "workman": "wɜːkmən",
    "workmates": "wɜːkmeɪts",
    "workmate": "wɜːkmeɪt",
    "workmen": "wɜːkmɛn",
    "workouts": "wɜːkaʊts",
    "workout": "wɜːkaʊt",
    "workplaces": "wɜːkpleɪsɪz",
    "workplace": "wɜːkpleɪs",
    "workroom": "wɜːkruːm",
    "worksheets": "wɜːkʃiːts",
    "worksheet": "wɜːkʃiːt",
    "workshops": "wɜːkʃɒps",
    "workshop": "wɜːkʃɒp",
    "workshy": "wɜːkʃaɪ",
    "workspaces": "wɜːkspeɪsɪz",
    "workspace": "wɜːkspeɪs",
    "workstations": "wɜːksteɪʃənz",
    "workstation": "wɜːksteɪʃən",
    "works": "wɜːks",
    "worktops": "wɜːktɒps",
    "worktop": "wɜːktɒp",
    "workup": "wɜːkʌp",
    "work": "wɜːk",
    "worldliness": "wɜːldlinəs",
    "worldly": "wɜːldli",
    "worlds": "wɜːldz",
    "worldviews": "wɜːldvjuːz",
    "worldview": "wɜːldvjuː",
    "worldwide": "wɜːldwaɪd",
    "world": "wɜːld",
    "wormed": "wɜːmd",
    "wormholes": "wɜːmhəʊlz",
    "wormhole": "wɜːmhəʊl",
    "worming": "wɜːmɪŋ",
    "worms": "wɜːmz",
    "worm": "wɜːm",
    "wormwood": "wɜːmwʊd",
    "wormy": "wɜːmi",
    "worn": "wɔːn",
    "worriedly": "wʌrɪdli",
    "worried": "wʌrɪd",
    "worriers": "wʌriəz",
    "worrier": "wʌrɪɐ",
    "worries": "wʌrɪz",
    "worrisome": "wʌrisʌm",
    "worryingly": "wʌrɪɪŋli",
    "worrying": "wʌrɪɪŋ",
    "worrywart": "wʌrɪwɔːt",
    "worry": "wʌri",
    "worsened": "wɜːsənd",
    "worsening": "wɜːsənɪŋ",
    "worsens": "wɜːsənz",
    "worsen": "wɜːsən",
    "worser": "wɜːsɐ",
    "worse": "wɜːs",
    "worshipful": "wɜːʃɪpfəl",
    "worshipped": "wɜːʃɪpt",
    "worshippers": "wɜːʃɪpəz",
    "worshipper": "wɜːʃɪpɐ",
    "worshipping": "wɜːʃɪpɪŋ",
    "worships": "wɜːʃɪps",
    "worship": "wɜːʃɪp",
    "worst": "wɜːst",
    "worthier": "wɜːðɪɐ",
    "worthiest": "wɜːðɪəst",
    "worthies": "wɜːðɪz",
    "worthily": "wɜːðɪli",
    "worthiness": "wɜːðɪnəs",
    "worthlessness": "wɜːθləsnəs",
    "worthless": "wɜːθləs",
    "worthwhile": "wɜːθwaɪl",
    "worth": "wɜːθ",
    "worthy": "wɜːði",
    "wort": "wɔːt",
    "wotcha": "wɒtʃɐ",
    "wot": "wɒt",
    "wouldst": "wʊdst",
    "woulds": "wʊdz",
    "would": "wʊd",
    "wounded": "wuːndɪd",
    "wounding": "wuːndɪŋ",
    "wounds": "wuːndz",
    "woundwort": "wuːndwɔːt",
    "woven": "wəʊvən",
    "wove": "wəʊv",
    "wo": "wəʊ",
    "wowed": "waʊd",
    "wowing": "waʊɪŋ",
    "wowser": "waʊzɐ",
    "wows": "waʊz",
    "wow": "waʊ",
    "wrack": "ræk",
    "wracked": "rækt",
    "wracking": "rækɪŋ",
    "wracks": "ræks",
    "wraith": "reɪθ",
    "wrangle": "ræŋɡəl",
    "wrangled": "ræŋɡəld",
    "wrangler": "ræŋɡlɐ",
    "wranglers": "ræŋɡləz",
    "wrangles": "ræŋɡəlz",
    "wrangling": "ræŋɡəlɪŋ",
    "wranglings": "ræŋɡlɪŋz",
    "wrap": "ræp",
    "wraparound": "ræpɐraʊnd",
    "wrapped": "ræpt",
    "wrapper": "ræpɐ",
    "wrappers": "ræpəz",
    "wrapping": "ræpɪŋ",
    "wrappings": "ræpɪŋz",
    "wraps": "ræps",
    "wrasse": "rɑːs",
    "wrasses": "rɑːsɪz",
    "wrath": "ræθ",
    "wrathful": "ræθfəl",
    "wreaked": "riːkt",
    "wreak": "riːk",
    "wreaking": "riːkɪŋ",
    "wreaks": "riːks",
    "wreathed": "riːðd",
    "wreathes": "riːðz",
    "wreath": "riːθ",
    "wreaths": "riːθs",
    "wreckage": "rɛkɪdʒ",
    "wrecked": "rɛkt",
    "wreck": "rɛk",
    "wrecker": "rɛkɐ",
    "wreckers": "rɛkəz",
    "wrecking": "rɛkɪŋ",
    "wrecks": "rɛks",
    "wrenched": "rɛntʃt",
    "wrench": "rɛntʃ",
    "wrenches": "rɛntʃɪz",
    "wrenching": "rɛntʃɪŋ",
    "wren": "rɛn",
    "wrens": "rɛnz",
    "wrested": "rɛstɪd",
    "wrest": "rɛst",
    "wresting": "rɛstɪŋ",
    "wrestled": "rɛsəld",
    "wrestle": "rɛsəl",
    "wrestler": "rɛslɐ",
    "wrestlers": "rɛsləz",
    "wrestles": "rɛsəlz",
    "wrestling": "rɛslɪŋ",
    "wrests": "rɛsts",
    "wretched": "rɛtʃɪd",
    "wretchedly": "rɛtʃɪdli",
    "wretchedness": "rɛtʃɪdnəs",
    "wretches": "rɛtʃɪz",
    "wretch": "rɛtʃ",
    "wriggled": "rɪɡəld",
    "wriggle": "rɪɡəl",
    "wriggler": "rɪɡlɐ",
    "wrigglers": "rɪɡləz",
    "wriggles": "rɪɡəlz",
    "wriggling": "rɪɡlɪŋ",
    "wriggly": "rɪɡli",
    "wright": "raɪt",
    "wrights": "raɪts",
    "wringer": "rɪŋɐ",
    "wringers": "rɪŋəz",
    "wringing": "rɪŋɪŋ",
    "wring": "rɪŋ",
    "wrings": "rɪŋz",
    "wrinkled": "rɪŋkəld",
    "wrinkle": "rɪŋkəl",
    "wrinkles": "rɪŋkəlz",
    "wrinklier": "rɪŋkliɐ",
    "wrinklies": "rɪŋkliz",
    "wrinkling": "rɪŋklɪŋ",
    "wrinkly": "rɪŋkli",
    "wristbands": "rɪstbændz",
    "wristband": "rɪstbænd",
    "wrists": "rɪsts",
    "wrist": "rɪst",
    "wristwatches": "rɪstwɒtʃɪz",
    "wristwatch": "rɪstwɒtʃ",
    "writable": "raɪtəbəl",
    "write": "raɪt",
    "writer": "raɪtɐ",
    "writers": "raɪtəz",
    "writes": "raɪts",
    "writhe": "raɪð",
    "writhed": "raɪðd",
    "writhen": "rɪðən",
    "writhes": "raɪðz",
    "writhing": "raɪðɪŋ",
    "writing": "raɪtɪŋ",
    "writings": "raɪtɪŋz",
    "writs": "rɪts",
    "writ": "rɪt",
    "written": "rɪtən",
    "wrongdoer": "rɒŋduːɐ",
    "wrongdoers": "rɒŋduːəz",
    "wrongdoing": "rɒŋduːɪŋ",
    "wrongdoings": "rɒŋduːɪŋz",
    "wronged": "rɒŋd",
    "wronger": "rɒŋɡɐ",
    "wrongest": "rɒŋɡəst",
    "wrongfully": "rɒŋfəli",
    "wrongful": "rɒŋfəl",
    "wrongheaded": "rɒŋhɛdɪd",
    "wrongly": "rɒŋli",
    "wrongness": "rɒŋnəs",
    "wrong": "rɒŋ",
    "wrongs": "rɒŋz",
    "wrote": "rəʊt",
    "wrought": "rɔːt",
    "wrung": "rʌŋ",
    "wry": "raɪ",
    "wryly": "raɪli",
    "wunderkind": "wʌndəkaɪnd",
    "wurst": "wɜːst",
    "wusses": "wʊsɪz",
    "wuss": "wʊs",
    "wussy": "wʊsi",
    "wynd": "wɪnd",
    "xanthophyll": "zɑːnθəfɪl",
    "x": "ɛks",
    "xenia": "ziːniɐ",
    "xenon": "zɛnɒn",
    "xenophobes": "zɛnəfəʊbz",
    "xenophobe": "zɛnəfəʊb",
    "xenophobia": "zɛnəfəʊbiə",
    "xenophobic": "zɛnəfəʊbɪk",
    "xerophyte": "ziərəfaɪt",
    "xerox": "ziərɒks",
    "xi": "rəʊmən ɪlɛvən",
    "xis": "ksɪs",
    "xu": "zuː",
    "xylem": "zaɪləm",
    "xylophones": "zaɪləfəʊnz",
    "xylophone": "zaɪləfəʊn",
    "yabber": "jæbɐ",
    "yachting": "jɒtɪŋ",
    "yacht": "jɒt",
    "yachts": "jɒts",
    "yachtsman": "jɒtsmən",
    "yachtsmen": "jɒtsmɛn",
    "yachtswoman": "jɒtswʊmən",
    "yacked": "jækt",
    "yacking": "jækɪŋ",
    "yack": "jæk",
    "yacks": "jæks",
    "yah": "jɑː",
    "yahoo": "jæhuː",
    "yahoos": "jæhuːz",
    "ya": "jɐ",
    "yakka": "jækɐ",
    "yakking": "jækɪŋ",
    "yaks": "jæks",
    "yam": "jæm",
    "yammering": "jæmərɪŋ",
    "yammer": "jæmɐ",
    "yams": "jæmz",
    "yang": "jæŋ",
    "yanked": "jæŋkt",
    "yanking": "jæŋkɪŋ",
    "yank": "jæŋk",
    "yanks": "jæŋks",
    "yap": "jæp",
    "yapok": "jæpɒk",
    "yapped": "jæpt",
    "yapper": "jæpɐ",
    "yapping": "jæpɪŋ",
    "yappy": "jæpi",
    "yaps": "jæps",
    "yardage": "jɑːdɪdʒ",
    "yardages": "jɑːdɪdʒɪz",
    "yardarm": "jɑːdɑːm",
    "yard": "jɑːd",
    "yards": "jɑːdz",
    "yardstick": "jɑːdstɪk",
    "yardsticks": "jɑːdstɪks",
    "yare": "jeə",
    "yarmulke": "jɑːmʌlk",
    "yarn": "jɑːn",
    "yarns": "jɑːnz",
    "yarrow": "jærəʊ",
    "yaw": "jɔː",
    "yawl": "jɔːl",
    "yawned": "jɔːnd",
    "yawning": "jɔːnɪŋ",
    "yawn": "jɔːn",
    "yawns": "jɔːnz",
    "yawp": "jɔːp",
    "yaws": "jɔːz",
    "yeah": "jɛh",
    "yeahs": "jɛhz",
    "yea": "jeɪ",
    "yearbook": "jiəbʊk",
    "yearbooks": "jiəbʊks",
    "year": "jiə",
    "yearlies": "jiəliz",
    "yearling": "jiəlɪŋ",
    "yearlings": "jiəlɪŋz",
    "yearlong": "jiəlɒŋ",
    "yearly": "jiəli",
    "yearned": "jɜːnd",
    "yearning": "jɜːnɪŋ",
    "yearnings": "jɜːnɪŋz",
    "yearn": "jɜːn",
    "yearns": "jɜːnz",
    "years": "jiəz",
    "yeas": "jeɪz",
    "yeast": "jiːst",
    "yeasts": "jiːsts",
    "yeasty": "jiːsti",
    "yelled": "jɛld",
    "yelling": "jɛlɪŋ",
    "yell": "jɛl",
    "yellowed": "jɛləʊd",
    "yellower": "jɛləʊɐ",
    "yellowhammer": "jɛləʊhæmɐ",
    "yellowhammers": "jɛləʊæməz",
    "yellowing": "jɛləʊɪŋ",
    "yellowish": "jɛləʊɪʃ",
    "yellow": "jɛləʊ",
    "yellowlegs": "jɛləʊlɛɡz",
    "yellowness": "jɛləʊnəs",
    "yellows": "jɛləʊz",
    "yellowtail": "jɛləʊteɪl",
    "yellowy": "jɛləʊi",
    "yells": "jɛlz",
    "yelped": "jɛlpt",
    "yelping": "jɛlpɪŋ",
    "yelp": "jɛlp",
    "yelps": "jɛlps",
    "yen": "jɛn",
    "yens": "jɛnz",
    "yeoman": "jəʊmən",
    "yeomanry": "jəʊmənri",
    "yeomen": "jəʊmɛn",
    "yep": "jɛp",
    "yer": "jə",
    "yeses": "jɛsiːz",
    "yeshiva": "jɛshɪvɐ",
    "yes": "jɛs",
    "yesterday": "jɛstədeɪ",
    "yesterdays": "jɛstədeɪz",
    "yester": "jɛstɐ",
    "yesteryear": "jɛstəjiə",
    "yestreen": "jɛstriːn",
    "yeti": "jɛti",
    "yetis": "jɛtiz",
    "yet": "jɛt",
    "yew": "juː",
    "yews": "juːz",
    "yid": "jɪd",
    "yids": "jɪdz",
    "yielded": "jiːldɪd",
    "yielding": "jiːldɪŋ",
    "yield": "jiːld",
    "yields": "jiːldz",
    "yikes": "jaɪks",
    "yin": "jɪn",
    "yipe": "jaɪp",
    "yip": "jɪp",
    "yippee": "jɪpiː",
    "yippie": "jɪpi",
    "yipping": "jɪpɪŋ",
    "yips": "jɪps",
    "yobbo": "jɒbəʊ",
    "yobbos": "jɒbəʊz",
    "yob": "jɒb",
    "yobs": "jɒbz",
    "yock": "jɒk",
    "yodel": "jəʊdəl",
    "yodelled": "jəʊdəld",
    "yodeller": "jəʊdəlɐ",
    "yodellers": "jəʊdələz",
    "yodelling": "jəʊdəlɪŋ",
    "yodels": "jəʊdəlz",
    "yod": "jɒd",
    "yoga": "jəʊɡɐ",
    "yoghurt": "jɒɡət",
    "yoghurts": "jɒɡəts",
    "yogic": "jɒdʒɪk",
    "yogi": "jəʊɡi",
    "yogini": "jɒdʒiːni",
    "yogis": "jəʊɡɪz",
    "yogurt": "jɒɡɜːt",
    "yogurts": "jɒɡɜːts",
    "yo": "jəʊ",
    "yoked": "jəʊkt",
    "yoke": "jəʊk",
    "yokel": "jəʊkəl",
    "yokels": "jəʊkəlz",
    "yokes": "jəʊks",
    "yoking": "jəʊkɪŋ",
    "yolk": "jəʊk",
    "yolks": "jəʊks",
    "yonder": "jɒndɐ",
    "yoni": "jəʊni",
    "yon": "jɒn",
    "yonks": "jɒŋks",
    "yore": "jɔː",
    "yorker": "jɔːkɐ",
    "yorkers": "jɔːkəz",
    "york": "jɔːk",
    "you": "juː",
    "younger": "jʌŋɡɐ",
    "youngest": "jʌŋɡəst",
    "youngish": "jʌŋɡɪʃ",
    "young": "jʌŋ",
    "youngling": "jʌŋɡəlɪŋ",
    "youngster": "jʌŋstɐ",
    "youngsters": "jʌŋstəz",
    "your": "jɔː",
    "yourself": "jɔːsɛlf",
    "yourselves": "jɔːsɛlvz",
    "yours": "jɔːz",
    "yous": "juːz",
    "youthful": "juːθfəl",
    "youthfully": "juːθfəli",
    "youthfulness": "juːθfəlnəs",
    "youth": "juːθ",
    "youths": "juːθs",
    "yow": "jaʊ",
    "yowled": "jaʊld",
    "yowling": "jaʊlɪŋ",
    "yowl": "jaʊl",
    "yowls": "jaʊlz",
    "ytterbium": "ɪtəbiəm",
    "yttrium": "ɪtriəm",
    "yuan": "juːən",
    "yucca": "juːkɐ",
    "yuccas": "juːkəz",
    "yuckier": "juːkiɐ",
    "yuckiest": "juːkiəst",
    "yuck": "jʌk",
    "yucky": "jʌki",
    "yuk": "jʌk",
    "yukky": "jʌki",
    "yule": "juːl",
    "yuletide": "juːlɪtaɪd",
    "yum": "jʌm",
    "yummier": "juːmɪɐ",
    "yummiest": "juːmɪəst",
    "yummy": "jʌmi",
    "yup": "jʌp",
    "yuppie": "juːpi",
    "yuppies": "juːpɪz",
    "yuppy": "jʌpi",
    "yurt": "jɜːt",
    "yurts": "jɜːts",
    "y": "waɪ",
    "zabaglione": "zæbɐɡlaɪəni",
    "zaire": "zaɪiə",
    "zaniest": "zeɪnɪəst",
    "zaniness": "zeɪnɪnəs",
    "zany": "zeɪni",
    "zapped": "zæpt",
    "zapper": "zæpɐ",
    "zapping": "zæpɪŋ",
    "zappy": "zæpi",
    "zaps": "zæps",
    "zap": "zæp",
    "zarf": "zɑːf",
    "zarzuela": "zɑːzweɪlɐ",
    "zealotry": "zɛlətri",
    "zealots": "zɛləts",
    "zealot": "zɛlət",
    "zealously": "zɛləsli",
    "zealousness": "zɛləsnəs",
    "zealous": "zɛləs",
    "zeal": "ziːl",
    "zebras": "zɛbrəz",
    "zebra": "zɛbrɐ",
    "zebu": "zɛbuː",
    "zeds": "zɛdz",
    "zed": "zɛd",
    "zees": "ziːz",
    "zee": "ziː",
    "zeitgeist": "zaɪtɡaɪst",
    "zenith": "zɛnɪθ",
    "zephyrs": "zɛfəz",
    "zephyr": "zɛfɐ",
    "zeppelins": "zɛpɪlɪnz",
    "zeppelin": "zɛpɪlɪn",
    "zeroed": "ziərəʊd",
    "zeroes": "ziərəʊz",
    "zeroing": "ziərəʊɪŋ",
    "zeros": "ziərəʊz",
    "zero": "ziərəʊ",
    "zests": "zɛsts",
    "zesty": "zɛsti",
    "zest": "zɛst",
    "zetas": "zɛtəz",
    "zeta": "zɛtɐ",
    "ziggurat": "zɪɡjʊreɪt",
    "zigs": "zɪɡz",
    "zig": "zɪɡ",
    "zigzagged": "zɪɡzæɡd",
    "zigzagging": "zɪɡzæɡɪŋ",
    "zigzags": "zɪɡzæɡz",
    "zigzag": "zɪɡzæɡ",
    "zilch": "zɪltʃ",
    "zillions": "zɪliənz",
    "zillion": "zɪliən",
    "zinced": "zɪnst",
    "zinc": "zɪŋk",
    "zine": "ziːn",
    "zinfandel": "zɪnfændəl",
    "zinged": "zɪndʒd",
    "zingers": "zɪŋɡəz",
    "zinger": "zɪŋɡɐ",
    "zingier": "zɪŋɪɐ",
    "zinging": "zɪŋɪŋ",
    "zings": "zɪŋz",
    "zingy": "zɪŋi",
    "zing": "zɪŋ",
    "zinnias": "zɪniəz",
    "zinnia": "zɪniɐ",
    "zipped": "zɪpt",
    "zippers": "zɪpəz",
    "zipper": "zɪpɐ",
    "zipping": "zɪpɪŋ",
    "zippy": "zɪpi",
    "zips": "zɪps",
    "zip": "zɪp",
    "zirconia": "zɜːkəʊniə",
    "zirconium": "zɜːkəʊniəm",
    "zircons": "zɜːkənz",
    "zircon": "zɜːkən",
    "zithers": "zɪðəz",
    "zither": "zɪðɐ",
    "zits": "zɪts",
    "zit": "zɪt",
    "zlotys": "zləʊtɪz",
    "zloty": "zləʊti",
    "zodiacal": "zəʊdɪækəl",
    "zodiac": "zəʊdɪæk",
    "zombies": "zɒmbɪz",
    "zombie": "zɒmbi",
    "zombi": "zɒmbaɪ",
    "zonal": "zəʊnəl",
    "zoned": "zəʊnd",
    "zones": "zəʊnz",
    "zone": "zəʊn",
    "zoning": "zəʊnɪŋ",
    "zonked": "zɒŋkt",
    "zonk": "zɒŋk",
    "zookeepers": "zʊkiːpəz",
    "zookeeper": "zʊkiːpɐ",
    "zoologically": "zuːəlɒdʒɪkli",
    "zoological": "zuːəlɒdʒɪkəl",
    "zoologists": "zuːɒlədʒɪsts",
    "zoologist": "zuːɒlədʒɪst",
    "zoology": "zuːɒlədʒi",
    "zoomed": "zuːmd",
    "zooming": "zuːmɪŋ",
    "zoomorphic": "zuːmɔːfɪk",
    "zooms": "zuːmz",
    "zoom": "zuːm",
    "zoonosis": "zuːnəʊsɪs",
    "zooplankton": "zuːplæŋktən",
    "zoos": "zuːz",
    "zoo": "zuː",
    "zoster": "zɒstɐ",
    "zounds": "zaʊndz",
    "zucchetto": "zʌkɛtəʊ",
    "zucchini": "zʌkiːni",
    "zydeco": "zaɪdiːkəʊ",
    "zygoma": "zaɪɡəʊmɐ",
    "zygote": "zaɪɡəʊt",
    "zygotic": "zaɪɡɒtɪk",
    "z": "zɛd"
}

export const ipaanswers = ["ɐbæʃt", "ɐbeɪt", "æbəts", "ɐbaɪd", "eɪbəl", "eɪbli", "ɐbəʊd", "ɐbaʊt", "ɐbrɔːd", "æbsɛs", "ɐbsɔːb",
    "ɐbsɜːd", "æksɛs", "ɐkjuːz", "ɐtʃiːv", "eɪkɪŋ", "æsɪdz", "eɪkɔːn", "eɪkəz", "ækrɪd", "əkrɒs", "æktɪd", "æktɪŋ", "ækʃən", "æktɪv",
    "æktəz", "ɐkjuːt", "ɐdæpt", "ɐdhiə", "ɐdʒɜːn", "ɐdmɪt", "ɐdɒpt", "ɐdɔːnd", "ædʌlt", "ædvɜːs", "ɐfeəz", "ɐfeəz", "ɐfɜːmd", "ɐfɔːdz",
    "æfɡæn", "ɐfiːld", "ɐfrɛʃ", "æɡeɪt", "ɐɡɑːst", "ɐɡləʊ", "æɡəni", "ɐɡriːd", "ɐɡriːz", "eɪɡjuː", "eɪdɪd", "eɪdɪŋ", "eɪlɪŋ", "eɪmɪŋ",
    "eəpɔːt", "ɐlɑːmd", "ɐlɑːmz", "ælbəm", "ɔːldəz", "ɐlaɪt", "ɐlaɪn", "ɐlaɪk", "ɐlaɪn", "ɐlaɪv", "ɐleɪd", "ɐleɪz", "ɐlɛdʒ", "ɐlaʊd",
    "ɐlaʊz", "ɐlɒft", "ɐləʊn", "ɐlaʊd", "ɒlsəʊ", "ɒltəz", "ɒltəd", "ɒlðəʊ", "æmətɐ", "æmbəl", "æmblɐ", "æmbʊʃ", "ɐmɛnd", "æmɪti", "æmpəl",
    "æmpli", "æmpuːl", "ɐmjuːz", "eɪnəl", "ænɑːki", "ænkəz", "æŋɡəd", "æŋɡəl", "æŋɡlɐ", "æŋɡri", "æŋkəl", "ænəlz", "ɐnɔɪd", "ɐnʌld", "ænəʊd",
    "ɐnʌðɐ", "ɑːnsəd", "ɑːnsəz", "æntiːk", "eɪnʌs", "æŋʃəs", "ɛnɪmɔː", "eɪɔːtɐ", "ɐpeɪs", "æpəθi", "ɐpɔːld", "ɐpiːld", "ɐpiːlz", "ɐpiəd", "ɐpiəz",
    "ɐpiːzd", "ɐplɔːd", "ɐplɔːz", "æpəlz", "ɐpruːv", "æptli", "ɑːbɪtɐ", "ɑːkeɪd", "ɑːtʃɪz", "ɑːtʃɪŋ", "ɑːkaɪv", "ɑːktɪk", "ɑːdənt", "eəriə", "ɐriːnɐ",
    "ɑːɡjuːd", "ɑːɡjuːz", "əraɪt", "ɐraɪz", "ɑːmɑːdɐ", "ɑːməri", "ɑːmpɪt", "ɐrəʊz", "ɐraʊz", "ɐreɪd", "ɐriəz", "ɐrɛst", "ɐraɪv", "ærəʊz", "ɑːtəri", "ɑːtfəl",
    "ɑːtɪst", "ɑːtləs", "ɐsɛnd", "ɐsɛnt", "ɐsaɪd", "ɑːskɪŋ", "ɐsliːp", "æspən", "ɐseɪl", "ɐsɒlt", "ɐsɛnt", "ɐsɜːts", "ɐsɛsɐ", "ɐsaɪn", "ɐsɪst", "ɐsuːmd", "ɐsuːmz",
    "əʃjɔːd", "əʃjɔːz", "æθliːt", "æθwɔːt", "ætləs", "ætəmz", "ɐtəʊn", "ɐtætʃ", "ɐtækt", "ɐtækɐ", "ɐtæks", "ɐteɪn", "ɐtɛnd", "ætɪks", "ɐtaɪə", "ɐtɜːni", "ɔːkʃən",
    "ɔːdɪtɐ", "ɔːrɪəs", "ɔːstiə", "ɐveɪl", "ɐvɔɪd", "ɐvaʊd", "ɐweɪt", "ɐweɪk", "ɐwɔːdz", "ɔːfəli", "ɐwaɪl", "ɔːkwəd", "ɐwəʊk", "æksɪs", "beɪbz", "bæbuːn", "beɪbi",
    "bækɪŋ", "bædli", "bæɡəz", "bæɡɪŋ", "beɪli", "beɪts", "beɪkt", "beɪkɐ", "beɪlz", "bɔːlkt", "bæləd", "bæleɪ", "bəluːn", "bælət", "bændz", "bændi", "bæŋɡd", "bæŋɪŋ",
    "bænɪʃ", "bæŋkɐ", "bæŋks", "bænəz", "bɑːntɐ", "beəli", "bɑːɡɪn", "bɑːkɪŋ", "bærən", "bærəl", "bærən", "bærɪɐ", "bɑːrɪŋ", "bærəʊ", "bɑːtəd", "bɑːtən", "beɪst", "beɪzɐ",
    "bæzəl", "bætən", "bætəd", "bætəl", "beɪɪŋ", "bɐzɑːz", "biːkən", "biːdɪd", "biːdɪŋ", "biːmɪŋ", "biədz", "beərɐ", "biːsts", "biːtən", "biːtɪŋ", "bjuːti", "bɪkʌz", "bɪkʌm",
    "bɛdɪd", "bɛdɪŋ", "bɪfɔːl", "bɪfɛl", "bɪɡæn", "bɪɡɛt", "bɛɡəz", "bɛɡɪŋ", "bɪɡɪn", "bɪɡʌn", "bɪhɑːf", "biːɪŋz", "bɪliːf", "bɪliːv", "bɛlɪz", "bɪlɒŋ", "bɪləʊ", "bɛlts", "bɛntʃ",
    "bɛndz", "bɪniːθ", "bɜːlɪn", "bɛrəl", "bɪsɛt", "bɛtɪd", "bɛtɪŋ", "bɪweə", "baɪəs", "bɪdən", "bɪdɪŋ", "bɪlɪt", "baɪnd", "bɪʃəp", "baɪtɐ", "baɪts", "bɪtən", "blædɐ", "bleɪd",
    "bleɪm", "blænd", "blæŋk", "blɑːst", "bleɪz", "bliːdɐ", "bliːdz", "blɛnd", "blɛst", "blaɪt", "blɪŋk", "blɒkt", "blɒks", "bləʊk", "blɒnd", "blʌdi", "blɒtʃ", "bləʊn", "bləʊz",
    "bluːɪʃ", "blʌnt", "blʌʃt", "bɔːdɪd", "bɔːdɪŋ", "bəʊst", "bəʊts", "bəʊdz", "bɒdɪs", "bɒdɪd", "bɒdɪz", "bɔɪld", "bɔɪlɐ", "bɔɪlz", "bəʊld", "bəʊlt", "bɒndz", "bəʊnd", "bəʊnz",
    "bɒnɪt", "bəʊni", "bʊkɪŋ", "bʊkɪʃ", "buːmɪŋ", "buːtɪd", "bɔːdəd", "bɔːdəz", "bɔːdəm", "bɔːrɪŋ", "bʌrəz", "bɒrəʊ", "bɔːzɔɪ", "bʊsəm", "bɒsɪz", "bɒsɪŋ", "bɒtəl", "bɒtəm", "baʊns",
    "baʊnd", "buːkeɪ", "bɜːbən", "baʊts", "baʊəl", "bəʊld", "bəʊlɐ", "bəʊlz", "bɒkst", "bɒksɐ", "bɔɪɪʃ", "breɪs", "breɪn", "breɪk", "brænd", "breɪv", "brɔːlɐ",
    "brɔːlz", "brɔːni", "briːtʃ", "brɛdθ", "breɪk", "brɛst", "briːðd", "briːðz", "briːtʃ", "briːdz", "briːzi", "bruːɪŋ", "braɪə", "braɪb", "brɪks", "braɪd", "brɪdʒ",
    "briːfɐ", "briːfs", "braɪt", "brɪmd", "brɪmz", "brɪŋz", "brɪŋk", "brɪsk", "brɔːdɐ", "brəʊk", "brɒnz", "brʊks", "brʌðɐ", "braʊn", "braʊz", "bruːɪn", "bruːzd", "brʌnt",
    "brʌʃt", "brʌsk", "bruːts", "bʌbəl", "bʌkɪt", "bʌkəl", "bʌdɪŋ", "bʌfuːn", "bɪldɐ", "bʌldʒ", "bʌlki", "bʊlɪt", "bʌmpt", "bʌntʃ", "bʌŋkɐ", "bʌŋks", "bɜːdən", "bɜːɡəz",
    "bɜːɡlɐ", "bɛrɪd", "bɜːnɪŋ", "bʌrəʊ", "bɜːsts", "bʊʃəl", "bʊʃɪz", "bɪzɪd", "bɪzɪɐ", "bʌsəl", "bʌsts", "bʊtʃɐ", "bʌtlɐ", "bʌtɪd", "bʌtək", "bʌtən", "baɪəz", "baɪɪŋ",
    "bʌzɪŋ", "kɐbæl", "kæbɪn", "kækəl", "kɐdɛt", "keɪdʒ", "keɪks", "kɔːləz", "kɔːlɪŋ", "kæləs", "kæləs", "kɑːmɪŋ", "kɑːmli", "kæməl", "kæmrɐ", "kæmpt", "kæmfɐ", "kæmps",
    "kənæl", "kænsɐ", "kændi", "kænɪŋ", "kænən", "kænən", "kænst", "kɑːntɐ", "keɪpɐ", "kɑːbən", "kɑːdɪŋ", "kəriə", "keərɐ", "kərɛs", "kærət", "kɑːɡəʊ", "kɑːpəl", "kɑːpɪŋ",
    "kɑːpəs", "kærəl", "kærɪd", "kærɪɐ", "kærɪz", "kærət", "kɑːtɪd", "kɑːtəz", "kɑːtɪŋ", "kɑːtuːn", "kɑːvɪŋ", "kæʃiə", "kɐsɛt", "kæsək", "kɑːsəl", "kɑːstɐ", "kɑːsts", "kætʃɐ",
    "keɪtɐ", "kætəl", "kɔːkəs", "kɔːsəl", "kɔːzɪz", "kɔːzɪŋ", "kɔːʃən", "kɔːʃəs", "keɪvd", "kævən", "kɔːrɪŋ", "siːsɪz", "siːsɪŋ", "siːdəz", "siːdɪd",
    "siːdɪŋ", "siːlɪŋ", "sɛləz", "sɛnsɐ", "sɛnsɐ", "sɛnʃɐ", "sɛntɐ", "sɛntɐ", "sɛnts", "sɜːtən", "sɛʃən", "tʃeɪf", "tʃæft", "tʃeɪn", "tʃeəz",
    "tʃɔːkt", "tʃɔːks", "tʃɔːki", "tʃæmp", "tʃɑːns", "tʃɑːnt", "keɪɒs", "tʃɑːli", "ʃɑːlət", "tʃɑːmd", "tʃɑːmɐ", "tʃɑːmz", "tʃɑːtɐ", "tʃɑːts",
    "tʃeɪs", "kæzəm", "tʃæts", "tʃætɐ", "tʃæti", "tʃiːpɐ", "tʃɛkt", "tʃɛks", "tʃiːkt", "tʃiːks", "tʃiəd", "tʃiəz", "tʃiːtɐ", "ʃəmiːz", "tʃɛri",
    "tʃɛst", "tʃjuːd", "tʃiːfs", "tʃɪli", "tʃɪld", "tʃɪlz", "tʃɪli", "tʃaɪm", "tʃɪŋk", "tʃɪnz", "tʃɪps", "tʃɜːpt", "tʃɔɪs", "kwaɪə", "tʃəʊk", "tʃɒpt",
    "kɔːriə", "kɔːrəs", "tʃəʊz", "tʃʌbi", "tʃʌkt", "tʃɜːtʃ", "tʃɜːnd", "saɪdɐ", "sɪɡɑːz", "sɪndɐ", "sɜːkəl", "sɜːkɪt", "sɜːkəs", "sɪtiz", "sɪvɪk",
    "sɪvəl", "kleɪm", "klæmi", "klæmp", "klæŋk", "klæpt", "klæpɐ", "klæʃt", "klɑːsp", "klɑːst", "klætɐ", "kliːnd", "kliːnɐ", "klɛnz", "kliəd", "kliəz",
    "kliːvɐ", "klɛft", "klɑːks", "klɛvɐ", "klɪkt", "klɪfs", "klaɪm", "klɪŋk", "klɪpt", "klɪps", "kləʊk", "klɒks", "kləʊð", "klɒθs", "klɒts", "klaʊd", "klaʊn",
    "klʌbz", "klʌkt", "klʌmp", "klʌtʃ", "kəʊtʃ", "kɔːsli", "kəʊst", "kəʊts", "kɒblɐ", "kɒbɜːɡ", "kɒkɪŋ", "kɒkʃɔː", "kəʊdz", "kəʊɜːs", "kɒfɪn", "kɔɪld", "kɔɪlz",
    "kɔɪnz", "kəʊld", "kəʊli", "kɒlɪk", "kɒləz", "kɒliːɡ", "kɜːnəl", "kʌləd", "kʌləz", "kʌləd", "kʌləz", "kəʊlt", "kɒlʌm", "kəʊmɐ", "kəʊmd", "kəʊmz", "kʌmli", "kɒmɪt",
    "kɒmɪk", "kʌmɪŋ", "kɒmɜːs", "kəmɪt", "kɒmən", "kənkɜː", "kənfɜː", "kɒnkɐ", "kɒntɔː", "kʊkəz", "kʊkɪŋ", "kuːlɪŋ", "kɒpɪd", "kɒpiə", "kɒpɪz", "kɒpəz", "kɒkeɪ", "kəkɛt",
    "kɒrəl", "kɔːdɪd", "kɔːdɪŋ", "kɔːdən", "kɔːniə", "kɔːnəd", "kɔːnəz", "kɔːnɪt", "kɔːnɪs", "kɔːpəs", "kɔːsɛt", "kɒsæk", "kɒstɐ", "kɒsts", "kəʊzi", "kɒtən", "kaʊtʃ",
    "kɒfɪŋ", "kʊdst", "kaʊnt", "kʌpəl", "kuːpɒn", "kɜːrɪɐ", "kɔːsɪz", "kɔːsɪŋ", "kɔːtɪd", "kɔːtɪɐ", "kɔːtɪŋ", "kɔːtli", "kʌzən", "kʌvəd", "kʌvəz", "kaʊəd", "krækt",
    "kræks", "krɑːft", "kræɡi", "kræmd", "kræmp", "kreɪn", "kræŋk", "kræʃt", "kreɪt", "krɔːld", "kriːkt", "kriːks", "kriːmi", "kriːks", "krɛpt", "krɛst", "kraɪd",
    "kraɪz", "kraɪm", "krɪsp", "krɒpt", "krɒps", "krɒst", "kruːpi", "kraʊd", "krəʊd", "kraʊn", "krəʊz", "kruːəl", "krʌʃt", "krʌst", "krʌtʃ", "kʌnɪŋ", "kʌbəd", "kʌpɪŋ",
    "kɜːlɪŋ", "kɜːsɪz", "kɜːsɪŋ", "kɜːtən", "kɜːtli", "kɜːtsi", "kɜːvɪŋ", "kʊʃən", "kʌtlɐ", "kʌtəz", "kʌtɪŋ", "sɪsts", "dæɡəz", "deɪli", "deəri", "deɪzi", "dælid", "deɪmz", "dæmɪŋ", "dæmpɐ", "dɑːnst", "dɑːnsɐ", "dændi", "dɑːkli", "dɑːlɪŋ", "dɑːtɪd", "dɑːtɪŋ", "dæʃɪŋ", "deɪtɐ", "deɪts", "dɔːbɪŋ", "dɔːtəz", "dɔːnɪŋ", "deɪzd", "diːkən", "dɛdli", "diːləz", "diːlɪŋ", "diərɐ", "diəli", "dɛθli", "dɛbɪt", "dɛbriː", "dɛtəz", "dɪkeɪ", "dɪsiːs", "dɪsiːt", "dɪsiːv", "dɪkriː", "diːmɪŋ", "diːpən", "diːpli", "dɪfiːt", "dɪfɜːd", "dɪfaɪ", "dɪɡriː", "deɪnd", "dɪleɪ", "dɪliːt", "dɪluːd", "dɪmiːn", "diːmən", "dɛnsɐ", "dɪnaɪ", "dɪpɑːt", "dɛpəʊ", "dɛpθs", "dɑːbɪz", "dɜːməl", "dɪzɜːv", "dɪzɜːt", "dɪtɜːd", "dɛvəl", "daɪəl", "dɪdst", "daɪət", "dɪfəd", "dɪfəz", "dɪɡɪŋ", "dɪmli", "daɪnd", "dɪnəz", "dɪpɪŋ", "dɪsɜːn", "dɪsks", "dɪziːz", "dɪʃɪz", "dɪsks", "dɪvæn", "daɪvd", "dɪvɔːs", "dɒktɐ", "dɒfɪŋ", "dɒɡmɐ", "duːɪŋz", "dəʊld", "dəʊlz", "dɒləz", "dəʊmz", "dɒŋki", "dɒnɪŋ", "dəʊnɐ", "dɔːweɪ", "dɔːsəl", "dɔːsəm", "dɒtɪd", "dʌbəl", "dʌbli", "daʊtɐ", "daʊts", "duːʃɪz", "daʊnd", "daʊni", "daʊri", "dɔɪən", "dəʊzd", "dʌzən", "drɑːft", "dræɡd", "dræɡz", "dreɪn", "dreɪk", "drɑːmɐ", "dræmz", "dræŋk", "drɑːft", "drɔːld", "driːmd", "driːmɐ", "driːmz", "driːmi", "drɛdʒ", "drɛɡz", "drɛst", "drɛsɐ", "draɪd", "draɪz", "drɪft", "drɪld", "drɪlz", "drɪŋk", "draɪv", "drəʊl", "drəʊn", "druːpt", "drɒpt", "drɒps", "draʊt", "drəʊv", "draʊn", "drʌɡz", "drʌmd", "drʌmɐ", "drʌmz", "drʌŋk", "djuːəl", "dʌtʃi", "dʌkts", "djuːəl", "djuːks", "djuːli", "dʌmli", "dʌmpt", "dʌmps", "dʌnɪŋ", "djuːps", "dʌski", "dʌsti", "djuːti", "dwɔːft", "dwɔːfs", "dwɛlɐ", "dwɛlt", "daɪɪŋ", "daɪɪŋ", "iːɡəli", "iːɡəlz", "ɜːnəst", "ɜːnɪŋz", "iəʃɒt", "ɜːθwɜːk", "iːzɪli", "iːstən", "ɛkəʊd", "ɛkəʊz", "ɛdɪɪŋ", "ɛdʒɪz", "ɛdɪtɐ", "ɪfeɪs", "ɪfɛkt", "ɛfəts", "ɛɡʃɛl", "eɪtiːn", "eɪtθs", "eɪtɪz", "ɪlæps", "ɛlbəʊ", "ɛldəz", "ɪlɛkt", "ɪlɪps", "ɪləʊp", "ɛmbɑːk", "ɛmbəz", "ɪmɜːdʒ", "ɛmpti", "ɛnækt", "ɛndɪd", "ɛndɪŋ", "ɛndɔːs", "ɛndaʊ", "ɛndjɔː", "ɛnəmɐ", "ɛnəmi", "ɛnfɔːs", "ɛnjuːi", "ɛnsjuː", "ɛnʃɔːz", "ɛntəd", "ɛntəz", "ɛntri", "ɛnvɪd", "ɛnvɔɪ", "ɛpɪks", "ɛpɒkz", "iːkwəl", "ɪkwɪp", "ɪrɛkt", "ɪrəʊd", "ɛrənd", "ɪrʌpt", "ɛsəns", "ɛstiːm", "ɛθɪks", "ɛθnɪk", "iːθaɪl", "ɪveɪd", "ɪvɛnt", "ɛvəmɔː", "iːvəlz", "ɪvɪns", "ɪvəʊk", "ɪvɒlv", "ɛɡzæm", "ɛksiːd", "ɛɡzɜːt", "ɛɡzɔːt", "ɛɡzɪt", "aɪbɔːl", "aɪlɪd", "fəsɑːd", "feɪsd", "fæsɛt", "fæktɐ", "fækts", "feɪdz", "feɪld", "feɪlz", "feɪnt", "feərɐ", "feəli", "feəri", "fɔːlən", "fɔːlɪŋ", "fæləʊ", "feɪmd", "fæmɪn", "fænsi", "fænɪŋ", "fɑːməz", "fɑːmɪŋ", "færəʊ", "fɑːθɪŋ", "fæʃən", "fɑːsən", "fɑːstɐ", "feɪts", "fɑːðəz", "fæðəm", "fɐtiːɡ", "fætɪd", "fætən", "fɒlts", "fɒlti", "feɪvɐ", "feɪvɐ", "fɛðəd", "fɛðəz", "fiːtʃɐ", "fiːbəl", "fiːbli", "fiːdɪŋ", "fiːlɪŋ", "feɪnd", "fɛlɪŋ", "fɛləʊ", "fɛlən", "fɛlts", "fɛnst", "fɛnsɐ", "fɛrɪt", "fɛrɪz", "fɛstɐ", "fɛtʃt", "fɛtəd", "fɛtəz", "fiːvəz", "faɪbɐ", "fɪdəl", "fiːldz", "fiːndz", "fɪfθs", "fɪfti", "faɪtɐ", "faɪts", "fɪɡəd", "fɪɡəz", "faɪld", "faɪlz", "fɪlɪŋ", "fɪlmz", "fɪlmi", "fɪltɐ", "fɪlθi", "faɪnd", "faɪnd", "faɪnɐ", "faɪnz", "fɪnɛs", "fɪŋɡɐ", "faɪəd", "faɪəz", "fɜːmli", "fɪʃɪz", "fɪʃɪŋ", "fɪʃən", "fɪʃəd", "fɪʃəz", "fɪsts", "fɪtɪd", "fɪtɪŋ", "faɪvɐ", "fɪkst", "fɪɔːdz", "flæbi", "flæɡd", "flæɡz", "fleɪl", "fleɪm", "flæŋk", "flæpt", "flæps", "fleəd", "fleəz", "flæʃt", "flɑːsk", "flæts", "flætɐ", "flɔːnt", "flæks", "fleɪd", "flɛkt", "fliːsi", "fliːɪŋ", "fliːts", "flɛʃi", "flɛks", "flɪkt", "flaɪz", "flaɪt", "flɪŋz", "flɪnt", "fləʊt", "flɒkt", "flɒɡd", "flʌdz", "flɒpt", "flɒpi", "flɔːrɐ", "flaʊə", "flaʊt", "fləʊd", "fləʊn", "fləʊz", "flʌfi", "fluːɪd", "flʌri", "flʌʃt", "flʌtɐ", "fəʊmz", "fiːtəl", "fiːtəs", "fəʊld", "fəʊks", "fɒləʊ", "fɒndɐ", "fuːlɪʃ", "fʊtɪŋ", "fəbɪd", "fɔːsɪz", "fɔːsɪŋ", "fɔːɡəʊ", "fɔːɡɒn", "fɔːhɛd", "fɒrən", "fɔːlɛɡ", "fɔːmən", "fɔːmɛn", "fɔːnuːn", "fɔːpɔːz", "fɔːsiːn", "fɔːsiːz", "fɔːtɛl", "fɔːfɪt", "fɔːdʒd", "fɔːdʒɐ", "fəɡɛt", "fəɡɪv", "fɔːɡəʊ", "fəɡɒt", "fɔːlɔːn", "fɔːməl", "fɔːmæt", "fɔːmɪŋ", "fɔːsʊk", "fɔːtɪz", "fɔːrəm", "fɔːwəd", "fɒsəl", "fɒstɐ", "faʊnd", "fɔːtiːn", "fɔːθli", "faʊlz", "fɒksi", "freɪl", "freɪm", "fræŋk", "frɔːdz", "freɪd", "friːks", "friːɪŋ", "friːli", "friːst", "freɪt", "fraɪə", "frɪdʒ", "fraɪd", "frɛnd", "fraɪt", "frɪld", "fraɪz", "frɪts", "frɒks", "frʌnt", "frɒst", "frɒθi", "fraʊn", "frəʊz", "fruːts", "fʌkɪŋ", "fjuːəl", "fʊlɪŋ", "fjuːmd", "fjuːmz", "fʌndz", "fʌnəl", "fʌnɪɐ", "fɜːləʊ", "fɜːnɪs", "fɜːnɪʃ", "fʌrəʊ", "fɜːtɪv", "fjɔːri", "fjuːzd", "fʌsɪŋ", "ɡeɪdʒ", "ɡeɪli", "ɡeɪnd", "ɡeɪnɐ", "ɡeɪnz", "ɡeɪlz", "ɡɔːlɪŋ", "ɡælən", "ɡæləp", "ɡeɪmz", "ɡæmʌt", "ɡeɪpt", "ɡeɪps", "ɡɑːdən", "ɡɑːɡəl", "ɡɑːlɪk", "ɡɑːtəz", "ɡæsɪz", "ɡɑːspt", "ɡɑːsps", "ɡeɪts", "ɡæðəd", "ɡæðəz", "ɡeɪdʒ", "ɡeɪzd", "ɡəzɛt", "dʒɛmz", "dʒɛnuː", "dʒɜːmz", "ɡɛtɪŋ", "ɡəʊst", "ɡɪbən", "ɡɪfts", "ɡɪɡlɐ", "ɡɪliz", "ɡɜːdəl", "ɡɜːlɪʃ", "dʒɪst", "ɡɪvən", "ɡɪvɪŋ", "ɡleɪd", "ɡlæmɐ", "ɡlɑːns", "ɡlænd", "ɡlænz", "ɡleəd", "ɡlɑːsi", "ɡliːmd", "ɡliːnd", "ɡlaɪd", "ɡlɪmɐ", "ɡlɪnt", "ɡlɪtɐ", "ɡləʊt", "ɡləʊb", "ɡluːmi", "ɡlɔːri", "ɡlɒsi", "ɡlʌvd", "ɡlʌvz", "ɡləʊd", "næʃɪŋ", "nɔːrɪŋ", "ɡəʊlz", "ɡəʊts", "ɡɒbəl", "ɡɒdɛs", "ɡɒdli", "ɡəʊɪŋ", "ɡɔɪtɐ", "ɡəʊld", "ɡɒlfɐ", "ɡʊdbi", "ɡʊdli", "ɡɒsɪp", "ɡɒθɪk", "ɡɒtən", "ɡaʊdʒ", "ɡaʊti", "ɡʌvən", "ɡaʊnz", "ɡræbd", "ɡræbz", "ɡreɪs", "ɡreɪd", "ɡrɑːft", "ɡreɪn", "ɡræmɐ", "ɡrænd", "ɡræni", "ɡrɑːnt", "ɡreɪp", "ɡrɑːsp", "ɡrɑːsi", "ɡreɪt", "ɡreɪz", "ɡriːzi", "ɡreɪt", "ɡriːdi", "ɡriːvd", "ɡraɪm", "ɡrɪnd", "ɡrɪpt", "ɡrɪst", "ɡrɪti", "ɡrəʊn", "ɡrəʊt", "ɡrɔɪn", "ɡruːmd", "ɡruːmz", "ɡruːvd", "ɡruːvz", "ɡrəʊs", "ɡruːpt", "ɡruːps", "ɡrəʊv", "ɡraʊl", "ɡrəʊn", "ɡrəʊz", "ɡrəʊθ", "ɡrʌdʒ", "ɡruːəl", "ɡrʌnt", "ɡɑːdɪd", "ɡɑːdɪŋ", "ɡɛsɪz", "ɡɛsɪŋ", "ɡɛsts", "ɡaɪdz", "ɡɪlti", "ɡɪniz", "ɡʌltʃ", "ɡʌlɪt", "ɡʌliz", "ɡʌlpt", "ɡʌnəz", "ɡɜːɡəl", "ɡʌʃɪz", "ɡʌʃɪŋ", "ɡʌtɪd", "ɡʌtəd", "ɡʌtəz", "hæbɪt", "hækɪŋ", "hæfɪz", "hæɡəd", "heɪld", "heəri", "hæləʊ", "hæməd", "hæmpɐ", "hændz", "hændi", "hæŋɪŋ", "hæpən", "hæpɪɐ", "hɑːbəd", "hɑːdli", "hɑːmɪŋ", "hɑːnɪs", "hɑːpuːn", "hærɪd", "hærɪɐ", "hærəʊ", "hɑːʃli", "heɪst", "heɪst", "hætʃt", "hætəz", "hɔːləz", "hɔːlɪŋ", "hævɪŋ", "hævək", "hɔːkəz", "hæzəd", "hɛdɪd", "hɛdɪŋ", "hiːləz", "hiːlɪŋ", "hɛlθi", "hiːpɪŋ", "hiərɐ", "hɑːkən", "hɑːtɪd", "hiːtɪd", "hiːðən", "hiːtɪŋ", "hɛvən", "hiːvəz", "hɛviɐ", "hiːvɪŋ", "hiːdɪd", "hiːdɪŋ", "haɪts", "eərɛs", "hɛlɪʃ", "hələʊ", "hɛlpt", "hɛlpɐ", "hɛlps", "hɛnri", "hɜːmɪt", "hɜːniɐ", "hɜːpiːz", "hɛʃən", "hɪdən", "haɪdz", "haɪli", "hɪlək", "haɪnd", "hɪndʒ", "hɪnts", "haɪəd", "hɪsɪŋ", "hɪtʃt", "hɪtɪŋ", "haɪvz", "hɔːsli", "həʊks", "hɒbɪz", "həʊld", "həʊlz", "hɒləʊ", "həʊlt", "həʊli", "həʊmɐ", "həʊmz", "ɒnɪst", "hʌnɪd", "hʊdɪd", "həʊpt", "həʊps", "hɒpɪŋ", "hɒrɪd", "hɒrəz", "hɔːsɪz", "həʊst", "hɒtli", "haʊnd", "hʌbʌb", "hjuːdʒ", "hʌɡɪŋ", "hʌmɪŋ", "hjuːmɐ", "hʌŋɡɐ", "hʌntɐ", "hʌnts", "hɜːlɪŋ", "hərɑːz", "hʌrɪd", "hɜːtɪŋ", "hʌʃɪŋ", "hʌsks", "hʌski", "hʌzɑːz", "hʌsɪz", "haɪpɐ", "aɪsɪz", "aɪkɒn", "aɪdiə", "ɪdɪət", "aɪdəl", "aɪdli", "aɪdəl", "ɪɡnɔːd", "ɪɡnɔːz", "ɪliːəm", "ɪlɪæk", "ɪliəm", "ɪlnəs", "ɪmɪdʒ", "ɪmɛns", "ɪmɜːsd", "ɪmjuːn", "ɪmpeə", "ɪmpɑːt", "ɪmpiːd", "ɪmpɛl", "ɪmplɔː", "ɪmpjɔː", "ɪnæpt", "ɪnkʌm", "ɪnkɜːd", "ɪndiːd", "ɪndiz", "ɪndɔːz", "ɪnɜːʃɐ", "ɪnfɜːd", "ɪnfɔːm", "ɪnfrɐ", "ɪndʒɐ", "ɪnədz", "ɪnpʊt", "ɪnʃɔːd", "ɪnjɔːd", "ɪnwəd", "aɪrɪs", "ɜːksʌm", "aɪənz", "aɪəlz", "ɪʃuːɪŋ", "ɪtʃɪŋ", "aɪtəm", "dʒæbɐ", "dʒæks", "dʒeɪl", "dʒæmd", "dʒeɪn", "dʒiːnz", "dʒiəd", "dʒɛli", "dʒɛni", "dʒɜːkt", "dʒɜːks", "dʒɜːki", "dʒɜːsi", "dʒɛst", "dʒɛts", "dʒuːəl", "dʒɪɡɐ", "dʒɪmi", "dʒɒbz", "dʒɒki", "dʒɒni", "dʒɔɪn", "dʒəʊk", "dʒɒli", "dʒɜːni", "dʒaʊl", "dʒɔɪz", "dʒʌdʒ", "dʒʌɡz", "dʒʌmp", "dʒɔːri", "dʒʌst", "kaɪzɐ", "kiːnli", "kiːpəz", "kiːpɪŋ", "kɛtəl", "kiːbɔːd", "kɪkɪŋ", "kɪdni", "kɪlɪŋ", "kaɪnd", "kɪŋli", "kɪsɪz", "kɪsɪŋ", "kɪtən", "neɪvz", "niːdɪd", "niːdɪŋ", "niːlɪŋ", "naɪts", "nɪtɪd", "nɪtɪŋ", "naɪvz", "nɒkɪŋ", "nɒtɪd", "nəʊɪŋ", "nʌkəl", "leɪbɐ", "leɪbɐ", "leɪst", "lækɪz", "lækɪŋ", "leɪdi", "læɡɪŋ", "leɪks", "læmps", "lændz", "leɪnz", "læpsd", "lɑːdʒɐ", "læskɑː", "leɪzɐ", "læʃɪz", "læʃɪŋ", "læsɪz", "lɑːsts", "leɪtɐ", "lɑːfəz", "lɑːfɪŋ", "lɑːftɐ", "lɔːntʃ", "lɔːrəl", "lævɪʃ", "lɔːfəl", "lɔːləs", "lɔːsuːt", "lɔɪəz", "leɪɪŋ", "leɪzi", "lɛdɪd", "lɛdən", "liːdəz", "liːkɪŋ", "liːnɪŋ", "liːpɪŋ", "lɜːnɪŋ", "liːsɪz", "liːʃɪz", "liːvɪŋ", "lɛdʒɐ", "liːɡəl", "lɛmən", "lɛndɐ", "lɛndz", "lɛŋθs", "lɛŋθi", "lɛpəd", "liːʒən", "lɛsən", "lɛsən", "liːθəl", "lɛtəz", "lɛtɪŋ", "lɛvəl", "liːvəz", "lɛvɪd", "lɛvɪz", "lɪkɪŋ", "lɪdɪd", "lɪfts", "laɪtɐ", "laɪts", "laɪkt", "laɪks", "lɪliz", "laɪmz", "lɪmɪt", "lɪmpt", "lɪmps", "lɪniə", "laɪnd", "lɪnɪn", "laɪnz", "lɪŋɡɐ", "lɪŋkt", "lɪŋks", "laɪən", "lɪkəz", "lɪsən", "lɪstɐ", "lɪsts", "lɪtəd", "lɪtəl", "lɪvɪd", "lɪvɪŋ", "ləʊdz", "ləʊfɐ", "ləʊnz", "ləʊðd", "lɒkɪt", "lɒkɪŋ", "lɒkʌp", "ləʊdz", "lɒdʒd", "lɒdʒɐ", "lɒfti", "lɒɡɪŋ", "lɒɡɪn", "lɔɪnz", "lɒlɪŋ", "lɒŋɡɐ", "lɒŋɪŋ", "lʊkɪŋ", "luːmɪŋ", "luːsli", "luːtɪd", "luːtəz", "luːtɪŋ", "lɔːdɪŋ", "luːzɪz", "luːzɪŋ", "lɒsɪz", "laʊdɐ", "lʌvli", "lʌvəz", "lʌvɪŋ", "ləʊli", "lɔɪəl", "luːsɪd", "lʌmbɑː", "lʌmbɐ", "luːmɛn", "lʌmps", "lʌntʃ", "luːpəs", "lɜːtʃt", "lɔːrɪd", "lɔːrɪŋ", "lɜːkɪŋ", "lʌstɐ", "lʌsti", "laɪɪŋ", "lɪntʃ", "lɪrɪk", "məʃiːn", "mædəm", "mædəm", "mædli", "mæɡət", "meɪdz", "meɪlz", "meɪmd", "meɪnz", "meɪkɐ", "meɪks", "meɪlz", "mælɪs", "mælɪt", "mæməl", "mæməz", "mæməθ", "mændʒ", "mænli", "mænəz", "mænɪŋ", "mænəz", "mənjɔː", "mæpɪŋ", "mɑːbəl", "mɑːtʃt", "məriːn", "mɑːkɪt", "mɑːkɪŋ", "məruːn", "mɑːrkiː", "mærɪd", "mærɪz", "mærəʊ", "mɑːʃəl", "mɑːʃɪz", "mɑːʃəl", "mɑːtɪn", "mɑːtəz", "mɑːvəl", "mɑːskt", "mæsɑːʒ", "mæsɪz", "mæsɪv", "mɑːstɐ", "mɑːsts", "mætʃt", "meɪtɐ", "meɪts", "mætɪd", "mætəd", "mætəz", "mætɪŋ", "mætək", "mətʃɔː", "mɔːkɪʃ", "meɪbiː", "meɪəʊ", "mɛdəʊ", "miːnɪŋ", "miːnli", "mɛʒəd", "mɛʒəz", "miːtəs", "mɛdəl", "mɛdəl", "mɛdlɐ", "miːdiːɐ", "miːkli", "miːtɪŋ", "mɛləʊ", "mɛlən", "mɛlts", "mɛmbɐ", "mɛmwɑː", "mɛnɪs", "mɛnjuː", "mɜːsɪz", "miəli", "mɜːdʒd", "mɜːdʒɐ", "mɛrɪt", "mɛrɪɐ", "mɛʃɪz", "mɛtəl", "miːtɪd", "mɛθəd", "mɛtəl", "mɪdəl", "mɪdst", "maɪti", "maɪld", "maɪlz", "mɪlki", "maɪnd", "maɪnd", "maɪnɐ", "maɪnz", "maɪnɐ", "mɪnts", "mɪrəz", "mɪsɪz", "mɪsɪŋ", "mɪʃən", "mɪsɪs", "mɪstɐ", "mɪsts", "mɪsti", "mɪkst", "məʊnd", "məʊnz", "mɒbɪŋ", "mɒkɪŋ", "mɒdəl", "mɒdən", "məʊdz", "mɔɪst", "məʊld", "məʊlz", "mɒnək", "mʌnɪd", "mʌŋɡɐ", "mʌnki", "mʌnks", "məsjɜː", "mʌnθs", "mɒpɪŋ", "məræl", "mɒrəl", "mɔːbɪd", "mɔːnɪŋ", "mɒrɪs", "mɒrəʊ", "mɔːsəl", "mɔːtəl", "məʊst", "mʌðəz", "mɒtli", "məʊtɐ", "mɒtəʊ", "məʊld", "maʊnd", "maʊnt", "mɔːnɪŋ", "maʊðd", "muːvɪŋ", "məʊəz", "mʌdəl", "mʌfti", "mjuːlz", "mʌməz", "mɜːdəd", "mɜːdəz", "mɜːməd", "mɜːməz", "mʌsəl", "mʌstɐ", "mʌsti", "mʌtəd", "mʌtən", "mʌzəl", "neɪlz", "naɪiːv", "neɪmd", "neɪmz", "nærəʊ", "nɑːsti", "neɪts", "nɔːsɪɐ", "nævɪz", "neɪvi", "niərɐ", "niəli", "niːtli", "niːdɪd", "niːdɪŋ", "niːdəl", "neɪbɐ", "neɪɪŋ", "naɪðɐ", "nɛfjuː", "nɜːvəs", "nɛsts", "njuːli", "nɛkst", "naɪsɐ", "nɪʃɪz", "nɪkəl", "nɪdəs", "niːsɪz", "naɪts", "naɪnθ", "nɪpəl", "nɒdɪd", "nɒdɪŋ", "nəʊdz", "nɔɪzi", "nəʊmɐ", "nɔːməl", "nɔːðən", "nəʊzd", "nəʊts", "nʌθɪŋ", "nʌrɪʃ", "nəʊvɐ", "nɒvəl", "nɒvɪs", "nʌdʒd", "nɜːsɪz", "nɜːsɪŋ", "əʊbiːz", "əʊbeɪ", "əbliːk", "ɒbzɜːv", "əkluːd", "əʊʃən", "iːdɪmɐ", "əfɛnd", "ɒfɪsɐ", "ɒfsɛt", "ɒfənɐ", "əʊhəʊ", "əʊldɐ", "əʊmɛn", "əʊmɪt", "ʌniən", "əʊnli", "ɒnsɛt", "ɒnwəd", "əʊpəl", "əʊpən", "ɒpərɐ", "əpəʊz", "əprɛs", "ɒptɪk", "ɒpʃən", "ɒrətɐ", "ɔːtʃəd", "ɔːdeɪn", "ɔːdiəl", "ɔːdəli", "ɔːɡənz", "ɔːdʒɪz", "ɔːfənz", "ɒsiəs", "aʊtduː", "aʊtdɔː", "aʊtɪŋ", "aʊtlɔː", "əʊvəl", "ʌvənz", "əʊvɜːt", "əʊvəm", "əʊnəz", "əʊnɪŋ", "ɒksən", "peɪst", "pækɪt", "pækɪŋ", "pædɪd", "pædəl", "peɪdʒ", "peɪlz", "peɪnd", "peɪnz", "peɪnt", "pælɪs", "pælət", "peɪlɐ", "pælɪt", "pælɪd", "pɒltɐ", "pænəl", "peɪnz", "pænɪk", "peɪpɐ", "pɑːsəl", "pɑːtʃt", "pɑːdən", "pærɪʃ", "pɑːkɪŋ", "pɑːkeɪ", "pærət", "pɑːsən", "pɑːtɪd", "pɑːʃəl", "pɑːtɪz", "pɑːtɪŋ", "pɑːtli", "pɑːtnɐ", "pɑːsəz", "pɑːsɪz", "pɑːsɪŋ", "pæʃən", "pɑːsɪv", "peɪst", "pɑːstɐ", "pætɪd", "pætəd", "pætən", "pætɪz", "pætɪŋ", "pɔːntʃ", "pɔːpəz", "pɔːzɪz", "pɔːzɪŋ", "peɪvd", "pɔːrɪŋ", "peɪɪŋ", "pɛbəl", "piːlɪŋ", "piːpɪŋ", "pɛlɪt", "piːnəl", "piːnɪs", "pɛnɪz", "piːənz", "piːpəl", "pɛpəd", "pəsiːv", "pɜːtʃt", "pəfɔːm", "pɛrəl", "pɛrɪʃ", "pɜːsən", "pətɜːb", "pəvɜːs", "pɛtəl", "piːtəd", "piːtəz", "pətiːt", "pɛtɪd", "pɛtɪŋ", "fiːtən", "freɪz", "pɪkɪt", "pɪkɪŋ", "piːsɪz", "piəst", "pɪɡmi", "paɪld", "paɪlz", "pɪləz", "pɪləʊ", "pɪntʃ", "pɪnɪŋ", "paɪnt", "paɪəs", "paɪps", "pɪkeɪ", "pɪtʃt", "pɪtʃɐ", "pɪtid", "pɪtiz", "pɪtɪd", "pɪtɪŋ", "pleɪs", "pleɪɡ", "pleɪd", "pleɪn", "pleɪt", "pleɪn", "plæŋk", "plænd", "plænɐ", "plænz", "plænt", "pleɪt", "pleɪd", "pleɪɐ", "pleɪz", "pliːdz", "pliːzd", "plɛʒɐ", "plɛdʒ", "plɜːrɐ", "plaɪd", "plaɪt", "plɒts", "plaʊd", "plʌvɐ", "plʌkt", "plʌɡd", "plʌɡz", "plʌmɐ", "pluːmd", "pluːmz", "plʌmp", "plʌmz", "pɒkɪt", "pɒdʒi", "pəʊɪm", "pəʊɪt", "pɔɪnt", "pəʊkɐ", "pəʊki", "pəʊlɐ", "pəʊlz", "pəliːs", "pɒlɑːd", "pəʊld", "pɒlən", "pɒndɐ", "pɒndz", "pəʊni", "puːlɪŋ", "pəʊps", "pɒpɪŋ", "pɔːrɪŋ", "pɔːrəs", "pɔːtəl", "pɔːtəz", "pɔːʃən", "pɔːtli", "pəʊzd", "pəzɛs", "pəʊst", "pɒtæʃ", "pɒtəz", "paʊtʃ", "paʊns", "paʊnd", "pɔːrɪŋ", "paʊdɐ", "paʊəz", "preɪz", "præŋk", "preɪd", "priːtʃ", "prɪfɜː", "prɛst", "prɛʃɐ", "prɪti", "preɪd", "praɪs", "prɪkt", "praɪd", "praɪd", "priːst", "praɪm", "prɪns", "prɪnt", "praɪɐ", "praɪz", "prəʊb", "prəʊn", "prɒŋd", "pruːfs", "prɒpɐ", "prɒpt", "prəʊz", "praʊd", "pruːvd", "pruːvz", "praʊl", "suːdəʊ", "pjuːbz", "pʌkəd", "pʊdɪŋ", "pʌfɪŋ", "pʊlɪz", "pʊlɪŋ", "pʌlzd", "pʌmpt", "pʌmps", "pʌntʃ", "pʌnɪʃ", "pjuːni", "pʌpɪt", "pjɔːli", "pjʊrɐ", "pɜːdʒd", "pɜːpəl", "pɜːpəs", "pɜːsɪz", "pɜːsɪŋ", "pəsjuː", "pəsuːt", "pʊʃɪz", "pʊʃɪŋ", "pʌzəl", "kwɑːmz", "kwɒri", "kwɔːtɐ", "kwætɐ", "kwiːnz", "kwɛld", "kwɛst", "kwɪkɐ", "kwɪlt", "kwaɪə", "kwɪts", "kwɪvɐ", "kwəʊt", "ræbaɪ", "ræbɪt", "ræbəl", "reɪsd", "rækɪŋ", "rɑːfts", "reɪdʒ", "reɪdɐ", "reɪld", "reɪlz", "reɪnz", "reɪni", "reɪzd", "reɪks", "rælid", "rɑːntʃ", "ræŋkɐ", "ræŋks", "ræpɪd", "reəli", "reərɐ", "ræʃəz", "ræʃɪz", "reɪts", "ræʃən", "rætəl", "reɪvd", "rəviːn", "rævɪʃ", "reɪzd", "reɪzɐ", "riːtʃt", "rɪækt", "riːdəz", "riəli", "rɛlmz", "riːpɪŋ", "riːzən", "rɪbɜːθ", "rɪbɔːn", "rɪsiːd", "rɪsiːt", "rɪsiːv", "rɛkən", "rɪkɔːs", "rɛktɐ", "rɪkɜːd", "rɪkɜːz", "rɛdɪʃ", "rɪdiːm", "riːlɪŋ", "rɪfɜːd", "rɪfɜːz", "riːɡəl", "rɪɡɑːd", "rɪhiːt", "reɪnd", "reɪnz", "reɪnd", "reɪnz", "rɛlɪk", "rɪliːf", "rɪliːv", "rɛlɪʃ", "rɪlɪt", "rɪlɪv", "rɪlaɪ", "rɪmɔːs", "rɪmuːv", "riːnəl", "rɛndɐ", "rɪnjuː", "rɛntɐ", "rɛnts", "rɪpeɪ", "rɪpiːl", "rɪpiːt", "rɪpɛl", "rɛzɪn", "rɪzɔːs", "rɛsts", "rɪtɛl", "rɪtɔːt", "rɪviːl", "rɪvɜːs", "rɪvɜːt", "rɪwɔːd", "raɪmz", "rɪðəm", "rɪbən", "rɪtʃɐ", "rɪdən", "rɪdəl", "raɪdɐ", "raɪdz", "rɪfts", "rɪɡɪŋ", "raɪts", "rɪɡəz", "raɪmz", "rɪŋɪŋ", "rɪnsd", "raɪət", "rɪzən", "raɪzɐ", "rɪskt", "rɪsks", "rɪski", "rɪvəz", "raɪvz", "rɪvɪt", "rəʊdz", "rəʊmd", "rɔːrɪŋ", "rəʊst", "rɒbəz", "rɒbɪŋ", "rəʊbd", "rəʊbz", "rɒbɪn", "rɒkɪt", "rɒkɪŋ", "rɒdʒɐ", "rəʊɡz", "rəʊlz", "rəʊld", "rəʊlɐ", "rəʊlz", "rɒmpɐ", "ruːmɪɐ", "ruːtɪd", "rəʊps", "rəʊzi", "rɒtɪd", "rɒtən", "rʌfli", "raʊnd", "raʊzd", "rəʊvɐ", "raʊdi", "rɔɪəl", "rʌbəz", "rʌbɪŋ", "rʌbɪʃ", "ruːdli", "ruːfəl", "rʌfəl", "rʌɡbi", "ruːɪnd", "ruːɪnz", "ruːləz", "ruːlɪŋ", "ruːməd", "ruːməz", "ruːməz", "rʌnəz", "rʌnɪŋ", "rɔːrəl", "rʌʃɪz", "rʌʃɪŋ", "rʌsəl", "rʌsti", "sæbɑːθ", "seɪbɐ", "sædən", "sædəl", "sædli", "seɪfɐ", "seɪfs", "seɪdʒ", "seɪld", "seɪlɐ", "seɪlz", "seɪnt", "sæləd", "seɪlz", "sæliz", "sæləʊ", "sæmən", "sælɒn", "sɐluːn", "sɒltɐ", "sɒlts", "səluːt", "sælvɐ", "sændz", "sændi", "sæpɪŋ", "sæʃɪz", "sætɪn", "seɪvd", "seɪvz", "sɔːrɪŋ", "seɪɪŋ", "skæbz", "skɒld", "skeɪl", "skælp", "skæmp", "skænd", "skɑːnt", "skeəs", "skeəd", "skɑːvz", "skætɐ", "sɛptɐ", "skiːmɐ", "skiːmz", "ʃnæps", "skɒlɐ", "skuːld", "skuːlz", "skuːnɐ", "sɪsəz", "skəʊp", "skɔːnd", "skɒtʃ", "skɜːdʒ", "skaʊə", "skaʊt", "skaʊl", "skræp", "skrɔːl", "skriːm", "skriːn", "skruːd", "skruːz", "skrʌb", "skrʌf", "skʌlɐ", "skʌri", "skɜːvi", "siːbɔːd", "siːlɪŋ", "siːmən", "siːmɛn", "siːpɔːt", "sɜːtʃt", "siːzən", "siːtɪd", "siːtɪŋ", "sɛsiːd", "sɛktɐ", "sɛkts", "sɪkjɔː", "sɪdæn", "siːkəz", "siːkɪŋ", "siːmɪŋ", "siːðɪŋ", "seɪnɜː", "siːzɪz", "siːzɪŋ", "siːʒəz", "sɛləz", "sɛlɪŋ", "siːmən", "sɛnət", "sɛndz", "siːnjɐ", "siərɐ", "səriːn", "sɜːmən", "sɛrəs", "sɛrɪd", "sɛrəm", "sɜːvɪs", "sɜːvɪŋ", "sɛʃən", "sɛtɪŋ", "sɛtlɐ", "sɛtəl", "sɛvən", "sɛvəd", "sɪviə", "səʊɪŋ", "ʃeɪdz", "ʃædəʊ", "ʃeɪdi", "ʃɑːfts", "ʃeɪks", "ʃæləʊ", "ʃɑːnti", "ʃeɪpt", "ʃeɪps", "ʃɑːpən", "ʃɑːpli", "ʃætəd", "ʃætəz", "ʃeɪvd", "ʃɛdɪŋ", "ʃiːpɪʃ", "ʃɛlɪŋ", "ʃɛltɐ", "ʃɛlvz", "ʃɛpəd", "ʃɛrɪf", "ʃɪfts", "ʃɪlɪŋ", "ʃaɪnz", "ʃaɪni", "ʃɪpəz", "ʃɪpɪŋ", "ʃɪvəz", "ʃɒkɪŋ", "ʃuːtɪŋ", "ʃɒpɪŋ", "ʃɔːtən", "ʃɔːtli", "ʃaʊts", "ʃʌvəl", "ʃʌvɪŋ", "ʃaʊəd", "ʃəʊɪŋ", "ʃræŋk", "ʃrɛdz", "ʃriːkt", "ʃriːks", "ʃrɪmp", "ʃraɪn", "ʃrɪŋk", "ʃrʌɡd", "ʃrʌŋk", "ʃʌdəd", "ʃʌdəz", "ʃʌtəd", "ʃʌtəz", "ʃʌtɪŋ", "ʃaɪɪŋ", "ʃaɪli", "sɪkəl", "sɪkli", "saɪdz", "saɪɪŋ", "saɪts", "saɪnd", "saɪnɐ", "saɪnz", "sɪlks", "sɪlvɐ", "sɪnjuː", "sɪŋəz", "sɪŋɪŋ", "sɪŋks", "sɪnəz", "sɪnɪŋ", "sɪpɪŋ", "sɪstɐ", "saɪts", "sɪtɪŋ", "sɪksθ", "saɪzd", "skeɪn", "skɛtʃ", "skaɪz", "skɪld", "skɪnd", "skɪni", "skɪnz", "skɪpt", "skɪpɐ", "skɜːts", "skɪts", "slæbz", "sleɪn", "slæmd", "slæpt", "slæʃt", "sleɪt", "slɔːtɐ", "sleɪv", "slɛdʒ", "sliːkɐ", "sliːpɐ", "sliːps", "sliːpi", "sliːvz", "sleɪz", "slɛpt", "slaɪs", "slaɪd", "slaɪt", "slaɪm", "slɪŋk", "slɪpt", "slɪpɐ", "slɪps", "slɪts", "sluːps", "sləʊp", "slʌfd", "sləʊd", "sləʊɐ", "slʌmp", "slʌmz", "smækt", "smɔːlɐ", "smɑːtɐ", "smæʃt", "smæʃɐ", "smiəd", "smɛld", "smɛlz", "smɛlt", "smaɪl", "smaɪt", "smɪθs", "smɪθi", "sməʊk", "smuːðd", "smuːðɐ", "sməʊt", "smʌðɐ", "smʌdʒ", "snæks", "sneɪl", "sneɪk", "snæpt", "snɑːld", "snætʃ", "sniəd", "snɪft", "snɪɡɐ", "snɪpt", "snaʊt", "snəʊd", "snəʊz", "snəʊi", "səʊkt", "sɔːrɪŋ", "sɒbɪŋ", "səʊbɐ", "sɒkɪt", "səʊdɐ", "sɒdən", "səʊfɐ", "sɒfən", "sɒftɐ", "sɔɪld", "sɔɪlz", "sɒlɪs", "səʊlɐ", "sɒldɐ", "səʊld", "səʊld", "sɒləm", "sɒlɪd", "sɒlvd", "sɒmbɐ", "suːðɪŋ", "sɔːdɪd", "sɒrəl", "sɒrəʊ", "sɔːtɪd", "sɔːtɪŋ", "səʊld", "səʊlz", "saʊnd", "sɔːsɪz", "saʊəd", "saʊsd", "sʌðən", "səʊɪŋ", "speɪs", "speɪd", "speɪk", "spænd", "speəd", "speəz", "spɑːks", "spiːkɐ", "spiːks", "spiəz", "spɛsi", "spiːtʃ", "spiːdi", "spɛld", "spɛlz", "spɛns", "spɛnd", "spɛnt", "sfiəz", "spaɪs", "spaɪz", "spaɪk", "spɪld", "spɪlt", "spaɪn", "spaɪə", "spaɪt", "splæʃ", "spliːn", "splɪt", "spɔɪl", "spəʊk", "spuːlz", "spuːnz", "spɔːts", "spɒts", "spaʊs", "spræŋ", "spreɪ", "sprɛd", "spriːz", "sprɪɡ", "sprɪŋ", "spruːs", "sprʌŋ", "spɜːnd", "skwɒd", "skweə", "skwɒt", "skwiːz", "stæbd", "stæbz", "stækt", "stæks", "stæɡɐ", "steɪd", "steɪn", "steəz", "steɪk", "steɪl", "stɔːkt", "stɔːlz", "stæmp", "stɑːns", "stænd", "stɑːtʃ", "steəd", "steəz", "stɑːri", "stɑːts", "stɑːvd", "steɪt", "steɪd", "steɪz", "stɛdi", "stiːlz", "stɛlθ", "stiːmd", "stiːmɐ", "stiːli", "stiəd", "staɪn", "stɛmd", "stɛmz", "stɛpt", "stɛps", "stɛps", "stɜːnɐ", "stɪks", "stɪki", "staɪl", "stɪlz", "stɪŋk", "stɪnt", "stɪtʃ", "stɒkt", "stɒks", "stəʊk", "stəʊl", "stəʊn", "stuːlz", "stuːpt", "stɒpt", "stɒps", "stɔːmd", "stɔːmz", "stɔːmi", "stɔːri", "staʊt", "stəʊv", "stræp", "streɪ", "striːk", "striːm", "striːt", "strɛs", "struːd", "struːn", "strɪŋ", "strɪp", "strɒŋ", "strʌk", "strʌt", "stʌbi", "stʌdi", "stʌft", "stʌfs", "stʌfi", "stʌmp", "stʌnd", "stɜːdi", "staɪl", "sʌtəl", "sʌbɜːb", "səkʌm", "sʌkɪŋ", "sʌdən", "sʌfəd", "sʌfəz", "suːtɪd", "swiːts", "suːtəz", "sʌlki", "sʌlən", "sʌlfɐ", "sʌmɪt", "sʌmən", "suːpɜːb", "sʌpəz", "sʌpɪŋ", "sʌpəl", "səpɔːt", "sʌprɐ", "sɜːfɪs", "suːtʃɐ", "swɒbd", "swɒbz", "swæɡɐ", "sweɪn", "swɒmp", "swæŋk", "swɔːmd", "swɔːði", "sweɪd", "sweɪz", "sweəz", "swɛts", "swiːdz", "swiːps", "swiːtɐ", "swiːts", "swɛld", "swɛlz", "swɛpt", "swɜːvd", "swɜːvz", "swɪft", "swɪmɐ", "swɪmz", "swaɪn", "swɪtʃ", "swuːpt", "sɪnɒd", "tæsɪt", "tækɪŋ", "tækəl", "teɪld", "teɪlɐ", "teɪlz", "teɪnt", "teɪks", "tɔːkəz", "tɔːkɪŋ", "tælɪd", "tælɪʃ", "tæləʊ", "teɪmd", "tæŋks", "teɪpɐ", "teɪps", "tæpɪŋ", "tɑːɡɪt", "tærɪf", "tɑːsəs", "tɑːsks", "tæsəl", "teɪst", "tætəd", "tætəl", "tætuːd", "tɔːnts", "tævən", "tækst", "tæksi", "tiːtʃɐ", "tiːzɪŋ", "tɛlɪŋ", "tɛmpɐ", "tɛmps", "tɛmpt", "tɛndɐ", "tɛndz", "tɛnɪs", "tɛnθs", "tɛnts", "tɛnjɐ", "tɛpɪd", "tɛrɪs", "tɛrəz", "tɛsts", "tɛðəd", "tɛkst", "θeɪlɐ", "θæŋkt", "θæŋks", "θætʃt", "θɔːrɪŋ", "θiətɐ", "θiətɐ", "θɛfts", "θiəri", "ðeəfɔː", "ðeətuː", "θɜːməl", "θiːsɪs", "θɪkɪt", "θɪkli", "θɪŋkɐ", "θɪŋks", "θɪnli", "θɪnɪŋ", "θɜːdli", "θɜːsti", "θɜːtiːn", "θɜːtɪz", "θræʃt", "θrɛdz", "θrɛts", "θraɪs", "θrɪld", "θraɪv", "θrəʊt", "θrɒbd", "θrəʊn", "θrɒŋd", "θrɒŋz", "θrəʊn", "θrəʊz", "θrʌst", "θʌdɪd", "θʌdɪŋ", "θʌmpt", "θʌndɐ", "tɪɑːrɐ", "tɪbiɐ", "tɪkɪt", "tɪkɪŋ", "tɪkəl", "taɪdz", "taɪdi", "taɪɡɐ", "taɪtɐ", "tɪldɐ", "taɪld", "tɪləz", "tɪlɪŋ", "tɪmbɐ", "taɪmd", "taɪmz", "tɪmɪd", "tɪndɐ", "tɪndʒ", "tɪŋkɐ", "tɪnts", "taɪni", "tɪpsi", "taɪəd", "taɪəz", "tɪʃuːz", "tɪtəl", "təʊst", "tədeɪ", "tɔɪlz", "təʊld", "təʊld", "təʊlz", "təʊli", "təʊnd", "təʊnz", "tɒnɪk", "təʊni", "tɒpɪk", "tɔːʃən", "tɔːtəs", "tɔːtʃɐ", "tɒsɪŋ", "tʌtʃt", "tʊwɔːd", "taʊəl", "taʊəd", "taʊnz", "tɔɪɪŋ", "treɪs", "træks", "trækt", "treɪd", "treɪl", "treɪn", "treɪt", "træmp", "trɑːns", "træps", "trɔːmɐ", "trɛʒɐ", "triːts", "triːti", "trɛmɐ", "trɛnd", "traɪb", "trɪkt", "trɪks", "trɪki", "traɪd", "traɪz", "trɪɡɐ", "trɪld", "trɪlz", "trɪmd", "trɪpt", "trɪps", "traɪt", "trɒkɑː", "trɒli", "truːpt", "truːpɐ", "truːps", "trɒtɐ", "trɒfz", "traʊt", "trəʊv", "truːli", "trʌŋk", "trʌst", "truːθs", "tjuːbz", "tʌkɪŋ", "tʌfts", "tʌɡɪŋ", "tjuːmɐ", "tjuːnd", "tjuːnz", "tʌnəl", "tɜːbɪd", "tɜːnɪŋ", "tɜːtəl", "tjuːtɐ", "tweɪn", "twɛlv", "twaɪs", "twɪɡz", "twɪnz", "twɜːld", "twɪst", "twɪtʃ", "twɪtɐ", "taɪɪŋ", "taɪps", "ʌɡliɐ", "ʌlsəz", "ʌlstɐ", "ʌltrɐ", "ʌnɑːmd", "ʌnbɔːn", "ʌŋkəl", "ʌnkuːθ", "ʌnkʌt", "ʌndɪd", "ʌndʌn", "ʌndjuː", "ʌnɜːθd", "ʌniːzi", "ʌnfeə", "ʌnfɪt", "ʌnhɜːd", "juːniːk", "juːnɪt", "ʌnlɛs", "ʌnmɑːd", "ʌnpæk", "ʌnsiːt", "ʌnsiːn", "ʌntɪl", "ʌntruː", "ʌnwɛl", "ʌphɪl", "ʌpkiːp", "ʌpwəd", "ɜːtʃɪn", "jɔːriə", "ɜːdʒɪz", "ɜːdʒɪŋ", "jɔːrɪk", "jɔːrɪn", "juːzəz", "juːzɪŋ", "ʌtəli", "væɡəs", "væleɪ", "vælɪd", "vɐliːs", "vælɪz", "væljuː", "vælvz", "vænɪʃ", "veɪpɐ", "veɪpɐ", "vɑːnɪʃ", "veəri", "vɑːzɪz", "væsəl", "vɛktɐ", "veɪld", "veɪnz", "viːnəl", "vɛndɐ", "vɛnəm", "vɛnəs", "vɛnjuː", "vɜːbəl", "vɜːdjɔː", "vɜːnəl", "vɜːsɪz", "vɜːʃən", "vɜːsəʊ", "vɜːsɪz", "vɛsəl", "vɛsts", "viːtəʊ", "vɛkst", "vɪʃəs", "vɪktɐ", "vjuːɪŋ", "vɪlən", "vɪləz", "vɪlaɪ", "vaɪnz", "vaɪpɐ", "vɜːtʃuː", "vɪʒən", "vɪzɪt", "vɪstɐ", "vɪvɪd", "vɒdkɐ", "vɔɪst", "vɒlɪz", "vɒmɪt", "vəʊtɐ", "vəʊts", "vʌlɡɐ", "vʌlvɐ", "vaɪɪŋ", "wɒdɪŋ", "weɪdʒ", "wæɡɪŋ", "wæɡɪʃ", "wæɡən", "weɪld", "weɪst", "weɪtɐ", "weɪts", "weɪvd", "weɪkt", "weɪks", "weɪlz", "wɔːkɪŋ", "wɒlɪt", "wɔːlɪŋ", "wɒlts", "wɒndɐ", "weɪnd", "wɒnts", "wɔːdɪŋ", "wɔːfeə", "wɔːmɪŋ", "wɔːmli", "wɔːnɪŋ", "wɒrən", "wɔːrɪŋ", "wɒrɪɐ", "wɔːʃɪp", "weəri", "wɒʃɪŋ", "wɒsps", "weɪst", "wɒtʃt", "wɔːtəd", "wɔːtəz", "wɒtəl", "weɪvd", "weɪvɐ", "weɪvz", "weɪvi", "wækst", "wæksi", "wiːkən", "wiːkli", "wɛlθi", "wɛpən", "weərɐ", "wiəri", "wiːvəz", "wiːvɪŋ", "wɛbɪŋ", "wɛdɪd", "wɛdɪŋ", "wɛdʒd", "wiːkli", "wiːpəz", "wiːpɪŋ", "weɪɪŋ", "weɪts", "weɪti", "wɛlɪŋ", "wɛntʃ", "wɛtɪd", "wɛtɪŋ", "wiːlɪŋ", "weəfɔː", "waɪnd", "wɪpɪŋ", "wɜːlɪŋ", "wɜːrɪŋ", "wɪski", "wɪski", "wɪspɐ", "wɪsəl", "waɪtɐ", "waɪts", "wɪzɪŋ", "huːɛvɐ", "həʊli", "huːsəʊ", "wɪkɪt", "waɪdɐ", "wɪdəʊ", "wiːldɐ", "wiːldz", "waɪld", "waɪlz", "wɪlɪŋ", "wɪləʊ", "waɪli", "wɪnst", "waɪnd", "waɪnz", "wɪŋɪŋ", "wɪŋkt", "wɪnɪŋ", "wɪntɐ", "waɪpt", "waɪəd", "waɪəz", "waɪzɐ", "wɪʃɪz", "wɪʃɪŋ", "wɪsps", "wɪðæl", "wɪðəd", "wɪðəz", "wɪðɪn", "wɪtɪd", "waɪvz", "wɪzəd", "wɒbli", "wʊlvz", "wʊmən", "wɪmɪn", "wʌndɐ", "wʊdɪd", "wʊdən", "wʊlən", "wʊlən", "wɜːdɪd", "wɜːdɪŋ", "wɜːkəz", "wɜːkɪŋ", "wɜːldz", "wɜːmɪŋ", "wʌrɪd", "wʌrɪz", "wɜːʃɪp", "wɜːðɪɐ", "wuːndz", "ræpɪŋ", "rɛkəz", "rɛkɪŋ", "rɛsəl", "rɪɡəl", "rɪŋɪŋ", "rɪsts", "raɪtɐ", "raɪts", "raɪðd", "rɪtən", "rɒŋli", "jɔːnɪŋ", "jiəli", "jɜːnɪŋ", "jɛlɪŋ", "jɛləʊ", "jɛlpt", "jiːldz", "jəʊkt", "jɒndɐ", "jɔːkəz", "jʌŋɡɐ", "zɛləs", "zɛnɪθ"];